function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("mobx"), require("mobx-react"), require("@miriamtech/if2-js-model"), require("@miriamtech/if2-ui"), require("ramda"), require("jquery"), require("moment"), require("prop-types"), require("react-bootstrap"), require("uuid"), require("@miriamtech/if2-fields"), require("popper.js"), require("bootstrap"), require("react-dom"), require("js-quantities"), require("jsonschema"), require("luxon"), require("mobx-utils"), require("lodash"), require("d3-selection"), require("d3-shape"), require("react_ujs"), require("@turf/center"), require("react-calendar"), require("error-stack-parser"), require("i18next-browser-languagedetector"), require("react-svg"), require("d3-scale"), require("react-virtuoso"), require("popper-max-size-modifier"), require("react-interval"), require("react-markdown"), require("remark-gfm"), require("url-pattern"), require("p-debounce"), require("@miriamtech/if2-crops")) : "function" == typeof define && define.amd ? define(["react", "mobx", "mobx-react", "@miriamtech/if2-js-model", "@miriamtech/if2-ui", "ramda", "jquery", "moment", "prop-types", "react-bootstrap", "uuid", "@miriamtech/if2-fields", "popper.js", "bootstrap", "react-dom", "js-quantities", "jsonschema", "luxon", "mobx-utils", "lodash", "d3-selection", "d3-shape", "react_ujs", "@turf/center", "react-calendar", "error-stack-parser", "i18next-browser-languagedetector", "react-svg", "d3-scale", "react-virtuoso", "popper-max-size-modifier", "react-interval", "react-markdown", "remark-gfm", "url-pattern", "p-debounce", "@miriamtech/if2-crops"], t) : "object" == typeof exports ? exports.if2 = t(require("react"), require("mobx"), require("mobx-react"), require("@miriamtech/if2-js-model"), require("@miriamtech/if2-ui"), require("ramda"), require("jquery"), require("moment"), require("prop-types"), require("react-bootstrap"), require("uuid"), require("@miriamtech/if2-fields"), require("popper.js"), require("bootstrap"), require("react-dom"), require("js-quantities"), require("jsonschema"), require("luxon"), require("mobx-utils"), require("lodash"), require("d3-selection"), require("d3-shape"), require("react_ujs"), require("@turf/center"), require("react-calendar"), require("error-stack-parser"), require("i18next-browser-languagedetector"), require("react-svg"), require("d3-scale"), require("react-virtuoso"), require("popper-max-size-modifier"), require("react-interval"), require("react-markdown"), require("remark-gfm"), require("url-pattern"), require("p-debounce"), require("@miriamtech/if2-crops")) : e.if2 = t(e.react, e.mobx, e["mobx-react"], e["@miriamtech/if2-js-model"], e["@miriamtech/if2-ui"], e.ramda, e.jquery, e.moment, e["prop-types"], e["react-bootstrap"], e.uuid, e["@miriamtech/if2-fields"], e["popper.js"], e.bootstrap, e["react-dom"], e["js-quantities"], e.jsonschema, e.luxon, e["mobx-utils"], e.lodash, e["d3-selection"], e["d3-shape"], e.react_ujs, e["@turf/center"], e["react-calendar"], e["error-stack-parser"], e["i18next-browser-languagedetector"], e["react-svg"], e["d3-scale"], e["react-virtuoso"], e["popper-max-size-modifier"], e["react-interval"], e["react-markdown"], e["remark-gfm"], e["url-pattern"], e["p-debounce"], e["@miriamtech/if2-crops"]);
}(window, function (e, t, r, n, o, i, a, c, u, l, s, p, f, d, b, y, m, v, h, g, w, O, j, P, _, E, S, C, k, R, T, z, N, D, x, A, M) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 368);
  }([function (t, r) {
    t.exports = e;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t) {
    e.exports = n;
  }, function (e, t) {
    e.exports = o;
  },, function (e, t) {
    e.exports = i;
  }, function (e, t) {
    e.exports = a;
  }, function (e, t) {
    e.exports = c;
  }, function (e, t) {
    e.exports = u;
  }, function (e, t) {
    e.exports = l;
  }, function (e, t) {
    e.exports = s;
  }, function (e, t, r) {
    "use strict";

    r.d(t, "a", function () {
      return w;
    });
    var n,
        o,
        i,
        a,
        c = r(0),
        u = r.n(c),
        l = r(1),
        s = r(2),
        p = r(7),
        f = r.n(p);
    r(20), r(21);

    function d(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function b(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, y(n.key), n);
      }
    }

    function y(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function m(e, t, r) {
      return t = v(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], v(e).constructor) : t.apply(e, r));
    }

    function v(e) {
      return (v = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function h(e, t) {
      return (h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function g(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    f()(document).off(".data-api");
    var w = Object(s.observer)((i = g((o = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return d(e = m(this, t, [].concat(n)), "onChange", i, e), d(e, "onClick", a, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && h(e, t);
      }(t, c["Component"]), r = t, (n = [{
        key: "componentDidMount",
        value: function () {
          f()('.checkbox[data-toggle="tooltip"]').tooltip({
            delay: {
              show: 700
            },
            trigger: "hover"
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.id,
              r = e.className,
              n = e.isChecked,
              o = e.isDisabled,
              i = e.title,
              a = e.tabIndex,
              c = e.testId;
          return u.a.createElement("input", {
            id: t,
            tabIndex: a,
            title: i,
            "data-toggle": "tooltip",
            "data-testid": c,
            type: "checkbox",
            className: "checkbox".concat(r ? " ".concat(r) : ""),
            value: n,
            checked: n,
            onChange: this.onChange,
            onClick: this.onClick,
            disabled: o
          });
        }
      }]) && b(r.prototype, n), o && b(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "onChange", [l.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          (0, e.props.onChange)(t.target.checked);
        };
      }
    }), a = g(o.prototype, "onClick", [l.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return function (e) {
          e.stopPropagation();
        };
      }
    }), n = o)) || n;
  }, function (e, t, r) {
    var n;
    /*!
      Copyright (c) 2018 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    /*!
      Copyright (c) 2018 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      var r = {}.hasOwnProperty;

      function o() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var n = arguments[t];

          if (n) {
            var i = typeof n;
            if ("string" === i || "number" === i) e.push(n);else if (Array.isArray(n)) {
              if (n.length) {
                var a = o.apply(null, n);
                a && e.push(a);
              }
            } else if ("object" === i) if (n.toString === Object.prototype.toString) for (var c in n) r.call(n, c) && n[c] && e.push(c);else e.push(n.toString());
          }
        }

        return e.join(" ");
      }

      e.exports ? (o.default = o, e.exports = o) : void 0 === (n = function () {
        return o;
      }.apply(t, [])) || (e.exports = n);
    }();
  }, function (e, t, r) {
    var n = r(341)("round");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(223),
        o = r(100),
        i = r(119),
        a = r(55),
        c = i(function (e, t) {
      if (null == e) return [];
      var r = t.length;
      return r > 1 && a(e, t[0], t[1]) ? t = [] : r > 2 && a(t[0], t[1], t[2]) && (t = [t[0]]), o(e, n(t, 1), []);
    });
    e.exports = c;
  }, function (e, t) {
    var r = Array.isArray;
    e.exports = r;
  }, function (e, t, r) {
    var n = r(99),
        o = "object" == typeof self && self && self.Object === Object && self,
        i = n || o || Function("return this")();
    e.exports = i;
  }, function (e, t, r) {
    var n = r(315),
        o = r(316);

    e.exports = function (e, t, r) {
      var i = t && r || 0;
      "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
      var a = (e = e || {}).random || (e.rng || n)();
      if (a[6] = 15 & a[6] | 64, a[8] = 63 & a[8] | 128, t) for (var c = 0; c < 16; ++c) t[i + c] = a[c];
      return t || o(a);
    };
  }, function (e, t) {
    e.exports = p;
  }, function (e, t) {
    e.exports = f;
  }, function (e, t) {
    e.exports = d;
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    };
  }, function (e, t) {
    e.exports = b;
  }, function (e, t) {
    e.exports = y;
  }, function (e, t) {
    e.exports = function (e) {
      return null != e && "object" == typeof e;
    };
  }, function (e, t, r) {
    "use strict";

    r.d(t, "a", function () {
      return b;
    });
    var n,
        o = r(0),
        i = r.n(o),
        a = r(2),
        c = r(11),
        u = r(12);

    function l(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, s(n.key), n);
      }
    }

    function s(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function p(e, t, r) {
      return t = f(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], f(e).constructor) : t.apply(e, r));
    }

    function f(e) {
      return (f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function d(e, t) {
      return (d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var b = Object(a.observer)(n = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = p(this, t, [e])).fingerprint = Object(c.v4)(), r.id = "checkbox-".concat(r.fingerprint), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && d(e, t);
      }(t, o["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.label,
              r = e.className;
          return i.a.createElement("div", {
            className: "checkbox-with-label-container"
          }, i.a.createElement(u.a, Object.assign({
            id: this.id,
            className: r
          }, this.props)), i.a.createElement("label", {
            htmlFor: this.id,
            className: "ml-2"
          }, t));
        }
      }]) && l(r.prototype, n), a && l(r, a), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, a;
    }()) || n;
  }, function (e, t) {
    e.exports = m;
  }, function (e, t) {
    e.exports = v;
  }, function (e, t, r) {
    var n = r(234),
        o = r(237);

    e.exports = function (e, t) {
      var r = o(e, t);
      return n(r) ? r : void 0;
    };
  }, function (e, t, r) {
    var n = r(17).Symbol;
    e.exports = n;
  }, function (e, t, r) {
    var n = r(30),
        o = r(226),
        i = r(227),
        a = "[object Null]",
        c = "[object Undefined]",
        u = n ? n.toStringTag : void 0;

    e.exports = function (e) {
      return null == e ? void 0 === e ? c : a : u && u in Object(e) ? o(e) : i(e);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return e === t || e != e && t != t;
    };
  }, function (e, t, r) {
    var n = r(69),
        o = r(75);

    e.exports = function (e) {
      return null != e && o(e.length) && !n(e);
    };
  }, function (e, t) {
    e.exports = function (e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    };
  }, function (e, t, r) {
    var n = r(22),
        o = r(314),
        i = r(81),
        a = "Expected a function",
        c = Math.max,
        u = Math.min;

    e.exports = function (e, t, r) {
      var l,
          s,
          p,
          f,
          d,
          b,
          y = 0,
          m = !1,
          v = !1,
          h = !0;
      if ("function" != typeof e) throw new TypeError(a);

      function g(t) {
        var r = l,
            n = s;
        return l = s = void 0, y = t, f = e.apply(n, r);
      }

      function w(e) {
        var r = e - b;
        return void 0 === b || r >= t || r < 0 || v && e - y >= p;
      }

      function O() {
        var e = o();
        if (w(e)) return j(e);
        d = setTimeout(O, function (e) {
          var r = t - (e - b);
          return v ? u(r, p - (e - y)) : r;
        }(e));
      }

      function j(e) {
        return d = void 0, h && l ? g(e) : (l = s = void 0, f);
      }

      function P() {
        var e = o(),
            r = w(e);

        if (l = arguments, s = this, b = e, r) {
          if (void 0 === d) return function (e) {
            return y = e, d = setTimeout(O, t), m ? g(e) : f;
          }(b);
          if (v) return clearTimeout(d), d = setTimeout(O, t), g(b);
        }

        return void 0 === d && (d = setTimeout(O, t)), f;
      }

      return t = i(t) || 0, n(r) && (m = !!r.leading, p = (v = "maxWait" in r) ? c(i(r.maxWait) || 0, t) : p, h = "trailing" in r ? !!r.trailing : h), P.cancel = function () {
        void 0 !== d && clearTimeout(d), y = 0, l = b = s = d = void 0;
      }, P.flush = function () {
        return void 0 === d ? f : j(o());
      }, P;
    };
  }, function (e, t, r) {
    var n = r(31),
        o = r(25),
        i = "[object Symbol]";

    e.exports = function (e) {
      return "symbol" == typeof e || o(e) && n(e) == i;
    };
  }, function (e, t, r) {
    var n = r(113),
        o = r(273),
        i = r(33);

    e.exports = function (e) {
      return i(e) ? n(e) : o(e);
    };
  }, function (e, t, r) {
    var n = r(127),
        o = r(78);

    e.exports = function (e, t, r, i) {
      var a = !r;
      r || (r = {});

      for (var c = -1, u = t.length; ++c < u;) {
        var l = t[c],
            s = i ? i(r[l], e[l], l, r, e) : void 0;
        void 0 === s && (s = e[l]), a ? o(r, l, s) : n(r, l, s);
      }

      return r;
    };
  }, function (e, t, r) {
    var n = r(113),
        o = r(307),
        i = r(33);

    e.exports = function (e) {
      return i(e) ? n(e, !0) : o(e);
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, r, n, o, i, a, c) {
      if (!e) {
        var u;
        if (void 0 === t) u = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var l = [r, n, o, i, a, c],
              s = 0;
          (u = new Error(t.replace(/%s/g, function () {
            return l[s++];
          }))).name = "Invariant Violation";
        }
        throw u.framesToPop = 1, u;
      }
    };
  }, function (e, t) {
    e.exports = h;
  }, function (e, t, r) {
    (function (e) {
      function r(e, t) {
        for (var r = 0, n = e.length - 1; n >= 0; n--) {
          var o = e[n];
          "." === o ? e.splice(n, 1) : ".." === o ? (e.splice(n, 1), r++) : r && (e.splice(n, 1), r--);
        }

        if (t) for (; r--; r) e.unshift("..");
        return e;
      }

      function n(e, t) {
        if (e.filter) return e.filter(t);

        for (var r = [], n = 0; n < e.length; n++) t(e[n], n, e) && r.push(e[n]);

        return r;
      }

      t.resolve = function () {
        for (var t = "", o = !1, i = arguments.length - 1; i >= -1 && !o; i--) {
          var a = i >= 0 ? arguments[i] : e.cwd();
          if ("string" != typeof a) throw new TypeError("Arguments to path.resolve must be strings");
          a && (t = a + "/" + t, o = "/" === a.charAt(0));
        }

        return (o ? "/" : "") + (t = r(n(t.split("/"), function (e) {
          return !!e;
        }), !o).join("/")) || ".";
      }, t.normalize = function (e) {
        var i = t.isAbsolute(e),
            a = "/" === o(e, -1);
        return (e = r(n(e.split("/"), function (e) {
          return !!e;
        }), !i).join("/")) || i || (e = "."), e && a && (e += "/"), (i ? "/" : "") + e;
      }, t.isAbsolute = function (e) {
        return "/" === e.charAt(0);
      }, t.join = function () {
        var e = Array.prototype.slice.call(arguments, 0);
        return t.normalize(n(e, function (e, t) {
          if ("string" != typeof e) throw new TypeError("Arguments to path.join must be strings");
          return e;
        }).join("/"));
      }, t.relative = function (e, r) {
        function n(e) {
          for (var t = 0; t < e.length && "" === e[t]; t++);

          for (var r = e.length - 1; r >= 0 && "" === e[r]; r--);

          return t > r ? [] : e.slice(t, r - t + 1);
        }

        e = t.resolve(e).substr(1), r = t.resolve(r).substr(1);

        for (var o = n(e.split("/")), i = n(r.split("/")), a = Math.min(o.length, i.length), c = a, u = 0; u < a; u++) if (o[u] !== i[u]) {
          c = u;
          break;
        }

        var l = [];

        for (u = c; u < o.length; u++) l.push("..");

        return (l = l.concat(i.slice(c))).join("/");
      }, t.sep = "/", t.delimiter = ":", t.dirname = function (e) {
        if ("string" != typeof e && (e += ""), 0 === e.length) return ".";

        for (var t = e.charCodeAt(0), r = 47 === t, n = -1, o = !0, i = e.length - 1; i >= 1; --i) if (47 === (t = e.charCodeAt(i))) {
          if (!o) {
            n = i;
            break;
          }
        } else o = !1;

        return -1 === n ? r ? "/" : "." : r && 1 === n ? "/" : e.slice(0, n);
      }, t.basename = function (e, t) {
        var r = function (e) {
          "string" != typeof e && (e += "");
          var t,
              r = 0,
              n = -1,
              o = !0;

          for (t = e.length - 1; t >= 0; --t) if (47 === e.charCodeAt(t)) {
            if (!o) {
              r = t + 1;
              break;
            }
          } else -1 === n && (o = !1, n = t + 1);

          return -1 === n ? "" : e.slice(r, n);
        }(e);

        return t && r.substr(-1 * t.length) === t && (r = r.substr(0, r.length - t.length)), r;
      }, t.extname = function (e) {
        "string" != typeof e && (e += "");

        for (var t = -1, r = 0, n = -1, o = !0, i = 0, a = e.length - 1; a >= 0; --a) {
          var c = e.charCodeAt(a);
          if (47 !== c) -1 === n && (o = !1, n = a + 1), 46 === c ? -1 === t ? t = a : 1 !== i && (i = 1) : -1 !== t && (i = -1);else if (!o) {
            r = a + 1;
            break;
          }
        }

        return -1 === t || -1 === n || 0 === i || 1 === i && t === n - 1 && t === r + 1 ? "" : e.slice(t, n);
      };
      var o = "b" === "ab".substr(-1) ? function (e, t, r) {
        return e.substr(t, r);
      } : function (e, t, r) {
        return t < 0 && (t = e.length + t), e.substr(t, r);
      };
    }).call(this, r(97));
  }, function (e, t, r) {
    "use strict";

    r.d(t, "a", function () {
      return b;
    }), r.d(t, "c", function () {
      return y;
    }), r.d(t, "b", function () {
      return m;
    }), r.d(t, "d", function () {
      return v;
    }), r.d(t, "e", function () {
      return h;
    });
    var n = r(135),
        o = r.n(n),
        i = r(136),
        a = r.n(i),
        c = r(34),
        u = r.n(c),
        l = r(0);

    function s(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function p(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? s(Object(r), !0).forEach(function (t) {
          u()(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var f,
        d = {
      bindI18n: "languageChanged",
      bindI18nStore: "",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: !0,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
      useSuspense: !0
    },
        b = r.n(l).a.createContext();

    function y() {
      return d;
    }

    var m = function () {
      function e() {
        o()(this, e), this.usedNamespaces = {};
      }

      return a()(e, [{
        key: "addUsedNamespaces",
        value: function (e) {
          var t = this;
          e.forEach(function (e) {
            t.usedNamespaces[e] || (t.usedNamespaces[e] = !0);
          });
        }
      }, {
        key: "getUsedNamespaces",
        value: function () {
          return Object.keys(this.usedNamespaces);
        }
      }]), e;
    }();

    function v() {
      return f;
    }

    var h = {
      type: "3rdParty",
      init: function (e) {
        !function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          d = p(p({}, d), e);
        }(e.options.react), function (e) {
          f = e;
        }(e);
      }
    };
  }, function (e, t, r) {
    var n = r(225),
        o = r(25),
        i = Object.prototype,
        a = i.hasOwnProperty,
        c = i.propertyIsEnumerable,
        u = n(function () {
      return arguments;
    }()) ? n : function (e) {
      return o(e) && a.call(e, "callee") && !c.call(e, "callee");
    };
    e.exports = u;
  }, function (e, t, r) {
    var n = r(29)(Object, "create");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(242),
        o = r(243),
        i = r(244),
        a = r(245),
        c = r(246);

    function u(e) {
      var t = -1,
          r = null == e ? 0 : e.length;

      for (this.clear(); ++t < r;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }

    u.prototype.clear = n, u.prototype.delete = o, u.prototype.get = i, u.prototype.has = a, u.prototype.set = c, e.exports = u;
  }, function (e, t, r) {
    var n = r(32);

    e.exports = function (e, t) {
      for (var r = e.length; r--;) if (n(e[r][0], t)) return r;

      return -1;
    };
  }, function (e, t, r) {
    var n = r(248);

    e.exports = function (e, t) {
      var r = e.__data__;
      return n(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
    };
  }, function (e, t, r) {
    var n = r(36),
        o = 1 / 0;

    e.exports = function (e) {
      if ("string" == typeof e || n(e)) return e;
      var t = e + "";
      return "0" == t && 1 / e == -o ? "-0" : t;
    };
  }, function (e, t, r) {
    var n = r(46),
        o = r(255),
        i = r(256),
        a = r(257),
        c = r(258),
        u = r(259);

    function l(e) {
      var t = this.__data__ = new n(e);
      this.size = t.size;
    }

    l.prototype.clear = o, l.prototype.delete = i, l.prototype.get = a, l.prototype.has = c, l.prototype.set = u, e.exports = l;
  }, function (e, t, r) {
    (function (e) {
      var n = r(17),
          o = r(271),
          i = t && !t.nodeType && t,
          a = i && "object" == typeof e && e && !e.nodeType && e,
          c = a && a.exports === i ? n.Buffer : void 0,
          u = (c ? c.isBuffer : void 0) || o;
      e.exports = u;
    }).call(this, r(72)(e));
  }, function (e, t) {
    e.exports = function (e) {
      return function (t) {
        return e(t);
      };
    };
  }, function (e, t, r) {
    var n = r(275),
        o = r(70),
        i = r(276),
        a = r(277),
        c = r(278),
        u = r(31),
        l = r(103),
        s = l(n),
        p = l(o),
        f = l(i),
        d = l(a),
        b = l(c),
        y = u;
    (n && "[object DataView]" != y(new n(new ArrayBuffer(1))) || o && "[object Map]" != y(new o()) || i && "[object Promise]" != y(i.resolve()) || a && "[object Set]" != y(new a()) || c && "[object WeakMap]" != y(new c())) && (y = function (e) {
      var t = u(e),
          r = "[object Object]" == t ? e.constructor : void 0,
          n = r ? l(r) : "";
      if (n) switch (n) {
        case s:
          return "[object DataView]";

        case p:
          return "[object Map]";

        case f:
          return "[object Promise]";

        case d:
          return "[object Set]";

        case b:
          return "[object WeakMap]";
      }
      return t;
    }), e.exports = y;
  }, function (e, t) {
    e.exports = function (e) {
      return e;
    };
  }, function (e, t, r) {
    var n = r(32),
        o = r(33),
        i = r(73),
        a = r(22);

    e.exports = function (e, t, r) {
      if (!a(r)) return !1;
      var c = typeof t;
      return !!("number" == c ? o(r) && i(t, r.length) : "string" == c && t in r) && n(r[t], e);
    };
  }, function (e, t, r) {
    "use strict";

    var n = function () {};

    e.exports = n;
  }, function (e, t, r) {
    var n = r(217),
        o = r(218),
        i = r(219),
        a = r(221);

    e.exports = function (e, t) {
      return n(e) || o(e, t) || i(e, t) || a();
    };
  }, function (e, t) {
    e.exports = g;
  }, function (e, t, r) {
    var n = r(301),
        o = r(309)(function (e, t, r) {
      n(e, t, r);
    });
    e.exports = o;
  }, function (e, t, r) {
    var n = r(100),
        o = r(16);

    e.exports = function (e, t, r, i) {
      return null == e ? [] : (o(t) || (t = null == t ? [] : [t]), o(r = i ? void 0 : r) || (r = null == r ? [] : [r]), n(e, t, r));
    };
  }, function (e, t) {
    e.exports = w;
  }, function (e, t, r) {
    "use strict";

    var n,
        o,
        i = r(0),
        a = r.n(i),
        c = r(1),
        u = r(2);

    function l(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, s(n.key), n);
      }
    }

    function s(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function p(e, t, r) {
      return t = f(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], f(e).constructor) : t.apply(e, r));
    }

    function f(e) {
      return (f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function d(e, t) {
      return (d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var b,
        y,
        m,
        v,
        h,
        g,
        w = Object(u.observer)((b = (o = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), p(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && d(e, t);
      }(t, i["Component"]), r = t, (n = [{
        key: "equipment",
        get: function () {
          var e = this.props,
              t = e.tractor,
              r = e.sprayer,
              n = e.spreader,
              o = e.sprayRate,
              i = [].concat(t || []).concat(r || []).concat(n || []).concat((null == o ? void 0 : o.displayValue) || []).map(function (e) {
            return a.a.createElement("span", {
              key: e
            }, e);
          });
          return i.length ? i.reduce(function (e, t) {
            return [e, " / ", t];
          }) : null;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.className;
          return a.a.createElement("span", {
            className: e
          }, this.equipment);
        }
      }]) && l(r.prototype, n), o && l(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, y = "equipment", m = [c.computed], v = Object.getOwnPropertyDescriptor(o.prototype, "equipment"), h = o.prototype, g = {}, Object.keys(v).forEach(function (e) {
      g[e] = v[e];
    }), g.enumerable = !!g.enumerable, g.configurable = !!g.configurable, ("value" in g || g.initializer) && (g.writable = !0), g = m.slice().reverse().reduce(function (e, t) {
      return t(b, y, e) || e;
    }, g), h && void 0 !== g.initializer && (g.value = g.initializer ? g.initializer.call(h) : void 0, g.initializer = void 0), void 0 === g.initializer && Object.defineProperty(b, y, g), n = o)) || n;
    t.a = w;
  }, function (e, t, r) {
    "use strict";

    r.d(t, "a", function () {
      return d;
    });
    var n,
        o,
        i,
        a,
        c,
        u = r(1);

    function l(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function s(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, p(n.key), n);
      }
    }

    function p(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function f(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var d = ((c = function () {
      function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), l(this, "_sortTable", o, this), l(this, "addSort", i, this), l(this, "removeSort", a, this);
      }

      return t = e, (r = [{
        key: "isSorting",
        value: function (e) {
          return Boolean(this._sortTable[e]);
        }
      }, {
        key: "isSortingDown",
        value: function (e) {
          return this._sortTable[e] === this.constructor.DESC;
        }
      }, {
        key: "isSortingUp",
        value: function (e) {
          return this._sortTable[e] === this.constructor.ASC;
        }
      }, {
        key: "dump",
        value: function () {
          var e = this;
          return Object.keys(this._sortTable || {}).map(function (t) {
            return {
              key: t,
              sort_type: e._sortTable[t]
            };
          });
        }
      }, {
        key: "load",
        value: function (t) {
          var r = this;
          (t || []).forEach(function (t) {
            r._sortTable[t.key] = t.sort_type || e.ASC;
          });
        }
      }]) && s(t.prototype, r), n && s(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), t;
      var t, r, n;
    }()).ASC = "sort_asc", c.DESC = "sort_desc", o = f((n = c).prototype, "_sortTable", [u.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return {};
      }
    }), i = f(n.prototype, "addSort", [u.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r) {
          var n = r || d.ASC;
          e.isSorting(t) && e.removeSort(t), e._sortTable[t] = n;
        };
      }
    }), a = f(n.prototype, "removeSort", [u.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          delete e._sortTable[t];
        };
      }
    }), f(n.prototype, "load", [u.action], Object.getOwnPropertyDescriptor(n.prototype, "load"), n.prototype), n);
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = t.length, o = e.length; ++r < n;) e[o + r] = t[r];

      return e;
    };
  }, function (e, t) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (r = window);
    }

    e.exports = r;
  }, function (e, t, r) {
    var n = r(102),
        o = r(49);

    e.exports = function (e, t) {
      for (var r = 0, i = (t = n(t, e)).length; null != e && r < i;) e = e[o(t[r++])];

      return r && r == i ? e : void 0;
    };
  }, function (e, t, r) {
    var n = r(16),
        o = r(36),
        i = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        a = /^\w*$/;

    e.exports = function (e, t) {
      if (n(e)) return !1;
      var r = typeof e;
      return !("number" != r && "symbol" != r && "boolean" != r && null != e && !o(e)) || a.test(e) || !i.test(e) || null != t && e in Object(t);
    };
  }, function (e, t, r) {
    var n = r(231),
        o = r(247),
        i = r(249),
        a = r(250),
        c = r(251);

    function u(e) {
      var t = -1,
          r = null == e ? 0 : e.length;

      for (this.clear(); ++t < r;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }

    u.prototype.clear = n, u.prototype.delete = o, u.prototype.get = i, u.prototype.has = a, u.prototype.set = c, e.exports = u;
  }, function (e, t, r) {
    var n = r(31),
        o = r(22),
        i = "[object AsyncFunction]",
        a = "[object Function]",
        c = "[object GeneratorFunction]",
        u = "[object Proxy]";

    e.exports = function (e) {
      if (!o(e)) return !1;
      var t = n(e);
      return t == a || t == c || t == i || t == u;
    };
  }, function (e, t, r) {
    var n = r(29)(r(17), "Map");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(269),
        o = r(112),
        i = Object.prototype.propertyIsEnumerable,
        a = Object.getOwnPropertySymbols,
        c = a ? function (e) {
      return null == e ? [] : (e = Object(e), n(a(e), function (t) {
        return i.call(e, t);
      }));
    } : o;
    e.exports = c;
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function () {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function () {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t) {
    var r = 9007199254740991,
        n = /^(?:0|[1-9]\d*)$/;

    e.exports = function (e, t) {
      var o = typeof e;
      return !!(t = null == t ? r : t) && ("number" == o || "symbol" != o && n.test(e)) && e > -1 && e % 1 == 0 && e < t;
    };
  }, function (e, t, r) {
    var n = r(272),
        o = r(52),
        i = r(76),
        a = i && i.isTypedArray,
        c = a ? o(a) : n;
    e.exports = c;
  }, function (e, t) {
    var r = 9007199254740991;

    e.exports = function (e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= r;
    };
  }, function (e, t, r) {
    (function (e) {
      var n = r(99),
          o = t && !t.nodeType && t,
          i = o && "object" == typeof e && e && !e.nodeType && e,
          a = i && i.exports === o && n.process,
          c = function () {
        try {
          var e = i && i.require && i.require("util").types;

          return e || a && a.binding && a.binding("util");
        } catch (e) {}
      }();

      e.exports = c;
    }).call(this, r(72)(e));
  }, function (e, t) {
    var r = Object.prototype;

    e.exports = function (e) {
      var t = e && e.constructor;
      return e === ("function" == typeof t && t.prototype || r);
    };
  }, function (e, t, r) {
    var n = r(120);

    e.exports = function (e, t, r) {
      "__proto__" == t && n ? n(e, t, {
        configurable: !0,
        enumerable: !0,
        value: r,
        writable: !0
      }) : e[t] = r;
    };
  }, function (e, t, r) {
    var n = r(109);

    e.exports = function (e) {
      var t = new e.constructor(e.byteLength);
      return new n(t).set(new n(e)), t;
    };
  }, function (e, t, r) {
    var n = r(114)(Object.getPrototypeOf, Object);
    e.exports = n;
  }, function (e, t, r) {
    var n = r(312),
        o = r(22),
        i = r(36),
        a = NaN,
        c = /^[-+]0x[0-9a-f]+$/i,
        u = /^0b[01]+$/i,
        l = /^0o[0-7]+$/i,
        s = parseInt;

    e.exports = function (e) {
      if ("number" == typeof e) return e;
      if (i(e)) return a;

      if (o(e)) {
        var t = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = o(t) ? t + "" : t;
      }

      if ("string" != typeof e) return 0 === e ? e : +e;
      e = n(e);
      var r = u.test(e);
      return r || l.test(e) ? s(e.slice(2), r ? 2 : 8) : c.test(e) ? a : +e;
    };
  }, function (e, t, r) {
    (function (e) {
      var n = void 0 !== e && e || "undefined" != typeof self && self || window,
          o = Function.prototype.apply;

      function i(e, t) {
        this._id = e, this._clearFn = t;
      }

      t.setTimeout = function () {
        return new i(o.call(setTimeout, n, arguments), clearTimeout);
      }, t.setInterval = function () {
        return new i(o.call(setInterval, n, arguments), clearInterval);
      }, t.clearTimeout = t.clearInterval = function (e) {
        e && e.close();
      }, i.prototype.unref = i.prototype.ref = function () {}, i.prototype.close = function () {
        this._clearFn.call(n, this._id);
      }, t.enroll = function (e, t) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
      }, t.unenroll = function (e) {
        clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
      }, t._unrefActive = t.active = function (e) {
        clearTimeout(e._idleTimeoutId);
        var t = e._idleTimeout;
        t >= 0 && (e._idleTimeoutId = setTimeout(function () {
          e._onTimeout && e._onTimeout();
        }, t));
      }, r(343), t.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== e && e.setImmediate || this && this.setImmediate, t.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== e && e.clearImmediate || this && this.clearImmediate;
    }).call(this, r(65));
  }, function (e) {
    e.exports = JSON.parse('{"type":"object","properties":{"type":{"const":"UnitConversionColumn"},"id":{"type":"string"},"position":{"type":"integer"},"is_showing":{"type":"boolean"},"name_override":{"type":"string"},"units":{"type":"string"},"column_id":{"type":"string"}},"required":["type","id","position","is_showing","name_override","units","column_id"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"type":"object","properties":{"type":{"const":"ScalarColumn"},"id":{"type":"string"},"position":{"type":"integer"},"is_showing":{"type":"boolean"},"name_override":{"type":"string"},"column_id":{"type":"string"}},"required":["type","id","position","is_showing","name_override","column_id"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"type":"object","properties":{"type":{"const":"UnitsColumn"},"id":{"type":"string"},"position":{"type":"integer"},"is_showing":{"type":"boolean"},"name_override":{"type":"string"},"column_id":{"type":"string"}},"required":["type","id","position","is_showing","name_override","column_id"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"type":"object","properties":{"type":{"const":"AdditionColumn"},"id":{"type":"string"},"position":{"type":"integer"},"is_showing":{"type":"boolean"},"name_override":{"type":"string"},"operand1":{"$ref":"./calculation_operand.json"},"operand2":{"$ref":"./calculation_operand.json"}},"required":["type","id","position","is_showing","name_override","operand1","operand2"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"type":"object","properties":{"type":{"const":"BlankColumn"},"id":{"type":"string"},"position":{"type":"integer"},"is_showing":{"type":"boolean"},"name_override":{"type":"string"},"column_id":{"type":"string"}},"required":["type","id","position","is_showing","name_override","column_id"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"type":"object","properties":{"type":{"const":"DivisionColumn"},"id":{"type":"string"},"position":{"type":"integer"},"is_showing":{"type":"boolean"},"name_override":{"type":"string"},"operand1":{"$ref":"./calculation_operand.json"},"operand2":{"$ref":"./calculation_operand.json"}},"required":["type","id","position","is_showing","name_override","operand1","operand2"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"type":"object","properties":{"type":{"const":"IfColumn"},"id":{"type":"string"},"position":{"type":"integer"},"is_showing":{"type":"boolean"},"name_override":{"type":"string"},"conditional_column_id":{"type":"string"},"then_operand":{"$ref":"./calculation_operand.json"},"else_operand":{"$ref":"./calculation_operand.json"}},"required":["type","id","position","is_showing","name_override","conditional_column_id","then_operand","else_operand"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"type":"object","properties":{"type":{"const":"MultiplicationColumn"},"id":{"type":"string"},"position":{"type":"integer"},"is_showing":{"type":"boolean"},"name_override":{"type":"string"},"operand1":{"$ref":"./calculation_operand.json"},"operand2":{"$ref":"./calculation_operand.json"}},"required":["type","id","position","is_showing","name_override","operand1","operand2"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"type":"object","properties":{"type":{"const":"NotColumn"},"id":{"type":"string"},"position":{"type":"integer"},"is_showing":{"type":"boolean"},"name_override":{"type":"string"},"column_id":{"type":"string"}},"required":["type","id","position","is_showing","name_override","column_id"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"type":"object","properties":{"type":{"const":"OrColumn"},"id":{"type":"string"},"position":{"type":"integer"},"is_showing":{"type":"boolean"},"name_override":{"type":"string"},"operand1_column_id":{"type":"string"},"operand2_column_id":{"type":"string"}},"required":["type","id","position","is_showing","name_override","operand1_column_id","operand2_column_id"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"type":"object","properties":{"type":{"const":"SubtractionColumn"},"id":{"type":"string"},"position":{"type":"integer"},"is_showing":{"type":"boolean"},"name_override":{"type":"string"},"operand1":{"$ref":"./calculation_operand.json"},"operand2":{"$ref":"./calculation_operand.json"}},"required":["type","id","position","is_showing","name_override","operand1","operand2"],"additionalProperties":false}');
  }, function (e, t, r) {
    "use strict";

    var n = r(366),
        o = {
      childContextTypes: !0,
      contextType: !0,
      contextTypes: !0,
      defaultProps: !0,
      displayName: !0,
      getDefaultProps: !0,
      getDerivedStateFromError: !0,
      getDerivedStateFromProps: !0,
      mixins: !0,
      propTypes: !0,
      type: !0
    },
        i = {
      name: !0,
      length: !0,
      prototype: !0,
      caller: !0,
      callee: !0,
      arguments: !0,
      arity: !0
    },
        a = {
      $$typeof: !0,
      compare: !0,
      defaultProps: !0,
      displayName: !0,
      propTypes: !0,
      type: !0
    },
        c = {};

    function u(e) {
      return n.isMemo(e) ? a : c[e.$$typeof] || o;
    }

    c[n.ForwardRef] = {
      $$typeof: !0,
      render: !0,
      defaultProps: !0,
      displayName: !0,
      propTypes: !0
    }, c[n.Memo] = a;
    var l = Object.defineProperty,
        s = Object.getOwnPropertyNames,
        p = Object.getOwnPropertySymbols,
        f = Object.getOwnPropertyDescriptor,
        d = Object.getPrototypeOf,
        b = Object.prototype;

    e.exports = function e(t, r, n) {
      if ("string" != typeof r) {
        if (b) {
          var o = d(r);
          o && o !== b && e(t, o, n);
        }

        var a = s(r);
        p && (a = a.concat(p(r)));

        for (var c = u(t), y = u(r), m = 0; m < a.length; ++m) {
          var v = a[m];

          if (!(i[v] || n && n[v] || y && y[v] || c && c[v])) {
            var h = f(r, v);

            try {
              l(t, v, h);
            } catch (e) {}
          }
        }
      }

      return t;
    };
  }, function (e, t) {
    e.exports = O;
  }, function (e, t) {
    e.exports = j;
  }, function (e, t) {
    var r,
        n,
        o = e.exports = {};

    function i() {
      throw new Error("setTimeout has not been defined");
    }

    function a() {
      throw new Error("clearTimeout has not been defined");
    }

    function c(e) {
      if (r === setTimeout) return setTimeout(e, 0);
      if ((r === i || !r) && setTimeout) return r = setTimeout, setTimeout(e, 0);

      try {
        return r(e, 0);
      } catch (t) {
        try {
          return r.call(null, e, 0);
        } catch (t) {
          return r.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        r = "function" == typeof setTimeout ? setTimeout : i;
      } catch (e) {
        r = i;
      }

      try {
        n = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (e) {
        n = a;
      }
    }();
    var u,
        l = [],
        s = !1,
        p = -1;

    function f() {
      s && u && (s = !1, u.length ? l = u.concat(l) : p = -1, l.length && d());
    }

    function d() {
      if (!s) {
        var e = c(f);
        s = !0;

        for (var t = l.length; t;) {
          for (u = l, l = []; ++p < t;) u && u[p].run();

          p = -1, t = l.length;
        }

        u = null, s = !1, function (e) {
          if (n === clearTimeout) return clearTimeout(e);
          if ((n === a || !n) && clearTimeout) return n = clearTimeout, clearTimeout(e);

          try {
            n(e);
          } catch (t) {
            try {
              return n.call(null, e);
            } catch (t) {
              return n.call(this, e);
            }
          }
        }(e);
      }
    }

    function b(e, t) {
      this.fun = e, this.array = t;
    }

    function y() {}

    o.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
      l.push(new b(e, t)), 1 !== l.length || s || c(d);
    }, b.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = y, o.addListener = y, o.once = y, o.off = y, o.removeListener = y, o.removeAllListeners = y, o.emit = y, o.prependListener = y, o.prependOnceListener = y, o.listeners = function (e) {
      return [];
    }, o.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, o.cwd = function () {
      return "/";
    }, o.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, o.umask = function () {
      return 0;
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (e) {
      return function (t, r, n, o, i) {
        var a = n || "<<anonymous>>",
            c = i || r;
        if (null == t[r]) return new Error("The " + o + " `" + c + "` is required to make `" + a + "` accessible for users of assistive technologies such as screen readers.");

        for (var u = arguments.length, l = Array(u > 5 ? u - 5 : 0), s = 5; s < u; s++) l[s - 5] = arguments[s];

        return e.apply(void 0, [t, r, n, o, i].concat(l));
      };
    }, e.exports = t.default;
  }, function (e, t, r) {
    (function (t) {
      var r = "object" == typeof t && t && t.Object === Object && t;
      e.exports = r;
    }).call(this, r(65));
  }, function (e, t, r) {
    var n = r(101),
        o = r(66),
        i = r(105),
        a = r(288),
        c = r(292),
        u = r(52),
        l = r(293),
        s = r(54),
        p = r(16);

    e.exports = function (e, t, r) {
      t = t.length ? n(t, function (e) {
        return p(e) ? function (t) {
          return o(t, 1 === e.length ? e[0] : e);
        } : e;
      }) : [s];
      var f = -1;
      t = n(t, u(i));
      var d = a(e, function (e, r, o) {
        return {
          criteria: n(t, function (t) {
            return t(e);
          }),
          index: ++f,
          value: e
        };
      });
      return c(d, function (e, t) {
        return l(e, t, r);
      });
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = null == e ? 0 : e.length, o = Array(n); ++r < n;) o[r] = t(e[r], r, e);

      return o;
    };
  }, function (e, t, r) {
    var n = r(16),
        o = r(67),
        i = r(228),
        a = r(104);

    e.exports = function (e, t) {
      return n(e) ? e : o(e, t) ? [e] : i(a(e));
    };
  }, function (e, t) {
    var r = Function.prototype.toString;

    e.exports = function (e) {
      if (null != e) {
        try {
          return r.call(e);
        } catch (e) {}

        try {
          return e + "";
        } catch (e) {}
      }

      return "";
    };
  }, function (e, t, r) {
    var n = r(252);

    e.exports = function (e) {
      return null == e ? "" : n(e);
    };
  }, function (e, t, r) {
    var n = r(253),
        o = r(280),
        i = r(54),
        a = r(16),
        c = r(285);

    e.exports = function (e) {
      return "function" == typeof e ? e : null == e ? i : "object" == typeof e ? a(e) ? o(e[0], e[1]) : n(e) : c(e);
    };
  }, function (e, t, r) {
    var n = r(260),
        o = r(25);

    e.exports = function e(t, r, i, a, c) {
      return t === r || (null == t || null == r || !o(t) && !o(r) ? t != t && r != r : n(t, r, i, a, e, c));
    };
  }, function (e, t, r) {
    var n = r(261),
        o = r(108),
        i = r(264),
        a = 1,
        c = 2;

    e.exports = function (e, t, r, u, l, s) {
      var p = r & a,
          f = e.length,
          d = t.length;
      if (f != d && !(p && d > f)) return !1;
      var b = s.get(e),
          y = s.get(t);
      if (b && y) return b == t && y == e;
      var m = -1,
          v = !0,
          h = r & c ? new n() : void 0;

      for (s.set(e, t), s.set(t, e); ++m < f;) {
        var g = e[m],
            w = t[m];
        if (u) var O = p ? u(w, g, m, t, e, s) : u(g, w, m, e, t, s);

        if (void 0 !== O) {
          if (O) continue;
          v = !1;
          break;
        }

        if (h) {
          if (!o(t, function (e, t) {
            if (!i(h, t) && (g === e || l(g, e, r, u, s))) return h.push(t);
          })) {
            v = !1;
            break;
          }
        } else if (g !== w && !l(g, w, r, u, s)) {
          v = !1;
          break;
        }
      }

      return s.delete(e), s.delete(t), v;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = null == e ? 0 : e.length; ++r < n;) if (t(e[r], r, e)) return !0;

      return !1;
    };
  }, function (e, t, r) {
    var n = r(17).Uint8Array;
    e.exports = n;
  }, function (e, t, r) {
    var n = r(111),
        o = r(71),
        i = r(37);

    e.exports = function (e) {
      return n(e, i, o);
    };
  }, function (e, t, r) {
    var n = r(64),
        o = r(16);

    e.exports = function (e, t, r) {
      var i = t(e);
      return o(e) ? i : n(i, r(e));
    };
  }, function (e, t) {
    e.exports = function () {
      return [];
    };
  }, function (e, t, r) {
    var n = r(270),
        o = r(44),
        i = r(16),
        a = r(51),
        c = r(73),
        u = r(74),
        l = Object.prototype.hasOwnProperty;

    e.exports = function (e, t) {
      var r = i(e),
          s = !r && o(e),
          p = !r && !s && a(e),
          f = !r && !s && !p && u(e),
          d = r || s || p || f,
          b = d ? n(e.length, String) : [],
          y = b.length;

      for (var m in e) !t && !l.call(e, m) || d && ("length" == m || p && ("offset" == m || "parent" == m) || f && ("buffer" == m || "byteLength" == m || "byteOffset" == m) || c(m, y)) || b.push(m);

      return b;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return function (r) {
        return e(t(r));
      };
    };
  }, function (e, t, r) {
    var n = r(22);

    e.exports = function (e) {
      return e == e && !n(e);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return function (r) {
        return null != r && r[e] === t && (void 0 !== t || e in Object(r));
      };
    };
  }, function (e, t, r) {
    var n = r(289),
        o = r(291)(n);
    e.exports = o;
  }, function (e, t, r) {
    var n = r(290)();
    e.exports = n;
  }, function (e, t, r) {
    var n = r(54),
        o = r(295),
        i = r(297);

    e.exports = function (e, t) {
      return i(o(e, t, n), e + "");
    };
  }, function (e, t, r) {
    var n = r(29),
        o = function () {
      try {
        var e = n(Object, "defineProperty");
        return e({}, "", {}), e;
      } catch (e) {}
    }();

    e.exports = o;
  }, function (e, t, r) {
    var n = r(78),
        o = r(32);

    e.exports = function (e, t, r) {
      (void 0 === r || o(e[t], r)) && (void 0 !== r || t in e) || n(e, t, r);
    };
  }, function (e, t, r) {
    (function (e) {
      var n = r(17),
          o = t && !t.nodeType && t,
          i = o && "object" == typeof e && e && !e.nodeType && e,
          a = i && i.exports === o ? n.Buffer : void 0,
          c = a ? a.allocUnsafe : void 0;

      e.exports = function (e, t) {
        if (t) return e.slice();
        var r = e.length,
            n = c ? c(r) : new e.constructor(r);
        return e.copy(n), n;
      };
    }).call(this, r(72)(e));
  }, function (e, t, r) {
    var n = r(79);

    e.exports = function (e, t) {
      var r = t ? n(e.buffer) : e.buffer;
      return new e.constructor(r, e.byteOffset, e.length);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      var r = -1,
          n = e.length;

      for (t || (t = Array(n)); ++r < n;) t[r] = e[r];

      return t;
    };
  }, function (e, t, r) {
    var n = r(303),
        o = r(80),
        i = r(77);

    e.exports = function (e) {
      return "function" != typeof e.constructor || i(e) ? {} : n(o(e));
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
    };
  }, function (e, t, r) {
    var n = r(78),
        o = r(32),
        i = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, r) {
      var a = e[t];
      i.call(e, t) && o(a, r) && (void 0 !== r || t in e) || n(e, t, r);
    };
  }, function (e, t, r) {
    var n = r(81),
        o = 1 / 0,
        i = 17976931348623157e292;

    e.exports = function (e) {
      return e ? (e = n(e)) === o || e === -o ? (e < 0 ? -1 : 1) * i : e == e ? e : 0 : 0 === e ? e : 0;
    };
  }, function (e, t, r) {
    var n = r(64),
        o = r(80),
        i = r(71),
        a = r(112),
        c = Object.getOwnPropertySymbols ? function (e) {
      for (var t = []; e;) n(t, i(e)), e = o(e);

      return t;
    } : a;
    e.exports = c;
  }, function (e, t) {
    e.exports = function (e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    };
  }, function (e, t) {
    function r(t) {
      return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? e.exports = r = function (e) {
        return typeof e;
      } : e.exports = r = function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, r(t);
    }

    e.exports = r;
  }, function (e, t) {
    e.exports = function (e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];

      return n;
    };
  }, function (e, t, r) {
    var n = r(132);

    e.exports = function (e, t) {
      if (e) {
        if ("string" == typeof e) return n(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
      }
    };
  }, function (e, t, r) {
    var n = r(222);

    e.exports = function (e, t) {
      if (null == e) return {};
      var r,
          o,
          i = n(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (o = 0; o < a.length; o++) r = a[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
      }

      return i;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (e, t) {
    function r(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    e.exports = function (e, t, n) {
      return t && r(e.prototype, t), n && r(e, n), e;
    };
  }, function (e, t) {
    e.exports = P;
  }, function (e, t) {
    e.exports = _;
  }, function (e, t) {
    e.exports = E;
  }, function (e, t) {
    e.exports = S;
  }, function (e) {
    e.exports = JSON.parse('{"en":{"account_contacts":"%{account.name} Contacts","add_contact":"Add Contact","confirm_delete_contact":"Are you sure you want to delete the contact \'%{name}\'?","contact_not_found":"Contact not found","contact_updated":"Contact updated","create_user":"Create User","edit_contact":"Edit Contact","if2":{"contacts":{"inaccessible_accounts":{"one":"%{count} other account you don\'t have permission to access","other":"%{count} other accounts you don\'t have permission to access"},"is_default_licensed_applicator_for":"%{name} is the default licensed applicator for the following accounts:","is_emergency_contact_for":"%{name} is the emergency contact for the following accounts:","please_resolve_these_issues":"Please resolve these issues, then try again.","try_delete_again":"Try delete again","unable_to_delete":"Unable to delete contact"}},"new_contact":"New Contact","new_contact_for":"New Contact for %{name}","search_contacts":"Search Contacts","successfully_added_contact":"Successfully added contact %{name}","successfully_updated_contact":"Successfully updated contact","view_contact":"View Contact","you_have_successfully_deleted_contact":"You have successfully deleted %{name}"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"activerecord":{"errors":{"messages":{"account_cannot_have_prices":"is not allowed to have prices"}}},"if2":{"account_prices":{"inherited_from":"These product prices are inherited from %{account}."}}}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"IF2::Account":"account","IF2::Accounts::Branch":"account","IF2::Accounts::Corporate":"account","IF2::Accounts::General":"account","IF2::Accounts::Grower":"account","account_deleted":"Account %{name} deleted","account_plus_name_updated":"Account %{name} updated","activerecord":{"attributes":{"if2/account":{"default_licensed_applicator":"Default licensed applicator"}},"errors":{"messages":{"must_have_license_number":"must have a license number"}}},"add_account":"Add Account","add_sub_account":"Add Sub Account","change_account":"Change Account","confirm_delete_account":"Are you sure you want to delete \\"%{name}\\"?","edit_account":"Edit Account","full_name":"Full Name","manage":"Manage","new_account":"New Account","notification_lists":"Notification Lists","notification_lists_contacts_should_be_notified_when":"The following contacts should be notified when","notification_lists_no_contacts_specified":"No contacts specified","notification_lists_recommendation_approval_title":"Recommendations Needing Review/Approval","notification_lists_recommendation_approval_when":"unapproved recommendations are ready for review","notification_lists_recommendation_title":"Recommendations","notification_lists_recommendation_when":"new recommendations are made for this account","parent_account_not_found":"Parent account not found","position_under":"Position Under","record_application_amounts_in":"Record Application Amounts In","search":"Search","search_accounts":"Search Accounts","select_account":"Select Account","select_accounts":"Select Accounts","street_1":"Street 1","street_2":"Street 2","sub_accounts":"Sub Accounts","this_account_cant_be_deleted_until":"This account can\'t be deleted until all of its sub-accounts, users, application records, etc. are deleted","type":"Type","unable_to_delete_account":"Unable to delete account: %{error}","unable_to_delete_account_users_still_assigned":"Unable to delete account: users are still assigned to this account","unable_to_delete_account_with_sub_accounts":"Unable to delete account: deleting account with sub-accounts is not permitted","unable_to_delete_root":"Unable to delete account: deleting root account is not permitted","unable_to_update_account":"Unable to update account: %{error}","unable_to_update_account_change_parent_root":"Unable to update account: changing the parent of a root account is not permitted","you_cant_move_account_under_itself":"You can\'t move this account under itself or one of its descendants","zip":"ZIP"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"active_ingredient_cannot_be_destroyed":"This active ingredient is being used by products. Only active ingredients that are not used may be deleted.","add_active_ingredient":"Add Active Ingredient","ai_created":"%{name} created","ai_updated":"%{name} updated","cas_number":"CAS Number","cas_number_optional":"CAS Number (optional)","cas_number_short":"CAS #","confirm_delete_ai":"Are you sure you want to delete the Active Ingredient: %{ai}?","edit_active_ingredient":"Edit Active Ingredient","enter_cas_number":"Enter CAS # to search and import active ingredient data from the EPA","enter_name_to_search":"Enter name to search and import active ingredient data from the EPA","error_creating_active_ingredient":"Error creating the active ingredient: %{error}","error_updating_active_ingredient":"Error updating the active ingredient: %{error}","find_active_ingredient":"Find Active Ingredient","ingredient_not_found":"Ingredient Not Found","ingredient_not_found_in_database":"Ingredient Not Found in Database","limited_by_espp":"Limited By ESPP","liquid_concentration":"Liquid Concentration","mode_of_action":"Mode of Action","name_optional":"Name (optional)","new_active_ingredient":"New Active Ingredient","products_with_this_active_ingredient":"Products with this Active Ingredient","search_active_ingredients":"Search active ingredients","set_active_ingredient_percent":"Set Active Ingredient Percent","short_name":"Short Name","toxicity_category":"Toxicity Category","toxicity_class":"Toxcity Class","use_may_be_limited_under_the_epa":"Use may be limited under the EPA Endangered Species Protection Program (ESPP)"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"if2":{"action_not_authorized":"You are not authorized to perform this action","invalid_authenticity_request":"Can\'t verify authenticity of request"},"incorrect_username_or_password":"Incorrect username or password","log_in":"Sign In","password":"Password","permission_denied_logged_out":"Permission denied. You have been logged out.","username":"Username"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"add":"Add","add_column":"Add Column","add_new":"Add New","adding":"Adding","address":"Address","all_equipment_types":"All","applicators":"Applicators","applied_pl_masc":"applied","applied_sing_masc":"applied","apply":"Apply","author":"Author","base_units":"Base Units","bee_hazard":"Bee Hazard","cancel":"Cancel","cannot_be_blank":"Cannot be blank","category":"Category","choose_account":"Choose Account","choose_columns":"Choose Columns","city":"City","clear_all":"Clear All","clear_filters":"Clear Filters","close":"Close","collapse_all":"Collapse All","complete":"Complete","contact":"Contact","date_date":"Date","date_dates":"Date(s)","delete":"Delete","download":"Download","edit":"Edit","effective_date":"Effective Date","email_address":"Email Address","epa_number":"EPA Number","equipment":"Equipment","existing":"Existing","expand_all":"Expand All","field":"Field","filter":"Filter","filter_summary":"Filter Summary","filters":"Filters","first_name":"First Name","floz":"fluid ounces (floz)","formulation":"Formulation","grams":"grams","grand_total":"Grand Total:","hide":"Hide","incomplete":"Incomplete","kilograms":"kilograms (kg)","last_name":"Last Name","lastname_cannot_be_blank":"Last name can\'t be blank","license_number":"License #","license_number_cannot_be_blank":"License number can\'t be blank","license_number_full":"License Number","liters":"liters (L)","login_required":"Login required","make_default":"Make Default","max":"Max","mils":"milliliters (mL)","more":"More","n_a":"N/A","name":"Name","name_cannot_be_blank":"Name can\'t be blank","never":"Never","next":"Next","nutrient_analysis":"Nutrient Analysis","ok":"OK","ounces_dry":"ounces (dry)","percent":"Percent","phone":"Phone","phone_number":"Phone Number","pints":"pints","pounds":"pounds","previous":"Previous","price":"Price","privileges":"Privileges","product":"Product","product_name":"Product Name","quantity":"Quantity","quarts":"quarts","rate":"Rate","reason":"Reason","recommendations":"Recommendations","remove":"Remove","review":"Review","save":"Save","save_changes":"Save Changes","search_by_cas":"Search by CAS","search_by_name":"Search by Name","search_epa":"Search EPA","searching_epa":"Searching EPA...","see_more":"See More","sprayer":"Sprayer","sprayer_cannot_be_blank":"Sprayer can\'t be blank","spreader":"Spreader","spreader_cannot_be_blank":"Spreader can\'t be blank","spreader_equipment":"Spreader","state":"State","street":"Street","tank_cleaned":"Tank Cleaned","this_is_a":"This is a","tons":"tons","total":"Total","tractor":"Tractor","tractor_cannot_be_blank":"Tractor can\'t be blank","unit":"Unit","unit_each":"Unit/Each","unspecified":"Unspecified","use":"Use","variety":"Variety","view":"View"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"add_field_filter_to_show_treatment":"Add a \\"Field\\" filter to show treatment table","if2":{"block_accounting":{"total_is_estimated":"Totals include estimated prices, and are subject to change","total_may_not_be_correct":"Totals may not be correct because some prices are missing"}},"must_include_field_filter":"Must include a \\"Field\\" filter"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"accounts":"Accounts","active_ingredients":"Active Ingredients","crops":"Crops","if2":{"breadcrumb":{"home":"Home"}},"products":"Products","profile":"Profile","reports":"Reports","roles":"Roles","search_results":"Search Results","users":"Users"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"confirm_delete_crop":"Are you sure you want to delete the crop \'%{crop}\'?","confirm_delete_crop_full":"Are you sure you want to delete this crop?","crops_star":"Crops *","cultivars":"Cultivars","new_crop":"New Crop","organic_star":"Organic *","root_stocks":"Root Stocks","use_type":"Use Type","use_types":"Use Types","varieties":"Varieties"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"error_displaying_application_details":"There was an error and the application details cannot be shown.","error_displaying_fields":"There was an error and fields cannot be shown.","error_displaying_licensed_applicator":"There was an error and the Licensed Applicator cannot be shown.","error_displaying_products_applied":"There was an error and the applied products cannot be shown.","error_report_sent":"Error report has been sent"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"IF2::Implement":"implement","IF2::Sprayer":"sprayer","IF2::Spreader":"spreader","IF2::Tractor":"tractor","activerecord":{"attributes":{"if2/sprayer":{"tank_size":"Tank size"}}},"confirm_delete_implement":"Are you sure you want to delete %{implement}?","edit_sprayer":"Edit: %{name}","edit_spreader":"Edit: %{name}","edit_tractor":"Edit: %{name}","license_plate_number":"License Plate Number","license_plate_or_id":"License Plate/ID","name_of_this_sprayer":"Name of This Sprayer","name_of_this_spreader":"Name of This Spreader","name_of_this_tractor":"Name of this tractor","new_sprayer":"New Sprayer","new_spreader":"New Spreader","new_tractor":"New Tractor","tank_size":"Tank Size","units_provided_value_blank":"%{model} units were specified but the value is blank.","use_the_form_new_equipment":"Use the form below to define a new piece of equipment.","use_the_form_to_edit_equipemnt":"Use the form below to edit this piece of equipment."}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"account":"Account","account_not_found":"Account not found","acreage":"Acreage","acres":"Acres","county":"County","field_has_already_been_added":"Field has already been added","row_spacing":"Row Spacing"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"add_another_license":"Add Another License","add_new_license":"Add New License","agency":"Agency","confirm_delete_license":"Are you sure you want to delete the license for this user?","edit_license":"Edit License Information","license":"License","license_information_deleted":"License information successfully deleted.","license_type":"License Type","licenses":"Licenses","number":"Number","pesticide_consultant_license":"Pesticide Consultant License","successfully_added_license":"License information successfully added to the user.","successfully_updated_license":"License information successfully updated.","use_the_form_edit_license":{"html":"Use the form below to edit license information for <b>%{name}</b>."},"use_the_form_new_license":{"html":"Use the form below to add license information to <b>%{name}</b>."}}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"application_records_short":"Application Records","block_accounting":"Block Accounting","confirm_delete_price":"Are you sure you want to delete the price for","contacts":"Contacts","fields":"Fields","if2":{"prices":{"estimated":"estimated","price_is_estimated":"Price is estimated"}},"new_price":"New Price","no_prices_configured":"No prices are configured for %{account.name} yet.","price_editor":"Price Editor","price_per_acre":"Price per Acre","prices":"Prices","product_pricing":"Product Pricing","quantity_great_than_zero":"Quanity must be greater than 0.","teams":"Teams","unit_price":"Unit Price","you_must_select_price":"You must select a price.","you_must_select_product":"You must select a product.","you_must_select_quantity":"You must select a quantity."}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"IF2::Product":"product","IF2::Product::RecommendationNote":"recommendation note","IF2::Product::TargetRate":"target rate","account_error":"You don\'t have permission to add a product for the selected account","ache_inhibitor":"AChE Inhibitor","activate":"Activate","active_ingredient":"Active Ingredient","add_attachment":"Add Attachment","add_crop_label":"Add Crop Label","add_crop_labeling":"Add Crop Labeling Information","add_organic_listing":"Add Organic Listing","add_organic_listing_details":"Add Organic Listing Details","add_product":"Add Product","additional_attachments":"Additional Attachments","alternate_names":"Alternate Names:","an_error_creating_product":"An error was encountered while creating the product.","app":"app","application_methods":"Application Methods","are_invalid":"are invalid","between_apps":"between apps","by_count":"By Count (Tags, Dispensers)","by_volume":"By Volume (Liquids)","by_weight":"By Weight (Dry, Wettables)","cant_find_epa_number":"Unable to find product with EPA Number %{number}","chemicals":"Chemicals","concentration":"Concentration","confirm_delete_label":"Are you sure you want to delete this labeling information?","confirm_delete_organic_listing":"Are you sure you want to delete this organic listing?","confirm_delete_this_product":"Are you sure you want to delete this product?","crop_labeling":"Crop Labeling","edit_product":"Edit Product","enter_epa_or_exempt":"Enter EPA number or \\"Exempt\\"","epa_reg_number":"EPA Registration #:","expired":"Expired","expires":"Expires","for_retail_sale_and_use_only":"For retail sale to and use by certified applicators or persons under their\\ndirect supervision and only for those uses covered by the certified\\napplicator’s certification.\\n","grower_specific_products":"Grower Specific Products","inactivate":"Inactivate","inactive":"Inactive","label":"Label","last_reviewed_on":"Last reviewed on","last_updated_on":"Last updated on","loading_products":"Loading products","manufacturer":"Manufacturer","mark_as_reviewed":"Mark as reviewed","mass_per_volume":"Weight Per Volume","max_per_application":"Max/Application","max_per_year":"Max/Year","max_spray_rate":"Max Spray Rate","min_spray_rate":"Min Spray Rate","must_select_account":"You must select an account","never_reviewed_before":"Never reviewed before.","new_product":"New product","no_account_selected":"No account selected.","no_crop_label_specified":"No crop label has been entered for this product.","no_organic_listing":"No organic listing information has been entered for this product.","organic_listings":"Organic Listings","phi":"PHI","product_activated":"Activated %{name}","product_created":"%{name} created","product_inactivated":"Inactivated %{name}","product_not_available_to_all_accounts":"This product is not available to all accounts","product_type":"Product Type","product_updated":"Updated %{name}","read_and_follow_label":"Read and follow all the instructions on the label.","reference":"Reference","reg_number":"Registration #:","rei":"REI","restricted_use_pesticide":"RESTRICTED USE PESTICIDE","review_products":"Review Products","reviewed_at":"Reviewed At","reviewed_by":"by","sds":"SDS","search_products":"Search Products","select_a_formulation":"Select a Formulation","select_product":"Select Product","select_unit_of_measure_for_this_product":"Select the unit of measure for this product.","show_inactive_products":"Show Inactive Products","signal_word":{"caution":"CAUTION","danger":"DANGER","danger_poison":"DANGER - POISON","title_case":"Signal Word","unspecified":"Not Specified","warning":"WARNING"},"specify_epa_number":"Must specify an EPA Number or enter \\"Exempt\\"","target_rates_required":"Target Rates Required","target_rates_required_for_this_product":"Target rates required for this product.","this_product_is_a_nutrient":"This product is a nutrient.","this_product_is_an_ache_inhibitor":"This product is an Acetylcholinesterase inhibitor.","unknown":"Unknown","url":"URL","use_as_primary_name":"Use as Primary Name","view_certificate":"View Certificate","wa_reg_number":"Washington Registration #"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"actions":"Actions","add_api_token":"Add API Token","api_tokens":"API Tokens","confirm_delete_token":"Are you sure you want to delete this token?","generated":"Generated","last_used":"Last Used","successfully_updated_your_user":"You have successfully updated your user","token":"Token"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"activerecord":{"errors":{"models":{"if2/recommendation":{"attributes":{"account":{"invalid_json":"does not match the required schema"},"accounts":{"invalid_json":"do not match the required schema"},"approved":{"invalid_json":"does not match the required schema"},"fields":{"invalid_json":"do not match the required schema"},"rejected":{"invalid_json":"does not match the required schema"},"written_by":{"invalid_json":"does not match the required schema"}}}}}},"approve":"Approve","approve_and_send":"Approve & Send","approve_recommendation":"Approve Recommendation","approved_by":"Approved by","approving_this_rec_will_email":"Approving this recommendation will email it to:","create":"Create","inherited_from":"Inherited From:","pdf_archives_are_missing":"Some of the selected recommendations do not have a pdf associated with them.","print":"Print","recommendation_filters":"Recommendation Filters","recommendation_has_been_approved":"%{title} has been approved","recommendation_has_been_rejected":"%{title} has been rejected","recommendation_reference_optional":"Recommendation reference (optional)","recommended_by_optional":"Recommended by (optional)","record_selected":"Record Selected","records_selected":"Records Selected","recs_require_approval":"Recommendations require approval","reject":"Reject","reject_recommendaation":"Reject Recommendation","rejected":"Rejected","rejection_reason":"Rejection Reason","search_recommendations":"Search Recommendations"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"activerecord":{"errors":{"models":{"if2/report":{"attributes":{"account_uuids":{"invalid_json":"do not match the required schema"},"column_specs":{"invalid_json":"do not match the required schema"},"filters":{"invalid_json":"do not match the required schema"},"sort_config":{"invalid_json":"do not match the required schema"}}},"if2/report_template":{"attributes":{"column_specs":{"invalid_json":"do not match the required schema"},"filters":{"invalid_json":"do not match the required schema"},"sort_config":{"invalid_json":"do not match the required schema"}}},"if2/report_view_row":{"attributes":{"data":{"must_be_object":"must be an object"}}}}}},"add_calculated_column":"Add Calculated Column","add_calculation":"Add Calculation","application_record_report":"Application Record Report","apply_filter":"Apply Filter","are_you_sure":"Are you sure?","blank_operand_error":"%{leftOrRightOperand} is blank: \\"%{typeOfBlank}\\"","clear":"Clear","column":"Column","column_actions":"Column Actions","column_blank_error":"Select column","column_hidden":"This column is hidden","column_visible":"This column is visible","constant":"Constant","convert":"Convert","convert_units":"Convert Units","data_set_too_large":"Data set too large! The current query returns %{totalResults} records, which exceeds the current limit of %{recordLimit}.  Please refine your filters and try again.","discard_changes":"Discard Changes","download_as_csv":"Download CSV","edit_calculation":"Edit Calculation","field_report":"Field Report","field_reports":"Field Reports","group_sort":"Group/Sort","group_verb":"Group","if2":{"reports":{"beginswith":"Begins with","confirm_delete_template":"Are you sure you want to delete %{template}?","contains":"Contains","custom":"Custom","delete_template":"Delete template","edit_template":"Edit template","exact":"Is exactly","filter_text":"Filter text","lastmonth":"Last Month","lastweek":"Last Week","lastyear":"Last Year","legacy_reports_deprecated":"You\'re using the legacy reporting system, which has been deprecated and will eventually be removed. Consider using the <a href=\'%{link}\'>new reporting system</a>, which is far faster.","new_report_from_template":"New report from template","ok_to_overwrite_report":"Ok to overwrite the current report?","ok_to_overwrite_template":"Ok to overwrite the current template?","report_still_running":"The report is still running; this row count is not final","rows":"rows","save_as_new_report":"Save as new report","save_as_new_template":"Save as new template","template_saved_successfully":"Template saved successfully","templates":"Report Templates","thismonth":"This Month","thisweek":"This Week","thisyear":"This Year","you_still_have_legacy_reports":"You still have some reports in the <a href=\'%{link}\'>legacy reporting system</a>, which has been deprecated and will eventually be removed."}},"incompatible_units_error":"Incompatible units: \\"%{firstUnit}\\" and \\"%{secondUnit}\\"","invalid_operand_error":"%{leftOrRightOperand} is invalid: \\"%{operandValue}\\"","left_operand":"Left operand","match_on_field_id":"Match on field id","match_on_field_name":"Match on field name","name_in_units":"%{name} in %{units}","name_scalar":"%{name} (Scalar)","name_units":"%{name} (Units)","new_report":"New Report","only_showing_max_rows":"Only showing first %{rowCount} rows. Download to see more...","operands_missing_error":"Operands missing","operation_blank_error":"Select operation","product_report":"Product Report","product_reports":"Product Reports","recommendation_report":"Recommendation Report","recommendation_reports":"Recommendation Reports","refresh_query":"Query again","report_attributes":{"account":"Account","account_id":"Account ID","accountingReference":"Accounting Reference (deprecated)","accounting_reference":"Accounting Reference","accounts":"Accounts","ache_inhibitor":"Ache Inhibitor","acidWaterTreatment":"Acid Water Treatment (deprecated)","acid_water_treatment":"Acid Water Treatment","acres":"Acres","action":"Action","activeIngredients":"Active Ingredient (deprecated)","active_ingredient":"Active Ingredient","active_ingredient_amounts":"Active Ingredient Amounts","active_ingredient_id":"Active Ingredient ID","active_ingredient_list":"Active Ingredient List","active_ingredients":"Active Ingredients","address":"Address","addresses":"Addresses","agency":"Agency","al":"Al","allow_on_recommendations":"Allow on Recommendations","alternateNames":"Alternate Names (deprecated)","alternate_names":"Alternate Names","application_id":"Application ID","application_method":"Application Method","application_methods":"Application Methods","applications":"Application","applicators":"Applicators","approved":"Approved","aprecs_customer_id":"ApRecs Customer ID","aprecs_field_id":"ApRecs Field ID","aprecs_location_id":"ApRecs Location ID","area":"Area","areas_to_treat":"Areas To Treat","at":"At","attached_label_filename":"Attached Label Filename","attached_sds_filename":"Attached SDS Filename","attachments":"Attachments","b":"B","base_unit":"Base Unit","bee_hazard":"Bee Hazard","brand":"Brand","by":"By","ca":"Ca","cas":"CAS","categories":"Categories","category":"Category","certificate_url":"Certificate URL","city":"City","clientPath":"Client Path (deprecated)","client_path":"Client Path","client_path_string":"Client Path String","complete":"Complete","computed_gallons_applied":"Computed Gallons Applied","contact":"Contact","cooling_type":"Cooling Type","cooling_type_id":"Cooling Type ID","cooling_types":"Cooling Types","copied_from":"Copied From","county":"County","county_override":"County Override","coverage":"Coverage","coverage_percentage":"Coverage (%)","createdAt":"Created At (deprecated)","created_at":"Created At","created_at_date":"Created At Date","crop":"Crop","crop_id":"Crop ID","crop_labels":"Crop Labels","crop_names":"Crop Names","crop_root_stocks":"Crop Root Stocks","crop_use_types":"Crop Use Types","cu":"Cu","cultivar":"Cultivar","cultivar_id":"Cultivar ID","cultivars":"Cultivars","date":"Date","date_time":"Date Time","defaultSprayer":"Default Sprayer (deprecated)","defaultSpreader":"Default Spreader (deprecated)","defaultTractor":"Default Tractor (deprecated)","default_licensed_applicator_id":"Default Licensed Applicator ID","default_sprayer":"Default Sprayer","default_spreader":"Default Spreader","default_tractor":"Default Tractor","description":"Description","display_state_registration":"Display State Registration","display_total_acres_completed":"Display Total Acres Completed","display_total_gallons_applied":"Display Total Gallons Applied","display_total_treated_acres":"Display Total Treated Acres","display_units":"Display Units","display_value":"Display Value","document_number":"Document Number","dryland":"Dryland","elevation":"Elevation","emails":"Email","emergency_contact_id":"Emergency Contact ID","end_date":"End Date","epaNumber":"EPA Number (deprecated)","epa_number":"EPA Number","expires":"Expires","external_url":"External URL","fe":"Fe","field":"Field","field_completions":"Field Completion","field_cooling_types":"Field Cooling Types","field_cultivars":"Field Cultivars","field_id":"Field ID","field_irrigation_management_types":"Field Irrigation Management Types","field_irrigation_monitoring_types":"Field Irrigation Monitoring Types","field_irrigation_types":"Field Irrigation Types","field_root_stocks":"Field Root Stocks","field_soil_types":"Field Soil Types","field_support_systems":"Field Support Systems","field_use_types":"Field Use Types","field_varieties":"Field Varieties","field_water_sources":"Field Water Sources","fields":"Field","filename":"Filename","firstName":"First Name (deprecated)","first_name":"First Name","formulation":"Formulation","fullName":"Full Name (deprecated)","full_name":"Full Name","full_name_override":"Full Name Override","gallons_applied":"Gallons Applied","gallons_applied_override":"Gallons Applied Override","geoJson":"GeoJSON (deprecated)","geo_json":"GeoJSON","grafts":"Grafts","group_number":"Group Number","harvestLot":"Harvest Lot (deprecated)","harvest_lot":"Harvest Lot","harvest_lot_fields":"Harvest Lot Fields","harvest_lot_id":"Harvest Lot ID","harvest_lots":"Harvest Lots","has_nutrient_analysis":"Nutrient","high_wind_speed":"High Wind Speed","humicAcid":"Humic Acid","id":"ID","inactive":"Inactive","irrigationRate":"Irrigation Rate (deprecated)","irrigation_management_type":"Irrigation Management Type","irrigation_management_type_id":"Irrigation Management Type ID","irrigation_management_types":"Irrigation Management Types","irrigation_monitoring_type":"Irrigation Monitoring Type","irrigation_monitoring_type_id":"Irrigation Monitoring Type ID","irrigation_monitoring_types":"Irrigation Monitoring Types","irrigation_rate":"Irrigation Rate","irrigation_type":"Irrigation Type","irrigation_type_id":"Irrigation Type ID","irrigation_types":"Irrigation Types","json_string":"JSON String","k":"K","label":"Label","label_source":"Label Source","label_url":"Label URL","lastName":"Last Name (deprecated)","last_name":"Last Name","latitude":"Latitude","licenseNumber":"License Number (deprecated)","license_number":"License Number","license_plate_number":"License Plate Number","licensed_applicator":"Licensed Applicator","licenses":"Licenses","limited_by_espp":"Limited by ESPP","liquid_concentration":"Liquid Concentration","longitude":"Longitude","low_wind_speed":"Low Wind Speed","manufacturer":"Manufacturer","mass_per_volume":"Weight/Volume","max_applications_per_year":"Max Applications/Year","max_per_application":"Max/Application","max_per_year":"Max/Year","max_phi":"Max PHI","max_rei":"Max REI","max_spray_rate":"Max Spray Rate","mg":"Mg","min_spray_rate":"Min Spray Rate","min_treatment_interval":"Min Treatment Interval","mn":"Mn","mo":"Mo","mode_of_action":"Mode of Action","mode_of_action_id":"Mode of Action ID","modes_of_action":"Modes of Action","n":"N","name":"Name","name_override":"Name Override","nearestRegion":"Nearest Region (deprecated)","nearest_region":"Nearest Region","nonBearing":"Non Bearing (deprecated)","non_bearing":"Non Bearing","notes":"Notes","number":"Number","nutrientAnalysis":"Nutrient Analysis (deprecated)","nutrient_analysis":"Nutrient Analysis","old_crop_snapshot":"Old Crop Snapshot","optimum_temperature":"Optimum Temperature","ordered_by":"Ordered By","organic":"Organic","organicDate":"Organic Date","organic_date":"Organic Date","organic_listings":"Organic Listings","p":"P","parent":"Parent","parent_id":"Parent ID","pc_code":"PC Code","percent":"Percent","percent_variance_acres_treated":"Percent Variance Acres Treated","percentage":"Percentage","phi":"PHI","phi_override":"PHI Override","phi_override_by":"PHI Override By","phi_override_reason":"PHI Override Reason","phones":"Phone","plantSpacing":"Plant Spacing (deprecated)","plant_spacing":"Plant Spacing","position":"Position","pounds_per_acre":"Lbs/Acre","predicted_acres_treated":"Predicted Acres Treated","previousCrop":"Previous Crop (deprecated)","previous_crop":"Previous Crop","price":"Price","prices":"Prices","primary":"Primary","processor":"Processor","processor_id":"Processor ID","product":"Product","productType":"Product Type (deprecated)","product_applications":"Product Application","product_crop_labels":"Product Crop Labels","product_id":"Product ID","product_type":"Product Type","products":"Products","quantity":"Quantity","rate":"Rate","rate_per_acre":"Rate/Acre","rate_per_volume":"Rate/Volume","reason":"Reason","recommendation":"Recommendation","recommendations_require_approval":"Recommendations Require Approval","record_application_amounts_in":"Record Application Amounts In","reference":"Reference","registration_number":"Registration Number","rei":"REI","rei_override":"REI Override","rei_override_by":"REI Override By","rei_override_reason":"REI Override Reason","rejected":"Rejected","replaces":"Replaces","rev":"Rev","reviewedAt":"Reviewed At (deprecated)","reviewed_at":"Reviewed At","reviewed_by":"Reviewed By","rootStocks":"Root Stocks (deprecated)","root_stock":"Root Stock","root_stock_id":"Root Stock ID","root_stocks":"Root Stocks","rowSpacing":"Row Spacing (deprecated)","row_spacing":"Row Spacing","s":"S","scalar":"Scalar","sds_source":"SDS Source","sds_url":"SDS URL","serial":"Serial","shade_color":"Shade Color","share_application_records":"Share Application Records","short_name":"Short Name","show_field_map":"Show Field Map","show_map_when_printing":"Show Map When Printing","show_nutrient_totals":"Show Nutrient Totals","show_product_totals":"Show Product Totals","si":"Si","signalWord":"Signal Word (deprecated)","signal_word":"Signal Word","soil_type":"Soil Type","soil_type_id":"Soil Type ID","soil_types":"Soil Types","special_conditions":"Special Conditions","spray_rate":"Spray Rate","spray_record_id":"Spray Record ID","sprayer":"Sprayer","spreader":"Spreader","start_date":"Start Date","start_time":"Start Time","state":"State","state_registration":"State Registration","status":"Status","stop_time":"Stop Time","street1":"Street 1","street2":"Street 2","support_system":"Support System","support_system_id":"Support System ID","support_systems":"Support Systems","tank_cleaned":"Tank Cleaned","tank_size":"Tank Size","tanks_completed":"Tanks Completed","target":"Target","target_coverage":"Target Coverage","target_coverage_percentage":"Target Coverage Percentage","target_gallons_per_acre":"Target Gallons/Acre","target_rate":"Target Rate","target_rates":"Target Rates","target_rates_required":"Target Rates Required","temperature_high":"Temperature High","temperature_low":"Temperature Low","temperature_units":"Temperature Units","timing":"Timing","title":"Title","total":"Total","total_acres":"Total Acres","total_fields":"Total Fields","toxicity_category":"Toxicity Category","toxicity_class":"Toxicity Class","tractor":"Tractor","transitional":"Transitional","transitionalDate":"Transitional Date (deprecated)","transitional_date":"Transitional Date","treeDensity":"Tree Density (deprecated)","tree_density":"Tree Density","type":"Type","units":"Unit","updatedAt":"Updated At (deprecated)","updated_at":"Updated At","updated_at_date":"Updated At Date","url":"URL","use":"Use","useTypes":"Use Types (deprecated)","use_per_applied_acre_verbiage":"Use Per Applied Acre Verbiage","use_type":"Use Type","use_type_id":"Use Type ID","use_types":"Use Types","user":"User","user_id":"User ID","uuid":"UUID","value":"Value","varieties":"Varieties","variety":"Variety","variety_cultivars":"Variety Cultivars","variety_id":"Variety ID","variety_use_types":"Variety Use Types","water_rate":"Water Rate","water_source":"Water Source","water_source_id":"Water Source ID","water_sources":"Water Sources","wind_direction":"Wind Direction","work_order":"Work Order","work_order_id":"Work Order ID","written_by":"Written By","written_by_id":"Written By ID","year":"Year","yearPlanted":"Year Planted (deprecated)","year_planted":"Year Planted","zip":"Zip","zn":"Zn"},"report_deleted":"Report deleted","report_not_found":"Report not found","report_saved_successfully":"Report saved successfully","report_updated":"Report updated","request_timed_out":"Request timed out","right_operand":"Right operand","scalar_blank_error":"Enter scalar value","select_column":"- Select Column -","select_operand":"Select Operand","sort_ascending":"Sort Ascending","sort_descending":"Sort Descending","split_scalar_from_units":"Split scalar from units","toggle_dropdown":"Toggle Dropdown","unable_to_load_column_error":"Unable to load column: \\"%{columnName}\\"","unexpected_error":"Unexpected error","ungroup":"Ungroup","units":"Units","unknown_units":"Unknown units","unresponsive_continue_waiting":"Request is taking longer than expected. Continue waiting?"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"IF2::Role":"role","activerecord":{"errors":{"models":{"if2/role":{"attributes":{"privileges":{"must_be_array":"must be an array","unsupported":"are unsupported: %{privileges}"}}}}}},"added_role":"Added %{name}","assign_new_role":"Assign New Role","assignable_roles_have_more_privs":{"one":"Assignable Roles: %{name} has more privileges than this role.","other":"Assignable Roles: %{name} have more privileges than this role."},"confirm_delete_role":"Are you sure you want to delete the role \\"%{role}\\"?","description":"Description","edit_role":"Edit Role","edit_this_user":"Edit this user","new_role":"New Role","no_roles_config":"No roles configured yet","removed_role":"Removed %{name}","role":{"privileges":{"approve_recommendations":"Approve Recommendations","create_recommendations":"Create Recommendations","edit_contacts":"Edit Contacts","edit_estimated_prices":"Edit Estimated Prices","edit_prices":"Edit Prices","edit_report_templates":"Edit Report Templates","edit_spray_records":"Edit Application Records","edit_users":"Edit Users","flexible_reports":"Flexible Reports","groups":{"account_management":"Account Management","application_records":"Application Records","contacts":"Contacts","emails":"Emails","prices":"Prices","privileged_information":"Privileged Information","recommendations":"Recommendations","reports":"Reports","scouting":"Scouting","system_administration":"System Administration","users":"Users"},"manage_accounts":"Manage Accounts","manage_crops":"Administer Crop Database","manage_documents":"Access Document Library","manage_fields":"Manage Fields","manage_implements":"Manage Equipment","manage_notification_lists":"Manage Notification Lists","manage_products":"Manage Products","manage_root_products":"Administer Chemical Database","manage_teams":"Manage Teams","scouting":"Scouting","switch_users":"Login as another user (without password)","view_contacts":"View Contacts","view_emails":"View Emails","view_estimated_prices":"View Estimated Prices","view_prices":"View Prices","view_product_crop_labeling":"View Product Crop Labeling","view_product_recommendation_notes":"View Product-Specific Recommendation Notes","view_product_target_rates":"View Product Target Rates","view_recommendations":"View Recommendations (created by others)","view_root_products":"View Chemical Database","view_spray_records":"View Application Records","view_users":"View Users"}},"role_selected":"Role Selected:","saving":"Saving...","select_a_role":"Select a Role","select_an_account":"Select an Account","select_and_follow_prompts":"Select a role and follow the prompts","select_role":"Select Role","updated_role":"Updated %{name}"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"changes_have_been_saved":"Your changes have been saved.","errors_prevented_save_fem":{"one":"%{count} error prevented this %{model} from being saved.","other":"%{count} errors prevented this %{model} from being saved."},"errors_prevented_save_masc":{"one":"%{count} error prevented this %{model} from being saved.","other":"%{count} errors prevented this %{model} from being saved."},"preferred_language":"Preferred Language"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"IF2::SprayRecord":"spray record","account_application_records":"%{name}: Application Records","acres_completed":"Acres Completed","acres_treated":"Acres Treated","activerecord":{"errors":{"models":{"if2/spray_record":{"attributes":{"base":{"applicator_has_a_sprayer_for_a_spreader_only_application_method":"Applicators should not include a sprayer for this application method","applicator_has_a_spreader_for_a_sprayer_only_application_method":"Applicators should not include a spreader for this application method","applicators_should_not_have_sprayer_and_spreader":"Applicators should not have both a sprayer and a spreader","cannot_mark_record_complete_without_applications_or_products":"You cannot mark this record complete without applications or products","recommendation_fields_deleted":"Recommendation has fields that have been deleted","recommendation_products_not_found":"Recommendation includes products that could not be found in the database"},"fields":{"invalid_json":"do not match the required schema"}}},"if2/spray_record/field_completion":{"attributes":{"base":{"field_is_already_complete":"This field is already complete"},"percentage":{"total_field_percentage_exceeds_100":"The total percentage for this field on the spray record cannot exceed 100%"}}},"if2/spray_record/product_application":{"attributes":{"base":{"product_must_be_unique":"Product must be unique","rate_must_be_greater_than_zero":"Rate must be greater than zero"}}}}}},"add_fields":"Add Fields","alert_licensed_applicator_missing":"There is no licensed applicator on this application record. Please add one before marking complete.","all_changes_to_this_application_will_be_lost":"All changes to this application will be lost. Are you sure you want to proceed?","application_details":"Application Details","application_method":"Application Method","application_record":"Application Record","application_record_filters":"Application Record Filters","application_record_reports":"Application Record Reports","applicator_has_a_sprayer_for_a_spreader_only_application_method":"Applicators should not include a sprayer for this application method","applicator_has_a_spreader_for_a_sprayer_only_application_method":"Applicators should not include a spreader for this application method","applicator_is_required":"Applicator is required","applicator_license":"Applicator/License","applicator_not_found":"Applicator not found","at_least_one_applicator_is_required":"At least one applicator is required","at_least_one_field_is_required":"At least one field is required","blocks_treated":"Blocks/Treated","bulk_application_records":"Application Records","calculator_type":"Calulator Type","cardinal_directions":{"e":"E","n":"N","ne":"NE","nw":"NW","s":"S","se":"SE","sw":"SW","w":"W"},"choose":"Choose","choose_accounts":"Choose Accounts","choose_recommendation":"Choose recommendation","choose_which_accounts_this_application_record_applies_to":"Choose which account this Application Record applies to","common":"common","confirm_continue_conventional_added_to_organic":"You have added conventional fields to an organic Application Record. If you continue the organic status will be removed from the Application Record. Do you want to continue?","confirm_continue_will_add_crop_plural":"are not currently included in the Application Record crops. If you continue they will be added to the list of crops. Are you sure you want to continue?","confirm_continue_will_add_crop_singular":"is not currently included in the Application Record crops. If you continue it will be added to the list of crops. Are you sure you want to continue?","confirm_delete_application_record":"Are you sure you want to delete this Application Record?","confirm_remove_application_detail":"Are you sure you want to remove this application detail from the record?","confirm_remove_field":"Are you sure you want to remove this field?  All saved application details for the field will also be removed.","confirm_remove_product":"Are you sure you want to remove this product?","confirm_reopen_for_editing":"Are you sure you want to re-open this Application Record for editing?","crop":"Crop","crop_not_present":"%{string} is listed as a crop on the Application Record but is not present in any of the fields. Is it okay to remove this crop from the Application Record?","crops_not_present":"%{string} are listed as crops on the Application Record but are not present in any of the fields. Is it okay to remove these crops from the Application Record?","date_time":"Date/Time","default_licensed_applicator_for_account_html":"Default Licensed Applicator for <strong>%{account}</strong> and subaccounts","direction":"Direction","display_name":"Display Name","edit_spray_record":"Edit: %{title}","editing_will_cause_lost_changes_confirm":"Editing this application will cause your new application changes to be lost. Do you wish to proceed?","emergency_contact":"Emergency Contact","error_displaying_notes":"There was an error dispalying notes.","example_top_50_percent":"(e.g. the top 50% of the tree)","field_is_required":"%{field} is required","field_title":"Fields: %{title}","fields_listed_but_not_treated":"The following fields are listed on the application record but have not been treated and will be removed.","filter_applied_not_all_records_are_shown":"filter applied. Not all records are shown.","filter_verb":"Filter","filters_applied_not_all_records_are_shown":"filters applied. Not all records are shown.","gallons":"Gallons","gallons_applied":"Gallons Applied","hide_completed_fields":"Hide Completed Fields","high_temp":"High Temp.","how_much_field_completed":{"one":"How much of the %{acres} acre field was completed?","other":"How much of the %{acres} acre field was completed?"},"include_licensed_applicator":"Include a licensed applicator","inconsistent_rates":"Inconsistent rates","invalid_tank_size":"invalid tank size","licensed_applicator":"Licensed Applicator","licensed_applicator_missing":"Licensed Applicator Missing","licensed_applicator_updated":"Licensed applicator updated","low_temp":"Low Temp.","mark_as_complete":"Mark as complete","mark_as_complete_instructions":"When all details have been added, use the button below to complete this Application Record.","mark_as_complete_requirements":"Please make sure the following conditions are met.","method":"Method","missing_details":"Missing Details","must_not_be_blank":"Must not be blank","new":"New","new_application_record":"New Application Record","new_applicator":"New Applicator","new_record":"New Record","no_fields_have_been_added":"No fields have been added to this Application Record.","no_products_have_been_added_to_this_application_record":"No products have been added to this Application Record.","none_fem":"None","not_all_records_shown":"Not all records are shown. ","notes":"Notes","operation_is_not_permitted":"Operation is not permitted","overnight_application":"Overnight Application","partial_completion_of_field":"Partial completion of field","partial_coverage_of_plant_or_ground":"Partial coverage of plant or ground","percent_completed":"% Completed","percent_covered":"% Covered","percent_variance":"% Variance","predicted_acres_treated":"Predicted Acres Treated","prediction_rate_note":"Predicted acres have been calculated based on %{rateType} rate of %{rate} gal/acre","product_already_applied":"Product already applied","product_application_not_found":"Product application not found","products_applied":"Products Applied","rate_cannot_be_blank":"Rate can\'t be blank","rate_does_not_match_others":"Rate does not match other applicator rates","rate_does_not_match_target":"Rate does not match target rate of %{rate} gal/acre","rate_does_not_match_target_messege":"Rate does not match target","rate_missing":"rate missing","re_entry_not_included":"The re-entry date will not be included on this REI poster since this record is incomplete","reason_for_override":"Reason for override","recommendation":"Recommendation","recommendation_date":"Recommendation Date","recommendation_reference":"Recommendation Reference","recommended_by":"Recommended By","reg_number_short":"EPA #","rei_poster":"REI Poster","rei_poster_title":"REI Poster: %{title}","rei_posters":"REI Posters","remove_override":"Remove Override","remove_these_fields":"Remove these fields?","remove_untreated_fields":"Remove any fields that do not have application details","search_application_records":"Search Application Records","select_applicators":"Select Applicators","select_contact":"Select Contact","select_licensed_applicator":"Select licensed applicator","select_licensed_applicator_from_options":"The following individuals have licenses. You can select one of them:","show_calculators":"Show Calculators","show_completed_fields":"Show Completed Fields","show_field_map":"Show field map","some_options_disabled":"Some options may be deactivated depending on the fields that have been added to the Application Record.","spray_rate":"Spray Rate","spray_record_created":"Spray record created","spray_record_found":"Spray record found","spray_record_not_found":"Spray record not found","spray_record_updated":"Spray record updated","start_time":"Start Time","stop_time":"Stop Time","tanks":"Tanks","tanks_completed":"Tanks Completed","target":"Target","target_coverage":"Target Coverage","target_coverage_percentage":"Target Coverage (%)","target_gallons_per_acre":"Target Gallons Per Acre","target_gpa":"Target GPA","target_reason":"Target/Reason","temp_wind":"Temp/Wind","this_application_record_already_includes_organic_fields":"This Application Record already includes organic fields","this_applicator_has_both_sprayer_and_spreader":"This applicator has both a sprayer and spreader assigned","title":"Title","title_optional":"Title of this Application Record (optional)","total_applied":"Total Applied","total_gallons_applied":"Total Gallons Applied","treated_acres_selected":"Treated Acres Selected","unable_to_save_spray_record":"Unable to save spray record","units_cannot_be_blank":"Units can\'t be blank","untreated_fields_warning":"Untreated Fields Warning","use_the_form_new_application_record":"Use the form below to create a new Application Record.","valid_product_required":"Valid product required","valid_rate_required":"Valid rate required","valid_units_required":"Valid units required","weed_spray":"Weed Spray","weed_strip":"Weed Strip","wind_high":"Wind High","wind_low":"Wind Low","wind_speed":"Wind Speed"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"add_team":"Add Team","confirm_delete_team":"Are you sure you want to delete %{team}?","edit_team":"Edit %{name}","must_choose_applicator":"You must choose an applicator.","new_team":"New Team","no_teams_created_for":"No teams have been created for","select_a_sprayer":"Select a Sprayer","select_a_spreader":"Select a Spreader","select_a_tractor":"Select a Tractor","select_an_applicator":"Select an Applicator","team_added":"Added %{name}","team_name":"Team Name"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"all_records":"All Records","calculate":"Calculate","conventional":"Conventional","crop_filter":"- Crop Filter -","custom":"Custom","date_range":"Date Range","deselect":"Deselect ","end_date":"End Date","filters_unexpected_error":"Encountered unexpected error while applying filters.","last_month":"Last Month","last_week":"Last Week","last_year":"Last Year","organic":"Organic","reload_this_page":"Reload this page","rename":"Rename","search_by_name_crop_variety":"Search by name, crop type, variety, etc.","select":"Select ","select_crops":"Select Crops","select_date_range":"Select Date Range","select_fields":"Select Fields","select_organic_or_conventional":"Select Organic or Conventional","select_products":"Select Products","select_status":"Select Status","select_targets":"Select Targets","select_variety":"Select Variety","start_date":"Start Date","status":"Status","this_month":"This Month","this_page":"This Page","this_week":"This Week","this_year":"This Year","title_placeholder":"Title","variety_filter":"- Variety Filter -"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"activerecord":{"errors":{"messages":{"incompatible_units":"does not have units compatible with %{compatible_with}","invalid_units":"contains invalid units","missing_units":"is missing units"}}}}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"IF2::Contact":"contact","add_a_contact":"Add a Contact","contact_info_for":"Contact Information for %{user}","make_sure_contant_details_include_email":"Make sure the contact details include the person\'s email address.","to_add_someone_to_this_list":"To add someone to this list, add them to the <a href=\'%{link}\'>contacts for this account</a> (or a parent account)."}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"IF2::User":"user","add_user":"Add User","applicator_license_number":"Applicator License Number","at_least_one_role":"You must assign at least one role to this user.","cannot_delete_self":"You cannot delete your own user.","categories":"Categories","confirm_delete_user":"Are you sure you want to delete %{name}?","contact_info":"Contact","default_sprayer":"Default Sprayer","default_spreader":"Default Spreader","default_tractor":"Default Tractor","edit_contact_info":"Edit Contact Info","edit_user":"Edit: %{user}","email":"Email","if2":{"users":{"activate":"activate","active_label":"User can login","deactivate":"deactivate","inactive":"inactive"}},"initials":"Initials","initials_are_generated_if_blank":"Initials will be automatically generated if left blank","last_active":"Last Active: %{active} ago","last_login":"Last Login: %{login} ago","login_as":"Login as %{user}","new_user":"New User","no_roles_configured":"No roles are configured yet.","password_confirmation":"Password Confirmation","pesticide_consultant":"Pesticide Consultant","successfully_deleted":"You have successfully deleted %{name}.","successfully_updated":"Successfully updated %{name}.","use_as_primary_email":"Use as primary email","user_phone":"Phone: %{phone}"}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"will_paginate":{"next_label":"Next &#8594;","previous_label":"&#8592; Previous"}}}');
  }, function (e) {
    e.exports = JSON.parse('{"en":{"if2":{"date":"Date","no_related":"No related records have been created","related":"Related"}}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"account_contacts":"Contactos de %{account.name}","add_contact":"Añadir Contacto","confirm_delete_contact":"¿Está seguro de que quiere eliminar al contact \'%{name}\'?","contact_not_found":"No se encontró al contacto","contact_updated":"Contacto actualizado","create_user":"Crear usuario","edit_contact":"Editar Contacto","if2":{"contacts":{"inaccessible_accounts":{"one":"%{count} otra cuenta a la que no tiene permiso para acceder","other":"%{count} otras cuentas a las que no tiene permiso para acceder"},"is_default_licensed_applicator_for":"%{name} es el aplicador licenciado por defecto para las siguientes cuentas:","is_emergency_contact_for":"%{name} es el contacto de emergencia para las siguientes cuentas:","please_resolve_these_issues":"Por favor resuelva estos problemas e intente de nuevo.","try_delete_again":"Intentar borrar de nuevo","unable_to_delete":"No se pudo borrar al contacto"}},"new_contact":"Nuevo Contacto","new_contact_for":"Nuevo contacto para %{name}","search_contacts":"Buscar en los contactos","successfully_added_contact":"Se añadió contacto %{name} exitosamente","successfully_updated_contact":"Contact actualizado exitosamente","view_contact":"Ver contacto","you_have_successfully_deleted_contact":"Se ha eliminado a %{name} exitosamente"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"activerecord":{"errors":{"messages":{"account_cannot_have_prices":"no puede tener precios"}}},"if2":{"account_prices":{"inherited_from":"Estos precios de productos se heredan de %{account}."}}}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"IF2::Account":"cuenta","IF2::Accounts::Branch":"cuenta","IF2::Accounts::Corporate":"cuenta","IF2::Accounts::General":"cuenta","IF2::Accounts::Grower":"cuenta","account_deleted":"Cuenta %{name} eliminada","account_plus_name_updated":"Cuenta %{name} actualizada","activerecord":{"attributes":{"if2/account":{"default_licensed_applicator":"Aplicador licenciado por defecto"}},"errors":{"messages":{"must_have_license_number":"requiere un número de licencia"}}},"add_account":"Añadir Cuenta","add_sub_account":"Añadir Subcuenta","change_account":"Cambiar de cuenta","confirm_delete_account":"¿Está seguro de que quiere eliminar la cuenta \'%{name}\'?","edit_account":"Editar Cuenta","full_name":"Nombre completo","manage":"Manejar","new_account":"Nueva Cuenta","notification_lists":"Receptores de notificaciones","notification_lists_contacts_should_be_notified_when":"Los siguientes contactos deben ser notificados cuando","notification_lists_no_contacts_specified":"Ningún contacto especificado","notification_lists_recommendation_approval_title":"Recomendaciones que necesitan revisión/aprobación","notification_lists_recommendation_approval_when":"recomendaciones no aprobadas están listas para revisar","notification_lists_recommendation_title":"Recomendaciones","notification_lists_recommendation_when":"se hacen nuevas recomendaciones para esta cuenta","parent_account_not_found":"No se pudo encontrar la cuenta padre","position_under":"Puesto bajo","record_application_amounts_in":"Registro de aplicación cantidades en","search":"Buscar","search_accounts":"Buscar cuentas","select_account":"Seleccionar Cuenta","select_accounts":"Seleccionar Cuentas","street_1":"Calle 1","street_2":"Calle 2","sub_accounts":"Subcuentas","this_account_cant_be_deleted_until":"No se puede eliminar esta cuenta hasta que todos subcuentas, usuarios, registros de aplicación, etc. se hayan eliminado","type":"Tipo","unable_to_delete_account":"No se pudo eliminar la cuenta: %{error}","unable_to_delete_account_users_still_assigned":"Unable to delete account: users are still assigned to this account","unable_to_delete_account_with_sub_accounts":"No se pudo eliminar esta cuenta: No se permite eliminar una cuenta con subcuentas","unable_to_delete_root":"No se pudo eliminar esta cuenta: No se permite eliminar la cuenta raíz.","unable_to_update_account":"No se pudo actualizar esta cuenta: %{error}","unable_to_update_account_change_parent_root":"No se pudo actualizar la cuenta: no se permite cambiar el padre de una cuenta raíz","you_cant_move_account_under_itself":"No se puede mover esta cuenta bajo sí misma o bajo uno de sus descendientes","zip":"Código Postal"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"active_ingredient_cannot_be_destroyed":"Este ingrediente activo está siendo utilizado por productos. Sólo se podrán suprimir los principios activos que no se utilicen.","add_active_ingredient":"Añadir Ingrediente Activo","ai_created":"%{name} creado","ai_updated":"%{name} actualizado","cas_number":"Número CAS","cas_number_optional":"Número CAS (opcional)","cas_number_short":"No. de CAS","confirm_delete_ai":"¿Está seguro de que quiere eliminar el ingrediente activo: %{ai}?","edit_active_ingredient":"Editar Ingrediente Activo","enter_cas_number":"Introduzca un número CAS para buscar e importar datos del ingrediente activo de la EPA","enter_name_to_search":"Introduzca un nombre para buscar e importar datos del ingrediente activo de la EPA","error_creating_active_ingredient":"Hubo un error creando el ingrediente activo: %{error}","error_updating_active_ingredient":"Hubo un error actualizando el Ingrediente Activo: %{error}","find_active_ingredient":"Buscar ingrediente activo","ingredient_not_found":"No se encontró el ingrediente","ingredient_not_found_in_database":"No se encontró el ingrediente en la base de datos","limited_by_espp":"Limitado Por ESPP","liquid_concentration":"Concentración líquida","mode_of_action":"Modo de acción","name_optional":"Nombre (opcional)","new_active_ingredient":"Nuevo Ingrediente Activo","products_with_this_active_ingredient":"Productos con este ingrediente activo","search_active_ingredients":"Buscar ingredientes activos","set_active_ingredient_percent":"Asignar porcentaje del ingrediente activo","short_name":"Forma corta del nombre","toxicity_category":"Categoría de toxicidad","toxicity_class":"Clase de toxicidad","use_may_be_limited_under_the_epa":"Puede que el uso de este producto sea limitado bajo el Programa de Protección de Especies en Peligro de Extinción de la EPA (ESPP por sus signos en inglés)"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"if2":{"action_not_authorized":"No está autorizado para realizar esta acción","invalid_authenticity_request":"No se puede verificar la autenticidad de la solicitud"},"incorrect_username_or_password":"Usuario o conraseña inválidos","log_in":"Iniciar sesión","password":"Contraseña","permission_denied_logged_out":"Permiso denegado. Se ha cerrado la sesión.","username":"Nombre de usuario"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"add":"Añadir","add_column":"Añadir Columna","add_new":"Añadir Nuevo","adding":"Añadiendo","address":"Dirección","all_equipment_types":"Todos","applicators":"Aplicadores","applied_pl_masc":"aplicados","applied_sing_masc":"aplicado","apply":"Aplicar","author":"Autor","base_units":"Unidades básicas","bee_hazard":"Peligro para las abejas","cancel":"Cancelar","cannot_be_blank":"No puede estar en blanco","category":"Categoría","choose_account":"Seleccione una cuenta","choose_columns":"Seleccionar columnas","city":"Ciudad","clear_all":"Quitar todos","clear_filters":"Quitar filtros","close":"Cerrar","collapse_all":"Colapsar todos","complete":"Completo","contact":"Contacto","date_date":"Fecha","date_dates":"Fecha(s)","delete":"Eliminar","download":"Descargar","edit":"Editar","effective_date":"Fecha de vigencia","email_address":"Dirección de correo electrónico","epa_number":"Número EPA","equipment":"Equipamiento","existing":"Actual","expand_all":"Expandir todos","field":"Campo","filter":"Filtro","filter_summary":"Resumen de filtros","filters":"Filtros","first_name":"Nombre","floz":"onzas líquidas (floz)","formulation":"Formulación","grams":"gramos","grand_total":"Gran Total:","hide":"Esconder","incomplete":"Incompleto","kilograms":"kilogramos (kg)","last_name":"Apellido","lastname_cannot_be_blank":"El apellido no puede estar en blanco","license_number":"No. de licencia","license_number_cannot_be_blank":"Número de licencia no puede estar en blanco","license_number_full":"Número de licencia","liters":"litros (L)","login_required":"Se requiere iniciar sesión","make_default":"Hacer el valor por defecto","max":"Máximo","mils":"mililitros (mL)","more":"Más","n_a":"N/C","name":"Nombre","name_cannot_be_blank":"El nombre no puede estar en blanco","never":"Nunca","next":"Siguiente","nutrient_analysis":"Análisis de nutrientes","ok":"Aceptar","ounces_dry":"onzas (no-líquidas)","percent":"porcentaje","phone":"Teléfono","phone_number":"Número de teléfono","pints":"pintas","pounds":"libras","previous":"Atrás","price":"Precio","privileges":"Privilegios","product":"Producto","product_name":"Nombre de producto","quantity":"Cantidad","quarts":"cuartos de galón","rate":"Ritmo","reason":"Razón","recommendations":"Recomendaciones","remove":"Eliminar","review":"Revisar","save":"Guardar","save_changes":"Guardar Cambios","search_by_cas":"Buscar por CAS","search_by_name":"Buscar por nombre","search_epa":"Buscar EPA","searching_epa":"Buscando EPA...","see_more":"Ver más","sprayer":"Pulverizadora","sprayer_cannot_be_blank":"La pulverizadora no puede estar en blanco","spreader":"Distribuidor de nutrientes sólidos","spreader_cannot_be_blank":"Distribuidor de nutrientes sólidos no puede estar en blanco","spreader_equipment":"Esparciador","state":"Estado","street":"Calle","tank_cleaned":"Tanque Lavado","this_is_a":"Este es un","tons":"toneladas","total":"Total","tractor":"Tractor","tractor_cannot_be_blank":"El tractor no puede estar en blanco","unit":"Unidad","unit_each":"Unidad/Cada uno","unspecified":"No especificado","use":"Uso","variety":"Variedad","view":"Ver"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"add_field_filter_to_show_treatment":"Añada un filtro de \\"Campo\\" para mostrar una tabla de tratamiento","if2":{"block_accounting":{"total_is_estimated":"Los totales incluyen precios estimados y están sujetos a cambios","total_may_not_be_correct":"Puede que los totales no sean correctos porque faltan algunos precios"}},"must_include_field_filter":"Se necesita inlcuir un filtro de \\"Campo\\""}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"accounts":"Cuentas","active_ingredients":"Ingredientes activos","crops":"Cultivos","if2":{"breadcrumb":{"home":"Inicio"}},"products":"Productos","profile":"Perfil","reports":"Informes","roles":"Papeles","search_results":"Resultados de búsqueda","users":"Usuarios"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"confirm_delete_crop":"¿Está seguro de que quiere eliminar el cultivo \\"%{crop}?\\"","confirm_delete_crop_full":"¿Está seguro de que quiere eliminar este cultivo?","crops_star":"Cultivos *","cultivars":"Cultivares","new_crop":"Nuevo Cultivo","organic_star":"Orgánico *","root_stocks":"Rizomas","select_crops":"Seleccionar cultivos","some_options_disabled":"* Algunas opciones pueden estar desactivadas dependiendo de los campos que han sido añadidos al registro de aplicación.","use_type":"Utilización","use_types":"Utilizaciones","varieties":"Variedades"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"error_displaying_application_details":"Hubo un error y no se puede mostrar los detalles de aplicación.","error_displaying_fields":"Hubo un error y no se puede mostrar los campos.","error_displaying_licensed_applicator":"Hubo un error y no se puede mostrar el aplicador autorizado.","error_displaying_products_applied":"Hubo un error y no se puede mostrar los productos aplicados.","error_report_sent":"Se ha enviado el informe de errores"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"IF2::Implement":"implementar","IF2::Sprayer":"pulverizadora","IF2::Spreader":"esparcidor","IF2::Tractor":"tractor","activerecord":{"attributes":{"if2/sprayer":{"tank_size":"Capacidad del tanque de solución"}}},"confirm_delete_implement":"¿Está seguro de que quiere eliminar %{implement}?","edit_sprayer":"Editar: %{name}","edit_spreader":"Editar: %{name}","edit_tractor":"Editar: %{name}","license_plate_number":"Número de placa","license_plate_or_id":"Placa/Identificación","name_of_this_sprayer":"Nombre de esta pulverizadora","name_of_this_spreader":"Nombre de esta Sembradora","name_of_this_tractor":"Nombre de este tractor","new_sprayer":"Nueva Pulverizadora","new_spreader":"Nueva Esparciador","new_tractor":"Nuevo Tractor","tank_size":"Capacidad del tanque de solución","units_provided_value_blank":"Se especificaron las unidades de %{model} pero el valor está en blanco.","use_the_form_new_equipment":"Use el formulario de abajo para definir un nuevo equipo.","use_the_form_to_edit_equipemnt":"Use el siguiente formulario para editar este equipo."}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"account":"Cuenta","account_not_found":"No se encontró la cuenta","acreage":"Superficie","acres":"Acres","county":"Condado","row_spacing":"Espaciado de la hilera"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"add_another_license":"Añadir otra licencia","add_new_license":"Añadir nueva licencia","agency":"Agencia","confirm_delete_license":"¿Está seguro de que quiere eliminar la licencia para este usuario?","edit_license":"Editar información de licencia","license":"Licencia","license_information_deleted":"La información de licencia se ha eliminado exitosamente.","license_type":"Clase de licencia","licenses":"Licencias","number":"Número","pesticide_consultant_license":"Consultor para pesticidas","successfully_added_license":"La información de licencia se ha añadido exitosamente al usuario.","successfully_updated_license":"La información de licencia se actualizado exitosamente.","use_the_form_edit_license":{"html":"Use el siguiente formulario para editar la información de licencia para <b>%{name}</b>."},"use_the_form_new_license":{"html":"Use el siguiente formulario para añadirle información de licencia a <b>%{name}</b>."}}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"application_records_short":"Registros de aplicación","block_accounting":"Contabilidad de bloque","confirm_delete_price":"¿Está seguro de que quiere eliminar el precio para","contacts":"Contactos","fields":"Campos","if2":{"prices":{"estimated":"estimado","price_is_estimated":"El precio es estimado"}},"new_price":"Nuevo Precio","no_prices_configured":"Todavía no se ha configurado ningún precio para %{account.name}.","price_editor":"Editor de precios","price_per_acre":"Precio por acre","prices":"Precios","product_pricing":"Fijación de precios","quantity_great_than_zero":"La cantidad debe ser mayor de 0.","teams":"Equipos","unit_price":"Precio por unidad","you_must_select_price":"Usted debe seleccionar un precio.","you_must_select_product":"Usted debe seleccionar un producto.","you_must_select_quantity":"Usted debe seleccionar una cantidad."}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"IF2::Product":"producto","IF2::Product::RecommendationNote":"nota de recomendación","IF2::Product::TargetRate":"tasa objetivo","account_error":"Usted no tiene permiso para añadir un producto para la cuenta seleccionada","ache_inhibitor":"Inhibidor de AChE","activate":"Activar","active_ingredient":"Ingrediente activo","add_attachment":"Añadir adjunto","add_crop_label":"Añadir etiquetado de cultivo","add_crop_labeling":"Añadir información de etiquetado del cultivo","add_organic_listing":"Añadir listado orgánico","add_organic_listing_details":"Añadir detalles de listado orgánico","add_product":"Añadir Producto","additional_attachments":"Adjuntos adicionales","alternate_names":"Nombres alternativos:","an_error_creating_product":"Hubo un error en el proceso de crear el producto.","app":"applicación","application_methods":"Métodos de aplicación","are_invalid":"son inválidos","between_apps":"entre aplicaciones","by_count":"Por conteo (etiquetas, dispensadores)","by_volume":"Por volumen (líquidos)","by_weight":"Por peso (secos, mojables)","cant_find_epa_number":"Unable to find product with EPA Number %{number}","chemicals":"Químicos","concentration":"Concentración","confirm_delete_label":"¿Está seguro de que quiere eliminar esta información de etiquetado?","confirm_delete_organic_listing":"¿Está seguro de que quiere eliminar este listado orgánico?","confirm_delete_this_product":"¿Está seguro de que quiere eliminar este producto?","crop_labeling":"Etiquetado de cultivos","edit_product":"Editar producto","enter_epa_or_exempt":"Introduzca número de EPA o \\"Exempt\\"","epa_reg_number":"No. de registración de EPA:","expired":"Caducó","expires":"Fecha de caducidad","for_retail_sale_and_use_only":"Para la venta al por menor y uso por aplicadores certificados o personas\\nque estén bajo su directa supervisión y únicamente para los usos detallados\\nen la certificación del aplicador certificado.\\n","grower_specific_products":"Productos específicos al cultivador","inactivate":"Desactivar","inactive":"Desactivado","label":"Etiqueta","last_reviewed_on":"Última revisión","last_updated_on":"Última actualización","loading_products":"Cargando los products","manufacturer":"Fabricante","mark_as_reviewed":"Marque como revisado","mass_per_volume":"Peso por volumen","max_per_application":"Máx/Aplicación","max_per_year":"Máx/Año","max_spray_rate":"Máx Ritmo de rociada","min_spray_rate":"Min. Ritmo de rociada","must_select_account":"Usted debe seleccionar una cuenta","never_reviewed_before":"Nunca se ha revisado.","new_product":"Nuevo Producto","no_account_selected":"No account selected.","no_crop_label_specified":"No se ha introducido ninguna información de etiqueta del cultivo para este producto.","no_organic_listing":"No se ha introducido ninguna información de listado orgánico para este producto.","organic_listings":"Listados orgánicos","phi":"PHI","product_activated":"%{name} activado","product_created":"%{name} creado","product_inactivated":"%{name} inactivado","product_not_available_to_all_accounts":"Este producto no está disponible para todas las cuentas.","product_type":"Tipo de producto","product_updated":"%{name} actualizado","read_and_follow_label":"Lea y siga todas las instrucciones de la etiqueta.","reference":"Referencia","reg_number":"No. de registración","rei":"REI","restricted_use_pesticide":"PESTICIDA DE USO RESTRINGIDO","review_products":"Revisar Productos","reviewed_at":"Revisado","reviewed_by":"por","sds":"SDS","search_products":"Buscar productos","select_a_formulation":"Seleccione una formulación","select_product":"Seleccionar producto","select_unit_of_measure_for_this_product":"Seleccione la unidad de medida para este producto.","show_inactive_products":"Mostrar productos inactivos","signal_word":{"caution":"PRECAUCIÓN","danger":"PELIGRO","danger_poison":"PELIGRO - VENENO","title_case":"Palabra Señal","unspecified":"No especificada","warning":"AVISO"},"specify_epa_number":"Usted debe especificar un número de EPA o introducir \\"Exempt\\" en el formulario","target_rates_required":"Tasas objetivo requeridas","target_rates_required_for_this_product":"Tasas objetivo requeridas para este producto.","this_product_is_a_nutrient":"Este producto es un nutriente.","this_product_is_an_ache_inhibitor":"Este producto es un inhibidor de la acetilcolinesterasa.","unknown":"Desconocida","url":"URL","use_as_primary_name":"Usar como Nombre Principal","view_certificate":"Ver Certificado","wa_reg_number":"No. de registro de Washington"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"actions":"Acciones","add_api_token":"Añadir Token de API","api_tokens":"Tokens de API","confirm_delete_token":"¿Está seguro de que quiere eliminar este token?","generated":"Generado","last_used":"Usado por última vez","successfully_updated_your_user":"Usted ha actualizado al usuario exitosamente","token":"Token de acceso"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"activerecord":{"errors":{"models":{"if2/recommendation":{"attributes":{"account":{"invalid_json":"no emparejan con el esquema requerido"},"accounts":{"invalid_json":"no emparejan con el esquema requerido"},"approved":{"invalid_json":"no emparejan con el esquema requerido"},"fields":{"invalid_json":"no emparejan con el esquema requerido"},"rejected":{"invalid_json":"no emparejan con el esquema requerido"},"written_by":{"invalid_json":"no emparejan con el esquema requerido"}}}}}},"approve":"Aprobar","approve_and_send":"Aprobar y enviar","approve_recommendation":"Aprobar recomendación","approved_by":"Aprobada por","approving_this_rec_will_email":"Al aprobar esta recomendación será enviada a:","create":"Crear","inherited_from":"Heredado de:","pdf_archives_are_missing":"Some of the selected recommendations do not have a pdf associated with them.","print":"Imprimir","recommendation_filters":"Filtros de recommendacion","recommendation_has_been_approved":"La recomendación \'%{title}\' fue aprobada.","recommendation_has_been_rejected":"La recomendación \'%{title}\' fue rechazada.","recommendation_reference_optional":"Referencia de recomendación (opcional)","recommended_by_optional":"Recomendado por (opcional)","record_selected":"Registro seleccionado","records_selected":"Registros seleccionados","recs_require_approval":"Recomendaciones requieren aprobación","reject":"Rechazar","reject_recommendaation":"Rechazar recomendación","rejected":"Rechazada","rejection_reason":"Razón del rechazo","search_recommendations":"Buscar recomendaciones"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"activerecord":{"errors":{"models":{"if2/report":{"attributes":{"account_uuids":{"invalid_json":"no emparejan con el esquema requerido"},"column_specs":{"invalid_json":"no emparejan con el esquema requerido"},"filters":{"invalid_json":"no emparejan con el esquema requerido"},"sort_config":{"invalid_json":"no emparejan con el esquema requerido"}}},"if2/report_template":{"attributes":{"column_specs":{"invalid_json":"no emparejan con el esquema requerido"},"filters":{"invalid_json":"no emparejan con el esquema requerido"},"sort_config":{"invalid_json":"no emparejan con el esquema requerido"}}},"if2/report_view_row":{"attributes":{"data":{"must_be_object":"debe ser un objeto"}}}}}},"add_calculated_column":"Añadir columna calculada","add_calculation":"Añadir cálculo","application_record_report":"Informe de registro de aplicación","apply_filter":"Aplicar Filtro","are_you_sure":"¿Está seguro/a?","blank_operand_error":"%{leftOrRightOperand} está en blanco: %{typeOfBlank}","clear":"Quitar","column":"Columna","column_actions":"Acciones de columna","column_blank_error":"Seleccione una columna","column_hidden":"Esta columna está oculta","column_visible":"Esta columna está visible","constant":"Constante","convert":"Convertir","convert_units":"Convertir unidades","data_set_too_large":"¡El conjunto de datos está demasiado grande! La consulta actual devuelve %{totalResults} entradas, lo que excede el límite actual de %{recordLimit}.  Por favor, refine sus filtros e intente de nuevo.","discard_changes":"Descartar cambios","download_as_csv":"Descargar CSV","edit_calculation":"Editar cálculo","field_report":"Informe de Campo","field_reports":"Informes de Campo","group_sort":"Agrupar/Ordenar","group_verb":"Agrupar","if2":{"reports":{"beginswith":"Comienza con","confirm_delete_template":"¿Estás segura de que quieres eliminar %{template}?","contains":"Contiene","custom":"Custom","delete_template":"Eliminar plantilla","edit_template":"Editar plantilla","exact":"Es exactamente","filter_text":"Texto para el filtro","lastmonth":"Last Month","lastweek":"Last Week","lastyear":"Last Year","legacy_reports_deprecated":"Está utilizando el sistema de informes heredado, que ha quedado obsoleto y que eventualmente se eliminará. Considere la posibilidad de utilizar el <a href=\'%{link}\'>nuevo sistema de informes</a>, que es mucho más rápido.","new_report_from_template":"Nuevo informe de la plantilla","ok_to_overwrite_report":"¿Está bien sobreescribir el informe actual?","ok_to_overwrite_template":"¿Está bien sobrescribir la plantilla actual?","report_still_running":"El informe aún se está ejecutando; este recuento de filas no es definitivo","rows":"filas","save_as_new_report":"Guardar como nuevo informe","save_as_new_template":"Guardar como nueva plantilla","template_saved_successfully":"Plantilla guardada correctamente","templates":"Plantillas de informes","thismonth":"This Month","thisweek":"This Week","thisyear":"This Year","you_still_have_legacy_reports":"Todavía tiene algunos informes en el <a href=\'%{link}\'>sistema de informes antiguo</a>, que ha quedado obsoleto y eventualmente se eliminará."}},"incompatible_units_error":"Unidades incompatibles: \\"%{firstUnit} y %{secondUnit}\\"","invalid_operand_error":"%{leftOrRightOperand} está inválido: %{operandValue}","left_operand":"Operando izquierdo","match_on_field_id":"Coincidencia en la identificación del campo","match_on_field_name":"Coincidencia en el nombre del campo","name_in_units":"%{name} en %{units}","name_scalar":"%{name} (escalar)","name_units":"%{name} (unidades)","new_report":"Nuevo Informe","only_showing_max_rows":"Solamente se muestran las preimeras %{rowCount} filas. Descargue para ver más...","operands_missing_error":"Faltan los operandos","operation_blank_error":"Seleccione una operación","product_report":"Informe de Producto","product_reports":"Informes de Producto","recommendation_report":"Informe de recomendación","recommendation_reports":"Informes de recomendación","refresh_query":"Consulta de nuevo","report_attributes":{"account":"Cuenta","account_id":"ID de Cuenta","accountingReference":"Referencia de contabilidad (obsoleta)","accounting_reference":"Referencia de contabilidad","accounts":"Cuentas","ache_inhibitor":"Inhibidor Ache","acidWaterTreatment":"Tratamiento de aguas ácidas (obsoleto)","acid_water_treatment":"Tratamiento de aguas ácidas","acres":"Acres","action":"Acción","activeIngredients":"Ingredientes activos (obsoletos)","active_ingredient":"Ingrediente activo","active_ingredient_amounts":"Cantidades de ingrediente activo","active_ingredient_id":"ID de ingrediente activo","active_ingredient_list":"Lista de ingredientes activos","active_ingredients":"Ingredientes activos","address":"Dirección","addresses":"Direcciónes","agency":"Agencia","al":"Al","allow_on_recommendations":"Permitir en recomendaciones","alternateNames":"Nombres alternativos (obsoletos)","alternate_names":"Nombres alternativos","application_id":"ID de aplicación","application_method":"Método de aplicación","application_methods":"Métodos de aplicación","applications":"Aplicación","applicators":"Aplicadores","approved":"Aprobada","aprecs_customer_id":"ID del cliente de ApRecs","aprecs_field_id":"ID de campo de ApRecs","aprecs_location_id":"ID de ubicación de ApRecs","area":"Área","areas_to_treat":"Áreas para tratar","at":"a las","attached_label_filename":"Nombre del archivo de la etiqueta adjunta","attached_sds_filename":"Nombre del archivo SDS adjunto","attachments":"Archivos adjuntos","b":"B","base_unit":"Unidad básica","bee_hazard":"Peligro a las abejas","brand":"Marca","by":"por","ca":"Ca","cas":"CAS","categories":"Categorías","category":"Categoría","certificate_url":"URL del certificado","city":"Ciudad","clientPath":"Ruta del cliente (obsoleto)","client_path":"Ruta del cliente","client_path_string":"Cadena de ruta del cliente","complete":"Completo","computed_gallons_applied":"Galones calculados aplicados","contact":"Contacto","cooling_type":"Tipo de refrigeración","cooling_type_id":"ID del tipo de refrigeración","cooling_types":"Tipos de refrigeración","copied_from":"Copiado de","county":"Condado","county_override":"Anulación del condado","coverage":"Cobertura","coverage_percentage":"Cobertura (%)","createdAt":"Creado (obsoleto)","created_at":"Creado","created_at_date":"Fecha de creación","crop":"Cultivo","crop_id":"ID del cultivo","crop_labels":"Etiquetas de cultivo","crop_names":"Nombres de cultivo","crop_root_stocks":"Rizomas de cultivos","crop_use_types":"Tipos de uso de cultivos","cu":"Cu","cultivar":"Cultivar","cultivar_id":"ID de cultivar","cultivars":"Cultivares","date":"Fecha","date_time":"Fecha Hora","defaultSprayer":"Pulverizadora por defecto (obsoleto)","defaultSpreader":"Esparcidor por defecto (obsoleto)","defaultTractor":"Tractor por defecto (obsoleto)","default_licensed_applicator_id":"ID de aplicador con licencia predeterminado","default_sprayer":"Pulverizadora por defecto","default_spreader":"Esparcidor por defecto","default_tractor":"Tractor por defecto","description":"Description (translate)","display_state_registration":"Mostrar Registro del Estado","display_total_acres_completed":"Mostrar total acres completados","display_total_gallons_applied":"Mostrar total galones aplicados","display_total_treated_acres":"Mostrar total de acres tratados","display_units":"Unidades Mostradas","display_value":"Mostrar valor","document_number":"Número de documento","dryland":"Tierra seca","elevation":"Altura","emails":"Correos electrónico","emergency_contact_id":"ID de contacto de emergencia","end_date":"Fecha de finalización","epaNumber":"Número EPA (obsoleto)","epa_number":"Número EPA","expires":"Caduca","external_url":"URL externa","fe":"Fe","field":"Campo","field_completions":"Compleción del campo","field_cooling_types":"Tipos de enfriamiento de campo","field_cultivars":"Cultivares de campo","field_id":"ID de campo","field_irrigation_management_types":"Tipos de gestión del riego de campos","field_irrigation_monitoring_types":"Tipos de monitoreo de riego de campo","field_irrigation_types":"Tipos de riego de campo","field_root_stocks":"Rizomas de campo","field_soil_types":"Tipos de suelo de campo","field_support_systems":"Sistemas de apoyo de campo","field_use_types":"Tipos de uso del campo","field_varieties":"Variedades en el campo","field_water_sources":"Fuentes de agua de campo","fields":"Campo","filename":"Nombre del archivo","firstName":"Nombre (obsoleto)","first_name":"Nombre","formulation":"Formulación","fullName":"Nombre completo (obsoleto)","full_name":"Nombre completo","full_name_override":"Anulación del nombre completo","gallons_applied":"Galones aplicados","gallons_applied_override":"Anulación de galones aplicados","geoJson":"GeoJSON (obsoleto)","geo_json":"GeoJSON","grafts":"Injertos","group_number":"Número del grupo","harvestLot":"Lote de cosecha (obsoleto)","harvest_lot":"Lote de cosecha","harvest_lot_fields":"Campos del lote de cosecha","harvest_lot_id":"ID del lote de cosecha","harvest_lots":"Lotes de cosecha","has_nutrient_analysis":"Nutriente","high_wind_speed":"Alta velocidad del viento","humicAcid":"Ácido húmico","id":"ID","inactive":"Inactivo","irrigationRate":"Ritmo de riego (obsoleto)","irrigation_management_type":"Tipo de gestión del riego","irrigation_management_type_id":"ID del tipo de gestión de riego","irrigation_management_types":"Tipos de gestión del riego","irrigation_monitoring_type":"Tipo de monitoreo de riego","irrigation_monitoring_type_id":"ID del tipo de monitoreo de riego","irrigation_monitoring_types":"Tipos de monitoreo de riego","irrigation_rate":"Ritmo de riego","irrigation_type":"Tipo de riego","irrigation_type_id":"ID del Tipo de riego","irrigation_types":"Tipos de riego","json_string":"Cadena JSON","k":"K","label":"Etiqueta","label_source":"Fuente de la etiqueta","label_url":"URL de etiqueta","lastName":"Apellido (obsoleto)","last_name":"Apellido","latitude":"Latitud","licenseNumber":"No. de licencia (obsoleto)","license_number":"No. de licencia","license_plate_number":"Número de placa de licencia","licensed_applicator":"Aplicador licenciado","licenses":"Licencias","limited_by_espp":"Limitado por ESPP","liquid_concentration":"Concentración líquida","longitude":"Longitud","low_wind_speed":"Baja velocidad del viento","manufacturer":"Fabricante","mass_per_volume":"Peso/Volumen","max_applications_per_year":"Mayor número de aplicaciones/año","max_per_application":"Máx/Aplicación","max_per_year":"Máx/Año","max_phi":"PHI máximo","max_rei":"REI máximo","max_spray_rate":"Ritmo de pulverización máximo","mg":"Mg","min_spray_rate":"Ritmo de pulverización mínimo","min_treatment_interval":"Intervalo de tratamiento mínimo","mn":"Mn","mo":"Mo","mode_of_action":"Modo de acción","mode_of_action_id":"Modo de identificación de acción","modes_of_action":"Modos de acción","n":"N","name":"Nombre","name_override":"Anulación de nombre","nearestRegion":"Región más cercana (obsoleta)","nearest_region":"Región más cercana","nonBearing":"Que no rinde frutos (obsoleto)","non_bearing":"Que no rinde frutos","notes":"Apuntes","number":"Número","nutrientAnalysis":"Análisis de nutrientes (obsoleto)","nutrient_analysis":"Análisis de nutrientes","old_crop_snapshot":"Instantánea de cultivo anterior","optimum_temperature":"Temperatura óptima","ordered_by":"Pedido por","organic":"Orgánico","organicDate":"Fecha de declaración orgánica (obsoleta)","organic_date":"Fecha de declaración orgánica","organic_listings":"Entradas orgánicas","p":"P","parent":"Padre","parent_id":"ID de padre","pc_code":"Código PC","percent":"Porciento","percent_variance_acres_treated":"Variación porcentual de acres tratados","percentage":"Percentaje","phi":"PHI","phi_override":"Anulación PHI","phi_override_by":"Anulación PHI por","phi_override_reason":"Razón por anular PHI","phones":"Teléfono","plantSpacing":"Espaciamiento entre plantas (obsoleto)","plant_spacing":"Espaciamiento entre plantas","position":"Posición","pounds_per_acre":"Lbs/Acre","predicted_acres_treated":"Acres tratados previstos","previousCrop":"Cultivo anterior (obsoleto)","previous_crop":"Cultivo anterior","price":"Precio","prices":"Precios","primary":"Primario","processor":"Procesador","processor_id":"ID del procesador","product":"Producto","productType":"Tipo de producto (obsoleto)","product_applications":"Aplicación del producto","product_crop_labels":"Etiquetas de cultivos de productos","product_id":"ID del producto","product_type":"Tipo de producto","products":"Productos","quantity":"Cantidad","rate":"Ritmo","rate_per_acre":"Ritmo/acre","rate_per_volume":"Ritmo/volumen","reason":"Razón","recommendation":"Recomendación","recommendations_require_approval":"Las recomendaciones requieren aprobación","record_application_amounts_in":"Registre las cantidades de aplicación en","reference":"Referencia","registration_number":"Número de registro","rei":"REI","rei_override":"Anulación REI","rei_override_by":"Anulación REI por","rei_override_reason":"Razón por anular REI","rejected":"Rechazada","replaces":"Reemplaza","rev":"Rev","reviewedAt":"Revisado (obsoleto)","reviewed_at":"Revisado","reviewed_by":"Revisado por","rootStocks":"Rizomas (obsoletas)","root_stock":"Rizoma","root_stock_id":"ID de rizoma","root_stocks":"Rizomas","rowSpacing":"Espaciado de la hilera (obsoleto)","row_spacing":"Espaciado de la hilera","s":"S","scalar":"Escalar","sds_source":"Fuente de SDS","sds_url":"URL de SDS","serial":"Serial","shade_color":"Color de sombra","share_application_records":"Compartir registros de aplicaciones","short_name":"Forma corta del nombre","show_field_map":"Mostrar mapa del campo","show_map_when_printing":"Mostrar mapa al imprimir","show_nutrient_totals":"Mostrar totales de nutrientes","show_product_totals":"Mostrar totales de productos","si":"Si","signalWord":"Palabra de señal (obsoleta)","signal_word":"Palabra de Señal","soil_type":"Tipo de suelo","soil_type_id":"ID de tipo de suelo","soil_types":"Tipos de suelo","special_conditions":"Condiciones especiales","spray_rate":"Ritmo de pulverización","spray_record_id":"ID de aplicación","sprayer":"Pulverizadora","spreader":"Distribuidor de nutrientes sólidos","start_date":"Fecha de inicio","start_time":"Comenzó","state":"Estado","state_registration":"Registro estatal","status":"Estado","stop_time":"Terminó","street1":"Calle 1","street2":"Calle 2","support_system":"Sistema de soporte","support_system_id":"ID del sistema de soporte","support_systems":"Sistemas de soporte","tank_cleaned":"Tanque lavado","tank_size":"Capacidad del tanque","tanks_completed":"Tanques completados","target":"Objectivo","target_coverage":"Cobertura objetivo","target_coverage_percentage":"Cobertura meta (%)","target_gallons_per_acre":"GPA meta","target_rate":"Ritmo objetivo","target_rates":"Ritmos objetivo","target_rates_required":"Se requeiren ritmos objetivo","temperature_high":"Alta temperatura","temperature_low":"Baja temperatura","temperature_units":"Unidades de temperatura","timing":"Cadencia","title":"Título","total":"Total","total_acres":"Acres Totales","total_fields":"Campos Totales","toxicity_category":"Categoría de toxicidad","toxicity_class":"Clase de toxicidad","tractor":"Tractor","transitional":"Transicional","transitionalDate":"Fecha de transición (obsoleta)","transitional_date":"Fecha de transición","treeDensity":"Densidad de árboles (obsoleta)","tree_density":"Densidad de árboles","type":"Tipo","units":"Unidades","updatedAt":"Actualizado (obsoleto)","updated_at":"Actualizado","updated_at_date":"Fecha de actualización","url":"URL","use":"Uso","useTypes":"Tipos de uso (obsoletos)","use_per_applied_acre_verbiage":"Utilice palabrería \\"por acre aplicado\\"","use_type":"Tipo de uso","use_type_id":"ID de \\"Tipo de uso\\"","use_types":"Tipos de uso","user":"Usuario","user_id":"ID de usuario","uuid":"UUID","value":"Valor","varieties":"Variedades","variety":"Variedad","variety_cultivars":"Cultivares de variedad","variety_id":"ID de variedad","variety_use_types":"Tipos de uso de variedad","water_rate":"Tarifa de agua","water_source":"Fuente de agua","water_source_id":"ID de fuente de agua","water_sources":"Fuentes de agua","wind_direction":"Dirección del viento","work_order":"Orden de trabajo","work_order_id":"ID de la orden de trabajo\\"","written_by":"Escrito por","written_by_id":"ID \\"Escrito por\\"","year":"Año","yearPlanted":"Año plantado (obsoleto)","year_planted":"Año plantado","zip":"Código postal","zn":"Zn"},"report_deleted":"Informe eliminado","report_not_found":"No se encontró el informe","report_saved_successfully":"Informe se ha guardado exitosamente","report_updated":"Informe actualizado","request_timed_out":"La solicitud se expiró","right_operand":"Operando derecho","scalar_blank_error":"Ingrese valor escalar","select_column":"- Seleccionar columna -","select_operand":"Seleccionar operando","sort_ascending":"Ordenar ascendente","sort_descending":"Ordenar descendente","split_scalar_from_units":"Dividir escalar de unidades","toggle_dropdown":"Alternar menú desplegable","unable_to_load_column_error":"No se pudo cargar columna: \\"%{columnName}\\"","unexpected_error":"Error inesperado","ungroup":"Desagrupar","units":"Unidades","unknown_units":"Unidades desconocidas","unresponsive_continue_waiting":"La solicitud está tardando más de lo esperado. ¿Desea seguir esperando?"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"IF2::Role":"role","activerecord":{"errors":{"models":{"if2/role":{"attributes":{"privileges":{"must_be_array":"debe ser una matriz","unsupported":"no son compatibles: %{privileges}"}}}}}},"added_role":"%{name} añadido","application_record_reports":"Informes de registros de aplicación","assign_new_role":"Asignar Nuevo Papel","assignable_roles_have_more_privs":{"one":"Papeles asignables: %{name} tiene más privilegios que este papel.","other":"Papeles asignables: %{name} tienen más privilegios que este papel."},"confirm_delete_role":"¿Está seguro de que quiere eliminar el papel \'%{role}\'?","description":"Descripción","edit_role":"Editar papel","edit_this_user":"Editar a este usuario","new_role":"Nuevo papel","no_roles_config":"Todavía no se ha configurado ningún papel","removed_role":"%{name} eliminado","role":{"privileges":{"approve_recommendations":"Aprobar recomendaciones","create_recommendations":"Crear recomendaciones","edit_contacts":"Editar contactos","edit_estimated_prices":"Editar precios estimados","edit_prices":"Editar precios","edit_report_templates":"Editar plantillas de informes","edit_spray_records":"Editar registros de aplicación","edit_users":"Editar usuarios","flexible_reports":"Informes flexibles","groups":{"account_management":"Manejo de cuentas","application_records":"Registros de aplicación","contacts":"Contactos","emails":"Direcciones de correo electrónico","prices":"Precios","privileged_information":"Información privilegiada","recommendations":"Recommendaciones","reports":"Informes","scouting":"Reconocimiento","system_administration":"Administración del sistema","users":"Usarios"},"manage_accounts":"Manejar cuentas","manage_crops":"Administrar base de datos del cultivo","manage_documents":"Acceso a la biblioteca de documentos","manage_fields":"Manejar campos","manage_implements":"Manejar herramientas","manage_notification_lists":"Manejar listas de notificaciones","manage_products":"Manejar productos","manage_root_products":"Administrar base de datos de químicos","manage_teams":"Manejar equipos","scouting":"Reconocimiento","switch_users":"Iniciar sesión como otro usuario (sin contraseña)","view_contacts":"Ver contactos","view_emails":"Ver direcciones de correo electrónico","view_estimated_prices":"Ver precios estimados","view_prices":"Ver precios","view_product_crop_labeling":"Ver etiquetado de cultivos de productos","view_product_recommendation_notes":"Ver notas específicas al producto","view_product_target_rates":"Ver tasas objetivo del producto","view_recommendations":"Ver recomendaciones (creadas por otros)","view_root_products":"Ver base de datos de químicos","view_spray_records":"Ver registros de aplicación","view_users":"Ver usuarios"}},"role_selected":"Papel Seleccionado:","saving":"Guardando...","select_a_role":"Seleccione un papel","select_an_account":"Seleccione una cuenta","select_and_follow_prompts":"Seleccione un papel y siga los pies","select_role":"Seleccione un papel","updated_role":"%{name} actualizado"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"changes_have_been_saved":"Sus cambios se han guardado.","errors_prevented_save_fem":{"one":"%{count} error impidió que esta %{model} se guardara.","other":"%{count} errores impidieron que esta %{model} se guardara."},"errors_prevented_save_masc":{"one":"%{count} error impidió que este %{model} se guardara.","other":"%{count} errores impidieron que este %{model} se guardara."},"preferred_language":"Idioma Preferido"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"IF2::SprayRecord":"registro de apliación","account_application_records":"%{name}: Registros de aplicación","acres_completed":"Acres completados","acres_treated":"Acres tratados","activerecord":{"errors":{"models":{"if2/spray_record":{"attributes":{"base":{"applicator_has_a_sprayer_for_a_spreader_only_application_method":"Aplicadores no deben incluir una pulverizadora para este método de apliación","applicator_has_a_spreader_for_a_sprayer_only_application_method":"Aplicadores no deben incluir un distribuidor de nutrientes para este método de aplicación","applicators_should_not_have_sprayer_and_spreader":"Aplicadores no deben incluir ambos una pulverizadora y un distribuidor de nutrientes sólidos","cannot_mark_record_complete_without_applications_or_products":"No se puede marcar este registro como completo sin aplicaciones o productos.","recommendation_fields_deleted":"La recomendación tiene campos que se han eliminado","recommendation_products_not_found":"La recomendación incluye productos que no se pudieron encontrar (en la base de datos)"},"fields":{"invalid_json":"no emparejan con el esquema requerido"}}},"if2/spray_record/field_completion":{"attributes":{"base":{"field_is_already_complete":"Este campo ya está completo"},"percentage":{"total_field_percentage_exceeds_100":"El porcentaje total de este campo en el registro de pulverización no puede superar el 100 %"}}},"if2/spray_record/product_application":{"attributes":{"base":{"product_must_be_unique":"El producto debe ser único","rate_must_be_greater_than_zero":"El ritmo debe ser mayor de cero"}}}}}},"add_fields":"Añadir campos","alert_licensed_applicator_missing":"No hay ningún aplicador autorizado en este registro de aplicación. Por favor, añada uno antes de marcarlo como completo.","all_changes_to_this_application_will_be_lost":"Todos los cambios a este registro serán perdidos. ¿Está seguro de que desea proceder?","application_details":"Detalles de aplicación","application_method":"Método de aplicación","application_record":"Registro de aplicación","applicator_has_a_sprayer_for_a_spreader_only_application_method":"Aplicadores no deben incluir una pulverizadora para este método de aplicación","applicator_has_a_spreader_for_a_sprayer_only_application_method":"Aplicadores no deben incluir un distribuidor de nutrientes sólidos para este método de aplicación","applicator_is_required":"Se requiere aplicador","applicator_license":"Aplicador/Licencia","applicator_not_found":"No se encontró el aplicador","at_least_one_applicator_is_required":"Se requiere al menos un aplicador.","at_least_one_field_is_required":"Se requiere al menos un campo.","blocks_treated":"Bloques/Tratados","bulk_application_records":"Registros de aplicación","calculate":"Calcular","calculator_type":"Tipo de calculadora","cardinal_directions":{"e":"E","n":"N","ne":"NE","nw":"NW","s":"S","se":"SE","sw":"SO","w":"O"},"choose":"Escoger","choose_accounts":"Escoger cuentas","choose_recommendation":"Escoger recomendación","choose_which_accounts_this_application_record_applies_to":"Escoja a qué cuentas este registro de aplicación se aplica","common":"común","confirm_continue_conventional_added_to_organic":"Añadió campos convencionales a un registro de aplicación orgánico. Si usted procede el estatus orgánico se quitará de del registro. ¿Desea proceder?","confirm_continue_will_add_crop_plural":"no están incluidos en los cultivos del registro de aplicación. Si usted procede serán añadidos a la lista de cultivos. ¿Desea proceder?                       |","confirm_continue_will_add_crop_singular":"no está incluido en los cultivos del registro de aplicación. Si usted procede será añadido a la lista de cultivos. ¿Desea proceder?","confirm_delete_application_record":"¿Está seguro de que quiere eliminar este registro de aplicación?","confirm_remove_application_detail":"¿Está seguro de que desear eliminar este detalle de aplicación del registro?","confirm_remove_field":"¿Está seguro de que desea eliminar este cultivo? Todos los detalles para el campo serán eliminados también.","confirm_remove_product":"¿Está seguro de que desea eliminar este producto?","confirm_reopen_for_editing":"¿Está seguro de que quiere re-abrir esta apliación para editarla?","crop":"Cultivo","crop_not_present":"%{string} está listado como un cultivo en el registro de aplicación pero no está presente en ningún campo. ¿Desea quitar estos cultivos del registro de aplicación?","crops_not_present":"%{string} están listados como cultivos en el registro de aplicación pero no están presentes en ningún campo. ¿Desea quitar estos cultivos del registro de aplicación?","date_time":"Fecha/Hora","default_licensed_applicator_for_account_html":"Aplicador autorizado por defecto para <strong>%{account}</strong> y subcuentas","direction":"Dirección","display_name":"Nombre de usuario","edit_spray_record":"Editar: %{title}","editing_will_cause_lost_changes_confirm":"Al editar esta applicación se perderán los nuevos cambios a la aplicación. ¿Desea proceder?","emergency_contact":"Contacto de emergencia","error_displaying_notes":"Hubo un error y no se pudo mostrar los apuntes.","example_top_50_percent":"(p. ej., el 50% superior del árbol)","field_has_already_been_added":"El campo ya se añadió anteriormente.","field_is_required":"Se requiere %{field}","field_title":"Campos: %{title}","fields_listed_but_not_treated":"Los siguientes campos están presentes en el registro de aplicación pero no sido tratados y serán removidos.","filter_applied_not_all_records_are_shown":"filtro aplicado. No se muestran todos los registros.","filter_verb":"Filtrar","filters_applied_not_all_records_are_shown":"filtros aplicados. No se muestran todos los registros.","gallons":"Galones","gallons_applied":"Galones Aplicados","hide_completed_fields":"Esconder campos completados","high_temp":"Temp. máxima","how_much_field_completed":{"one":"¿Qué porcentaje del campo de %{acres} acre fue completado?","other":"¿Qué porcentaje del campo de %{acres} acres fueron completados?"},"include_licensed_applicator":"Incluir un aplicador licenciado","inconsistent_rates":"Ritmos inconsistentes","invalid_tank_size":"capacidad del tanque no válido","licensed_applicator":"Aplicador autorizado","licensed_applicator_missing":"Falta un aplicador autorizado","licensed_applicator_updated":"Aplicador autorizado actualizado","low_temp":"Temp. mínima","mark_as_complete":"Marque como completo","mark_as_complete_instructions":"Cuando todos los detalles han sido añadidos, use el botón de abajo para completar este registro de aplicación.","mark_as_complete_requirements":"Asegúrese de cumplir con las siguientes condiciones.","method":"Método","missing_details":"Faltan Detalles","must_not_be_blank":"No puede estar en blanco","new":"Nuevo","new_application_record":"Nuevo registro de aplicación","new_applicator":"Nuevo Aplicador","new_record":"Nuevo Registro","no_fields_have_been_added":"No se ha añadido ningún registro de aplicación","no_products_have_been_added_to_this_application_record":"No se ha añadido ningún products a este registro de applicación.","none_fem":"Ninguna","not_all_records_shown":"No se muestran todos los regisgtros. ","notes":"Apuntes","operation_is_not_permitted":"No se permite esa operación","overnight_application":"Aplicación por la noche","partial_completion_of_field":"Compleción parcial de campo","partial_coverage_of_plant_or_ground":"Cobertura parcial de planta o suelo","percent_completed":"% Completado","percent_covered":"% Cubierto","percent_variance":"% Varianza","predicted_acres_treated":"Acres tratados pronosticados","prediction_rate_note":"Los acres pronosticados han sido calculados basado en ritmo %{rateType} de %{rate} gal/acre","product_already_applied":"El producto ya se aplicó","product_application_not_found":"No se encontró la aplicación del producto","products_applied":"Productos aplicados","rate_cannot_be_blank":"El ritmo no puede estar en blanco","rate_does_not_match_others":"Ritmo no encuadra con otros ritmos del aplicador","rate_does_not_match_target":"El ritmo no corresponde con el ritmo objetivo de %{rate} gal/acre","rate_does_not_match_target_messege":"Ritmo no encuadra con el ritmo objetivo","rate_missing":"falta el ritmo","re_entry_not_included":"La fecha de reingreso no será incluida en este póster REI ya que este registro está incompleto.","reason_for_override":"Razón para control manual","recommendation":"Recomendación","recommendation_date":"Fecha de recomendación","recommendation_reference":"Referencia de recomendación","recommended_by":"Recomendado por","reg_number_short":"No. de EPA","rei_poster":"Póster REI","rei_poster_title":"REI Póster: %{title}","rei_posters":"Pósteres REI","remove_override":"Quitar control manual","remove_these_fields":"¿Remover estos campos?","remove_untreated_fields":"Remueva cualquier campo que no tenga detalles de la aplicación","search_application_records":"Buscar Registros de Aplicación","search_by_name_crop_variety":"Buscar por nombre, cultivo, variedad, etc.","select_applicators":"Seleccionar aplicadores","select_contact":"Seleccione Contacto","select_licensed_applicator":"Seleccionar aplicador licenciado","select_licensed_applicator_from_options":"Los siguientes individuos tienen una licencia. Usted puede seleccionar a uno de ellos:","show_calculators":"Mostrar calculadoras","show_completed_fields":"Mostrar campos completados","show_field_map":"Mostrar mapa del campo","spray_rate":"Ritmo de rocío","spray_record_created":"Registro de rocío creado","spray_record_found":"Registro de rocío encontrado","spray_record_not_found":"No se encontró el registro de recío","spray_record_updated":"Registro de rocío actualizado","start_time":"Comenzó","stop_time":"Terminó","tanks":"Tanques","tanks_completed":"Tanques completados","target":"Objetivo","target_coverage":"Cobertura meta","target_coverage_percentage":"Cobertura meta (%)","target_gallons_per_acre":"Galones por acre meta","target_gpa":"GPA Meta","target_reason":"Meta/Razón","temp_wind":"Temp/Viento","this_application_record_already_includes_organic_fields":"Este registro de aplicación ya incluye campos orgánicos.","this_applicator_has_both_sprayer_and_spreader":"This applicator has both a sprayer and spreader assigned","title":"Título","title_optional":"Título de este registro de aplicación (opcional)","total_applied":"Aplicado en total","total_gallons_applied":"Total galones aplicados","treated_acres_selected":"Acres tratados seleccionados","unable_to_save_spray_record":"No se pudo guardar el registro de aplicación","units_cannot_be_blank":"Las unidades no pueden estar en blanco","untreated_fields_warning":"Aviso Campos no Tratados","use_the_form_new_application_record":"Use el formulario de abajo para crear un nuevo registro de aplicación.","valid_product_required":"Se requiere un producto válido","valid_rate_required":"Se requiere un ritmo válido","valid_units_required":"Se requieren unidades válidas","weed_spray":"Rociada de malezas","weed_strip":"Línea de malezas","wind_high":"Vto. máx.","wind_low":"Vto. mín.","wind_speed":"Velocidad del viento"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"add_team":"Añadir Equipo","confirm_delete_team":"¿Está seguro de que quiere eliminar: %{team}?","edit_team":"Editar %{name}","must_choose_applicator":"Usted debe seleccionar a un aplicador.","new_team":"Nuevo Equipo","no_teams_created_for":"No se ha creado ningún equipo para","select_a_sprayer":"Seleccione una pulverizadora","select_a_spreader":"Select a Spreader","select_a_tractor":"Seleccione un tractor","select_an_applicator":"Seleccione a un aplicador","team_added":"%{name} añadido","team_name":"Nombre de equipo"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"all_records":"Todos los registros","application_record_filters":"Filtros de registro de aplicación","conventional":"Convencional","crop_filter":"- Filtro por cultivo -","custom":"Costumbre","date_range":"Rango de fechas","deselect":"Deseleccionar ","end_date":"Fecha límite","filters_unexpected_error":"Hubo un error inesperado mientras se aplicaba los filtros.","last_month":"El mes pasado","last_week":"La semana pasada","last_year":"El año pasado","organic":"Orgánico","reload_this_page":"Recargar esta página","rename":"Renombrar","select":"Seleccionar ","select_date_range":"Seleccione un rango de fechas","select_fields":"Seleccionar campos","select_organic_or_conventional":"Seleccione orgánico o convencional","select_products":"Seleccionar productos","select_status":"Seleccionar estado","select_targets":"Seleccionar metas","select_variety":"Seleccionar variedad","start_date":"Fecha de inicio","status":"Estado","this_month":"Este mes","this_page":"Esta página","this_week":"Esta semana","this_year":"Este año","title_placeholder":"Título","variety_filter":"- Filtro por variedad -"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"activerecord":{"errors":{"messages":{"incompatible_units":"no tiene unidades compatibles con %{compatible_with}","invalid_units":"contiene unidades no válidas","missing_units":"faltan las unidades"}}}}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"IF2::Contact":"contacto","add_a_contact":"Añadir a un contacto","contact_info_for":"Información de contacto para %{user}","make_sure_contant_details_include_email":"Asegúrese de que los detalles para este contacto incluyan una dirección de correo electrónico.","to_add_someone_to_this_list":"Para añadir a alguien a esta lista, añadale a los <a href=\'%{link}\'>contactos para esta cuenta</a> (o para una cuenta superior)."}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"IF2::User":"usuario","add_user":"Añadir usuario","applicator_license_number":"Número de licencia del aplicador","at_least_one_role":"Usted debe asignarle por lo menos un papel a este usuario","cannot_delete_self":"No se puede eliminar a su propio usuario.","categories":"Categorías","confirm_delete_user":"¿Está seguro/a de que quiere eliminar a %{name}?","contact_info":"Información de contacto","default_sprayer":"Pulverizadora de defecto","default_spreader":"Default Spreader","default_tractor":"Tractor de defecto","edit_contact_info":"Editar información de contacto","edit_user":"Editar a %{user}","email":"Correo electrónico","if2":{"users":{"activate":"activar","active_label":"Este usuario puede inscribirse","deactivate":"desactivar","inactive":"inactivo"}},"initials":"Iniciales","initials_are_generated_if_blank":"Iniciales serán generados automáticamente si se daja en blanco","last_active":"Última actividad: hace %{active}","last_login":"Último acceso: hace %{login}","login_as":"Iniciar sesión como %{user}","new_user":"Nuevo usuario","no_roles_configured":"Todavía no hay ningún papel que esté configurado.","password_confirmation":"Confirmación de contraseña","pesticide_consultant":"Consultor para pesticidas","successfully_deleted":"Usted ha eliminado a %{name} exitosamente.","successfully_updated":"%{name} actualizado/a exitosamente.","use_as_primary_email":"Usar como correo electrónico primario","user_phone":"Teléfono: %{phone}"}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"will_paginate":{"next_label":"Siguiente &#8594;","previous_label":"&#8592; Atrás"}}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"if2":{"date":"Fecha","no_related":"No se ha creado ningún registro relacionado","related":"Registros relacionados"}}}');
  }, function (e, t, r) {
    var n = r(310)();
    e.exports = n;
  }, function (e, t) {
    e.exports = C;
  }, function (e, t, r) {
    var n = r(108),
        o = r(105),
        i = r(317),
        a = r(16),
        c = r(55);

    e.exports = function (e, t, r) {
      var u = a(e) ? n : i;
      return r && c(e, t, r) && (t = void 0), u(e, o(t, 3));
    };
  }, function (e, t, r) {
    var n = r(318),
        o = 1,
        i = 4;

    e.exports = function (e) {
      return n(e, o | i);
    };
  }, function (e, t, r) {
    var n = r(334);

    e.exports = function (e) {
      return e && e.length ? n(e) : [];
    };
  }, function (e, t) {
    e.exports = k;
  }, function (e, t) {
    e.exports = R;
  }, function (e, t) {
    e.exports = T;
  }, function (e, t) {
    e.exports = z;
  }, function (e, t) {
    e.exports = N;
  }, function (e, t) {
    e.exports = D;
  }, function (e, t, r) {
    "use strict";

    (function (e) {
      var n,
          o,
          i,
          a = r(0),
          c = r.n(a),
          u = r(1),
          l = r(2),
          s = r(3),
          p = r(7),
          f = r.n(p),
          d = r(213),
          b = r(62),
          y = r(209),
          m = r(26);

      function v(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, h(n.key), n);
        }
      }

      function h(e) {
        var t = function (e, t) {
          if ("object" != typeof e || !e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(e, "string");

        return "symbol" == typeof t ? t : t + "";
      }

      function g(e, t, r) {
        return t = w(t), function (e, t) {
          if (t && ("object" == typeof t || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }(e, function () {
          try {
            var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
          } catch (e) {}

          return function () {
            return !!e;
          }();
        }() ? Reflect.construct(t, r || [], w(e).constructor) : t.apply(e, r));
      }

      function w(e) {
        return (w = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }

      function O(e, t) {
        return (O = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }

      function j(e, t, r, n, o) {
        var i = {};
        return Object.keys(n).forEach(function (e) {
          i[e] = n[e];
        }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
          return n(e, t, r) || r;
        }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
      }

      var P = Object(l.observer)((j((o = function (t) {
        function r() {
          var e, t, n, o, a;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r);

          for (var c = arguments.length, u = new Array(c), l = 0; l < c; l++) u[l] = arguments[l];

          return e = g(this, r, [].concat(u)), t = e, n = "onEditApplicator", a = e, (o = i) && Object.defineProperty(t, n, {
            enumerable: o.enumerable,
            configurable: o.configurable,
            writable: o.writable,
            value: o.initializer ? o.initializer.call(a) : void 0
          }), e.toggleTankCleaned = function () {
            var t = e.props;
            (0, t.toggleTankCleaned)(t.applicator);
          }, e;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && O(e, t);
        }(r, a["Component"]), function (e, t, r) {
          return t && v(e.prototype, t), r && v(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
          }), e;
        }(r, [{
          key: "applicatorWarnings",
          get: function () {
            var e = this.props,
                t = e.applicator,
                r = e.applicationMethod;
            return t.warningTranslationKeysGiven(r);
          }
        }, {
          key: "warningText",
          get: function () {
            var e = this.props.t;
            return this.applicatorWarnings.map(function (t) {
              return e(t);
            }).join(", ");
          }
        }, {
          key: "componentDidMount",
          value: function () {
            var t = this;
            this.tooltipDisposer = Object(u.reaction)(function () {
              return t.applicatorWarnings.length;
            }, function (t) {
              t < 1 || e(function () {
                return f()('.applicator-warning[data-toggle="tooltip"], .validation-text[data-toggle="tooltip"]').tooltip({
                  delay: {
                    show: 700
                  },
                  trigger: "hover"
                });
              });
            }, {
              fireImmediately: !0
            });
          }
        }, {
          key: "render",
          value: function () {
            var e,
                t = this.props,
                r = t.applicator,
                n = t.recordAmountsIn,
                o = t.applicationMethod,
                i = t.validationText,
                a = t.validationTooltipText,
                u = t.t;
            return c.a.createElement("div", {
              key: r.contact.id,
              "aria-label": "Application Applicator",
              className: "row no-gutters mb-1 applicator-info"
            }, c.a.createElement("div", {
              className: "col-1 icons"
            }, c.a.createElement("a", {
              href: "#",
              onClick: this.onEditApplicator
            }, c.a.createElement("i", {
              className: "fa fa-edit edit-link"
            }))), c.a.createElement("div", {
              className: "col-6"
            }, r.contact.firstName, " ", r.contact.lastName, c.a.createElement("div", {
              className: "equipment-row"
            }, c.a.createElement("div", {
              className: "equipment-text"
            }, c.a.createElement(b.a, {
              tractor: r.tractor && r.tractor.name || "",
              sprayer: c.a.createElement(c.a.Fragment, null, c.a.createElement("span", {
                className: "mr-1"
              }, r.sprayer && r.sprayer.name), r.tankCleaned ? c.a.createElement("img", {
                className: "tank-cleaned-icon",
                alt: u("tank_cleaned")
              }) : null) || "",
              spreader: r.spreader && r.spreader.name || "",
              sprayRate: (r.sprayRate || "" !== r.sprayRate && 0 === r.sprayRate) && r.sprayRate || ""
            }), this.applicatorWarnings.length > 0 ? c.a.createElement("i", {
              className: "applicator-warning fas fa-ban ml-1",
              "data-original-title": this.warningText,
              "data-toggle": "tooltip"
            }) : null), c.a.createElement("div", {
              className: "validation-text",
              "data-testid": "validation-text",
              "data-original-title": a,
              "data-toggle": "tooltip"
            }, i))), c.a.createElement("div", {
              className: "col-5"
            }, s.SprayRecord.requiresRate(o) || s.SprayRecord.requiresTankSize(o) ? c.a.createElement(y.a, {
              applicator: r,
              recordAmountsIn: n
            }) : null, null != r && null !== (e = r.sprayer) && void 0 !== e && e.name ? c.a.createElement(m.a, {
              label: u("tank_cleaned"),
              isChecked: r.tankCleaned,
              onChange: this.toggleTankCleaned
            }) : null));
          }
        }]);
      }()).prototype, "applicatorWarnings", [u.computed], Object.getOwnPropertyDescriptor(o.prototype, "applicatorWarnings"), o.prototype), j(o.prototype, "warningText", [u.computed], Object.getOwnPropertyDescriptor(o.prototype, "warningText"), o.prototype), i = j(o.prototype, "onEditApplicator", [u.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            var r = e.props,
                n = r.applicator,
                o = r.onEditApplicator;
            t.preventDefault(), o(n);
          };
        }
      }), n = o)) || n;
      t.a = Object(d.a)()(P);
    }).call(this, r(82).setImmediate);
  }, function (e, t, r) {
    "use strict";

    (function (e) {
      var n,
          o,
          i,
          a,
          c,
          u,
          l,
          s,
          p,
          f,
          d = r(0),
          b = r.n(d),
          y = r(1),
          m = r(2),
          v = r(213),
          h = r(4);

      function g(e, t, r, n) {
        r && Object.defineProperty(e, t, {
          enumerable: r.enumerable,
          configurable: r.configurable,
          writable: r.writable,
          value: r.initializer ? r.initializer.call(n) : void 0
        });
      }

      function w(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, O(n.key), n);
        }
      }

      function O(e) {
        var t = function (e, t) {
          if ("object" != typeof e || !e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(e, "string");

        return "symbol" == typeof t ? t : t + "";
      }

      function j(e, t, r) {
        return t = P(t), function (e, t) {
          if (t && ("object" == typeof t || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }(e, function () {
          try {
            var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
          } catch (e) {}

          return function () {
            return !!e;
          }();
        }() ? Reflect.construct(t, r || [], P(e).constructor) : t.apply(e, r));
      }

      function P(e) {
        return (P = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }

      function _(e, t) {
        return (_ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }

      function E(e, t, r, n, o) {
        var i = {};
        return Object.keys(n).forEach(function (e) {
          i[e] = n[e];
        }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
          return n(e, t, r) || r;
        }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
      }

      var S = Object(m.observer)(((f = function (e) {
        function t(e) {
          var r;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), g(r = j(this, t, [e]), "selectModel", i, r), g(r, "selectOptions", a, r), g(r, "recordAmountsIn", c, r), g(r, "onChangeGallonsApplied", u, r), g(r, "onChangeSelection", l, r), g(r, "onChangeTanksCompleted", s, r), g(r, "onRegisterSelectModel", p, r);
          var n = r.props,
              o = n.applicator,
              f = n.recordAmountsIn,
              d = n.t;
          if (!o) throw new Error(d("applicator_is_required"));
          return r.selectOptions = [{
            key: "tanks",
            text: d("tanks_completed"),
            value: "tanks"
          }, {
            key: "gallons",
            text: d("gallons_applied"),
            value: "gallons"
          }], r.recordAmountsIn = null != o && o.gallonsApplied ? "gallons" : null != o && o.tanksCompleted ? "tanks" : f, r;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && _(e, t);
        }(t, d["Component"]), function (e, t, r) {
          return t && w(e.prototype, t), r && w(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
          }), e;
        }(t, [{
          key: "render",
          value: function () {
            var e = this.props,
                t = e.applicator,
                r = e.t;
            return b.a.createElement("div", {
              className: "amount-applied row no-gutters"
            }, b.a.createElement("div", {
              className: "col mr-1"
            }, "tanks" === this.recordAmountsIn ? b.a.createElement("input", {
              type: "number",
              className: "form-control",
              placeholder: r("tanks"),
              onChange: this.onChangeTanksCompleted,
              value: t.tanksCompleted
            }) : b.a.createElement("input", {
              type: "number",
              className: "form-control",
              placeholder: r("gallons"),
              onChange: this.onChangeGallonsApplied,
              value: t.gallonsApplied
            })), b.a.createElement("div", {
              className: "col-8"
            }, b.a.createElement(h.SelectDropdown, {
              disableClear: !0,
              options: this.selectOptions,
              onRegisterModel: this.onRegisterSelectModel,
              onChange: this.onChangeSelection
            })));
          }
        }]);
      }()).defaultProps = {
        recordAmountsIn: "tanks"
      }, i = E((o = f).prototype, "selectModel", [y.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), a = E(o.prototype, "selectOptions", [y.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), c = E(o.prototype, "recordAmountsIn", [y.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), u = E(o.prototype, "onChangeGallonsApplied", [y.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.props.applicator.update({
              gallons_applied: t.target.value
            });
          };
        }
      }), l = E(o.prototype, "onChangeSelection", [y.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            var r = e.props.applicator;
            null != (null == t ? void 0 : t.value) && (e.recordAmountsIn = t.value, "tanks" === e.recordAmountsIn ? r.update({
              gallons_applied: null
            }) : "gallons" === e.recordAmountsIn && r.update({
              tanks_completed: null
            }));
          };
        }
      }), s = E(o.prototype, "onChangeTanksCompleted", [y.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.props.applicator.update({
              tanksCompleted: t.target.value
            });
          };
        }
      }), p = E(o.prototype, "onRegisterSelectModel", [y.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var t = this;
          return function (r) {
            e(function () {
              return Object(y.runInAction)(function () {
                t.selectModel = r, t.selectModel.changeByKey(t.recordAmountsIn);
              });
            });
          };
        }
      }), n = o)) || n;
      t.a = Object(v.a)()(S);
    }).call(this, r(82).setImmediate);
  }, function (e, t) {
    e.exports = x;
  }, function (e, t, r) {
    "use strict";

    (function (e) {
      r.d(t, "a", function () {
        return y;
      });
      var n = r(1),
          o = r(63);

      function i(e, t, r, n) {
        r && Object.defineProperty(e, t, {
          enumerable: r.enumerable,
          configurable: r.configurable,
          writable: r.writable,
          value: r.initializer ? r.initializer.call(n) : void 0
        });
      }

      function a(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, c(n.key), n);
        }
      }

      function c(e) {
        var t = function (e, t) {
          if ("object" != typeof e || !e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(e, "string");

        return "symbol" == typeof t ? t : t + "";
      }

      function u(e, t, r) {
        return t = f(t), function (e, t) {
          if (t && ("object" == typeof t || "function" == typeof t)) return t;
          if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
          return function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }(e);
        }(e, function () {
          try {
            var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
          } catch (e) {}

          return function () {
            return !!e;
          }();
        }() ? Reflect.construct(t, r || [], f(e).constructor) : t.apply(e, r));
      }

      function l(e, t, r, n) {
        var o = s(f(1 & n ? e.prototype : e), t, r);
        return 2 & n && "function" == typeof o ? function (e) {
          return o.apply(r, e);
        } : o;
      }

      function s() {
        return (s = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
          var n = p(e, t);

          if (n) {
            var o = Object.getOwnPropertyDescriptor(n, t);
            return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
          }
        }).apply(null, arguments);
      }

      function p(e, t) {
        for (; !{}.hasOwnProperty.call(e, t) && null !== (e = f(e)););

        return e;
      }

      function f(e) {
        return (f = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }

      function d(e, t) {
        return (d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }

      function b(e, t, r, n, o) {
        var i = {};
        return Object.keys(n).forEach(function (e) {
          i[e] = n[e];
        }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
          return n(e, t, r) || r;
        }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
      }

      var y = function (t) {
        var r, c, s;
        return c = b((r = function (r) {
          function p(e) {
            var t;
            return function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, p), i(t = u(this, p, [e]), "groupSpecs", c, t), t.sortConfig = new o.a(), i(t, "sortingColumn", s, t), t.disposeColumnSortReaction = Object(n.reaction)(function () {
              return t.sortingColumn;
            }, function (e) {
              t.unGroupedColumns.forEach(function (r) {
                r.id !== (null == e ? void 0 : e.id) && t.sortConfig.removeSort(r.id);
              });
            }), t;
          }

          return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && d(e, t);
          }(p, t), f = p, (b = [{
            key: "unGroupedColumns",
            get: function () {
              var e = this;
              return this.visibleColumns.filter(function (t) {
                return !e.isGrouped(t);
              });
            }
          }, {
            key: "componentWillUnmount",
            value: function () {
              this.disposeColumnSortReaction();
            }
          }, {
            key: "isGrouped",
            value: function (e) {
              return !!this.groupSpecs.find(function (t) {
                return (null == t ? void 0 : t.id) && t.id === (null == e ? void 0 : e.id);
              });
            }
          }, {
            key: "isSortingDown",
            value: function (e) {
              return this.sortConfig.isSortingDown(e.id);
            }
          }, {
            key: "isSortingUp",
            value: function (e) {
              return this.sortConfig.isSortingUp(e.id);
            }
          }, {
            key: "loadGroups",
            value: function (e) {
              var t = this;
              (e || []).forEach(function (e) {
                var r = e && t.findColumn(e);
                r && t.group(r);
              });
            }
          }, {
            key: "loadSortConfig",
            value: function (e) {
              var t = this;
              this.sortConfig.load(e);
              var r = this.sortConfig.dump().find(function (e) {
                return !t.groupSpecs.find(function (t) {
                  return (null == t ? void 0 : t.id) && t.id === e.key;
                });
              });
              this.sortingColumn = r && this.findColumn(null == r ? void 0 : r.key);
            }
          }, {
            key: "moveColumnToPosition",
            value: function (e, t) {
              e && (l(p, "moveColumnToPosition", this, 3)([e, t]), this.isGrouped(e) && this.moveGroupToPosition(e, t));
            }
          }, {
            key: "moveGroupToPosition",
            value: function (e, t) {
              if (!(t > this.groupSpecs.length)) {
                var r = this.groupSpecs.findIndex(function (t) {
                  return (null == t ? void 0 : t.id) && (null == t ? void 0 : t.id) === (null == e ? void 0 : e.id);
                });
                r < 0 || (this.groupSpecs.splice(r, 1), this.groupSpecs.splice(t, 0, e));
              }
            }
          }, {
            key: "removeColumn",
            value: function (t) {
              var r,
                  o = this;
              t && (l(p, "removeColumn", this, 3)([t]), this.sortConfig.removeSort(t.id), t.id === (null === (r = this.sortingColumn) || void 0 === r ? void 0 : r.id) && (this.sortingColumn = null), this.isGrouped(t) && e(function () {
                return Object(n.runInAction)(function () {
                  return o.unGroup(t);
                });
              }));
            }
          }, {
            key: "sortAscending",
            value: function (e) {
              this.isGrouped(e) || (this.sortingColumn = e), this.sortConfig.addSort(e.id, o.a.ASC);
            }
          }, {
            key: "sortDescending",
            value: function (e) {
              this.isGrouped(e) || (this.sortingColumn = e), this.sortConfig.addSort(e.id, o.a.DESC);
            }
          }, {
            key: "group",
            value: function (e) {
              var t = this.groupSpecs.length;
              this.groupSpecs.push(e), this.moveColumnToPosition(e, t), this.sortAscending(e);
            }
          }, {
            key: "unGroup",
            value: function (e) {
              this.groupSpecs = this.groupSpecs.filter(function (t) {
                return (null == t ? void 0 : t.id) && t.id !== (null == e ? void 0 : e.id);
              }), this.moveColumnToPosition(e, this.groupSpecs.length), this.sortConfig.removeSort(e.id);
            }
          }]) && a(f.prototype, b), y && a(f, y), Object.defineProperty(f, "prototype", {
            writable: !1
          }), f;
          var f, b, y;
        }()).prototype, "groupSpecs", [n.observable], {
          configurable: !0,
          enumerable: !0,
          writable: !0,
          initializer: function () {
            return [];
          }
        }), s = b(r.prototype, "sortingColumn", [n.observable], {
          configurable: !0,
          enumerable: !0,
          writable: !0,
          initializer: null
        }), b(r.prototype, "unGroupedColumns", [n.computed], Object.getOwnPropertyDescriptor(r.prototype, "unGroupedColumns"), r.prototype), b(r.prototype, "moveColumnToPosition", [n.action], Object.getOwnPropertyDescriptor(r.prototype, "moveColumnToPosition"), r.prototype), b(r.prototype, "moveGroupToPosition", [n.action], Object.getOwnPropertyDescriptor(r.prototype, "moveGroupToPosition"), r.prototype), b(r.prototype, "removeColumn", [n.action], Object.getOwnPropertyDescriptor(r.prototype, "removeColumn"), r.prototype), b(r.prototype, "sortAscending", [n.action], Object.getOwnPropertyDescriptor(r.prototype, "sortAscending"), r.prototype), b(r.prototype, "sortDescending", [n.action], Object.getOwnPropertyDescriptor(r.prototype, "sortDescending"), r.prototype), b(r.prototype, "group", [n.action], Object.getOwnPropertyDescriptor(r.prototype, "group"), r.prototype), b(r.prototype, "unGroup", [n.action], Object.getOwnPropertyDescriptor(r.prototype, "unGroup"), r.prototype), r;
      };
    }).call(this, r(82).setImmediate);
  }, function (e, t) {
    e.exports = A;
  }, function (e, t, r) {
    "use strict";

    r.d(t, "a", function () {
      return w;
    });
    var n = r(34),
        o = r.n(n),
        i = r(57),
        a = r.n(i),
        c = r(134),
        u = r.n(c),
        l = r(0),
        s = r.n(l),
        p = r(43);
    var f = {};

    function d() {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

      "string" == typeof t[0] && f[t[0]] || ("string" == typeof t[0] && (f[t[0]] = new Date()), function () {
        if (console && console.warn) {
          for (var e, t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];

          "string" == typeof r[0] && (r[0] = "react-i18next:: ".concat(r[0])), (e = console).warn.apply(e, r);
        }
      }.apply(void 0, t));
    }

    function b(e, t, r) {
      e.loadNamespaces(t, function () {
        if (e.isInitialized) r();else {
          e.on("initialized", function t() {
            setTimeout(function () {
              e.off("initialized", t);
            }, 0), r();
          });
        }
      });
    }

    function y(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function m(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? y(Object(r), !0).forEach(function (t) {
          o()(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : y(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function v(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          r = t.i18n,
          n = Object(l.useContext)(p.a) || {},
          o = n.i18n,
          i = n.defaultNS,
          c = r || o || Object(p.d)();

      if (c && !c.reportNamespaces && (c.reportNamespaces = new p.b()), !c) {
        d("You will need to pass in an i18next instance by using initReactI18next");

        var u = function (e) {
          return Array.isArray(e) ? e[e.length - 1] : e;
        },
            s = [u, {}, !1];

        return s.t = u, s.i18n = {}, s.ready = !1, s;
      }

      var f = m(m(m({}, Object(p.c)()), c.options.react), t),
          y = f.useSuspense,
          v = e || i || c.options && c.options.defaultNS;
      v = "string" == typeof v ? [v] : v || ["translation"], c.reportNamespaces.addUsedNamespaces && c.reportNamespaces.addUsedNamespaces(v);
      var h = (c.isInitialized || c.initializedStoreOnce) && v.every(function (e) {
        return function (e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          if (!t.languages || !t.languages.length) return d("i18n.languages were undefined or empty", t.languages), !0;
          var n = t.languages[0],
              o = !!t.options && t.options.fallbackLng,
              i = t.languages[t.languages.length - 1];
          if ("cimode" === n.toLowerCase()) return !0;

          var a = function (e, r) {
            var n = t.services.backendConnector.state["".concat(e, "|").concat(r)];
            return -1 === n || 2 === n;
          };

          return !(r.bindI18n && r.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !a(t.isLanguageChangingTo, e)) && (!!t.hasResourceBundle(n, e) || !t.services.backendConnector.backend || !(!a(n, e) || o && !a(i, e)));
        }(e, c, f);
      });

      function g() {
        return {
          t: c.getFixedT(null, "fallback" === f.nsMode ? v : v[0])
        };
      }

      var w = Object(l.useState)(g()),
          O = a()(w, 2),
          j = O[0],
          P = O[1],
          _ = Object(l.useRef)(!0);

      Object(l.useEffect)(function () {
        var e = f.bindI18n,
            t = f.bindI18nStore;

        function r() {
          _.current && P(g());
        }

        return _.current = !0, h || y || b(c, v, function () {
          _.current && P(g());
        }), e && c && c.on(e, r), t && c && c.store.on(t, r), function () {
          _.current = !1, e && c && e.split(" ").forEach(function (e) {
            return c.off(e, r);
          }), t && c && t.split(" ").forEach(function (e) {
            return c.store.off(e, r);
          });
        };
      }, [v.join()]);
      var E = [j.t, c, h];
      if (E.t = j.t, E.i18n = c, E.ready = h, h) return E;
      if (!h && !y) return E;
      throw new Promise(function (e) {
        b(c, v, function () {
          e();
        });
      });
    }

    function h(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function g(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? h(Object(r), !0).forEach(function (t) {
          o()(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : h(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function w(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return function (r) {
        function n(n) {
          var o = n.forwardedRef,
              i = u()(n, ["forwardedRef"]),
              c = v(e, i),
              l = a()(c, 3),
              p = l[0],
              f = l[1],
              d = l[2],
              b = g(g({}, i), {}, {
            t: p,
            i18n: f,
            tReady: d
          });
          return t.withRef && o ? b.ref = o : !t.withRef && o && (b.forwardedRef = o), s.a.createElement(r, b);
        }

        var o;
        n.displayName = "withI18nextTranslation(".concat((o = r).displayName || o.name || ("string" == typeof o && o.length > 0 ? o : "Unknown"), ")"), n.WrappedComponent = r;
        return t.withRef ? s.a.forwardRef(function (e, t) {
          return s.a.createElement(n, Object.assign({}, e, {
            forwardedRef: t
          }));
        }) : n;
      };
    }
  }, function (e, t) {
    e.exports = M;
  }, function (e, t, r) {
    /*!
      * Bootstrap modal.js v4.6.1 (https://getbootstrap.com/)
      * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
      */
    e.exports = function (e, t) {
      "use strict";

      function r(e) {
        return e && "object" == typeof e && "default" in e ? e : {
          default: e
        };
      }

      var n = r(e),
          o = r(t);

      function i(e, t) {
        for (var r = 0; r < t.length; r++) {
          var n = t[r];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      function a() {
        return (a = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = arguments[t];

            for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }

          return e;
        }).apply(this, arguments);
      }

      var c = "modal",
          u = ".bs.modal",
          l = n.default.fn.modal,
          s = ".modal-dialog",
          p = {
        backdrop: !0,
        keyboard: !0,
        focus: !0,
        show: !0
      },
          f = {
        backdrop: "(boolean|string)",
        keyboard: "boolean",
        focus: "boolean",
        show: "boolean"
      },
          d = function () {
        function e(e, t) {
          this._config = this._getConfig(t), this._element = e, this._dialog = e.querySelector(s), this._backdrop = null, this._isShown = !1, this._isBodyOverflowing = !1, this._ignoreBackdropClick = !1, this._isTransitioning = !1, this._scrollbarWidth = 0;
        }

        var t,
            r,
            l,
            d = e.prototype;
        return d.toggle = function (e) {
          return this._isShown ? this.hide() : this.show(e);
        }, d.show = function (e) {
          var t = this;

          if (!this._isShown && !this._isTransitioning) {
            var r = n.default.Event("show.bs.modal", {
              relatedTarget: e
            });
            n.default(this._element).trigger(r), r.isDefaultPrevented() || (this._isShown = !0, n.default(this._element).hasClass("fade") && (this._isTransitioning = !0), this._checkScrollbar(), this._setScrollbar(), this._adjustDialog(), this._setEscapeEvent(), this._setResizeEvent(), n.default(this._element).on("click.dismiss.bs.modal", '[data-dismiss="modal"]', function (e) {
              return t.hide(e);
            }), n.default(this._dialog).on("mousedown.dismiss.bs.modal", function () {
              n.default(t._element).one("mouseup.dismiss.bs.modal", function (e) {
                n.default(e.target).is(t._element) && (t._ignoreBackdropClick = !0);
              });
            }), this._showBackdrop(function () {
              return t._showElement(e);
            }));
          }
        }, d.hide = function (e) {
          var t = this;

          if (e && e.preventDefault(), this._isShown && !this._isTransitioning) {
            var r = n.default.Event("hide.bs.modal");

            if (n.default(this._element).trigger(r), this._isShown && !r.isDefaultPrevented()) {
              this._isShown = !1;
              var i = n.default(this._element).hasClass("fade");

              if (i && (this._isTransitioning = !0), this._setEscapeEvent(), this._setResizeEvent(), n.default(document).off("focusin.bs.modal"), n.default(this._element).removeClass("show"), n.default(this._element).off("click.dismiss.bs.modal"), n.default(this._dialog).off("mousedown.dismiss.bs.modal"), i) {
                var a = o.default.getTransitionDurationFromElement(this._element);
                n.default(this._element).one(o.default.TRANSITION_END, function (e) {
                  return t._hideModal(e);
                }).emulateTransitionEnd(a);
              } else this._hideModal();
            }
          }
        }, d.dispose = function () {
          [window, this._element, this._dialog].forEach(function (e) {
            return n.default(e).off(u);
          }), n.default(document).off("focusin.bs.modal"), n.default.removeData(this._element, "bs.modal"), this._config = null, this._element = null, this._dialog = null, this._backdrop = null, this._isShown = null, this._isBodyOverflowing = null, this._ignoreBackdropClick = null, this._isTransitioning = null, this._scrollbarWidth = null;
        }, d.handleUpdate = function () {
          this._adjustDialog();
        }, d._getConfig = function (e) {
          return e = a({}, p, e), o.default.typeCheckConfig(c, e, f), e;
        }, d._triggerBackdropTransition = function () {
          var e = this,
              t = n.default.Event("hidePrevented.bs.modal");

          if (n.default(this._element).trigger(t), !t.isDefaultPrevented()) {
            var r = this._element.scrollHeight > document.documentElement.clientHeight;
            r || (this._element.style.overflowY = "hidden"), this._element.classList.add("modal-static");
            var i = o.default.getTransitionDurationFromElement(this._dialog);
            n.default(this._element).off(o.default.TRANSITION_END), n.default(this._element).one(o.default.TRANSITION_END, function () {
              e._element.classList.remove("modal-static"), r || n.default(e._element).one(o.default.TRANSITION_END, function () {
                e._element.style.overflowY = "";
              }).emulateTransitionEnd(e._element, i);
            }).emulateTransitionEnd(i), this._element.focus();
          }
        }, d._showElement = function (e) {
          var t = this,
              r = n.default(this._element).hasClass("fade"),
              i = this._dialog ? this._dialog.querySelector(".modal-body") : null;
          this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE || document.body.appendChild(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), n.default(this._dialog).hasClass("modal-dialog-scrollable") && i ? i.scrollTop = 0 : this._element.scrollTop = 0, r && o.default.reflow(this._element), n.default(this._element).addClass("show"), this._config.focus && this._enforceFocus();

          var a = n.default.Event("shown.bs.modal", {
            relatedTarget: e
          }),
              c = function () {
            t._config.focus && t._element.focus(), t._isTransitioning = !1, n.default(t._element).trigger(a);
          };

          if (r) {
            var u = o.default.getTransitionDurationFromElement(this._dialog);
            n.default(this._dialog).one(o.default.TRANSITION_END, c).emulateTransitionEnd(u);
          } else c();
        }, d._enforceFocus = function () {
          var e = this;
          n.default(document).off("focusin.bs.modal").on("focusin.bs.modal", function (t) {
            document !== t.target && e._element !== t.target && 0 === n.default(e._element).has(t.target).length && e._element.focus();
          });
        }, d._setEscapeEvent = function () {
          var e = this;
          this._isShown ? n.default(this._element).on("keydown.dismiss.bs.modal", function (t) {
            e._config.keyboard && 27 === t.which ? (t.preventDefault(), e.hide()) : e._config.keyboard || 27 !== t.which || e._triggerBackdropTransition();
          }) : this._isShown || n.default(this._element).off("keydown.dismiss.bs.modal");
        }, d._setResizeEvent = function () {
          var e = this;
          this._isShown ? n.default(window).on("resize.bs.modal", function (t) {
            return e.handleUpdate(t);
          }) : n.default(window).off("resize.bs.modal");
        }, d._hideModal = function () {
          var e = this;
          this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._showBackdrop(function () {
            n.default(document.body).removeClass("modal-open"), e._resetAdjustments(), e._resetScrollbar(), n.default(e._element).trigger("hidden.bs.modal");
          });
        }, d._removeBackdrop = function () {
          this._backdrop && (n.default(this._backdrop).remove(), this._backdrop = null);
        }, d._showBackdrop = function (e) {
          var t = this,
              r = n.default(this._element).hasClass("fade") ? "fade" : "";

          if (this._isShown && this._config.backdrop) {
            if (this._backdrop = document.createElement("div"), this._backdrop.className = "modal-backdrop", r && this._backdrop.classList.add(r), n.default(this._backdrop).appendTo(document.body), n.default(this._element).on("click.dismiss.bs.modal", function (e) {
              t._ignoreBackdropClick ? t._ignoreBackdropClick = !1 : e.target === e.currentTarget && ("static" === t._config.backdrop ? t._triggerBackdropTransition() : t.hide());
            }), r && o.default.reflow(this._backdrop), n.default(this._backdrop).addClass("show"), !e) return;
            if (!r) return void e();
            var i = o.default.getTransitionDurationFromElement(this._backdrop);
            n.default(this._backdrop).one(o.default.TRANSITION_END, e).emulateTransitionEnd(i);
          } else if (!this._isShown && this._backdrop) {
            n.default(this._backdrop).removeClass("show");

            var a = function () {
              t._removeBackdrop(), e && e();
            };

            if (n.default(this._element).hasClass("fade")) {
              var c = o.default.getTransitionDurationFromElement(this._backdrop);
              n.default(this._backdrop).one(o.default.TRANSITION_END, a).emulateTransitionEnd(c);
            } else a();
          } else e && e();
        }, d._adjustDialog = function () {
          var e = this._element.scrollHeight > document.documentElement.clientHeight;
          !this._isBodyOverflowing && e && (this._element.style.paddingLeft = this._scrollbarWidth + "px"), this._isBodyOverflowing && !e && (this._element.style.paddingRight = this._scrollbarWidth + "px");
        }, d._resetAdjustments = function () {
          this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
        }, d._checkScrollbar = function () {
          var e = document.body.getBoundingClientRect();
          this._isBodyOverflowing = Math.round(e.left + e.right) < window.innerWidth, this._scrollbarWidth = this._getScrollbarWidth();
        }, d._setScrollbar = function () {
          var e = this;

          if (this._isBodyOverflowing) {
            var t = [].slice.call(document.querySelectorAll(".fixed-top, .fixed-bottom, .is-fixed, .sticky-top")),
                r = [].slice.call(document.querySelectorAll(".sticky-top"));
            n.default(t).each(function (t, r) {
              var o = r.style.paddingRight,
                  i = n.default(r).css("padding-right");
              n.default(r).data("padding-right", o).css("padding-right", parseFloat(i) + e._scrollbarWidth + "px");
            }), n.default(r).each(function (t, r) {
              var o = r.style.marginRight,
                  i = n.default(r).css("margin-right");
              n.default(r).data("margin-right", o).css("margin-right", parseFloat(i) - e._scrollbarWidth + "px");
            });
            var o = document.body.style.paddingRight,
                i = n.default(document.body).css("padding-right");
            n.default(document.body).data("padding-right", o).css("padding-right", parseFloat(i) + this._scrollbarWidth + "px");
          }

          n.default(document.body).addClass("modal-open");
        }, d._resetScrollbar = function () {
          var e = [].slice.call(document.querySelectorAll(".fixed-top, .fixed-bottom, .is-fixed, .sticky-top"));
          n.default(e).each(function (e, t) {
            var r = n.default(t).data("padding-right");
            n.default(t).removeData("padding-right"), t.style.paddingRight = r || "";
          });
          var t = [].slice.call(document.querySelectorAll(".sticky-top"));
          n.default(t).each(function (e, t) {
            var r = n.default(t).data("margin-right");
            void 0 !== r && n.default(t).css("margin-right", r).removeData("margin-right");
          });
          var r = n.default(document.body).data("padding-right");
          n.default(document.body).removeData("padding-right"), document.body.style.paddingRight = r || "";
        }, d._getScrollbarWidth = function () {
          var e = document.createElement("div");
          e.className = "modal-scrollbar-measure", document.body.appendChild(e);
          var t = e.getBoundingClientRect().width - e.clientWidth;
          return document.body.removeChild(e), t;
        }, e._jQueryInterface = function (t, r) {
          return this.each(function () {
            var o = n.default(this).data("bs.modal"),
                i = a({}, p, n.default(this).data(), "object" == typeof t && t ? t : {});

            if (o || (o = new e(this, i), n.default(this).data("bs.modal", o)), "string" == typeof t) {
              if (void 0 === o[t]) throw new TypeError('No method named "' + t + '"');
              o[t](r);
            } else i.show && o.show(r);
          });
        }, t = e, l = [{
          key: "VERSION",
          get: function () {
            return "4.6.1";
          }
        }, {
          key: "Default",
          get: function () {
            return p;
          }
        }], (r = null) && i(t.prototype, r), l && i(t, l), e;
      }();

      return n.default(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function (e) {
        var t,
            r = this,
            i = o.default.getSelectorFromElement(this);
        i && (t = document.querySelector(i));
        var c = n.default(t).data("bs.modal") ? "toggle" : a({}, n.default(t).data(), n.default(this).data());
        "A" !== this.tagName && "AREA" !== this.tagName || e.preventDefault();
        var u = n.default(t).one("show.bs.modal", function (e) {
          e.isDefaultPrevented() || u.one("hidden.bs.modal", function () {
            n.default(r).is(":visible") && r.focus();
          });
        });

        d._jQueryInterface.call(n.default(t), c, this);
      }), n.default.fn.modal = d._jQueryInterface, n.default.fn.modal.Constructor = d, n.default.fn.modal.noConflict = function () {
        return n.default.fn.modal = l, d._jQueryInterface;
      }, d;
    }(r(7), r(216));
  }, function (e, t, r) {
    /*!
      * Bootstrap util.js v4.6.1 (https://getbootstrap.com/)
      * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
      */
    e.exports = function (e) {
      "use strict";

      var t,
          r = (t = e) && "object" == typeof t && "default" in t ? t : {
        default: t
      },
          n = "transitionend";

      function o(e) {
        var t = this,
            n = !1;
        return r.default(this).one(i.TRANSITION_END, function () {
          n = !0;
        }), setTimeout(function () {
          n || i.triggerTransitionEnd(t);
        }, e), this;
      }

      var i = {
        TRANSITION_END: "bsTransitionEnd",
        getUID: function (e) {
          do {
            e += ~~(1e6 * Math.random());
          } while (document.getElementById(e));

          return e;
        },
        getSelectorFromElement: function (e) {
          var t = e.getAttribute("data-target");

          if (!t || "#" === t) {
            var r = e.getAttribute("href");
            t = r && "#" !== r ? r.trim() : "";
          }

          try {
            return document.querySelector(t) ? t : null;
          } catch (e) {
            return null;
          }
        },
        getTransitionDurationFromElement: function (e) {
          if (!e) return 0;
          var t = r.default(e).css("transition-duration"),
              n = r.default(e).css("transition-delay"),
              o = parseFloat(t),
              i = parseFloat(n);
          return o || i ? (t = t.split(",")[0], n = n.split(",")[0], 1e3 * (parseFloat(t) + parseFloat(n))) : 0;
        },
        reflow: function (e) {
          return e.offsetHeight;
        },
        triggerTransitionEnd: function (e) {
          r.default(e).trigger(n);
        },
        supportsTransitionEnd: function () {
          return Boolean(n);
        },
        isElement: function (e) {
          return (e[0] || e).nodeType;
        },
        typeCheckConfig: function (e, t, r) {
          for (var n in r) if (Object.prototype.hasOwnProperty.call(r, n)) {
            var o = r[n],
                a = t[n],
                c = a && i.isElement(a) ? "element" : null == (u = a) ? "" + u : {}.toString.call(u).match(/\s([a-z]+)/i)[1].toLowerCase();
            if (!new RegExp(o).test(c)) throw new Error(e.toUpperCase() + ': Option "' + n + '" provided type "' + c + '" but expected type "' + o + '".');
          }

          var u;
        },
        findShadowRoot: function (e) {
          if (!document.documentElement.attachShadow) return null;

          if ("function" == typeof e.getRootNode) {
            var t = e.getRootNode();
            return t instanceof ShadowRoot ? t : null;
          }

          return e instanceof ShadowRoot ? e : e.parentNode ? i.findShadowRoot(e.parentNode) : null;
        },
        jQueryDetection: function () {
          if (void 0 === r.default) throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
          var e = r.default.fn.jquery.split(" ")[0].split(".");
          if (e[0] < 2 && e[1] < 9 || 1 === e[0] && 9 === e[1] && e[2] < 1 || e[0] >= 4) throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0");
        }
      };
      return i.jQueryDetection(), r.default.fn.emulateTransitionEnd = o, r.default.event.special[i.TRANSITION_END] = {
        bindType: n,
        delegateType: n,
        handle: function (e) {
          if (r.default(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
        }
      }, i;
    }(r(7));
  }, function (e, t) {
    e.exports = function (e) {
      if (Array.isArray(e)) return e;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var r = [],
            n = !0,
            o = !1,
            i = void 0;

        try {
          for (var a, c = e[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0);
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            n || null == c.return || c.return();
          } finally {
            if (o) throw i;
          }
        }

        return r;
      }
    };
  }, function (e, t, r) {
    var n = r(220);

    e.exports = function (e, t) {
      if (e) {
        if ("string" == typeof e) return n(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
      }
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];

      return n;
    };
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if (null == e) return {};
      var r,
          n,
          o = {},
          i = Object.keys(e);

      for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);

      return o;
    };
  }, function (e, t, r) {
    var n = r(64),
        o = r(224);

    e.exports = function e(t, r, i, a, c) {
      var u = -1,
          l = t.length;

      for (i || (i = o), c || (c = []); ++u < l;) {
        var s = t[u];
        r > 0 && i(s) ? r > 1 ? e(s, r - 1, i, a, c) : n(c, s) : a || (c[c.length] = s);
      }

      return c;
    };
  }, function (e, t, r) {
    var n = r(30),
        o = r(44),
        i = r(16),
        a = n ? n.isConcatSpreadable : void 0;

    e.exports = function (e) {
      return i(e) || o(e) || !!(a && e && e[a]);
    };
  }, function (e, t, r) {
    var n = r(31),
        o = r(25),
        i = "[object Arguments]";

    e.exports = function (e) {
      return o(e) && n(e) == i;
    };
  }, function (e, t, r) {
    var n = r(30),
        o = Object.prototype,
        i = o.hasOwnProperty,
        a = o.toString,
        c = n ? n.toStringTag : void 0;

    e.exports = function (e) {
      var t = i.call(e, c),
          r = e[c];

      try {
        e[c] = void 0;
        var n = !0;
      } catch (e) {}

      var o = a.call(e);
      return n && (t ? e[c] = r : delete e[c]), o;
    };
  }, function (e, t) {
    var r = Object.prototype.toString;

    e.exports = function (e) {
      return r.call(e);
    };
  }, function (e, t, r) {
    var n = r(229),
        o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
        i = /\\(\\)?/g,
        a = n(function (e) {
      var t = [];
      return 46 === e.charCodeAt(0) && t.push(""), e.replace(o, function (e, r, n, o) {
        t.push(n ? o.replace(i, "$1") : r || e);
      }), t;
    });
    e.exports = a;
  }, function (e, t, r) {
    var n = r(230),
        o = 500;

    e.exports = function (e) {
      var t = n(e, function (e) {
        return r.size === o && r.clear(), e;
      }),
          r = t.cache;
      return t;
    };
  }, function (e, t, r) {
    var n = r(68),
        o = "Expected a function";

    function i(e, t) {
      if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError(o);

      var r = function () {
        var n = arguments,
            o = t ? t.apply(this, n) : n[0],
            i = r.cache;
        if (i.has(o)) return i.get(o);
        var a = e.apply(this, n);
        return r.cache = i.set(o, a) || i, a;
      };

      return r.cache = new (i.Cache || n)(), r;
    }

    i.Cache = n, e.exports = i;
  }, function (e, t, r) {
    var n = r(232),
        o = r(46),
        i = r(70);

    e.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new n(),
        map: new (i || o)(),
        string: new n()
      };
    };
  }, function (e, t, r) {
    var n = r(233),
        o = r(238),
        i = r(239),
        a = r(240),
        c = r(241);

    function u(e) {
      var t = -1,
          r = null == e ? 0 : e.length;

      for (this.clear(); ++t < r;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }

    u.prototype.clear = n, u.prototype.delete = o, u.prototype.get = i, u.prototype.has = a, u.prototype.set = c, e.exports = u;
  }, function (e, t, r) {
    var n = r(45);

    e.exports = function () {
      this.__data__ = n ? n(null) : {}, this.size = 0;
    };
  }, function (e, t, r) {
    var n = r(69),
        o = r(235),
        i = r(22),
        a = r(103),
        c = /^\[object .+?Constructor\]$/,
        u = Function.prototype,
        l = Object.prototype,
        s = u.toString,
        p = l.hasOwnProperty,
        f = RegExp("^" + s.call(p).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");

    e.exports = function (e) {
      return !(!i(e) || o(e)) && (n(e) ? f : c).test(a(e));
    };
  }, function (e, t, r) {
    var n,
        o = r(236),
        i = (n = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n : "";

    e.exports = function (e) {
      return !!i && i in e;
    };
  }, function (e, t, r) {
    var n = r(17)["__core-js_shared__"];
    e.exports = n;
  }, function (e, t) {
    e.exports = function (e, t) {
      return null == e ? void 0 : e[t];
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = this.has(e) && delete this.__data__[e];
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t, r) {
    var n = r(45),
        o = "__lodash_hash_undefined__",
        i = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = this.__data__;

      if (n) {
        var r = t[e];
        return r === o ? void 0 : r;
      }

      return i.call(t, e) ? t[e] : void 0;
    };
  }, function (e, t, r) {
    var n = r(45),
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = this.__data__;
      return n ? void 0 !== t[e] : o.call(t, e);
    };
  }, function (e, t, r) {
    var n = r(45),
        o = "__lodash_hash_undefined__";

    e.exports = function (e, t) {
      var r = this.__data__;
      return this.size += this.has(e) ? 0 : 1, r[e] = n && void 0 === t ? o : t, this;
    };
  }, function (e, t) {
    e.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (e, t, r) {
    var n = r(47),
        o = Array.prototype.splice;

    e.exports = function (e) {
      var t = this.__data__,
          r = n(t, e);
      return !(r < 0) && (r == t.length - 1 ? t.pop() : o.call(t, r, 1), --this.size, !0);
    };
  }, function (e, t, r) {
    var n = r(47);

    e.exports = function (e) {
      var t = this.__data__,
          r = n(t, e);
      return r < 0 ? void 0 : t[r][1];
    };
  }, function (e, t, r) {
    var n = r(47);

    e.exports = function (e) {
      return n(this.__data__, e) > -1;
    };
  }, function (e, t, r) {
    var n = r(47);

    e.exports = function (e, t) {
      var r = this.__data__,
          o = n(r, e);
      return o < 0 ? (++this.size, r.push([e, t])) : r[o][1] = t, this;
    };
  }, function (e, t, r) {
    var n = r(48);

    e.exports = function (e) {
      var t = n(this, e).delete(e);
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
    };
  }, function (e, t, r) {
    var n = r(48);

    e.exports = function (e) {
      return n(this, e).get(e);
    };
  }, function (e, t, r) {
    var n = r(48);

    e.exports = function (e) {
      return n(this, e).has(e);
    };
  }, function (e, t, r) {
    var n = r(48);

    e.exports = function (e, t) {
      var r = n(this, e),
          o = r.size;
      return r.set(e, t), this.size += r.size == o ? 0 : 1, this;
    };
  }, function (e, t, r) {
    var n = r(30),
        o = r(101),
        i = r(16),
        a = r(36),
        c = 1 / 0,
        u = n ? n.prototype : void 0,
        l = u ? u.toString : void 0;

    e.exports = function e(t) {
      if ("string" == typeof t) return t;
      if (i(t)) return o(t, e) + "";
      if (a(t)) return l ? l.call(t) : "";
      var r = t + "";
      return "0" == r && 1 / t == -c ? "-0" : r;
    };
  }, function (e, t, r) {
    var n = r(254),
        o = r(279),
        i = r(116);

    e.exports = function (e) {
      var t = o(e);
      return 1 == t.length && t[0][2] ? i(t[0][0], t[0][1]) : function (r) {
        return r === e || n(r, e, t);
      };
    };
  }, function (e, t, r) {
    var n = r(50),
        o = r(106),
        i = 1,
        a = 2;

    e.exports = function (e, t, r, c) {
      var u = r.length,
          l = u,
          s = !c;
      if (null == e) return !l;

      for (e = Object(e); u--;) {
        var p = r[u];
        if (s && p[2] ? p[1] !== e[p[0]] : !(p[0] in e)) return !1;
      }

      for (; ++u < l;) {
        var f = (p = r[u])[0],
            d = e[f],
            b = p[1];

        if (s && p[2]) {
          if (void 0 === d && !(f in e)) return !1;
        } else {
          var y = new n();
          if (c) var m = c(d, b, f, e, t, y);
          if (!(void 0 === m ? o(b, d, i | a, c, y) : m)) return !1;
        }
      }

      return !0;
    };
  }, function (e, t, r) {
    var n = r(46);

    e.exports = function () {
      this.__data__ = new n(), this.size = 0;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = this.__data__,
          r = t.delete(e);
      return this.size = t.size, r;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.get(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.has(e);
    };
  }, function (e, t, r) {
    var n = r(46),
        o = r(70),
        i = r(68),
        a = 200;

    e.exports = function (e, t) {
      var r = this.__data__;

      if (r instanceof n) {
        var c = r.__data__;
        if (!o || c.length < a - 1) return c.push([e, t]), this.size = ++r.size, this;
        r = this.__data__ = new i(c);
      }

      return r.set(e, t), this.size = r.size, this;
    };
  }, function (e, t, r) {
    var n = r(50),
        o = r(107),
        i = r(265),
        a = r(268),
        c = r(53),
        u = r(16),
        l = r(51),
        s = r(74),
        p = 1,
        f = "[object Arguments]",
        d = "[object Array]",
        b = "[object Object]",
        y = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, r, m, v, h) {
      var g = u(e),
          w = u(t),
          O = g ? d : c(e),
          j = w ? d : c(t),
          P = (O = O == f ? b : O) == b,
          _ = (j = j == f ? b : j) == b,
          E = O == j;

      if (E && l(e)) {
        if (!l(t)) return !1;
        g = !0, P = !1;
      }

      if (E && !P) return h || (h = new n()), g || s(e) ? o(e, t, r, m, v, h) : i(e, t, O, r, m, v, h);

      if (!(r & p)) {
        var S = P && y.call(e, "__wrapped__"),
            C = _ && y.call(t, "__wrapped__");

        if (S || C) {
          var k = S ? e.value() : e,
              R = C ? t.value() : t;
          return h || (h = new n()), v(k, R, r, m, h);
        }
      }

      return !!E && (h || (h = new n()), a(e, t, r, m, v, h));
    };
  }, function (e, t, r) {
    var n = r(68),
        o = r(262),
        i = r(263);

    function a(e) {
      var t = -1,
          r = null == e ? 0 : e.length;

      for (this.__data__ = new n(); ++t < r;) this.add(e[t]);
    }

    a.prototype.add = a.prototype.push = o, a.prototype.has = i, e.exports = a;
  }, function (e, t) {
    var r = "__lodash_hash_undefined__";

    e.exports = function (e) {
      return this.__data__.set(e, r), this;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.has(e);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return e.has(t);
    };
  }, function (e, t, r) {
    var n = r(30),
        o = r(109),
        i = r(32),
        a = r(107),
        c = r(266),
        u = r(267),
        l = 1,
        s = 2,
        p = "[object Boolean]",
        f = "[object Date]",
        d = "[object Error]",
        b = "[object Map]",
        y = "[object Number]",
        m = "[object RegExp]",
        v = "[object Set]",
        h = "[object String]",
        g = "[object Symbol]",
        w = "[object ArrayBuffer]",
        O = "[object DataView]",
        j = n ? n.prototype : void 0,
        P = j ? j.valueOf : void 0;

    e.exports = function (e, t, r, n, j, _, E) {
      switch (r) {
        case O:
          if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
          e = e.buffer, t = t.buffer;

        case w:
          return !(e.byteLength != t.byteLength || !_(new o(e), new o(t)));

        case p:
        case f:
        case y:
          return i(+e, +t);

        case d:
          return e.name == t.name && e.message == t.message;

        case m:
        case h:
          return e == t + "";

        case b:
          var S = c;

        case v:
          var C = n & l;
          if (S || (S = u), e.size != t.size && !C) return !1;
          var k = E.get(e);
          if (k) return k == t;
          n |= s, E.set(e, t);
          var R = a(S(e), S(t), n, j, _, E);
          return E.delete(e), R;

        case g:
          if (P) return P.call(e) == P.call(t);
      }

      return !1;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = -1,
          r = Array(e.size);
      return e.forEach(function (e, n) {
        r[++t] = [n, e];
      }), r;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = -1,
          r = Array(e.size);
      return e.forEach(function (e) {
        r[++t] = e;
      }), r;
    };
  }, function (e, t, r) {
    var n = r(110),
        o = 1,
        i = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, r, a, c, u) {
      var l = r & o,
          s = n(e),
          p = s.length;
      if (p != n(t).length && !l) return !1;

      for (var f = p; f--;) {
        var d = s[f];
        if (!(l ? d in t : i.call(t, d))) return !1;
      }

      var b = u.get(e),
          y = u.get(t);
      if (b && y) return b == t && y == e;
      var m = !0;
      u.set(e, t), u.set(t, e);

      for (var v = l; ++f < p;) {
        var h = e[d = s[f]],
            g = t[d];
        if (a) var w = l ? a(g, h, d, t, e, u) : a(h, g, d, e, t, u);

        if (!(void 0 === w ? h === g || c(h, g, r, a, u) : w)) {
          m = !1;
          break;
        }

        v || (v = "constructor" == d);
      }

      if (m && !v) {
        var O = e.constructor,
            j = t.constructor;
        O != j && "constructor" in e && "constructor" in t && !("function" == typeof O && O instanceof O && "function" == typeof j && j instanceof j) && (m = !1);
      }

      return u.delete(e), u.delete(t), m;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = null == e ? 0 : e.length, o = 0, i = []; ++r < n;) {
        var a = e[r];
        t(a, r, e) && (i[o++] = a);
      }

      return i;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = Array(e); ++r < e;) n[r] = t(r);

      return n;
    };
  }, function (e, t) {
    e.exports = function () {
      return !1;
    };
  }, function (e, t, r) {
    var n = r(31),
        o = r(75),
        i = r(25),
        a = {};
    a["[object Float32Array]"] = a["[object Float64Array]"] = a["[object Int8Array]"] = a["[object Int16Array]"] = a["[object Int32Array]"] = a["[object Uint8Array]"] = a["[object Uint8ClampedArray]"] = a["[object Uint16Array]"] = a["[object Uint32Array]"] = !0, a["[object Arguments]"] = a["[object Array]"] = a["[object ArrayBuffer]"] = a["[object Boolean]"] = a["[object DataView]"] = a["[object Date]"] = a["[object Error]"] = a["[object Function]"] = a["[object Map]"] = a["[object Number]"] = a["[object Object]"] = a["[object RegExp]"] = a["[object Set]"] = a["[object String]"] = a["[object WeakMap]"] = !1, e.exports = function (e) {
      return i(e) && o(e.length) && !!a[n(e)];
    };
  }, function (e, t, r) {
    var n = r(77),
        o = r(274),
        i = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      if (!n(e)) return o(e);
      var t = [];

      for (var r in Object(e)) i.call(e, r) && "constructor" != r && t.push(r);

      return t;
    };
  }, function (e, t, r) {
    var n = r(114)(Object.keys, Object);
    e.exports = n;
  }, function (e, t, r) {
    var n = r(29)(r(17), "DataView");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(29)(r(17), "Promise");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(29)(r(17), "Set");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(29)(r(17), "WeakMap");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(115),
        o = r(37);

    e.exports = function (e) {
      for (var t = o(e), r = t.length; r--;) {
        var i = t[r],
            a = e[i];
        t[r] = [i, a, n(a)];
      }

      return t;
    };
  }, function (e, t, r) {
    var n = r(106),
        o = r(281),
        i = r(282),
        a = r(67),
        c = r(115),
        u = r(116),
        l = r(49),
        s = 1,
        p = 2;

    e.exports = function (e, t) {
      return a(e) && c(t) ? u(l(e), t) : function (r) {
        var a = o(r, e);
        return void 0 === a && a === t ? i(r, e) : n(t, a, s | p);
      };
    };
  }, function (e, t, r) {
    var n = r(66);

    e.exports = function (e, t, r) {
      var o = null == e ? void 0 : n(e, t);
      return void 0 === o ? r : o;
    };
  }, function (e, t, r) {
    var n = r(283),
        o = r(284);

    e.exports = function (e, t) {
      return null != e && o(e, t, n);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return null != e && t in Object(e);
    };
  }, function (e, t, r) {
    var n = r(102),
        o = r(44),
        i = r(16),
        a = r(73),
        c = r(75),
        u = r(49);

    e.exports = function (e, t, r) {
      for (var l = -1, s = (t = n(t, e)).length, p = !1; ++l < s;) {
        var f = u(t[l]);
        if (!(p = null != e && r(e, f))) break;
        e = e[f];
      }

      return p || ++l != s ? p : !!(s = null == e ? 0 : e.length) && c(s) && a(f, s) && (i(e) || o(e));
    };
  }, function (e, t, r) {
    var n = r(286),
        o = r(287),
        i = r(67),
        a = r(49);

    e.exports = function (e) {
      return i(e) ? n(a(e)) : o(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return function (t) {
        return null == t ? void 0 : t[e];
      };
    };
  }, function (e, t, r) {
    var n = r(66);

    e.exports = function (e) {
      return function (t) {
        return n(t, e);
      };
    };
  }, function (e, t, r) {
    var n = r(117),
        o = r(33);

    e.exports = function (e, t) {
      var r = -1,
          i = o(e) ? Array(e.length) : [];
      return n(e, function (e, n, o) {
        i[++r] = t(e, n, o);
      }), i;
    };
  }, function (e, t, r) {
    var n = r(118),
        o = r(37);

    e.exports = function (e, t) {
      return e && n(e, t, o);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return function (t, r, n) {
        for (var o = -1, i = Object(t), a = n(t), c = a.length; c--;) {
          var u = a[e ? c : ++o];
          if (!1 === r(i[u], u, i)) break;
        }

        return t;
      };
    };
  }, function (e, t, r) {
    var n = r(33);

    e.exports = function (e, t) {
      return function (r, o) {
        if (null == r) return r;
        if (!n(r)) return e(r, o);

        for (var i = r.length, a = t ? i : -1, c = Object(r); (t ? a-- : ++a < i) && !1 !== o(c[a], a, c););

        return r;
      };
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      var r = e.length;

      for (e.sort(t); r--;) e[r] = e[r].value;

      return e;
    };
  }, function (e, t, r) {
    var n = r(294);

    e.exports = function (e, t, r) {
      for (var o = -1, i = e.criteria, a = t.criteria, c = i.length, u = r.length; ++o < c;) {
        var l = n(i[o], a[o]);
        if (l) return o >= u ? l : l * ("desc" == r[o] ? -1 : 1);
      }

      return e.index - t.index;
    };
  }, function (e, t, r) {
    var n = r(36);

    e.exports = function (e, t) {
      if (e !== t) {
        var r = void 0 !== e,
            o = null === e,
            i = e == e,
            a = n(e),
            c = void 0 !== t,
            u = null === t,
            l = t == t,
            s = n(t);
        if (!u && !s && !a && e > t || a && c && l && !u && !s || o && c && l || !r && l || !i) return 1;
        if (!o && !a && !s && e < t || s && r && i && !o && !a || u && r && i || !c && i || !l) return -1;
      }

      return 0;
    };
  }, function (e, t, r) {
    var n = r(296),
        o = Math.max;

    e.exports = function (e, t, r) {
      return t = o(void 0 === t ? e.length - 1 : t, 0), function () {
        for (var i = arguments, a = -1, c = o(i.length - t, 0), u = Array(c); ++a < c;) u[a] = i[t + a];

        a = -1;

        for (var l = Array(t + 1); ++a < t;) l[a] = i[a];

        return l[t] = r(u), n(e, this, l);
      };
    };
  }, function (e, t) {
    e.exports = function (e, t, r) {
      switch (r.length) {
        case 0:
          return e.call(t);

        case 1:
          return e.call(t, r[0]);

        case 2:
          return e.call(t, r[0], r[1]);

        case 3:
          return e.call(t, r[0], r[1], r[2]);
      }

      return e.apply(t, r);
    };
  }, function (e, t, r) {
    var n = r(298),
        o = r(300)(n);
    e.exports = o;
  }, function (e, t, r) {
    var n = r(299),
        o = r(120),
        i = r(54),
        a = o ? function (e, t) {
      return o(e, "toString", {
        configurable: !0,
        enumerable: !1,
        value: n(t),
        writable: !0
      });
    } : i;
    e.exports = a;
  }, function (e, t) {
    e.exports = function (e) {
      return function () {
        return e;
      };
    };
  }, function (e, t) {
    var r = 800,
        n = 16,
        o = Date.now;

    e.exports = function (e) {
      var t = 0,
          i = 0;
      return function () {
        var a = o(),
            c = n - (a - i);

        if (i = a, c > 0) {
          if (++t >= r) return arguments[0];
        } else t = 0;

        return e.apply(void 0, arguments);
      };
    };
  }, function (e, t, r) {
    var n = r(50),
        o = r(121),
        i = r(118),
        a = r(302),
        c = r(22),
        u = r(39),
        l = r(126);

    e.exports = function e(t, r, s, p, f) {
      t !== r && i(r, function (i, u) {
        if (f || (f = new n()), c(i)) a(t, r, u, s, e, p, f);else {
          var d = p ? p(l(t, u), i, u + "", t, r, f) : void 0;
          void 0 === d && (d = i), o(t, u, d);
        }
      }, u);
    };
  }, function (e, t, r) {
    var n = r(121),
        o = r(122),
        i = r(123),
        a = r(124),
        c = r(125),
        u = r(44),
        l = r(16),
        s = r(304),
        p = r(51),
        f = r(69),
        d = r(22),
        b = r(305),
        y = r(74),
        m = r(126),
        v = r(306);

    e.exports = function (e, t, r, h, g, w, O) {
      var j = m(e, r),
          P = m(t, r),
          _ = O.get(P);

      if (_) n(e, r, _);else {
        var E = w ? w(j, P, r + "", e, t, O) : void 0,
            S = void 0 === E;

        if (S) {
          var C = l(P),
              k = !C && p(P),
              R = !C && !k && y(P);
          E = P, C || k || R ? l(j) ? E = j : s(j) ? E = a(j) : k ? (S = !1, E = o(P, !0)) : R ? (S = !1, E = i(P, !0)) : E = [] : b(P) || u(P) ? (E = j, u(j) ? E = v(j) : d(j) && !f(j) || (E = c(P))) : S = !1;
        }

        S && (O.set(P, E), g(E, P, h, w, O), O.delete(P)), n(e, r, E);
      }
    };
  }, function (e, t, r) {
    var n = r(22),
        o = Object.create,
        i = function () {
      function e() {}

      return function (t) {
        if (!n(t)) return {};
        if (o) return o(t);
        e.prototype = t;
        var r = new e();
        return e.prototype = void 0, r;
      };
    }();

    e.exports = i;
  }, function (e, t, r) {
    var n = r(33),
        o = r(25);

    e.exports = function (e) {
      return o(e) && n(e);
    };
  }, function (e, t, r) {
    var n = r(31),
        o = r(80),
        i = r(25),
        a = "[object Object]",
        c = Function.prototype,
        u = Object.prototype,
        l = c.toString,
        s = u.hasOwnProperty,
        p = l.call(Object);

    e.exports = function (e) {
      if (!i(e) || n(e) != a) return !1;
      var t = o(e);
      if (null === t) return !0;
      var r = s.call(t, "constructor") && t.constructor;
      return "function" == typeof r && r instanceof r && l.call(r) == p;
    };
  }, function (e, t, r) {
    var n = r(38),
        o = r(39);

    e.exports = function (e) {
      return n(e, o(e));
    };
  }, function (e, t, r) {
    var n = r(22),
        o = r(77),
        i = r(308),
        a = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      if (!n(e)) return i(e);
      var t = o(e),
          r = [];

      for (var c in e) ("constructor" != c || !t && a.call(e, c)) && r.push(c);

      return r;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = [];
      if (null != e) for (var r in Object(e)) t.push(r);
      return t;
    };
  }, function (e, t, r) {
    var n = r(119),
        o = r(55);

    e.exports = function (e) {
      return n(function (t, r) {
        var n = -1,
            i = r.length,
            a = i > 1 ? r[i - 1] : void 0,
            c = i > 2 ? r[2] : void 0;

        for (a = e.length > 3 && "function" == typeof a ? (i--, a) : void 0, c && o(r[0], r[1], c) && (a = i < 3 ? void 0 : a, i = 1), t = Object(t); ++n < i;) {
          var u = r[n];
          u && e(t, u, n, a);
        }

        return t;
      });
    };
  }, function (e, t, r) {
    var n = r(311),
        o = r(55),
        i = r(128);

    e.exports = function (e) {
      return function (t, r, a) {
        return a && "number" != typeof a && o(t, r, a) && (r = a = void 0), t = i(t), void 0 === r ? (r = t, t = 0) : r = i(r), a = void 0 === a ? t < r ? 1 : -1 : i(a), n(t, r, a, e);
      };
    };
  }, function (e, t) {
    var r = Math.ceil,
        n = Math.max;

    e.exports = function (e, t, o, i) {
      for (var a = -1, c = n(r((t - e) / (o || 1)), 0), u = Array(c); c--;) u[i ? c : ++a] = e, e += o;

      return u;
    };
  }, function (e, t, r) {
    var n = r(313),
        o = /^\s+/;

    e.exports = function (e) {
      return e ? e.slice(0, n(e) + 1).replace(o, "") : e;
    };
  }, function (e, t) {
    var r = /\s/;

    e.exports = function (e) {
      for (var t = e.length; t-- && r.test(e.charAt(t)););

      return t;
    };
  }, function (e, t, r) {
    var n = r(17);

    e.exports = function () {
      return n.Date.now();
    };
  }, function (e, t) {
    var r = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);

    if (r) {
      var n = new Uint8Array(16);

      e.exports = function () {
        return r(n), n;
      };
    } else {
      var o = new Array(16);

      e.exports = function () {
        for (var e, t = 0; t < 16; t++) 0 == (3 & t) && (e = 4294967296 * Math.random()), o[t] = e >>> ((3 & t) << 3) & 255;

        return o;
      };
    }
  }, function (e, t) {
    for (var r = [], n = 0; n < 256; ++n) r[n] = (n + 256).toString(16).substr(1);

    e.exports = function (e, t) {
      var n = t || 0,
          o = r;
      return [o[e[n++]], o[e[n++]], o[e[n++]], o[e[n++]], "-", o[e[n++]], o[e[n++]], "-", o[e[n++]], o[e[n++]], "-", o[e[n++]], o[e[n++]], "-", o[e[n++]], o[e[n++]], o[e[n++]], o[e[n++]], o[e[n++]], o[e[n++]]].join("");
    };
  }, function (e, t, r) {
    var n = r(117);

    e.exports = function (e, t) {
      var r;
      return n(e, function (e, n, o) {
        return !(r = t(e, n, o));
      }), !!r;
    };
  }, function (e, t, r) {
    var n = r(50),
        o = r(319),
        i = r(127),
        a = r(320),
        c = r(321),
        u = r(122),
        l = r(124),
        s = r(322),
        p = r(323),
        f = r(110),
        d = r(324),
        b = r(53),
        y = r(325),
        m = r(326),
        v = r(125),
        h = r(16),
        g = r(51),
        w = r(330),
        O = r(22),
        j = r(332),
        P = r(37),
        _ = r(39),
        E = 1,
        S = 2,
        C = 4,
        k = "[object Arguments]",
        R = "[object Function]",
        T = "[object GeneratorFunction]",
        z = "[object Object]",
        N = {};

    N[k] = N["[object Array]"] = N["[object ArrayBuffer]"] = N["[object DataView]"] = N["[object Boolean]"] = N["[object Date]"] = N["[object Float32Array]"] = N["[object Float64Array]"] = N["[object Int8Array]"] = N["[object Int16Array]"] = N["[object Int32Array]"] = N["[object Map]"] = N["[object Number]"] = N[z] = N["[object RegExp]"] = N["[object Set]"] = N["[object String]"] = N["[object Symbol]"] = N["[object Uint8Array]"] = N["[object Uint8ClampedArray]"] = N["[object Uint16Array]"] = N["[object Uint32Array]"] = !0, N["[object Error]"] = N[R] = N["[object WeakMap]"] = !1, e.exports = function e(t, r, D, x, A, M) {
      var I,
          F = r & E,
          B = r & S,
          L = r & C;
      if (D && (I = A ? D(t, x, A, M) : D(t)), void 0 !== I) return I;
      if (!O(t)) return t;
      var V = h(t);

      if (V) {
        if (I = y(t), !F) return l(t, I);
      } else {
        var U = b(t),
            q = U == R || U == T;
        if (g(t)) return u(t, F);

        if (U == z || U == k || q && !A) {
          if (I = B || q ? {} : v(t), !F) return B ? p(t, c(I, t)) : s(t, a(I, t));
        } else {
          if (!N[U]) return A ? t : {};
          I = m(t, U, F);
        }
      }

      M || (M = new n());
      var K = M.get(t);
      if (K) return K;
      M.set(t, I), j(t) ? t.forEach(function (n) {
        I.add(e(n, r, D, n, t, M));
      }) : w(t) && t.forEach(function (n, o) {
        I.set(o, e(n, r, D, o, t, M));
      });
      var G = V ? void 0 : (L ? B ? d : f : B ? _ : P)(t);
      return o(G || t, function (n, o) {
        G && (n = t[o = n]), i(I, o, e(n, r, D, o, t, M));
      }), I;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = null == e ? 0 : e.length; ++r < n && !1 !== t(e[r], r, e););

      return e;
    };
  }, function (e, t, r) {
    var n = r(38),
        o = r(37);

    e.exports = function (e, t) {
      return e && n(t, o(t), e);
    };
  }, function (e, t, r) {
    var n = r(38),
        o = r(39);

    e.exports = function (e, t) {
      return e && n(t, o(t), e);
    };
  }, function (e, t, r) {
    var n = r(38),
        o = r(71);

    e.exports = function (e, t) {
      return n(e, o(e), t);
    };
  }, function (e, t, r) {
    var n = r(38),
        o = r(129);

    e.exports = function (e, t) {
      return n(e, o(e), t);
    };
  }, function (e, t, r) {
    var n = r(111),
        o = r(129),
        i = r(39);

    e.exports = function (e) {
      return n(e, i, o);
    };
  }, function (e, t) {
    var r = Object.prototype.hasOwnProperty;

    e.exports = function (e) {
      var t = e.length,
          n = new e.constructor(t);
      return t && "string" == typeof e[0] && r.call(e, "index") && (n.index = e.index, n.input = e.input), n;
    };
  }, function (e, t, r) {
    var n = r(79),
        o = r(327),
        i = r(328),
        a = r(329),
        c = r(123),
        u = "[object Boolean]",
        l = "[object Date]",
        s = "[object Map]",
        p = "[object Number]",
        f = "[object RegExp]",
        d = "[object Set]",
        b = "[object String]",
        y = "[object Symbol]",
        m = "[object ArrayBuffer]",
        v = "[object DataView]",
        h = "[object Float32Array]",
        g = "[object Float64Array]",
        w = "[object Int8Array]",
        O = "[object Int16Array]",
        j = "[object Int32Array]",
        P = "[object Uint8Array]",
        _ = "[object Uint8ClampedArray]",
        E = "[object Uint16Array]",
        S = "[object Uint32Array]";

    e.exports = function (e, t, r) {
      var C = e.constructor;

      switch (t) {
        case m:
          return n(e);

        case u:
        case l:
          return new C(+e);

        case v:
          return o(e, r);

        case h:
        case g:
        case w:
        case O:
        case j:
        case P:
        case _:
        case E:
        case S:
          return c(e, r);

        case s:
          return new C();

        case p:
        case b:
          return new C(e);

        case f:
          return i(e);

        case d:
          return new C();

        case y:
          return a(e);
      }
    };
  }, function (e, t, r) {
    var n = r(79);

    e.exports = function (e, t) {
      var r = t ? n(e.buffer) : e.buffer;
      return new e.constructor(r, e.byteOffset, e.byteLength);
    };
  }, function (e, t) {
    var r = /\w*$/;

    e.exports = function (e) {
      var t = new e.constructor(e.source, r.exec(e));
      return t.lastIndex = e.lastIndex, t;
    };
  }, function (e, t, r) {
    var n = r(30),
        o = n ? n.prototype : void 0,
        i = o ? o.valueOf : void 0;

    e.exports = function (e) {
      return i ? Object(i.call(e)) : {};
    };
  }, function (e, t, r) {
    var n = r(331),
        o = r(52),
        i = r(76),
        a = i && i.isMap,
        c = a ? o(a) : n;
    e.exports = c;
  }, function (e, t, r) {
    var n = r(53),
        o = r(25),
        i = "[object Map]";

    e.exports = function (e) {
      return o(e) && n(e) == i;
    };
  }, function (e, t, r) {
    var n = r(333),
        o = r(52),
        i = r(76),
        a = i && i.isSet,
        c = a ? o(a) : n;
    e.exports = c;
  }, function (e, t, r) {
    var n = r(53),
        o = r(25),
        i = "[object Set]";

    e.exports = function (e) {
      return o(e) && n(e) == i;
    };
  }, function (e, t, r) {
    var n = r(32);

    e.exports = function (e, t) {
      for (var r = -1, o = e.length, i = 0, a = []; ++r < o;) {
        var c = e[r],
            u = t ? t(c) : c;

        if (!r || !n(u, l)) {
          var l = u;
          a[i++] = 0 === c ? 0 : c;
        }
      }

      return a;
    };
  }, function (e, t, r) {
    var n = {
      "./addition_column.json": 86,
      "./blank_column.json": 87,
      "./calculation_operand.json": 336,
      "./calculation_operands/column_calculation_operand.json": 337,
      "./calculation_operands/constant_calculation_operand.json": 338,
      "./division_column.json": 88,
      "./if_column.json": 89,
      "./multiplication_column.json": 90,
      "./not_column.json": 91,
      "./or_column.json": 92,
      "./scalar_column.json": 84,
      "./subtraction_column.json": 93,
      "./unit_conversion_column.json": 83,
      "./unit_denominator_column.json": 339,
      "./unit_numerator_column.json": 340,
      "./units_column.json": 85
    };

    function o(e) {
      var t = i(e);
      return r(t);
    }

    function i(e) {
      if (!r.o(n, e)) {
        var t = new Error("Cannot find module '" + e + "'");
        throw t.code = "MODULE_NOT_FOUND", t;
      }

      return n[e];
    }

    o.keys = function () {
      return Object.keys(n);
    }, o.resolve = i, e.exports = o, o.id = 335;
  }, function (e) {
    e.exports = JSON.parse('{"anyOf":[{"$ref":"./calculation_operands/column_calculation_operand.json"},{"$ref":"./calculation_operands/constant_calculation_operand.json"}]}');
  }, function (e) {
    e.exports = JSON.parse('{"type":"object","properties":{"type":{"type":{"const":"ColumnCalculationOperand"}},"id":{"type":"string"}},"required":["type","id"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"type":"object","properties":{"type":{"type":{"const":"ConstantCalculationOperand"}},"value":{"type":["string","boolean"]}},"required":["type","value"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"type":"object","properties":{"type":{"const":"UnitDenominatorColumn"},"id":{"type":"string"},"position":{"type":"integer"},"is_showing":{"type":"boolean"},"name_override":{"type":"string"},"column_id":{"type":"string"}},"required":["type","id","position","is_showing","name_override","column_id"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"type":"object","properties":{"type":{"const":"UnitNumeratorColumn"},"id":{"type":"string"},"position":{"type":"integer"},"is_showing":{"type":"boolean"},"name_override":{"type":"string"},"column_id":{"type":"string"}},"required":["type","id","position","is_showing","name_override","column_id"],"additionalProperties":false}');
  }, function (e, t, r) {
    var n = r(17),
        o = r(342),
        i = r(81),
        a = r(104),
        c = n.isFinite,
        u = Math.min;

    e.exports = function (e) {
      var t = Math[e];
      return function (e, r) {
        if (e = i(e), (r = null == r ? 0 : u(o(r), 292)) && c(e)) {
          var n = (a(e) + "e").split("e"),
              l = t(n[0] + "e" + (+n[1] + r));
          return +((n = (a(l) + "e").split("e"))[0] + "e" + (+n[1] - r));
        }

        return t(e);
      };
    };
  }, function (e, t, r) {
    var n = r(128);

    e.exports = function (e) {
      var t = n(e),
          r = t % 1;
      return t == t ? r ? t - r : t : 0;
    };
  }, function (e, t, r) {
    (function (e, t) {
      !function (e, r) {
        "use strict";

        if (!e.setImmediate) {
          var n,
              o,
              i,
              a,
              c,
              u = 1,
              l = {},
              s = !1,
              p = e.document,
              f = Object.getPrototypeOf && Object.getPrototypeOf(e);
          f = f && f.setTimeout ? f : e, "[object process]" === {}.toString.call(e.process) ? n = function (e) {
            t.nextTick(function () {
              b(e);
            });
          } : !function () {
            if (e.postMessage && !e.importScripts) {
              var t = !0,
                  r = e.onmessage;
              return e.onmessage = function () {
                t = !1;
              }, e.postMessage("", "*"), e.onmessage = r, t;
            }
          }() ? e.MessageChannel ? ((i = new MessageChannel()).port1.onmessage = function (e) {
            b(e.data);
          }, n = function (e) {
            i.port2.postMessage(e);
          }) : p && "onreadystatechange" in p.createElement("script") ? (o = p.documentElement, n = function (e) {
            var t = p.createElement("script");
            t.onreadystatechange = function () {
              b(e), t.onreadystatechange = null, o.removeChild(t), t = null;
            }, o.appendChild(t);
          }) : n = function (e) {
            setTimeout(b, 0, e);
          } : (a = "setImmediate$" + Math.random() + "$", c = function (t) {
            t.source === e && "string" == typeof t.data && 0 === t.data.indexOf(a) && b(+t.data.slice(a.length));
          }, e.addEventListener ? e.addEventListener("message", c, !1) : e.attachEvent("onmessage", c), n = function (t) {
            e.postMessage(a + t, "*");
          }), f.setImmediate = function (e) {
            "function" != typeof e && (e = new Function("" + e));

            for (var t = new Array(arguments.length - 1), r = 0; r < t.length; r++) t[r] = arguments[r + 1];

            var o = {
              callback: e,
              args: t
            };
            return l[u] = o, n(u), u++;
          }, f.clearImmediate = d;
        }

        function d(e) {
          delete l[e];
        }

        function b(e) {
          if (s) setTimeout(b, 0, e);else {
            var t = l[e];

            if (t) {
              s = !0;

              try {
                !function (e) {
                  var t = e.callback,
                      n = e.args;

                  switch (n.length) {
                    case 0:
                      t();
                      break;

                    case 1:
                      t(n[0]);
                      break;

                    case 2:
                      t(n[0], n[1]);
                      break;

                    case 3:
                      t(n[0], n[1], n[2]);
                      break;

                    default:
                      t.apply(r, n);
                  }
                }(t);
              } finally {
                d(e), s = !1;
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === e ? this : e : self);
    }).call(this, r(65), r(97));
  }, function (e, t, r) {
    var n = r(130);

    function o(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    e.exports = function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? o(Object(r), !0).forEach(function (t) {
          n(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (e, t) {
    function r(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    e.exports = function (e, t, n) {
      return t && r(e.prototype, t), n && r(e, n), e;
    };
  }, function (e, t, r) {
    var n = r(348);

    e.exports = function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && n(e, t);
    };
  }, function (e, t) {
    function r(t, n) {
      return e.exports = r = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      }, r(t, n);
    }

    e.exports = r;
  }, function (e, t, r) {
    var n = r(350),
        o = r(351),
        i = r(352);

    e.exports = function (e) {
      var t = o();
      return function () {
        var r,
            o = n(e);

        if (t) {
          var a = n(this).constructor;
          r = Reflect.construct(o, arguments, a);
        } else r = o.apply(this, arguments);

        return i(this, r);
      };
    };
  }, function (e, t) {
    function r(t) {
      return e.exports = r = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, r(t);
    }

    e.exports = r;
  }, function (e, t) {
    e.exports = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    };
  }, function (e, t, r) {
    var n = r(131),
        o = r(353);

    e.exports = function (e, t) {
      return !t || "object" !== n(t) && "function" != typeof t ? o(e) : t;
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    };
  }, function (e, t, r) {
    var n = r(355),
        o = r(356),
        i = r(133),
        a = r(357);

    e.exports = function (e) {
      return n(e) || o(e) || i(e) || a();
    };
  }, function (e, t, r) {
    var n = r(132);

    e.exports = function (e) {
      if (Array.isArray(e)) return n(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    };
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    };
  }, function (e, t, r) {
    var n = r(359),
        o = r(360),
        i = r(133),
        a = r(361);

    e.exports = function (e, t) {
      return n(e) || o(e, t) || i(e, t) || a();
    };
  }, function (e, t) {
    e.exports = function (e) {
      if (Array.isArray(e)) return e;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
        var r = [],
            n = !0,
            o = !1,
            i = void 0;

        try {
          for (var a, c = e[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0);
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            n || null == c.return || c.return();
          } finally {
            if (o) throw i;
          }
        }

        return r;
      }
    };
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    };
  }, function (e, t, r) {
    var n = r(363);

    e.exports = function (e, t) {
      if (null == e) return {};
      var r,
          o,
          i = n(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (o = 0; o < a.length; o++) r = a[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
      }

      return i;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if (null == e) return {};
      var r,
          n,
          o = {},
          i = Object.keys(e);

      for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);

      return o;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(t)
        }
      }));
    };
  }, function (e, t) {
    function r() {
      return e.exports = r = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }

        return e;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, r.apply(this, arguments);
    }

    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    "use strict";

    e.exports = r(367);
  }, function (e, t, r) {
    "use strict";
    /** @license React v16.13.1
     * react-is.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var n = "function" == typeof Symbol && Symbol.for,
        o = n ? Symbol.for("react.element") : 60103,
        i = n ? Symbol.for("react.portal") : 60106,
        a = n ? Symbol.for("react.fragment") : 60107,
        c = n ? Symbol.for("react.strict_mode") : 60108,
        u = n ? Symbol.for("react.profiler") : 60114,
        l = n ? Symbol.for("react.provider") : 60109,
        s = n ? Symbol.for("react.context") : 60110,
        p = n ? Symbol.for("react.async_mode") : 60111,
        f = n ? Symbol.for("react.concurrent_mode") : 60111,
        d = n ? Symbol.for("react.forward_ref") : 60112,
        b = n ? Symbol.for("react.suspense") : 60113,
        y = n ? Symbol.for("react.suspense_list") : 60120,
        m = n ? Symbol.for("react.memo") : 60115,
        v = n ? Symbol.for("react.lazy") : 60116,
        h = n ? Symbol.for("react.block") : 60121,
        g = n ? Symbol.for("react.fundamental") : 60117,
        w = n ? Symbol.for("react.responder") : 60118,
        O = n ? Symbol.for("react.scope") : 60119;

    function j(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case o:
            switch (e = e.type) {
              case p:
              case f:
              case a:
              case u:
              case c:
              case b:
                return e;

              default:
                switch (e = e && e.$$typeof) {
                  case s:
                  case d:
                  case v:
                  case m:
                  case l:
                    return e;

                  default:
                    return t;
                }

            }

          case i:
            return t;
        }
      }
    }

    function P(e) {
      return j(e) === f;
    }

    t.AsyncMode = p, t.ConcurrentMode = f, t.ContextConsumer = s, t.ContextProvider = l, t.Element = o, t.ForwardRef = d, t.Fragment = a, t.Lazy = v, t.Memo = m, t.Portal = i, t.Profiler = u, t.StrictMode = c, t.Suspense = b, t.isAsyncMode = function (e) {
      return P(e) || j(e) === p;
    }, t.isConcurrentMode = P, t.isContextConsumer = function (e) {
      return j(e) === s;
    }, t.isContextProvider = function (e) {
      return j(e) === l;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === o;
    }, t.isForwardRef = function (e) {
      return j(e) === d;
    }, t.isFragment = function (e) {
      return j(e) === a;
    }, t.isLazy = function (e) {
      return j(e) === v;
    }, t.isMemo = function (e) {
      return j(e) === m;
    }, t.isPortal = function (e) {
      return j(e) === i;
    }, t.isProfiler = function (e) {
      return j(e) === u;
    }, t.isStrictMode = function (e) {
      return j(e) === c;
    }, t.isSuspense = function (e) {
      return j(e) === b;
    }, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === a || e === f || e === u || e === c || e === b || e === y || "object" == typeof e && null !== e && (e.$$typeof === v || e.$$typeof === m || e.$$typeof === l || e.$$typeof === s || e.$$typeof === d || e.$$typeof === g || e.$$typeof === w || e.$$typeof === O || e.$$typeof === h);
    }, t.typeOf = j;
  }, function (e, t, r) {
    "use strict";

    r.r(t), r.d(t, "ProductsApi", function () {
      return $r;
    }), r.d(t, "ProductApplicationErrorMessagesModel", function () {
      return qHe;
    }), r.d(t, "ProductSelectModel", function () {
      return Zn;
    }), r.d(t, "ResultsPage", function () {
      return xv;
    }), r.d(t, "withAccountNav", function () {
      return CX;
    }), r.d(t, "AccountsTreeModel", function () {
      return as;
    }), r.d(t, "AccountNodeControls", function () {
      return Al;
    }), r.d(t, "AccountTreeNav", function () {
      return fl;
    }), r.d(t, "CheckAllDropdown", function () {
      return roe;
    }), r.d(t, "OverrideEditor", function () {
      return KWe;
    }), r.d(t, "OverrideModal", function () {
      return RWe;
    }), r.d(t, "PaginationNav", function () {
      return Bie;
    }), r.d(t, "ProductSelector", function () {
      return lo;
    });
    var n = {};
    r.r(n), r.d(n, "AccountContacts", function () {
      return Xt;
    }), r.d(n, "AccountProductPriceManager", function () {
      return pl;
    }), r.d(n, "AccountSelector", function () {
      return ys;
    }), r.d(n, "AccountTreeNodeContent", function () {
      return Cl;
    }), r.d(n, "AccountTreeNodeContentWithBadge", function () {
      return Ps;
    }), r.d(n, "ActionButtons", function () {
      return xs;
    }), r.d(n, "ActiveIngredientForm", function () {
      return Pp;
    }), r.d(n, "ApplicatorCard", function () {
      return zf;
    }), r.d(n, "ApplicatorEditor", function () {
      return ed;
    }), r.d(n, "ApplicatorEditorModal", function () {
      return gd;
    }), r.d(n, "BlockAccounting", function () {
      return ej;
    }), r.d(n, "CheckableTreeNodeControls", function () {
      return nj;
    }), r.d(n, "Checkbox", function () {
      return oj.a;
    }), r.d(n, "CheckboxWithLabel", function () {
      return rd.a;
    }), r.d(n, "CopyToClipboardButton", function () {
      return Sj;
    }), r.d(n, "CropsSelector", function () {
      return zP;
    }), r.d(n, "Dashboard", function () {
      return jC;
    }), r.d(n, "DatePicker", function () {
      return Bu;
    }), r.d(n, "DateRangeSelector", function () {
      return mg;
    }), r.d(n, "EditableTitle", function () {
      return LC;
    }), r.d(n, "EmailListManager", function () {
      return fk;
    }), r.d(n, "ErrorBoundary", function () {
      return mf;
    }), r.d(n, "ExpandToggle", function () {
      return DE;
    }), r.d(n, "FieldSelector", function () {
      return FR;
    }), r.d(n, "FilterModal", function () {
      return Kg;
    }), r.d(n, "FlexReportBuilder", function () {
      return HQ;
    }), r.d(n, "FormGridInput", function () {
      return Xs;
    }), r.d(n, "FormGridLabel", function () {
      return Ws;
    }), r.d(n, "FormRow", function () {
      return Ls;
    }), r.d(n, "LicensedApplicatorEditor", function () {
      return wX;
    }), r.d(n, "LinkDropdownToggle", function () {
      return KB;
    }), r.d(n, "BlocksCell", function () {
      return lE;
    }), r.d(n, "CropRowEntry", function () {
      return R_;
    }), r.d(n, "FieldColumn", function () {
      return N_;
    }), r.d(n, "FieldColumns", function () {
      return $_;
    }), r.d(n, "FieldRowEntry", function () {
      return P_;
    }), r.d(n, "RowEntry", function () {
      return v_;
    }), r.d(n, "RowEntryRenderer", function () {
      return V_;
    }), r.d(n, "ListManager", function () {
      return dp;
    }), r.d(n, "ManageAccounts", function () {
      return IX;
    }), r.d(n, "ManageActiveIngredients", function () {
      return xZ;
    }), r.d(n, "ManageProducts", function () {
      return u0;
    }), r.d(n, "MarkdownViewer", function () {
      return g0;
    }), r.d(n, "MultiSelectDropdown", function () {
      return wP;
    }), r.d(n, "NavigationSideBarContainer", function () {
      return S0;
    }), r.d(n, "OrganicCertificateComponent", function () {
      return t1;
    }), r.d(n, "NewApplicationManager", function () {
      return h8;
    }), r.d(n, "NewReportButton", function () {
      return D8;
    }), r.d(n, "PdfButton", function () {
      return L8;
    }), r.d(n, "PercentageDial", function () {
      return $E;
    }), r.d(n, "ProductForm", function () {
      return yte;
    }), r.d(n, "ProductPriceEditor", function () {
      return Zu;
    }), r.d(n, "ProductUseReportsFilter", function () {
      return one;
    }), r.d(n, "ProductUseReportsNav", function () {
      return kne;
    }), r.d(n, "ProgressBar", function () {
      return Gne;
    }), r.d(n, "QuantityField", function () {
      return Ic;
    }), r.d(n, "RadioBtnGroup", function () {
      return Mk;
    }), r.d(n, "ReadOnlyTreeNodeContent", function () {
      return hl;
    }), r.d(n, "RecommendationList", function () {
      return loe;
    }), r.d(n, "RecommendationRow", function () {
      return ZS;
    }), r.d(n, "RecommendationsDashboard", function () {
      return iae;
    }), r.d(n, "RecommendationSelector", function () {
      return Iae;
    }), r.d(n, "ReportsManager", function () {
      return zxe;
    }), r.d(n, "ReviewProducts", function () {
      return Vxe;
    }), r.d(n, "RoleAssignment", function () {
      return sIe;
    }), r.d(n, "RoleAssignmentTable", function () {
      return TFe;
    }), r.d(n, "RoleForm", function () {
      return fBe;
    }), r.d(n, "SearchBox", function () {
      return TBe;
    }), r.d(n, "SearchDropdown", function () {
      return Bn;
    }), r.d(n, "SelectDropdown", function () {
      return VBe;
    }), r.d(n, "SprayRecordAccountsSelector", function () {
      return yLe;
    }), r.d(n, "SprayRecordFieldsCard", function () {
      return cVe;
    }), r.d(n, "SprayRecordFieldsEditor", function () {
      return YUe;
    }), r.d(n, "SprayRecordList", function () {
      return cqe;
    }), r.d(n, "SprayRecordMarkCompleteForm", function () {
      return qKe;
    }), r.d(n, "SprayRecordNotes", function () {
      return fGe;
    }), r.d(n, "SprayRecordPrintedMap", function () {
      return JGe;
    }), r.d(n, "SprayRecordProductsEditorIndex", function () {
      return EJe;
    }), r.d(n, "SprayRecordRow", function () {
      return yS;
    }), r.d(n, "SprayRecordsDashboard", function () {
      return xJe;
    }), r.d(n, "SprayRecordsStoreInitializer", function () {
      return LJe;
    }), r.d(n, "TeamEditor", function () {
      return _Ye;
    }), r.d(n, "TimeInput", function () {
      return M1;
    }), r.d(n, "UnitSelector", function () {
      return Bf;
    }), r.d(n, "UnsortedListManager", function () {
      return rk;
    }), r.d(n, "PageTitleWithIcon", function () {
      return UO;
    });
    var o = {};
    r.r(o), r.d(o, "AccountNodeControls", function () {
      return Al;
    }), r.d(o, "AccountTreeNav", function () {
      return fl;
    }), r.d(o, "CheckAllDropdown", function () {
      return roe;
    }), r.d(o, "OverrideEditor", function () {
      return KWe;
    }), r.d(o, "OverrideModal", function () {
      return RWe;
    }), r.d(o, "PaginationNav", function () {
      return Bie;
    }), r.d(o, "ProductSelector", function () {
      return lo;
    });
    r(214);
    var i,
        a,
        c,
        u,
        l = r(19),
        s = r(0),
        p = r.n(s),
        f = r(1),
        d = r(2),
        b = r(42),
        y = r.n(b),
        m = r(7),
        v = r.n(m),
        h = (r(215), r(4)),
        g = r(213),
        w = r(3);

    function O(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function j(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, P(n.key), n);
      }
    }

    function P(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function _(e, t, r) {
      return t = E(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], E(e).constructor) : t.apply(e, r));
    }

    function E(e) {
      return (E = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function S(e, t) {
      return (S = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function C(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var k = Object(d.observer)((c = C((a = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = _(this, t, [].concat(n))).showContact = function (t) {
          var r = e.props,
              n = r.account;
          (0, r.onShowContact)(n.findContact(t));
        }, e.sortByLastName = function (e, t) {
          return Object(h.genericSort)(e.lastName.toLowerCase(), t.lastName.toLowerCase());
        }, O(e, "newAccountPending", c, e), O(e, "newContactsPending", u, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && S(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && j(e.prototype, t), r && j(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "status",
        get: function () {
          return this.newAccountPending || this.newContactsPending ? "pending" : "ready";
        }
      }, {
        key: "sortedContacts",
        get: function () {
          var e = this.props.account;
          return e && e.contacts.slice().sort(this.sortByLastName) || [];
        }
      }, {
        key: "accountUuid",
        get: function () {
          var e = this.props.account;
          return e && e.id || "";
        }
      }, {
        key: "filteredContacts",
        get: function () {
          var e = this.props.searchTerm;
          return e ? this.sortedContacts.filter(function (t) {
            return t.fullText.toLowerCase().includes(e.toLowerCase());
          }) : this.sortedContacts;
        }
      }, {
        key: "apiContactsPath",
        get: function () {
          var e = this.props.account;
          return new URL("contacts", "".concat(e.apiUrl, "/")).toString();
        }
      }, {
        key: "apiAccountPath",
        value: function (e) {
          var t = this.props.apiUrlBase;
          return new URL(e, t).toString();
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = this,
              t = this.props,
              r = t.account,
              n = t.onNewAccount,
              o = t.onNewContacts;
          this.newContactsPending = !0, fetch(this.apiContactsPath).then(function (t) {
            return e.newContactsPending = !1, t.json();
          }).then(function (e) {
            return o(r.id, e);
          }).catch(function (t) {
            console.log(t), e.newAccountPending = !1;
          }), r.parent_id && (this.newAccountPending = !0, fetch(this.apiAccountPath(r.parent_id)).then(function (t) {
            return e.newAccountPending = !1, t.json();
          }).then(function (e) {
            return n(e);
          }).catch(function (t) {
            console.log(t), e.newAccountPending = !1;
          }));
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              r = this.props,
              n = r.account,
              o = r.t,
              i = r.accountContactPath,
              a = r.newUserPath,
              c = r.editUsers;
          return s.createElement(s.Fragment, null, this.filteredContacts.length ? s.createElement("div", {
            className: "contacts-table-wrapper"
          }, s.createElement("h4", {
            className: "mt-4"
          }, o("account_contacts", {
            account: n
          })), s.createElement(h.ContactsTable, {
            contacts: this.filteredContacts,
            contactButtons: function (t) {
              return s.createElement(s.Fragment, null, s.createElement("a", {
                role: "button",
                className: "btn btn-outline-success btn-sm mr-1",
                href: "".concat(i, "/").concat(t.serial)
              }, o("view_contact")), c && !t.userId ? s.createElement("a", {
                role: "button",
                className: "btn btn-outline-success btn-sm mr-1",
                href: "".concat(a, "?contact_id=").concat(t.serial)
              }, o("create_user")) : null, s.createElement("button", {
                type: "button",
                className: "btn btn-outline-primary btn-sm mr-1",
                onClick: function () {
                  return e.showContact(t.id);
                }
              }, o("more")));
            }
          })) : null, n.parent && n.organization_root_id == n.parent.organization_root_id ? s.createElement(t, Object.assign({}, this.props, {
            account: n.parent
          })) : null, "pending" === this.status ? s.createElement(h.Spinner, null) : null);
        }
      }]);
    }()).prototype, "newAccountPending", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), u = C(a.prototype, "newContactsPending", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), C(a.prototype, "status", [f.computed], Object.getOwnPropertyDescriptor(a.prototype, "status"), a.prototype), C(a.prototype, "sortedContacts", [f.computed], Object.getOwnPropertyDescriptor(a.prototype, "sortedContacts"), a.prototype), C(a.prototype, "accountUuid", [f.computed], Object.getOwnPropertyDescriptor(a.prototype, "accountUuid"), a.prototype), C(a.prototype, "filteredContacts", [f.computed], Object.getOwnPropertyDescriptor(a.prototype, "filteredContacts"), a.prototype), C(a.prototype, "apiContactsPath", [f.computed], Object.getOwnPropertyDescriptor(a.prototype, "apiContactsPath"), a.prototype), i = a)) || i,
        R = Object(g.a)()(k);

    function T(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, z(n.key), n);
      }
    }

    function z(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var N = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.apiPath = "/if2/api/accounts/", this.accountsPath = t || "/if2/accounts/";
      }, (t = [{
        key: "childrenOf",
        value: function (e) {
          return fetch("".concat(this.apiPath, "/").concat(e, "/children").replace("//", "/")).then(function (e) {
            return e.json();
          });
        }
      }, {
        key: "descendantsOf",
        value: function (e) {
          return fetch("".concat(this.apiPath, "/").concat(e, "/descendants").replace("//", "/")).then(function (e) {
            return e.json();
          });
        }
      }, {
        key: "ancestorsWithContextOf",
        value: function (e) {
          return fetch("".concat(this.apiPath, "/").concat(e, "/ancestors_with_context").replace("//", "/")).then(function (e) {
            return e.json();
          });
        }
      }, {
        key: "fetch",
        value: function (e) {
          function t(t) {
            return e.apply(this, arguments);
          }

          return t.toString = function () {
            return e.toString();
          }, t;
        }(function (e) {
          return fetch("".concat(this.apiPath, "/").concat(e).replace("//", "/")).then(function (e) {
            return e.json();
          });
        })
      }]) && T(e.prototype, t), r && T(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }(),
        D = r(41),
        x = r(6),
        A = r(8),
        M = r.n(A),
        I = (r(137), r(24)),
        F = r.n(I),
        B = ["isStatic", "decorate"];

    function L(e) {
      return function (e) {
        if (Array.isArray(e)) return V(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return V(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? V(e, t) : void 0;
        }
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function V(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function U(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Y(n.key), n);
      }
    }

    function q(e, t, r) {
      return t = G(t), K(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], G(e).constructor) : t.apply(e, r));
    }

    function K(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function G(e) {
      return (G = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function W(e, t) {
      return (W = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function H(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function J(e, t, r) {
      return (t = Y(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Y(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var Q = function (e, t) {
      return Object(h.genericSort)(e.toLowerCase(), t.toLowerCase());
    },
        X = function (e, t, r) {
      var n = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? H(Object(r), !0).forEach(function (t) {
            J(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : H(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }

        return e;
      }({
        base: Object,
        mixins: [],
        superArgs: function () {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

          return t;
        }
      }, t || {}),
          o = n.base,
          i = n.mixins,
          a = n.superArgs,
          c = J({}, e, function (e) {
        function t() {
          var e;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          for (var n = arguments.length, o = new Array(n), i = 0; i < n; i++) o[i] = arguments[i];

          return e = q(this, t, L(a.apply(void 0, o))), r ? (r.call.apply(r, [e].concat(o)), e) : K(e);
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && W(e, t);
        }(t, o || Object), n = t, i && U(n.prototype, i), c && U(n, c), Object.defineProperty(n, "prototype", {
          writable: !1
        }), n;
        var n, i, c;
      }())[e];

      return i.forEach(function (e) {
        Object.keys(e).forEach(function (t) {
          var r = e[t],
              n = r.isStatic,
              o = r.decorate,
              i = function (e, t) {
            if (null == e) return {};

            var r,
                n,
                o = function (e, t) {
              if (null == e) return {};
              var r = {};

              for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
                if (t.includes(n)) continue;
                r[n] = e[n];
              }

              return r;
            }(e, t);

            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);

              for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
            }

            return o;
          }(r, B);

          n ? Object.defineProperty(c, t, i) : Object.defineProperty(c.prototype, t, i), o && Object(f.decorate)(c, J({}, t, o));
        });
      }), Object.defineProperty(c, "name", {
        value: e
      }), c;
    },
        Z = function (e, t, r) {
      var n = document.createElement("a"),
          o = r || "text/plain";
      n.setAttribute("href", "data:".concat(o, ";charset=utf-8,").concat(encodeURIComponent(e))), n.setAttribute("download", t), n.style.display = "none", document.body.appendChild(n), n.click(), document.body.removeChild(n);
    },
        ee = function (e) {
      return L(new Set(e));
    },
        te = function (e, t, r, n) {
      var o = n ? t : e;
      if (!o && 0 !== o) return r;

      try {
        o = F()(o).scalar;
      } catch (e) {
        if (!(e instanceof F.a.Error)) throw e;
        o = r;
      }

      return o;
    },
        re = function (e) {
      return Object.keys(e).reduce(function (t, r) {
        return null != e[r] && (t[r] = e[r]), t;
      }, {});
    },
        ne = function (e) {
      if (e.length < 2) return e[0] || "";
      var t = [].concat(e.slice(0, -2).join(", ") || []),
          r = e.slice(-2),
          n = t.length ? r.join(", and ") : r.join(" and ");
      return t.concat(n).join(", ");
    },
        oe = function (e) {
      return e && 0 != e.length ? M()(e, "HH:mm:ss").format("h:mm A") : "";
    },
        ie = function (e, t) {
      return Object(h.naturalSort)(t, e);
    };

    function ae(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ue(n.key), n);
      }
    }

    function ce(e, t, r) {
      return t && ae(e.prototype, t), r && ae(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function ue(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var le = ce(function e(t) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.name = t.name || "", this.key = t.key || "", this.serializedKey = t.serializedKey || this.key.replace(/([A-Z])/g, function (e) {
        return "_".concat(e.toLowerCase());
      }), this.type = t.type || "string", this.isReadonly = t.isReadonly || !1, this.shouldNotSerialize = t.shouldNotSerialize || !1, this.defaultValue = null === t.defaultValue ? null : t.defaultValue || "boolean" !== this.type && "", this.filterType = t.filterType || "";
    });

    function se(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function pe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? se(Object(r), !0).forEach(function (t) {
          fe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : se(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function fe(e, t, r) {
      return (t = be(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function de(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, be(n.key), n);
      }
    }

    function be(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ye(e, t, r) {
      return t = me(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], me(e).constructor) : t.apply(e, r));
    }

    function me(e) {
      return (me = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ve(e, t) {
      return (ve = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var he = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = ye(this, t, [pe({
          type: "array",
          defaultValue: []
        }, e || {})])).elementSpec = e.elementSpec, r.defaultAccessor = pe(pe({}, r.elementSpec.defaultAccessor), {}, {
          path: [].concat(r.key, r.elementSpec.defaultAccessor.path)
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ve(e, t);
      }(t, le), r = t, n && de(r.prototype, n), o && de(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function ge(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function we(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ge(Object(r), !0).forEach(function (t) {
          Oe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ge(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Oe(e, t, r) {
      return (t = Pe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function je(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Pe(n.key), n);
      }
    }

    function Pe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function _e(e, t, r) {
      return t = Ee(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Ee(e).constructor) : t.apply(e, r));
    }

    function Ee(e) {
      return (Ee = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Se(e, t) {
      return (Se = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Ce = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = _e(this, t, [we({
          type: "object",
          defaultValue: {}
        }, e || {})])).modelSpec = e.modelSpec, r.defaultAccessor = we(we({}, r.modelSpec.defaultAccessor), {}, {
          path: [].concat(r.key, r.modelSpec.defaultAccessor.path)
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Se(e, t);
      }(t, le), r = t, n && je(r.prototype, n), o && je(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function ke(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Re(n.key), n);
      }
    }

    function Re(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var Te,
        ze,
        Ne = function () {
      return e = function e(t) {
        var r = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.attributes = [], this.defaults = {}, this.defaultKey = "name", this.accessorsForAttribute = function (e) {
          var t = function (e, t) {
            return {
              path: t,
              attribute: e
            };
          },
              n = function (e, n) {
            return [t(n, [n.key]), e.accessors.map(function (e) {
              return r.descendantAccessor(e, n.key);
            })];
          };

          return e ? Object(x.ifElse)(Object(x.is)(he), function (e) {
            return n(e.elementSpec, e);
          }, Object(x.ifElse)(Object(x.is)(Ce), function (e) {
            return n(e.modelSpec, e);
          }, function (e) {
            return t(e, [e.key]);
          }))(e) : {
            path: [],
            attribute: e
          };
        }, this.accessorsForKey = function (e) {
          return r.accessorsForAttribute(r.findAttribute(e));
        }, this.descendantAccessor = function (e, t) {
          return {
            path: [t].concat(e.path),
            attribute: e.attribute
          };
        }, this.attributes = t.attributes || [], this.attributes.filter(function (e) {
          return !e.isReadonly;
        }).forEach(function (e) {
          return r.defaults[e.key] = e.defaultValue;
        }), this.defaultKey = t.defaultKey || "name";
      }, (t = [{
        key: "findAttribute",
        value: function (e) {
          return Array.isArray(this.attributes) && this.attributes.find(function (t) {
            return [t.key, t.serializedKey].includes(e);
          }) || void 0;
        }
      }, {
        key: "accessors",
        get: function () {
          return Object(x.flatten)(Object(x.map)(this.accessorsForAttribute, this.attributes));
        }
      }, {
        key: "defaultAccessor",
        get: function () {
          var e = this;
          return Object(x.ifElse)(function (e) {
            return Object(x.is)(he, Object(x.prop)("attribute", e));
          }, function (t) {
            return e.descendantAccessor(t.attribute.elementSpec.defaultAccessor, t.attribute.key);
          }, Object(x.ifElse)(function (e) {
            return Object(x.is)(Ce, Object(x.prop)("attribute", e));
          }, function (t) {
            return e.descendantAccessor(t.attribute.modelSpec.defaultAccessor, t.attribute.key);
          }, x.identity))(Object(x.head)(Object(x.flatten)([this.accessorsForKey(this.defaultKey)])));
        }
      }]) && ke(e.prototype, t), r && ke(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function De(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function xe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? De(Object(r), !0).forEach(function (t) {
          Ae(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : De(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Ae(e, t, r) {
      return (t = Ie(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Me(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ie(n.key), n);
      }
    }

    function Ie(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Fe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Be = ((ze = function () {
      function e(t) {
        var r = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), t ? this.update(xe(xe({}, this.constructor.spec.defaults), this.unmarshall(t || {}))) : this.update(this.constructor.spec.defaults), Object.keys(this.constructor.spec.defaults).forEach(function (e) {
          Object(f.decorate)(r, Ae({}, e, f.observable));
        });
      }

      return t = e, (r = [{
        key: "attributes",
        get: function () {
          var e = this;
          return this.constructor.spec.attributes.map(function (t) {
            return {
              key: t.key,
              value: e[t.key],
              spec: t
            };
          });
        }
      }, {
        key: "serialize",
        value: function () {
          var e = {};
          return this.attributes.forEach(function (t) {
            t.spec.shouldNotSerialize || (e[t.spec.serializedKey] = t.value && "function" == typeof t.value.serialize ? t.value.serialize() : t.value);
          }), e;
        }
      }, {
        key: "unmarshall",
        value: function (e) {
          var t = this,
              r = {};
          return Object.keys(e).forEach(function (n) {
            var o = t.constructor.spec.findAttribute(n);
            o && (r[o.key] = e[n]);
          }), r;
        }
      }, {
        key: "update",
        value: function (e) {
          var t = this,
              r = this.unmarshall(e || {});
          return Object.keys(r).forEach(function (e) {
            t.updateAttribute(e, r[e]);
          }), this;
        }
      }, {
        key: "updateAttribute",
        value: function (t, r) {
          return this[t] instanceof e ? this[t].update(r) : (this[t] = r || (0 === r ? 0 : this.constructor.spec.findAttribute(t).defaultValue), this[t]);
        }
      }]) && Me(t.prototype, r), n && Me(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), t;
      var t, r, n;
    }()).spec = new Ne({}), Fe((Te = ze).prototype, "attributes", [f.computed], Object.getOwnPropertyDescriptor(Te.prototype, "attributes"), Te.prototype), Fe(Te.prototype, "update", [f.action], Object.getOwnPropertyDescriptor(Te.prototype, "update"), Te.prototype), Fe(Te.prototype, "updateAttribute", [f.action], Object.getOwnPropertyDescriptor(Te.prototype, "updateAttribute"), Te.prototype), Te);

    function Le(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ve(n.key), n);
      }
    }

    function Ve(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Ue(e, t, r) {
      return t = qe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], qe(e).constructor) : t.apply(e, r));
    }

    function qe(e) {
      return (qe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Ke(e, t) {
      return (Ke = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Ge,
        We,
        He,
        Je,
        Ye,
        Qe,
        $e,
        Xe,
        Ze,
        et = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Ue(this, t, [{
          defaultKey: "name",
          attributes: [new le({
            name: "ID",
            key: "id"
          }), new le({
            name: "Serial",
            key: "serial"
          }), new le({
            name: "Name",
            key: "name"
          }), new le({
            name: "Full Name",
            key: "fullName"
          })]
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ke(e, t);
      }(t, Ne), r = t, n && Le(r.prototype, n), o && Le(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }(),
        tt = {
      updateCollectionAttribute: {
        value: function (e, t, r, n, o) {
          var i = Array.isArray(n) ? n : [];
          if (this[r] instanceof e) return this[r].updateItems(i), this[r];
          var a = {
            items: i
          };
          return o && (a.key = o), this[r] = new e(t, a), this[r];
        }
      },
      updateModelAttribute: {
        value: function (e, t, r) {
          return r ? this[t] instanceof e ? this[t].update(r) : (this[t] = new e(r), this[t]) : (this[t] = void 0, this[t]);
        }
      }
    },
        rt = X("AccountReference", {
      base: Be,
      mixins: [tt, {
        spec: {
          value: new et(),
          isStatic: !0
        },
        fromAccount: {
          isStatic: !0,
          value: function (e) {
            return new rt({
              id: e.id,
              serial: e.serial,
              name: e.name
            });
          }
        }
      }]
    }),
        nt = rt;

    function ot(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function it(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, at(n.key), n);
      }
    }

    function at(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ct(e, t, r) {
      return t = pt(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], pt(e).constructor) : t.apply(e, r));
    }

    function ut(e, t, r, n) {
      var o = lt(pt(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function lt() {
      return (lt = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = st(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function st(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = pt(e)););

      return e;
    }

    function pt(e) {
      return (pt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ft(e, t) {
      return (ft = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function dt(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var bt,
        yt,
        mt,
        vt,
        ht,
        gt,
        wt = (We = dt((Ge = function (e) {
      function t(e, r, n) {
        var o;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), ot(o = ct(this, t, [e, r, n]), "state", We, o), ot(o, "lastError", He, o), ot(o, "currentUserId", Je, o), ot(o, "isChecked", Ye, o), ot(o, "accessLevel", Qe, o), ot(o, "users", $e, o), ot(o, "clientPath", Xe, o), ot(o, "fields", Ze, o), o.currentUserId = n;
        var i = o.users.findIndex(function (e) {
          return e.id === o.currentUserId;
        });
        return o.isChecked = o.isParentChecked() || -1 !== i, o.accessLevel = -1 !== i && o.users[i].role || "", o.initializeChildrenChecked(o.isChecked), r.is_open && (o.isCollapsed = !1), o;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ft(e, t);
      }(t, h["AccountModel"]), r = t, (n = [{
        key: "apiUrl",
        get: function () {
          var e = new URL(this.accountsStore.accountsApi.apiPath, window.location.origin);
          return new URL(this.id, e).toString();
        }
      }, {
        key: "url",
        get: function () {
          var e = new URL(this.accountsStore.accountsApi.accountsPath, window.location.origin);
          return e.searchParams.set("uuid", this.id), e.toString();
        }
      }, {
        key: "inheritedAccessLevel",
        get: function () {
          return this.nearestAncestorAccessLevel();
        }
      }, {
        key: "isDisabled",
        get: function () {
          return this.isParentChecked();
        }
      }, {
        key: "clientPathString",
        get: function () {
          var e = this;
          return this.clientPath.filter(function (t) {
            return t.id !== e.id;
          }).map(function (e) {
            return e.name;
          }).concat(this.name || []).join(": ");
        }
      }, {
        key: "isParentChecked",
        value: function () {
          var e = this.parent;
          return e && e.isChecked || !1;
        }
      }, {
        key: "nearestAncestorAccessLevel",
        value: function () {
          var e = this.parent;
          return e && e.accessLevel ? e.accessLevel : e ? e.nearestAncestorAccessLevel() : "";
        }
      }, {
        key: "setChildrenChecked",
        value: function (e) {
          this.children.forEach(function (t) {
            t.isChecked = e, t.setChildrenChecked(e);
          });
        }
      }, {
        key: "initializeChildrenChecked",
        value: function (e) {
          this.children.forEach(function (t) {
            null == t.isChecked && (t.isChecked = e), t.initializeChildrenChecked(e);
          });
        }
      }, {
        key: "setAccessLevel",
        value: function (e) {
          this.accessLevel = e;
        }
      }, {
        key: "toggleChecked",
        value: function () {
          this.isDisabled || (this.isChecked = !this.isChecked, this.setChildrenChecked(this.isChecked));
        }
      }, {
        key: "toggleCollapsed",
        value: function () {
          this.isCollapsed && this.updateChildren(), ut(t, "toggleCollapsed", this, 3)([]);
        }
      }, {
        key: "update",
        value: function (e) {
          ut(t, "update", this, 3)([e]), this.users = Array.isArray(e.users) ? e.users : this.users;
          var r = Array.isArray(e.client_path) && e.client_path || Array.isArray(e.clientPath) && e.clientPath;
          this.clientPath = r && r.map(function (e) {
            return nt.fromAccount(e);
          }) || this.clientPath, this.fields = e.fields || [];
        }
      }, {
        key: "updateChildren",
        value: function () {
          return this.accountsStore.updateChildrenOf(this.id);
        }
      }, {
        key: "expand",
        value: function () {
          return this.isCollapsed = !1, this.updateChildren();
        }
      }]) && it(r.prototype, n), o && it(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "state", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "ready";
      }
    }), He = dt(Ge.prototype, "lastError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Je = dt(Ge.prototype, "currentUserId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Ye = dt(Ge.prototype, "isChecked", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Qe = dt(Ge.prototype, "accessLevel", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), $e = dt(Ge.prototype, "users", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), Xe = dt(Ge.prototype, "clientPath", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), Ze = dt(Ge.prototype, "fields", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), dt(Ge.prototype, "apiUrl", [f.computed], Object.getOwnPropertyDescriptor(Ge.prototype, "apiUrl"), Ge.prototype), dt(Ge.prototype, "url", [f.computed], Object.getOwnPropertyDescriptor(Ge.prototype, "url"), Ge.prototype), dt(Ge.prototype, "inheritedAccessLevel", [f.computed], Object.getOwnPropertyDescriptor(Ge.prototype, "inheritedAccessLevel"), Ge.prototype), dt(Ge.prototype, "isDisabled", [f.computed], Object.getOwnPropertyDescriptor(Ge.prototype, "isDisabled"), Ge.prototype), dt(Ge.prototype, "clientPathString", [f.computed], Object.getOwnPropertyDescriptor(Ge.prototype, "clientPathString"), Ge.prototype), dt(Ge.prototype, "setChildrenChecked", [f.action], Object.getOwnPropertyDescriptor(Ge.prototype, "setChildrenChecked"), Ge.prototype), dt(Ge.prototype, "initializeChildrenChecked", [f.action], Object.getOwnPropertyDescriptor(Ge.prototype, "initializeChildrenChecked"), Ge.prototype), dt(Ge.prototype, "setAccessLevel", [f.action], Object.getOwnPropertyDescriptor(Ge.prototype, "setAccessLevel"), Ge.prototype), dt(Ge.prototype, "toggleChecked", [f.action], Object.getOwnPropertyDescriptor(Ge.prototype, "toggleChecked"), Ge.prototype), dt(Ge.prototype, "toggleCollapsed", [f.action], Object.getOwnPropertyDescriptor(Ge.prototype, "toggleCollapsed"), Ge.prototype), dt(Ge.prototype, "update", [f.action], Object.getOwnPropertyDescriptor(Ge.prototype, "update"), Ge.prototype), dt(Ge.prototype, "updateChildren", [f.action], Object.getOwnPropertyDescriptor(Ge.prototype, "updateChildren"), Ge.prototype), dt(Ge.prototype, "expand", [f.action], Object.getOwnPropertyDescriptor(Ge.prototype, "expand"), Ge.prototype), Ge);

    function Ot(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function jt(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Pt(n.key), n);
      }
    }

    function Pt(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function _t(e, t, r) {
      return t = Et(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Et(e).constructor) : t.apply(e, r));
    }

    function Et(e) {
      return (Et = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function St(e, t) {
      return (St = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Ct(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var kt,
        Rt,
        Tt = (yt = Ct((bt = function (e) {
      function t(e, r, n) {
        var o;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (o = _t(this, t)).accountsApi = void 0, o.contactsStore = void 0, Ot(o, "accounts", yt, o), Ot(o, "accountsMap", mt, o), Ot(o, "isLoading", vt, o), Ot(o, "hasLoadedAncestorsWithContext", ht, o), o.childrenOf = Object(D.computedFn)(function (e) {
          return this.accounts.filter(function (t) {
            return t.parent_id === e;
          });
        }), o.contactsOf = Object(D.computedFn)(function (e) {
          var t = this.find(e);
          return t ? this.contactsStore.findMany(t.contact_ids) : [];
        }), o.find = function (e) {
          return o.accountsMap.get(e);
        }, Ot(o, "updateChildrenOf", gt, o), o.accountsApi = e, o.contactsStore = r, o.currentUserId = n, o;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && St(e, t);
      }(t, Object(w["Mix"])(w["loadingStatusCollectionMixin"])), r = t, (n = [{
        key: "roots",
        get: function () {
          return this.accounts.filter(function (e) {
            return !e.parent;
          });
        }
      }, {
        key: "destroy",
        value: function () {
          this.disposeLocalStoreCache();
        }
      }, {
        key: "getFields",
        value: function (e) {
          var t = this.findMany(e),
              r = Object(x.flatten)(t.map(function (e) {
            return e.fields.map(function (t) {
              return {
                account: e,
                field: t
              };
            });
          }));
          return Object(x.uniqBy)(function (e) {
            return e.field.id;
          }, r);
        }
      }, {
        key: "findMany",
        value: function (e) {
          return e.map(this.find).filter(Boolean);
        }
      }, {
        key: "findSerial",
        value: function (e) {
          return this.accounts.find(function (t) {
            return t.serial === e;
          });
        }
      }, {
        key: "isChecked",
        value: function (e) {
          var t = this.find(e);
          return t ? t.isChecked : t;
        }
      }, {
        key: "urlFor",
        value: function (e) {
          return this.find(e).url;
        }
      }, {
        key: "apiUrlFor",
        value: function (e) {
          return this.find(e).apiUrl;
        }
      }, {
        key: "push",
        value: function (e) {
          var t = this.find(e.id);
          return t ? t.update(e) : (t = new wt(this, e, this.currentUserId), this.accountsMap.set(t.id, t), this.accounts.push(t)), this.setLoaded(t.id, !0), t;
        }
      }, {
        key: "pushContacts",
        value: function (e) {
          this.contactsStore.pushMany(e);
        }
      }, {
        key: "updateDescendantsOf",
        value: function (e) {
          var t = this,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            setPending: !0
          },
              n = this.find(e);
          return n ? (null != r && r.setPending && this.setPending(e, !0), this.accountsApi.descendantsOf(e).then(function (e) {
            return Object(f.runInAction)(function () {
              return e.map(function (e) {
                return t.push(e);
              });
            });
          }).catch(function (e) {
            return Object(f.runInAction)(function () {
              n.lastError = e;
            });
          }).finally(function () {
            Object(f.runInAction)(function () {
              null != r && r.setPending && t.setPending(e, !1);
            });
          })) : Promise.resolve();
        }
      }, {
        key: "descendantsAreLoadedOf",
        value: function (e) {
          var t = this;
          return !!this.childrenAreLoadedOf(e) && this.find(e).children.every(function (e) {
            return t.descendantsAreLoadedOf(e.id);
          });
        }
      }, {
        key: "childrenAreLoadedOf",
        value: function (e) {
          var t = this,
              r = this.find(e);
          if (r) return !r.hasChildren || !r.child_ids.some(function (e) {
            return !t.isLoaded(e);
          });
        }
      }, {
        key: "setAccessLevel",
        value: function (e, t) {
          this.find(e).setAccessLevel(t);
        }
      }, {
        key: "load",
        value: function (e) {
          var t = this;
          return this.isLoading = !0, this.setPending(e, !0), this.accountsApi.fetch(e).then(function (r) {
            return r ? (t.finishPending(e), t.push(r)) : r;
          }).finally(function () {
            return Object(f.runInAction)(function () {
              t.setPending(e, !1), t.isLoading = !1;
            });
          });
        }
      }, {
        key: "loadChildrenOf",
        value: function (e) {
          return this.updateChildrenOf(e);
        }
      }, {
        key: "loadAncestorsWithContextOf",
        value: function (e) {
          var t = this;
          return this.isLoading = !0, this.accountsApi.ancestorsWithContextOf(e).then(function (e) {
            return e.forEach(function (e) {
              return t.push(e);
            });
          }).then(Object(f.runInAction)(function () {
            t.hasLoadedAncestorsWithContext = !0;
          })).finally(function () {
            Object(f.runInAction)(function () {
              t.isLoading = !1;
            });
          });
        }
      }]) && jt(r.prototype, n), o && jt(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "accounts", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), mt = Ct(bt.prototype, "accountsMap", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new Map();
      }
    }), vt = Ct(bt.prototype, "isLoading", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), ht = Ct(bt.prototype, "hasLoadedAncestorsWithContext", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Ct(bt.prototype, "roots", [f.computed], Object.getOwnPropertyDescriptor(bt.prototype, "roots"), bt.prototype), Ct(bt.prototype, "push", [f.action], Object.getOwnPropertyDescriptor(bt.prototype, "push"), bt.prototype), Ct(bt.prototype, "pushContacts", [f.action], Object.getOwnPropertyDescriptor(bt.prototype, "pushContacts"), bt.prototype), gt = Ct(bt.prototype, "updateChildrenOf", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            setPending: !0
          },
              n = e.find(t);
          return n ? (null != r && r.setPending && e.setPending(t, !0), e.accountsApi.childrenOf(t).then(function (t) {
            return Object(f.runInAction)(function () {
              return t.map(function (t) {
                return e.push(t);
              });
            });
          }).catch(function (e) {
            return Object(f.runInAction)(function () {
              n.lastError = e;
            });
          }).finally(function () {
            Object(f.runInAction)(function () {
              null != r && r.setPending && e.setPending(t, !1);
            });
          })) : Promise.resolve();
        };
      }
    }), Ct(bt.prototype, "updateDescendantsOf", [f.action], Object.getOwnPropertyDescriptor(bt.prototype, "updateDescendantsOf"), bt.prototype), Ct(bt.prototype, "setAccessLevel", [f.action], Object.getOwnPropertyDescriptor(bt.prototype, "setAccessLevel"), bt.prototype), Ct(bt.prototype, "load", [f.action], Object.getOwnPropertyDescriptor(bt.prototype, "load"), bt.prototype), Ct(bt.prototype, "loadAncestorsWithContextOf", [f.action], Object.getOwnPropertyDescriptor(bt.prototype, "loadAncestorsWithContextOf"), bt.prototype), bt);

    function zt(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Nt(n.key), n);
      }
    }

    function Nt(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Dt(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var xt,
        At,
        Mt,
        It,
        Ft,
        Bt,
        Lt,
        Vt,
        Ut,
        qt = (Rt = Dt((kt = function () {
      return e = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(this, "contacts", Rt, this), this.findMany = Object(D.computedFn)(function (e) {
          return this.contacts.filter(function (t) {
            return !!e.find(function (e) {
              return e === t.id;
            });
          });
        });
      }, (t = [{
        key: "find",
        value: function (e) {
          return this.contacts.find(function (t) {
            return t.id === e;
          });
        }
      }, {
        key: "push",
        value: function (e) {
          var t = this.find(e.id);
          t ? t.update(e) : this.contacts.push(new w.Contact(e));
        }
      }, {
        key: "pushMany",
        value: function (e) {
          var t = this;
          e.forEach(function (e) {
            return t.push(e);
          });
        }
      }]) && zt(e.prototype, t), r && zt(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "contacts", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), Dt(kt.prototype, "push", [f.action], Object.getOwnPropertyDescriptor(kt.prototype, "push"), kt.prototype), Dt(kt.prototype, "pushMany", [f.action], Object.getOwnPropertyDescriptor(kt.prototype, "pushMany"), kt.prototype), kt);

    function Kt(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Gt(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Wt(n.key), n);
      }
    }

    function Wt(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Ht(e, t, r) {
      return t = Jt(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Jt(e).constructor) : t.apply(e, r));
    }

    function Jt(e) {
      return (Jt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Yt(e, t) {
      return (Yt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Qt(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    v()(document).off(".data-api");
    var $t = Object(d.observer)((Mt = Qt((At = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Kt(r = Ht(this, t, [e]), "contactDetailsModalId", Mt, r), Kt(r, "currentContact", It, r), Kt(r, "searchTerm", Ft, r), Kt(r, "handleNewAccount", Bt, r), Kt(r, "handleNewContacts", Lt, r), Kt(r, "filterContacts", Vt, r), Kt(r, "showContact", Ut, r), r.contactPath = function (e) {
          return y.a.join(r.contactsPath, e);
        }, r.editContactPath = function (e) {
          return y.a.join(r.contactPath(e), "edit");
        };
        var n = r.props,
            o = n.accountId,
            i = n.accountHash,
            a = n.accountsPath,
            c = n.editContacts,
            u = n.accountContactPath;
        return r.accountsApi = new N(a), r.accountsStore = new Tt(r.accountsApi, new qt()), r.account = r.accountsStore.push(i), r.accountId = o, r.editContacts = c, r.accountContactPath = u, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Yt(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Gt(e.prototype, t), r && Gt(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "contactsPath",
        get: function () {
          return y.a.join(this.accountsApi.accountsPath, this.accountId, "contacts");
        }
      }, {
        key: "newContactPath",
        get: function () {
          return y.a.join(this.contactsPath, "new");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.t,
              r = e.newUserPath,
              n = e.editUsers,
              o = e.hideTitle;
          return s.createElement("div", {
            className: "account-contacts"
          }, s.createElement(h.ContactDetailsModal, {
            id: this.contactDetailsModalId,
            contact: this.currentContact || new w.Contact()
          }), o ? null : s.createElement("h3", {
            className: "contacts-title float-left"
          }, t("contacts")), s.createElement("a", {
            className: "btn btn-primary float-right",
            style: this.editContacts ? {} : {
              display: "none"
            },
            href: this.newContactPath,
            role: "button"
          }, t("add_contact")), s.createElement(h.SearchBar, {
            placeholder: t("search_contacts"),
            onSearch: this.filterContacts
          }), s.createElement(R, {
            accountContactPath: this.accountContactPath,
            contactPath: this.contactPath,
            editContactPath: this.editContactPath,
            onNewAccount: this.handleNewAccount,
            onNewContacts: this.handleNewContacts,
            onShowContact: this.showContact,
            account: this.account,
            apiUrlBase: new URL(this.accountsApi.apiPath, location.origin),
            searchTerm: this.searchTerm,
            editUsers: n,
            newUserPath: r
          }));
        }
      }]);
    }()).prototype, "contactDetailsModalId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "contactDetailsModal";
      }
    }), It = Qt(At.prototype, "currentContact", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new w.Contact();
      }
    }), Ft = Qt(At.prototype, "searchTerm", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Qt(At.prototype, "contactsPath", [f.computed], Object.getOwnPropertyDescriptor(At.prototype, "contactsPath"), At.prototype), Qt(At.prototype, "newContactPath", [f.computed], Object.getOwnPropertyDescriptor(At.prototype, "newContactPath"), At.prototype), Bt = Qt(At.prototype, "handleNewAccount", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.accountsStore.push(t);
        };
      }
    }), Lt = Qt(At.prototype, "handleNewContacts", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r) {
          e.accountsStore.pushContacts(r);
        };
      }
    }), Vt = Qt(At.prototype, "filterContacts", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.searchTerm = t.target.value;
        };
      }
    }), Ut = Qt(At.prototype, "showContact", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.currentContact = t, v()("#".concat(e.contactDetailsModalId)).modal("show");
        };
      }
    }), xt = At)) || xt,
        Xt = Object(g.a)()($t);

    function Zt() {
      return (Zt = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }

        return e;
      }).apply(this, arguments);
    }

    function er(e, t) {
      if (null == e) return {};
      var r,
          n,
          o = {},
          i = Object.keys(e);

      for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);

      return o;
    }

    var tr = r(13),
        rr = r.n(tr),
        nr = p.a.createContext({});
    nr.Consumer, nr.Provider;

    function or(e, t) {
      var r = Object(s.useContext)(nr);
      return e || r[t] || t;
    }

    var ir = ["bsPrefix", "variant", "pill", "className", "as"],
        ar = p.a.forwardRef(function (e, t) {
      var r = e.bsPrefix,
          n = e.variant,
          o = e.pill,
          i = e.className,
          a = e.as,
          c = void 0 === a ? "span" : a,
          u = er(e, ir),
          l = or(r, "badge");
      return p.a.createElement(c, Zt({
        ref: t
      }, u, {
        className: rr()(i, l, o && l + "-pill", n && l + "-" + n)
      }));
    });
    ar.displayName = "Badge", ar.defaultProps = {
      pill: !1
    };
    var cr,
        ur = ar,
        lr = ["floz", "pt", "qt", "gal", "mL", "L"];

    function sr(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, pr(n.key), n);
      }
    }

    function pr(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function fr(e, t, r) {
      return t = dr(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], dr(e).constructor) : t.apply(e, r));
    }

    function dr(e) {
      return (dr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function br(e, t) {
      return (br = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function yr(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var mr,
        vr,
        hr,
        gr,
        wr,
        Or,
        jr,
        Pr,
        _r = (yr((cr = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), fr(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && br(e, t);
      }(t, w["Product"]), r = t, (n = [{
        key: "isLiquid",
        get: function () {
          return lr.includes(this.baseUnit);
        }
      }, {
        key: "baseUnitQuantity",
        get: function () {
          return new w.Quantity(this.baseUnit);
        }
      }, {
        key: "isMeasuredByMass",
        get: function () {
          return this.baseUnitQuantity.isCompatible("kg");
        }
      }, {
        key: "isMeasuredByVolume",
        get: function () {
          return this.baseUnitQuantity.isCompatible("L");
        }
      }, {
        key: "unitChoices",
        get: function () {
          return this.baseUnit ? this.isMeasuredByMass ? ["oz", "lbs", "tn", "grams", "kg"] : this.isMeasuredByVolume ? ["floz", "pt", "qt", "gal", "mL", "L"] : [] : ["unit"];
        }
      }, {
        key: "stateRegistrationStates",
        get: function () {
          return this.stateRegistration ? Object.keys(this.stateRegistration).map(function (e) {
            return e.toUpperCase();
          }) : [];
        }
      }, {
        key: "formulations",
        get: function () {
          return [{
            description: "Crystalline",
            type: "dry",
            base_unit: "lbs"
          }, {
            description: "Dust",
            type: "dry",
            base_unit: "lbs"
          }, {
            description: "Emulsifiable Concentrate",
            type: "liquid",
            base_unit: "floz"
          }, {
            description: "Flowable Concentrate",
            type: "liquid",
            base_unit: "floz"
          }, {
            description: "Granular",
            type: "dry",
            base_unit: "lbs"
          }, {
            description: "Impregnated Materials",
            type: "dispenser",
            base_unit: ""
          }, {
            description: "Invert-Emulsifiable Conc.",
            type: "liquid",
            base_unit: "floz"
          }, {
            description: "Microencapsulated",
            type: "wettable",
            base_unit: "lbs"
          }, {
            description: "Oils (no added pesticide)",
            type: "liquid",
            base_unit: "floz"
          }, {
            description: "Pelleted/Tableted",
            type: "dry",
            base_unit: "lbs"
          }, {
            description: "Pressurized Dust",
            type: "liquid",
            base_unit: "floz"
          }, {
            description: "Pressurized Gas",
            type: "liquid",
            base_unit: "floz"
          }, {
            description: "Pressurized Liquid",
            type: "liquid",
            base_unit: "floz"
          }, {
            description: "Ready-to-Use Solution",
            type: "liquid",
            base_unit: "floz"
          }, {
            description: "Solid Agar",
            type: "dry",
            base_unit: "lbs"
          }, {
            description: "Soluble Concentrate",
            type: "liquid",
            base_unit: "floz"
          }, {
            description: "Soluble Concentrate/Solid",
            type: "wettable",
            base_unit: "lbs"
          }, {
            description: "Technical Chemical",
            type: "liquid",
            base_unit: "floz"
          }, {
            description: "Water Dispersible Granule",
            type: "wettable",
            base_unit: "lbs"
          }, {
            description: "Water Soluble Packaging",
            type: "wettable",
            base_unit: "lbs"
          }, {
            description: "Wettable Powder",
            type: "wettable",
            base_unit: "lbs"
          }];
        }
      }, {
        key: "pushActiveIngredient",
        value: function (e) {
          var t = this.activeIngredients.findIndex(function (t) {
            return t.id === e.id;
          });
          t >= 0 ? this.activeIngredients[t] = e : this.activeIngredients.push(e);
        }
      }, {
        key: "removeActiveIngredient",
        value: function (e) {
          var t = this.activeIngredients.findIndex(function (t) {
            return t.id === e;
          });
          t >= 0 && this.activeIngredients.splice(t, 1);
        }
      }, {
        key: "toggleUse",
        value: function () {
          this.use = "restricted" === this.use ? "general" : "restricted";
        }
      }, {
        key: "updateAlternateNames",
        value: function (e) {
          this.update({
            alternateNames: e.sort(Q)
          });
        }
      }, {
        key: "newPrimaryName",
        value: function (e) {
          var t = this.name;
          this.update({
            alternateNames: ee(this.alternateNames.filter(function (t) {
              return t !== e;
            }).concat(t)).sort(Q)
          }), this.name = e;
        }
      }, {
        key: "newBaseUnit",
        value: function (e) {
          this.formulation.update({
            baseUnit: e
          });
        }
      }, {
        key: "newFormulationDescription",
        value: function (e) {
          var t = this.formulations.find(function (t) {
            return t.description === e;
          }),
              r = this.formulation && this.formulation.baseUnit;
          this.update({
            formulation: t
          }), void 0 !== r && this.formulation.update({
            baseUnit: r
          });
        }
      }, {
        key: "toggleNutrientAnalysis",
        value: function () {
          this.update({
            nutrientAnalysis: this.hasNutrientAnalysis ? null : {
              n: "0",
              p: "0",
              k: "0",
              s: "0",
              ca: "0",
              mg: "0",
              al: "0",
              b: "0",
              cu: "0",
              fe: "0",
              mn: "0",
              mo: "0",
              si: "0",
              zn: "0",
              humicAcid: "0"
            }
          });
        }
      }, {
        key: "stateRegistrationFor",
        value: function (e) {
          if (this.stateRegistration) return this.stateRegistration[e.toLowerCase()];
        }
      }, {
        key: "setStateRegistration",
        value: function (e, t) {
          var r = e.toLowerCase();
          this.stateRegistration || (this.stateRegistration = {}), this.stateRegistration[r] = t, t || delete this.stateRegistration[r];
        }
      }]) && sr(r.prototype, n), o && sr(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "isLiquid", [f.computed], Object.getOwnPropertyDescriptor(cr.prototype, "isLiquid"), cr.prototype), yr(cr.prototype, "baseUnitQuantity", [f.computed], Object.getOwnPropertyDescriptor(cr.prototype, "baseUnitQuantity"), cr.prototype), yr(cr.prototype, "isMeasuredByMass", [f.computed], Object.getOwnPropertyDescriptor(cr.prototype, "isMeasuredByMass"), cr.prototype), yr(cr.prototype, "isMeasuredByVolume", [f.computed], Object.getOwnPropertyDescriptor(cr.prototype, "isMeasuredByVolume"), cr.prototype), yr(cr.prototype, "unitChoices", [f.computed], Object.getOwnPropertyDescriptor(cr.prototype, "unitChoices"), cr.prototype), yr(cr.prototype, "stateRegistrationStates", [f.computed], Object.getOwnPropertyDescriptor(cr.prototype, "stateRegistrationStates"), cr.prototype), yr(cr.prototype, "formulations", [f.computed], Object.getOwnPropertyDescriptor(cr.prototype, "formulations"), cr.prototype), yr(cr.prototype, "pushActiveIngredient", [f.action], Object.getOwnPropertyDescriptor(cr.prototype, "pushActiveIngredient"), cr.prototype), yr(cr.prototype, "removeActiveIngredient", [f.action], Object.getOwnPropertyDescriptor(cr.prototype, "removeActiveIngredient"), cr.prototype), yr(cr.prototype, "toggleUse", [f.action], Object.getOwnPropertyDescriptor(cr.prototype, "toggleUse"), cr.prototype), yr(cr.prototype, "updateAlternateNames", [f.action], Object.getOwnPropertyDescriptor(cr.prototype, "updateAlternateNames"), cr.prototype), yr(cr.prototype, "newPrimaryName", [f.action], Object.getOwnPropertyDescriptor(cr.prototype, "newPrimaryName"), cr.prototype), yr(cr.prototype, "newBaseUnit", [f.action], Object.getOwnPropertyDescriptor(cr.prototype, "newBaseUnit"), cr.prototype), yr(cr.prototype, "newFormulationDescription", [f.action], Object.getOwnPropertyDescriptor(cr.prototype, "newFormulationDescription"), cr.prototype), yr(cr.prototype, "toggleNutrientAnalysis", [f.action], Object.getOwnPropertyDescriptor(cr.prototype, "toggleNutrientAnalysis"), cr.prototype), yr(cr.prototype, "setStateRegistration", [f.action], Object.getOwnPropertyDescriptor(cr.prototype, "setStateRegistration"), cr.prototype), cr);

    function Er(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Sr(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Cr(n.key), n);
      }
    }

    function Cr(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function kr(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Rr = ((Pr = function () {
      return e = function e() {
        var t = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.id = void 0, this.product = void 0, Er(this, "price", vr, this), Er(this, "quantity", hr, this), Er(this, "category", gr, this), Er(this, "effectiveDate", wr, this), Er(this, "estimated", Or, this), Er(this, "setUnit", jr, this), this.toJS = function () {
          return {
            product_id: t.product.serial,
            price: t.price,
            category: t.category,
            quantity: t.quantity.displayValue,
            effective_date: t.effectiveDate,
            estimated: t.estimated
          };
        }, this.updateFromJS = function (e) {
          t.id = e.id, t.serial = e.serial, t.product = e.product, t.price = e.price || "", t.category = e.category || "", t.quantity = e.quantity ? new w.Quantity(e.quantity) : new w.Quantity(), t.effectiveDate = e.effective_date, t.estimated = e.estimated;
        }, this.save = function (e, r) {
          var n = t.serial ? "/if2/api/product_prices/".concat(t.serial) : "/if2/api/accounts/".concat(e, "/product_prices");
          return fetch(n, {
            method: t.serial ? "PATCH" : "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              price: t.toJS(),
              authenticity_token: r
            })
          }).then(function (e) {
            if (e.ok) return e.json();
            throw Error(e.statusText || "Unexpected error");
          }).catch(function (e) {
            console.error("Save Failed:", e);
          });
        };
      }, (t = [{
        key: "priceFormatted",
        get: function () {
          return parseFloat(this.price).toFixed(2);
        }
      }]) && Sr(e.prototype, t), r && Sr(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).fromJS = function (e) {
      var t = new Pr();
      return t.updateFromJS(e), t;
    }, Pr.getPrices = function (e) {
      return fetch("/if2/api/accounts/".concat(e, "/product_prices/"), {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function (e) {
        if (e.ok) return e.json();
        if (404 === e.status) return e.json().then(function (e) {
          return Promise.reject(new Error(e && e.message || "Not Found"));
        });
        throw Error(e.statusText);
      });
    }, vr = kr((mr = Pr).prototype, "price", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), hr = kr(mr.prototype, "quantity", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new w.Quantity();
      }
    }), gr = kr(mr.prototype, "category", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), wr = kr(mr.prototype, "effectiveDate", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new Date();
      }
    }), Or = kr(mr.prototype, "estimated", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), kr(mr.prototype, "priceFormatted", [f.computed], Object.getOwnPropertyDescriptor(mr.prototype, "priceFormatted"), mr.prototype), jr = kr(mr.prototype, "setUnit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.quantity.units = t;
        };
      }
    }), mr);

    function Tr(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zr(n.key), n);
      }
    }

    function zr(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var Nr,
        Dr,
        xr,
        Ar,
        Mr,
        Ir,
        Fr,
        Br,
        Lr,
        Vr,
        Ur,
        qr,
        Kr,
        Gr,
        Wr,
        Hr,
        Jr,
        Yr,
        Qr,
        $r = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.defaultApiPath = "/if2/api/products/", this.productPath = "/if2/products/", this.apiPath = t || this.defaultApiPath;
      }, (t = [{
        key: "_getQueryParams",
        value: function (e) {
          var t = e.only,
              r = e.search,
              n = e.limit,
              o = e.offset,
              i = e.meta,
              a = e.filter,
              c = [].concat(Array.isArray(t) && t.map(function (e) {
            return ["only[]", e];
          }) || []).concat(r && [["search", r]] || []).concat(n && [["limit", n]] || []).concat(o && [["offset", o]] || []).concat(i && [["meta", i]] || []).concat((a && Object.keys(a).map(function (e) {
            return [["filter[][key]", e], ["filter[][value]", a[e]]];
          }) || []).flat());
          return c.length && new URLSearchParams(c);
        }
      }, {
        key: "fetchAll",
        value: function () {
          return fetch(this.apiPath);
        }
      }, {
        key: "findAll",
        value: function (e) {
          return fetch([this.apiPath].concat(this._getQueryParams(e || {}) || []).join("?")).then(function (e) {
            return e.json();
          });
        }
      }, {
        key: "findAllForAccount",
        value: function (e, t) {
          return fetch(["".concat(this.apiPath, "account/").concat(e)].concat(this._getQueryParams(t || {}) || []).join("?")).then(function (e) {
            return e.json();
          });
        }
      }]) && Tr(e.prototype, t), r && Tr(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function Xr() {
      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      Xr = function () {
        return t;
      };

      var e,
          t = {},
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = Object.defineProperty || function (e, t, r) {
        e[t] = r.value;
      },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          u = i.toStringTag || "@@toStringTag";

      function l(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        l({}, "");
      } catch (e) {
        l = function (e, t, r) {
          return e[t] = r;
        };
      }

      function s(e, t, r, n) {
        var i = t && t.prototype instanceof v ? t : v,
            a = Object.create(i.prototype),
            c = new T(n || []);
        return o(a, "_invoke", {
          value: S(e, r, c)
        }), a;
      }

      function p(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      t.wrap = s;
      var f = "suspendedStart",
          d = "suspendedYield",
          b = "executing",
          y = "completed",
          m = {};

      function v() {}

      function h() {}

      function g() {}

      var w = {};
      l(w, a, function () {
        return this;
      });
      var O = Object.getPrototypeOf,
          j = O && O(O(z([])));
      j && j !== r && n.call(j, a) && (w = j);
      var P = g.prototype = v.prototype = Object.create(w);

      function _(e) {
        ["next", "throw", "return"].forEach(function (t) {
          l(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function E(e, t) {
        function r(o, i, a, c) {
          var u = p(e[o], e, i);

          if ("throw" !== u.type) {
            var l = u.arg,
                s = l.value;
            return s && "object" == typeof s && n.call(s, "__await") ? t.resolve(s.__await).then(function (e) {
              r("next", e, a, c);
            }, function (e) {
              r("throw", e, a, c);
            }) : t.resolve(s).then(function (e) {
              l.value = e, a(l);
            }, function (e) {
              return r("throw", e, a, c);
            });
          }

          c(u.arg);
        }

        var i;
        o(this, "_invoke", {
          value: function (e, n) {
            function o() {
              return new t(function (t, o) {
                r(e, n, t, o);
              });
            }

            return i = i ? i.then(o, o) : o();
          }
        });
      }

      function S(t, r, n) {
        var o = f;
        return function (i, a) {
          if (o === b) throw Error("Generator is already running");

          if (o === y) {
            if ("throw" === i) throw a;
            return {
              value: e,
              done: !0
            };
          }

          for (n.method = i, n.arg = a;;) {
            var c = n.delegate;

            if (c) {
              var u = C(c, n);

              if (u) {
                if (u === m) continue;
                return u;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (o === f) throw o = y, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            o = b;
            var l = p(t, r, n);

            if ("normal" === l.type) {
              if (o = n.done ? y : d, l.arg === m) continue;
              return {
                value: l.arg,
                done: n.done
              };
            }

            "throw" === l.type && (o = y, n.method = "throw", n.arg = l.arg);
          }
        };
      }

      function C(t, r) {
        var n = r.method,
            o = t.iterator[n];
        if (o === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, C(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), m;
        var i = p(o, t.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, m;
        var a = i.arg;
        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, m) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m);
      }

      function k(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function R(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function T(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(k, this), this.reset(!0);
      }

      function z(t) {
        if (t || "" === t) {
          var r = t[a];
          if (r) return r.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var o = -1,
                i = function r() {
              for (; ++o < t.length;) if (n.call(t, o)) return r.value = t[o], r.done = !1, r;

              return r.value = e, r.done = !0, r;
            };

            return i.next = i;
          }
        }

        throw new TypeError(typeof t + " is not iterable");
      }

      return h.prototype = g, o(P, "constructor", {
        value: g,
        configurable: !0
      }), o(g, "constructor", {
        value: h,
        configurable: !0
      }), h.displayName = l(g, u, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === h || "GeneratorFunction" === (t.displayName || t.name));
      }, t.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, l(e, u, "GeneratorFunction")), e.prototype = Object.create(P), e;
      }, t.awrap = function (e) {
        return {
          __await: e
        };
      }, _(E.prototype), l(E.prototype, c, function () {
        return this;
      }), t.AsyncIterator = E, t.async = function (e, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new E(s(e, r, n, o), i);
        return t.isGeneratorFunction(r) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, _(P), l(P, u, "Generator"), l(P, a, function () {
        return this;
      }), l(P, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (e) {
        var t = Object(e),
            r = [];

        for (var n in t) r.push(n);

        return r.reverse(), function e() {
          for (; r.length;) {
            var n = r.pop();
            if (n in t) return e.value = n, e.done = !1, e;
          }

          return e.done = !0, e;
        };
      }, t.values = z, T.prototype = {
        constructor: T,
        reset: function (t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(R), !t) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
        },
        stop: function () {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function (t) {
          if (this.done) throw t;
          var r = this;

          function o(n, o) {
            return c.type = "throw", c.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
                c = a.completion;
            if ("root" === a.tryLoc) return o("end");

            if (a.tryLoc <= this.prev) {
              var u = n.call(a, "catchLoc"),
                  l = n.call(a, "finallyLoc");

              if (u && l) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!l) throw Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function (e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(a);
        },
        complete: function (e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
        },
        finish: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), R(r), m;
          }
        },
        catch: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                R(r);
              }

              return o;
            }
          }

          throw Error("illegal catch attempt");
        },
        delegateYield: function (t, r, n) {
          return this.delegate = {
            iterator: z(t),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = e), m;
        }
      }, t;
    }

    function Zr(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function en(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Zr(Object(r), !0).forEach(function (t) {
          tn(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Zr(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function tn(e, t, r) {
      return (t = cn(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function rn(e, t, r, n, o, i, a) {
      try {
        var c = e[i](a),
            u = c.value;
      } catch (e) {
        return void r(e);
      }

      c.done ? t(u) : Promise.resolve(u).then(n, o);
    }

    function nn(e) {
      return function () {
        var t = this,
            r = arguments;
        return new Promise(function (n, o) {
          var i = e.apply(t, r);

          function a(e) {
            rn(i, n, o, a, c, "next", e);
          }

          function c(e) {
            rn(i, n, o, a, c, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function on(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function an(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, cn(n.key), n);
      }
    }

    function cn(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function un(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var ln,
        sn,
        pn = ((Qr = function () {
      return e = function e(t, r) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.api = void 0, this.useNewModels = void 0, on(this, "status", Dr, this), on(this, "loadingProgress", xr, this), on(this, "products", Ar, this), on(this, "productIndex", Mr, this), on(this, "pageSize", Ir, this), on(this, "searchTerm", Fr, this), on(this, "isFilteringOrganic", Br, this), on(this, "showInactive", Lr, this), on(this, "_totalResults", Vr, this), on(this, "currentResults", Ur, this), on(this, "lastQueryOptions", qr, this), on(this, "filterOrganic", Kr, this), on(this, "stopFilteringOrganic", Gr, this), on(this, "filterProducts", Wr, this), on(this, "changePageSize", Hr, this), on(this, "pageBack", Jr, this), on(this, "pageForward", Yr, this);
        var n = r || {};
        this.api = t, this.useNewModels = n.useNewModels || !1;
      }, r = [{
        key: "extractIndexToOffset",
        value: function (e, t, r) {
          return e.slice(0, t) + e.slice(t + r, e.length);
        }
      }], (t = [{
        key: "isLoading",
        get: function () {
          return "loading" === this.status;
        }
      }, {
        key: "isPending",
        get: function () {
          return "pending" === this.status;
        }
      }, {
        key: "apiPath",
        get: function () {
          return this.api.apiPath;
        }
      }, {
        key: "endIndex",
        get: function () {
          return this.productIndex + this.currentResults;
        }
      }, {
        key: "filteredProducts",
        get: function () {
          var e = this,
              t = this.products.concat();
          return this.searchTerm && (t = t.filter(function (t) {
            return t.searchText.includes(e.searchTerm);
          })), this.showInactive || (t = t.filter(function (e) {
            return e.isActive;
          })), this.isFilteringOrganic && (t = t.filter(function (e) {
            return e.isOrganic;
          })), t;
        }
      }, {
        key: "filteredSortedProducts",
        get: function () {
          return this.filteredProducts;
        }
      }, {
        key: "productPath",
        get: function () {
          return this.api.productPath;
        }
      }, {
        key: "visibleSortedProducts",
        get: function () {
          return this.filteredSortedProducts.slice(this.productIndex, this.endIndex);
        }
      }, {
        key: "totalResults",
        get: function () {
          return this._totalResults || this.filterProducts.length;
        }
      }, {
        key: "visibleProductsSortedBy",
        value: function (e) {
          return this.filteredProducts.sort(e).slice(this.productIndex, this.endIndex);
        }
      }, {
        key: "find",
        value: function (e) {
          return this.products.find(function (t) {
            return t.id === e;
          });
        }
      }, {
        key: "fetchAll",
        value: function (e) {
          var t = this;
          return this.status = "pending", this.lastQueryOptions = e, this.api.findAll(e).then(function (r) {
            return Object(f.runInAction)(function () {
              var n = r;
              null != e && e.meta && (n = r.products, t._totalResults = r.totalResults), t.currentResults = n.length, t.status = "ready", t.pushMany(n);
            });
          }).catch(function (e) {
            return Object(f.runInAction)(function () {
              return t.status = "ready", console.log(e), [];
            });
          });
        }
      }, {
        key: "fetchAllForAccount",
        value: function (e, t) {
          var r = this;
          return this.status = "pending", this.api.findAllForAccount(e, t).then(function (e) {
            return Object(f.runInAction)(function () {
              r.status = "ready", r.pushMany(e);
            });
          }).catch(function () {
            return Object(f.runInAction)(function () {
              return r.status = "ready", [];
            });
          });
        }
      }, {
        key: "push",
        value: function (e) {
          var t = this.find(e.id);
          return t ? t.update(e) : (t = new _r(e), this.products.push(t)), t;
        }
      }, {
        key: "pushMany",
        value: function (e) {
          for (var t = this, r = [], n = 0, o = 0; n < e.length; n += 1) {
            var i = r[o] || [];
            i.push(e[n]), r[o] = i, n % 100 + 1 >= 100 && (o += 1);
          }

          var a = 0;
          this.status = "loading", function e() {
            Object(f.runInAction)(function () {
              Array.isArray(r[a]) && (r[a].forEach(function (e) {
                return t.push(e);
              }), r[a] = null), a += 1, t.loadingProgress = Math.round(r.length && a / r.length * 100 || 0), a < r.length ? setTimeout(function () {
                return e();
              }, 1) : (t.status = "ready", t.loadingProgress = 0, r = null);
            });
          }();
        }
      }]) && an(e.prototype, t), r && an(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).sortActiveIngredientSearchText = function (e) {
      return function (t, r) {
        var n = t.activeIngredients.map(function (e) {
          return e.name.toLowerCase();
        }),
            o = r.activeIngredients.map(function (e) {
          return e.name.toLowerCase();
        }),
            i = n.join(" "),
            a = o.join(" "),
            c = i.indexOf(e),
            u = a.indexOf(e);
        if (c < u) return -1 === c ? 1 : -1;
        if (u < c) return -1 === u ? -1 : 1;

        if (c === u) {
          if (-1 === c || -1 === u) return Object(h.sortByName)(t, r);
          var l = Qr.extractIndexToOffset(i, c, e.length),
              s = Qr.extractIndexToOffset(a, u, e.length);
          return Object(h.naturalSort)(l, s);
        }

        return 0;
      };
    }, Qr.sortBySearchText = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
      return function (r, n) {
        var o = r.name.toLowerCase().indexOf(e),
            i = n.name.toLowerCase().indexOf(e);
        if (o < i) return -1 === o ? 1 : -1;
        if (i < o) return -1 === i ? -1 : 1;

        if (o === i) {
          if ((-1 === o || -1 === i) && t) return t(e)(r, n);
          var a = Qr.extractIndexToOffset(r.name, o, e.length),
              c = Qr.extractIndexToOffset(n.name, i, e.length);
          return Object(h.naturalSort)(a, c);
        }

        return 0;
      };
    }, Dr = un((Nr = Qr).prototype, "status", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "ready";
      }
    }), xr = un(Nr.prototype, "loadingProgress", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), Ar = un(Nr.prototype, "products", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), Mr = un(Nr.prototype, "productIndex", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), Ir = un(Nr.prototype, "pageSize", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 25;
      }
    }), Fr = un(Nr.prototype, "searchTerm", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Br = un(Nr.prototype, "isFilteringOrganic", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Lr = un(Nr.prototype, "showInactive", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Vr = un(Nr.prototype, "_totalResults", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), Ur = un(Nr.prototype, "currentResults", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), qr = un(Nr.prototype, "lastQueryOptions", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), un(Nr.prototype, "isLoading", [f.computed], Object.getOwnPropertyDescriptor(Nr.prototype, "isLoading"), Nr.prototype), un(Nr.prototype, "isPending", [f.computed], Object.getOwnPropertyDescriptor(Nr.prototype, "isPending"), Nr.prototype), un(Nr.prototype, "apiPath", [f.computed], Object.getOwnPropertyDescriptor(Nr.prototype, "apiPath"), Nr.prototype), un(Nr.prototype, "endIndex", [f.computed], Object.getOwnPropertyDescriptor(Nr.prototype, "endIndex"), Nr.prototype), un(Nr.prototype, "filteredProducts", [f.computed], Object.getOwnPropertyDescriptor(Nr.prototype, "filteredProducts"), Nr.prototype), un(Nr.prototype, "filteredSortedProducts", [f.computed], Object.getOwnPropertyDescriptor(Nr.prototype, "filteredSortedProducts"), Nr.prototype), un(Nr.prototype, "productPath", [f.computed], Object.getOwnPropertyDescriptor(Nr.prototype, "productPath"), Nr.prototype), un(Nr.prototype, "visibleSortedProducts", [f.computed], Object.getOwnPropertyDescriptor(Nr.prototype, "visibleSortedProducts"), Nr.prototype), un(Nr.prototype, "totalResults", [f.computed], Object.getOwnPropertyDescriptor(Nr.prototype, "totalResults"), Nr.prototype), Kr = un(Nr.prototype, "filterOrganic", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isFilteringOrganic = !0;
        };
      }
    }), Gr = un(Nr.prototype, "stopFilteringOrganic", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isFilteringOrganic = !1;
        };
      }
    }), Wr = un(Nr.prototype, "filterProducts", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.searchTerm = t.toLowerCase(), e.productIndex = 0;
        };
      }
    }), Hr = un(Nr.prototype, "changePageSize", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = Number(t);
          if (r < 1) return e.productIndex = 0, void (e.pageSize = 0);
          e.pageSize = r;
        };
      }
    }), Jr = un(Nr.prototype, "pageBack", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.currentResults = Math.min(e.pageSize, e.productIndex);
          var t = e.productIndex - e.pageSize;
          e.totalResults < 1 || t < 0 ? e.productIndex = 0 : e.productIndex = t;
        };
      }
    }), Yr = un(Nr.prototype, "pageForward", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return nn(Xr().mark(function t() {
          var r;
          return Xr().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                if (!(e.endIndex >= e.totalResults)) {
                  t.next = 2;
                  break;
                }

                return t.abrupt("return");

              case 2:
                if (r = e.endIndex, e.productIndex = e.endIndex, !e.lastQueryOptions) {
                  t.next = 7;
                  break;
                }

                return t.next = 7, e.fetchAll(en(en({}, e.lastQueryOptions), {}, {
                  offset: r
                }));

              case 7:
              case "end":
                return t.stop();
            }
          }, t);
        }));
      }
    }), un(Nr.prototype, "fetchAll", [f.action], Object.getOwnPropertyDescriptor(Nr.prototype, "fetchAll"), Nr.prototype), un(Nr.prototype, "fetchAllForAccount", [f.action], Object.getOwnPropertyDescriptor(Nr.prototype, "fetchAllForAccount"), Nr.prototype), un(Nr.prototype, "push", [f.action], Object.getOwnPropertyDescriptor(Nr.prototype, "push"), Nr.prototype), un(Nr.prototype, "pushMany", [f.action], Object.getOwnPropertyDescriptor(Nr.prototype, "pushMany"), Nr.prototype), Nr);

    function fn(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, dn(n.key), n);
      }
    }

    function dn(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function bn(e, t, r) {
      return t = yn(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], yn(e).constructor) : t.apply(e, r));
    }

    function yn(e) {
      return (yn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function mn(e, t) {
      return (mn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var vn,
        hn,
        gn,
        wn,
        On = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((sn = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), bn(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && mn(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "displayText",
        get: function () {
          var e = this.props.ingredient;
          return "".concat(e.name, " (").concat(e.percent, " %)");
        }
      }, {
        key: "render",
        value: function () {
          return p.a.createElement("div", {
            className: "product-ingredient d-block text-truncate small",
            title: this.displayText
          }, this.displayText);
        }
      }]) && fn(r.prototype, n), o && fn(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "displayText", [f.computed], Object.getOwnPropertyDescriptor(sn.prototype, "displayText"), sn.prototype), ln = sn)) || ln;

    function jn(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Pn(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _n(n.key), n);
      }
    }

    function _n(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function En(e, t, r) {
      return t = Sn(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Sn(e).constructor) : t.apply(e, r));
    }

    function Sn(e) {
      return (Sn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Cn(e, t) {
      return (Cn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function kn(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Rn,
        Tn,
        zn = Object(d.observer)((kn((hn = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return jn(e = En(this, t, [].concat(n)), "onMouseDown", gn, e), jn(e, "preventDefault", wn, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Cn(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "className",
        get: function () {
          var e = this.props,
              t = e.product,
              r = e.activeProduct;
          return ["dropdown-item"].concat(r === t ? "active" : "").concat("product-dropdown-item").join(" ");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.product;
          return p.a.createElement("a", {
            className: this.className,
            key: e.id,
            onMouseDown: this.onMouseDown,
            onClick: this.preventDefault,
            tabIndex: -1,
            href: "#"
          }, p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col-sm-6 text-truncate"
          }, p.a.createElement("b", {
            title: e.name
          }, e.name), p.a.createElement("div", {
            className: "small text-truncate understated",
            title: e.manufacturer
          }, e.manufacturer)), p.a.createElement("div", {
            className: "col-sm-6 text-right text-truncate"
          }, p.a.createElement("small", null, p.a.createElement("b", null, p.a.createElement("span", {
            className: "text-uppercase",
            title: e.productType
          }, e.productType))), e.activeIngredients.map(function (e, t) {
            return p.a.createElement(On, {
              key: "".concat(e.id, "-").concat(t),
              ingredient: e
            });
          }), e.hasNutrientAnalysis ? p.a.createElement("div", {
            className: "product-ingredient d-block text-truncate small",
            title: e.nutrientAnalysisLabel
          }, e.nutrientAnalysisLabel) : null)));
        }
      }]) && Pn(r.prototype, n), o && Pn(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "className", [f.computed], Object.getOwnPropertyDescriptor(hn.prototype, "className"), hn.prototype), gn = kn(hn.prototype, "onMouseDown", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.onSelectProduct,
              o = r.product,
              i = r.index;
          t.preventDefault(), n(o, i);
        };
      }
    }), wn = kn(hn.prototype, "preventDefault", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return function (e) {
          e.preventDefault();
        };
      }
    }), vn = hn)) || vn;

    function Nn(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Dn(n.key), n);
      }
    }

    function Dn(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function xn(e, t, r) {
      return t = An(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], An(e).constructor) : t.apply(e, r));
    }

    function An(e) {
      return (An = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Mn(e, t) {
      return (Mn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var In,
        Fn,
        Bn = Object(d.observer)(((Tn = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), xn(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Mn(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.children,
              r = e.dropdownClassName,
              n = e.searchBarPlaceholder,
              o = e.showDropdown,
              i = e.tabIndex,
              a = e.onSearch,
              c = e.onSearchBarKeyDown,
              u = e.onSearchBarBlur,
              l = e.onSearchBarFocus,
              s = e.errorMessage;
          return p.a.createElement("div", {
            className: "search-dropdown"
          }, p.a.createElement("div", {
            role: "listbox",
            tabIndex: i,
            className: "dropdown".concat(o ? " show" : ""),
            onKeyDown: c,
            onBlur: u,
            onFocus: l
          }, p.a.createElement(h.SearchBar, {
            placeholder: n,
            onSearch: a,
            errorMessage: s
          }), p.a.createElement("div", {
            className: "dropdown-menu".concat(o ? " show" : "", " w-100").concat(r ? " ".concat(r) : "")
          }, t)));
        }
      }]) && Nn(r.prototype, n), o && Nn(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).defaultProps = {
      tabIndex: "-1"
    }, Rn = Tn)) || Rn;

    function Ln(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Vn(n.key), n);
      }
    }

    function Vn(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Un(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var qn,
        Kn,
        Gn,
        Wn,
        Hn,
        Jn,
        Yn,
        Qn,
        $n,
        Xn,
        Zn = (Fn = Un((In = function () {
      return e = function e(t) {
        if (function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.store = void 0, function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(this, "_activeIndex", Fn, this), this.store = t, !t) throw new Error("ProductSelectModel requires a productsStore");
      }, (t = [{
        key: "_activeProduct",
        get: function () {
          return this.store.filteredProducts[this._activeIndex];
        }
      }, {
        key: "activate",
        value: function (e) {
          this._activeIndex = e;
        }
      }, {
        key: "activateNext",
        value: function () {
          var e;
          null !== (e = this.store.filteredProducts) && void 0 !== e && e.length && (this._activeIndex = this._activeIndex + 1 >= this.store.filteredProducts.length ? 0 : (this._activeIndex + 1) % this.store.filteredProducts.length);
        }
      }, {
        key: "activatePrevious",
        value: function () {
          this._activeIndex = this._activeIndex - 1 < 0 ? this.store.filteredProducts.length - 1 : this._activeIndex - 1;
        }
      }, {
        key: "isActive",
        value: function (e) {
          return e === this._activeProduct;
        }
      }, {
        key: "getActive",
        value: function () {
          return this._activeProduct;
        }
      }, {
        key: "reset",
        value: function () {
          return this.activate(0);
        }
      }]) && Ln(e.prototype, t), r && Ln(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "_activeIndex", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), Un(In.prototype, "_activeProduct", [f.computed], Object.getOwnPropertyDescriptor(In.prototype, "_activeProduct"), In.prototype), Un(In.prototype, "activate", [f.action], Object.getOwnPropertyDescriptor(In.prototype, "activate"), In.prototype), Un(In.prototype, "activateNext", [f.action], Object.getOwnPropertyDescriptor(In.prototype, "activateNext"), In.prototype), Un(In.prototype, "activatePrevious", [f.action], Object.getOwnPropertyDescriptor(In.prototype, "activatePrevious"), In.prototype), In);

    function eo(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function to(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ro(n.key), n);
      }
    }

    function ro(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function no(e, t, r) {
      return t = oo(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], oo(e).constructor) : t.apply(e, r));
    }

    function oo(e) {
      return (oo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function io(e, t) {
      return (io = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ao(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var co,
        uo = Object(d.observer)((Gn = ao((Kn = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), eo(r = no(this, t, [e]), "searchIsFocused", Gn, r), eo(r, "focusSearch", Wn, r), eo(r, "blurSearch", Hn, r), eo(r, "handleArrowDown", Jn, r), eo(r, "handleArrowUp", Yn, r), eo(r, "onSearch", Qn, r), eo(r, "onSearchBarKeyDown", $n, r), eo(r, "onSelectProduct", Xn, r);
        var n = r.props.productsStore;
        return r.productSelectModel = new Zn(n), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && io(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && to(e.prototype, t), r && to(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "showDropdown",
        get: function () {
          var e = this.props.productsStore;
          return this.searchIsFocused && e.filteredProducts.length > 0 && e.searchTerm;
        }
      }, {
        key: "currentProductName",
        get: function () {
          var e = this.props,
              t = e.currentProduct,
              r = e.t;
          return (null == t ? void 0 : t.name) || r("select_product");
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.productsStore,
              n = t.errorMessage,
              o = t.t;
          return p.a.createElement("div", {
            className: "product-selector"
          }, p.a.createElement("div", null, this.searchIsFocused ? p.a.createElement(Bn, {
            dropdownClassName: "product-selector-dropdown",
            searchBarPlaceholder: this.currentProductName || o("select_product"),
            value: this.currentProductName || "",
            showDropdown: this.showDropdown,
            onSearch: this.onSearch,
            onSearchBarKeyDown: this.onSearchBarKeyDown,
            onSearchBarBlur: this.blurSearch,
            onSearchBarFocus: this.focusSearch,
            errorMessage: n,
            className: "form-control my-2".concat(n ? " is-invalid" : "")
          }, r.isPending ? p.a.createElement(h.Spinner, null) : r.filteredSortedProducts.map(function (t, r) {
            return p.a.createElement(zn, {
              activeProduct: e.productSelectModel.getActive(),
              key: t.id,
              product: t,
              index: r,
              onSelectProduct: e.onSelectProduct
            });
          })) : p.a.createElement(p.a.Fragment, null, p.a.createElement("input", {
            type: "text",
            className: "form-control my-2".concat(n ? " is-invalid" : ""),
            placeholder: this.currentProductName,
            value: this.currentProductName,
            onFocus: this.focusSearch,
            onChange: function () {}
          }), p.a.createElement("div", {
            className: "invalid-feedback"
          }, n))));
        }
      }]);
    }()).prototype, "searchIsFocused", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), ao(Kn.prototype, "showDropdown", [f.computed], Object.getOwnPropertyDescriptor(Kn.prototype, "showDropdown"), Kn.prototype), ao(Kn.prototype, "currentProductName", [f.computed], Object.getOwnPropertyDescriptor(Kn.prototype, "currentProductName"), Kn.prototype), Wn = ao(Kn.prototype, "focusSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.searchIsFocused = !0, setTimeout(function () {
            return v()('.product-selector .search-bar input[type="search"]').focus();
          }, 40);
        };
      }
    }), Hn = ao(Kn.prototype, "blurSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.searchIsFocused = !1;
        };
      }
    }), Jn = ao(Kn.prototype, "handleArrowDown", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.showDropdown && e.productSelectModel.activateNext();
        };
      }
    }), Yn = ao(Kn.prototype, "handleArrowUp", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.showDropdown && e.productSelectModel.activatePrevious();
        };
      }
    }), Qn = ao(Kn.prototype, "onSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.productsStore.searchTerm = t.target.value.toLowerCase(), e.focusSearch(), e.productSelectModel.reset();
        };
      }
    }), $n = ao(Kn.prototype, "onSearchBarKeyDown", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onSelectProduct;

          switch (t.key) {
            case "Enter":
              if (!e.showDropdown) return;
              r(e.productSelectModel.getActive());
              break;

            case "Tab":
              if (!e.showDropdown) return;
              t.shiftKey ? r(e.productSelectModel.getActive()) : (t.preventDefault(), r(e.productSelectModel.getActive())), e.blurSearch();
              break;

            case "ArrowUp":
              t.preventDefault(), e.handleArrowUp();
              break;

            case "ArrowDown":
              t.preventDefault(), e.handleArrowDown();
          }
        };
      }
    }), Xn = ao(Kn.prototype, "onSelectProduct", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r) {
          var n = e.props.onSelectProduct;
          e.productSelectModel.activate(r), n(t, !1), e.blurSearch();
        };
      }
    }), qn = Kn)) || qn,
        lo = Object(g.a)()(uo);
    var so = Function.prototype.bind.call(Function.prototype.call, [].slice);

    function po(e, t) {
      return so(e.querySelectorAll(t));
    }

    var fo = !("undefined" == typeof window || !window.document || !window.document.createElement),
        bo = !1,
        yo = !1;

    try {
      var mo = {
        get passive() {
          return bo = !0;
        },

        get once() {
          return yo = bo = !0;
        }

      };
      fo && (window.addEventListener("test", mo, mo), window.removeEventListener("test", mo, !0));
    } catch (e) {}

    var vo = function (e, t, r, n) {
      if (n && "boolean" != typeof n && !yo) {
        var o = n.once,
            i = n.capture,
            a = r;
        !yo && o && (a = r.__once || function e(n) {
          this.removeEventListener(t, e, i), r.call(this, n);
        }, r.__once = a), e.addEventListener(t, a, bo ? n : i);
      }

      e.addEventListener(t, r, n);
    },
        ho = r(9),
        go = r.n(ho);

    r(40);

    function wo(e) {
      return "default" + e.charAt(0).toUpperCase() + e.substr(1);
    }

    function Oo(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : String(t);
    }

    function jo(e, t, r) {
      var n = Object(s.useRef)(void 0 !== e),
          o = Object(s.useState)(t),
          i = o[0],
          a = o[1],
          c = void 0 !== e,
          u = n.current;
      return n.current = c, !c && u && i !== t && a(t), [c ? e : i, Object(s.useCallback)(function (e) {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) n[o - 1] = arguments[o];

        r && r.apply(void 0, [e].concat(n)), a(e);
      }, [r])];
    }

    function Po(e, t) {
      return Object.keys(t).reduce(function (r, n) {
        var o,
            i = r,
            a = i[wo(n)],
            c = i[n],
            u = er(i, [wo(n), n].map(Oo)),
            l = t[n],
            s = jo(c, a, e[l]),
            p = s[0],
            f = s[1];
        return Zt({}, u, ((o = {})[n] = p, o[l] = f, o));
      }, e);
    }

    function _o(e, t) {
      return (_o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Eo(e, t) {
      e.prototype = Object.create(t.prototype), e.prototype.constructor = e, _o(e, t);
    }

    function So() {
      var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
      null != e && this.setState(e);
    }

    function Co(e) {
      this.setState(function (t) {
        var r = this.constructor.getDerivedStateFromProps(e, t);
        return null != r ? r : null;
      }.bind(this));
    }

    function ko(e, t) {
      try {
        var r = this.props,
            n = this.state;
        this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(r, n);
      } finally {
        this.props = r, this.state = n;
      }
    }

    So.__suppressDeprecationWarning = !0, Co.__suppressDeprecationWarning = !0, ko.__suppressDeprecationWarning = !0;

    var Ro = function (e) {
      var t = Object(s.useRef)(e);
      return Object(s.useEffect)(function () {
        t.current = e;
      }, [e]), t;
    };

    function To(e) {
      var t = Ro(e);
      return Object(s.useCallback)(function () {
        return t.current && t.current.apply(t, arguments);
      }, [t]);
    }

    function zo(e, t, r) {
      return void 0 === r && (r = !1), function (e, t, r, n) {
        void 0 === n && (n = !1);
        var o = To(r);
        Object(s.useEffect)(function () {
          var r = "function" == typeof e ? e() : e;
          return r.addEventListener(t, o, n), function () {
            return r.removeEventListener(t, o, n);
          };
        }, [e]);
      }(Object(s.useCallback)(function () {
        return document;
      }, []), e, t, r);
    }

    var No = p.a.createContext(null);

    function Do() {
      return Object(s.useState)(null);
    }

    function xo() {
      var e = Object(s.useRef)(!0),
          t = Object(s.useRef)(function () {
        return e.current;
      });
      return Object(s.useEffect)(function () {
        return e.current = !0, function () {
          e.current = !1;
        };
      }, []), t.current;
    }

    var Ao = function (e) {
      var t = xo();
      return [e[0], Object(s.useCallback)(function (r) {
        if (t()) return e[1](r);
      }, [t, e[1]])];
    };

    function Mo(e) {
      return e.split("-")[0];
    }

    function Io(e) {
      if (null == e) return window;

      if ("[object Window]" !== e.toString()) {
        var t = e.ownerDocument;
        return t && t.defaultView || window;
      }

      return e;
    }

    function Fo(e) {
      return e instanceof Io(e).Element || e instanceof Element;
    }

    function Bo(e) {
      return e instanceof Io(e).HTMLElement || e instanceof HTMLElement;
    }

    function Lo(e) {
      return "undefined" != typeof ShadowRoot && (e instanceof Io(e).ShadowRoot || e instanceof ShadowRoot);
    }

    var Vo = Math.max,
        Uo = Math.min,
        qo = Math.round;

    function Ko(e, t) {
      void 0 === t && (t = !1);
      var r = e.getBoundingClientRect(),
          n = 1,
          o = 1;

      if (Bo(e) && t) {
        var i = e.offsetHeight,
            a = e.offsetWidth;
        a > 0 && (n = qo(r.width) / a || 1), i > 0 && (o = qo(r.height) / i || 1);
      }

      return {
        width: r.width / n,
        height: r.height / o,
        top: r.top / o,
        right: r.right / n,
        bottom: r.bottom / o,
        left: r.left / n,
        x: r.left / n,
        y: r.top / o
      };
    }

    function Go(e) {
      var t = Ko(e),
          r = e.offsetWidth,
          n = e.offsetHeight;
      return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
        x: e.offsetLeft,
        y: e.offsetTop,
        width: r,
        height: n
      };
    }

    function Wo(e, t) {
      var r = t.getRootNode && t.getRootNode();
      if (e.contains(t)) return !0;

      if (r && Lo(r)) {
        var n = t;

        do {
          if (n && e.isSameNode(n)) return !0;
          n = n.parentNode || n.host;
        } while (n);
      }

      return !1;
    }

    function Ho(e) {
      return e ? (e.nodeName || "").toLowerCase() : null;
    }

    function Jo(e) {
      return Io(e).getComputedStyle(e);
    }

    function Yo(e) {
      return ["table", "td", "th"].indexOf(Ho(e)) >= 0;
    }

    function Qo(e) {
      return ((Fo(e) ? e.ownerDocument : e.document) || window.document).documentElement;
    }

    function $o(e) {
      return "html" === Ho(e) ? e : e.assignedSlot || e.parentNode || (Lo(e) ? e.host : null) || Qo(e);
    }

    function Xo(e) {
      return Bo(e) && "fixed" !== Jo(e).position ? e.offsetParent : null;
    }

    function Zo(e) {
      for (var t = Io(e), r = Xo(e); r && Yo(r) && "static" === Jo(r).position;) r = Xo(r);

      return r && ("html" === Ho(r) || "body" === Ho(r) && "static" === Jo(r).position) ? t : r || function (e) {
        var t = -1 !== navigator.userAgent.toLowerCase().indexOf("firefox");
        if (-1 !== navigator.userAgent.indexOf("Trident") && Bo(e) && "fixed" === Jo(e).position) return null;
        var r = $o(e);

        for (Lo(r) && (r = r.host); Bo(r) && ["html", "body"].indexOf(Ho(r)) < 0;) {
          var n = Jo(r);
          if ("none" !== n.transform || "none" !== n.perspective || "paint" === n.contain || -1 !== ["transform", "perspective"].indexOf(n.willChange) || t && "filter" === n.willChange || t && n.filter && "none" !== n.filter) return r;
          r = r.parentNode;
        }

        return null;
      }(e) || t;
    }

    function ei(e) {
      return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
    }

    function ti(e, t, r) {
      return Vo(e, Uo(t, r));
    }

    function ri(e) {
      return Object.assign({}, {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }, e);
    }

    function ni(e, t) {
      return t.reduce(function (t, r) {
        return t[r] = e, t;
      }, {});
    }

    var oi = "top",
        ii = "bottom",
        ai = "right",
        ci = "left",
        ui = "auto",
        li = [oi, ii, ai, ci],
        si = "start",
        pi = "end",
        fi = "clippingParents",
        di = "viewport",
        bi = "popper",
        yi = "reference",
        mi = li.reduce(function (e, t) {
      return e.concat([t + "-" + si, t + "-" + pi]);
    }, []),
        vi = [].concat(li, [ui]).reduce(function (e, t) {
      return e.concat([t, t + "-" + si, t + "-" + pi]);
    }, []),
        hi = ["beforeRead", "read", "afterRead", "beforeMain", "main", "afterMain", "beforeWrite", "write", "afterWrite"],
        gi = function (e, t) {
      return ri("number" != typeof (e = "function" == typeof e ? e(Object.assign({}, t.rects, {
        placement: t.placement
      })) : e) ? e : ni(e, li));
    };

    var wi = {
      name: "arrow",
      enabled: !0,
      phase: "main",
      fn: function (e) {
        var t,
            r = e.state,
            n = e.name,
            o = e.options,
            i = r.elements.arrow,
            a = r.modifiersData.popperOffsets,
            c = Mo(r.placement),
            u = ei(c),
            l = [ci, ai].indexOf(c) >= 0 ? "height" : "width";

        if (i && a) {
          var s = gi(o.padding, r),
              p = Go(i),
              f = "y" === u ? oi : ci,
              d = "y" === u ? ii : ai,
              b = r.rects.reference[l] + r.rects.reference[u] - a[u] - r.rects.popper[l],
              y = a[u] - r.rects.reference[u],
              m = Zo(i),
              v = m ? "y" === u ? m.clientHeight || 0 : m.clientWidth || 0 : 0,
              h = b / 2 - y / 2,
              g = s[f],
              w = v - p[l] - s[d],
              O = v / 2 - p[l] / 2 + h,
              j = ti(g, O, w),
              P = u;
          r.modifiersData[n] = ((t = {})[P] = j, t.centerOffset = j - O, t);
        }
      },
      effect: function (e) {
        var t = e.state,
            r = e.options.element,
            n = void 0 === r ? "[data-popper-arrow]" : r;
        null != n && ("string" != typeof n || (n = t.elements.popper.querySelector(n))) && Wo(t.elements.popper, n) && (t.elements.arrow = n);
      },
      requires: ["popperOffsets"],
      requiresIfExists: ["preventOverflow"]
    };

    function Oi(e) {
      return e.split("-")[1];
    }

    var ji = {
      top: "auto",
      right: "auto",
      bottom: "auto",
      left: "auto"
    };

    function Pi(e) {
      var t,
          r = e.popper,
          n = e.popperRect,
          o = e.placement,
          i = e.variation,
          a = e.offsets,
          c = e.position,
          u = e.gpuAcceleration,
          l = e.adaptive,
          s = e.roundOffsets,
          p = e.isFixed,
          f = a.x,
          d = void 0 === f ? 0 : f,
          b = a.y,
          y = void 0 === b ? 0 : b,
          m = "function" == typeof s ? s({
        x: d,
        y: y
      }) : {
        x: d,
        y: y
      };
      d = m.x, y = m.y;
      var v = a.hasOwnProperty("x"),
          h = a.hasOwnProperty("y"),
          g = ci,
          w = oi,
          O = window;

      if (l) {
        var j = Zo(r),
            P = "clientHeight",
            _ = "clientWidth";
        if (j === Io(r) && "static" !== Jo(j = Qo(r)).position && "absolute" === c && (P = "scrollHeight", _ = "scrollWidth"), j = j, o === oi || (o === ci || o === ai) && i === pi) w = ii, y -= (p && j === O && O.visualViewport ? O.visualViewport.height : j[P]) - n.height, y *= u ? 1 : -1;
        if (o === ci || (o === oi || o === ii) && i === pi) g = ai, d -= (p && j === O && O.visualViewport ? O.visualViewport.width : j[_]) - n.width, d *= u ? 1 : -1;
      }

      var E,
          S = Object.assign({
        position: c
      }, l && ji),
          C = !0 === s ? function (e) {
        var t = e.x,
            r = e.y,
            n = window.devicePixelRatio || 1;
        return {
          x: qo(t * n) / n || 0,
          y: qo(r * n) / n || 0
        };
      }({
        x: d,
        y: y
      }) : {
        x: d,
        y: y
      };
      return d = C.x, y = C.y, u ? Object.assign({}, S, ((E = {})[w] = h ? "0" : "", E[g] = v ? "0" : "", E.transform = (O.devicePixelRatio || 1) <= 1 ? "translate(" + d + "px, " + y + "px)" : "translate3d(" + d + "px, " + y + "px, 0)", E)) : Object.assign({}, S, ((t = {})[w] = h ? y + "px" : "", t[g] = v ? d + "px" : "", t.transform = "", t));
    }

    var _i = {
      name: "computeStyles",
      enabled: !0,
      phase: "beforeWrite",
      fn: function (e) {
        var t = e.state,
            r = e.options,
            n = r.gpuAcceleration,
            o = void 0 === n || n,
            i = r.adaptive,
            a = void 0 === i || i,
            c = r.roundOffsets,
            u = void 0 === c || c,
            l = {
          placement: Mo(t.placement),
          variation: Oi(t.placement),
          popper: t.elements.popper,
          popperRect: t.rects.popper,
          gpuAcceleration: o,
          isFixed: "fixed" === t.options.strategy
        };
        null != t.modifiersData.popperOffsets && (t.styles.popper = Object.assign({}, t.styles.popper, Pi(Object.assign({}, l, {
          offsets: t.modifiersData.popperOffsets,
          position: t.options.strategy,
          adaptive: a,
          roundOffsets: u
        })))), null != t.modifiersData.arrow && (t.styles.arrow = Object.assign({}, t.styles.arrow, Pi(Object.assign({}, l, {
          offsets: t.modifiersData.arrow,
          position: "absolute",
          adaptive: !1,
          roundOffsets: u
        })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
          "data-popper-placement": t.placement
        });
      },
      data: {}
    },
        Ei = {
      passive: !0
    };
    var Si = {
      name: "eventListeners",
      enabled: !0,
      phase: "write",
      fn: function () {},
      effect: function (e) {
        var t = e.state,
            r = e.instance,
            n = e.options,
            o = n.scroll,
            i = void 0 === o || o,
            a = n.resize,
            c = void 0 === a || a,
            u = Io(t.elements.popper),
            l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
        return i && l.forEach(function (e) {
          e.addEventListener("scroll", r.update, Ei);
        }), c && u.addEventListener("resize", r.update, Ei), function () {
          i && l.forEach(function (e) {
            e.removeEventListener("scroll", r.update, Ei);
          }), c && u.removeEventListener("resize", r.update, Ei);
        };
      },
      data: {}
    },
        Ci = {
      left: "right",
      right: "left",
      bottom: "top",
      top: "bottom"
    };

    function ki(e) {
      return e.replace(/left|right|bottom|top/g, function (e) {
        return Ci[e];
      });
    }

    var Ri = {
      start: "end",
      end: "start"
    };

    function Ti(e) {
      return e.replace(/start|end/g, function (e) {
        return Ri[e];
      });
    }

    function zi(e) {
      var t = Io(e);
      return {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
      };
    }

    function Ni(e) {
      return Ko(Qo(e)).left + zi(e).scrollLeft;
    }

    function Di(e) {
      var t = Jo(e),
          r = t.overflow,
          n = t.overflowX,
          o = t.overflowY;
      return /auto|scroll|overlay|hidden/.test(r + o + n);
    }

    function xi(e, t) {
      var r;
      void 0 === t && (t = []);

      var n = function e(t) {
        return ["html", "body", "#document"].indexOf(Ho(t)) >= 0 ? t.ownerDocument.body : Bo(t) && Di(t) ? t : e($o(t));
      }(e),
          o = n === (null == (r = e.ownerDocument) ? void 0 : r.body),
          i = Io(n),
          a = o ? [i].concat(i.visualViewport || [], Di(n) ? n : []) : n,
          c = t.concat(a);

      return o ? c : c.concat(xi($o(a)));
    }

    function Ai(e) {
      return Object.assign({}, e, {
        left: e.x,
        top: e.y,
        right: e.x + e.width,
        bottom: e.y + e.height
      });
    }

    function Mi(e, t) {
      return t === di ? Ai(function (e) {
        var t = Io(e),
            r = Qo(e),
            n = t.visualViewport,
            o = r.clientWidth,
            i = r.clientHeight,
            a = 0,
            c = 0;
        return n && (o = n.width, i = n.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (a = n.offsetLeft, c = n.offsetTop)), {
          width: o,
          height: i,
          x: a + Ni(e),
          y: c
        };
      }(e)) : Fo(t) ? function (e) {
        var t = Ko(e);
        return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
      }(t) : Ai(function (e) {
        var t,
            r = Qo(e),
            n = zi(e),
            o = null == (t = e.ownerDocument) ? void 0 : t.body,
            i = Vo(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0),
            a = Vo(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0),
            c = -n.scrollLeft + Ni(e),
            u = -n.scrollTop;
        return "rtl" === Jo(o || r).direction && (c += Vo(r.clientWidth, o ? o.clientWidth : 0) - i), {
          width: i,
          height: a,
          x: c,
          y: u
        };
      }(Qo(e)));
    }

    function Ii(e, t, r) {
      var n = "clippingParents" === t ? function (e) {
        var t = xi($o(e)),
            r = ["absolute", "fixed"].indexOf(Jo(e).position) >= 0 && Bo(e) ? Zo(e) : e;
        return Fo(r) ? t.filter(function (e) {
          return Fo(e) && Wo(e, r) && "body" !== Ho(e);
        }) : [];
      }(e) : [].concat(t),
          o = [].concat(n, [r]),
          i = o[0],
          a = o.reduce(function (t, r) {
        var n = Mi(e, r);
        return t.top = Vo(n.top, t.top), t.right = Uo(n.right, t.right), t.bottom = Uo(n.bottom, t.bottom), t.left = Vo(n.left, t.left), t;
      }, Mi(e, i));
      return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
    }

    function Fi(e) {
      var t,
          r = e.reference,
          n = e.element,
          o = e.placement,
          i = o ? Mo(o) : null,
          a = o ? Oi(o) : null,
          c = r.x + r.width / 2 - n.width / 2,
          u = r.y + r.height / 2 - n.height / 2;

      switch (i) {
        case oi:
          t = {
            x: c,
            y: r.y - n.height
          };
          break;

        case ii:
          t = {
            x: c,
            y: r.y + r.height
          };
          break;

        case ai:
          t = {
            x: r.x + r.width,
            y: u
          };
          break;

        case ci:
          t = {
            x: r.x - n.width,
            y: u
          };
          break;

        default:
          t = {
            x: r.x,
            y: r.y
          };
      }

      var l = i ? ei(i) : null;

      if (null != l) {
        var s = "y" === l ? "height" : "width";

        switch (a) {
          case si:
            t[l] = t[l] - (r[s] / 2 - n[s] / 2);
            break;

          case pi:
            t[l] = t[l] + (r[s] / 2 - n[s] / 2);
        }
      }

      return t;
    }

    function Bi(e, t) {
      void 0 === t && (t = {});
      var r = t,
          n = r.placement,
          o = void 0 === n ? e.placement : n,
          i = r.boundary,
          a = void 0 === i ? fi : i,
          c = r.rootBoundary,
          u = void 0 === c ? di : c,
          l = r.elementContext,
          s = void 0 === l ? bi : l,
          p = r.altBoundary,
          f = void 0 !== p && p,
          d = r.padding,
          b = void 0 === d ? 0 : d,
          y = ri("number" != typeof b ? b : ni(b, li)),
          m = s === bi ? yi : bi,
          v = e.rects.popper,
          h = e.elements[f ? m : s],
          g = Ii(Fo(h) ? h : h.contextElement || Qo(e.elements.popper), a, u),
          w = Ko(e.elements.reference),
          O = Fi({
        reference: w,
        element: v,
        strategy: "absolute",
        placement: o
      }),
          j = Ai(Object.assign({}, v, O)),
          P = s === bi ? j : w,
          _ = {
        top: g.top - P.top + y.top,
        bottom: P.bottom - g.bottom + y.bottom,
        left: g.left - P.left + y.left,
        right: P.right - g.right + y.right
      },
          E = e.modifiersData.offset;

      if (s === bi && E) {
        var S = E[o];
        Object.keys(_).forEach(function (e) {
          var t = [ai, ii].indexOf(e) >= 0 ? 1 : -1,
              r = [oi, ii].indexOf(e) >= 0 ? "y" : "x";
          _[e] += S[r] * t;
        });
      }

      return _;
    }

    var Li = {
      name: "flip",
      enabled: !0,
      phase: "main",
      fn: function (e) {
        var t = e.state,
            r = e.options,
            n = e.name;

        if (!t.modifiersData[n]._skip) {
          for (var o = r.mainAxis, i = void 0 === o || o, a = r.altAxis, c = void 0 === a || a, u = r.fallbackPlacements, l = r.padding, s = r.boundary, p = r.rootBoundary, f = r.altBoundary, d = r.flipVariations, b = void 0 === d || d, y = r.allowedAutoPlacements, m = t.options.placement, v = Mo(m), h = u || (v === m || !b ? [ki(m)] : function (e) {
            if (Mo(e) === ui) return [];
            var t = ki(e);
            return [Ti(e), t, Ti(t)];
          }(m)), g = [m].concat(h).reduce(function (e, r) {
            return e.concat(Mo(r) === ui ? function (e, t) {
              void 0 === t && (t = {});
              var r = t,
                  n = r.placement,
                  o = r.boundary,
                  i = r.rootBoundary,
                  a = r.padding,
                  c = r.flipVariations,
                  u = r.allowedAutoPlacements,
                  l = void 0 === u ? vi : u,
                  s = Oi(n),
                  p = s ? c ? mi : mi.filter(function (e) {
                return Oi(e) === s;
              }) : li,
                  f = p.filter(function (e) {
                return l.indexOf(e) >= 0;
              });
              0 === f.length && (f = p);
              var d = f.reduce(function (t, r) {
                return t[r] = Bi(e, {
                  placement: r,
                  boundary: o,
                  rootBoundary: i,
                  padding: a
                })[Mo(r)], t;
              }, {});
              return Object.keys(d).sort(function (e, t) {
                return d[e] - d[t];
              });
            }(t, {
              placement: r,
              boundary: s,
              rootBoundary: p,
              padding: l,
              flipVariations: b,
              allowedAutoPlacements: y
            }) : r);
          }, []), w = t.rects.reference, O = t.rects.popper, j = new Map(), P = !0, _ = g[0], E = 0; E < g.length; E++) {
            var S = g[E],
                C = Mo(S),
                k = Oi(S) === si,
                R = [oi, ii].indexOf(C) >= 0,
                T = R ? "width" : "height",
                z = Bi(t, {
              placement: S,
              boundary: s,
              rootBoundary: p,
              altBoundary: f,
              padding: l
            }),
                N = R ? k ? ai : ci : k ? ii : oi;
            w[T] > O[T] && (N = ki(N));
            var D = ki(N),
                x = [];

            if (i && x.push(z[C] <= 0), c && x.push(z[N] <= 0, z[D] <= 0), x.every(function (e) {
              return e;
            })) {
              _ = S, P = !1;
              break;
            }

            j.set(S, x);
          }

          if (P) for (var A = function (e) {
            var t = g.find(function (t) {
              var r = j.get(t);
              if (r) return r.slice(0, e).every(function (e) {
                return e;
              });
            });
            if (t) return _ = t, "break";
          }, M = b ? 3 : 1; M > 0; M--) {
            if ("break" === A(M)) break;
          }
          t.placement !== _ && (t.modifiersData[n]._skip = !0, t.placement = _, t.reset = !0);
        }
      },
      requiresIfExists: ["offset"],
      data: {
        _skip: !1
      }
    };

    function Vi(e, t, r) {
      return void 0 === r && (r = {
        x: 0,
        y: 0
      }), {
        top: e.top - t.height - r.y,
        right: e.right - t.width + r.x,
        bottom: e.bottom - t.height + r.y,
        left: e.left - t.width - r.x
      };
    }

    function Ui(e) {
      return [oi, ai, ii, ci].some(function (t) {
        return e[t] >= 0;
      });
    }

    var qi = {
      name: "hide",
      enabled: !0,
      phase: "main",
      requiresIfExists: ["preventOverflow"],
      fn: function (e) {
        var t = e.state,
            r = e.name,
            n = t.rects.reference,
            o = t.rects.popper,
            i = t.modifiersData.preventOverflow,
            a = Bi(t, {
          elementContext: "reference"
        }),
            c = Bi(t, {
          altBoundary: !0
        }),
            u = Vi(a, n),
            l = Vi(c, o, i),
            s = Ui(u),
            p = Ui(l);
        t.modifiersData[r] = {
          referenceClippingOffsets: u,
          popperEscapeOffsets: l,
          isReferenceHidden: s,
          hasPopperEscaped: p
        }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
          "data-popper-reference-hidden": s,
          "data-popper-escaped": p
        });
      }
    };
    var Ki = {
      name: "offset",
      enabled: !0,
      phase: "main",
      requires: ["popperOffsets"],
      fn: function (e) {
        var t = e.state,
            r = e.options,
            n = e.name,
            o = r.offset,
            i = void 0 === o ? [0, 0] : o,
            a = vi.reduce(function (e, r) {
          return e[r] = function (e, t, r) {
            var n = Mo(e),
                o = [ci, oi].indexOf(n) >= 0 ? -1 : 1,
                i = "function" == typeof r ? r(Object.assign({}, t, {
              placement: e
            })) : r,
                a = i[0],
                c = i[1];
            return a = a || 0, c = (c || 0) * o, [ci, ai].indexOf(n) >= 0 ? {
              x: c,
              y: a
            } : {
              x: a,
              y: c
            };
          }(r, t.rects, i), e;
        }, {}),
            c = a[t.placement],
            u = c.x,
            l = c.y;
        null != t.modifiersData.popperOffsets && (t.modifiersData.popperOffsets.x += u, t.modifiersData.popperOffsets.y += l), t.modifiersData[n] = a;
      }
    };
    var Gi = {
      name: "popperOffsets",
      enabled: !0,
      phase: "read",
      fn: function (e) {
        var t = e.state,
            r = e.name;
        t.modifiersData[r] = Fi({
          reference: t.rects.reference,
          element: t.rects.popper,
          strategy: "absolute",
          placement: t.placement
        });
      },
      data: {}
    };
    var Wi = {
      name: "preventOverflow",
      enabled: !0,
      phase: "main",
      fn: function (e) {
        var t = e.state,
            r = e.options,
            n = e.name,
            o = r.mainAxis,
            i = void 0 === o || o,
            a = r.altAxis,
            c = void 0 !== a && a,
            u = r.boundary,
            l = r.rootBoundary,
            s = r.altBoundary,
            p = r.padding,
            f = r.tether,
            d = void 0 === f || f,
            b = r.tetherOffset,
            y = void 0 === b ? 0 : b,
            m = Bi(t, {
          boundary: u,
          rootBoundary: l,
          padding: p,
          altBoundary: s
        }),
            v = Mo(t.placement),
            h = Oi(t.placement),
            g = !h,
            w = ei(v),
            O = "x" === w ? "y" : "x",
            j = t.modifiersData.popperOffsets,
            P = t.rects.reference,
            _ = t.rects.popper,
            E = "function" == typeof y ? y(Object.assign({}, t.rects, {
          placement: t.placement
        })) : y,
            S = "number" == typeof E ? {
          mainAxis: E,
          altAxis: E
        } : Object.assign({
          mainAxis: 0,
          altAxis: 0
        }, E),
            C = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null,
            k = {
          x: 0,
          y: 0
        };

        if (j) {
          if (i) {
            var R,
                T = "y" === w ? oi : ci,
                z = "y" === w ? ii : ai,
                N = "y" === w ? "height" : "width",
                D = j[w],
                x = D + m[T],
                A = D - m[z],
                M = d ? -_[N] / 2 : 0,
                I = h === si ? P[N] : _[N],
                F = h === si ? -_[N] : -P[N],
                B = t.elements.arrow,
                L = d && B ? Go(B) : {
              width: 0,
              height: 0
            },
                V = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
                U = V[T],
                q = V[z],
                K = ti(0, P[N], L[N]),
                G = g ? P[N] / 2 - M - K - U - S.mainAxis : I - K - U - S.mainAxis,
                W = g ? -P[N] / 2 + M + K + q + S.mainAxis : F + K + q + S.mainAxis,
                H = t.elements.arrow && Zo(t.elements.arrow),
                J = H ? "y" === w ? H.clientTop || 0 : H.clientLeft || 0 : 0,
                Y = null != (R = null == C ? void 0 : C[w]) ? R : 0,
                Q = D + W - Y,
                $ = ti(d ? Uo(x, D + G - Y - J) : x, D, d ? Vo(A, Q) : A);
            j[w] = $, k[w] = $ - D;
          }

          if (c) {
            var X,
                Z = "x" === w ? oi : ci,
                ee = "x" === w ? ii : ai,
                te = j[O],
                re = "y" === O ? "height" : "width",
                ne = te + m[Z],
                oe = te - m[ee],
                ie = -1 !== [oi, ci].indexOf(v),
                ae = null != (X = null == C ? void 0 : C[O]) ? X : 0,
                ce = ie ? ne : te - P[re] - _[re] - ae + S.altAxis,
                ue = ie ? te + P[re] + _[re] - ae - S.altAxis : oe,
                le = d && ie ? function (e, t, r) {
              var n = ti(e, t, r);
              return n > r ? r : n;
            }(ce, te, ue) : ti(d ? ce : ne, te, d ? ue : oe);
            j[O] = le, k[O] = le - te;
          }

          t.modifiersData[n] = k;
        }
      },
      requiresIfExists: ["offset"]
    };

    function Hi(e, t, r) {
      void 0 === r && (r = !1);

      var n,
          o,
          i = Bo(t),
          a = Bo(t) && function (e) {
        var t = e.getBoundingClientRect(),
            r = qo(t.width) / e.offsetWidth || 1,
            n = qo(t.height) / e.offsetHeight || 1;
        return 1 !== r || 1 !== n;
      }(t),
          c = Qo(t),
          u = Ko(e, a),
          l = {
        scrollLeft: 0,
        scrollTop: 0
      },
          s = {
        x: 0,
        y: 0
      };

      return (i || !i && !r) && (("body" !== Ho(t) || Di(c)) && (l = (n = t) !== Io(n) && Bo(n) ? {
        scrollLeft: (o = n).scrollLeft,
        scrollTop: o.scrollTop
      } : zi(n)), Bo(t) ? ((s = Ko(t, !0)).x += t.clientLeft, s.y += t.clientTop) : c && (s.x = Ni(c))), {
        x: u.left + l.scrollLeft - s.x,
        y: u.top + l.scrollTop - s.y,
        width: u.width,
        height: u.height
      };
    }

    function Ji(e) {
      var t = new Map(),
          r = new Set(),
          n = [];
      return e.forEach(function (e) {
        t.set(e.name, e);
      }), e.forEach(function (e) {
        r.has(e.name) || function e(o) {
          r.add(o.name), [].concat(o.requires || [], o.requiresIfExists || []).forEach(function (n) {
            if (!r.has(n)) {
              var o = t.get(n);
              o && e(o);
            }
          }), n.push(o);
        }(e);
      }), n;
    }

    var Yi = {
      placement: "bottom",
      modifiers: [],
      strategy: "absolute"
    };

    function Qi() {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

      return !t.some(function (e) {
        return !(e && "function" == typeof e.getBoundingClientRect);
      });
    }

    function $i(e) {
      void 0 === e && (e = {});
      var t = e,
          r = t.defaultModifiers,
          n = void 0 === r ? [] : r,
          o = t.defaultOptions,
          i = void 0 === o ? Yi : o;
      return function (e, t, r) {
        void 0 === r && (r = i);
        var o,
            a,
            c = {
          placement: "bottom",
          orderedModifiers: [],
          options: Object.assign({}, Yi, i),
          modifiersData: {},
          elements: {
            reference: e,
            popper: t
          },
          attributes: {},
          styles: {}
        },
            u = [],
            l = !1,
            s = {
          state: c,
          setOptions: function (r) {
            var o = "function" == typeof r ? r(c.options) : r;
            p(), c.options = Object.assign({}, i, c.options, o), c.scrollParents = {
              reference: Fo(e) ? xi(e) : e.contextElement ? xi(e.contextElement) : [],
              popper: xi(t)
            };

            var a = function (e) {
              var t = Ji(e);
              return hi.reduce(function (e, r) {
                return e.concat(t.filter(function (e) {
                  return e.phase === r;
                }));
              }, []);
            }(function (e) {
              var t = e.reduce(function (e, t) {
                var r = e[t.name];
                return e[t.name] = r ? Object.assign({}, r, t, {
                  options: Object.assign({}, r.options, t.options),
                  data: Object.assign({}, r.data, t.data)
                }) : t, e;
              }, {});
              return Object.keys(t).map(function (e) {
                return t[e];
              });
            }([].concat(n, c.options.modifiers)));

            return c.orderedModifiers = a.filter(function (e) {
              return e.enabled;
            }), c.orderedModifiers.forEach(function (e) {
              var t = e.name,
                  r = e.options,
                  n = void 0 === r ? {} : r,
                  o = e.effect;

              if ("function" == typeof o) {
                var i = o({
                  state: c,
                  name: t,
                  instance: s,
                  options: n
                });
                u.push(i || function () {});
              }
            }), s.update();
          },
          forceUpdate: function () {
            if (!l) {
              var e = c.elements,
                  t = e.reference,
                  r = e.popper;

              if (Qi(t, r)) {
                c.rects = {
                  reference: Hi(t, Zo(r), "fixed" === c.options.strategy),
                  popper: Go(r)
                }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function (e) {
                  return c.modifiersData[e.name] = Object.assign({}, e.data);
                });

                for (var n = 0; n < c.orderedModifiers.length; n++) if (!0 !== c.reset) {
                  var o = c.orderedModifiers[n],
                      i = o.fn,
                      a = o.options,
                      u = void 0 === a ? {} : a,
                      p = o.name;
                  "function" == typeof i && (c = i({
                    state: c,
                    options: u,
                    name: p,
                    instance: s
                  }) || c);
                } else c.reset = !1, n = -1;
              }
            }
          },
          update: (o = function () {
            return new Promise(function (e) {
              s.forceUpdate(), e(c);
            });
          }, function () {
            return a || (a = new Promise(function (e) {
              Promise.resolve().then(function () {
                a = void 0, e(o());
              });
            })), a;
          }),
          destroy: function () {
            p(), l = !0;
          }
        };
        if (!Qi(e, t)) return s;

        function p() {
          u.forEach(function (e) {
            return e();
          }), u = [];
        }

        return s.setOptions(r).then(function (e) {
          !l && r.onFirstUpdate && r.onFirstUpdate(e);
        }), s;
      };
    }

    var Xi = $i({
      defaultModifiers: [qi, Gi, _i, Si, Ki, Li, Wi, wi]
    }),
        Zi = function (e) {
      return {
        position: e,
        top: "0",
        left: "0",
        opacity: "0",
        pointerEvents: "none"
      };
    },
        ea = {
      name: "applyStyles",
      enabled: !1
    },
        ta = {
      name: "ariaDescribedBy",
      enabled: !0,
      phase: "afterWrite",
      effect: function (e) {
        var t = e.state;
        return function () {
          var e = t.elements,
              r = e.reference,
              n = e.popper;

          if ("removeAttribute" in r) {
            var o = (r.getAttribute("aria-describedby") || "").split(",").filter(function (e) {
              return e.trim() !== n.id;
            });
            o.length ? r.setAttribute("aria-describedby", o.join(",")) : r.removeAttribute("aria-describedby");
          }
        };
      },
      fn: function (e) {
        var t,
            r = e.state.elements,
            n = r.popper,
            o = r.reference,
            i = null == (t = n.getAttribute("role")) ? void 0 : t.toLowerCase();

        if (n.id && "tooltip" === i && "setAttribute" in o) {
          var a = o.getAttribute("aria-describedby");
          if (a && -1 !== a.split(",").indexOf(n.id)) return;
          o.setAttribute("aria-describedby", a ? a + "," + n.id : n.id);
        }
      }
    },
        ra = [];

    var na = function (e, t, r) {
      var n = void 0 === r ? {} : r,
          o = n.enabled,
          i = void 0 === o || o,
          a = n.placement,
          c = void 0 === a ? "bottom" : a,
          u = n.strategy,
          l = void 0 === u ? "absolute" : u,
          p = n.modifiers,
          f = void 0 === p ? ra : p,
          d = er(n, ["enabled", "placement", "strategy", "modifiers"]),
          b = Object(s.useRef)(),
          y = Object(s.useCallback)(function () {
        var e;
        null == (e = b.current) || e.update();
      }, []),
          m = Object(s.useCallback)(function () {
        var e;
        null == (e = b.current) || e.forceUpdate();
      }, []),
          v = Ao(Object(s.useState)({
        placement: c,
        update: y,
        forceUpdate: m,
        attributes: {},
        styles: {
          popper: Zi(l),
          arrow: {}
        }
      })),
          h = v[0],
          g = v[1],
          w = Object(s.useMemo)(function () {
        return {
          name: "updateStateModifier",
          enabled: !0,
          phase: "write",
          requires: ["computeStyles"],
          fn: function (e) {
            var t = e.state,
                r = {},
                n = {};
            Object.keys(t.elements).forEach(function (e) {
              r[e] = t.styles[e], n[e] = t.attributes[e];
            }), g({
              state: t,
              styles: r,
              attributes: n,
              update: y,
              forceUpdate: m,
              placement: t.placement
            });
          }
        };
      }, [y, m, g]);
      return Object(s.useEffect)(function () {
        b.current && i && b.current.setOptions({
          placement: c,
          strategy: l,
          modifiers: [].concat(f, [w, ea])
        });
      }, [l, c, w, i]), Object(s.useEffect)(function () {
        if (i && null != e && null != t) return b.current = Xi(e, t, Zt({}, d, {
          placement: c,
          strategy: l,
          modifiers: [].concat(f, [ta, w])
        })), function () {
          null != b.current && (b.current.destroy(), b.current = void 0, g(function (e) {
            return Zt({}, e, {
              attributes: {},
              styles: {
                popper: Zi(l)
              }
            });
          }));
        };
      }, [i, e, t]), h;
    };

    function oa(e, t) {
      return e.contains ? e.contains(t) : e.compareDocumentPosition ? e === t || !!(16 & e.compareDocumentPosition(t)) : void 0;
    }

    var ia = function (e, t, r, n) {
      var o = n && "boolean" != typeof n ? n.capture : n;
      e.removeEventListener(t, r, o), r.__once && e.removeEventListener(t, r.__once, o);
    };

    var aa = function (e, t, r, n) {
      return vo(e, t, r, n), function () {
        ia(e, t, r, n);
      };
    },
        ca = r(56),
        ua = r.n(ca);

    function la(e) {
      return e && e.ownerDocument || document;
    }

    var sa = r(23),
        pa = r.n(sa);

    function fa(e) {
      return e && "setState" in e ? pa.a.findDOMNode(e) : null != e ? e : null;
    }

    var da = function (e) {
      return la(fa(e));
    },
        ba = 27,
        ya = function () {};

    var ma = function (e) {
      return e && ("current" in e ? e.current : e);
    };

    var va = function (e, t, r) {
      var n = void 0 === r ? {} : r,
          o = n.disabled,
          i = n.clickTrigger,
          a = void 0 === i ? "click" : i,
          c = Object(s.useRef)(!1),
          u = t || ya,
          l = Object(s.useCallback)(function (t) {
        var r,
            n,
            o = ma(e);
        ua()(!!o, "RootClose captured a close event but does not have a ref to compare it to. useRootClose(), should be passed a ref that resolves to a DOM node"), c.current = !(o && (n = t, !(n.metaKey || n.altKey || n.ctrlKey || n.shiftKey)) && function (e) {
          return 0 === e.button;
        }(t) && !oa(o, null != (r = null == t.composedPath ? void 0 : t.composedPath()[0]) ? r : t.target));
      }, [e]),
          p = To(function (e) {
        c.current || u(e);
      }),
          f = To(function (e) {
        e.keyCode === ba && u(e);
      });
      Object(s.useEffect)(function () {
        if (!o && null != e) {
          var t = window.event,
              r = da(ma(e)),
              n = aa(r, a, l, !0),
              i = aa(r, a, function (e) {
            e !== t ? p(e) : t = void 0;
          }),
              c = aa(r, "keyup", function (e) {
            e !== t ? f(e) : t = void 0;
          }),
              u = [];
          return "ontouchstart" in r.documentElement && (u = [].slice.call(r.body.children).map(function (e) {
            return aa(e, "mousemove", ya);
          })), function () {
            n(), i(), c(), u.forEach(function (e) {
              return e();
            });
          };
        }
      }, [e, o, a, l, p, f]);
    };

    function ha(e) {
      var t,
          r,
          n,
          o,
          i,
          a = e.enabled,
          c = e.enableEvents,
          u = e.placement,
          l = e.flip,
          s = e.offset,
          p = e.fixed,
          f = e.containerPadding,
          d = e.arrowElement,
          b = e.popperConfig,
          y = void 0 === b ? {} : b,
          m = function (e) {
        var t = {};
        return Array.isArray(e) ? (null == e || e.forEach(function (e) {
          t[e.name] = e;
        }), t) : e || t;
      }(y.modifiers);

      return Zt({}, y, {
        placement: u,
        enabled: a,
        strategy: p ? "fixed" : y.strategy,
        modifiers: (i = Zt({}, m, {
          eventListeners: {
            enabled: c
          },
          preventOverflow: Zt({}, m.preventOverflow, {
            options: f ? Zt({
              padding: f
            }, null == (t = m.preventOverflow) ? void 0 : t.options) : null == (r = m.preventOverflow) ? void 0 : r.options
          }),
          offset: {
            options: Zt({
              offset: s
            }, null == (n = m.offset) ? void 0 : n.options)
          },
          arrow: Zt({}, m.arrow, {
            enabled: !!d,
            options: Zt({}, null == (o = m.arrow) ? void 0 : o.options, {
              element: d
            })
          }),
          flip: Zt({
            enabled: !!l
          }, m.flip)
        }), void 0 === i && (i = {}), Array.isArray(i) ? i : Object.keys(i).map(function (e) {
          return i[e].name = e, i[e];
        }))
      });
    }

    var ga = function () {};

    function wa(e) {
      void 0 === e && (e = {});
      var t = Object(s.useContext)(No),
          r = Do(),
          n = r[0],
          o = r[1],
          i = Object(s.useRef)(!1),
          a = e,
          c = a.flip,
          u = a.offset,
          l = a.rootCloseEvent,
          p = a.fixed,
          f = void 0 !== p && p,
          d = a.popperConfig,
          b = void 0 === d ? {} : d,
          y = a.usePopper,
          m = void 0 === y ? !!t : y,
          v = null == (null == t ? void 0 : t.show) ? !!e.show : t.show,
          h = null == (null == t ? void 0 : t.alignEnd) ? e.alignEnd : t.alignEnd;
      v && !i.current && (i.current = !0);

      var g = t || {},
          w = g.drop,
          O = g.setMenu,
          j = g.menuElement,
          P = g.toggleElement,
          _ = h ? "bottom-end" : "bottom-start";

      "up" === w ? _ = h ? "top-end" : "top-start" : "right" === w ? _ = h ? "right-end" : "right-start" : "left" === w && (_ = h ? "left-end" : "left-start");
      var E = na(P, j, ha({
        placement: _,
        enabled: !(!m || !v),
        enableEvents: v,
        offset: u,
        flip: c,
        fixed: f,
        arrowElement: n,
        popperConfig: b
      })),
          S = Zt({
        ref: O || ga,
        "aria-labelledby": null == P ? void 0 : P.id
      }, E.attributes.popper, {
        style: E.styles.popper
      }),
          C = {
        show: v,
        alignEnd: h,
        hasShown: i.current,
        toggle: null == t ? void 0 : t.toggle,
        popper: m ? E : null,
        arrowProps: m ? Zt({
          ref: o
        }, E.attributes.arrow, {
          style: E.styles.arrow
        }) : {}
      };
      return va(j, function (e) {
        null == t || t.toggle(!1, e);
      }, {
        clickTrigger: l,
        disabled: !v
      }), [S, C];
    }

    var Oa = {
      children: go.a.func.isRequired,
      show: go.a.bool,
      alignEnd: go.a.bool,
      flip: go.a.bool,
      usePopper: go.a.oneOf([!0, !1]),
      popperConfig: go.a.object,
      rootCloseEvent: go.a.string
    };

    function ja(e) {
      var t = e.children,
          r = wa(er(e, ["children"])),
          n = r[0],
          o = r[1];
      return p.a.createElement(p.a.Fragment, null, o.hasShown ? t(n, o) : null);
    }

    ja.displayName = "ReactOverlaysDropdownMenu", ja.propTypes = Oa, ja.defaultProps = {
      usePopper: !0
    };

    var Pa = ja,
        _a = function () {};

    function Ea() {
      var e = Object(s.useContext)(No) || {},
          t = e.show,
          r = void 0 !== t && t,
          n = e.toggle,
          o = void 0 === n ? _a : n,
          i = e.setToggle,
          a = Object(s.useCallback)(function (e) {
        o(!r, e);
      }, [r, o]);
      return [{
        ref: i || _a,
        onClick: a,
        "aria-haspopup": !0,
        "aria-expanded": !!r
      }, {
        show: r,
        toggle: o
      }];
    }

    var Sa = {
      children: go.a.func.isRequired
    };

    function Ca(e) {
      var t = e.children,
          r = Ea(),
          n = r[0],
          o = r[1];
      return p.a.createElement(p.a.Fragment, null, t(n, o));
    }

    Ca.displayName = "ReactOverlaysDropdownToggle", Ca.propTypes = Sa;
    var ka = Ca,
        Ra = {
      children: go.a.node,
      drop: go.a.oneOf(["up", "left", "right", "down"]),
      focusFirstItemOnShow: go.a.oneOf([!1, !0, "keyboard"]),
      itemSelector: go.a.string,
      alignEnd: go.a.bool,
      show: go.a.bool,
      defaultShow: go.a.bool,
      onToggle: go.a.func
    };

    function Ta() {
      var e = Object(s.useReducer)(function (e) {
        return !e;
      }, !1)[1],
          t = Object(s.useRef)(null),
          r = Object(s.useCallback)(function (r) {
        t.current = r, e();
      }, [e]);
      return [t, r];
    }

    function za(e) {
      var t,
          r,
          n = e.drop,
          o = e.alignEnd,
          i = e.defaultShow,
          a = e.show,
          c = e.onToggle,
          u = e.itemSelector,
          l = void 0 === u ? "* > *" : u,
          f = e.focusFirstItemOnShow,
          d = e.children,
          b = jo(a, i, c),
          y = b[0],
          m = b[1],
          v = Ta(),
          h = v[0],
          g = v[1],
          w = h.current,
          O = Ta(),
          j = O[0],
          P = O[1],
          _ = j.current,
          E = (t = y, r = Object(s.useRef)(null), Object(s.useEffect)(function () {
        r.current = t;
      }), r.current),
          S = Object(s.useRef)(null),
          C = Object(s.useRef)(!1),
          k = Object(s.useCallback)(function (e, t) {
        m(e, t);
      }, [m]),
          R = Object(s.useMemo)(function () {
        return {
          toggle: k,
          drop: n,
          show: y,
          alignEnd: o,
          menuElement: w,
          toggleElement: _,
          setMenu: g,
          setToggle: P
        };
      }, [k, n, y, o, w, _, g, P]);
      w && E && !y && (C.current = w.contains(document.activeElement));
      var T = To(function () {
        _ && _.focus && _.focus();
      }),
          z = To(function () {
        var e = S.current,
            t = f;

        if (null == t && (t = !(!h.current || !function (e, t) {
          if (!co) {
            var r = document.body,
                n = r.matches || r.matchesSelector || r.webkitMatchesSelector || r.mozMatchesSelector || r.msMatchesSelector;

            co = function (e, t) {
              return n.call(e, t);
            };
          }

          return co(e, t);
        }(h.current, "[role=menu]")) && "keyboard"), !1 !== t && ("keyboard" !== t || /^key.+$/.test(e))) {
          var r = po(h.current, l)[0];
          r && r.focus && r.focus();
        }
      });
      Object(s.useEffect)(function () {
        y ? z() : C.current && (C.current = !1, T());
      }, [y, C, T, z]), Object(s.useEffect)(function () {
        S.current = null;
      });

      var N = function (e, t) {
        if (!h.current) return null;
        var r = po(h.current, l),
            n = r.indexOf(e) + t;
        return r[n = Math.max(0, Math.min(n, r.length))];
      };

      return zo("keydown", function (e) {
        var t,
            r,
            n = e.key,
            o = e.target,
            i = null == (t = h.current) ? void 0 : t.contains(o),
            a = null == (r = j.current) ? void 0 : r.contains(o);
        if ((!/input|textarea/i.test(o.tagName) || !(" " === n || "Escape" !== n && i)) && (i || a) && (h.current || "Tab" !== n)) switch (S.current = e.type, n) {
          case "ArrowUp":
            var c = N(o, -1);
            return c && c.focus && c.focus(), void e.preventDefault();

          case "ArrowDown":
            if (e.preventDefault(), y) {
              var u = N(o, 1);
              u && u.focus && u.focus();
            } else m(!0, e);

            return;

          case "Tab":
            vo(document, "keyup", function (t) {
              var r;
              ("Tab" !== t.key || t.target) && null != (r = h.current) && r.contains(t.target) || m(!1, e);
            }, {
              once: !0
            });
            break;

          case "Escape":
            e.preventDefault(), e.stopPropagation(), m(!1, e);
        }
      }), p.a.createElement(No.Provider, {
        value: R
      }, d);
    }

    za.displayName = "ReactOverlaysDropdown", za.propTypes = Ra, za.Menu = Pa, za.Toggle = ka;

    var Na = za,
        Da = function (e, t) {
      return void 0 === t && (t = null), null != e ? String(e) : t || null;
    },
        xa = p.a.createContext(null),
        Aa = p.a.createContext(null);

    Aa.displayName = "NavContext";
    var Ma = Aa;

    var Ia = function () {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

      return t.filter(function (e) {
        return null != e;
      }).reduce(function (e, t) {
        if ("function" != typeof t) throw new Error("Invalid Argument Type, must only provide functions, undefined, or null.");
        return null === e ? t : function () {
          for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

          e.apply(this, n), t.apply(this, n);
        };
      }, null);
    },
        Fa = ["as", "disabled", "onKeyDown"];

    function Ba(e) {
      return !e || "#" === e.trim();
    }

    var La = p.a.forwardRef(function (e, t) {
      var r = e.as,
          n = void 0 === r ? "a" : r,
          o = e.disabled,
          i = e.onKeyDown,
          a = er(e, Fa),
          c = function (e) {
        var t = a.href,
            r = a.onClick;
        (o || Ba(t)) && e.preventDefault(), o ? e.stopPropagation() : r && r(e);
      };

      return Ba(a.href) && (a.role = a.role || "button", a.href = a.href || "#"), o && (a.tabIndex = -1, a["aria-disabled"] = !0), p.a.createElement(n, Zt({
        ref: t
      }, a, {
        onClick: c,
        onKeyDown: Ia(function (e) {
          " " === e.key && (e.preventDefault(), c(e));
        }, i)
      }));
    });
    La.displayName = "SafeAnchor";
    var Va = La,
        Ua = ["bsPrefix", "className", "children", "eventKey", "disabled", "href", "onClick", "onSelect", "active", "as"],
        qa = {
      as: Va,
      disabled: !1
    },
        Ka = p.a.forwardRef(function (e, t) {
      var r = e.bsPrefix,
          n = e.className,
          o = e.children,
          i = e.eventKey,
          a = e.disabled,
          c = e.href,
          u = e.onClick,
          l = e.onSelect,
          f = e.active,
          d = e.as,
          b = er(e, Ua),
          y = or(r, "dropdown-item"),
          m = Object(s.useContext)(xa),
          v = (Object(s.useContext)(Ma) || {}).activeKey,
          h = Da(i, c),
          g = null == f && null != h ? Da(v) === h : f,
          w = To(function (e) {
        a || (u && u(e), m && m(h, e), l && l(h, e));
      });
      return p.a.createElement(d, Zt({}, b, {
        ref: t,
        href: c,
        disabled: a,
        className: rr()(n, y, g && "active", a && "disabled"),
        onClick: w
      }), o);
    });
    Ka.displayName = "DropdownItem", Ka.defaultProps = qa;

    var Ga = Ka,
        Wa = function (e) {
      return e && "function" != typeof e ? function (t) {
        e.current = t;
      } : e;
    };

    var Ha = function (e, t) {
      return Object(s.useMemo)(function () {
        return function (e, t) {
          var r = Wa(e),
              n = Wa(t);
          return function (e) {
            r && r(e), n && n(e);
          };
        }(e, t);
      }, [e, t]);
    },
        Ja = p.a.createContext(null);

    Ja.displayName = "NavbarContext";
    var Ya = Ja;

    function Qa(e, t) {
      return e;
    }

    function $a(e, t) {
      return e.classList ? !!t && e.classList.contains(t) : -1 !== (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ");
    }

    function Xa(e) {
      var t = window.getComputedStyle(e);
      return {
        top: parseFloat(t.marginTop) || 0,
        right: parseFloat(t.marginRight) || 0,
        bottom: parseFloat(t.marginBottom) || 0,
        left: parseFloat(t.marginLeft) || 0
      };
    }

    function Za() {
      var e = Object(s.useRef)(null),
          t = Object(s.useRef)(null),
          r = Object(s.useRef)(null),
          n = or(void 0, "popover"),
          o = or(void 0, "dropdown-menu");
      return [Object(s.useCallback)(function (r) {
        r && ($a(r, n) || $a(r, o)) && (t.current = Xa(r), r.style.margin = "0", e.current = r);
      }, [n, o]), [Object(s.useMemo)(function () {
        return {
          name: "offset",
          options: {
            offset: function (e) {
              var r = e.placement;
              if (!t.current) return [0, 0];
              var n = t.current,
                  o = n.top,
                  i = n.left,
                  a = n.bottom,
                  c = n.right;

              switch (r.split("-")[0]) {
                case "top":
                  return [0, a];

                case "left":
                  return [0, c];

                case "bottom":
                  return [0, o];

                case "right":
                  return [0, i];

                default:
                  return [0, 0];
              }
            }
          }
        };
      }, [t]), Object(s.useMemo)(function () {
        return {
          name: "arrow",
          options: {
            padding: function () {
              if (!r.current) return 0;
              var e = r.current,
                  t = e.top,
                  n = e.right,
                  o = t || n;
              return {
                top: o,
                left: o,
                right: o,
                bottom: o
              };
            }
          }
        };
      }, [r]), Object(s.useMemo)(function () {
        return {
          name: "popoverArrowMargins",
          enabled: !0,
          phase: "main",
          fn: function () {},
          requiresIfExists: ["arrow"],
          effect: function (t) {
            var o = t.state;

            if (e.current && o.elements.arrow && $a(e.current, n)) {
              if (o.modifiersData["arrow#persistent"]) {
                var i = Xa(o.elements.arrow),
                    a = i.top,
                    c = i.right,
                    u = a || c;
                o.modifiersData["arrow#persistent"].padding = {
                  top: u,
                  left: u,
                  right: u,
                  bottom: u
                };
              } else r.current = Xa(o.elements.arrow);

              return o.elements.arrow.style.margin = "0", function () {
                o.elements.arrow && (o.elements.arrow.style.margin = "");
              };
            }
          }
        };
      }, [n])]];
    }

    var ec = ["bsPrefix", "className", "align", "alignRight", "rootCloseEvent", "flip", "show", "renderOnMount", "as", "popperConfig"],
        tc = go.a.oneOf(["left", "right"]),
        rc = go.a.oneOfType([tc, go.a.shape({
      sm: tc
    }), go.a.shape({
      md: tc
    }), go.a.shape({
      lg: tc
    }), go.a.shape({
      xl: tc
    })]),
        nc = p.a.forwardRef(function (e, t) {
      var r = e.bsPrefix,
          n = e.className,
          o = e.align,
          i = e.alignRight,
          a = e.rootCloseEvent,
          c = e.flip,
          u = e.show,
          l = e.renderOnMount,
          f = e.as,
          d = void 0 === f ? "div" : f,
          b = e.popperConfig,
          y = er(e, ec),
          m = Object(s.useContext)(Ya),
          v = or(r, "dropdown-menu"),
          h = Za(),
          g = h[0],
          w = h[1],
          O = [];
      if (o) if ("object" == typeof o) {
        var j = Object.keys(o);

        if (j.length) {
          var P = j[0],
              _ = o[P];
          i = "left" === _, O.push(v + "-" + P + "-" + _);
        }
      } else "right" === o && (i = !0);
      var E = wa({
        flip: c,
        rootCloseEvent: a,
        show: u,
        alignEnd: i,
        usePopper: !m && 0 === O.length,
        popperConfig: Zt({}, b, {
          modifiers: w.concat((null == b ? void 0 : b.modifiers) || [])
        })
      }),
          S = E[0],
          C = E[1],
          k = C.hasShown,
          R = C.popper,
          T = C.show,
          z = C.alignEnd,
          N = C.toggle;
      if (S.ref = Ha(g, Ha(Qa(t), S.ref)), !k && !l) return null;
      "string" != typeof d && (S.show = T, S.close = function () {
        return null == N ? void 0 : N(!1);
      }, S.alignRight = z);
      var D = y.style;
      return null != R && R.placement && (D = Zt({}, y.style, S.style), y["x-placement"] = R.placement), p.a.createElement(d, Zt({}, y, S, {
        style: D,
        className: rr.a.apply(void 0, [n, v, T && "show", z && v + "-right"].concat(O))
      }));
    });
    nc.displayName = "DropdownMenu", nc.defaultProps = {
      align: "left",
      alignRight: !1,
      flip: !0
    };
    var oc = nc,
        ic = (r(98), ["bsPrefix", "variant", "size", "active", "className", "block", "type", "as"]),
        ac = p.a.forwardRef(function (e, t) {
      var r = e.bsPrefix,
          n = e.variant,
          o = e.size,
          i = e.active,
          a = e.className,
          c = e.block,
          u = e.type,
          l = e.as,
          s = er(e, ic),
          f = or(r, "btn"),
          d = rr()(a, f, i && "active", n && f + "-" + n, c && f + "-block", o && f + "-" + o);
      if (s.href) return p.a.createElement(Va, Zt({}, s, {
        as: l,
        ref: t,
        className: rr()(d, s.disabled && "disabled")
      }));
      t && (s.ref = t), u ? s.type = u : l || (s.type = "button");
      var b = l || "button";
      return p.a.createElement(b, Zt({}, s, {
        className: d
      }));
    });
    ac.displayName = "Button", ac.defaultProps = {
      variant: "primary",
      active: !1,
      disabled: !1
    };
    var cc = ac,
        uc = ["bsPrefix", "split", "className", "childBsPrefix", "as"],
        lc = p.a.forwardRef(function (e, t) {
      var r = e.bsPrefix,
          n = e.split,
          o = e.className,
          i = e.childBsPrefix,
          a = e.as,
          c = void 0 === a ? cc : a,
          u = er(e, uc),
          l = or(r, "dropdown-toggle");
      void 0 !== i && (u.bsPrefix = i);
      var s = Ea()[0];
      return s.ref = Ha(s.ref, Qa(t)), p.a.createElement(c, Zt({
        className: rr()(o, l, n && l + "-split")
      }, s, u));
    });
    lc.displayName = "DropdownToggle";
    var sc = lc,
        pc = /-(.)/g;

    var fc = ["className", "bsPrefix", "as"],
        dc = function (e) {
      return e[0].toUpperCase() + (t = e, t.replace(pc, function (e, t) {
        return t.toUpperCase();
      })).slice(1);
      var t;
    };

    function bc(e, t) {
      var r = void 0 === t ? {} : t,
          n = r.displayName,
          o = void 0 === n ? dc(e) : n,
          i = r.Component,
          a = r.defaultProps,
          c = p.a.forwardRef(function (t, r) {
        var n = t.className,
            o = t.bsPrefix,
            a = t.as,
            c = void 0 === a ? i || "div" : a,
            u = er(t, fc),
            l = or(o, e);
        return p.a.createElement(c, Zt({
          ref: r,
          className: rr()(n, l)
        }, u));
      });
      return c.defaultProps = a, c.displayName = o, c;
    }

    var yc = ["bsPrefix", "drop", "show", "className", "alignRight", "onSelect", "onToggle", "focusFirstItemOnShow", "as", "navbar"],
        mc = bc("dropdown-header", {
      defaultProps: {
        role: "heading"
      }
    }),
        vc = bc("dropdown-divider", {
      defaultProps: {
        role: "separator"
      }
    }),
        hc = bc("dropdown-item-text", {
      Component: "span"
    }),
        gc = p.a.forwardRef(function (e, t) {
      var r = Po(e, {
        show: "onToggle"
      }),
          n = r.bsPrefix,
          o = r.drop,
          i = r.show,
          a = r.className,
          c = r.alignRight,
          u = r.onSelect,
          l = r.onToggle,
          f = r.focusFirstItemOnShow,
          d = r.as,
          b = void 0 === d ? "div" : d,
          y = (r.navbar, er(r, yc)),
          m = Object(s.useContext)(xa),
          v = or(n, "dropdown"),
          h = To(function (e, t, r) {
        void 0 === r && (r = t.type), t.currentTarget !== document || "keydown" === r && "Escape" !== t.key || (r = "rootClose"), l && l(e, t, {
          source: r
        });
      }),
          g = To(function (e, t) {
        m && m(e, t), u && u(e, t), h(!1, t, "select");
      });
      return p.a.createElement(xa.Provider, {
        value: g
      }, p.a.createElement(Na, {
        drop: o,
        show: i,
        alignEnd: c,
        onToggle: h,
        focusFirstItemOnShow: f,
        itemSelector: "." + v + "-item:not(.disabled):not(:disabled)"
      }, p.a.createElement(b, Zt({}, y, {
        ref: t,
        className: rr()(a, i && "show", (!o || "down" === o) && v, "up" === o && "dropup", "right" === o && "dropright", "left" === o && "dropleft")
      }))));
    });
    gc.displayName = "Dropdown", gc.defaultProps = {
      navbar: !1
    }, gc.Divider = vc, gc.Header = mc, gc.Item = Ga, gc.ItemText = hc, gc.Menu = oc, gc.Toggle = sc;
    var wc,
        Oc,
        jc,
        Pc,
        _c = gc;

    function Ec(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Sc(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Cc(n.key), n);
      }
    }

    function Cc(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function kc(e, t, r) {
      return t = Rc(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Rc(e).constructor) : t.apply(e, r));
    }

    function Rc(e) {
      return (Rc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Tc(e, t) {
      return (Tc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function zc(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Nc,
        Dc,
        xc,
        Ac,
        Mc = Object(d.observer)((jc = zc((Oc = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Ec(r = kc(this, t, [e]), "units", jc, r), Ec(r, "scalar", Pc, r), r.quantityDisposer = Object(f.reaction)(function () {
          return r.props.quantity;
        }, function (e) {
          e ? (r.scalar = e.scalar, r.units = e.units) : (r.scalar = "", r.units = "");
        }, {
          fireImmediately: !0
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Tc(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Sc(e.prototype, t), r && Sc(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "unitChoices",
        get: function () {
          var e = this.props.product;
          return (null == e ? void 0 : e.unitChoices) || [];
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.quantityDisposer();
        }
      }, {
        key: "changeScalar",
        value: function (e) {
          this.scalar = e.target.value, this.onChangeQuantity();
        }
      }, {
        key: "changeUnit",
        value: function (e) {
          this.units = "unit" === e ? "" : e, this.onChangeQuantity();
        }
      }, {
        key: "onChangeQuantity",
        value: function () {
          var e = this.props.onChange,
              t = new w.Quantity();
          t.scalar = this.scalar, t.units = this.units, e(t);
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.errorMessage,
              n = t.placeholder,
              o = this.props.t;
          return p.a.createElement("div", {
            className: "quantity-field"
          }, p.a.createElement("div", {
            className: "input-group"
          }, p.a.createElement("input", {
            className: "form-control ".concat(r ? "is-invalid" : ""),
            type: "number",
            onChange: function (t) {
              return e.changeScalar(t);
            },
            placeholder: n,
            value: this.scalar
          }), r ? p.a.createElement("div", {
            className: "invalid-feedback order-last"
          }, r) : null, p.a.createElement("div", {
            className: "input-group-append"
          }, p.a.createElement(_c, null, p.a.createElement(_c.Toggle, {
            variant: "outline-secondary",
            className: "h-100"
          }, "" === this.units ? o("unit") : this.units), p.a.createElement(_c.Menu, null, this.unitChoices.map(function (t) {
            return p.a.createElement(_c.Item, {
              key: t,
              onClick: function () {
                return e.changeUnit(t);
              }
            }, t);
          }))))));
        }
      }]);
    }()).prototype, "units", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Pc = zc(Oc.prototype, "scalar", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), zc(Oc.prototype, "unitChoices", [f.computed], Object.getOwnPropertyDescriptor(Oc.prototype, "unitChoices"), Oc.prototype), zc(Oc.prototype, "changeScalar", [f.action], Object.getOwnPropertyDescriptor(Oc.prototype, "changeScalar"), Oc.prototype), zc(Oc.prototype, "changeUnit", [f.action], Object.getOwnPropertyDescriptor(Oc.prototype, "changeUnit"), Oc.prototype), wc = Oc)) || wc,
        Ic = Object(g.a)()(Mc),
        Fc = r(138),
        Bc = r.n(Fc);
    r(20), r(21);

    function Lc(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Vc(n.key), n);
      }
    }

    function Vc(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Uc(e, t, r) {
      return t = qc(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], qc(e).constructor) : t.apply(e, r));
    }

    function qc(e) {
      return (qc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Kc(e, t) {
      return (Kc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    v()(document).off(".data-api");
    var Gc,
        Wc,
        Hc,
        Jc,
        Yc,
        Qc,
        $c,
        Xc,
        Zc = Object(d.observer)(((Ac = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = Uc(this, t, [e]), "onKeyDown", xc, r), r.ref = Object(s.createRef)(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Kc(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "componentDidMount",
        value: function () {
          v()('[data-toggle="tooltip"]').tooltip({
            trigger: "hover",
            delay: {
              show: 500,
              hide: 0
            }
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.tabIndex,
              r = e.placeholder,
              n = e.className,
              o = e.title,
              i = e.value,
              a = e.onChange,
              c = e.onClick,
              u = e.onBlur,
              l = e.onFocus;
          return p.a.createElement("input", {
            tabIndex: t,
            placeholder: r || "mm/dd/yyyy",
            className: "form-control dateInput".concat(n ? " ".concat(n) : ""),
            "data-toggle": "tooltip",
            "data-placement": "top",
            "data-original-title": o,
            value: i,
            onBlur: u,
            onChange: a,
            onClick: c,
            onFocus: l,
            onKeyDown: this.onKeyDown
          });
        }
      }]) && Lc(r.prototype, n), o && Lc(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).defaultProps = {
      onChange: function () {},
      onClick: function () {},
      onBlur: function () {},
      onFocus: function () {},
      onTab: function () {},
      onEnter: function () {}
    }, xc = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((Dc = Ac).prototype, "onKeyDown", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.onTab,
              o = r.onEnter;
          "Tab" !== t.key ? "Enter" === t.key && o(t) : n(t);
        };
      }
    }), Nc = Dc)) || Nc;

    function eu(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function tu(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ru(n.key), n);
      }
    }

    function ru(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function nu(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var ou,
        iu,
        au,
        cu,
        uu,
        lu,
        su,
        pu,
        fu,
        du,
        bu,
        yu,
        mu,
        vu = (Wc = nu((Gc = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), eu(this, "isFocused", Wc, this), eu(this, "dateText", Hc, this), eu(this, "validFormats", Jc, this), eu(this, "onBlur", Yc, this), eu(this, "onFocus", Qc, this), eu(this, "onChange", $c, this), eu(this, "onChangeDate", Xc, this), this.dateText = t ? this.getValidDateString(t) : "";
      }, (t = [{
        key: "date",
        get: function () {
          return new Date(this.getValidDateString(this.dateText));
        }
      }, {
        key: "getValidDateString",
        value: function (e) {
          var t = M()(e || new Date(), this.validFormats).format("MM/DD/YYYY");
          return "Invalid date" === t ? M()(new Date()).format("MM/DD/YYYY") : t;
        }
      }]) && tu(e.prototype, t), r && tu(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "isFocused", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Hc = nu(Gc.prototype, "dateText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Jc = nu(Gc.prototype, "validFormats", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return ["MM/DD/YYYY", "MM-DD-YYYY", "YYYY-MM-DD"];
      }
    }), nu(Gc.prototype, "date", [f.computed], Object.getOwnPropertyDescriptor(Gc.prototype, "date"), Gc.prototype), Yc = nu(Gc.prototype, "onBlur", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.dateText = e.dateText ? M()(e.date).format("MM/DD/YYYY") : e.dateText, e.isFocused = !1;
        };
      }
    }), Qc = nu(Gc.prototype, "onFocus", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isFocused = !0;
        };
      }
    }), $c = nu(Gc.prototype, "onChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.dateText = t.target.value;
        };
      }
    }), Xc = nu(Gc.prototype, "onChangeDate", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.dateText = M()(t).format("MM/DD/YYYY");
        };
      }
    }), Gc);

    function hu(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function gu(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, wu(n.key), n);
      }
    }

    function wu(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Ou(e, t, r) {
      return t = ju(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ju(e).constructor) : t.apply(e, r));
    }

    function ju(e) {
      return (ju = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Pu(e, t) {
      return (Pu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function _u(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Eu,
        Su,
        Cu,
        ku,
        Ru,
        Tu,
        zu,
        Nu,
        Du,
        xu,
        Au,
        Mu,
        Iu,
        Fu,
        Bu = Object(d.observer)((au = _u((iu = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = Ou(this, t, [e])).datePickerRef = void 0, hu(r, "dateModel", au, r), hu(r, "showDropdown", cu, r), hu(r, "activeStartDate", uu, r), hu(r, "onClickDocument", lu, r), hu(r, "onEnterInput", su, r), hu(r, "onFocusInput", pu, r), hu(r, "onTabInput", fu, r), hu(r, "onChange", du, r), hu(r, "onChangeDate", bu, r), hu(r, "onActiveStartDateChange", yu, r), hu(r, "clearDate", mu, r), r.datePickerRef = Object(s.createRef)(), r.dateModel = new vu(e.value), r.activeStartDate = r.startDateFor(r.dateModel.date), r.dateDisposer = Object(f.reaction)(function () {
          return r.props.value;
        }, function (e) {
          r.dateModel = new vu(e), r.activeStartDate = r.startDateFor(r.dateModel.date);
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Pu(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "componentDidMount",
        value: function () {
          document.addEventListener("click", this.onClickDocument);
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          document.removeEventListener("click", this.onClickDocument), this.dateDisposer();
        }
      }, {
        key: "closeDropdown",
        value: function () {
          var e = this.props.onChange;
          this.showDropdown = !1, this.dateModel.dateText && e(this.dateModel.date);
        }
      }, {
        key: "changeDate",
        value: function (e) {
          this.dateModel.onChangeDate(e), this.activeStartDate = this.startDateFor(e);
        }
      }, {
        key: "startDateFor",
        value: function (e) {
          return new Date(M()(e).format("MM/01/YYYY"));
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.tabIndex,
              r = e.placeholder,
              n = e.className,
              o = e.inputClassName,
              i = e.title;
          return p.a.createElement("div", {
            ref: this.datePickerRef,
            className: "date-picker".concat(n ? " ".concat(n) : ""),
            "aria-label": "Date Picker"
          }, p.a.createElement("button", {
            className: "clear-date".concat(this.dateModel.dateText ? "" : " empty"),
            type: "button",
            onClick: this.clearDate
          }, p.a.createElement("span", {
            "aria-hidden": "true"
          }, "×")), p.a.createElement(Zc, {
            tabIndex: t,
            type: "text",
            className: o,
            title: i,
            onChange: this.onChange,
            onBlur: this.dateModel.onBlur,
            onEnter: this.onEnterInput,
            onFocus: this.onFocusInput,
            onTab: this.onTabInput,
            placeholder: r,
            value: this.dateModel.dateText
          }), p.a.createElement("div", {
            className: "dropdown-menu py-0".concat(this.showDropdown ? " show" : ""),
            "aria-label": "calendar dropdown"
          }, p.a.createElement(Bc.a, {
            calendarType: "US",
            activeStartDate: this.activeStartDate,
            value: this.dateModel.date,
            onChange: this.onChangeDate,
            onActiveStartDateChange: this.onActiveStartDateChange
          })));
        }
      }]) && gu(r.prototype, n), o && gu(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "dateModel", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new vu();
      }
    }), cu = _u(iu.prototype, "showDropdown", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), uu = _u(iu.prototype, "activeStartDate", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new Date();
      }
    }), lu = _u(iu.prototype, "onClickDocument", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.datePickerRef.current.contains(t.target) || e.showDropdown && e.closeDropdown();
        };
      }
    }), su = _u(iu.prototype, "onEnterInput", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.changeDate(e.dateModel.date), e.showDropdown ? e.closeDropdown() : e.showDropdown = !0;
        };
      }
    }), pu = _u(iu.prototype, "onFocusInput", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.showDropdown = !0, e.dateModel.onFocus();
        };
      }
    }), fu = _u(iu.prototype, "onTabInput", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.closeDropdown();
        };
      }
    }), du = _u(iu.prototype, "onChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.dateModel.onChange(t), e.activeStartDate = e.startDateFor(e.dateModel.date);
        };
      }
    }), bu = _u(iu.prototype, "onChangeDate", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.changeDate(t), e.closeDropdown();
        };
      }
    }), yu = _u(iu.prototype, "onActiveStartDateChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = t.activeStartDate;
          e.activeStartDate = r;
        };
      }
    }), _u(iu.prototype, "closeDropdown", [f.action], Object.getOwnPropertyDescriptor(iu.prototype, "closeDropdown"), iu.prototype), _u(iu.prototype, "changeDate", [f.action], Object.getOwnPropertyDescriptor(iu.prototype, "changeDate"), iu.prototype), mu = _u(iu.prototype, "clearDate", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.onChange;
          e.changeDate(""), e.closeDropdown(), t();
        };
      }
    }), ou = iu)) || ou;

    function Lu(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Vu(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Uu(n.key), n);
      }
    }

    function Uu(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function qu(e, t, r) {
      return t = Ku(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Ku(e).constructor) : t.apply(e, r));
    }

    function Ku(e) {
      return (Ku = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Gu(e, t) {
      return (Gu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Wu(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Hu,
        Ju,
        Yu,
        Qu,
        $u,
        Xu = Object(d.observer)((Cu = Wu((Su = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = qu(this, t, [e])).categorySelectorModel = void 0, Lu(r, "categoryOptions", Cu, r), Lu(r, "originalProductPrice", ku, r), Lu(r, "product", Ru, r), Lu(r, "price", Tu, r), Lu(r, "quantity", zu, r), Lu(r, "effectiveDate", Nu, r), Lu(r, "estimated", Du, r), Lu(r, "invalidFields", xu, r), Lu(r, "submitted", Au, r), Lu(r, "submitting", Mu, r), Lu(r, "onChangePrice", Iu, r), Lu(r, "onRegisterCategoryModel", Fu, r), e.categoryOptions && (r.categoryOptions = e.categoryOptions.map(function (e) {
          return {
            key: e,
            text: e,
            value: {
              name: e,
              id: e
            }
          };
        })), r.productPriceDisposer = Object(f.reaction)(function () {
          return r.props.productPrice;
        }, function (e) {
          r.submitted = !1, r.submitting = !1, r.originalProductPrice = Rr.fromJS(e), e ? (r.product = e.product, r.price = e.price || "", r.effectiveDate = e.effectiveDate || new Date(), r.estimated = e.estimated || !1, r.categorySelectorModel && (r.categorySelectorModel.text = e.category || ""), r.quantity = e.quantity ? new w.Quantity(e.quantity) : null) : (r.product = null, r.price = "", r.effectiveDate = new Date(), r.estimated = !1, r.categorySelectorModel && (r.categorySelectorModel.text = ""), r.quantity = null), r.invalidFields = {};
        }, {
          fireImmediately: !0
        }), r.productsStore = new pn(new $r(), {
          useNewModels: !0
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Gu(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Vu(e.prototype, t), r && Vu(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "isNew",
        get: function () {
          return !this.originalProductPrice || !this.originalProductPrice.id;
        }
      }, {
        key: "category",
        get: function () {
          return this.categorySelectorModel ? this.categorySelectorModel.text : "";
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = this.props.account;
          this.productsStore.fetchAllForAccount(e.serial);
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.productPriceDisposer();
        }
      }, {
        key: "validate",
        value: function () {
          var e = this.props.t;
          this.submitted && (this.invalidFields = {}, this.product || (this.invalidFields.product = e("you_must_select_product")), this.price || (this.invalidFields.price = e("you_must_select_price")), this.quantity ? 0 === parseInt(this.quantity.scalar, 10) && (this.invalidFields.quantity = e("quantity_great_than_zero")) : this.invalidFields.quantity = e("you_must_select_quantity"));
        }
      }, {
        key: "handleSubmission",
        value: function (e) {
          var t = this,
              r = this.props,
              n = r.account,
              o = r.authenticityToken,
              i = r.callback;
          if (e.preventDefault(), this.submitted = !0, this.submitting = !0, this.validate(), 0 === Object.keys(this.invalidFields).length) return this.originalProductPrice.product = this.product, this.originalProductPrice.category = this.category, this.originalProductPrice.price = this.price, this.originalProductPrice.quantity = this.quantity, this.originalProductPrice.effectiveDate = this.effectiveDate, this.originalProductPrice.estimated = this.estimated, this.originalProductPrice.save(n.serial, o).then(function (e) {
            if ("success" === e.status) {
              if (!i) return window.location.reload();
              i(t.originalProductPrice);
            }

            return t.submitted = !1, t.submitting = !1, v()("#price-editor-modal").modal("hide"), e.errors ? alert(e.errors) : Promise.resolve();
          }, function (e) {
            t.submitted = !1, t.submitting = !1, e.errors && alert(e.errors);
          });
          this.submitting = !1;
        }
      }, {
        key: "renderSpinner",
        value: function () {
          if (this.submitting) return p.a.createElement(h.Spinner, null);
        }
      }, {
        key: "_renderEstimatedCheckbox",
        value: function () {
          var e = this,
              t = this.props,
              r = t.t;
          return t.canEditEstimatedPrices ? p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", {
            className: "form-label text-uppercase font-weight-bold small"
          }, r("if2.prices.price_is_estimated")), p.a.createElement("div", {
            className: "form-check"
          }, p.a.createElement("input", {
            type: "checkbox",
            name: "account_product_price[estimated]",
            checked: this.estimated,
            onChange: function (t) {
              e.estimated = t.target.checked;
            }
          }))) : null;
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props.t;
          return p.a.createElement(h.ModalDialog, {
            id: "price-editor-modal",
            dataBackdrop: "static",
            className: "price-editor-modal"
          }, p.a.createElement(h.ModalHeader, {
            title: t("price_editor")
          }), p.a.createElement("form", {
            className: "needs-validation ".concat(this.submitted ? "was-validated" : ""),
            onSubmit: function (t) {
              return e.handleSubmission(t);
            },
            noValidate: !0
          }, p.a.createElement(h.ModalBody, null, p.a.createElement("div", {
            className: "form-group"
          }, this.isNew ? p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", {
            className: "form-label text-uppercase font-weight-bold small"
          }, t("product")), p.a.createElement(lo, {
            productsStore: this.productsStore,
            currentProduct: this.product,
            onSelectProduct: function (t) {
              e.product = t, e.validate();
            },
            errorMessage: this.invalidFields.product
          })) : p.a.createElement("h3", null, this.originalProductPrice.product.name)), p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", {
            className: "form-label text-uppercase font-weight-bold small"
          }, t("price")), p.a.createElement("div", {
            className: "input-group"
          }, p.a.createElement("div", {
            className: "input-group-prepend"
          }, p.a.createElement("div", {
            className: "input-group-text"
          }, "$")), p.a.createElement("input", {
            type: "number",
            name: "account_product_price[price]",
            className: "form-control",
            value: this.price,
            placeholder: t("price"),
            required: !0,
            onChange: this.onChangePrice
          }), this.invalidFields.price ? p.a.createElement("div", {
            className: "invalid-feedback"
          }, this.invalidFields.price) : null)), this._renderEstimatedCheckbox(), p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", {
            className: "form-label text-uppercase font-weight-bold small"
          }, t("quantity")), p.a.createElement(Ic, {
            product: this.product,
            quantity: this.quantity,
            placeholder: t("quantity"),
            onChange: function (t) {
              e.quantity = t, e.validate();
            },
            errorMessage: this.invalidFields.quantity
          })), p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", {
            className: "form-label text-uppercase font-weight-bold small"
          }, t("category")), p.a.createElement(h.FreeformSelector, {
            id: "category-selector",
            options: this.categoryOptions,
            placeholder: t("category"),
            onRegisterModel: this.onRegisterCategoryModel
          }), this.invalidFields.category ? p.a.createElement("div", {
            className: "invalid-feedback"
          }, this.invalidFields.category) : null), p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", {
            className: "form-label text-uppercase font-weight-bold small"
          }, t("effective_date")), p.a.createElement("div", {
            className: "input-group"
          }, p.a.createElement(Bu, {
            tabIndex: "1",
            placeholder: "mm/dd/yyyy",
            className: "mr-1 w-100",
            value: this.effectiveDate,
            onChange: function (t) {
              e.effectiveDate = t;
            }
          }), p.a.createElement("i", {
            className: "fas fa-calendar-alt input-icon calendar-icon"
          })))), p.a.createElement("div", {
            className: "modal-footer flex-column"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-primary",
            onClick: function (t) {
              e.handleSubmission(t);
            },
            disabled: this.submitting
          }, this.renderSpinner(), t("save")), p.a.createElement("button", {
            type: "button",
            className: "btn btn-outline-secondary",
            "data-dismiss": "modal"
          }, t("cancel")))));
        }
      }]);
    }()).prototype, "categoryOptions", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), ku = Wu(Su.prototype, "originalProductPrice", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Ru = Wu(Su.prototype, "product", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Tu = Wu(Su.prototype, "price", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), zu = Wu(Su.prototype, "quantity", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return null;
      }
    }), Nu = Wu(Su.prototype, "effectiveDate", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new Date();
      }
    }), Du = Wu(Su.prototype, "estimated", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), xu = Wu(Su.prototype, "invalidFields", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return {};
      }
    }), Au = Wu(Su.prototype, "submitted", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Mu = Wu(Su.prototype, "submitting", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Wu(Su.prototype, "isNew", [f.computed], Object.getOwnPropertyDescriptor(Su.prototype, "isNew"), Su.prototype), Wu(Su.prototype, "category", [f.computed], Object.getOwnPropertyDescriptor(Su.prototype, "category"), Su.prototype), Wu(Su.prototype, "validate", [f.action], Object.getOwnPropertyDescriptor(Su.prototype, "validate"), Su.prototype), Iu = Wu(Su.prototype, "onChangePrice", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          /^\d*\.?\d{0,2}$/.test(t.target.value) && (e.price = t.target.value, e.validate());
        };
      }
    }), Fu = Wu(Su.prototype, "onRegisterCategoryModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.categorySelectorModel = t;
        };
      }
    }), Wu(Su.prototype, "handleSubmission", [f.action], Object.getOwnPropertyDescriptor(Su.prototype, "handleSubmission"), Su.prototype), Eu = Su)) || Eu,
        Zu = Object(g.a)()(Xu);

    function el(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function tl(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, rl(n.key), n);
      }
    }

    function rl(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function nl(e, t, r) {
      return t = ol(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ol(e).constructor) : t.apply(e, r));
    }

    function ol(e) {
      return (ol = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function il(e, t) {
      return (il = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function al(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var cl,
        ul,
        ll,
        sl = Object(d.observer)((Yu = al((Ju = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), el(r = nl(this, t, [e]), "productPriceToEdit", Yu, r), el(r, "newPrice", Qu, r), el(r, "editPrice", $u, r), r.productPriceToEdit = {
          product: new _r()
        }, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && il(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && tl(e.prototype, t), r && tl(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "renderEstimatedBadge",
        value: function (e, t) {
          return t.estimated ? p.a.createElement(ur, {
            variant: "warning",
            className: "ml-2"
          }, e("if2.prices.estimated")) : null;
        }
      }, {
        key: "renderPrices",
        value: function () {
          var e = this,
              t = this.props,
              r = t.prices,
              n = t.readOnly,
              o = t.deletePathTemplate,
              i = this.props.t;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("div", {
            className: "row card"
          }, p.a.createElement("div", {
            className: "container-fluid mt-3"
          }, p.a.createElement("table", {
            className: "table table-sm table-striped"
          }, p.a.createElement("thead", null, p.a.createElement("tr", null, p.a.createElement("th", {
            scope: "col"
          }, i("product")), p.a.createElement("th", {
            scope: "col"
          }, i("category")), p.a.createElement("th", {
            scope: "col"
          }, i("price")), p.a.createElement("th", {
            scope: "col"
          }, i("quantity")), n ? null : p.a.createElement("th", {
            scope: "col",
            "aria-label": "Actions"
          }))), p.a.createElement("tbody", null, r.map(function (t) {
            return p.a.createElement("tr", {
              key: t.product.id
            }, p.a.createElement("td", null, t.product.name), p.a.createElement("td", null, t.category), p.a.createElement("td", null, t.price, e.renderEstimatedBadge(i, t)), p.a.createElement("td", null, t.quantity), n ? null : p.a.createElement("td", {
              className: "text-right"
            }, p.a.createElement("a", {
              href: "#",
              onClick: function () {
                return e.editPrice(t);
              },
              className: "btn btn-primary btn-text btn-sm"
            }, i("edit")), p.a.createElement("a", {
              href: o.replace(":id", t.serial),
              className: "btn btn-danger btn-text btn-sm ml-1",
              "data-method": "DELETE",
              "data-confirm": "".concat(i("confirm_delete_price"), " ").concat(t.product.name, "?")
            }, i("delete"))));
          }))))));
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.account,
              n = t.readOnly,
              o = t.canEditEstimatedPrices,
              i = t.prices,
              a = t.categoryOptions,
              c = t.authenticityToken,
              u = t.t;
          return p.a.createElement("div", {
            className: "accounts-products-price-manager"
          }, p.a.createElement(Zu, {
            productPrice: this.productPriceToEdit,
            account: r,
            authenticityToken: c,
            categoryOptions: a,
            canEditEstimatedPrices: o
          }), p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col"
          }, n ? null : p.a.createElement("p", {
            className: "float-right"
          }, p.a.createElement("a", {
            href: "#",
            onClick: function () {
              return e.newPrice();
            },
            className: "text-primary"
          }, u("new_price"), " ", p.a.createElement("i", {
            className: "fas fa-plus-circle"
          }))))), 0 === i.length ? p.a.createElement("p", null, u("no_prices_configured", {
            account: r
          })) : this.renderPrices());
        }
      }]);
    }()).prototype, "productPriceToEdit", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Qu = al(Ju.prototype, "newPrice", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.productPriceToEdit = {
            product: null,
            price: null,
            category: null,
            quantity: null
          }, v()("#price-editor-modal").modal();
        };
      }
    }), $u = al(Ju.prototype, "editPrice", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.product = new _r(t.product), e.productPriceToEdit = t, v()("#price-editor-modal").modal();
        };
      }
    }), Hu = Ju)) || Hu,
        pl = Object(g.a)()(sl),
        fl = function (e) {
      return Object(d.useObserver)(function () {
        return p.a.createElement("div", {
          className: "account-tree-nav"
        }, p.a.createElement(h.Tree, e));
      });
    };

    function dl(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bl(n.key), n);
      }
    }

    function bl(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function yl(e, t, r) {
      return t = ml(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ml(e).constructor) : t.apply(e, r));
    }

    function ml(e) {
      return (ml = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function vl(e, t) {
      return (vl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var hl = Object(d.observer)(((ll = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), yl(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && vl(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "className",
        get: function () {
          var e = this.props.nodeClasses;
          return ee(e.concat(["content-wrapper", "read-only"])).join(" ");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.node,
              r = e.title;
          return p.a.createElement("div", {
            className: this.className,
            title: r
          }, t.name);
        }
      }]) && dl(r.prototype, n), o && dl(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).defaultProps = {
      nodeClasses: []
    }, function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((ul = ll).prototype, "className", [f.computed], Object.getOwnPropertyDescriptor(ul.prototype, "className"), ul.prototype), cl = ul)) || cl,
        gl = ["node"];

    function wl(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ol(n.key), n);
      }
    }

    function Ol(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function jl(e, t, r) {
      return t = Pl(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Pl(e).constructor) : t.apply(e, r));
    }

    function Pl(e) {
      return (Pl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function _l(e, t) {
      return (_l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var El,
        Sl,
        Cl = function (e) {
      return Object(d.observer)(function (t) {
        function r() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r), jl(this, r, arguments);
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && _l(e, t);
        }(r, s["Component"]), n = r, (o = [{
          key: "render",
          value: function () {
            var t = this.props,
                r = t.node,
                n = function (e, t) {
              if (null == e) return {};

              var r,
                  n,
                  o = function (e, t) {
                if (null == e) return {};
                var r = {};

                for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
                  if (t.includes(n)) continue;
                  r[n] = e[n];
                }

                return r;
              }(e, t);

              if (Object.getOwnPropertySymbols) {
                var i = Object.getOwnPropertySymbols(e);

                for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
              }

              return o;
            }(t, gl);

            return e.isReadOnly(r.id) ? p.a.createElement(hl, Object.assign({
              node: r
            }, n)) : p.a.createElement(h.TreeNodeContent, Object.assign({
              node: r
            }, n));
          }
        }]) && wl(n.prototype, o), i && wl(n, i), Object.defineProperty(n, "prototype", {
          writable: !1
        }), n;
        var n, o, i;
      }());
    },
        kl = ["node", "actions"];

    function Rl(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Tl(n.key), n);
      }
    }

    function Tl(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function zl(e, t, r) {
      return t = Nl(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Nl(e).constructor) : t.apply(e, r));
    }

    function Nl(e) {
      return (Nl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Dl(e, t) {
      return (Dl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var xl,
        Al = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((Sl = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), zl(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Dl(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "controls",
        get: function () {
          var e = this.props,
              t = e.treeModel,
              r = e.node;
          return t.accountsStore.isPending(r.id) ? [{
            id: "1",
            component: h.Spinner
          }] : [{
            id: "1",
            component: h.TreeNodeToggle
          }];
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.node,
              r = e.actions,
              n = function (e, t) {
            if (null == e) return {};

            var r,
                n,
                o = function (e, t) {
              if (null == e) return {};
              var r = {};

              for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
                if (t.includes(n)) continue;
                r[n] = e[n];
              }

              return r;
            }(e, t);

            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);

              for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
            }

            return o;
          }(e, kl);

          return p.a.createElement(h.TreeNodeControls, Object.assign({
            node: t,
            actions: r,
            controls: this.controls
          }, n));
        }
      }]) && Rl(r.prototype, n), o && Rl(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "controls", [f.computed], Object.getOwnPropertyDescriptor(Sl.prototype, "controls"), Sl.prototype), El = Sl)) || El;

    function Ml(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Il(n.key), n);
      }
    }

    function Il(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Fl(e, t, r) {
      return t = Bl(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Bl(e).constructor) : t.apply(e, r));
    }

    function Bl(e) {
      return (Bl = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Ll(e, t) {
      return (Ll = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Vl,
        Ul,
        ql = Object(d.observer)(xl = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = Fl(this, t, [e])).containerClasses = ["inline-spinner"], r.handleClickName = function (e) {
          var t = r.props.onClickName;
          v()("#".concat(r.id)).modal("hide"), t(e);
        }, r.handleToggleExpand = function (e) {
          var t = r.props,
              n = t.accountsStore,
              o = t.treeModel;
          o.toggleExpanded(e), o.isExpanded(e) && n.updateChildrenOf(e);
        };
        var n = e.id;
        return r.id = n, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ll(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Ml(e.prototype, t), r && Ml(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.t,
              r = e.treeModel,
              n = e.isLoading;
          return p.a.createElement("div", {
            className: "account-selector-modal modal fade",
            id: this.id,
            tabIndex: "-1",
            role: "dialog",
            "aria-labelledby": "accountSelectorModalLabel",
            "aria-hidden": "true"
          }, p.a.createElement("div", {
            className: "modal-dialog",
            role: "document"
          }, p.a.createElement("div", {
            className: "modal-content"
          }, p.a.createElement("div", {
            className: "modal-header"
          }, p.a.createElement("h5", {
            className: "modal-title",
            id: "accountSelectorModalLabel"
          }, t("select_account"), n ? p.a.createElement(h.Spinner, {
            containerClasses: this.containerClasses
          }) : null), p.a.createElement("button", {
            type: "button",
            className: "close",
            "data-dismiss": "modal",
            "aria-label": "Close"
          }, p.a.createElement("span", {
            "aria-hidden": "true"
          }, "×"))), p.a.createElement("div", {
            className: "modal-body"
          }, p.a.createElement(fl, {
            items: r.roots,
            model: r,
            ControlsComponent: Al,
            ContentComponent: Cl(r),
            actions: {
              handleToggleExpand: this.handleToggleExpand,
              handleClickNodeContent: this.handleClickName
            }
          })), p.a.createElement("div", {
            className: "modal-footer"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-secondary",
            "data-dismiss": "modal"
          }, t("cancel"))))));
        }
      }]);
    }()) || xl,
        Kl = Object(g.a)()(ql);

    function Gl(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Wl(n.key), n);
      }
    }

    function Wl(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Hl(e, t, r) {
      return t = $l(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], $l(e).constructor) : t.apply(e, r));
    }

    function Jl(e, t, r, n) {
      var o = Yl($l(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function Yl() {
      return (Yl = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Ql(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Ql(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = $l(e)););

      return e;
    }

    function $l(e) {
      return ($l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Xl(e, t) {
      return (Xl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Zl(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var es,
        ts,
        rs,
        ns,
        os,
        is,
        as = (Ul = Zl((Vl = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = Hl(this, t, [].concat(n)), "_readOnlyNodes", Ul, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Xl(e, t);
      }(t, h["AccountsTreeModel"]), r = t, o = [{
        key: "sortRoots",
        value: function (e) {
          return e.slice().sort(w.sortByName);
        }
      }], (n = [{
        key: "isReadOnly",
        value: function (e) {
          return this._readOnlyNodes.has(e);
        }
      }, {
        key: "markReadOnly",
        value: function (e) {
          this._readOnlyNodes.add(e);
        }
      }, {
        key: "openAccounts",
        value: function (e) {
          var r = this,
              n = [],
              o = [];
          return e.forEach(function (e) {
            if (r.isReadOnly(e)) return n.push(e);
            o.push(e);
          }), this.expandMany(n), Jl(t, "openAccounts", this, 3)([o]);
        }
      }, {
        key: "setRoots",
        value: function () {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
              n = t.reduce(function (e, t) {
            return r.find(function (e) {
              return e.id === t.parent_id;
            }) || e.push(t), e;
          }, []),
              o = Object(x.uniq)(r.reduce(function (t, n) {
            return e.markReadOnly(n.id), r.find(function (e) {
              return e.id === n.parent_id;
            }) ? t : t.concat(n);
          }, []));
          this.roots = n.concat(o);
        }
      }, {
        key: "sortRoots",
        value: function () {
          this.roots = this.constructor.sortRoots(this.roots);
        }
      }, {
        key: "toggleExpanded",
        value: function (e) {
          return this.isReadOnly(e) ? (this.isCollapsed(e) ? this.expand(e) : this.collapse(e), Promise.resolve()) : Jl(t, "toggleExpanded", this, 3)([e]);
        }
      }]) && Gl(r.prototype, n), o && Gl(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "_readOnlyNodes", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new Set();
      }
    }), Zl(Vl.prototype, "openAccounts", [f.action], Object.getOwnPropertyDescriptor(Vl.prototype, "openAccounts"), Vl.prototype), Zl(Vl.prototype, "setRoots", [f.action], Object.getOwnPropertyDescriptor(Vl.prototype, "setRoots"), Vl.prototype), Zl(Vl.prototype, "sortRoots", [f.action], Object.getOwnPropertyDescriptor(Vl.prototype, "sortRoots"), Vl.prototype), Zl(Vl.prototype, "toggleExpanded", [f.action], Object.getOwnPropertyDescriptor(Vl.prototype, "toggleExpanded"), Vl.prototype), Vl);

    function cs(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function us(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ls(n.key), n);
      }
    }

    function ls(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ss(e, t, r) {
      return t = ps(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ps(e).constructor) : t.apply(e, r));
    }

    function ps(e) {
      return (ps = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function fs(e, t) {
      return (fs = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ds(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var bs = Object(d.observer)((rs = ds((ts = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = ss(this, t, [e])).accountSelectorModalId = "accountSelectorModal", cs(r, "selectedAccountId", rs, r), cs(r, "isLoadingAccountsModal", ns, r), cs(r, "handleClickName", os, r), cs(r, "showAccountSelectorModal", is, r);
        var n = e.visibleRoots,
            o = e.selectedAccount,
            i = e.accountsPath,
            a = e.readOnlyAncestors;
        return r.selectedAccountId = (null == o ? void 0 : o.id) || r.selectedAccountId, r.accountsApi = new N(i), r.accountsStore = new Tt(r.accountsApi, new qt()), o && r.accountsStore.push(o), r.defaultTreeModel = new as(r.accountsStore), r.treeModel.setRoots((n || []).map(function (e) {
          return r.accountsStore.push(e);
        }), (a || []).map(function (e) {
          return r.accountsStore.push(e);
        })), r.treeModel.sortRoots(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && fs(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && us(e.prototype, t), r && us(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "paramName",
        get: function () {
          return this.props.paramName || "account[parent_uuid]";
        }
      }, {
        key: "selectedAccountName",
        get: function () {
          var e = this.accountsStore.find(this.selectedAccountId);
          return e ? e.name : "";
        }
      }, {
        key: "selectedAccountSerial",
        get: function () {
          var e = this.accountsStore.find(this.selectedAccountId);
          return e ? e.serial : "";
        }
      }, {
        key: "selectedAccountForInput",
        get: function () {
          return this.useSerial ? this.selectedAccountSerial : this.selectedAccountId;
        }
      }, {
        key: "treeModel",
        get: function () {
          return this.props.treeModel || this.defaultTreeModel;
        }
      }, {
        key: "useSerial",
        get: function () {
          var e = this.props.useSerial;
          return Boolean(e);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.t,
              r = e.readOnlyAncestors;
          return p.a.createElement("div", {
            className: "account-selector"
          }, p.a.createElement("input", {
            type: "hidden",
            name: this.paramName,
            value: this.selectedAccountForInput
          }), p.a.createElement(Kl, {
            id: this.accountSelectorModalId,
            accountsStore: this.accountsStore,
            readOnlyAncestors: r,
            onClickName: this.handleClickName,
            treeModel: this.treeModel,
            isLoading: this.isLoadingAccountsModal
          }), p.a.createElement("div", {
            className: "input-group"
          }, p.a.createElement("input", {
            type: "text",
            readOnly: !0,
            className: "form-control",
            value: this.selectedAccountName,
            "aria-label": "Account Name",
            "aria-describedby": "button-select-different-account"
          }), p.a.createElement("div", {
            className: "input-group-append"
          }, p.a.createElement("button", {
            className: "btn btn-primary",
            type: "button",
            id: "button-select-different-account",
            onClick: this.showAccountSelectorModal
          }, t("change_account")))));
        }
      }]);
    }()).prototype, "selectedAccountId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), ns = ds(ts.prototype, "isLoadingAccountsModal", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), ds(ts.prototype, "paramName", [f.computed], Object.getOwnPropertyDescriptor(ts.prototype, "paramName"), ts.prototype), ds(ts.prototype, "selectedAccountName", [f.computed], Object.getOwnPropertyDescriptor(ts.prototype, "selectedAccountName"), ts.prototype), ds(ts.prototype, "selectedAccountSerial", [f.computed], Object.getOwnPropertyDescriptor(ts.prototype, "selectedAccountSerial"), ts.prototype), ds(ts.prototype, "selectedAccountForInput", [f.computed], Object.getOwnPropertyDescriptor(ts.prototype, "selectedAccountForInput"), ts.prototype), ds(ts.prototype, "treeModel", [f.computed], Object.getOwnPropertyDescriptor(ts.prototype, "treeModel"), ts.prototype), ds(ts.prototype, "useSerial", [f.computed], Object.getOwnPropertyDescriptor(ts.prototype, "useSerial"), ts.prototype), os = ds(ts.prototype, "handleClickName", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.selectedAccountId = t;
        };
      }
    }), is = ds(ts.prototype, "showAccountSelectorModal", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          if (t.preventDefault(), e.selectedAccountId && !e.accountsStore.hasLoadedAncestorsWithContext) return e.isLoadingAccountsModal = !0, e.treeModel.openToAccounts([e.selectedAccountId]).then(function () {
            return v()("#".concat(e.accountSelectorModalId)).modal("show");
          }).catch(console.error).finally(function () {
            Object(f.runInAction)(function () {
              e.isLoadingAccountsModal = !1;
            });
          });
          v()("#".concat(e.accountSelectorModalId)).modal("show");
        };
      }
    }), es = ts)) || es,
        ys = Object(g.a)()(bs);

    function ms(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, vs(n.key), n);
      }
    }

    function vs(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function hs(e, t, r) {
      return t = gs(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], gs(e).constructor) : t.apply(e, r));
    }

    function gs(e) {
      return (gs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ws(e, t) {
      return (ws = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Os,
        js,
        Ps = function (e) {
      var t;
      return Object(d.observer)((function (e, t, r, n, o) {
        var i = {};
        Object.keys(n).forEach(function (e) {
          i[e] = n[e];
        }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
          return n(e, t, r) || r;
        }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
      }((t = function (t) {
        function r(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r), (t = hs(this, r, [e])).treeNodeContentModel = new h.TreeNodeContentModel(t.props), t;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && ws(e, t);
        }(r, s["Component"]), n = r, (o = [{
          key: "badgeType",
          get: function () {
            return "grower" === this.props.node.account_type ? "success" : "secondary";
          }
        }, {
          key: "render",
          value: function () {
            var t = this.props,
                r = t.node,
                n = t.title,
                o = t.tabIndex;
            return e.isReadOnly(r.id) ? p.a.createElement(hl, {
              node: r,
              title: n,
              tabIndex: o
            }) : p.a.createElement(p.a.Fragment, null, p.a.createElement("div", {
              className: this.treeNodeContentModel.className,
              onClick: this.treeNodeContentModel.handleClick,
              onKeyDown: this.treeNodeContentModel.handleKeyPress,
              role: "button",
              tabIndex: o,
              title: n
            }, r.name), "general" !== r.account_type ? p.a.createElement("span", {
              className: "account-type-badge badge badge-".concat(this.badgeType)
            }, r.account_type) : null);
          }
        }]) && ms(n.prototype, o), i && ms(n, i), Object.defineProperty(n, "prototype", {
          writable: !1
        }), n;
        var n, o, i;
      }()).prototype, "badgeType", [f.computed], Object.getOwnPropertyDescriptor(t.prototype, "badgeType"), t.prototype), t));
    },
        _s = r(58),
        Es = r.n(_s);

    function Ss(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Cs(n.key), n);
      }
    }

    function Cs(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ks(e, t, r) {
      return t = Rs(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Rs(e).constructor) : t.apply(e, r));
    }

    function Rs(e) {
      return (Rs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Ts(e, t) {
      return (Ts = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var zs,
        Ns,
        Ds = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((js = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = ks(this, t, [].concat(n)))._renderAction = function (t) {
          if (t.target && 0 == t.actions.length) return p.a.createElement("a", {
            href: t.target.url,
            class: "btn btn-success"
          }, t.name);

          if (!t.target && t.actions.length > 0) {
            var r = Object(_s.uniqueId)("dropdown");
            return p.a.createElement(_c, {
              key: "dropdown-".concat(t.i18n_key)
            }, p.a.createElement(_c.Toggle, {
              id: r,
              variant: "success"
            }, t.name), p.a.createElement(_c.Menu, null, t.actions.map(function (r) {
              return e._renderDropdownAction(t.key, r);
            })));
          }

          return null;
        }, e._renderDropdownAction = function (e, t) {
          var r = "".concat(e, "_").concat(t.key);
          if (t.target && 0 == t.actions.length) return p.a.createElement(_c.Item, {
            key: r,
            href: t.target.url
          }, t.name);
          t.actions.length;
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ts(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "_group",
        get: function () {
          var e = this.props.group;
          if (!e) throw new Error("ActionButtons needs a 'group' property");
          return e;
        }
      }, {
        key: "render",
        value: function () {
          var e = this;
          this.props.t;
          return p.a.createElement(p.a.Fragment, null, this._group.actions.map(function (t) {
            return e._renderAction(t);
          }));
        }
      }]) && Ss(r.prototype, n), o && Ss(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "_group", [f.computed], Object.getOwnPropertyDescriptor(js.prototype, "_group"), js.prototype), Os = js)) || Os,
        xs = Object(g.a)()(Ds);

    function As(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ms(n.key), n);
      }
    }

    function Ms(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Is(e, t, r) {
      return t = Fs(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Fs(e).constructor) : t.apply(e, r));
    }

    function Fs(e) {
      return (Fs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Bs(e, t) {
      return (Bs = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Ls = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((Ns = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Is(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Bs(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "classNames",
        get: function () {
          var e = this.props.className;
          return ["if2-form-row"].concat(e || []).join(" ");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.children;
          return p.a.createElement("div", {
            className: this.classNames
          }, e);
        }
      }]) && As(r.prototype, n), o && As(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "classNames", [f.computed], Object.getOwnPropertyDescriptor(Ns.prototype, "classNames"), Ns.prototype), zs = Ns)) || zs;

    function Vs(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Us(n.key), n);
      }
    }

    function Us(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function qs(e, t, r) {
      return t = Ks(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Ks(e).constructor) : t.apply(e, r));
    }

    function Ks(e) {
      return (Ks = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Gs(e, t) {
      return (Gs = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Ws = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), qs(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Gs(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.children,
              r = e.htmlFor,
              n = e.autoWidth;
          return p.a.createElement("label", {
            className: n ? "form-grid-label-auto" : "form-grid-label",
            htmlFor: r
          }, t);
        }
      }]) && Vs(r.prototype, n), o && Vs(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function Hs(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Js(n.key), n);
      }
    }

    function Js(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Ys(e, t, r) {
      return t = Qs(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Qs(e).constructor) : t.apply(e, r));
    }

    function Qs(e) {
      return (Qs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function $s(e, t) {
      return ($s = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Xs = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Ys(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && $s(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.value,
              r = e.name,
              n = e.placeholder,
              o = e.id,
              i = e.readOnly,
              a = e.onChange,
              c = e.type,
              u = e.autoWidth;
          return p.a.createElement("div", {
            className: u ? "form-grid-input-auto" : "form-grid-input"
          }, p.a.createElement("input", {
            placeholder: n,
            type: c || "text",
            name: r,
            readOnly: i,
            id: o,
            value: t,
            onChange: a
          }));
        }
      }]) && Hs(r.prototype, n), o && Hs(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }(),
        Zs = r(15),
        ep = r.n(Zs);

    function tp(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function rp(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? tp(Object(r), !0).forEach(function (t) {
          np(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : tp(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function np(e, t, r) {
      return (t = ip(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function op(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ip(n.key), n);
      }
    }

    function ip(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ap(e, t, r) {
      return t = cp(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], cp(e).constructor) : t.apply(e, r));
    }

    function cp(e) {
      return (cp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function up(e, t) {
      return (up = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var lp,
        sp,
        pp,
        fp = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = ap(this, t, [e])).state = {
          items: e.initialItems.slice(),
          newItemName: "",
          editingItem: null,
          editedItemName: null
        }, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && up(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && op(e.prototype, t), r && op(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "updateNewItemName",
        value: function (e) {
          this.setState({
            newItemName: e
          });
        }
      }, {
        key: "addItem",
        value: function () {
          var e = this.state,
              t = e.items,
              r = e.newItemName,
              n = this.props.onUpdate,
              o = t.slice();
          "" !== r && (o.find(function (e) {
            return e.name === r;
          }) ? this.setState({
            newItemName: ""
          }) : (o.push({
            name: r
          }), this.setState({
            items: o,
            newItemName: ""
          })), n(o));
        }
      }, {
        key: "editItem",
        value: function (e) {
          this.setState({
            editingItem: e,
            editedItemName: e.name
          });
        }
      }, {
        key: "changeItemName",
        value: function (e) {
          this.setState({
            editedItemName: e
          });
        }
      }, {
        key: "doneEditing",
        value: function (e) {
          var t = this.state,
              r = t.editedItemName,
              n = t.items,
              o = this.props.onUpdate;
          e.name = r, this.setState({
            items: n,
            editedItemName: null,
            editingItem: null
          }), o(n);
        }
      }, {
        key: "removeItem",
        value: function (e) {
          var t = this.state.items,
              r = this.props.onUpdate,
              n = t.filter(function (t) {
            return t !== e;
          });
          this.setState({
            items: n
          }), r(n);
        }
      }, {
        key: "renderItems",
        value: function (e) {
          var t = this,
              r = e.ListItemChild,
              n = this.state,
              o = n.items,
              i = n.editingItem,
              a = n.editedItemName;
          return p.a.createElement("ul", {
            className: "list-group"
          }, ep()(o, function (e) {
            return e.name.toLowerCase();
          }).map(function (n) {
            return p.a.createElement("li", {
              key: n.name,
              className: "list-group-item d-flex justify-content-between align-items-center"
            }, i === n ? p.a.createElement("input", {
              type: "text",
              autoFocus: !0,
              onChange: function (e) {
                return t.changeItemName(e.target.value);
              },
              onBlur: function () {
                return t.doneEditing(n);
              },
              value: a
            }) : p.a.createElement("span", {
              style: {
                cursor: "text"
              },
              onClick: function () {
                return t.editItem(n);
              }
            }, n.name), r ? p.a.createElement(r, Object.assign({
              item: n
            }, e)) : null, p.a.createElement("a", {
              href: "j#",
              onClick: function (e) {
                e.preventDefault(), t.removeItem(n);
              },
              "aria-label": "Remove"
            }, p.a.createElement("i", {
              className: "fa fa-times"
            })));
          }));
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.placeholder,
              n = t.newItemName,
              o = t.t;
          return p.a.createElement("div", {
            className: "list-manager"
          }, p.a.createElement("div", {
            className: "row mb-2"
          }, p.a.createElement("div", {
            className: "col"
          }, p.a.createElement("input", {
            type: "text",
            className: "form-control",
            placeholder: r,
            onChange: function (t) {
              return e.updateNewItemName(t.target.value);
            },
            onKeyPress: function (t) {
              "Enter" === t.key && (t.preventDefault(), e.addItem());
            },
            value: n
          })), p.a.createElement("div", {
            className: "col-ml-auto px-3"
          }, p.a.createElement("button", {
            type: "button",
            onClick: function () {
              return e.addItem();
            },
            className: "btn btn-success"
          }, o("add")))), p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col-sm-12"
          }, this.renderItems(this.props))));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function (e, t) {
          return rp(rp({}, t), {}, {
            items: e.initialItems.slice()
          });
        }
      }]);
    }(),
        dp = Object(g.a)()(fp);

    function bp(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, yp(n.key), n);
      }
    }

    function yp(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function mp(e, t, r) {
      return t = vp(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], vp(e).constructor) : t.apply(e, r));
    }

    function vp(e) {
      return (vp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function hp(e, t) {
      return (hp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function gp(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var wp,
        Op,
        jp = Object(d.observer)((pp = gp((sp = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = mp(this, t, [e]), "activeIngredient", pp, r);
        var n = e.activeIngredient;
        return r.activeIngredient = n ? new w.ActiveIngredient(n) : r.activeIngredient, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && hp(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && bp(e.prototype, t), r && bp(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "alternateNames",
        get: function () {
          return this.activeIngredient.alternateNames;
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props.t;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "active_ingredient_name"
          }, t("name")), p.a.createElement(Xs, {
            placeholder: t("name"),
            name: "active_ingredient[name]",
            id: "active_ingredient_name",
            value: this.activeIngredient.name,
            onChange: function (t) {
              return e.activeIngredient.name = t.target.value;
            }
          })), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "active_ingredient_alternate_names"
          }, t("alternate_names")), p.a.createElement("div", {
            className: "col-sm-10 px-3",
            id: "active_ingredient_alternate_names"
          }, this.alternateNames.map(function (e) {
            return p.a.createElement("input", {
              key: e,
              name: "active_ingredient[alternate_names][]",
              type: "hidden",
              value: e
            });
          }), p.a.createElement(dp, {
            initialItems: this.alternateNames.map(function (e) {
              return {
                name: e
              };
            }),
            onUpdate: function (t) {
              e.activeIngredient.update({
                alternateNames: ee(t.map(function (e) {
                  return e.name;
                })).sort(Q)
              });
            },
            ListItemChild: function (r) {
              return p.a.createElement("div", {
                className: "d-flex justify-content-end flex-grow-1 px-3"
              }, p.a.createElement("button", {
                className: "btn btn-outline-secondary",
                type: "button",
                onClick: function () {
                  return e.activeIngredient.newPrimaryName(r.item.name);
                }
              }, t("use_as_primary_name")));
            },
            placeholder: t("alternate_names")
          }))));
        }
      }]);
    }()).prototype, "activeIngredient", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new w.ActiveIngredient();
      }
    }), gp(sp.prototype, "alternateNames", [f.computed], Object.getOwnPropertyDescriptor(sp.prototype, "alternateNames"), sp.prototype), lp = sp)) || lp,
        Pp = Object(g.a)()(jp);

    function _p(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ep(n.key), n);
      }
    }

    function Ep(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Sp(e, t, r) {
      return t = Cp(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Cp(e).constructor) : t.apply(e, r));
    }

    function Cp(e) {
      return (Cp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function kp(e, t) {
      return (kp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Rp(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Tp,
        zp,
        Np = Object(d.observer)((Rp((Op = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = Sp(this, t, [e])).sprayRecordsStore = void 0, r.sprayRecordsStore = window.sprayRecordsStore, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && kp(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && _p(e.prototype, t), r && _p(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "sprayRecordId",
        get: function () {
          return this.props.sprayRecordId;
        }
      }, {
        key: "sprayRecord",
        get: function () {
          return this.sprayRecordsStore.find(this.sprayRecordId);
        }
      }, {
        key: "applications",
        get: function () {
          return this.sprayRecord && this.sprayRecord.applications || [];
        }
      }, {
        key: "applicator",
        get: function () {
          return this.sprayRecord.licensedApplicator || new w.Contact();
        }
      }, {
        key: "componentDidMount",
        value: function () {
          if (this.props.testThrowError) throw new Error("Test fallback UI");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return p.a.createElement("table", {
            className: "table table-sm"
          }, p.a.createElement("thead", {
            className: "thead-light"
          }, p.a.createElement("tr", null, p.a.createElement("th", {
            scope: "col"
          }, e("name")), p.a.createElement("th", {
            scope: "col"
          }, e("license_number")), p.a.createElement("th", {
            scope: "col"
          }, e("phone")), p.a.createElement("th", {
            scope: "col"
          }, e("address")), p.a.createElement("th", {
            "aria-label": "Actions",
            className: "actions"
          }))), p.a.createElement("tbody", null, p.a.createElement("tr", null, p.a.createElement("td", null, this.applicator.name), p.a.createElement("td", null, this.applicator.licenseNumber), p.a.createElement("td", null, this.applicator.phone), p.a.createElement("td", null, this.applicator.address), p.a.createElement("td", null))));
        }
      }]);
    }()).prototype, "sprayRecordId", [f.computed], Object.getOwnPropertyDescriptor(Op.prototype, "sprayRecordId"), Op.prototype), Rp(Op.prototype, "sprayRecord", [f.computed], Object.getOwnPropertyDescriptor(Op.prototype, "sprayRecord"), Op.prototype), Rp(Op.prototype, "applications", [f.computed], Object.getOwnPropertyDescriptor(Op.prototype, "applications"), Op.prototype), Rp(Op.prototype, "applicator", [f.computed], Object.getOwnPropertyDescriptor(Op.prototype, "applicator"), Op.prototype), wp = Op)) || wp,
        Dp = Object(g.a)()(Np);

    function xp(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ap(n.key), n);
      }
    }

    function Ap(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Mp(e, t, r) {
      return t = Ip(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Ip(e).constructor) : t.apply(e, r));
    }

    function Ip(e) {
      return (Ip = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Fp(e, t) {
      return (Fp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Bp = Object(d.observer)(((zp = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = Mp(this, t, [].concat(n))).onReload = function (e) {
          e.preventDefault(), window.location.reload();
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Fp(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && xp(e.prototype, t), r && xp(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.errorMessage,
              r = e.allowReload,
              n = e.t;
          return p.a.createElement("span", {
            className: "error-component"
          }, t, r ? p.a.createElement(p.a.Fragment, null, " ", p.a.createElement("a", {
            href: "#",
            onClick: this.onReload
          }, n("reload_this_page"))) : null);
        }
      }]);
    }()).defaultProps = {
      errorMessage: "Error rendering component.",
      allowReload: !0
    }, Tp = zp)) || Tp,
        Lp = Object(g.a)()(Bp),
        Vp = r(139),
        Up = r.n(Vp);

    function qp(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Kp(e, t, r) {
      return (t = Wp(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Gp(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Wp(n.key), n);
      }
    }

    function Wp(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var Hp = function () {
      return e = function e(t, r) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.message = "", this.stackFrames = [], this.url = void 0, this.componentStack = void 0, this.componentProps = void 0, this.message = t.message, this.stackFrames = Up.a.parse(t), r && (this.url = r.url, this.componentStack = r.componentStack, this.componentProps = r.componentProps);
      }, (t = [{
        key: "serialize",
        value: function () {
          var e,
              t = this.message,
              r = this.stackFrames,
              n = this.componentStack,
              o = this.componentProps,
              i = this.url;
          if ((i || n || o) && (e = {}, i && (e.url = i), n && (e.component_stack = n), o)) try {
            e.component_props = JSON.stringify(o, null, 2);
          } catch (e) {}
          var a = {
            error: {
              message: t,
              stack_frames: r.map(function (e) {
                return function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var r = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? qp(Object(r), !0).forEach(function (t) {
                      Kp(e, t, r[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : qp(Object(r)).forEach(function (t) {
                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                    });
                  }

                  return e;
                }({}, e);
              })
            }
          };
          return e && (a.info = e), a;
        }
      }]) && Gp(e.prototype, t), r && Gp(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function Jp(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Yp(n.key), n);
      }
    }

    function Yp(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var Qp = function () {
      return e = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.apiErrorsPath = "/if2/api/errors", this.apiErrorsNotifyPath = [this.apiErrorsPath].concat("notify").join("/");
      }, (t = [{
        key: "csrf",
        value: function () {
          return document.querySelector("[name='csrf-token']").content;
        }
      }, {
        key: "notify",
        value: function (e) {
          var t = this.csrf();
          return fetch(this.apiErrorsNotifyPath, {
            method: "POST",
            headers: {
              "X-CSRF-Token": t,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
          });
        }
      }]) && Jp(e.prototype, t), r && Jp(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function $p(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Xp(e, t, r) {
      return (t = ef(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Zp(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ef(n.key), n);
      }
    }

    function ef(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var tf = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.api = new Qp(), t && (this.api = t);
      }, (t = [{
        key: "notify",
        value: function (e, t) {
          var r = new Hp(e, function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {};
              t % 2 ? $p(Object(r), !0).forEach(function (t) {
                Xp(e, t, r[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : $p(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
            }

            return e;
          }({
            url: window.location.toString()
          }, t));
          return this.api.notify(r.serialize());
        }
      }]) && Zp(e.prototype, t), r && Zp(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function rf(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function nf(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? rf(Object(r), !0).forEach(function (t) {
          of(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : rf(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function of(e, t, r) {
      return (t = cf(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function af(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, cf(n.key), n);
      }
    }

    function cf(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function uf(e, t, r) {
      return t = lf(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], lf(e).constructor) : t.apply(e, r));
    }

    function lf(e) {
      return (lf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function sf(e, t) {
      return (sf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var pf,
        ff,
        df,
        bf,
        yf,
        mf = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = uf(this, t, [e])).errorsService = new tf(), r.state = {
          hasError: !1
        }, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && sf(e, t);
      }(t, s["Component"]), r = t, o = [{
        key: "getDerivedStateFromError",
        value: function () {
          return {
            hasError: !0
          };
        }
      }], (n = [{
        key: "componentDidCatch",
        value: function (e, t) {
          var r = this.props.componentProps;
          this.errorsService.notify(e, nf(nf({}, t), {}, {
            componentProps: r
          }));
        }
      }, {
        key: "render",
        value: function () {
          var e = this.state.hasError,
              t = this.props,
              r = t.renderError,
              n = t.children;
          return e ? r() : n;
        }
      }]) && af(r.prototype, n), o && af(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function vf(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function hf(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, gf(n.key), n);
      }
    }

    function gf(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function wf(e, t, r) {
      return t = Of(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Of(e).constructor) : t.apply(e, r));
    }

    function Of(e) {
      return (Of = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function jf(e, t) {
      return (jf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Pf(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    mf.defaultProps = {
      renderError: function () {
        return p.a.createElement(Lp, null);
      }
    };

    var _f,
        Ef,
        Sf,
        Cf,
        kf,
        Rf,
        Tf = Object(d.observer)((df = Pf((ff = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), vf(r = wf(this, t, [e]), "isOpen", df, r), vf(r, "close", bf, r), vf(r, "open", yf, r), r.sprayRecordsStore = window.sprayRecordsStore, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && jf(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && hf(e.prototype, t), r && hf(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "sprayRecord",
        get: function () {
          var e = this.props.sprayRecordId;
          return this.sprayRecordsStore.find(e);
        }
      }, {
        key: "licensedApplicator",
        get: function () {
          return this.sprayRecord && this.sprayRecord.licensedApplicator;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return p.a.createElement(h.Card, {
            shouldNotPrint: !this.licensedApplicator
          }, p.a.createElement(h.CardHeader, {
            isOpen: this.isOpen,
            title: e("licensed_applicator").toUpperCase(),
            onOpen: this.open,
            onClose: this.close,
            hasToggle: !0
          }), p.a.createElement(h.CardBody, {
            isOpen: this.isOpen
          }, p.a.createElement(mf, {
            componentProps: this.props,
            renderError: function () {
              return p.a.createElement(Lp, {
                errorMessage: e("error_displaying_licensed_applicator")
              });
            }
          }, p.a.createElement(Dp, this.props))));
        }
      }]);
    }()).prototype, "isOpen", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !0;
      }
    }), Pf(ff.prototype, "sprayRecord", [f.computed], Object.getOwnPropertyDescriptor(ff.prototype, "sprayRecord"), ff.prototype), Pf(ff.prototype, "licensedApplicator", [f.computed], Object.getOwnPropertyDescriptor(ff.prototype, "licensedApplicator"), ff.prototype), bf = Pf(ff.prototype, "close", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isOpen = !1;
        };
      }
    }), yf = Pf(ff.prototype, "open", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isOpen = !0;
        };
      }
    }), pf = ff)) || pf,
        zf = Object(g.a)()(Tf);

    function Nf(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Df(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, xf(n.key), n);
      }
    }

    function xf(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Af(e, t, r) {
      return t = Mf(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Mf(e).constructor) : t.apply(e, r));
    }

    function Mf(e) {
      return (Mf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function If(e, t) {
      return (If = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Ff(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Bf = Object(d.observer)((Sf = Ff((Ef = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Nf(r = Af(this, t, [e]), "currentUnit", Sf, r), Nf(r, "currentValue", Cf, r), Nf(r, "updateValue", kf, r), Nf(r, "updateUnit", Rf, r);
        var n = r.props,
            o = n.current,
            i = n.unitList,
            a = r.props,
            c = a.currentUnit,
            u = a.currentValue;

        if (o) {
          var l = new w.Quantity(o);
          u = "".concat(l.scalar), c = l.units;
        }

        return r.currentUnit = c || new h.UnitChoiceModel(i[0]).value || "", r.currentValue = u || "", r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && If(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "current",
        get: function () {
          var e, t;
          return this.currentValue || "0" === this.currentValue || "dry" === (null === (e = this.currentUnit) || void 0 === e || null === (t = e.toLowerCase) || void 0 === t ? void 0 : t.call(e)) ? [this.currentValue, this.currentUnit].filter(Boolean).join(" ") : "";
        }
      }, {
        key: "unitChoices",
        get: function () {
          var e = this,
              t = this.props.unitList.map(function (e) {
            return new h.UnitChoiceModel(e);
          });
          return this.currentUnit && !t.find(function (t) {
            return e.currentUnit === t.value;
          }) ? [new h.UnitChoiceModel(this.currentUnit)].concat(t) : t;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.name,
              r = e.placeholder;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("input", {
            type: "hidden",
            name: t,
            value: this.current
          }), p.a.createElement(h.UnitSelector, {
            placeholder: r,
            valueColumnClassName: "col-sm-6",
            unitColumnClassName: "col-sm-4",
            currentUnit: this.currentUnit,
            currentValue: this.currentValue,
            onUpdateValue: this.updateValue,
            onUpdateUnit: this.updateUnit,
            unitChoices: this.unitChoices
          }));
        }
      }]) && Df(r.prototype, n), o && Df(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "currentUnit", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Cf = Ff(Ef.prototype, "currentValue", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Ff(Ef.prototype, "current", [f.computed], Object.getOwnPropertyDescriptor(Ef.prototype, "current"), Ef.prototype), Ff(Ef.prototype, "unitChoices", [f.computed], Object.getOwnPropertyDescriptor(Ef.prototype, "unitChoices"), Ef.prototype), kf = Ff(Ef.prototype, "updateValue", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.currentValue = t;
        };
      }
    }), Rf = Ff(Ef.prototype, "updateUnit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.currentUnit = t;
        };
      }
    }), _f = Ef)) || _f;

    function Lf(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Vf(n.key), n);
      }
    }

    function Vf(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Uf(e, t, r) {
      return t = qf(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], qf(e).constructor) : t.apply(e, r));
    }

    function qf(e) {
      return (qf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Kf(e, t) {
      return (Kf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Gf,
        Wf,
        Hf,
        Jf,
        Yf,
        Qf,
        $f,
        Xf,
        Zf = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = Uf(this, t, [e])).state = {
          selectedContactId: e.applicator.contact.id,
          selectedTractorSerial: e.applicator.tractor.serial,
          selectedSprayerSerial: e.applicator.sprayer.serial
        }, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Kf(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Lf(e.prototype, t), r && Lf(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "componentDidMount",
        value: function () {
          this.selectDefaultTractorAndSprayer();
        }
      }, {
        key: "contactNameAndLicense",
        value: function (e) {
          var t = "".concat(e.firstName, " ").concat(e.lastName);
          return e.licenseNumber.length > 0 && (t += " (".concat(e.licenseNumber, ")")), t;
        }
      }, {
        key: "selectContact",
        value: function (e) {
          var t = this;
          this.setState({
            selectedContactId: e
          }, function () {
            t.selectDefaultTractorAndSprayer();
          });
        }
      }, {
        key: "selectTractor",
        value: function (e) {
          this.setState({
            selectedTractorSerial: e
          });
        }
      }, {
        key: "selectSprayer",
        value: function (e) {
          this.setState({
            selectedSprayerSerial: e
          });
        }
      }, {
        key: "selectedContact",
        get: function () {
          var e = this;
          return Es.a.find(this.props.applicatorContacts, function (t) {
            return t.id == e.state.selectedContactId;
          });
        }
      }, {
        key: "selectDefaultTractorAndSprayer",
        value: function () {
          this.selectedContact && (this.selectedContact.defaultTractor && (console.log(this.selectedContact.defaultTractor), this.setState({
            selectedTractorSerial: this.selectedContact.defaultTractor.serial
          })), this.selectedContact.defaultSprayer && (console.log(this.selectedContact.defaultSprayer), this.setState({
            selectedSprayerSerial: this.selectedContact.defaultSprayer.serial
          })));
        }
      }, {
        key: "renderNoApplicators",
        value: function () {
          var e = this.props.t;
          return p.a.createElement("div", {
            className: "alert alert-warning mt-1"
          }, p.a.createElement("a", {
            href: this.props.newContactPath
          }, e("add_a_contact")));
        }
      }, {
        key: "renderApplicatorSelector",
        value: function () {
          var e = this;
          return p.a.createElement("select", {
            name: "spray_record_applicator[contact_id]",
            value: this.state.selectedContactId,
            onChange: function (t) {
              return e.selectContact(t.target.value);
            },
            className: "form-control"
          }, p.a.createElement("option", null), this.props.applicatorContacts.map(function (t) {
            return p.a.createElement("option", {
              key: t.id,
              value: t.id
            }, e.contactNameAndLicense(t));
          }));
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props.t;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("div", {
            className: "form-group row"
          }, p.a.createElement("label", {
            className: "col-sm-2 col-form-label"
          }, t("contact")), p.a.createElement("div", {
            className: "col-sm-10"
          }, 0 == this.props.applicatorContacts.length ? this.renderNoApplicators() : this.renderApplicatorSelector())), p.a.createElement("div", {
            className: "form-group row"
          }, p.a.createElement("label", {
            className: "col-sm-2 col-form-label"
          }, t("tractor")), p.a.createElement("div", {
            className: "col-sm-10"
          }, p.a.createElement("select", {
            name: "spray_record_applicator[tractor_id]",
            value: this.state.selectedTractorSerial,
            onChange: function (t) {
              return e.selectTractor(t.target.value);
            },
            className: "form-control"
          }, p.a.createElement("option", null), this.props.tractors.map(function (e) {
            return p.a.createElement("option", {
              value: e.serial
            }, e.name);
          })))), p.a.createElement("div", {
            className: "form-group row"
          }, p.a.createElement("label", {
            className: "col-sm-2 col-form-label"
          }, t("sprayer")), p.a.createElement("div", {
            className: "col-sm-10"
          }, p.a.createElement("select", {
            name: "spray_record_applicator[sprayer_id]",
            value: this.state.selectedSprayerSerial,
            onChange: function (t) {
              return e.selectSprayer(t.target.value);
            },
            className: "form-control"
          }, p.a.createElement("option", null), this.props.sprayers.map(function (e) {
            return p.a.createElement("option", {
              value: e.serial
            }, e.name);
          })))), p.a.createElement("div", {
            className: "form-group row"
          }, p.a.createElement("label", {
            className: "col-sm-2 col-form-label"
          }, t("spray_rate")), p.a.createElement(Bf, {
            valueColumnClassName: "col-sm-6",
            unitColumnClassName: "col-sm-4",
            name: "spray_record_applicator[spray_rate]",
            current: this.props.applicator.spray_rate,
            unitList: ["gal/acre"],
            class: "row"
          })));
        }
      }]);
    }(),
        ed = Object(g.a)()(Zf),
        td = r(11),
        rd = r(26);

    function nd(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function od(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, id(n.key), n);
      }
    }

    function id(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ad(e, t, r) {
      return t = cd(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], cd(e).constructor) : t.apply(e, r));
    }

    function cd(e) {
      return (cd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ud(e, t) {
      return (ud = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ld(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var sd,
        pd = Object(d.observer)(((Xf = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = ad(this, t, [].concat(n))).fingerprint = Object(td.v4)(), nd(e, "unitChoices", Hf, e), nd(e, "setSprayer", Jf, e), nd(e, "setSpreader", Yf, e), nd(e, "onSprayerPress", Qf, e), nd(e, "onSpreaderPress", $f, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ud(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && od(e.prototype, t), r && od(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "sprayerRadioId",
        get: function () {
          return "sprayer-radio-".concat(this.fingerprint);
        }
      }, {
        key: "spreaderRadioId",
        get: function () {
          return "spreader-radio-".concat(this.fingerprint);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.implementType,
              r = e.tractorError,
              n = e.sprayerError,
              o = e.spreaderError,
              i = e.tractorSelector,
              a = e.sprayerSelector,
              c = e.spreaderSelector,
              u = e.rateUnit,
              l = e.rateUnitsError,
              s = e.rateValue,
              f = e.rateValueError,
              d = e.makeEquipmentDefault,
              b = e.onUpdateRateUnit,
              y = e.onUpdateRateValue,
              m = e.onToggleMakeEquipmentDefault,
              v = e.tankCleaned,
              g = e.onToggleTankCleaned,
              w = e.t;
          return p.a.createElement("div", {
            className: "equipment-selector",
            role: "group",
            "aria-label": "Equipment"
          }, p.a.createElement("div", {
            className: "row modal-input-row mt-3"
          }, p.a.createElement("div", {
            className: "col mx-0"
          }, p.a.createElement("div", {
            className: "row modal-input-row mb-0 mx-0"
          }, p.a.createElement("div", {
            className: "col-sm-12 px-1"
          }, p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", null, "Tractor"), p.a.createElement(h.SelectDropdown, {
            className: r ? "is-invalid" : "",
            placeholder: w("tractor"),
            options: i.options,
            onChange: i.change,
            model: i
          }), p.a.createElement("div", {
            className: "invalid-feedback"
          }, r)))), p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col-sm-12 px-1"
          }, p.a.createElement("div", {
            role: "button",
            className: "form-check form-check-inline",
            onClick: this.setSprayer,
            onKeyPress: this.onSprayerPress,
            tabIndex: 0
          }, p.a.createElement("input", {
            className: "form-check-input".concat(n ? " is-invalid" : ""),
            style: {
              pointerEvents: "none"
            },
            name: "implement-type",
            type: "radio",
            readOnly: !0,
            checked: "sprayer" === t,
            id: this.sprayerRadioId
          }), p.a.createElement("label", {
            className: "form-check-label",
            htmlFor: this.sprayerRadioId
          }, "Sprayer")), p.a.createElement("div", {
            role: "button",
            className: "form-check form-check-inline",
            onClick: this.setSpreader,
            onKeyPress: this.onSpreaderPress,
            tabIndex: 0
          }, p.a.createElement("input", {
            className: "form-check-input".concat(o ? " is-invalid" : ""),
            style: {
              pointerEvents: "none"
            },
            name: "implement-type",
            type: "radio",
            readOnly: !0,
            checked: "spreader" === t,
            id: this.spreaderRadioId
          }), p.a.createElement("label", {
            className: "form-check-label",
            htmlFor: this.spreaderRadioId
          }, "Spreader"))))), "spreader" === t ? p.a.createElement("div", {
            className: "row modal-input-row mb-0 mx-0"
          }, p.a.createElement("div", {
            className: "col-sm-12 px-1"
          }, p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement(h.SelectDropdown, {
            className: o ? "is-invalid" : "",
            placeholder: w("spreader"),
            options: c.options,
            onChange: c.change,
            model: c
          }), p.a.createElement("div", {
            className: "invalid-feedback"
          }, o)))) : p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("div", {
            className: "row modal-input-row mb-0 mx-0"
          }, p.a.createElement("div", {
            className: "col-sm-8 px-1"
          }, p.a.createElement(h.SelectDropdown, {
            className: n ? "is-invalid" : "",
            placeholder: w("sprayer"),
            options: a.options,
            onChange: a.change,
            model: a
          }), p.a.createElement("div", {
            className: "invalid-feedback"
          }, n)), p.a.createElement("div", {
            className: "col-sm-4"
          }, p.a.createElement("div", {
            className: "row modal-input-row mb-0 mx-0",
            "data-testid": "spray-rate-quantity-selector"
          }, p.a.createElement(h.UnitSelector, {
            placeholder: w("rate"),
            currentUnit: u,
            currentValue: s,
            unitChoices: this.unitChoices,
            valueColumnClassName: "col-md-5 unit-selector-value px-1",
            unitColumnClassName: "col-md-7 unit-selector-unit px-1",
            valueError: f,
            unitsError: l,
            onUpdateUnit: b,
            onUpdateValue: y
          }))))))), p.a.createElement("div", {
            className: "equipment-selector-options"
          }, p.a.createElement(rd.a, {
            label: w("make_default"),
            isChecked: d,
            onChange: m
          }), "sprayer" === t ? p.a.createElement("div", {
            className: "tank-cleaned-container"
          }, p.a.createElement(rd.a, {
            label: w("tank_cleaned"),
            isChecked: v,
            onChange: g
          }), p.a.createElement("img", {
            className: "tank-cleaned-icon",
            alt: w("tank_cleaned")
          })) : null));
        }
      }]);
    }()).defaultProps = {
      onSetImplementType: function () {}
    }, Xf.KEY_ENTER = 13, Hf = ld((Wf = Xf).prototype, "unitChoices", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [{
          value: "gal/acre"
        }];
      }
    }), ld(Wf.prototype, "sprayerRadioId", [f.computed], Object.getOwnPropertyDescriptor(Wf.prototype, "sprayerRadioId"), Wf.prototype), ld(Wf.prototype, "spreaderRadioId", [f.computed], Object.getOwnPropertyDescriptor(Wf.prototype, "spreaderRadioId"), Wf.prototype), Jf = ld(Wf.prototype, "setSprayer", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          (0, e.props.onSetImplementType)("sprayer");
        };
      }
    }), Yf = ld(Wf.prototype, "setSpreader", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          (0, e.props.onSetImplementType)("spreader");
        };
      }
    }), Qf = ld(Wf.prototype, "onSprayerPress", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          if (t.which === e.constructor.KEY_ENTER) return e.setSprayer();
        };
      }
    }), $f = ld(Wf.prototype, "onSpreaderPress", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          if (t.which === e.constructor.KEY_ENTER) return e.setSpreader();
        };
      }
    }), Gf = Wf)) || Gf,
        fd = Object(g.a)()(pd);

    function dd(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bd(n.key), n);
      }
    }

    function bd(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function yd(e, t, r) {
      return t = md(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], md(e).constructor) : t.apply(e, r));
    }

    function md(e) {
      return (md = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function vd(e, t) {
      return (vd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var hd = Object(d.observer)(sd = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), yd(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && vd(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && dd(e.prototype, t), r && dd(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "componentWillUnmount",
        value: function () {
          this.props.model.onUnmount();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.model,
              t = e.props,
              r = t.id,
              n = t.disableAnimation,
              o = t.showEquipmentSelectors,
              i = t.requiresSprayer,
              a = t.requiresSpreader,
              c = t.t,
              u = e.applicator,
              l = e.isNew,
              s = e.showRemoveBtn,
              f = e.isNameEditable;
          return p.a.createElement(h.ModalDialog, {
            id: r,
            ariaLabelledBy: "".concat(r, "-header"),
            size: "large",
            className: "applicator-editor-modal",
            dismissOnClose: !1,
            disableAnimation: n
          }, p.a.createElement(h.ModalHeader, {
            id: "".concat(r, "-header"),
            title: l ? c("new_applicator") : u.contact.name,
            onClose: e.onClose
          }), p.a.createElement(h.ModalBody, null, p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col mx-5 py-3 px-5"
          }, p.a.createElement("div", {
            className: "row modal-input-row"
          }, p.a.createElement("div", {
            className: "col-sm-6 px-1"
          }, p.a.createElement("div", {
            className: "row modal-input-row mb-0 mx-0"
          }, p.a.createElement("div", {
            className: "col-sm-6 mr-1 pr-1"
          }, p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", null, "First Name"), p.a.createElement("input", {
            type: "text",
            className: "form-control".concat(e.firstNameError ? " is-invalid" : ""),
            readOnly: !f,
            placeholder: c("first_name"),
            value: e.applicator.contact.firstName,
            onChange: e.onChangeFirstName
          }), p.a.createElement("div", {
            className: "invalid-feedback"
          }, e.firstNameError))), p.a.createElement("div", {
            className: "col-sm-6 ml-n1"
          }, p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", null, "Last Name"), p.a.createElement("input", {
            type: "text",
            className: "form-control".concat(e.lastNameError ? " is-invalid" : ""),
            readOnly: !f,
            placeholder: c("last_name"),
            value: e.applicator.contact.lastName,
            onChange: e.onChangeLastName
          }), p.a.createElement("div", {
            className: "invalid-feedback"
          }, e.lastNameError))))), p.a.createElement("div", {
            className: "col-sm-6 px-1"
          }, p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", null, "License Number"), p.a.createElement("input", {
            type: "text",
            className: "form-control".concat(e.licenseNumberError ? " is-invalid" : ""),
            placeholder: c("license_number_full"),
            value: e.applicator.contact.licenseNumber,
            onChange: e.onChangeLicenseNumber
          }), p.a.createElement("div", {
            className: "invalid-feedback"
          }, e.licenseNumberError)))), p.a.createElement("div", {
            className: "row modal-input-row"
          }, p.a.createElement("div", {
            className: "col-sm-6 px-1"
          }, p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", null, "Phone Number"), p.a.createElement("input", {
            type: "text",
            className: "form-control",
            placeholder: c("phone_number"),
            value: e.applicator.contact.phone,
            onChange: e.onChangePhone
          }))), p.a.createElement("div", {
            className: "col-sm-6 px-1"
          }, p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", null, "Email Address"), p.a.createElement("input", {
            type: "text",
            className: "form-control",
            placeholder: c("email_address"),
            value: e.applicator.contact.email,
            onChange: e.onChangeEmail
          })))), p.a.createElement("div", {
            className: "row modal-input-row"
          }, p.a.createElement("div", {
            className: "col-sm-6 px-1"
          }, p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", null, "Street Address"), p.a.createElement("input", {
            type: "text",
            className: "form-control",
            placeholder: c("street"),
            value: e.addressModel.street1,
            onChange: e.onChangeStreet1
          }))), p.a.createElement("div", {
            className: "col-sm-6 px-1"
          }, p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", null, "City"), p.a.createElement("input", {
            type: "text",
            className: "form-control",
            placeholder: c("city"),
            value: e.addressModel.city,
            onChange: e.onChangeCity
          })))), p.a.createElement("div", {
            className: "row modal-input-row"
          }, p.a.createElement("div", {
            className: "col-sm-6 px-1"
          }, p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", null, "State"), p.a.createElement("input", {
            type: "text",
            className: "form-control",
            placeholder: c("state"),
            value: e.addressModel.state,
            onChange: e.onChangeState
          }))), p.a.createElement("div", {
            className: "col-sm-6 px-1"
          }, p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", null, "Zip"), p.a.createElement("input", {
            type: "text",
            className: "form-control",
            placeholder: c("zip"),
            value: e.addressModel.zip,
            onChange: e.onChangeZip
          })))), e.showMakeDefaultContact ? p.a.createElement("div", {
            className: "contact-options"
          }, p.a.createElement(rd.a, {
            label: c("make_default"),
            isChecked: e.makeContactDefault,
            onChange: e.onToggleMakeContactDefault
          })) : null, o ? p.a.createElement(fd, {
            tractorSelector: e.tractorSelector,
            sprayerSelector: e.sprayerSelector,
            spreaderSelector: e.spreaderSelector,
            requiresSprayer: i,
            requiresSpreader: a,
            implementType: e.implementType,
            rateUnit: e.rateUnit,
            rateValue: e.rateValue,
            tractorError: e.tractorError,
            sprayerError: e.sprayerError,
            spreaderError: e.spreaderError,
            rateUnitsError: e.rateUnitsError,
            rateValueError: e.rateValueError,
            makeEquipmentDefault: e.makeEquipmentDefault,
            onToggleMakeEquipmentDefault: e.onToggleMakeEquipmentDefault,
            onUpdateRateUnit: e.onUpdateRateUnit,
            onUpdateRateValue: e.onUpdateRateValue,
            tankCleaned: e.applicator.tankCleaned,
            onToggleTankCleaned: e.toggleTankCleaned,
            onSetImplementType: e.onSetImplementType
          }) : null, p.a.createElement("div", {
            className: "row modal-input-row mt-3"
          }, p.a.createElement("div", {
            className: "col-md-8 col-lg-6 ml-auto"
          }, p.a.createElement("div", {
            className: "row no-gutters"
          }, p.a.createElement("div", {
            className: "col-sm-6 px-1"
          }, s ? p.a.createElement("button", {
            type: "button",
            className: "btn btn-danger",
            onClick: e.onRemove
          }, c("remove")) : null), p.a.createElement("div", {
            className: "col-sm-6 px-1"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-success",
            onClick: e.onSave
          }, c("save"))))))))));
        }
      }]);
    }()) || sd,
        gd = Object(g.a)()(hd);

    function wd(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Od(n.key), n);
      }
    }

    function Od(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function jd(e, t, r) {
      return t = Sd(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, _d() ? Reflect.construct(t, r || [], Sd(e).constructor) : t.apply(e, r));
    }

    function Pd(e) {
      var t = "function" == typeof Map ? new Map() : void 0;
      return (Pd = function (e) {
        if (null === e || !function (e) {
          try {
            return -1 !== Function.toString.call(e).indexOf("[native code]");
          } catch (t) {
            return "function" == typeof e;
          }
        }(e)) return e;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, r);
        }

        function r() {
          return function (e, t, r) {
            if (_d()) return Reflect.construct.apply(null, arguments);
            var n = [null];
            n.push.apply(n, t);
            var o = new (e.bind.apply(e, n))();
            return r && Ed(o, r.prototype), o;
          }(e, arguments, Sd(this).constructor);
        }

        return r.prototype = Object.create(e.prototype, {
          constructor: {
            value: r,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), Ed(r, e);
      })(e);
    }

    function _d() {
      try {
        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch (e) {}

      return (_d = function () {
        return !!e;
      })();
    }

    function Ed(e, t) {
      return (Ed = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Sd(e) {
      return (Sd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var Cd = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = jd(this, t, [e.message || e.statusText])).status = e.status, r.statusText = e.statusText, r.errors = e.errors || [], r.name = r.constructor.name, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ed(e, t);
      }(t, Pd(Error)), r = t, (n = [{
        key: "formatMessage",
        value: function () {
          return [].concat(this.message || []).concat(this.errors || []).join("\n\t") || this;
        }
      }]) && wd(r.prototype, n), o && wd(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function kd(e) {
      return (kd = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function Rd(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Td(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? Object(arguments[t]) : {},
            n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
          return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), n.forEach(function (t) {
          Rd(e, t, r[t]);
        });
      }

      return e;
    }

    function zd(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Nd(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function Dd(e, t, r) {
      return t && Nd(e.prototype, t), r && Nd(e, r), e;
    }

    function xd(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function Ad(e, t) {
      return !t || "object" !== kd(t) && "function" != typeof t ? xd(e) : t;
    }

    function Md(e) {
      return (Md = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Id(e, t) {
      return (Id = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Fd(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && Id(e, t);
    }

    var Bd = {
      type: "logger",
      log: function (e) {
        this.output("log", e);
      },
      warn: function (e) {
        this.output("warn", e);
      },
      error: function (e) {
        this.output("error", e);
      },
      output: function (e, t) {
        console && console[e] && console[e].apply(console, t);
      }
    },
        Ld = new (function () {
      function e(t) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        zd(this, e), this.init(t, r);
      }

      return Dd(e, [{
        key: "init",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.prefix = t.prefix || "i18next:", this.logger = e || Bd, this.options = t, this.debug = t.debug;
        }
      }, {
        key: "setDebug",
        value: function (e) {
          this.debug = e;
        }
      }, {
        key: "log",
        value: function () {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

          return this.forward(t, "log", "", !0);
        }
      }, {
        key: "warn",
        value: function () {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

          return this.forward(t, "warn", "", !0);
        }
      }, {
        key: "error",
        value: function () {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

          return this.forward(t, "error", "");
        }
      }, {
        key: "deprecate",
        value: function () {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

          return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
        }
      }, {
        key: "forward",
        value: function (e, t, r, n) {
          return n && !this.debug ? null : ("string" == typeof e[0] && (e[0] = "".concat(r).concat(this.prefix, " ").concat(e[0])), this.logger[t](e));
        }
      }, {
        key: "create",
        value: function (t) {
          return new e(this.logger, Td({}, {
            prefix: "".concat(this.prefix, ":").concat(t, ":")
          }, this.options));
        }
      }]), e;
    }())(),
        Vd = function () {
      function e() {
        zd(this, e), this.observers = {};
      }

      return Dd(e, [{
        key: "on",
        value: function (e, t) {
          var r = this;
          return e.split(" ").forEach(function (e) {
            r.observers[e] = r.observers[e] || [], r.observers[e].push(t);
          }), this;
        }
      }, {
        key: "off",
        value: function (e, t) {
          this.observers[e] && (t ? this.observers[e] = this.observers[e].filter(function (e) {
            return e !== t;
          }) : delete this.observers[e]);
        }
      }, {
        key: "emit",
        value: function (e) {
          for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];

          if (this.observers[e]) {
            var o = [].concat(this.observers[e]);
            o.forEach(function (e) {
              e.apply(void 0, r);
            });
          }

          if (this.observers["*"]) {
            var i = [].concat(this.observers["*"]);
            i.forEach(function (t) {
              t.apply(t, [e].concat(r));
            });
          }
        }
      }]), e;
    }();

    function Ud() {
      var e,
          t,
          r = new Promise(function (r, n) {
        e = r, t = n;
      });
      return r.resolve = e, r.reject = t, r;
    }

    function qd(e) {
      return null == e ? "" : "" + e;
    }

    function Kd(e, t, r) {
      function n(e) {
        return e && e.indexOf("###") > -1 ? e.replace(/###/g, ".") : e;
      }

      function o() {
        return !e || "string" == typeof e;
      }

      for (var i = "string" != typeof t ? [].concat(t) : t.split("."); i.length > 1;) {
        if (o()) return {};
        var a = n(i.shift());
        !e[a] && r && (e[a] = new r()), e = e[a];
      }

      return o() ? {} : {
        obj: e,
        k: n(i.shift())
      };
    }

    function Gd(e, t, r) {
      var n = Kd(e, t, Object);
      n.obj[n.k] = r;
    }

    function Wd(e, t) {
      var r = Kd(e, t),
          n = r.obj,
          o = r.k;
      if (n) return n[o];
    }

    function Hd(e, t, r) {
      var n = Wd(e, r);
      return void 0 !== n ? n : Wd(t, r);
    }

    function Jd(e, t, r) {
      for (var n in t) "__proto__" !== n && "constructor" !== n && (n in e ? "string" == typeof e[n] || e[n] instanceof String || "string" == typeof t[n] || t[n] instanceof String ? r && (e[n] = t[n]) : Jd(e[n], t[n], r) : e[n] = t[n]);

      return e;
    }

    function Yd(e) {
      return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }

    var Qd = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "/": "&#x2F;"
    };

    function $d(e) {
      return "string" == typeof e ? e.replace(/[&<>"'\/]/g, function (e) {
        return Qd[e];
      }) : e;
    }

    var Xd = "undefined" != typeof window && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1,
        Zd = function (e) {
      function t(e) {
        var r,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
          ns: ["translation"],
          defaultNS: "translation"
        };
        return zd(this, t), r = Ad(this, Md(t).call(this)), Xd && Vd.call(xd(r)), r.data = e || {}, r.options = n, void 0 === r.options.keySeparator && (r.options.keySeparator = "."), r;
      }

      return Fd(t, Vd), Dd(t, [{
        key: "addNamespaces",
        value: function (e) {
          this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
        }
      }, {
        key: "removeNamespaces",
        value: function (e) {
          var t = this.options.ns.indexOf(e);
          t > -1 && this.options.ns.splice(t, 1);
        }
      }, {
        key: "getResource",
        value: function (e, t, r) {
          var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              o = void 0 !== n.keySeparator ? n.keySeparator : this.options.keySeparator,
              i = [e, t];
          return r && "string" != typeof r && (i = i.concat(r)), r && "string" == typeof r && (i = i.concat(o ? r.split(o) : r)), e.indexOf(".") > -1 && (i = e.split(".")), Wd(this.data, i);
        }
      }, {
        key: "addResource",
        value: function (e, t, r, n) {
          var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {
            silent: !1
          },
              i = this.options.keySeparator;
          void 0 === i && (i = ".");
          var a = [e, t];
          r && (a = a.concat(i ? r.split(i) : r)), e.indexOf(".") > -1 && (n = t, t = (a = e.split("."))[1]), this.addNamespaces(t), Gd(this.data, a, n), o.silent || this.emit("added", e, t, r, n);
        }
      }, {
        key: "addResources",
        value: function (e, t, r) {
          var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
            silent: !1
          };

          for (var o in r) "string" != typeof r[o] && "[object Array]" !== Object.prototype.toString.apply(r[o]) || this.addResource(e, t, o, r[o], {
            silent: !0
          });

          n.silent || this.emit("added", e, t, r);
        }
      }, {
        key: "addResourceBundle",
        value: function (e, t, r, n, o) {
          var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {
            silent: !1
          },
              a = [e, t];
          e.indexOf(".") > -1 && (n = r, r = t, t = (a = e.split("."))[1]), this.addNamespaces(t);
          var c = Wd(this.data, a) || {};
          n ? Jd(c, r, o) : c = Td({}, c, r), Gd(this.data, a, c), i.silent || this.emit("added", e, t, r);
        }
      }, {
        key: "removeResourceBundle",
        value: function (e, t) {
          this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
        }
      }, {
        key: "hasResourceBundle",
        value: function (e, t) {
          return void 0 !== this.getResource(e, t);
        }
      }, {
        key: "getResourceBundle",
        value: function (e, t) {
          return t || (t = this.options.defaultNS), "v1" === this.options.compatibilityAPI ? Td({}, {}, this.getResource(e, t)) : this.getResource(e, t);
        }
      }, {
        key: "getDataByLanguage",
        value: function (e) {
          return this.data[e];
        }
      }, {
        key: "toJSON",
        value: function () {
          return this.data;
        }
      }]), t;
    }(),
        eb = {
      processors: {},
      addPostProcessor: function (e) {
        this.processors[e.name] = e;
      },
      handle: function (e, t, r, n, o) {
        var i = this;
        return e.forEach(function (e) {
          i.processors[e] && (t = i.processors[e].process(t, r, n, o));
        }), t;
      }
    },
        tb = {},
        rb = function (e) {
      function t(e) {
        var r,
            n,
            o,
            i,
            a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        return zd(this, t), r = Ad(this, Md(t).call(this)), Xd && Vd.call(xd(r)), n = ["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], o = e, i = xd(r), n.forEach(function (e) {
          o[e] && (i[e] = o[e]);
        }), r.options = a, void 0 === r.options.keySeparator && (r.options.keySeparator = "."), r.logger = Ld.create("translator"), r;
      }

      return Fd(t, Vd), Dd(t, [{
        key: "changeLanguage",
        value: function (e) {
          e && (this.language = e);
        }
      }, {
        key: "exists",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            interpolation: {}
          },
              r = this.resolve(e, t);
          return r && void 0 !== r.res;
        }
      }, {
        key: "extractFromKey",
        value: function (e, t) {
          var r = void 0 !== t.nsSeparator ? t.nsSeparator : this.options.nsSeparator;
          void 0 === r && (r = ":");
          var n = void 0 !== t.keySeparator ? t.keySeparator : this.options.keySeparator,
              o = t.ns || this.options.defaultNS;

          if (r && e.indexOf(r) > -1) {
            var i = e.match(this.interpolator.nestingRegexp);
            if (i && i.length > 0) return {
              key: e,
              namespaces: o
            };
            var a = e.split(r);
            (r !== n || r === n && this.options.ns.indexOf(a[0]) > -1) && (o = a.shift()), e = a.join(n);
          }

          return "string" == typeof o && (o = [o]), {
            key: e,
            namespaces: o
          };
        }
      }, {
        key: "translate",
        value: function (e, t, r) {
          var n = this;
          if ("object" !== kd(t) && this.options.overloadTranslationOptionHandler && (t = this.options.overloadTranslationOptionHandler(arguments)), t || (t = {}), null == e) return "";
          Array.isArray(e) || (e = [String(e)]);
          var o = void 0 !== t.keySeparator ? t.keySeparator : this.options.keySeparator,
              i = this.extractFromKey(e[e.length - 1], t),
              a = i.key,
              c = i.namespaces,
              u = c[c.length - 1],
              l = t.lng || this.language,
              s = t.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

          if (l && "cimode" === l.toLowerCase()) {
            if (s) {
              var p = t.nsSeparator || this.options.nsSeparator;
              return u + p + a;
            }

            return a;
          }

          var f = this.resolve(e, t),
              d = f && f.res,
              b = f && f.usedKey || a,
              y = f && f.exactUsedKey || a,
              m = Object.prototype.toString.apply(d),
              v = ["[object Number]", "[object Function]", "[object RegExp]"],
              h = void 0 !== t.joinArrays ? t.joinArrays : this.options.joinArrays,
              g = !this.i18nFormat || this.i18nFormat.handleAsObject,
              w = "string" != typeof d && "boolean" != typeof d && "number" != typeof d;

          if (g && d && w && v.indexOf(m) < 0 && ("string" != typeof h || "[object Array]" !== m)) {
            if (!t.returnObjects && !this.options.returnObjects) return this.logger.warn("accessing an object - but returnObjects options is not enabled!"), this.options.returnedObjectHandler ? this.options.returnedObjectHandler(b, d, t) : "key '".concat(a, " (").concat(this.language, ")' returned an object instead of string.");

            if (o) {
              var O = "[object Array]" === m,
                  j = O ? [] : {},
                  P = O ? y : b;

              for (var _ in d) if (Object.prototype.hasOwnProperty.call(d, _)) {
                var E = "".concat(P).concat(o).concat(_);
                j[_] = this.translate(E, Td({}, t, {
                  joinArrays: !1,
                  ns: c
                })), j[_] === E && (j[_] = d[_]);
              }

              d = j;
            }
          } else if (g && "string" == typeof h && "[object Array]" === m) (d = d.join(h)) && (d = this.extendTranslation(d, e, t, r));else {
            var S = !1,
                C = !1;

            if (!this.isValidLookup(d) && void 0 !== t.defaultValue) {
              if (S = !0, void 0 !== t.count) {
                var k = this.pluralResolver.getSuffix(l, t.count);
                d = t["defaultValue".concat(k)];
              }

              d || (d = t.defaultValue);
            }

            this.isValidLookup(d) || (C = !0, d = a);
            var R = t.defaultValue && t.defaultValue !== d && this.options.updateMissing;

            if (C || S || R) {
              if (this.logger.log(R ? "updateKey" : "missingKey", l, u, a, R ? t.defaultValue : d), o) {
                var T = this.resolve(a, Td({}, t, {
                  keySeparator: !1
                }));
                T && T.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
              }

              var z = [],
                  N = this.languageUtils.getFallbackCodes(this.options.fallbackLng, t.lng || this.language);
              if ("fallback" === this.options.saveMissingTo && N && N[0]) for (var D = 0; D < N.length; D++) z.push(N[D]);else "all" === this.options.saveMissingTo ? z = this.languageUtils.toResolveHierarchy(t.lng || this.language) : z.push(t.lng || this.language);

              var x = function (e, r) {
                n.options.missingKeyHandler ? n.options.missingKeyHandler(e, u, r, R ? t.defaultValue : d, R, t) : n.backendConnector && n.backendConnector.saveMissing && n.backendConnector.saveMissing(e, u, r, R ? t.defaultValue : d, R, t), n.emit("missingKey", e, u, r, d);
              };

              if (this.options.saveMissing) {
                var A = void 0 !== t.count && "string" != typeof t.count;
                this.options.saveMissingPlurals && A ? z.forEach(function (e) {
                  n.pluralResolver.getPluralFormsOfKey(e, a).forEach(function (t) {
                    return x([e], t);
                  });
                }) : x(z, a);
              }
            }

            d = this.extendTranslation(d, e, t, f, r), C && d === a && this.options.appendNamespaceToMissingKey && (d = "".concat(u, ":").concat(a)), C && this.options.parseMissingKeyHandler && (d = this.options.parseMissingKeyHandler(d));
          }

          return d;
        }
      }, {
        key: "extendTranslation",
        value: function (e, t, r, n, o) {
          var i = this;
          if (this.i18nFormat && this.i18nFormat.parse) e = this.i18nFormat.parse(e, r, n.usedLng, n.usedNS, n.usedKey, {
            resolved: n
          });else if (!r.skipInterpolation) {
            r.interpolation && this.interpolator.init(Td({}, r, {
              interpolation: Td({}, this.options.interpolation, r.interpolation)
            }));
            var a,
                c = r.interpolation && r.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;

            if (c) {
              var u = e.match(this.interpolator.nestingRegexp);
              a = u && u.length;
            }

            var l = r.replace && "string" != typeof r.replace ? r.replace : r;

            if (this.options.interpolation.defaultVariables && (l = Td({}, this.options.interpolation.defaultVariables, l)), e = this.interpolator.interpolate(e, l, r.lng || this.language, r), c) {
              var s = e.match(this.interpolator.nestingRegexp);
              a < (s && s.length) && (r.nest = !1);
            }

            !1 !== r.nest && (e = this.interpolator.nest(e, function () {
              for (var e = arguments.length, n = new Array(e), a = 0; a < e; a++) n[a] = arguments[a];

              return o && o[0] === n[0] && !r.context ? (i.logger.warn("It seems you are nesting recursively key: ".concat(n[0], " in key: ").concat(t[0])), null) : i.translate.apply(i, n.concat([t]));
            }, r)), r.interpolation && this.interpolator.reset();
          }
          var p = r.postProcess || this.options.postProcess,
              f = "string" == typeof p ? [p] : p;
          return null != e && f && f.length && !1 !== r.applyPostProcessor && (e = eb.handle(f, e, t, this.options && this.options.postProcessPassResolved ? Td({
            i18nResolved: n
          }, r) : r, this)), e;
        }
      }, {
        key: "resolve",
        value: function (e) {
          var t,
              r,
              n,
              o,
              i,
              a = this,
              c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return "string" == typeof e && (e = [e]), e.forEach(function (e) {
            if (!a.isValidLookup(t)) {
              var u = a.extractFromKey(e, c),
                  l = u.key;
              r = l;
              var s = u.namespaces;
              a.options.fallbackNS && (s = s.concat(a.options.fallbackNS));
              var p = void 0 !== c.count && "string" != typeof c.count,
                  f = void 0 !== c.context && "string" == typeof c.context && "" !== c.context,
                  d = c.lngs ? c.lngs : a.languageUtils.toResolveHierarchy(c.lng || a.language, c.fallbackLng);
              s.forEach(function (e) {
                a.isValidLookup(t) || (i = e, !tb["".concat(d[0], "-").concat(e)] && a.utils && a.utils.hasLoadedNamespace && !a.utils.hasLoadedNamespace(i) && (tb["".concat(d[0], "-").concat(e)] = !0, a.logger.warn('key "'.concat(r, '" for languages "').concat(d.join(", "), '" won\'t get resolved as namespace "').concat(i, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), d.forEach(function (r) {
                  if (!a.isValidLookup(t)) {
                    o = r;
                    var i,
                        u,
                        s = l,
                        d = [s];
                    if (a.i18nFormat && a.i18nFormat.addLookupKeys) a.i18nFormat.addLookupKeys(d, l, r, e, c);else p && (i = a.pluralResolver.getSuffix(r, c.count)), p && f && d.push(s + i), f && d.push(s += "".concat(a.options.contextSeparator).concat(c.context)), p && d.push(s += i);

                    for (; u = d.pop();) a.isValidLookup(t) || (n = u, t = a.getResource(r, e, u, c));
                  }
                }));
              });
            }
          }), {
            res: t,
            usedKey: r,
            exactUsedKey: n,
            usedLng: o,
            usedNS: i
          };
        }
      }, {
        key: "isValidLookup",
        value: function (e) {
          return !(void 0 === e || !this.options.returnNull && null === e || !this.options.returnEmptyString && "" === e);
        }
      }, {
        key: "getResource",
        value: function (e, t, r) {
          var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
          return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, r, n) : this.resourceStore.getResource(e, t, r, n);
        }
      }]), t;
    }();

    function nb(e) {
      return e.charAt(0).toUpperCase() + e.slice(1);
    }

    var ob = function () {
      function e(t) {
        zd(this, e), this.options = t, this.whitelist = this.options.supportedLngs || !1, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Ld.create("languageUtils");
      }

      return Dd(e, [{
        key: "getScriptPartFromCode",
        value: function (e) {
          if (!e || e.indexOf("-") < 0) return null;
          var t = e.split("-");
          return 2 === t.length ? null : (t.pop(), "x" === t[t.length - 1].toLowerCase() ? null : this.formatLanguageCode(t.join("-")));
        }
      }, {
        key: "getLanguagePartFromCode",
        value: function (e) {
          if (!e || e.indexOf("-") < 0) return e;
          var t = e.split("-");
          return this.formatLanguageCode(t[0]);
        }
      }, {
        key: "formatLanguageCode",
        value: function (e) {
          if ("string" == typeof e && e.indexOf("-") > -1) {
            var t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"],
                r = e.split("-");
            return this.options.lowerCaseLng ? r = r.map(function (e) {
              return e.toLowerCase();
            }) : 2 === r.length ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = nb(r[1].toLowerCase()))) : 3 === r.length && (r[0] = r[0].toLowerCase(), 2 === r[1].length && (r[1] = r[1].toUpperCase()), "sgn" !== r[0] && 2 === r[2].length && (r[2] = r[2].toUpperCase()), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = nb(r[1].toLowerCase())), t.indexOf(r[2].toLowerCase()) > -1 && (r[2] = nb(r[2].toLowerCase()))), r.join("-");
          }

          return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
        }
      }, {
        key: "isWhitelisted",
        value: function (e) {
          return this.logger.deprecate("languageUtils.isWhitelisted", 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.'), this.isSupportedCode(e);
        }
      }, {
        key: "isSupportedCode",
        value: function (e) {
          return ("languageOnly" === this.options.load || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
        }
      }, {
        key: "getBestMatchFromCodes",
        value: function (e) {
          var t,
              r = this;
          return e ? (e.forEach(function (e) {
            if (!t) {
              var n = r.formatLanguageCode(e);
              r.options.supportedLngs && !r.isSupportedCode(n) || (t = n);
            }
          }), !t && this.options.supportedLngs && e.forEach(function (e) {
            if (!t) {
              var n = r.getLanguagePartFromCode(e);
              if (r.isSupportedCode(n)) return t = n;
              t = r.options.supportedLngs.find(function (e) {
                if (0 === e.indexOf(n)) return e;
              });
            }
          }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t) : null;
        }
      }, {
        key: "getFallbackCodes",
        value: function (e, t) {
          if (!e) return [];
          if ("function" == typeof e && (e = e(t)), "string" == typeof e && (e = [e]), "[object Array]" === Object.prototype.toString.apply(e)) return e;
          if (!t) return e.default || [];
          var r = e[t];
          return r || (r = e[this.getScriptPartFromCode(t)]), r || (r = e[this.formatLanguageCode(t)]), r || (r = e[this.getLanguagePartFromCode(t)]), r || (r = e.default), r || [];
        }
      }, {
        key: "toResolveHierarchy",
        value: function (e, t) {
          var r = this,
              n = this.getFallbackCodes(t || this.options.fallbackLng || [], e),
              o = [],
              i = function (e) {
            e && (r.isSupportedCode(e) ? o.push(e) : r.logger.warn("rejecting language code not found in supportedLngs: ".concat(e)));
          };

          return "string" == typeof e && e.indexOf("-") > -1 ? ("languageOnly" !== this.options.load && i(this.formatLanguageCode(e)), "languageOnly" !== this.options.load && "currentOnly" !== this.options.load && i(this.getScriptPartFromCode(e)), "currentOnly" !== this.options.load && i(this.getLanguagePartFromCode(e))) : "string" == typeof e && i(this.formatLanguageCode(e)), n.forEach(function (e) {
            o.indexOf(e) < 0 && i(r.formatLanguageCode(e));
          }), o;
        }
      }]), e;
    }(),
        ib = [{
      lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "ti", "tr", "uz", "wa"],
      nr: [1, 2],
      fc: 1
    }, {
      lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
      nr: [1, 2],
      fc: 2
    }, {
      lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "kk", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
      nr: [1],
      fc: 3
    }, {
      lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
      nr: [1, 2, 5],
      fc: 4
    }, {
      lngs: ["ar"],
      nr: [0, 1, 2, 3, 11, 100],
      fc: 5
    }, {
      lngs: ["cs", "sk"],
      nr: [1, 2, 5],
      fc: 6
    }, {
      lngs: ["csb", "pl"],
      nr: [1, 2, 5],
      fc: 7
    }, {
      lngs: ["cy"],
      nr: [1, 2, 3, 8],
      fc: 8
    }, {
      lngs: ["fr"],
      nr: [1, 2],
      fc: 9
    }, {
      lngs: ["ga"],
      nr: [1, 2, 3, 7, 11],
      fc: 10
    }, {
      lngs: ["gd"],
      nr: [1, 2, 3, 20],
      fc: 11
    }, {
      lngs: ["is"],
      nr: [1, 2],
      fc: 12
    }, {
      lngs: ["jv"],
      nr: [0, 1],
      fc: 13
    }, {
      lngs: ["kw"],
      nr: [1, 2, 3, 4],
      fc: 14
    }, {
      lngs: ["lt"],
      nr: [1, 2, 10],
      fc: 15
    }, {
      lngs: ["lv"],
      nr: [1, 2, 0],
      fc: 16
    }, {
      lngs: ["mk"],
      nr: [1, 2],
      fc: 17
    }, {
      lngs: ["mnk"],
      nr: [0, 1, 2],
      fc: 18
    }, {
      lngs: ["mt"],
      nr: [1, 2, 11, 20],
      fc: 19
    }, {
      lngs: ["or"],
      nr: [2, 1],
      fc: 2
    }, {
      lngs: ["ro"],
      nr: [1, 2, 20],
      fc: 20
    }, {
      lngs: ["sl"],
      nr: [5, 1, 2, 3],
      fc: 21
    }, {
      lngs: ["he", "iw"],
      nr: [1, 2, 20, 21],
      fc: 22
    }],
        ab = {
      1: function (e) {
        return Number(e > 1);
      },
      2: function (e) {
        return Number(1 != e);
      },
      3: function (e) {
        return 0;
      },
      4: function (e) {
        return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
      },
      5: function (e) {
        return Number(0 == e ? 0 : 1 == e ? 1 : 2 == e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5);
      },
      6: function (e) {
        return Number(1 == e ? 0 : e >= 2 && e <= 4 ? 1 : 2);
      },
      7: function (e) {
        return Number(1 == e ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
      },
      8: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : 8 != e && 11 != e ? 2 : 3);
      },
      9: function (e) {
        return Number(e >= 2);
      },
      10: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4);
      },
      11: function (e) {
        return Number(1 == e || 11 == e ? 0 : 2 == e || 12 == e ? 1 : e > 2 && e < 20 ? 2 : 3);
      },
      12: function (e) {
        return Number(e % 10 != 1 || e % 100 == 11);
      },
      13: function (e) {
        return Number(0 !== e);
      },
      14: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : 3 == e ? 2 : 3);
      },
      15: function (e) {
        return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
      },
      16: function (e) {
        return Number(e % 10 == 1 && e % 100 != 11 ? 0 : 0 !== e ? 1 : 2);
      },
      17: function (e) {
        return Number(1 == e || e % 10 == 1 && e % 100 != 11 ? 0 : 1);
      },
      18: function (e) {
        return Number(0 == e ? 0 : 1 == e ? 1 : 2);
      },
      19: function (e) {
        return Number(1 == e ? 0 : 0 == e || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3);
      },
      20: function (e) {
        return Number(1 == e ? 0 : 0 == e || e % 100 > 0 && e % 100 < 20 ? 1 : 2);
      },
      21: function (e) {
        return Number(e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0);
      },
      22: function (e) {
        return Number(1 == e ? 0 : 2 == e ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3);
      }
    };

    var cb = function () {
      function e(t) {
        var r,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        zd(this, e), this.languageUtils = t, this.options = n, this.logger = Ld.create("pluralResolver"), this.rules = (r = {}, ib.forEach(function (e) {
          e.lngs.forEach(function (t) {
            r[t] = {
              numbers: e.nr,
              plurals: ab[e.fc]
            };
          });
        }), r);
      }

      return Dd(e, [{
        key: "addRule",
        value: function (e, t) {
          this.rules[e] = t;
        }
      }, {
        key: "getRule",
        value: function (e) {
          return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
        }
      }, {
        key: "needsPlural",
        value: function (e) {
          var t = this.getRule(e);
          return t && t.numbers.length > 1;
        }
      }, {
        key: "getPluralFormsOfKey",
        value: function (e, t) {
          var r = this,
              n = [],
              o = this.getRule(e);
          return o ? (o.numbers.forEach(function (o) {
            var i = r.getSuffix(e, o);
            n.push("".concat(t).concat(i));
          }), n) : n;
        }
      }, {
        key: "getSuffix",
        value: function (e, t) {
          var r = this,
              n = this.getRule(e);

          if (n) {
            var o = n.noAbs ? n.plurals(t) : n.plurals(Math.abs(t)),
                i = n.numbers[o];
            this.options.simplifyPluralSuffix && 2 === n.numbers.length && 1 === n.numbers[0] && (2 === i ? i = "plural" : 1 === i && (i = ""));

            var a = function () {
              return r.options.prepend && i.toString() ? r.options.prepend + i.toString() : i.toString();
            };

            return "v1" === this.options.compatibilityJSON ? 1 === i ? "" : "number" == typeof i ? "_plural_".concat(i.toString()) : a() : "v2" === this.options.compatibilityJSON ? a() : this.options.simplifyPluralSuffix && 2 === n.numbers.length && 1 === n.numbers[0] ? a() : this.options.prepend && o.toString() ? this.options.prepend + o.toString() : o.toString();
          }

          return this.logger.warn("no plural rule found for: ".concat(e)), "";
        }
      }]), e;
    }(),
        ub = function () {
      function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        zd(this, e), this.logger = Ld.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || function (e) {
          return e;
        }, this.init(t);
      }

      return Dd(e, [{
        key: "init",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          e.interpolation || (e.interpolation = {
            escapeValue: !0
          });
          var t = e.interpolation;
          this.escape = void 0 !== t.escape ? t.escape : $d, this.escapeValue = void 0 === t.escapeValue || t.escapeValue, this.useRawValueToEscape = void 0 !== t.useRawValueToEscape && t.useRawValueToEscape, this.prefix = t.prefix ? Yd(t.prefix) : t.prefixEscaped || "{{", this.suffix = t.suffix ? Yd(t.suffix) : t.suffixEscaped || "}}", this.formatSeparator = t.formatSeparator ? t.formatSeparator : t.formatSeparator || ",", this.unescapePrefix = t.unescapeSuffix ? "" : t.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : t.unescapeSuffix || "", this.nestingPrefix = t.nestingPrefix ? Yd(t.nestingPrefix) : t.nestingPrefixEscaped || Yd("$t("), this.nestingSuffix = t.nestingSuffix ? Yd(t.nestingSuffix) : t.nestingSuffixEscaped || Yd(")"), this.nestingOptionsSeparator = t.nestingOptionsSeparator ? t.nestingOptionsSeparator : t.nestingOptionsSeparator || ",", this.maxReplaces = t.maxReplaces ? t.maxReplaces : 1e3, this.alwaysFormat = void 0 !== t.alwaysFormat && t.alwaysFormat, this.resetRegExp();
        }
      }, {
        key: "reset",
        value: function () {
          this.options && this.init(this.options);
        }
      }, {
        key: "resetRegExp",
        value: function () {
          var e = "".concat(this.prefix, "(.+?)").concat(this.suffix);
          this.regexp = new RegExp(e, "g");
          var t = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
          this.regexpUnescape = new RegExp(t, "g");
          var r = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
          this.nestingRegexp = new RegExp(r, "g");
        }
      }, {
        key: "interpolate",
        value: function (e, t, r, n) {
          var o,
              i,
              a,
              c = this,
              u = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

          function l(e) {
            return e.replace(/\$/g, "$$$$");
          }

          var s = function (e) {
            if (e.indexOf(c.formatSeparator) < 0) {
              var o = Hd(t, u, e);
              return c.alwaysFormat ? c.format(o, void 0, r) : o;
            }

            var i = e.split(c.formatSeparator),
                a = i.shift().trim(),
                l = i.join(c.formatSeparator).trim();
            return c.format(Hd(t, u, a), l, r, n);
          };

          this.resetRegExp();
          var p = n && n.missingInterpolationHandler || this.options.missingInterpolationHandler,
              f = n && n.interpolation && n.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
          return [{
            regex: this.regexpUnescape,
            safeValue: function (e) {
              return l(e);
            }
          }, {
            regex: this.regexp,
            safeValue: function (e) {
              return c.escapeValue ? l(c.escape(e)) : l(e);
            }
          }].forEach(function (t) {
            for (a = 0; o = t.regex.exec(e);) {
              if (void 0 === (i = s(o[1].trim()))) {
                if ("function" == typeof p) {
                  var r = p(e, o, n);
                  i = "string" == typeof r ? r : "";
                } else {
                  if (f) {
                    i = o[0];
                    continue;
                  }

                  c.logger.warn("missed to pass in variable ".concat(o[1], " for interpolating ").concat(e)), i = "";
                }
              } else "string" == typeof i || c.useRawValueToEscape || (i = qd(i));
              if (e = e.replace(o[0], t.safeValue(i)), t.regex.lastIndex = 0, ++a >= c.maxReplaces) break;
            }
          }), e;
        }
      }, {
        key: "nest",
        value: function (e, t) {
          var r,
              n,
              o = this,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              a = Td({}, i);

          function c(e, t) {
            var r = this.nestingOptionsSeparator;
            if (e.indexOf(r) < 0) return e;
            var n = e.split(new RegExp("".concat(r, "[ ]*{"))),
                o = "{".concat(n[1]);
            e = n[0], o = (o = this.interpolate(o, a)).replace(/'/g, '"');

            try {
              a = JSON.parse(o), t && (a = Td({}, t, a));
            } catch (t) {
              return this.logger.warn("failed parsing options string in nesting for key ".concat(e), t), "".concat(e).concat(r).concat(o);
            }

            return delete a.defaultValue, e;
          }

          for (a.applyPostProcessor = !1, delete a.defaultValue; r = this.nestingRegexp.exec(e);) {
            var u = [],
                l = !1;

            if (r[0].includes(this.formatSeparator) && !/{.*}/.test(r[1])) {
              var s = r[1].split(this.formatSeparator).map(function (e) {
                return e.trim();
              });
              r[1] = s.shift(), u = s, l = !0;
            }

            if ((n = t(c.call(this, r[1].trim(), a), a)) && r[0] === e && "string" != typeof n) return n;
            "string" != typeof n && (n = qd(n)), n || (this.logger.warn("missed to resolve ".concat(r[1], " for nesting ").concat(e)), n = ""), l && (n = u.reduce(function (e, t) {
              return o.format(e, t, i.lng, i);
            }, n.trim())), e = e.replace(r[0], n), this.regexp.lastIndex = 0;
          }

          return e;
        }
      }]), e;
    }();

    var lb = function (e) {
      function t(e, r, n) {
        var o,
            i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        return zd(this, t), o = Ad(this, Md(t).call(this)), Xd && Vd.call(xd(o)), o.backend = e, o.store = r, o.services = n, o.languageUtils = n.languageUtils, o.options = i, o.logger = Ld.create("backendConnector"), o.state = {}, o.queue = [], o.backend && o.backend.init && o.backend.init(n, i.backend, i), o;
      }

      return Fd(t, Vd), Dd(t, [{
        key: "queueLoad",
        value: function (e, t, r, n) {
          var o = this,
              i = [],
              a = [],
              c = [],
              u = [];
          return e.forEach(function (e) {
            var n = !0;
            t.forEach(function (t) {
              var c = "".concat(e, "|").concat(t);
              !r.reload && o.store.hasResourceBundle(e, t) ? o.state[c] = 2 : o.state[c] < 0 || (1 === o.state[c] ? a.indexOf(c) < 0 && a.push(c) : (o.state[c] = 1, n = !1, a.indexOf(c) < 0 && a.push(c), i.indexOf(c) < 0 && i.push(c), u.indexOf(t) < 0 && u.push(t)));
            }), n || c.push(e);
          }), (i.length || a.length) && this.queue.push({
            pending: a,
            loaded: {},
            errors: [],
            callback: n
          }), {
            toLoad: i,
            pending: a,
            toLoadLanguages: c,
            toLoadNamespaces: u
          };
        }
      }, {
        key: "loaded",
        value: function (e, t, r) {
          var n = e.split("|"),
              o = n[0],
              i = n[1];
          t && this.emit("failedLoading", o, i, t), r && this.store.addResourceBundle(o, i, r), this.state[e] = t ? -1 : 2;
          var a = {};
          this.queue.forEach(function (r) {
            var n, c, u, l, s, p;
            n = r.loaded, c = i, l = Kd(n, [o], Object), s = l.obj, p = l.k, s[p] = s[p] || [], u && (s[p] = s[p].concat(c)), u || s[p].push(c), function (e, t) {
              for (var r = e.indexOf(t); -1 !== r;) e.splice(r, 1), r = e.indexOf(t);
            }(r.pending, e), t && r.errors.push(t), 0 !== r.pending.length || r.done || (Object.keys(r.loaded).forEach(function (e) {
              a[e] || (a[e] = []), r.loaded[e].length && r.loaded[e].forEach(function (t) {
                a[e].indexOf(t) < 0 && a[e].push(t);
              });
            }), r.done = !0, r.errors.length ? r.callback(r.errors) : r.callback());
          }), this.emit("loaded", a), this.queue = this.queue.filter(function (e) {
            return !e.done;
          });
        }
      }, {
        key: "read",
        value: function (e, t, r) {
          var n = this,
              o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
              i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 350,
              a = arguments.length > 5 ? arguments[5] : void 0;
          return e.length ? this.backend[r](e, t, function (c, u) {
            c && u && o < 5 ? setTimeout(function () {
              n.read.call(n, e, t, r, o + 1, 2 * i, a);
            }, i) : a(c, u);
          }) : a(null, {});
        }
      }, {
        key: "prepareLoading",
        value: function (e, t) {
          var r = this,
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              o = arguments.length > 3 ? arguments[3] : void 0;
          if (!this.backend) return this.logger.warn("No backend was added via i18next.use. Will not load resources."), o && o();
          "string" == typeof e && (e = this.languageUtils.toResolveHierarchy(e)), "string" == typeof t && (t = [t]);
          var i = this.queueLoad(e, t, n, o);
          if (!i.toLoad.length) return i.pending.length || o(), null;
          i.toLoad.forEach(function (e) {
            r.loadOne(e);
          });
        }
      }, {
        key: "load",
        value: function (e, t, r) {
          this.prepareLoading(e, t, {}, r);
        }
      }, {
        key: "reload",
        value: function (e, t, r) {
          this.prepareLoading(e, t, {
            reload: !0
          }, r);
        }
      }, {
        key: "loadOne",
        value: function (e) {
          var t = this,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
              n = e.split("|"),
              o = n[0],
              i = n[1];
          this.read(o, i, "read", void 0, void 0, function (n, a) {
            n && t.logger.warn("".concat(r, "loading namespace ").concat(i, " for language ").concat(o, " failed"), n), !n && a && t.logger.log("".concat(r, "loaded namespace ").concat(i, " for language ").concat(o), a), t.loaded(e, n, a);
          });
        }
      }, {
        key: "saveMissing",
        value: function (e, t, r, n, o) {
          var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
          this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t) ? this.logger.warn('did not save key "'.concat(r, '" as the namespace "').concat(t, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!") : null != r && "" !== r && (this.backend && this.backend.create && this.backend.create(e, t, r, n, null, Td({}, i, {
            isUpdate: o
          })), e && e[0] && this.store.addResource(e[0], t, r, n));
        }
      }]), t;
    }();

    function sb() {
      return {
        debug: !1,
        initImmediate: !0,
        ns: ["translation"],
        defaultNS: ["translation"],
        fallbackLng: ["dev"],
        fallbackNS: !1,
        whitelist: !1,
        nonExplicitWhitelist: !1,
        supportedLngs: !1,
        nonExplicitSupportedLngs: !1,
        load: "all",
        preload: !1,
        simplifyPluralSuffix: !0,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: !1,
        saveMissing: !1,
        updateMissing: !1,
        saveMissingTo: "fallback",
        saveMissingPlurals: !0,
        missingKeyHandler: !1,
        missingInterpolationHandler: !1,
        postProcess: !1,
        postProcessPassResolved: !1,
        returnNull: !0,
        returnEmptyString: !0,
        returnObjects: !1,
        joinArrays: !1,
        returnedObjectHandler: !1,
        parseMissingKeyHandler: !1,
        appendNamespaceToMissingKey: !1,
        appendNamespaceToCIMode: !1,
        overloadTranslationOptionHandler: function (e) {
          var t = {};

          if ("object" === kd(e[1]) && (t = e[1]), "string" == typeof e[1] && (t.defaultValue = e[1]), "string" == typeof e[2] && (t.tDescription = e[2]), "object" === kd(e[2]) || "object" === kd(e[3])) {
            var r = e[3] || e[2];
            Object.keys(r).forEach(function (e) {
              t[e] = r[e];
            });
          }

          return t;
        },
        interpolation: {
          escapeValue: !0,
          format: function (e, t, r, n) {
            return e;
          },
          prefix: "{{",
          suffix: "}}",
          formatSeparator: ",",
          unescapePrefix: "-",
          nestingPrefix: "$t(",
          nestingSuffix: ")",
          nestingOptionsSeparator: ",",
          maxReplaces: 1e3,
          skipOnVariables: !1
        }
      };
    }

    function pb(e) {
      return "string" == typeof e.ns && (e.ns = [e.ns]), "string" == typeof e.fallbackLng && (e.fallbackLng = [e.fallbackLng]), "string" == typeof e.fallbackNS && (e.fallbackNS = [e.fallbackNS]), e.whitelist && (e.whitelist && e.whitelist.indexOf("cimode") < 0 && (e.whitelist = e.whitelist.concat(["cimode"])), e.supportedLngs = e.whitelist), e.nonExplicitWhitelist && (e.nonExplicitSupportedLngs = e.nonExplicitWhitelist), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
    }

    function fb() {}

    var db = new (function (e) {
      function t() {
        var e,
            r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = arguments.length > 1 ? arguments[1] : void 0;

        if (zd(this, t), e = Ad(this, Md(t).call(this)), Xd && Vd.call(xd(e)), e.options = pb(r), e.services = {}, e.logger = Ld, e.modules = {
          external: []
        }, n && !e.isInitialized && !r.isClone) {
          if (!e.options.initImmediate) return e.init(r, n), Ad(e, xd(e));
          setTimeout(function () {
            e.init(r, n);
          }, 0);
        }

        return e;
      }

      return Fd(t, Vd), Dd(t, [{
        key: "init",
        value: function () {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = arguments.length > 1 ? arguments[1] : void 0;

          function n(e) {
            return e ? "function" == typeof e ? new e() : e : null;
          }

          if ("function" == typeof t && (r = t, t = {}), t.whitelist && !t.supportedLngs && this.logger.deprecate("whitelist", 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.'), t.nonExplicitWhitelist && !t.nonExplicitSupportedLngs && this.logger.deprecate("whitelist", 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.'), this.options = Td({}, sb(), this.options, pb(t)), this.format = this.options.interpolation.format, r || (r = fb), !this.options.isClone) {
            this.modules.logger ? Ld.init(n(this.modules.logger), this.options) : Ld.init(null, this.options);
            var o = new ob(this.options);
            this.store = new Zd(this.options.resources, this.options);
            var i = this.services;
            i.logger = Ld, i.resourceStore = this.store, i.languageUtils = o, i.pluralResolver = new cb(o, {
              prepend: this.options.pluralSeparator,
              compatibilityJSON: this.options.compatibilityJSON,
              simplifyPluralSuffix: this.options.simplifyPluralSuffix
            }), i.interpolator = new ub(this.options), i.utils = {
              hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            }, i.backendConnector = new lb(n(this.modules.backend), i.resourceStore, i, this.options), i.backendConnector.on("*", function (t) {
              for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) n[o - 1] = arguments[o];

              e.emit.apply(e, [t].concat(n));
            }), this.modules.languageDetector && (i.languageDetector = n(this.modules.languageDetector), i.languageDetector.init(i, this.options.detection, this.options)), this.modules.i18nFormat && (i.i18nFormat = n(this.modules.i18nFormat), i.i18nFormat.init && i.i18nFormat.init(this)), this.translator = new rb(this.services, this.options), this.translator.on("*", function (t) {
              for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) n[o - 1] = arguments[o];

              e.emit.apply(e, [t].concat(n));
            }), this.modules.external.forEach(function (t) {
              t.init && t.init(e);
            });
          }

          this.services.languageDetector || this.options.lng || this.logger.warn("init: no languageDetector is used and no lng is defined");
          var a = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
          a.forEach(function (t) {
            e[t] = function () {
              var r;
              return (r = e.store)[t].apply(r, arguments);
            };
          });
          var c = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
          c.forEach(function (t) {
            e[t] = function () {
              var r;
              return (r = e.store)[t].apply(r, arguments), e;
            };
          });

          var u = Ud(),
              l = function () {
            e.changeLanguage(e.options.lng, function (t, n) {
              e.isInitialized = !0, e.options.isClone || e.logger.log("initialized", e.options), e.emit("initialized", e.options), u.resolve(n), r(t, n);
            });
          };

          return this.options.resources || !this.options.initImmediate ? l() : setTimeout(l, 0), u;
        }
      }, {
        key: "loadResources",
        value: function (e) {
          var t = this,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : fb,
              n = r,
              o = "string" == typeof e ? e : this.language;

          if ("function" == typeof e && (n = e), !this.options.resources || this.options.partialBundledLanguages) {
            if (o && "cimode" === o.toLowerCase()) return n();

            var i = [],
                a = function (e) {
              e && t.services.languageUtils.toResolveHierarchy(e).forEach(function (e) {
                i.indexOf(e) < 0 && i.push(e);
              });
            };

            if (o) a(o);else {
              var c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
              c.forEach(function (e) {
                return a(e);
              });
            }
            this.options.preload && this.options.preload.forEach(function (e) {
              return a(e);
            }), this.services.backendConnector.load(i, this.options.ns, n);
          } else n(null);
        }
      }, {
        key: "reloadResources",
        value: function (e, t, r) {
          var n = Ud();
          return e || (e = this.languages), t || (t = this.options.ns), r || (r = fb), this.services.backendConnector.reload(e, t, function (e) {
            n.resolve(), r(e);
          }), n;
        }
      }, {
        key: "use",
        value: function (e) {
          if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
          if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
          return "backend" === e.type && (this.modules.backend = e), ("logger" === e.type || e.log && e.warn && e.error) && (this.modules.logger = e), "languageDetector" === e.type && (this.modules.languageDetector = e), "i18nFormat" === e.type && (this.modules.i18nFormat = e), "postProcessor" === e.type && eb.addPostProcessor(e), "3rdParty" === e.type && this.modules.external.push(e), this;
        }
      }, {
        key: "changeLanguage",
        value: function (e, t) {
          var r = this;
          this.isLanguageChangingTo = e;
          var n = Ud();
          this.emit("languageChanging", e);

          var o = function (e) {
            var o = "string" == typeof e ? e : r.services.languageUtils.getBestMatchFromCodes(e);
            o && (r.language || (r.language = o, r.languages = r.services.languageUtils.toResolveHierarchy(o)), r.translator.language || r.translator.changeLanguage(o), r.services.languageDetector && r.services.languageDetector.cacheUserLanguage(o)), r.loadResources(o, function (e) {
              !function (e, o) {
                o ? (r.language = o, r.languages = r.services.languageUtils.toResolveHierarchy(o), r.translator.changeLanguage(o), r.isLanguageChangingTo = void 0, r.emit("languageChanged", o), r.logger.log("languageChanged", o)) : r.isLanguageChangingTo = void 0, n.resolve(function () {
                  return r.t.apply(r, arguments);
                }), t && t(e, function () {
                  return r.t.apply(r, arguments);
                });
              }(e, o);
            });
          };

          return e || !this.services.languageDetector || this.services.languageDetector.async ? !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect(o) : o(e) : o(this.services.languageDetector.detect()), n;
        }
      }, {
        key: "getFixedT",
        value: function (e, t) {
          var r = this,
              n = function e(t, n) {
            var o;

            if ("object" !== kd(n)) {
              for (var i = arguments.length, a = new Array(i > 2 ? i - 2 : 0), c = 2; c < i; c++) a[c - 2] = arguments[c];

              o = r.options.overloadTranslationOptionHandler([t, n].concat(a));
            } else o = Td({}, n);

            return o.lng = o.lng || e.lng, o.lngs = o.lngs || e.lngs, o.ns = o.ns || e.ns, r.t(t, o);
          };

          return "string" == typeof e ? n.lng = e : n.lngs = e, n.ns = t, n;
        }
      }, {
        key: "t",
        value: function () {
          var e;
          return this.translator && (e = this.translator).translate.apply(e, arguments);
        }
      }, {
        key: "exists",
        value: function () {
          var e;
          return this.translator && (e = this.translator).exists.apply(e, arguments);
        }
      }, {
        key: "setDefaultNamespace",
        value: function (e) {
          this.options.defaultNS = e;
        }
      }, {
        key: "hasLoadedNamespace",
        value: function (e) {
          var t = this,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (!this.isInitialized) return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
          if (!this.languages || !this.languages.length) return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
          var n = this.languages[0],
              o = !!this.options && this.options.fallbackLng,
              i = this.languages[this.languages.length - 1];
          if ("cimode" === n.toLowerCase()) return !0;

          var a = function (e, r) {
            var n = t.services.backendConnector.state["".concat(e, "|").concat(r)];
            return -1 === n || 2 === n;
          };

          if (r.precheck) {
            var c = r.precheck(this, a);
            if (void 0 !== c) return c;
          }

          return !!this.hasResourceBundle(n, e) || !this.services.backendConnector.backend || !(!a(n, e) || o && !a(i, e));
        }
      }, {
        key: "loadNamespaces",
        value: function (e, t) {
          var r = this,
              n = Ud();
          return this.options.ns ? ("string" == typeof e && (e = [e]), e.forEach(function (e) {
            r.options.ns.indexOf(e) < 0 && r.options.ns.push(e);
          }), this.loadResources(function (e) {
            n.resolve(), t && t(e);
          }), n) : (t && t(), Promise.resolve());
        }
      }, {
        key: "loadLanguages",
        value: function (e, t) {
          var r = Ud();
          "string" == typeof e && (e = [e]);
          var n = this.options.preload || [],
              o = e.filter(function (e) {
            return n.indexOf(e) < 0;
          });
          return o.length ? (this.options.preload = n.concat(o), this.loadResources(function (e) {
            r.resolve(), t && t(e);
          }), r) : (t && t(), Promise.resolve());
        }
      }, {
        key: "dir",
        value: function (e) {
          if (e || (e = this.languages && this.languages.length > 0 ? this.languages[0] : this.language), !e) return "rtl";
          return ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam"].indexOf(this.services.languageUtils.getLanguagePartFromCode(e)) >= 0 ? "rtl" : "ltr";
        }
      }, {
        key: "createInstance",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = arguments.length > 1 ? arguments[1] : void 0;
          return new t(e, r);
        }
      }, {
        key: "cloneInstance",
        value: function () {
          var e = this,
              r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : fb,
              o = Td({}, this.options, r, {
            isClone: !0
          }),
              i = new t(o),
              a = ["store", "services", "language"];
          return a.forEach(function (t) {
            i[t] = e[t];
          }), i.services = Td({}, this.services), i.services.utils = {
            hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
          }, i.translator = new rb(i.services, i.options), i.translator.on("*", function (e) {
            for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];

            i.emit.apply(i, [e].concat(r));
          }), i.init(o, n), i.translator.options = i.options, i.translator.backendConnector.services.utils = {
            hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
          }, i;
        }
      }]), t;
    }())(),
        bb = r(140),
        yb = r.n(bb),
        mb = r(43),
        vb = r(59),
        hb = r.n(vb),
        gb = r(141),
        wb = r(142),
        Ob = r(143),
        jb = r(144),
        Pb = r(145),
        _b = r(146),
        Eb = r(147),
        Sb = r(148),
        Cb = r(149),
        kb = r(150),
        Rb = r(151),
        Tb = r(152),
        zb = r(153),
        Nb = r(154),
        Db = r(155),
        xb = r(156),
        Ab = r(157),
        Mb = r(158),
        Ib = r(159),
        Fb = r(160),
        Bb = r(161),
        Lb = r(162),
        Vb = r(163),
        Ub = r(164),
        qb = r(165),
        Kb = r(166),
        Gb = r(167),
        Wb = r(168),
        Hb = [gb.en, wb.en, Ob.en, jb.en, Pb.en, _b.en, Eb.en, Sb.en, Cb.en, kb.en, Rb.en, Tb.en, zb.en, Nb.en, Db.en, xb.en, Ab.en, Mb.en, Ib.en, Fb.en, Bb.en, Lb.en, Vb.en, Ub.en, qb.en, Kb.en, Gb.en, Wb.en].reduce(function (e, t) {
      return hb()(e, t);
    }, {}),
        Jb = r(169),
        Yb = r(170),
        Qb = r(171),
        $b = r(172),
        Xb = r(173),
        Zb = r(174),
        ey = r(175),
        ty = r(176),
        ry = r(177),
        ny = r(178),
        oy = r(179),
        iy = r(180),
        ay = r(181),
        cy = r(182),
        uy = r(183),
        ly = r(184),
        sy = r(185),
        py = r(186),
        fy = r(187),
        dy = r(188),
        by = r(189),
        yy = r(190),
        my = r(191),
        vy = r(192),
        hy = r(193),
        gy = r(194),
        wy = r(195),
        Oy = r(196),
        jy = [Jb.es, Yb.es, Qb.es, $b.es, Xb.es, Zb.es, ey.es, ty.es, ry.es, ny.es, oy.es, iy.es, ay.es, cy.es, uy.es, ly.es, sy.es, py.es, fy.es, dy.es, by.es, yy.es, my.es, vy.es, hy.es, gy.es, wy.es, Oy.es].reduce(function (e, t) {
      return hb()(e, t);
    }, {});

    function Py(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function _y(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Py(Object(r), !0).forEach(function (t) {
          Ey(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Py(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Ey(e, t, r) {
      return (t = function (e) {
        var t = function (e, t) {
          if ("object" != typeof e || !e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(e, "string");

        return "symbol" == typeof t ? t : t + "";
      }(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    var Sy = {
      en: {
        translation: Cy(Hb)
      },
      es: {
        translation: Cy(jy)
      }
    };

    function Cy(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
      return Object.keys(e).reduce(function (r, n) {
        var o = e[n],
            i = n;
        return t.length > 0 && (i = "".concat(t, ".").concat(n)), "string" != typeof o ? _y(_y({}, r), Cy(o, i)) : (r[i] = o, r);
      }, {});
    }

    function ky(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ry(n.key), n);
      }
    }

    function Ry(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Ty(e, t, r) {
      return t = zy(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], zy(e).constructor) : t.apply(e, r));
    }

    function zy(e) {
      return (zy = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Ny(e, t) {
      return (Ny = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    db.use(yb.a).use(mb.e).init({
      resources: Sy,
      languages: ["en", "es"],
      fallbackLng: "en",
      detection: {
        order: ["querystring", "path"],
        lookupFromPathIndex: 1,
        lookupQuerystring: "locale"
      },
      keySeparator: !0,
      interpolation: {
        escapeValue: !1,
        prefix: "%{",
        suffix: "}"
      }
    });

    var Dy = function (e) {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Ty(this, t, [{
          message: db.t("if2.invalid_authenticity_request"),
          status: e.status || 422,
          statusText: e.statusText || !e.status && "Unprocessable Entity",
          errors: e.errors || []
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ny(e, t);
      }(t, Cd), r = t, n && ky(r.prototype, n), o && ky(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function xy(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ay(n.key), n);
      }
    }

    function Ay(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var My = function () {
      return e = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
      }, (t = [{
        key: "csrf",
        value: function () {
          var e;
          return null === (e = document.querySelector("[name='csrf-token']")) || void 0 === e ? void 0 : e.content;
        }
      }, {
        key: "handleUnexpectedError",
        value: function (e) {
          throw new Cd({
            status: e.status,
            statusText: e.statusText
          });
        }
      }, {
        key: "handleUnprocessableEntityError",
        value: function (e) {
          var t = this;
          return e.json().catch(function () {
            return t.handleUnexpectedError(e);
          }).then(function (t) {
            if ("InvalidAuthenticityTokenError" === t.type) throw new Dy();
            throw new Cd({
              status: e.status,
              statusText: e.statusText,
              errors: t.errors
            });
          });
        }
      }, {
        key: "handleFetchResponse",
        value: function (e) {
          var t = this;
          if (204 !== e.status) return 422 === e.status ? this.handleUnprocessableEntityError(e) : e.ok ? e.json().catch(function () {
            return t.handleUnexpectedError(e);
          }) : e.json().catch(function () {
            return t.handleUnexpectedError(e);
          }).then(function (t) {
            throw new Cd({
              status: e.status,
              statusText: e.statusText,
              errors: t.errors
            });
          });
        }
      }, {
        key: "jsonFetch",
        value: function (e, t, r) {
          var n = this,
              o = {
            method: t || "GET",
            headers: {
              "X-CSRF-Token": this.csrf(),
              "Content-Type": "application/json",
              Accept: "application/json"
            }
          };
          return r && (o.body = JSON.stringify(r)), fetch(e, o).then(function (e) {
            return n.handleFetchResponse(e);
          });
        }
      }]) && xy(e.prototype, t), r && xy(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function Iy(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Fy(n.key), n);
      }
    }

    function Fy(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function By(e, t, r) {
      return t = Uy(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Uy(e).constructor) : t.apply(e, r));
    }

    function Ly() {
      return (Ly = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Vy(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Vy(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = Uy(e)););

      return e;
    }

    function Uy(e) {
      return (Uy = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function qy(e, t) {
      return (qy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Ky,
        Gy = function (e) {
      function t(e, r) {
        var n;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (n = By(this, t)).apiSprayRecordsPath = "/if2/api/spray_records", n.sprayRecordsCropsPath = "".concat(n.apiSprayRecordsPath, "/crops"), n.sprayRecordsFieldsPath = "".concat(n.apiSprayRecordsPath, "/fields"), n.sprayRecordsProductsPath = "".concat(n.apiSprayRecordsPath, "/products"), n.sprayRecordsTargetsPath = "".concat(n.apiSprayRecordsPath, "/targets"), n.sprayRecordsVarietiesPath = "".concat(n.apiSprayRecordsPath, "/varieties"), n.sprayRecordsQueryPath = "".concat(n.apiSprayRecordsPath, "/query"), n.sprayRecordsQueryAllSerialsPath = "".concat(n.apiSprayRecordsPath, "/query_all_serials"), n.sprayRecordsBasePath = e || "/if2/spray_records", n.accountsPath = r || "/if2/accounts", n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && qy(e, t);
      }(t, My), function (e, t, r) {
        return t && Iy(e.prototype, t), r && Iy(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "apiSprayRecordPath",
        value: function (e) {
          return "".concat(this.apiSprayRecordsPath, "/").concat(e);
        }
      }, {
        key: "apiSprayRecordLicensedApplicatorPath",
        value: function (e) {
          return "".concat(this.apiSprayRecordPath(e), "/licensed_applicator");
        }
      }, {
        key: "accountSprayRecordsPath",
        value: function (e) {
          return "/if2/api/accounts/".concat(e, "/spray_records");
        }
      }, {
        key: "sprayRecordsPath",
        value: function (e) {
          return "/if2/api/spray_records/".concat(e);
        }
      }, {
        key: "sprayRecordsProductApplicationPath",
        value: function (e, t) {
          return "".concat(this.apiSprayRecordPath(e), "/product_applications/").concat(t);
        }
      }, {
        key: "sprayRecordsApplicationPath",
        value: function (e) {
          return "".concat(this.apiSprayRecordPath(e), "/applications");
        }
      }, {
        key: "sprayRecordAccountContactsPath",
        value: function (e) {
          return "".concat(this.apiSprayRecordPath(e), "/account_contacts");
        }
      }, {
        key: "sprayRecordApplicatorContactsPath",
        value: function (e) {
          return "".concat(this.apiSprayRecordPath(e), "/applicator_contacts");
        }
      }, {
        key: "applicationPath",
        value: function (e) {
          return "/if2/api/applications/".concat(e);
        }
      }, {
        key: "newAccountSprayRecordPath",
        value: function (e) {
          return "".concat(this.accountsPath, "/").concat(e, "/spray_records/new");
        }
      }, {
        key: "newSprayRecordApplicatorPath",
        value: function (e) {
          return "/if2/spray_records/".concat(e, "/applicators/new");
        }
      }, {
        key: "create",
        value: function (e, t) {
          var r = this.csrf();
          return fetch(this.accountSprayRecordsPath(e), {
            method: "POST",
            headers: {
              "X-CSRF-Token": r,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              spray_record: t
            })
          });
        }
      }, {
        key: "notFoundError",
        value: function () {
          throw new Error("Spray record not found");
        }
      }, {
        key: "unprocessableError",
        value: function (e) {
          if (!Array.isArray(e.errors) || !e.errors.length) return function (e, t, r, n) {
            var o = Ly(Uy(1 & n ? e.prototype : e), t, r);
            return 2 & n && "function" == typeof o ? function (e) {
              return o.apply(r, e);
            } : o;
          }(t, "unprocessableError", this, 3)([e]);
          throw new Error((e.errors || []).join("; "));
        }
      }, {
        key: "fetch",
        value: function (e) {
          return this.sendRequest("GET", this.sprayRecordsPath(e));
        }
      }, {
        key: "fetchAccountContacts",
        value: function (e) {
          return this.jsonFetch(this.sprayRecordAccountContactsPath(e));
        }
      }, {
        key: "fetchApplicatorContacts",
        value: function (e) {
          return this.jsonFetch(this.sprayRecordApplicatorContactsPath(e));
        }
      }, {
        key: "fetchLicensedApplicator",
        value: function (e) {
          return this.jsonFetch(this.apiSprayRecordLicensedApplicatorPath(e));
        }
      }, {
        key: "fetchAllForAccounts",
        value: function (e) {
          var t = this.csrf();
          return fetch(this.sprayRecordsQueryPath, {
            method: "POST",
            headers: {
              "X-CSRF-Token": t,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              accounts: e
            })
          }).then(function (e) {
            return e.json();
          }).then(function (e) {
            if ("success" !== e.status) {
              var t = new Error(e.message || "An unexpected error occurred while fetching spray records");
              throw t.errors = e.errors || [], t;
            }

            return e;
          });
        }
      }, {
        key: "fetchCrops",
        value: function (e) {
          var t = this.csrf();
          return fetch(this.sprayRecordsCropsPath, {
            method: "POST",
            headers: {
              "X-CSRF-Token": t,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
          }).then(function (e) {
            return e.json();
          }).then(function (e) {
            if ("success" !== e.status) {
              var t = new Error(e.message || "An unexpected error occurred while fetching");
              throw t.errors = e.errors || [], t;
            }

            return e;
          });
        }
      }, {
        key: "fetchFields",
        value: function (e) {
          return this.jsonFetch(this.sprayRecordsFieldsPath, "POST", e);
        }
      }, {
        key: "fetchProducts",
        value: function (e) {
          return this.jsonFetch(this.sprayRecordsProductsPath, "POST", e);
        }
      }, {
        key: "fetchTargets",
        value: function (e) {
          return this.jsonFetch(this.sprayRecordsTargetsPath, "POST", e);
        }
      }, {
        key: "fetchVarieties",
        value: function (e) {
          var t = this.csrf();
          return fetch(this.sprayRecordsVarietiesPath, {
            method: "POST",
            headers: {
              "X-CSRF-Token": t,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
          }).then(function (e) {
            return e.json();
          }).then(function (e) {
            if ("success" !== e.status) {
              var t = new Error(e.message || "An unexpected error occurred while fetching");
              throw t.errors = e.errors || [], t;
            }

            return e;
          });
        }
      }, {
        key: "query",
        value: function (e) {
          return this.jsonFetch(this.sprayRecordsQueryPath, "POST", e);
        }
      }, {
        key: "queryAllSerials",
        value: function (e) {
          var t = this.csrf();
          return fetch(this.sprayRecordsQueryAllSerialsPath, {
            method: "POST",
            headers: {
              "X-CSRF-Token": t,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
          }).then(function (e) {
            return e.json();
          }).then(function (e) {
            if ("success" !== e.status) {
              var t = new Error(e.message || "An unexpected error occurred while fetching spray records");
              throw t.errors = e.errors || [], t;
            }

            return e;
          });
        }
      }, {
        key: "update",
        value: function (e, t) {
          return this.jsonFetch(this.sprayRecordsPath(e), "PATCH", {
            spray_record: t
          });
        }
      }, {
        key: "updateLicensedApplicator",
        value: function (e, t) {
          return this.jsonFetch(this.apiSprayRecordLicensedApplicatorPath(e), "PATCH", t);
        }
      }, {
        key: "deleteProductApplication",
        value: function (e, t) {
          var r = this.csrf();
          return fetch("".concat(this.sprayRecordsProductApplicationPath(e, t)), {
            method: "DELETE",
            headers: {
              "X-CSRF-Token": r,
              "Content-Type": "application/json"
            }
          });
        }
      }, {
        key: "moveProductApplication",
        value: function (e, t, r) {
          var n = this.csrf();
          return fetch("".concat(this.sprayRecordsProductApplicationPath(e, t), "/reposition"), {
            method: "POST",
            headers: {
              "X-CSRF-Token": n,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              to_position: r
            })
          });
        }
      }, {
        key: "createApplication",
        value: function (e, t) {
          return this.jsonFetch(this.sprayRecordsApplicationPath(e), "POST", {
            application: t
          });
        }
      }, {
        key: "updateApplication",
        value: function (e) {
          return this.jsonFetch(this.applicationPath(e.serial), "PATCH", {
            application: e
          });
        }
      }, {
        key: "deleteApplication",
        value: function (e) {
          return this.sendRequest("DELETE", this.applicationPath(e.serial));
        }
      }, {
        key: "sendRequest",
        value: function (e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
              n = this.csrf(),
              o = {
            method: e,
            headers: {
              "X-CSRF-Token": n,
              "Content-Type": "application/json"
            }
          };
          return r && (o.body = JSON.stringify(r)), fetch(t, o).then(function (e) {
            return e.json();
          }).catch(function (e) {
            throw console.log(e), {
              status: "error",
              message: "An unexpected error occurred",
              error: e
            };
          });
        }
      }]);
    }();

    function Wy(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Hy(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Wy(Object(r), !0).forEach(function (t) {
          Jy(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Wy(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Jy(e, t, r) {
      return (t = Qy(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Yy(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Qy(n.key), n);
      }
    }

    function Qy(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function $y(e, t, r) {
      return t = em(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], em(e).constructor) : t.apply(e, r));
    }

    function Xy() {
      return (Xy = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Zy(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Zy(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = em(e)););

      return e;
    }

    function em(e) {
      return (em = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function tm(e, t) {
      return (tm = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function rm(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var nm,
        om = (rm((Ky = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), $y(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && tm(e, t);
      }(t, w["SprayRecordProductApplication"]), function (e, t, r) {
        return t && Yy(e.prototype, t), r && Yy(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "units",
        get: function () {
          var e;
          return (null === (e = this.product) || void 0 === e ? void 0 : e.unitChoices) || [];
        }
      }, {
        key: "unitsPerArea",
        get: function () {
          var e = this.units.map(function (e) {
            return "".concat(e, "/acre");
          });
          return this.product.isMeasuredByMass ? e.concat(["grams/hectare", "kg/hectare"]) : this.product.isMeasuredByVolume ? e.concat(["mL/hectare", "L/hectare"]) : e;
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = Xy(em(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return Hy(Hy({}, a), {}, {
            product: Hy(Hy({}, a.product), {}, {
              modelClass: _r,
              defaultValue: new _r()
            })
          });
        }
      }]);
    }()).prototype, "units", [f.computed], Object.getOwnPropertyDescriptor(Ky.prototype, "units"), Ky.prototype), rm(Ky.prototype, "unitsPerArea", [f.computed], Object.getOwnPropertyDescriptor(Ky.prototype, "unitsPerArea"), Ky.prototype), Ky);

    function im(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function am(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? im(Object(r), !0).forEach(function (t) {
          cm(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : im(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function cm(e, t, r) {
      return (t = lm(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function um(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, lm(n.key), n);
      }
    }

    function lm(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function sm(e, t, r) {
      return t = dm(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], dm(e).constructor) : t.apply(e, r));
    }

    function pm() {
      return (pm = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = fm(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function fm(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = dm(e)););

      return e;
    }

    function dm(e) {
      return (dm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function bm(e, t) {
      return (bm = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ym(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var mm,
        vm,
        hm,
        gm,
        wm,
        Om,
        jm,
        Pm = (ym((nm = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), sm(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && bm(e, t);
      }(t, w["SprayRecord"]), function (e, t, r) {
        return t && um(e.prototype, t), r && um(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "totalCompletedAcres",
        get: function () {
          return this.applications.reduce(function (e, t) {
            return e + t.totalAcresCompleted;
          }, 0);
        }
      }, {
        key: "totalAcres",
        get: function () {
          return this.fields.reduce(function (e, t) {
            return e + t.acres;
          }, 0);
        }
      }, {
        key: "percentComplete",
        get: function () {
          return this.totalCompletedAcres / this.totalAcres || 0;
        }
      }, {
        key: "percentageComplete",
        get: function () {
          return 100 * this.percentComplete;
        }
      }, {
        key: "newModel",
        get: function () {
          return !0;
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          var e, r, n, o, i;
          return am(am({}, (e = t, r = "getAttributeDefinition", n = this, i = pm(dm(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([])), {}, {
            productApplications: {
              name: "Product Application",
              key: "productApplications",
              type: "modelCollection",
              modelClass: om
            }
          });
        }
      }]);
    }()).prototype, "totalCompletedAcres", [f.computed], Object.getOwnPropertyDescriptor(nm.prototype, "totalCompletedAcres"), nm.prototype), ym(nm.prototype, "totalAcres", [f.computed], Object.getOwnPropertyDescriptor(nm.prototype, "totalAcres"), nm.prototype), ym(nm.prototype, "percentComplete", [f.computed], Object.getOwnPropertyDescriptor(nm.prototype, "percentComplete"), nm.prototype), ym(nm.prototype, "percentageComplete", [f.computed], Object.getOwnPropertyDescriptor(nm.prototype, "percentageComplete"), nm.prototype), ym(nm.prototype, "newModel", [f.computed], Object.getOwnPropertyDescriptor(nm.prototype, "newModel"), nm.prototype), nm);

    function _m(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Em(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? _m(Object(r), !0).forEach(function (t) {
          Sm(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _m(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Sm(e, t, r) {
      return (t = Rm(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Cm(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function km(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Rm(n.key), n);
      }
    }

    function Rm(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Tm(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var zm,
        Nm,
        Dm,
        xm,
        Am,
        Mm,
        Im,
        Fm = (vm = Tm((mm = function () {
      return function (e, t, r) {
        return t && km(e.prototype, t), r && km(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.api = void 0, Cm(this, "sprayRecords", vm, this), Cm(this, "crops", hm, this), Cm(this, "fields", gm, this), Cm(this, "products", wm, this), Cm(this, "targets", Om, this), Cm(this, "varieties", jm, this), this.api = t || new Gy();
      }, [{
        key: "items",
        get: function () {
          return this.sprayRecords;
        }
      }, {
        key: "sprayRecordsBasePath",
        get: function () {
          return this.api.sprayRecordsBasePath;
        }
      }, {
        key: "newAccountSprayRecordPath",
        value: function (e) {
          return this.api.newAccountSprayRecordPath(e);
        }
      }, {
        key: "deleteProductApplication",
        value: function (e, t) {
          var r = this;
          return this.api.deleteProductApplication(e, t).then(function (n) {
            if (!n.ok) throw n;
            return r.fetch(e), r.removeProductApplication(e, t);
          });
        }
      }, {
        key: "fetch",
        value: function (e) {
          var t = this;
          return this.api.fetch(e).then(function (e) {
            return t.push(e.sprayRecord);
          });
        }
      }, {
        key: "fetchAllForAccounts",
        value: function (e) {
          var t = this;
          return this.api.fetchAllForAccounts(e).then(function (e) {
            return t.pushMany(e.sprayRecords);
          }).then(function (e) {
            return e;
          });
        }
      }, {
        key: "find",
        value: function (e) {
          return this.sprayRecords.find(function (t) {
            return t.id === e;
          });
        }
      }, {
        key: "fetchCrops",
        value: function (e) {
          var t = this;
          return this.api.fetchCrops(Em({}, e || {})).then(function (e) {
            return e.crops ? (t.crops = e.crops, t.crops) : t.crops;
          });
        }
      }, {
        key: "fetchFields",
        value: function (e) {
          var t = this;
          return this.api.fetchFields(Em({}, e || {})).then(function (e) {
            return e.fields ? (t.fields = e.fields, t.fields) : t.fields;
          });
        }
      }, {
        key: "fetchProducts",
        value: function (e) {
          var t = this;
          return this.api.fetchProducts(Em({}, e || {})).then(function (e) {
            return e.products ? (t.products = e.products, t.products) : t.products;
          });
        }
      }, {
        key: "fetchTargets",
        value: function (e) {
          var t = this;
          return this.api.fetchTargets(Em({}, e || {})).then(function (e) {
            return e.targets ? (t.targets = e.targets, t.targets) : t.targets;
          });
        }
      }, {
        key: "fetchVarieties",
        value: function (e) {
          var t = this;
          return this.api.fetchVarieties(Em({}, e || {})).then(function (e) {
            return e.varieties ? (t.varieties = e.varieties, t.varieties) : t.varieties;
          });
        }
      }, {
        key: "fetchAccountContacts",
        value: function (e) {
          return this.api.fetchAccountContacts(e.id).then(function (e) {
            return e.contacts;
          });
        }
      }, {
        key: "fetchApplicatorContacts",
        value: function (e) {
          return this.api.fetchApplicatorContacts(e.id).then(function (e) {
            return e.applicators;
          });
        }
      }, {
        key: "update",
        value: function (e, t) {
          var r = this;
          return this.api.update(e, t).then(function (e) {
            return r.push(e.sprayRecord);
          });
        }
      }, {
        key: "moveProductApplication",
        value: function (e, t, r, n) {
          var o = this,
              i = this.find(e);
          return i ? (i.moveProductApplication(t, r, n), this.api.moveProductApplication(e, t, n).then(function (e) {
            if (!e.ok) throw e;
            return e.json();
          }).then(function (e) {
            return o.push(e.sprayRecord);
          })) : Promise.reject(new Error("Spray record not found in store"));
        }
      }, {
        key: "new",
        value: function (e) {
          return new Pm(e);
        }
      }, {
        key: "push",
        value: function (e, t) {
          var r = this.find(e.id);
          return r ? r.update(e) : (r = this.new(e), Object.keys(t || {}).forEach(function (e) {
            r[e] = t[e];
          }), this.sprayRecords.push(r)), r;
        }
      }, {
        key: "pushApplication",
        value: function (e, t) {
          var r = this.find(e);
          if (r) return r.pushApplication(t);
        }
      }, {
        key: "pushMany",
        value: function (e, t) {
          var r = this;
          return e.map(function (e) {
            return r.push(e, t);
          });
        }
      }, {
        key: "remove",
        value: function (e) {
          var t = this.sprayRecords.findIndex(function (t) {
            return t.id === e;
          });
          t < 0 || this.sprayRecords.splice(t, 1);
        }
      }, {
        key: "removeApplication",
        value: function (e, t) {
          var r = this.find(e);
          r && r.removeApplication(t);
        }
      }, {
        key: "removeProductApplication",
        value: function (e, t) {
          var r = this.find(e);
          r && r.removeProductApplication(t);
        }
      }, {
        key: "saveProductApplication",
        value: function (e, t) {
          var r,
              n,
              o,
              i = this;
          return this.api.update(e, {
            product_applications: [{
              id: t.id,
              product_id: t.product.id,
              rate: (null === (r = t.rate) || void 0 === r ? void 0 : r.toJS()) || "",
              target: t.target,
              position: t.position,
              phi_override: (null === (n = t.phiOverride) || void 0 === n ? void 0 : n.toJS()) || "",
              phi_override_by: t.phiOverrideBy,
              phi_override_reason: t.phiOverrideReason,
              rei_override: (null === (o = t.reiOverride) || void 0 === o ? void 0 : o.toJS()) || "",
              rei_override_by: t.reiOverrideBy,
              rei_override_reason: t.reiOverrideReason
            }]
          }).then(function (e) {
            return i.push(e.sprayRecord);
          });
        }
      }, {
        key: "handleApplicationResponse",
        value: function (e, t) {
          if ("success" !== e.status) throw e;
          return this.fetch(t);
        }
      }, {
        key: "updateApplication",
        value: function (e, t) {
          var r = this;
          return this.api.updateApplication(t).then(function (t) {
            return r.handleApplicationResponse(t, e), r.pushApplication(e, t.application);
          });
        }
      }, {
        key: "addApplication",
        value: function (e, t) {
          var r = this;
          return this.api.createApplication(e, t).then(function (t) {
            return r.handleApplicationResponse(t, e), r.pushApplication(e, t.application);
          });
        }
      }, {
        key: "deleteApplication",
        value: function (e, t) {
          var r = this;
          return this.api.deleteApplication(t).then(function (n) {
            return r.handleApplicationResponse(n, e), r.removeApplication(e, t.serial);
          });
        }
      }]);
    }()).prototype, "sprayRecords", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), hm = Tm(mm.prototype, "crops", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), gm = Tm(mm.prototype, "fields", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), wm = Tm(mm.prototype, "products", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), Om = Tm(mm.prototype, "targets", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), jm = Tm(mm.prototype, "varieties", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), Tm(mm.prototype, "items", [f.computed], Object.getOwnPropertyDescriptor(mm.prototype, "items"), mm.prototype), Tm(mm.prototype, "sprayRecordsBasePath", [f.computed], Object.getOwnPropertyDescriptor(mm.prototype, "sprayRecordsBasePath"), mm.prototype), Tm(mm.prototype, "deleteProductApplication", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "deleteProductApplication"), mm.prototype), Tm(mm.prototype, "fetch", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "fetch"), mm.prototype), Tm(mm.prototype, "fetchAllForAccounts", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "fetchAllForAccounts"), mm.prototype), Tm(mm.prototype, "update", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "update"), mm.prototype), Tm(mm.prototype, "moveProductApplication", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "moveProductApplication"), mm.prototype), Tm(mm.prototype, "push", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "push"), mm.prototype), Tm(mm.prototype, "pushApplication", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "pushApplication"), mm.prototype), Tm(mm.prototype, "pushMany", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "pushMany"), mm.prototype), Tm(mm.prototype, "remove", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "remove"), mm.prototype), Tm(mm.prototype, "removeApplication", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "removeApplication"), mm.prototype), Tm(mm.prototype, "removeProductApplication", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "removeProductApplication"), mm.prototype), Tm(mm.prototype, "saveProductApplication", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "saveProductApplication"), mm.prototype), Tm(mm.prototype, "handleApplicationResponse", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "handleApplicationResponse"), mm.prototype), Tm(mm.prototype, "updateApplication", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "updateApplication"), mm.prototype), Tm(mm.prototype, "addApplication", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "addApplication"), mm.prototype), Tm(mm.prototype, "deleteApplication", [f.action], Object.getOwnPropertyDescriptor(mm.prototype, "deleteApplication"), mm.prototype), mm),
        Bm = r(60),
        Lm = r.n(Bm),
        Vm = r(197),
        Um = r.n(Vm),
        qm = r(35),
        Km = r.n(qm);

    function Gm(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Wm(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Jm(n.key), n);
      }
    }

    function Hm(e, t, r) {
      return t && Wm(e.prototype, t), r && Wm(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function Jm(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Ym(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Qm,
        $m,
        Xm,
        Zm,
        ev,
        tv,
        rv,
        nv,
        ov,
        iv,
        av,
        cv,
        uv,
        lv,
        sv,
        pv,
        fv,
        dv,
        bv,
        yv,
        mv,
        vv,
        hv,
        gv,
        wv,
        Ov,
        jv,
        Pv,
        _v,
        Ev,
        Sv,
        Cv,
        kv,
        Rv,
        Tv,
        zv,
        Nv,
        Dv,
        xv = (Nm = Ym((zm = Hm(function e(t) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), Gm(this, "isActive", Nm, this), Gm(this, "isHidden", Dm, this), Gm(this, "isChecked", xm, this), Gm(this, "setActive", Am, this), Gm(this, "setHidden", Mm, this), Gm(this, "setChecked", Im, this);
      var r = (t || {}).number;
      this.number = r;
    })).prototype, "isActive", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Dm = Ym(zm.prototype, "isHidden", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), xm = Ym(zm.prototype, "isChecked", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Am = Ym(zm.prototype, "setActive", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.isActive = t;
        };
      }
    }), Mm = Ym(zm.prototype, "setHidden", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.isHidden = t;
        };
      }
    }), Im = Ym(zm.prototype, "setChecked", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.isChecked = t;
        };
      }
    }), zm);

    function Av(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Mv(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Av(Object(r), !0).forEach(function (t) {
          Iv(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Av(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Iv(e, t, r) {
      return (t = Lv(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Fv(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Bv(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Lv(n.key), n);
      }
    }

    function Lv(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Vv(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Uv,
        qv,
        Kv,
        Gv,
        Wv = ($m = Vv((Qm = function () {
      return e = function e(t, r) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.api = void 0, this.store = void 0, this.runQuery = void 0, Fv(this, "allChecked", $m, this), Fv(this, "limit", Xm, this), Fv(this, "offset", Zm, this), Fv(this, "totalResults", ev, this), Fv(this, "resultIds", tv, this), Fv(this, "accounts", rv, this), Fv(this, "search", nv, this), Fv(this, "cropFilters", ov, this), Fv(this, "dateFilters", iv, this), Fv(this, "fieldFilters", av, this), Fv(this, "productFilters", cv, this), Fv(this, "targetFilters", uv, this), Fv(this, "varietyFilters", lv, this), Fv(this, "organicFilter", sv, this), Fv(this, "statusFilters", pv, this), Fv(this, "updatedAtFilters", fv, this), Fv(this, "cropsIsPending", dv, this), Fv(this, "fieldsIsPending", bv, this), Fv(this, "productsIsPending", yv, this), Fv(this, "targetsIsPending", mv, this), Fv(this, "varietiesIsPending", vv, this), Fv(this, "fetchingAllSerials", hv, this), Fv(this, "isPending", gv, this), Fv(this, "pendingRequests", wv, this), Fv(this, "completeRequest", Ov, this), Fv(this, "clearFlagCallback", jv, this), Fv(this, "clearSearch", Pv, this), Fv(this, "changeCropFilter", _v, this), Fv(this, "changeDateRangeFilter", Ev, this), Fv(this, "changeFieldFilter", Sv, this), Fv(this, "changeProductFilter", Cv, this), Fv(this, "changeVarietyFilter", kv, this), Fv(this, "changeOrganicFilter", Rv, this), Fv(this, "changeSearch", Tv, this), Fv(this, "changeTargetFilter", zv, this), Fv(this, "changeUpdatedAtRangeFilter", Nv, this), Fv(this, "changeStatusFilter", Dv, this), this.store = t, this.accounts = r || [], this.api = t.api, this.runQuery = Km()(this.runRawQuery, 700);
      }, (t = [{
        key: "currentPage",
        get: function () {
          var e = this;
          return this.pages.find(function (t) {
            return t.number === e.currentPageNumber;
          });
        }
      }, {
        key: "currentPageChecked",
        get: function () {
          return this.currentPage && this.currentPage.isChecked;
        }
      }, {
        key: "currentPageNumber",
        get: function () {
          return this.limit ? Math.floor(this.offset / this.limit) + 1 : 1;
        }
      }, {
        key: "numPages",
        get: function () {
          return this.totalResults <= 1 || !this.limit ? 1 : Math.ceil(this.totalResults / this.limit);
        }
      }, {
        key: "filters",
        get: function () {
          return [].concat(this.hasCropFilter ? {
            filter: "crop",
            values: this.cropFilters
          } : []).concat(this.hasDateFilter ? {
            filter: "date",
            values: this.dateFilters
          } : []).concat(this.hasFieldFilter ? {
            filter: "field",
            values: this.fieldFilters
          } : []).concat(this.hasProductFilter ? {
            filter: "product",
            values: this.productFilters
          } : []).concat(this.hasTargetFilter ? {
            filter: "target",
            values: this.targetFilters
          } : []).concat(this.hasVarietyFilter ? {
            filter: "variety",
            values: this.varietyFilters
          } : []).concat(this.hasOrganicFilter ? {
            filter: "organic",
            values: this.organicFilter
          } : []).concat(this.hasUpdatedAtFilter ? {
            filter: "updated_at",
            values: this.updatedAtFilters
          } : []).concat(this.hasStatusFilter ? {
            filter: "status",
            values: this.statusFilters
          } : []);
        }
      }, {
        key: "items",
        get: function () {
          var e = this;
          return this.store ? Lm()(this.store.items.filter(function (t) {
            return e.resultIds.includes(t.id);
          }), ["searchScore"], ["desc"]) : [];
        }
      }, {
        key: "hasCropFilter",
        get: function () {
          return this.cropFilters.length > 0;
        }
      }, {
        key: "hasDateFilter",
        get: function () {
          return this.dateFilters.start || this.dateFilters.end;
        }
      }, {
        key: "hasVarietyFilter",
        get: function () {
          return this.varietyFilters.length > 0;
        }
      }, {
        key: "hasOrganicFilter",
        get: function () {
          return this.organicFilter.length > 0;
        }
      }, {
        key: "hasFieldFilter",
        get: function () {
          return this.fieldFilters.length > 0;
        }
      }, {
        key: "hasTargetFilter",
        get: function () {
          return this.targetFilters.length > 0;
        }
      }, {
        key: "hasStatusFilter",
        get: function () {
          return this.statusFilters.length > 0;
        }
      }, {
        key: "hasProductFilter",
        get: function () {
          return this.productFilters.length > 0;
        }
      }, {
        key: "hasUpdatedAtFilter",
        get: function () {
          return this.updatedAtFilters.start || this.updatedAtFilters.end;
        }
      }, {
        key: "hasAnyFilter",
        get: function () {
          return this.filtersAppliedCount > 0;
        }
      }, {
        key: "filtersAppliedCount",
        get: function () {
          return [this.hasCropFilter, this.hasDateFilter, this.hasFieldFilter, this.hasProductFilter, this.hasTargetFilter, this.hasVarietyFilter, this.hasStatusFilter, this.hasOrganicFilter, this.hasUpdatedAtFilter].filter(Boolean).length;
        }
      }, {
        key: "pages",
        get: function () {
          return Um()(this.numPages).map(function (e) {
            return new xv({
              number: e + 1
            });
          });
        }
      }, {
        key: "clearLimit",
        value: function () {
          this.limit = void 0;
        }
      }, {
        key: "fetchFilterOptions",
        value: function () {
          this.cropsIsPending = !0, this.fieldsIsPending = !0, this.productsIsPending = !0, this.targetsIsPending = !0, this.varietiesIsPending = !0, this.store.fetchCrops({
            accounts: this.accounts
          }).then(this.clearFlagCallback("cropsIsPending")).catch(this.clearFlagCallback("cropsIsPending")), this.store.fetchFields({
            accounts: this.accounts
          }).then(this.clearFlagCallback("fieldsIsPending")).catch(this.clearFlagCallback("fieldsIsPending")), this.store.fetchProducts({
            accounts: this.accounts
          }).then(this.clearFlagCallback("productsIsPending")).catch(this.clearFlagCallback("productsIsPending")), this.store.fetchTargets({
            accounts: this.accounts
          }).then(this.clearFlagCallback("targetsIsPending")).catch(this.clearFlagCallback("targetsIsPending")), this.store.fetchVarieties({
            accounts: this.accounts
          }).then(this.clearFlagCallback("varietiesIsPending")).catch(this.clearFlagCallback("varietiesIsPending"));
        }
      }, {
        key: "captureQueryResults",
        value: function (e) {
          this.offset = e.offset, this.totalResults = e.totalResults;
        }
      }, {
        key: "query",
        value: function (e) {
          var t = this;
          return this.pendingRequests += 1, this.isPending = !0, this.api.query(Mv({
            accounts: this.accounts,
            limit: this.limit,
            offset: this.offset,
            search: this.search,
            filters: this.filters
          }, e || {})).then(function (e) {
            return t.captureQueryResults(e);
          }).finally(function () {
            return Object(f.runInAction)(function () {
              t.completeRequest();
            });
          });
        }
      }, {
        key: "queryAllSerials",
        value: function (e) {
          return this.api.queryAllSerials(Mv({
            accounts: this.accounts,
            search: this.search,
            filters: this.filters
          }, e || {})).then(function (e) {
            return e.serials;
          });
        }
      }, {
        key: "queryPage",
        value: function (e, t) {
          return this.query(Mv(Mv({}, t || {}), {}, {
            offset: e * this.limit - this.limit
          }));
        }
      }, {
        key: "copyFilter",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
            default: []
          };
          return Object(x.clone)(e) || t.default;
        }
      }, {
        key: "setLimit",
        value: function (e) {
          this.limit = e;
        }
      }, {
        key: "setOffset",
        value: function (e) {
          this.offset = e;
        }
      }, {
        key: "setTotalResults",
        value: function (e) {
          this.totalResults = e;
        }
      }, {
        key: "runRawQuery",
        value: function () {
          return this.query({
            offset: 0
          });
        }
      }]) && Bv(e.prototype, t), r && Bv(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "allChecked", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Xm = Vv(Qm.prototype, "limit", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 20;
      }
    }), Zm = Vv(Qm.prototype, "offset", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), ev = Vv(Qm.prototype, "totalResults", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), tv = Vv(Qm.prototype, "resultIds", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), rv = Vv(Qm.prototype, "accounts", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), nv = Vv(Qm.prototype, "search", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), ov = Vv(Qm.prototype, "cropFilters", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), iv = Vv(Qm.prototype, "dateFilters", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return {};
      }
    }), av = Vv(Qm.prototype, "fieldFilters", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), cv = Vv(Qm.prototype, "productFilters", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), uv = Vv(Qm.prototype, "targetFilters", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), lv = Vv(Qm.prototype, "varietyFilters", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), sv = Vv(Qm.prototype, "organicFilter", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), pv = Vv(Qm.prototype, "statusFilters", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), fv = Vv(Qm.prototype, "updatedAtFilters", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return {};
      }
    }), dv = Vv(Qm.prototype, "cropsIsPending", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), bv = Vv(Qm.prototype, "fieldsIsPending", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), yv = Vv(Qm.prototype, "productsIsPending", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), mv = Vv(Qm.prototype, "targetsIsPending", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), vv = Vv(Qm.prototype, "varietiesIsPending", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), hv = Vv(Qm.prototype, "fetchingAllSerials", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), gv = Vv(Qm.prototype, "isPending", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), wv = Vv(Qm.prototype, "pendingRequests", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), Vv(Qm.prototype, "currentPage", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "currentPage"), Qm.prototype), Vv(Qm.prototype, "currentPageChecked", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "currentPageChecked"), Qm.prototype), Vv(Qm.prototype, "currentPageNumber", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "currentPageNumber"), Qm.prototype), Vv(Qm.prototype, "numPages", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "numPages"), Qm.prototype), Vv(Qm.prototype, "filters", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "filters"), Qm.prototype), Vv(Qm.prototype, "items", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "items"), Qm.prototype), Vv(Qm.prototype, "hasCropFilter", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "hasCropFilter"), Qm.prototype), Vv(Qm.prototype, "hasDateFilter", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "hasDateFilter"), Qm.prototype), Vv(Qm.prototype, "hasVarietyFilter", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "hasVarietyFilter"), Qm.prototype), Vv(Qm.prototype, "hasOrganicFilter", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "hasOrganicFilter"), Qm.prototype), Vv(Qm.prototype, "hasFieldFilter", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "hasFieldFilter"), Qm.prototype), Vv(Qm.prototype, "hasTargetFilter", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "hasTargetFilter"), Qm.prototype), Vv(Qm.prototype, "hasStatusFilter", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "hasStatusFilter"), Qm.prototype), Vv(Qm.prototype, "hasProductFilter", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "hasProductFilter"), Qm.prototype), Vv(Qm.prototype, "hasUpdatedAtFilter", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "hasUpdatedAtFilter"), Qm.prototype), Vv(Qm.prototype, "hasAnyFilter", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "hasAnyFilter"), Qm.prototype), Vv(Qm.prototype, "filtersAppliedCount", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "filtersAppliedCount"), Qm.prototype), Vv(Qm.prototype, "pages", [f.computed], Object.getOwnPropertyDescriptor(Qm.prototype, "pages"), Qm.prototype), Vv(Qm.prototype, "clearLimit", [f.action], Object.getOwnPropertyDescriptor(Qm.prototype, "clearLimit"), Qm.prototype), Vv(Qm.prototype, "fetchFilterOptions", [f.action], Object.getOwnPropertyDescriptor(Qm.prototype, "fetchFilterOptions"), Qm.prototype), Ov = Vv(Qm.prototype, "completeRequest", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.pendingRequests -= 1, e.pendingRequests <= 0 && (e.pendingRequests = 0, e.isPending = !1);
        };
      }
    }), Vv(Qm.prototype, "captureQueryResults", [f.action], Object.getOwnPropertyDescriptor(Qm.prototype, "captureQueryResults"), Qm.prototype), Vv(Qm.prototype, "query", [f.action], Object.getOwnPropertyDescriptor(Qm.prototype, "query"), Qm.prototype), jv = Vv(Qm.prototype, "clearFlagCallback", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function () {
            e[t] = !1;
          };
        };
      }
    }), Pv = Vv(Qm.prototype, "clearSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.changeSearch("");
        };
      }
    }), _v = Vv(Qm.prototype, "changeCropFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.cropFilters = e.copyFilter(t);
        };
      }
    }), Ev = Vv(Qm.prototype, "changeDateRangeFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.dateFilters = e.copyFilter(t, {
            default: {}
          });
        };
      }
    }), Sv = Vv(Qm.prototype, "changeFieldFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.fieldFilters = e.copyFilter(t);
        };
      }
    }), Cv = Vv(Qm.prototype, "changeProductFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.productFilters = e.copyFilter(t);
        };
      }
    }), kv = Vv(Qm.prototype, "changeVarietyFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.varietyFilters = e.copyFilter(t);
        };
      }
    }), Rv = Vv(Qm.prototype, "changeOrganicFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.organicFilter = e.copyFilter(t);
        };
      }
    }), Tv = Vv(Qm.prototype, "changeSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.search = t;
        };
      }
    }), zv = Vv(Qm.prototype, "changeTargetFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.targetFilters = e.copyFilter(t);
        };
      }
    }), Nv = Vv(Qm.prototype, "changeUpdatedAtRangeFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.updatedAtFilters = t;
        };
      }
    }), Dv = Vv(Qm.prototype, "changeStatusFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.statusFilters = e.copyFilter(t);
        };
      }
    }), Vv(Qm.prototype, "setLimit", [f.action], Object.getOwnPropertyDescriptor(Qm.prototype, "setLimit"), Qm.prototype), Vv(Qm.prototype, "setOffset", [f.action], Object.getOwnPropertyDescriptor(Qm.prototype, "setOffset"), Qm.prototype), Vv(Qm.prototype, "setTotalResults", [f.action], Object.getOwnPropertyDescriptor(Qm.prototype, "setTotalResults"), Qm.prototype), Qm);

    function Hv(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Jv(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Yv(n.key), n);
      }
    }

    function Yv(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Qv(e, t, r) {
      return t = Zv(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Zv(e).constructor) : t.apply(e, r));
    }

    function $v() {
      return ($v = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Xv(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Xv(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = Zv(e)););

      return e;
    }

    function Zv(e) {
      return (Zv = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function eh(e, t) {
      return (eh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function th(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var rh,
        nh,
        oh,
        ih,
        ah,
        ch,
        uh,
        lh,
        sh,
        ph,
        fh,
        dh,
        bh,
        yh,
        mh,
        vh,
        hh,
        gh,
        wh,
        Oh,
        jh,
        Ph,
        _h,
        Eh,
        Sh = (qv = th((Uv = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return Hv(e = Qv(this, t, [].concat(n)), "allSprayRecordSerials", qv, e), Hv(e, "fetchingAllSerials", Kv, e), Hv(e, "setSprayRecordSerials", Gv, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && eh(e, t);
      }(t, Wv), function (e, t, r) {
        return t && Jv(e.prototype, t), r && Jv(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "checkedCount",
        get: function () {
          return this.serialsForBulkActions.length;
        }
      }, {
        key: "sprayRecords",
        get: function () {
          var e = this;
          return this.store ? this.store.sprayRecords.filter(function (t) {
            return e.resultIds.includes(t.id);
          }) : [];
        }
      }, {
        key: "serialsForBulkActions",
        get: function () {
          var e = new Set(this.store.sprayRecords.filter(function (e) {
            return !e.isChecked;
          }).map(function (e) {
            return e.serial;
          }));
          return this.allChecked ? this.allSprayRecordSerials.filter(function (t) {
            return !e.has(t);
          }) : this.store.sprayRecords.filter(function (e) {
            return e.isChecked;
          }).map(function (e) {
            return e.serial;
          });
        }
      }, {
        key: "captureQueryResults",
        value: function (e) {
          var r, n, o, i, a, c, u;
          if ((o = t, i = "captureQueryResults", a = this, u = $v(Zv(1 & (c = 3) ? o.prototype : o), i, a), 2 & c && "function" == typeof u ? function (e) {
            return u.apply(a, e);
          } : u)([e]), this.resultIds = (null == e || null === (r = e.sprayRecords) || void 0 === r || null === (n = r.map) || void 0 === n ? void 0 : n.call(r, function (e) {
            return e.id;
          })) || [], this.resultIds.length) return this.store.pushMany(e.sprayRecords, {
            isChecked: this.allChecked
          });
        }
      }, {
        key: "checkAll",
        value: function () {
          var e = this;
          return this.allChecked = !0, this.store.sprayRecords.forEach(function (e) {
            return e.check();
          }), this.pages.map(function (e) {
            return e.setChecked(!0);
          }), this.setFetchingAllSerialsFlag(!0), this.queryAllSerials().then(this.setSprayRecordSerials).catch(console.error).finally(function () {
            return e.setFetchingAllSerialsFlag(!1);
          });
        }
      }, {
        key: "checkAllOnPage",
        value: function () {
          this.sprayRecords.forEach(function (e) {
            e.check();
          }), this.currentPage && this.currentPage.setChecked(!0);
        }
      }, {
        key: "unCheckAll",
        value: function () {
          this.allChecked = !1, this.setSprayRecordSerials([]), this.pages.map(function (e) {
            return e.setChecked(!1);
          }), this.store.sprayRecords.forEach(function (e) {
            return e.unCheck();
          });
        }
      }, {
        key: "unCheckAllOnPage",
        value: function () {
          this.currentPage && this.currentPage.setChecked(!1), this.sprayRecords.forEach(function (e) {
            return e.unCheck();
          });
        }
      }, {
        key: "setFetchingAllSerialsFlag",
        value: function (e) {
          this.fetchingAllSerials = e;
        }
      }]);
    }()).prototype, "allSprayRecordSerials", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), Kv = th(Uv.prototype, "fetchingAllSerials", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), th(Uv.prototype, "checkedCount", [f.computed], Object.getOwnPropertyDescriptor(Uv.prototype, "checkedCount"), Uv.prototype), th(Uv.prototype, "sprayRecords", [f.computed], Object.getOwnPropertyDescriptor(Uv.prototype, "sprayRecords"), Uv.prototype), th(Uv.prototype, "serialsForBulkActions", [f.computed], Object.getOwnPropertyDescriptor(Uv.prototype, "serialsForBulkActions"), Uv.prototype), th(Uv.prototype, "captureQueryResults", [f.action], Object.getOwnPropertyDescriptor(Uv.prototype, "captureQueryResults"), Uv.prototype), th(Uv.prototype, "checkAll", [f.action], Object.getOwnPropertyDescriptor(Uv.prototype, "checkAll"), Uv.prototype), th(Uv.prototype, "checkAllOnPage", [f.action], Object.getOwnPropertyDescriptor(Uv.prototype, "checkAllOnPage"), Uv.prototype), th(Uv.prototype, "unCheckAll", [f.action], Object.getOwnPropertyDescriptor(Uv.prototype, "unCheckAll"), Uv.prototype), th(Uv.prototype, "unCheckAllOnPage", [f.action], Object.getOwnPropertyDescriptor(Uv.prototype, "unCheckAllOnPage"), Uv.prototype), Gv = th(Uv.prototype, "setSprayRecordSerials", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.allSprayRecordSerials = t;
        };
      }
    }), th(Uv.prototype, "setFetchingAllSerialsFlag", [f.action], Object.getOwnPropertyDescriptor(Uv.prototype, "setFetchingAllSerialsFlag"), Uv.prototype), Uv);

    function Ch(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function kh(e, t, r) {
      return (t = zh(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Rh(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Th(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zh(n.key), n);
      }
    }

    function zh(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Nh(e, t, r) {
      return t = Dh(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Dh(e).constructor) : t.apply(e, r));
    }

    function Dh(e) {
      return (Dh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function xh(e, t) {
      return (xh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Ah(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Mh,
        Ih = (nh = Ah((rh = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = Nh(this, t, [].concat(n))).today = M()(), e.animationFrameRequestId = void 0, Rh(e, "selector", nh, e), Rh(e, "dateOptions", oh, e), Rh(e, "startOfLastYear", ih, e), Rh(e, "startOfLastMonth", ah, e), Rh(e, "startOfLastWeek", ch, e), Rh(e, "startOfThisYear", uh, e), Rh(e, "startOfThisMonth", lh, e), Rh(e, "startOfThisWeek", sh, e), Rh(e, "endOfLastYear", ph, e), Rh(e, "endOfLastMonth", fh, e), Rh(e, "endOfLastWeek", dh, e), Rh(e, "endOfThisYear", bh, e), Rh(e, "endOfThisMonth", yh, e), Rh(e, "endOfThisWeek", mh, e), Rh(e, "startDate", vh, e), Rh(e, "endDate", hh, e), Rh(e, "shouldShowCustomDateSelector", gh, e), Rh(e, "registerSelectorModel", wh, e), e.tick = function () {
          e.updateIfNecessary(), e.animationFrameRequestId = requestAnimationFrame(e.tick);
        }, Rh(e, "clearFilters", Oh, e), Rh(e, "selectOption", jh, e), Rh(e, "onChangeDateRange", Ph, e), Rh(e, "onChangeStartDate", _h, e), Rh(e, "onChangeEndDate", Eh, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && xh(e, t);
      }(t, h["ViewModel"]), function (e, t, r) {
        return t && Th(e.prototype, t), r && Th(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "dateRange",
        get: function () {
          var e, t, r, n;
          return {
            start: (null === (e = this.startDate) || void 0 === e || null === (t = e.toISOString) || void 0 === t ? void 0 : t.call(e)) || "",
            end: (null === (r = this.endDate) || void 0 === r || null === (n = r.toISOString) || void 0 === n ? void 0 : n.call(r)) || ""
          };
        }
      }, {
        key: "translatedDateOptions",
        get: function () {
          var e = this.props.t;
          return this.dateOptions.map(function (t) {
            var r = function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ch(Object(r), !0).forEach(function (t) {
                  kh(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ch(Object(r)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
              }

              return e;
            }({}, t);

            return r.text = e(t.text), r;
          });
        }
      }, {
        key: "customSelected",
        get: function () {
          var e;
          return "custom" === (null === (e = this.selector.selectedOption) || void 0 === e ? void 0 : e.key);
        }
      }, {
        key: "onMount",
        value: function () {
          this.updateDateRanges(), this.clearFilters(), this.animationFrameRequestId = requestAnimationFrame(this.tick);
        }
      }, {
        key: "onUnmount",
        value: function () {
          this.animationFrameRequestId && cancelAnimationFrame(this.animationFrameRequestId);
        }
      }, {
        key: "updateIfNecessary",
        value: function () {
          var e = M()();
          e.diff(this.today, "days") < 1 || (this.today = e, this.updateDateRanges());
        }
      }, {
        key: "updateDateRanges",
        value: function () {
          var e = M()(),
              t = M()(e).subtract(1, "years"),
              r = M()(e).subtract(1, "months"),
              n = M()(e).subtract(1, "weeks");
          this.startOfLastYear = M()(t).startOf("year").toDate(), this.startOfLastMonth = M()(r).startOf("month").toDate(), this.startOfLastWeek = M()(n).startOf("week").toDate(), this.startOfThisYear = M()(e).startOf("year").toDate(), this.startOfThisMonth = M()(e).startOf("month").toDate(), this.startOfThisWeek = M()(e).startOf("week").toDate(), this.endOfLastYear = M()(t).endOf("year").toDate(), this.endOfLastMonth = M()(r).endOf("month").toDate(), this.endOfLastWeek = M()(n).endOf("week").toDate(), this.endOfThisYear = M()(e).endOf("year").toDate(), this.endOfThisMonth = M()(e).endOf("month").toDate(), this.endOfThisWeek = M()(e).endOf("week").toDate();
        }
      }]);
    }()).prototype, "selector", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), oh = Ah(rh.prototype, "dateOptions", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [{
          key: "thisYear",
          text: "this_year",
          value: "thisYear"
        }, {
          key: "lastYear",
          text: "last_year",
          value: "lastYear"
        }, {
          key: "thisMonth",
          text: "this_month",
          value: "thisMonth"
        }, {
          key: "lastMonth",
          text: "last_month",
          value: "lastMonth"
        }, {
          key: "thisWeek",
          text: "this_week",
          value: "thisWeek"
        }, {
          key: "lastWeek",
          text: "last_week",
          value: "lastWeek"
        }, {
          key: "custom",
          text: "custom",
          value: "custom"
        }].sort(function (e, t) {
          return Object(h.naturalSort)(e.text, t.text);
        });
      }
    }), ih = Ah(rh.prototype, "startOfLastYear", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), ah = Ah(rh.prototype, "startOfLastMonth", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), ch = Ah(rh.prototype, "startOfLastWeek", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), uh = Ah(rh.prototype, "startOfThisYear", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), lh = Ah(rh.prototype, "startOfThisMonth", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), sh = Ah(rh.prototype, "startOfThisWeek", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), ph = Ah(rh.prototype, "endOfLastYear", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), fh = Ah(rh.prototype, "endOfLastMonth", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), dh = Ah(rh.prototype, "endOfLastWeek", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), bh = Ah(rh.prototype, "endOfThisYear", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), yh = Ah(rh.prototype, "endOfThisMonth", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), mh = Ah(rh.prototype, "endOfThisWeek", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), vh = Ah(rh.prototype, "startDate", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), hh = Ah(rh.prototype, "endDate", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), gh = Ah(rh.prototype, "shouldShowCustomDateSelector", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Ah(rh.prototype, "dateRange", [f.computed], Object.getOwnPropertyDescriptor(rh.prototype, "dateRange"), rh.prototype), Ah(rh.prototype, "translatedDateOptions", [f.computed], Object.getOwnPropertyDescriptor(rh.prototype, "translatedDateOptions"), rh.prototype), Ah(rh.prototype, "customSelected", [f.computed], Object.getOwnPropertyDescriptor(rh.prototype, "customSelected"), rh.prototype), wh = Ah(rh.prototype, "registerSelectorModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.selector = t;
        };
      }
    }), Oh = Ah(rh.prototype, "clearFilters", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.onChangeDateRange();
        };
      }
    }), jh = Ah(rh.prototype, "selectOption", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.dateOptions.find(function (e) {
            return e.key === t;
          });
          e.onChangeDateRange(r);
        };
      }
    }), Ph = Ah(rh.prototype, "onChangeDateRange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          switch (e.selector && e.selector.change(t), t && t.key) {
            case "thisYear":
              e.startDate = e.startOfThisYear, e.endDate = e.endOfThisYear;
              break;

            case "thisMonth":
              e.startDate = e.startOfThisMonth, e.endDate = e.endOfThisMonth;
              break;

            case "thisWeek":
              e.startDate = e.startOfThisWeek, e.endDate = e.endOfThisWeek;
              break;

            case "lastYear":
              e.startDate = e.startOfLastYear, e.endDate = e.endOfLastYear;
              break;

            case "lastMonth":
              e.startDate = e.startOfLastMonth, e.endDate = e.endOfLastMonth;
              break;

            case "lastWeek":
              e.startDate = e.startOfLastWeek, e.endDate = e.endOfLastWeek;
              break;

            default:
              t || (e.startDate = "", e.endDate = "");
          }

          e.shouldShowCustomDateSelector = t && "custom" === t.key;
        };
      }
    }), _h = Ah(rh.prototype, "onChangeStartDate", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.startDate = t;
        };
      }
    }), Eh = Ah(rh.prototype, "onChangeEndDate", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.endDate = t;
        };
      }
    }), Ah(rh.prototype, "updateIfNecessary", [f.action], Object.getOwnPropertyDescriptor(rh.prototype, "updateIfNecessary"), rh.prototype), Ah(rh.prototype, "updateDateRanges", [f.action], Object.getOwnPropertyDescriptor(rh.prototype, "updateDateRanges"), rh.prototype), rh);

    function Fh(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Bh(n.key), n);
      }
    }

    function Bh(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Lh(e, t, r) {
      return t = Vh(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Vh(e).constructor) : t.apply(e, r));
    }

    function Vh(e) {
      return (Vh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Uh(e, t) {
      return (Uh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var qh,
        Kh,
        Gh,
        Wh,
        Hh,
        Jh,
        Yh,
        Qh,
        $h,
        Xh,
        Zh,
        eg,
        tg,
        rg,
        ng,
        og,
        ig,
        ag,
        cg,
        ug,
        lg,
        sg,
        pg,
        fg,
        dg,
        bg,
        yg = Object(d.observer)(Mh = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
        var n = (r = Lh(this, t, [e])).props.model;
        return r.model = n || new Ih(r.props), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Uh(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Fh(e.prototype, t), r && Fh(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "componentDidMount",
        value: function () {
          this.model.onMount();
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.model.onUnmount();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return p.a.createElement("div", {
            className: "date-range-selector"
          }, p.a.createElement(h.SelectDropdown, {
            className: "filter-selector",
            placeholder: e("select_date_range"),
            options: this.model.translatedDateOptions,
            onChange: this.model.onChangeDateRange,
            onRegisterModel: this.model.registerSelectorModel
          }), this.model.shouldShowCustomDateSelector ? p.a.createElement("div", {
            className: "date-picker-row row no-gutters"
          }, p.a.createElement("div", {
            className: "col-6"
          }, p.a.createElement("div", {
            className: "input-group"
          }, p.a.createElement(Bu, {
            placeholder: e("start_date"),
            className: "mr-1 w-100",
            value: this.model.startDate,
            onChange: this.model.onChangeStartDate
          }), p.a.createElement("i", {
            className: "fas fa-calendar-alt input-icon"
          }))), p.a.createElement("div", {
            className: "col-6"
          }, p.a.createElement("div", {
            className: "input-group"
          }, p.a.createElement(Bu, {
            placeholder: e("end_date"),
            className: "w-100",
            value: this.model.endDate,
            onChange: this.model.onChangeEndDate
          }), p.a.createElement("i", {
            className: "fas fa-calendar-alt input-icon"
          })))) : null);
        }
      }]);
    }()) || Mh,
        mg = Object(g.a)()(yg);

    function vg(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function hg(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? vg(Object(r), !0).forEach(function (t) {
          gg(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vg(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function gg(e, t, r) {
      return (t = Eg(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function wg() {
      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      wg = function () {
        return t;
      };

      var e,
          t = {},
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = Object.defineProperty || function (e, t, r) {
        e[t] = r.value;
      },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          u = i.toStringTag || "@@toStringTag";

      function l(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        l({}, "");
      } catch (e) {
        l = function (e, t, r) {
          return e[t] = r;
        };
      }

      function s(e, t, r, n) {
        var i = t && t.prototype instanceof v ? t : v,
            a = Object.create(i.prototype),
            c = new T(n || []);
        return o(a, "_invoke", {
          value: S(e, r, c)
        }), a;
      }

      function p(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      t.wrap = s;
      var f = "suspendedStart",
          d = "suspendedYield",
          b = "executing",
          y = "completed",
          m = {};

      function v() {}

      function h() {}

      function g() {}

      var w = {};
      l(w, a, function () {
        return this;
      });
      var O = Object.getPrototypeOf,
          j = O && O(O(z([])));
      j && j !== r && n.call(j, a) && (w = j);
      var P = g.prototype = v.prototype = Object.create(w);

      function _(e) {
        ["next", "throw", "return"].forEach(function (t) {
          l(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function E(e, t) {
        function r(o, i, a, c) {
          var u = p(e[o], e, i);

          if ("throw" !== u.type) {
            var l = u.arg,
                s = l.value;
            return s && "object" == typeof s && n.call(s, "__await") ? t.resolve(s.__await).then(function (e) {
              r("next", e, a, c);
            }, function (e) {
              r("throw", e, a, c);
            }) : t.resolve(s).then(function (e) {
              l.value = e, a(l);
            }, function (e) {
              return r("throw", e, a, c);
            });
          }

          c(u.arg);
        }

        var i;
        o(this, "_invoke", {
          value: function (e, n) {
            function o() {
              return new t(function (t, o) {
                r(e, n, t, o);
              });
            }

            return i = i ? i.then(o, o) : o();
          }
        });
      }

      function S(t, r, n) {
        var o = f;
        return function (i, a) {
          if (o === b) throw Error("Generator is already running");

          if (o === y) {
            if ("throw" === i) throw a;
            return {
              value: e,
              done: !0
            };
          }

          for (n.method = i, n.arg = a;;) {
            var c = n.delegate;

            if (c) {
              var u = C(c, n);

              if (u) {
                if (u === m) continue;
                return u;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (o === f) throw o = y, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            o = b;
            var l = p(t, r, n);

            if ("normal" === l.type) {
              if (o = n.done ? y : d, l.arg === m) continue;
              return {
                value: l.arg,
                done: n.done
              };
            }

            "throw" === l.type && (o = y, n.method = "throw", n.arg = l.arg);
          }
        };
      }

      function C(t, r) {
        var n = r.method,
            o = t.iterator[n];
        if (o === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, C(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), m;
        var i = p(o, t.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, m;
        var a = i.arg;
        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, m) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m);
      }

      function k(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function R(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function T(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(k, this), this.reset(!0);
      }

      function z(t) {
        if (t || "" === t) {
          var r = t[a];
          if (r) return r.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var o = -1,
                i = function r() {
              for (; ++o < t.length;) if (n.call(t, o)) return r.value = t[o], r.done = !1, r;

              return r.value = e, r.done = !0, r;
            };

            return i.next = i;
          }
        }

        throw new TypeError(typeof t + " is not iterable");
      }

      return h.prototype = g, o(P, "constructor", {
        value: g,
        configurable: !0
      }), o(g, "constructor", {
        value: h,
        configurable: !0
      }), h.displayName = l(g, u, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === h || "GeneratorFunction" === (t.displayName || t.name));
      }, t.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, l(e, u, "GeneratorFunction")), e.prototype = Object.create(P), e;
      }, t.awrap = function (e) {
        return {
          __await: e
        };
      }, _(E.prototype), l(E.prototype, c, function () {
        return this;
      }), t.AsyncIterator = E, t.async = function (e, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new E(s(e, r, n, o), i);
        return t.isGeneratorFunction(r) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, _(P), l(P, u, "Generator"), l(P, a, function () {
        return this;
      }), l(P, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (e) {
        var t = Object(e),
            r = [];

        for (var n in t) r.push(n);

        return r.reverse(), function e() {
          for (; r.length;) {
            var n = r.pop();
            if (n in t) return e.value = n, e.done = !1, e;
          }

          return e.done = !0, e;
        };
      }, t.values = z, T.prototype = {
        constructor: T,
        reset: function (t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(R), !t) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
        },
        stop: function () {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function (t) {
          if (this.done) throw t;
          var r = this;

          function o(n, o) {
            return c.type = "throw", c.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
                c = a.completion;
            if ("root" === a.tryLoc) return o("end");

            if (a.tryLoc <= this.prev) {
              var u = n.call(a, "catchLoc"),
                  l = n.call(a, "finallyLoc");

              if (u && l) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!l) throw Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function (e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(a);
        },
        complete: function (e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
        },
        finish: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), R(r), m;
          }
        },
        catch: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                R(r);
              }

              return o;
            }
          }

          throw Error("illegal catch attempt");
        },
        delegateYield: function (t, r, n) {
          return this.delegate = {
            iterator: z(t),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = e), m;
        }
      }, t;
    }

    function Og(e, t, r, n, o, i, a) {
      try {
        var c = e[i](a),
            u = c.value;
      } catch (e) {
        return void r(e);
      }

      c.done ? t(u) : Promise.resolve(u).then(n, o);
    }

    function jg(e) {
      return function () {
        var t = this,
            r = arguments;
        return new Promise(function (n, o) {
          var i = e.apply(t, r);

          function a(e) {
            Og(i, n, o, a, c, "next", e);
          }

          function c(e) {
            Og(i, n, o, a, c, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function Pg(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function _g(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Eg(n.key), n);
      }
    }

    function Eg(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Sg(e, t, r) {
      return t = Cg(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Cg(e).constructor) : t.apply(e, r));
    }

    function Cg(e) {
      return (Cg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function kg(e, t) {
      return (kg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Rg(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Tg,
        zg,
        Ng = ((bg = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = Sg(this, t, [e])).fingerprint = Object(td.v4)(), r.storageName = "filters", r.initialFilters = null, Pg(r, "cropsSelectorModel", Kh, r), Pg(r, "fieldsSelectorModel", Gh, r), Pg(r, "productsSelectorModel", Wh, r), Pg(r, "statusSelectorModel", Hh, r), Pg(r, "targetsSelectorModel", Jh, r), Pg(r, "varietiesSelectorModel", Yh, r), Pg(r, "organicSelectorModel", Qh, r), Pg(r, "restoreLocalStoragePromise", $h, r), Pg(r, "filterIsPending", Xh, r), Pg(r, "clearIsPending", Zh, r), Pg(r, "hasError", eg, r), Pg(r, "errorText", tg, r), Pg(r, "clearAllFilters", rg, r), Pg(r, "onClickFilterButton", ng, r), Pg(r, "onClose", og, r), Pg(r, "onClear", ig, r), Pg(r, "publishFilterChanges", ag, r), Pg(r, "registerCropsSelectorModel", cg, r), Pg(r, "registerFieldsSelectorModel", ug, r), Pg(r, "registerProductsSelectorModel", lg, r), Pg(r, "registerStatusSelectorModel", sg, r), Pg(r, "registerTargetsSelectorModel", pg, r), Pg(r, "registerVarietiesSelectorModel", fg, r), Pg(r, "registerOrganicSelectorModel", dg, r);
        var n = r.props,
            o = n.t,
            i = n.id,
            a = n.store,
            c = n.queryService,
            u = n.storageName,
            l = n.initialFilters,
            s = n.configuration;
        return r.id = i || "filter-modal-".concat(r.fingerprint), r.store = a, r.queryService = c, r.errorText = o("filters_unexpected_error"), r.storageName = u, r.dateSelectorModel = new Ih({
          t: o
        }), r.initialFilters = l || (null == s ? void 0 : s.default_filters) || {}, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && kg(e, t);
      }(t, h["ViewModel"]), function (e, t, r) {
        return t && _g(e.prototype, t), r && _g(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "cropOptions",
        get: function () {
          return this.store.crops.map(function (e) {
            return {
              key: e,
              text: e,
              value: e
            };
          }).sort(function (e, t) {
            return Object(h.naturalSort)(e.text, t.text);
          });
        }
      }, {
        key: "fieldLabelId",
        get: function () {
          return "field-label-".concat(this.fingerprint);
        }
      }, {
        key: "fieldOptions",
        get: function () {
          return this.store.fields.map(function (e) {
            return {
              key: e.id,
              text: [].concat(e.fieldName || []).concat(e.accountName ? "(".concat(e.accountName, ")") : []).join(" "),
              value: e.id
            };
          }).sort(function (e, t) {
            return Object(h.naturalSort)(e.text, t.text);
          });
        }
      }, {
        key: "productOptions",
        get: function () {
          return this.store.products.filter(function (e) {
            return e.id && e.name;
          }).map(function (e) {
            return {
              key: e.id,
              text: e.name,
              value: e.id
            };
          }).sort(function (e, t) {
            return Object(h.naturalSort)(e.text, t.text);
          });
        }
      }, {
        key: "statusLabelId",
        get: function () {
          return "status-label-".concat(this.fingerprint);
        }
      }, {
        key: "statusOptions",
        get: function () {
          var e = this.props.t;
          return [{
            key: "complete",
            text: e("complete"),
            value: "complete"
          }, {
            key: "incomplete",
            text: e("incomplete"),
            value: "incomplete"
          }];
        }
      }, {
        key: "targetOptions",
        get: function () {
          return this.store.targets.map(function (e) {
            return {
              key: e,
              text: e,
              value: e
            };
          }).sort(function (e, t) {
            return Object(h.naturalSort)(e.text, t.text);
          });
        }
      }, {
        key: "varietyOptions",
        get: function () {
          return this.store.varieties.map(function (e) {
            return {
              key: e,
              text: e,
              value: e
            };
          }).sort(function (e, t) {
            return Object(h.naturalSort)(e.text, t.text);
          });
        }
      }, {
        key: "organicSelectorOptions",
        get: function () {
          var e = this.props.t;
          return [{
            key: "organic",
            text: e("organic"),
            value: !0
          }, {
            key: "conventional",
            text: e("conventional"),
            value: !1
          }];
        }
      }, {
        key: "badgeContent",
        get: function () {
          return this.queryService.filtersAppliedCount || "+";
        }
      }, {
        key: "queryWhenReady",
        value: function () {
          var e = this;
          return Object(f.when)(function () {
            return Boolean(e.restoreLocalStoragePromise);
          }, function () {
            e.restoreLocalStoragePromise.then(function () {
              return e.onFilter();
            }).catch(console.error);
          });
        }
      }, {
        key: "onMount",
        value: (o = jg(wg().mark(function e() {
          var t = this;
          return wg().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return this.queryService.fetchFilterOptions(), Object.keys(this.initialFilters).includes("status") && Object(f.when)(function () {
                  return Boolean(t.statusSelectorModel);
                }, function () {
                  return Object(f.runInAction)(function () {
                    t.statusSelectorModel.selectedKeys = t.initialFilters.status || [];
                  });
                }), this.restoreLocalStoragePromise = this.restoreLocalStorage(), e.next = 5, this.restoreLocalStoragePromise;

              case 5:
                this.publishFilterChanges();

              case 6:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function () {
          return o.apply(this, arguments);
        })
      }, {
        key: "whenAllSelectorModelsReady",
        value: function () {
          var e = this,
              t = this.props.includeStatusFilter;
          return Promise.all([Object(f.when)(function () {
            return Boolean(e.cropsSelectorModel);
          }), Object(f.when)(function () {
            return Boolean(e.fieldsSelectorModel);
          }), Object(f.when)(function () {
            return Boolean(e.productsSelectorModel);
          }), Object(f.when)(function () {
            return Boolean(e.targetsSelectorModel);
          }), Object(f.when)(function () {
            return Boolean(e.varietiesSelectorModel);
          }), Object(f.when)(function () {
            return Boolean(e.organicSelectorModel);
          }), Object(f.when)(function () {
            return Boolean(e.dateSelectorModel.selector);
          })].concat(t ? function () {
            return Boolean(e.statusSelectorModel);
          } : []));
        }
      }, {
        key: "whenFetchingOptionsIsFinished",
        value: function () {
          var e = this;
          return Promise.all([Object(f.when)(function () {
            return !e.queryService.fieldsIsPending;
          }), Object(f.when)(function () {
            return !e.queryService.cropsIsPending;
          }), Object(f.when)(function () {
            return !e.queryService.productsIsPending;
          }), Object(f.when)(function () {
            return !e.queryService.targetsIsPending;
          }), Object(f.when)(function () {
            return !e.queryService.varietiesIsPending;
          })]);
        }
      }, {
        key: "setDefaultFilters",
        value: function () {
          var e,
              t,
              r,
              n,
              o,
              i,
              a,
              c,
              u,
              l,
              s,
              p = this.props.includeStatusFilter;
          (this.cropsSelectorModel.selectedKeys = (null === (e = this.initialFilters) || void 0 === e ? void 0 : e.crops) || [], this.productsSelectorModel.selectedKeys = (null === (t = this.initialFilters) || void 0 === t ? void 0 : t.products) || [], this.targetsSelectorModel.selectedKeys = (null === (r = this.initialFilters) || void 0 === r ? void 0 : r.targets) || [], this.fieldsSelectorModel.selectedKeys = (null === (n = this.initialFilters) || void 0 === n ? void 0 : n.fields) || [], this.varietiesSelectorModel.selectedKeys = (null === (o = this.initialFilters) || void 0 === o ? void 0 : o.varieties) || [], null !== (i = this.initialFilters) && void 0 !== i && i.organicFilter) ? this.organicSelectorModel.search(null === (u = this.initialFilters) || void 0 === u ? void 0 : u.organicFilter) : this.organicSelectorModel.reset();
          null !== (a = this.initialFilters) && void 0 !== a && null !== (a = a.dateRange) && void 0 !== a && a.option ? this.dateSelectorModel.selectOption(this.initialFilters.dateRange.option) : (this.dateSelectorModel.startDate = (null === (l = this.initialFilters) || void 0 === l || null === (l = l.dateRange) || void 0 === l ? void 0 : l.start) || "", this.dateSelectorModel.endDate = (null === (s = this.initialFilters) || void 0 === s || null === (s = s.dateRange) || void 0 === s ? void 0 : s.end) || "");
          p && (this.statusSelectorModel.selectedKeys = (null === (c = this.initialFilters) || void 0 === c ? void 0 : c.status) || []);
        }
      }, {
        key: "saveLocalStorage",
        value: function () {
          var e,
              t = this.props.includeStatusFilter,
              r = {
            cropFilters: this.cropsSelectorModel.selectedKeys,
            productFilters: this.productsSelectorModel.selectedKeys,
            targetFilters: this.targetsSelectorModel.selectedKeys,
            fieldFilters: this.fieldsSelectorModel.selectedKeys,
            varietyFilters: this.varietiesSelectorModel.selectedKeys,
            organicFilter: (null === (e = this.organicSelectorModel.selectedOption) || void 0 === e ? void 0 : e.text) || "",
            dateRange: {
              selectedOption: this.dateSelectorModel.selector.selectedOption
            }
          };
          this.dateSelectorModel.customSelected && (r.dateRange = hg(hg({}, this.dateSelectorModel.dateRange), {}, {
            selectedOption: this.dateSelectorModel.selector.selectedOption
          })), t && (r.statusFilters = this.statusSelectorModel.selectedKeys), window.localStorage.setItem(this.storageName, JSON.stringify(r));
        }
      }, {
        key: "restoreLocalStorage",
        value: (n = jg(wg().mark(function e() {
          var t, r, n, o, i;
          return wg().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return r = this.props.includeStatusFilter, n = window.localStorage.getItem(this.storageName), e.next = 4, this.whenAllSelectorModelsReady();

              case 4:
                if (this.setDefaultFilters(), n) {
                  e.next = 7;
                  break;
                }

                return e.abrupt("return");

              case 7:
                return o = JSON.parse(n), e.next = 10, this.whenFetchingOptionsIsFinished();

              case 10:
                this.restoreFilter({
                  filters: null == o ? void 0 : o.cropFilters,
                  model: this.cropsSelectorModel,
                  options: this.cropOptions
                }), this.restoreFilter({
                  filters: null == o ? void 0 : o.fieldFilters,
                  model: this.fieldsSelectorModel,
                  options: this.fieldOptions
                }), this.restoreFilter({
                  filters: null == o ? void 0 : o.productFilters,
                  model: this.productsSelectorModel,
                  options: this.productOptions
                }), this.restoreFilter({
                  filters: null == o ? void 0 : o.targetFilters,
                  model: this.targetsSelectorModel,
                  options: this.targetOptions
                }), this.restoreFilter({
                  filters: null == o ? void 0 : o.varietyFilters,
                  model: this.varietiesSelectorModel,
                  options: this.varietyOptions
                }), this.restoreSelectDropdownFilter({
                  value: null == o ? void 0 : o.organicFilter,
                  model: this.organicSelectorModel
                }), null != o && null !== (t = o.dateRange) && void 0 !== t && t.selectedOption && (this.dateSelectorModel.onChangeDateRange(null == o || null === (i = o.dateRange) || void 0 === i ? void 0 : i.selectedOption), this.dateSelectorModel.customSelected && (this.dateSelectorModel.startDate = o.dateRange.start && new Date(o.dateRange.start), this.dateSelectorModel.endDate = o.dateRange.end && new Date(o.dateRange.end))), r && (this.statusSelectorModel.selectedKeys = null == o ? void 0 : o.statusFilters);

              case 18:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function () {
          return n.apply(this, arguments);
        })
      }, {
        key: "restoreFilter",
        value: function (e) {
          var t = e.filters,
              r = e.model,
              n = e.options;

          if (null != t && t.length) {
            var o = n.filter(function (e) {
              return t.includes(e.value);
            });
            return r.selectedKeys = o.map(function (e) {
              return e.value;
            }), r.selectedKeys;
          }
        }
      }, {
        key: "restoreSelectDropdownFilter",
        value: function (e) {
          var t = e.value,
              r = e.model;
          t && r.search(t);
        }
      }, {
        key: "show",
        value: function () {
          return $("#".concat(this.id)).modal("show");
        }
      }, {
        key: "close",
        value: function () {
          $("#".concat(this.id)).modal("hide");
        }
      }, {
        key: "onFilter",
        value: (r = jg(wg().mark(function e(t) {
          var r,
              n,
              o = this;
          return wg().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return r = (t || {}).shouldClose, n = this.props.onFilter, e.prev = 2, e.next = 5, n();

              case 5:
                return e.abrupt("return", this.queryService.runRawQuery());

              case 8:
                e.prev = 8, e.t0 = e.catch(2), console.error(e.t0), Object(f.runInAction)(function () {
                  o.hasError = !0, o.errorText = (null === e.t0 || void 0 === e.t0 ? void 0 : e.t0.message) || e.t0;
                });

              case 12:
                return e.prev = 12, r && this.onClose(), e.finish(12);

              case 15:
              case "end":
                return e.stop();
            }
          }, e, this, [[2, 8, 12, 15]]);
        })), function (e) {
          return r.apply(this, arguments);
        })
      }, {
        key: "resetError",
        value: function () {
          var e = this.props.t;
          this.hasError = !1, this.errorText = e("filters_unexpected_error");
        }
      }]);
      var r, n, o;
    }()).defaultProps = {
      onClose: function () {},
      onClear: function () {},
      onFilter: function () {
        return Promise.resolve();
      },
      initialFilters: null
    }, Kh = Rg((qh = bg).prototype, "cropsSelectorModel", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Gh = Rg(qh.prototype, "fieldsSelectorModel", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Wh = Rg(qh.prototype, "productsSelectorModel", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Hh = Rg(qh.prototype, "statusSelectorModel", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Jh = Rg(qh.prototype, "targetsSelectorModel", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Yh = Rg(qh.prototype, "varietiesSelectorModel", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Qh = Rg(qh.prototype, "organicSelectorModel", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), $h = Rg(qh.prototype, "restoreLocalStoragePromise", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Xh = Rg(qh.prototype, "filterIsPending", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Zh = Rg(qh.prototype, "clearIsPending", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), eg = Rg(qh.prototype, "hasError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), tg = Rg(qh.prototype, "errorText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Rg(qh.prototype, "cropOptions", [f.computed], Object.getOwnPropertyDescriptor(qh.prototype, "cropOptions"), qh.prototype), Rg(qh.prototype, "fieldLabelId", [f.computed], Object.getOwnPropertyDescriptor(qh.prototype, "fieldLabelId"), qh.prototype), Rg(qh.prototype, "fieldOptions", [f.computed], Object.getOwnPropertyDescriptor(qh.prototype, "fieldOptions"), qh.prototype), Rg(qh.prototype, "productOptions", [f.computed], Object.getOwnPropertyDescriptor(qh.prototype, "productOptions"), qh.prototype), Rg(qh.prototype, "statusLabelId", [f.computed], Object.getOwnPropertyDescriptor(qh.prototype, "statusLabelId"), qh.prototype), Rg(qh.prototype, "statusOptions", [f.computed], Object.getOwnPropertyDescriptor(qh.prototype, "statusOptions"), qh.prototype), Rg(qh.prototype, "targetOptions", [f.computed], Object.getOwnPropertyDescriptor(qh.prototype, "targetOptions"), qh.prototype), Rg(qh.prototype, "varietyOptions", [f.computed], Object.getOwnPropertyDescriptor(qh.prototype, "varietyOptions"), qh.prototype), Rg(qh.prototype, "organicSelectorOptions", [f.computed], Object.getOwnPropertyDescriptor(qh.prototype, "organicSelectorOptions"), qh.prototype), Rg(qh.prototype, "badgeContent", [f.computed], Object.getOwnPropertyDescriptor(qh.prototype, "badgeContent"), qh.prototype), Rg(qh.prototype, "onMount", [f.action], Object.getOwnPropertyDescriptor(qh.prototype, "onMount"), qh.prototype), Rg(qh.prototype, "restoreLocalStorage", [f.action], Object.getOwnPropertyDescriptor(qh.prototype, "restoreLocalStorage"), qh.prototype), Rg(qh.prototype, "restoreFilter", [f.action], Object.getOwnPropertyDescriptor(qh.prototype, "restoreFilter"), qh.prototype), Rg(qh.prototype, "restoreSelectDropdownFilter", [f.action], Object.getOwnPropertyDescriptor(qh.prototype, "restoreSelectDropdownFilter"), qh.prototype), rg = Rg(qh.prototype, "clearAllFilters", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.includeStatusFilter;
          return e.cropsSelectorModel && e.cropsSelectorModel.clearSelection(), e.fieldsSelectorModel && e.fieldsSelectorModel.clearSelection(), e.productsSelectorModel && e.productsSelectorModel.clearSelection(), e.statusSelectorModel && t && e.statusSelectorModel.clearSelection(), e.targetsSelectorModel && e.targetsSelectorModel.clearSelection(), e.varietiesSelectorModel && e.varietiesSelectorModel.clearSelection(), e.organicSelectorModel && e.organicSelectorModel.reset(), e.dateSelectorModel.clearFilters(), e.publishFilterChanges(), e.clearIsPending = !0, e.saveLocalStorage(), e.resetError(), e.onFilter().finally(Object(f.runInAction)(function () {
            e.clearIsPending = !1;
          }));
        };
      }
    }), ng = Rg(qh.prototype, "onClickFilterButton", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return t.preventDefault(), e.saveLocalStorage(), e.publishFilterChanges(), e.filterIsPending = !0, e.resetError(), e.onFilter({
            shouldClose: !0
          }).finally(Object(f.runInAction)(function () {
            e.filterIsPending = !1;
          }));
        };
      }
    }), og = Rg(qh.prototype, "onClose", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          return (0, e.props.onClose)(), e.close();
        };
      }
    }), ig = Rg(qh.prototype, "onClear", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onClear;
          return t && t.preventDefault(), r(), e.clearAllFilters();
        };
      }
    }), Rg(qh.prototype, "onFilter", [f.action], Object.getOwnPropertyDescriptor(qh.prototype, "onFilter"), qh.prototype), ag = Rg(qh.prototype, "publishFilterChanges", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t,
              r,
              n = e.props.includeStatusFilter;
          e.queryService.changeCropFilter(e.cropsSelectorModel.selectedKeys), e.queryService.changeFieldFilter(e.fieldsSelectorModel.selectedKeys), e.queryService.changeProductFilter(e.productsSelectorModel.selectedKeys), e.queryService.changeTargetFilter(e.targetsSelectorModel.selectedKeys), e.queryService.changeVarietyFilter(e.varietiesSelectorModel.selectedKeys), e.queryService.changeOrganicFilter([].concat(null !== (t = null === (r = e.organicSelectorModel.selectedOption) || void 0 === r ? void 0 : r.value) && void 0 !== t ? t : [])), e.queryService.changeDateRangeFilter(e.dateSelectorModel.dateRange), n && e.queryService.changeStatusFilter(e.statusSelectorModel.selectedKeys);
        };
      }
    }), cg = Rg(qh.prototype, "registerCropsSelectorModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.cropsSelectorModel = t;
        };
      }
    }), ug = Rg(qh.prototype, "registerFieldsSelectorModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.fieldsSelectorModel = t;
        };
      }
    }), lg = Rg(qh.prototype, "registerProductsSelectorModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.productsSelectorModel = t;
        };
      }
    }), sg = Rg(qh.prototype, "registerStatusSelectorModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.statusSelectorModel = t;
        };
      }
    }), pg = Rg(qh.prototype, "registerTargetsSelectorModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.targetsSelectorModel = t;
        };
      }
    }), fg = Rg(qh.prototype, "registerVarietiesSelectorModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.varietiesSelectorModel = t;
        };
      }
    }), dg = Rg(qh.prototype, "registerOrganicSelectorModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.organicSelectorModel = t;
        };
      }
    }), Rg(qh.prototype, "resetError", [f.action], Object.getOwnPropertyDescriptor(qh.prototype, "resetError"), qh.prototype), qh);

    function Dg(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, xg(n.key), n);
      }
    }

    function xg(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Ag(e, t, r) {
      return t = Mg(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Mg(e).constructor) : t.apply(e, r));
    }

    function Mg(e) {
      return (Mg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Ig(e, t) {
      return (Ig = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Fg,
        Bg,
        Lg,
        Vg,
        Ug,
        qg = Object(d.inject)("configuration")(Tg = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((zg = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = Ag(this, t, [e])).defaultModel = new Ng(r.props), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ig(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Dg(e.prototype, t), r && Dg(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "model",
        get: function () {
          return this.props.model || this.defaultModel;
        }
      }, {
        key: "componentDidMount",
        value: function () {
          this.model.onMount();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.disableAnimation,
              r = e.t,
              n = this.model.props,
              o = n.id,
              i = n.title,
              a = this.model.queryService,
              c = a.cropsIsPending,
              u = a.fieldsIsPending,
              l = a.productsIsPending,
              s = a.targetsIsPending,
              f = a.varietiesIsPending;
          return p.a.createElement(h.ModalDialog, {
            id: o,
            dismissOnClose: !1,
            className: "if2-modal filter-modal",
            dialogClassNames: "modal-md",
            disableAnimation: t
          }, p.a.createElement(h.ModalHeader, {
            title: i || r("filters"),
            onClose: this.model.onClose,
            dismissOnClose: !1
          }), p.a.createElement(h.ModalBody, null, p.a.createElement("div", {
            className: "col pt-4 px-1"
          }, p.a.createElement("div", {
            className: "form-group mb-2"
          }, this.model.hasError ? p.a.createElement("p", {
            className: "feedback-text text-danger"
          }, this.model.errorText) : null, p.a.createElement("label", {
            id: this.model.fieldLabelId,
            className: "mb-1 text-uppercase font-weight-bold small"
          }, r("field")), p.a.createElement(h.MultiSelectDropdown, {
            labelledBy: this.model.fieldLabelId,
            className: "filter-selector",
            placeholder: r("select_fields"),
            isLoadingOptions: u,
            options: this.model.fieldOptions,
            onRegisterModel: this.model.registerFieldsSelectorModel,
            showFilterBadge: !0
          })), p.a.createElement("div", {
            className: "form-group mb-2"
          }, p.a.createElement("label", {
            className: "mb-1 text-uppercase font-weight-bold small"
          }, r("crop")), p.a.createElement(h.MultiSelectDropdown, {
            className: "filter-selector",
            placeholder: r("select_crops"),
            isLoadingOptions: c,
            options: this.model.cropOptions,
            onRegisterModel: this.model.registerCropsSelectorModel,
            showFilterBadge: !0
          })), p.a.createElement("div", {
            className: "form-group mb-2"
          }, p.a.createElement("label", {
            className: "mb-1 text-uppercase font-weight-bold small"
          }, r("variety")), p.a.createElement(h.MultiSelectDropdown, {
            className: "filter-selector",
            placeholder: r("select_variety"),
            isLoadingOptions: f,
            options: this.model.varietyOptions,
            onRegisterModel: this.model.registerVarietiesSelectorModel,
            showFilterBadge: !0
          })), p.a.createElement("div", {
            className: "form-group mb-2"
          }, p.a.createElement("label", {
            className: "mb-1 text-uppercase font-weight-bold small"
          }, r("product")), p.a.createElement(h.MultiSelectDropdown, {
            className: "filter-selector",
            placeholder: r("select_products"),
            isLoadingOptions: l,
            options: this.model.productOptions,
            onRegisterModel: this.model.registerProductsSelectorModel,
            showFilterBadge: !0
          })), p.a.createElement("div", {
            className: "form-group mb-2"
          }, p.a.createElement("label", {
            className: "mb-1 text-uppercase font-weight-bold small"
          }, r("target")), p.a.createElement(h.MultiSelectDropdown, {
            className: "filter-selector",
            placeholder: r("select_targets"),
            isLoadingOptions: s,
            options: this.model.targetOptions,
            onRegisterModel: this.model.registerTargetsSelectorModel,
            showFilterBadge: !0
          })), this.model.props.includeStatusFilter ? p.a.createElement("div", {
            className: "form-group mb-2"
          }, p.a.createElement("label", {
            id: this.model.statusLabelId,
            className: "mb-1 text-uppercase font-weight-bold small"
          }, r("status")), p.a.createElement(h.MultiSelectDropdown, {
            labelledBy: this.model.statusLabelId,
            className: "filter-selector",
            placeholder: r("select_status"),
            options: this.model.statusOptions,
            onRegisterModel: this.model.registerStatusSelectorModel,
            showFilterBadge: !0
          })) : null, p.a.createElement("div", {
            className: "form-group mb-2"
          }, p.a.createElement("label", {
            className: "mb-1 text-uppercase font-weight-bold small"
          }, r("organic")), p.a.createElement(h.SelectDropdown, {
            className: "filter-selector",
            placeholder: r("select_organic_or_conventional"),
            options: this.model.organicSelectorOptions,
            onRegisterModel: this.model.registerOrganicSelectorModel,
            showFilterBadge: !0
          })), p.a.createElement("div", {
            className: "form-group mb-2"
          }, p.a.createElement("label", {
            className: "mb-1 text-uppercase font-weight-bold small"
          }, r("date_range")), p.a.createElement(mg, {
            model: this.model.dateSelectorModel
          })), p.a.createElement("div", {
            className: "my-3"
          }, p.a.createElement("div", {
            className: "form-group mb-2"
          }, p.a.createElement("button", {
            type: "button",
            disabled: this.model.filterIsPending,
            className: "btn btn-primary font-weight-bold text-uppercase",
            "aria-label": "Filter Button",
            onClick: this.model.onClickFilterButton
          }, this.model.filterIsPending ? p.a.createElement("div", {
            className: "filter-spinner"
          }, p.a.createElement(h.Spinner, null)) : null, r("filter"))), p.a.createElement("div", {
            className: "form-group mb-2"
          }, p.a.createElement("button", {
            type: "button",
            disabled: this.model.clearIsPending,
            className: "btn btn-secondary font-weight-bold text-uppercase",
            "aria-label": "Clear All Filters Button",
            onClick: this.model.clearAllFilters
          }, this.model.clearIsPending ? p.a.createElement("div", {
            className: "filter-spinner"
          }, p.a.createElement(h.Spinner, null)) : null, r("clear_filters"))), p.a.createElement("div", {
            className: "form-group mb-2"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-outline-secondary font-weight-bold text-uppercase",
            "aria-label": "Cancel Button",
            onClick: this.model.onClose
          }, r("close")))))));
        }
      }]);
    }()).prototype, "model", [f.computed], Object.getOwnPropertyDescriptor(zg.prototype, "model"), zg.prototype), Tg = zg)) || Tg) || Tg,
        Kg = Object(g.a)()(qg);

    function Gg(e) {
      return function (e) {
        if (Array.isArray(e)) return Wg(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return Wg(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Wg(e, t) : void 0;
        }
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Wg(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function Hg(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Jg(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Yg(n.key), n);
      }
    }

    function Yg(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Qg(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var $g,
        Xg,
        Zg,
        ew,
        tw = (Bg = Qg((Fg = function () {
      return e = function e(t, r) {
        var n = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Hg(this, "visible", Bg, this), Hg(this, "priceObj", Lg, this), this.priceMemento = void 0, this.quantityMemento = void 0, Hg(this, "toggleVisibleStatus", Vg, this), this.saveMemento = function () {
          n.priceMemento = n.priceObj.price, n.quantityMemento = {
            scalar: n.priceObj.quantity.scalar,
            units: n.priceObj.quantity.units
          };
        }, Hg(this, "restoreMemento", Ug, this), this.id = r.id, this.parentId = t.id, this.fields = t.fields, this.sprayRate = this.calculatedSprayRate(t), null === this.sprayRate && console.log("Can't calculate spray rate: ".concat(t.serial)), this.product = r.product, this.rate = new w.Quantity(r.rate), this.target = r.target, this.targetCoveragePercentage = t.targetCoveragePercentage || 100, this.date = t.abbreviatedDateTitle, this.record = t, this.app = r;
      }, (t = [{
        key: "targetCoverageDecimal",
        get: function () {
          return this.targetCoveragePercentage / 100;
        }
      }, {
        key: "pricePerAcre",
        get: function () {
          var e,
              t = this.rate;
          if (this.shouldCalculateSprayRate && (t = t.mul(this.sprayRate)), this.priceObj.price) try {
            e = new w.Quantity(this.priceObj.price).div(this.priceObj.quantity).mul(t).mul(this.targetCoverageDecimal).to("1/acre");
          } catch (e) {
            if (console.error(e), "QtyError" !== e.name) throw e;
          }
          return w.Quantity.isQuantityTruthy(e) && e;
        }
      }, {
        key: "isPriceEstimated",
        get: function () {
          var e;
          return null === (e = this.priceObj) || void 0 === e ? void 0 : e.estimated;
        }
      }, {
        key: "_exceptionalIcons",
        get: function () {
          var e = "";
          return this.isPriceEstimated && (e += "†"), e.length > 0 && (e = " ".concat(e)), e;
        }
      }, {
        key: "crops",
        get: function () {
          return this.fields.map(function (e) {
            return e.crop.name;
          });
        }
      }, {
        key: "cropsSet",
        get: function () {
          return Gg(new Set(this.crops));
        }
      }, {
        key: "shouldCalculateSprayRate",
        get: function () {
          var e = new w.Quantity("1 acre");
          return !("density" !== this.rate.kind() && "area" !== this.rate.mul(e).kind() || !this.sprayRate);
        }
      }, {
        key: "priceDisplayValue",
        get: function () {
          return "" === this.priceObj.price ? "N/A" : "$".concat(this.priceObj.priceFormatted, "/").concat(this.priceObj.quantity.displayValue);
        }
      }, {
        key: "pricePerAcreDisplayValue",
        get: function () {
          return this.pricePerAcre ? "$".concat(this.pricePerAcre.format({
            fixed: !0,
            digits: 2,
            formatUnits: !0
          })).concat(this._exceptionalIcons) : "N/A";
        }
      }, {
        key: "csvDataOrder",
        get: function () {
          var e, t, r;
          return [this.date, this.record.name || this.record.applicationMethod, this.cropsSet, null === (e = this.product) || void 0 === e ? void 0 : e.name, null === (t = this.rate) || void 0 === t ? void 0 : t.displayValue, this.target, this.targetCoveragePercentage, null === (r = this.priceObj) || void 0 === r ? void 0 : r.category, this.priceDisplayValue, this.pricePerAcreDisplayValue];
        }
      }, {
        key: "setupPriceObj",
        value: function (e) {
          var t,
              r = this;
          e.forEach(function (e) {
            e.product.serial === r.product.serial && (e.product = r.product, t = Rr.fromJS(e));
          }), void 0 === t && (t = Rr.fromJS({
            product: this.product
          })), this.priceObj = t;
        }
      }, {
        key: "calculatedSprayRate",
        value: function (e) {
          if (e.targetGallonsPerAcre) return new w.Quantity("".concat(e.targetGallonsPerAcre, " gal/acre"));
          var t = null,
              r = 0;
          return (e.applications || []).forEach(function (e) {
            (e.applicators || []).forEach(function (e) {
              e.sprayRate && e.sprayRate.length > 0 && (t = t ? t.add(e.sprayRate) : new w.Quantity(e.sprayRate), r += 1);
            });
          }), 0 === r ? null : t.div(r);
        }
      }]) && Jg(e.prototype, t), r && Jg(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "visible", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Lg = Qg(Fg.prototype, "priceObj", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Qg(Fg.prototype, "targetCoverageDecimal", [f.computed], Object.getOwnPropertyDescriptor(Fg.prototype, "targetCoverageDecimal"), Fg.prototype), Qg(Fg.prototype, "pricePerAcre", [f.computed], Object.getOwnPropertyDescriptor(Fg.prototype, "pricePerAcre"), Fg.prototype), Qg(Fg.prototype, "isPriceEstimated", [f.computed], Object.getOwnPropertyDescriptor(Fg.prototype, "isPriceEstimated"), Fg.prototype), Qg(Fg.prototype, "_exceptionalIcons", [f.computed], Object.getOwnPropertyDescriptor(Fg.prototype, "_exceptionalIcons"), Fg.prototype), Qg(Fg.prototype, "crops", [f.computed], Object.getOwnPropertyDescriptor(Fg.prototype, "crops"), Fg.prototype), Qg(Fg.prototype, "cropsSet", [f.computed], Object.getOwnPropertyDescriptor(Fg.prototype, "cropsSet"), Fg.prototype), Qg(Fg.prototype, "shouldCalculateSprayRate", [f.computed], Object.getOwnPropertyDescriptor(Fg.prototype, "shouldCalculateSprayRate"), Fg.prototype), Qg(Fg.prototype, "priceDisplayValue", [f.computed], Object.getOwnPropertyDescriptor(Fg.prototype, "priceDisplayValue"), Fg.prototype), Qg(Fg.prototype, "pricePerAcreDisplayValue", [f.computed], Object.getOwnPropertyDescriptor(Fg.prototype, "pricePerAcreDisplayValue"), Fg.prototype), Qg(Fg.prototype, "csvDataOrder", [f.computed], Object.getOwnPropertyDescriptor(Fg.prototype, "csvDataOrder"), Fg.prototype), Qg(Fg.prototype, "setupPriceObj", [f.action], Object.getOwnPropertyDescriptor(Fg.prototype, "setupPriceObj"), Fg.prototype), Vg = Qg(Fg.prototype, "toggleVisibleStatus", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.visible = !e.visible;
        };
      }
    }), Ug = Qg(Fg.prototype, "restoreMemento", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.priceObj.price = e.priceMemento, e.priceObj.quantity.scalar = e.quantityMemento.scalar, e.priceObj.quantity.units = e.quantityMemento.units;
        };
      }
    }), Fg);

    function rw(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function nw(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ow(n.key), n);
      }
    }

    function ow(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function iw(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var aw = (Xg = iw(($g = function () {
      return e = function e(t, r, n, o) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), rw(this, "record", Xg, this), rw(this, "productFilters", Zg, this), rw(this, "targetFilters", ew, this), this.prices = void 0, this.record = t, this.productFilters = r, this.targetFilters = n, this.prices = o;
      }, (t = [{
        key: "filteredProductApplications",
        get: function () {
          var e = this,
              t = this.record.productApplications;
          return this.productFilters.length > 0 && (t = this.record.productApplications.filter(function (t) {
            return e.productFilters.includes(t.product.id);
          })), this.targetFilters.length > 0 && (t = this.record.productApplications.filter(function (t) {
            return e.targetFilters.map(function (e) {
              return e.toLowerCase();
            }).includes(t.target.toLowerCase());
          })), t;
        }
      }, {
        key: "dataRowModels",
        get: function () {
          var e = this;
          return this.filteredProductApplications.map(function (t) {
            var r = new tw(e.record, t);
            return r.setupPriceObj(e.prices), r;
          });
        }
      }, {
        key: "isPriceIncomplete",
        get: function () {
          return this.dataRowModels.some(function (e) {
            return !e.pricePerAcre;
          });
        }
      }, {
        key: "isPriceEstimated",
        get: function () {
          return this.dataRowModels.some(function (e) {
            return e.isPriceEstimated;
          });
        }
      }, {
        key: "totalPricePerAcre",
        get: function () {
          return this.dataRowModels.reduce(function (e, t) {
            return e + (t.pricePerAcre ? parseFloat(t.pricePerAcre.scalar) : 0);
          }, 0);
        }
      }, {
        key: "totalPricePerAcreFormatted",
        get: function () {
          return "$".concat(this.totalPricePerAcre.toFixed(2), " /acre");
        }
      }]) && nw(e.prototype, t), r && nw(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "record", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Zg = iw($g.prototype, "productFilters", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), ew = iw($g.prototype, "targetFilters", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), iw($g.prototype, "filteredProductApplications", [f.computed], Object.getOwnPropertyDescriptor($g.prototype, "filteredProductApplications"), $g.prototype), iw($g.prototype, "dataRowModels", [f.computed], Object.getOwnPropertyDescriptor($g.prototype, "dataRowModels"), $g.prototype), iw($g.prototype, "isPriceIncomplete", [f.computed], Object.getOwnPropertyDescriptor($g.prototype, "isPriceIncomplete"), $g.prototype), iw($g.prototype, "isPriceEstimated", [f.computed], Object.getOwnPropertyDescriptor($g.prototype, "isPriceEstimated"), $g.prototype), iw($g.prototype, "totalPricePerAcre", [f.computed], Object.getOwnPropertyDescriptor($g.prototype, "totalPricePerAcre"), $g.prototype), iw($g.prototype, "totalPricePerAcreFormatted", [f.computed], Object.getOwnPropertyDescriptor($g.prototype, "totalPricePerAcreFormatted"), $g.prototype), $g);

    function cw(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, uw(n.key), n);
      }
    }

    function uw(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var lw,
        sw,
        pw = function () {
      return e = function e(t) {
        var r = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.downloadCSV = function (e) {
          return Z(r.toStringCSV(e), r.downCaseTitle(), "text/csv");
        }, this.title = "".concat((null == t ? void 0 : t.title) || "Block Accounting Report", ".csv"), this.t = null == t ? void 0 : t.t;
      }, r = [{
        key: "buildHeader",
        value: function (e) {
          var t = this;
          return e.map(function (e) {
            return t.quoteWrap(e);
          }).join(",");
        }
      }, {
        key: "buildBody",
        value: function (e, t) {
          var r = this,
              n = [];
          return t.forEach(function (t) {
            t.dataRowModels.forEach(function (e) {
              n.push(r.buildApplicationRow(e));
            }), n.push(r.buildTotal({
              total: t.totalPricePerAcreFormatted,
              numColumns: e
            }));
          }), n.join("\n");
        }
      }, {
        key: "buildApplicationRow",
        value: function (e) {
          var t = this;
          return e.csvDataOrder.map(function (e) {
            return t.quoteWrap(e);
          }).join(",");
        }
      }, {
        key: "buildTotal",
        value: function (e) {
          var t = e.numColumns,
              r = e.label,
              n = void 0 === r ? "Total" : r,
              o = e.total,
              i = "".concat(n, ": ").concat(o),
              a = Array(t - 1).fill(",");
          return i = this.quoteWrap(i), "".concat(a.join("")).concat(i);
        }
      }, {
        key: "quoteWrap",
        value: function (e) {
          return '"'.concat(e, '"');
        }
      }, {
        key: "computeGrandTotal",
        value: function (e) {
          return e.reduce(function (e, t) {
            return e + t.totalPricePerAcre;
          }, 0);
        }
      }], (t = [{
        key: "headers",
        value: function () {
          return [this.t("if2.date"), this.t("title"), this.t("crop"), this.t("product"), this.t("rate"), this.t("target"), this.t("target_coverage_percentage"), this.t("category"), this.t("unit_price"), this.t("price_per_acre")];
        }
      }, {
        key: "downCaseTitle",
        value: function () {
          return this.title.toLowerCase().split(" ").join("_");
        }
      }, {
        key: "toStringCSV",
        value: function (e) {
          return [this.constructor.buildHeader(this.headers()), this.constructor.buildBody(this.headers().length, e), this.constructor.buildTotal({
            label: "Grand Total",
            numColumns: this.headers().length,
            total: this.constructor.computeGrandTotal(e)
          })].join("\n");
        }
      }]) && cw(e.prototype, t), r && cw(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function fw(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, dw(n.key), n);
      }
    }

    function dw(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function bw(e, t, r) {
      return t = yw(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], yw(e).constructor) : t.apply(e, r));
    }

    function yw(e) {
      return (yw = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function mw(e, t) {
      return (mw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function vw(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var hw,
        gw,
        ww = Object(d.observer)((vw((sw = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), bw(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && mw(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && fw(e.prototype, t), r && fw(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "grandTotalFormatted",
        get: function () {
          var e = this.props.grandTotal;
          return "$".concat(e.toFixed(2), " /acre");
        }
      }, {
        key: "_thClass",
        get: function () {
          var e = this.props,
              t = e.isGrandTotalIncomplete,
              r = e.isGrandTotalEstimated,
              n = "text-right";
          return (t || r) && (n += " text-danger"), n;
        }
      }, {
        key: "_exceptionalIcons",
        get: function () {
          var e = this.props,
              t = "";
          return e.isGrandTotalIncomplete && (t += "*"), e.isGrandTotalEstimated && (t += "†"), t.length > 0 && (t += " "), t;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return p.a.createElement("tr", {
            className: "bg-white"
          }, p.a.createElement("td", {
            colSpan: "7"
          }), p.a.createElement("th", {
            className: this._thClass
          }, this._exceptionalIcons, e("grand_total"), " ", this.grandTotalFormatted));
        }
      }]);
    }()).prototype, "grandTotalFormatted", [f.computed], Object.getOwnPropertyDescriptor(sw.prototype, "grandTotalFormatted"), sw.prototype), vw(sw.prototype, "_thClass", [f.computed], Object.getOwnPropertyDescriptor(sw.prototype, "_thClass"), sw.prototype), vw(sw.prototype, "_exceptionalIcons", [f.computed], Object.getOwnPropertyDescriptor(sw.prototype, "_exceptionalIcons"), sw.prototype), lw = sw)) || lw,
        Ow = Object(g.a)()(ww);

    function jw(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Pw(n.key), n);
      }
    }

    function Pw(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function _w(e, t, r) {
      return t = Ew(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Ew(e).constructor) : t.apply(e, r));
    }

    function Ew(e) {
      return (Ew = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Sw(e, t) {
      return (Sw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Cw(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var kw,
        Rw,
        Tw = Object(d.observer)((Cw((gw = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), _w(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Sw(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "_thClass",
        get: function () {
          var e = this.props,
              t = e.isPriceIncomplete,
              r = e.isPriceEstimated,
              n = "text-right";
          return (t || r) && (n += " text-danger"), n;
        }
      }, {
        key: "_exceptionalIcons",
        get: function () {
          var e = this.props,
              t = "";
          return e.isPriceIncomplete && (t += "*"), e.isPriceEstimated && (t += "†"), t.length > 0 && (t += " "), t;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.toggleApplications,
              r = e.record,
              n = e.total,
              o = e.someVisible;
          return p.a.createElement("tr", {
            onClick: function () {
              t(r.id);
            },
            className: "record-title clickable"
          }, p.a.createElement("th", null, p.a.createElement("i", {
            className: "fa fa-caret-".concat(o ? "down" : "right", " mr-3")
          }), r.abbreviatedDateTitle), p.a.createElement("th", {
            colSpan: "6"
          }, p.a.createElement("a", {
            href: "/if2/spray_records/".concat(r.serial),
            className: "unadorned"
          }, r.name ? r.name : r.applicationMethod)), p.a.createElement("th", {
            className: this._thClass
          }, this._exceptionalIcons, "Total: ", n));
        }
      }]) && jw(r.prototype, n), o && jw(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "_thClass", [f.computed], Object.getOwnPropertyDescriptor(gw.prototype, "_thClass"), gw.prototype), Cw(gw.prototype, "_exceptionalIcons", [f.computed], Object.getOwnPropertyDescriptor(gw.prototype, "_exceptionalIcons"), gw.prototype), hw = gw)) || hw;

    function zw(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Nw(n.key), n);
      }
    }

    function Nw(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Dw(e, t, r) {
      return t = xw(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], xw(e).constructor) : t.apply(e, r));
    }

    function xw(e) {
      return (xw = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Aw(e, t) {
      return (Aw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Mw(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Iw,
        Fw = Object(d.observer)((Mw((Rw = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Dw(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Aw(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "_thClass",
        get: function () {
          var e = this.props,
              t = e.isPriceIncomplete,
              r = e.isPriceEstimated,
              n = "text-right";
          return (t || r) && (n += " text-danger"), n;
        }
      }, {
        key: "_exceptionalIcons",
        get: function () {
          var e = this.props,
              t = "";
          return e.isPriceIncomplete && (t += "*"), e.isPriceEstimated && (t += "†"), t.length > 0 && (t += " "), t;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.someVisible,
              r = e.total;
          return p.a.createElement("tr", {
            className: t ? "bg-white" : "d-none"
          }, p.a.createElement("td", {
            colSpan: "7"
          }), p.a.createElement("th", {
            className: this._thClass
          }, this._exceptionalIcons, "Total: ", r));
        }
      }]) && zw(r.prototype, n), o && zw(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "_thClass", [f.computed], Object.getOwnPropertyDescriptor(Rw.prototype, "_thClass"), Rw.prototype), Mw(Rw.prototype, "_exceptionalIcons", [f.computed], Object.getOwnPropertyDescriptor(Rw.prototype, "_exceptionalIcons"), Rw.prototype), kw = Rw)) || kw;

    function Bw(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Lw(n.key), n);
      }
    }

    function Lw(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Vw(e, t, r) {
      return t = Uw(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Uw(e).constructor) : t.apply(e, r));
    }

    function Uw(e) {
      return (Uw = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function qw(e, t) {
      return (qw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Kw,
        Gw,
        Ww,
        Hw = Object(d.observer)(Iw = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Vw(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && qw(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.model,
              r = e.onClickPrice;
          return p.a.createElement("tr", {
            className: "data-row ".concat(t.visible ? "" : "d-none")
          }, p.a.createElement("td", null, p.a.createElement("div", {
            className: "w-100 pl-3"
          }, t.cropsSet)), p.a.createElement("td", null, t && t.product && t.product.name), p.a.createElement("td", null, t.rate.displayValue, " ", t.shouldIncludeSprayRate ? "@ ".concat(t.sprayRate, " GPA") : ""), p.a.createElement("td", null, t.target), p.a.createElement("td", null, t.targetCoveragePercentage), p.a.createElement("td", null, t.priceObj.category), p.a.createElement("td", {
            className: "text-right"
          }, p.a.createElement("span", {
            role: "none",
            className: "clickable ".concat("" === t.priceObj.price ? "price-link" : "unadorned"),
            onClick: function () {
              t.saveMemento(), r(t.priceObj);
            }
          }, t.pricePerAcreDisplayValue)), p.a.createElement("td", {
            className: "text-right"
          }, t.pricePerAcreDisplayValue));
        }
      }]) && Bw(r.prototype, n), o && Bw(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || Iw;

    function Jw(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Yw(n.key), n);
      }
    }

    function Yw(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Qw(e, t, r) {
      return t = $w(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], $w(e).constructor) : t.apply(e, r));
    }

    function $w(e) {
      return ($w = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Xw(e, t) {
      return (Xw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Zw(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var eO,
        tO,
        rO,
        nO,
        oO,
        iO,
        aO = Object(d.observer)((Zw((Gw = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = Qw(this, t, [].concat(n)), "toggleApplications", Ww, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Xw(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "someVisible",
        get: function () {
          return this.props.group.dataRowModels.some(function (e) {
            return e.visible;
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.group,
              r = e.prices,
              n = e.onClickPrice;
          return p.a.createElement("tbody", null, p.a.createElement(Tw, {
            toggleApplications: this.toggleApplications,
            record: t.record,
            isPriceIncomplete: t.isPriceIncomplete,
            isPriceEstimated: t.isPriceEstimated,
            total: t.totalPricePerAcreFormatted,
            someVisible: this.someVisible
          }), t.dataRowModels.map(function (e) {
            return p.a.createElement(Hw, {
              key: e.id,
              model: e,
              record: t.record,
              prices: r,
              onClickPrice: n
            });
          }), p.a.createElement(Fw, {
            someVisible: this.someVisible,
            isPriceIncomplete: t.isPriceIncomplete,
            isPriceEstimated: t.isPriceEstimated,
            total: t.totalPricePerAcreFormatted
          }));
        }
      }]) && Jw(r.prototype, n), o && Jw(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "someVisible", [f.computed], Object.getOwnPropertyDescriptor(Gw.prototype, "someVisible"), Gw.prototype), Ww = Zw(Gw.prototype, "toggleApplications", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.group.dataRowModels.forEach(function (e) {
            e.parentId === t && e.toggleVisibleStatus();
          });
        };
      }
    }), Kw = Gw)) || Kw;

    function cO(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function uO(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, lO(n.key), n);
      }
    }

    function lO(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function sO(e, t, r) {
      return t = pO(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], pO(e).constructor) : t.apply(e, r));
    }

    function pO(e) {
      return (pO = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function fO(e, t) {
      return (fO = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function dO(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var bO = Object(d.observer)((rO = dO((tO = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), cO(r = sO(this, t, [e]), "productPriceToEdit", rO, r), cO(r, "updatePricesLocally", nO, r), cO(r, "onClickPrice", oO, r), cO(r, "onClosePriceModal", iO, r), r.productPriceToEdit = {
          product: new _r()
        }, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && fO(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && uO(e.prototype, t), r && uO(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "grandTotal",
        get: function () {
          var e = this.props.sprayRecordsList;
          return e ? e.reduce(function (e, t) {
            return e + t.totalPricePerAcre;
          }, 0) : null;
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.account,
              n = t.sprayRecordsList,
              o = t.authenticityToken,
              i = t.isGrandTotalIncomplete,
              a = t.isGrandTotalEstimated,
              c = t.canEditEstimatedPrices,
              u = t.t;
          return p.a.createElement("div", {
            className: "block-accounting-dashboard"
          }, p.a.createElement(Zu, {
            productPrice: this.productPriceToEdit,
            account: r,
            authenticityToken: o,
            callback: this.updatePricesLocally,
            canEditEstimatedPrices: c
          }), p.a.createElement("table", {
            className: "table table-striped"
          }, p.a.createElement("thead", null, p.a.createElement("tr", {
            className: "table-header"
          }, p.a.createElement("th", null, p.a.createElement("div", {
            className: "w-100 pl-3"
          }, u("crop"))), p.a.createElement("th", null, u("product")), p.a.createElement("th", null, u("rate")), p.a.createElement("th", null, u("target")), p.a.createElement("th", null, u("target_coverage_percentage")), p.a.createElement("th", null, u("category")), p.a.createElement("th", {
            className: "text-right"
          }, u("unit_price")), p.a.createElement("th", {
            className: "text-right"
          }, u("price_per_acre")))), n.map(function (t) {
            return p.a.createElement(aO, {
              key: t.record.id,
              group: t,
              prices: e.prices,
              onClickPrice: e.onClickPrice
            });
          }), p.a.createElement("tbody", null, p.a.createElement(Ow, {
            isGrandTotalIncomplete: i,
            isGrandTotalEstimated: a,
            grandTotal: this.grandTotal
          }))));
        }
      }]);
    }()).prototype, "productPriceToEdit", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), dO(tO.prototype, "grandTotal", [f.computed], Object.getOwnPropertyDescriptor(tO.prototype, "grandTotal"), tO.prototype), nO = dO(tO.prototype, "updatePricesLocally", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.sprayRecordsList.forEach(function (e) {
            e.dataRowModels.forEach(function (e) {
              e.product.id === t.product.id && (e.priceObj = t);
            });
          });
        };
      }
    }), oO = dO(tO.prototype, "onClickPrice", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.productPriceToEdit = t, v()("#price-editor-modal").modal();
        };
      }
    }), iO = dO(tO.prototype, "onClosePriceModal", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return function () {
          v()("#price-editor-modal").modal("hide");
        };
      }
    }), eO = tO)) || eO,
        yO = Object(g.a)()(bO),
        mO = ["configuration"];

    function vO(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, hO(n.key), n);
      }
    }

    function hO(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function gO(e, t, r) {
      return t = wO(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], wO(e).constructor) : t.apply(e, r));
    }

    function wO(e) {
      return (wO = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function OO(e, t) {
      return (OO = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var jO = function (e) {
      return function (t) {
        function r(e) {
          var t;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r);
          var n = (t = gO(this, r, [e])).props.configuration;
          return t.configuration = n, t;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && OO(e, t);
        }(r, s["Component"]), n = r, (o = [{
          key: "render",
          value: function () {
            var t = this.props,
                r = (t.configuration, function (e, t) {
              if (null == e) return {};

              var r,
                  n,
                  o = function (e, t) {
                if (null == e) return {};
                var r = {};

                for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
                  if (t.includes(n)) continue;
                  r[n] = e[n];
                }

                return r;
              }(e, t);

              if (Object.getOwnPropertySymbols) {
                var i = Object.getOwnPropertySymbols(e);

                for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
              }

              return o;
            }(t, mO));
            return p.a.createElement(d.Provider, {
              configuration: this.configuration
            }, p.a.createElement(e, r));
          }
        }]) && vO(n.prototype, o), i && vO(n, i), Object.defineProperty(n, "prototype", {
          writable: !1
        }), n;
        var n, o, i;
      }();
    },
        PO = r(198);

    function _O(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, EO(n.key), n);
      }
    }

    function EO(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function SO(e, t, r) {
      return t = CO(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], CO(e).constructor) : t.apply(e, r));
    }

    function CO(e) {
      return (CO = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function kO(e, t) {
      return (kO = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var RO,
        TO,
        zO,
        NO,
        DO,
        xO,
        AO,
        MO,
        IO,
        FO,
        BO,
        LO,
        VO,
        UO = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), SO(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && kO(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.icon,
              r = e.color,
              n = e.type,
              o = e.title,
              i = e.colorClass,
              a = e.children;
          return s.createElement("div", {
            className: "title-icon-container"
          }, s.createElement(PO.ReactSVG, {
            src: t,
            className: "title-icon ".concat(i),
            style: {
              color: r
            }
          }), s.createElement("div", null, s.createElement("div", {
            className: "title-type ".concat(i),
            style: {
              color: r
            }
          }, n), o ? s.createElement("h1", null, s.createElement("span", null, o)) : s.createElement("div", null, " ", a, " ")));
        }
      }]) && _O(r.prototype, n), o && _O(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function qO(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function KO(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? qO(Object(r), !0).forEach(function (t) {
          GO(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : qO(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function GO(e, t, r) {
      return (t = JO(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function WO(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function HO(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, JO(n.key), n);
      }
    }

    function JO(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function YO(e, t, r) {
      return t = QO(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], QO(e).constructor) : t.apply(e, r));
    }

    function QO(e) {
      return (QO = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function $O(e, t) {
      return ($O = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function XO(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var ZO = Object(d.inject)("configuration")(RO = Object(d.observer)((zO = XO((TO = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), WO(r = YO(this, t, [e]), "filterModalId", zO, r), r.initialFilters = {
          status: ["complete"]
        }, WO(r, "applications", NO, r), WO(r, "prices", DO, r), r.downloadCSV = function () {
          r.downloadManager.downloadCSV(r.sprayRecordsList);
        }, r.getPrices = function () {
          var e = r.props.account;
          Rr.getPrices(e.serial).then(function (e) {
            return r.fillPrices(e), Promise.resolve();
          }).catch(function (e) {
            console.error(e);
          });
        }, WO(r, "fillPrices", xO, r), WO(r, "onChangeProduct", AO, r), WO(r, "onChangeTarget", MO, r), WO(r, "onClickFilterFlag", IO, r), WO(r, "onFilter", FO, r), WO(r, "goToPage", BO, r), WO(r, "expandAll", LO, r), WO(r, "collapseAll", VO, r);
        var n = r.props,
            o = n.accountIds,
            i = n.sprayRecordsApi,
            a = n.sprayRecordsStore,
            c = n.sprayRecordsBasePath,
            u = n.accountsPath,
            l = n.account,
            s = n.t,
            p = n.configuration;
        return r.getPrices(), r.sprayRecordsApi = i || new Gy(c, u), r.sprayRecordsStore = a || new Fm(r.sprayRecordsApi), r.queryService = new Sh(r.sprayRecordsStore, o || []), r.queryService.clearLimit(), r.filterModalModel = new Ng({
          id: r.filterModalId,
          store: r.sprayRecordsStore,
          queryService: r.queryService,
          onFilter: r.onFilter,
          initialFilters: KO(KO({}, null == p ? void 0 : p.default_filters), r.initialFilters),
          includeStatusFilter: !0,
          storageName: "block-accounting-filters",
          t: s,
          configuration: p
        }), r.downloadManager = new pw({
          title: "".concat(l.name, " Block Accounting Report"),
          t: s
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && $O(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && HO(e.prototype, t), r && HO(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "fieldFilters",
        get: function () {
          return Object(x.uniq)(this.queryService.fieldFilters || []);
        }
      }, {
        key: "newAccountSprayRecordPath",
        get: function () {
          var e = this.props.account;
          return this.sprayRecordsStore.newAccountSprayRecordPath(e.serial);
        }
      }, {
        key: "sprayRecords",
        get: function () {
          return this.queryService.sprayRecords;
        }
      }, {
        key: "locallyCheckedSprayRecords",
        get: function () {
          return this.sprayRecords.filter(function (e) {
            return e.isChecked;
          });
        }
      }, {
        key: "sprayRecordsList",
        get: function () {
          var e = this;
          return this.sprayRecords.filter(function (t) {
            var r = Object(x.filter)(Boolean, Object(x.uniq)(Object(x.flatten)((t.applications || []).map(function (e) {
              return (e.fieldCompletions || []).map(function (e) {
                var t;
                return (null == e || null === (t = e.field) || void 0 === t ? void 0 : t.id) || [];
              });
            }))));
            return Object(x.difference)(r, e.fieldFilters).length < r.length;
          }).map(function (t) {
            return new aw(t, e.queryService.productFilters, e.queryService.targetFilters, e.prices);
          });
        }
      }, {
        key: "isGrandTotalIncomplete",
        get: function () {
          return this.sprayRecordsList.some(function (e) {
            return e.isPriceIncomplete;
          });
        }
      }, {
        key: "isGrandTotalEstimated",
        get: function () {
          return this.sprayRecordsList.some(function (e) {
            return e.isPriceEstimated;
          });
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = this;
          return Object(f.when)(function () {
            return Boolean(e.filterModalModel.restoreLocalStoragePromise);
          }, function () {
            e.filterModalModel.restoreLocalStoragePromise.then(function () {
              if (e.filterModalModel.fieldsSelectorModel.selectedKeys.length) return e.filterModalModel.onFilter();
            }).catch(console.error);
          });
        }
      }, {
        key: "_renderLegend",
        value: function (e) {
          return this.isGrandTotalIncomplete || this.isGrandTotalEstimated ? p.a.createElement("div", {
            className: "text-danger"
          }, this.isGrandTotalIncomplete ? p.a.createElement("div", null, p.a.createElement("em", null, "* ", e("if2.block_accounting.total_may_not_be_correct"))) : null, this.isGrandTotalEstimated ? p.a.createElement("div", null, p.a.createElement("em", null, "† ", e("if2.block_accounting.total_is_estimated"))) : null) : null;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.account,
              r = e.authenticityToken,
              n = e.disableAnimation,
              o = e.canEditEstimatedPrices,
              i = e.t,
              a = e.icon;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement(UO, {
            icon: a,
            colorClass: "block-accounting-color",
            type: i("block_accounting"),
            title: t.name
          }), p.a.createElement("div", {
            "aria-label": "Block Accounting Dashboard",
            className: "block-accounting-dashboard"
          }, p.a.createElement(Kg, {
            disableAnimation: n,
            model: this.filterModalModel
          }), p.a.createElement("div", {
            className: "row no-gutters align-items-center mb-2"
          }, this.queryService.hasFieldFilter ? p.a.createElement(p.a.Fragment, null, p.a.createElement("button", {
            type: "button",
            className: "btn btn-secondary mx-1 my-1",
            onClick: this.expandAll
          }, i("expand_all").toUpperCase()), p.a.createElement("button", {
            type: "button",
            className: "btn btn-outline-secondary mx-1 my-1",
            onClick: this.collapseAll
          }, i("collapse_all").toUpperCase())) : p.a.createElement("p", {
            className: "feedback-text"
          }, i("add_field_filter_to_show_treatment")), p.a.createElement("div", {
            className: "col d-flex justify-content-end"
          }, this.queryService.hasFieldFilter ? p.a.createElement("button", {
            className: "btn btn-primary mr-4",
            type: "button",
            onClick: this.downloadCSV
          }, "Download") : null, p.a.createElement("div", {
            className: "d-flex align-content-center",
            style: {
              height: "2rem",
              width: "2rem"
            }
          }, p.a.createElement(h.FiltersButton, {
            onClick: this.onClickFilterFlag,
            badgeContent: this.filterModalModel.badgeContent
          })))), p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col"
          }, this.queryService.isPending ? p.a.createElement("div", {
            className: "query-spinner"
          }, p.a.createElement(h.Spinner, null)) : null, this.queryService.hasFieldFilter ? p.a.createElement(p.a.Fragment, null, p.a.createElement(yO, {
            sprayRecordsList: this.sprayRecordsList,
            sprayRecordsPath: this.sprayRecordsStore.sprayRecordsBasePath,
            account: t,
            authenticityToken: r,
            isGrandTotalIncomplete: this.isGrandTotalIncomplete,
            isGrandTotalEstimated: this.isGrandTotalEstimated,
            canEditEstimatedPrices: o
          }), this._renderLegend(i)) : null))));
        }
      }]);
    }()).prototype, "filterModalId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "block-accounting-filter-modal";
      }
    }), NO = XO(TO.prototype, "applications", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), DO = XO(TO.prototype, "prices", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), XO(TO.prototype, "fieldFilters", [f.computed], Object.getOwnPropertyDescriptor(TO.prototype, "fieldFilters"), TO.prototype), XO(TO.prototype, "newAccountSprayRecordPath", [f.computed], Object.getOwnPropertyDescriptor(TO.prototype, "newAccountSprayRecordPath"), TO.prototype), XO(TO.prototype, "sprayRecords", [f.computed], Object.getOwnPropertyDescriptor(TO.prototype, "sprayRecords"), TO.prototype), XO(TO.prototype, "locallyCheckedSprayRecords", [f.computed], Object.getOwnPropertyDescriptor(TO.prototype, "locallyCheckedSprayRecords"), TO.prototype), XO(TO.prototype, "sprayRecordsList", [f.computed], Object.getOwnPropertyDescriptor(TO.prototype, "sprayRecordsList"), TO.prototype), XO(TO.prototype, "isGrandTotalIncomplete", [f.computed], Object.getOwnPropertyDescriptor(TO.prototype, "isGrandTotalIncomplete"), TO.prototype), XO(TO.prototype, "isGrandTotalEstimated", [f.computed], Object.getOwnPropertyDescriptor(TO.prototype, "isGrandTotalEstimated"), TO.prototype), xO = XO(TO.prototype, "fillPrices", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.prices = t || [];
        };
      }
    }), AO = XO(TO.prototype, "onChangeProduct", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.productFilters = t, e.queryService.changeProductFilter(t);
        };
      }
    }), MO = XO(TO.prototype, "onChangeTarget", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.targetFilters = t, e.queryService.changeTargetFilter(t);
        };
      }
    }), IO = XO(TO.prototype, "onClickFilterFlag", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.filterModalModel.show();
        };
      }
    }), FO = XO(TO.prototype, "onFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          if (!e.queryService.hasFieldFilter) {
            var t = e.props.t;
            return alert(t("must_include_field_filter")), Promise.reject(new Error(t("must_include_field_filter")));
          }

          return Promise.resolve();
        };
      }
    }), BO = XO(TO.prototype, "goToPage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.queryService.queryPage(t).catch(function (e) {
            console.error(e);
          });
        };
      }
    }), LO = XO(TO.prototype, "expandAll", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.sprayRecordsList.forEach(function (e) {
            e.dataRowModels.forEach(function (e) {
              e.visible = !0;
            });
          });
        };
      }
    }), VO = XO(TO.prototype, "collapseAll", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.sprayRecordsList.forEach(function (e) {
            e.dataRowModels.forEach(function (e) {
              e.visible = !1;
            });
          });
        };
      }
    }), RO = TO)) || RO) || RO,
        ej = jO(Object(g.a)()(ZO)),
        tj = function (e) {
      var t = e.node;
      return Object(d.useObserver)(function () {
        return p.a.createElement(h.TreeNodeCheckbox, Object.assign({
          isCheckedClasses: ["far", "fa-check-square", "fa-sm", "clickable"].concat((r = t, r.isDisabled ? ["disabled"] : [])),
          isUncheckedClasses: ["far", "fa-square", "fa-sm", "clickable"]
        }, e));
        var r;
      });
    },
        rj = ["node", "actions", "treeModel"];

    var nj = function (e) {
      var t = e.node,
          r = e.actions,
          n = e.treeModel,
          o = function (e, t) {
        if (null == e) return {};

        var r,
            n,
            o = function (e, t) {
          if (null == e) return {};
          var r = {};

          for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
            if (t.includes(n)) continue;
            r[n] = e[n];
          }

          return r;
        }(e, t);

        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(e);

          for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
        }

        return o;
      }(e, rj);

      return Object(d.useObserver)(function () {
        var e = n.accountsStore.isPending(t.id) ? [{
          id: "1",
          component: h.Spinner
        }, {
          id: "2",
          component: tj
        }] : [{
          id: "1",
          component: h.TreeNodeToggle
        }, {
          id: "2",
          component: tj
        }];
        return p.a.createElement(h.TreeNodeControls, Object.assign({
          node: t,
          actions: r,
          controls: e,
          treeModel: n
        }, o));
      });
    },
        oj = r(12);

    function ij(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, aj(n.key), n);
      }
    }

    function aj(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function cj(e, t, r) {
      return t = uj(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], uj(e).constructor) : t.apply(e, r));
    }

    function uj(e) {
      return (uj = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function lj(e, t) {
      return (lj = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var sj,
        pj,
        fj,
        dj,
        bj,
        yj,
        mj,
        vj,
        hj,
        gj,
        wj,
        Oj,
        jj,
        Pj,
        _j,
        Ej,
        Sj = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = cj(this, t, [].concat(n))).copyToClipboard = function () {
          var t = e.props.string;
          navigator.clipboard.writeText(t);
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && lj(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.label,
              r = e.className;
          return p.a.createElement("button", {
            className: "btn ".concat(r),
            type: "button",
            onClick: this.copyToClipboard
          }, t);
        }
      }]) && ij(r.prototype, n), o && ij(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }(),
        Cj = r(18),
        kj = r.n(Cj),
        Rj = r(199),
        Tj = r.n(Rj);

    function zj(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Nj(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? zj(Object(r), !0).forEach(function (t) {
          Dj(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zj(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Dj(e, t, r) {
      return (t = Mj(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function xj(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Aj(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Mj(n.key), n);
      }
    }

    function Mj(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Ij(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Fj,
        Bj,
        Lj,
        Vj,
        Uj,
        qj,
        Kj,
        Gj,
        Wj,
        Hj,
        Jj,
        Yj,
        Qj,
        $j,
        Xj,
        Zj,
        eP = (pj = Ij((sj = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), xj(this, "options", pj, this), xj(this, "activeIndex", fj, this), xj(this, "disabledKeys", dj, this), xj(this, "searchText", bj, this), xj(this, "selectedKeys", yj, this), xj(this, "clearSearch", mj, this), xj(this, "clearSelection", vj, this), xj(this, "disable", hj, this), xj(this, "search", gj, this), xj(this, "toggleSelected", wj, this), xj(this, "select", Oj, this), xj(this, "selectByKey", jj, this), xj(this, "selectByOption", Pj, this), xj(this, "toggleByOption", _j, this), xj(this, "toggleByIndex", Ej, this), this.options = t || [];
      }, (t = [{
        key: "lowerCaseSearchText",
        get: function () {
          return this.searchText.toLowerCase();
        }
      }, {
        key: "selectedOptions",
        get: function () {
          var e = this;
          return this.options.filter(function (t) {
            return e.selectedKeys.includes(t.key);
          });
        }
      }, {
        key: "selectedValues",
        get: function () {
          return this.selectedOptions.map(function (e) {
            return e.value;
          });
        }
      }, {
        key: "filteredOptions",
        get: function () {
          var e = this;
          return this.options.filter(function (t) {
            var r = t.searchTokens || [t.text];
            return Tj()(r, function (t) {
              return t.toLowerCase().includes(e.lowerCaseSearchText);
            });
          }).map(function (t, r) {
            return Nj(Nj({}, t), {}, {
              isActive: r === e.activeIndex,
              isDisabled: e.disabledKeys.includes(t.key),
              isSelected: e.selectedKeys.includes(t.key)
            });
          });
        }
      }, {
        key: "activateNext",
        value: function () {
          this.filteredOptions < 1 ? this.activeIndex = "" : 0 !== this.activeIndex && !this.activeIndex || this.activeIndex < 0 ? this.activeIndex = 0 : (this.activeIndex = this.activeIndex + 1, this.activeIndex >= this.filteredOptions.length && (this.activeIndex = 0));
        }
      }, {
        key: "activatePrevious",
        value: function () {
          this.filteredOptions < 1 ? this.activeIndex = "" : this.activeIndex <= 0 || !this.activeIndex || this.activeIndex > this.filteredOptions.length ? this.activeIndex = this.filteredOptions.length - 1 : this.activeIndex = this.activeIndex - 1;
        }
      }, {
        key: "selectActive",
        value: function () {
          this.select(this.activeIndex);
        }
      }, {
        key: "toggleActiveSelected",
        value: function () {
          this.toggleByIndex(this.activeIndex);
        }
      }]) && Aj(e.prototype, t), r && Aj(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "options", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), fj = Ij(sj.prototype, "activeIndex", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), dj = Ij(sj.prototype, "disabledKeys", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), bj = Ij(sj.prototype, "searchText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), yj = Ij(sj.prototype, "selectedKeys", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), Ij(sj.prototype, "lowerCaseSearchText", [f.computed], Object.getOwnPropertyDescriptor(sj.prototype, "lowerCaseSearchText"), sj.prototype), Ij(sj.prototype, "selectedOptions", [f.computed], Object.getOwnPropertyDescriptor(sj.prototype, "selectedOptions"), sj.prototype), Ij(sj.prototype, "selectedValues", [f.computed], Object.getOwnPropertyDescriptor(sj.prototype, "selectedValues"), sj.prototype), Ij(sj.prototype, "filteredOptions", [f.computed], Object.getOwnPropertyDescriptor(sj.prototype, "filteredOptions"), sj.prototype), mj = Ij(sj.prototype, "clearSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.search("");
        };
      }
    }), vj = Ij(sj.prototype, "clearSelection", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.selectedKeys = e.selectedKeys.filter(function (t) {
            return e.disabledKeys.includes(t);
          });
        };
      }
    }), hj = Ij(sj.prototype, "disable", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];

          e.disabledKeys = ee(e.disabledKeys.concat(r));
        };
      }
    }), gj = Ij(sj.prototype, "search", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.searchText = t, e.activeIndex = t ? 0 : "";
        };
      }
    }), wj = Ij(sj.prototype, "toggleSelected", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.selectedKeys.indexOf(t);
          r < 0 ? e.selectedKeys.push(t) : e.selectedKeys.splice(r, 1);
          var n = e.filteredOptions.findIndex(function (e) {
            return e.key === t;
          });
          n < 0 || (e.activeIndex = n);
        };
      }
    }), Oj = Ij(sj.prototype, "select", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.filteredOptions[t];
          r && e.selectByOption(r);
        };
      }
    }), jj = Ij(sj.prototype, "selectByKey", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.filteredOptions.findIndex(function (e) {
            return e.key === t;
          });
          r < 0 || (e.selectedKeys.indexOf(t) < 0 && e.selectedKeys.push(t), e.activeIndex = r);
        };
      }
    }), Pj = Ij(sj.prototype, "selectByOption", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.selectByKey(t.key);
        };
      }
    }), _j = Ij(sj.prototype, "toggleByOption", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.filteredOptions.findIndex(function (e) {
            return e.key === t.key;
          });
          r < 0 || (e.activeIndex = r, e.toggleSelected(t.key));
        };
      }
    }), Ej = Ij(sj.prototype, "toggleByIndex", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.activeIndex = t;
          var r = e.filteredOptions[t];
          r && e.toggleSelected(r.key);
        };
      }
    }), Ij(sj.prototype, "activateNext", [f.action], Object.getOwnPropertyDescriptor(sj.prototype, "activateNext"), sj.prototype), Ij(sj.prototype, "activatePrevious", [f.action], Object.getOwnPropertyDescriptor(sj.prototype, "activatePrevious"), sj.prototype), sj);

    function tP(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function rP(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, nP(n.key), n);
      }
    }

    function nP(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function oP(e, t, r) {
      return t = iP(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], iP(e).constructor) : t.apply(e, r));
    }

    function iP(e) {
      return (iP = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function aP(e, t) {
      return (aP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function cP(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var uP,
        lP,
        sP,
        pP,
        fP,
        dP,
        bP,
        yP,
        mP,
        vP,
        hP,
        gP = Object(d.observer)(((Zj = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = oP(this, t, [e])).id = kj()(), tP(r, "searchText", Lj, r), tP(r, "showDropdown", Vj, r), tP(r, "model", Uj, r), tP(r, "onClickDocument", qj, r), tP(r, "chooseItem", Kj, r), tP(r, "search", Gj, r), tP(r, "clearSearch", Wj, r), tP(r, "onClearAll", Hj, r), tP(r, "onChange", Jj, r), tP(r, "onClose", Yj, r), tP(r, "onFocus", Qj, r), tP(r, "onKeyDown", $j, r), tP(r, "preventDefault", Xj, r), r.selectorRef = Object(s.createRef)(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && aP(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && rP(e.prototype, t), r && rP(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "selectedOptionsText",
        get: function () {
          return this.model.selectedOptions.map(function (e) {
            return e.text;
          }).join(", ");
        }
      }, {
        key: "placeholderText",
        get: function () {
          var e = this.props.placeholder,
              t = this.model.selectedOptions.slice(0, 3);
          if (t.length <= 0) return e;
          var r = this.model.selectedOptions.length;
          return t.map(function (e) {
            return t = e.text, n = r || 7, t.slice(0, n).concat(t.length > n ? "…" : "");
            var t, r, n;
          }).join(", ").concat(r > 3 ? " + ".concat(r - 3, " more") : "");
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = this;
          document.addEventListener("click", this.onClickDocument), this.modelDisposer = Object(f.reaction)(function () {
            return e.props.options;
          }, function (t) {
            var r = e.props.onRegisterModel,
                n = e.model.activeIndex,
                o = e.model.selectedKeys.slice(),
                i = e.model.disabledKeys.slice();
            e.model = new eP(t), e.model.disabledKeys = i, e.model.selectedKeys = o, e.model.activeIndex = n, r(e.model);
          }, {
            fireImmediately: !0
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          document.removeEventListener("click", this.onClickDocument), this.modelDisposer();
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.tabIndex,
              n = t.className,
              o = t.isLoadingOptions,
              i = t.labelledBy,
              a = t.t,
              c = this.searchText;
          return p.a.createElement("div", {
            id: "multi-select-dropdown-".concat(this.id),
            "aria-labelledby": i,
            className: "multi-select-dropdown".concat(n ? " ".concat(n) : ""),
            role: "combobox",
            tabIndex: "-1",
            onKeyDown: this.onKeyDown,
            ref: this.selectorRef,
            "aria-expanded": this.showDropdown,
            "aria-controls": "listbox-".concat(this.id)
          }, p.a.createElement("button", {
            className: "clear-search".concat(c ? "" : " empty"),
            type: "button",
            onClick: this.clearSearch
          }, p.a.createElement("span", {
            "aria-hidden": "true"
          }, "×")), p.a.createElement("input", {
            tabIndex: r || 0,
            title: this.selectedOptionsText,
            type: "text",
            className: "form-control multi-select-dropdown-input".concat(null == c || "" === c ? " unspecified" : ""),
            "aria-label": "MultiSelectDropdown Input",
            autoComplete: "disable",
            autoCorrect: "off",
            autoCapitalize: "on",
            spellCheck: "false",
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onChange: this.onChange,
            placeholder: this.placeholderText,
            value: c
          }), p.a.createElement("div", {
            className: "dropdown-menu".concat(this.showDropdown ? " show" : "", " w-100"),
            role: "listbox",
            id: "listbox-".concat(this.id)
          }, o ? p.a.createElement(h.Spinner, null) : null, p.a.createElement("div", {
            className: "scroll-panel"
          }, this.model.filteredOptions.map(function (t) {
            return p.a.createElement("a", {
              href: "#",
              key: t.key,
              className: "dropdown-item".concat(t.isSelected ? " selected" : "").concat(t.isActive ? " active" : "").concat(t.isDisabled ? " disabled" : ""),
              "aria-selected": t.isSelected,
              role: "option",
              title: t.text,
              onMouseDown: e.preventDefault,
              onClick: e.chooseItem(t)
            }, p.a.createElement(oj.a, {
              isDisabled: t.isDisabled,
              isChecked: t.isSelected,
              onChange: e.chooseItem(t)
            }), t.text);
          })), p.a.createElement("div", {
            className: "dropdown-divider"
          }), p.a.createElement("div", {
            className: "d-flex justify-content-between mx-3"
          }, p.a.createElement("a", {
            href: "#",
            role: "button",
            onClick: this.onClearAll
          }, a("clear_all")), p.a.createElement("a", {
            href: "#",
            role: "button",
            onClick: this.onClose
          }, a("apply")))));
        }
      }]);
    }()).defaultProps = {
      options: [],
      onCancel: function () {},
      onChange: function () {},
      onBlur: function () {},
      onFocus: function () {},
      onRegisterModel: function () {}
    }, Lj = cP((Bj = Zj).prototype, "searchText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Vj = cP(Bj.prototype, "showDropdown", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Uj = cP(Bj.prototype, "model", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new eP([]);
      }
    }), cP(Bj.prototype, "selectedOptionsText", [f.computed], Object.getOwnPropertyDescriptor(Bj.prototype, "selectedOptionsText"), Bj.prototype), cP(Bj.prototype, "placeholderText", [f.computed], Object.getOwnPropertyDescriptor(Bj.prototype, "placeholderText"), Bj.prototype), qj = cP(Bj.prototype, "onClickDocument", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.selectorRef.current.contains(t.target) || (e.showDropdown = !1);
        };
      }
    }), Kj = cP(Bj.prototype, "chooseItem", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function (r) {
            var n = e.props.onChange;
            e.model.toggleByOption(t), n(e.model.selectedValues), r && r.preventDefault && r.preventDefault();
          };
        };
      }
    }), Gj = cP(Bj.prototype, "search", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.searchText = t, e.model.search(t);
        };
      }
    }), Wj = cP(Bj.prototype, "clearSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.search("");
        };
      }
    }), Hj = cP(Bj.prototype, "onClearAll", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.onChange;
          e.model.clearSelection(), t(e.model.selectedValues);
        };
      }
    }), Jj = cP(Bj.prototype, "onChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.search(t.target.value);
        };
      }
    }), Yj = cP(Bj.prototype, "onClose", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.showDropdown = !1;
        };
      }
    }), Qj = cP(Bj.prototype, "onFocus", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onFocus;
          e.showDropdown = !0, r(t);
        };
      }
    }), $j = cP(Bj.prototype, "onKeyDown", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onChange;
          if ("Tab" === t.key) return e.model.toggleActiveSelected(), r(e.model.selectedValues), e.clearSearch(), void (e.showDropdown = !1);

          if ("ArrowDown" !== t.key) {
            if ("ArrowUp" !== t.key) return "Escape" === t.key ? (e.clearSearch(), void (e.showDropdown = !1)) : void ("Enter" === t.key && (e.model.toggleActiveSelected(), r(e.model.selectedValues), t.preventDefault()));
            e.model.activatePrevious();
          } else e.model.activateNext();
        };
      }
    }), Xj = cP(Bj.prototype, "preventDefault", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return function (e) {
          e.preventDefault();
        };
      }
    }), Fj = Bj)) || Fj,
        wP = Object(g.a)()(gP);

    function OP(e) {
      return function (e) {
        if (Array.isArray(e)) return jP(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return jP(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? jP(e, t) : void 0;
        }
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function jP(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function PP(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function _P(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, EP(n.key), n);
      }
    }

    function EP(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function SP(e, t, r) {
      return t = CP(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], CP(e).constructor) : t.apply(e, r));
    }

    function CP(e) {
      return (CP = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function kP(e, t) {
      return (kP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function RP(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var TP = Object(d.observer)((sP = RP((lP = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), PP(r = SP(this, t, [e]), "isOrganic", sP, r), PP(r, "disableOrganic", pP, r), PP(r, "selectedCrops", fP, r), PP(r, "selectedCropNames", dP, r), PP(r, "disabledCropNames", bP, r), PP(r, "onChangeCrops", yP, r), PP(r, "onChangeOrganic", mP, r), PP(r, "onRegisterCropsModel", vP, r), PP(r, "onToggleOrganic", hP, r);
        var n = r.props,
            o = n.selectedCrops,
            i = n.isOrganic,
            a = n.disableOrganic,
            c = n.paramName;
        return r.selectedCropNames = o.map(function (e) {
          return e.name;
        }), r.disabledCropNames = o.reduce(function (e, t) {
          return t.disabled ? e.concat(t.name) : e;
        }, []), r.isOrganic = i, r.disableOrganic = a, r.paramName = c || "spray_record", r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && kP(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && _P(e.prototype, t), r && _P(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "cropOptions",
        get: function () {
          return this.props.cropsList.map(function (e) {
            return {
              key: e,
              text: e,
              value: e
            };
          });
        }
      }, {
        key: "organicValue",
        get: function () {
          return this.isOrganic ? "1" : "0";
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.t,
              n = t.footer,
              o = t.disableOrganicText;
          return p.a.createElement("div", {
            className: "row ".concat(this.paramName, "-crops-selector")
          }, p.a.createElement("div", {
            className: "col form-group"
          }, p.a.createElement("label", {
            className: "text-secondary text-uppercase font-weight-bold"
          }, r("crops_star")), p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col-md-6"
          }, p.a.createElement(wP, {
            placeholder: r("select_crops"),
            options: this.cropOptions,
            onChange: this.onChangeCrops,
            onRegisterModel: this.onRegisterCropsModel
          }), this.selectedCrops.length ? this.selectedCrops.map(function (t) {
            return p.a.createElement("input", {
              key: t,
              type: "hidden",
              value: t,
              name: "".concat(e.paramName, "[crop_names][]")
            });
          }) : p.a.createElement("input", {
            type: "hidden",
            value: "",
            name: "".concat(this.paramName, "[crop_names][]")
          })), p.a.createElement("div", {
            className: "col-md-6"
          }, p.a.createElement("div", {
            className: "form-group my-2"
          }, p.a.createElement("input", {
            name: "".concat(this.paramName, "[organic]"),
            type: "hidden",
            value: this.organicValue
          }), p.a.createElement(oj.a, {
            isChecked: this.isOrganic,
            isDisabled: this.disableOrganic,
            onChange: this.onChangeOrganic
          }), p.a.createElement("a", {
            className: "text-secondary font-weight-bold ml-2" + "".concat(this.disableOrganic ? " disabled" : ""),
            title: "".concat(this.disableOrganic && o || ""),
            href: "#",
            onClick: this.onToggleOrganic
          }, r("organic_star"))))), p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col"
          }, p.a.createElement("p", {
            className: "feedback-text"
          }, n)))));
        }
      }]);
    }()).prototype, "isOrganic", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), pP = RP(lP.prototype, "disableOrganic", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), fP = RP(lP.prototype, "selectedCrops", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), dP = RP(lP.prototype, "selectedCropNames", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), bP = RP(lP.prototype, "disabledCropNames", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), RP(lP.prototype, "cropOptions", [f.computed], Object.getOwnPropertyDescriptor(lP.prototype, "cropOptions"), lP.prototype), RP(lP.prototype, "organicValue", [f.computed], Object.getOwnPropertyDescriptor(lP.prototype, "organicValue"), lP.prototype), yP = RP(lP.prototype, "onChangeCrops", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.selectedCrops = t;
        };
      }
    }), mP = RP(lP.prototype, "onChangeOrganic", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.isOrganic = t;
        };
      }
    }), vP = RP(lP.prototype, "onRegisterCropsModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r;
          e.cropSelectorModel = t, e.cropSelectorModel.selectedKeys = e.selectedCropNames, e.selectedCrops = e.cropSelectorModel.selectedValues, (r = e.cropSelectorModel).disable.apply(r, OP(e.disabledCropNames));
        };
      }
    }), hP = RP(lP.prototype, "onToggleOrganic", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.preventDefault(), e.disableOrganic || (e.isOrganic = !e.isOrganic);
        };
      }
    }), uP = lP)) || uP,
        zP = Object(g.a)()(TP);

    function NP(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function DP(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? NP(Object(r), !0).forEach(function (t) {
          xP(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : NP(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function xP(e, t, r) {
      return (t = MP(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function AP(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, MP(n.key), n);
      }
    }

    function MP(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function IP(e, t, r) {
      return t = LP(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], LP(e).constructor) : t.apply(e, r));
    }

    function FP() {
      return (FP = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = BP(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function BP(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = LP(e)););

      return e;
    }

    function LP(e) {
      return (LP = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function VP(e, t) {
      return (VP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var UP,
        qP = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), IP(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && VP(e, t);
      }(t, w["RecommendationProductApplication"]), function (e, t, r) {
        return t && AP(e.prototype, t), r && AP(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = FP(LP(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return DP(DP({}, a), {}, {
            product: DP(DP({}, a.product), {}, {
              modelClass: _r,
              defaultValue: new _r()
            })
          });
        }
      }]);
    }();

    function KP(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function GP(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? KP(Object(r), !0).forEach(function (t) {
          WP(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : KP(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function WP(e, t, r) {
      return (t = JP(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function HP(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, JP(n.key), n);
      }
    }

    function JP(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function YP(e, t, r) {
      return t = XP(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], XP(e).constructor) : t.apply(e, r));
    }

    function QP() {
      return (QP = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = $P(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function $P(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = XP(e)););

      return e;
    }

    function XP(e) {
      return (XP = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ZP(e, t) {
      return (ZP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var e_ = (function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((UP = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), YP(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ZP(e, t);
      }(t, w["Recommendation"]), function (e, t, r) {
        return t && HP(e.prototype, t), r && HP(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "updatedTime",
        get: function () {
          return this.updatedAt && M()(this.updatedAt).format("YYYY/MM/DD HH:mm:ss");
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          var e, r, n, o, i;
          return GP(GP({}, (e = t, r = "getAttributeDefinition", n = this, i = QP(XP(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([])), {}, {
            productApplications: {
              name: "Product Application",
              key: "productApplications",
              type: "modelCollection",
              modelClass: qP
            }
          });
        }
      }]);
    }()).prototype, "updatedTime", [f.computed], Object.getOwnPropertyDescriptor(UP.prototype, "updatedTime"), UP.prototype), UP);

    function t_(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, r_(n.key), n);
      }
    }

    function r_(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function n_(e, t, r) {
      return t = o_(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], o_(e).constructor) : t.apply(e, r));
    }

    function o_(e) {
      return (o_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function i_(e, t) {
      return (i_ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var a_,
        c_,
        u_ = function (e) {
      function t(e, r, n) {
        var o;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (o = n_(this, t)).defaultPath = "if2/dashboard/query_records", o.queryPath = e || o.defaultPath, o.sprayRecordsBasePath = r || "if2/spray_records", o.recommendationsBasePath = n || "if2/recommendations", o;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && i_(e, t);
      }(t, My), r = t, (n = [{
        key: "query",
        value: function (e) {
          return this.jsonFetch(this.queryPath, "POST", e);
        }
      }]) && t_(r.prototype, n), o && t_(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function l_(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, s_(n.key), n);
      }
    }

    function s_(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function p_(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var f_ = (c_ = p_((a_ = function () {
      return function (e, t, r) {
        return t && l_(e.prototype, t), r && l_(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.api = void 0, function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(this, "records", c_, this), this.api = t || new u_();
      }, [{
        key: "queryPath",
        get: function () {
          return this.api.queryPath;
        }
      }, {
        key: "find",
        value: function (e) {
          return this.records.find(function (t) {
            return t.id === e;
          });
        }
      }, {
        key: "update",
        value: function (e, t) {
          return this.api.update(e, t);
        }
      }, {
        key: "new",
        value: function (e) {
          if ("IF2::Recommendation" === e.type) return new e_(e);
          if ("IF2::SprayRecord" === e.type) return new Pm(e);
          throw new Error("requires document of type IF2::Recommendation or IF2::SprayRecord");
        }
      }, {
        key: "push",
        value: function (e, t) {
          var r = this.find(e.id);
          return r ? r.update(e) : (r = this.new(e), Object.keys(t || {}).forEach(function (e) {
            r[e] = t[e];
          }), this.records.push(r)), r;
        }
      }, {
        key: "pushMany",
        value: function (e, t) {
          var r = this;
          return e.map(function (e) {
            return r.push(e, t);
          });
        }
      }, {
        key: "remove",
        value: function (e) {
          var t = this.records.findIndex(function (t) {
            return t.id === e;
          });
          t < 0 || this.records.splice(t, 1);
        }
      }, {
        key: "query",
        value: function (e) {
          var t = this;
          return this.api.query(e).then(function (e) {
            return t.pushMany(e.records);
          });
        }
      }]);
    }()).prototype, "records", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), p_(a_.prototype, "queryPath", [f.computed], Object.getOwnPropertyDescriptor(a_.prototype, "queryPath"), a_.prototype), p_(a_.prototype, "update", [f.action], Object.getOwnPropertyDescriptor(a_.prototype, "update"), a_.prototype), p_(a_.prototype, "push", [f.action], Object.getOwnPropertyDescriptor(a_.prototype, "push"), a_.prototype), p_(a_.prototype, "pushMany", [f.action], Object.getOwnPropertyDescriptor(a_.prototype, "pushMany"), a_.prototype), p_(a_.prototype, "remove", [f.action], Object.getOwnPropertyDescriptor(a_.prototype, "remove"), a_.prototype), a_),
        d_ = r(200),
        b_ = r.n(d_);

    function y_(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, m_(n.key), n);
      }
    }

    function m_(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var v_ = function () {
      return e = function e(t, r) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
          padding: 0
        };
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.id = kj()(), this.type = t, this.name = r, this.padding = n.padding;
      }, (t = [{
        key: "size",
        get: function () {
          return this.padding + 1;
        }
      }]) && y_(e.prototype, t), r && y_(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function h_(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, g_(n.key), n);
      }
    }

    function g_(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function w_(e, t, r) {
      return t = O_(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], O_(e).constructor) : t.apply(e, r));
    }

    function O_(e) {
      return (O_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function j_(e, t) {
      return (j_ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var P_ = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];

        return w_(this, t, ["field"].concat(r));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && j_(e, t);
      }(t, v_), r = t, n && h_(r.prototype, n), o && h_(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function __(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, E_(n.key), n);
      }
    }

    function E_(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function S_(e, t, r) {
      return t = C_(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], C_(e).constructor) : t.apply(e, r));
    }

    function C_(e) {
      return (C_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function k_(e, t) {
      return (k_ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var R_ = function (e) {
      function t() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];

        return S_(this, t, ["crop"].concat(r));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && k_(e, t);
      }(t, v_), r = t, n && __(r.prototype, n), o && __(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function T_(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, z_(n.key), n);
      }
    }

    function z_(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var N_ = function () {
      return e = function e(t) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.id = t, this.entries = [], this.currentCrop = r;
      }, (t = [{
        key: "addField",
        value: function (e) {
          var t = new P_(e.name);

          if (e.crop.name !== this.currentCrop) {
            var r = new R_(e.crop.name);
            this.entries.length > 0 && (r.padding = 1), this.entries.push(r), this.currentCrop = e.crop.name;
          } else 0 === this.entries.length && (t.padding = 1);

          this.entries.push(t);
        }
      }, {
        key: "size",
        get: function () {
          var e = 0;
          return this.entries.forEach(function (t) {
            e += t.size;
          }), e;
        }
      }, {
        key: "map",
        value: function (e) {
          return this.entries.map(e);
        }
      }]) && T_(e.prototype, t), r && T_(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function D_(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, x_(n.key), n);
      }
    }

    function x_(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function A_(e, t, r) {
      return t = M_(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], M_(e).constructor) : t.apply(e, r));
    }

    function M_(e) {
      return (M_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function I_(e, t) {
      return (I_ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var F_,
        B_,
        L_,
        V_ = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), A_(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && I_(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props.entry;
          return "crop" === e.type ? p.a.createElement("h4", {
            className: "crop"
          }, e.name) : p.a.createElement("div", {
            className: "field"
          }, e.name);
        }
      }]) && D_(r.prototype, n), o && D_(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function U_(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, q_(n.key), n);
      }
    }

    function q_(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function K_(e, t, r) {
      return t = G_(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], G_(e).constructor) : t.apply(e, r));
    }

    function G_(e) {
      return (G_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function W_(e, t) {
      return (W_ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function H_(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var J_,
        Y_,
        Q_ = Object(d.observer)((L_ = H_((B_ = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = K_(this, t, [e]), "size", L_, r), r.updateColumnsDisposer = Object(f.autorun)(function () {
          r.columns.length > 3 && (r.size += 1);
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && W_(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && U_(e.prototype, t), r && U_(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "fields",
        get: function () {
          return this.props.fields.slice().sort(function (e, t) {
            return Object(h.naturalSort)(e.name, t.name);
          });
        }
      }, {
        key: "columns",
        get: function () {
          var e = this,
              t = [],
              r = 0,
              n = new N_(r);
          return this.fields.forEach(function (o) {
            var i = b_()(n);
            i.addField(o), i.size > e.size ? (t.push(n), (n = new N_(r += 1, n.currentCrop)).addField(o)) : n = i;
          }), t.push(n), t;
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.updateColumnsDisposer();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("h3", {
            className: "fields mt-3"
          }, e("fields")), p.a.createElement("div", {
            className: "row"
          }, this.columns.map(function (e) {
            return p.a.createElement("div", {
              key: e.id,
              className: "col-4 field-col"
            }, e.map(function (e) {
              return p.a.createElement(V_, {
                key: e.id,
                entry: e
              });
            }));
          })));
        }
      }]);
    }()).prototype, "size", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 7;
      }
    }), H_(B_.prototype, "fields", [f.computed], Object.getOwnPropertyDescriptor(B_.prototype, "fields"), B_.prototype), H_(B_.prototype, "columns", [f.computed], Object.getOwnPropertyDescriptor(B_.prototype, "columns"), B_.prototype), F_ = B_)) || F_,
        $_ = Object(g.a)()(Q_),
        X_ = r(201),
        Z_ = r.n(X_);

    function eE(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, tE(n.key), n);
      }
    }

    function tE(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function rE(e, t, r) {
      return t = nE(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], nE(e).constructor) : t.apply(e, r));
    }

    function nE(e) {
      return (nE = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function oE(e, t) {
      return (oE = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function iE(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var aE,
        cE,
        uE,
        lE = Object(d.observer)((iE((Y_ = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), rE(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && oE(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "cropName",
        get: function () {
          return this.cropNames.length > 1 ? "Multiple" : this.cropNames[0];
        }
      }, {
        key: "cropNames",
        get: function () {
          var e = this.props.option;
          return Z_()(e.fields.map(function (e) {
            return e.crop.name;
          }));
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.option;
          return 0 === this.cropNames.length ? null : p.a.createElement(p.a.Fragment, null, this.cropName, p.a.createElement("br", null), p.a.createElement("div", {
            className: "understated-bold"
          }, 1 === e.fields.length ? "1 Block" : "".concat(e.fields.length, " Blocks")));
        }
      }]) && eE(r.prototype, n), o && eE(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "cropName", [f.computed], Object.getOwnPropertyDescriptor(Y_.prototype, "cropName"), Y_.prototype), iE(Y_.prototype, "cropNames", [f.computed], Object.getOwnPropertyDescriptor(Y_.prototype, "cropNames"), Y_.prototype), J_ = Y_)) || J_;

    function sE(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, pE(n.key), n);
      }
    }

    function pE(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function fE(e, t, r) {
      return t = dE(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], dE(e).constructor) : t.apply(e, r));
    }

    function dE(e) {
      return (dE = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function bE(e, t) {
      return (bE = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function yE(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var mE,
        vE,
        hE,
        gE,
        wE = Object(d.observer)((yE((cE = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = fE(this, t, [].concat(n)), "onExpand", uE, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && bE(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "displayedProductApplications",
        get: function () {
          var e = this.props,
              t = e.sprayRecord,
              r = e.isExpanded,
              n = e.maxProductDisplayCount;
          return r ? t.productApplications : t.productApplications.slice(0, n);
        }
      }, {
        key: "notDisplayed",
        get: function () {
          var e = this.props,
              t = e.sprayRecord,
              r = e.isExpanded,
              n = e.maxProductDisplayCount;
          return r ? [] : t.productApplications.slice(n);
        }
      }, {
        key: "render",
        value: function () {
          var e = this;
          return 0 === this.props.sprayRecord.productApplications.length ? null : this.displayedProductApplications.map(function (t, r) {
            return p.a.createElement("div", {
              key: t.id
            }, t && t.product && t.product.name, 1 === r && e.notDisplayed.length > 0 ? p.a.createElement("a", {
              href: "#",
              onClick: e.onExpand,
              className: "text-primary unadorned"
            }, " ", "+", e.notDisplayed.length) : null);
          });
        }
      }]) && sE(r.prototype, n), o && sE(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "displayedProductApplications", [f.computed], Object.getOwnPropertyDescriptor(cE.prototype, "displayedProductApplications"), cE.prototype), yE(cE.prototype, "notDisplayed", [f.computed], Object.getOwnPropertyDescriptor(cE.prototype, "notDisplayed"), cE.prototype), uE = yE(cE.prototype, "onExpand", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onExpand;
          t.preventDefault(), t.stopPropagation(), r();
        };
      }
    }), aE = cE)) || aE;

    function OE(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function jE(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, PE(n.key), n);
      }
    }

    function PE(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function _E(e, t, r) {
      return t = EE(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], EE(e).constructor) : t.apply(e, r));
    }

    function EE(e) {
      return (EE = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function SE(e, t) {
      return (SE = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function CE(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var kE,
        RE,
        TE,
        zE,
        NE,
        DE = Object(d.observer)((hE = CE((vE = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return OE(e = _E(this, t, [].concat(n)), "onContract", hE, e), OE(e, "onExpand", gE, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && SE(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          return this.props.isExpanded ? p.a.createElement("a", {
            href: "#",
            className: "expand-toggle",
            onClick: this.onContract,
            "aria-label": "Expanded"
          }, p.a.createElement("i", {
            className: "icon icon-expanded"
          })) : p.a.createElement("a", {
            href: "#",
            className: "expand-toggle",
            onClick: this.onExpand,
            "aria-label": "Contracted"
          }, p.a.createElement("i", {
            className: "icon icon-contracted"
          }));
        }
      }]) && jE(r.prototype, n), o && jE(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "onContract", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onContract;
          t.preventDefault(), t.stopPropagation(), r();
        };
      }
    }), gE = CE(vE.prototype, "onExpand", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onExpand;
          t.preventDefault(), t.stopPropagation(), r();
        };
      }
    }), mE = vE)) || mE,
        xE = r(61),
        AE = r(202),
        ME = r(95);

    function IE(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function FE(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, BE(n.key), n);
      }
    }

    function BE(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function LE(e, t, r) {
      return t = VE(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], VE(e).constructor) : t.apply(e, r));
    }

    function VE(e) {
      return (VE = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function UE(e, t) {
      return (UE = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function qE(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    v()(document).off(".data-api");
    var KE,
        GE,
        WE,
        HE,
        JE,
        YE,
        QE,
        $E = Object(d.observer)(((NE = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), IE(r = LE(this, t, [e]), "width", TE, r), IE(r, "height", zE, r), r.svgRef = Object(s.createRef)(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && UE(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "outerRadius",
        get: function () {
          return this.width / 2;
        }
      }, {
        key: "innerRadius",
        get: function () {
          return .7 * this.outerRadius;
        }
      }, {
        key: "dataEntries",
        get: function () {
          var e = this.props.percent;
          return [{
            key: "complete",
            value: Number(e)
          }, {
            key: "notComplete",
            value: 100 - Number(e)
          }];
        }
      }, {
        key: "color",
        get: function () {
          var e = this.props,
              t = e.colorComplete,
              r = e.colorNotComplete;
          return Object(AE.scaleOrdinal)().domain(this.dataEntries).range([t, r]);
        }
      }, {
        key: "percentComplete",
        get: function () {
          var e = this.props.percent;
          return "".concat(Math.round(e));
        }
      }, {
        key: "pieGenerator",
        get: function () {
          return Object(ME.pie)().value(function (e) {
            return e.value;
          }).sortValues(null);
        }
      }, {
        key: "pieData",
        get: function () {
          return this.pieGenerator(this.dataEntries);
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = this;
          v()('[data-toggle="tooltip"]').tooltip(), this.d3UpdateDisposer = Object(f.autorun)(function () {
            var t = Object(xE.select)(e.svgRef.current).selectAll("g.dial-group");
            t.selectAll(".segment").data(e.pieData).join("path").attr("class", function (e) {
              return "complete" === e.data.key ? "segment complete" : "segment not-complete";
            }).attr("d", Object(ME.arc)().innerRadius(e.innerRadius).outerRadius(e.outerRadius)).attr("fill", function (t) {
              return e.color(t.data.key);
            }).attr("stroke", "white"), t.selectAll(".percentage-text").data([e.percentComplete]).join("text").text(function (e) {
              return "".concat(e, "%");
            }).attr("class", "percentage-text").attr("dominant-baseline", "middle");
          }, {
            delay: 30
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.d3UpdateDisposer();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.percent,
              r = e.useIconWhenComplete,
              n = e.title,
              o = e.onClick;
          return p.a.createElement("div", {
            className: "percentage-dial",
            "data-original-title": n,
            "data-toggle": "tooltip",
            onClick: o
          }, r && Number(Math.round(t)) >= 100 ? p.a.createElement("div", {
            className: "complete-100-percent"
          }) : p.a.createElement("svg", {
            ref: this.svgRef,
            viewBox: "0 0 ".concat(this.width, " ").concat(this.height)
          }, p.a.createElement("g", {
            className: "dial-group",
            transform: "translate(".concat(this.width / 2, ", ").concat(this.height / 2, ")")
          })));
        }
      }]) && FE(r.prototype, n), o && FE(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).defaultProps = {
      percent: 0,
      colorComplete: "#f2f2f3",
      colorNotComplete: "#30a649",
      onClick: function () {}
    }, TE = qE((RE = NE).prototype, "width", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 100;
      }
    }), zE = qE(RE.prototype, "height", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 100;
      }
    }), qE(RE.prototype, "outerRadius", [f.computed], Object.getOwnPropertyDescriptor(RE.prototype, "outerRadius"), RE.prototype), qE(RE.prototype, "innerRadius", [f.computed], Object.getOwnPropertyDescriptor(RE.prototype, "innerRadius"), RE.prototype), qE(RE.prototype, "dataEntries", [f.computed], Object.getOwnPropertyDescriptor(RE.prototype, "dataEntries"), RE.prototype), qE(RE.prototype, "color", [f.computed], Object.getOwnPropertyDescriptor(RE.prototype, "color"), RE.prototype), qE(RE.prototype, "percentComplete", [f.computed], Object.getOwnPropertyDescriptor(RE.prototype, "percentComplete"), RE.prototype), qE(RE.prototype, "pieGenerator", [f.computed], Object.getOwnPropertyDescriptor(RE.prototype, "pieGenerator"), RE.prototype), qE(RE.prototype, "pieData", [f.computed], Object.getOwnPropertyDescriptor(RE.prototype, "pieData"), RE.prototype), kE = RE)) || kE;

    function XE(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function ZE(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, eS(n.key), n);
      }
    }

    function eS(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function tS(e, t, r) {
      return t = rS(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], rS(e).constructor) : t.apply(e, r));
    }

    function rS(e) {
      return (rS = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function nS(e, t) {
      return (nS = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function oS(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var iS,
        aS = (GE = oS((KE = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return XE(e = tS(this, t, [].concat(n)), "isExpanded", GE, e), e.maxProductDisplayCount = 2, XE(e, "expand", WE, e), XE(e, "contract", HE, e), XE(e, "toggleExpanded", JE, e), XE(e, "stopPropagation", YE, e), XE(e, "onToggleChecked", QE, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && nS(e, t);
      }(t, h["ViewModel"]), r = t, (n = [{
        key: "sprayRecordPath",
        get: function () {
          var e = this.props,
              t = e.sprayRecordsPath,
              r = e.sprayRecord;
          return "".concat(t, "/").concat(r.serial);
        }
      }, {
        key: "recommendationNumber",
        get: function () {
          var e,
              t = this.props.sprayRecord;
          return (null == t || null === (e = t.recommendation) || void 0 === e ? void 0 : e.documentNumber) || "";
        }
      }, {
        key: "recommendedBy",
        get: function () {
          var e,
              t = this.props.sprayRecord;
          return (null == t || null === (e = t.recommendation) || void 0 === e || null === (e = e.writtenBy) || void 0 === e ? void 0 : e.name) || "";
        }
      }]) && ZE(r.prototype, n), o && ZE(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "isExpanded", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), oS(KE.prototype, "sprayRecordPath", [f.computed], Object.getOwnPropertyDescriptor(KE.prototype, "sprayRecordPath"), KE.prototype), oS(KE.prototype, "recommendationNumber", [f.computed], Object.getOwnPropertyDescriptor(KE.prototype, "recommendationNumber"), KE.prototype), oS(KE.prototype, "recommendedBy", [f.computed], Object.getOwnPropertyDescriptor(KE.prototype, "recommendedBy"), KE.prototype), WE = oS(KE.prototype, "expand", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isExpanded = !0;
        };
      }
    }), HE = oS(KE.prototype, "contract", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isExpanded = !1;
        };
      }
    }), JE = oS(KE.prototype, "toggleExpanded", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isExpanded = !e.isExpanded;
        };
      }
    }), YE = oS(KE.prototype, "stopPropagation", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return function (e) {
          return e.stopPropagation();
        };
      }
    }), QE = oS(KE.prototype, "onToggleChecked", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.props.sprayRecord.toggleChecked();
        };
      }
    }), KE);

    function cS(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, uS(n.key), n);
      }
    }

    function uS(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function lS(e, t, r) {
      return t = sS(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], sS(e).constructor) : t.apply(e, r));
    }

    function sS(e) {
      return (sS = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function pS(e, t) {
      return (pS = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var fS,
        dS,
        bS,
        yS = Object(d.observer)(iS = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
        var n = (r = lS(this, t, [e])).props.model;
        return r.model = n || new aS(r.props), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && pS(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.model.props,
              t = e.isLight,
              r = e.sprayRecord,
              n = e.includeCheckboxes,
              o = e.icon,
              i = e.includeDashboardSpacers;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("tr", {
            "aria-label": "Spray Record Row",
            className: "".concat(t ? "" : " dark")
          }, n ? p.a.createElement("td", {
            className: "px-3 align-middle",
            "aria-label": "Spray Record Checkbox"
          }, p.a.createElement(oj.a, {
            onChange: this.model.onToggleChecked,
            isChecked: r.isChecked
          })) : null, p.a.createElement("td", {
            "aria-label": "Expand Toggle",
            onClick: this.model.toggleExpanded,
            className: "chevron is-clickable px-3 align-middle"
          }, r.fields.length > 0 || r.productApplications.length > this.model.maxProductDisplayCount ? p.a.createElement(DE, {
            isExpanded: this.model.isExpanded,
            onContract: this.model.contract,
            onExpand: this.model.expand
          }) : p.a.createElement("i", {
            className: "icon-spacer"
          })), o ? p.a.createElement("td", {
            className: "icon-cell"
          }, !0 === o ? "" : o) : null, p.a.createElement("td", null, r.title && r.title !== r.abbreviatedDateTitle ? p.a.createElement("a", {
            href: this.model.sprayRecordPath,
            onClick: this.model.stopPropagation
          }, r.title) : null, r.abbreviatedDateTitle && r.title && r.abbreviatedDateTitle !== r.title ? p.a.createElement("br", null) : null, r.abbreviatedDateTitle ? p.a.createElement("a", {
            className: "unobtrusive",
            href: this.model.sprayRecordPath,
            title: r.dateTitle,
            onClick: this.model.stopPropagation
          }, r.abbreviatedDateTitle) : null), p.a.createElement("td", null, this.model.recommendationNumber, this.model.recommendationNumber && this.model.recommendedBy ? p.a.createElement("br", null) : null, this.model.recommendedBy), p.a.createElement("td", null, r.account.fullName), p.a.createElement("td", {
            className: "text-nowrap",
            "aria-label": "Blocks"
          }, p.a.createElement(lE, {
            option: r
          })), p.a.createElement("td", {
            rowSpan: this.model.isExpanded ? 2 : 1,
            "aria-label": "Products"
          }, p.a.createElement(wE, {
            onExpand: this.model.expand,
            isExpanded: this.model.isExpanded,
            sprayRecord: r,
            maxProductDisplayCount: this.model.maxProductDisplayCount
          })), p.a.createElement("td", {
            rowSpan: this.model.isExpanded ? 2 : 1,
            "aria-label": "Percentage Complete"
          }, p.a.createElement($E, {
            title: r.name,
            percent: r.percentageComplete,
            useIconWhenComplete: !0
          })), p.a.createElement("td", {
            className: "actions",
            rowSpan: this.model.isExpanded ? 2 : 1
          }, r.complete ? p.a.createElement("a", {
            href: this.model.sprayRecordPath,
            onClick: this.model.stopPropagation,
            className: "text-success",
            "aria-label": "Complete"
          }, p.a.createElement("i", {
            className: "fas fa-check"
          })) : p.a.createElement("a", {
            href: this.model.sprayRecordPath,
            onClick: this.model.stopPropagation,
            className: "icon-link",
            "aria-label": "Edit"
          }, p.a.createElement("i", {
            className: "fas fa-edit"
          })), r.complete ? p.a.createElement("a", {
            href: "".concat(this.model.sprayRecordPath, "?print=true"),
            onClick: this.model.stopPropagation,
            className: "icon-link",
            "aria-label": "Print"
          }, p.a.createElement("i", {
            className: "fas fa-print"
          })) : p.a.createElement("i", {
            className: "icon-spacer"
          }))), this.model.isExpanded ? p.a.createElement("tr", {
            className: "align-top expanded borderless".concat(t ? "" : " dark"),
            height: "100%"
          }, n ? p.a.createElement("td", {
            "aria-label": "Checkbox Spacer"
          }) : null, i ? p.a.createElement("td", {
            "aria-label": "Dashboard Spacer"
          }) : null, p.a.createElement("td", {
            "aria-label": "Spacer"
          }), p.a.createElement("td", {
            colSpan: "4",
            "aria-label": "Fields"
          }, p.a.createElement($_, {
            fields: r.fields
          }))) : null);
        }
      }]) && cS(r.prototype, n), o && cS(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || iS;

    function mS(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, vS(n.key), n);
      }
    }

    function vS(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function hS(e, t, r) {
      return t = gS(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], gS(e).constructor) : t.apply(e, r));
    }

    function gS(e) {
      return (gS = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function wS(e, t) {
      return (wS = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function OS(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var jS,
        PS = Object(d.observer)((OS((dS = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = hS(this, t, [].concat(n)), "onExpand", bS, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && wS(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "displayedProductApplications",
        get: function () {
          var e = this.props,
              t = e.recommendation,
              r = e.isExpanded,
              n = e.maxProductDisplayCount;
          return r ? t.productApplications : t.productApplications.slice(0, n);
        }
      }, {
        key: "notDisplayed",
        get: function () {
          var e = this.props,
              t = e.recommendation,
              r = e.isExpanded,
              n = e.maxProductDisplayCount;
          return r ? [] : t.productApplications.slice(n);
        }
      }, {
        key: "render",
        value: function () {
          var e = this;
          return 0 === this.props.recommendation.productApplications.length ? null : this.displayedProductApplications.map(function (t, r) {
            return p.a.createElement("div", {
              key: t.id || r
            }, t.product.name, 1 === r && e.notDisplayed.length > 0 ? p.a.createElement("a", {
              href: "#",
              onClick: e.onExpand,
              className: "text-primary unadorned"
            }, " ", "+", e.notDisplayed.length) : null);
          });
        }
      }]) && mS(r.prototype, n), o && mS(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "displayedProductApplications", [f.computed], Object.getOwnPropertyDescriptor(dS.prototype, "displayedProductApplications"), dS.prototype), OS(dS.prototype, "notDisplayed", [f.computed], Object.getOwnPropertyDescriptor(dS.prototype, "notDisplayed"), dS.prototype), bS = OS(dS.prototype, "onExpand", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onExpand;
          t.preventDefault(), t.stopPropagation(), r();
        };
      }
    }), fS = dS)) || fS;

    function _S() {
      return (_S = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }

        return e;
      }).apply(null, arguments);
    }

    var ES,
        SS = function (e) {
      return s.createElement("svg", _S({
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30
      }, e), jS || (jS = s.createElement("g", {
        "data-name": "Group 3693",
        transform: "translate(-450 -457.51)"
      }, s.createElement("circle", {
        "data-name": "Ellipse 35",
        cx: 15,
        cy: 15,
        r: 15,
        transform: "translate(450 457.51)",
        fill: "#dc3645"
      }), s.createElement("g", {
        "data-name": "Group 3678",
        fill: "#fff"
      }, s.createElement("path", {
        "data-name": "Line 224",
        d: "M458.5 480.01a1 1 0 01-.707-.293 1 1 0 010-1.414l13-13a1 1 0 011.414 0 1 1 0 010 1.414l-13 13a1 1 0 01-.707.293z"
      }), s.createElement("path", {
        "data-name": "Line 225",
        d: "M457.5 466.01a1 1 0 01.293-.707 1 1 0 011.414 0l13 13a1 1 0 010 1.414 1 1 0 01-1.414 0l-13-13a1 1 0 01-.293-.707z"
      })))));
    };

    function CS() {
      return (CS = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }

        return e;
      }).apply(null, arguments);
    }

    var kS,
        RS,
        TS = function (e) {
      return s.createElement("svg", CS({
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30
      }, e), ES || (ES = s.createElement("g", {
        "data-name": "Group 3752"
      }, s.createElement("g", {
        "data-name": "Group 3711"
      }, s.createElement("circle", {
        "data-name": "Ellipse 35",
        cx: 15,
        cy: 15,
        r: 15,
        transform: "translate(0 -.001)",
        fill: "#33449c"
      })), s.createElement("g", {
        "data-name": "Icon feather-bell",
        fill: "#fff"
      }, s.createElement("path", {
        "data-name": "Path 472",
        d: "M23.02 20.568H6.982a.9.9 0 01-.869-.636.869.869 0 01.368-.986 4.506 4.506 0 001.125-1.486 13.026 13.026 0 001.158-5.765 6.237 6.237 0 0112.474 0 13.026 13.026 0 001.162 5.766 4.506 4.506 0 001.125 1.486.869.869 0 01.368.986.9.9 0 01-.873.635zM8.9 18.794h12.2q-.1-.166-.2-.352a14.023 14.023 0 01-1.445-6.747 4.455 4.455 0 00-8.91 0A14.023 14.023 0 019.1 18.442q-.1.186-.2.352z"
      }), s.createElement("path", {
        "data-name": "Path 473",
        d: "M15 24.517a2.378 2.378 0 01-2.051-1.181.79.79 0 111.367-.793.79.79 0 001.367 0 .79.79 0 011.367.793A2.378 2.378 0 0115 24.517z"
      })))));
    };

    function zS() {
      return (zS = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }

        return e;
      }).apply(null, arguments);
    }

    var NS,
        DS,
        xS,
        AS,
        MS,
        IS,
        FS,
        BS,
        LS,
        VS,
        US,
        qS = function (e) {
      return s.createElement("svg", zS({
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30
      }, e), kS || (kS = s.createElement("defs", null, s.createElement("clipPath", {
        id: "change-ylw_svg__a"
      }, s.createElement("path", {
        "data-name": "Rectangle 1963",
        fill: "#fff",
        d: "M0 0h20.338v14.311H0z"
      })))), RS || (RS = s.createElement("g", {
        "data-name": "Group 3751",
        transform: "translate(-451 -479.542)"
      }, s.createElement("circle", {
        "data-name": "Ellipse 48",
        cx: 15,
        cy: 15,
        r: 15,
        transform: "translate(451 479.542)",
        fill: "#ffc108"
      }), s.createElement("g", {
        "data-name": "Group 3734"
      }, s.createElement("g", {
        "data-name": "Group 3676",
        clipPath: "url(#change-ylw_svg__a)",
        fill: "#fff",
        transform: "translate(456 487.231)"
      }, s.createElement("path", {
        "data-name": "Path 459",
        d: "M17.723 12.011c-6.027 0-8.06-2.441-9.868-4.612C6.271 5.5 4.9 3.857.842 3.817a.85.85 0 01.008-1.7h.009c4.848.047 6.6 2.156 8.3 4.194 1.848 2.217 3.592 4.3 9.848 3.963a.85.85 0 11.094 1.7q-.723.041-1.38.04"
      }), s.createElement("path", {
        "data-name": "Path 460",
        d: "M17.132 14.311a.849.849 0 01-.656-1.39l1.442-1.753-1.4-1.445a.85.85 0 011.223-1.182l2.45 2.536L17.789 14a.845.845 0 01-.657.31"
      }), s.createElement("path", {
        "data-name": "Path 461",
        d: "M6.708 8.364c.35.42.71.86 1.11 1.29a8.3 8.3 0 01-1.48 1.19A10 10 0 011 12.194a.85.85 0 01-.01-1.7c2.97-.03 4.5-.91 5.72-2.13"
      }), s.createElement("path", {
        "data-name": "Path 462",
        d: "M20.048 3.234a.857.857 0 01-.9.8c-4.44-.23-6.6.75-8.15 2.13-.23-.26-.45-.53-.69-.81-.13-.16-.27-.32-.41-.49 1.59-1.42 3.84-2.56 7.97-2.56.44 0 .9.01 1.38.04a.836.836 0 01.8.89"
      }), s.createElement("path", {
        "data-name": "Path 463",
        d: "M17.276 0a.849.849 0 00-.656 1.39l1.442 1.753-1.4 1.445a.85.85 0 001.226 1.182l2.45-2.536L17.933.31a.845.845 0 00-.657-.31"
      }))))));
    };

    function KS(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function GS(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, WS(n.key), n);
      }
    }

    function WS(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function HS(e, t, r) {
      return t = JS(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], JS(e).constructor) : t.apply(e, r));
    }

    function JS(e) {
      return (JS = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function YS(e, t) {
      return (YS = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function QS(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var $S,
        XS = Object(d.observer)((xS = QS((DS = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return KS(e = HS(this, t, [].concat(n)), "isExpanded", xS, e), KS(e, "hovering", AS, e), e.maxProductDisplayCount = 2, KS(e, "expand", MS, e), KS(e, "contract", IS, e), KS(e, "toggleExpanded", FS, e), KS(e, "stopPropagation", BS, e), KS(e, "onToggleChecked", LS, e), e.onChoose = function () {
          var t = e.props,
              r = t.recommendationSelector,
              n = t.recommendation;
          r && r.select(n);
        }, KS(e, "onMouseEnter", VS, e), KS(e, "onMouseLeave", US, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && YS(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "recommendationPath",
        get: function () {
          var e = this.props,
              t = e.recommendationsPath,
              r = e.recommendation;
          return "".concat(t, "/").concat(r.id);
        }
      }, {
        key: "rowClassNames",
        get: function () {
          var e = this.props,
              t = e.isLight,
              r = e.recommendationSelector;
          return [].concat(t ? [] : "dark").concat(this.hovering ? "hovering" : []).concat(r ? this.isExpanded ? "recommendation-row-expanded" : "recommendation-row-contracted" : []).concat(r ? "is-clickable" : []).join(" ");
        }
      }, {
        key: "expandedRowClassNames",
        get: function () {
          var e = this.props,
              t = e.isLight,
              r = e.recommendationSelector;
          return ["expanded", "borderless", "align-top"].concat(t ? [] : "dark").concat(this.hovering ? "hovering" : []).concat(r ? "is-clickable" : []).join(" ");
        }
      }, {
        key: "statusIcon",
        get: function () {
          var e = this.props.recommendation.status;
          return "pending-approval" === e ? p.a.createElement(TS, null) : "rejected" === e ? p.a.createElement(SS, null) : "change-requested" === e ? p.a.createElement(qS, null) : null;
        }
      }, {
        key: "statusTextClass",
        get: function () {
          var e = this.props.recommendation.status;
          return "pending-approval" === e ? "pending-approval-text" : "rejected" === e ? "rejected-text" : "change-requested" === e ? "change-requested-text" : null;
        }
      }, {
        key: "statusText",
        get: function () {
          var e = this.props.recommendation.status;
          return "pending-approval" === e ? "PENDING APPROVAL" : "rejected" === e ? "REJECTED" : "change-requested" === e ? "CHANGE REQUESTED" : null;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.recommendation,
              r = e.hasArchive,
              n = e.includeCheckboxes,
              o = e.icon,
              i = e.showApprovalStatus,
              a = e.recommendationSelector,
              c = e.includeDashboardSpacers,
              u = e.recommendationsStore;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("tr", {
            id: t.id,
            "aria-label": "Recommendation Row",
            className: this.rowClassNames,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
            onClick: this.onChoose
          }, n ? p.a.createElement("td", {
            className: "px-3 align-middle",
            "aria-label": "Checkbox"
          }, p.a.createElement(oj.a, {
            onChange: this.onToggleChecked,
            isChecked: u.isChecked(t.id)
          })) : null, p.a.createElement("td", {
            "aria-label": "Expand Toggle",
            className: "chevron is-clickable px-3 align-middle",
            onClick: this.toggleExpanded
          }, p.a.createElement(DE, {
            isExpanded: this.isExpanded,
            onContract: this.contract,
            onExpand: this.expand
          })), i ? p.a.createElement("td", {
            className: "status-icon"
          }, p.a.createElement("div", null, this.statusIcon)) : null, o ? p.a.createElement("td", {
            className: "icon-cell"
          }, !0 === o ? "" : o) : null, p.a.createElement("td", null, i ? p.a.createElement("p", {
            className: this.statusTextClass
          }, this.statusText) : null, p.a.createElement("a", {
            href: a ? "#" : this.recommendationPath
          }, t.title), t.dateTitle && t.dateTitle !== t.title ? p.a.createElement(p.a.Fragment, null, p.a.createElement("br", null), p.a.createElement("a", {
            className: "unobtrusive",
            href: this.recommendationPath,
            onClick: this.stopPropagation
          }, t.dateTitle)) : null), p.a.createElement("td", {
            className: "text-nowrap"
          }, t.writtenBy.name, p.a.createElement("br", null), t.documentNumber ? "#".concat(t.documentNumber) : null), p.a.createElement("td", null, t.account.fullName), p.a.createElement("td", {
            className: "text-nowrap"
          }, 0 === t.fields.length ? t.cropNames.map(function (e) {
            return e.value;
          }).join(", ") : p.a.createElement(lE, {
            option: t
          })), p.a.createElement("td", {
            rowSpan: this.isExpanded ? 2 : 1,
            "aria-label": "Products"
          }, p.a.createElement(PS, {
            onExpand: this.expand,
            isExpanded: this.isExpanded,
            recommendation: t,
            maxProductDisplayCount: this.maxProductDisplayCount
          })), c ? p.a.createElement("td", {
            rowSpan: this.isExpanded ? 2 : 1,
            "aria-label": "Dashboard Spacer"
          }) : null, p.a.createElement("td", {
            className: "actions",
            rowSpan: this.isExpanded ? 2 : 1
          }, r ? p.a.createElement("a", {
            href: "".concat(this.recommendationPath, "/archived_pdf"),
            "aria-label": "Archive"
          }, p.a.createElement("i", {
            className: "far fa-file-pdf text-primary"
          })) : null)), this.isExpanded ? p.a.createElement("tr", {
            className: this.expandedRowClassNames,
            height: "100%",
            onClick: this.onChoose,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
          }, n ? p.a.createElement("td", {
            "aria-label": "Checkbox Spacer"
          }) : null, c ? p.a.createElement("td", {
            "aria-label": "Expanded Dashboard Spacer"
          }) : null, p.a.createElement("td", {
            "aria-label": "Expanded Spacer"
          }), p.a.createElement("td", {
            colSpan: "4",
            "aria-label": "Fields"
          }, p.a.createElement($_, {
            fields: t.fields
          }))) : null);
        }
      }]) && GS(r.prototype, n), o && GS(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "isExpanded", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), AS = QS(DS.prototype, "hovering", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), QS(DS.prototype, "recommendationPath", [f.computed], Object.getOwnPropertyDescriptor(DS.prototype, "recommendationPath"), DS.prototype), QS(DS.prototype, "rowClassNames", [f.computed], Object.getOwnPropertyDescriptor(DS.prototype, "rowClassNames"), DS.prototype), QS(DS.prototype, "expandedRowClassNames", [f.computed], Object.getOwnPropertyDescriptor(DS.prototype, "expandedRowClassNames"), DS.prototype), QS(DS.prototype, "statusIcon", [f.computed], Object.getOwnPropertyDescriptor(DS.prototype, "statusIcon"), DS.prototype), QS(DS.prototype, "statusTextClass", [f.computed], Object.getOwnPropertyDescriptor(DS.prototype, "statusTextClass"), DS.prototype), QS(DS.prototype, "statusText", [f.computed], Object.getOwnPropertyDescriptor(DS.prototype, "statusText"), DS.prototype), MS = QS(DS.prototype, "expand", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isExpanded = !0;
        };
      }
    }), IS = QS(DS.prototype, "contract", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isExpanded = !1;
        };
      }
    }), FS = QS(DS.prototype, "toggleExpanded", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.stopPropagation(), t.target.closest("a") || t.target.closest("button") || (e.isExpanded = !e.isExpanded);
        };
      }
    }), BS = QS(DS.prototype, "stopPropagation", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return function (e) {
          return e.stopPropagation();
        };
      }
    }), LS = QS(DS.prototype, "onToggleChecked", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.recommendation;
          t.recommendationsStore.toggleChecked(r.id);
        };
      }
    }), VS = QS(DS.prototype, "onMouseEnter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.hovering = !0;
        };
      }
    }), US = QS(DS.prototype, "onMouseLeave", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.hovering = !1;
        };
      }
    }), NS = DS)) || NS,
        ZS = Object(g.a)()(XS);

    function eC(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, tC(n.key), n);
      }
    }

    function tC(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function rC(e, t, r) {
      return t = nC(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], nC(e).constructor) : t.apply(e, r));
    }

    function nC(e) {
      return (nC = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function oC(e, t) {
      return (oC = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var iC,
        aC,
        cC,
        uC = Object(d.observer)($S = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), rC(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && oC(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && eC(e.prototype, t), r && eC(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.records,
              r = e.t,
              n = e.store;
          return p.a.createElement("div", {
            className: "dashboard-record-list",
            "aria-label": "Dashboard Record List"
          }, p.a.createElement("table", {
            className: "table table-sm table-manually-striped"
          }, p.a.createElement("thead", null, p.a.createElement("tr", null, p.a.createElement("th", {
            "aria-label": "Expandable Arrow"
          }), p.a.createElement("th", {
            "aria-label": "Icon Type Identifier"
          }), p.a.createElement("th", {
            scope: "col"
          }, r("title"), p.a.createElement("br", null), r("date_dates")), p.a.createElement("th", {
            scope: "col"
          }, r("recommendation"), "/", r("author")), p.a.createElement("th", {
            scope: "col"
          }, r("account")), p.a.createElement("th", {
            scope: "col"
          }, r("crop")), p.a.createElement("th", {
            scope: "col"
          }, r("products")), p.a.createElement("th", {
            "aria-label": "Percentage Complete Dial"
          }), p.a.createElement("th", {
            "aria-label": "Actions",
            scope: "col",
            className: "actions"
          }))), p.a.createElement("tbody", null, null == t ? void 0 : t.map(function (e) {
            return "IF2::SprayRecord" === e.type ? p.a.createElement(yS, {
              key: e.id,
              sprayRecordsPath: n.api.sprayRecordsBasePath,
              sprayRecord: e,
              icon: p.a.createElement("div", {
                className: "row-icon spray-record-row-icon"
              }),
              isLight: !0,
              includeDashboardSpacers: !0
            }) : p.a.createElement(ZS, {
              key: e.id,
              recommendationsPath: n.api.recommendationsBasePath,
              recommendation: e,
              icon: p.a.createElement("div", {
                className: "row-icon recommendation-row-icon"
              }),
              isLight: !1,
              includeDashboardSpacers: !0
            });
          }))));
        }
      }]);
    }()) || $S,
        lC = Object(g.a)()(uC);

    function sC(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, pC(n.key), n);
      }
    }

    function pC(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function fC(e, t, r) {
      return t = dC(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], dC(e).constructor) : t.apply(e, r));
    }

    function dC(e) {
      return (dC = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function bC(e, t) {
      return (bC = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function yC(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var mC,
        vC,
        hC,
        gC,
        wC,
        OC = Object(d.observer)((cC = yC((aC = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = fC(this, t, [e]), "store", cC, r);
        var n = r.props,
            o = n.queryPath,
            i = n.i18n,
            a = n.localeOverride,
            c = n.store;
        return r.store = c || new f_(new u_(o)), a && i.changeLanguage(a), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && bC(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "records",
        get: function () {
          return this.store.records;
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = this.props.accountIds;
          return this.store.query({
            accounts: e,
            limit: 20
          }).catch(function (e) {
            e instanceof Dy ? window.location.reload() : console.error(e);
          });
        }
      }, {
        key: "render",
        value: function () {
          return p.a.createElement(lC, {
            records: this.records,
            store: this.store
          });
        }
      }]) && sC(r.prototype, n), o && sC(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "store", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), yC(aC.prototype, "records", [f.computed], Object.getOwnPropertyDescriptor(aC.prototype, "records"), aC.prototype), iC = aC)) || iC,
        jC = Object(g.a)()(OC);

    function PC(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function _C(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, EC(n.key), n);
      }
    }

    function EC(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function SC(e, t, r) {
      return t = CC(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], CC(e).constructor) : t.apply(e, r));
    }

    function CC(e) {
      return (CC = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function kC(e, t) {
      return (kC = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function RC(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    v()(document).off(".data-api");
    var TC,
        zC,
        NC,
        DC,
        xC,
        AC,
        MC,
        IC,
        FC,
        BC,
        LC = Object(d.observer)(((wC = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return PC(e = SC(this, t, [].concat(n)), "onChange", hC, e), PC(e, "onBlur", gC, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && kC(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "componentDidMount",
        value: function () {
          v()('[data-toggle="tooltip"]').tooltip({
            trigger: "hover",
            delay: {
              show: 500,
              hide: 0
            }
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.value,
              r = e.inputClassName,
              n = e.placeholder,
              o = e.title,
              i = e.ariaLabel;
          return p.a.createElement("div", {
            className: "editable-title"
          }, p.a.createElement("input", {
            "aria-label": i,
            type: "text",
            className: r,
            placeholder: n,
            "data-original-title": o,
            "data-toggle": "tooltip",
            value: t,
            onChange: this.onChange,
            onBlur: this.onBlur
          }));
        }
      }]) && _C(r.prototype, n), o && _C(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).defaultProps = {
      onBlur: function () {}
    }, hC = RC((vC = wC).prototype, "onChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return (0, e.props.onChange)(t.target.value);
        };
      }
    }), gC = RC(vC.prototype, "onBlur", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return (0, e.props.onBlur)(t);
        };
      }
    }), mC = vC)) || mC;

    function VC(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function UC(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qC(n.key), n);
      }
    }

    function qC(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function KC(e, t, r) {
      return t = GC(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], GC(e).constructor) : t.apply(e, r));
    }

    function GC(e) {
      return (GC = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function WC(e, t) {
      return (WC = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function HC(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var JC,
        YC,
        QC,
        $C,
        XC,
        ZC,
        ek,
        tk = Object(d.observer)((NC = HC((zC = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return VC(e = KC(this, t, [].concat(n)), "newItemName", NC, e), VC(e, "editingItem", DC, e), VC(e, "editedItemName", xC, e), e.addItem = function (t) {
          (0, e.props.addItem)(t), e.newItemName = "";
        }, e.removeItem = function (t) {
          (0, e.props.removeItem)(t);
        }, VC(e, "changeItem", AC, e), VC(e, "updateNewItemName", MC, e), VC(e, "editItem", IC, e), VC(e, "doneEditing", FC, e), VC(e, "confirm", BC, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && WC(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && UC(e.prototype, t), r && UC(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.items,
              n = t.placeholder,
              o = t.t,
              i = t.ListItemChild;
          return p.a.createElement("div", {
            className: "unsorted-list-manager"
          }, p.a.createElement("div", {
            className: "d-flex justify-content-between mb-3"
          }, p.a.createElement("input", {
            type: "text",
            className: "form-control mr-2",
            "data-testid": "unsorted-list-manager-input",
            placeholder: n,
            onChange: this.updateNewItemName,
            onKeyPress: function (t) {
              "Enter" === t.key && (t.preventDefault(), e.addItem(e.newItemName));
            },
            value: this.newItemName
          }), p.a.createElement("button", {
            type: "button",
            onClick: function () {
              return e.addItem(e.newItemName);
            },
            className: "btn btn-success"
          }, o("add"))), p.a.createElement("ul", {
            className: "list-group"
          }, (r || []).map(function (t) {
            return p.a.createElement("li", {
              key: t,
              className: "list-group-item d-flex justify-content-between align-items-center"
            }, e.editingItem === t ? p.a.createElement("input", {
              type: "text",
              autoFocus: !0,
              onChange: function (t) {
                return e.changeItem(t.target.value);
              },
              onBlur: function () {
                return e.doneEditing(t);
              },
              value: e.editedItemName
            }) : p.a.createElement("span", {
              style: {
                cursor: "text"
              },
              onClick: function () {
                return e.editItem(t);
              },
              onKeyPress: e.confirm
            }, t), i ? p.a.createElement(i, Object.assign({
              item: t
            }, e.props)) : null, p.a.createElement("a", {
              href: "#",
              onClick: function (r) {
                r.preventDefault(), e.removeItem(t);
              },
              "aria-label": "Remove"
            }, p.a.createElement("i", {
              className: "fa fa-times"
            })));
          })));
        }
      }]);
    }()).prototype, "newItemName", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), DC = HC(zC.prototype, "editingItem", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), xC = HC(zC.prototype, "editedItemName", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), AC = HC(zC.prototype, "changeItem", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.editedItemName = t;
        };
      }
    }), MC = HC(zC.prototype, "updateNewItemName", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.newItemName = t.target.value;
        };
      }
    }), IC = HC(zC.prototype, "editItem", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.editingItem = t, e.editedItemName = t;
        };
      }
    }), FC = HC(zC.prototype, "doneEditing", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.changeItem;
          e.editingItem = null, r(t, e.editedItemName);
        };
      }
    }), BC = HC(zC.prototype, "confirm", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return function (e) {
          "Enter" === e.key && "Escape" === e.key && e.target.blur();
        };
      }
    }), TC = zC)) || TC,
        rk = Object(g.a)()(tk);

    function nk(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function ok(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ik(n.key), n);
      }
    }

    function ik(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ak(e, t, r) {
      return t = ck(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ck(e).constructor) : t.apply(e, r));
    }

    function ck(e) {
      return (ck = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function uk(e, t) {
      return (uk = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function lk(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var sk,
        pk = Object(d.observer)((QC = lk((YC = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), nk(r = ak(this, t, [e]), "emails", QC, r), nk(r, "addEmail", $C, r), nk(r, "removeEmail", XC, r), nk(r, "changeEmail", ZC, r), nk(r, "makeEmailPrimary", ek, r);
        var n = r.props.emails;
        return r.emails = (null == n ? void 0 : n.map(function (e) {
          return e.address;
        })) || [], r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && uk(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && ok(e.prototype, t), r && ok(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this,
              t = this.props.t;
          return p.a.createElement(rk, {
            items: this.emails,
            addItem: this.addEmail,
            removeItem: this.removeEmail,
            changeItem: this.changeEmail,
            ListItemChild: function (r) {
              return p.a.createElement("div", {
                className: "d-flex justify-content-end flex-grow-1 px-3"
              }, p.a.createElement("button", {
                className: "btn btn-outline-secondary",
                type: "button",
                onClick: e.makeEmailPrimary(r.item)
              }, t("use_as_primary_email")), p.a.createElement("input", {
                type: "hidden",
                name: "contact[emails][]",
                value: r.item
              }));
            },
            placeholder: t("email")
          });
        }
      }]);
    }()).prototype, "emails", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), $C = lk(YC.prototype, "addEmail", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.emails.find(function (e) {
            return e === t;
          }) || e.emails.push(t);
        };
      }
    }), XC = lk(YC.prototype, "removeEmail", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.emails.findIndex(function (e) {
            return e === t;
          });
          e.emails.splice(r, 1);
        };
      }
    }), ZC = lk(YC.prototype, "changeEmail", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r) {
          var n = e.emails.findIndex(function (e) {
            return e === t;
          });
          e.emails.splice(n, 1, r);
        };
      }
    }), ek = lk(YC.prototype, "makeEmailPrimary", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function () {
            var r = e.emails.findIndex(function (e) {
              return e === t;
            });

            if (-1 !== r) {
              var n = e.emails.splice(r, 1);
              e.emails = n.concat(e.emails);
            }
          };
        };
      }
    }), JC = YC)) || JC,
        fk = Object(g.a)()(pk);

    function dk(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bk(n.key), n);
      }
    }

    function bk(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function yk(e, t, r) {
      return t = mk(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], mk(e).constructor) : t.apply(e, r));
    }

    function mk(e) {
      return (mk = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function vk(e, t) {
      return (vk = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var hk,
        gk = Object(d.observer)(sk = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), yk(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && vk(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && dk(e.prototype, t), r && dk(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.filterFields,
              r = e.t;
          return p.a.createElement("div", {
            className: "field-selector-search"
          }, p.a.createElement("div", {
            className: "form-row align-items-center"
          }, p.a.createElement("div", {
            className: "col"
          }, p.a.createElement(h.SearchBar, {
            placeholder: r("search_by_name_crop_variety"),
            onSearch: function (e) {
              return t(e.target.value);
            }
          }))));
        }
      }]);
    }()) || sk,
        wk = Object(g.a)()(gk);

    function Ok(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, jk(n.key), n);
      }
    }

    function jk(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Pk(e, t, r) {
      return t = _k(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], _k(e).constructor) : t.apply(e, r));
    }

    function _k(e) {
      return (_k = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Ek(e, t) {
      return (Ek = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Sk,
        Ck = Object(d.observer)(hk = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Pk(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ek(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.isChecked,
              r = e.name,
              n = e.label,
              o = e.btnClasses,
              i = e.onClick;
          return p.a.createElement("label", {
            className: "btn".concat(o ? " ".concat(o) : " btn-secondary").concat(t ? " active" : "")
          }, p.a.createElement("input", {
            type: "radio",
            name: r,
            checked: t || "",
            value: t || "",
            onClick: i,
            onChange: function () {}
          }), n);
        }
      }]) && Ok(r.prototype, n), o && Ok(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || hk;

    function kk(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Rk(n.key), n);
      }
    }

    function Rk(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Tk(e, t, r) {
      return t = zk(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], zk(e).constructor) : t.apply(e, r));
    }

    function zk(e) {
      return (zk = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Nk(e, t) {
      return (Nk = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Dk,
        xk,
        Ak,
        Mk = Object(d.observer)(Sk = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Tk(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Nk(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.buttons,
              r = e.onChange;
          return p.a.createElement("div", {
            className: "btn-group btn-group-toggle",
            "data-toggle": "buttons"
          }, t.map(function (e) {
            return p.a.createElement(Ck, Object.assign({}, e, {
              key: e.id,
              onClick: function () {
                return r(e.id);
              }
            }));
          }));
        }
      }]) && kk(r.prototype, n), o && kk(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || Sk;

    function Ik(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Fk(n.key), n);
      }
    }

    function Fk(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Bk(e, t, r) {
      return t = Lk(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Lk(e).constructor) : t.apply(e, r));
    }

    function Lk(e) {
      return (Lk = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Vk(e, t) {
      return (Vk = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Uk(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var qk,
        Kk,
        Gk,
        Wk = Object(d.observer)((Uk((xk = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = Bk(this, t, [e]), "onRegisterCropsModel", Ak, r), r.selectedCropsDisposer = Object(f.reaction)(function () {
          return r.props.selectedCrops;
        }, function (e) {
          r.selectedCrops = e;
        }, {
          fireImmediately: !0
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Vk(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Ik(e.prototype, t), r && Ik(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "cropOptions",
        get: function () {
          return this.props.cropsList.map(function (e) {
            return {
              key: e,
              text: e,
              value: e
            };
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.onChange,
              r = e.t;
          return p.a.createElement(wP, {
            placeholder: r("crop_filter"),
            options: this.cropOptions,
            onChange: t,
            onRegisterModel: this.onRegisterCropsModel
          });
        }
      }]);
    }()).prototype, "cropOptions", [f.computed], Object.getOwnPropertyDescriptor(xk.prototype, "cropOptions"), xk.prototype), Ak = Uk(xk.prototype, "onRegisterCropsModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.cropSelectorModel = t, e.cropSelectorModel.selectedKeys = e.selectedCrops;
        };
      }
    }), Dk = xk)) || Dk,
        Hk = Object(g.a)()(Wk);

    function Jk(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Yk(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Jk(Object(r), !0).forEach(function (t) {
          Qk(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Jk(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Qk(e, t, r) {
      return (t = Xk(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function $k(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Xk(n.key), n);
      }
    }

    function Xk(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Zk(e, t, r) {
      return t = eR(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], eR(e).constructor) : t.apply(e, r));
    }

    function eR(e) {
      return (eR = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function tR(e, t) {
      return (tR = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function rR(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var nR,
        oR,
        iR,
        aR,
        cR = Object(d.observer)((Gk = rR((Kk = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = Zk(this, t, [].concat(n)), "radioButtons", Gk, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && tR(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && $k(e.prototype, t), r && $k(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "radioButtonChoices",
        get: function () {
          var e = this.props.organicFilter;
          return this.radioButtons.map(function (t) {
            return Yk(Yk({}, t), {}, {
              isChecked: e === t.id
            });
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.crops,
              r = e.varieties,
              n = e.cropFilter,
              o = e.varietyFilter,
              i = e.onFilterCrop,
              a = e.onFilterVariety,
              c = e.onFilterOrganic,
              u = e.t;
          return p.a.createElement("div", {
            className: "field-selector-filters"
          }, p.a.createElement("div", {
            className: "form-row align-items-center"
          }, p.a.createElement("div", {
            className: "col-md-auto"
          }, p.a.createElement(Mk, {
            onChange: c,
            buttons: this.radioButtonChoices
          })), p.a.createElement("div", {
            className: "col"
          }, p.a.createElement(Hk, {
            cropsList: t,
            selectedCrops: n,
            onChange: i
          })), p.a.createElement("div", {
            className: "col"
          }, p.a.createElement("select", {
            className: "form-control",
            value: o,
            onChange: function (e) {
              return a(e.target.value);
            }
          }, p.a.createElement("option", {
            value: ""
          }, u("variety_filter")), r.map(function (e) {
            return p.a.createElement("option", {
              key: e,
              value: e
            }, e);
          })))));
        }
      }]);
    }()).prototype, "radioButtons", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [{
          label: "Organic",
          id: "organic"
        }, {
          label: "Conventional",
          id: "conventional"
        }, {
          label: "Both",
          id: "both"
        }];
      }
    }), rR(Kk.prototype, "radioButtonChoices", [f.computed], Object.getOwnPropertyDescriptor(Kk.prototype, "radioButtonChoices"), Kk.prototype), qk = Kk)) || qk,
        uR = Object(g.a)()(cR);

    function lR(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function sR(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, pR(n.key), n);
      }
    }

    function pR(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function fR(e, t, r) {
      return t = dR(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], dR(e).constructor) : t.apply(e, r));
    }

    function dR(e) {
      return (dR = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function bR(e, t) {
      return (bR = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function yR(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    v()(document).off(".data-api");
    var mR,
        vR,
        hR,
        gR,
        wR = Object(d.observer)((iR = yR((oR = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return lR(e = fR(this, t, [].concat(n)), "onClick", iR, e), lR(e, "onChange", aR, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && bR(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "componentDidMount",
        value: function () {
          v()(function () {
            v()('.field-selector-result[data-toggle="tooltip"]').tooltip({
              delay: {
                show: 700
              },
              trigger: "hover"
            });
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.field,
              r = e.title;
          return p.a.createElement("tr", {
            "data-toggle": "tooltip",
            title: r,
            className: "".concat(t.isSelected ? "text-muted " : "", "field-selector-result"),
            onClick: this.onClick
          }, p.a.createElement("td", null, p.a.createElement(oj.a, {
            isDisabled: t.isSelected,
            isChecked: t.isChecked,
            onChange: this.onChange,
            testId: "add-field-".concat(t.id)
          })), p.a.createElement("td", null, t.clientPathFieldName), p.a.createElement("td", {
            className: t.organic ? "organic" : ""
          }, " "), p.a.createElement("td", null, t.cropName), p.a.createElement("td", null, t.varieties.map(function (e) {
            return e.name;
          }).join(", ")), p.a.createElement("td", null, t.acreage));
        }
      }]) && sR(r.prototype, n), o && sR(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "onClick", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.field;
          t.isSelected || t.toggleChecked();
        };
      }
    }), aR = yR(oR.prototype, "onChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.props.field.toggleChecked();
        };
      }
    }), nR = oR)) || nR;

    function OR(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function jR(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, PR(n.key), n);
      }
    }

    function PR(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function _R(e, t, r) {
      return t = ER(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ER(e).constructor) : t.apply(e, r));
    }

    function ER(e) {
      return (ER = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function SR(e, t) {
      return (SR = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function CR(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var kR,
        RR = Object(d.observer)((hR = CR((vR = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return OR(e = _R(this, t, [].concat(n)), "checkAll", hR, e), OR(e, "checkUncheckAll", gR, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && SR(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && jR(e.prototype, t), r && jR(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.fields,
              r = e.accountId,
              n = e.t;
          return p.a.createElement("div", {
            className: "field-selector-results"
          }, p.a.createElement("table", {
            className: "table table-sm table-striped table-hover field-selector-results"
          }, p.a.createElement("thead", {
            className: "thead-light"
          }, p.a.createElement("tr", null, p.a.createElement("th", {
            scope: "col"
          }, p.a.createElement(oj.a, {
            title: "Select/Deselect All",
            isChecked: this.checkAll,
            onChange: this.checkUncheckAll
          })), p.a.createElement("th", {
            scope: "col"
          }, n("name")), p.a.createElement("th", {
            scope: "col"
          }), p.a.createElement("th", {
            scope: "col"
          }, n("crop")), p.a.createElement("th", {
            scope: "col"
          }, n("variety")), p.a.createElement("th", {
            scope: "col"
          }, n("acreage")))), p.a.createElement("tbody", null, t.sort(function (e, t) {
            return Object(h.naturalSort)("".concat(e.account.name, " ").concat(e.name), "".concat(t.account.name, " ").concat(t.name));
          }).map(function (e) {
            return p.a.createElement(wR, {
              key: e.id,
              accountId: r,
              field: e,
              title: e.isSelected ? n("field_has_already_been_added") : null
            });
          }))));
        }
      }]);
    }()).prototype, "checkAll", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !0;
      }
    }), gR = CR(vR.prototype, "checkUncheckAll", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.fields;
          e.checkAll = !e.checkAll, e.checkAll ? t.forEach(function (e) {
            return e.check();
          }) : t.forEach(function (e) {
            return e.isSelected ? null : e.uncheck();
          });
        };
      }
    }), mR = vR)) || mR,
        TR = Object(g.a)()(RR);

    function zR(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, NR(n.key), n);
      }
    }

    function NR(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function DR(e, t, r) {
      return t = xR(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], xR(e).constructor) : t.apply(e, r));
    }

    function xR(e) {
      return (xR = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function AR(e, t) {
      return (AR = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var MR,
        IR,
        FR = Object(d.observer)(kR = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), DR(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && AR(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.accountId,
              r = e.crops,
              n = e.varieties,
              o = e.cropFilter,
              i = e.organicFilter,
              a = e.varietyFilter,
              c = e.filterFields,
              u = e.filteredFields,
              l = e.isPending,
              s = e.onFilterCrop,
              f = e.onFilterVariety,
              d = e.onFilterOrganic,
              b = e.children;
          return p.a.createElement("div", {
            className: "field-selector"
          }, p.a.createElement("div", {
            className: "row align-items-center mb-3"
          }, p.a.createElement("div", {
            className: "col"
          }, p.a.createElement(wk, {
            filterFields: c,
            isPending: l
          }), p.a.createElement(uR, {
            crops: r,
            varieties: n,
            cropFilter: o,
            organicFilter: i,
            varietyFilter: a,
            onFilterCrop: s,
            onFilterVariety: f,
            onFilterOrganic: d
          })), b ? p.a.createElement("div", {
            className: "col-md-auto"
          }, b) : null), l ? p.a.createElement("div", {
            className: "large-spinner py-4"
          }, p.a.createElement(h.Spinner, null)) : u.length > 0 ? p.a.createElement(TR, {
            accountId: t,
            fields: u
          }) : null);
        }
      }]) && zR(r.prototype, n), o && zR(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || kR;

    function BR(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, LR(n.key), n);
      }
    }

    function LR(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function VR(e, t, r) {
      return t = UR(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], UR(e).constructor) : t.apply(e, r));
    }

    function UR(e) {
      return (UR = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function qR(e, t) {
      return (qR = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var KR,
        GR,
        WR,
        HR,
        JR,
        YR = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((IR = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = VR(this, t, [].concat(n))).onBlur = function () {
          return e.props.report.update().catch(console.error);
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && qR(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && BR(e.prototype, t), r && BR(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "feedback",
        get: function () {
          var e = this.props,
              t = e.report,
              r = e.t;
          return t.isInvalid && "blank_title" === t.errors.title ? r("cannot_be_blank") : "";
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.report,
              r = e.t;
          return p.a.createElement("div", {
            className: "col-md-6"
          }, p.a.createElement(LC, {
            ariaLabel: "Report Title",
            inputClassName: t.isInvalid ? "is-invalid" : "",
            title: this.feedback,
            placeholder: r("title_placeholder"),
            value: t.title,
            onBlur: this.onBlur,
            onChange: t.changeTitle
          }));
        }
      }]);
    }()).prototype, "feedback", [f.computed], Object.getOwnPropertyDescriptor(IR.prototype, "feedback"), IR.prototype), MR = IR)) || MR,
        QR = Object(g.a)()(YR),
        $R = r(28);

    function XR(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function ZR(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, eT(n.key), n);
      }
    }

    function eT(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function tT(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var rT,
        nT,
        oT,
        iT,
        aT = ((JR = function () {
      function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), XR(this, "_sortTable", GR, this), XR(this, "addSort", WR, this), XR(this, "removeSort", HR, this), t && this.load(t);
      }

      return t = e, (r = [{
        key: "isSorting",
        value: function (e) {
          return Boolean(this._sortTable[e]);
        }
      }, {
        key: "isSortingDown",
        value: function (e) {
          return this._sortTable[e] === this.constructor.DESC;
        }
      }, {
        key: "isSortingUp",
        value: function (e) {
          return this._sortTable[e] === this.constructor.ASC;
        }
      }, {
        key: "dump",
        value: function () {
          var e = this;
          return Object.keys(this._sortTable || {}).map(function (t) {
            return {
              id: t,
              direction: e._sortTable[t],
              type: "SortConfig"
            };
          });
        }
      }, {
        key: "load",
        value: function (t) {
          var r = this;
          (t || []).forEach(function (t) {
            r._sortTable[t.id] = t.direction || e.ASC;
          });
        }
      }]) && ZR(t.prototype, r), n && ZR(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), t;
      var t, r, n;
    }()).ASC = "asc", JR.DESC = "desc", GR = tT((KR = JR).prototype, "_sortTable", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return {};
      }
    }), WR = tT(KR.prototype, "addSort", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r) {
          var n = r || aT.ASC;
          e.isSorting(t) && e.removeSort(t), e._sortTable[t] = n;
        };
      }
    }), HR = tT(KR.prototype, "removeSort", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          delete e._sortTable[t];
        };
      }
    }), tT(KR.prototype, "load", [f.action], Object.getOwnPropertyDescriptor(KR.prototype, "load"), KR.prototype), KR),
        cT = r(27),
        uT = r(83);

    function lT(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function sT(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, pT(n.key), n);
      }
    }

    function pT(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function fT(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var dT,
        bT,
        yT,
        mT = (nT = fT((rT = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), lT(this, "isShowing", nT, this), lT(this, "position", oT, this), lT(this, "nameOverride", iT, this), this.constructor.validateProps(t), this.position = t.position, this.isShowing = t.isShowing || !1, this.nameOverride = t.nameOverride || "", this.ref = Object(s.createRef)(), this.id = t.id || Object(td.v4)();
      }, r = [{
        key: "requiredProps",
        value: function () {
          return ["position"];
        }
      }, {
        key: "type",
        value: function () {
          return "ColumnSpecBase";
        }
      }, {
        key: "validateMissing",
        value: function (e) {
          if (!e) throw new Error("Missing props");
          var t = [];
          if (this.requiredProps().forEach(function (r) {
            null == e[r] && t.push(r);
          }), t.length) throw new Error("Missing props: ".concat(t.join(", ")));
        }
      }, {
        key: "validateProps",
        value: function (e) {
          this.validateMissing(e);
        }
      }], (t = [{
        key: "changeName",
        value: function (e) {
          this.nameOverride = e;
        }
      }, {
        key: "defaultName",
        value: function () {
          return "";
        }
      }, {
        key: "display",
        value: function (e) {
          var t = Object(x.prop)(this.id, e);
          return null == t || "" === t ? " " : "".concat(t);
        }
      }, {
        key: "errors",
        value: function () {
          return [];
        }
      }, {
        key: "filterType",
        value: function () {}
      }, {
        key: "getName",
        value: function () {
          return this.nameOverride || this.defaultName();
        }
      }, {
        key: "isCalculable",
        value: function () {
          return !1;
        }
      }, {
        key: "updatePosition",
        value: function (e) {
          return this.position = e, this;
        }
      }, {
        key: "toJS",
        value: function () {
          return {
            position: this.position,
            is_showing: this.isShowing,
            name_override: this.nameOverride || this.defaultName(),
            id: this.id,
            type: this.constructor.type()
          };
        }
      }]) && sT(e.prototype, t), r && sT(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "isShowing", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), oT = fT(rT.prototype, "position", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), iT = fT(rT.prototype, "nameOverride", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), fT(rT.prototype, "changeName", [f.action], Object.getOwnPropertyDescriptor(rT.prototype, "changeName"), rT.prototype), fT(rT.prototype, "updatePosition", [f.action], Object.getOwnPropertyDescriptor(rT.prototype, "updatePosition"), rT.prototype), rT);

    function vT(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function hT(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? vT(Object(r), !0).forEach(function (t) {
          gT(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vT(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function gT(e, t, r) {
      return (t = jT(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function wT(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function OT(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, jT(n.key), n);
      }
    }

    function jT(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function PT(e, t, r) {
      return t = kT(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], kT(e).constructor) : t.apply(e, r));
    }

    function _T(e, t) {
      return (_T = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ET(e, t, r, n) {
      var o = ST(kT(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function ST() {
      return (ST = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = CT(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function CT(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = kT(e)););

      return e;
    }

    function kT(e) {
      return (kT = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function RT(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var TT,
        zT,
        NT = (bT = RT((dT = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), wT(r = PT(this, t, [e]), "units", bT, r), wT(r, "referenceColumnSpec", yT, r), r.units = e.units, r.referenceColumnSpec = e.referenceColumnSpec, r.t = e.t, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && _T(e, t);
      }(t, mT), function (e, t, r) {
        return t && OT(e.prototype, t), r && OT(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "defaultName",
        value: function () {
          return this.t("name_in_units", {
            name: this.referenceColumnSpec.getName(),
            units: this.units
          });
        }
      }, {
        key: "isCalculable",
        value: function () {
          return !0;
        }
      }, {
        key: "toJS",
        value: function () {
          return hT(hT({}, ET(t, "toJS", this, 3)([])), {}, {
            units: this.units,
            column_id: this.referenceColumnSpec.id
          });
        }
      }, {
        key: "validateSchema",
        value: function () {
          return Object(cT.validate)(this.toJS(), uT);
        }
      }], [{
        key: "isUnitConversionColumnSpec",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(t.prototype, e);
        }
      }, {
        key: "load",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = e.rawColumnSpec,
              r = e.t,
              n = e.unLoadedSpecCache,
              o = e.loadedSpecCache,
              i = new this({
            id: t.id,
            position: t.position,
            units: t.units,
            referenceColumnSpec: o.get(t.column_id) || n.get(t.column_id),
            nameOverride: t.name_override,
            isShowing: t.is_showing,
            t: r
          });
          return o.set(i.id, i), i;
        }
      }, {
        key: "requiredProps",
        value: function () {
          return ET(t, "requiredProps", this, 2)([]).concat(["units", "referenceColumnSpec", "t"]);
        }
      }, {
        key: "type",
        value: function () {
          return "UnitConversionColumn";
        }
      }]);
    }()).prototype, "units", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), yT = RT(dT.prototype, "referenceColumnSpec", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), dT),
        DT = r(84);

    function xT(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function AT(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? xT(Object(r), !0).forEach(function (t) {
          MT(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xT(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function MT(e, t, r) {
      return (t = FT(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function IT(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, FT(n.key), n);
      }
    }

    function FT(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function BT(e, t, r) {
      return t = KT(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], KT(e).constructor) : t.apply(e, r));
    }

    function LT(e, t) {
      return (LT = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function VT(e, t, r, n) {
      var o = UT(KT(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function UT() {
      return (UT = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = qT(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function qT(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = KT(e)););

      return e;
    }

    function KT(e) {
      return (KT = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var GT,
        WT,
        HT = (zT = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((TT = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = BT(this, t, [e]), "referenceColumnSpec", zT, r), r.referenceColumnSpec = e.referenceColumnSpec, r.t = e.t, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && LT(e, t);
      }(t, mT), function (e, t, r) {
        return t && IT(e.prototype, t), r && IT(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "defaultName",
        value: function () {
          return this.t("name_scalar", {
            name: this.referenceColumnSpec.getName()
          });
        }
      }, {
        key: "display",
        value: function (e) {
          var r = VT(t, "display", this, 3)([e]);
          return " " === r ? r : "1/1" === (r = r.trim()) ? "1" : "".concat(r);
        }
      }, {
        key: "isCalculable",
        value: function () {
          return !0;
        }
      }, {
        key: "toJS",
        value: function () {
          return AT(AT({}, VT(t, "toJS", this, 3)([])), {}, {
            column_id: this.referenceColumnSpec.id
          });
        }
      }, {
        key: "validateSchema",
        value: function () {
          return Object(cT.validate)(this.toJS(), DT);
        }
      }], [{
        key: "isScalarColumnSpec",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(t.prototype, e);
        }
      }, {
        key: "load",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = e.rawColumnSpec,
              r = e.t,
              n = e.unLoadedSpecCache,
              o = e.loadedSpecCache,
              i = new this({
            id: t.id,
            position: t.position,
            referenceColumnSpec: o.get(t.column_id) || n.get(t.column_id),
            nameOverride: t.name_override,
            isShowing: t.is_showing,
            t: r
          });
          return o.set(i.id, i), i;
        }
      }, {
        key: "requiredProps",
        value: function () {
          return VT(t, "requiredProps", this, 2)([]).concat(["referenceColumnSpec", "t"]);
        }
      }, {
        key: "type",
        value: function () {
          return "ScalarColumn";
        }
      }]);
    }()).prototype, "referenceColumnSpec", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), TT),
        JT = r(85);

    function YT(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function QT(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? YT(Object(r), !0).forEach(function (t) {
          $T(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : YT(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function $T(e, t, r) {
      return (t = ZT(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function XT(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ZT(n.key), n);
      }
    }

    function ZT(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ez(e, t, r) {
      return t = iz(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], iz(e).constructor) : t.apply(e, r));
    }

    function tz(e, t) {
      return (tz = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function rz(e, t, r, n) {
      var o = nz(iz(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function nz() {
      return (nz = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = oz(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function oz(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = iz(e)););

      return e;
    }

    function iz(e) {
      return (iz = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var az = (WT = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((GT = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = ez(this, t, [e]), "referenceColumnSpec", WT, r), r.referenceColumnSpec = e.referenceColumnSpec, r.t = e.t, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && tz(e, t);
      }(t, mT), function (e, t, r) {
        return t && XT(e.prototype, t), r && XT(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "defaultName",
        value: function () {
          return this.t("name_units", {
            name: this.referenceColumnSpec.getName()
          });
        }
      }, {
        key: "isCalculable",
        value: function () {
          return !0;
        }
      }, {
        key: "toJS",
        value: function () {
          return QT(QT({}, rz(t, "toJS", this, 3)([])), {}, {
            column_id: this.referenceColumnSpec.id
          });
        }
      }, {
        key: "validateSchema",
        value: function () {
          return Object(cT.validate)(this.toJS(), JT);
        }
      }], [{
        key: "isUnitsColumnSpec",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(t.prototype, e);
        }
      }, {
        key: "load",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = e.rawColumnSpec,
              r = e.t,
              n = e.unLoadedSpecCache,
              o = e.loadedSpecCache,
              i = new this({
            id: t.id,
            position: t.position,
            referenceColumnSpec: o.get(t.column_id) || n.get(t.column_id),
            nameOverride: t.name_override,
            isShowing: t.is_showing,
            t: r
          });
          return o.set(i.id, i), i;
        }
      }, {
        key: "requiredProps",
        value: function () {
          return rz(t, "requiredProps", this, 2)([]).concat(["referenceColumnSpec", "t"]);
        }
      }, {
        key: "type",
        value: function () {
          return "UnitsColumn";
        }
      }]);
    }()).prototype, "referenceColumnSpec", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), GT);

    function cz(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, uz(n.key), n);
      }
    }

    function uz(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var lz = function () {
      return e = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
      }, r = [{
        key: "type",
        value: function () {
          return "CalculationOperandSpecBase";
        }
      }], (t = [{
        key: "getName",
        value: function () {
          return "";
        }
      }, {
        key: "getValue",
        value: function (e) {}
      }, {
        key: "toJS",
        value: function () {
          return {
            type: this.constructor.type()
          };
        }
      }]) && cz(e.prototype, t), r && cz(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function sz(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function pz(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? sz(Object(r), !0).forEach(function (t) {
          fz(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : sz(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function fz(e, t, r) {
      return (t = bz(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function dz(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bz(n.key), n);
      }
    }

    function bz(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function yz(e, t, r) {
      return t = hz(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], hz(e).constructor) : t.apply(e, r));
    }

    function mz() {
      return (mz = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = vz(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function vz(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = hz(e)););

      return e;
    }

    function hz(e) {
      return (hz = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function gz(e, t) {
      return (gz = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var wz,
        Oz,
        jz,
        Pz,
        _z = function (e) {
      function t(e) {
        var r;
        if (function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = yz(this, t, [e])).referenceColumnSpec = e.referenceColumnSpec, !r.referenceColumnSpec) throw new Error("Missing referenceColumnSpec!");
        return r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && gz(e, t);
      }(t, lz), function (e, t, r) {
        return t && dz(e.prototype, t), r && dz(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "getName",
        value: function () {
          return this.referenceColumnSpec.getName();
        }
      }, {
        key: "getValue",
        value: function (e) {
          return this.referenceColumnSpec.display(e);
        }
      }, {
        key: "toJS",
        value: function () {
          return pz(pz({}, (e = t, r = "toJS", n = this, i = mz(hz(1 & (o = 3) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([])), {}, {
            id: this.referenceColumnSpec.id
          });
          var e, r, n, o, i;
        }
      }], [{
        key: "isColumnCalculationOperandSpec",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(t.prototype, e);
        }
      }, {
        key: "type",
        value: function () {
          return "ColumnCalculationOperand";
        }
      }]);
    }();

    function Ez(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Sz(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Cz(n.key), n);
      }
    }

    function Cz(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function kz(e, t, r) {
      return t = Dz(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Dz(e).constructor) : t.apply(e, r));
    }

    function Rz(e, t) {
      return (Rz = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Tz(e, t, r, n) {
      var o = zz(Dz(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function zz() {
      return (zz = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Nz(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Nz(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = Dz(e)););

      return e;
    }

    function Dz(e) {
      return (Dz = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function xz(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Az = (Oz = xz((wz = function (e) {
      function t(e) {
        var n;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Ez(n = kz(this, t, [e]), "calculation", Oz, n), Ez(n, "operand1", jz, n), Ez(n, "operand2", Pz, n), n.validator = void 0, n.calculation = e.calculation, n.operand1 = e.operand1, n.operand2 = e.operand2, n.validator = new cT.Validator();
        var o = r(335);
        return o.keys().forEach(function (e) {
          n.validator.addSchema(o(e), e.replace("./", "/"));
        }), n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Rz(e, t);
      }(t, mT), n = t, i = [{
        key: "getRawOperandKeys",
        value: function () {
          return ["operand1", "operand2"];
        }
      }, {
        key: "getOperandName",
        value: function (e) {
          return _z.isColumnCalculationOperandSpec(e) && this.isCalculationColumnSpec(e.referenceColumnSpec) ? "(".concat(e.getName(), ")") : e.getName();
        }
      }, {
        key: "getRawOperands",
        value: function (e) {
          var t = e.rawColumnSpec;
          return this.getRawOperandKeys().map(function (e) {
            return t[e];
          });
        }
      }, {
        key: "isCalculationColumnSpec",
        value: function (e) {
          var t;
          return (null === (t = e.isCalculationColumnSpec) || void 0 === t ? void 0 : t.call(e)) || !1;
        }
      }, {
        key: "requiredProps",
        value: function () {
          return Tz(t, "requiredProps", this, 2)([]).concat(["calculation", "operand1"]);
        }
      }, {
        key: "type",
        value: function () {
          throw new Error("CalculatedColumnSpec is an abstract class.  Its type should be overridden by concrete implementation");
        }
      }], (o = [{
        key: "defaultName",
        value: function () {
          var e = this,
              t = this.getOperands().map(function (t) {
            return e.constructor.getOperandName(t);
          });
          return this.calculation.display(t);
        }
      }, {
        key: "errors",
        value: function (e) {
          var t;
          return (null === (t = this.calculate(e)) || void 0 === t ? void 0 : t.errors) || [];
        }
      }, {
        key: "calculate",
        value: function (e) {
          var t = this.getOperands().map(function (t) {
            return t.getValue(e);
          });
          return this.calculation.calculate(t);
        }
      }, {
        key: "getOperands",
        value: function () {
          return [this.operand1, this.operand2];
        }
      }, {
        key: "isCalculable",
        value: function () {
          return !0;
        }
      }, {
        key: "isCalculationColumnSpec",
        value: function () {
          return !0;
        }
      }, {
        key: "toJS",
        value: function () {
          var e = Tz(t, "toJS", this, 3)([]),
              r = this.getOperands();
          return this.constructor.getRawOperandKeys().forEach(function (t, n) {
            e[t] = r[n].toJS();
          }), e;
        }
      }, {
        key: "validateSchema",
        value: function () {
          throw new Error("CalculatedColumnSpec is an abstract class.  Concrete implementation should validate against appropriate schema");
        }
      }]) && Sz(n.prototype, o), i && Sz(n, i), Object.defineProperty(n, "prototype", {
        writable: !1
      }), n;
      var n, o, i;
    }()).prototype, "calculation", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), jz = xz(wz.prototype, "operand1", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Pz = xz(wz.prototype, "operand2", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), wz),
        Mz = r(86);

    function Iz(e, t, r) {
      return t = Vz(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, Bz() ? Reflect.construct(t, r || [], Vz(e).constructor) : t.apply(e, r));
    }

    function Fz(e) {
      var t = "function" == typeof Map ? new Map() : void 0;
      return (Fz = function (e) {
        if (null === e || !function (e) {
          try {
            return -1 !== Function.toString.call(e).indexOf("[native code]");
          } catch (t) {
            return "function" == typeof e;
          }
        }(e)) return e;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, r);
        }

        function r() {
          return function (e, t, r) {
            if (Bz()) return Reflect.construct.apply(null, arguments);
            var n = [null];
            n.push.apply(n, t);
            var o = new (e.bind.apply(e, n))();
            return r && Lz(o, r.prototype), o;
          }(e, arguments, Vz(this).constructor);
        }

        return r.prototype = Object.create(e.prototype, {
          constructor: {
            value: r,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), Lz(r, e);
      })(e);
    }

    function Bz() {
      try {
        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch (e) {}

      return (Bz = function () {
        return !!e;
      })();
    }

    function Lz(e, t) {
      return (Lz = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Vz(e) {
      return (Vz = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Uz(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function qz(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Gz(n.key), n);
      }
    }

    function Kz(e, t, r) {
      return t && qz(e.prototype, t), r && qz(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function Gz(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var Wz = function () {
      return Kz(function e(t) {
        if (Uz(this, e), null == t || !t.t) throw new Error("Must provide translation function");
        this.t = t.t;
      }, [{
        key: "allowConstantOperands",
        value: function () {
          return !1;
        }
      }, {
        key: "arity",
        value: function () {
          throw new Error("CalculationBase `arity()` method should be overridden");
        }
      }, {
        key: "validateOperands",
        value: function (e) {
          return !Array.isArray(e) || e.length < this.arity() ? [new this.constructor.OperandsMissingError(this.t)] : [];
        }
      }, {
        key: "calculate",
        value: function (e) {
          return {
            result: null,
            errors: this.validateOperands(e)
          };
        }
      }, {
        key: "display",
        value: function () {
          throw new Error("CalculationBase `display()` method should be overridden");
        }
      }], [{
        key: "isOperandsMissingError",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(this.OperandsMissingError.prototype, e);
        }
      }, {
        key: "operatorSymbol",
        value: function () {
          throw new Error("CalculationBase `static operatorSymbol()` method should be overridden");
        }
      }, {
        key: "operatorId",
        value: function () {
          throw new Error("CalculationBase `static operatorId()` method should be overridden");
        }
      }]);
    }();

    function Hz(e) {
      var t = "function" == typeof Map ? new Map() : void 0;
      return (Hz = function (e) {
        if (null === e || !function (e) {
          try {
            return -1 !== Function.toString.call(e).indexOf("[native code]");
          } catch (t) {
            return "function" == typeof e;
          }
        }(e)) return e;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, r);
        }

        function r() {
          return function (e, t, r) {
            if (Zz()) return Reflect.construct.apply(null, arguments);
            var n = [null];
            n.push.apply(n, t);
            var o = new (e.bind.apply(e, n))();
            return r && oN(o, r.prototype), o;
          }(e, arguments, rN(this).constructor);
        }

        return r.prototype = Object.create(e.prototype, {
          constructor: {
            value: r,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), oN(r, e);
      })(e);
    }

    function Jz(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Yz(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $z(n.key), n);
      }
    }

    function Qz(e, t, r) {
      return t && Yz(e.prototype, t), r && Yz(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function $z(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Xz(e, t, r) {
      return t = rN(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, Zz() ? Reflect.construct(t, r || [], rN(e).constructor) : t.apply(e, r));
    }

    function Zz() {
      try {
        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch (e) {}

      return (Zz = function () {
        return !!e;
      })();
    }

    function eN() {
      return (eN = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = tN(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function tN(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = rN(e)););

      return e;
    }

    function rN(e) {
      return (rN = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function nN(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && oN(e, t);
    }

    function oN(e, t) {
      return (oN = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    Wz.OperandsMissingError = function (e) {
      function t(e) {
        var r;
        return Uz(this, t), (r = Iz(this, t, [e("operands_missing_error")])).name = "OperandsMissingError", r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Lz(e, t);
      }(t, Fz(Error)), Kz(t);
    }();

    var iN = function (e) {
      function t() {
        return Jz(this, t), Xz(this, t, arguments);
      }

      return nN(t, Wz), Qz(t, [{
        key: "allowConstantOperands",
        value: function () {
          return !0;
        }
      }, {
        key: "arity",
        value: function () {
          return 2;
        }
      }, {
        key: "validateOperands",
        value: function (e) {
          var r,
              n,
              o,
              i,
              a,
              c = this,
              u = (r = t, n = "validateOperands", o = this, a = eN(rN(1 & (i = 3) ? r.prototype : r), n, o), 2 & i && "function" == typeof a ? function (e) {
            return a.apply(o, e);
          } : a)([e]);
          if (u.length) return u;
          var l = new w.Quantity(e[0]),
              s = new w.Quantity(e[1]),
              p = [];
          return [l, s].forEach(function (t, r) {
            null != e[r] && "" !== e[r] ? t.isBlank && p.push(new c.constructor.InvalidOperandError(e[r], r, c.t)) : p.push(new c.constructor.BlankOperandError(e[r], r, c.t));
          }), p.length ? p : [];
        }
      }, {
        key: "display",
        value: function (e) {
          return "".concat(e[0], " ").concat(this.constructor.operatorSymbol(), " ").concat(e[1]);
        }
      }], [{
        key: "isInvalidOperandError",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(this.InvalidOperandError.prototype, e);
        }
      }, {
        key: "isBlankOperandError",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(this.BlankOperandError.prototype, e);
        }
      }, {
        key: "isIncompatibleUnitsError",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(this.IncompatibleUnitsError.prototype, e);
        }
      }]);
    }();

    function aN(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, cN(n.key), n);
      }
    }

    function cN(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function uN(e, t, r) {
      return t = fN(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], fN(e).constructor) : t.apply(e, r));
    }

    function lN(e, t, r, n) {
      var o = sN(fN(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function sN() {
      return (sN = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = pN(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function pN(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = fN(e)););

      return e;
    }

    function fN(e) {
      return (fN = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function dN(e, t) {
      return (dN = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    iN.InvalidOperandError = function (e) {
      function t(e, r, n) {
        var o;
        return Jz(this, t), (o = Xz(this, t, [n("invalid_operand_error", {
          leftOrRightOperand: n(0 === r ? "left_operand" : "right_operand"),
          operandValue: w.Quantity.isQuantity(e) && e.displayValue || e
        })])).operand = e, o.index = r, o.name = "InvalidOperandError", o;
      }

      return nN(t, Hz(Error)), Qz(t);
    }(), iN.BlankOperandError = function (e) {
      function t(e, r, n) {
        var o;
        return Jz(this, t), (o = Xz(this, t, [n("blank_operand_error", {
          leftOrRightOperand: n(0 === r ? "left_operand" : "right_operand"),
          typeOfBlank: e
        })])).operand = e, o.index = r, o.name = "BlankOperandError", o;
      }

      return nN(t, Hz(Error)), Qz(t);
    }(), iN.IncompatibleUnitsError = function (e) {
      function t(e, r, n) {
        var o;
        return Jz(this, t), (o = Xz(this, t, [n("incompatible_units_error", {
          firstUnit: e,
          secondUnit: r
        })])).op1Units = e, o.op2Units = r, o.name = "IncompatibleUnitsError", o;
      }

      return nN(t, Hz(Error)), Qz(t);
    }();

    var bN = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), uN(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && dN(e, t);
      }(t, iN), r = t, o = [{
        key: "operatorSymbol",
        value: function () {
          return "+";
        }
      }, {
        key: "operatorId",
        value: function () {
          return "add";
        }
      }], (n = [{
        key: "validateOperands",
        value: function (e) {
          var r = lN(t, "validateOperands", this, 3)([e]);
          if (r.length) return r;
          var n = new w.Quantity(e[0]),
              o = new w.Quantity(e[1]);
          return n.units === o.units || w.Quantity.isCompatible(n, o) || r.push(new this.constructor.IncompatibleUnitsError(n.units, o.units, this.t)), r;
        }
      }, {
        key: "calculate",
        value: function (e) {
          var r,
              n = lN(t, "calculate", this, 3)([e]);

          if (null !== (r = n.errors) && void 0 !== r && r.length) {
            if (n.errors.find(function (e) {
              return t.isOperandsMissingError(e);
            })) return n;
            if (n.errors.find(function (e) {
              return t.isInvalidOperandError(e);
            })) return n;
            var o = !1,
                i = e.slice();

            if (n.errors.forEach(function (e) {
              t.isBlankOperandError(e) && (i[e.index] = 0, o = !0);
            }), o) {
              var a = i.find(function (e) {
                return 0 !== e;
              });
              n.result = a && new w.Quantity(a) || null;
            }

            return n;
          }

          return n.result = new w.Quantity(e[0]).add(new w.Quantity(e[1])), n;
        }
      }]) && aN(r.prototype, n), o && aN(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function yN(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function mN(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? yN(Object(r), !0).forEach(function (t) {
          vN(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yN(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function vN(e, t, r) {
      return (t = gN(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function hN(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, gN(n.key), n);
      }
    }

    function gN(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function wN(e, t, r) {
      return t = _N(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], _N(e).constructor) : t.apply(e, r));
    }

    function ON(e, t) {
      return (ON = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function jN() {
      return (jN = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = PN(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function PN(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = _N(e)););

      return e;
    }

    function _N(e) {
      return (_N = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var EN = function (e) {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
        var r = e.t;
        return wN(this, t, [mN(mN({}, e), {}, {
          calculation: new bN({
            t: r
          })
        })]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ON(e, t);
      }(t, Az), function (e, t, r) {
        return t && hN(e.prototype, t), r && hN(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "validateSchema",
        value: function () {
          return this.validator.validate(this.toJS(), Mz);
        }
      }], [{
        key: "requiredProps",
        value: function () {
          return (e = t, r = "requiredProps", n = this, o = 2, i = jN(_N(1 & o ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]).concat(["operand2", "t"]);
          var e, r, n, o, i;
        }
      }, {
        key: "type",
        value: function () {
          return "AdditionColumn";
        }
      }]);
    }(),
        SN = r(93);

    function CN(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, kN(n.key), n);
      }
    }

    function kN(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function RN(e, t, r) {
      return t = DN(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], DN(e).constructor) : t.apply(e, r));
    }

    function TN(e, t, r, n) {
      var o = zN(DN(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function zN() {
      return (zN = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = NN(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function NN(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = DN(e)););

      return e;
    }

    function DN(e) {
      return (DN = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function xN(e, t) {
      return (xN = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var AN = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), RN(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && xN(e, t);
      }(t, iN), r = t, o = [{
        key: "operatorSymbol",
        value: function () {
          return "−";
        }
      }, {
        key: "operatorId",
        value: function () {
          return "subtract";
        }
      }], (n = [{
        key: "validateOperands",
        value: function (e) {
          var r = TN(t, "validateOperands", this, 3)([e]);
          if (r.length) return r;
          var n = new w.Quantity(e[0]),
              o = new w.Quantity(e[1]);
          return n.units === o.units || w.Quantity.isCompatible(n, o) || r.push(new this.constructor.IncompatibleUnitsError(n.units, o.units, this.t)), r;
        }
      }, {
        key: "calculate",
        value: function (e) {
          var r,
              n = TN(t, "calculate", this, 3)([e]);

          if (null !== (r = n.errors) && void 0 !== r && r.length) {
            if (n.errors.find(function (e) {
              return t.isOperandsMissingError(e);
            })) return n;
            if (n.errors.find(function (e) {
              return t.isInvalidOperandError(e);
            })) return n;
            var o = n.errors.filter(function (e) {
              return t.isBlankOperandError(e);
            });

            if (1 === o.length) {
              var i = 0 === o[0].index ? new w.Quantity(e[1]) : new w.Quantity(e[0]),
                  a = new w.Quantity(i.toJS());
              a.updateScalar(0), n.result = 0 === o[0].index ? a.sub(i) : i;
            }

            return n;
          }

          return n.result = new w.Quantity(e[0]).sub(new w.Quantity(e[1])), n;
        }
      }]) && CN(r.prototype, n), o && CN(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function MN(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function IN(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? MN(Object(r), !0).forEach(function (t) {
          FN(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : MN(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function FN(e, t, r) {
      return (t = LN(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function BN(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, LN(n.key), n);
      }
    }

    function LN(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function VN(e, t, r) {
      return t = GN(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], GN(e).constructor) : t.apply(e, r));
    }

    function UN(e, t) {
      return (UN = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function qN() {
      return (qN = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = KN(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function KN(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = GN(e)););

      return e;
    }

    function GN(e) {
      return (GN = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var WN = function (e) {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
        var r = e.t;
        return VN(this, t, [IN(IN({}, e), {}, {
          calculation: new AN({
            t: r
          })
        })]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && UN(e, t);
      }(t, Az), function (e, t, r) {
        return t && BN(e.prototype, t), r && BN(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "validateSchema",
        value: function () {
          return this.validator.validate(this.toJS(), SN);
        }
      }], [{
        key: "requiredProps",
        value: function () {
          return (e = t, r = "requiredProps", n = this, o = 2, i = qN(GN(1 & o ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]).concat(["operand2", "t"]);
          var e, r, n, o, i;
        }
      }, {
        key: "type",
        value: function () {
          return "SubtractionColumn";
        }
      }]);
    }(),
        HN = r(90);

    function JN(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, YN(n.key), n);
      }
    }

    function YN(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function QN(e, t, r) {
      return t = ZN(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ZN(e).constructor) : t.apply(e, r));
    }

    function $N() {
      return ($N = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = XN(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function XN(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = ZN(e)););

      return e;
    }

    function ZN(e) {
      return (ZN = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function eD(e, t) {
      return (eD = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var tD = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), QN(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && eD(e, t);
      }(t, iN), function (e, t, r) {
        return t && JN(e.prototype, t), r && JN(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "calculate",
        value: function (e) {
          var r,
              n,
              o,
              i,
              a,
              c,
              u = (n = t, o = "calculate", i = this, c = $N(ZN(1 & (a = 3) ? n.prototype : n), o, i), 2 & a && "function" == typeof c ? function (e) {
            return c.apply(i, e);
          } : c)([e]);
          return null !== (r = u.errors) && void 0 !== r && r.length ? u : (u.result = new w.Quantity(e[0]).mul(new w.Quantity(e[1])), u);
        }
      }], [{
        key: "operatorSymbol",
        value: function () {
          return "×";
        }
      }, {
        key: "operatorId",
        value: function () {
          return "multiply";
        }
      }]);
    }();

    function rD(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function nD(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? rD(Object(r), !0).forEach(function (t) {
          oD(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : rD(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function oD(e, t, r) {
      return (t = aD(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function iD(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, aD(n.key), n);
      }
    }

    function aD(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function cD(e, t, r) {
      return t = pD(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], pD(e).constructor) : t.apply(e, r));
    }

    function uD(e, t) {
      return (uD = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function lD() {
      return (lD = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = sD(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function sD(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = pD(e)););

      return e;
    }

    function pD(e) {
      return (pD = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var fD = function (e) {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
        var r = e.t;
        return cD(this, t, [nD(nD({}, e), {}, {
          calculation: new tD({
            t: r
          })
        })]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && uD(e, t);
      }(t, Az), function (e, t, r) {
        return t && iD(e.prototype, t), r && iD(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "validateSchema",
        value: function () {
          return this.validator.validate(this.toJS(), HN);
        }
      }], [{
        key: "requiredProps",
        value: function () {
          return (e = t, r = "requiredProps", n = this, o = 2, i = lD(pD(1 & o ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]).concat(["operand2", "t"]);
          var e, r, n, o, i;
        }
      }, {
        key: "type",
        value: function () {
          return "MultiplicationColumn";
        }
      }]);
    }(),
        dD = r(88);

    function bD(e) {
      var t = "function" == typeof Map ? new Map() : void 0;
      return (bD = function (e) {
        if (null === e || !function (e) {
          try {
            return -1 !== Function.toString.call(e).indexOf("[native code]");
          } catch (t) {
            return "function" == typeof e;
          }
        }(e)) return e;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, r);
        }

        function r() {
          return function (e, t, r) {
            if (wD()) return Reflect.construct.apply(null, arguments);
            var n = [null];
            n.push.apply(n, t);
            var o = new (e.bind.apply(e, n))();
            return r && SD(o, r.prototype), o;
          }(e, arguments, _D(this).constructor);
        }

        return r.prototype = Object.create(e.prototype, {
          constructor: {
            value: r,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), SD(r, e);
      })(e);
    }

    function yD(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function mD(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, hD(n.key), n);
      }
    }

    function vD(e, t, r) {
      return t && mD(e.prototype, t), r && mD(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function hD(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function gD(e, t, r) {
      return t = _D(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, wD() ? Reflect.construct(t, r || [], _D(e).constructor) : t.apply(e, r));
    }

    function wD() {
      try {
        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch (e) {}

      return (wD = function () {
        return !!e;
      })();
    }

    function OD(e, t, r, n) {
      var o = jD(_D(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function jD() {
      return (jD = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = PD(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function PD(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = _D(e)););

      return e;
    }

    function _D(e) {
      return (_D = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ED(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && SD(e, t);
    }

    function SD(e, t) {
      return (SD = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var CD = function (e) {
      function t() {
        return yD(this, t), gD(this, t, arguments);
      }

      return ED(t, iN), vD(t, [{
        key: "validateOperands",
        value: function (e) {
          var r = OD(t, "validateOperands", this, 3)([e]);
          return r.length ? r : (new w.Quantity(e[1]).isZero() && r.push(new this.constructor.DivideByZeroError()), r);
        }
      }, {
        key: "calculate",
        value: function (e) {
          var r,
              n = OD(t, "calculate", this, 3)([e]);
          return null !== (r = n.errors) && void 0 !== r && r.length ? n : (n.result = new w.Quantity(e[0]).div(new w.Quantity(e[1])), n);
        }
      }], [{
        key: "isDivideByZeroError",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(this.DivideByZeroError.prototype, e);
        }
      }, {
        key: "operatorSymbol",
        value: function () {
          return "÷";
        }
      }, {
        key: "operatorId",
        value: function () {
          return "divide";
        }
      }]);
    }();

    function kD(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function RD(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? kD(Object(r), !0).forEach(function (t) {
          TD(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : kD(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function TD(e, t, r) {
      return (t = ND(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function zD(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ND(n.key), n);
      }
    }

    function ND(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function DD(e, t, r) {
      return t = ID(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ID(e).constructor) : t.apply(e, r));
    }

    function xD(e, t) {
      return (xD = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function AD() {
      return (AD = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = MD(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function MD(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = ID(e)););

      return e;
    }

    function ID(e) {
      return (ID = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    CD.DivideByZeroError = function (e) {
      function t() {
        var e;
        return yD(this, t), (e = gD(this, t, ["Divide by zero"])).name = "DivideByZeroError", e;
      }

      return ED(t, bD(Error)), vD(t);
    }();

    var FD = function (e) {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
        var r = e.t;
        return DD(this, t, [RD(RD({}, e), {}, {
          calculation: new CD({
            t: r
          })
        })]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && xD(e, t);
      }(t, Az), function (e, t, r) {
        return t && zD(e.prototype, t), r && zD(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "validateSchema",
        value: function () {
          return this.validator.validate(this.toJS(), dD);
        }
      }], [{
        key: "requiredProps",
        value: function () {
          return (e = t, r = "requiredProps", n = this, o = 2, i = AD(ID(1 & o ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]).concat(["operand2", "t"]);
          var e, r, n, o, i;
        }
      }, {
        key: "type",
        value: function () {
          return "DivisionColumn";
        }
      }]);
    }(),
        BD = r(87);

    function LD(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (null != r) {
          var n,
              o,
              i,
              a,
              c = [],
              u = !0,
              l = !1;

          try {
            if (i = (r = r.call(e)).next, 0 === t) {
              if (Object(r) !== r) return;
              u = !1;
            } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== t); u = !0);
          } catch (e) {
            l = !0, o = e;
          } finally {
            try {
              if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
            } finally {
              if (l) throw o;
            }
          }

          return c;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return VD(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? VD(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function VD(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function UD(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qD(n.key), n);
      }
    }

    function qD(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function KD(e, t, r) {
      return t = GD(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], GD(e).constructor) : t.apply(e, r));
    }

    function GD(e) {
      return (GD = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function WD(e, t) {
      return (WD = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var HD = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), KD(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && WD(e, t);
      }(t, Wz), r = t, (n = [{
        key: "arity",
        value: function () {
          return 1;
        }
      }, {
        key: "display",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              t = LD(e, 1),
              r = t[0];
          return "".concat(this.constructor.operatorSymbol(), "( ").concat(r, " )");
        }
      }]) && UD(r.prototype, n), o && UD(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function JD(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (null != r) {
          var n,
              o,
              i,
              a,
              c = [],
              u = !0,
              l = !1;

          try {
            if (i = (r = r.call(e)).next, 0 === t) {
              if (Object(r) !== r) return;
              u = !1;
            } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== t); u = !0);
          } catch (e) {
            l = !0, o = e;
          } finally {
            try {
              if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
            } finally {
              if (l) throw o;
            }
          }

          return c;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return YD(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? YD(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function YD(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function QD(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $D(n.key), n);
      }
    }

    function $D(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function XD(e, t, r) {
      return t = rx(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], rx(e).constructor) : t.apply(e, r));
    }

    function ZD(e, t, r, n) {
      var o = ex(rx(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function ex() {
      return (ex = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = tx(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function tx(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = rx(e)););

      return e;
    }

    function rx(e) {
      return (rx = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function nx(e, t) {
      return (nx = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var ox = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), XD(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && nx(e, t);
      }(t, HD), r = t, o = [{
        key: "operatorSymbol",
        value: function () {
          return "ISBLANK";
        }
      }, {
        key: "operatorId",
        value: function () {
          return "blank";
        }
      }], (n = [{
        key: "calculate",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              r = ZD(t, "calculate", this, 3)([e]),
              n = JD(e, 1),
              o = n[0];
          return r.result = null == o || "function" == typeof o.trim && "" === o.trim(), r;
        }
      }]) && QD(r.prototype, n), o && QD(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }(),
        ix = ["column_id"];

    function ax(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function cx(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ax(Object(r), !0).forEach(function (t) {
          ux(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ax(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function ux(e, t, r) {
      return (t = sx(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function lx(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, sx(n.key), n);
      }
    }

    function sx(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function px(e, t, r) {
      return t = bx(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], bx(e).constructor) : t.apply(e, r));
    }

    function fx() {
      return (fx = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = dx(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function dx(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = bx(e)););

      return e;
    }

    function bx(e) {
      return (bx = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function yx(e, t) {
      return (yx = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var mx = function (e) {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
        var r = e.t;
        return px(this, t, [cx(cx({}, e), {}, {
          calculation: new ox({
            t: r
          })
        })]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && yx(e, t);
      }(t, Az), function (e, t, r) {
        return t && lx(e.prototype, t), r && lx(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "getOperands",
        value: function () {
          return [this.operand1];
        }
      }, {
        key: "toJS",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "toJS", n = this, i = fx(bx(1 & (o = 3) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]),
              c = a.column_id;
          return cx(cx({}, function (e, t) {
            if (null == e) return {};

            var r,
                n,
                o = function (e, t) {
              if (null == e) return {};
              var r = {};

              for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
                if (t.includes(n)) continue;
                r[n] = e[n];
              }

              return r;
            }(e, t);

            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);

              for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
            }

            return o;
          }(a, ix)), {}, {
            column_id: c.id
          });
        }
      }, {
        key: "validateSchema",
        value: function () {
          return this.validator.validate(this.toJS(), BD);
        }
      }], [{
        key: "getRawOperandKeys",
        value: function () {
          return ["column_id"];
        }
      }, {
        key: "getRawOperands",
        value: function (e) {
          var t = e.rawColumnSpec,
              r = e.unLoadedSpecCache;
          return this.getRawOperandKeys().map(function (e) {
            return r.get(t[e]);
          });
        }
      }, {
        key: "type",
        value: function () {
          return "BlankColumn";
        }
      }]);
    }();

    function vx(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function hx(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? vx(Object(r), !0).forEach(function (t) {
          gx(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vx(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function gx(e, t, r) {
      return (t = Ox(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function wx(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ox(n.key), n);
      }
    }

    function Ox(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function jx(e, t, r) {
      return t = Ex(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Ex(e).constructor) : t.apply(e, r));
    }

    function Px() {
      return (Px = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = _x(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function _x(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = Ex(e)););

      return e;
    }

    function Ex(e) {
      return (Ex = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Sx(e, t) {
      return (Sx = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Cx = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = jx(this, t, [e])).value = e.value, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Sx(e, t);
      }(t, lz), function (e, t, r) {
        return t && wx(e.prototype, t), r && wx(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "getName",
        value: function () {
          return this.value;
        }
      }, {
        key: "getValue",
        value: function (e) {
          return this.value;
        }
      }, {
        key: "toJS",
        value: function () {
          return hx(hx({}, (e = t, r = "toJS", n = this, i = Px(Ex(1 & (o = 3) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([])), {}, {
            value: this.value
          });
          var e, r, n, o, i;
        }
      }], [{
        key: "isConstantCalculationOperandSpec",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(t.prototype, e);
        }
      }, {
        key: "type",
        value: function () {
          return "ConstantCalculationOperand";
        }
      }]);
    }(),
        kx = r(91);

    function Rx(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (null != r) {
          var n,
              o,
              i,
              a,
              c = [],
              u = !0,
              l = !1;

          try {
            if (i = (r = r.call(e)).next, 0 === t) {
              if (Object(r) !== r) return;
              u = !1;
            } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== t); u = !0);
          } catch (e) {
            l = !0, o = e;
          } finally {
            try {
              if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
            } finally {
              if (l) throw o;
            }
          }

          return c;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return Tx(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Tx(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Tx(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function zx(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Nx(n.key), n);
      }
    }

    function Nx(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Dx(e, t, r) {
      return t = Ix(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Ix(e).constructor) : t.apply(e, r));
    }

    function xx(e, t, r, n) {
      var o = Ax(Ix(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function Ax() {
      return (Ax = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Mx(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Mx(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = Ix(e)););

      return e;
    }

    function Ix(e) {
      return (Ix = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Fx(e, t) {
      return (Fx = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Bx = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Dx(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Fx(e, t);
      }(t, HD), r = t, o = [{
        key: "operatorSymbol",
        value: function () {
          return "NOT";
        }
      }, {
        key: "operatorId",
        value: function () {
          return "not";
        }
      }], (n = [{
        key: "calculate",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              r = xx(t, "calculate", this, 3)([e]),
              n = Rx(e, 1),
              o = n[0];
          return !1 === o && (r.result = !0), !0 === o && (r.result = !1), r;
        }
      }]) && zx(r.prototype, n), o && zx(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }(),
        Lx = ["column_id"];

    function Vx(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Ux(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Vx(Object(r), !0).forEach(function (t) {
          qx(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Vx(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function qx(e, t, r) {
      return (t = Gx(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Kx(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Gx(n.key), n);
      }
    }

    function Gx(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Wx(e, t, r) {
      return t = Yx(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Yx(e).constructor) : t.apply(e, r));
    }

    function Hx() {
      return (Hx = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Jx(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Jx(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = Yx(e)););

      return e;
    }

    function Yx(e) {
      return (Yx = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Qx(e, t) {
      return (Qx = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var $x = function (e) {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
        var r = e.t;
        return Wx(this, t, [Ux(Ux({}, e), {}, {
          calculation: new Bx({
            t: r
          })
        })]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Qx(e, t);
      }(t, Az), function (e, t, r) {
        return t && Kx(e.prototype, t), r && Kx(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "getOperands",
        value: function () {
          return [this.operand1];
        }
      }, {
        key: "toJS",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "toJS", n = this, i = Hx(Yx(1 & (o = 3) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]),
              c = a.column_id;
          return Ux(Ux({}, function (e, t) {
            if (null == e) return {};

            var r,
                n,
                o = function (e, t) {
              if (null == e) return {};
              var r = {};

              for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
                if (t.includes(n)) continue;
                r[n] = e[n];
              }

              return r;
            }(e, t);

            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);

              for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
            }

            return o;
          }(a, Lx)), {}, {
            column_id: c.id
          });
        }
      }, {
        key: "validateSchema",
        value: function () {
          return this.validator.validate(this.toJS(), kx);
        }
      }], [{
        key: "getRawOperandKeys",
        value: function () {
          return ["column_id"];
        }
      }, {
        key: "getRawOperands",
        value: function (e) {
          var t = e.rawColumnSpec,
              r = e.unLoadedSpecCache;
          return this.getRawOperandKeys().map(function (e) {
            return r.get(t[e]);
          });
        }
      }, {
        key: "type",
        value: function () {
          return "NotColumn";
        }
      }]);
    }(),
        Xx = r(92);

    function Zx(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, eA(n.key), n);
      }
    }

    function eA(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function tA(e, t, r) {
      return t = oA(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], oA(e).constructor) : t.apply(e, r));
    }

    function rA() {
      return (rA = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = nA(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function nA(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = oA(e)););

      return e;
    }

    function oA(e) {
      return (oA = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function iA(e, t) {
      return (iA = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var aA = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), tA(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && iA(e, t);
      }(t, iN), function (e, t, r) {
        return t && Zx(e.prototype, t), r && Zx(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "allowConstantOperands",
        value: function () {
          return !1;
        }
      }, {
        key: "calculate",
        value: function (e) {
          var r,
              n,
              o,
              i,
              a,
              c = (r = t, n = "calculate", o = this, a = rA(oA(1 & (i = 3) ? r.prototype : r), n, o), 2 & i && "function" == typeof a ? function (e) {
            return a.apply(o, e);
          } : a)([e]);
          return e.some(function (e) {
            return !0 !== e && !1 !== e;
          }) ? c : (c.result = e.some(function (e) {
            return !0 === e;
          }), c);
        }
      }, {
        key: "validateOperands",
        value: function () {
          return [];
        }
      }], [{
        key: "operatorSymbol",
        value: function () {
          return "OR";
        }
      }, {
        key: "operatorId",
        value: function () {
          return "or";
        }
      }]);
    }(),
        cA = ["operand1_column_id", "operand2_column_id"];

    function uA(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function lA(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? uA(Object(r), !0).forEach(function (t) {
          sA(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : uA(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function sA(e, t, r) {
      return (t = fA(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function pA(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, fA(n.key), n);
      }
    }

    function fA(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function dA(e, t, r) {
      return t = hA(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], hA(e).constructor) : t.apply(e, r));
    }

    function bA(e, t) {
      return (bA = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function yA(e, t, r, n) {
      var o = mA(hA(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function mA() {
      return (mA = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = vA(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function vA(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = hA(e)););

      return e;
    }

    function hA(e) {
      return (hA = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var gA = function (e) {
      function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
        var r = e.t;
        return dA(this, t, [lA(lA({}, e), {}, {
          calculation: new aA({
            t: r
          })
        })]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && bA(e, t);
      }(t, Az), r = t, n = [{
        key: "toJS",
        value: function () {
          var e = yA(t, "toJS", this, 3)([]),
              r = e.operand1_column_id,
              n = e.operand2_column_id;
          return lA(lA({}, function (e, t) {
            if (null == e) return {};

            var r,
                n,
                o = function (e, t) {
              if (null == e) return {};
              var r = {};

              for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
                if (t.includes(n)) continue;
                r[n] = e[n];
              }

              return r;
            }(e, t);

            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);

              for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
            }

            return o;
          }(e, cA)), {}, {
            operand1_column_id: r.id,
            operand2_column_id: n.id
          });
        }
      }, {
        key: "validateSchema",
        value: function () {
          return this.validator.validate(this.toJS(), Xx);
        }
      }], o = [{
        key: "getRawOperandKeys",
        value: function () {
          return ["operand1_column_id", "operand2_column_id"];
        }
      }, {
        key: "getRawOperands",
        value: function (e) {
          var t = e.rawColumnSpec,
              r = e.unLoadedSpecCache;
          return this.getRawOperandKeys().map(function (e) {
            return r.get(t[e]);
          });
        }
      }, {
        key: "requiredProps",
        value: function () {
          return yA(t, "requiredProps", this, 2)([]).concat(["operand2", "t"]);
        }
      }, {
        key: "type",
        value: function () {
          return "OrColumn";
        }
      }], n && pA(r.prototype, n), o && pA(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }(),
        wA = r(89);

    function OA(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (null != r) {
          var n,
              o,
              i,
              a,
              c = [],
              u = !0,
              l = !1;

          try {
            if (i = (r = r.call(e)).next, 0 === t) {
              if (Object(r) !== r) return;
              u = !1;
            } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== t); u = !0);
          } catch (e) {
            l = !0, o = e;
          } finally {
            try {
              if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
            } finally {
              if (l) throw o;
            }
          }

          return c;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return jA(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? jA(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function jA(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function PA(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _A(n.key), n);
      }
    }

    function _A(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function EA(e, t, r) {
      return t = SA(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], SA(e).constructor) : t.apply(e, r));
    }

    function SA(e) {
      return (SA = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function CA(e, t) {
      return (CA = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var kA = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), EA(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && CA(e, t);
      }(t, Wz), r = t, (n = [{
        key: "arity",
        value: function () {
          return 3;
        }
      }, {
        key: "display",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
              t = OA(e, 3),
              r = t[0],
              n = t[1],
              o = t[2];
          return "".concat(this.constructor.operatorSymbol(), "( ").concat(r, ", ").concat(n, ", ").concat(o, " )");
        }
      }]) && PA(r.prototype, n), o && PA(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function RA(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (null != r) {
          var n,
              o,
              i,
              a,
              c = [],
              u = !0,
              l = !1;

          try {
            if (i = (r = r.call(e)).next, 0 === t) {
              if (Object(r) !== r) return;
              u = !1;
            } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== t); u = !0);
          } catch (e) {
            l = !0, o = e;
          } finally {
            try {
              if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
            } finally {
              if (l) throw o;
            }
          }

          return c;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return TA(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? TA(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function TA(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function zA(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, NA(n.key), n);
      }
    }

    function NA(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function DA(e, t, r) {
      return t = MA(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], MA(e).constructor) : t.apply(e, r));
    }

    function xA() {
      return (xA = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = AA(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function AA(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = MA(e)););

      return e;
    }

    function MA(e) {
      return (MA = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function IA(e, t) {
      return (IA = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var FA,
        BA,
        LA = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), DA(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && IA(e, t);
      }(t, kA), function (e, t, r) {
        return t && zA(e.prototype, t), r && zA(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "calculate",
        value: function (e) {
          var r,
              n,
              o,
              i,
              a,
              c,
              u = (n = t, o = "calculate", i = this, c = xA(MA(1 & (a = 3) ? n.prototype : n), o, i), 2 & a && "function" == typeof c ? function (e) {
            return c.apply(i, e);
          } : c)([e]);
          if (null !== (r = u.errors) && void 0 !== r && r.length) return u;
          var l = RA(e, 3),
              s = l[0],
              p = l[1],
              f = l[2];
          return !0 === s && (u.result = p), !1 === s && (u.result = f), u;
        }
      }], [{
        key: "operatorSymbol",
        value: function () {
          return "IF";
        }
      }, {
        key: "operatorId",
        value: function () {
          return "if";
        }
      }]);
    }(),
        VA = ["conditional_column_id"];

    function UA(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function qA(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? UA(Object(r), !0).forEach(function (t) {
          KA(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : UA(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function KA(e, t, r) {
      return (t = WA(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function GA(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, WA(n.key), n);
      }
    }

    function WA(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function HA(e, t, r) {
      return t = XA(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], XA(e).constructor) : t.apply(e, r));
    }

    function JA(e, t) {
      return (JA = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function YA(e, t, r, n) {
      var o = QA(XA(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function QA() {
      return (QA = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = $A(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function $A(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = XA(e)););

      return e;
    }

    function XA(e) {
      return (XA = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var ZA,
        eM,
        tM,
        rM,
        nM,
        oM,
        iM,
        aM,
        cM,
        uM,
        lM,
        sM,
        pM,
        fM,
        dM = (BA = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((FA = function (e) {
      function t() {
        var e,
            r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
        var n = r.t;
        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = HA(this, t, [qA(qA({}, r), {}, {
          calculation: new LA({
            t: n
          })
        })]), "operand3", BA, e), e.operand3 = r.operand3, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && JA(e, t);
      }(t, Az), r = t, n = [{
        key: "getOperands",
        value: function () {
          return [this.operand1, this.operand2, this.operand3];
        }
      }, {
        key: "toJS",
        value: function () {
          var e = YA(t, "toJS", this, 3)([]),
              r = e.conditional_column_id;
          return qA(qA({}, function (e, t) {
            if (null == e) return {};

            var r,
                n,
                o = function (e, t) {
              if (null == e) return {};
              var r = {};

              for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
                if (t.includes(n)) continue;
                r[n] = e[n];
              }

              return r;
            }(e, t);

            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);

              for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
            }

            return o;
          }(e, VA)), {}, {
            conditional_column_id: r.id
          });
        }
      }, {
        key: "validateSchema",
        value: function () {
          return this.validator.validate(this.toJS(), wA);
        }
      }], o = [{
        key: "getRawOperandKeys",
        value: function () {
          return ["conditional_column_id", "then_operand", "else_operand"];
        }
      }, {
        key: "getRawOperands",
        value: function (e) {
          var t = e.rawColumnSpec,
              r = e.unLoadedSpecCache;
          return this.getRawOperandKeys().map(function (e, n) {
            return 0 === n ? r.get(t[e]) : t[e];
          });
        }
      }, {
        key: "requiredProps",
        value: function () {
          return YA(t, "requiredProps", this, 2)([]).concat(["operand2", "operand3", "t"]);
        }
      }, {
        key: "type",
        value: function () {
          return "IfColumn";
        }
      }], n && GA(r.prototype, n), o && GA(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "operand3", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), FA);

    function bM(e, t, r) {
      return (t = gM(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function yM(e) {
      return function (e) {
        if (Array.isArray(e)) return mM(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return mM(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? mM(e, t) : void 0;
        }
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function mM(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function vM(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function hM(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, gM(n.key), n);
      }
    }

    function gM(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function wM(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    v()(document).off(".data-api");
    var OM,
        jM,
        PM = (eM = wM((ZA = function () {
      return function (e, t, r) {
        return t && hM(e.prototype, t), r && hM(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(function e() {
        var t = this,
            r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), vM(this, "_columnFilterMap", eM, this), this._columnSpecMap = new Map(), vM(this, "_columnToRename", tM, this), vM(this, "_draggedColumnSpec", rM, this), vM(this, "_dropTargetColumnSpec", nM, this), vM(this, "_sortingColumn", oM, this), vM(this, "columnSpecs", iM, this), vM(this, "filterModalId", aM, this), vM(this, "groupSpecs", cM, this), this.sortConfig = void 0, vM(this, "changeColumnName", uM, this), vM(this, "dragColumn", lM, this), vM(this, "dropColumn", sM, this), vM(this, "stopDraggingColumn", pM, this), vM(this, "stopRenamingColumn", fM, this);
        var n = r.columnSpecs,
            o = r.groupSpecs,
            i = r.sortConfig,
            a = r.filters;
        this.setColumnSpecs(n || []), this.groupSpecs = o || [], this.sortConfig = new aT(i), (a || []).forEach(function (e) {
          return t.filter(e);
        });
      }, [{
        key: "numFilters",
        get: function () {
          return this._columnFilterMap.size;
        }
      }, {
        key: "visibleColumns",
        get: function () {
          return this.columnSpecs.filter(function (e) {
            return e.isShowing;
          });
        }
      }, {
        key: "addColumn",
        value: function (e) {
          e ? (this._columnSpecMap.set(e.id, e), e.isShowing = !0) : console.error(new Error("Unable to add column.  ColumnSpec is empty"));
        }
      }, {
        key: "addColumnAtEnd",
        value: function (e) {
          this.addColumnAtPosition(e, this.visibleColumns.length);
        }
      }, {
        key: "addColumnAtPosition",
        value: function (e, t) {
          this.addColumn(e), this.moveColumnToPosition(e, t);
        }
      }, {
        key: "addColumns",
        value: function (e) {
          var t = this;
          e.map(function (e) {
            var r = t.findColumn(e);
            return {
              column: r,
              position: r.position
            };
          }).forEach(function (e) {
            e.column && t.addColumnAtPosition(e.column, e.position);
          });
        }
      }, {
        key: "clearAllFilters",
        value: function () {
          this._columnFilterMap.clear();
        }
      }, {
        key: "clearFilter",
        value: function (e) {
          this._columnFilterMap.delete(e);
        }
      }, {
        key: "columnsToSave",
        value: function () {
          var e = this.visibleColumns.map(function (e) {
            return Az.isCalculationColumnSpec(e) ? function e(t) {
              return t.getOperands().reduce(function (t, r) {
                if (_z.isColumnCalculationOperandSpec(r)) {
                  var n = r.referenceColumnSpec;
                  t.push(n), Az.isCalculationColumnSpec(n) && t.push(e(n));
                }

                return t;
              }, []).flat();
            }(e).concat(e) : e;
          });
          return Object(w.uniqBy)("id", e.flat()).map(function (e) {
            return e.toJS();
          });
        }
      }, {
        key: "destroyColumn",
        value: function (e) {
          if (e) {
            this.sortConfig.removeSort(e.id);
            var t = this.columnSpecs.findIndex(function (t) {
              return t.id === e.id;
            });
            t < 0 || (this.columnSpecs.splice(t, 1), this._columnSpecMap.delete(e.id));
          }
        }
      }, {
        key: "dragOverColumn",
        value: function (e) {
          this._dropTargetColumnSpec = e;
        }
      }, {
        key: "dumpFilters",
        value: function () {
          return yM(this._columnFilterMap.values());
        }
      }, {
        key: "findColumn",
        value: function (e) {
          return e && this._columnSpecMap.get(e);
        }
      }, {
        key: "isDraggingAnyColumn",
        value: function () {
          return !!this._draggedColumnSpec;
        }
      }, {
        key: "isDraggingColumn",
        value: function (e) {
          return this._draggedColumnSpec === e;
        }
      }, {
        key: "isDraggingColumnOver",
        value: function (e) {
          return this._dropTargetColumnSpec === e;
        }
      }, {
        key: "isFiltering",
        value: function (e) {
          return this._columnFilterMap.has(e.id);
        }
      }, {
        key: "isGrouped",
        value: function (e) {
          return !!this.groupSpecs.find(function (t) {
            return (null == t ? void 0 : t.id) && t.id === (null == e ? void 0 : e.id);
          });
        }
      }, {
        key: "isRenamingColumn",
        value: function (e) {
          return this._columnToRename === e;
        }
      }, {
        key: "isSortingDown",
        value: function (e) {
          return this.sortConfig.isSortingDown(e.id);
        }
      }, {
        key: "isSortingUp",
        value: function (e) {
          return this.sortConfig.isSortingUp(e.id);
        }
      }, {
        key: "isValidDropTarget",
        value: function (e) {
          var t,
              r = this.isGrouped(e),
              n = this.isGrouped(this._draggedColumnSpec);
          return (null == e ? void 0 : e.id) && (null == e ? void 0 : e.id) !== (null === (t = this._draggedColumnSpec) || void 0 === t ? void 0 : t.id) && (!r && !n || r && n);
        }
      }, {
        key: "filter",
        value: function (e) {
          this._columnFilterMap.set(e.id, e);
        }
      }, {
        key: "filterFor",
        value: function (e) {
          return this._columnFilterMap.get(e);
        }
      }, {
        key: "group",
        value: function (e) {
          var t = this.groupSpecs.length;
          this.groupSpecs.push(e), this.moveColumnToPosition(e, t), this.sortAscending(e);
        }
      }, {
        key: "loadCalculatedColumn",
        value: function () {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = t.rawColumnSpec,
              n = t.t,
              o = t.unLoadedSpecCache,
              i = t.loadedSpecCache,
              a = this.constructor.getCalculation(r.type, n),
              c = this.constructor.getCalculatedColumnClass(r.type),
              u = c.getRawOperands({
            rawColumnSpec: r,
            unLoadedSpecCache: o
          }).map(function (t) {
            return e.loadCalculationOperand({
              rawOperand: t,
              t: n,
              unLoadedSpecCache: o,
              loadedSpecCache: i
            });
          }),
              l = new c({
            t: n,
            id: r.id,
            position: r.position,
            calculation: a,
            operand1: u[0],
            operand2: u[1],
            operand3: u[2],
            nameOverride: r.name_override,
            isShowing: r.is_showing
          });
          return i.set(l.id, l), l;
        }
      }, {
        key: "loadCalculationOperand",
        value: function (e) {
          var t = e.rawOperand,
              r = e.t,
              n = e.unLoadedSpecCache,
              o = e.loadedSpecCache;
          if (t.type === Cx.type()) return new Cx({
            value: t.value
          });
          var i = o.get(t.id) || this.loadColumn({
            rawColumnSpec: n.get(t.id),
            t: r,
            unLoadedSpecCache: n
          });
          return i ? new _z({
            referenceColumnSpec: i
          }) : console.error(new Error('Unable to load column "'.concat(t.id, '"')));
        }
      }, {
        key: "loadColumn",
        value: function (e) {
          var t = e.rawColumnSpec,
              r = e.unLoadedSpecCache,
              n = e.t,
              o = this._columnSpecMap,
              i = this.findColumn(t.id);
          return i ? (t.name_override && i.changeName(t.name_override), i.isShowing = t.is_showing, i.position = t.position) : this.constructor.isRawCalculationColumnSpec(t) ? i = this.loadCalculatedColumn({
            rawColumnSpec: t,
            t: n,
            unLoadedSpecCache: r,
            loadedSpecCache: o
          }) : t.type === NT.type() ? i = NT.load({
            rawColumnSpec: t,
            t: n,
            unLoadedSpecCache: r,
            loadedSpecCache: o
          }) : t.type === HT.type() ? i = HT.load({
            rawColumnSpec: t,
            t: n,
            unLoadedSpecCache: r,
            loadedSpecCache: o
          }) : t.type === az.type() && (i = az.load({
            rawColumnSpec: t,
            t: n,
            unLoadedSpecCache: r,
            loadedSpecCache: o
          })), i;
        }
      }, {
        key: "loadColumns",
        value: function (e, t) {
          var r = this,
              n = new Map(),
              o = [];
          e.forEach(function (e) {
            return n.set(e.id, e);
          }), e.forEach(function (e) {
            var i = r.loadColumn({
              rawColumnSpec: e,
              unLoadedSpecCache: n,
              t: t
            });
            i ? o.push(i.id) : console.error(new Error('Unable to load column "'.concat(e.id, '"')));
          }), this.addColumns(o.filter(function (e) {
            var t;
            return null === (t = r.findColumn(e)) || void 0 === t ? void 0 : t.isShowing;
          }));
        }
      }, {
        key: "moveColumnToPosition",
        value: function (e, t) {
          if (e) {
            var r = this.columnSpecs.findIndex(function (t) {
              return e.id === t.id;
            });
            r > -1 && this.columnSpecs.splice(r, 1), this.columnSpecs.splice(t, 0, e), this.columnSpecs.forEach(function (e, t) {
              e.position = t;
            }), this.reorderColumns(), this.isGrouped(e) && this.moveGroupToPosition(e, t);
          }
        }
      }, {
        key: "moveGroupToPosition",
        value: function (e, t) {
          if (!(t > this.groupSpecs.length)) {
            var r = this.groupSpecs.findIndex(function (t) {
              return (null == t ? void 0 : t.id) && (null == t ? void 0 : t.id) === (null == e ? void 0 : e.id);
            });
            r < 0 || (this.groupSpecs.splice(r, 1), this.groupSpecs.splice(t, 0, e), this.groupSpecs.forEach(function (e, t) {
              e.position = t;
            }));
          }
        }
      }, {
        key: "removeAllColumns",
        value: function () {
          var e = this;
          this.visibleColumns.forEach(function (t) {
            return e.removeColumn(t);
          });
        }
      }, {
        key: "removeColumn",
        value: function (e) {
          e && (this.sortConfig.removeSort(e.id), e.isShowing = !1);
        }
      }, {
        key: "replaceColumn",
        value: function (e, t) {
          var r = this.isSortingDown(e),
              n = this.sortConfig.isSorting(e.id);
          this.destroyColumn(e), this.addColumnAtPosition(t, e.position), n && (r ? this.sortDescending(t) : this.sortAscending(t));
        }
      }, {
        key: "setColumnSpecs",
        value: function (e) {
          var t = this;
          this.columnSpecs = e, this.columnSpecs.forEach(function (e) {
            return t._columnSpecMap.set(e.id, e);
          });
        }
      }, {
        key: "splitScalarFromUnits",
        value: function (e, t) {
          if (e) {
            var r = new HT({
              position: e.position + 1,
              referenceColumnSpec: e,
              t: t
            });
            this.addColumnAtPosition(r, r.position);
            var n = new az({
              position: e.position + 2,
              referenceColumnSpec: e,
              t: t
            });
            return this.addColumnAtPosition(n, n.position), [r, n];
          }
        }
      }, {
        key: "renameColumn",
        value: function (e) {
          this._columnToRename = e;
        }
      }, {
        key: "reorderColumns",
        value: function () {
          this.columnSpecs = this.columnSpecs.slice().sort(function (e, t) {
            return Object(w.naturalSort)(e.position, t.position);
          }).map(function (e, t) {
            return e.updatePosition(t);
          });
        }
      }, {
        key: "reorderGroups",
        value: function () {
          this.groupSpecs = this.groupSpecs.slice().sort(function (e, t) {
            return Object(w.naturalSort)(e.position, t.position);
          }).map(function (e, t) {
            return e.updatePosition(t);
          });
        }
      }, {
        key: "shouldDropAfter",
        value: function (e) {
          return this._draggedColumnSpec.position < e.position;
        }
      }, {
        key: "sortAscending",
        value: function (e) {
          this.isSortingUp(e) ? this.sortConfig.removeSort(e.id) : (this.isGrouped(e) || (this._sortingColumn = e), this.sortConfig.addSort(e.id, aT.ASC));
        }
      }, {
        key: "sortDescending",
        value: function (e) {
          this.isSortingDown(e) ? this.sortConfig.removeSort(e.id) : (this.isGrouped(e) || (this._sortingColumn = e), this.sortConfig.addSort(e.id, aT.DESC));
        }
      }, {
        key: "unGroup",
        value: function (e) {
          this.groupSpecs = this.groupSpecs.filter(function (t) {
            return (null == t ? void 0 : t.id) && t.id !== (null == e ? void 0 : e.id);
          }), this.moveColumnToPosition(e, this.groupSpecs.length), this.sortConfig.removeSort(e.id);
        }
      }], [{
        key: "isRawCalculationColumnSpec",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return [EN.type(), WN.type(), fD.type(), FD.type(), mx.type(), $x.type(), gA.type(), dM.type()].includes(e.type);
        }
      }, {
        key: "getCalculation",
        value: function (e, t) {
          var r,
              n = (bM(bM(bM(bM(bM(bM(bM(bM(bM(bM(r = {}, EN.type(), bN), WN.type(), AN), fD.type(), tD), FD.type(), CD), mx.type(), ox), $x.type(), Bx), gA.type(), aA), dM.type(), LA), "add", bN), "subtract", AN), bM(bM(bM(bM(bM(bM(r, "multiply", tD), "divide", CD), "blank", ox), "not", Bx), "or", aA), "if", LA))[e];
          return n && new n({
            t: t
          });
        }
      }, {
        key: "getCalculatedColumnClass",
        value: function (e) {
          var t;
          return (bM(bM(bM(bM(bM(bM(bM(bM(bM(bM(t = {}, EN.type(), EN), WN.type(), WN), fD.type(), fD), FD.type(), FD), mx.type(), mx), $x.type(), $x), gA.type(), gA), dM.type(), dM), "add", EN), "subtract", WN), bM(bM(bM(bM(bM(bM(t, "multiply", fD), "divide", FD), "blank", mx), "not", $x), "or", gA), "if", dM))[e];
        }
      }]);
    }()).prototype, "_columnFilterMap", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new Map();
      }
    }), tM = wM(ZA.prototype, "_columnToRename", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), rM = wM(ZA.prototype, "_draggedColumnSpec", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), nM = wM(ZA.prototype, "_dropTargetColumnSpec", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), oM = wM(ZA.prototype, "_sortingColumn", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), iM = wM(ZA.prototype, "columnSpecs", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), aM = wM(ZA.prototype, "filterModalId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "report-column-filter-modal";
      }
    }), cM = wM(ZA.prototype, "groupSpecs", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), wM(ZA.prototype, "numFilters", [f.computed], Object.getOwnPropertyDescriptor(ZA.prototype, "numFilters"), ZA.prototype), wM(ZA.prototype, "visibleColumns", [f.computed], Object.getOwnPropertyDescriptor(ZA.prototype, "visibleColumns"), ZA.prototype), wM(ZA.prototype, "addColumn", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "addColumn"), ZA.prototype), wM(ZA.prototype, "addColumnAtEnd", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "addColumnAtEnd"), ZA.prototype), wM(ZA.prototype, "addColumnAtPosition", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "addColumnAtPosition"), ZA.prototype), wM(ZA.prototype, "addColumns", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "addColumns"), ZA.prototype), uM = wM(ZA.prototype, "changeColumnName", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e._columnToRename && e._columnToRename.changeName(t);
        };
      }
    }), wM(ZA.prototype, "clearAllFilters", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "clearAllFilters"), ZA.prototype), wM(ZA.prototype, "clearFilter", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "clearFilter"), ZA.prototype), wM(ZA.prototype, "destroyColumn", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "destroyColumn"), ZA.prototype), lM = wM(ZA.prototype, "dragColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e._draggedColumnSpec = t;
        };
      }
    }), wM(ZA.prototype, "dragOverColumn", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "dragOverColumn"), ZA.prototype), sM = wM(ZA.prototype, "dropColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e._draggedColumnSpec,
              n = e.isValidDropTarget(t);
          e.stopDraggingColumn(), e._dropTargetColumnSpec = null, n && e.moveColumnToPosition(r, t.position);
        };
      }
    }), wM(ZA.prototype, "filter", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "filter"), ZA.prototype), wM(ZA.prototype, "group", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "group"), ZA.prototype), wM(ZA.prototype, "loadColumn", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "loadColumn"), ZA.prototype), wM(ZA.prototype, "moveColumnToPosition", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "moveColumnToPosition"), ZA.prototype), wM(ZA.prototype, "moveGroupToPosition", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "moveGroupToPosition"), ZA.prototype), wM(ZA.prototype, "removeAllColumns", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "removeAllColumns"), ZA.prototype), wM(ZA.prototype, "removeColumn", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "removeColumn"), ZA.prototype), wM(ZA.prototype, "replaceColumn", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "replaceColumn"), ZA.prototype), wM(ZA.prototype, "setColumnSpecs", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "setColumnSpecs"), ZA.prototype), wM(ZA.prototype, "splitScalarFromUnits", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "splitScalarFromUnits"), ZA.prototype), wM(ZA.prototype, "renameColumn", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "renameColumn"), ZA.prototype), wM(ZA.prototype, "reorderColumns", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "reorderColumns"), ZA.prototype), wM(ZA.prototype, "reorderGroups", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "reorderGroups"), ZA.prototype), wM(ZA.prototype, "sortAscending", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "sortAscending"), ZA.prototype), wM(ZA.prototype, "sortDescending", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "sortDescending"), ZA.prototype), pM = wM(ZA.prototype, "stopDraggingColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          return e._draggedColumnSpec = null;
        };
      }
    }), fM = wM(ZA.prototype, "stopRenamingColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          return e._columnToRename = null;
        };
      }
    }), wM(ZA.prototype, "unGroup", [f.action], Object.getOwnPropertyDescriptor(ZA.prototype, "unGroup"), ZA.prototype), ZA);

    function _M(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, EM(n.key), n);
      }
    }

    function EM(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function SM(e, t, r) {
      return t = TM(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], TM(e).constructor) : t.apply(e, r));
    }

    function CM(e, t) {
      return (CM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function kM() {
      return (kM = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = RM(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function RM(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = TM(e)););

      return e;
    }

    function TM(e) {
      return (TM = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var zM = (jM = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((OM = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = SM(this, t, [e]), "types", jM, r), r.t = e.t, r.nameOverride = e.nameOverride || r.defaultName(), r.types = e.types || ["string"], r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && CM(e, t);
      }(t, mT), function (e, t, r) {
        return t && _M(e.prototype, t), r && _M(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "defaultName",
        value: function () {
          return this.constructor.getNameFromId(this.id, this.t);
        }
      }, {
        key: "filterType",
        value: function () {
          return this.types.filter(function (e) {
            return null != e;
          }).some(function (e) {
            return ["date", "date-time"].includes(e);
          }) ? "DateFilter" : "TextFilter";
        }
      }, {
        key: "isCalculable",
        value: function () {
          var e = this;
          return !!this.types.filter(function (e) {
            return null != e;
          }).some(function (t) {
            return "unit-string" === t || e.constructor.isNumericType(t);
          });
        }
      }, {
        key: "isDeprecated",
        value: function () {
          return this.constructor.isDeprecated(this.id);
        }
      }], [{
        key: "isDeprecated",
        value: function (e) {
          return db.getFixedT("en")(this.getTranslationKey(e)).includes("(deprecated)");
        }
      }, {
        key: "isNumericType",
        value: function (e) {
          return ["integer", "number", "decimal"].includes(e);
        }
      }, {
        key: "isReportColumnSpec",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(t.prototype, e);
        }
      }, {
        key: "requiredProps",
        value: function () {
          return (e = t, r = "requiredProps", n = this, o = 2, i = kM(TM(1 & o ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]).concat(["t"]);
          var e, r, n, o, i;
        }
      }, {
        key: "getNameFromId",
        value: function (e, t) {
          return t(this.getTranslationKey(e));
        }
      }, {
        key: "getTranslationKey",
        value: function (e) {
          var t = e.split("/");
          return "report_attributes.".concat(t[t.length - 1]);
        }
      }, {
        key: "type",
        value: function () {
          return "ReportColumn";
        }
      }]);
    }()).prototype, "types", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), OM);

    function NM() {
      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      NM = function () {
        return t;
      };

      var e,
          t = {},
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = Object.defineProperty || function (e, t, r) {
        e[t] = r.value;
      },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          u = i.toStringTag || "@@toStringTag";

      function l(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        l({}, "");
      } catch (e) {
        l = function (e, t, r) {
          return e[t] = r;
        };
      }

      function s(e, t, r, n) {
        var i = t && t.prototype instanceof v ? t : v,
            a = Object.create(i.prototype),
            c = new T(n || []);
        return o(a, "_invoke", {
          value: S(e, r, c)
        }), a;
      }

      function p(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      t.wrap = s;
      var f = "suspendedStart",
          d = "suspendedYield",
          b = "executing",
          y = "completed",
          m = {};

      function v() {}

      function h() {}

      function g() {}

      var w = {};
      l(w, a, function () {
        return this;
      });
      var O = Object.getPrototypeOf,
          j = O && O(O(z([])));
      j && j !== r && n.call(j, a) && (w = j);
      var P = g.prototype = v.prototype = Object.create(w);

      function _(e) {
        ["next", "throw", "return"].forEach(function (t) {
          l(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function E(e, t) {
        function r(o, i, a, c) {
          var u = p(e[o], e, i);

          if ("throw" !== u.type) {
            var l = u.arg,
                s = l.value;
            return s && "object" == typeof s && n.call(s, "__await") ? t.resolve(s.__await).then(function (e) {
              r("next", e, a, c);
            }, function (e) {
              r("throw", e, a, c);
            }) : t.resolve(s).then(function (e) {
              l.value = e, a(l);
            }, function (e) {
              return r("throw", e, a, c);
            });
          }

          c(u.arg);
        }

        var i;
        o(this, "_invoke", {
          value: function (e, n) {
            function o() {
              return new t(function (t, o) {
                r(e, n, t, o);
              });
            }

            return i = i ? i.then(o, o) : o();
          }
        });
      }

      function S(t, r, n) {
        var o = f;
        return function (i, a) {
          if (o === b) throw Error("Generator is already running");

          if (o === y) {
            if ("throw" === i) throw a;
            return {
              value: e,
              done: !0
            };
          }

          for (n.method = i, n.arg = a;;) {
            var c = n.delegate;

            if (c) {
              var u = C(c, n);

              if (u) {
                if (u === m) continue;
                return u;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (o === f) throw o = y, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            o = b;
            var l = p(t, r, n);

            if ("normal" === l.type) {
              if (o = n.done ? y : d, l.arg === m) continue;
              return {
                value: l.arg,
                done: n.done
              };
            }

            "throw" === l.type && (o = y, n.method = "throw", n.arg = l.arg);
          }
        };
      }

      function C(t, r) {
        var n = r.method,
            o = t.iterator[n];
        if (o === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, C(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), m;
        var i = p(o, t.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, m;
        var a = i.arg;
        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, m) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m);
      }

      function k(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function R(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function T(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(k, this), this.reset(!0);
      }

      function z(t) {
        if (t || "" === t) {
          var r = t[a];
          if (r) return r.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var o = -1,
                i = function r() {
              for (; ++o < t.length;) if (n.call(t, o)) return r.value = t[o], r.done = !1, r;

              return r.value = e, r.done = !0, r;
            };

            return i.next = i;
          }
        }

        throw new TypeError(typeof t + " is not iterable");
      }

      return h.prototype = g, o(P, "constructor", {
        value: g,
        configurable: !0
      }), o(g, "constructor", {
        value: h,
        configurable: !0
      }), h.displayName = l(g, u, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === h || "GeneratorFunction" === (t.displayName || t.name));
      }, t.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, l(e, u, "GeneratorFunction")), e.prototype = Object.create(P), e;
      }, t.awrap = function (e) {
        return {
          __await: e
        };
      }, _(E.prototype), l(E.prototype, c, function () {
        return this;
      }), t.AsyncIterator = E, t.async = function (e, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new E(s(e, r, n, o), i);
        return t.isGeneratorFunction(r) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, _(P), l(P, u, "Generator"), l(P, a, function () {
        return this;
      }), l(P, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (e) {
        var t = Object(e),
            r = [];

        for (var n in t) r.push(n);

        return r.reverse(), function e() {
          for (; r.length;) {
            var n = r.pop();
            if (n in t) return e.value = n, e.done = !1, e;
          }

          return e.done = !0, e;
        };
      }, t.values = z, T.prototype = {
        constructor: T,
        reset: function (t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(R), !t) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
        },
        stop: function () {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function (t) {
          if (this.done) throw t;
          var r = this;

          function o(n, o) {
            return c.type = "throw", c.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
                c = a.completion;
            if ("root" === a.tryLoc) return o("end");

            if (a.tryLoc <= this.prev) {
              var u = n.call(a, "catchLoc"),
                  l = n.call(a, "finallyLoc");

              if (u && l) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!l) throw Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function (e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(a);
        },
        complete: function (e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
        },
        finish: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), R(r), m;
          }
        },
        catch: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                R(r);
              }

              return o;
            }
          }

          throw Error("illegal catch attempt");
        },
        delegateYield: function (t, r, n) {
          return this.delegate = {
            iterator: z(t),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = e), m;
        }
      }, t;
    }

    function DM(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function xM(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? DM(Object(r), !0).forEach(function (t) {
          AM(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : DM(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function AM(e, t, r) {
      return (t = FM(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function MM(e, t, r, n, o, i, a) {
      try {
        var c = e[i](a),
            u = c.value;
      } catch (e) {
        return void r(e);
      }

      c.done ? t(u) : Promise.resolve(u).then(n, o);
    }

    function IM(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, FM(n.key), n);
      }
    }

    function FM(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function BM(e, t, r) {
      return t = LM(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], LM(e).constructor) : t.apply(e, r));
    }

    function LM(e) {
      return (LM = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function VM(e, t) {
      return (VM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var UM = function (e) {
      function t() {
        var e,
            r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), e = BM(this, t);
        var n = r.reportsPath;
        return e.reportsPath = n || t.defaultReportsPath, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && VM(e, t);
      }(t, My), function (e, t, r) {
        return t && IM(e.prototype, t), r && IM(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "_urlWithQueryParams",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = t.limit,
              n = t.offset,
              o = t.reportType,
              i = t.template,
              a = t.template_id,
              c = [].concat(null != r && [["limit", r]] || []).concat(null != n && [["offset", n]] || []).concat(null != o && [["report_type", o]] || []).concat(null != i && [["template", i]] || []).concat(null != a && [["template_id", a]] || []);
          return [e].concat(c.length && new URLSearchParams(c) || []).join("?");
        }
      }, {
        key: "reportColumnsUrl",
        value: function (e) {
          return this._urlWithQueryParams([this.reportsPath].concat("columns").join("/"), {
            reportType: e
          });
        }
      }, {
        key: "reportPath",
        value: function (e) {
          return [this.reportsPath].concat(e).join("/");
        }
      }, {
        key: "publishReportPath",
        value: function (e) {
          return [this.reportPath(e)].concat("publish").join("/");
        }
      }, {
        key: "viewStatusPath",
        value: function (e) {
          return [this.reportPath(e)].concat("data_status").join("/");
        }
      }, {
        key: "columnSpecs",
        value: (r = NM().mark(function e(t, r) {
          return NM().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this.jsonFetch(this.reportColumnsUrl(t)).then(function (e) {
                  return e.map(function (e, t) {
                    return new zM(xM(xM({}, e), {}, {
                      position: t,
                      t: r
                    }));
                  });
                }));

              case 1:
              case "end":
                return e.stop();
            }
          }, e, this);
        }), n = function () {
          var e = this,
              t = arguments;
          return new Promise(function (n, o) {
            var i = r.apply(e, t);

            function a(e) {
              MM(i, n, o, a, c, "next", e);
            }

            function c(e) {
              MM(i, n, o, a, c, "throw", e);
            }

            a(void 0);
          });
        }, function (e, t) {
          return n.apply(this, arguments);
        })
      }, {
        key: "createDraft",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return this.jsonFetch(this.reportsPath, "POST", e);
        }
      }, {
        key: "delete",
        value: function (e) {
          return this.jsonFetch(this.reportPath(e), "DELETE");
        }
      }, {
        key: "fetch",
        value: function (e, t) {
          return this.jsonFetch(this._urlWithQueryParams(this.reportPath(e), t));
        }
      }, {
        key: "loadReport",
        value: function (e) {
          window.location.assign(this.reportPath(e));
        }
      }, {
        key: "loadTemplate",
        value: function (e) {
          window.location.assign(this._urlWithQueryParams(this.newReportPath(), {
            template: !0,
            template_id: e
          }));
        }
      }, {
        key: "newReportPath",
        value: function () {
          return [this.reportsPath].concat("new").join("/");
        }
      }, {
        key: "publish",
        value: function (e) {
          return this.jsonFetch(this.publishReportPath(e), "POST");
        }
      }, {
        key: "status",
        value: function (e) {
          return this.jsonFetch(this.viewStatusPath(e)).then(function (e) {
            if (e.error) throw new Error(e.error);
            return e;
          });
        }
      }, {
        key: "update",
        value: function (e, t) {
          return this.jsonFetch(this.reportPath(e), "PATCH", t);
        }
      }]);
      var r, n;
    }();

    function qM(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, KM(n.key), n);
      }
    }

    function KM(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    UM.defaultReportsPath = "/if2/reports";

    var GM,
        WM,
        HM,
        JM = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.key = t.key, this.columnSpec = t.columnSpec, this.displayValue = this.constructor.displayValue(this.columnSpec, t.rowData), this.errors = this.constructor.errors(this.columnSpec, t.rowData);
      }, r = [{
        key: "displayValue",
        value: function (e, t) {
          return e.display(t);
        }
      }, {
        key: "errors",
        value: function (e, t) {
          return e.errors(t);
        }
      }], (t = null) && qM(e.prototype, t), r && qM(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function YM(e, t, r) {
      return t = ZM(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, $M() ? Reflect.construct(t, r || [], ZM(e).constructor) : t.apply(e, r));
    }

    function QM(e) {
      var t = "function" == typeof Map ? new Map() : void 0;
      return (QM = function (e) {
        if (null === e || !function (e) {
          try {
            return -1 !== Function.toString.call(e).indexOf("[native code]");
          } catch (t) {
            return "function" == typeof e;
          }
        }(e)) return e;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, r);
        }

        function r() {
          return function (e, t, r) {
            if ($M()) return Reflect.construct.apply(null, arguments);
            var n = [null];
            n.push.apply(n, t);
            var o = new (e.bind.apply(e, n))();
            return r && XM(o, r.prototype), o;
          }(e, arguments, ZM(this).constructor);
        }

        return r.prototype = Object.create(e.prototype, {
          constructor: {
            value: r,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), XM(r, e);
      })(e);
    }

    function $M() {
      try {
        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch (e) {}

      return ($M = function () {
        return !!e;
      })();
    }

    function XM(e, t) {
      return (XM = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ZM(e) {
      return (ZM = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function eI(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function tI(e, t, r) {
      return (t = iI(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function rI(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function nI(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, iI(n.key), n);
      }
    }

    function oI(e, t, r) {
      return t && nI(e.prototype, t), r && nI(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function iI(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function aI(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var cI,
        uI,
        lI,
        sI,
        pI,
        fI,
        dI,
        bI,
        yI = ((HM = function () {
      function e(t) {
        rI(this, e), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(this, "columnSpecs", WM, this);
        var r = this.constructor.validateProps(t),
            n = r.columnSpecs,
            o = r.rowData,
            i = r.level,
            a = r.key,
            c = r.index;
        this.key = null == a ? JSON.stringify(o) : a, this.index = c, this.rowData = o, this.level = i || 0, this.columnSpecs = n;
      }

      return oI(e, [{
        key: "cells",
        get: function () {
          var e = this;
          return this.columnSpecs.map(function (t) {
            return new JM({
              key: "".concat(e.key, "-").concat(t.id),
              columnSpec: t,
              rowData: e.rowData
            });
          });
        }
      }, {
        key: "getSubrecord",
        value: function (e) {
          return this.constructor.getSubrecord(e, this);
        }
      }, {
        key: "setColumnSpecs",
        value: function (e) {
          this.columnSpecs = e;
        }
      }], [{
        key: "renderPrefixCellsToCsvString",
        value: function (e) {
          return [].concat(e.level && e.level > 0 ? Object(x.repeat)(JSON.stringify(""), e.level) : []).join(",");
        }
      }, {
        key: "renderToCsvString",
        value: function (e) {
          return [].concat(this.renderPrefixCellsToCsvString(e) || []).concat(e.cells.map(function (e) {
            var t;
            return '"'.concat(null === (t = e.displayValue) || void 0 === t ? void 0 : t.replace(/"/g, '""'), '"');
          })).join(",");
        }
      }, {
        key: "sort",
        value: function (e, t) {
          var r = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {};
              t % 2 ? eI(Object(r), !0).forEach(function (t) {
                tI(e, t, r[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : eI(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
            }

            return e;
          }({}, t || {}),
              n = r.sortDescending,
              o = r.accessor,
              i = r.customSort;

          if (!o) return e;
          var a = i || (n ? ie : h.naturalSort),
              c = Object(x.useWith)(a, [o, o]);
          return Object(x.sort)(c, e);
        }
      }, {
        key: "validateProps",
        value: function (t) {
          if (!t) throw new e.MissingPropsError();
          var r = t.columnSpecs,
              n = t.rowData,
              o = [];
          if (r || o.push("columnSpecs"), n || o.push("rowData"), o.length > 0) throw new e.MissingPropsError(o);
          return t;
        }
      }]);
    }()).MissingPropsError = function (e) {
      function t(e) {
        var r;
        rI(this, t);

        for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) o[i - 1] = arguments[i];

        return (r = YM(this, t, [["Missing prop".concat(e && 1 === e.length ? "" : "s")].concat(e && e.map(function (e) {
          return '"'.concat(e, '"');
        }).join(", ") || []).join(": ")].concat(o))).name = r.constructor.name, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && XM(e, t);
      }(t, QM(Error)), oI(t);
    }(), WM = aI((GM = HM).prototype, "columnSpecs", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), aI(GM.prototype, "cells", [f.computed], Object.getOwnPropertyDescriptor(GM.prototype, "cells"), GM.prototype), aI(GM.prototype, "setColumnSpecs", [f.action], Object.getOwnPropertyDescriptor(GM.prototype, "setColumnSpecs"), GM.prototype), GM);

    function mI(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function vI(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? mI(Object(r), !0).forEach(function (t) {
          hI(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : mI(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function hI(e, t, r) {
      return (t = OI(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function gI(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function wI(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, OI(n.key), n);
      }
    }

    function OI(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function jI(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var PI = ((bI = function () {
      return function (e, t, r) {
        return t && wI(e.prototype, t), r && wI(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), gI(this, "currentColumn", uI, this), gI(this, "dateRangeSelector", lI, this), this.id = Object(td.v4)(), gI(this, "isShowing", sI, this), gI(this, "textFilterMethodSelector", pI, this), gI(this, "textFilterText", fI, this), gI(this, "onChangeTextFilterText", dI, this);
        var r = t.t;
        this.t = r;
      }, [{
        key: "formId",
        get: function () {
          return "".concat(this.id, "-form");
        }
      }, {
        key: "title",
        get: function () {
          var e;
          return (null === (e = this.currentColumn) || void 0 === e ? void 0 : e.getName()) || "";
        }
      }, {
        key: "apply",
        value: function (e) {
          var t,
              r,
              n,
              o,
              i,
              a = null === (t = this.currentColumn) || void 0 === t ? void 0 : t.filterType(),
              c = {
            type: a,
            id: null === (r = this.currentColumn) || void 0 === r ? void 0 : r.id
          };
          "TextFilter" === a && e.columnConfig.filter(vI(vI({}, c), {}, {
            method: (null === (n = this.textFilterMethodSelector) || void 0 === n ? void 0 : n.selectedValue) || "contains",
            value: this.textFilterText
          }));
          "DateFilter" === a && e.columnConfig.filter(vI(vI({}, c), {}, {
            method: this.dateRangeSelectorMethod(),
            start_date: $R.DateTime.fromJSDate(null === (o = this.dateRangeSelector) || void 0 === o ? void 0 : o.startDate).toISODate(),
            end_date: $R.DateTime.fromJSDate(null === (i = this.dateRangeSelector) || void 0 === i ? void 0 : i.endDate).toISODate()
          }));
        }
      }, {
        key: "hide",
        value: function () {
          this.isShowing = !1, this.currentColumn = null;
        }
      }, {
        key: "loadFilter",
        value: function (e) {
          switch (e.type) {
            case "TextFilter":
              this.loadTextFilter(e);
              break;

            case "DateFilter":
              this.loadDateFilter(e);
          }
        }
      }, {
        key: "loadDateFilter",
        value: function (e) {
          var t = this;
          return Object(f.when)(function () {
            var e;
            return null === (e = t.dateRangeSelector) || void 0 === e ? void 0 : e.selector;
          }).then(function () {
            return t.updateDateRangeSelector(e);
          });
        }
      }, {
        key: "loadTextFilter",
        value: function (e) {
          this.textFilterMethodSelector && this.textFilterMethodSelector.changeByKey(e.method), this.textFilterText = e.value;
        }
      }, {
        key: "reset",
        value: function () {
          this.textFilterMethodSelector = null, this.textFilterText = "", this.dateRangeSelector = null;
        }
      }, {
        key: "dateRangeSelectorMethod",
        value: function () {
          var e;
          return {
            thisYear: "thisyear",
            lastYear: "lastyear",
            thisMonth: "thismonth",
            lastMonth: "lastmonth",
            thisWeek: "thisweek",
            lastWeek: "lastweek",
            custom: "custom"
          }[null === (e = this.dateRangeSelector) || void 0 === e || null === (e = e.selector) || void 0 === e || null === (e = e.selectedOption) || void 0 === e ? void 0 : e.value];
        }
      }, {
        key: "show",
        value: function (e, t) {
          this.isShowing = !0, this.currentColumn = t, "TextFilter" === t.filterType() ? this.textFilterMethodSelector = new h.SelectorModel(this.constructor.textFilterOptions(this.t)) : "DateFilter" === t.filterType() && (this.dateRangeSelector = new h.DateRangeSelectorModel());
          var r = e.columnConfig.filterFor(t.id);
          r && this.loadFilter(r);
        }
      }, {
        key: "updateDateRangeSelector",
        value: function (e) {
          this.dateRangeSelector.onChangeDateRange({
            key: {
              thisyear: "thisYear",
              lastyear: "lastYear",
              thismonth: "thisMonth",
              lastmonth: "lastMonth",
              thisweek: "thisWeek",
              lastweek: "lastWeek",
              custom: "custom"
            }[e.method]
          }), e.start_date && this.dateRangeSelector.onChangeStartDate(new Date(e.start_date)), e.end_date && this.dateRangeSelector.onChangeEndDate(new Date(e.end_date));
        }
      }]);
    }()).textFilterOptions = function (e) {
      return ["beginswith", "contains", "exact"].map(function (t) {
        return {
          key: t,
          text: e("if2.reports.".concat(t)),
          value: t
        };
      });
    }, uI = jI((cI = bI).prototype, "currentColumn", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), lI = jI(cI.prototype, "dateRangeSelector", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), sI = jI(cI.prototype, "isShowing", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), pI = jI(cI.prototype, "textFilterMethodSelector", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), fI = jI(cI.prototype, "textFilterText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), jI(cI.prototype, "formId", [f.computed], Object.getOwnPropertyDescriptor(cI.prototype, "formId"), cI.prototype), jI(cI.prototype, "title", [f.computed], Object.getOwnPropertyDescriptor(cI.prototype, "title"), cI.prototype), jI(cI.prototype, "apply", [f.action], Object.getOwnPropertyDescriptor(cI.prototype, "apply"), cI.prototype), jI(cI.prototype, "hide", [f.action], Object.getOwnPropertyDescriptor(cI.prototype, "hide"), cI.prototype), jI(cI.prototype, "loadFilter", [f.action], Object.getOwnPropertyDescriptor(cI.prototype, "loadFilter"), cI.prototype), jI(cI.prototype, "loadDateFilter", [f.action], Object.getOwnPropertyDescriptor(cI.prototype, "loadDateFilter"), cI.prototype), jI(cI.prototype, "loadTextFilter", [f.action], Object.getOwnPropertyDescriptor(cI.prototype, "loadTextFilter"), cI.prototype), dI = jI(cI.prototype, "onChangeTextFilterText", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.textFilterText = t.target.value;
        };
      }
    }), jI(cI.prototype, "reset", [f.action], Object.getOwnPropertyDescriptor(cI.prototype, "reset"), cI.prototype), jI(cI.prototype, "show", [f.action], Object.getOwnPropertyDescriptor(cI.prototype, "show"), cI.prototype), jI(cI.prototype, "updateDateRangeSelector", [f.action], Object.getOwnPropertyDescriptor(cI.prototype, "updateDateRangeSelector"), cI.prototype), cI);

    function _I(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, EI(n.key), n);
      }
    }

    function EI(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function SI(e, t, r) {
      return t = CI(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], CI(e).constructor) : t.apply(e, r));
    }

    function CI(e) {
      return (CI = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function kI(e, t) {
      return (kI = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function RI(e) {
      return "".concat("/if2/report_templates", "/").concat(e);
    }

    var TI,
        zI,
        NI,
        DI,
        xI,
        AI,
        MI,
        II,
        FI,
        BI,
        LI,
        VI,
        UI,
        qI,
        KI,
        GI,
        WI,
        HI,
        JI,
        YI,
        QI,
        $I,
        XI,
        ZI,
        eF,
        tF,
        rF,
        nF,
        oF,
        iF,
        aF,
        cF,
        uF,
        lF,
        sF,
        pF,
        fF,
        dF,
        bF,
        yF,
        mF,
        vF,
        hF,
        gF,
        wF,
        OF,
        jF,
        PF,
        _F,
        EF,
        SF,
        CF,
        kF = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), SI(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && kI(e, t);
      }(t, My), r = t, (n = [{
        key: "create",
        value: function (e) {
          return this.jsonFetch("/if2/report_templates", "POST", {
            template: e
          });
        }
      }, {
        key: "update",
        value: function (e, t) {
          return this.jsonFetch(RI(e), "PATCH", {
            template: t
          });
        }
      }, {
        key: "delete",
        value: function (e) {
          return this.jsonFetch(RI(e), "DELETE");
        }
      }]) && _I(r.prototype, n), o && _I(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function RF(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function TF(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? RF(Object(r), !0).forEach(function (t) {
          zF(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : RF(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function zF(e, t, r) {
      return (t = MF(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function NF() {
      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      NF = function () {
        return t;
      };

      var e,
          t = {},
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = Object.defineProperty || function (e, t, r) {
        e[t] = r.value;
      },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          u = i.toStringTag || "@@toStringTag";

      function l(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        l({}, "");
      } catch (e) {
        l = function (e, t, r) {
          return e[t] = r;
        };
      }

      function s(e, t, r, n) {
        var i = t && t.prototype instanceof v ? t : v,
            a = Object.create(i.prototype),
            c = new T(n || []);
        return o(a, "_invoke", {
          value: S(e, r, c)
        }), a;
      }

      function p(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      t.wrap = s;
      var f = "suspendedStart",
          d = "suspendedYield",
          b = "executing",
          y = "completed",
          m = {};

      function v() {}

      function h() {}

      function g() {}

      var w = {};
      l(w, a, function () {
        return this;
      });
      var O = Object.getPrototypeOf,
          j = O && O(O(z([])));
      j && j !== r && n.call(j, a) && (w = j);
      var P = g.prototype = v.prototype = Object.create(w);

      function _(e) {
        ["next", "throw", "return"].forEach(function (t) {
          l(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function E(e, t) {
        function r(o, i, a, c) {
          var u = p(e[o], e, i);

          if ("throw" !== u.type) {
            var l = u.arg,
                s = l.value;
            return s && "object" == typeof s && n.call(s, "__await") ? t.resolve(s.__await).then(function (e) {
              r("next", e, a, c);
            }, function (e) {
              r("throw", e, a, c);
            }) : t.resolve(s).then(function (e) {
              l.value = e, a(l);
            }, function (e) {
              return r("throw", e, a, c);
            });
          }

          c(u.arg);
        }

        var i;
        o(this, "_invoke", {
          value: function (e, n) {
            function o() {
              return new t(function (t, o) {
                r(e, n, t, o);
              });
            }

            return i = i ? i.then(o, o) : o();
          }
        });
      }

      function S(t, r, n) {
        var o = f;
        return function (i, a) {
          if (o === b) throw Error("Generator is already running");

          if (o === y) {
            if ("throw" === i) throw a;
            return {
              value: e,
              done: !0
            };
          }

          for (n.method = i, n.arg = a;;) {
            var c = n.delegate;

            if (c) {
              var u = C(c, n);

              if (u) {
                if (u === m) continue;
                return u;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (o === f) throw o = y, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            o = b;
            var l = p(t, r, n);

            if ("normal" === l.type) {
              if (o = n.done ? y : d, l.arg === m) continue;
              return {
                value: l.arg,
                done: n.done
              };
            }

            "throw" === l.type && (o = y, n.method = "throw", n.arg = l.arg);
          }
        };
      }

      function C(t, r) {
        var n = r.method,
            o = t.iterator[n];
        if (o === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, C(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), m;
        var i = p(o, t.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, m;
        var a = i.arg;
        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, m) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m);
      }

      function k(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function R(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function T(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(k, this), this.reset(!0);
      }

      function z(t) {
        if (t || "" === t) {
          var r = t[a];
          if (r) return r.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var o = -1,
                i = function r() {
              for (; ++o < t.length;) if (n.call(t, o)) return r.value = t[o], r.done = !1, r;

              return r.value = e, r.done = !0, r;
            };

            return i.next = i;
          }
        }

        throw new TypeError(typeof t + " is not iterable");
      }

      return h.prototype = g, o(P, "constructor", {
        value: g,
        configurable: !0
      }), o(g, "constructor", {
        value: h,
        configurable: !0
      }), h.displayName = l(g, u, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === h || "GeneratorFunction" === (t.displayName || t.name));
      }, t.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, l(e, u, "GeneratorFunction")), e.prototype = Object.create(P), e;
      }, t.awrap = function (e) {
        return {
          __await: e
        };
      }, _(E.prototype), l(E.prototype, c, function () {
        return this;
      }), t.AsyncIterator = E, t.async = function (e, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new E(s(e, r, n, o), i);
        return t.isGeneratorFunction(r) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, _(P), l(P, u, "Generator"), l(P, a, function () {
        return this;
      }), l(P, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (e) {
        var t = Object(e),
            r = [];

        for (var n in t) r.push(n);

        return r.reverse(), function e() {
          for (; r.length;) {
            var n = r.pop();
            if (n in t) return e.value = n, e.done = !1, e;
          }

          return e.done = !0, e;
        };
      }, t.values = z, T.prototype = {
        constructor: T,
        reset: function (t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(R), !t) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
        },
        stop: function () {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function (t) {
          if (this.done) throw t;
          var r = this;

          function o(n, o) {
            return c.type = "throw", c.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
                c = a.completion;
            if ("root" === a.tryLoc) return o("end");

            if (a.tryLoc <= this.prev) {
              var u = n.call(a, "catchLoc"),
                  l = n.call(a, "finallyLoc");

              if (u && l) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!l) throw Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function (e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(a);
        },
        complete: function (e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
        },
        finish: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), R(r), m;
          }
        },
        catch: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                R(r);
              }

              return o;
            }
          }

          throw Error("illegal catch attempt");
        },
        delegateYield: function (t, r, n) {
          return this.delegate = {
            iterator: z(t),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = e), m;
        }
      }, t;
    }

    function DF(e, t, r, n, o, i, a) {
      try {
        var c = e[i](a),
            u = c.value;
      } catch (e) {
        return void r(e);
      }

      c.done ? t(u) : Promise.resolve(u).then(n, o);
    }

    function xF(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function AF(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, MF(n.key), n);
      }
    }

    function MF(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function IF(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var FF,
        BF,
        LF,
        VF = ((CF = function () {
      function e() {
        var t = this,
            r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this._dataTimeout = void 0, this.accountsApi = void 0, this.accountsStore = void 0, this.accountsTree = void 0, this.api = void 0, xF(this, "atBottom", zI, this), xF(this, "atTop", NI, this), this.canEditTemplates = !1, this.columnConfig = void 0, this.columnFilterModal = void 0, xF(this, "currentRangeEnd", DI, this), xF(this, "currentRangeStart", xI, this), xF(this, "didLoadColumns", AI, this), xF(this, "draftReportId", MI, this), xF(this, "errorAlertMessages", II, this), xF(this, "errorAlertText", FI, this), xF(this, "errors", BI, this), xF(this, "firstItemIndex", LI, this), xF(this, "initialTopMostItemIndex", VI, this), xF(this, "isDirty", UI, this), xF(this, "isInvalid", qI, this), xF(this, "isLoadingColumns", KI, this), xF(this, "isLoadingCurrentPage", GI, this), xF(this, "isLoadingNextPage", WI, this), xF(this, "isLoadingPreviousPage", HI, this), xF(this, "isScrolling", JI, this), xF(this, "isShowingErrorAlert", YI, this), xF(this, "isShowingSuccessAlert", QI, this), xF(this, "isTemplate", $I, this), xF(this, "limit", XI, this), xF(this, "offset", ZI, this), xF(this, "originalReportId", eF, this), xF(this, "pageBackOffset", tF, this), xF(this, "pageForwardOffset", rF, this), xF(this, "previousRangeEnd", nF, this), xF(this, "previousRangeStart", oF, this), this.reportType = void 0, xF(this, "rows", iF, this), xF(this, "selectedAccountIds", aF, this), xF(this, "successAlertText", cF, this), xF(this, "templateId", uF, this), xF(this, "status", lF, this), xF(this, "totalRowCount", sF, this), this.templatesApi = void 0, xF(this, "title", pF, this), xF(this, "changeTitle", fF, this), xF(this, "isScrollingChanged", dF, this), xF(this, "loadCurrentPage", bF, this), xF(this, "loadNextPage", yF, this), xF(this, "loadPreviousPage", mF, this), this.loadStatus = function () {
          return t.api.status(t.draftReportId).then(function (e) {
            return Object(f.runInAction)(function () {
              return t.status = null == e ? void 0 : e.status, t.totalRowCount = null == e ? void 0 : e.row_count, t.status;
            });
          }).catch(function (e) {
            return t.showErrorAlert(e);
          });
        }, this.onBeforeUnload = function (e) {
          e.preventDefault(), e.returnValue = !0;
        }, xF(this, "onCloseErrorAlert", vF, this), xF(this, "onCloseSuccessAlert", hF, this), xF(this, "showErrorAlert", gF, this), xF(this, "showSuccessAlert", wF, this), xF(this, "selectAccounts", OF, this), xF(this, "setClean", jF, this), xF(this, "setDirty", PF, this), xF(this, "updateAtBottom", _F, this), xF(this, "updateAtTop", EF, this), xF(this, "updateCurrentRange", SF, this), this.waitForData = function (r) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              o = n.timeout,
              i = n.limit;
          t._dataTimeout && clearTimeout(t._dataTimeout);

          var a = performance.now(),
              c = function n() {
            return r().then(function (c) {
              if (c.length === (null != i ? i : t.limit)) return c;
              return function i() {
                return new Promise(function (c, u) {
                  if (o && performance.now() - a > o) {
                    if (!window.confirm(t.t("unresponsive_continue_waiting"))) return u(new Error(t.t("request_timed_out")));
                    a = performance.now();
                  }

                  t.loadStatus().then(function (o) {
                    if (o === e.Status.READY) return c(r());
                    o !== e.Status.REFRESHING ? t._dataTimeout = setTimeout(function () {
                      return c(i());
                    }, t.constructor.pollingTimeout) : t._dataTimeout = setTimeout(function () {
                      return c(n());
                    }, t.constructor.pollingTimeout);
                  }).catch(u);
                });
              }();
            });
          };

          return c();
        };
        var n = r.report,
            o = r.accountRoots,
            i = r.reportsPath,
            a = r.canEditTemplates,
            c = r.t;
        this.canEditTemplates = a, this._setIsTemplate(r), this._setTemplateId(r), this.t = c, this.title = (null == n ? void 0 : n.title) || $R.DateTime.now().toFormat("MM-dd-yyyy"), this.api = new UM({
          reportsPath: i
        }), this.templatesApi = new kF(), this.reportType = (null == n ? void 0 : n.report_type) || "IF2::SprayRecord", this.originalReportId = null != n && n.draft ? null == n ? void 0 : n.original_report_id : null == n ? void 0 : n.serial, this.shouldDisableSave || this.enableUnloadHandler(), this.columnFilterModal = new PI({
          t: c
        }), this.accountsApi = new N(), this.accountsStore = new Tt(this.accountsApi, new qt()), this.accountsTree = new as(this.accountsStore), this.accountsTree.setRoots((o || []).map(function (e) {
          return t.accountsStore.push(e);
        })), ((null == n ? void 0 : n.account_uuids) || []).forEach(function (e) {
          return t.accountsTree.check(e);
        }), this.selectedAccountIds = (null == n ? void 0 : n.account_uuids) || [], this.initColumnConfig(n);
      }

      return function (e, t, r) {
        return t && AF(e.prototype, t), r && AF(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(e, [{
        key: "shouldDisableSave",
        get: function () {
          return !this.isDirty && (this.originalReportId || this.isTemplate && this.templateId) || this.isTemplate && !this.canEditTemplates;
        }
      }, {
        key: "isScrollingDown",
        get: function () {
          return this.currentRangeEnd > this.previousRangeEnd;
        }
      }, {
        key: "isScrollingUp",
        get: function () {
          return this.currentRangeStart < this.previousRangeStart;
        }
      }, {
        key: "isProcessing",
        get: function () {
          return [e.Status.STALE, e.Status.ENQUEUED, e.Status.REFRESHING].includes(this.status);
        }
      }, {
        key: "_setTemplateId",
        value: function (e) {
          var t = e.templateId,
              r = new URL(document.location);
          return this.templateId = t || r.searchParams.get("template_id"), this.templateId;
        }
      }, {
        key: "_setIsTemplate",
        value: function (e) {
          var t,
              r = e.isTemplate,
              n = new URL(document.location);
          return this.isTemplate = null !== r && r || "true" === (null === (t = n.searchParams.get("template")) || void 0 === t ? void 0 : t.toLowerCase()), this.isTemplate;
        }
      }, {
        key: "_update",
        value: function (e) {
          var t = this;
          return this.api.update(this.draftReportId, e).then(function () {
            return t.setDirty();
          }).then(function () {
            return t.loadCurrentPage();
          }).catch(function (e) {
            return t.showErrorAlert(e);
          });
        }
      }, {
        key: "initColumnConfig",
        value: (t = NF().mark(function e(t) {
          var r,
              n = this;
          return NF().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return this.isLoadingColumns = !0, this.columnConfig = new PM({
                  sortConfig: null == t ? void 0 : t.sort_config,
                  filters: null == t ? void 0 : t.filters
                }), e.next = 4, this.api.columnSpecs(this.reportType, this.t);

              case 4:
                r = e.sent, this.columnConfig.setColumnSpecs(r), this.columnConfig.loadColumns((null == t ? void 0 : t.column_specs) || [], this.t), Object(f.runInAction)(function () {
                  n.isLoadingColumns = !1, n.didLoadColumns = !0;
                });

              case 8:
              case "end":
                return e.stop();
            }
          }, e, this);
        }), r = function () {
          var e = this,
              r = arguments;
          return new Promise(function (n, o) {
            var i = t.apply(e, r);

            function a(e) {
              DF(i, n, o, a, c, "next", e);
            }

            function c(e) {
              DF(i, n, o, a, c, "throw", e);
            }

            a(void 0);
          });
        }, function (e) {
          return r.apply(this, arguments);
        })
      }, {
        key: "clearValidation",
        value: function () {
          this.errors = {}, this.isInvalid = !1;
        }
      }, {
        key: "createDraft",
        value: function () {
          var e = this;
          return Promise.resolve().then(function () {
            return Object(f.when)(function () {
              return e.didLoadColumns;
            });
          }).then(function () {
            return e.api.createDraft(e.toJS());
          }).then(function (t) {
            var r = t.id;
            return Object(f.runInAction)(function () {
              return e.draftReportId = r;
            });
          });
        }
      }, {
        key: "disableUnloadHandler",
        value: function () {
          window.removeEventListener("beforeunload", this.onBeforeUnload);
        }
      }, {
        key: "enableUnloadHandler",
        value: function () {
          window.addEventListener("beforeunload", this.onBeforeUnload);
        }
      }, {
        key: "fetchRows",
        value: function () {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            offset: 0
          },
              r = t.offset;
          return this.api.fetch(this.draftReportId, t).then(function (t) {
            var n = t.rows;
            return Object(f.runInAction)(function () {
              return n.map(function (t, n) {
                return new yI({
                  index: r + n,
                  columnSpecs: e.columnConfig.visibleColumns,
                  rowData: t
                });
              });
            });
          });
        }
      }, {
        key: "resetPagingState",
        value: function () {
          this.limit = e.initialLimit, this.offset = e.initialOffset, this.pageForwardOffset = e.initialLimit, this.pageBackOffset = Math.max(0, e.initialOffset - e.initialLimit), this.firstItemIndex = this.offset, this.initialTopMostItemIndex = e.initialOffset, this.currentRangeEnd = 0, this.currentRangeStart = 0;
        }
      }, {
        key: "saveReport",
        value: function (e) {
          var t = this,
              r = Promise.resolve();
          return e && (r = this._update(TF(TF({}, this.toJS()), {}, {
            original_report_id: null
          }))), r.then(function () {
            return t.api.publish(t.draftReportId);
          }).then(function (e) {
            return Object(f.runInAction)(function () {
              t.setClean(), null != e && e.id && (t.originalReportId = e.id);
            });
          }).then(function () {
            return e ? t.api.loadReport(t.originalReportId) : null;
          }).then(function () {
            return t.showSuccessAlert(t.t("report_saved_successfully"));
          }).catch(function (e) {
            return t.showErrorAlert((null == e ? void 0 : e.message) || e);
          });
        }
      }, {
        key: "saveTemplate",
        value: function (e) {
          var t,
              r = this;
          if (e) t = this.templatesApi.create(this.toJS());else {
            if (!this.templateId) throw new Error("Cannot update template without a templateId");
            t = this.templatesApi.update(this.templateId, this.toJS());
          }
          return t.then(function (e) {
            return Object(f.runInAction)(function () {
              r.setClean(), r.templateId = e.id;
            });
          }).then(function () {
            return e ? r.api.loadTemplate(r.templateId) : null;
          }).then(function () {
            return r.showSuccessAlert(r.t("if2.reports.template_saved_successfully"));
          }).catch(function (e) {
            return r.showErrorAlert((null == e ? void 0 : e.message) || e);
          });
        }
      }, {
        key: "tableCellClass",
        value: function (e) {
          return this.columnConfig.isDraggingAnyColumn() ? this.columnConfig.isDraggingColumn(e) ? "drag-origin" : this.columnConfig.isDraggingColumnOver(e) ? this.columnConfig.shouldDropAfter(e) ? "drop-after" : "drop-before" : "" : "";
        }
      }, {
        key: "toggleAccountChecked",
        value: function (e) {
          var t = this;
          return this.accountsStore.descendantsAreLoadedOf(e) ? Promise.resolve(this.accountsTree.toggleChecked(e)) : this.accountsStore.updateDescendantsOf(e).then(function () {
            return t.accountsTree.toggleChecked(e);
          });
        }
      }, {
        key: "toggleAccountExpanded",
        value: function (e) {
          var t = this,
              r = this.accountsStore.find(e);
          if (!r) return Promise.resolve();
          var n = new Set();
          return r.child_ids.forEach(function (e) {
            t.accountsStore.isLoaded(e) && n.add(e);
          }), this.accountsTree.toggleExpanded(e).then(function () {
            r.child_ids.forEach(function (r) {
              var o = t.accountsTree.isChecked(e),
                  i = n.has(r);
              o ? i || t.accountsTree.check(r) : i || t.accountsTree.setCheck(r, t.selectedAccountIds.includes(r));
            });
          });
        }
      }, {
        key: "toJS",
        value: function () {
          return {
            account_uuids: this.selectedAccountIds,
            column_specs: this.columnConfig.columnsToSave(),
            sort_config: this.columnConfig.sortConfig.dump(),
            title: this.title,
            report_type: this.reportType,
            original_report_id: this.originalReportId,
            id: this.draftReportId,
            filters: this.columnConfig.dumpFilters()
          };
        }
      }, {
        key: "update",
        value: function () {
          return this.clearValidation(), this.validate(!0), this.isInvalid ? Promise.resolve() : this._update(this.toJS());
        }
      }, {
        key: "validate",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          this.title || (this.errors.title = "blank_title"), e && (this.isInvalid = Object.keys(this.errors).length > 0);
        }
      }]);
      var t, r;
    }()).Status = Object.freeze({
      STALE: "stale",
      ENQUEUED: "enqueued",
      REFRESHING: "refreshing",
      READY: "ready",
      FAILED: "failed"
    }), CF.initialLimit = 100, CF.initialOffset = 0, CF.waitTimeout = 45e3, CF.pollingTimeout = 500, zI = IF((TI = CF).prototype, "atBottom", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !0;
      }
    }), NI = IF(TI.prototype, "atTop", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !0;
      }
    }), DI = IF(TI.prototype, "currentRangeEnd", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), xI = IF(TI.prototype, "currentRangeStart", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), AI = IF(TI.prototype, "didLoadColumns", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), MI = IF(TI.prototype, "draftReportId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), II = IF(TI.prototype, "errorAlertMessages", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), FI = IF(TI.prototype, "errorAlertText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), BI = IF(TI.prototype, "errors", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return {};
      }
    }), LI = IF(TI.prototype, "firstItemIndex", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return VF.initialOffset;
      }
    }), VI = IF(TI.prototype, "initialTopMostItemIndex", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return VF.initialOffset;
      }
    }), UI = IF(TI.prototype, "isDirty", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), qI = IF(TI.prototype, "isInvalid", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), KI = IF(TI.prototype, "isLoadingColumns", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), GI = IF(TI.prototype, "isLoadingCurrentPage", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), WI = IF(TI.prototype, "isLoadingNextPage", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), HI = IF(TI.prototype, "isLoadingPreviousPage", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), JI = IF(TI.prototype, "isScrolling", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), YI = IF(TI.prototype, "isShowingErrorAlert", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), QI = IF(TI.prototype, "isShowingSuccessAlert", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), $I = IF(TI.prototype, "isTemplate", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), XI = IF(TI.prototype, "limit", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return VF.initialLimit;
      }
    }), ZI = IF(TI.prototype, "offset", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return VF.initialOffset;
      }
    }), eF = IF(TI.prototype, "originalReportId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), tF = IF(TI.prototype, "pageBackOffset", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return Math.max(0, VF.initialOffset - VF.initialLimit);
      }
    }), rF = IF(TI.prototype, "pageForwardOffset", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return VF.initialLimit;
      }
    }), nF = IF(TI.prototype, "previousRangeEnd", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), oF = IF(TI.prototype, "previousRangeStart", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), iF = IF(TI.prototype, "rows", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), aF = IF(TI.prototype, "selectedAccountIds", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), cF = IF(TI.prototype, "successAlertText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), uF = IF(TI.prototype, "templateId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), lF = IF(TI.prototype, "status", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), sF = IF(TI.prototype, "totalRowCount", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), pF = IF(TI.prototype, "title", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), IF(TI.prototype, "shouldDisableSave", [f.computed], Object.getOwnPropertyDescriptor(TI.prototype, "shouldDisableSave"), TI.prototype), IF(TI.prototype, "isScrollingDown", [f.computed], Object.getOwnPropertyDescriptor(TI.prototype, "isScrollingDown"), TI.prototype), IF(TI.prototype, "isScrollingUp", [f.computed], Object.getOwnPropertyDescriptor(TI.prototype, "isScrollingUp"), TI.prototype), IF(TI.prototype, "isProcessing", [f.computed], Object.getOwnPropertyDescriptor(TI.prototype, "isProcessing"), TI.prototype), IF(TI.prototype, "initColumnConfig", [f.action], Object.getOwnPropertyDescriptor(TI.prototype, "initColumnConfig"), TI.prototype), fF = IF(TI.prototype, "changeTitle", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.title = t;
        };
      }
    }), IF(TI.prototype, "clearValidation", [f.action], Object.getOwnPropertyDescriptor(TI.prototype, "clearValidation"), TI.prototype), dF = IF(TI.prototype, "isScrollingChanged", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.isScrolling = t;
        };
      }
    }), bF = IF(TI.prototype, "loadCurrentPage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = e.limit;
          if (0 === r) return Promise.resolve([]);
          var n = e.currentRangeStart,
              o = e.currentRangeEnd;
          return e.isLoadingCurrentPage = !0, e.waitForData(function () {
            return e.fetchRows(TF({
              limit: r,
              offset: n
            }, t));
          }, {
            timeout: e.constructor.waitTimeout
          }).then(function (t) {
            return Object(f.runInAction)(function () {
              e.rows = t, e.offset = n, e.pageForwardOffset = n + t.length, e.firstItemIndex = n, e.initialTopMostItemIndex = o, e.pageBackOffset = Math.max(0, n - r);
            }), t;
          }).finally(function () {
            return Object(f.runInAction)(function () {
              e.isLoadingCurrentPage = !1;
            });
          });
        };
      }
    }), yF = IF(TI.prototype, "loadNextPage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          if (e.offset >= e.pageForwardOffset) return Promise.resolve([]);
          var t = e.pageForwardOffset,
              r = e.currentRangeEnd;
          return e.isLoadingNextPage = !0, e.waitForData(function () {
            return e.fetchRows({
              offset: t,
              limit: e.limit
            });
          }, {
            timeout: e.constructor.waitTimeout
          }).then(function (n) {
            return Object(f.runInAction)(function () {
              e.rows = Object(w.uniqBy)("index", e.rows.concat(n)), e.offset = t, e.initialTopMostItemIndex = r, e.pageForwardOffset = e.offset + n.length;
            }), n;
          }).finally(function () {
            return Object(f.runInAction)(function () {
              return e.isLoadingNextPage = !1;
            });
          });
        };
      }
    }), mF = IF(TI.prototype, "loadPreviousPage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          if (e.currentRangeStart <= 0) return Promise.resolve([]);
          var t = e.currentRangeEnd,
              r = e.pageBackOffset,
              n = Math.max(0, r - e.limit),
              o = Math.min(e.limit, e.offset - r);
          return e.isLoadingPreviousPage = !0, e.waitForData(function () {
            return e.fetchRows({
              limit: o,
              offset: r
            });
          }, {
            timeout: e.constructor.waitTimeout,
            limit: o
          }).then(function (o) {
            return Object(f.runInAction)(function () {
              e.rows = Object(w.uniqBy)("index", o.concat(e.rows)), e.offset = r, e.firstItemIndex = r, e.initialTopMostItemIndex = t, e.pageBackOffset = n;
            }), o;
          }).finally(function () {
            return Object(f.runInAction)(function () {
              return e.isLoadingPreviousPage = !1;
            });
          });
        };
      }
    }), vF = IF(TI.prototype, "onCloseErrorAlert", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isShowingErrorAlert = !1, e.errorAlertText = "", e.errorAlertMessages = [];
        };
      }
    }), hF = IF(TI.prototype, "onCloseSuccessAlert", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isShowingSuccessAlert = !1, e.successAlertText = "";
        };
      }
    }), IF(TI.prototype, "resetPagingState", [f.action], Object.getOwnPropertyDescriptor(TI.prototype, "resetPagingState"), TI.prototype), IF(TI.prototype, "saveReport", [f.action], Object.getOwnPropertyDescriptor(TI.prototype, "saveReport"), TI.prototype), IF(TI.prototype, "saveTemplate", [f.action], Object.getOwnPropertyDescriptor(TI.prototype, "saveTemplate"), TI.prototype), gF = IF(TI.prototype, "showErrorAlert", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.errorAlertText = (null == t ? void 0 : t.message) || t, e.errorAlertMessages = (null == t ? void 0 : t.errors) || [], e.isShowingErrorAlert = !0;
        };
      }
    }), wF = IF(TI.prototype, "showSuccessAlert", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.successAlertText = t, e.isShowingSuccessAlert = !0, new Promise(function (t) {
            setTimeout(function () {
              return t(e.onCloseSuccessAlert());
            }, 3e3);
          });
        };
      }
    }), OF = IF(TI.prototype, "selectAccounts", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.selectedAccountIds = t, e.resetPagingState(), e.update();
        };
      }
    }), jF = IF(TI.prototype, "setClean", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isDirty = !1, e.disableUnloadHandler();
        };
      }
    }), PF = IF(TI.prototype, "setDirty", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isDirty = !0, e.enableUnloadHandler();
        };
      }
    }), IF(TI.prototype, "toggleAccountChecked", [f.action], Object.getOwnPropertyDescriptor(TI.prototype, "toggleAccountChecked"), TI.prototype), _F = IF(TI.prototype, "updateAtBottom", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.atBottom = t;
        };
      }
    }), EF = IF(TI.prototype, "updateAtTop", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.atTop = t;
        };
      }
    }), SF = IF(TI.prototype, "updateCurrentRange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = t.startIndex,
              n = t.endIndex;
          e.previousRangeStart = e.currentRangeStart, e.currentRangeStart = r, e.previousRangeEnd = e.currentRangeEnd, e.currentRangeEnd = n;
        };
      }
    }), IF(TI.prototype, "validate", [f.action], Object.getOwnPropertyDescriptor(TI.prototype, "validate"), TI.prototype), TI),
        UF = r(203);

    function qF(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, KF(n.key), n);
      }
    }

    function KF(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function GF(e, t, r) {
      return t = WF(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], WF(e).constructor) : t.apply(e, r));
    }

    function WF(e) {
      return (WF = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function HF(e, t) {
      return (HF = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var JF = Object(d.observer)((LF = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((BF = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = GF(this, t, [e]), "value", LF, r), r.onChange = function (e) {
          r.value = e.target.value;
        }, r.onKeyUp = function (e) {
          "Escape" === e.key && r.onCancel(), "Enter" === e.key && r.onSave();
        }, r.onCancel = function () {
          r.props.report.columnConfig.stopRenamingColumn();
        }, r.onSave = function () {
          var e = r.props.report;
          return e.columnConfig.changeColumnName(r.value), e.columnConfig.stopRenamingColumn(), e.update().catch(console.error);
        }, r.valueDisposer = Object(f.autorun)(function () {
          var e = r.props.columnSpec;
          r.value = e.nameOverride;
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && HF(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "componentWillUnmount",
        value: function () {
          this.valueDisposer();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.columnSpec;
          return p.a.createElement("input", {
            onKeyUp: this.onKeyUp,
            onChange: this.onChange,
            onBlur: this.onSave,
            value: this.value || "",
            placeholder: e.defaultName()
          });
        }
      }]) && qF(r.prototype, n), o && qF(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "value", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), FF = BF)) || FF;

    function YF(e) {
      var t,
          r,
          n = (t = e, (r = Object(s.useRef)(t)).current = t, r);
      Object(s.useEffect)(function () {
        return function () {
          return n.current();
        };
      }, []);
    }

    var QF = Math.pow(2, 31) - 1;

    function $F() {
      var e = xo(),
          t = Object(s.useRef)();
      return YF(function () {
        return clearTimeout(t.current);
      }), Object(s.useMemo)(function () {
        var r = function () {
          return clearTimeout(t.current);
        };

        return {
          set: function (n, o) {
            void 0 === o && (o = 0), e() && (r(), o <= QF ? t.current = setTimeout(n, o) : function e(t, r, n) {
              var o = n - Date.now();
              t.current = o <= QF ? setTimeout(r, o) : setTimeout(function () {
                return e(t, r, n);
              }, QF);
            }(t, n, Date.now() + o));
          },
          clear: r
        };
      }, []);
    }

    var XF = function (e) {
      var t;
      return "undefined" == typeof document ? null : null == e ? la().body : ("function" == typeof e && (e = e()), e && "current" in e && (e = e.current), null != (t = e) && t.nodeType && e || null);
    };

    function ZF(e, t) {
      var r = Object(s.useState)(function () {
        return XF(e);
      }),
          n = r[0],
          o = r[1];

      if (!n) {
        var i = XF(e);
        i && o(i);
      }

      return Object(s.useEffect)(function () {
        t && n && t(n);
      }, [t, n]), Object(s.useEffect)(function () {
        var t = XF(e);
        t !== n && o(t);
      }, [e, n]), n;
    }

    var eB = p.a.forwardRef(function (e, t) {
      var r = e.flip,
          n = e.offset,
          o = e.placement,
          i = e.containerPadding,
          a = void 0 === i ? 5 : i,
          c = e.popperConfig,
          u = void 0 === c ? {} : c,
          l = e.transition,
          f = Do(),
          d = f[0],
          b = f[1],
          y = Do(),
          m = y[0],
          v = y[1],
          h = Ha(b, t),
          g = ZF(e.container),
          w = ZF(e.target),
          O = Object(s.useState)(!e.show),
          j = O[0],
          P = O[1],
          _ = na(w, d, ha({
        placement: o,
        enableEvents: !!e.show,
        containerPadding: a || 5,
        flip: r,
        offset: n,
        arrowElement: m,
        popperConfig: u
      })),
          E = _.styles,
          S = _.attributes,
          C = er(_, ["styles", "attributes"]);

      e.show ? j && P(!1) : e.transition || j || P(!0);
      var k = e.show || l && !j;
      if (va(d, e.onHide, {
        disabled: !e.rootClose || e.rootCloseDisabled,
        clickTrigger: e.rootCloseEvent
      }), !k) return null;
      var R = e.children(Zt({}, C, {
        show: !!e.show,
        props: Zt({}, S.popper, {
          style: E.popper,
          ref: h
        }),
        arrowProps: Zt({}, S.arrow, {
          style: E.arrow,
          ref: v
        })
      }));

      if (l) {
        var T = e.onExit,
            z = e.onExiting,
            N = e.onEnter,
            D = e.onEntering,
            x = e.onEntered;
        R = p.a.createElement(l, {
          in: e.show,
          appear: !0,
          onExit: T,
          onExiting: z,
          onExited: function () {
            P(!0), e.onExited && e.onExited.apply(e, arguments);
          },
          onEnter: N,
          onEntering: D,
          onEntered: x
        }, R);
      }

      return g ? pa.a.createPortal(R, g) : null;
    });
    eB.displayName = "Overlay", eB.propTypes = {
      show: go.a.bool,
      placement: go.a.oneOf(vi),
      target: go.a.any,
      container: go.a.any,
      flip: go.a.bool,
      children: go.a.func.isRequired,
      containerPadding: go.a.number,
      popperConfig: go.a.object,
      rootClose: go.a.bool,
      rootCloseEvent: go.a.oneOf(["click", "mousedown"]),
      rootCloseDisabled: go.a.bool,
      onHide: function (e) {
        for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];

        var o;
        return e.rootClose ? (o = go.a.func).isRequired.apply(o, [e].concat(r)) : go.a.func.apply(go.a, [e].concat(r));
      },
      transition: go.a.elementType,
      onEnter: go.a.func,
      onEntering: go.a.func,
      onEntered: go.a.func,
      onExit: go.a.func,
      onExiting: go.a.func,
      onExited: go.a.func
    };
    var tB = eB;

    function rB(e, t) {
      return (rB = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var nB = !1,
        oB = p.a.createContext(null),
        iB = "unmounted",
        aB = "exited",
        cB = "entering",
        uB = "entered",
        lB = function (e) {
      var t, r;

      function n(t, r) {
        var n;
        n = e.call(this, t, r) || this;
        var o,
            i = r && !r.isMounting ? t.enter : t.appear;
        return n.appearStatus = null, t.in ? i ? (o = aB, n.appearStatus = cB) : o = uB : o = t.unmountOnExit || t.mountOnEnter ? iB : aB, n.state = {
          status: o
        }, n.nextCallback = null, n;
      }

      r = e, (t = n).prototype = Object.create(r.prototype), t.prototype.constructor = t, rB(t, r), n.getDerivedStateFromProps = function (e, t) {
        return e.in && t.status === iB ? {
          status: aB
        } : null;
      };
      var o = n.prototype;
      return o.componentDidMount = function () {
        this.updateStatus(!0, this.appearStatus);
      }, o.componentDidUpdate = function (e) {
        var t = null;

        if (e !== this.props) {
          var r = this.state.status;
          this.props.in ? r !== cB && r !== uB && (t = cB) : r !== cB && r !== uB || (t = "exiting");
        }

        this.updateStatus(!1, t);
      }, o.componentWillUnmount = function () {
        this.cancelNextCallback();
      }, o.getTimeouts = function () {
        var e,
            t,
            r,
            n = this.props.timeout;
        return e = t = r = n, null != n && "number" != typeof n && (e = n.exit, t = n.enter, r = void 0 !== n.appear ? n.appear : t), {
          exit: e,
          enter: t,
          appear: r
        };
      }, o.updateStatus = function (e, t) {
        void 0 === e && (e = !1), null !== t ? (this.cancelNextCallback(), t === cB ? this.performEnter(e) : this.performExit()) : this.props.unmountOnExit && this.state.status === aB && this.setState({
          status: iB
        });
      }, o.performEnter = function (e) {
        var t = this,
            r = this.props.enter,
            n = this.context ? this.context.isMounting : e,
            o = this.props.nodeRef ? [n] : [pa.a.findDOMNode(this), n],
            i = o[0],
            a = o[1],
            c = this.getTimeouts(),
            u = n ? c.appear : c.enter;
        !e && !r || nB ? this.safeSetState({
          status: uB
        }, function () {
          t.props.onEntered(i);
        }) : (this.props.onEnter(i, a), this.safeSetState({
          status: cB
        }, function () {
          t.props.onEntering(i, a), t.onTransitionEnd(u, function () {
            t.safeSetState({
              status: uB
            }, function () {
              t.props.onEntered(i, a);
            });
          });
        }));
      }, o.performExit = function () {
        var e = this,
            t = this.props.exit,
            r = this.getTimeouts(),
            n = this.props.nodeRef ? void 0 : pa.a.findDOMNode(this);
        t && !nB ? (this.props.onExit(n), this.safeSetState({
          status: "exiting"
        }, function () {
          e.props.onExiting(n), e.onTransitionEnd(r.exit, function () {
            e.safeSetState({
              status: aB
            }, function () {
              e.props.onExited(n);
            });
          });
        })) : this.safeSetState({
          status: aB
        }, function () {
          e.props.onExited(n);
        });
      }, o.cancelNextCallback = function () {
        null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null);
      }, o.safeSetState = function (e, t) {
        t = this.setNextCallback(t), this.setState(e, t);
      }, o.setNextCallback = function (e) {
        var t = this,
            r = !0;
        return this.nextCallback = function (n) {
          r && (r = !1, t.nextCallback = null, e(n));
        }, this.nextCallback.cancel = function () {
          r = !1;
        }, this.nextCallback;
      }, o.onTransitionEnd = function (e, t) {
        this.setNextCallback(t);
        var r = this.props.nodeRef ? this.props.nodeRef.current : pa.a.findDOMNode(this),
            n = null == e && !this.props.addEndListener;

        if (r && !n) {
          if (this.props.addEndListener) {
            var o = this.props.nodeRef ? [this.nextCallback] : [r, this.nextCallback],
                i = o[0],
                a = o[1];
            this.props.addEndListener(i, a);
          }

          null != e && setTimeout(this.nextCallback, e);
        } else setTimeout(this.nextCallback, 0);
      }, o.render = function () {
        var e = this.state.status;
        if (e === iB) return null;
        var t = this.props,
            r = t.children,
            n = (t.in, t.mountOnEnter, t.unmountOnExit, t.appear, t.enter, t.exit, t.timeout, t.addEndListener, t.onEnter, t.onEntering, t.onEntered, t.onExit, t.onExiting, t.onExited, t.nodeRef, function (e, t) {
          if (null == e) return {};
          var r,
              n,
              o = {},
              i = Object.keys(e);

          for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);

          return o;
        }(t, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]));
        return p.a.createElement(oB.Provider, {
          value: null
        }, "function" == typeof r ? r(e, n) : p.a.cloneElement(p.a.Children.only(r), n));
      }, n;
    }(p.a.Component);

    function sB() {}

    lB.contextType = oB, lB.propTypes = {}, lB.defaultProps = {
      in: !1,
      mountOnEnter: !1,
      unmountOnExit: !1,
      appear: !1,
      enter: !0,
      exit: !0,
      onEnter: sB,
      onEntering: sB,
      onEntered: sB,
      onExit: sB,
      onExiting: sB,
      onExited: sB
    }, lB.UNMOUNTED = iB, lB.EXITED = aB, lB.ENTERING = cB, lB.ENTERED = uB, lB.EXITING = "exiting";
    var pB = lB;

    function fB(e, t) {
      return function (e) {
        var t = la(e);
        return t && t.defaultView || window;
      }(e).getComputedStyle(e, t);
    }

    var dB = /([A-Z])/g;
    var bB = /^ms-/;

    function yB(e) {
      return function (e) {
        return e.replace(dB, "-$1").toLowerCase();
      }(e).replace(bB, "-ms-");
    }

    var mB = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

    var vB = function (e, t) {
      var r = "",
          n = "";
      if ("string" == typeof t) return e.style.getPropertyValue(yB(t)) || fB(e).getPropertyValue(yB(t));
      Object.keys(t).forEach(function (o) {
        var i = t[o];
        i || 0 === i ? !function (e) {
          return !(!e || !mB.test(e));
        }(o) ? r += yB(o) + ": " + i + ";" : n += o + "(" + i + ") " : e.style.removeProperty(yB(o));
      }), n && (r += "transform: " + n + ";"), e.style.cssText += ";" + r;
    };

    function hB(e, t, r) {
      void 0 === r && (r = 5);
      var n = !1,
          o = setTimeout(function () {
        n || function (e, t, r, n) {
          if (void 0 === r && (r = !1), void 0 === n && (n = !0), e) {
            var o = document.createEvent("HTMLEvents");
            o.initEvent(t, r, n), e.dispatchEvent(o);
          }
        }(e, "transitionend", !0);
      }, t + r),
          i = aa(e, "transitionend", function () {
        n = !0;
      }, {
        once: !0
      });
      return function () {
        clearTimeout(o), i();
      };
    }

    function gB(e, t, r, n) {
      var o, i;
      null == r && (o = vB(e, "transitionDuration") || "", i = -1 === o.indexOf("ms") ? 1e3 : 1, r = parseFloat(o) * i || 0);
      var a = hB(e, r, n),
          c = aa(e, "transitionend", t);
      return function () {
        a(), c();
      };
    }

    function wB(e, t) {
      var r = vB(e, t) || "",
          n = -1 === r.indexOf("ms") ? 1e3 : 1;
      return parseFloat(r) * n;
    }

    function OB(e, t) {
      var r = wB(e, "transitionDuration"),
          n = wB(e, "transitionDelay"),
          o = gB(e, function (r) {
        r.target === e && (o(), t(r));
      }, r + n);
    }

    var jB,
        PB = ["className", "children"],
        _B = ((jB = {})[cB] = "show", jB[uB] = "show", jB),
        EB = p.a.forwardRef(function (e, t) {
      var r = e.className,
          n = e.children,
          o = er(e, PB),
          i = Object(s.useCallback)(function (e) {
        !function (e) {
          e.offsetHeight;
        }(e), o.onEnter && o.onEnter(e);
      }, [o]);
      return p.a.createElement(pB, Zt({
        ref: t,
        addEndListener: OB
      }, o, {
        onEnter: i
      }), function (e, t) {
        return p.a.cloneElement(n, Zt({}, t, {
          className: rr()("fade", r, n.props.className, _B[e])
        }));
      });
    });

    EB.defaultProps = {
      in: !1,
      timeout: 300,
      mountOnEnter: !1,
      unmountOnExit: !1,
      appear: !1
    }, EB.displayName = "Fade";
    var SB = EB,
        CB = ["children", "transition", "popperConfig"],
        kB = ["props", "arrowProps", "show", "update", "forceUpdate", "placement", "state"],
        RB = {
      transition: SB,
      rootClose: !1,
      show: !1,
      placement: "top"
    };

    function TB(e) {
      var t = e.children,
          r = e.transition,
          n = e.popperConfig,
          o = void 0 === n ? {} : n,
          i = er(e, CB),
          a = Object(s.useRef)({}),
          c = Za(),
          u = c[0],
          l = c[1],
          f = !0 === r ? SB : r || null;
      return p.a.createElement(tB, Zt({}, i, {
        ref: u,
        popperConfig: Zt({}, o, {
          modifiers: l.concat(o.modifiers || [])
        }),
        transition: f
      }), function (e) {
        var n,
            o = e.props,
            i = e.arrowProps,
            c = e.show,
            u = e.update,
            l = (e.forceUpdate, e.placement),
            s = e.state,
            f = er(e, kB);
        !function (e, t) {
          var r = e.ref,
              n = t.ref;
          e.ref = r.__wrapped || (r.__wrapped = function (e) {
            return r(fa(e));
          }), t.ref = n.__wrapped || (n.__wrapped = function (e) {
            return n(fa(e));
          });
        }(o, i);
        var d = Object.assign(a.current, {
          state: s,
          scheduleUpdate: u,
          placement: l,
          outOfBoundaries: (null == s ? void 0 : null == (n = s.modifiersData.hide) ? void 0 : n.isReferenceHidden) || !1
        });
        return "function" == typeof t ? t(Zt({}, f, o, {
          placement: l,
          show: c
        }, !r && c && {
          className: "show"
        }, {
          popper: d,
          arrowProps: i
        })) : p.a.cloneElement(t, Zt({}, f, o, {
          placement: l,
          arrowProps: i,
          popper: d,
          className: rr()(t.props.className, !r && c && "show"),
          style: Zt({}, t.props.style, o.style)
        }));
      });
    }

    TB.defaultProps = RB;

    var zB = TB,
        NB = ["trigger", "overlay", "children", "popperConfig", "show", "defaultShow", "onToggle", "delay", "placement", "flip"],
        DB = function (e) {
      function t() {
        return e.apply(this, arguments) || this;
      }

      return Eo(t, e), t.prototype.render = function () {
        return this.props.children;
      }, t;
    }(p.a.Component);

    function xB(e, t, r) {
      var n = t[0],
          o = n.currentTarget,
          i = n.relatedTarget || n.nativeEvent[r];
      i && i === o || oa(o, i) || e.apply(void 0, t);
    }

    function AB(e) {
      var t = e.trigger,
          r = e.overlay,
          n = e.children,
          o = e.popperConfig,
          i = void 0 === o ? {} : o,
          a = e.show,
          c = e.defaultShow,
          u = void 0 !== c && c,
          l = e.onToggle,
          f = e.delay,
          d = e.placement,
          b = e.flip,
          y = void 0 === b ? d && -1 !== d.indexOf("auto") : b,
          m = er(e, NB),
          v = Object(s.useRef)(null),
          h = $F(),
          g = Object(s.useRef)(""),
          w = jo(a, u, l),
          O = w[0],
          j = w[1],
          P = function (e) {
        return e && "object" == typeof e ? e : {
          show: e,
          hide: e
        };
      }(f),
          _ = "function" != typeof n ? p.a.Children.only(n).props : {},
          E = _.onFocus,
          S = _.onBlur,
          C = _.onClick,
          k = Object(s.useCallback)(function () {
        return fa(v.current);
      }, []),
          R = Object(s.useCallback)(function () {
        h.clear(), g.current = "show", P.show ? h.set(function () {
          "show" === g.current && j(!0);
        }, P.show) : j(!0);
      }, [P.show, j, h]),
          T = Object(s.useCallback)(function () {
        h.clear(), g.current = "hide", P.hide ? h.set(function () {
          "hide" === g.current && j(!1);
        }, P.hide) : j(!1);
      }, [P.hide, j, h]),
          z = Object(s.useCallback)(function () {
        R();

        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

        null == E || E.apply(void 0, t);
      }, [R, E]),
          N = Object(s.useCallback)(function () {
        T();

        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

        null == S || S.apply(void 0, t);
      }, [T, S]),
          D = Object(s.useCallback)(function () {
        j(!O), C && C.apply(void 0, arguments);
      }, [C, j, O]),
          x = Object(s.useCallback)(function () {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

        xB(R, t, "fromElement");
      }, [R]),
          A = Object(s.useCallback)(function () {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

        xB(T, t, "toElement");
      }, [T]),
          M = null == t ? [] : [].concat(t),
          I = {};

      return -1 !== M.indexOf("click") && (I.onClick = D), -1 !== M.indexOf("focus") && (I.onFocus = z, I.onBlur = N), -1 !== M.indexOf("hover") && (I.onMouseOver = x, I.onMouseOut = A), p.a.createElement(p.a.Fragment, null, "function" == typeof n ? n(Zt({}, I, {
        ref: v
      })) : p.a.createElement(DB, {
        ref: v
      }, Object(s.cloneElement)(n, I)), p.a.createElement(zB, Zt({}, m, {
        show: O,
        onHide: T,
        flip: y,
        placement: d,
        popperConfig: i,
        target: k
      }), r));
    }

    AB.defaultProps = {
      defaultShow: !1,
      trigger: ["hover", "focus"]
    };
    var MB = AB,
        IB = ["bsPrefix", "placement", "className", "style", "children", "arrowProps", "popper", "show"],
        FB = p.a.forwardRef(function (e, t) {
      var r = e.bsPrefix,
          n = e.placement,
          o = e.className,
          i = e.style,
          a = e.children,
          c = e.arrowProps,
          u = (e.popper, e.show, er(e, IB));
      r = or(r, "tooltip");
      var l = ((null == n ? void 0 : n.split("-")) || [])[0];
      return p.a.createElement("div", Zt({
        ref: t,
        style: i,
        role: "tooltip",
        "x-placement": l,
        className: rr()(o, r, "bs-tooltip-" + l)
      }, u), p.a.createElement("div", Zt({
        className: "arrow"
      }, c)), p.a.createElement("div", {
        className: r + "-inner"
      }, a));
    });
    FB.defaultProps = {
      placement: "right"
    }, FB.displayName = "Tooltip";
    var BB,
        LB,
        VB = FB,
        UB = r(204),
        qB = r.n(UB),
        KB = Object(s.forwardRef)(function (e, t) {
      var r = e.children,
          n = e.className,
          o = e.onClick;
      return p.a.createElement("a", {
        className: n,
        href: "",
        role: "button",
        ref: t,
        onClick: function (e) {
          e.preventDefault(), o(e);
        }
      }, r);
    });

    function GB(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, WB(n.key), n);
      }
    }

    function WB(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function HB(e, t, r) {
      return t = JB(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], JB(e).constructor) : t.apply(e, r));
    }

    function JB(e) {
      return (JB = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function YB(e, t) {
      return (YB = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var QB,
        $B = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((LB = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), HB(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && YB(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "className",
        get: function () {
          return this.props.isRemovingColumn ? "icon icon-removing" : "";
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.children;
          return p.a.createElement(_c.Toggle, {
            as: KB,
            bsPrefix: "link-dropdown-toggle",
            className: this.className
          }, e);
        }
      }]) && GB(r.prototype, n), o && GB(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "className", [f.computed], Object.getOwnPropertyDescriptor(LB.prototype, "className"), LB.prototype), BB = LB)) || BB;

    function XB(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ZB(n.key), n);
      }
    }

    function ZB(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function eL(e, t, r) {
      return t = tL(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], tL(e).constructor) : t.apply(e, r));
    }

    function tL(e) {
      return (tL = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function rL(e, t) {
      return (rL = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var nL,
        oL,
        iL,
        aL,
        cL,
        uL,
        lL,
        sL,
        pL,
        fL,
        dL,
        bL,
        yL,
        mL = Object(d.observer)(QB = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), eL(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && rL(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.report,
              r = e.columnSpec;
          return p.a.createElement(p.a.Fragment, null, t.columnConfig.isFiltering(r) ? p.a.createElement("i", {
            role: "img",
            className: "fas fa-filter ml-1"
          }) : null, t.columnConfig.isGrouped(r) ? p.a.createElement("i", {
            role: "img",
            className: "fas fa-layer-group ml-1"
          }) : null, t.columnConfig.isSortingUp(r) ? p.a.createElement("i", {
            role: "img",
            className: "fas fa-sort-up ml-1"
          }) : t.columnConfig.isSortingDown(r) ? p.a.createElement("i", {
            role: "img",
            className: "fas fa-sort-down ml-1"
          }) : null);
        }
      }]) && XB(r.prototype, n), o && XB(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || QB;

    function vL(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function hL(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, gL(n.key), n);
      }
    }

    function gL(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function wL(e, t, r) {
      return t = OL(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], OL(e).constructor) : t.apply(e, r));
    }

    function OL(e) {
      return (OL = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function jL(e, t) {
      return (jL = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function PL(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var _L,
        EL,
        SL = {
      name: "applyMaxSize",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["maxSize"],
      fn: function (e) {
        var t = e.state,
            r = t.modifiersData.maxSize.height;
        t.styles.popper.maxHeight = "".concat(r, "px");
      }
    },
        CL = Object(d.observer)((iL = PL((oL = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), vL(r = wL(this, t, [e]), "isRemoving", iL, r), vL(r, "onCalculate", aL, r), vL(r, "onConvert", cL, r), vL(r, "onEditCalculation", uL, r), vL(r, "onRemoveColumn", lL, r), r.onRenameColumn = function (e) {
          var t = r.props,
              n = t.report,
              o = t.columnSpec;
          e.preventDefault(), n.columnConfig.renameColumn(o);
        }, vL(r, "onFilter", sL, r), vL(r, "onSplitScalarFromUnits", pL, r), vL(r, "onSortAscending", fL, r), vL(r, "onSortDescending", dL, r), vL(r, "onToggleGroup", bL, r), vL(r, "removeColumn", yL, r);
        var n = ["report", "columnSpec", "columnCalculationModal", "convertUnitsModal"].filter(function (t) {
          return !e[t];
        });
        if (n.length) throw new Error("Missing prop".concat(1 === n.length ? "s" : "", ": ").concat(n.map(function (e) {
          return '"'.concat(e, '"');
        }).join(", ")));
        return r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && jL(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && hL(e.prototype, t), r && hL(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "isSortingDown",
        get: function () {
          var e = this.props,
              t = e.report,
              r = e.columnSpec;
          return t.columnConfig.isSortingDown(r);
        }
      }, {
        key: "isSortingUp",
        get: function () {
          var e = this.props,
              t = e.report,
              r = e.columnSpec;
          return t.columnConfig.isSortingUp(r);
        }
      }, {
        key: "getColumnChoices",
        value: function (e) {
          var t = this.props,
              r = t.report,
              n = t.columnSpec;
          return e ? r.columnConfig.visibleColumns : r.columnConfig.visibleColumns.filter(function (e) {
            return e.id !== n.id;
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.report,
              r = e.columnSpec,
              n = e.t,
              o = e.convertUnitsModal;
          return p.a.createElement(_c, null, p.a.createElement($B, {
            isRemovingColumn: this.isRemoving
          }, p.a.createElement(MB, {
            placement: "top",
            delay: {
              show: 500,
              hide: 400
            },
            overlay: p.a.createElement(VB, null, r.id)
          }, p.a.createElement("span", null, r.getName())), p.a.createElement(mL, {
            report: t,
            columnSpec: r
          })), p.a.createElement(_c.Menu, {
            popperConfig: {
              strategy: "fixed",
              modifiers: [qB.a, SL]
            }
          }, p.a.createElement("h6", {
            className: "dropdown-header"
          }, n("column_actions")), p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "remove",
            onClick: this.onRemoveColumn
          }, p.a.createElement("i", {
            className: "fas fa-trash-alt pr-2"
          }), n("remove")), p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "rename",
            onClick: this.onRenameColumn
          }, p.a.createElement("i", {
            className: "fas fa-i-cursor pr-2"
          }), n("rename")), r.filterType() ? p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "filter",
            onClick: this.onFilter
          }, p.a.createElement("i", {
            className: "fas fa-filter pr-2"
          }), n("filter_verb")) : p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "filter",
            onClick: this.onFilter,
            disabled: !0
          }, p.a.createElement("i", {
            className: "fas fa-filter pr-2"
          }), n("filter_verb")), Az.isCalculationColumnSpec(r) ? p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "edit_calculation",
            onClick: this.onEditCalculation
          }, p.a.createElement("i", {
            className: "fas fa-edit pr-2"
          }), n("edit_calculation"), "…") : null, p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "calculate",
            onClick: this.onCalculate
          }, p.a.createElement("i", {
            className: "fas fa-calculator pr-2"
          }), n("calculate"), "…"), o.isConvertible(r) ? p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "convert",
            onClick: this.onConvert
          }, p.a.createElement("i", {
            role: "img",
            className: "fas fa-exchange-alt pr-2",
            "aria-label": "Convert"
          }), n("convert"), "…") : null, o.isConvertible(r) ? p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "split_scalar_from_units",
            onClick: this.onSplitScalarFromUnits
          }, p.a.createElement("i", {
            role: "img",
            className: "fas fa-th-list pr-2",
            "aria-label": "Split scalar from units"
          }), n("split_scalar_from_units")) : null, p.a.createElement("h6", {
            className: "dropdown-header"
          }, n("group_sort")), p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "group",
            disabled: !0,
            onClick: this.onToggleGroup
          }, p.a.createElement("i", {
            className: "fas fa-layer-group pr-2"
          }), t.columnConfig.isGrouped(r) ? n("ungroup") : n("group_verb")), p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "sort_ascending",
            onClick: this.onSortAscending
          }, p.a.createElement("i", {
            className: "fas fa-sort-up pr-2"
          }), n("sort_ascending"), this.isSortingUp ? p.a.createElement("i", {
            className: "fas fa-check pl-2"
          }) : null), p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "sort_descending",
            onClick: this.onSortDescending
          }, p.a.createElement("i", {
            className: "fas fa-sort-down pr-2"
          }), n("sort_descending"), this.isSortingDown ? p.a.createElement("i", {
            className: "fas fa-check pl-2"
          }) : null)));
        }
      }]);
    }()).prototype, "isRemoving", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), PL(oL.prototype, "isSortingDown", [f.computed], Object.getOwnPropertyDescriptor(oL.prototype, "isSortingDown"), oL.prototype), PL(oL.prototype, "isSortingUp", [f.computed], Object.getOwnPropertyDescriptor(oL.prototype, "isSortingUp"), oL.prototype), aL = PL(oL.prototype, "onCalculate", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.report,
              o = r.columnSpec,
              i = r.columnCalculationModal;
          t.preventDefault(), i.setColumnChoices(e.getColumnChoices(!0)), o && (i.isCalculable(o) && i.operand1.selectColumn(o.id), i.new({
            position: o.position && o.position + 1 || n.columnConfig.columnSpecs.length
          })), i.show();
        };
      }
    }), cL = PL(oL.prototype, "onConvert", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.columnSpec,
              o = r.convertUnitsModal;
          t.preventDefault(), o.show(n);
        };
      }
    }), uL = PL(oL.prototype, "onEditCalculation", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.columnSpec,
              o = r.columnCalculationModal;
          t.preventDefault(), o.setColumnChoices(e.getColumnChoices()), n && o.edit(n), o.show();
        };
      }
    }), lL = PL(oL.prototype, "onRemoveColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.preventDefault(), e.isRemoving = !0, setTimeout(e.removeColumn, 20);
        };
      }
    }), sL = PL(oL.prototype, "onFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.columnSpec,
              n = t.report;
          n.columnFilterModal.show(n, r);
        };
      }
    }), pL = PL(oL.prototype, "onSplitScalarFromUnits", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.columnSpec,
              n = t.report,
              o = t.t;
          return n.columnConfig.splitScalarFromUnits(r, o), n.update().catch(console.error);
        };
      }
    }), fL = PL(oL.prototype, "onSortAscending", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.report,
              n = t.columnSpec;
          return r.columnConfig.sortAscending(n), r.update().catch(console.error);
        };
      }
    }), dL = PL(oL.prototype, "onSortDescending", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.report,
              n = t.columnSpec;
          return r.columnConfig.sortDescending(n), r.update().catch(console.error);
        };
      }
    }), bL = PL(oL.prototype, "onToggleGroup", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.report,
              n = t.columnSpec;
          if (r.columnConfig.isGrouped(n)) return r.columnConfig.unGroup(n);
          r.columnConfig.group(n);
        };
      }
    }), yL = PL(oL.prototype, "removeColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.report,
              n = t.columnSpec;
          return r.columnConfig.removeColumn(n), r.update().catch(console.error).finally(function () {
            return Object(f.runInAction)(function () {
              return e.isRemoving = !1;
            });
          });
        };
      }
    }), nL = oL)) || nL,
        kL = Object(g.a)()(CL);

    function RL(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, TL(n.key), n);
      }
    }

    function TL(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function zL(e, t, r) {
      return t = NL(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], NL(e).constructor) : t.apply(e, r));
    }

    function NL(e) {
      return (NL = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function DL(e, t) {
      return (DL = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function xL(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var AL,
        ML,
        IL,
        FL,
        BL,
        LL,
        VL,
        UL,
        qL,
        KL,
        GL,
        WL,
        HL,
        JL,
        YL,
        QL,
        $L = Object(d.observer)((xL((EL = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = zL(this, t, [].concat(n))).onDragColumnEnd = function () {
          e.props.report.columnConfig.stopDraggingColumn();
        }, e.onDragColumnStart = function (t) {
          var r = e.props,
              n = r.report,
              o = r.columnSpec;
          t.dataTransfer.dropEffect = "move", n.columnConfig.dragColumn(o);
        }, e.onDragOverColumn = function (t) {
          var r = e.props,
              n = r.report,
              o = r.columnSpec;
          t.preventDefault(), t.stopPropagation(), n.columnConfig.isValidDropTarget(o) ? t.dataTransfer.dropEffect = "move" : t.dataTransfer.dropEffect = "none", n.columnConfig.dragOverColumn(o);
        }, e.onDropColumn = function (t) {
          var r = e.props,
              n = r.report,
              o = r.columnSpec;
          return t.preventDefault(), n.columnConfig.dropColumn(o), n.update().catch(console.error);
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && DL(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "isDraggable",
        get: function () {
          var e = this.props,
              t = e.report,
              r = e.columnSpec;
          return !t.columnConfig.isRenamingColumn(r);
        }
      }, {
        key: "isRenaming",
        get: function () {
          var e = this.props,
              t = e.report,
              r = e.columnSpec;
          return t.columnConfig.isRenamingColumn(r);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.report,
              r = e.columnSpec,
              n = e.columnCalculationModal,
              o = e.convertUnitsModal;
          return p.a.createElement("th", {
            scope: "col",
            className: t.tableCellClass(r),
            ref: r.ref,
            draggable: this.isDraggable,
            onDragStart: this.onDragColumnStart,
            onDragOver: this.onDragOverColumn,
            onDrop: this.onDropColumn,
            onDragEnd: this.onDragColumnEnd
          }, this.isRenaming ? p.a.createElement(JF, {
            columnSpec: r,
            report: t
          }) : p.a.createElement(kL, {
            report: t,
            columnSpec: r,
            columnCalculationModal: n,
            convertUnitsModal: o
          }));
        }
      }]) && RL(r.prototype, n), o && RL(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "isDraggable", [f.computed], Object.getOwnPropertyDescriptor(EL.prototype, "isDraggable"), EL.prototype), xL(EL.prototype, "isRenaming", [f.computed], Object.getOwnPropertyDescriptor(EL.prototype, "isRenaming"), EL.prototype), _L = EL)) || _L;

    function XL(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function ZL(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, eV(n.key), n);
      }
    }

    function eV(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function tV(e, t, r) {
      return t = rV(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], rV(e).constructor) : t.apply(e, r));
    }

    function rV(e) {
      return (rV = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function nV(e, t) {
      return (nV = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function oV(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var iV,
        aV,
        cV,
        uV,
        lV,
        sV,
        pV,
        fV,
        dV,
        bV,
        yV,
        mV,
        vV,
        hV,
        gV,
        wV,
        OV,
        jV,
        PV,
        _V,
        EV = ((QL = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return XL(e = tV(this, t, [].concat(n)), "additionalColumnChoices", ML, e), XL(e, "selectedColumn", IL, e), XL(e, "columnError", FL, e), XL(e, "isRadioDisabled", BL, e), XL(e, "selectedUnit", LL, e), XL(e, "scalar", VL, e), XL(e, "scalarError", UL, e), e.id = Object(td.v4)(), XL(e, "isConstant", qL, e), XL(e, "disableConstant", KL, e), XL(e, "enableConstant", GL, e), XL(e, "selectColumn", WL, e), XL(e, "selectUnit", HL, e), XL(e, "setScalar", JL, e), XL(e, "toggleConstant", YL, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && nV(e, t);
      }(t, h["ViewModel"]), function (e, t, r) {
        return t && ZL(e.prototype, t), r && ZL(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "isValid",
        get: function () {
          return this.isConstant && !this.scalarError || !this.isConstant && !this.columnError;
        }
      }, {
        key: "columnChoices",
        get: function () {
          var e = this.props.columnChoices;
          return Object(x.uniqBy)(Object(x.prop)("id"))((e || []).concat(this.additionalColumnChoices));
        }
      }, {
        key: "clearErrors",
        value: function () {
          this.columnError = "", this.scalarError = "";
        }
      }, {
        key: "getSelectedColumnSpec",
        value: function () {
          var e = this;
          return this.columnChoices.find(function (t) {
            return t.id === e.selectedColumn;
          });
        }
      }, {
        key: "reset",
        value: function () {
          this.scalar = "", this.selectedUnit = "", this.selectedColumn = "", this.isConstant = !1, this.clearErrors();
        }
      }, {
        key: "validate",
        value: function () {
          if (this.clearErrors(), this.isConstant) return this.validateConstant();

          if (!this.selectedColumn) {
            var e = this.props.t;
            this.columnError = e("column_blank_error");
          }
        }
      }, {
        key: "validateConstant",
        value: function () {
          if (!this.scalar && 0 !== this.scalar) {
            var e = this.props.t;
            this.scalarError = e("scalar_blank_error");
          }
        }
      }, {
        key: "initializeFromSpec",
        value: function (e) {
          if (_z.isColumnCalculationOperandSpec(e)) this.isConstant = !1, this.selectedColumn = e.referenceColumnSpec.id, this.additionalColumnChoices = [e.referenceColumnSpec];else if (Cx.isConstantCalculationOperandSpec(e)) {
            this.isConstant = !0;
            var t = new w.Quantity(e.value);
            this.scalar = t.scalar, this.selectedUnit = t.units;
          }
        }
      }]);
    }()).unitChoices = ["acre", "hectare"].map(function (e) {
      return {
        group: "Area",
        value: e
      };
    }).concat(["oz", "lbs", "tn", "grams", "kg"].map(function (e) {
      return {
        group: "Mass",
        value: e
      };
    })).concat(["floz", "pt", "qt", "gal", "hgal", "mL", "L"].map(function (e) {
      return {
        group: "Volume",
        value: e,
        displayName: e.replace("hgal", "100 gal")
      };
    })), ML = oV((AL = QL).prototype, "additionalColumnChoices", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), IL = oV(AL.prototype, "selectedColumn", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), FL = oV(AL.prototype, "columnError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), BL = oV(AL.prototype, "isRadioDisabled", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), LL = oV(AL.prototype, "selectedUnit", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), VL = oV(AL.prototype, "scalar", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), UL = oV(AL.prototype, "scalarError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), qL = oV(AL.prototype, "isConstant", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), oV(AL.prototype, "isValid", [f.computed], Object.getOwnPropertyDescriptor(AL.prototype, "isValid"), AL.prototype), oV(AL.prototype, "columnChoices", [f.computed], Object.getOwnPropertyDescriptor(AL.prototype, "columnChoices"), AL.prototype), oV(AL.prototype, "clearErrors", [f.action], Object.getOwnPropertyDescriptor(AL.prototype, "clearErrors"), AL.prototype), KL = oV(AL.prototype, "disableConstant", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isConstant = !1, e.isRadioDisabled = !0;
        };
      }
    }), GL = oV(AL.prototype, "enableConstant", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isRadioDisabled = !1;
        };
      }
    }), oV(AL.prototype, "reset", [f.action], Object.getOwnPropertyDescriptor(AL.prototype, "reset"), AL.prototype), WL = oV(AL.prototype, "selectColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.selectedColumn = t;
        };
      }
    }), HL = oV(AL.prototype, "selectUnit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.selectedUnit = t;
        };
      }
    }), JL = oV(AL.prototype, "setScalar", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.scalar = t;
        };
      }
    }), YL = oV(AL.prototype, "toggleConstant", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isConstant = !e.isConstant;
        };
      }
    }), oV(AL.prototype, "validate", [f.action], Object.getOwnPropertyDescriptor(AL.prototype, "validate"), AL.prototype), oV(AL.prototype, "validateConstant", [f.action], Object.getOwnPropertyDescriptor(AL.prototype, "validateConstant"), AL.prototype), oV(AL.prototype, "initializeFromSpec", [f.action], Object.getOwnPropertyDescriptor(AL.prototype, "initializeFromSpec"), AL.prototype), AL);

    function SV(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function CV(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, kV(n.key), n);
      }
    }

    function kV(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function RV(e, t, r) {
      return t = TV(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], TV(e).constructor) : t.apply(e, r));
    }

    function TV(e) {
      return (TV = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function zV(e, t) {
      return (zV = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function NV(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var DV,
        xV,
        AV,
        MV,
        IV = (iV = f.action.bound, aV = f.action.bound, (_V = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), SV(r = RV(this, t, [e]), "calculationColumnSpec", uV, r), SV(r, "id", lV, r), SV(r, "isEditing", sV, r), SV(r, "isShowing", pV, r), SV(r, "newColumnPosition", fV, r), SV(r, "operand1", dV, r), SV(r, "operand2", bV, r), SV(r, "operand3", yV, r), SV(r, "operationError", mV, r), SV(r, "saveButtonText", vV, r), SV(r, "selectedOperation", hV, r), SV(r, "title", gV, r), SV(r, "edit", wV, r), SV(r, "new", OV, r), SV(r, "reverseOperands", jV, r), SV(r, "selectOperation", PV, r), r.operand1 = new EV({
          t: r.props.t
        }), r.operand2 = new EV({
          t: r.props.t
        }), r.operand3 = new EV({
          t: r.props.t
        }), r.disposeOperationReaction = Object(f.reaction)(function () {
          return r.selectedOperation;
        }, function () {
          r.allowConstantOperands() ? r.operand1.enableConstant() : r.operand1.disableConstant();
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && zV(e, t);
      }(t, h["ViewModel"]), function (e, t, r) {
        return t && CV(e.prototype, t), r && CV(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "isValid",
        get: function () {
          return !this.operationError && this.operand1.isValid && this.operand2.isValid;
        }
      }, {
        key: "operands",
        get: function () {
          return [this.operand1, this.operand2, this.operand3].slice(0, this.getArity() || 2);
        }
      }, {
        key: "operandKeys",
        get: function () {
          return ["operand1", "operand2", "operand3"].slice(0, this.getArity() || 2);
        }
      }, {
        key: "allowConstantOperands",
        value: function () {
          var e = this.props.t;
          return this.selectedOperation && PM.getCalculation(this.selectedOperation, e).allowConstantOperands();
        }
      }, {
        key: "clearErrors",
        value: function () {
          this.operationError = "";
        }
      }, {
        key: "destroy",
        value: function () {
          this.disposeOperationReaction();
        }
      }, {
        key: "hide",
        value: function () {
          this.isShowing = !1;
        }
      }, {
        key: "isCalculable",
        value: function (e) {
          return e.isCalculable();
        }
      }, {
        key: "getArity",
        value: function () {
          var e = this.props.t;
          return this.selectedOperation && PM.getCalculation(this.selectedOperation, e).arity();
        }
      }, {
        key: "getCalculationName",
        value: function (e) {
          var t = this,
              r = PM.getCalculation(this.selectedOperation, e),
              n = this.operands.map(function (r) {
            var n = "<".concat(e("select_operand"), ">");

            try {
              var o = t.getCalculationOperandSpec(r);
              n = _z.isColumnCalculationOperandSpec(o) && Az.isCalculationColumnSpec(o.referenceColumnSpec) && 2 === o.referenceColumnSpec.calculation.arity() ? "(".concat(o.getName().trim() || n, ")") : o.getName().trim() || n;
            } catch (e) {}

            return n;
          });
          return r.display(n);
        }
      }, {
        key: "getCalculationSpec",
        value: function () {
          var e = this,
              t = this.props.t,
              r = PM.getCalculation(this.selectedOperation, t);
          if (!r) throw new Error('Could not create calculation for "'.concat(this.selectedOperation, '"'));
          var n = this.newColumnPosition,
              o = PM.getCalculatedColumnClass(this.selectedOperation),
              i = {
            t: t,
            position: n,
            calculation: r
          };
          return this.operandKeys.forEach(function (t) {
            return i[t] = e.getCalculationOperandSpec(e[t]);
          }), this.isEditing && (i.id = this.calculationColumnSpec.id), new o(i);
        }
      }, {
        key: "getCalculationOperandSpec",
        value: function (e) {
          return e.isConstant ? new Cx({
            value: [].concat(e.scalar).concat(e.selectedUnit).join(" ")
          }) : new _z({
            referenceColumnSpec: e.getSelectedColumnSpec()
          });
        }
      }, {
        key: "reset",
        value: function () {
          this.operand1.reset(), this.operand2.reset(), this.operand3.reset(), this.selectedOperation = "multiply", this.calculationColumnSpec = void 0, this.isEditing = !1, this.clearErrors();
        }
      }, {
        key: "setColumnChoices",
        value: function (e) {
          var t = this,
              r = e.filter(function (e) {
            return t.isCalculable(e);
          });
          this.operand1.update({
            columnChoices: r
          }), this.operand2.update({
            columnChoices: r
          }), this.operand3.update({
            columnChoices: r
          });
        }
      }, {
        key: "show",
        value: function () {
          this.isShowing = !0;
        }
      }, {
        key: "validate",
        value: function () {
          if (this.clearErrors(), this.operands.forEach(function (e) {
            return e.validate();
          }), !this.selectedOperation) {
            var e = this.props.t;
            this.operationError = e("operation_blank_error");
          }
        }
      }]);
    }()).operationChoices = [{
      id: "add",
      value: bN.operatorSymbol(),
      group: "arithmetic"
    }, {
      id: "subtract",
      value: AN.operatorSymbol(),
      group: "arithmetic"
    }, {
      id: "multiply",
      value: tD.operatorSymbol(),
      group: "arithmetic"
    }, {
      id: "divide",
      value: CD.operatorSymbol(),
      group: "arithmetic"
    }, {
      id: "blank",
      value: ox.operatorSymbol(),
      group: "logic"
    }, {
      id: "if",
      value: LA.operatorSymbol(),
      group: "logic"
    }, {
      id: "not",
      value: Bx.operatorSymbol(),
      group: "logic"
    }, {
      id: "or",
      value: aA.operatorSymbol(),
      group: "logic"
    }], uV = NV((cV = _V).prototype, "calculationColumnSpec", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), lV = NV(cV.prototype, "id", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return Object(td.v4)();
      }
    }), sV = NV(cV.prototype, "isEditing", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), pV = NV(cV.prototype, "isShowing", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), fV = NV(cV.prototype, "newColumnPosition", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), dV = NV(cV.prototype, "operand1", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), bV = NV(cV.prototype, "operand2", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), yV = NV(cV.prototype, "operand3", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), mV = NV(cV.prototype, "operationError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), vV = NV(cV.prototype, "saveButtonText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), hV = NV(cV.prototype, "selectedOperation", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "multiply";
      }
    }), gV = NV(cV.prototype, "title", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), NV(cV.prototype, "isValid", [f.computed], Object.getOwnPropertyDescriptor(cV.prototype, "isValid"), cV.prototype), NV(cV.prototype, "operands", [f.computed], Object.getOwnPropertyDescriptor(cV.prototype, "operands"), cV.prototype), NV(cV.prototype, "operandKeys", [f.computed], Object.getOwnPropertyDescriptor(cV.prototype, "operandKeys"), cV.prototype), NV(cV.prototype, "clearErrors", [f.action], Object.getOwnPropertyDescriptor(cV.prototype, "clearErrors"), cV.prototype), wV = NV(cV.prototype, "edit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.t;
          e.title = r("edit_calculation"), e.saveButtonText = r("save"), e.newColumnPosition = t.position, e.operand1.initializeFromSpec(t.operand1), e.operand2.initializeFromSpec(t.operand2), e.operand3.initializeFromSpec(t.operand3), e.selectedOperation = t.calculation.constructor.operatorId(), e.calculationColumnSpec = t, e.isEditing = !0;
        };
      }
    }), NV(cV.prototype, "hide", [iV], Object.getOwnPropertyDescriptor(cV.prototype, "hide"), cV.prototype), OV = NV(cV.prototype, "new", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.t;
          e.newColumnPosition = t.position, e.title = r("add_calculation"), e.saveButtonText = r("add");
        };
      }
    }), NV(cV.prototype, "reset", [f.action], Object.getOwnPropertyDescriptor(cV.prototype, "reset"), cV.prototype), jV = NV(cV.prototype, "reverseOperands", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.operand1;
          e.operand1 = e.operand2, e.operand2 = t;
        };
      }
    }), NV(cV.prototype, "setColumnChoices", [f.action], Object.getOwnPropertyDescriptor(cV.prototype, "setColumnChoices"), cV.prototype), PV = NV(cV.prototype, "selectOperation", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.selectedOperation = t;
        };
      }
    }), NV(cV.prototype, "show", [aV], Object.getOwnPropertyDescriptor(cV.prototype, "show"), cV.prototype), cV),
        FV = r(10);

    function BV(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function LV(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, VV(n.key), n);
      }
    }

    function VV(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function UV(e, t, r) {
      return t = qV(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], qV(e).constructor) : t.apply(e, r));
    }

    function qV(e) {
      return (qV = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function KV(e, t) {
      return (KV = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function GV(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var WV,
        HV,
        JV,
        YV,
        QV,
        $V,
        XV,
        ZV = Object(d.observer)((GV((xV = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return BV(e = UV(this, t, [].concat(n)), "onChangeOperation", AV, e), BV(e, "onReversOperands", MV, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && KV(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "allOptions",
        get: function () {
          return this.props.modal.constructor.operationChoices;
        }
      }, {
        key: "arithmeticOptions",
        get: function () {
          return this.allOptions.filter(function (e) {
            return "arithmetic" === e.group;
          });
        }
      }, {
        key: "className",
        get: function () {
          var e = this.props.className;
          return ["operation-tool"].concat(e || []).join(" ");
        }
      }, {
        key: "logicOptions",
        get: function () {
          return this.allOptions.filter(function (e) {
            return "logic" === e.group;
          });
        }
      }, {
        key: "operationClassNames",
        get: function () {
          var e = this.props.modal;
          return ["form-control calculation-selector operation-selector"].concat(e.isValid ? [] : "is-invalid").join(" ");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.modal;
          return p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col mb-2"
          }, p.a.createElement("select", {
            value: e.selectedOperation,
            onChange: this.onChangeOperation,
            className: this.operationClassNames
          }, this.arithmeticOptions.length ? p.a.createElement("optgroup", {
            label: "Arithmetic",
            key: "arithmetic"
          }, this.arithmeticOptions.map(function (e) {
            return p.a.createElement("option", {
              key: e.id,
              value: e.id
            }, e.value);
          })) : null, this.logicOptions.length ? p.a.createElement("optgroup", {
            label: "Logic",
            key: "logic"
          }, this.logicOptions.map(function (e) {
            return p.a.createElement("option", {
              key: e.id,
              value: e.id
            }, e.value);
          })) : null), p.a.createElement("div", {
            className: "invalid-feedback"
          }, e.operationError)), p.a.createElement("div", {
            className: "col-md-auto text-center mb-2"
          }, p.a.createElement("button", {
            type: "button",
            "aria-label": "Reverse operands",
            className: "btn btn-secondary",
            onClick: this.onReversOperands,
            disabled: 2 !== e.getArity()
          }, p.a.createElement("i", {
            className: "fas fa-exchange-alt"
          }))));
        }
      }]) && LV(r.prototype, n), o && LV(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "allOptions", [f.computed], Object.getOwnPropertyDescriptor(xV.prototype, "allOptions"), xV.prototype), GV(xV.prototype, "arithmeticOptions", [f.computed], Object.getOwnPropertyDescriptor(xV.prototype, "arithmeticOptions"), xV.prototype), GV(xV.prototype, "className", [f.computed], Object.getOwnPropertyDescriptor(xV.prototype, "className"), xV.prototype), GV(xV.prototype, "logicOptions", [f.computed], Object.getOwnPropertyDescriptor(xV.prototype, "logicOptions"), xV.prototype), GV(xV.prototype, "operationClassNames", [f.computed], Object.getOwnPropertyDescriptor(xV.prototype, "operationClassNames"), xV.prototype), AV = GV(xV.prototype, "onChangeOperation", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.modal,
              o = r.onChange;
          n.selectOperation(t.target.value), o();
        };
      }
    }), MV = GV(xV.prototype, "onReversOperands", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.modal,
              n = t.onChange;
          r.reverseOperands(), n();
        };
      }
    }), DV = xV)) || DV;

    function eU(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function tU(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, rU(n.key), n);
      }
    }

    function rU(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function nU(e, t, r) {
      return t = oU(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], oU(e).constructor) : t.apply(e, r));
    }

    function oU(e) {
      return (oU = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function iU(e, t) {
      return (iU = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function aU(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var cU,
        uU,
        lU,
        sU,
        pU = Object(d.observer)((aU((HV = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return eU(e = nU(this, t, [].concat(n)), "onChangeColumn", JV, e), eU(e, "onRadioClick", YV, e), eU(e, "onRadioKeyDown", QV, e), eU(e, "onUpdateUnit", $V, e), eU(e, "onUpdateValue", XV, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && iU(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && tU(e.prototype, t), r && tU(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "columnId",
        get: function () {
          var e = this.props.operand;
          return "".concat(e.id, "-column");
        }
      }, {
        key: "columnSelectorClassNames",
        get: function () {
          var e = this.props.operand;
          return ["form-control calculation-selector"].concat(e.isValid ? [] : "is-invalid").join(" ");
        }
      }, {
        key: "constantId",
        get: function () {
          var e = this.props.operand;
          return "".concat(e.id, "-constant");
        }
      }, {
        key: "defaultId",
        get: function () {
          var e = this.props.operand;
          return "".concat(e.id, "-default");
        }
      }, {
        key: "radioButtonClasses",
        get: function () {
          var e = this.props.operand;
          return ["form-check form-check-inline"].concat(e.isRadioDisabled ? "disabled" : []).join(" ");
        }
      }, {
        key: "radioRowClasses",
        get: function () {
          var e = this.props.alignRight;
          return "row radio-row".concat(e ? " justify-content-end" : "", " align-items-end");
        }
      }, {
        key: "groupName",
        get: function () {
          var e = this.props.operand;
          return "operand-radio-".concat(e.id);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.operand,
              r = e.t;
          return p.a.createElement("div", {
            className: "operand-tool col mb-2"
          }, p.a.createElement("div", {
            className: this.radioRowClasses
          }, p.a.createElement("div", {
            className: "col-auto mb-1"
          }, p.a.createElement("div", {
            role: "button",
            className: this.radioButtonClasses,
            onClick: this.onRadioClick(!t.isConstant),
            onKeyDown: this.onRadioKeyDown(!t.isConstant),
            tabIndex: "0"
          }, p.a.createElement("input", {
            className: "form-check-input",
            style: {
              pointerEvents: "none"
            },
            name: this.groupName,
            type: "radio",
            readOnly: !0,
            checked: !t.isConstant,
            tabIndex: "-1",
            id: this.columnId
          }), p.a.createElement("label", {
            className: "form-check-label",
            htmlFor: this.columnId
          }, r("column"))), p.a.createElement("div", {
            role: "button",
            className: this.radioButtonClasses,
            onClick: this.onRadioClick(t.isConstant),
            onKeyDown: this.onRadioKeyDown(t.isConstant),
            tabIndex: "0"
          }, p.a.createElement("input", {
            className: "form-check-input",
            style: {
              pointerEvents: "none"
            },
            name: this.groupName,
            type: "radio",
            readOnly: !0,
            checked: t.isConstant,
            tabIndex: "-1",
            id: this.constantId
          }), p.a.createElement("label", {
            className: "form-check-label",
            htmlFor: this.constantId
          }, r("constant"))))), p.a.createElement("div", {
            className: "row mx-n1 justify-content-end"
          }, t.isConstant ? p.a.createElement(h.UnitSelector, {
            unitChoices: t.constructor.unitChoices,
            currentUnit: t.selectedUnit,
            currentValue: t.scalar,
            valueColumnClassName: "col-sm-6 px-1",
            valueError: t.scalarError,
            unitColumnClassName: "col-sm-6 px-1",
            unitSelectorClassName: "form-control calculation-selector",
            onUpdateUnit: this.onUpdateUnit,
            onUpdateValue: this.onUpdateValue
          }) : p.a.createElement("div", {
            className: "col px-1"
          }, p.a.createElement("select", {
            value: t.selectedColumn,
            onChange: this.onChangeColumn,
            className: this.columnSelectorClassNames
          }, p.a.createElement("option", {
            key: this.defaultId,
            value: ""
          }, r("select_column")), t.columnChoices.map(function (e) {
            return p.a.createElement("option", {
              key: e.id,
              value: e.id
            }, e.getName());
          })), p.a.createElement("div", {
            className: "invalid-feedback"
          }, t.columnError))));
        }
      }]);
    }()).prototype, "columnId", [f.computed], Object.getOwnPropertyDescriptor(HV.prototype, "columnId"), HV.prototype), aU(HV.prototype, "columnSelectorClassNames", [f.computed], Object.getOwnPropertyDescriptor(HV.prototype, "columnSelectorClassNames"), HV.prototype), aU(HV.prototype, "constantId", [f.computed], Object.getOwnPropertyDescriptor(HV.prototype, "constantId"), HV.prototype), aU(HV.prototype, "defaultId", [f.computed], Object.getOwnPropertyDescriptor(HV.prototype, "defaultId"), HV.prototype), aU(HV.prototype, "radioButtonClasses", [f.computed], Object.getOwnPropertyDescriptor(HV.prototype, "radioButtonClasses"), HV.prototype), aU(HV.prototype, "radioRowClasses", [f.computed], Object.getOwnPropertyDescriptor(HV.prototype, "radioRowClasses"), HV.prototype), aU(HV.prototype, "groupName", [f.computed], Object.getOwnPropertyDescriptor(HV.prototype, "groupName"), HV.prototype), JV = aU(HV.prototype, "onChangeColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.operand,
              o = r.onChange;
          n.selectColumn(t.target.value), o(n);
        };
      }
    }), YV = aU(HV.prototype, "onRadioClick", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function () {
            var r = e.props,
                n = r.operand,
                o = r.onChange;
            n.isRadioDisabled || t || (n.toggleConstant(), o(n));
          };
        };
      }
    }), QV = aU(HV.prototype, "onRadioKeyDown", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function (r) {
            var n = e.props,
                o = n.operand,
                i = n.onChange;
            o.isRadioDisabled || ["Enter", " "].includes(r.key) && (e.onRadioClick(t)(), i(o));
          };
        };
      }
    }), $V = aU(HV.prototype, "onUpdateUnit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.operand,
              o = r.onChange;
          n.selectUnit(t), o(n);
        };
      }
    }), XV = aU(HV.prototype, "onUpdateValue", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.operand,
              o = r.onChange;
          n.setScalar(t), o(n);
        };
      }
    }), WV = HV)) || WV,
        fU = Object(g.a)()(pU);

    function dU(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function bU(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, yU(n.key), n);
      }
    }

    function yU(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function mU(e, t, r) {
      return t = vU(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], vU(e).constructor) : t.apply(e, r));
    }

    function vU(e) {
      return (vU = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function hU(e, t) {
      return (hU = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function gU(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var wU,
        OU,
        jU,
        PU,
        _U = Object(d.observer)((lU = gU((uU = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return dU(e = mU(this, t, [].concat(n)), "calculationName", lU, e), dU(e, "onChange", sU, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && hU(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && bU(e.prototype, t), r && bU(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "componentDidMount",
        value: function () {
          var e = this.props,
              t = e.modal,
              r = e.t;
          this.calculationName = t.getCalculationName(r);
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props.modal;
          return p.a.createElement(FV.ModalBody, null, p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col mb-3 text-center"
          }, p.a.createElement("span", {
            className: "calculation-name"
          }, this.calculationName))), p.a.createElement(ZV, {
            modal: t,
            onChange: this.onChange
          }), t.operands.map(function (t) {
            return p.a.createElement("div", {
              className: "row",
              key: t.id
            }, p.a.createElement(fU, {
              operand: t,
              onChange: e.onChange
            }));
          }));
        }
      }]);
    }()).prototype, "calculationName", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), sU = gU(uU.prototype, "onChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.modal,
              n = t.t;
          e.calculationName = r.getCalculationName(n);
        };
      }
    }), cU = uU)) || cU,
        EU = Object(g.a)()(_U);

    function SU(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function CU(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, kU(n.key), n);
      }
    }

    function kU(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function RU(e, t, r) {
      return t = TU(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], TU(e).constructor) : t.apply(e, r));
    }

    function TU(e) {
      return (TU = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function zU(e, t) {
      return (zU = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function NU(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var DU,
        xU,
        AU,
        MU = Object(d.observer)((jU = NU((OU = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return SU(e = RU(this, t, [].concat(n)), "onCancel", jU, e), SU(e, "onSave", PU, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && zU(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && CU(e.prototype, t), r && CU(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.modal,
              r = e.t;
          return p.a.createElement(FV.ModalFooter, null, p.a.createElement("button", {
            type: "button",
            className: "btn btn-secondary",
            onClick: this.onCancel
          }, r("cancel")), " ", p.a.createElement("button", {
            type: "button",
            className: "btn btn-primary",
            onClick: this.onSave
          }, r(t.saveButtonText)));
        }
      }]);
    }()).prototype, "onCancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.modal;
          t.hide(), t.reset();
        };
      }
    }), PU = NU(OU.prototype, "onSave", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.report,
              n = t.modal;

          if (n.validate(), n.isValid) {
            var o = n.getCalculationSpec();
            return n.isEditing ? r.columnConfig.replaceColumn(n.calculationColumnSpec, o) : r.columnConfig.addColumnAtPosition(o, o.position), n.hide(), n.reset(), r.update().catch(console.error);
          }
        };
      }
    }), wU = OU)) || wU,
        IU = Object(g.a)()(MU);

    function FU(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, BU(n.key), n);
      }
    }

    function BU(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function LU(e, t, r) {
      return t = VU(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], VU(e).constructor) : t.apply(e, r));
    }

    function VU(e) {
      return (VU = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function UU(e, t) {
      return (UU = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function qU(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var KU,
        GU,
        WU,
        HU,
        JU = Object(d.observer)((qU((xU = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = LU(this, t, [].concat(n)), "onCancel", AU, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && UU(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "headerId",
        get: function () {
          var e = this.props.modal;
          return "".concat(e.id, "-header");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.modal,
              r = e.report;
          return p.a.createElement(FV.Modal, {
            show: t.isShowing,
            dialogClassName: "if2-modal frb-column-calculation-modal",
            "aria-labelledby": this.headerId,
            onHide: this.onCancel
          }, p.a.createElement(FV.Modal.Header, {
            closeButton: !0
          }, p.a.createElement(FV.Modal.Title, {
            id: this.headerId
          }, t.title)), p.a.createElement(EU, {
            modal: t
          }), p.a.createElement(IU, {
            modal: t,
            report: r
          }));
        }
      }]) && FU(r.prototype, n), o && FU(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "headerId", [f.computed], Object.getOwnPropertyDescriptor(xU.prototype, "headerId"), xU.prototype), AU = qU(xU.prototype, "onCancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.modal;
          t.hide(), t.reset();
        };
      }
    }), DU = xU)) || DU;

    function YU(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function QU(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $U(n.key), n);
      }
    }

    function $U(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function XU(e, t, r) {
      return t = ZU(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ZU(e).constructor) : t.apply(e, r));
    }

    function ZU(e) {
      return (ZU = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function eq(e, t) {
      return (eq = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function tq(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var rq,
        nq,
        oq = Object(d.observer)((WU = tq((GU = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return YU(e = XU(this, t, [].concat(n)), "onCancel", WU, e), YU(e, "onClear", HU, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && eq(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && QU(e.prototype, t), r && QU(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.modal,
              r = e.t;
          return p.a.createElement(FV.ModalFooter, null, p.a.createElement("div", {
            className: "buttons-left"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-link text-danger font-weight-normal",
            onClick: this.onClear
          }, r("clear"))), p.a.createElement("div", {
            className: "buttons-right"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-outline-secondary",
            onClick: this.onCancel
          }, r("cancel")), " ", p.a.createElement("button", {
            type: "submit",
            className: "btn btn-primary",
            form: t.formId
          }, r("apply"))));
        }
      }]);
    }()).prototype, "onCancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.modal;
          t.hide(), t.reset();
        };
      }
    }), HU = tq(GU.prototype, "onClear", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t,
              r = e.props,
              n = r.modal,
              o = r.report;
          return o.columnConfig.clearFilter(null === (t = n.currentColumn) || void 0 === t ? void 0 : t.id), n.hide(), n.reset(), o.update();
        };
      }
    }), KU = GU)) || KU,
        iq = Object(g.a)()(oq);

    function aq(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, cq(n.key), n);
      }
    }

    function cq(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function uq(e, t, r) {
      return t = lq(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], lq(e).constructor) : t.apply(e, r));
    }

    function lq(e) {
      return (lq = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function sq(e, t) {
      return (sq = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var pq,
        fq = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((nq = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = uq(this, t, [e])).ref = Object(s.createRef)(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && sq(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && aq(e.prototype, t), r && aq(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "options",
        get: function () {
          var e = this.props,
              t = e.modal,
              r = e.t;
          return t.constructor.textFilterOptions(r);
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = this;
          setTimeout(function () {
            var t;
            return null === (t = e.ref.current) || void 0 === t ? void 0 : t.focus();
          }, 60);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.modal,
              r = e.t;
          return p.a.createElement("div", {
            className: "frb-column-filter-modal-body"
          }, p.a.createElement(h.SelectDropdown, {
            options: this.options,
            model: t.textFilterMethodSelector,
            placeholder: r("if2.reports.contains")
          }), p.a.createElement(h.FormInput, {
            forwardedRef: this.ref,
            className: "mt-2",
            onChange: t.onChangeTextFilterText,
            value: t.textFilterText,
            placeholder: r("if2.reports.filter_text")
          }));
        }
      }]);
    }()).prototype, "options", [f.computed], Object.getOwnPropertyDescriptor(nq.prototype, "options"), nq.prototype), rq = nq)) || rq,
        dq = Object(g.a)()(fq);

    function bq(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, yq(n.key), n);
      }
    }

    function yq(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function mq(e, t, r) {
      return t = vq(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], vq(e).constructor) : t.apply(e, r));
    }

    function vq(e) {
      return (vq = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function hq(e, t) {
      return (hq = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var gq,
        wq,
        Oq,
        jq = Object(d.observer)(pq = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), mq(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && hq(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props.modal;
          return p.a.createElement(h.DateRangeSelector, {
            model: e.dateRangeSelector
          });
        }
      }]) && bq(r.prototype, n), o && bq(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || pq;

    function Pq(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _q(n.key), n);
      }
    }

    function _q(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Eq(e, t, r) {
      return t = Sq(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Sq(e).constructor) : t.apply(e, r));
    }

    function Sq(e) {
      return (Sq = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Cq(e, t) {
      return (Cq = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var kq,
        Rq,
        Tq,
        zq = Object(d.observer)((Oq = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((wq = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = Eq(this, t, [].concat(n)), "onApply", Oq, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Cq(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e,
              t,
              r = this.props.modal;
          return p.a.createElement(FV.ModalBody, null, p.a.createElement("form", {
            id: r.formId,
            onSubmit: this.onApply
          }, "TextFilter" === (null === (e = r.currentColumn) || void 0 === e ? void 0 : e.filterType()) ? p.a.createElement(dq, {
            modal: r
          }) : "DateFilter" === (null === (t = r.currentColumn) || void 0 === t ? void 0 : t.filterType()) ? p.a.createElement(jq, {
            modal: r
          }) : null));
        }
      }]) && Pq(r.prototype, n), o && Pq(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "onApply", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.modal,
              o = r.report;
          return t.preventDefault(), n.apply(o), n.hide(), n.reset(), o.update();
        };
      }
    }), gq = wq)) || gq;

    function Nq(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Dq(n.key), n);
      }
    }

    function Dq(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function xq(e, t, r) {
      return t = Aq(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Aq(e).constructor) : t.apply(e, r));
    }

    function Aq(e) {
      return (Aq = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Mq(e, t) {
      return (Mq = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Iq(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Fq,
        Bq,
        Lq,
        Vq,
        Uq,
        qq,
        Kq,
        Gq,
        Wq,
        Hq,
        Jq,
        Yq,
        Qq = Object(d.observer)((Iq((Rq = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = xq(this, t, [].concat(n)), "onCancel", Tq, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Mq(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "headerId",
        get: function () {
          return "".concat(this.modal.id, "-header");
        }
      }, {
        key: "modal",
        get: function () {
          return this.props.report.columnFilterModal;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.report;
          return p.a.createElement(FV.Modal, {
            show: this.modal.isShowing,
            dialogClassName: "if2-modal frb-column-filter-modal",
            "aria-labelledby": this.headerId,
            onHide: this.onCancel
          }, p.a.createElement(FV.Modal.Header, {
            closeButton: !0
          }, p.a.createElement(FV.Modal.Title, {
            id: this.headerId
          }, this.modal.title)), p.a.createElement(zq, {
            modal: this.modal,
            report: e
          }), p.a.createElement(iq, {
            modal: this.modal,
            report: e
          }));
        }
      }]) && Nq(r.prototype, n), o && Nq(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "headerId", [f.computed], Object.getOwnPropertyDescriptor(Rq.prototype, "headerId"), Rq.prototype), Iq(Rq.prototype, "modal", [f.computed], Object.getOwnPropertyDescriptor(Rq.prototype, "modal"), Rq.prototype), Tq = Iq(Rq.prototype, "onCancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.modal.hide();
        };
      }
    }), kq = Rq)) || kq;

    function $q(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Xq(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Zq(n.key), n);
      }
    }

    function Zq(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function eK(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var tK,
        rK,
        nK,
        oK,
        iK = (Fq = f.action.bound, Bq = f.action.bound, Vq = eK((Lq = function () {
      return function (e, t, r) {
        return t && Xq(e.prototype, t), r && Xq(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), $q(this, "columnSpec", Vq, this), $q(this, "errorMessage", Uq, this), $q(this, "id", qq, this), this.invalidUnitsError = "", this.isBlankError = "", $q(this, "isShowing", Kq, this), $q(this, "saveButtonText", Gq, this), $q(this, "title", Wq, this), $q(this, "units", Hq, this), $q(this, "unitsPlaceholder", Jq, this), $q(this, "onChangeUnits", Yq, this);
        var r = t.t;
        this.saveButtonText = r("convert"), this.title = r("convert_units"), this.unitsPlaceholder = r("units"), this.isBlankError = r("must_not_be_blank"), this.invalidUnitsError = r("unknown_units");
      }, [{
        key: "isValid",
        get: function () {
          return !this.errorMessage;
        }
      }, {
        key: "clearErrors",
        value: function () {
          this.errorMessage = "";
        }
      }, {
        key: "getUnitConversionSpec",
        value: function (e) {
          return new NT({
            position: this.columnSpec.position + 1,
            units: this.units,
            referenceColumnSpec: this.columnSpec,
            t: e
          });
        }
      }, {
        key: "hide",
        value: function () {
          this.isShowing = !1;
        }
      }, {
        key: "isConvertible",
        value: function (e) {
          return NT.isUnitConversionColumnSpec(e) || Az.isCalculationColumnSpec(e) || zM.isReportColumnSpec(e) && e.isCalculable();
        }
      }, {
        key: "reset",
        value: function () {
          this.units = "", this.columnSpec = void 0, this.errorMessage = "";
        }
      }, {
        key: "show",
        value: function (e) {
          this.isShowing = !0, this.columnSpec = e;
        }
      }, {
        key: "validate",
        value: function () {
          this.clearErrors(), this.units ? this.constructor.isValidUnits(this.units) || (this.errorMessage = this.invalidUnitsError) : this.errorMessage = this.isBlankError;
        }
      }], [{
        key: "isValidUnits",
        value: function (e) {
          var t = new w.Quantity(e);
          return Boolean(t.units);
        }
      }]);
    }()).prototype, "columnSpec", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Uq = eK(Lq.prototype, "errorMessage", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), qq = eK(Lq.prototype, "id", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return Object(td.v4)();
      }
    }), Kq = eK(Lq.prototype, "isShowing", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Gq = eK(Lq.prototype, "saveButtonText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Wq = eK(Lq.prototype, "title", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Hq = eK(Lq.prototype, "units", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Jq = eK(Lq.prototype, "unitsPlaceholder", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), eK(Lq.prototype, "isValid", [f.computed], Object.getOwnPropertyDescriptor(Lq.prototype, "isValid"), Lq.prototype), eK(Lq.prototype, "clearErrors", [f.action], Object.getOwnPropertyDescriptor(Lq.prototype, "clearErrors"), Lq.prototype), eK(Lq.prototype, "hide", [Fq], Object.getOwnPropertyDescriptor(Lq.prototype, "hide"), Lq.prototype), Yq = eK(Lq.prototype, "onChangeUnits", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.units = t.target.value;
        };
      }
    }), eK(Lq.prototype, "reset", [f.action], Object.getOwnPropertyDescriptor(Lq.prototype, "reset"), Lq.prototype), eK(Lq.prototype, "show", [Bq], Object.getOwnPropertyDescriptor(Lq.prototype, "show"), Lq.prototype), Lq);

    function aK(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function cK(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, uK(n.key), n);
      }
    }

    function uK(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function lK(e, t, r) {
      return t = sK(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], sK(e).constructor) : t.apply(e, r));
    }

    function sK(e) {
      return (sK = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function pK(e, t) {
      return (pK = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function fK(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var dK,
        bK,
        yK = Object(d.observer)((fK((rK = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), aK(r = lK(this, t, [e]), "onCancel", nK, r), aK(r, "onSave", oK, r);
        var n = ["report", "modal"].filter(function (t) {
          return !e[t];
        });
        if (n.length) throw new Error("Missing prop".concat(1 === n.length ? "s" : "", ": ").concat(n.map(function (e) {
          return '"'.concat(e, '"');
        }).join(", ")));
        return r.ref = Object(s.createRef)(), r.disposeShowReaction = Object(f.reaction)(function () {
          return r.props.modal.isShowing;
        }, function (e) {
          e && setTimeout(function () {
            var e;
            return null === (e = r.ref.current) || void 0 === e ? void 0 : e.focus();
          }, 60);
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && pK(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && cK(e.prototype, t), r && cK(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "formId",
        get: function () {
          var e = this.props.modal;
          return "".concat(e.id, "-form");
        }
      }, {
        key: "headerId",
        get: function () {
          var e = this.props.modal;
          return "".concat(e.id, "-header");
        }
      }, {
        key: "validationId",
        get: function () {
          var e = this.props.modal;
          return "".concat(e.id, "-validation-feedback");
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.disposeShowReaction();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.modal,
              r = e.t;
          return p.a.createElement(FV.Modal, {
            show: t.isShowing,
            dialogClassName: "if2-modal frb-convert-units-modal",
            "aria-labelledby": this.headerId,
            size: "sm",
            onHide: this.onCancel
          }, p.a.createElement(FV.Modal.Header, {
            closeButton: !0
          }, p.a.createElement(FV.Modal.Title, {
            id: this.headerId
          }, t.title)), p.a.createElement(FV.ModalBody, null, p.a.createElement("form", {
            id: this.formId,
            onSubmit: this.onSave
          }, p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement(h.FormInput, {
            forwardedRef: this.ref,
            className: t.isValid ? "" : "is-invalid",
            "aria-describedby": this.validationId,
            value: t.units,
            onChange: t.onChangeUnits,
            placeholder: t.unitsPlaceholder
          }), t.isValid ? null : p.a.createElement("div", {
            id: this.validationId,
            className: "invalid-feedback"
          }, t.errorMessage)))), p.a.createElement(FV.ModalFooter, null, p.a.createElement("button", {
            type: "button",
            className: "btn btn-outline-secondary",
            onClick: this.onCancel
          }, r("cancel")), " ", p.a.createElement("button", {
            type: "button",
            className: "btn btn-primary",
            form: this.formId,
            onClick: this.onSave
          }, r(t.saveButtonText))));
        }
      }]);
    }()).prototype, "formId", [f.computed], Object.getOwnPropertyDescriptor(rK.prototype, "formId"), rK.prototype), fK(rK.prototype, "headerId", [f.computed], Object.getOwnPropertyDescriptor(rK.prototype, "headerId"), rK.prototype), fK(rK.prototype, "validationId", [f.computed], Object.getOwnPropertyDescriptor(rK.prototype, "validationId"), rK.prototype), nK = fK(rK.prototype, "onCancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.modal;
          t.hide(), t.reset();
        };
      }
    }), oK = fK(rK.prototype, "onSave", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.preventDefault();
          var r = e.props,
              n = r.report,
              o = r.modal,
              i = r.t;

          if (o.validate(), o.isValid) {
            var a = o.getUnitConversionSpec(i);
            return n.columnConfig.addColumnAtPosition(a, a.position), o.hide(), o.reset(), n.update().catch(console.error);
          }
        };
      }
    }), tK = rK)) || tK,
        mK = Object(g.a)()(yK);

    function vK(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, hK(n.key), n);
      }
    }

    function hK(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function gK(e, t, r) {
      return t = wK(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], wK(e).constructor) : t.apply(e, r));
    }

    function wK(e) {
      return (wK = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function OK(e, t) {
      return (OK = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var jK,
        PK = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((bK = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = gK(this, t, [e])).columnCalculationModal = void 0, r.convertUnitsModal = void 0;
        var n = r.props.t;
        return r.columnCalculationModal = new IV({
          t: n
        }), r.convertUnitsModal = new iK({
          t: n
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && OK(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "isLoading",
        get: function () {
          var e = this.props.report;
          return e.isLoadingCurrentPage || e.isLoadingPreviousPage;
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.columnCalculationModal.destroy();
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props.report;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("tr", null, t.columnConfig.visibleColumns.map(function (r) {
            return p.a.createElement($L, {
              key: r.id,
              report: t,
              columnSpec: r,
              columnCalculationModal: e.columnCalculationModal,
              convertUnitsModal: e.convertUnitsModal
            });
          })), this.isLoading ? p.a.createElement("tr", {
            className: "frb-rt-head-loading"
          }, p.a.createElement("td", {
            colSpan: t.columnConfig.visibleColumns.length,
            "aria-label": "Loading Spinner"
          }, p.a.createElement(h.Spinner, null))) : null, p.a.createElement(JU, {
            modal: this.columnCalculationModal,
            report: t
          }), p.a.createElement(Qq, {
            report: t
          }), p.a.createElement(mK, {
            modal: this.convertUnitsModal,
            report: t
          }));
        }
      }]) && vK(r.prototype, n), o && vK(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "isLoading", [f.computed], Object.getOwnPropertyDescriptor(bK.prototype, "isLoading"), bK.prototype), dK = bK)) || dK,
        _K = Object(g.a)()(PK);

    function EK(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, SK(n.key), n);
      }
    }

    function SK(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function CK(e, t, r) {
      return t = kK(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], kK(e).constructor) : t.apply(e, r));
    }

    function kK(e) {
      return (kK = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function RK(e, t) {
      return (RK = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var TK,
        zK,
        NK = Object(d.observer)(jK = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), CK(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && RK(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props.report;
          return e.isLoadingNextPage ? p.a.createElement("tr", {
            className: "frb-rt-foot"
          }, p.a.createElement("td", {
            colSpan: e.columnConfig.visibleColumns.length
          }, p.a.createElement(h.Spinner, null))) : null;
        }
      }]) && EK(r.prototype, n), o && EK(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || jK;

    function DK(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, xK(n.key), n);
      }
    }

    function xK(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function AK(e, t, r) {
      return t = MK(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], MK(e).constructor) : t.apply(e, r));
    }

    function MK(e) {
      return (MK = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function IK(e, t) {
      return (IK = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var FK,
        BK,
        LK = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((zK = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), AK(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && IK(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "tableCellClass",
        get: function () {
          var e = this.props,
              t = e.cell;
          return e.report.tableCellClass(t.columnSpec);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.cell;
          return p.a.createElement("td", {
            className: this.tableCellClass
          }, e.displayValue, e.errors.length ? p.a.createElement("span", {
            className: "cell-error pl-1",
            title: e.errors.map(function (e) {
              return e.message;
            }).join("\n")
          }, p.a.createElement("i", {
            role: "img",
            "aria-label": "Error Icon",
            className: "fas fa-exclamation-triangle"
          })) : null);
        }
      }]) && DK(r.prototype, n), o && DK(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "tableCellClass", [f.computed], Object.getOwnPropertyDescriptor(zK.prototype, "tableCellClass"), zK.prototype), TK = zK)) || TK;

    function VK(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, UK(n.key), n);
      }
    }

    function UK(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function qK(e, t, r) {
      return t = KK(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], KK(e).constructor) : t.apply(e, r));
    }

    function KK(e) {
      return (KK = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function GK(e, t) {
      return (GK = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function WK(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var HK,
        JK = Object(d.observer)((WK((BK = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), qK(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && GK(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "numColumns",
        get: function () {
          return this.props.context.columConfig.visibleColumns.length;
        }
      }, {
        key: "prefixCell",
        get: function () {
          var e = this.props.item;
          return e.level && e.level > 0 ? p.a.createElement("td", {
            colSpan: e.level
          }) : null;
        }
      }, {
        key: "bodyRow",
        get: function () {
          var e = this.props,
              t = e.item,
              r = e.context,
              n = e["data-item-index"];
          return t.isGroup ? null : p.a.createElement("tr", {
            className: n % 2 ? "dark" : null
          }, this.prefixCell, t.cells.map(function (e) {
            return p.a.createElement(LK, {
              key: e.key,
              report: r,
              cell: e
            });
          }));
        }
      }, {
        key: "groupedRow",
        get: function () {
          var e = this.props,
              r = e.item,
              n = e.context;
          return r.isGroup ? p.a.createElement(p.a.Fragment, null, p.a.createElement("tr", null, this.prefixCell, p.a.createElement("td", {
            colSpan: this.numColumns - r.level
          }, r.displayValue)), r.children.map(function (e) {
            return p.a.createElement(t, {
              key: e.key,
              report: n,
              row: e
            });
          })) : null;
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = this;
          this.rowDisposer = Object(f.autorun)(function () {
            var t = e.props,
                r = t.item,
                n = t.context;
            r.setColumnSpecs(n.columnConfig.visibleColumns);
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.rowDisposer();
        }
      }, {
        key: "render",
        value: function () {
          return p.a.createElement(p.a.Fragment, null, this.groupedRow, this.bodyRow);
        }
      }]) && VK(r.prototype, n), o && VK(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "numColumns", [f.computed], Object.getOwnPropertyDescriptor(BK.prototype, "numColumns"), BK.prototype), WK(BK.prototype, "prefixCell", [f.computed], Object.getOwnPropertyDescriptor(BK.prototype, "prefixCell"), BK.prototype), WK(BK.prototype, "bodyRow", [f.computed], Object.getOwnPropertyDescriptor(BK.prototype, "bodyRow"), BK.prototype), WK(BK.prototype, "groupedRow", [f.computed], Object.getOwnPropertyDescriptor(BK.prototype, "groupedRow"), BK.prototype), FK = BK)) || FK,
        YK = ["context"],
        QK = ["context"];

    function $K(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, XK(n.key), n);
      }
    }

    function XK(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ZK(e, t, r) {
      return t = eG(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], eG(e).constructor) : t.apply(e, r));
    }

    function eG(e) {
      return (eG = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function tG(e, t) {
      return (tG = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function rG(e, t) {
      if (null == e) return {};

      var r,
          n,
          o = function (e, t) {
        if (null == e) return {};
        var r = {};

        for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
          if (t.includes(n)) continue;
          r[n] = e[n];
        }

        return r;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }

      return o;
    }

    var nG,
        oG,
        iG,
        aG,
        cG,
        uG,
        lG = function (e) {
      e.context;
      var t = rG(e, YK);
      return p.a.createElement("table", Object.assign({
        className: "table table-sm"
      }, t));
    },
        sG = Object(s.forwardRef)(function (e, t) {
      e.context;
      var r = rG(e, QK);
      return p.a.createElement("thead", Object.assign({
        ref: t,
        className: "thead-light frb-rt-head"
      }, r));
    }),
        pG = Object(d.observer)(HK = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = ZK(this, t, [].concat(n))).itemKey = function (e, t) {
          return t.index;
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && tG(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "componentDidMount",
        value: function () {
          var e = this;
          this.disposeAtTopReaction = Object(f.reaction)(function () {
            return e.props.report.atTop;
          }, function (t) {
            var r = e.props.report;
            t && !e.atBottom && r.loadPreviousPage();
          }), this.disposeAtBottomReaction = Object(f.reaction)(function () {
            return e.props.report.atBottom;
          }, function (t) {
            var r = e.props.report;
            t && !e.atTop && r.loadNextPage();
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.disposeAtTopReaction(), this.disposeAtBottomReaction();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.report;
          return p.a.createElement("div", {
            className: "frb-report-table h-100"
          }, p.a.createElement(UF.TableVirtuoso, {
            atBottomStateChange: e.updateAtBottom,
            atTopStateChange: e.updateAtTop,
            firstItemIndex: e.firstItemIndex,
            initialTopMostItemIndex: e.initialTopMostItemIndex,
            components: {
              Table: lG,
              TableHead: sG,
              TableRow: JK
            },
            computeItemKey: this.itemKey,
            context: e,
            data: e.rows,
            defaultItemHeight: 28,
            fixedHeaderContent: function () {
              return p.a.createElement(_K, {
                report: e
              });
            },
            fixedFooterContent: function () {
              return p.a.createElement(NK, {
                report: e
              });
            },
            rangeChanged: e.updateCurrentRange,
            isScrolling: e.isScrollingChanged
          }));
        }
      }]) && $K(r.prototype, n), o && $K(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || HK;

    function fG(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function dG(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bG(n.key), n);
      }
    }

    function bG(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function yG(e, t, r) {
      return t = mG(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], mG(e).constructor) : t.apply(e, r));
    }

    function mG(e) {
      return (mG = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function vG(e, t) {
      return (vG = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function hG(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var gG,
        wG,
        OG,
        jG = Object(d.observer)((hG((oG = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), fG(r = yG(this, t, [e]), "handleToggleChecked", iG, r), fG(r, "handleToggleExpand", aG, r), fG(r, "onCancel", cG, r), fG(r, "onSubmit", uG, r);
        var n = e.id,
            o = e.report,
            i = e.readOnlyAncestors;
        return r.id = n, r.treeModel.setRoots(o.accountsStore.roots, (i || []).map(function (e) {
          return o.accountsStore.push(e);
        })), r.treeModel.sortRoots(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && vG(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && dG(e.prototype, t), r && dG(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "modalHeaderId",
        get: function () {
          var e = this.props.id;
          return "".concat(e, "-header");
        }
      }, {
        key: "treeModel",
        get: function () {
          return this.props.report.accountsTree;
        }
      }, {
        key: "resetCheckedAccounts",
        value: function (e) {
          this.treeModel.unCheckAll(), this.treeModel.checkMany(e);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.id,
              r = e.t;
          return p.a.createElement(h.ModalDialog, {
            id: t,
            dialogClassNames: "account-selector-modal",
            ariaLabelledBy: this.modalHeaderId
          }, p.a.createElement(h.ModalHeader, {
            title: r("select_accounts"),
            onClose: this.onCancel,
            id: this.modalHeaderId
          }), p.a.createElement("form", {
            onSubmit: this.onSubmit
          }, p.a.createElement(h.ModalBody, null, p.a.createElement(fl, {
            items: this.treeModel.roots,
            model: this.treeModel,
            ControlsComponent: nj,
            ContentComponent: Cl(this.treeModel),
            actions: {
              handleToggleChecked: this.handleToggleChecked,
              handleToggleExpand: this.handleToggleExpand
            }
          })), p.a.createElement(h.ModalFooter, null, p.a.createElement("div", {
            className: "w-100 d-flex justify-content-end"
          }, p.a.createElement("div", {
            className: ""
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-outline-secondary mr-2",
            "data-dismiss": "modal",
            onClick: this.onCancel
          }, r("cancel").toUpperCase()), p.a.createElement("button", {
            type: "submit",
            className: "btn btn-primary",
            "data-dismiss": "modal",
            onClick: this.onSubmit
          }, r("ok").toUpperCase()))))));
        }
      }]);
    }()).prototype, "modalHeaderId", [f.computed], Object.getOwnPropertyDescriptor(oG.prototype, "modalHeaderId"), oG.prototype), hG(oG.prototype, "treeModel", [f.computed], Object.getOwnPropertyDescriptor(oG.prototype, "treeModel"), oG.prototype), iG = hG(oG.prototype, "handleToggleChecked", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.props.report.toggleAccountChecked(t);
        };
      }
    }), aG = hG(oG.prototype, "handleToggleExpand", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.props.report.toggleAccountExpanded(t);
        };
      }
    }), cG = hG(oG.prototype, "onCancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.id,
              n = t.report;
          v()("#".concat(r)).modal("hide"), e.resetCheckedAccounts(n.selectedAccountIds);
        };
      }
    }), uG = hG(oG.prototype, "onSubmit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.report;
          t.preventDefault(), r.selectAccounts(e.treeModel.checked);
        };
      }
    }), nG = oG)) || nG,
        PG = Object(g.a)()(jG);

    function _G(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, EG(n.key), n);
      }
    }

    function EG(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function SG(e, t, r) {
      return t = CG(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], CG(e).constructor) : t.apply(e, r));
    }

    function CG(e) {
      return (CG = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function kG(e, t) {
      return (kG = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var RG,
        TG,
        zG = Object(d.observer)((OG = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((wG = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = SG(this, t, [].concat(n))).modalId = "account-selector-modal", function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e, "showModal", OG, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && kG(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && _G(e.prototype, t), r && _G(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.report,
              r = e.readOnlyAncestors,
              n = e.t;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement(PG, {
            id: this.modalId,
            report: t,
            readOnlyAncestors: r
          }), p.a.createElement("div", {
            className: "select-accounts-control d-inline-block"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-link icon icon-select",
            onClick: this.showModal
          }, n("select_accounts"))));
        }
      }]);
    }()).prototype, "showModal", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.preventDefault(), v()("#".concat(e.modalId)).modal("show");
        };
      }
    }), gG = wG)) || gG,
        NG = Object(g.a)()(zG);

    function DG(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, xG(n.key), n);
      }
    }

    function xG(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function AG(e, t, r) {
      return t = MG(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], MG(e).constructor) : t.apply(e, r));
    }

    function MG(e) {
      return (MG = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function IG(e, t) {
      return (IG = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function FG(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var BG,
        LG,
        VG = Object(d.observer)((FG((TG = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), AG(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && IG(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "isCollapsedClasses",
        get: function () {
          var e = ["fas", "fa-caret-right", "fa-sm", "clickable"];
          return this.props.node.isMatch ? e : e.concat("muted");
        }
      }, {
        key: "isExpandedClasses",
        get: function () {
          var e = ["fas", "fa-caret-down", "fa-sm", "clickable"];
          return this.props.node.isMatch ? e : e.concat("muted");
        }
      }, {
        key: "render",
        value: function () {
          return p.a.createElement(h.TreeNodeToggle, Object.assign({}, this.props, {
            isExpandedClasses: this.isExpandedClasses,
            isCollapsedClasses: this.isCollapsedClasses
          }));
        }
      }]) && DG(r.prototype, n), o && DG(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "isCollapsedClasses", [f.computed], Object.getOwnPropertyDescriptor(TG.prototype, "isCollapsedClasses"), TG.prototype), FG(TG.prototype, "isExpandedClasses", [f.computed], Object.getOwnPropertyDescriptor(TG.prototype, "isExpandedClasses"), TG.prototype), RG = TG)) || RG;

    function UG(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qG(n.key), n);
      }
    }

    function qG(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function KG(e, t, r) {
      return t = GG(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], GG(e).constructor) : t.apply(e, r));
    }

    function GG(e) {
      return (GG = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function WG(e, t) {
      return (WG = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function HG(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var JG,
        YG = Object(d.observer)((HG((LG = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), KG(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && WG(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "isCheckedClasses",
        get: function () {
          var e = this.props.node,
              t = ["far", "fa-check-square", "fa-sm", "clickable"];
          return t = e.isDisabled ? t.concat("disabled") : t, t = e.isMatch ? t : t.concat("muted");
        }
      }, {
        key: "isUncheckedClasses",
        get: function () {
          var e = ["far", "fa-square", "fa-sm", "clickable"];
          return this.props.node.isMatch ? e : e.concat("muted");
        }
      }, {
        key: "render",
        value: function () {
          return p.a.createElement(h.TreeNodeCheckbox, Object.assign({
            isCheckedClasses: this.isCheckedClasses,
            isUncheckedClasses: this.isUncheckedClasses
          }, this.props));
        }
      }]) && UG(r.prototype, n), o && UG(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "isCheckedClasses", [f.computed], Object.getOwnPropertyDescriptor(LG.prototype, "isCheckedClasses"), LG.prototype), HG(LG.prototype, "isUncheckedClasses", [f.computed], Object.getOwnPropertyDescriptor(LG.prototype, "isUncheckedClasses"), LG.prototype), BG = LG)) || BG,
        QG = ["node", "actions", "treeModel"];

    function $G(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, XG(n.key), n);
      }
    }

    function XG(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ZG(e, t, r) {
      return t = eW(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], eW(e).constructor) : t.apply(e, r));
    }

    function eW(e) {
      return (eW = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function tW(e, t) {
      return (tW = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var rW,
        nW,
        oW,
        iW = Object(d.observer)(JG = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), ZG(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && tW(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.node,
              r = e.actions,
              n = e.treeModel,
              o = function (e, t) {
            if (null == e) return {};

            var r,
                n,
                o = function (e, t) {
              if (null == e) return {};
              var r = {};

              for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
                if (t.includes(n)) continue;
                r[n] = e[n];
              }

              return r;
            }(e, t);

            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);

              for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
            }

            return o;
          }(e, QG),
              i = t.hasChildren ? [{
            id: "1",
            component: VG
          }] : [{
            id: "1",
            component: YG
          }];

          return p.a.createElement(h.TreeNodeControls, Object.assign({
            node: t,
            actions: r,
            controls: i,
            treeModel: n
          }, o));
        }
      }]) && $G(r.prototype, n), o && $G(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || JG;

    function aW(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, cW(n.key), n);
      }
    }

    function cW(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function uW(e, t, r) {
      return t = lW(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], lW(e).constructor) : t.apply(e, r));
    }

    function lW(e) {
      return (lW = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function sW(e, t) {
      return (sW = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var pW,
        fW,
        dW,
        bW,
        yW,
        mW = Object(d.observer)(((oW = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = uW(this, t, [].concat(n))).handleClick = function () {
          var t = e.props,
              r = t.node;
          t.actions.handleClickNodeContent(r.id);
        }, e.handleKeyPress = function (t) {
          if (t.which === e.constructor.KEY_ENTER) return t.stopPropagation(), e.handleClick();
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && sW(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "className",
        get: function () {
          var e = this.props,
              t = e.nodeClasses,
              r = e.node;
          return Object(w.uniq)(["content-wrapper", "clickable"].concat(r.isMatch ? [] : "muted").concat(t)).join(" ");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.node,
              r = e.title,
              n = e.tabIndex;
          return p.a.createElement("div", {
            className: this.className,
            onClick: this.handleClick,
            onKeyPress: this.handleKeyPress,
            role: "button",
            tabIndex: n,
            title: r
          }, p.a.createElement(MB, {
            placement: "right",
            delay: {
              show: 500,
              hide: 400
            },
            overlay: p.a.createElement(VB, null, t.id)
          }, p.a.createElement("span", {
            className: "pr-2"
          }, t.name)));
        }
      }]) && aW(r.prototype, n), o && aW(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).KEY_ENTER = 13, oW.defaultProps = {
      nodeClasses: [],
      tabIndex: "0"
    }, function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((nW = oW).prototype, "className", [f.computed], Object.getOwnPropertyDescriptor(nW.prototype, "className"), nW.prototype), rW = nW)) || rW;

    function vW(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function hW(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, gW(n.key), n);
      }
    }

    function gW(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function wW(e, t, r) {
      return t = OW(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], OW(e).constructor) : t.apply(e, r));
    }

    function OW(e) {
      return (OW = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function jW(e, t) {
      return (jW = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function PW(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var _W,
        EW,
        SW,
        CW = Object(d.observer)((dW = PW((fW = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return vW(e = wW(this, t, [].concat(n)), "handleClickNodeContent", dW, e), vW(e, "toggleChecked", bW, e), vW(e, "toggleExpanded", yW, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && jW(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props.columnSelector;
          return p.a.createElement("div", {
            className: "column-selector-tree my-2"
          }, p.a.createElement(h.Tree, {
            model: e.treeModel,
            items: e.treeModel.roots,
            ControlsComponent: iW,
            ContentComponent: mW,
            actions: {
              handleClickNodeContent: this.handleClickNodeContent,
              handleToggleExpand: this.toggleExpanded,
              handleToggleChecked: this.toggleChecked
            }
          }));
        }
      }]) && hW(r.prototype, n), o && hW(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "handleClickNodeContent", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.columnSelector.findNode(t);
          if (r) return r.hasChildren ? e.toggleExpanded(t) : void e.toggleChecked(t);
        };
      }
    }), bW = PW(fW.prototype, "toggleChecked", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.columnSelector.treeModel.toggleChecked(t);
        };
      }
    }), yW = PW(fW.prototype, "toggleExpanded", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.columnSelector.treeModel.toggleExpanded(t);
        };
      }
    }), pW = fW)) || pW;

    function kW(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, RW(n.key), n);
      }
    }

    function RW(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function TW(e, t, r) {
      return t = zW(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], zW(e).constructor) : t.apply(e, r));
    }

    function zW(e) {
      return (zW = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function NW(e, t) {
      return (NW = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var DW,
        xW = Object(d.observer)((SW = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((EW = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = TW(this, t, [].concat(n)), "onSearch", SW, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && NW(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && kW(e.prototype, t), r && kW(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.t,
              r = e.columnSelector,
              n = e.report;
          return p.a.createElement("div", {
            className: "column-selector"
          }, p.a.createElement(h.SearchBox, {
            placeholder: t("search"),
            searchText: r.searchText,
            onChange: this.onSearch,
            onClearSearch: r.onClearSearch
          }), p.a.createElement(CW, {
            columnSelector: r,
            report: n
          }));
        }
      }]);
    }()).prototype, "onSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.columnSelector.onSearch(t.target.value);
        };
      }
    }), _W = EW)) || _W,
        AW = Object(g.a)()(xW);

    function MW(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, IW(n.key), n);
      }
    }

    function IW(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function FW(e, t, r) {
      return t = BW(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], BW(e).constructor) : t.apply(e, r));
    }

    function BW(e) {
      return (BW = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function LW(e, t) {
      return (LW = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var VW,
        UW,
        qW,
        KW,
        GW,
        WW,
        HW = Object(d.observer)(DW = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), FW(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && LW(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && MW(e.prototype, t), r && MW(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.columnSelector,
              r = e.report,
              n = e.t;
          return p.a.createElement(FV.Modal, {
            size: "lg",
            show: t.isShowing,
            className: "frb-column-selector-modal",
            onHide: t.onHideModal,
            "aria-labelledby": "column-selector-modal-title",
            animation: !t.disableModalAnimation
          }, p.a.createElement(FV.Modal.Header, {
            closeButton: !0
          }, p.a.createElement(FV.Modal.Title, {
            id: "column-selector-modal-title"
          }, t.modalTitle)), p.a.createElement(FV.Modal.Body, null, p.a.createElement(AW, {
            columnSelector: t,
            report: r
          })), p.a.createElement(FV.Modal.Footer, null, p.a.createElement(FV.Button, {
            variant: "secondary",
            onClick: t.onHideModal
          }, n("cancel")), p.a.createElement(FV.Button, {
            variant: "primary",
            onClick: t.onOk
          }, n("ok"))));
        }
      }]);
    }()) || DW,
        JW = Object(g.a)()(HW);

    function YW(e) {
      return function (e) {
        if (Array.isArray(e)) return QW(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return QW(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? QW(e, t) : void 0;
        }
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function QW(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function $W(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function XW(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ZW(n.key), n);
      }
    }

    function ZW(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function eH(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var tH,
        rH,
        nH,
        oH,
        iH,
        aH,
        cH,
        uH,
        lH,
        sH,
        pH,
        fH,
        dH = (UW = eH((VW = function () {
      function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), $W(this, "_children", UW, this), $W(this, "_deprecatedChildren", qW, this), $W(this, "isRoot", KW, this), $W(this, "isDeprecated", GW, this), $W(this, "searchText", WW, this);
        var r = t.children,
            n = t.id,
            o = t.name,
            i = t.isDeprecated;
        this._children = r || [], this.id = n, this.name = o || "", this.isDeprecated = i || !1;
      }

      return function (e, t, r) {
        return t && XW(e.prototype, t), r && XW(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(e, [{
        key: "_allChildren",
        get: function () {
          return [].concat((this._deprecatedChildren || []).length && new e({
            id: "".concat(this.id, "-deprecated"),
            name: "Deprecated Columns",
            children: this._deprecatedChildren
          }) || []).concat(this._children || []);
        }
      }, {
        key: "children",
        get: function () {
          return this.isMatch ? this._allChildren : this._allChildren.filter(function (e) {
            return e.isMatch || e.hasDescendantMatch;
          });
        }
      }, {
        key: "hasChildren",
        get: function () {
          return this._allChildren.length;
        }
      }, {
        key: "hasDescendantMatch",
        get: function () {
          return this._allChildren.some(function (e) {
            return e.isMatch || e.hasDescendantMatch;
          });
        }
      }, {
        key: "isMatch",
        get: function () {
          return "" === this.searchText || this.name.toLowerCase().includes(this.searchText.toLowerCase());
        }
      }, {
        key: "addChild",
        value: function (e) {
          e.isDeprecated ? this._deprecatedChildren.push(e) : this._children.push(e);
        }
      }, {
        key: "clearSearch",
        value: function () {
          this.search("");
        }
      }, {
        key: "expandToMatches",
        value: function (e) {
          this.searchText && (this.hasDescendantMatch ? (e.expand(this.id), this._allChildren.forEach(function (t) {
            return t.expandToMatches(e);
          })) : e.collapse(this.id));
        }
      }, {
        key: "search",
        value: function (e) {
          this._allChildren.forEach(function (t) {
            return t.search(e);
          }), this.searchText = e;
        }
      }, {
        key: "sortChildren",
        value: function () {
          return this._children = this.constructor.sortChildren(this._children), this._deprecatedChildren = this.constructor.sortChildren(this._deprecatedChildren), this;
        }
      }], [{
        key: "buildTree",
        value: function (t, r) {
          for (var n = t.filter(function (e) {
            return zM.isReportColumnSpec(e);
          }).map(function (t) {
            return new e({
              id: t.id,
              name: t.getName(),
              isDeprecated: t.isDeprecated()
            });
          }), o = new Map(), i = new Set(); n.length > 0;) n.forEach(function (t) {
            var n = t.id.split("/");
            if (n.length < 2) return t.isRoot = !0, void o.set(t.id, t);
            var a = n.slice(0, -1).join("/"),
                c = zM.getNameFromId(a, r),
                u = o.get(a);
            u || (u = new e({
              id: a,
              name: c,
              isDeprecated: zM.isDeprecated(a)
            }), o.set(a, u)), u.addChild(t), i.add(t.id);
          }), n = YW(o.values()).filter(function (e) {
            return !e.isRoot && !i.has(e.id);
          });

          return YW(o.values()).filter(function (e) {
            return e.isRoot;
          }).sort(w.sortByName).map(function (e) {
            return e.sortChildren();
          });
        }
      }, {
        key: "sortChildren",
        value: function (e) {
          return e.map(function (e) {
            return e.sortChildren();
          }).sort(w.sortByName);
        }
      }]);
    }()).prototype, "_children", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), qW = eH(VW.prototype, "_deprecatedChildren", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), KW = eH(VW.prototype, "isRoot", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), GW = eH(VW.prototype, "isDeprecated", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), WW = eH(VW.prototype, "searchText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), eH(VW.prototype, "_allChildren", [f.computed], Object.getOwnPropertyDescriptor(VW.prototype, "_allChildren"), VW.prototype), eH(VW.prototype, "children", [f.computed], Object.getOwnPropertyDescriptor(VW.prototype, "children"), VW.prototype), eH(VW.prototype, "hasChildren", [f.computed], Object.getOwnPropertyDescriptor(VW.prototype, "hasChildren"), VW.prototype), eH(VW.prototype, "hasDescendantMatch", [f.computed], Object.getOwnPropertyDescriptor(VW.prototype, "hasDescendantMatch"), VW.prototype), eH(VW.prototype, "isMatch", [f.computed], Object.getOwnPropertyDescriptor(VW.prototype, "isMatch"), VW.prototype), eH(VW.prototype, "addChild", [f.action], Object.getOwnPropertyDescriptor(VW.prototype, "addChild"), VW.prototype), eH(VW.prototype, "clearSearch", [f.action], Object.getOwnPropertyDescriptor(VW.prototype, "clearSearch"), VW.prototype), eH(VW.prototype, "expandToMatches", [f.action], Object.getOwnPropertyDescriptor(VW.prototype, "expandToMatches"), VW.prototype), eH(VW.prototype, "search", [f.action], Object.getOwnPropertyDescriptor(VW.prototype, "search"), VW.prototype), eH(VW.prototype, "sortChildren", [f.action], Object.getOwnPropertyDescriptor(VW.prototype, "sortChildren"), VW.prototype), VW);

    function bH(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function yH(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, mH(n.key), n);
      }
    }

    function mH(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function vH(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var hH,
        gH = (rH = vH((tH = function () {
      return function (e, t, r) {
        return t && yH(e.prototype, t), r && yH(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(function e() {
        var t = this,
            r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), bH(this, "_nodeMap", rH, this), bH(this, "_treeRoots", nH, this), bH(this, "isShowing", oH, this), bH(this, "modalTitle", iH, this), this.report = void 0, bH(this, "searchText", aH, this), this.treeModel = void 0, this.disableModalAnimation = void 0, bH(this, "addColumns", cH, this), bH(this, "onOk", uH, this), bH(this, "onClearSearch", lH, this), bH(this, "onHideModal", sH, this), bH(this, "onSearch", pH, this), bH(this, "onShowModal", fH, this);
        var n = r.modalTitle,
            o = r.report,
            i = r.disableModalAnimation,
            a = r.t;
        this.modalTitle = n, this.report = o, this.treeModel = new h.TreeModel(), this.disableModalAnimation = i, Object(f.when)(function () {
          return o.didLoadColumns;
        }, function () {
          t._loadRoots(a);
        });
      }, [{
        key: "_loadRoots",
        value: function (e) {
          var t = this,
              r = dH.buildTree(this.report.columnConfig.columnSpecs, e);
          this.treeModel.roots = r, r.forEach(function (e) {
            return t._registerNode(e);
          }), this._treeRoots = r;
        }
      }, {
        key: "_registerNode",
        value: function (e) {
          var t = this;
          this._nodeMap.set(e.id, e), e.hasChildren && e.children.forEach(function (e) {
            return t._registerNode(e);
          });
        }
      }, {
        key: "findNode",
        value: function (e) {
          return this._nodeMap.get(e);
        }
      }]);
    }()).prototype, "_nodeMap", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new Map();
      }
    }), nH = vH(tH.prototype, "_treeRoots", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), oH = vH(tH.prototype, "isShowing", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), iH = vH(tH.prototype, "modalTitle", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), aH = vH(tH.prototype, "searchText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), cH = vH(tH.prototype, "addColumns", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          return e.report.columnConfig.addColumns(e.treeModel.checked), e.report.update().catch(console.error).finally(function () {
            return Object(f.runInAction)(function () {
              return e.adding = "";
            });
          });
        };
      }
    }), uH = vH(tH.prototype, "onOk", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.report.columnConfig.removeAllColumns(), e.addColumns(), e.onHideModal();
        };
      }
    }), lH = vH(tH.prototype, "onClearSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.searchText = "", e.treeModel.roots = e._treeRoots.map(function (e) {
            return e.clearSearch(), e;
          });
        };
      }
    }), sH = vH(tH.prototype, "onHideModal", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isShowing = !1, e.treeModel.unCheckAll();
        };
      }
    }), pH = vH(tH.prototype, "onSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.searchText = t, e.treeModel.roots = e._treeRoots.map(function (r) {
            return r.search(t), r.expandToMatches(e.treeModel), r;
          }).filter(function (e) {
            return e.isMatch || e.hasDescendantMatch;
          });
        };
      }
    }), fH = vH(tH.prototype, "onShowModal", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.treeModel.checkMany(e.report.columnConfig.visibleColumns.map(function (e) {
            return e.id;
          })), e.isShowing = !0;
        };
      }
    }), tH);

    function wH(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, OH(n.key), n);
      }
    }

    function OH(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function jH(e, t, r) {
      return t = PH(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], PH(e).constructor) : t.apply(e, r));
    }

    function PH(e) {
      return (PH = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function _H(e, t) {
      return (_H = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var EH,
        SH,
        CH = Object(d.observer)(hH = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = jH(this, t, [e])).columnSelector = void 0;
        var n = r.props,
            o = n.t,
            i = n.report,
            a = n.disableModalAnimation;
        return r.columnSelector = new gH({
          modalTitle: o("choose_columns"),
          report: i,
          disableModalAnimation: a,
          t: o
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && _H(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props.report;
          return p.a.createElement("div", {
            "aria-label": "Column Selector",
            className: "column-selector-control col text-right"
          }, p.a.createElement("button", {
            className: "btn btn-link icon icon-add",
            type: "button",
            onClick: this.columnSelector.onShowModal
          }, this.columnSelector.modalTitle), p.a.createElement(JW, {
            columnSelector: this.columnSelector,
            report: e
          }));
        }
      }]) && wH(r.prototype, n), o && wH(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || hH,
        kH = Object(g.a)()(CH),
        RH = r(205);

    function TH(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zH(n.key), n);
      }
    }

    function zH(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function NH(e, t, r) {
      return t = DH(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], DH(e).constructor) : t.apply(e, r));
    }

    function DH(e) {
      return (DH = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function xH(e, t) {
      return (xH = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var AH,
        MH,
        IH = function (e) {
      var t = e.t,
          r = e.isLoading,
          n = e.children;
      return r ? p.a.createElement(MB, {
        placement: "top",
        delay: {
          show: 250,
          hide: 400
        },
        overlay: p.a.createElement(VB, null, t("if2.reports.report_still_running"))
      }, p.a.createElement("div", {
        className: "d-flex flex-row justify-content-center"
      }, n, p.a.createElement(h.Spinner, {
        containerClasses: ["control-wrapper", "ml-1"]
      }))) : n;
    },
        FH = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((SH = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), NH(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && xH(e, t);
      }(t, p.a.Component), function (e, t, r) {
        return t && TH(e.prototype, t), r && TH(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "_report",
        get: function () {
          var e = this.props.report;
          if (!e) throw new Error("StatusIndicator requires report property");
          return e;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return this._report.status && null !== this._report.totalRowCount && void 0 !== this._report.totalRowCount ? p.a.createElement("div", {
            role: "status"
          }, p.a.createElement(RH.ReactInterval, {
            enabled: this._report.isProcessing,
            timeout: 2e3,
            callback: this._report.loadStatus
          }), p.a.createElement(IH, {
            t: e,
            isLoading: this._report.isProcessing
          }, "".concat(this._report.totalRowCount, " ").concat(e("if2.reports.rows")))) : p.a.createElement(h.Spinner, null);
        }
      }]);
    }()).prototype, "_report", [f.computed], Object.getOwnPropertyDescriptor(SH.prototype, "_report"), SH.prototype), EH = SH)) || EH,
        BH = Object(g.a)()(FH);

    function LH(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, VH(n.key), n);
      }
    }

    function VH(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function UH(e, t, r) {
      return t = qH(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], qH(e).constructor) : t.apply(e, r));
    }

    function qH(e) {
      return (qH = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function KH(e, t) {
      return (KH = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var GH = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((MH = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = UH(this, t, [].concat(n))).onRefreshQuery = function () {
          return e.props.report.update();
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && KH(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && LH(e.prototype, t), r && LH(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "shouldIncludeAccountSelector",
        get: function () {
          var e = this.props.report;
          return ["IF2::SprayRecord", "IF2::Field", "IF2::Recommendation"].includes(e.reportType);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.report,
              r = e.readOnlyAncestors,
              n = e.t;
          return p.a.createElement("div", {
            className: "row report-controls justify-content-between mb-2"
          }, p.a.createElement("div", {
            className: "col"
          }, this.shouldIncludeAccountSelector ? p.a.createElement(p.a.Fragment, null, p.a.createElement(NG, {
            readOnlyAncestors: r,
            report: t,
            selectedAccountIds: t.selectedAccountIds
          }), p.a.createElement("button", {
            type: "button",
            className: "btn btn-link".concat(t.draftReportId ? "" : " disabled"),
            "data-testid": "test-refresh-query-button",
            title: n("refresh_query"),
            "data-toggle": "tooltip",
            disabled: !t.draftReportId,
            onClick: this.onRefreshQuery,
            "aria-label": "Refresh Query"
          }, p.a.createElement("i", {
            className: "fas fa-redo"
          }))) : null), p.a.createElement("div", {
            className: "col d-flex flex-row justify-content-center"
          }, p.a.createElement(BH, {
            report: t
          })), p.a.createElement(kH, {
            report: t
          }));
        }
      }]);
    }()).prototype, "shouldIncludeAccountSelector", [f.computed], Object.getOwnPropertyDescriptor(MH.prototype, "shouldIncludeAccountSelector"), MH.prototype), AH = MH)) || AH,
        WH = Object(g.a)()(GH);

    function HH(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, JH(n.key), n);
      }
    }

    function JH(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var YH,
        QH,
        $H = function () {
      return e = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
      }, r = [{
        key: "setConfig",
        value: function (e, t) {
          if (!this._whiteList.includes(e)) throw new Error('"'.concat(e, '" is not a recognized config value'));
          this[e] = t;
        }
      }, {
        key: "getConfig",
        value: function (e) {
          if (this._whiteList.includes(e)) return this[e];
        }
      }], (t = null) && HH(e.prototype, t), r && HH(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function XH(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ZH(n.key), n);
      }
    }

    function ZH(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function eJ(e, t, r) {
      return t = tJ(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], tJ(e).constructor) : t.apply(e, r));
    }

    function tJ(e) {
      return (tJ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function rJ(e, t) {
      return (rJ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function nJ(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    $H.useNewReports = !1, $H._whiteList = ["useNewReports"];
    var oJ,
        iJ,
        aJ,
        cJ,
        uJ,
        lJ = Object(d.observer)((nJ((QH = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), eJ(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && rJ(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && XH(e.prototype, t), r && XH(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "className",
        get: function () {
          var e = this.props.report;
          return ["btn btn-secondary btn-text mx-1"].concat(e.isDirty ? [] : "disabled").join(" ");
        }
      }, {
        key: "discardChangesPath",
        get: function () {
          var e = this.props.report;
          return e.originalReportId ? e.api.reportPath(e.originalReportId) : e.api.reportsPath;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.report,
              r = e.t;
          return p.a.createElement("a", {
            role: "button",
            className: this.className,
            disabled: !t.isDirty,
            href: this.discardChangesPath
          }, r("discard_changes").toUpperCase());
        }
      }]);
    }()).prototype, "className", [f.computed], Object.getOwnPropertyDescriptor(QH.prototype, "className"), QH.prototype), nJ(QH.prototype, "discardChangesPath", [f.computed], Object.getOwnPropertyDescriptor(QH.prototype, "discardChangesPath"), QH.prototype), YH = QH)) || YH,
        sJ = Object(g.a)()(lJ);

    function pJ(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function fJ(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, dJ(n.key), n);
      }
    }

    function dJ(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function bJ(e, t, r) {
      return t = yJ(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], yJ(e).constructor) : t.apply(e, r));
    }

    function yJ(e) {
      return (yJ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function mJ(e, t) {
      return (mJ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function vJ(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var hJ,
        gJ = Object(d.observer)((vJ((iJ = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return pJ(e = bJ(this, t, [].concat(n)), "onSaveAsNewReport", aJ, e), pJ(e, "onSaveAsNewTemplate", cJ, e), pJ(e, "onSave", uJ, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && mJ(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && fJ(e.prototype, t), r && fJ(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "isDisabled",
        get: function () {
          return this.props.report.shouldDisableSave;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.report,
              r = e.t;
          return p.a.createElement(FV.Dropdown, {
            as: FV.ButtonGroup,
            "aria-label": "Save/Save as button group"
          }, p.a.createElement(FV.Button, {
            variant: "success",
            className: "btn-text ml-1",
            disabled: this.isDisabled,
            onClick: this.onSave
          }, r("save").toUpperCase()), p.a.createElement(FV.Dropdown.Toggle, {
            split: !0,
            variant: "success",
            id: "save-dropdown-toggle",
            className: "btn-text",
            disabled: this.isDisabled,
            "aria-haspopup": "true",
            "aria-controls": "save-dropdown-menu"
          }, p.a.createElement("span", {
            className: "sr-only"
          }, r("toggle_dropdown"))), p.a.createElement(FV.Dropdown.Menu, {
            id: "save-dropdown-menu",
            className: "dropdown-menu-right",
            role: "menu",
            "aria-labelledby": "save-dropdown-toggle"
          }, p.a.createElement(FV.Dropdown.Item, {
            as: "button",
            onClick: this.onSaveAsNewReport
          }, r("if2.reports.save_as_new_report")), t.canEditTemplates ? p.a.createElement(FV.Dropdown.Item, {
            as: "button",
            onClick: this.onSaveAsNewTemplate
          }, r("if2.reports.save_as_new_template")) : null));
        }
      }]);
    }()).prototype, "isDisabled", [f.computed], Object.getOwnPropertyDescriptor(iJ.prototype, "isDisabled"), iJ.prototype), aJ = vJ(iJ.prototype, "onSaveAsNewReport", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.props.report.saveReport(!0);
        };
      }
    }), cJ = vJ(iJ.prototype, "onSaveAsNewTemplate", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.props.report.saveTemplate(!0);
        };
      }
    }), uJ = vJ(iJ.prototype, "onSave", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.report;
          return t.isTemplate ? t.saveTemplate() : t.saveReport();
        };
      }
    }), oJ = iJ)) || oJ,
        wJ = Object(g.a)()(gJ);

    function OJ(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, jJ(n.key), n);
      }
    }

    function jJ(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function PJ(e, t, r) {
      return t = _J(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], _J(e).constructor) : t.apply(e, r));
    }

    function _J(e) {
      return (_J = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function EJ(e, t) {
      return (EJ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var SJ,
        CJ,
        kJ,
        RJ = Object(d.observer)(hJ = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), PJ(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && EJ(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && OJ(e.prototype, t), r && OJ(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.report,
              r = e.t;
          return t.originalReportId || t.canEditTemplates && t.isTemplate && t.templateId ? p.a.createElement("form", {
            className: "d-inline-block",
            action: t.api.reportPath(t.originalReportId),
            method: "post"
          }, p.a.createElement("input", {
            name: "_method",
            type: "hidden",
            value: "delete"
          }), p.a.createElement("input", {
            name: "authenticity_token",
            type: "hidden",
            value: t.api.csrf()
          }), p.a.createElement("button", {
            className: "btn btn-danger btn-text mx-1",
            type: "submit"
          }, r("delete").toUpperCase())) : null;
        }
      }]);
    }()) || hJ,
        TJ = Object(g.a)()(RJ);

    function zJ(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, NJ(n.key), n);
      }
    }

    function NJ(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function DJ(e, t, r) {
      return t = xJ(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], xJ(e).constructor) : t.apply(e, r));
    }

    function xJ(e) {
      return (xJ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function AJ(e, t) {
      return (AJ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function MJ(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var IJ,
        FJ,
        BJ,
        LJ,
        VJ,
        UJ,
        qJ = Object(d.observer)((MJ((CJ = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = DJ(this, t, [].concat(n)), "onClick", kJ, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && AJ(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && zJ(e.prototype, t), r && zJ(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "downloadCSVPath",
        get: function () {
          var e = this.props.report;
          return "".concat(e.api.reportPath(e.draftReportId), ".csv");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.report,
              r = e.t;
          return t.isTemplate ? null : p.a.createElement("a", {
            role: "button",
            className: "btn btn-orange btn-text mx-1",
            disabled: !t.draftReportId,
            href: this.downloadCSVPath,
            onClick: this.onClick
          }, r("download_as_csv").toUpperCase());
        }
      }]);
    }()).prototype, "downloadCSVPath", [f.computed], Object.getOwnPropertyDescriptor(CJ.prototype, "downloadCSVPath"), CJ.prototype), kJ = MJ(CJ.prototype, "onClick", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.report;
          t.isDirty && (t.disableUnloadHandler(), setTimeout(function () {
            t.isDirty && t.enableUnloadHandler();
          }, 100));
        };
      }
    }), SJ = CJ)) || SJ,
        KJ = Object(g.a)()(qJ);

    function GJ(e) {
      return function (e) {
        if (Array.isArray(e)) return WJ(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return WJ(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? WJ(e, t) : void 0;
        }
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function WJ(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function HJ(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function JJ(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, YJ(n.key), n);
      }
    }

    function YJ(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function QJ(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var $J,
        XJ,
        ZJ,
        eY,
        tY,
        rY = (FJ = QJ((IJ = function () {
      return e = function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), HJ(this, "_columnFilterMap", FJ, this), HJ(this, "columnVisibilityMap", BJ, this), HJ(this, "isShowing", LJ, this), HJ(this, "report", VJ, this), HJ(this, "title", UJ, this);
        var r = t.title;
        this.title = r || "";
      }, (t = [{
        key: "sortedFilters",
        get: function () {
          var e = this;
          return GJ(this._columnFilterMap.values()).map(function (t) {
            var r;
            return {
              name: (null === (r = e.report) || void 0 === r || null === (r = r.columnConfig.findColumn(t.id)) || void 0 === r ? void 0 : r.getName()) || t.id,
              filter: t
            };
          }).sort(w.sortByName);
        }
      }, {
        key: "apply",
        value: function (e) {
          var t = this;
          this.columnVisibilityMap.forEach(function (t, r) {
            var n = e.columnConfig.findColumn(r);
            t ? e.columnConfig.addColumn(n) : e.columnConfig.removeColumn(n);
          }), e.columnConfig.dumpFilters().forEach(function (r) {
            t._columnFilterMap.get(r.id) || e.columnConfig.clearFilter(r.id);
          });
        }
      }, {
        key: "editFilter",
        value: function (e, t) {
          t.columnFilterModal.show(t, t.columnConfig.findColumn(e.id)), this.hide();
        }
      }, {
        key: "hide",
        value: function () {
          this.isShowing = !1;
        }
      }, {
        key: "hideColumn",
        value: function (e) {
          this.columnVisibilityMap.set(e, !1);
        }
      }, {
        key: "removeFilter",
        value: function (e) {
          this._columnFilterMap.delete(e.id);
        }
      }, {
        key: "reset",
        value: function () {
          this.columnVisibilityMap.clear(), this._columnFilterMap.clear();
        }
      }, {
        key: "show",
        value: function (e) {
          var t = this;
          this.report = e, e.columnConfig.dumpFilters().forEach(function (r) {
            t._columnFilterMap.set(r.id, r);

            var n = e.columnConfig.findColumn(r.id);
            n.isShowing ? t.showColumn(n.id) : t.hideColumn(n.id);
          }), this.isShowing = !0;
        }
      }, {
        key: "showColumn",
        value: function (e) {
          this.columnVisibilityMap.set(e, !0);
        }
      }]) && JJ(e.prototype, t), r && JJ(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "_columnFilterMap", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new Map();
      }
    }), BJ = QJ(IJ.prototype, "columnVisibilityMap", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new Map();
      }
    }), LJ = QJ(IJ.prototype, "isShowing", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), VJ = QJ(IJ.prototype, "report", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), UJ = QJ(IJ.prototype, "title", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), QJ(IJ.prototype, "sortedFilters", [f.computed], Object.getOwnPropertyDescriptor(IJ.prototype, "sortedFilters"), IJ.prototype), QJ(IJ.prototype, "apply", [f.action], Object.getOwnPropertyDescriptor(IJ.prototype, "apply"), IJ.prototype), QJ(IJ.prototype, "editFilter", [f.action], Object.getOwnPropertyDescriptor(IJ.prototype, "editFilter"), IJ.prototype), QJ(IJ.prototype, "hide", [f.action], Object.getOwnPropertyDescriptor(IJ.prototype, "hide"), IJ.prototype), QJ(IJ.prototype, "hideColumn", [f.action], Object.getOwnPropertyDescriptor(IJ.prototype, "hideColumn"), IJ.prototype), QJ(IJ.prototype, "removeFilter", [f.action], Object.getOwnPropertyDescriptor(IJ.prototype, "removeFilter"), IJ.prototype), QJ(IJ.prototype, "reset", [f.action], Object.getOwnPropertyDescriptor(IJ.prototype, "reset"), IJ.prototype), QJ(IJ.prototype, "show", [f.action], Object.getOwnPropertyDescriptor(IJ.prototype, "show"), IJ.prototype), IJ);

    function nY(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function oY(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, iY(n.key), n);
      }
    }

    function iY(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function aY(e, t, r) {
      return t = cY(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], cY(e).constructor) : t.apply(e, r));
    }

    function cY(e) {
      return (cY = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function uY(e, t) {
      return (uY = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function lY(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var sY,
        pY,
        fY,
        dY,
        bY,
        yY,
        mY = Object(d.observer)((ZJ = lY((XJ = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return nY(e = aY(this, t, [].concat(n)), "onApply", ZJ, e), nY(e, "onCancel", eY, e), nY(e, "onClear", tY, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && uY(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && oY(e.prototype, t), r && oY(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props.t;
          return p.a.createElement(FV.ModalFooter, null, p.a.createElement("div", {
            className: "buttons-left"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-link text-danger font-weight-normal",
            onClick: this.onClear
          }, e("clear_filters"))), p.a.createElement("div", {
            className: "buttons-right"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-outline-secondary",
            onClick: this.onCancel
          }, e("cancel")), " ", p.a.createElement("button", {
            type: "button",
            className: "btn btn-primary",
            onClick: this.onApply
          }, e("apply"))));
        }
      }]);
    }()).prototype, "onApply", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.modal,
              n = t.report;
          return r.apply(n), r.hide(), r.reset(), n.update();
        };
      }
    }), eY = lY(XJ.prototype, "onCancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.modal;
          t.hide(), t.reset();
        };
      }
    }), tY = lY(XJ.prototype, "onClear", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.modal,
              n = t.report;
          return n.columnConfig.clearAllFilters(), r.hide(), r.reset(), n.update();
        };
      }
    }), $J = XJ)) || $J,
        vY = Object(g.a)()(mY);

    function hY(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function gY(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, wY(n.key), n);
      }
    }

    function wY(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function OY(e, t, r) {
      return t = jY(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], jY(e).constructor) : t.apply(e, r));
    }

    function jY(e) {
      return (jY = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function PY(e, t) {
      return (PY = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function _Y(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var EY,
        SY = Object(d.observer)((_Y((pY = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return hY(e = OY(this, t, [].concat(n)), "onEditFilter", fY, e), hY(e, "onHideColumn", dY, e), hY(e, "onRemoveFilter", bY, e), hY(e, "onShowColumn", yY, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && PY(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && gY(e.prototype, t), r && gY(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "columnSpec",
        get: function () {
          return this.props.report.columnConfig.findColumn(this.filter.id);
        }
      }, {
        key: "dateRange",
        get: function () {
          var e = this.props.t;
          return "custom" === this.filter.method ? [].concat($R.DateTime.fromISO(this.filter.start_date).toFormat("MM/dd/yyyy") || []).concat($R.DateTime.fromISO(this.filter.end_date).toFormat("MM/dd/yyyy") || []).join(" - ") : e("if2.reports.".concat(this.filter.method));
        }
      }, {
        key: "displayValue",
        get: function () {
          return "DateFilter" === this.filter.type ? this.dateRange : this.filter.value;
        }
      }, {
        key: "filter",
        get: function () {
          return this.props.filter.filter;
        }
      }, {
        key: "isTextFilter",
        get: function () {
          return "TextFilter" === this.filter.type;
        }
      }, {
        key: "name",
        get: function () {
          return this.props.filter.name;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.modal,
              r = e.t;
          return p.a.createElement("tr", {
            className: "filter-summary-row"
          }, p.a.createElement("th", {
            scope: "row"
          }, this.name), p.a.createElement("td", null, this.isTextFilter ? r("if2.reports.".concat(this.filter.method)) : null), p.a.createElement("td", null, this.displayValue), p.a.createElement("td", null, p.a.createElement("div", {
            className: "filter-buttons"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-link",
            title: r("edit"),
            onClick: this.onEditFilter,
            "aria-label": "Edit"
          }, p.a.createElement("i", {
            className: "fas fa-edit"
          })), t.columnVisibilityMap.get(this.filter.id) ? p.a.createElement("button", {
            type: "button",
            className: "btn btn-link",
            "data-toggle": "tooltip",
            title: r("column_visible"),
            onClick: this.onHideColumn,
            "aria-label": "Visible"
          }, p.a.createElement("i", {
            className: "fas fa-eye"
          })) : p.a.createElement("button", {
            type: "button",
            className: "btn btn-link",
            "data-toggle": "tooltip",
            title: r("column_hidden"),
            onClick: this.onShowColumn,
            "aria-label": "Hidden"
          }, p.a.createElement("i", {
            className: "fas fa-eye-slash"
          })), p.a.createElement("button", {
            type: "button",
            className: "btn btn-link",
            title: r("remove"),
            onClick: this.onRemoveFilter,
            "aria-label": "Remove"
          }, p.a.createElement("i", {
            className: "fas fa-times"
          })))));
        }
      }]);
    }()).prototype, "columnSpec", [f.computed], Object.getOwnPropertyDescriptor(pY.prototype, "columnSpec"), pY.prototype), _Y(pY.prototype, "dateRange", [f.computed], Object.getOwnPropertyDescriptor(pY.prototype, "dateRange"), pY.prototype), _Y(pY.prototype, "displayValue", [f.computed], Object.getOwnPropertyDescriptor(pY.prototype, "displayValue"), pY.prototype), _Y(pY.prototype, "filter", [f.computed], Object.getOwnPropertyDescriptor(pY.prototype, "filter"), pY.prototype), _Y(pY.prototype, "isTextFilter", [f.computed], Object.getOwnPropertyDescriptor(pY.prototype, "isTextFilter"), pY.prototype), _Y(pY.prototype, "name", [f.computed], Object.getOwnPropertyDescriptor(pY.prototype, "name"), pY.prototype), fY = _Y(pY.prototype, "onEditFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.modal,
              n = t.report;
          r.editFilter(e.filter, n);
        };
      }
    }), dY = _Y(pY.prototype, "onHideColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.props.modal.hideColumn(e.filter.id);
        };
      }
    }), bY = _Y(pY.prototype, "onRemoveFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.props.modal.removeFilter(e.filter);
        };
      }
    }), yY = _Y(pY.prototype, "onShowColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.props.modal.showColumn(e.filter.id);
        };
      }
    }), sY = pY)) || sY,
        CY = Object(g.a)()(SY);

    function kY(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, RY(n.key), n);
      }
    }

    function RY(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function TY(e, t, r) {
      return t = zY(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], zY(e).constructor) : t.apply(e, r));
    }

    function zY(e) {
      return (zY = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function NY(e, t) {
      return (NY = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var DY,
        xY,
        AY,
        MY = Object(d.observer)(EY = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), TY(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && NY(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.modal,
              r = e.report;
          return p.a.createElement(FV.Modal.Body, null, p.a.createElement("div", {
            className: "filters-table"
          }, p.a.createElement("table", {
            className: "table table-sm"
          }, p.a.createElement("thead", null), p.a.createElement("tbody", null, t.sortedFilters.map(function (e) {
            return p.a.createElement(CY, {
              key: e.filter.id,
              filter: e,
              modal: t,
              report: r
            });
          })))));
        }
      }]) && kY(r.prototype, n), o && kY(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || EY;

    function IY(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, FY(n.key), n);
      }
    }

    function FY(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function BY(e, t, r) {
      return t = LY(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], LY(e).constructor) : t.apply(e, r));
    }

    function LY(e) {
      return (LY = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function VY(e, t) {
      return (VY = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function UY(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var qY,
        KY,
        GY,
        WY = Object(d.observer)((UY((xY = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = BY(this, t, [].concat(n)), "onCancel", AY, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && VY(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "headerId",
        get: function () {
          var e = this.props.modal;
          return "".concat(e.id, "-header");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.modal,
              r = e.report;
          return p.a.createElement(FV.Modal, {
            show: t.isShowing,
            size: "lg",
            dialogClassName: "if2-modal frb-filter-summary-modal",
            "aria-labelledby": this.headerId,
            onHide: this.onCancel
          }, p.a.createElement(FV.Modal.Header, {
            closeButton: !0
          }, p.a.createElement(FV.Modal.Title, {
            id: this.headerId
          }, t.title)), p.a.createElement(MY, {
            modal: t,
            report: r
          }), p.a.createElement(vY, {
            modal: t,
            report: r
          }));
        }
      }]) && IY(r.prototype, n), o && IY(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "headerId", [f.computed], Object.getOwnPropertyDescriptor(xY.prototype, "headerId"), xY.prototype), AY = UY(xY.prototype, "onCancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.props.modal.hide();
        };
      }
    }), DY = xY)) || DY;

    function HY(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, JY(n.key), n);
      }
    }

    function JY(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function YY(e, t, r) {
      return t = QY(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], QY(e).constructor) : t.apply(e, r));
    }

    function QY(e) {
      return (QY = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function $Y(e, t) {
      return ($Y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var XY,
        ZY,
        eQ = Object(d.observer)((GY = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((KY = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = YY(this, t, [e]), "onOpenFilterSummaryModal", GY, r);
        var n = r.props || {},
            o = n.filterSummaryModalModel,
            i = n.t;
        return r.filterSummaryModalModel = o || new rY({
          title: i("filter_summary")
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && $Y(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props.report;
          return p.a.createElement("div", {
            className: "d-flex col-md-auto"
          }, p.a.createElement("div", {
            className: "report-filters-button pr-2"
          }, p.a.createElement(h.FiltersButton, {
            onClick: this.onOpenFilterSummaryModal,
            badgeContent: e.columnConfig.numFilters
          })), p.a.createElement("div", null, p.a.createElement(KJ, {
            report: e
          }), p.a.createElement(sJ, {
            report: e
          }), p.a.createElement(TJ, {
            report: e
          }), p.a.createElement(wJ, {
            report: e
          })), p.a.createElement(WY, {
            modal: this.filterSummaryModalModel,
            report: e
          }));
        }
      }]) && HY(r.prototype, n), o && HY(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "onOpenFilterSummaryModal", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.report;
          e.filterSummaryModalModel.show(t);
        };
      }
    }), qY = KY)) || qY,
        tQ = Object(g.a)()(eQ);

    function rQ(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, nQ(n.key), n);
      }
    }

    function nQ(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function oQ(e, t, r) {
      return t = iQ(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], iQ(e).constructor) : t.apply(e, r));
    }

    function iQ(e) {
      return (iQ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function aQ(e, t) {
      return (aQ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var cQ,
        uQ,
        lQ = Object(d.observer)(((ZY = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), oQ(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && aQ(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.report,
              r = e.transition;
          return p.a.createElement(FV.Alert, {
            "data-testid": "test-success-alert",
            variant: "success",
            show: t.isShowingSuccessAlert,
            onClose: t.onCloseSuccessAlert,
            transition: r,
            dismissible: !0
          }, p.a.createElement(FV.Alert.Heading, {
            "data-testid": "test-success-alert-heading"
          }, t.successAlertText));
        }
      }]) && rQ(r.prototype, n), o && rQ(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).defaultProps = {
      transition: FV.Fade
    }, XY = ZY)) || XY;

    function sQ(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, pQ(n.key), n);
      }
    }

    function pQ(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function fQ(e, t, r) {
      return t = dQ(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], dQ(e).constructor) : t.apply(e, r));
    }

    function dQ(e) {
      return (dQ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function bQ(e, t) {
      return (bQ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var yQ,
        mQ,
        vQ,
        hQ = Object(d.observer)(((uQ = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), fQ(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && bQ(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.report,
              r = e.transition;
          return p.a.createElement(FV.Alert, {
            "data-testid": "test-error-alert",
            variant: "danger",
            show: t.isShowingErrorAlert,
            onClose: t.onCloseErrorAlert,
            transition: r,
            dismissible: !0
          }, p.a.createElement(FV.Alert.Heading, {
            "data-testid": "test-error-alert-heading"
          }, t.errorAlertText), t.errorAlertMessages.map(function (e, t) {
            return p.a.createElement(p.a.Fragment, null, t > 0 ? p.a.createElement("hr", null) : null, p.a.createElement("p", null, e));
          }));
        }
      }]) && sQ(r.prototype, n), o && sQ(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).defaultProps = {
      transition: FV.Fade
    }, cQ = uQ)) || cQ;

    function gQ(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, wQ(n.key), n);
      }
    }

    function wQ(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function OQ(e, t, r) {
      return t = jQ(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], jQ(e).constructor) : t.apply(e, r));
    }

    function jQ(e) {
      return (jQ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function PQ(e, t) {
      return (PQ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function _Q(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var EQ,
        SQ,
        CQ,
        kQ = Object(d.observer)((_Q((mQ = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = OQ(this, t, [].concat(n)), "onClearFilters", vQ, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && PQ(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && gQ(e.prototype, t), r && gQ(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "filterStatusText",
        get: function () {
          var e = this.props,
              t = e.t,
              r = e.report;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("span", {
            className: "report-filters-number"
          }, r.columnConfig.numFilters || 0, " "), p.a.createElement("span", {
            className: "report-filters-applied-text"
          }, 1 === r.columnConfig.numFilters ? t("filter_applied_not_all_records_are_shown") : t("filters_applied_not_all_records_are_shown")));
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.report,
              r = e.t;
          return p.a.createElement("div", {
            className: "clear-report-filters",
            "data-testid": "report-filter-status"
          }, t.columnConfig.numFilters ? p.a.createElement(p.a.Fragment, null, this.filterStatusText, " ", p.a.createElement("a", {
            role: "button",
            href: "#",
            onClick: this.onClearFilters
          }, r("clear_filters"))) : null);
        }
      }]);
    }()).prototype, "filterStatusText", [f.computed], Object.getOwnPropertyDescriptor(mQ.prototype, "filterStatusText"), mQ.prototype), vQ = _Q(mQ.prototype, "onClearFilters", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.report;
          t.columnConfig.clearAllFilters(), t.update();
        };
      }
    }), yQ = mQ)) || yQ,
        RQ = Object(g.a)()(kQ);

    function TQ(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zQ(n.key), n);
      }
    }

    function zQ(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function NQ(e, t, r) {
      return t = DQ(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], DQ(e).constructor) : t.apply(e, r));
    }

    function DQ(e) {
      return (DQ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function xQ(e, t) {
      return (xQ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var AQ,
        MQ,
        IQ,
        FQ,
        BQ,
        LQ,
        VQ,
        UQ,
        qQ,
        KQ,
        GQ,
        WQ = Object(d.observer)((CQ = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((SQ = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = NQ(this, t, [e]), "reportModel", CQ, r);
        var n = r.props,
            o = n.report,
            i = n.reportModel,
            a = n.roots,
            c = n.canEditTemplates,
            u = n.t;
        return $H.setConfig("useNewReports", !0), r.reportModel = i || new VF({
          report: o,
          accountRoots: a,
          canEditTemplates: c,
          t: u
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && xQ(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "componentDidMount",
        value: function () {
          var e = this;
          this.reportModel.createDraft().then(function () {
            return e.reportModel.loadCurrentPage();
          }).catch(console.error);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.readOnlyAncestors;
          return p.a.createElement("div", {
            className: "flex-report-builder d-flex flex-column h-100"
          }, p.a.createElement("div", {
            className: "frb-alert-container"
          }, p.a.createElement(lQ, {
            report: this.reportModel
          }), p.a.createElement(hQ, {
            report: this.reportModel
          })), p.a.createElement("div", {
            className: "row align-items-center justify-content-between frb-header"
          }, p.a.createElement(QR, {
            report: this.reportModel
          }), p.a.createElement(tQ, {
            report: this.reportModel
          })), p.a.createElement(RQ, {
            report: this.reportModel
          }), p.a.createElement("div", {
            className: "row frb-body flex-grow-1"
          }, p.a.createElement("div", {
            className: "col pb-3"
          }, p.a.createElement(h.Card, {
            className: "p-3 h-100"
          }, p.a.createElement(WH, {
            report: this.reportModel,
            readOnlyAncestors: e
          }), p.a.createElement(pG, {
            report: this.reportModel
          })))));
        }
      }]) && TQ(r.prototype, n), o && TQ(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "reportModel", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), EQ = SQ)) || EQ,
        HQ = Object(g.a)()(WQ);

    function JQ(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (null != r) {
          var n,
              o,
              i,
              a,
              c = [],
              u = !0,
              l = !1;

          try {
            if (i = (r = r.call(e)).next, 0 === t) {
              if (Object(r) !== r) return;
              u = !1;
            } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== t); u = !0);
          } catch (e) {
            l = !0, o = e;
          } finally {
            try {
              if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
            } finally {
              if (l) throw o;
            }
          }

          return c;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return YQ(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? YQ(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function YQ(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function QQ(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function $Q(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, XQ(n.key), n);
      }
    }

    function XQ(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ZQ(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var e$,
        t$,
        r$,
        n$,
        o$,
        i$,
        a$,
        c$,
        u$,
        l$,
        s$,
        p$,
        f$,
        d$,
        b$,
        y$,
        m$,
        v$,
        h$,
        g$,
        w$,
        O$,
        j$,
        P$,
        _$,
        E$,
        S$,
        C$,
        k$,
        R$,
        T$,
        z$,
        N$,
        D$,
        x$,
        A$,
        M$,
        I$,
        F$,
        B$,
        L$,
        V$ = (MQ = ZQ((AQ = function () {
      return e = function e(t) {
        if (function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), QQ(this, "street1", MQ, this), QQ(this, "street2", IQ, this), QQ(this, "city", FQ, this), QQ(this, "state", BQ, this), QQ(this, "zip", LQ, this), QQ(this, "onChangeStreet1", VQ, this), QQ(this, "onChangeStreet2", UQ, this), QQ(this, "onChangeCity", qQ, this), QQ(this, "onChangeState", KQ, this), QQ(this, "onChangeZip", GQ, this), "string" != typeof t) {
          var r = this.props || {},
              n = r.street1,
              o = r.street2,
              i = r.city,
              a = r.state,
              c = r.zip;
          this.street1 = n || this.street1, this.street2 = o || this.street2, this.city = i || this.city, this.state = a || this.state, this.zip = c || this.zip;
        } else this.parseAddress(t);
      }, (t = [{
        key: "cityState",
        get: function () {
          return [].concat(this.city || []).concat(this.state || []).join(", ");
        }
      }, {
        key: "line3",
        get: function () {
          return [].concat(this.cityState || []).concat(this.zip || []).join("  ");
        }
      }, {
        key: "address",
        get: function () {
          return [].concat(this.street1 || []).concat(this.street2 || []).concat(this.line3 || []).join("\n");
        }
      }, {
        key: "parseMaybeCityStateZip",
        value: function (e) {
          e.split(",");
          if (e.length) return this.parseCityStateZip(e);
          this.street1 = e;
        }
      }, {
        key: "parseCityStateZip",
        value: function (e) {
          var t = JQ(e.split(","), 2),
              r = t[0],
              n = t[1];

          if (r && (this.city = r.trim()), n) {
            var o = JQ(n.trim().split(/\s+/), 2),
                i = o[0],
                a = o[1];
            this.state = i, this.zip = a;
          }
        }
      }, {
        key: "parseAddress",
        value: function (e) {
          var t = e.split("\n");
          if (3 === t.length) return this.street1 = t[0].trim(), this.street2 = t[1].trim(), this.parseCityStateZip(t[2].trim());
          if (2 === t.length) return this.street1 = t[0].trim(), this.parseCityStateZip(t[1].trim());
          if (1 === t.length) return this.street1 = t[0].trim();
          throw new Error("".concat("Unable to parse address: \n").concat(e));
        }
      }]) && $Q(e.prototype, t), r && $Q(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "street1", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), IQ = ZQ(AQ.prototype, "street2", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), FQ = ZQ(AQ.prototype, "city", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), BQ = ZQ(AQ.prototype, "state", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), LQ = ZQ(AQ.prototype, "zip", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), ZQ(AQ.prototype, "cityState", [f.computed], Object.getOwnPropertyDescriptor(AQ.prototype, "cityState"), AQ.prototype), ZQ(AQ.prototype, "line3", [f.computed], Object.getOwnPropertyDescriptor(AQ.prototype, "line3"), AQ.prototype), ZQ(AQ.prototype, "address", [f.computed], Object.getOwnPropertyDescriptor(AQ.prototype, "address"), AQ.prototype), VQ = ZQ(AQ.prototype, "onChangeStreet1", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.street1 = t;
        };
      }
    }), UQ = ZQ(AQ.prototype, "onChangeStreet2", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.street2 = t;
        };
      }
    }), qQ = ZQ(AQ.prototype, "onChangeCity", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.city = t;
        };
      }
    }), KQ = ZQ(AQ.prototype, "onChangeState", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.state = t;
        };
      }
    }), GQ = ZQ(AQ.prototype, "onChangeZip", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.zip = t;
        };
      }
    }), ZQ(AQ.prototype, "parseMaybeCityStateZip", [f.action], Object.getOwnPropertyDescriptor(AQ.prototype, "parseMaybeCityStateZip"), AQ.prototype), ZQ(AQ.prototype, "parseCityStateZip", [f.action], Object.getOwnPropertyDescriptor(AQ.prototype, "parseCityStateZip"), AQ.prototype), ZQ(AQ.prototype, "parseAddress", [f.action], Object.getOwnPropertyDescriptor(AQ.prototype, "parseAddress"), AQ.prototype), AQ);

    function U$(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function q$(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, K$(n.key), n);
      }
    }

    function K$(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function G$(e, t, r) {
      return t = W$(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], W$(e).constructor) : t.apply(e, r));
    }

    function W$(e) {
      return (W$ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function H$(e, t) {
      return (H$ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function J$(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Y$ = ((L$ = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), U$(r = G$(this, t, [e]), "applicator", t$, r), U$(r, "firstNameError", r$, r), U$(r, "implementType", n$, r), U$(r, "lastNameError", o$, r), U$(r, "tractorError", i$, r), U$(r, "sprayerError", a$, r), U$(r, "spreaderError", c$, r), U$(r, "licenseNumberError", u$, r), U$(r, "tractorSelector", l$, r), U$(r, "sprayerSelector", s$, r), U$(r, "spreaderSelector", p$, r), U$(r, "rateUnit", f$, r), U$(r, "rateValue", d$, r), U$(r, "rateUnitsError", b$, r), U$(r, "rateValueError", y$, r), U$(r, "makeContactDefault", m$, r), U$(r, "makeEquipmentDefault", v$, r), U$(r, "isNameEditable", h$, r), U$(r, "isNew", g$, r), U$(r, "showRemoveBtn", w$, r), U$(r, "showMakeDefaultContact", O$, r), U$(r, "onClose", j$, r), U$(r, "onSave", P$, r), U$(r, "onRemove", _$, r), U$(r, "onUpdateRateUnit", E$, r), U$(r, "onUpdateRateValue", S$, r), U$(r, "onChangeFirstName", C$, r), U$(r, "onChangeLastName", k$, r), U$(r, "onChangeLicenseNumber", R$, r), U$(r, "onChangeEmail", T$, r), U$(r, "onChangePhone", z$, r), U$(r, "onChangeStreet1", N$, r), U$(r, "onChangeCity", D$, r), U$(r, "onChangeState", x$, r), U$(r, "onChangeZip", A$, r), U$(r, "onSetImplementType", M$, r), U$(r, "onToggleMakeContactDefault", I$, r), U$(r, "onToggleMakeEquipmentDefault", F$, r), U$(r, "toggleTankCleaned", B$, r);
        var n = r.props,
            o = n.tractors,
            i = n.sprayers,
            a = n.spreaders;
        return r.tractorSelector = new h.SelectorModel(r.sortedObjects(o.map(function (e) {
          var t = new w.Tractor(e);
          return {
            key: t.id,
            text: r.nameAndLicense(t),
            value: t
          };
        }))), r.sprayerSelector = new h.SelectorModel(r.sortedObjects(i.map(function (e) {
          var t = new w.Sprayer(e);
          return {
            key: t.id,
            text: r.nameAndLicense(t),
            value: t
          };
        }))), r.spreaderSelector = new h.SelectorModel(r.sortedObjects(a.map(function (e) {
          var t = new w.Spreader(e);
          return {
            key: t.id,
            text: r.nameAndLicense(t),
            value: t
          };
        }))), r.requiresSpreaderDisposer = Object(f.reaction)(function () {
          return e.requiresSpreader;
        }, function (e) {
          r.implementType = e ? "spreader" : "sprayer";
        }, {
          fireImmediately: !0
        }), r.prepareExistingApplicatorForm(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && H$(e, t);
      }(t, h["ViewModel"]), function (e, t, r) {
        return t && q$(e.prototype, t), r && q$(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "addressModel",
        get: function () {
          return this.applicator && new V$(this.applicator.contact.address) || new V$();
        }
      }, {
        key: "hasErrors",
        get: function () {
          return this.firstNameError || this.lastNameError || this.tractorError || this.sprayerError || this.spreaderError || this.rateValueError || this.rateUnitsError || this.licenseNumberError;
        }
      }, {
        key: "sortedObjects",
        value: function (e) {
          return e.slice().sort(function (e, t) {
            return Object(h.naturalSort)(e.text || e.value.name, t.text || t.value.name, {
              ignorePunctuation: !1
            });
          });
        }
      }, {
        key: "onUnmount",
        value: function () {
          this.requiresSpreaderDisposer();
        }
      }, {
        key: "resetFormData",
        value: function (e) {
          var t = this.props,
              r = t.requiresSprayer,
              n = t.requiresSpreader;

          if (this.applicator = new w.SprayRecordApplicator(e.toJS()), this.tractorSelector.changeByKey(e.tractor && e.tractor.id), n ? this.sprayerSelector.reset() : this.sprayerSelector.changeByKey(e.sprayer && e.sprayer.id), r ? this.spreaderSelector.reset() : this.spreaderSelector.changeByKey(e.spreader && e.spreader.id), e.sprayRate) {
            var o = new w.Quantity(e.sprayRate).to("gal/acre");
            this.rateUnit = o.units, this.rateValue = "".concat(o.scalar);
          } else this.rateUnit = "", this.rateValue = "";
        }
      }, {
        key: "nameAndLicense",
        value: function (e) {
          return "".concat(e.name).concat(e.licensePlateNumber ? " (".concat(e.licensePlateNumber, ")") : "");
        }
      }, {
        key: "clearErrors",
        value: function () {
          this.firstNameError = "", this.lastNameError = "", this.tractorError = "", this.sprayerError = "", this.spreaderError = "", this.rateValueError = "", this.rateUnitsError = "", this.licenseNumberError = "";
        }
      }, {
        key: "close",
        value: function () {
          var e = this.props.id;
          v()("#".concat(e)).modal("hide"), this.onClose();
        }
      }, {
        key: "validate",
        value: function () {
          var e = this.props,
              t = e.requiresSprayRate,
              r = e.requiresSprayer,
              n = e.requiresSpreader,
              o = e.requiresTractor,
              i = e.requiresLicenseNumber,
              a = e.showEquipmentSelectors,
              c = e.t;
          return this.firstNameError = this.applicator.contact.firstName ? "" : c("name_cannot_be_blank"), this.lastNameError = this.applicator.contact.lastName ? "" : c("lastname_cannot_be_blank"), this.licenseNumberError = i && !this.applicator.licenseNumber ? c("license_number_cannot_be_blank") : "", a && (this.tractorError = o && !this.tractorSelector.selectedValue ? c("tractor_cannot_be_blank") : "", this.sprayerError = r && "sprayer" === this.implementType && !this.sprayerSelector.selectedValue ? c("sprayer_cannot_be_blank") : n && "sprayer" === this.implementType ? c("applicator_has_a_sprayer_for_a_spreader_only_application_method") : "", this.spreaderError = n && "spreader" === this.implementType && !this.spreaderSelector.selectedValue ? c("spreader_cannot_be_blank") : r && "spreader" === this.implementType ? c("applicator_has_a_spreader_for_a_sprayer_only_application_method") : "", this.rateValueError = t && !this.rateValue || this.rateUnit && !this.rateValue ? c("rate_cannot_be_blank") : "", this.rateUnitsError = t && !this.rateUnit || this.rateValue && !this.rateUnit ? c("units_cannot_be_blank") : ""), !t || this.rateValue;
        }
      }, {
        key: "prepareNewApplicatorForm",
        value: function (e) {
          this.isNew = !0, this.showRemoveBtn = !1, this.isNameEditable = !(null != e && e.id);
        }
      }, {
        key: "prepareExistingApplicatorForm",
        value: function (e) {
          var t;
          this.isNew = !1, this.showRemoveBtn = null === (t = null == e ? void 0 : e.showRemoveBtn) || void 0 === t || t, this.isNameEditable = !1;
        }
      }]);
    }()).defaultProps = {
      showRemoveBtn: !0,
      showEquipmentSelectors: !0,
      isNameEditable: !1,
      tractors: [],
      sprayers: [],
      spreaders: [],
      onRemove: function () {},
      onClose: function () {}
    }, t$ = J$((e$ = L$).prototype, "applicator", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new w.SprayRecordApplicator();
      }
    }), r$ = J$(e$.prototype, "firstNameError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), n$ = J$(e$.prototype, "implementType", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "sprayer";
      }
    }), o$ = J$(e$.prototype, "lastNameError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), i$ = J$(e$.prototype, "tractorError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), a$ = J$(e$.prototype, "sprayerError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), c$ = J$(e$.prototype, "spreaderError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), u$ = J$(e$.prototype, "licenseNumberError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), l$ = J$(e$.prototype, "tractorSelector", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), s$ = J$(e$.prototype, "sprayerSelector", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), p$ = J$(e$.prototype, "spreaderSelector", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), f$ = J$(e$.prototype, "rateUnit", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), d$ = J$(e$.prototype, "rateValue", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), b$ = J$(e$.prototype, "rateUnitsError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), y$ = J$(e$.prototype, "rateValueError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), m$ = J$(e$.prototype, "makeContactDefault", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), v$ = J$(e$.prototype, "makeEquipmentDefault", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), h$ = J$(e$.prototype, "isNameEditable", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), g$ = J$(e$.prototype, "isNew", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), w$ = J$(e$.prototype, "showRemoveBtn", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), O$ = J$(e$.prototype, "showMakeDefaultContact", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !0;
      }
    }), J$(e$.prototype, "addressModel", [f.computed], Object.getOwnPropertyDescriptor(e$.prototype, "addressModel"), e$.prototype), J$(e$.prototype, "hasErrors", [f.computed], Object.getOwnPropertyDescriptor(e$.prototype, "hasErrors"), e$.prototype), J$(e$.prototype, "resetFormData", [f.action], Object.getOwnPropertyDescriptor(e$.prototype, "resetFormData"), e$.prototype), j$ = J$(e$.prototype, "onClose", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.applicator,
              n = t.onClose;
          e.resetFormData(r), e.clearErrors(), n();
        };
      }
    }), P$ = J$(e$.prototype, "onSave", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.onSave;
          if (e.validate(), !e.hasErrors) return e.applicator.contact.setAddress(e.addressModel.address), e.applicator.tractor = e.tractorSelector.selectedValue, e.applicator.sprayer = e.sprayerSelector.selectedValue, e.applicator.spreader = e.spreaderSelector.selectedValue, e.applicator.sprayRate = [].concat(e.rateValue || []).concat(e.rateUnit || []).join(" "), t(e.applicator, {
            makeEquipmentDefault: e.makeEquipmentDefault,
            makeContactDefault: e.makeContactDefault
          }).finally(function () {
            return Object(f.runInAction)(function () {
              e.close(), e.makeEquipmentDefault = !1, e.makeContactDefault = !1;
            });
          });
        };
      }
    }), _$ = J$(e$.prototype, "onRemove", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.applicator;
          (0, t.onRemove)(r), e.close();
        };
      }
    }), E$ = J$(e$.prototype, "onUpdateRateUnit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.rateUnit = t;
        };
      }
    }), S$ = J$(e$.prototype, "onUpdateRateValue", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.rateValue = t;
        };
      }
    }), C$ = J$(e$.prototype, "onChangeFirstName", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.applicator.contact.firstName = t.target.value;
        };
      }
    }), k$ = J$(e$.prototype, "onChangeLastName", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.applicator.contact.lastName = t.target.value;
        };
      }
    }), R$ = J$(e$.prototype, "onChangeLicenseNumber", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.applicator.contact.licenseNumber = t.target.value;
        };
      }
    }), T$ = J$(e$.prototype, "onChangeEmail", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.applicator.contact.setEmail(t.target.value);
        };
      }
    }), z$ = J$(e$.prototype, "onChangePhone", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.applicator.contact.setPhone(t.target.value);
        };
      }
    }), N$ = J$(e$.prototype, "onChangeStreet1", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.addressModel.onChangeStreet1(t.target.value);
        };
      }
    }), D$ = J$(e$.prototype, "onChangeCity", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.addressModel.onChangeCity(t.target.value);
        };
      }
    }), x$ = J$(e$.prototype, "onChangeState", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.addressModel.onChangeState(t.target.value);
        };
      }
    }), A$ = J$(e$.prototype, "onChangeZip", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.addressModel.onChangeZip(t.target.value);
        };
      }
    }), M$ = J$(e$.prototype, "onSetImplementType", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.implementType = t;
        };
      }
    }), I$ = J$(e$.prototype, "onToggleMakeContactDefault", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.makeContactDefault = !e.makeContactDefault;
        };
      }
    }), F$ = J$(e$.prototype, "onToggleMakeEquipmentDefault", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.makeEquipmentDefault = !e.makeEquipmentDefault;
        };
      }
    }), J$(e$.prototype, "clearErrors", [f.action], Object.getOwnPropertyDescriptor(e$.prototype, "clearErrors"), e$.prototype), J$(e$.prototype, "validate", [f.action], Object.getOwnPropertyDescriptor(e$.prototype, "validate"), e$.prototype), J$(e$.prototype, "prepareNewApplicatorForm", [f.action], Object.getOwnPropertyDescriptor(e$.prototype, "prepareNewApplicatorForm"), e$.prototype), J$(e$.prototype, "prepareExistingApplicatorForm", [f.action], Object.getOwnPropertyDescriptor(e$.prototype, "prepareExistingApplicatorForm"), e$.prototype), B$ = J$(e$.prototype, "toggleTankCleaned", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          (0, e.props.toggleTankCleaned)(e.applicator);
        };
      }
    }), e$);

    function Q$(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $$(n.key), n);
      }
    }

    function $$(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function X$(e, t, r) {
      return t = Z$(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Z$(e).constructor) : t.apply(e, r));
    }

    function Z$(e) {
      return (Z$ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function eX(e, t) {
      return (eX = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var tX,
        rX,
        nX,
        oX,
        iX,
        aX,
        cX,
        uX = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = X$(this, t, [e])).apiContactsPath = e || "/if2/api/contacts", r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && eX(e, t);
      }(t, My), r = t, (n = [{
        key: "apiContactPath",
        value: function (e) {
          return "".concat(this.apiContactsPath, "/").concat(e);
        }
      }, {
        key: "create",
        value: function (e, t, r) {
          return this.jsonFetch(this.apiContactsPath, "POST", {
            contact: e,
            account_id: t,
            account_contact: r
          });
        }
      }, {
        key: "update",
        value: function (e, t) {
          return this.jsonFetch(this.apiContactPath(e), "PATCH", {
            contact: t
          });
        }
      }, {
        key: "fetch",
        value: function (e) {
          return this.jsonFetch(this.apiContactPath(e));
        }
      }]) && Q$(r.prototype, n), o && Q$(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function lX(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function sX(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? lX(Object(r), !0).forEach(function (t) {
          pX(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : lX(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function pX(e, t, r) {
      return (t = bX(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function fX(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function dX(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bX(n.key), n);
      }
    }

    function bX(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function yX(e, t, r) {
      return t = mX(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], mX(e).constructor) : t.apply(e, r));
    }

    function mX(e) {
      return (mX = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function vX(e, t) {
      return (vX = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function hX(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var gX = Object(d.observer)((nX = hX((rX = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = yX(this, t, [e])).modalId = "licensed-applicator-editor-modal", fX(r, "applicator", nX, r), fX(r, "onSelectorChange", oX, r), fX(r, "setApplicator", iX, r), fX(r, "onSaveApplicator", aX, r), fX(r, "edit", cX, r);
        var n = r.props,
            o = n.tractors,
            i = n.sprayers,
            a = n.spreaders,
            c = n.t;
        return r.sprayRecordsApi = e.sprayRecordsApi || new Gy(), r.contactsApi = e.contactsApi || new uX(), r.applicatorEditorModalModel = new Y$({
          id: r.modalId,
          applicator: r.applicator,
          tractors: o,
          sprayers: i,
          spreaders: a,
          showEquipmentSelectors: !1,
          onSave: r.onSaveApplicator,
          requiresLicenseNumber: !0,
          t: c
        }), r.applicatorEditorModalModel.prepareExistingApplicatorForm({
          showRemoveBtn: !1
        }), r.isNew && (r.applicatorEditorModalModel.showMakeDefaultContact = !1), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && vX(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "isNew",
        get: function () {
          return !this.props.sprayRecordSerial;
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = this,
              t = this.props,
              r = t.selectorId,
              n = t.sprayRecordId;
          v()("#".concat(r)).on("change", this.onSelectorChange);
          var o = v()("#".concat(r)).val();
          if (o) return this.isNew ? this.fetchContact(o) : this.sprayRecordsApi.fetchLicensedApplicator(n).then(function (t) {
            if (t.licensed_applicator && t.licensed_applicator.id === o) return e.setApplicator(t.licensed_applicator);
            throw Error("Licensed applicator not found");
          }).catch(console.error);
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          var e = this.props.selectorId;
          v()("#".concat(e)).off("change", this.onSelectorChange);
        }
      }, {
        key: "fetchContact",
        value: function (e) {
          var t = this;
          return this.contactsApi.fetch(e).then(function (e) {
            return t.setApplicator(e.contact), t.applicatorEditorModalModel.resetFormData(t.applicator);
          }).catch(console.error);
        }
      }, {
        key: "showModal",
        value: function () {
          this.applicatorEditorModalModel.resetFormData(this.applicator), v()("#".concat(this.modalId)).modal("show");
        }
      }, {
        key: "render",
        value: function () {
          return p.a.createElement("div", {
            className: "licensed-applicator-editor"
          }, p.a.createElement(gd, {
            model: this.applicatorEditorModalModel
          }), p.a.createElement("a", {
            href: "#",
            onClick: this.edit,
            "aria-label": "Edit Link"
          }, p.a.createElement("i", {
            className: "fa fa-edit edit-link"
          })));
        }
      }]) && dX(r.prototype, n), o && dX(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "applicator", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new w.SprayRecordApplicator();
      }
    }), hX(rX.prototype, "isNew", [f.computed], Object.getOwnPropertyDescriptor(rX.prototype, "isNew"), rX.prototype), hX(rX.prototype, "fetchContact", [f.action], Object.getOwnPropertyDescriptor(rX.prototype, "fetchContact"), rX.prototype), oX = hX(rX.prototype, "onSelectorChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = t.target.value;
          return r ? (e.applicatorEditorModalModel.prepareExistingApplicatorForm({
            showRemoveBtn: !1
          }), e.fetchContact(r)) : (e.applicator = new w.SprayRecordApplicator(), void e.applicatorEditorModalModel.prepareNewApplicatorForm());
        };
      }
    }), iX = hX(rX.prototype, "setApplicator", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.applicator = new w.SprayRecordApplicator({
            contact: t
          }), e.applicator;
        };
      }
    }), aX = hX(rX.prototype, "onSaveApplicator", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = e.props.sprayRecordId,
              o = r.makeContactDefault;
          return e.isSaving = !0, e.isNew ? e.contactsApi.update(t.contact.id, sX(sX({}, e.applicator.contact.toJS()), {}, {
            email: t.email,
            phone: t.phone,
            address: t.address
          })) : e.sprayRecordsApi.updateLicensedApplicator(n, {
            licensed_applicator: sX(sX({}, t.contact.toJS()), {}, {
              phone: t.phone,
              email: t.email,
              address: t.address
            }),
            make_default: o
          }).then(function (t) {
            return e.setApplicator(t.licensed_applicator), e.isSaving = !1, t.licensed_applicator;
          }).catch(function (t) {
            e.isSaving = !1, console.error(t), window.alert("Error saving changes to licensed applicator");
          });
        };
      }
    }), cX = hX(rX.prototype, "edit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.preventDefault(), e.showModal();
        };
      }
    }), tX = rX)) || tX,
        wX = Object(g.a)()(gX);

    function OX(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, jX(n.key), n);
      }
    }

    function jX(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function PX(e, t, r) {
      return t = _X(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], _X(e).constructor) : t.apply(e, r));
    }

    function _X(e) {
      return (_X = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function EX(e, t) {
      return (EX = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var SX,
        CX = function (e) {
      var t;
      return Object(d.observer)(((t = function (t) {
        function r(e) {
          var t;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r), (t = PX(this, r, [e])).handleToggleExpand = function (e) {
            t.treeModel.toggleExpanded(e);
          };
          var n = e.roots,
              o = e.readOnlyAncestors,
              i = e.accountsPath;
          return t.accountsApi = new N(i), t.accountsStore = new Tt(t.accountsApi, new qt()), t.treeModel = new as(t.accountsStore), t.treeModel.setRoots(n.map(function (e) {
            return t.accountsStore.push(e);
          }), o.map(function (e) {
            return t.accountsStore.push(e);
          })), t.treeModel.sortRoots(), t;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && EX(e, t);
        }(r, s["Component"]), n = r, (o = [{
          key: "render",
          value: function () {
            return p.a.createElement(e, Object.assign({
              handleToggleExpand: this.handleToggleExpand,
              treeModel: this.treeModel
            }, this.props));
          }
        }]) && OX(n.prototype, o), i && OX(n, i), Object.defineProperty(n, "prototype", {
          writable: !1
        }), n;
        var n, o, i;
      }()).defaultProps = {
        roots: [],
        readOnlyAncestors: [],
        includeAccountTypeBadges: !1
      }, t));
    };

    function kX(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, RX(n.key), n);
      }
    }

    function RX(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function TX(e, t, r) {
      return t = zX(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], zX(e).constructor) : t.apply(e, r));
    }

    function zX(e) {
      return (zX = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function NX(e, t) {
      return (NX = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var DX,
        xX,
        AX,
        MX = Object(d.observer)(SX = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = TX(this, t, [].concat(n))).handleClickName = function (t) {
          var r = e.props.treeModel;
          window.location.assign(r.accountsStore.urlFor(t));
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && NX(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "componentDidMount",
        value: function () {
          var e = this.props.treeModel,
              t = "".concat(window.location.pathname, ":expandedAccounts"),
              r = JSON.parse(sessionStorage.getItem(t)) || [];
          e.openAccounts(r), this.disposeLocalStoreCache = Object(f.autorun)(function () {
            sessionStorage.setItem(t, JSON.stringify(e.expanded));
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.disposeLocalStoreCache();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.handleToggleExpand,
              r = e.treeModel,
              n = e.includeAccountTypeBadges;
          return p.a.createElement(fl, {
            items: r.roots,
            model: r,
            ControlsComponent: Al,
            ContentComponent: n ? Ps(r) : Cl(r),
            actions: {
              handleToggleExpand: t,
              handleClickNodeContent: this.handleClickName
            }
          });
        }
      }]) && kX(r.prototype, n), o && kX(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || SX,
        IX = CX(MX);

    function FX(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, BX(n.key), n);
      }
    }

    function BX(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function LX(e, t, r) {
      return t = VX(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], VX(e).constructor) : t.apply(e, r));
    }

    function VX(e) {
      return (VX = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function UX(e, t) {
      return (UX = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var qX = Object(d.observer)((AX = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((xX = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = LX(this, t, [].concat(n)), "onClickIngredient", AX, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && UX(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && FX(e.prototype, t), r && FX(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.activeIngredients,
              n = t.aiButtons,
              o = t.t;
          return p.a.createElement("div", {
            className: "active-ingredients-table"
          }, p.a.createElement("table", null, p.a.createElement("tbody", null, p.a.createElement("tr", null, p.a.createElement("th", null, o("cas_number")), p.a.createElement("th", null, o("name")), p.a.createElement("th", null, o("liquid_concentration")), p.a.createElement("th", null, o("mode_of_action")), p.a.createElement("th", null, o("limited_by_espp"), p.a.createElement("i", {
            className: "fas fa-question-circle info",
            title: o("use_may_be_limited_under_the_epa")
          })), p.a.createElement("th", {
            "aria-label": "buttons"
          })), r.map(function (t) {
            return p.a.createElement("tr", {
              key: t.id
            }, p.a.createElement("td", {
              className: "ai-cas"
            }, t.cas), p.a.createElement("td", {
              className: "ai-name"
            }, p.a.createElement("a", {
              className: "ai-link",
              href: "#",
              onClick: e.onClickIngredient(t)
            }, "" === t.shortName ? t.name : "".concat(t.shortName, " (").concat(t.name, ")"))), p.a.createElement("td", null, t.liquidConcentration), p.a.createElement("td", {
              className: "ai-moa"
            }, t.modesOfAction.map(function (e) {
              return p.a.createElement(h.ModeOfActionTag, {
                modeOfAction: e,
                key: e.groupNumber
              });
            })), p.a.createElement("td", null, t.limitedByEspp ? p.a.createElement("i", {
              className: "fas fa-check"
            }) : null), p.a.createElement("td", null, n(t, e.props)));
          }))));
        }
      }]);
    }()).prototype, "onClickIngredient", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function (r) {
            var n = e.props.onClickIngredient;
            r.preventDefault(), n(t);
          };
        };
      }
    }), DX = xX)) || DX,
        KX = Object(g.a)()(qX);

    function GX(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, WX(n.key), n);
      }
    }

    function WX(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var HX,
        JX,
        YX,
        QX,
        $X,
        XX,
        ZX,
        eZ,
        tZ,
        rZ,
        nZ,
        oZ = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.apiPath = "/if2/api/active_ingredients/", this.epaSubstancePath = "https://cdxnodengn.epa.gov/cdx-srs-rest/substance", this.aiPath = "".concat(t, "/") || !1;
      }, (t = [{
        key: "csrf",
        value: function () {
          return document.querySelector("[name='csrf-token']").content;
        }
      }, {
        key: "create",
        value: function (e) {
          var t = this.csrf();
          return fetch(this.apiPath, {
            method: "POST",
            headers: {
              "X-CSRF-Token": t,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              active_ingredient: e
            })
          }).then(function (e) {
            return e.json();
          }).then(function (e) {
            return "success" === e.status ? e.active_ingredient : Promise.reject(new Error("Failed to create active ingredient: ".concat((e.errors || []).join("\n\t"))));
          });
        }
      }, {
        key: "findAll",
        value: function () {
          return fetch(this.apiPath).then(function (e) {
            return e.json();
          });
        }
      }, {
        key: "findByCAS",
        value: function (e) {
          var t = this;
          return fetch("".concat(this.epaSubstancePath, "/cas/").concat(encodeURIComponent(e))).then(function (e) {
            return e.json();
          }).then(function (e) {
            return e.map(function (e) {
              return t.fromSrsSubstance(e);
            });
          });
        }
      }, {
        key: "findByName",
        value: function (e) {
          var t = this;
          return fetch("".concat(this.epaSubstancePath, "/name/").concat(encodeURIComponent(e))).then(function (e) {
            return e.json();
          }).then(function (e) {
            return e.map(function (e) {
              return t.fromSrsSubstance(e);
            });
          });
        }
      }, {
        key: "fromSrsSubstance",
        value: function (e) {
          return {
            id: kj()(),
            name: e.epaName,
            cas: e.currentCasNumber,
            alternateNames: ee((e.synonyms || []).map(function (e) {
              return e.synonymName;
            }))
          };
        }
      }]) && GX(e.prototype, t), r && GX(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }(),
        iZ = ["alternateNames", "modesOfAction"],
        aZ = ["alternateNames", "name", "id"];

    function cZ(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function uZ(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? cZ(Object(r), !0).forEach(function (t) {
          lZ(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : cZ(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function lZ(e, t, r) {
      return (t = dZ(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function sZ(e, t) {
      if (null == e) return {};

      var r,
          n,
          o = function (e, t) {
        if (null == e) return {};
        var r = {};

        for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
          if (t.includes(n)) continue;
          r[n] = e[n];
        }

        return r;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }

      return o;
    }

    function pZ(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function fZ(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, dZ(n.key), n);
      }
    }

    function dZ(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function bZ(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var yZ,
        mZ,
        vZ,
        hZ = (JX = bZ((HX = function () {
      return function (e, t, r) {
        return t && fZ(e.prototype, t), r && fZ(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(function e(t) {
        var r = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.api = void 0, pZ(this, "searchTerm", JX, this), pZ(this, "status", YX, this), pZ(this, "currentIndex", QX, this), pZ(this, "pageSize", $X, this), pZ(this, "activeIngredients", XX, this), this.create = function (e) {
          var t = e.alternateNames,
              n = (e.modesOfAction, sZ(e, iZ));
          return r.api.create(uZ(uZ({}, n), {}, {
            alternate_names: t
          })).then(function (e) {
            return r.push(e);
          });
        }, pZ(this, "changePageSize", ZX, this), pZ(this, "pageBack", eZ, this), pZ(this, "pageForward", tZ, this), pZ(this, "filterActiveIngredients", rZ, this), pZ(this, "searchEPA", nZ, this), this.api = t;
      }, [{
        key: "aiPath",
        get: function () {
          return this.api.aiPath;
        }
      }, {
        key: "numResults",
        get: function () {
          return (this.searchTerm ? this.filteredAIs : this.activeIngredients).length;
        }
      }, {
        key: "endIndex",
        get: function () {
          return Math.min(this.currentIndex + this.pageSize, this.numResults);
        }
      }, {
        key: "filteredAIs",
        get: function () {
          var e = this;
          return this.searchTerm ? this.activeIngredients.filter(function (t) {
            return t.fullText.includes(e.searchTerm);
          }).sort(h.sortByName) : [];
        }
      }, {
        key: "pagedAIs",
        get: function () {
          return (this.searchTerm ? this.filteredAIs : this.activeIngredients.concat().sort(h.sortByName)).slice(this.currentIndex, this.endIndex);
        }
      }, {
        key: "find",
        value: function (e) {
          return this.activeIngredients.find(function (t) {
            return t.id === e;
          });
        }
      }, {
        key: "findByCAS",
        value: function (e) {
          if (e) return this.activeIngredients.find(function (t) {
            return t.cas === e;
          });
        }
      }, {
        key: "isCASNumber",
        value: function (e) {
          return /[0-9-]+/.test(e);
        }
      }, {
        key: "mergeAI",
        value: function (e, t) {
          var r = t.alternateNames,
              n = (t.name, t.id),
              o = sZ(t, aZ);
          return uZ(uZ(uZ({
            id: n
          }, e), o), {}, {
            alternateNames: ee((e.alternateNames || []).concat(r || []).concat(e.name === t.name ? [] : t.name || []))
          });
        }
      }, {
        key: "fetchAll",
        value: function () {
          var e = this;
          return this.status = "pending", this.api.findAll().then(function (t) {
            return Object(f.runInAction)(function () {
              return e.status = "ready", t.map(function (t) {
                return e.push(t);
              });
            });
          }).catch(function () {
            return Object(f.runInAction)(function () {
              return e.status = "ready", [];
            });
          });
        }
      }, {
        key: "push",
        value: function (e) {
          var t = this.find(e.id);
          return t ? t.update(e) : (t = new w.ActiveIngredient(e), this.activeIngredients.push(t)), t;
        }
      }]);
    }()).prototype, "searchTerm", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), YX = bZ(HX.prototype, "status", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "ready";
      }
    }), QX = bZ(HX.prototype, "currentIndex", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), $X = bZ(HX.prototype, "pageSize", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 25;
      }
    }), XX = bZ(HX.prototype, "activeIngredients", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), bZ(HX.prototype, "aiPath", [f.computed], Object.getOwnPropertyDescriptor(HX.prototype, "aiPath"), HX.prototype), bZ(HX.prototype, "numResults", [f.computed], Object.getOwnPropertyDescriptor(HX.prototype, "numResults"), HX.prototype), bZ(HX.prototype, "endIndex", [f.computed], Object.getOwnPropertyDescriptor(HX.prototype, "endIndex"), HX.prototype), bZ(HX.prototype, "filteredAIs", [f.computed], Object.getOwnPropertyDescriptor(HX.prototype, "filteredAIs"), HX.prototype), bZ(HX.prototype, "pagedAIs", [f.computed], Object.getOwnPropertyDescriptor(HX.prototype, "pagedAIs"), HX.prototype), ZX = bZ(HX.prototype, "changePageSize", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = Number(t);
          if (r < 1) return e.currentIndex = 0, void (e.pageSize = 0);
          e.pageSize = r;
        };
      }
    }), eZ = bZ(HX.prototype, "pageBack", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.currentIndex - e.pageSize;
          e.numResults < 1 || t < 0 ? e.currentIndex = 0 : e.currentIndex = t;
        };
      }
    }), tZ = bZ(HX.prototype, "pageForward", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.endIndex >= e.numResults || (e.currentIndex = e.endIndex);
        };
      }
    }), rZ = bZ(HX.prototype, "filterActiveIngredients", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.searchTerm = t.toLowerCase(), e.currentIndex = 0;
        };
      }
    }), nZ = bZ(HX.prototype, "searchEPA", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return t ? (e.status = "pending", (e.isCASNumber(t) ? e.api.findByCAS(t) : e.api.findByName(t)).then(function (t) {
            return t.map(function (t) {
              return e.push(e.mergeAI(e.findByCAS(t.cas) || {}, t));
            });
          }).then(function (t) {
            return Object(f.runInAction)(function () {
              return e.status = "ready", t;
            });
          }).catch(function () {
            return Object(f.runInAction)(function () {
              return e.status = "ready", [];
            });
          })) : Promise.resolve([]);
        };
      }
    }), bZ(HX.prototype, "fetchAll", [f.action], Object.getOwnPropertyDescriptor(HX.prototype, "fetchAll"), HX.prototype), bZ(HX.prototype, "push", [f.action], Object.getOwnPropertyDescriptor(HX.prototype, "push"), HX.prototype), HX);

    function gZ(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, wZ(n.key), n);
      }
    }

    function wZ(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function OZ(e, t, r) {
      return t = jZ(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], jZ(e).constructor) : t.apply(e, r));
    }

    function jZ(e) {
      return (jZ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function PZ(e, t) {
      return (PZ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function _Z(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    v()(document).off(".data-api");
    var EZ,
        SZ = Object(d.observer)((_Z((mZ = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = OZ(this, t, [].concat(n)), "changePageSize", vZ, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && PZ(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "firstIndex",
        get: function () {
          var e = this.props,
              t = e.pageSize,
              r = e.numResults,
              n = e.currentIndex;
          return r > 0 && t > 0 ? n + 1 : 0;
        }
      }, {
        key: "componentDidMount",
        value: function () {
          v()(function () {
            v()('[data-toggle="tooltip"]').tooltip();
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.lastIndex,
              r = e.numResults,
              n = e.pageSize,
              o = e.onPageBack,
              i = e.onPageForward;
          return s.createElement("div", {
            className: "paging-nav"
          }, s.createElement("div", {
            className: "input-group-prepend"
          }, s.createElement("button", {
            className: "btn btn-outline-secondary",
            type: "button",
            disabled: this.firstIndex <= 1,
            onClick: o
          }, s.createElement("i", {
            className: "fas fa-chevron-left"
          })), s.createElement("span", {
            className: "input-group-text bg-transparent",
            "data-toggle": "tooltip",
            "data-original-title": "Results currently displayed on this page"
          }, "".concat(this.firstIndex, " - ").concat(t, " of ").concat(r))), s.createElement("input", {
            className: "form-control",
            type: "number",
            min: "1",
            max: "500",
            "data-original-title": "Max number of results to show per page",
            "data-toggle": "tooltip",
            value: n,
            onChange: this.changePageSize
          }), s.createElement("div", {
            className: "input-group-append"
          }, s.createElement("button", {
            className: "btn btn-outline-secondary",
            type: "button",
            disabled: t >= r,
            onClick: i
          }, s.createElement("i", {
            className: "fas fa-chevron-right"
          }))));
        }
      }]) && gZ(r.prototype, n), o && gZ(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "firstIndex", [f.computed], Object.getOwnPropertyDescriptor(mZ.prototype, "firstIndex"), mZ.prototype), vZ = _Z(mZ.prototype, "changePageSize", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          (0, e.props.onChangePageSize)(t.target.value);
        };
      }
    }), yZ = mZ)) || yZ;

    function CZ(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, kZ(n.key), n);
      }
    }

    function kZ(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function RZ(e, t, r) {
      return t = TZ(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], TZ(e).constructor) : t.apply(e, r));
    }

    function TZ(e) {
      return (TZ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function zZ(e, t) {
      return (zZ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var NZ,
        DZ = Object(d.observer)(EZ = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = RZ(this, t, [e])).aiStore = void 0, r.getActiveIngredientPath = function (e) {
          return "".concat(r.aiStore.aiPath).concat(e, "/");
        }, r.filterActiveIngredients = function (e) {
          return r.aiStore.filterActiveIngredients(e.target.value);
        }, r.onClickIngredient = function (e) {
          window.location.assign(r.getActiveIngredientPath(e.id));
        };
        var n = e.activeIngredientsPath;
        return r.activeIngredientsApi = new oZ(n), r.aiStore = new hZ(r.activeIngredientsApi), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && zZ(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && CZ(e.prototype, t), r && CZ(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "componentDidMount",
        value: function () {
          this.aiStore.fetchAll();
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props.t;
          return s.createElement(s.Fragment, null, s.createElement("div", {
            className: "form-row align-items-center"
          }, s.createElement("div", {
            className: "col"
          }, s.createElement(h.SearchBar, {
            placeholder: t("search_active_ingredients"),
            onSearch: this.filterActiveIngredients
          })), s.createElement("div", {
            className: "col-auto ml-auto"
          }, s.createElement(SZ, {
            currentIndex: this.aiStore.currentIndex,
            lastIndex: this.aiStore.endIndex,
            numResults: this.aiStore.numResults,
            pageSize: this.aiStore.pageSize,
            onChangePageSize: this.aiStore.changePageSize,
            onPageBack: this.aiStore.pageBack,
            onPageForward: this.aiStore.pageForward
          }))), "pending" === this.aiStore.status ? s.createElement("div", {
            className: "large-spinner py-4"
          }, s.createElement(h.Spinner, null)) : s.createElement(KX, {
            activeIngredients: this.aiStore.pagedAIs,
            onClickIngredient: this.onClickIngredient,
            aiButtons: function (r) {
              return s.createElement("div", {
                className: "text-nowrap"
              }, s.createElement("a", {
                role: "button",
                className: "btn btn-outline-success btn-sm mr-1",
                href: "".concat(e.getActiveIngredientPath(r.id), "edit")
              }, t("edit")), s.createElement("a", {
                role: "button",
                className: "btn btn-outline-danger btn-sm",
                "data-confirm": t("confirm_delete_ai", {
                  ai: r.name
                }),
                "data-method": "delete",
                href: e.getActiveIngredientPath(r.id)
              }, t("delete")));
            }
          }));
        }
      }]);
    }()) || EZ,
        xZ = Object(g.a)()(DZ);

    function AZ(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, MZ(n.key), n);
      }
    }

    function MZ(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function IZ(e, t, r) {
      return t = FZ(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], FZ(e).constructor) : t.apply(e, r));
    }

    function FZ(e) {
      return (FZ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function BZ(e, t) {
      return (BZ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var LZ,
        VZ,
        UZ,
        qZ,
        KZ,
        GZ,
        WZ,
        HZ,
        JZ,
        YZ = Object(d.observer)(NZ = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), IZ(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && BZ(e, t);
      }(t, p.a.Component), r = t, (n = [{
        key: "componentDidMount",
        value: function () {
          var e = this.props,
              t = e.productsStore,
              r = e.defaultValue;
          t.filterProducts(r);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.onSearch,
              r = e.placeholder,
              n = e.defaultValue;
          return p.a.createElement("div", {
            className: "search-bar"
          }, p.a.createElement("div", {
            className: "input-group-prepend"
          }, p.a.createElement("span", {
            className: "input-group-text"
          }, p.a.createElement("i", {
            className: "fas fa-search"
          }))), p.a.createElement("input", {
            type: "search",
            autoComplete: "off",
            autoCorrect: "off",
            autoCapitalize: "off",
            spellCheck: "false",
            onChange: t,
            placeholder: r,
            defaultValue: n
          }));
        }
      }]) && AZ(r.prototype, n), o && AZ(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || NZ;

    function QZ() {
      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      QZ = function () {
        return t;
      };

      var e,
          t = {},
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = Object.defineProperty || function (e, t, r) {
        e[t] = r.value;
      },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          u = i.toStringTag || "@@toStringTag";

      function l(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        l({}, "");
      } catch (e) {
        l = function (e, t, r) {
          return e[t] = r;
        };
      }

      function s(e, t, r, n) {
        var i = t && t.prototype instanceof v ? t : v,
            a = Object.create(i.prototype),
            c = new T(n || []);
        return o(a, "_invoke", {
          value: S(e, r, c)
        }), a;
      }

      function p(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      t.wrap = s;
      var f = "suspendedStart",
          d = "suspendedYield",
          b = "executing",
          y = "completed",
          m = {};

      function v() {}

      function h() {}

      function g() {}

      var w = {};
      l(w, a, function () {
        return this;
      });
      var O = Object.getPrototypeOf,
          j = O && O(O(z([])));
      j && j !== r && n.call(j, a) && (w = j);
      var P = g.prototype = v.prototype = Object.create(w);

      function _(e) {
        ["next", "throw", "return"].forEach(function (t) {
          l(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function E(e, t) {
        function r(o, i, a, c) {
          var u = p(e[o], e, i);

          if ("throw" !== u.type) {
            var l = u.arg,
                s = l.value;
            return s && "object" == typeof s && n.call(s, "__await") ? t.resolve(s.__await).then(function (e) {
              r("next", e, a, c);
            }, function (e) {
              r("throw", e, a, c);
            }) : t.resolve(s).then(function (e) {
              l.value = e, a(l);
            }, function (e) {
              return r("throw", e, a, c);
            });
          }

          c(u.arg);
        }

        var i;
        o(this, "_invoke", {
          value: function (e, n) {
            function o() {
              return new t(function (t, o) {
                r(e, n, t, o);
              });
            }

            return i = i ? i.then(o, o) : o();
          }
        });
      }

      function S(t, r, n) {
        var o = f;
        return function (i, a) {
          if (o === b) throw Error("Generator is already running");

          if (o === y) {
            if ("throw" === i) throw a;
            return {
              value: e,
              done: !0
            };
          }

          for (n.method = i, n.arg = a;;) {
            var c = n.delegate;

            if (c) {
              var u = C(c, n);

              if (u) {
                if (u === m) continue;
                return u;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (o === f) throw o = y, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            o = b;
            var l = p(t, r, n);

            if ("normal" === l.type) {
              if (o = n.done ? y : d, l.arg === m) continue;
              return {
                value: l.arg,
                done: n.done
              };
            }

            "throw" === l.type && (o = y, n.method = "throw", n.arg = l.arg);
          }
        };
      }

      function C(t, r) {
        var n = r.method,
            o = t.iterator[n];
        if (o === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, C(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), m;
        var i = p(o, t.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, m;
        var a = i.arg;
        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, m) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m);
      }

      function k(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function R(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function T(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(k, this), this.reset(!0);
      }

      function z(t) {
        if (t || "" === t) {
          var r = t[a];
          if (r) return r.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var o = -1,
                i = function r() {
              for (; ++o < t.length;) if (n.call(t, o)) return r.value = t[o], r.done = !1, r;

              return r.value = e, r.done = !0, r;
            };

            return i.next = i;
          }
        }

        throw new TypeError(typeof t + " is not iterable");
      }

      return h.prototype = g, o(P, "constructor", {
        value: g,
        configurable: !0
      }), o(g, "constructor", {
        value: h,
        configurable: !0
      }), h.displayName = l(g, u, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === h || "GeneratorFunction" === (t.displayName || t.name));
      }, t.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, l(e, u, "GeneratorFunction")), e.prototype = Object.create(P), e;
      }, t.awrap = function (e) {
        return {
          __await: e
        };
      }, _(E.prototype), l(E.prototype, c, function () {
        return this;
      }), t.AsyncIterator = E, t.async = function (e, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new E(s(e, r, n, o), i);
        return t.isGeneratorFunction(r) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, _(P), l(P, u, "Generator"), l(P, a, function () {
        return this;
      }), l(P, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (e) {
        var t = Object(e),
            r = [];

        for (var n in t) r.push(n);

        return r.reverse(), function e() {
          for (; r.length;) {
            var n = r.pop();
            if (n in t) return e.value = n, e.done = !1, e;
          }

          return e.done = !0, e;
        };
      }, t.values = z, T.prototype = {
        constructor: T,
        reset: function (t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(R), !t) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
        },
        stop: function () {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function (t) {
          if (this.done) throw t;
          var r = this;

          function o(n, o) {
            return c.type = "throw", c.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
                c = a.completion;
            if ("root" === a.tryLoc) return o("end");

            if (a.tryLoc <= this.prev) {
              var u = n.call(a, "catchLoc"),
                  l = n.call(a, "finallyLoc");

              if (u && l) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!l) throw Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function (e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(a);
        },
        complete: function (e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
        },
        finish: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), R(r), m;
          }
        },
        catch: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                R(r);
              }

              return o;
            }
          }

          throw Error("illegal catch attempt");
        },
        delegateYield: function (t, r, n) {
          return this.delegate = {
            iterator: z(t),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = e), m;
        }
      }, t;
    }

    function $Z(e, t, r, n, o, i, a) {
      try {
        var c = e[i](a),
            u = c.value;
      } catch (e) {
        return void r(e);
      }

      c.done ? t(u) : Promise.resolve(u).then(n, o);
    }

    function XZ(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function ZZ(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, e0(n.key), n);
      }
    }

    function e0(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function t0(e, t, r) {
      return t = r0(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], r0(e).constructor) : t.apply(e, r));
    }

    function r0(e) {
      return (r0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function n0(e, t) {
      return (n0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function o0(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var i0,
        a0,
        c0 = Object(d.observer)((UZ = o0((VZ = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = t0(this, t, [e])).productsStore = void 0, r.aiStore = void 0, XZ(r, "searchText", UZ, r), r.fetchAll = function (e) {
          var t = (e || {}).offset;
          return r.productsStore.fetchAll({
            only: ["account", "active_ingredients", "alternate_names", "epa_number", "formulation", "id", "inactive", "manufacturer", "name", "organic", "organic_listings", "product_type", "registration_number", "serial", "type", "nutrientAnalysis"],
            filter: r.filter,
            limit: r.productsStore.pageSize,
            offset: t,
            search: r.searchText,
            meta: !0
          });
        }, r.getProductPath = function (e) {
          var t = r.props.productsPath;
          return "".concat(t, "/").concat(e).concat(r.searchText && "?search=".concat(encodeURIComponent(r.searchText)));
        }, r.getActiveIngredientPath = function (e) {
          return "".concat(r.aiStore.aiPath).concat(e);
        }, XZ(r, "updateSearchText", qZ, r), XZ(r, "onClickIngredient", KZ, r), XZ(r, "onClickProduct", GZ, r), XZ(r, "onPageSizeChange", WZ, r), XZ(r, "onShowInactiveChange", HZ, r), XZ(r, "onSearch", JZ, r);
        var n = e.activeIngredientsPath;
        return r.productsStore = new pn(new $r(e.apiPath), {
          useNewModels: !0
        }), r.aiStore = new hZ(new oZ(n)), e.search && (r.searchText = e.search), r._debouncedFetchAll = Km()(r.fetchAll, 500), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && n0(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && ZZ(e.prototype, t), r && ZZ(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "throttledProgress",
        get: function () {
          return this.productsStore.loadingProgress - this.productsStore.loadingProgress % 20;
        }
      }, {
        key: "filter",
        get: function () {
          var e;
          return this.productsStore.showInactive || (e = {
            inactive: !1
          }), e;
        }
      }, {
        key: "componentDidMount",
        value: function () {
          this.fetchAll({
            offset: this.productsStore.currentIndex
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.t,
              n = t.canClickIngredients;
          return s.createElement(s.Fragment, null, s.createElement("div", {
            className: "form-row align-items-center"
          }, s.createElement("div", {
            className: "col"
          }, s.createElement(YZ, {
            placeholder: r("search_products"),
            defaultValue: this.searchText,
            productsStore: this.productsStore,
            onSearch: this.onSearch
          })), s.createElement("div", {
            className: "col-auto ml-auto"
          }, s.createElement(SZ, {
            currentIndex: this.productsStore.productIndex,
            lastIndex: this.productsStore.endIndex,
            numResults: this.productsStore.totalResults,
            pageSize: this.productsStore.pageSize,
            onChangePageSize: this.onPageSizeChange,
            onPageBack: this.productsStore.pageBack,
            onPageForward: this.productsStore.pageForward
          }))), s.createElement("div", {
            className: "form-row"
          }, this.productsStore.isLoading ? s.createElement("div", {
            className: "col-auto"
          }, r("loading_products")) : null, s.createElement("div", {
            className: "col"
          }, this.productsStore.isLoading ? s.createElement("div", {
            className: "progress w-100"
          }, s.createElement("div", {
            className: "progress-bar bg-primary",
            role: "progressbar",
            style: {
              width: "".concat(this.throttledProgress, "%")
            }
          }, "".concat(this.productsStore.loadingProgress, "%"))) : null), s.createElement("div", {
            className: "col-auto"
          }, s.createElement("div", {
            className: "form-check text-right"
          }, s.createElement(oj.a, {
            className: "mr-1 align-middle form-check-input",
            isChecked: this.productsStore.showInactive,
            onChange: this.onShowInactiveChange
          }), s.createElement("label", {
            className: "form-check-label"
          }, r("show_inactive_products"))))), "pending" === this.productsStore.status ? s.createElement("div", {
            className: "large-spinner py-4"
          }, s.createElement(h.Spinner, null)) : s.createElement(h.ProductsTable, {
            products: this.productsStore.visibleSortedProducts,
            productButtons: function (t) {
              return s.createElement(s.Fragment, null, s.createElement("a", {
                role: "button",
                className: "btn btn-outline-primary btn-sm mr-1",
                href: "".concat(e.getProductPath(t.serial))
              }, r("view")));
            },
            onClickIngredient: n ? this.onClickIngredient : null,
            onClickProduct: this.onClickProduct
          }));
        }
      }]);
    }()).prototype, "searchText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), o0(VZ.prototype, "throttledProgress", [f.computed], Object.getOwnPropertyDescriptor(VZ.prototype, "throttledProgress"), VZ.prototype), o0(VZ.prototype, "filter", [f.computed], Object.getOwnPropertyDescriptor(VZ.prototype, "filter"), VZ.prototype), qZ = o0(VZ.prototype, "updateSearchText", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.searchText = t;
        };
      }
    }), KZ = o0(VZ.prototype, "onClickIngredient", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          location.assign("".concat(e.getActiveIngredientPath(t.id), "/edit"));
        };
      }
    }), GZ = o0(VZ.prototype, "onClickProduct", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          location.assign(e.getProductPath(t.serial));
        };
      }
    }), WZ = o0(VZ.prototype, "onPageSizeChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.productsStore.changePageSize(t), e._debouncedFetchAll();
        };
      }
    }), HZ = o0(VZ.prototype, "onShowInactiveChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t,
              r = (t = QZ().mark(function t(r) {
            return QZ().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return e.productsStore.showInactive = r, t.next = 3, e.fetchAll();

                case 3:
                case "end":
                  return t.stop();
              }
            }, t);
          }), function () {
            var e = this,
                r = arguments;
            return new Promise(function (n, o) {
              var i = t.apply(e, r);

              function a(e) {
                $Z(i, n, o, a, c, "next", e);
              }

              function c(e) {
                $Z(i, n, o, a, c, "throw", e);
              }

              a(void 0);
            });
          });
          return function (e) {
            return r.apply(this, arguments);
          };
        }();
      }
    }), JZ = o0(VZ.prototype, "onSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.updateSearchText(t.target.value), e._debouncedFetchAll(), e.productsStore.filterProducts(t.target.value);
        };
      }
    }), LZ = VZ)) || LZ,
        u0 = Object(g.a)()(c0),
        l0 = r(206),
        s0 = r.n(l0),
        p0 = r(207),
        f0 = r.n(p0);

    function d0(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, b0(n.key), n);
      }
    }

    function b0(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function y0(e, t, r) {
      return t = m0(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], m0(e).constructor) : t.apply(e, r));
    }

    function m0(e) {
      return (m0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function v0(e, t) {
      return (v0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var h0,
        g0 = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((a0 = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), y0(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && v0(e, t);
      }(t, p.a.Component), r = t, (n = [{
        key: "_content",
        get: function () {
          return this.props.content;
        }
      }, {
        key: "render",
        value: function () {
          return p.a.createElement(s0.a, {
            remarkPlugins: [f0.a]
          }, this._content);
        }
      }]) && d0(r.prototype, n), o && d0(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "_content", [f.computed], Object.getOwnPropertyDescriptor(a0.prototype, "_content"), a0.prototype), i0 = a0)) || i0;

    function w0(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, O0(n.key), n);
      }
    }

    function O0(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function j0(e, t, r) {
      return t = P0(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], P0(e).constructor) : t.apply(e, r));
    }

    function P0(e) {
      return (P0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function _0(e, t) {
      return (_0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var E0,
        S0 = Object(d.observer)(h0 = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = j0(this, t, [].concat(n))).handleSelection = function (t) {
          var r = e.props.navItems.find(function (e) {
            return e.id === t;
          });
          r && r.url && location.assign(r.url);
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && _0(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.currentSelection,
              r = e.navItems,
              n = e.title;
          return p.a.createElement(h.NavigationSideBar, {
            title: n,
            navItems: r,
            currentSelection: t,
            includeIcons: !0,
            onSelectItem: this.handleSelection
          });
        }
      }]) && w0(r.prototype, n), o && w0(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || h0;

    function C0(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, k0(n.key), n);
      }
    }

    function k0(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function R0(e, t, r) {
      return t = T0(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], T0(e).constructor) : t.apply(e, r));
    }

    function T0(e) {
      return (T0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function z0(e, t) {
      return (z0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var N0,
        D0,
        x0,
        A0,
        M0,
        I0,
        F0,
        B0,
        L0 = Object(d.observer)(E0 = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), R0(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && z0(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && C0(e.prototype, t), r && C0(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.model,
              r = e.t;
          return p.a.createElement("div", {
            className: "form-grid-input"
          }, p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col-sm-6"
          }, p.a.createElement("div", {
            className: "form-check"
          }, p.a.createElement("input", {
            className: "form-check-input",
            type: "radio",
            name: t.submissionSourceName,
            value: "url",
            checked: "url" === t.source,
            onChange: function () {
              return t.setSource("url");
            }
          }), p.a.createElement("label", {
            className: "form-check-label"
          }, "URL")), p.a.createElement("input", {
            placeholder: t.urlPlaceholder || r("".concat(t.title, "_url")),
            type: "url",
            name: t.submissionUrlName,
            id: t.submissionUrlId,
            value: t.url,
            onChange: t.onChangeUrl,
            disabled: "url" !== t.source
          })), p.a.createElement("div", {
            className: "col-sm-6"
          }, p.a.createElement("div", {
            className: "form-check"
          }, p.a.createElement("input", {
            className: "form-check-input",
            type: "radio",
            name: t.submissionSourceName,
            value: "attachment",
            checked: "attachment" === t.source,
            onChange: function () {
              return t.setSource("attachment");
            }
          }), p.a.createElement("label", {
            className: "form-check-label"
          }, "File", p.a.createElement("em", {
            className: "ml-1"
          }, t.filename))), p.a.createElement("input", {
            type: "file",
            name: t.submissionFilename,
            id: t.submissionFilenameId,
            disabled: "attachment" !== t.source
          }))));
        }
      }]);
    }()) || E0,
        V0 = Object(g.a)()(L0);

    function U0(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function q0(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, K0(n.key), n);
      }
    }

    function K0(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function G0(e, t, r) {
      return t = W0(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], W0(e).constructor) : t.apply(e, r));
    }

    function W0(e) {
      return (W0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function H0(e, t) {
      return (H0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function J0(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Y0 = (D0 = J0((N0 = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), U0(r = G0(this, t, [e]), "title", D0, r), U0(r, "source", x0, r), U0(r, "url", A0, r), U0(r, "filename", M0, r), r.submissionSourceName = "", r.submissionUrlName = "", r.submissionFilename = "", U0(r, "setSource", I0, r), U0(r, "onChangeUrl", F0, r), U0(r, "onChangeTitle", B0, r), r.id = r.props.id || Object(td.v4)(), r.serial = r.props.serial, r.submissionSourceName = r.props.submissionSourceName, r.submissionUrlName = r.props.submissionUrlName, r.submissionFilename = r.props.submissionFilename, r.title = r.props.title || "", r.source = r.props.source || "", r.url = r.props.url || "", r.filename = r.props.filename || "", r.urlPlaceholder = r.props.urlPlaceholder, r.submissionUrlId = "".concat(r.title, "_url_").concat(r.id), r.submissionFilenameId = "".concat(r.title, "_file_").concat(r.id), r.filename ? (r.setSource("attachment"), r.url = "") : r.setSource("url"), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && H0(e, t);
      }(t, h["ViewModel"]), r = t, o = [{
        key: "fromModel",
        value: function (e) {
          return new this(e);
        }
      }, {
        key: "fromAttachment",
        value: function (e) {
          return new this(e);
        }
      }], (n = null) && q0(r.prototype, n), o && q0(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "title", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), x0 = J0(N0.prototype, "source", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), A0 = J0(N0.prototype, "url", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), M0 = J0(N0.prototype, "filename", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), I0 = J0(N0.prototype, "setSource", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.source = t;
        };
      }
    }), F0 = J0(N0.prototype, "onChangeUrl", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.url = t.target.value;
        };
      }
    }), B0 = J0(N0.prototype, "onChangeTitle", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.title = t.target.value;
        };
      }
    }), N0);

    function Q0(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $0(n.key), n);
      }
    }

    function $0(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function X0(e, t, r) {
      return t = Z0(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Z0(e).constructor) : t.apply(e, r));
    }

    function Z0(e) {
      return (Z0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function e1(e, t) {
      return (e1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var t1 = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = X0(this, t, [e])).sprayRecordsStore = void 0;
        var n = e.filename,
            o = e.url;
        return r.labelUrlOrFileModel = new Y0({
          title: "certificate",
          submissionSourceName: "product_organic_listing[certificate_source]",
          submissionUrlName: "product_organic_listing[certificate_url]",
          submissionFilename: "product_organic_listing[certificate_file]",
          filename: n
        }), r.labelUrlOrFileModel.url = !n && o || "", r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && e1(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props.label;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("label", null, e), p.a.createElement(V0, {
            model: this.labelUrlOrFileModel
          }));
        }
      }]) && Q0(r.prototype, n), o && Q0(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function r1(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function n1(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, i1(n.key), n);
      }
    }

    function o1(e, t, r) {
      return t && n1(e.prototype, t), r && n1(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function i1(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var a1,
        c1,
        u1,
        l1,
        s1,
        p1,
        f1,
        d1,
        b1 = function () {
      return o1(function e(t) {
        r1(this, e), this.raw = void 0, this.s = "", this.consumed = 0, this.raw = t;
        var r = t.match(/^[0-1][0-9]/);
        return r ? (this.s = r[0], void (this.consumed = r[0].length)) : (r = t.match(/^2[0-4]/)) ? (this.s = r[0], void (this.consumed = r[0].length)) : void ((r = t.match(/^[0-9]/)) && (this.s = "0".concat(r[0]), this.consumed = r[0].length));
      }, [{
        key: "isPM",
        value: function () {
          return "" !== this.s && "24" !== this.s && Number(this.s) > 11;
        }
      }, {
        key: "meridiem",
        value: function () {
          return this.isPM() ? "PM" : "AM";
        }
      }, {
        key: "as12H",
        value: function () {
          return "00" === this.s ? "12" : Number(this.s) > 12 ? "".concat(Number(this.s) - 12) : "".concat(Number(this.s));
        }
      }]);
    }(),
        y1 = o1(function e(t) {
      r1(this, e), this.raw = void 0, this.s = "", this.consumed = 0, this.raw = t;
      var r = t.match(/^1[0-2]/);
      if (r) return this.s = r[0], void (this.consumed = r[0].length);
      (r = t.match(/^[1-9]/)) && (this.s = r[0], this.consumed = r[0].length);
    }),
        m1 = o1(function e(t) {
      r1(this, e), this.raw = void 0, this.s = "", this.consumed = 0, this.raw = t;
      var r = t.match(/^[0-5][0-9]/);
      if (r) return this.s = r[0], void (this.consumed = r[0].length);
      (r = t.match(/^[0-5]/)) && (this.s = "".concat(r[0], "0"), this.consumed = r[0].length);
    }),
        v1 = function () {
      return o1(function e(t) {
        r1(this, e), this.raw = void 0, this.s = "", this.raw = t, "" !== t && (this.isSpaceSeparated(t.trim()) || (this.isColonSeparated(t) ? this.parseColonSeparated(t) : this.parseNoColon(t)));
      }, [{
        key: "isColonSeparated",
        value: function (e) {
          return e.split(":").length > 1;
        }
      }, {
        key: "isSpaceSeparated",
        value: function (e) {
          return e.split(/\s+/).length > 1;
        }
      }, {
        key: "parseColonSeparated",
        value: function (e) {
          var t,
              r,
              n = e.split(":");

          if (!(n.length < 1 || n[1].length > 2 || "" === (t = new b1(n[0])).s)) {
            var o = t.meridiem();
            r = new m1(n[1] || ""), this.s = "".concat(t.as12H(), ":").concat(r.s || "00", " ").concat(o);
          }
        }
      }, {
        key: "parseNoColon",
        value: function (e) {
          var t = new b1(e);

          if ("" !== t.s) {
            var r = t.meridiem(),
                n = new m1(e.slice(t.consumed));
            this.s = "".concat(t.as12H(), ":").concat(n.s || "00", " ").concat(r);
          }
        }
      }]);
    }(),
        h1 = o1(function e(t) {
      r1(this, e), this.raw = void 0, this.s = "", this.raw = t, "" !== t.trim() && (this.s = t.trim().toUpperCase().replace(/\./g, ""), "P" !== this.s ? "A" !== this.s ? "AM" !== this.s && "PM" !== this.s && (this.s = "") : this.s = "AM" : this.s = "PM");
    }),
        g1 = function () {
      return o1(function e(t) {
        r1(this, e), this.raw = void 0, this.s = "", this.raw = t, "" !== t && (this.isColonSeparated(t) ? this.parseColonSeparated(t) : this.parse(t));
      }, [{
        key: "isColonSeparated",
        value: function (e) {
          return e.split(":").length > 1;
        }
      }, {
        key: "parse",
        value: function (e) {
          var t = new y1(e);

          if ("" !== t.s) {
            var r,
                n = new m1(e.slice(t.consumed));
            "" !== (r = "" === n.s ? new h1(e.slice(t.consumed)) : new h1(e.slice(t.consumed + n.consumed))).s && (this.s = "".concat(t.s, ":").concat(n.s || "00", " ").concat(r.s));
          }
        }
      }, {
        key: "parseColonSeparated",
        value: function (e) {
          var t = e.split(":");

          if (!(t.length < 1)) {
            var r = new y1(t[0]);

            if ("" !== r.s) {
              var n = new m1(t[1]);

              if ("" !== n.s) {
                var o = new h1(t[1].slice(n.consumed));
                "" !== o.s && (this.s = "".concat(r.s, ":").concat(n.s || "00", " ").concat(o.s));
              }
            }
          }
        }
      }]);
    }(),
        w1 = o1(function e(t) {
      r1(this, e), this.raw = void 0, this.s = "", this.raw = t;
      var r = new g1(t);
      "" === r.s ? (r = new v1(t), this.s = r.s) : this.s = r.s;
    }),
        O1 = function () {
      return o1(function e() {
        r1(this, e);
      }, [{
        key: "parse",
        value: function (e) {
          return new w1(e);
        }
      }]);
    }();

    function j1(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function P1(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _1(n.key), n);
      }
    }

    function _1(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function E1(e, t, r) {
      return t = S1(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], S1(e).constructor) : t.apply(e, r));
    }

    function S1(e) {
      return (S1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function C1(e, t) {
      return (C1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function k1(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var R1,
        T1,
        z1,
        N1,
        D1,
        x1,
        A1,
        M1 = Object(d.observer)((u1 = k1((c1 = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = E1(this, t, [e])).parser = void 0, j1(r, "isFocused", u1, r), j1(r, "onFocus", l1, r), j1(r, "onBlur", s1, r), j1(r, "onChange", p1, r), j1(r, "onClickSuggestion", f1, r), j1(r, "onKeyDown", d1, r), r.parser = new O1(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && C1(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && P1(e.prototype, t), r && P1(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "showDropdown",
        get: function () {
          return this.isFocused && this.suggestion;
        }
      }, {
        key: "suggestion",
        get: function () {
          var e = this.props.time;
          return this.parser.parse(e).s || "";
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.time,
              r = e.name,
              n = e.placeholder,
              o = e.containerClassName,
              i = e.inputClassName,
              a = e.tabIndex,
              c = e.tooltipPlacement,
              u = e.title;
          return p.a.createElement("div", {
            className: "time-input".concat(o ? " ".concat(o) : "")
          }, p.a.createElement("div", {
            className: "dropdown".concat(this.showDropdown ? " show" : ""),
            onKeyDown: this.onKeyDown,
            onBlur: this.onBlur,
            onFocus: this.onFocus
          }, p.a.createElement("input", {
            className: "form-control".concat(i ? " ".concat(i) : ""),
            tabIndex: a,
            name: r,
            "data-toggle": "tooltip",
            "data-placement": c,
            "data-original-title": u,
            placeholder: n,
            autoComplete: "off",
            value: t,
            onChange: this.onChange
          }), p.a.createElement("div", {
            className: "dropdown-menu".concat(this.showDropdown ? " show" : "", " w-100")
          }, p.a.createElement("a", {
            className: "dropdown-item active",
            href: "#",
            tabIndex: -1,
            onMouseDown: this.onClickSuggestion,
            onClick: function (e) {
              return e.preventDefault();
            }
          }, this.suggestion))));
        }
      }]);
    }()).prototype, "isFocused", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), k1(c1.prototype, "showDropdown", [f.computed], Object.getOwnPropertyDescriptor(c1.prototype, "showDropdown"), c1.prototype), k1(c1.prototype, "suggestion", [f.computed], Object.getOwnPropertyDescriptor(c1.prototype, "suggestion"), c1.prototype), l1 = k1(c1.prototype, "onFocus", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isFocused = !0;
        };
      }
    }), s1 = k1(c1.prototype, "onBlur", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isFocused = !1;
        };
      }
    }), p1 = k1(c1.prototype, "onChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          (0, e.props.onChange)(t.target.value);
        };
      }
    }), f1 = k1(c1.prototype, "onClickSuggestion", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onChange;
          t.preventDefault(), t.stopPropagation(), r(e.suggestion), e.onBlur();
        };
      }
    }), d1 = k1(c1.prototype, "onKeyDown", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onChange;

          switch (t.key) {
            case "Enter":
              t.preventDefault(), e.onBlur();

            case "Tab":
              r(e.suggestion);
          }
        };
      }
    }), a1 = c1)) || a1,
        I1 = r(14),
        F1 = r.n(I1);

    function B1(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function L1(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, V1(n.key), n);
      }
    }

    function V1(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function U1(e, t, r) {
      return t = q1(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], q1(e).constructor) : t.apply(e, r));
    }

    function q1(e) {
      return (q1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function K1(e, t) {
      return (K1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function G1(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var W1,
        H1,
        J1,
        Y1,
        Q1,
        $1,
        X1,
        Z1,
        e2,
        t2 = Object(d.observer)(((A1 = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return B1(e = U1(this, t, [].concat(n)), "isEditing", z1, e), B1(e, "onBlur", N1, e), B1(e, "onChange", D1, e), B1(e, "onFocus", x1, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && K1(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "value",
        get: function () {
          var e = this.props,
              t = e.value,
              r = e.overrideValue,
              n = e.didOverride ? r : t;

          if (this.isEditing) {
            if (!n && 0 !== n) return "";

            try {
              n = F()(n).scalar;
            } catch (e) {
              if (!(e instanceof F.a.Error)) throw e;
              n = "";
            }
          }

          return n;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.className,
              r = e.placeholder;
          return p.a.createElement("input", {
            className: "overridable-input".concat(t ? " ".concat(t) : ""),
            placeholder: r,
            type: this.isEditing ? "number" : "text",
            value: this.value,
            onChange: this.onChange,
            onFocus: this.onFocus,
            onBlur: this.onBlur
          });
        }
      }]) && L1(r.prototype, n), o && L1(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).defaultProps = {
      onChange: function () {},
      onBlur: function () {},
      onFocus: function () {}
    }, z1 = G1((T1 = A1).prototype, "isEditing", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), G1(T1.prototype, "value", [f.computed], Object.getOwnPropertyDescriptor(T1.prototype, "value"), T1.prototype), N1 = G1(T1.prototype, "onBlur", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onBlur;
          e.isEditing = !1, r(t);
        };
      }
    }), D1 = G1(T1.prototype, "onChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.unit,
              o = r.onChange,
              i = t.target.value;

          if (e.isEditing && "" !== i) {
            var a = Number(i);
            i = Number.isNaN(a) ? "" : a;
          }

          o(i || 0 === i ? "".concat(i, " ").concat(n) : "");
        };
      }
    }), x1 = G1(T1.prototype, "onFocus", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onFocus;
          e.isEditing = !0, r(t);
        };
      }
    }), R1 = T1)) || R1;

    function r2(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function n2(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, o2(n.key), n);
      }
    }

    function o2(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function i2(e, t, r) {
      return t = a2(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], a2(e).constructor) : t.apply(e, r));
    }

    function a2(e) {
      return (a2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function c2(e, t) {
      return (c2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function u2(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var l2,
        s2,
        p2,
        f2,
        d2,
        b2,
        y2,
        m2,
        v2,
        h2,
        g2,
        w2,
        O2,
        j2,
        P2,
        _2,
        E2,
        S2,
        C2,
        k2,
        R2,
        T2 = Object(d.observer)((J1 = u2((H1 = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), r2(r = i2(this, t, [e]), "selector", J1, r), r2(r, "coveragePercentOverride", Y1, r), r2(r, "rowSpacingOverride", Q1, r), r2(r, "weedStripOverride", $1, r), r2(r, "onCalculate", X1, r), r2(r, "onChangeRowSpacing", Z1, r), r2(r, "onChangeWeedStrip", e2, r);
        var n = r.props.t;
        return r.selector = new h.SelectorModel(["weed_spray"].map(function (e) {
          return {
            key: e,
            text: n(e),
            value: e
          };
        })), r.selector.changeByKey("weed_spray"), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && c2(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && n2(e.prototype, t), r && n2(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "rowSpacing",
        get: function () {
          var e,
              t = this.props,
              r = t.fieldCompletion,
              n = t.didOverrideRowSpacing;
          return te(null === (e = r.field) || void 0 === e || null === (e = e.rowSpacing) || void 0 === e ? void 0 : e.displayValue, this.rowSpacingOverride, 0, n);
        }
      }, {
        key: "useWeedSprayCalculator",
        get: function () {
          return this.selector.selectedOption && "weed_spray" === this.selector.selectedOption.key;
        }
      }, {
        key: "weedStrip",
        get: function () {
          var e = this.weedStripOverride;
          return e ? te(e, e, 0) : 0;
        }
      }, {
        key: "calculateWeedStripCoverage",
        value: function () {
          return this.weedStrip && this.rowSpacing ? this.weedStrip / this.rowSpacing : 0;
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t = this.props,
              r = t.fieldCompletion,
              n = t.didOverrideRowSpacing,
              o = t.t;
          return p.a.createElement("div", {
            className: "coverage-calculator"
          }, p.a.createElement(h.SelectDropdown, {
            placeholder: o("calculator_type"),
            options: this.selector.options,
            onChange: this.selector.change,
            model: this.selector
          }), this.useWeedSprayCalculator ? p.a.createElement(p.a.Fragment, null, p.a.createElement("div", {
            className: "row modal-input-row"
          }, p.a.createElement("div", {
            className: "col"
          }, p.a.createElement(t2, {
            className: "form-control",
            placeholder: o("row_spacing"),
            value: (null === (e = r.field) || void 0 === e || null === (e = e.rowSpacing) || void 0 === e ? void 0 : e.displayValue) || "",
            overrideValue: this.rowSpacingOverride,
            didOverride: n,
            unit: "ft",
            onChange: this.onChangeRowSpacing
          })), p.a.createElement("div", {
            className: "col"
          }, p.a.createElement(t2, {
            className: "form-control",
            placeholder: o("weed_strip"),
            value: this.weedStripOverride,
            overrideValue: this.weedStripOverride,
            unit: "ft",
            onChange: this.onChangeWeedStrip
          }))), p.a.createElement("div", {
            className: "row justify-content-end no-gutters mb-3"
          }, p.a.createElement("div", {
            className: "col-lg-6"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-outline-success",
            onClick: this.onCalculate
          }, o("calculate"))))) : null);
        }
      }]);
    }()).prototype, "selector", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Y1 = u2(H1.prototype, "coveragePercentOverride", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Q1 = u2(H1.prototype, "rowSpacingOverride", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), $1 = u2(H1.prototype, "weedStripOverride", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), u2(H1.prototype, "rowSpacing", [f.computed], Object.getOwnPropertyDescriptor(H1.prototype, "rowSpacing"), H1.prototype), u2(H1.prototype, "useWeedSprayCalculator", [f.computed], Object.getOwnPropertyDescriptor(H1.prototype, "useWeedSprayCalculator"), H1.prototype), u2(H1.prototype, "weedStrip", [f.computed], Object.getOwnPropertyDescriptor(H1.prototype, "weedStrip"), H1.prototype), X1 = u2(H1.prototype, "onCalculate", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          (0, e.props.onCalculate)(e.calculateWeedStripCoverage());
        };
      }
    }), Z1 = u2(H1.prototype, "onChangeRowSpacing", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onDidOverrideRowSpacing;
          e.rowSpacingOverride = t, r();
        };
      }
    }), e2 = u2(H1.prototype, "onChangeWeedStrip", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.weedStripOverride = t;
        };
      }
    }), W1 = H1)) || W1,
        z2 = Object(g.a)()(T2);

    function N2(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function D2(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, x2(n.key), n);
      }
    }

    function x2(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function A2(e, t, r) {
      return t = M2(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], M2(e).constructor) : t.apply(e, r));
    }

    function M2(e) {
      return (M2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function I2(e, t) {
      return (I2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function F2(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var B2,
        L2,
        V2,
        U2,
        q2 = Object(d.observer)((p2 = F2((s2 = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return N2(e = A2(this, t, [].concat(n)), "acresCompletedOverride", p2, e), N2(e, "acresCoveredOverride", f2, e), N2(e, "coveragePercentageOverride", d2, e), N2(e, "percentageCompletedOverride", b2, e), N2(e, "didOverrideAcresCompleted", y2, e), N2(e, "didOverrideAcresCovered", m2, e), N2(e, "didOverrideCoveragePercentage", v2, e), N2(e, "didOverridePercentageCompleted", h2, e), N2(e, "didOverrideRowSpacing", g2, e), N2(e, "showCoverageCalculator", w2, e), N2(e, "onChangeAcresCompleted", O2, e), N2(e, "onChangeAcresCovered", j2, e), N2(e, "onChangeCoveragePercentage", P2, e), N2(e, "onChangePercentageCompleted", _2, e), N2(e, "onClose", E2, e), N2(e, "onDidCalculateCoverage", S2, e), N2(e, "onDidOverrideRowSpacing", C2, e), N2(e, "onSave", k2, e), N2(e, "onShowCoverageCalculator", R2, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && I2(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && D2(e.prototype, t), r && D2(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "acresCompleted",
        get: function () {
          var e = this.props.fieldCompletion;
          return F1()(.01 * this.percentageCompleted * (e.field.acres || 0), 2);
        }
      }, {
        key: "acresCovered",
        get: function () {
          var e = this.props.fieldCompletion;
          return F1()((e.field.acres || 0) * this.coveragePercentage * .01, 2);
        }
      }, {
        key: "coveragePercentage",
        get: function () {
          var e = this.props.fieldCompletion;
          return te(e.coveragePercentage, this.coveragePercentageOverride, 100, this.didOverrideCoveragePercentage);
        }
      }, {
        key: "percentageCompleted",
        get: function () {
          var e = this.props.fieldCompletion;
          return te(e.percentage, this.percentageCompletedOverride, 100, this.didOverridePercentageCompleted);
        }
      }, {
        key: "disableOverrides",
        value: function () {
          this.didOverrideAcresCompleted = !1, this.didOverrideAcresCovered = !1, this.didOverrideCoveragePercentage = !1, this.didOverridePercentageCompleted = !1, this.didOverrideRowSpacing = !1;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.id,
              r = e.fieldCompletion,
              n = e.t;
          return p.a.createElement(h.ModalDialog, {
            id: t,
            className: "coverage-completion-modal",
            dismissOnClose: !1
          }, p.a.createElement(h.ModalHeader, {
            title: r.field.name,
            onClose: this.onClose
          }), p.a.createElement(h.ModalBody, null, p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col py-3 px-5"
          }, p.a.createElement("div", {
            className: "partial-coverage mb-5"
          }, p.a.createElement("h5", null, n("partial_coverage_of_plant_or_ground")), p.a.createElement("div", {
            className: "ml-4"
          }, p.a.createElement("p", {
            className: "coverage-example"
          }, n("example_top_50_percent")), p.a.createElement("label", {
            className: "checkbox-input-group"
          }, p.a.createElement(oj.a, {
            className: "mr-1",
            isChecked: this.showCoverageCalculator,
            onChange: this.onShowCoverageCalculator
          }), p.a.createElement("span", null, p.a.createElement("small", null, n("show_calculators")))), this.showCoverageCalculator ? p.a.createElement(z2, {
            fieldCompletion: r,
            didOverrideRowSpacing: this.didOverrideRowSpacing,
            onCalculate: this.onDidCalculateCoverage,
            onDidOverrideRowSpacing: this.onDidOverrideRowSpacing
          }) : null, p.a.createElement("div", {
            className: "row modal-input-row diagonal-input-row"
          }, p.a.createElement("div", {
            className: "col left"
          }, p.a.createElement("div", {
            className: "diagonal-container"
          }, p.a.createElement(t2, {
            className: "form-control",
            placeholder: n("percent_covered"),
            value: r.coveragePercentage || 0 === r.coveragePercentage ? "".concat(r.coveragePercentage, " %") : "100 %",
            overrideValue: this.coveragePercentageOverride,
            didOverride: this.didOverrideCoveragePercentage,
            unit: "%",
            onChange: this.onChangeCoveragePercentage
          }))), p.a.createElement("div", {
            className: "col right"
          }, p.a.createElement("div", {
            className: "diagonal-container"
          }, p.a.createElement(t2, {
            className: "form-control",
            placeholder: n("acres_treated"),
            value: "".concat(this.acresCovered, " acre"),
            overrideValue: this.acresCoveredOverride,
            didOverride: this.didOverrideAcresCovered,
            unit: "acre",
            onChange: this.onChangeAcresCovered
          })))))), p.a.createElement("div", {
            className: "partial-completion"
          }, p.a.createElement("h5", null, n("partial_completion_of_field")), p.a.createElement("div", {
            className: "ml-4"
          }, p.a.createElement("p", null, n(1 === r.field.acres ? "how_much_field_completed.one" : "how_much_field_completed.other", {
            acres: r.field.acres
          })), p.a.createElement("div", {
            className: "row modal-input-row diagonal-input-row mt-2 mb-3"
          }, p.a.createElement("div", {
            className: "col left"
          }, p.a.createElement("div", {
            className: "diagonal-container"
          }, p.a.createElement(t2, {
            className: "form-control",
            placeholder: n("percent_completed"),
            value: r.percentage || 0 === r.percentage ? "".concat(r.percentage, " %") : "100 %",
            overrideValue: this.percentageCompletedOverride,
            didOverride: this.didOverridePercentageCompleted,
            unit: "%",
            onChange: this.onChangePercentageCompleted
          }))), p.a.createElement("div", {
            className: "col right"
          }, p.a.createElement("div", {
            className: "diagonal-container"
          }, p.a.createElement(t2, {
            className: "form-control",
            placeholder: n("acres_completed"),
            value: "".concat(this.acresCompleted, " acre"),
            overrideValue: this.acresCompletedOverride,
            didOverride: this.didOverrideAcresCompleted,
            unit: "acre",
            onChange: this.onChangeAcresCompleted
          })))))), p.a.createElement("div", {
            className: "row justify-content-center no-gutters"
          }, p.a.createElement("div", {
            className: "col-lg-6"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-success",
            onClick: this.onSave
          }, n("save"))))))));
        }
      }]);
    }()).prototype, "acresCompletedOverride", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), f2 = F2(s2.prototype, "acresCoveredOverride", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), d2 = F2(s2.prototype, "coveragePercentageOverride", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "100 %";
      }
    }), b2 = F2(s2.prototype, "percentageCompletedOverride", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "100 %";
      }
    }), y2 = F2(s2.prototype, "didOverrideAcresCompleted", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), m2 = F2(s2.prototype, "didOverrideAcresCovered", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), v2 = F2(s2.prototype, "didOverrideCoveragePercentage", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), h2 = F2(s2.prototype, "didOverridePercentageCompleted", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), g2 = F2(s2.prototype, "didOverrideRowSpacing", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), w2 = F2(s2.prototype, "showCoverageCalculator", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), F2(s2.prototype, "acresCompleted", [f.computed], Object.getOwnPropertyDescriptor(s2.prototype, "acresCompleted"), s2.prototype), F2(s2.prototype, "acresCovered", [f.computed], Object.getOwnPropertyDescriptor(s2.prototype, "acresCovered"), s2.prototype), F2(s2.prototype, "coveragePercentage", [f.computed], Object.getOwnPropertyDescriptor(s2.prototype, "coveragePercentage"), s2.prototype), F2(s2.prototype, "percentageCompleted", [f.computed], Object.getOwnPropertyDescriptor(s2.prototype, "percentageCompleted"), s2.prototype), F2(s2.prototype, "disableOverrides", [f.action], Object.getOwnPropertyDescriptor(s2.prototype, "disableOverrides"), s2.prototype), O2 = F2(s2.prototype, "onChangeAcresCompleted", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.fieldCompletion;
          e.acresCompletedOverride = t, e.didOverrideAcresCompleted = !0;
          var n = te(e.acresCompletedOverride, e.acresCompletedOverride, 0),
              o = r.field.acres ? F1()(n / r.field.acres * 100, 2) : 0;
          e.percentageCompletedOverride = "".concat(o, " %"), e.didOverridePercentageCompleted = !0;
        };
      }
    }), j2 = F2(s2.prototype, "onChangeAcresCovered", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.fieldCompletion;
          e.acresCoveredOverride = t, e.didOverrideAcresCovered = !0;
          var n = te(e.acresCoveredOverride, e.acresCoveredOverride, 0),
              o = r.field.acres ? F1()(n / r.field.acres * 100, 2) : 0;
          e.coveragePercentageOverride = "".concat(o, " %"), e.didOverrideCoveragePercentage = !0;
        };
      }
    }), P2 = F2(s2.prototype, "onChangeCoveragePercentage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.coveragePercentageOverride = t, e.didOverrideCoveragePercentage = !0, e.acresCoveredOverride = "".concat(e.acresCovered, " acre"), e.didOverrideAcresCovered = !0;
        };
      }
    }), _2 = F2(s2.prototype, "onChangePercentageCompleted", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.percentageCompletedOverride = t, e.didOverridePercentageCompleted = !0, e.didOverrideAcresCompleted = !1;
        };
      }
    }), E2 = F2(s2.prototype, "onClose", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.id;
          v()("#".concat(t)).modal("hide"), e.disableOverrides();
        };
      }
    }), S2 = F2(s2.prototype, "onDidCalculateCoverage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.fieldCompletion,
              n = F1()(100 * t, 2);
          e.coveragePercentageOverride = n || 0 === n ? "".concat(n, " %") : "", e.didOverrideCoveragePercentage = !0, e.acresCoveredOverride = "".concat(F1()(t * (r.field.acres || 0), 2), " acre"), e.didOverrideAcresCovered = !0;
        };
      }
    }), C2 = F2(s2.prototype, "onDidOverrideRowSpacing", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.didOverrideRowSpacing = !0;
        };
      }
    }), k2 = F2(s2.prototype, "onSave", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.fieldCompletion;
          (0, t.onSave)({
            field: r.field,
            percentage: te(e.percentageCompleted, e.percentageCompletedOverride, 100, e.didOverridePercentageCompleted),
            coveragePercentage: te(e.coveragePercentage, e.coveragePercentageOverride, 100, e.didOverrideCoveragePercentage),
            acres: te(e.acresCompleted, e.acresCompletedOverride, r.field.acres || 0, e.didOverrideAcresCompleted)
          }), e.onClose();
        };
      }
    }), R2 = F2(s2.prototype, "onShowCoverageCalculator", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.showCoverageCalculator = t;
        };
      }
    }), l2 = s2)) || l2,
        K2 = Object(g.a)()(q2);

    function G2(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function W2(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, H2(n.key), n);
      }
    }

    function H2(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function J2(e, t, r) {
      return t = Y2(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Y2(e).constructor) : t.apply(e, r));
    }

    function Y2(e) {
      return (Y2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Q2(e, t) {
      return (Q2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function $2(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var X2,
        Z2,
        e3 = Object(d.observer)(($2((L2 = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return G2(e = J2(this, t, [].concat(n)), "onBtnClick", V2, e), G2(e, "onToggleCheckbox", U2, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Q2(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "partialCoverage",
        get: function () {
          var e = this.props.fieldCompletion;
          return e && Number(e.coveragePercentage) < 100;
        }
      }, {
        key: "partialCompletion",
        get: function () {
          var e = this.props.fieldCompletion;
          return e && Number(Math.round(e.percentage)) < 100;
        }
      }, {
        key: "fieldCompletionAcres",
        get: function () {
          var e = this.props.fieldCompletion;
          return F1()(e && Number(e.acres), 2) || 0;
        }
      }, {
        key: "isChecked",
        get: function () {
          return null != this.props.fieldCompletion;
        }
      }, {
        key: "displayCoveragePercentage",
        get: function () {
          var e = this.props.fieldCompletion;
          return "".concat(Object(h.truncateZeroes)(e.coveragePercentage), "%");
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.field,
              n = t.fieldCompletion;
          return p.a.createElement("tr", {
            className: "field-completion-row"
          }, p.a.createElement("td", null, p.a.createElement("span", null, p.a.createElement(oj.a, {
            className: "mr-1",
            isChecked: this.isChecked,
            onChange: function (t) {
              return e.onToggleCheckbox(t, r);
            }
          }), r.clientPathFieldName)), p.a.createElement("td", null, p.a.createElement("span", {
            className: this.partialCoverage || this.partialCompletion ? "partial-coverage-completion" : ""
          }, p.a.createElement("button", {
            type: "button",
            className: "field-completion-btn",
            onClick: this.onBtnClick,
            disabled: !n
          }, "".concat(this.fieldCompletionAcres, " acre")), this.partialCompletion ? p.a.createElement($E, {
            percent: n.percentage,
            onClick: this.onBtnClick,
            title: "Partial Completion"
          }) : null, this.partialCoverage ? p.a.createElement(p.a.Fragment, null, p.a.createElement("div", {
            className: "partial-coverage-indicator"
          }), p.a.createElement("div", {
            className: "partial-coverage-percentage"
          }, this.displayCoveragePercentage)) : null)));
        }
      }]) && W2(r.prototype, n), o && W2(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "partialCoverage", [f.computed], Object.getOwnPropertyDescriptor(L2.prototype, "partialCoverage"), L2.prototype), $2(L2.prototype, "partialCompletion", [f.computed], Object.getOwnPropertyDescriptor(L2.prototype, "partialCompletion"), L2.prototype), $2(L2.prototype, "fieldCompletionAcres", [f.computed], Object.getOwnPropertyDescriptor(L2.prototype, "fieldCompletionAcres"), L2.prototype), $2(L2.prototype, "isChecked", [f.computed], Object.getOwnPropertyDescriptor(L2.prototype, "isChecked"), L2.prototype), $2(L2.prototype, "displayCoveragePercentage", [f.computed], Object.getOwnPropertyDescriptor(L2.prototype, "displayCoveragePercentage"), L2.prototype), V2 = $2(L2.prototype, "onBtnClick", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props;
          (0, t.onShowModal)(t.fieldCompletion);
        };
      }
    }), U2 = $2(L2.prototype, "onToggleCheckbox", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r) {
          var n = e.props,
              o = n.onUpdateFieldCompletion,
              i = n.onRemoveFieldCompletion,
              a = n.remainingAcreagePerField,
              c = n.sprayRecord;

          if (t) {
            var u = a[r.id],
                l = u > 0 ? u : 0;
            o({
              field: r,
              percentage: F1()(l / r.acres * 100, 2),
              coveragePercentage: Number(c.targetCoveragePercentage) || 100,
              acres: l
            });
          } else i(r);
        };
      }
    }), B2 = L2)) || B2;

    function t3(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, r3(n.key), n);
      }
    }

    function r3(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function n3(e, t, r) {
      return t = o3(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], o3(e).constructor) : t.apply(e, r));
    }

    function o3(e) {
      return (o3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function i3(e, t) {
      return (i3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var a3,
        c3,
        u3,
        l3,
        s3,
        p3,
        f3 = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((Z2 = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), n3(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && i3(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && t3(e.prototype, t), r && t3(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "totalAcres",
        get: function () {
          var e = this.props.application;
          return "".concat(F1()(e.totalAcresCompleted, 2), " acre");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return p.a.createElement("div", {
            className: "field-completion-total-acres"
          }, p.a.createElement("div", {
            className: "row no-gutters"
          }, p.a.createElement("div", {
            className: "col-sm-4 font-weight-bold text-uppercase"
          }, "".concat(e("total"), ":")), p.a.createElement("div", {
            className: "col-sm-4 text-center text-nowrap"
          }, this.totalAcres), p.a.createElement("div", {
            className: "col-sm-4"
          })));
        }
      }]);
    }()).prototype, "totalAcres", [f.computed], Object.getOwnPropertyDescriptor(Z2.prototype, "totalAcres"), Z2.prototype), X2 = Z2)) || X2,
        d3 = Object(g.a)()(f3);

    function b3(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function y3(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, m3(n.key), n);
      }
    }

    function m3(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function v3(e, t, r) {
      return t = h3(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], h3(e).constructor) : t.apply(e, r));
    }

    function h3(e) {
      return (h3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function g3(e, t) {
      return (g3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function w3(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var O3,
        j3,
        P3,
        _3 = Object(d.observer)((u3 = w3((c3 = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = v3(this, t, [].concat(n))).modalId = "coverage-completion-modal", b3(e, "currentFieldCompletion", u3, e), b3(e, "showCompleted", l3, e), b3(e, "showModal", s3, e), b3(e, "onToggleShowCompleted", p3, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && g3(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && y3(e.prototype, t), r && y3(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "fieldCompletionHash",
        get: function () {
          var e = this.props.application,
              t = {};
          return e.fieldCompletions.forEach(function (e) {
            t[e.field.id] = e;
          }), t;
        }
      }, {
        key: "sortedFields",
        get: function () {
          var e = this,
              t = this.props,
              r = t.fields,
              n = t.remainingAcreagePerField;
          return r.filter(function (t) {
            return e.showCompleted || e.fieldCompletionHash[t.id] || F1()(n[t.id], 2) > 0;
          }).sort(function (e, t) {
            return Object(h.naturalSort)(e.name, t.name);
          });
        }
      }, {
        key: "showCompletedToggle",
        get: function () {
          var e = this.props.t;
          return p.a.createElement("tr", null, p.a.createElement("td", null), p.a.createElement("td", null, p.a.createElement("a", {
            className: "show-completed-toggle ".concat(this.showCompleted ? " is-showing" : " is-hiding"),
            onClick: this.onToggleShowCompleted,
            href: "#"
          }, this.showCompleted ? e("hide_completed_fields") : e("show_completed_fields"))));
        }
      }, {
        key: "renderErrorMessage",
        value: function () {
          var e = this.props.errorMessage;
          if (e) return p.a.createElement("tr", null, p.a.createElement("td", null), p.a.createElement("td", {
            className: "errors"
          }, e));
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.accountId,
              n = t.application,
              o = t.sprayRecord,
              i = t.onUpdateFieldCompletion,
              a = t.onRemoveFieldCompletion,
              c = t.remainingAcreagePerField;
          return p.a.createElement("div", {
            className: "coverage-completion-details"
          }, p.a.createElement(K2, {
            id: this.modalId,
            fieldCompletion: this.currentFieldCompletion,
            onSave: i
          }), p.a.createElement("table", null, p.a.createElement("tbody", null, this.renderErrorMessage(), this.sortedFields.map(function (t) {
            return p.a.createElement(e3, {
              key: t.id,
              accountId: r,
              fieldCompletion: e.fieldCompletionHash[t.id],
              field: t,
              sprayRecord: o,
              remainingAcreagePerField: c,
              onShowModal: e.showModal,
              onUpdateFieldCompletion: i,
              onRemoveFieldCompletion: a
            });
          }), p.a.createElement("tr", null, p.a.createElement("td", null), p.a.createElement("td", null, p.a.createElement(d3, {
            application: n
          }))), this.showCompletedToggle)));
        }
      }]);
    }()).prototype, "currentFieldCompletion", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new w.FieldCompletion();
      }
    }), l3 = w3(c3.prototype, "showCompleted", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), w3(c3.prototype, "fieldCompletionHash", [f.computed], Object.getOwnPropertyDescriptor(c3.prototype, "fieldCompletionHash"), c3.prototype), w3(c3.prototype, "sortedFields", [f.computed], Object.getOwnPropertyDescriptor(c3.prototype, "sortedFields"), c3.prototype), w3(c3.prototype, "showCompletedToggle", [f.computed], Object.getOwnPropertyDescriptor(c3.prototype, "showCompletedToggle"), c3.prototype), s3 = w3(c3.prototype, "showModal", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.currentFieldCompletion = t, v()("#".concat(e.modalId)).modal("show");
        };
      }
    }), p3 = w3(c3.prototype, "onToggleShowCompleted", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.preventDefault(), e.showCompleted = !e.showCompleted;
        };
      }
    }), a3 = c3)) || a3,
        E3 = Object(g.a)()(_3),
        S3 = r(62);

    function C3(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, k3(n.key), n);
      }
    }

    function k3(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function R3(e, t, r) {
      return t = T3(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], T3(e).constructor) : t.apply(e, r));
    }

    function T3(e) {
      return (T3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function z3(e, t) {
      return (z3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function N3(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var D3,
        x3 = Object(d.observer)((N3((j3 = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = R3(this, t, [].concat(n)), "onClick", P3, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && z3(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "tractorName",
        get: function () {
          var e = this.props.item;
          return e.value && e.value.tractor && e.value.tractor.name || "";
        }
      }, {
        key: "sprayerName",
        get: function () {
          var e = this.props.item;
          return e.value && e.value.sprayer && e.value.sprayer.name || "";
        }
      }, {
        key: "spreaderName",
        get: function () {
          var e = this.props.item;
          return e.value && e.value.spreader && e.value.spreader.name || "";
        }
      }, {
        key: "sprayRate",
        get: function () {
          var e = this.props.item;
          return e.value && (e.value.sprayRate || "" !== e.value.sprayRate && 0 === e.value.sprayRate) && e.value.sprayRate || "";
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.item;
          return p.a.createElement("div", {
            className: "applicator-select-item"
          }, p.a.createElement("a", {
            key: e.key,
            href: "#",
            "aria-label": "Applicator",
            className: "list-group-item d-flex justify-content-between align-items-center".concat(e.isSelected ? " selected" : "").concat(e.isActive ? " active" : ""),
            onClick: this.onClick
          }, p.a.createElement("span", null, e.text, p.a.createElement(S3.a, {
            className: "understated ml-2",
            tractor: this.tractorName,
            sprayer: this.sprayerName,
            spreader: this.spreaderName,
            sprayRate: this.sprayRate
          })), p.a.createElement("i", {
            className: "fa fa-edit edit-link"
          })));
        }
      }]) && C3(r.prototype, n), o && C3(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "tractorName", [f.computed], Object.getOwnPropertyDescriptor(j3.prototype, "tractorName"), j3.prototype), N3(j3.prototype, "sprayerName", [f.computed], Object.getOwnPropertyDescriptor(j3.prototype, "sprayerName"), j3.prototype), N3(j3.prototype, "spreaderName", [f.computed], Object.getOwnPropertyDescriptor(j3.prototype, "spreaderName"), j3.prototype), N3(j3.prototype, "sprayRate", [f.computed], Object.getOwnPropertyDescriptor(j3.prototype, "sprayRate"), j3.prototype), P3 = N3(j3.prototype, "onClick", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.onClick,
              o = r.item;
          t.preventDefault(), n(o, t);
        };
      }
    }), O3 = j3)) || O3;

    function A3(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, M3(n.key), n);
      }
    }

    function M3(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function I3(e, t, r) {
      return t = F3(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], F3(e).constructor) : t.apply(e, r));
    }

    function F3(e) {
      return (F3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function B3(e, t) {
      return (B3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var L3,
        V3,
        U3,
        q3 = Object(d.observer)(D3 = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), I3(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && B3(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.items,
              r = e.onClickItem;
          return p.a.createElement("div", {
            className: "applicator-select-list"
          }, p.a.createElement("ul", {
            className: "list-group"
          }, t.map(function (e) {
            return p.a.createElement(x3, {
              key: e.key,
              item: e,
              onClick: r
            });
          })));
        }
      }]) && A3(r.prototype, n), o && A3(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || D3;

    function K3(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, G3(n.key), n);
      }
    }

    function G3(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function W3(e, t, r) {
      return t = H3(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], H3(e).constructor) : t.apply(e, r));
    }

    function H3(e) {
      return (H3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function J3(e, t) {
      return (J3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Y3,
        Q3 = Object(d.observer)((U3 = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((V3 = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = W3(this, t, [].concat(n)), "onClick", U3, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && J3(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props.item;
          return p.a.createElement("div", {
            className: "team-select-item"
          }, p.a.createElement("a", {
            key: e.key,
            href: "#",
            "aria-label": "Team",
            className: "list-group-item".concat(e.isSelected ? " selected" : "").concat(e.isActive ? " active" : ""),
            onClick: this.onClick
          }, e.text, p.a.createElement("span", {
            className: "understated ml-2"
          }, e.value.applicators.map(function (e) {
            return e.name;
          }).join(", "))));
        }
      }]) && K3(r.prototype, n), o && K3(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "onClick", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.onClick,
              o = r.item;
          t.preventDefault(), n(o, t);
        };
      }
    }), L3 = V3)) || L3;

    function $3(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, X3(n.key), n);
      }
    }

    function X3(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Z3(e, t, r) {
      return t = e4(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], e4(e).constructor) : t.apply(e, r));
    }

    function e4(e) {
      return (e4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function t4(e, t) {
      return (t4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var r4,
        n4,
        o4,
        i4,
        a4,
        c4,
        u4,
        l4,
        s4,
        p4,
        f4,
        d4,
        b4,
        y4,
        m4,
        v4,
        h4,
        g4 = Object(d.observer)(Y3 = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Z3(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && t4(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.items,
              r = e.onClickItem;
          return p.a.createElement("div", {
            className: "applicator-select-list"
          }, p.a.createElement("ul", {
            className: "list-group"
          }, ep()(t, function (e) {
            return e.text;
          }).map(function (e) {
            return p.a.createElement(Q3, {
              key: e.key,
              item: e,
              onClick: r
            });
          })));
        }
      }]) && $3(r.prototype, n), o && $3(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || Y3;

    function w4(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function O4(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, j4(n.key), n);
      }
    }

    function j4(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function P4(e, t, r) {
      return t = _4(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], _4(e).constructor) : t.apply(e, r));
    }

    function _4(e) {
      return (_4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function E4(e, t) {
      return (E4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function S4(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var C4,
        k4,
        R4,
        T4,
        z4,
        N4,
        D4,
        x4,
        A4,
        M4 = Object(d.observer)(((h4 = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), w4(r = P4(this, t, [e]), "showDropdown", o4, r), w4(r, "tab", i4, r), w4(r, "searchText", a4, r), w4(r, "applicatorSelection", c4, r), w4(r, "teamSelection", u4, r), w4(r, "addNew", l4, r), w4(r, "close", s4, r), w4(r, "onClickDocument", p4, r), w4(r, "onKeyDown", f4, r), w4(r, "onInputChange", d4, r), w4(r, "onInputFocus", b4, r), w4(r, "onClickApplicator", y4, r), w4(r, "onSelectTeams", m4, r), w4(r, "onClickTeam", v4, r), r.selectorRef = Object(s.createRef)(), r.applicatorOptionsDisposer = Object(f.reaction)(function () {
          return r.applicatorOptions;
        }, function (e) {
          var t = r.applicatorSelection.activeIndex;
          r.applicatorSelection = new eP(e), r.applicatorSelection.selectedKeys = e.filter(function (e) {
            return e.isSelected;
          }).map(function (e) {
            return e.key;
          }), r.applicatorSelection.activeIndex = t;
        }, {
          fireImmediately: !0
        }), r.teamOptionsDisposer = Object(f.reaction)(function () {
          return r.teamOptions;
        }, function (e) {
          var t = r.teamSelection.activeIndex;
          r.teamSelection = new eP(e), r.teamSelection.activeIndex = t;
        }, {
          fireImmediately: !0
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && E4(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && O4(e.prototype, t), r && O4(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "applicatorOptions",
        get: function () {
          var e = this.props,
              t = e.applicatorChoices,
              r = e.applicators,
              n = t.map(function (e) {
            return {
              key: e.contact && e.contact.id || e.name,
              text: e.name,
              value: e
            };
          });
          return n.forEach(function (e) {
            e.isSelected = r.find(function (t) {
              return t.contact.id === e.value.contact.id;
            });
          }), ep()(n, function (e) {
            return e.text;
          });
        }
      }, {
        key: "teamOptions",
        get: function () {
          var e = this.props.teamChoices.map(function (e) {
            var t = [e.name];
            return e.applicators.forEach(function (e) {
              return t.push(e.name);
            }), {
              key: e.id,
              text: e.name,
              searchTokens: t,
              value: e
            };
          });
          return ep()(e, function (e) {
            return e.text;
          });
        }
      }, {
        key: "componentDidMount",
        value: function () {
          document.addEventListener("click", this.onClickDocument);
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          document.removeEventListener("click", this.onClickDocument), this.applicatorOptionsDisposer(), this.teamOptionsDisposer();
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.tabIndex,
              n = t.t;
          return p.a.createElement("div", {
            role: "listbox",
            tabIndex: "-1",
            className: "applicator-selector mb-1",
            onKeyDown: this.onKeyDown,
            ref: this.selectorRef
          }, p.a.createElement("input", {
            type: "search",
            tabIndex: r,
            className: "form-control applicator-selector-input",
            value: this.searchText,
            onChange: this.onInputChange,
            onFocus: this.onInputFocus,
            onClick: this.onInputFocus,
            placeholder: n("select_applicators")
          }), p.a.createElement("div", {
            className: "dropdown-menu card py-0".concat(this.showDropdown ? " show" : ""),
            "aria-label": "Applicators Dropdown"
          }, p.a.createElement("div", {
            className: "card-body"
          }, p.a.createElement("ul", {
            className: "nav nav-fill"
          }, p.a.createElement("li", {
            className: "nav-item"
          }, p.a.createElement("a", {
            className: "nav-link medium-bold".concat("applicators" === this.tab ? " active" : ""),
            href: "#",
            role: "tab",
            onClick: function (t) {
              t.preventDefault(), e.tab = "applicators";
            }
          }, n("applicators"))), p.a.createElement("li", {
            className: "nav-item"
          }, p.a.createElement("a", {
            className: "nav-link medium-bold".concat("teams" === this.tab ? " active" : ""),
            href: "#",
            role: "tab",
            onClick: function (t) {
              t.preventDefault(), e.tab = "teams";
            }
          }, n("teams"))), p.a.createElement("li", {
            className: "nav-item"
          }, p.a.createElement("a", {
            className: "nav-link",
            href: "#",
            role: "tab",
            onClick: this.addNew
          }, p.a.createElement("i", {
            className: "fas fa-plus-circle text-primary"
          }), " ", n("add_new")))), "applicators" === this.tab ? p.a.createElement(q3, {
            items: this.applicatorSelection.filteredOptions,
            onClickItem: this.onClickApplicator
          }) : p.a.createElement(g4, {
            items: this.teamSelection.filteredOptions,
            onClickItem: this.onClickTeam
          }))));
        }
      }]);
    }()).defaultProps = {
      applicators: [],
      applicatorChoices: [],
      onChangeApplicators: function () {}
    }, o4 = S4((n4 = h4).prototype, "showDropdown", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), i4 = S4(n4.prototype, "tab", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "applicators";
      }
    }), a4 = S4(n4.prototype, "searchText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), c4 = S4(n4.prototype, "applicatorSelection", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new eP();
      }
    }), u4 = S4(n4.prototype, "teamSelection", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new eP();
      }
    }), S4(n4.prototype, "applicatorOptions", [f.computed], Object.getOwnPropertyDescriptor(n4.prototype, "applicatorOptions"), n4.prototype), S4(n4.prototype, "teamOptions", [f.computed], Object.getOwnPropertyDescriptor(n4.prototype, "teamOptions"), n4.prototype), l4 = S4(n4.prototype, "addNew", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onAddNew;
          t.preventDefault(), r();
        };
      }
    }), s4 = S4(n4.prototype, "close", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.showDropdown = !1, e.teamSelection.clearSelection();
        };
      }
    }), p4 = S4(n4.prototype, "onClickDocument", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.selectorRef.current.contains(t.target) || e.close();
        };
      }
    }), f4 = S4(n4.prototype, "onKeyDown", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onChangeApplicators,
              n = "applicators" === e.tab ? e.applicatorSelection : e.teamSelection,
              o = "applicators" === e.tab ? r : e.onSelectTeams;
          if ("Tab" === t.key) return e.searchText = "", n.selectActive(), o(n.selectedValues), void e.close();
          if ("ArrowDown" !== t.key) {
            if ("ArrowUp" !== t.key) {
              if ("Enter" === t.key) {
                if (e.searchText = "", n.selectActive(), o(n.selectedValues), t.shiftKey) return void t.preventDefault();
                e.tab = "applicators", e.close();
              }
            } else n.activatePrevious();
          } else n.activateNext();
        };
      }
    }), d4 = S4(n4.prototype, "onInputChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.searchText = t.target.value, e.applicatorSelection.search(t.target.value), e.teamSelection.search(t.target.value);
        };
      }
    }), b4 = S4(n4.prototype, "onInputFocus", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.showDropdown = !0;
        };
      }
    }), y4 = S4(n4.prototype, "onClickApplicator", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r) {
          var n = e.props,
              o = n.onChangeApplicators,
              i = n.onEditApplicator;
          e.applicatorSelection.selectByOption(t), o(e.applicatorSelection.selectedValues), r.target.className.includes("edit-link") && i(t.value), r && r.shiftKey ? r.preventDefault() : e.close();
        };
      }
    }), m4 = S4(n4.prototype, "onSelectTeams", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.onChangeApplicators,
              o = r.applicators,
              i = [];
          o.forEach(function (e) {
            return i.push(e);
          }), t.forEach(function (e) {
            e.applicators.forEach(function (e) {
              var t = i.find(function (t) {
                return t.contact.id === e.contact.id;
              });
              t ? (t.tractor = e.tractor, t.sprayer = e.sprayer, t.spreader = e.spreader) : i.push(e);
            });
          }), n(i);
        };
      }
    }), v4 = S4(n4.prototype, "onClickTeam", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.teamSelection.selectByOption(t), e.onSelectTeams(e.teamSelection.selectedValues), e.close(), e.tab = "applicators";
        };
      }
    }), r4 = n4)) || r4,
        I4 = Object(g.a)()(M4);

    function F4(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function B4(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, L4(n.key), n);
      }
    }

    function L4(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function V4(e, t, r) {
      return t = U4(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], U4(e).constructor) : t.apply(e, r));
    }

    function U4(e) {
      return (U4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function q4(e, t) {
      return (q4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function K4(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var G4,
        W4,
        H4,
        J4,
        Y4,
        Q4,
        $4,
        X4,
        Z4,
        e5,
        t5,
        r5,
        n5,
        o5 = Object(d.observer)(((A4 = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = V4(this, t, [e])).contactSelector = new h.SelectorModel(r.contactOptions), F4(r, "contactOptions", R4, r), F4(r, "useExistingContact", T4, r), F4(r, "onToggle", z4, r), F4(r, "onKeyDown", N4, r), F4(r, "onClose", D4, r), F4(r, "onSave", x4, r), r.contactsDisposer = Object(f.reaction)(function () {
          return r.props.contacts;
        }, function (e) {
          var t = r.contactSelector.selectedOption && r.contactSelector.selectedOption.key;
          r.updateContactOptions(e), r.contactSelector.setOptions(r.contactOptions.slice().sort(function (e, t) {
            return Object(h.naturalSort)(e.text, t.text);
          })), r.contactSelector.changeByKey(t);
        }, {
          fireImmediately: !0
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && q4(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && B4(e.prototype, t), r && B4(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "canSave",
        get: function () {
          return !this.useExistingContact || this.contactSelector.selectedValue;
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.contactsDisposer();
        }
      }, {
        key: "updateContactOption",
        value: function (e) {
          var t = this.contactOptions.find(function (t) {
            return t.key === e.id;
          });
          if (t) t.value.update(e), t.text = t.value.name;else {
            var r = new w.Contact(e);
            this.contactOptions.push({
              key: r.id,
              text: r.name,
              value: r
            });
          }
        }
      }, {
        key: "updateContactOptions",
        value: function (e) {
          var t = this;
          e.forEach(function (e) {
            return t.updateContactOption(e);
          });
        }
      }, {
        key: "close",
        value: function () {
          var e = this.props.id;
          v()("#".concat(e)).modal("hide"), this.onClose();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.id,
              r = e.disableAnimation,
              n = e.t;
          return p.a.createElement(h.ModalDialog, {
            id: t,
            className: "select-contact-modal",
            ariaLabelledBy: "".concat(t, "-header"),
            dismissOnClose: !1,
            disableAnimation: r
          }, p.a.createElement(h.ModalHeader, {
            id: "".concat(t, "-header"),
            title: n("select_contact"),
            onClose: this.onClose
          }), p.a.createElement(h.ModalBody, null, p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col mx-5 py-3 px-5"
          }, p.a.createElement("div", {
            className: "row modal-input-row"
          }, p.a.createElement("div", {
            className: "col text-center"
          }, p.a.createElement("div", {
            className: "btn-group btn-group-toggle w-100",
            "data-toggle": "buttons"
          }, p.a.createElement("label", {
            id: "select-contact-modal-existing-radio-label",
            className: "btn btn-primary".concat(this.useExistingContact ? " active" : ""),
            role: "radio",
            "aria-checked": this.useExistingContact,
            tabIndex: "0",
            onClick: this.onToggle(!0),
            onKeyDown: this.onKeyDown(!0)
          }, p.a.createElement("input", {
            tabIndex: "-1",
            readOnly: !0,
            type: "radio",
            name: "options",
            value: this.useExistingContact,
            checked: this.useExistingContact,
            "aria-labelledby": "select-contact-modal-existing-radio-label"
          }), n("existing")), p.a.createElement("label", {
            id: "select-contact-modal-new-radio-label",
            className: "btn btn-primary".concat(this.useExistingContact ? "" : " active"),
            role: "radio",
            "aria-checked": !this.useExistingContact,
            tabIndex: "0",
            onClick: this.onToggle(!1),
            onKeyDown: this.onKeyDown(!1)
          }, p.a.createElement("input", {
            tabIndex: "-1",
            readOnly: !0,
            type: "radio",
            name: "options",
            value: !this.useExistingContact,
            checked: !this.useExistingContact,
            "aria-labelledby": "select-contact-modal-new-radio-label"
          }), n("new"))))), this.useExistingContact ? p.a.createElement("div", {
            className: "select-contact-modal__dropdown row modal-input-row mt-3"
          }, p.a.createElement("div", {
            className: "col"
          }, p.a.createElement(h.SelectDropdown, {
            inputText: this.contactSelector.searchText,
            placeholder: n("contact"),
            options: this.contactSelector.options,
            onChange: this.contactSelector.change,
            model: this.contactSelector
          }))) : null, p.a.createElement("div", {
            className: "row modal-input-row mt-3"
          }, p.a.createElement("div", {
            className: "col"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-success".concat(this.canSave ? "" : " disabled"),
            disabled: !this.canSave,
            "aria-label": n("ok"),
            onClick: this.onSave
          }, n("ok"))))))));
        }
      }]);
    }()).defaultProps = {
      contacts: [],
      onSave: function () {},
      onClose: function () {}
    }, R4 = K4((k4 = A4).prototype, "contactOptions", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), T4 = K4(k4.prototype, "useExistingContact", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !0;
      }
    }), K4(k4.prototype, "canSave", [f.computed], Object.getOwnPropertyDescriptor(k4.prototype, "canSave"), k4.prototype), K4(k4.prototype, "updateContactOption", [f.action], Object.getOwnPropertyDescriptor(k4.prototype, "updateContactOption"), k4.prototype), K4(k4.prototype, "updateContactOptions", [f.action], Object.getOwnPropertyDescriptor(k4.prototype, "updateContactOptions"), k4.prototype), z4 = K4(k4.prototype, "onToggle", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function () {
            e.useExistingContact = t;
          };
        };
      }
    }), N4 = K4(k4.prototype, "onKeyDown", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function (r) {
            " " !== r.key && "Enter" !== r.key || (e.useExistingContact = t);
          };
        };
      }
    }), D4 = K4(k4.prototype, "onClose", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.onClose;
          e.useExistingContact = !0, e.contactSelector.change(), t();
        };
      }
    }), x4 = K4(k4.prototype, "onSave", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.onSave;
          if (e.useExistingContact) return t(e.contactSelector.selectedValue), void e.close();
          t(new w.Contact()), e.close();
        };
      }
    }), C4 = k4)) || C4,
        i5 = Object(g.a)()(o5),
        a5 = r(208);

    function c5() {
      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      c5 = function () {
        return t;
      };

      var e,
          t = {},
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = Object.defineProperty || function (e, t, r) {
        e[t] = r.value;
      },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          u = i.toStringTag || "@@toStringTag";

      function l(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        l({}, "");
      } catch (e) {
        l = function (e, t, r) {
          return e[t] = r;
        };
      }

      function s(e, t, r, n) {
        var i = t && t.prototype instanceof v ? t : v,
            a = Object.create(i.prototype),
            c = new T(n || []);
        return o(a, "_invoke", {
          value: S(e, r, c)
        }), a;
      }

      function p(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      t.wrap = s;
      var f = "suspendedStart",
          d = "suspendedYield",
          b = "executing",
          y = "completed",
          m = {};

      function v() {}

      function h() {}

      function g() {}

      var w = {};
      l(w, a, function () {
        return this;
      });
      var O = Object.getPrototypeOf,
          j = O && O(O(z([])));
      j && j !== r && n.call(j, a) && (w = j);
      var P = g.prototype = v.prototype = Object.create(w);

      function _(e) {
        ["next", "throw", "return"].forEach(function (t) {
          l(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function E(e, t) {
        function r(o, i, a, c) {
          var u = p(e[o], e, i);

          if ("throw" !== u.type) {
            var l = u.arg,
                s = l.value;
            return s && "object" == typeof s && n.call(s, "__await") ? t.resolve(s.__await).then(function (e) {
              r("next", e, a, c);
            }, function (e) {
              r("throw", e, a, c);
            }) : t.resolve(s).then(function (e) {
              l.value = e, a(l);
            }, function (e) {
              return r("throw", e, a, c);
            });
          }

          c(u.arg);
        }

        var i;
        o(this, "_invoke", {
          value: function (e, n) {
            function o() {
              return new t(function (t, o) {
                r(e, n, t, o);
              });
            }

            return i = i ? i.then(o, o) : o();
          }
        });
      }

      function S(t, r, n) {
        var o = f;
        return function (i, a) {
          if (o === b) throw Error("Generator is already running");

          if (o === y) {
            if ("throw" === i) throw a;
            return {
              value: e,
              done: !0
            };
          }

          for (n.method = i, n.arg = a;;) {
            var c = n.delegate;

            if (c) {
              var u = C(c, n);

              if (u) {
                if (u === m) continue;
                return u;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (o === f) throw o = y, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            o = b;
            var l = p(t, r, n);

            if ("normal" === l.type) {
              if (o = n.done ? y : d, l.arg === m) continue;
              return {
                value: l.arg,
                done: n.done
              };
            }

            "throw" === l.type && (o = y, n.method = "throw", n.arg = l.arg);
          }
        };
      }

      function C(t, r) {
        var n = r.method,
            o = t.iterator[n];
        if (o === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, C(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), m;
        var i = p(o, t.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, m;
        var a = i.arg;
        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, m) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m);
      }

      function k(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function R(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function T(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(k, this), this.reset(!0);
      }

      function z(t) {
        if (t || "" === t) {
          var r = t[a];
          if (r) return r.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var o = -1,
                i = function r() {
              for (; ++o < t.length;) if (n.call(t, o)) return r.value = t[o], r.done = !1, r;

              return r.value = e, r.done = !0, r;
            };

            return i.next = i;
          }
        }

        throw new TypeError(typeof t + " is not iterable");
      }

      return h.prototype = g, o(P, "constructor", {
        value: g,
        configurable: !0
      }), o(g, "constructor", {
        value: h,
        configurable: !0
      }), h.displayName = l(g, u, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === h || "GeneratorFunction" === (t.displayName || t.name));
      }, t.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, l(e, u, "GeneratorFunction")), e.prototype = Object.create(P), e;
      }, t.awrap = function (e) {
        return {
          __await: e
        };
      }, _(E.prototype), l(E.prototype, c, function () {
        return this;
      }), t.AsyncIterator = E, t.async = function (e, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new E(s(e, r, n, o), i);
        return t.isGeneratorFunction(r) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, _(P), l(P, u, "Generator"), l(P, a, function () {
        return this;
      }), l(P, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (e) {
        var t = Object(e),
            r = [];

        for (var n in t) r.push(n);

        return r.reverse(), function e() {
          for (; r.length;) {
            var n = r.pop();
            if (n in t) return e.value = n, e.done = !1, e;
          }

          return e.done = !0, e;
        };
      }, t.values = z, T.prototype = {
        constructor: T,
        reset: function (t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(R), !t) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
        },
        stop: function () {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function (t) {
          if (this.done) throw t;
          var r = this;

          function o(n, o) {
            return c.type = "throw", c.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
                c = a.completion;
            if ("root" === a.tryLoc) return o("end");

            if (a.tryLoc <= this.prev) {
              var u = n.call(a, "catchLoc"),
                  l = n.call(a, "finallyLoc");

              if (u && l) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!l) throw Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function (e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(a);
        },
        complete: function (e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
        },
        finish: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), R(r), m;
          }
        },
        catch: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                R(r);
              }

              return o;
            }
          }

          throw Error("illegal catch attempt");
        },
        delegateYield: function (t, r, n) {
          return this.delegate = {
            iterator: z(t),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = e), m;
        }
      }, t;
    }

    function u5(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function l5(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? u5(Object(r), !0).forEach(function (t) {
          s5(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : u5(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function s5(e, t, r) {
      return (t = y5(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function p5(e, t, r, n, o, i, a) {
      try {
        var c = e[i](a),
            u = c.value;
      } catch (e) {
        return void r(e);
      }

      c.done ? t(u) : Promise.resolve(u).then(n, o);
    }

    function f5(e) {
      return function () {
        var t = this,
            r = arguments;
        return new Promise(function (n, o) {
          var i = e.apply(t, r);

          function a(e) {
            p5(i, n, o, a, c, "next", e);
          }

          function c(e) {
            p5(i, n, o, a, c, "throw", e);
          }

          a(void 0);
        });
      };
    }

    function d5(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function b5(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, y5(n.key), n);
      }
    }

    function y5(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function m5(e, t, r) {
      return t = v5(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], v5(e).constructor) : t.apply(e, r));
    }

    function v5(e) {
      return (v5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function h5(e, t) {
      return (h5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function g5(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var w5,
        O5,
        j5,
        P5 = Object(d.observer)((H4 = g5((W4 = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = m5(this, t, [e])).modalId = "applicator-editor-modal", r.selectContactModalId = "select-contact-modal", d5(r, "applicatorChoices", H4, r), d5(r, "teamChoices", J4, r), d5(r, "selectedApplicator", Y4, r), r._applicatorFromContact = function (e) {
          var t,
              n,
              o,
              i = r.props,
              a = i.sprayers,
              c = i.spreaders,
              u = i.tractors,
              l = new w.Contact(e),
              s = {
            id: Object(td.v4)(),
            contact: l.toJS(),
            tractor: r._findImplement(l.defaultTractor, u) || (null === (t = l.defaultTractor) || void 0 === t ? void 0 : t.toJS()),
            spray_rate: r.sprayRate
          };
          r.applicatorRequiresSprayer && (s.sprayer = r._findImplement(l.defaultSprayer, a) || (null === (n = l.defaultSprayer) || void 0 === n ? void 0 : n.toJS()));
          r.applicatorRequiresSpreader && (s.spreader = r._findImplement(l.defaultSpreader, c) || (null === (o = l.defaultSpreader) || void 0 === o ? void 0 : o.toJS()));
          return new w.SprayRecordApplicator(s);
        }, d5(r, "updateSelectedApplicators", Q4, r), d5(r, "addNewApplicator", $4, r), d5(r, "selectContactForNewApplicator", X4, r), d5(r, "editApplicator", Z4, r), r.onCloseModal = function () {
          r.applicatorEditorModalModel.prepareExistingApplicatorForm();
        }, d5(r, "onNewContact", e5, r), d5(r, "onSaveApplicator", t5, r), d5(r, "onRemoveApplicator", r5, r), d5(r, "toggleTankCleaned", n5, r);
        var n = r.props,
            o = n.teams,
            i = n.tractors,
            a = n.sprayers,
            c = n.spreaders,
            u = n.t;
        return r.teamChoices = o.map(function (e) {
          return new w.Team(e);
        }), r.applicatorChoicesDisposer = Object(f.reaction)(function () {
          return r.props.applicatorContacts;
        }, function (e) {
          r.applicatorChoices = e.map(r._applicatorFromContact);
        }, {
          fireImmediately: !0
        }), r.applicatorEditorModalModel = new Y$({
          id: r.modalId,
          applicator: r.selectedApplicator,
          tractors: i,
          sprayers: a,
          spreaders: c,
          requiresTractor: r.applicatorRequiresTractor,
          requiresSprayer: r.applicatorRequiresSprayer,
          requiresSpreader: r.applicatorRequiresSpreader,
          requiresSprayRate: r.requiresSprayRate,
          onSave: r.onSaveApplicator,
          onRemove: r.onRemoveApplicator,
          onClose: r.onCloseModal,
          toggleTankCleaned: r.toggleTankCleaned,
          t: u
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && h5(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && b5(e.prototype, t), r && b5(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "sprayRate",
        get: function () {
          var e = this.props.sprayRecord;
          return e.targetGallonsPerAcre ? "".concat(e.targetGallonsPerAcre, " gal/acre") : null;
        }
      }, {
        key: "contacts",
        get: function () {
          return this.props.contacts.filter(function (e) {
            return !(e.categories || []).includes("Applicator");
          });
        }
      }, {
        key: "sortedApplicators",
        get: function () {
          var e = this.props.application;
          return Object(x.sortBy)(Object(x.compose)(function (e) {
            return e.toLowerCase();
          }, Object(x.prop)("name")), e.applicators);
        }
      }, {
        key: "requiresSprayRate",
        get: function () {
          var e = this.props.sprayRecord;
          return w.SprayRecord.requiresRate(e.applicationMethod) || w.SprayRecord.requiresTankSize(e.applicationMethod);
        }
      }, {
        key: "applicatorRequiresSprayer",
        get: function () {
          var e = this.props.sprayRecord;
          return w.SprayRecord.requiresSprayer(e.applicationMethod);
        }
      }, {
        key: "applicatorRequiresSpreader",
        get: function () {
          var e = this.props.sprayRecord;
          return w.SprayRecord.requiresSpreader(e.applicationMethod);
        }
      }, {
        key: "applicatorRequiresTractor",
        get: function () {
          var e = this.props.sprayRecord;
          return w.SprayRecord.requiresTractor(e.applicationMethod);
        }
      }, {
        key: "_findImplement",
        value: function (e, t) {
          return t.find(function (t) {
            return t.id === (null == e ? void 0 : e.id);
          });
        }
      }, {
        key: "addApplicator",
        value: (r = f5(c5().mark(function e(t) {
          var r, n, o, i, a, c;
          return c5().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (r = this.props, n = r.application, o = r.onChange, i = r.createApplicator, !(a = this.findApplicatorByContact(t))) {
                  e.next = 5;
                  break;
                }

                return a.update(t.toJS()), e.abrupt("return");

              case 5:
                return e.next = 7, i(t, n);

              case 7:
                if (c = e.sent) {
                  e.next = 10;
                  break;
                }

                return e.abrupt("return");

              case 10:
                n.applicators.push(new w.SprayRecordApplicator(l5({
                  id: Object(td.v4)()
                }, c.toJS()))), o && o();

              case 12:
              case "end":
                return e.stop();
            }
          }, e, this);
        })), function (e) {
          return r.apply(this, arguments);
        })
      }, {
        key: "findApplicatorByContact",
        value: function (e) {
          var t = this.props.application;
          return "" === e.contact.id ? null : t.applicators.find(function (t) {
            return t.contact.id && t.contact.id === e.contact.id;
          });
        }
      }, {
        key: "showModal",
        value: function () {
          this.applicatorEditorModalModel.resetFormData(this.selectedApplicator), this.applicatorEditorModalModel.isNew || this.applicatorEditorModalModel.validate(), v()("#".concat(this.modalId)).modal("show");
        }
      }, {
        key: "showSelectContactModal",
        value: function () {
          v()("#".concat(this.selectContactModalId)).modal("show");
        }
      }, {
        key: "renderErrorMessage",
        value: function () {
          var e = this.props.errorMessage;
          if (e) return p.a.createElement("div", {
            className: "errors"
          }, e);
        }
      }, {
        key: "validateApplicator",
        value: function (e) {
          var t,
              r,
              n = this.props,
              o = n.sprayRecord,
              i = n.t,
              a = [],
              c = new w.Quantity(null === (t = e.sprayer) || void 0 === t ? void 0 : t.tankSize);
          return e.sprayRate || !w.SprayRecord.requiresRate(o.applicationMethod) && !w.SprayRecord.requiresTankSize(o.applicationMethod) ? !w.SprayRecord.requiresTankSize(o.applicationMethod) || null === (r = e.sprayer) || void 0 === r || !r.id || w.Quantity.isQuantityTruthy(c) && c.isCompatible("gal") ? e.warningTranslationKeysGiven(o.applicationMethod).length > 0 && a.push(i("missing_details")) : a.push(i("invalid_tank_size")) : a.push(i("rate_missing")), (w.SprayRecord.requiresRate(o.applicationMethod) && !e.matchesTargetGallonsPerAcre(o.targetGallonsPerAcre) || this.isOutlier(e)) && a.push("*"), a.length ? a.join(" ") : null;
        }
      }, {
        key: "isOutlier",
        value: function (e) {
          var t = this.props.application.sprayRateOutliers,
              r = "empty";
          return e.sprayRate && (r = e.sprayRate.displayValue), t.some(function (e) {
            return e === r;
          });
        }
      }, {
        key: "rateValidationTooltip",
        value: function (e) {
          var t = this.props,
              r = t.sprayRecord,
              n = t.t,
              o = this.isOutlier(e),
              i = [];
          return e.matchesTargetGallonsPerAcre(r.targetGallonsPerAcre) || i.push(n("rate_does_not_match_target", {
            rate: r.targetGallonsPerAcre
          })), o && i.push(n("rate_does_not_match_others")), i.join(". ");
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.application,
              n = t.tabIndex,
              o = t.recordAmountsIn,
              i = t.sprayRecord,
              a = t.disableModalAnimation,
              c = t.testInternalState,
              u = t.t;
          return p.a.createElement("div", {
            className: "applicator-manager mt-3"
          }, (null == c ? void 0 : c({
            applicatorChoices: this.applicatorChoices
          })) || null, this.renderErrorMessage(), p.a.createElement(gd, {
            model: this.applicatorEditorModalModel,
            disableAnimation: a,
            t: u
          }), p.a.createElement(i5, {
            id: this.selectContactModalId,
            contacts: this.contacts,
            disableAnimation: a,
            onSave: this.onNewContact,
            onClose: function () {}
          }), p.a.createElement(I4, {
            applicators: r.applicators,
            applicatorChoices: this.applicatorChoices,
            teamChoices: this.teamChoices,
            tabIndex: n,
            onAddNew: this.selectContactForNewApplicator,
            onChangeApplicators: this.updateSelectedApplicators,
            onEditApplicator: this.editApplicator
          }), this.sortedApplicators.map(function (t) {
            return p.a.createElement(a5.a, {
              key: t.id,
              applicationMethod: null == i ? void 0 : i.applicationMethod,
              applicator: t,
              recordAmountsIn: o,
              validationText: e.validateApplicator(t),
              validationTooltipText: e.rateValidationTooltip(t),
              onEditApplicator: e.editApplicator,
              toggleTankCleaned: e.toggleTankCleaned
            });
          }));
        }
      }]);
      var r;
    }()).prototype, "applicatorChoices", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), J4 = g5(W4.prototype, "teamChoices", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), Y4 = g5(W4.prototype, "selectedApplicator", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new w.SprayRecordApplicator({
          id: Object(td.v4)()
        });
      }
    }), g5(W4.prototype, "contacts", [f.computed], Object.getOwnPropertyDescriptor(W4.prototype, "contacts"), W4.prototype), g5(W4.prototype, "sortedApplicators", [f.computed], Object.getOwnPropertyDescriptor(W4.prototype, "sortedApplicators"), W4.prototype), g5(W4.prototype, "requiresSprayRate", [f.computed], Object.getOwnPropertyDescriptor(W4.prototype, "requiresSprayRate"), W4.prototype), g5(W4.prototype, "applicatorRequiresSprayer", [f.computed], Object.getOwnPropertyDescriptor(W4.prototype, "applicatorRequiresSprayer"), W4.prototype), g5(W4.prototype, "applicatorRequiresSpreader", [f.computed], Object.getOwnPropertyDescriptor(W4.prototype, "applicatorRequiresSpreader"), W4.prototype), g5(W4.prototype, "applicatorRequiresTractor", [f.computed], Object.getOwnPropertyDescriptor(W4.prototype, "applicatorRequiresTractor"), W4.prototype), Q4 = g5(W4.prototype, "updateSelectedApplicators", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.application;
          r.applicators = r.applicators.filter(function (e) {
            return t.find(function (t) {
              return t.contact.id && t.contact.id === e.contact.id;
            });
          }), t.forEach(function (t) {
            r.applicators.find(function (e) {
              return e.contact.id === t.contact.id;
            }) || r.applicators.push(new w.SprayRecordApplicator(l5(l5({
              id: Object(td.v4)()
            }, t.toJS()), {}, {
              spray_rate: e.sprayRate
            })));
          });
        };
      }
    }), $4 = g5(W4.prototype, "addNewApplicator", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.sprayRecord;
          e.selectedApplicator = new w.SprayRecordApplicator({
            id: Object(td.v4)(),
            contact: t,
            spray_rate: r.targetGallonsPerAcre && [].concat(r.targetGallonsPerAcre).concat("gal/acre").join(" ") || void 0
          }), e.applicatorEditorModalModel.prepareNewApplicatorForm(t), e.showModal();
        };
      }
    }), X4 = g5(W4.prototype, "selectContactForNewApplicator", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.showSelectContactModal();
        };
      }
    }), Z4 = g5(W4.prototype, "editApplicator", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.findApplicatorByContact(t);
          r && (e.selectedApplicator = r, e.showModal());
        };
      }
    }), e5 = g5(W4.prototype, "onNewContact", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.addNewApplicator(t);
        };
      }
    }), t5 = g5(W4.prototype, "onSaveApplicator", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = f5(c5().mark(function t(r) {
            var n,
                o,
                i,
                a,
                c,
                u,
                l,
                s = arguments;
            return c5().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  if (n = s.length > 1 && void 0 !== s[1] ? s[1] : {}, o = e.props, i = o.onChange, a = o.contactsApi, c = n.makeContactDefault, u = n.makeEquipmentDefault, !e.findApplicatorByContact(r) && !e.applicatorEditorModalModel.isNew) {
                    t.next = 6;
                    break;
                  }

                  return t.next = 6, e.addApplicator(r);

                case 6:
                  i && (c && a.update({
                    id: r.contact.id,
                    phone: r.phone,
                    email: r.email,
                    address: r.address
                  }), u && (l = {
                    default_tractor_id: r.tractor.serial
                  }, r.sprayer && (l.default_sprayer_id = r.sprayer.serial), r.spreader && (l.default_spreader_id = r.spreader.serial), a.update(r.contact.id, l)), i());

                case 7:
                case "end":
                  return t.stop();
              }
            }, t);
          }));
          return function (e) {
            return t.apply(this, arguments);
          };
        }();
      }
    }), r5 = g5(W4.prototype, "onRemoveApplicator", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.application,
              n = r.applicators.findIndex(function (e) {
            return e.contact.id === t.contact.id;
          });
          r.applicators.splice(n, 1);
        };
      }
    }), n5 = g5(W4.prototype, "toggleTankCleaned", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return function (e) {
          e.tankCleaned = !e.tankCleaned;
        };
      }
    }), G4 = W4)) || G4,
        _5 = Object(g.a)()(P5);

    function E5(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, S5(n.key), n);
      }
    }

    function S5(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function C5(e, t, r) {
      return t = k5(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], k5(e).constructor) : t.apply(e, r));
    }

    function k5(e) {
      return (k5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function R5(e, t) {
      return (R5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function T5(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var z5,
        N5,
        D5,
        x5,
        A5,
        M5,
        I5,
        F5,
        B5,
        L5,
        V5,
        U5,
        q5,
        K5 = Object(d.observer)((T5((O5 = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = C5(this, t, [].concat(n)), "onChangeGallonsAppliedOverride", j5, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && R5(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && E5(e.prototype, t), r && E5(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "percentVariance",
        get: function () {
          var e = this.props,
              t = e.application,
              r = e.sprayRecord;
          return F1()(t.constructor.percentVarianceAcresTreated(t, null == r ? void 0 : r.targetGallonsPerAcre), 2);
        }
      }, {
        key: "percentVarianceClassNames",
        get: function () {
          return ["percent-variance-value"].concat(this.percentVariance < 0 ? "text-danger" : []).join(" ");
        }
      }, {
        key: "inconsistentRatesNote",
        get: function () {
          var e = this.props,
              t = e.application,
              r = e.sprayRecord,
              n = e.t;
          return (t.applicators || []).some(function (e) {
            return !e.matchesTargetGallonsPerAcre(r.targetGallonsPerAcre);
          }) && n("rate_does_not_match_target_messege");
        }
      }, {
        key: "gpasDontMatch",
        get: function () {
          var e = this.props,
              t = e.application,
              r = e.t;
          return t.sprayRateOutliers.length > 0 && r("inconsistent_rates");
        }
      }, {
        key: "predictedAcresNote",
        get: function () {
          var e = this.props,
              t = e.application,
              r = e.sprayRecord,
              n = e.t;
          return this.showPredictedAcresNote && n("prediction_rate_note", {
            rate: t.constructor.predictedAcresRate(t, r.targetGallonsPerAcre),
            rateType: t.constructor.commonGallonsPerAcre(t) ? n("common") : n("target")
          });
        }
      }, {
        key: "notes",
        get: function () {
          return [].concat(this.inconsistentRatesNote || []).concat(this.predictedAcresNote || []).concat(this.gpasDontMatch || []).join(". ");
        }
      }, {
        key: "percentVarianceDisplayValue",
        get: function () {
          return Number.isFinite(this.percentVariance) ? "  ".concat(this.percentVariance, "%") : "";
        }
      }, {
        key: "predictedAcresTreated",
        get: function () {
          var e = this.props,
              t = e.application,
              r = e.sprayRecord;
          return F1()(t.constructor.predictedAcresTreated(t, r.targetGallonsPerAcre), 2);
        }
      }, {
        key: "predictedAcresValidationText",
        get: function () {
          return this.showPredictedAcresNote ? "*" : null;
        }
      }, {
        key: "showPredictedAcresNote",
        get: function () {
          var e = this.props,
              t = e.application,
              r = e.sprayRecord;
          return t.gallonsAppliedOverride && t.constructor.commonGallonsPerAcre(t) !== parseFloat(r.targetGallonsPerAcre);
        }
      }, {
        key: "totalGallonsApplied",
        get: function () {
          var e = this.props.application;
          return F1()(e.totalGallonsApplied, 2);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.application,
              r = e.t;
          return p.a.createElement("div", {
            className: "application-stats"
          }, p.a.createElement("div", {
            className: "row no-gutters align-items-center"
          }, p.a.createElement("div", {
            className: "col-6"
          }, p.a.createElement("div", {
            className: "row no-gutters align-items-center"
          }, p.a.createElement("div", {
            className: "col-md-auto"
          }, r("total_gallons_applied"), p.a.createElement("span", null, ":")), p.a.createElement("div", {
            className: "col total-gallons-applied px-2 py-1"
          }, p.a.createElement("input", {
            "data-testid": "total-gallons-applied",
            type: "number",
            className: "form-control form-control-sm",
            value: t.gallonsAppliedOverride,
            placeholder: this.totalGallonsApplied,
            onChange: this.onChangeGallonsAppliedOverride
          })))), p.a.createElement("div", {
            className: "col"
          }, p.a.createElement("label", null, r("predicted_acres_treated"), p.a.createElement("span", {
            className: "pr-2"
          }, ":"), p.a.createElement("span", {
            "data-testid": "predicted-acres-treated"
          }, this.predictedAcresTreated), p.a.createElement("span", {
            className: "validation-text ml-2",
            "data-testid": "predicted-acres-validation-text",
            "data-original-title": this.predictedAcresNote,
            "data-toggle": "tooltip"
          }, this.predictedAcresValidationText)))), p.a.createElement("div", {
            className: "row no-gutters"
          }, p.a.createElement("div", {
            className: "col-6"
          }, p.a.createElement("label", null, r("treated_acres_selected"), p.a.createElement("span", {
            className: "pr-2"
          }, ":"), p.a.createElement("span", {
            "data-testid": "treated-acres-selected"
          }, t.totalTreatedAcres))), p.a.createElement("div", {
            className: "col"
          }, p.a.createElement("label", null, r("percent_variance"), p.a.createElement("span", {
            className: "pr-2"
          }, ":"), p.a.createElement("span", {
            className: this.percentVarianceClassNames,
            "data-testid": "percent-variance"
          }, this.percentVarianceDisplayValue)))), p.a.createElement("div", {
            className: "row no-gutters my-2"
          }, p.a.createElement("div", {
            className: "col validation-text"
          }, p.a.createElement("span", {
            className: "mr-2"
          }, this.notes ? "*" : null), p.a.createElement("span", {
            "data-testid": "application-stats-notes"
          }, this.notes))));
        }
      }]);
    }()).prototype, "percentVariance", [f.computed], Object.getOwnPropertyDescriptor(O5.prototype, "percentVariance"), O5.prototype), T5(O5.prototype, "percentVarianceClassNames", [f.computed], Object.getOwnPropertyDescriptor(O5.prototype, "percentVarianceClassNames"), O5.prototype), T5(O5.prototype, "inconsistentRatesNote", [f.computed], Object.getOwnPropertyDescriptor(O5.prototype, "inconsistentRatesNote"), O5.prototype), T5(O5.prototype, "gpasDontMatch", [f.computed], Object.getOwnPropertyDescriptor(O5.prototype, "gpasDontMatch"), O5.prototype), T5(O5.prototype, "predictedAcresNote", [f.computed], Object.getOwnPropertyDescriptor(O5.prototype, "predictedAcresNote"), O5.prototype), T5(O5.prototype, "notes", [f.computed], Object.getOwnPropertyDescriptor(O5.prototype, "notes"), O5.prototype), T5(O5.prototype, "percentVarianceDisplayValue", [f.computed], Object.getOwnPropertyDescriptor(O5.prototype, "percentVarianceDisplayValue"), O5.prototype), T5(O5.prototype, "predictedAcresTreated", [f.computed], Object.getOwnPropertyDescriptor(O5.prototype, "predictedAcresTreated"), O5.prototype), T5(O5.prototype, "predictedAcresValidationText", [f.computed], Object.getOwnPropertyDescriptor(O5.prototype, "predictedAcresValidationText"), O5.prototype), T5(O5.prototype, "showPredictedAcresNote", [f.computed], Object.getOwnPropertyDescriptor(O5.prototype, "showPredictedAcresNote"), O5.prototype), T5(O5.prototype, "totalGallonsApplied", [f.computed], Object.getOwnPropertyDescriptor(O5.prototype, "totalGallonsApplied"), O5.prototype), j5 = T5(O5.prototype, "onChangeGallonsAppliedOverride", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.application.update({
            gallons_applied_override: t.target.value
          });
        };
      }
    }), w5 = O5)) || w5,
        G5 = Object(g.a)()(K5);

    function W5(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function H5(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? W5(Object(r), !0).forEach(function (t) {
          J5(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : W5(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function J5(e, t, r) {
      return (t = $5(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Y5(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Q5(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $5(n.key), n);
      }
    }

    function $5(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function X5(e, t, r) {
      return t = Z5(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Z5(e).constructor) : t.apply(e, r));
    }

    function Z5(e) {
      return (Z5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function e6(e, t) {
      return (e6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function t6(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    v()(document).off(".data-api");
    var r6,
        n6,
        o6 = Object(d.observer)((D5 = t6((N5 = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Y5(r = X5(this, t, [e]), "application", D5, r), Y5(r, "errors", x5, r), Y5(r, "submitted", A5, r), Y5(r, "changed", M5, r), Y5(r, "submitting", I5, r), Y5(r, "removeFieldCompletion", F5, r), Y5(r, "updateFieldCompletion", B5, r), Y5(r, "handleSave", L5, r), Y5(r, "cancel", V5, r), Y5(r, "handleChange", U5, r), Y5(r, "updateWindSpeed", q5, r);
        var n = r.props,
            o = n.application,
            i = n.t,
            a = o.toJS();
        return r.originalApplication = H5(H5({}, a), {}, {
          start_time: oe(a.start_time),
          stop_time: oe(a.stop_time)
        }), r.application = new w.SprayRecordApplication(r.originalApplication), r.windSelector = new h.SelectorModel(["N", "NE", "E", "SE", "S", "SW", "W", "NW"].map(function (e) {
          return {
            key: e,
            text: i("cardinal_directions.".concat(e.toLowerCase())),
            value: e
          };
        })), r.windSelector.changeByText(r.application.windDirection || ""), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && e6(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Q5(e.prototype, t), r && Q5(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "remainingAcreagePerField",
        get: function () {
          var e = this.props,
              t = e.fields,
              r = e.sprayRecord,
              n = {};
          return t.forEach(function (e) {
            n[e.id] = e.acres, r.applications.forEach(function (t) {
              t.fieldCompletions.filter(function (t) {
                return t.field.id === e.id;
              }).forEach(function (t) {
                n[e.id] -= t.acres;
              });
            });
          }), n;
        }
      }, {
        key: "accountUuid",
        get: function () {
          var e = this.props.sprayRecord;
          return e.account && e.account.id || "";
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = this;
          this.errorReaction = Object(f.reaction)(function () {
            return e.errors;
          }, function () {
            return v()('[data-toggle="tooltip"]').tooltip();
          }, {
            delay: 2
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.errorReaction();
        }
      }, {
        key: "restoreOriginalApplication",
        value: function () {
          var e = this.props.isChangedCallback;
          this.application = new w.SprayRecordApplication(this.originalApplication), this.submitted = !1, this.submitting = !1, this.changed = !1, e && e(this.changed), this.windSelector.changeByText(this.application.windDirection || "");
        }
      }, {
        key: "sortApplicators",
        value: function (e) {
          return ep()(e, ["lastName", "firstName"]);
        }
      }, {
        key: "validateIfSubmitted",
        value: function () {
          this.submitted && this.validate();
        }
      }, {
        key: "validate",
        value: function () {
          this.errors = this.validationErrors();
        }
      }, {
        key: "validationErrors",
        value: function () {
          var e = this,
              t = {},
              r = this.props.t,
              n = {
            date: r("date_date"),
            startTime: r("start_time"),
            stopTime: r("stop_time"),
            temperatureLow: r("low_temp"),
            temperatureHigh: r("high_temp"),
            windSpeed: r("wind_speed")
          };
          return Object.keys(n).forEach(function (o) {
            null !== e.application[o] && "" !== e.application[o] || (t[o] = r("field_is_required", {
              field: n[o]
            }));
          }), 0 === this.application.fieldCompletions.length && (t.fieldCompletions = r("at_least_one_field_is_required")), 0 === this.application.applicators.length && (t.applicators = r("at_least_one_applicator_is_required")), t;
        }
      }, {
        key: "errorClass",
        value: function (e) {
          if (this.errors[e]) return "field-with-error";
        }
      }, {
        key: "errorMessage",
        value: function (e) {
          var t = this.errors[e];
          return t;
        }
      }, {
        key: "formatWindSpeed",
        value: function (e) {
          return e ? "".concat(e, " mph") : "";
        }
      }, {
        key: "handleKeyPress",
        value: function (e) {
          "Enter" === e.key && this.handleSave();
        }
      }, {
        key: "renderSpinner",
        value: function () {
          if (this.submitting) return p.a.createElement(p.a.Fragment, null, p.a.createElement("div", {
            className: "application-dulling-overlay"
          }), p.a.createElement("div", {
            className: "application-save-spinner"
          }, p.a.createElement("div", {
            className: "spinner-border"
          })));
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t,
              r = this,
              n = this.props,
              o = n.fields,
              i = n.tractors,
              a = n.sprayers,
              c = n.spreaders,
              u = n.sprayRecord,
              l = n.recordAmountsIn,
              s = n.applicatorContacts,
              f = n.contacts,
              d = n.contactsApi,
              b = n.teams,
              y = n.t,
              m = n.createApplicator;
          return p.a.createElement("tr", {
            "aria-label": "Application Row Editor",
            className: "application-editor"
          }, p.a.createElement("td", {
            "aria-label": "Plus"
          }, p.a.createElement("i", {
            className: "fas fa-plus disabled"
          })), p.a.createElement("td", {
            colSpan: "5"
          }, p.a.createElement("div", {
            className: "row no-gutters"
          }, p.a.createElement("div", {
            className: "col-5"
          }, p.a.createElement("div", {
            className: "row no-gutters"
          }, p.a.createElement("div", {
            className: "col-5"
          }, p.a.createElement("div", {
            className: "input-group"
          }, p.a.createElement(Bu, {
            tabIndex: "1",
            placeholder: "mm/dd/yyyy",
            className: "mr-1 w-100",
            inputClassName: this.errorClass("date"),
            title: this.errorMessage("date"),
            value: this.application.date,
            onChange: function (e) {
              r.application.date = e, r.handleChange();
            }
          }), p.a.createElement("i", {
            className: "fas fa-calendar-alt input-icon calendar-icon"
          }))), p.a.createElement("div", {
            className: "col-6"
          }, p.a.createElement("div", {
            className: "input-group"
          }, p.a.createElement(M1, {
            tabIndex: "2",
            name: "startTime",
            containerClassName: "mr-1",
            inputClassName: "".concat(this.errorClass("startTime")),
            tooltipPlacement: "top",
            title: this.errorMessage("startTime"),
            time: this.application.startTime,
            placeholder: y("start_time"),
            onChange: function (e) {
              r.application.startTime = e, r.handleChange();
            }
          }), p.a.createElement("div", {
            className: "middle-icon-container"
          }, p.a.createElement("i", {
            className: "fas fa-clock input-icon middle-icon time-icon"
          })), p.a.createElement(M1, {
            tabIndex: "3",
            name: "stopTime",
            inputClassName: "stop-time ".concat(this.errorClass("stopTime")),
            tooltipPlacement: "top",
            title: this.errorMessage("stopTime"),
            time: this.application.stopTime,
            placeholder: y("stop_time"),
            onChange: function (e) {
              r.application.stopTime = e, r.handleChange();
            }
          })))), p.a.createElement("div", {
            className: "row no-gutters"
          }, p.a.createElement("div", {
            className: "col"
          }, p.a.createElement(_5, {
            tabIndex: "9",
            errorMessage: this.errorMessage("applicators"),
            sprayRecord: u,
            applicatorContacts: s,
            contacts: f,
            contactsApi: d,
            teams: b,
            application: this.application,
            tractors: i,
            sprayers: a,
            spreaders: c,
            recordAmountsIn: l,
            onChange: function () {
              return r.handleChange();
            },
            createApplicator: m
          }))), w.SprayRecord.requiresRate(u.applicationMethod) ? p.a.createElement(G5, {
            application: this.application,
            sprayRecord: u
          }) : null), p.a.createElement("div", {
            className: "col-7 d-flex flex-column"
          }, p.a.createElement("div", {
            className: "row no-gutters"
          }, p.a.createElement("div", {
            className: "col-6"
          }, p.a.createElement("div", {
            className: "row no-gutters"
          }, p.a.createElement("div", {
            className: "col-8"
          }, p.a.createElement("div", {
            className: "input-group"
          }, p.a.createElement("input", {
            tabIndex: "4",
            type: "number",
            placeholder: y("wind_low"),
            className: "form-control ml-1 mr-1 ".concat(this.errorClass("lowWindSpeed")),
            "data-toggle": "tooltip",
            "data-placement": "top",
            "data-original-title": this.errorMessage("lowWindSpeed"),
            value: (null === (e = this.application.lowWindSpeed) || void 0 === e ? void 0 : e.scalar) || "",
            onChange: this.updateWindSpeed("lowWindSpeed")
          }), p.a.createElement("div", {
            className: "middle-icon-container"
          }, p.a.createElement("i", {
            className: "fas fa-wind input-icon middle-icon wind-icon"
          })), p.a.createElement("input", {
            tabIndex: "5",
            type: "number",
            placeholder: y("wind_high"),
            className: "form-control mr-1 wind-high ".concat(this.errorClass("highWindSpeed")),
            "data-toggle": "tooltip",
            "data-placement": "top",
            "data-original-title": this.errorMessage("highWindSpeed"),
            value: (null === (t = this.application.highWindSpeed) || void 0 === t ? void 0 : t.scalar) || "",
            onChange: this.updateWindSpeed("highWindSpeed")
          }))), p.a.createElement("div", {
            className: "col-4"
          }, p.a.createElement(h.SelectDropdown, {
            placeholder: y("direction"),
            tabIndex: "6",
            options: this.windSelector.options,
            onChange: this.windSelector.change,
            model: this.windSelector
          })))), p.a.createElement("div", {
            className: "col-6"
          }, p.a.createElement("div", {
            className: "input-group"
          }, p.a.createElement("input", {
            tabIndex: "7",
            type: "number",
            placeholder: y("low_temp"),
            className: "form-control ml-1 mr-1 temperature ".concat(this.errorClass("temperatureLow")),
            "data-toggle": "tooltip",
            "data-placement": "top",
            "data-original-title": this.errorMessage("temperatureLow"),
            value: this.application.temperatureLow,
            onChange: function (e) {
              r.application.temperatureLow = e.target.value, r.handleChange();
            }
          }), p.a.createElement("div", {
            className: "middle-icon-container"
          }, p.a.createElement("i", {
            className: "fas fa-cloud-sun input-icon middle-icon temperature-icon"
          })), p.a.createElement("input", {
            tabIndex: "8",
            type: "number",
            placeholder: y("high_temp"),
            className: "form-control high-temp temperature ".concat(this.errorClass("temperatureHigh")),
            "data-toggle": "tooltip",
            "data-placement": "top",
            "data-original-title": this.errorMessage("temperatureHigh"),
            value: this.application.temperatureHigh,
            onChange: function (e) {
              r.application.temperatureHigh = e.target.value, r.handleChange();
            }
          })))), p.a.createElement("div", {
            className: "row no-gutters"
          }, p.a.createElement("div", {
            className: "col"
          }, p.a.createElement(E3, {
            accountId: this.accountUuid,
            application: this.application,
            sprayRecord: u,
            remainingAcreagePerField: this.remainingAcreagePerField,
            errorMessage: this.errorMessage("fieldCompletions"),
            fields: o,
            onUpdateFieldCompletion: this.updateFieldCompletion,
            onRemoveFieldCompletion: this.removeFieldCompletion
          }))), p.a.createElement("div", {
            className: "row no-gutters flex-fill align-items-end mb-3"
          }, p.a.createElement("div", {
            className: "col-3 ml-auto"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-lg btn-success",
            onClick: this.handleSave,
            disabled: this.submitting
          }, this.renderSpinner(), y("save"))))))), p.a.createElement("td", {
            className: "actions"
          }, this.renderSpinner(), p.a.createElement("a", {
            href: "#",
            onClick: function (e) {
              e.preventDefault(), r.handleSave();
            },
            disabled: this.submitting,
            "aria-label": "Save"
          }, p.a.createElement("i", {
            className: "fas fa-save text-success"
          })), p.a.createElement("a", {
            href: "#",
            onClick: this.cancel,
            "aria-label": "Cancel"
          }, p.a.createElement("i", {
            className: "fas fa-times-circle text-secondary"
          }))));
        }
      }]);
    }()).prototype, "application", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), x5 = t6(N5.prototype, "errors", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return {};
      }
    }), A5 = t6(N5.prototype, "submitted", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), M5 = t6(N5.prototype, "changed", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), I5 = t6(N5.prototype, "submitting", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), t6(N5.prototype, "remainingAcreagePerField", [f.computed], Object.getOwnPropertyDescriptor(N5.prototype, "remainingAcreagePerField"), N5.prototype), t6(N5.prototype, "accountUuid", [f.computed], Object.getOwnPropertyDescriptor(N5.prototype, "accountUuid"), N5.prototype), t6(N5.prototype, "restoreOriginalApplication", [f.action], Object.getOwnPropertyDescriptor(N5.prototype, "restoreOriginalApplication"), N5.prototype), F5 = t6(N5.prototype, "removeFieldCompletion", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.application.fieldCompletions.findIndex(function (e) {
            return e.field.id === t.id;
          });
          r < 0 || (e.application.fieldCompletions.splice(r, 1), e.handleChange());
        };
      }
    }), B5 = t6(N5.prototype, "updateFieldCompletion", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          if (t.field) {
            var r = e.application.fieldCompletions.find(function (e) {
              return e.field.id === t.field.id;
            });
            r ? r.update(t) : (r = new w.FieldCompletion(t), e.application.fieldCompletions.push(r)), e.handleChange();
          }
        };
      }
    }), L5 = t6(N5.prototype, "handleSave", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.sprayRecord,
              n = t.onSave;
          e.application.windDirection = e.windSelector.selectedValue || e.application.windDirection, e.errors = {}, e.submitted = !0;
          var o = e.validationErrors();
          Object.keys(o).length > 0 ? e.errors = o : (e.submitting = !0, e.application.sprayRecordId = r.serial, n(e.application.toJS(), function () {
            return e.restoreOriginalApplication();
          }, function (t) {
            e.submitting = !1;
            var r = t.message;
            t.errors && (r = [r].concat(t.errors.join("\n") || []).join(":\n")), window.alert(r);
          }));
        };
      }
    }), V5 = t6(N5.prototype, "cancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.onSave,
              o = r.t;
          t.preventDefault();
          var i = !0;
          e.changed && (i = window.confirm(o("all_changes_to_this_application_will_be_lost"))), i && (e.restoreOriginalApplication(), n(null));
        };
      }
    }), U5 = t6(N5.prototype, "handleChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.isChangedCallback;
          e.changed = !0, t && t(e.changed), e.validateIfSubmitted();
        };
      }
    }), t6(N5.prototype, "validate", [f.action], Object.getOwnPropertyDescriptor(N5.prototype, "validate"), N5.prototype), q5 = t6(N5.prototype, "updateWindSpeed", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function (r) {
            e.application.update(J5({}, t, e.formatWindSpeed(r.target.value))), e.handleChange();
          };
        };
      }
    }), z5 = N5)) || z5,
        i6 = Object(g.a)()(o6);

    function a6(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, c6(n.key), n);
      }
    }

    function c6(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var u6,
        l6,
        s6,
        p6,
        f6 = (n6 = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((r6 = function () {
      return e = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(this, "isExpanded", n6, this);
      }, (t = [{
        key: "get",
        value: function (e, t, r) {
          return "isExpanded" === t ? this.isExpanded : Reflect.get.apply(Reflect, arguments);
        }
      }, {
        key: "set",
        value: function (e, t, r) {
          return "isExpanded" === t ? (this.isExpanded = r, !0) : Reflect.set.apply(Reflect, arguments);
        }
      }]) && a6(e.prototype, t), r && a6(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "isExpanded", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !0;
      }
    }), r6);

    function d6(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function b6(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, y6(n.key), n);
      }
    }

    function y6(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function m6(e, t, r) {
      return t = v6(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], v6(e).constructor) : t.apply(e, r));
    }

    function v6(e) {
      return (v6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function h6(e, t) {
      return (h6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function g6(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var w6,
        O6,
        j6,
        P6,
        _6,
        E6 = Object(d.observer)((s6 = g6((l6 = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return d6(e = m6(this, t, [].concat(n)), "expand", s6, e), d6(e, "contract", p6, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && h6(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.application,
              r = e.isExpanded;
          return t.applicators.length < 2 ? p.a.createElement("i", {
            className: "fas fa-minus disabled"
          }) : r ? p.a.createElement("a", {
            href: "#",
            className: "icon-link",
            onClick: this.contract
          }, p.a.createElement("i", {
            className: "fas fa-minus"
          })) : p.a.createElement("a", {
            href: "#",
            className: "icon-link",
            onClick: this.expand
          }, p.a.createElement("i", {
            className: "fas fa-plus"
          }));
        }
      }]) && b6(r.prototype, n), o && b6(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "expand", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.application;
          t.preventDefault(), r.isExpanded = !0;
        };
      }
    }), p6 = g6(l6.prototype, "contract", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.application;
          t.preventDefault(), r.isExpanded = !1;
        };
      }
    }), u6 = l6)) || u6;

    function S6(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function C6(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, k6(n.key), n);
      }
    }

    function k6(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function R6(e, t, r) {
      return t = T6(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], T6(e).constructor) : t.apply(e, r));
    }

    function T6(e) {
      return (T6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function z6(e, t) {
      return (z6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function N6(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var D6,
        x6,
        A6,
        M6,
        I6,
        F6,
        B6,
        L6,
        V6 = Object(d.observer)((N6((O6 = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return S6(e = R6(this, t, [].concat(n)), "expand", j6, e), S6(e, "onDelete", P6, e), S6(e, "onEdit", _6, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && z6(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && C6(e.prototype, t), r && C6(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "applicators",
        get: function () {
          return this.props.application.applicators;
        }
      }, {
        key: "expandedClass",
        get: function () {
          return this.props.isExpanded ? "application-expanded" : "application-contracted";
        }
      }, {
        key: "displayedClass",
        get: function () {
          return this.props.isDisplayed ? "application-displayed" : "application-not-displayed";
        }
      }, {
        key: "expandedDisplayedClassNames",
        get: function () {
          return "".concat(this.expandedClass, " ").concat(this.displayedClass);
        }
      }, {
        key: "expansionOptions",
        get: function () {
          return {
            plus: !this.props.isExpanded && this.restOfApplicators.length
          };
        }
      }, {
        key: "firstApplicator",
        get: function () {
          return this.applicators.length > 0 && this.applicators[0] || null;
        }
      }, {
        key: "nonApplicatorRowSpan",
        get: function () {
          return this.props.isExpanded && this.applicators.length > 0 ? this.applicators.length : 1;
        }
      }, {
        key: "restOfApplicators",
        get: function () {
          return this.applicators.slice(1);
        }
      }, {
        key: "renderApplicatorContact",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return p.a.createElement(p.a.Fragment, null, e.contact.firstName, " ", e.contact.lastName, p.a.createElement("br", null), p.a.createElement("div", {
            className: "understated-bold"
          }, e.contact.licenseNumber, this.renderApplicatorExpansionOptions(t)));
        }
      }, {
        key: "renderApplicatorEquipment",
        value: function (e) {
          var t,
              r,
              n,
              o,
              i,
              a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              c = this.props,
              u = c.t,
              l = c.sprayRecord,
              s = e.warningTranslationKeysGiven(l.applicationMethod);
          return p.a.createElement(p.a.Fragment, null, (null === (t = e.tractor) || void 0 === t ? void 0 : t.name) || null, p.a.createElement("br", null), p.a.createElement("div", {
            className: "understated-bold"
          }, p.a.createElement("div", {
            className: "sprayer-container"
          }, p.a.createElement("span", {
            className: "sprayer-name"
          }, (null === (r = e.sprayer) || void 0 === r ? void 0 : r.name) || null), e.tankCleaned ? p.a.createElement("div", null, p.a.createElement("img", {
            className: "tank-cleaned-icon",
            alt: u("tank_cleaned")
          }), p.a.createElement("span", {
            className: "tank-cleaned-text"
          }, u("tank_cleaned"))) : null, null !== (n = e.sprayer) && void 0 !== n && n.name && null !== (o = e.spreader) && void 0 !== o && o.name ? p.a.createElement("br", null) : null, (null === (i = e.spreader) || void 0 === i ? void 0 : i.name) || null, s.length > 0 ? p.a.createElement("i", {
            className: "applicator-warning fas fa-ban ml-1",
            "data-original-title": s.map(function (e) {
              return u(e);
            }).join(", "),
            "data-toggle": "tooltip"
          }) : null, this.renderApplicatorExpansionOptions(a))));
        }
      }, {
        key: "renderApplicatorExpansionOptions",
        value: function (e) {
          if (e.plus) return p.a.createElement("a", {
            href: "#",
            onClick: this.expand,
            className: "text-primary unadorned"
          }, " ", "+", e.plus);
        }
      }, {
        key: "renderAdditionalApplicatorRow",
        value: function (e, t) {
          var r = this.props.application;
          return p.a.createElement("tr", {
            key: "".concat(r.serial, "-").concat(e.contact.id),
            className: t
          }, p.a.createElement("td", null, this.renderApplicatorContact(e)), p.a.createElement("td", null, this.renderApplicatorEquipment(e)));
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.application,
              n = t.isDisplayed,
              o = t.isExpanded,
              i = t.showEditControls,
              a = t.t;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("tr", {
            key: r.id,
            className: this.expandedDisplayedClassNames,
            "aria-label": "Application Row",
            "aria-hidden": !n
          }, p.a.createElement("td", {
            rowSpan: this.nonApplicatorRowSpan,
            "aria-label": "Expand/Collapse Row"
          }, p.a.createElement(E6, {
            application: r,
            isExpanded: o
          })), p.a.createElement("td", {
            rowSpan: this.nonApplicatorRowSpan
          }, M()(r.date).format("MM/DD/YYYY"), p.a.createElement("br", null), p.a.createElement("div", {
            className: "understated-bold"
          }, p.a.createElement("span", {
            className: "text-nowrap"
          }, oe(r.startTime)), " - ", p.a.createElement("span", {
            className: "text-nowrap"
          }, oe(r.stopTime))), r.isOvernight ? p.a.createElement("i", {
            className: "fas fa-moon text-primary",
            "data-toggle": "tooltip",
            title: a("overnight_application")
          }) : null), p.a.createElement("td", null, this.firstApplicator ? this.renderApplicatorContact(this.firstApplicator, this.expansionOptions) : null), p.a.createElement("td", null, this.firstApplicator ? this.renderApplicatorEquipment(this.firstApplicator, this.expansionOptions) : null), p.a.createElement("td", {
            rowSpan: this.nonApplicatorRowSpan
          }, p.a.createElement("div", {
            className: "understated-bold"
          }, r.fieldCompletions.map(function (e) {
            return e.field.name;
          }).sort(h.naturalSort).join(", "))), p.a.createElement("td", {
            rowSpan: this.nonApplicatorRowSpan
          }, p.a.createElement("span", {
            className: "text-nowrap"
          }, r.temperatureLow, " - "), p.a.createElement("span", {
            className: "text-nowrap"
          }, r.temperatureHigh, " °", r.temperatureUnits), p.a.createElement("div", {
            className: "understated-bold"
          }, r.windDirectionAndSpeed)), p.a.createElement("td", {
            className: "actions"
          }, i ? p.a.createElement(p.a.Fragment, null, p.a.createElement("a", {
            href: "#",
            onClick: this.onEdit(r),
            "aria-label": "Edit Application"
          }, p.a.createElement("i", {
            className: "fas fa-edit text-primary"
          })), p.a.createElement("a", {
            href: "#",
            onClick: this.onDelete(r),
            "data-confirm": a("confirm_remove_application_detail"),
            "aria-label": "Remove Application"
          }, p.a.createElement("i", {
            className: "fas fa-trash-alt text-danger"
          }))) : null)), o ? this.restOfApplicators.map(function (t) {
            return e.renderAdditionalApplicatorRow(t, e.expandedDisplayedClassNames);
          }) : null);
        }
      }]);
    }()).prototype, "applicators", [f.computed], Object.getOwnPropertyDescriptor(O6.prototype, "applicators"), O6.prototype), N6(O6.prototype, "expandedClass", [f.computed], Object.getOwnPropertyDescriptor(O6.prototype, "expandedClass"), O6.prototype), N6(O6.prototype, "displayedClass", [f.computed], Object.getOwnPropertyDescriptor(O6.prototype, "displayedClass"), O6.prototype), N6(O6.prototype, "expandedDisplayedClassNames", [f.computed], Object.getOwnPropertyDescriptor(O6.prototype, "expandedDisplayedClassNames"), O6.prototype), N6(O6.prototype, "expansionOptions", [f.computed], Object.getOwnPropertyDescriptor(O6.prototype, "expansionOptions"), O6.prototype), N6(O6.prototype, "firstApplicator", [f.computed], Object.getOwnPropertyDescriptor(O6.prototype, "firstApplicator"), O6.prototype), N6(O6.prototype, "nonApplicatorRowSpan", [f.computed], Object.getOwnPropertyDescriptor(O6.prototype, "nonApplicatorRowSpan"), O6.prototype), N6(O6.prototype, "restOfApplicators", [f.computed], Object.getOwnPropertyDescriptor(O6.prototype, "restOfApplicators"), O6.prototype), j6 = N6(O6.prototype, "expand", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.application;
          t.preventDefault(), r.isExpanded = !0;
        };
      }
    }), P6 = N6(O6.prototype, "onDelete", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function (r) {
            var n = e.props.onDelete;
            r.preventDefault(), n(t);
          };
        };
      }
    }), _6 = N6(O6.prototype, "onEdit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function (r) {
            var n = e.props.onEdit;
            r.preventDefault(), n(t);
          };
        };
      }
    }), w6 = O6)) || w6,
        U6 = Object(g.a)()(V6),
        q6 = ["contact"];

    function K6() {
      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      K6 = function () {
        return t;
      };

      var e,
          t = {},
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = Object.defineProperty || function (e, t, r) {
        e[t] = r.value;
      },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          u = i.toStringTag || "@@toStringTag";

      function l(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        l({}, "");
      } catch (e) {
        l = function (e, t, r) {
          return e[t] = r;
        };
      }

      function s(e, t, r, n) {
        var i = t && t.prototype instanceof v ? t : v,
            a = Object.create(i.prototype),
            c = new T(n || []);
        return o(a, "_invoke", {
          value: S(e, r, c)
        }), a;
      }

      function p(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      t.wrap = s;
      var f = "suspendedStart",
          d = "suspendedYield",
          b = "executing",
          y = "completed",
          m = {};

      function v() {}

      function h() {}

      function g() {}

      var w = {};
      l(w, a, function () {
        return this;
      });
      var O = Object.getPrototypeOf,
          j = O && O(O(z([])));
      j && j !== r && n.call(j, a) && (w = j);
      var P = g.prototype = v.prototype = Object.create(w);

      function _(e) {
        ["next", "throw", "return"].forEach(function (t) {
          l(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function E(e, t) {
        function r(o, i, a, c) {
          var u = p(e[o], e, i);

          if ("throw" !== u.type) {
            var l = u.arg,
                s = l.value;
            return s && "object" == typeof s && n.call(s, "__await") ? t.resolve(s.__await).then(function (e) {
              r("next", e, a, c);
            }, function (e) {
              r("throw", e, a, c);
            }) : t.resolve(s).then(function (e) {
              l.value = e, a(l);
            }, function (e) {
              return r("throw", e, a, c);
            });
          }

          c(u.arg);
        }

        var i;
        o(this, "_invoke", {
          value: function (e, n) {
            function o() {
              return new t(function (t, o) {
                r(e, n, t, o);
              });
            }

            return i = i ? i.then(o, o) : o();
          }
        });
      }

      function S(t, r, n) {
        var o = f;
        return function (i, a) {
          if (o === b) throw Error("Generator is already running");

          if (o === y) {
            if ("throw" === i) throw a;
            return {
              value: e,
              done: !0
            };
          }

          for (n.method = i, n.arg = a;;) {
            var c = n.delegate;

            if (c) {
              var u = C(c, n);

              if (u) {
                if (u === m) continue;
                return u;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (o === f) throw o = y, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            o = b;
            var l = p(t, r, n);

            if ("normal" === l.type) {
              if (o = n.done ? y : d, l.arg === m) continue;
              return {
                value: l.arg,
                done: n.done
              };
            }

            "throw" === l.type && (o = y, n.method = "throw", n.arg = l.arg);
          }
        };
      }

      function C(t, r) {
        var n = r.method,
            o = t.iterator[n];
        if (o === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, C(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), m;
        var i = p(o, t.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, m;
        var a = i.arg;
        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, m) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m);
      }

      function k(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function R(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function T(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(k, this), this.reset(!0);
      }

      function z(t) {
        if (t || "" === t) {
          var r = t[a];
          if (r) return r.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var o = -1,
                i = function r() {
              for (; ++o < t.length;) if (n.call(t, o)) return r.value = t[o], r.done = !1, r;

              return r.value = e, r.done = !0, r;
            };

            return i.next = i;
          }
        }

        throw new TypeError(typeof t + " is not iterable");
      }

      return h.prototype = g, o(P, "constructor", {
        value: g,
        configurable: !0
      }), o(g, "constructor", {
        value: h,
        configurable: !0
      }), h.displayName = l(g, u, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === h || "GeneratorFunction" === (t.displayName || t.name));
      }, t.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, l(e, u, "GeneratorFunction")), e.prototype = Object.create(P), e;
      }, t.awrap = function (e) {
        return {
          __await: e
        };
      }, _(E.prototype), l(E.prototype, c, function () {
        return this;
      }), t.AsyncIterator = E, t.async = function (e, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new E(s(e, r, n, o), i);
        return t.isGeneratorFunction(r) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, _(P), l(P, u, "Generator"), l(P, a, function () {
        return this;
      }), l(P, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (e) {
        var t = Object(e),
            r = [];

        for (var n in t) r.push(n);

        return r.reverse(), function e() {
          for (; r.length;) {
            var n = r.pop();
            if (n in t) return e.value = n, e.done = !1, e;
          }

          return e.done = !0, e;
        };
      }, t.values = z, T.prototype = {
        constructor: T,
        reset: function (t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(R), !t) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
        },
        stop: function () {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function (t) {
          if (this.done) throw t;
          var r = this;

          function o(n, o) {
            return c.type = "throw", c.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
                c = a.completion;
            if ("root" === a.tryLoc) return o("end");

            if (a.tryLoc <= this.prev) {
              var u = n.call(a, "catchLoc"),
                  l = n.call(a, "finallyLoc");

              if (u && l) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!l) throw Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function (e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(a);
        },
        complete: function (e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
        },
        finish: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), R(r), m;
          }
        },
        catch: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                R(r);
              }

              return o;
            }
          }

          throw Error("illegal catch attempt");
        },
        delegateYield: function (t, r, n) {
          return this.delegate = {
            iterator: z(t),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = e), m;
        }
      }, t;
    }

    function G6(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function W6(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? G6(Object(r), !0).forEach(function (t) {
          H6(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : G6(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function H6(e, t, r) {
      return (t = X6(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function J6(e, t) {
      if (null == e) return {};

      var r,
          n,
          o = function (e, t) {
        if (null == e) return {};
        var r = {};

        for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
          if (t.includes(n)) continue;
          r[n] = e[n];
        }

        return r;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }

      return o;
    }

    function Y6(e, t, r, n, o, i, a) {
      try {
        var c = e[i](a),
            u = c.value;
      } catch (e) {
        return void r(e);
      }

      c.done ? t(u) : Promise.resolve(u).then(n, o);
    }

    function Q6(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function $6(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, X6(n.key), n);
      }
    }

    function X6(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Z6(e, t, r) {
      return t = e8(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], e8(e).constructor) : t.apply(e, r));
    }

    function e8(e) {
      return (e8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function t8(e, t) {
      return (t8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function r8(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var n8,
        o8,
        i8,
        a8,
        c8,
        u8 = Object(d.observer)((A6 = r8((x6 = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = Z6(this, t, [e])).sprayRecordsStore = void 0, r.initialApplication = new w.SprayRecordApplication(), Q6(r, "applicatorContacts", A6, r), Q6(r, "contacts", M6, r), Q6(r, "newApplicationIsChanged", I6, r), Q6(r, "editing", F6, r), Q6(r, "stopEditing", B6, r), Q6(r, "createApplicator", L6, r);
        var n = (r.props || {}).sprayRecordsStore;
        return r.sprayRecordsStore = n || window.sprayRecordsStore, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && t8(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && $6(e.prototype, t), r && $6(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "sprayRecordId",
        get: function () {
          return this.props.sprayRecordId;
        }
      }, {
        key: "sprayRecord",
        get: function () {
          return this.sprayRecordsStore.find(this.sprayRecordId);
        }
      }, {
        key: "applications",
        get: function () {
          var e;
          return this.expandable((null === (e = this.sprayRecord) || void 0 === e ? void 0 : e.applications) || []);
        }
      }, {
        key: "sortedApplications",
        get: function () {
          var e;
          return this.expandable((null === (e = this.sprayRecord) || void 0 === e ? void 0 : e.sortedApplications) || []);
        }
      }, {
        key: "fields",
        get: function () {
          return this.sprayRecord.fields || [];
        }
      }, {
        key: "completeAcresByField",
        get: function () {
          var e = {};
          return this.fields.forEach(function (t) {
            e[t.id] = 0;
          }), this.applications.forEach(function (t) {
            t.fieldCompletions.forEach(function (t) {
              e[t.field.id] += t.acres;
            });
          }), e;
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = this;
          if (this.props.testThrowError) throw new Error("Test fallback UI");
          this.sprayRecordsStore.fetchAccountContacts(this.sprayRecord).then(function (t) {
            return e.setContacts(t), t;
          }).catch(console.error), this.sprayRecordsStore.fetchApplicatorContacts(this.sprayRecord).then(function (t) {
            return e.setApplicators(t), t;
          }).catch(console.error);
        }
      }, {
        key: "expandable",
        value: function (e) {
          return e.map(function (e) {
            return new Proxy(e, new f6());
          });
        }
      }, {
        key: "isExpanded",
        value: function (e) {
          return e.isExpanded;
        }
      }, {
        key: "expandApplication",
        value: function (e) {
          e.isExpanded = !0;
        }
      }, {
        key: "contractApplication",
        value: function (e) {
          e.isExpanded = !1;
        }
      }, {
        key: "addApplication",
        value: function (e, t, r) {
          var n = this;
          e && this.sprayRecordsStore.addApplication(this.sprayRecordId, e).then(function () {
            return n.sprayRecordsStore.fetchApplicatorContacts(n.sprayRecord).then(function (e) {
              return n.setApplicators(e), e;
            });
          }).then(function () {
            return t();
          }).catch(function (e) {
            return r(e);
          });
        }
      }, {
        key: "updateApplication",
        value: function (e, t, r) {
          var n = this;
          e ? this.sprayRecordsStore.updateApplication(this.sprayRecordId, e).then(function () {
            return n.refreshApplicators();
          }).then(function () {
            return n.stopEditing(), t();
          }).catch(function (e) {
            return r(e);
          }) : this.stopEditing();
        }
      }, {
        key: "editApplication",
        value: function (e) {
          var t = !0,
              r = this.props.t;
          this.newApplicationIsChanged && (t = window.confirm(r("editing_will_cause_lost_changes_confirm"))), t && (this.newApplicationIsChanged = !1, this.editing = e.serial);
        }
      }, {
        key: "deleteApplication",
        value: function (e) {
          this.sprayRecordsStore.deleteApplication(this.sprayRecordId, e).catch(function (e) {
            return alert(e);
          });
        }
      }, {
        key: "setApplicators",
        value: function (e) {
          this.applicatorContacts = e;
        }
      }, {
        key: "setContacts",
        value: function (e) {
          this.contacts = e;
        }
      }, {
        key: "refreshApplicators",
        value: function () {
          var e = this;
          return this.sprayRecordsStore.fetchApplicatorContacts(this.sprayRecord).then(function (t) {
            return e.setApplicators(t), t;
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.tractors,
              n = t.sprayers,
              o = t.spreaders,
              i = t.teams,
              a = t.recordApplicationAmountsIn,
              c = t.showEditControls,
              u = t.contactsApi,
              l = t.t;
          return p.a.createElement("table", {
            className: "table table-sm application-manager"
          }, p.a.createElement("thead", {
            className: "thead-light"
          }, p.a.createElement("tr", null, p.a.createElement("th", {
            className: "expand",
            "aria-label": "Row Expand/Collapse Button"
          }), p.a.createElement("th", {
            scope: "col"
          }, l("date_time")), p.a.createElement("th", {
            scope: "col"
          }, l("applicator_license")), p.a.createElement("th", {
            scope: "col"
          }, l("equipment")), p.a.createElement("th", {
            scope: "col"
          }, l("blocks_treated")), p.a.createElement("th", {
            scope: "col"
          }, l("temp_wind")), p.a.createElement("th", {
            className: "actions",
            "aria-label": "Actions"
          }))), p.a.createElement("tbody", null, this.sortedApplications.map(function (t) {
            return e.editing === t.serial ? p.a.createElement(i6, {
              key: t.serial,
              serial: t.serial,
              sprayRecord: e.sprayRecord,
              application: t,
              applicatorContacts: e.applicatorContacts,
              contactsApi: u,
              contacts: e.contacts,
              teams: i,
              completeAcresByField: e.completeAcresByField,
              fields: e.fields,
              tractors: r,
              sprayers: n,
              spreaders: o,
              createApplicator: e.createApplicator,
              recordAmountsIn: a,
              onSave: function (t, r, n) {
                return e.updateApplication(t, r, n);
              },
              onCancel: e.stopEditing
            }) : p.a.createElement(s.Fragment, {
              key: t.serial
            }, p.a.createElement(U6, {
              sprayRecord: e.sprayRecord,
              application: t,
              isExpanded: !0,
              isDisplayed: t.isExpanded,
              showEditControls: c,
              onEdit: function () {
                return e.editApplication(t);
              },
              onDelete: function () {
                return e.deleteApplication(t);
              }
            }), p.a.createElement(U6, {
              sprayRecord: e.sprayRecord,
              application: t,
              isExpanded: !1,
              isDisplayed: !t.isExpanded,
              showEditControls: c,
              onEdit: function () {
                return e.editApplication(t);
              },
              onDelete: function () {
                return e.deleteApplication(t);
              }
            }));
          }), !c || this.editing || this.sprayRecord.complete ? null : p.a.createElement(i6, {
            className: "new-application-row",
            sprayRecord: this.sprayRecord,
            application: this.initialApplication,
            applicatorContacts: this.applicatorContacts,
            contacts: this.contacts,
            contactsApi: u,
            teams: i,
            fields: this.fields,
            tractors: r,
            sprayers: n,
            spreaders: o,
            recordAmountsIn: a,
            completeAcresByField: this.completeAcresByField,
            isChangedCallback: function (t) {
              return e.newApplicationIsChanged = t;
            },
            createApplicator: this.createApplicator,
            onSave: function (t, r, n) {
              return e.addApplication(t, r, n);
            }
          })));
        }
      }]);
    }()).prototype, "applicatorContacts", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), M6 = r8(x6.prototype, "contacts", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), I6 = r8(x6.prototype, "newApplicationIsChanged", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), F6 = r8(x6.prototype, "editing", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return null;
      }
    }), r8(x6.prototype, "sprayRecordId", [f.computed], Object.getOwnPropertyDescriptor(x6.prototype, "sprayRecordId"), x6.prototype), r8(x6.prototype, "sprayRecord", [f.computed], Object.getOwnPropertyDescriptor(x6.prototype, "sprayRecord"), x6.prototype), r8(x6.prototype, "applications", [f.computed], Object.getOwnPropertyDescriptor(x6.prototype, "applications"), x6.prototype), r8(x6.prototype, "sortedApplications", [f.computed], Object.getOwnPropertyDescriptor(x6.prototype, "sortedApplications"), x6.prototype), r8(x6.prototype, "fields", [f.computed], Object.getOwnPropertyDescriptor(x6.prototype, "fields"), x6.prototype), r8(x6.prototype, "completeAcresByField", [f.computed], Object.getOwnPropertyDescriptor(x6.prototype, "completeAcresByField"), x6.prototype), r8(x6.prototype, "expandApplication", [f.action], Object.getOwnPropertyDescriptor(x6.prototype, "expandApplication"), x6.prototype), r8(x6.prototype, "contractApplication", [f.action], Object.getOwnPropertyDescriptor(x6.prototype, "contractApplication"), x6.prototype), B6 = r8(x6.prototype, "stopEditing", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.editing = null;
        };
      }
    }), r8(x6.prototype, "addApplication", [f.action], Object.getOwnPropertyDescriptor(x6.prototype, "addApplication"), x6.prototype), r8(x6.prototype, "updateApplication", [f.action], Object.getOwnPropertyDescriptor(x6.prototype, "updateApplication"), x6.prototype), r8(x6.prototype, "editApplication", [f.action], Object.getOwnPropertyDescriptor(x6.prototype, "editApplication"), x6.prototype), r8(x6.prototype, "deleteApplication", [f.action], Object.getOwnPropertyDescriptor(x6.prototype, "deleteApplication"), x6.prototype), r8(x6.prototype, "setApplicators", [f.action], Object.getOwnPropertyDescriptor(x6.prototype, "setApplicators"), x6.prototype), r8(x6.prototype, "setContacts", [f.action], Object.getOwnPropertyDescriptor(x6.prototype, "setContacts"), x6.prototype), L6 = r8(x6.prototype, "createApplicator", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t,
              r = (t = K6().mark(function t(r) {
            var n, o, i, a, c, u, l, s;
            return K6().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return n = e.props.contactsApi, o = r.toJS(), i = o.contact, a = J6(o, q6), t.prev = 2, t.next = 5, n.create(W6(W6({}, i), {}, {
                    categories: ["Applicator"]
                  }), e.sprayRecord.account.serial, !0);

                case 5:
                  return c = t.sent, u = c.contact, t.next = 9, e.refreshApplicators();

                case 9:
                  return l = t.sent, s = l.find(function (e) {
                    return (null == e ? void 0 : e.id) && e.id === u.id;
                  }), t.abrupt("return", new w.SprayRecordApplicator(W6({
                    contact: s
                  }, a)));

                case 14:
                  t.prev = 14, t.t0 = t.catch(2), console.error(t.t0), alert((null === t.t0 || void 0 === t.t0 ? void 0 : t.t0.message) || t.t0);

                case 18:
                case "end":
                  return t.stop();
              }
            }, t, null, [[2, 14]]);
          }), function () {
            var e = this,
                r = arguments;
            return new Promise(function (n, o) {
              var i = t.apply(e, r);

              function a(e) {
                Y6(i, n, o, a, c, "next", e);
              }

              function c(e) {
                Y6(i, n, o, a, c, "throw", e);
              }

              a(void 0);
            });
          });
          return function (e) {
            return r.apply(this, arguments);
          };
        }();
      }
    }), D6 = x6)) || D6,
        l8 = Object(g.a)()(u8);

    function s8(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function p8(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, f8(n.key), n);
      }
    }

    function f8(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function d8(e, t, r) {
      return t = b8(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], b8(e).constructor) : t.apply(e, r));
    }

    function b8(e) {
      return (b8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function y8(e, t) {
      return (y8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function m8(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var v8 = Object(d.observer)((i8 = m8((o8 = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), s8(r = d8(this, t, [e]), "isOpen", i8, r), s8(r, "close", a8, r), s8(r, "open", c8, r);
        var n = r.props.contactsPath;
        return r.sprayRecordsStore = window.sprayRecordsStore, r.contactsApi = new uX(n), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && y8(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && p8(e.prototype, t), r && p8(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "sprayRecord",
        get: function () {
          var e = this.props.sprayRecordId;
          return this.sprayRecordsStore.find(e);
        }
      }, {
        key: "applications",
        get: function () {
          return this.sprayRecord && this.sprayRecord.applications || [];
        }
      }, {
        key: "componentDidMount",
        value: function () {
          jQuery('.sprayer-and-spreader-warning[data-toggle="tooltip"]').tooltip({
            delay: {
              show: 700
            },
            trigger: "hover"
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return p.a.createElement(h.Card, {
            shouldNotPrint: this.applications.length <= 0
          }, p.a.createElement(h.CardHeader, {
            isOpen: this.isOpen,
            title: e("application_details").toUpperCase(),
            onOpen: this.open,
            onClose: this.close,
            hasToggle: !0
          }), p.a.createElement(h.CardBody, {
            isOpen: this.isOpen
          }, p.a.createElement(mf, {
            componentProps: this.props,
            renderError: function () {
              return p.a.createElement(Lp, {
                errorMessage: e("error_displaying_application_details")
              });
            }
          }, p.a.createElement(l8, Object.assign({}, this.props, {
            contactsApi: this.contactsApi
          })))));
        }
      }]);
    }()).prototype, "isOpen", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !0;
      }
    }), m8(o8.prototype, "sprayRecord", [f.computed], Object.getOwnPropertyDescriptor(o8.prototype, "sprayRecord"), o8.prototype), m8(o8.prototype, "applications", [f.computed], Object.getOwnPropertyDescriptor(o8.prototype, "applications"), o8.prototype), a8 = m8(o8.prototype, "close", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isOpen = !1;
        };
      }
    }), c8 = m8(o8.prototype, "open", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isOpen = !0;
        };
      }
    }), n8 = o8)) || n8,
        h8 = Object(g.a)()(v8),
        g8 = ["title", "children", "bsPrefix", "rootCloseEvent", "variant", "size", "menuAlign", "menuRole", "renderMenuOnMount", "disabled", "href", "id"],
        w8 = {
      id: go.a.any,
      href: go.a.string,
      onClick: go.a.func,
      title: go.a.node.isRequired,
      disabled: go.a.bool,
      menuAlign: rc,
      menuRole: go.a.string,
      renderMenuOnMount: go.a.bool,
      rootCloseEvent: go.a.string,
      bsPrefix: go.a.string,
      variant: go.a.string,
      size: go.a.string
    },
        O8 = p.a.forwardRef(function (e, t) {
      var r = e.title,
          n = e.children,
          o = e.bsPrefix,
          i = e.rootCloseEvent,
          a = e.variant,
          c = e.size,
          u = e.menuAlign,
          l = e.menuRole,
          s = e.renderMenuOnMount,
          f = e.disabled,
          d = e.href,
          b = e.id,
          y = er(e, g8);
      return p.a.createElement(_c, Zt({
        ref: t
      }, y), p.a.createElement(sc, {
        id: b,
        href: d,
        size: c,
        variant: a,
        disabled: f,
        childBsPrefix: o
      }, r), p.a.createElement(oc, {
        align: u,
        role: l,
        renderOnMount: s,
        rootCloseEvent: i
      }, n));
    });
    O8.displayName = "DropdownButton", O8.propTypes = w8;
    var j8,
        P8,
        _8 = O8;

    function E8(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, S8(n.key), n);
      }
    }

    function S8(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function C8(e, t, r) {
      return t = k8(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], k8(e).constructor) : t.apply(e, r));
    }

    function k8(e) {
      return (k8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function R8(e, t) {
      return (R8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function T8(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var z8,
        N8 = Object(d.observer)((T8((P8 = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), C8(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && R8(e, t);
      }(t, p.a.Component), function (e, t, r) {
        return t && E8(e.prototype, t), r && E8(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "_newApplicationRecordReportUrl",
        get: function () {
          var e = this.props.newApplicationRecordReportUrl;
          if (!e) throw new Error("NewReportButton needs a 'newApplicationRecordReportUrl' property");
          return e;
        }
      }, {
        key: "_newRecommendationReportUrl",
        get: function () {
          var e = this.props.newRecommendationReportUrl;
          if (!e) throw new Error("NewReportButton needs a 'newRecommendationReportUrl' property");
          return e;
        }
      }, {
        key: "_newFieldReportUrl",
        get: function () {
          var e = this.props.newFieldReportUrl;
          if (!e) throw new Error("NewReportButton needs a 'newFieldReportUrl' property");
          return e;
        }
      }, {
        key: "_newProductReportUrl",
        get: function () {
          var e = this.props.newProductReportUrl;
          if (!e) throw new Error("NewReportButton needs a 'newProductReportUrl' property");
          return e;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return p.a.createElement(_8, {
            variant: "primary",
            title: e("new_report"),
            className: "btn-text"
          }, p.a.createElement(_c.Item, {
            href: this._newApplicationRecordReportUrl
          }, e("application_record_report")), p.a.createElement(_c.Item, {
            href: this._newRecommendationReportUrl
          }, e("recommendation_report")), p.a.createElement(_c.Item, {
            href: this._newFieldReportUrl
          }, e("field_report")), p.a.createElement(_c.Item, {
            href: this._newProductReportUrl
          }, e("product_report")));
        }
      }]);
    }()).prototype, "_newApplicationRecordReportUrl", [f.computed], Object.getOwnPropertyDescriptor(P8.prototype, "_newApplicationRecordReportUrl"), P8.prototype), T8(P8.prototype, "_newRecommendationReportUrl", [f.computed], Object.getOwnPropertyDescriptor(P8.prototype, "_newRecommendationReportUrl"), P8.prototype), T8(P8.prototype, "_newFieldReportUrl", [f.computed], Object.getOwnPropertyDescriptor(P8.prototype, "_newFieldReportUrl"), P8.prototype), T8(P8.prototype, "_newProductReportUrl", [f.computed], Object.getOwnPropertyDescriptor(P8.prototype, "_newProductReportUrl"), P8.prototype), j8 = P8)) || j8,
        D8 = Object(g.a)()(N8);

    function x8(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, A8(n.key), n);
      }
    }

    function A8(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function M8(e, t, r) {
      return t = I8(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], I8(e).constructor) : t.apply(e, r));
    }

    function I8(e) {
      return (I8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function F8(e, t) {
      return (F8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var B8,
        L8 = Object(d.observer)(z8 = function (e) {
      function t(e) {
        var r, n;
        if (function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (n = M8(this, t, [e]))._csrf = null === (r = document.querySelector("[name='csrf-token']")) || void 0 === r ? void 0 : r.content, !n._csrf) throw new Error("PdfButton requires a csrf-token");
        return n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && F8(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props.selectedIds;
          return p.a.createElement("form", {
            className: "d-inline-block",
            action: "".concat(window.location.pathname, "/pdf"),
            method: "POST"
          }, p.a.createElement("input", {
            type: "hidden",
            name: "authenticity_token",
            value: this._csrf
          }), e.map(function (e) {
            return p.a.createElement("input", {
              type: "hidden",
              name: "recommendations[]",
              key: e,
              value: e
            });
          }), p.a.createElement("input", {
            type: "submit",
            className: "btn btn-outline-recommendations mr-1",
            disabled: 0 == e.length,
            value: "PDF"
          }));
        }
      }]) && x8(r.prototype, n), o && x8(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || z8;

    function V8(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, U8(n.key), n);
      }
    }

    function U8(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function q8(e, t, r) {
      return t = K8(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], K8(e).constructor) : t.apply(e, r));
    }

    function K8(e) {
      return (K8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function G8(e, t) {
      return (G8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var W8,
        H8,
        J8,
        Y8,
        Q8,
        $8,
        X8,
        Z8,
        e7,
        t7,
        r7 = Object(d.observer)(B8 = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), q8(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && G8(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && V8(e.prototype, t), r && V8(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.activeIngredients,
              r = e.onEditActiveIngredient,
              n = e.onRemoveActiveIngredient,
              o = e.onShowActiveIngredientModal,
              i = e.t;
          return p.a.createElement(p.a.Fragment, null, t.map(function (e) {
            var t;
            return p.a.createElement(s.Fragment, {
              key: e.id
            }, p.a.createElement("input", {
              name: "product[active_ingredients][][id]",
              type: "hidden",
              value: e.id
            }), p.a.createElement("input", {
              name: "product[active_ingredients][][name]",
              type: "hidden",
              value: e.name
            }), p.a.createElement("input", {
              name: "product[active_ingredients][][cas]",
              type: "hidden",
              value: e.cas
            }), p.a.createElement("input", {
              name: "product[active_ingredients][][percent]",
              type: "hidden",
              value: e.percent
            }), p.a.createElement("input", {
              name: "product[active_ingredients][][liquid_concentration]",
              type: "hidden",
              value: (null === (t = e.liquidConcentration) || void 0 === t ? void 0 : t.displayValue) || ""
            }), (e.alternateNames && e.alternateNames || []).map(function (e) {
              return p.a.createElement("input", {
                key: e,
                name: "product[active_ingredients][][alternate_names][]",
                type: "hidden",
                value: e
              });
            }));
          }), p.a.createElement(Ls, null, p.a.createElement("div", {
            className: "col-sm-12"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-success float-right",
            onClick: o
          }, i("add")))), t.length > 0 ? p.a.createElement(Ls, null, p.a.createElement("div", {
            className: "col-sm-12"
          }, p.a.createElement("table", {
            className: "table table-sm"
          }, p.a.createElement("thead", null, p.a.createElement("tr", null, p.a.createElement("th", {
            scope: "col"
          }, i("cas_number_short")), p.a.createElement("th", {
            scope: "col"
          }, i("name")), p.a.createElement("th", {
            scope: "col"
          }, "%"), p.a.createElement("th", {
            scope: "col"
          }, i("liquid_concentration")), p.a.createElement("th", {
            scope: "col",
            "aria-label": "Actions"
          }))), p.a.createElement("tbody", null, t.map(function (e) {
            var t;
            return p.a.createElement("tr", {
              key: e.id
            }, p.a.createElement("td", null, e.cas), p.a.createElement("td", null, e.name), p.a.createElement("td", null, e.percent), p.a.createElement("td", null, null === (t = e.liquidConcentration) || void 0 === t ? void 0 : t.displayValue), p.a.createElement("td", {
              className: "text-center"
            }, p.a.createElement("div", {
              className: "btn-group",
              role: "group",
              "aria-label": "Active ingredient actions"
            }, p.a.createElement("button", {
              type: "button",
              className: "btn btn-success btn-sm",
              onClick: function () {
                return r(e);
              }
            }, i("edit")), p.a.createElement("button", {
              type: "button",
              className: "btn btn-danger btn-sm",
              onClick: function () {
                return n(e);
              }
            }, i("remove")))));
          }))))) : null);
        }
      }]);
    }()) || B8,
        n7 = Object(g.a)()(r7);

    function o7(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function i7(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, a7(n.key), n);
      }
    }

    function a7(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function c7(e, t, r) {
      return t = u7(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], u7(e).constructor) : t.apply(e, r));
    }

    function u7(e) {
      return (u7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function l7(e, t) {
      return (l7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function s7(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var p7,
        f7,
        d7,
        b7,
        y7,
        m7,
        v7,
        h7,
        g7,
        w7,
        O7,
        j7,
        P7,
        _7,
        E7,
        S7,
        C7,
        k7,
        R7,
        T7,
        z7,
        N7,
        D7,
        x7,
        A7,
        M7,
        I7,
        F7,
        B7,
        L7 = Object(d.observer)((J8 = s7((H8 = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), o7(r = c7(this, t, [e]), "liquidConcentrationUnits", J8, r), o7(r, "liquidConcentrationScalar", Y8, r), o7(r, "onUpdatePercent", Q8, r), o7(r, "updateLiquidConcentration", $8, r), o7(r, "handleUpdateliquidConcentrationUnit", X8, r), o7(r, "handleUpdateliquidConcentrationScalar", Z8, r), o7(r, "onSelectorChange", e7, r), o7(r, "onSelectorSearch", t7, r), r.selector = new h.SelectorModel(r.nameOptions), r.selectOptionsDisposer = Object(f.reaction)(function () {
          return r.nameOptions;
        }, function (e) {
          var t = r.props.activeIngredient;
          r.selector = new h.SelectorModel(e), r.selector.changeByText(t.name);
        }, {
          fireImmediately: !0
        }), r.liquidConcentrationDisposer = Object(f.reaction)(function () {
          var e = r.props.activeIngredient;
          return null == e ? void 0 : e.liquidConcentration;
        }, function (e) {
          r.liquidConcentrationScalar = (null == e ? void 0 : e.scalar) || "", r.liquidConcentrationUnits = null != e && e.units ? w.Quantity.formatUnits(e.units) : "";
        }, {
          fireImmediately: !0
        }), r.aiNameDisposer = Object(f.autorun)(function () {
          var e = r.props.activeIngredient;
          r.selector.changeByText(e.name), r.selector.search(e.name);
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && l7(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && i7(e.prototype, t), r && i7(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "nameOptions",
        get: function () {
          var e = this.props.activeIngredientNames;
          return ee(e || []).sort(h.naturalSort).map(function (e) {
            return {
              key: e,
              text: e,
              value: e
            };
          });
        }
      }, {
        key: "liquidConcentration",
        get: function () {
          if (!this.liquidConcentrationScalar || !this.liquidConcentrationUnits) return null;
          var e = new w.Quantity();
          return e.scalar = this.liquidConcentrationScalar, e.units = this.liquidConcentrationUnits, e;
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.selectOptionsDisposer(), this.aiNameDisposer(), this.liquidConcentrationDisposer();
        }
      }, {
        key: "liquidConcentrationUnitChoices",
        value: function () {
          return [{
            value: "lbs/gal"
          }, {
            value: "g/L"
          }];
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.activeIngredient,
              r = e.t;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("div", {
            className: "form-group row"
          }, p.a.createElement("div", {
            className: "col-sm-2"
          }, p.a.createElement("label", {
            className: "mb-1 text-uppercase font-weight-bold"
          }, "CAS")), p.a.createElement("div", {
            className: "col-sm-10"
          }, p.a.createElement("p", {
            "aria-label": "CAS Number",
            className: "h5 mb-1"
          }, t.cas))), p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", {
            className: "mb-1 text-uppercase font-weight-bold"
          }, r("name")), p.a.createElement(h.SelectDropdown, {
            placeholder: r("name"),
            options: this.selector.options,
            onChange: this.onSelectorChange,
            model: this.selector
          })), p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col-sm-7"
          }, p.a.createElement("label", {
            className: "mb-1 text-uppercase font-weight-bold"
          }, r("percent")), p.a.createElement("div", {
            className: "input-group"
          }, p.a.createElement("input", {
            type: "number",
            className: "form-control",
            placeholder: r("percent"),
            "aria-label": "Active Ingredient Percent",
            id: "active_ingredient_percent",
            value: t.percent,
            min: 0,
            max: 100,
            onChange: this.onUpdatePercent
          }), p.a.createElement("div", {
            className: "input-group-append"
          }, p.a.createElement("span", {
            className: "input-group-text"
          }, "%")))))), p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col-sm-7"
          }, p.a.createElement("label", {
            className: "mb-1 text-uppercase font-weight-bold"
          }, r("liquid_concentration")), p.a.createElement("div", {
            className: "input-group"
          }, p.a.createElement(h.UnitSelector, {
            placeholder: r("concentration"),
            currentUnit: this.liquidConcentrationUnits,
            currentValue: this.liquidConcentrationScalar,
            unitChoices: this.liquidConcentrationUnitChoices(),
            valueColumnClassName: "col-md-5 unit-selector-value",
            unitColumnClassName: "col-md-7 unit-selector-unit",
            onUpdateUnit: this.handleUpdateliquidConcentrationUnit,
            onUpdateValue: this.handleUpdateliquidConcentrationScalar
          }))))));
        }
      }]);
    }()).prototype, "liquidConcentrationUnits", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Y8 = s7(H8.prototype, "liquidConcentrationScalar", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), s7(H8.prototype, "nameOptions", [f.computed], Object.getOwnPropertyDescriptor(H8.prototype, "nameOptions"), H8.prototype), s7(H8.prototype, "liquidConcentration", [f.computed], Object.getOwnPropertyDescriptor(H8.prototype, "liquidConcentration"), H8.prototype), Q8 = s7(H8.prototype, "onUpdatePercent", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          (0, e.props.onUpdatePercent)(t.target.value);
        };
      }
    }), $8 = s7(H8.prototype, "updateLiquidConcentration", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          (0, e.props.onUpdateLiquidConcentration)(e.liquidConcentration);
        };
      }
    }), X8 = s7(H8.prototype, "handleUpdateliquidConcentrationUnit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.liquidConcentrationUnits = t, e.updateLiquidConcentration();
        };
      }
    }), Z8 = s7(H8.prototype, "handleUpdateliquidConcentrationScalar", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.liquidConcentrationScalar = t, e.updateLiquidConcentration();
        };
      }
    }), e7 = s7(H8.prototype, "onSelectorChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          (0, e.props.onUpdateName)(t && t.value || ""), e.selector.change(t);
        };
      }
    }), t7 = s7(H8.prototype, "onSelectorSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          (0, e.props.onUpdateName)(t), e.selector.search(t);
        };
      }
    }), W8 = H8)) || W8,
        V7 = Object(g.a)()(L7);

    function U7(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function q7(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? U7(Object(r), !0).forEach(function (t) {
          K7(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : U7(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function K7(e, t, r) {
      return (t = H7(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function G7(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function W7(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, H7(n.key), n);
      }
    }

    function H7(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function J7(e, t, r) {
      return t = Y7(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Y7(e).constructor) : t.apply(e, r));
    }

    function Y7(e) {
      return (Y7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Q7(e, t) {
      return (Q7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function $7(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var X7,
        Z7,
        e9,
        t9,
        r9,
        n9,
        o9,
        i9,
        a9,
        c9,
        u9,
        l9,
        s9,
        p9,
        f9,
        d9,
        b9,
        y9,
        m9 = Object(d.observer)(((B7 = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = J7(this, t, [e])).casSelector = new h.SelectorModel(r.aiOptions), r.nameSelector = new h.SelectorModel(r.aiOptions), G7(r, "aiOptions", d7, r), G7(r, "aiPercent", b7, r), G7(r, "aiLiquidConcentration", y7, r), G7(r, "casSearch", m7, r), G7(r, "nameSearch", v7, r), G7(r, "selectedKey", h7, r), G7(r, "selectedValue", g7, r), G7(r, "customizeName", w7, r), G7(r, "customizePercent", O7, r), G7(r, "customizeLiquidConcentration", j7, r), G7(r, "onAddActiveIngredient", P7, r), G7(r, "onButtonClick", _7, r), G7(r, "onCasClear", E7, r), G7(r, "onCasSearch", S7, r), G7(r, "onCasChange", C7, r), G7(r, "onCasFocus", k7, r), G7(r, "onNameClear", R7, r), G7(r, "onNameChange", T7, r), G7(r, "onNameSearch", z7, r), G7(r, "handleChange", N7, r), G7(r, "onSave", D7, r), G7(r, "onSearchEPA", x7, r), G7(r, "onClose", A7, r), G7(r, "onBlur", M7, r), G7(r, "onNameFocus", I7, r), G7(r, "reset", F7, r), r.activeIngredientsDisposer = Object(f.reaction)(function () {
          return r.props.activeIngredients;
        }, function (e) {
          r.aiOptions = e.slice().sort(function (e, t) {
            return Object(h.naturalSort)(e.name, t.name);
          }).reduce(function (e, t) {
            return e.concat({
              key: t.id,
              text: [].concat(t.cas ? t.cas : []).concat(t.name ? t.name : []).join(" : "),
              value: {
                activeIngredient: t,
                name: t.name
              }
            }).concat(t.alternateNames.slice().sort(function (e, t) {
              return Object(h.naturalSort)(e, t);
            }).map(function (e) {
              return {
                key: "".concat(t.id, "-").concat(t.cas, "-").concat(e),
                text: "\t".concat([].concat(t.cas ? t.cas : []).concat(e || []).join(" : ")),
                value: {
                  activeIngredient: t,
                  name: e
                }
              };
            }));
          }, []), r.casSelector = new h.SelectorModel(r.aiOptions), r.casSelector.changeByKey(r.selectedKey), r.casSelector.search(r.casSearch, !0), r.selectedValue = r.casSelector.selectedValue, r.nameSelector = new h.SelectorModel(r.aiOptions), r.nameSelector.changeByKey(r.selectedKey), r.nameSelector.search(r.nameSearch, !0);
        }, {
          fireImmediately: !0
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Q7(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && W7(e.prototype, t), r && W7(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "selectedAI",
        get: function () {
          return this.selectedValue && this.selectedValue.activeIngredient;
        }
      }, {
        key: "selectedName",
        get: function () {
          return this.selectedValue && this.selectedValue.name || "";
        }
      }, {
        key: "aiToCustomize",
        get: function () {
          return new w.ActiveIngredient(q7(q7({}, this.selectedAI || {}), {}, {
            cas: this.casSearch,
            name: this.nameSearch,
            percent: this.aiPercent,
            liquidConcentration: this.aiLiquidConcentration
          }));
        }
      }, {
        key: "selectedAINames",
        get: function () {
          return (this.selectedAI && this.selectedAI.alternateNames && this.selectedAI.alternateNames || []).slice().concat(this.selectedName || []).sort(function (e, t) {
            return Object(h.naturalSort)(e, t);
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.activeIngredientsDisposer();
        }
      }, {
        key: "focusCasSelector",
        value: function () {
          v()(".select-dropdown.cas-selector input").focus();
        }
      }, {
        key: "focusNameSelector",
        value: function () {
          v()(".select-dropdown.name-selector input").focus();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.id,
              r = e.className,
              n = e.wizardModel,
              o = e.t;
          return p.a.createElement(h.ModalDialog, {
            id: t,
            dismissOnClose: !1,
            className: r
          }, p.a.createElement(h.ModalHeader, {
            title: o(n.modalTitle),
            onClose: this.onClose
          }), p.a.createElement("form", null, p.a.createElement(h.ModalBody, null, p.a.createElement("div", {
            className: "col py-3 px-5"
          }, "customizing-ai" === n.stage ? p.a.createElement(p.a.Fragment, null, p.a.createElement(V7, {
            activeIngredient: this.aiToCustomize,
            activeIngredientNames: this.selectedAINames,
            onUpdateName: this.customizeName,
            onUpdatePercent: this.customizePercent,
            onUpdateLiquidConcentration: this.customizeLiquidConcentration
          })) : p.a.createElement(p.a.Fragment, null, p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", {
            className: "mb-1 text-uppercase font-weight-bold"
          }, "CAS"), p.a.createElement(h.SelectDropdown, {
            className: "cas-selector",
            placeholder: o("search_by_cas"),
            options: this.casSelector.options,
            onBlur: this.onBlur,
            onFocus: this.onCasFocus,
            onChange: this.onCasChange,
            onClearSearch: this.onCasClear,
            onSearch: this.onCasSearch,
            onKeyDown: this.onKeyDown,
            allowFreehanding: !0,
            model: this.casSelector
          })), p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("label", {
            className: "mb-1 text-uppercase font-weight-bold"
          }, o("name")), p.a.createElement(h.SelectDropdown, {
            className: "name-selector",
            placeholder: o("search_by_name"),
            options: this.nameSelector.options,
            onBlur: this.onBlur,
            onFocus: this.onNameFocus,
            onChange: this.onNameChange,
            onClearSearch: this.onNameClear,
            onSearch: this.onNameSearch,
            onKeyDown: this.onKeyDown,
            allowFreehanding: !0,
            model: this.nameSelector
          }))), p.a.createElement("p", {
            "aria-label": "Feedback Text",
            className: "feedback-text".concat(n.isErrorStage ? " text-danger" : "")
          }, o(n.feedbackText)), n.showSpinner ? p.a.createElement(h.Spinner, null) : null, p.a.createElement("div", {
            className: "mt-3 mb-5"
          }, p.a.createElement("button", {
            type: "submit",
            className: "btn btn-lg font-weight-bold text-uppercase ".concat(n.buttonClass).concat(n.isButtonDisabled ? " disabled" : ""),
            "aria-label": "Wizard Button",
            onClick: this.onButtonClick
          }, o(n.buttonText), n.showEllipsisBtn ? p.a.createElement("i", {
            className: "fas fa-ellipsis-h fa-2x ellipsis-btn"
          }) : null))))));
        }
      }]);
    }()).defaultProps = {
      onClose: function () {}
    }, d7 = $7((f7 = B7).prototype, "aiOptions", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), b7 = $7(f7.prototype, "aiPercent", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), y7 = $7(f7.prototype, "aiLiquidConcentration", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), m7 = $7(f7.prototype, "casSearch", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), v7 = $7(f7.prototype, "nameSearch", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), h7 = $7(f7.prototype, "selectedKey", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), g7 = $7(f7.prototype, "selectedValue", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), $7(f7.prototype, "selectedAI", [f.computed], Object.getOwnPropertyDescriptor(f7.prototype, "selectedAI"), f7.prototype), $7(f7.prototype, "selectedName", [f.computed], Object.getOwnPropertyDescriptor(f7.prototype, "selectedName"), f7.prototype), $7(f7.prototype, "aiToCustomize", [f.computed], Object.getOwnPropertyDescriptor(f7.prototype, "aiToCustomize"), f7.prototype), $7(f7.prototype, "selectedAINames", [f.computed], Object.getOwnPropertyDescriptor(f7.prototype, "selectedAINames"), f7.prototype), w7 = $7(f7.prototype, "customizeName", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.nameSearch = t;
        };
      }
    }), O7 = $7(f7.prototype, "customizePercent", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.aiPercent = t;
        };
      }
    }), j7 = $7(f7.prototype, "customizeLiquidConcentration", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.aiLiquidConcentration = t;
        };
      }
    }), P7 = $7(f7.prototype, "onAddActiveIngredient", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.wizardModel,
              n = t.onAddActiveIngredient;
          return r.addActiveIngredient(), n({
            name: e.nameSearch,
            cas: e.casSearch
          }).then(function (t) {
            return e.selectedKey = t && t.id || "", e.nameSelector.changeByKey(e.selectedKey), e.casSelector.changeByKey(e.selectedKey), r.addedAI();
          }).catch(function (e) {
            return r.error(e);
          });
        };
      }
    }), _7 = $7(f7.prototype, "onButtonClick", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.wizardModel;
          return t.preventDefault(), "ready-to-search-epa" === r.stage || "error-searching-epa" === r.stage ? e.onSearchEPA() : "ready-to-add-ai" === r.stage ? e.onAddActiveIngredient() : "ai-selected" === r.stage ? r.applyActiveIngredient() : void ("customizing-ai" === r.stage && e.onSave());
        };
      }
    }), E7 = $7(f7.prototype, "onCasClear", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.wizardModel;
          e.onCasSearch(""), e.onNameSearch(e.nameSearch), e.casSelector.change(null), e.nameSearch ? t.notFound() : t.startOver();
        };
      }
    }), S7 = $7(f7.prototype, "onCasSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.onSearch,
              o = r.wizardModel;
          e.casSearch = t, n(t), e.casSelector.search(t, !0), o.searchDatabase();
        };
      }
    }), C7 = $7(f7.prototype, "onCasChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t && (e.selectedKey = (null == t ? void 0 : t.key) || "", e.casSelector.changeByKey(t.key), e.onCasSearch(t.value.activeIngredient.cas), e.nameSelector.changeByKey(t.key), e.onNameSearch(t.value.name), e.handleChange());
        };
      }
    }), k7 = $7(f7.prototype, "onCasFocus", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.onCasSearch(e.casSearch);
        };
      }
    }), R7 = $7(f7.prototype, "onNameClear", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.wizardModel;
          e.onNameSearch(""), e.onCasSearch(e.casSearch), e.nameSelector.change(null), e.casSearch ? t.notFound() : t.startOver();
        };
      }
    }), T7 = $7(f7.prototype, "onNameChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t && (e.selectedKey = (null == t ? void 0 : t.key) || "", e.casSelector.changeByKey(t.key), e.onCasSearch(t.value.activeIngredient.cas), e.nameSelector.changeByKey(t.key), e.onNameSearch(t.value.name), e.handleChange());
        };
      }
    }), z7 = $7(f7.prototype, "onNameSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.onSearch,
              o = r.wizardModel;
          e.nameSearch = t, n(t), e.nameSelector.search(t, !0), o.searchDatabase();
        };
      }
    }), N7 = $7(f7.prototype, "handleChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.wizardModel;
          e.nameSelector.searchText || e.casSelector.searchText || t.startOver(), "" === e.nameSelector.selectedIndex && "" === e.casSelector.selectedIndex ? t.notFound() : t.selectActiveIngredient();
        };
      }
    }), D7 = $7(f7.prototype, "onSave", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.wizardModel;
          (0, t.onSave)(e.aiToCustomize), r.save(), e.reset();
        };
      }
    }), x7 = $7(f7.prototype, "onSearchEPA", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.wizardModel,
              n = t.onSearchEPA;
          return r.searchEPA(), Promise.all([n(e.casSearch), n(e.nameSearch)]).then(function (t) {
            return t[0].length > 0 ? (e.focusCasSelector(), r.foundResults()) : t[1].length > 0 ? (e.focusNameSelector(), r.foundResults()) : r.notFound();
          }).catch(function (e) {
            return r.error(e);
          });
        };
      }
    }), A7 = $7(f7.prototype, "onClose", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.wizardModel;
          (0, t.onClose)(), r.close(), e.reset();
        };
      }
    }), M7 = $7(f7.prototype, "onBlur", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.handleChange();
        };
      }
    }), I7 = $7(f7.prototype, "onNameFocus", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.onNameSearch(e.nameSearch);
        };
      }
    }), F7 = $7(f7.prototype, "reset", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.casSelector.reset(), e.nameSelector.reset(), e.casSearch = "", e.nameSearch = "", e.selectedKey = "", e.selectedValue = null, e.aiPercent = "", e.aiLiquidConcentration = "";
        };
      }
    }), p7 = f7)) || p7,
        v9 = Object(g.a)()(m9);

    function h9(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function g9(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, w9(n.key), n);
      }
    }

    function w9(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function O9(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var j9,
        P9,
        _9,
        E9,
        S9,
        C9,
        k9,
        R9,
        T9,
        z9 = (Z7 = O9((X7 = function () {
      return e = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), h9(this, "stage", Z7, this), h9(this, "modalTitle", e9, this), h9(this, "isShowing", t9, this), h9(this, "lastError", r9, this), h9(this, "addActiveIngredient", n9, this), h9(this, "addedAI", o9, this), h9(this, "applyActiveIngredient", i9, this), h9(this, "close", a9, this), h9(this, "error", c9, this), h9(this, "foundResults", u9, this), h9(this, "notFound", l9, this), h9(this, "save", s9, this), h9(this, "searchDatabase", p9, this), h9(this, "searchEPA", f9, this), h9(this, "selectActiveIngredient", d9, this), h9(this, "setStage", b9, this), h9(this, "startOver", y9, this);
      }, (t = [{
        key: "feedbackText",
        get: function () {
          return "ready-to-search-epa" === this.stage ? "ingredient_not_found_in_database" : "ready-to-add-ai" === this.stage ? "ingredient_not_found" : "error-searching-epa" === this.stage || "error-adding-ai" === this.stage ? this.lastError : "";
        }
      }, {
        key: "isButtonDisabled",
        get: function () {
          return "start" === this.stage || "searching-database" === this.stage || "searching-epa" === this.stage || "adding-ai" === this.stage;
        }
      }, {
        key: "isErrorStage",
        get: function () {
          return "error-searching-epa" === this.stage || "error-adding-ai" === this.stage;
        }
      }, {
        key: "buttonClass",
        get: function () {
          return "customizing-ai" === this.stage ? "btn-success" : "btn-primary";
        }
      }, {
        key: "buttonText",
        get: function () {
          return "ai-selected" === this.stage ? "apply" : "customizing-ai" === this.stage ? "save" : "ready-to-search-epa" === this.stage || "error-searching-epa" === this.stage ? "search_epa" : "searching-epa" === this.stage ? "searching_epa" : "ready-to-add-ai" === this.stage || "error-adding-ai" === this.stage ? "add" : "adding-ai" === this.stage ? "adding" : "";
        }
      }, {
        key: "showEllipsisBtn",
        get: function () {
          return "start" === this.stage || "searching-database" === this.stage;
        }
      }, {
        key: "showSpinner",
        get: function () {
          return "searching-epa" === this.stage || "adding-ai" === this.stage;
        }
      }]) && g9(e.prototype, t), r && g9(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "stage", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "start";
      }
    }), e9 = O9(X7.prototype, "modalTitle", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "find_active_ingredient";
      }
    }), t9 = O9(X7.prototype, "isShowing", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !0;
      }
    }), r9 = O9(X7.prototype, "lastError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), O9(X7.prototype, "feedbackText", [f.computed], Object.getOwnPropertyDescriptor(X7.prototype, "feedbackText"), X7.prototype), O9(X7.prototype, "isButtonDisabled", [f.computed], Object.getOwnPropertyDescriptor(X7.prototype, "isButtonDisabled"), X7.prototype), O9(X7.prototype, "isErrorStage", [f.computed], Object.getOwnPropertyDescriptor(X7.prototype, "isErrorStage"), X7.prototype), O9(X7.prototype, "buttonClass", [f.computed], Object.getOwnPropertyDescriptor(X7.prototype, "buttonClass"), X7.prototype), O9(X7.prototype, "buttonText", [f.computed], Object.getOwnPropertyDescriptor(X7.prototype, "buttonText"), X7.prototype), O9(X7.prototype, "showEllipsisBtn", [f.computed], Object.getOwnPropertyDescriptor(X7.prototype, "showEllipsisBtn"), X7.prototype), O9(X7.prototype, "showSpinner", [f.computed], Object.getOwnPropertyDescriptor(X7.prototype, "showSpinner"), X7.prototype), n9 = O9(X7.prototype, "addActiveIngredient", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          "ready-to-add-ai" !== e.stage && "error-adding-ai" !== e.stage || e.setStage("adding-ai");
        };
      }
    }), o9 = O9(X7.prototype, "addedAI", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          "adding-ai" === e.stage && (e.modalTitle = "set_active_ingredient_percent", e.setStage("customizing-ai"));
        };
      }
    }), i9 = O9(X7.prototype, "applyActiveIngredient", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          "ai-selected" === e.stage && (e.modalTitle = "set_active_ingredient_percent", e.setStage("customizing-ai"));
        };
      }
    }), a9 = O9(X7.prototype, "close", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isShowing = !1, e.modalTitle = "find_active_ingredient", e.setStage("start");
        };
      }
    }), c9 = O9(X7.prototype, "error", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          "searching-epa" === e.stage && (e.lastError = t && t.message || "Unexpected error encountered!", e.setStage("error-searching-epa")), "adding-ai" === e.stage && (e.lastError = t && t.message || "Unexpected error encountered!", e.setStage("error-adding-ai"));
        };
      }
    }), u9 = O9(X7.prototype, "foundResults", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          "searching-epa" === e.stage && e.setStage("searching-database");
        };
      }
    }), l9 = O9(X7.prototype, "notFound", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          "searching-database" === e.stage && e.setStage("ready-to-search-epa"), "searching-epa" === e.stage && (e.modalTitle = "add_active_ingredient", e.setStage("ready-to-add-ai"));
        };
      }
    }), s9 = O9(X7.prototype, "save", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          "customizing-ai" === e.stage && (e.isShowing = !1, e.modalTitle = "find_active_ingredient", e.setStage("start"));
        };
      }
    }), p9 = O9(X7.prototype, "searchDatabase", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          "start" !== e.stage && "error-adding-ai" !== e.stage && "error-searching-epa" !== e.stage && "ready-to-search-epa" !== e.stage && "ready-to-add-ai" !== e.stage && "ai-selected" !== e.stage || e.setStage("searching-database");
        };
      }
    }), f9 = O9(X7.prototype, "searchEPA", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          "ready-to-search-epa" !== e.stage && "error-searching-epa" !== e.stage || e.setStage("searching-epa");
        };
      }
    }), d9 = O9(X7.prototype, "selectActiveIngredient", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          "searching-database" === e.stage && e.setStage("ai-selected");
        };
      }
    }), b9 = O9(X7.prototype, "setStage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.stage = t;
        };
      }
    }), y9 = O9(X7.prototype, "startOver", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isShowing = !0, e.modalTitle = "find_active_ingredient", e.setStage("start");
        };
      }
    }), X7);

    function N9(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function D9(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, x9(n.key), n);
      }
    }

    function x9(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function A9(e, t, r) {
      return t = M9(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], M9(e).constructor) : t.apply(e, r));
    }

    function M9(e) {
      return (M9 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function I9(e, t) {
      return (I9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function F9(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var B9,
        L9 = Object(d.observer)((_9 = F9((P9 = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return N9(e = A9(this, t, [].concat(n)), "searchIsFocused", _9, e), N9(e, "searchTerm", E9, e), N9(e, "updateName", S9, e), N9(e, "updatePercent", C9, e), N9(e, "updateLiquidConcentration", k9, e), N9(e, "focusSearch", R9, e), N9(e, "blurSearch", T9, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && I9(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && D9(e.prototype, t), r && D9(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "showDropdown",
        get: function () {
          var e = this.props.activeIngredients;
          return this.searchIsFocused && e.length > 0;
        }
      }, {
        key: "disableEPASearch",
        get: function () {
          return this.props.activeIngredients.length > 0 || !this.searchTerm;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.id,
              r = e.activeIngredient,
              n = e.activeIngredientNames,
              o = e.onOk,
              i = e.onCancel,
              a = e.onRemove,
              c = e.t;
          return p.a.createElement(h.ModalDialog, {
            id: t,
            className: "edit-active-ingredient-modal if2-modal",
            dismissOnClose: !1
          }, p.a.createElement(h.ModalHeader, {
            title: "Edit Active Ingredient"
          }), p.a.createElement("form", null, p.a.createElement(h.ModalBody, null, p.a.createElement("div", {
            className: "col py-3 px-5"
          }, p.a.createElement(V7, {
            activeIngredient: r,
            activeIngredientNames: n,
            onUpdateName: this.updateName,
            onUpdatePercent: this.updatePercent,
            onUpdateLiquidConcentration: this.updateLiquidConcentration
          }), p.a.createElement("div", {
            className: "row mt-4 mb-5"
          }, p.a.createElement("div", {
            className: "col mr-auto"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-danger btn-lg font-weight-bold text-uppercase",
            "data-dismiss": "modal",
            onClick: function (e) {
              e.preventDefault(), a(r);
            }
          }, c("remove"))), p.a.createElement("div", {
            className: "col ml-auto d-flex justify-content-between"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-secondary btn-lg font-weight-bold text-uppercase",
            "data-dismiss": "modal",
            onClick: i
          }, c("cancel")), p.a.createElement("button", {
            type: "submit",
            className: "btn btn-primary btn-lg font-weight-bold text-uppercase",
            "data-dismiss": "modal",
            onClick: o
          }, c("ok"))))))));
        }
      }]);
    }()).prototype, "searchIsFocused", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), E9 = F9(P9.prototype, "searchTerm", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), F9(P9.prototype, "showDropdown", [f.computed], Object.getOwnPropertyDescriptor(P9.prototype, "showDropdown"), P9.prototype), F9(P9.prototype, "disableEPASearch", [f.computed], Object.getOwnPropertyDescriptor(P9.prototype, "disableEPASearch"), P9.prototype), S9 = F9(P9.prototype, "updateName", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.activeIngredient.name = t;
        };
      }
    }), C9 = F9(P9.prototype, "updatePercent", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.activeIngredient.percent = t;
        };
      }
    }), k9 = F9(P9.prototype, "updateLiquidConcentration", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.activeIngredient.liquidConcentration = t;
        };
      }
    }), R9 = F9(P9.prototype, "focusSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.searchIsFocused = !0;
        };
      }
    }), T9 = F9(P9.prototype, "blurSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.searchIsFocused = !1;
        };
      }
    }), j9 = P9)) || j9,
        V9 = Object(g.a)()(L9);

    function U9(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, q9(n.key), n);
      }
    }

    function q9(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function K9(e, t, r) {
      return t = G9(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], G9(e).constructor) : t.apply(e, r));
    }

    function G9(e) {
      return (G9 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function W9(e, t) {
      return (W9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var H9,
        J9,
        Y9 = Object(d.observer)(B9 = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), K9(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && W9(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && U9(e.prototype, t), r && U9(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.nutrientAnalysis,
              r = e.t,
              n = {
            left: ["n", "p", "k", "s", "ca", "mg", "humicAcid"],
            right: ["al", "b", "cu", "fe", "mn", "mo", "si", "zn"]
          };
          return p.a.createElement(p.a.Fragment, null, p.a.createElement(Ls, null, Object.keys(n).map(function (e) {
            return p.a.createElement("div", {
              key: e,
              className: "col-sm-6 nutrient-analysis"
            }, p.a.createElement("table", {
              className: "table table-sm"
            }, p.a.createElement("thead", null, p.a.createElement("tr", null, p.a.createElement("th", {
              className: "text-center",
              scope: "col"
            }, r("name")), p.a.createElement("th", {
              className: "text-center",
              scope: "col"
            }, "%"))), p.a.createElement("tbody", null, n[e].map(function (e) {
              var r = e.replace(/([A-Z])/g, " $1").trim().split(" ").map(function (e) {
                return "".concat(e.slice(0, 1).toUpperCase()).concat(e.slice(1));
              }).join(" ");
              return p.a.createElement("tr", {
                key: e
              }, p.a.createElement("td", {
                className: "text-right"
              }, r), p.a.createElement("td", {
                "aria-label": "Nutrient Value"
              }, p.a.createElement("input", {
                className: "form-control form-control-sm col",
                placeholder: r,
                name: "product[nutrient_analysis][".concat(e, "]"),
                type: "number",
                min: "0",
                max: "100",
                step: "any",
                value: t[e],
                onChange: function (r) {
                  return t[e] = r.target.value;
                }
              })));
            }))));
          })));
        }
      }]);
    }()) || B9,
        Q9 = Object(g.a)()(Y9);

    function $9(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, X9(n.key), n);
      }
    }

    function X9(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Z9(e, t, r) {
      return t = eee(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], eee(e).constructor) : t.apply(e, r));
    }

    function eee(e) {
      return (eee = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function tee(e, t) {
      return (tee = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var ree = 13,
        nee = Object(d.observer)(((J9 = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = Z9(this, t, [].concat(n))).handleClick = function () {
          var t = e.props,
              r = t.node;
          t.actions.handleClickNodeContent(r.id);
        }, e.handleKeyPress = function (t) {
          if (t.which === ree) return t.stopPropagation(), e.handleClick();
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && tee(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.node,
              r = e.nodeClasses;
          return "grower" === t.account_type || "corporate" === t.account_type ? p.a.createElement("div", {
            className: r.join(" "),
            onClick: this.handleClick,
            onKeyPress: this.handleKeyPress,
            role: "button",
            tabIndex: "0"
          }, t.name) : p.a.createElement("div", {
            className: "content-wrapper not-clickable"
          }, t.name);
        }
      }]) && $9(r.prototype, n), o && $9(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).defaultProps = {
      nodeClasses: ["content-wrapper", "clickable"]
    }, H9 = J9)) || H9,
        oee = ["node"];

    function iee(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, aee(n.key), n);
      }
    }

    function aee(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function cee(e, t, r) {
      return t = uee(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], uee(e).constructor) : t.apply(e, r));
    }

    function uee(e) {
      return (uee = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function lee(e, t) {
      return (lee = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var see,
        pee = function (e) {
      return Object(d.observer)(function (t) {
        function r() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r), cee(this, r, arguments);
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && lee(e, t);
        }(r, s["Component"]), n = r, (o = [{
          key: "render",
          value: function () {
            var t = this.props,
                r = t.node,
                n = function (e, t) {
              if (null == e) return {};

              var r,
                  n,
                  o = function (e, t) {
                if (null == e) return {};
                var r = {};

                for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
                  if (t.includes(n)) continue;
                  r[n] = e[n];
                }

                return r;
              }(e, t);

              if (Object.getOwnPropertySymbols) {
                var i = Object.getOwnPropertySymbols(e);

                for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
              }

              return o;
            }(t, oee);

            return e.isReadOnly(r.id) ? p.a.createElement(hl, Object.assign({
              node: r
            }, n)) : p.a.createElement(nee, Object.assign({
              node: r
            }, n));
          }
        }]) && iee(n.prototype, o), i && iee(n, i), Object.defineProperty(n, "prototype", {
          writable: !1
        }), n;
        var n, o, i;
      }());
    };

    function fee(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, dee(n.key), n);
      }
    }

    function dee(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function bee(e, t, r) {
      return t = yee(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], yee(e).constructor) : t.apply(e, r));
    }

    function yee(e) {
      return (yee = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function mee(e, t) {
      return (mee = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var vee,
        hee,
        gee,
        wee,
        Oee,
        jee = Object(d.observer)(see = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = bee(this, t, [].concat(n))).handleToggleExpand = function (t) {
          var r = e.props,
              n = r.treeModel,
              o = r.accountsStore;
          n.toggleExpanded(t), n.isExpanded(t) && o.updateChildrenOf(t);
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && mee(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && fee(e.prototype, t), r && fee(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.t,
              r = e.handleClickNodeContent,
              n = e.treeModel;
          return p.a.createElement(h.ModalDialog, {
            id: "account-selector-modal",
            dataBackdrop: "static",
            ariaLabelledBy: "account-selector-modal-header",
            dismissOnClose: !1
          }, p.a.createElement(h.ModalHeader, {
            id: "account-selector-modal-header",
            title: t("choose_account")
          }), p.a.createElement(h.ModalBody, null, p.a.createElement(fl, {
            items: n.roots,
            model: n,
            ControlsComponent: Al,
            ContentComponent: pee(n),
            actions: {
              handleToggleExpand: this.handleToggleExpand,
              handleClickNodeContent: r
            }
          })), p.a.createElement("div", {
            className: "modal-footer"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-outline-secondary",
            "data-dismiss": "modal"
          }, t("cancel"))));
        }
      }]);
    }()) || see,
        Pee = Object(g.a)()(jee);

    function _ee(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Eee(e, t, r) {
      return (t = kee(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function See(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Cee(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, kee(n.key), n);
      }
    }

    function kee(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Ree(e, t, r) {
      return t = Tee(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Tee(e).constructor) : t.apply(e, r));
    }

    function Tee(e) {
      return (Tee = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function zee(e, t) {
      return (zee = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Nee(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Dee,
        xee,
        Aee,
        Mee,
        Iee,
        Fee,
        Bee,
        Lee,
        Vee,
        Uee,
        qee,
        Kee,
        Gee,
        Wee,
        Hee,
        Jee,
        Yee,
        Qee = Object(d.observer)((gee = Nee((hee = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), See(r = Ree(this, t, [e]), "urlOrFileModels", gee, r), See(r, "onAdd", wee, r), See(r, "onRemove", Oee, r);
        var n = r.props,
            o = n.product,
            i = n.t;
        return r.urlOrFileModels = ((null == o ? void 0 : o.attachments) || []).map(function (e, t) {
          return Y0.fromAttachment(function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {};
              t % 2 ? _ee(Object(r), !0).forEach(function (t) {
                Eee(e, t, r[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _ee(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
            }

            return e;
          }({
            submissionSourceName: "product[attachments][attachment-".concat(t, "][source]"),
            submissionUrlName: "product[attachments][attachment-".concat(t, "][external_url]"),
            submissionFilename: "product[attachments][attachment-".concat(t, "][file]"),
            urlPlaceholder: i("url")
          }, e));
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && zee(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Cee(e.prototype, t), r && Cee(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "setNames",
        value: function () {
          this.urlOrFileModels.forEach(function (e, t) {
            e.submissionSourceName = "product[attachments][attachment-".concat(t, "][source]"), e.submissionUrlName = "product[attachments][attachment-".concat(t, "][external_url]"), e.submissionFilename = "product[attachments][attachment-".concat(t, "][file]");
          });
        }
      }, {
        key: "lastIndex",
        value: function (e) {
          return e === this.urlOrFileModels.length - 1;
        }
      }, {
        key: "renderAddButtonRow",
        value: function () {
          var e = this.props.t;
          return p.a.createElement(Ls, null, p.a.createElement(Ws, null, this.urlOrFileModels.length ? "" : e("additional_attachments")), p.a.createElement("div", {
            className: "col-sm-10 d-flex justify-content-start px-3"
          }, p.a.createElement("a", {
            href: "#",
            className: "add-attachment-button",
            onClick: this.onAdd
          }, p.a.createElement("i", {
            className: "fas fa-plus-circle"
          }), p.a.createElement("span", null, e("add_attachment")))));
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props.t;
          return p.a.createElement("div", {
            className: "product-attachments"
          }, this.urlOrFileModels.map(function (r, n) {
            return p.a.createElement("div", {
              className: "product-attachment-rows",
              key: r.id
            }, p.a.createElement(Ls, null, p.a.createElement(Ws, null, !n && t("additional_attachments")), r.serial ? p.a.createElement("input", {
              type: "hidden",
              name: "product[attachments][attachment-".concat(n, "][serial]"),
              value: r.serial
            }) : null, p.a.createElement("div", {
              className: "product-attachment-title-container"
            }, p.a.createElement("input", {
              className: "form-control",
              placeholder: t("title"),
              name: "product[attachments][attachment-".concat(n, "][title]"),
              onChange: r.onChangeTitle,
              value: r.title
            }), p.a.createElement("a", {
              href: "#",
              onClick: function (t) {
                t.preventDefault(), e.onRemove(r.id);
              },
              "aria-label": "Remove"
            }, p.a.createElement("i", {
              className: "fa fa-times"
            })))), p.a.createElement(Ls, {
              className: e.lastIndex(n) ? void 0 : "last-product-attachment-row"
            }, p.a.createElement(Ws, null, " "), p.a.createElement(V0, {
              model: r
            })));
          }), this.renderAddButtonRow());
        }
      }]);
    }()).prototype, "urlOrFileModels", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), wee = Nee(hee.prototype, "onAdd", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.t,
              r = new Y0({
            urlPlaceholder: t("url")
          });
          e.urlOrFileModels.push(r), e.setNames();
        };
      }
    }), Oee = Nee(hee.prototype, "onRemove", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.urlOrFileModels.findIndex(function (e) {
            return e.id === t;
          });
          r >= 0 && e.urlOrFileModels.splice(r, 1), e.setNames();
        };
      }
    }), Nee(hee.prototype, "setNames", [f.action], Object.getOwnPropertyDescriptor(hee.prototype, "setNames"), hee.prototype), vee = hee)) || vee,
        $ee = Object(g.a)()(Qee);

    function Xee(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (null != r) {
          var n,
              o,
              i,
              a,
              c = [],
              u = !0,
              l = !1;

          try {
            if (i = (r = r.call(e)).next, 0 === t) {
              if (Object(r) !== r) return;
              u = !1;
            } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== t); u = !0);
          } catch (e) {
            l = !0, o = e;
          } finally {
            try {
              if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
            } finally {
              if (l) throw o;
            }
          }

          return c;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return Zee(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Zee(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Zee(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function ete(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function tte(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ete(Object(r), !0).forEach(function (t) {
          rte(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ete(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function rte(e, t, r) {
      return (t = ite(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function nte(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function ote(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ite(n.key), n);
      }
    }

    function ite(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ate(e, t, r) {
      return t = cte(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], cte(e).constructor) : t.apply(e, r));
    }

    function cte(e) {
      return (cte = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ute(e, t) {
      return (ute = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function lte(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var ste,
        pte,
        fte,
        dte,
        bte = Object(d.observer)(((Yee = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = ate(this, t, [e])).aiStore = void 0, nte(r, "product", Aee, r), nte(r, "addAIWizardModalId", Mee, r), nte(r, "editActiveIngredientModalId", Iee, r), nte(r, "currentActiveIngredient", Fee, r), nte(r, "isLoadingAccountsModal", Bee, r), nte(r, "addActiveIngredient", Lee, r), nte(r, "updateProductWithCurrentAI", Vee, r), nte(r, "handleSelectAI", Uee, r), nte(r, "handleSaveAI", qee, r), nte(r, "editActiveIngredient", Kee, r), nte(r, "removeActiveIngredient", Gee, r), nte(r, "handleAccountClickName", Wee, r), nte(r, "updateMassPerVolumeScalar", Hee, r), nte(r, "updateMassPerVolumeUnits", Jee, r);
        var n = e.product,
            o = e.newRecord,
            i = e.activeIngredientsStore,
            a = e.accountsStore,
            c = e.rootsForAccountSelector,
            u = e.readOnlyAncestors,
            l = e.treeModel,
            s = e.labelFilename,
            p = e.sdsFilename;

        if (r.labelUrlOrFileModel = new Y0({
          title: "label",
          submissionSourceName: "product[label_source]",
          submissionUrlName: "product[label_url]",
          submissionFilename: "product[label_file]",
          filename: s
        }), r.sdsUrlOrFileModel = new Y0({
          title: "sds",
          submissionSourceName: "product[sds_source]",
          submissionUrlName: "product[sds_url]",
          submissionFilename: "product[sds_file]",
          filename: p
        }), n && (r.product = o ? new _r(tte(tte({}, re(n)), {}, {
          nutrientAnalysis: n.nutrientAnalysis
        })) : _r.fromDocument(n)), r.labelUrlOrFileModel.url = !s && r.product.labelUrl || "", r.sdsUrlOrFileModel.url = !p && r.product.sdsUrl || "", r.aiStore = i || new hZ(new oZ()), r.accountsStore = a || new Tt(new N(), new qt()), c.forEach(function (e) {
          r.accountsStore.push(e);
        }), r.treeModel = l || new as(r.accountsStore), r.treeModel.setRoots(r.accountsStore.roots, (u || []).map(function (e) {
          return r.accountsStore.push(e);
        })), r.treeModel.sortRoots(), r.wizardModel = new z9(), r.product.isLiquid && !r.product.massPerVolume) {
          var f = Xee(r.constructor.massPerVolumeChoices, 1)[0];
          r.product.massPerVolume = new w.Quantity(), r.product.massPerVolume.units = f;
        }

        return r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ute(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && ote(e.prototype, t), r && ote(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "currentAINames",
        get: function () {
          var e = this.aiStore.find(this.currentActiveIngredient.id);
          return (e && e.alternateNames || []).concat(e && e.name || []);
        }
      }, {
        key: "baseUnit",
        get: function () {
          if (null === this.product.formulation) return "";
          var e = this.product.formulation.baseUnit;
          return void 0 === e ? "" : "" === e ? "count" : e;
        }
      }, {
        key: "massPerVolume",
        get: function () {
          var e = this.product.massPerVolume;
          return null != e && e.scalar && "0" !== e.scalar && e.units && e.displayValue || "";
        }
      }, {
        key: "componentDidMount",
        value: function () {
          this.aiStore.fetchAll();
        }
      }, {
        key: "stateRegistrationRow",
        value: function () {
          var e = this,
              t = this.props.t;
          return "Exempt" !== this.product.epaNumber ? "" : p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_state_registration_wa"
          }, t("wa_reg_number")), p.a.createElement(Xs, {
            placeholder: t("reg_number"),
            name: "product[state_registration][wa]",
            id: "product_state_registration_wa",
            value: this.product.stateRegistrationFor("WA") || "",
            onChange: function (t) {
              return e.product.setStateRegistration("WA", t.target.value);
            }
          }));
        }
      }, {
        key: "chooseAccount",
        value: function (e) {
          var t,
              r = this;
          if (e.preventDefault(), null !== (t = this.product.account) && void 0 !== t && t.id && !this.accountsStore.hasLoadedAncestorsWithContext) return this.isLoadingAccountsModal = !0, this.treeModel.openToAccounts([this.product.account.id]).then(function () {
            return Object(f.runInAction)(function () {
              r.isLoadingAccountsModal = !1;
            }), v()("#account-selector-modal").modal("show");
          });
          v()("#account-selector-modal").modal("show");
        }
      }, {
        key: "updateBaseUnit",
        value: function (e) {
          var t = "count" === e ? "" : e,
              r = new _r(tte({}, re(this.product)));

          if (this.product.newBaseUnit(t), this.product.isLiquid || (this.product.massPerVolume = new w.Quantity()), !r.isLiquid && this.product.isLiquid) {
            this.product.massPerVolume = new w.Quantity();
            var n = Xee(this.constructor.massPerVolumeChoices, 1)[0];
            this.product.massPerVolume.units = n;
          }
        }
      }, {
        key: "renderAccount",
        value: function () {
          var e = this.props,
              t = e.canCreateRootProducts,
              r = e.t;
          return this.product.account ? this.product.account.name : r(t ? "product_not_available_to_all_accounts" : "no_account_selected");
        }
      }, {
        key: "renderAccountChoiceButton",
        value: function () {
          var e = this,
              t = this.props,
              r = t.showAccountChoiceButton,
              n = t.t;
          if (r) return p.a.createElement(p.a.Fragment, null, p.a.createElement(Pee, {
            accountsStore: this.accountsStore,
            treeModel: this.treeModel,
            handleClickNodeContent: this.handleAccountClickName
          }), p.a.createElement("button", {
            type: "button",
            className: "btn btn-success ml-2",
            onClick: function (t) {
              return e.chooseAccount(t);
            }
          }, this.isLoadingAccountsModal ? p.a.createElement(h.Spinner, {
            containerClasses: ["accounts-button-spinner"],
            textClassNames: "text-white"
          }) : null, n("change_account")));
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t,
              r,
              n,
              o,
              i = this,
              a = this.props,
              c = a.authenticityToken,
              u = a.actionUrl,
              l = a.method,
              s = a.t;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement(v9, {
            id: this.addAIWizardModalId,
            activeIngredients: this.aiStore.filteredAIs,
            wizardModel: this.wizardModel,
            className: "add-ai-wizard if2-modal",
            onAddActiveIngredient: this.aiStore.create,
            onSearch: this.aiStore.filterActiveIngredients,
            onSearchEPA: this.aiStore.searchEPA,
            onSave: this.handleSaveAI
          }), p.a.createElement(V9, {
            activeIngredients: this.aiStore.filteredAIs,
            id: this.editActiveIngredientModalId,
            activeIngredient: this.currentActiveIngredient,
            activeIngredientNames: this.currentAINames,
            onOk: this.updateProductWithCurrentAI,
            onCancel: function () {
              i.currentActiveIngredient = new w.ActiveIngredient();
            },
            onRemove: this.removeActiveIngredient
          }), p.a.createElement("form", {
            "aria-label": "Product Form",
            action: u,
            encType: "multipart/form-data",
            method: ["put", "patch"].includes(l) ? "post" : l
          }, ["put", "patch"].includes(l) ? p.a.createElement("input", {
            type: "hidden",
            name: "_method",
            value: l
          }) : null, p.a.createElement("input", {
            type: "hidden",
            name: "authenticity_token",
            value: c
          }), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_epa_number"
          }, s("epa_number")), p.a.createElement(Xs, {
            placeholder: "EPA Number",
            readOnly: !0,
            name: "product[epa_number]",
            id: "product_epa_number",
            value: this.product.epaNumber,
            onChange: function (e) {
              return i.product.update({
                epaNumber: e.target.value
              });
            }
          })), this.stateRegistrationRow(), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_name"
          }, s("name")), p.a.createElement(Xs, {
            placeholder: s("name"),
            name: "product[name]",
            id: "product_name",
            value: this.product.name,
            onChange: function (e) {
              return i.product.update({
                name: e.target.value
              });
            }
          })), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_account"
          }, s("account")), p.a.createElement("div", {
            className: "col-sm-5 px-3"
          }, p.a.createElement("input", {
            type: "hidden",
            name: "product[account_id]",
            value: this.product.account ? this.product.account.serial : ""
          }), this.renderAccount()), p.a.createElement("div", {
            className: "col-sm-5 text-right"
          }, this.renderAccountChoiceButton())), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_manufacturer"
          }, s("manufacturer")), p.a.createElement(Xs, {
            placeholder: s("manufacturer"),
            name: "product[manufacturer]",
            id: "product_manufacturer",
            value: this.product.manufacturer,
            onChange: function (e) {
              return i.product.update({
                manufacturer: e.target.value
              });
            }
          })), p.a.createElement(Ls, null, p.a.createElement(Ws, null, s(this.labelUrlOrFileModel.title)), p.a.createElement(V0, {
            model: this.labelUrlOrFileModel
          })), p.a.createElement(Ls, null, p.a.createElement(Ws, null, s(this.sdsUrlOrFileModel.title)), p.a.createElement(V0, {
            model: this.sdsUrlOrFileModel
          })), p.a.createElement($ee, {
            product: this.product
          }), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_signal_word"
          }, s("signal_word.title_case")), p.a.createElement("div", {
            className: "form-grid-input"
          }, p.a.createElement("select", {
            className: "form-control",
            id: "product_signal_word",
            name: "product[signal_word]",
            value: this.product.signalWord,
            onChange: function (e) {
              return i.product.update({
                signalWord: e.target.value
              });
            }
          }, ["", "caution", "danger", "danger_poison", "warning"].map(function (e) {
            return p.a.createElement("option", {
              value: e,
              key: e
            }, s("signal_word.".concat(e || "unspecified")));
          })))), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_type"
          }, s("product_type")), p.a.createElement(Xs, {
            placeholder: s("product_type"),
            name: "product[product_type]",
            id: "product_type",
            value: this.product.productType,
            onChange: function (e) {
              return i.product.update({
                productType: e.target.value
              });
            }
          })), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_use"
          }, s("use")), p.a.createElement("div", {
            className: "col-sm-10 px-3",
            id: "product_use"
          }, p.a.createElement(Ls, null, p.a.createElement("div", {
            className: "col-sm-12"
          }, p.a.createElement("div", {
            className: "form-check"
          }, p.a.createElement("label", {
            className: "form-check-label",
            htmlFor: "product_use_checkbox"
          }, p.a.createElement("input", {
            name: "product[use]",
            type: "hidden",
            value: "0"
          }), p.a.createElement("input", {
            type: "checkbox",
            className: "form-check-input",
            name: "product[use]",
            id: "product_use_checkbox",
            value: this.product.use,
            checked: "restricted" === this.product.use,
            onChange: function () {
              return i.product.toggleUse();
            }
          }), s("this_is_a"), " ", p.a.createElement("strong", null, s("restricted_use_pesticide")))))))), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_alternate_names"
          }, s("alternate_names")), p.a.createElement("div", {
            className: "col-sm-10 px-3",
            id: "product_alternate_names"
          }, this.product.alternateNames.map(function (e) {
            return p.a.createElement("input", {
              key: e,
              name: "product[alternate_names][]",
              type: "hidden",
              value: e
            });
          }), p.a.createElement(dp, {
            initialItems: this.product.alternateNames.map(function (e) {
              return {
                name: e
              };
            }),
            onUpdate: function (e) {
              i.product.updateAlternateNames(e.map(function (e) {
                return e.name;
              }));
            },
            ListItemChild: function (e) {
              return p.a.createElement("div", {
                className: "d-flex justify-content-end flex-grow-1 px-3"
              }, p.a.createElement("button", {
                className: "btn btn-outline-secondary",
                type: "button",
                onClick: function () {
                  return i.product.newPrimaryName(e.item.name);
                }
              }, s("use_as_primary_name")));
            },
            placeholder: s("alternate_names")
          }))), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_formulation"
          }, s("formulation")), p.a.createElement("div", {
            className: "col-sm-10 px-3"
          }, p.a.createElement("input", {
            name: "product[formulation][description]",
            type: "hidden",
            value: null === (e = this.product.formulation) || void 0 === e ? void 0 : e.description
          }), p.a.createElement("input", {
            name: "product[formulation][type]",
            type: "hidden",
            value: null === (t = this.product.formulation) || void 0 === t ? void 0 : t.type
          }), p.a.createElement("select", {
            className: "form-control",
            id: "product_formulation",
            value: null === (r = this.product.formulation) || void 0 === r ? void 0 : r.description,
            onChange: function (e) {
              return i.product.newFormulationDescription(e.target.value);
            }
          }, p.a.createElement("option", {
            value: "",
            disabled: !0
          }, s("select_a_formulation")), this.product.formulations.map(function (e) {
            return p.a.createElement("option", {
              value: e.description,
              key: e.description
            }, e.description);
          })))), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_formulation_base_unit"
          }, s("base_units")), p.a.createElement("div", {
            className: "col-sm-10 px-3"
          }, p.a.createElement("input", {
            type: "hidden",
            name: "product[formulation][base_unit]",
            value: this.product.baseUnit || ""
          }), p.a.createElement("select", {
            className: "form-control",
            id: "product_formulation_base_unit",
            value: this.baseUnit,
            onChange: function (e) {
              return i.updateBaseUnit(e.target.value);
            }
          }, p.a.createElement("option", {
            value: "",
            disabled: !0
          }, s("select_unit_of_measure_for_this_product")), p.a.createElement("optgroup", {
            label: s("by_weight")
          }, p.a.createElement("option", {
            value: "oz"
          }, s("ounces_dry")), p.a.createElement("option", {
            value: "lbs"
          }, s("pounds")), p.a.createElement("option", {
            value: "tons"
          }, s("tons")), p.a.createElement("option", {
            value: "grams"
          }, s("grams")), p.a.createElement("option", {
            value: "kg"
          }, s("kilograms"))), p.a.createElement("optgroup", {
            label: s("by_volume")
          }, p.a.createElement("option", {
            value: "floz"
          }, s("floz")), p.a.createElement("option", {
            value: "pt"
          }, s("pints")), p.a.createElement("option", {
            value: "qt"
          }, s("quarts")), p.a.createElement("option", {
            value: "gal"
          }, s("gallons")), p.a.createElement("option", {
            value: "mL"
          }, s("mils")), p.a.createElement("option", {
            value: "L"
          }, s("liters"))), p.a.createElement("optgroup", {
            label: s("by_count")
          }, p.a.createElement("option", {
            value: "count"
          }, s("unit_each")))))), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_mass_per_volume"
          }, s("mass_per_volume")), p.a.createElement("div", {
            className: "col-sm-10 px-3 row"
          }, p.a.createElement("input", {
            type: "hidden",
            name: "product[mass_per_volume]",
            value: this.massPerVolume
          }), p.a.createElement(h.UnitSelector, {
            valueColumnClassName: "col-sm-2",
            unitColumnClassName: "col-sm-3",
            currentValue: (null === (n = this.product) || void 0 === n || null === (n = n.massPerVolume) || void 0 === n ? void 0 : n.scalar) || "",
            currentUnit: (null === (o = this.product) || void 0 === o || null === (o = o.massPerVolume) || void 0 === o ? void 0 : o.units) || "",
            onUpdateValue: this.updateMassPerVolumeScalar,
            onUpdateUnit: this.updateMassPerVolumeUnits,
            unitChoices: this.constructor.massPerVolumeChoices,
            disableValueInput: !this.product.isLiquid,
            disableUnitSelector: !this.product.isLiquid
          }))), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_active_ingredients"
          }, s("active_ingredients")), p.a.createElement("div", {
            className: "col-sm-10 px-3",
            id: "product_active_ingredients"
          }, p.a.createElement(n7, {
            activeIngredients: this.product.activeIngredients,
            onEditActiveIngredient: this.editActiveIngredient,
            onRemoveActiveIngredient: this.removeActiveIngredient,
            onShowActiveIngredientModal: this.addActiveIngredient
          }))), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "ache_inhibitor"
          }, s("ache_inhibitor")), p.a.createElement("div", {
            className: "col-sm-10 px-3",
            id: "product_ache_inhibitor"
          }, p.a.createElement("div", {
            className: "if2-form-row"
          }, p.a.createElement("div", {
            className: "col-mr-auto"
          }, p.a.createElement("div", {
            className: "form-check"
          }, p.a.createElement("label", {
            className: "form-check-label",
            htmlFor: "product_ache_inhibitor_checkbox"
          }, p.a.createElement("input", {
            name: "product[ache_inhibitor]",
            type: "hidden",
            value: this.product.acheInhibitor ? "1" : "0"
          }), p.a.createElement(oj.a, {
            className: "form-check-input",
            isChecked: this.product.acheInhibitor,
            onChange: function (e) {
              return i.product.acheInhibitor = e;
            }
          }), s("this_product_is_an_ache_inhibitor"))))))), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "target_rates_required"
          }, s("target_rates_required")), p.a.createElement("div", {
            className: "col-sm-10 px-3",
            id: "product_target_rates_required"
          }, p.a.createElement("div", {
            className: "if2-form-row"
          }, p.a.createElement("div", {
            className: "col-mr-auto"
          }, p.a.createElement("div", {
            className: "form-check"
          }, p.a.createElement("label", {
            className: "form-check-label",
            htmlFor: "product_target_rates_required_checkbox"
          }, p.a.createElement("input", {
            name: "product[target_rates_required]",
            type: "hidden",
            value: this.product.targetRatesRequired ? "1" : "0"
          }), p.a.createElement(oj.a, {
            className: "form-check-input",
            isChecked: this.product.targetRatesRequired,
            onChange: function (e) {
              return i.product.targetRatesRequired = e;
            }
          }), s("target_rates_required_for_this_product"))))))), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_nutrient_analysis"
          }, s("nutrient_analysis")), p.a.createElement("div", {
            className: "col-sm-10 px-3",
            id: "product_nutrient_analysis"
          }, p.a.createElement("div", {
            className: "if2-form-row"
          }, p.a.createElement("div", {
            className: "col-mr-auto"
          }, p.a.createElement("div", {
            className: "form-check"
          }, p.a.createElement("label", {
            className: "form-check-label",
            htmlFor: "product_nutrient_analysis_checkbox"
          }, p.a.createElement("input", {
            type: "checkbox",
            className: "form-check-input",
            id: "product_nutrient_analysis_checkbox",
            value: this.product.hasNutrientAnalysis,
            checked: this.product.hasNutrientAnalysis,
            onChange: function () {
              return i.product.toggleNutrientAnalysis();
            }
          }), s("this_product_is_a_nutrient")))), p.a.createElement("div", {
            className: "col text-right text-nowrap"
          }, p.a.createElement("span", {
            className: "lead font-weight-bold"
          }, this.product.nutrientAnalysisLabel))), this.product.hasNutrientAnalysis ? p.a.createElement(Q9, {
            nutrientAnalysis: this.product.nutrientAnalysis
          }) : p.a.createElement("input", {
            name: "product[nutrient]",
            type: "hidden",
            value: "no"
          }))), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_bee_hazard"
          }, s("bee_hazard")), p.a.createElement("div", {
            className: "form-grid-input"
          }, p.a.createElement("textarea", {
            placeholder: s("bee_hazard"),
            name: "product[bee_hazard]",
            id: "product_bee_hazard",
            value: this.product.beeHazard,
            onChange: function (e) {
              return i.product.update({
                beeHazard: e.target.value
              });
            }
          }))), p.a.createElement(Ls, null, p.a.createElement(Ws, {
            htmlFor: "product_notes"
          }, s("notes")), p.a.createElement("div", {
            className: "form-grid-input"
          }, p.a.createElement("textarea", {
            placeholder: s("notes"),
            name: "product[notes]",
            id: "product_notes",
            value: this.product.notes,
            onChange: function (e) {
              return i.product.update({
                notes: e.target.value
              });
            }
          }))), p.a.createElement(Ls, null, p.a.createElement("div", {
            className: "col-sm-10 offset-sm-2 px-3 text-right"
          }, p.a.createElement("a", {
            href: u,
            className: "btn btn-secondary"
          }, s("cancel")), p.a.createElement("input", {
            type: "submit",
            name: "commit",
            value: s("save"),
            className: "btn btn-primary ml-1",
            "data-disable-with": "Save"
          })))));
        }
      }]);
    }()).massPerVolumeChoices = ["lbs/gal", "kg/L"], Aee = lte((xee = Yee).prototype, "product", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new _r();
      }
    }), Mee = lte(xee.prototype, "addAIWizardModalId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "add-ai-wizard-modal";
      }
    }), Iee = lte(xee.prototype, "editActiveIngredientModalId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "editActiveIngredientModal";
      }
    }), Fee = lte(xee.prototype, "currentActiveIngredient", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new w.ActiveIngredient();
      }
    }), Bee = lte(xee.prototype, "isLoadingAccountsModal", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), lte(xee.prototype, "currentAINames", [f.computed], Object.getOwnPropertyDescriptor(xee.prototype, "currentAINames"), xee.prototype), lte(xee.prototype, "baseUnit", [f.computed], Object.getOwnPropertyDescriptor(xee.prototype, "baseUnit"), xee.prototype), lte(xee.prototype, "massPerVolume", [f.computed], Object.getOwnPropertyDescriptor(xee.prototype, "massPerVolume"), xee.prototype), Lee = lte(xee.prototype, "addActiveIngredient", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.preventDefault(), v()("#".concat(e.addAIWizardModalId)).modal("show");
        };
      }
    }), Vee = lte(xee.prototype, "updateProductWithCurrentAI", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.product.pushActiveIngredient(e.currentActiveIngredient), e.currentActiveIngredient = new w.ActiveIngredient();
        };
      }
    }), Uee = lte(xee.prototype, "handleSelectAI", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.currentActiveIngredient = t;
        };
      }
    }), qee = lte(xee.prototype, "handleSaveAI", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.product.pushActiveIngredient(t), v()("#".concat(e.addAIWizardModalId)).modal("hide");
        };
      }
    }), Kee = lte(xee.prototype, "editActiveIngredient", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.handleSelectAI(new w.ActiveIngredient(t)), v()("#".concat(e.editActiveIngredientModalId)).modal("show");
        };
      }
    }), Gee = lte(xee.prototype, "removeActiveIngredient", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          window.confirm("Remove ".concat(t.name, " from this product?")) && e.product.removeActiveIngredient(t.id);
        };
      }
    }), Wee = lte(xee.prototype, "handleAccountClickName", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.accountsStore.find(t);
          e.product.update({
            account: {
              id: t,
              name: r.name,
              serial: r.serial
            }
          }), v()("#account-selector-modal").modal("hide");
        };
      }
    }), lte(xee.prototype, "chooseAccount", [f.action], Object.getOwnPropertyDescriptor(xee.prototype, "chooseAccount"), xee.prototype), lte(xee.prototype, "updateBaseUnit", [f.action], Object.getOwnPropertyDescriptor(xee.prototype, "updateBaseUnit"), xee.prototype), Hee = lte(xee.prototype, "updateMassPerVolumeScalar", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          if (!e.product.massPerVolume) return e.product.update({
            massPerVolume: new w.Quantity("".concat(t))
          });
          e.product.massPerVolume.scalar = t;
        };
      }
    }), Jee = lte(xee.prototype, "updateMassPerVolumeUnits", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          if (!e.product.massPerVolume) return e.product.update({
            massPerVolume: new w.Quantity("0 ".concat(t))
          });
          e.product.massPerVolume.units = t;
        };
      }
    }), Dee = xee)) || Dee,
        yte = Object(g.a)()(bte);

    function mte(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, vte(n.key), n);
      }
    }

    function vte(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function hte(e, t, r) {
      return t = gte(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], gte(e).constructor) : t.apply(e, r));
    }

    function gte(e) {
      return (gte = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function wte(e, t) {
      return (wte = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Ote,
        jte,
        Pte,
        _te,
        Ete,
        Ste = Object(d.observer)(((dte = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = hte(this, t, [e]), "onRegisterModel", fte, r);
        var n = r.props.id;
        return r.id = n || "complete-filter-".concat(Object(td.v4)()), r.options = ["both", "complete", "incomplete"].map(function (e) {
          return {
            key: e,
            text: e,
            value: e
          };
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && wte(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e,
              t,
              r,
              n = this.props.filterWidgetManager;
          return p.a.createElement("div", {
            className: "complete-filter"
          }, null !== (e = n.completeModel) && void 0 !== e && e.selectedValue || !1 === (null === (t = n.completeModel) || void 0 === t ? void 0 : t.selectedValue) ? p.a.createElement("input", {
            type: "hidden",
            name: this.constructor.paramName,
            value: null === (r = n.completeModel) || void 0 === r ? void 0 : r.selectedValue
          }) : null, p.a.createElement(h.SelectDropdown, {
            id: this.id,
            options: this.options,
            onRegisterModel: this.onRegisterModel
          }));
        }
      }]) && mte(r.prototype, n), o && mte(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).paramName = "status", fte = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((pte = dte).prototype, "onRegisterModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.filterWidgetManager.register("completeModel", t);
        };
      }
    }), ste = pte)) || ste;

    function Cte(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function kte(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Rte(n.key), n);
      }
    }

    function Rte(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Tte(e, t, r) {
      return t = zte(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], zte(e).constructor) : t.apply(e, r));
    }

    function zte(e) {
      return (zte = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Nte(e, t) {
      return (Nte = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Dte(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var xte,
        Ate,
        Mte = Object(d.observer)(((Ete = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Cte(r = Tte(this, t, [e]), "model", Pte, r), r.options = [], Cte(r, "onRegisterModel", _te, r);
        var n = r.props.id;
        return r.id = n || "field-filter-".concat(Object(td.v4)()), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Nte(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "selectedIds",
        get: function () {
          var e;
          return (null === (e = this.props.filterWidgetManager.fieldModel) || void 0 === e ? void 0 : e.selectedKeys.join(",")) || "";
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = this.props.fields;
          this.options = e.map(function (e) {
            return {
              key: e.id,
              text: e.name,
              value: e
            };
          }).sort(function (e, t) {
            return Object(w.naturalSort)(e.text, t.text);
          });
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t = this.props.filterWidgetManager;
          return p.a.createElement("div", {
            className: "field-filter"
          }, null !== (e = t.fieldModel) && void 0 !== e && null !== (e = e.selectedKeys) && void 0 !== e && e.length ? p.a.createElement("input", {
            type: "hidden",
            name: "".concat(this.constructor.paramName),
            value: this.selectedIds
          }) : null, p.a.createElement(h.MultiSelectDropdown, {
            id: this.id,
            options: this.options,
            onRegisterModel: this.onRegisterModel
          }));
        }
      }]) && kte(r.prototype, n), o && kte(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).paramName = "field_ids", Pte = Dte((jte = Ete).prototype, "model", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Dte(jte.prototype, "selectedIds", [f.computed], Object.getOwnPropertyDescriptor(jte.prototype, "selectedIds"), jte.prototype), _te = Dte(jte.prototype, "onRegisterModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.filterWidgetManager.register("fieldModel", t);
        };
      }
    }), Ote = jte)) || Ote;

    function Ite(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Fte(n.key), n);
      }
    }

    function Fte(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Bte(e, t, r) {
      return t = Lte(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Lte(e).constructor) : t.apply(e, r));
    }

    function Lte(e) {
      return (Lte = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Vte(e, t) {
      return (Vte = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Ute,
        qte,
        Kte,
        Gte,
        Wte,
        Hte = Object(d.observer)(((Ate = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
        var n = (r = Bte(this, t, [e])).props.id;
        return r.id = n || "year-filter-".concat(Object(td.v4)()), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Vte(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e,
              t = this.props.filterWidgetManager;
          return p.a.createElement("div", {
            className: "year-filter"
          }, null !== (e = t.yearModel) && void 0 !== e && e.value ? p.a.createElement("input", {
            type: "hidden",
            name: this.constructor.paramName,
            value: t.yearModel.value
          }) : null, p.a.createElement(h.FormInput, {
            id: this.id,
            type: "number",
            onChange: t.yearModel.onChange,
            value: t.yearModel.value
          }));
        }
      }]) && Ite(r.prototype, n), o && Ite(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).paramName = "year", xte = Ate)) || xte;

    function Jte(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Yte(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Qte(n.key), n);
      }
    }

    function Qte(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function $te(e, t, r) {
      return t = Xte(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Xte(e).constructor) : t.apply(e, r));
    }

    function Xte(e) {
      return (Xte = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Zte(e, t) {
      return (Zte = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ere(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var tre = Object(d.observer)(((Wte = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Jte(r = $te(this, t, [e]), "model", Kte, r), Jte(r, "onRegisterModel", Gte, r);
        var n = r.props,
            o = n.id,
            i = n.fields;
        return r.id = o || "crops-filter-".concat(Object(td.v4)()), r.crops = Object(w.uniqBy)("id", i.map(function (e) {
          return e.crop;
        })), r.options = r.crops.map(function (e) {
          return {
            key: e.name,
            text: e.name,
            value: e
          };
        }).sort(function (e, t) {
          return Object(w.naturalSort)(e.text, t.text);
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Zte(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "selectedCropNames",
        get: function () {
          var e;
          return (null === (e = this.props.filterWidgetManager.cropModel) || void 0 === e ? void 0 : e.selectedKeys.join(",")) || "";
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t = this.props.filterWidgetManager;
          return p.a.createElement("div", {
            className: "crops-filter"
          }, null !== (e = t.cropModel) && void 0 !== e && null !== (e = e.selectedKeys) && void 0 !== e && e.length ? p.a.createElement("input", {
            type: "hidden",
            name: this.constructor.paramName,
            value: this.selectedCropNames
          }) : null, p.a.createElement(h.MultiSelectDropdown, {
            id: this.id,
            options: this.options,
            onRegisterModel: this.onRegisterModel
          }));
        }
      }]) && Yte(r.prototype, n), o && Yte(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).paramName = "crop_names", Kte = ere((qte = Wte).prototype, "model", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), ere(qte.prototype, "selectedCropNames", [f.computed], Object.getOwnPropertyDescriptor(qte.prototype, "selectedCropNames"), qte.prototype), Gte = ere(qte.prototype, "onRegisterModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.filterWidgetManager.register("cropModel", t);
        };
      }
    }), Ute = qte)) || Ute;

    function rre(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, nre(n.key), n);
      }
    }

    function nre(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ore(e, t, r) {
      return t = ire(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ire(e).constructor) : t.apply(e, r));
    }

    function ire(e) {
      return (ire = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function are(e, t) {
      return (are = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var cre = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), ore(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && are(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.label,
              r = e.component;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("label", null, t), r);
        }
      }]) && rre(r.prototype, n), o && rre(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function ure(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, lre(n.key), n);
      }
    }

    function lre(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function sre(e, t, r) {
      return t = pre(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], pre(e).constructor) : t.apply(e, r));
    }

    function pre(e) {
      return (pre = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function fre(e, t) {
      return (fre = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var dre,
        bre = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), sre(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && fre(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.fields,
              r = e.filterWidgetManager;
          return p.a.createElement(h.ModalBody, null, p.a.createElement(cre, {
            label: "Year",
            component: p.a.createElement(Hte, {
              filterWidgetManager: r
            })
          }), p.a.createElement(cre, {
            label: "Status",
            component: p.a.createElement(Ste, {
              filterWidgetManager: r
            })
          }), p.a.createElement(cre, {
            label: "Fields",
            component: p.a.createElement(Mte, {
              filterWidgetManager: r,
              fields: t
            })
          }), p.a.createElement(cre, {
            label: "Crops",
            component: p.a.createElement(tre, {
              filterWidgetManager: r,
              fields: t
            })
          }));
        }
      }]) && ure(r.prototype, n), o && ure(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function yre(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, mre(n.key), n);
      }
    }

    function mre(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function vre(e, t, r) {
      return t = hre(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], hre(e).constructor) : t.apply(e, r));
    }

    function hre(e) {
      return (hre = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function gre(e, t) {
      return (gre = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var wre,
        Ore,
        jre,
        Pre = Object(d.observer)(dre = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = vre(this, t, [].concat(n))).close = function () {
          var t = e.props.id;
          $("#".concat(t)).modal("hide");
        }, e.handleSubmit = function () {
          $("#product-use-report-filter-form").submit();
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && gre(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.id,
              r = e.title,
              n = e.filterWidgetManager,
              o = e.fields;
          return p.a.createElement(h.ModalDialog, {
            id: t,
            dismissOnClose: !1,
            className: "if2-modal filter-modal",
            dialogClassNames: "modal-md"
          }, p.a.createElement(h.ModalHeader, {
            title: r || "",
            onClose: this.close,
            ariaLabel: r
          }), p.a.createElement("form", {
            id: "product-use-report-filter-form"
          }, p.a.createElement(bre, {
            filterWidgetManager: n,
            fields: o
          }), p.a.createElement(h.ModalFooter, null, p.a.createElement("button", {
            className: "apply",
            type: "button",
            onClick: this.handleSubmit
          }, "Apply"), p.a.createElement("button", {
            className: "cancel",
            type: "button",
            onClick: this.close
          }, "Cancel"), p.a.createElement("button", {
            className: "clear",
            type: "button",
            onClick: n.clearAll
          }, "Clear Filters"))));
        }
      }]) && yre(r.prototype, n), o && yre(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || dre;

    function _re(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (null != r) {
          var n,
              o,
              i,
              a,
              c = [],
              u = !0,
              l = !1;

          try {
            if (i = (r = r.call(e)).next, 0 === t) {
              if (Object(r) !== r) return;
              u = !1;
            } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== t); u = !0);
          } catch (e) {
            l = !0, o = e;
          } finally {
            try {
              if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
            } finally {
              if (l) throw o;
            }
          }

          return c;
        }
      }(e, t) || Sre(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Ere(e) {
      return function (e) {
        if (Array.isArray(e)) return Cre(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || Sre(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Sre(e, t) {
      if (e) {
        if ("string" == typeof e) return Cre(e, t);
        var r = {}.toString.call(e).slice(8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Cre(e, t) : void 0;
      }
    }

    function Cre(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function kre(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Rre(n.key), n);
      }
    }

    function Rre(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Tre(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var zre,
        Nre,
        Dre,
        xre = ((jre = function () {
      return e = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(this, "_params", Ore, this);
      }, (t = [{
        key: "getParams",
        value: function () {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          return Ere(this._params.keys()).reduce(function (r, n) {
            return t.includes(n) ? (r[n] = e.getArrayValue(n), r) : (r[n] = e.getValue(n), r);
          }, {});
        }
      }, {
        key: "has",
        value: function (e) {
          return this._params.has(e);
        }
      }, {
        key: "getValue",
        value: function (e) {
          return this._params.get(e);
        }
      }, {
        key: "getArrayValue",
        value: function (e) {
          var t = this.getValue(e);
          return t ? t.split("%2C") : [];
        }
      }, {
        key: "add",
        value: function (e, t) {
          this._params.set(e, t);
        }
      }, {
        key: "addMany",
        value: function (e) {
          var t = this;
          e.forEach(function (e) {
            t.add(e.key, e.value);
          });
        }
      }, {
        key: "remove",
        value: function (e) {
          this._params.delete(e);
        }
      }]) && kre(e.prototype, t), r && kre(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).parseSearch = function (e) {
      var t = null == e ? void 0 : e.replace("?", "");
      if (t) return t.split("&").map(function (e) {
        var t = _re(e.split("="), 2);

        return {
          key: t[0],
          value: t[1]
        };
      });
    }, Ore = Tre((wre = jre).prototype, "_params", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new Map();
      }
    }), Tre(wre.prototype, "add", [f.action], Object.getOwnPropertyDescriptor(wre.prototype, "add"), wre.prototype), wre);

    function Are(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Mre(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ire(n.key), n);
      }
    }

    function Ire(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Fre(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Bre,
        Lre,
        Vre,
        Ure,
        qre,
        Kre,
        Gre = (Nre = Fre((zre = function () {
      return e = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Are(this, "value", Nre, this), Are(this, "onChange", Dre, this);
      }, (t = [{
        key: "clear",
        value: function () {
          this.value = "";
        }
      }]) && Mre(e.prototype, t), r && Mre(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "value", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Dre = Fre(zre.prototype, "onChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.value = t.target.value;
        };
      }
    }), zre);

    function Wre(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Hre(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Jre(n.key), n);
      }
    }

    function Jre(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Yre(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Qre,
        $re = (Lre = Yre((Bre = function () {
      return e = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Wre(this, "yearModel", Lre, this), Wre(this, "completeModel", Vre, this), Wre(this, "fieldModel", Ure, this), Wre(this, "cropModel", qre, this), Wre(this, "clearAll", Kre, this);
      }, (t = [{
        key: "init",
        value: function (e) {
          this.yearModel.value = (null == e ? void 0 : e.year) || "", this.completeModel.search((null == e ? void 0 : e.status) || this.getDefaultValue(this.completeModel)), this.fieldModel.selectedKeys = (null == e ? void 0 : e.field_ids) || [], this.cropModel.selectedKeys = (null == e ? void 0 : e.crop_names) || [];
        }
      }, {
        key: "getDefaultValue",
        value: function (e) {
          return e === this.yearModel ? new Date().getFullYear() : e === this.completeModel ? "complete" : void 0;
        }
      }, {
        key: "getKeys",
        value: function () {
          return Object.keys(this);
        }
      }, {
        key: "register",
        value: function (e, t) {
          this[e] = t;
        }
      }, {
        key: "clear",
        value: function (e) {
          var t,
              r = this[e];

          if (r) {
            if (r === this.completeModel) return this.completeModel.search(this.getDefaultValue(this.completeModel));

            if (r !== this.yearModel) {
              if (!(r instanceof h.FilteringMultiSelectModel)) return r instanceof h.SelectorModel ? r.reset() : null === (t = r.clear) || void 0 === t ? void 0 : t.call(r);
              r.selectedKeys = [];
            } else this.yearModel.clear();
          }
        }
      }]) && Hre(e.prototype, t), r && Hre(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "yearModel", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new Gre();
      }
    }), Vre = Yre(Bre.prototype, "completeModel", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new h.SelectorModel([]);
      }
    }), Ure = Yre(Bre.prototype, "fieldModel", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new h.FilteringMultiSelectModel();
      }
    }), qre = Yre(Bre.prototype, "cropModel", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new h.FilteringMultiSelectModel();
      }
    }), Yre(Bre.prototype, "register", [f.action], Object.getOwnPropertyDescriptor(Bre.prototype, "register"), Bre.prototype), Yre(Bre.prototype, "clear", [f.action], Object.getOwnPropertyDescriptor(Bre.prototype, "clear"), Bre.prototype), Kre = Yre(Bre.prototype, "clearAll", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.getKeys().forEach(function (t) {
            e.clear(t);
          });
        };
      }
    }), Bre);

    function Xre(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Zre(n.key), n);
      }
    }

    function Zre(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ene(e, t, r) {
      return t = rne(t), tne(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], rne(e).constructor) : t.apply(e, r));
    }

    function tne(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }

    function rne(e) {
      return (rne = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function nne(e, t) {
      return (nne = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var one = Object(d.observer)(Qre = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = ene(this, t, [e])).filterModalId = "filter-modal-".concat(Object(td.v4)()), r.filterWidgetManager = new $re(), r.urlParams = new xre(), r.openFilterModal = function () {
          r.filterWidgetManager.init(r.urlParams.getParams(["field_ids", "crop_names"])), $("#".concat(r.filterModalId)).modal("show");
        };
        var n = xre.parseSearch(window.location.search);
        return null != n && n.length ? (r.urlParams.addMany(n), r) : tne(r);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && nne(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.title,
              r = e.fields;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("div", {
            className: "d-flex align-content-center pr-2 h-100",
            style: {
              width: "2rem"
            }
          }, p.a.createElement(h.FiltersButton, {
            onClick: this.openFilterModal
          })), p.a.createElement(Pre, {
            id: this.filterModalId,
            title: t,
            filterWidgetManager: this.filterWidgetManager,
            fields: r
          }));
        }
      }]) && Xre(r.prototype, n), o && Xre(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || Qre,
        ine = r(210),
        ane = r.n(ine);

    function cne(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function une(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? cne(Object(r), !0).forEach(function (t) {
          lne(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : cne(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function lne(e, t, r) {
      return (t = dne(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function sne(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (null != r) {
          var n,
              o,
              i,
              a,
              c = [],
              u = !0,
              l = !1;

          try {
            if (i = (r = r.call(e)).next, 0 === t) {
              if (Object(r) !== r) return;
              u = !1;
            } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== t); u = !0);
          } catch (e) {
            l = !0, o = e;
          } finally {
            try {
              if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
            } finally {
              if (l) throw o;
            }
          }

          return c;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return pne(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? pne(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function pne(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function fne(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, dne(n.key), n);
      }
    }

    function dne(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var bne,
        yne,
        mne,
        vne = function () {
      return e = function e(t) {
        if (function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.i18n = t.i18n, !this.i18n) throw new Error("UrlBuilder requires i18n object");
      }, r = [{
        key: "withLocale",
        value: function (e) {
          var t,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = (null === (t = e.options) || void 0 === t ? void 0 : t.fallbackLng) || [],
              o = sne(n, 1),
              i = o[0],
              a = une({}, r);
          return e.resolvedLanguage !== i && (a.locale = e.resolvedLanguage), a;
        }
      }], (t = [{
        key: "build",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = e && new ane.a(e);
          return (null == r ? void 0 : r.stringify(this.constructor.withLocale(this.i18n, t))) || "";
        }
      }]) && fne(e.prototype, t), r && fne(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function hne(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, gne(n.key), n);
      }
    }

    function gne(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function wne(e, t, r) {
      return t = One(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], One(e).constructor) : t.apply(e, r));
    }

    function One(e) {
      return (One = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function jne(e, t) {
      return (jne = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Pne,
        _ne,
        Ene,
        Sne,
        Cne = Object(d.observer)((mne = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((yne = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = wne(this, t, [].concat(n)), "isLoading", mne, e), e.handleClickName = function (t) {
          var r = e.props,
              n = r.accountPathPattern,
              o = r.treeModel.accountsStore.find(t);

          if (o) {
            var i = new vne({
              i18n: db
            }),
                a = new URL(i.build(n, {
              id: o.serial
            }), window.location.origin);
            window.location.assign(a);
          }
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && jne(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "componentDidMount",
        value: function () {
          this.updateRoots();
        }
      }, {
        key: "updateRoots",
        value: function () {
          var e = this,
              t = this.props.treeModel,
              r = [],
              n = t.roots.map(function (e) {
            return t.isReadOnly(e.id) ? (Object(f.runInAction)(function () {
              r.push(e);
            }), Promise.resolve(e)) : t.accountsStore.updateChildrenOf(e.id).then(function () {
              if (!e.children.some(function (e) {
                return "processor" === e.account_type;
              })) return Object(f.runInAction)(function () {
                return r.push(e);
              });
            });
          });
          return Promise.all(n).then(function () {
            return Object(f.runInAction)(function () {
              t.roots = r, t.sortRoots();
            });
          }).finally(function () {
            return Object(f.runInAction)(function () {
              e.isLoading = !1;
            });
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.treeModel,
              r = e.handleToggleExpand;
          return this.isLoading ? p.a.createElement(h.Spinner, null) : p.a.createElement(fl, {
            items: t.roots,
            model: t,
            ControlsComponent: Al,
            ContentComponent: Cl(t),
            actions: {
              handleToggleExpand: r,
              handleClickNodeContent: this.handleClickName
            }
          });
        }
      }]) && hne(r.prototype, n), o && hne(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "isLoading", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !0;
      }
    }), bne = yne)) || bne,
        kne = CX(Cne);

    function Rne(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Tne(n.key), n);
      }
    }

    function Tne(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function zne(e, t, r) {
      return t = Nne(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Nne(e).constructor) : t.apply(e, r));
    }

    function Nne(e) {
      return (Nne = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Dne(e, t) {
      return (Dne = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function xne(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Ane,
        Mne,
        Ine,
        Fne,
        Bne,
        Lne,
        Vne,
        Une,
        qne,
        Kne,
        Gne = Object(d.observer)(((Sne = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = zne(this, t, [e]), "throttledValue", Ene, r), r.valueThrottleDisposer = Object(f.reaction)(function () {
          return r.value;
        }, function (e) {
          r.throttledValue = e;
        }, {
          fireImmediately: !0,
          delay: 100
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Dne(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "value",
        get: function () {
          return this.props.valueNow;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.className,
              r = e.valueMin,
              n = e.valueMax;
          return p.a.createElement("div", {
            className: "progress".concat(t ? " ".concat(t) : "")
          }, p.a.createElement("div", {
            className: "progress-bar",
            role: "progressbar",
            "aria-valuenow": this.throttledValue,
            "aria-valuemin": r,
            "aria-valuemax": n,
            style: {
              width: "".concat(this.throttledValue, "%")
            }
          }, "".concat(this.throttledValue, "%")));
        }
      }]) && Rne(r.prototype, n), o && Rne(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).defaultProps = {
      valueMin: 0,
      valueMax: 100,
      valueNow: 0
    }, Ene = xne((_ne = Sne).prototype, "throttledValue", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), xne(_ne.prototype, "value", [f.computed], Object.getOwnPropertyDescriptor(_ne.prototype, "value"), _ne.prototype), Pne = _ne)) || Pne;

    function Wne(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Hne(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Jne(n.key), n);
      }
    }

    function Jne(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Yne(e, t, r) {
      return t = Qne(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Qne(e).constructor) : t.apply(e, r));
    }

    function Qne(e) {
      return (Qne = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function $ne(e, t) {
      return ($ne = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Xne(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Zne,
        eoe,
        toe = Object(d.observer)((Ine = Xne((Mne = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Wne(r = Yne(this, t, [e]), "isShowingDropdown", Ine, r), r.isDescendantOf = function (e, t) {
          return !!e && (e.parentNode && e.parentNode === t || r.isDescendantOf(e.parentNode, t));
        }, Wne(r, "onDocumentClick", Fne, r), Wne(r, "doNothing", Bne, r), Wne(r, "onClickButton", Lne, r), Wne(r, "onClickCheckbox", Vne, r), Wne(r, "onSelectAll", Une, r), Wne(r, "onSelectPage", qne, r), Wne(r, "onUncheckAll", Kne, r), r.ref = Object(s.createRef)(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && $ne(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Hne(e.prototype, t), r && Hne(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "componentDidMount",
        value: function () {
          document.addEventListener("click", this.onDocumentClick);
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          document.removeEventListener("click", this.onDocumentClick);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.recordsCurrentPage,
              r = e.totalRecords,
              n = e.isChecked,
              o = e.someChecked,
              i = e.t,
              a = e.pageOptionsOnly;
          return p.a.createElement("div", {
            className: "dropdown checkall-dropdown".concat(this.isShowingDropdown ? " show" : ""),
            ref: this.ref
          }, p.a.createElement("button", {
            className: "btn btn-checkall dropdown-toggle",
            type: "button",
            onClick: this.onClickButton,
            "aria-haspopup": "true",
            "aria-expanded": "false",
            "aria-label": "show/hide dropdown"
          }, p.a.createElement(oj.a, {
            isChecked: n,
            onChange: this.onClickCheckbox
          })), p.a.createElement("div", {
            className: "dropdown-menu".concat(this.isShowingDropdown ? " show" : "")
          }, p.a.createElement("a", {
            className: "dropdown-item",
            href: "#",
            onClick: this.onSelectPage
          }, i(n ? "deselect" : "select"), i("this_page"), t ? " (".concat(t, ")") : null), a ? o ? p.a.createElement("a", {
            className: "dropdown-item",
            href: "#",
            onClick: this.onUncheckAll
          }, i("deselect"), i("all_records"), r ? " (".concat(r, ")") : null) : null : p.a.createElement("a", {
            className: "dropdown-item",
            href: "#",
            onClick: this.onSelectAll
          }, i(n ? "deselect" : "select"), i("all_records"), r ? " (".concat(r, ")") : null)));
        }
      }]);
    }()).prototype, "isShowingDropdown", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Fne = Xne(Mne.prototype, "onDocumentClick", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.isDescendantOf(t.target, e.ref.current) || (e.isShowingDropdown = !1);
        };
      }
    }), Bne = Xne(Mne.prototype, "doNothing", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return function () {};
      }
    }), Lne = Xne(Mne.prototype, "onClickButton", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isShowingDropdown = !0;
        };
      }
    }), Vne = Xne(Mne.prototype, "onClickCheckbox", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.isChecked,
              n = t.onUncheckPage,
              o = t.onSelectPage;
          r ? n() : o();
        };
      }
    }), Une = Xne(Mne.prototype, "onSelectAll", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.isChecked,
              o = r.onSelectAll,
              i = r.onUncheckAll;
          t.preventDefault(), e.isShowingDropdown = !1, n ? i() : o();
        };
      }
    }), qne = Xne(Mne.prototype, "onSelectPage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.isChecked,
              o = r.onSelectPage,
              i = r.onUncheckPage;
          t.preventDefault(), e.isShowingDropdown = !1, n ? i() : o();
        };
      }
    }), Kne = Xne(Mne.prototype, "onUncheckAll", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onUncheckAll;
          t.preventDefault(), e.isShowingDropdown = !1, r();
        };
      }
    }), Ane = Mne)) || Ane,
        roe = Object(g.a)()(toe);

    function noe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ooe(n.key), n);
      }
    }

    function ooe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ioe(e, t, r) {
      return t = aoe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], aoe(e).constructor) : t.apply(e, r));
    }

    function aoe(e) {
      return (aoe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function coe(e, t) {
      return (coe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var uoe = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((eoe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), ioe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && coe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && noe(e.prototype, t), r && noe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "someChecked",
        get: function () {
          return this.props.checkedCount > 0;
        }
      }, {
        key: "hasArchive",
        value: function (e) {
          return this.props.archiveIndex[e.id];
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.recommendationsPath,
              n = t.recommendations,
              o = t.includeCheckboxes,
              i = t.recommendationSelector,
              a = t.isChecked,
              c = t.onUncheckAll,
              u = t.onUncheckPage,
              l = t.onSelectAll,
              s = t.onSelectPage,
              f = t.recommendationsStore,
              d = t.showApprovalStatus,
              b = t.t;
          return p.a.createElement("div", {
            className: "recommendation-list",
            "aria-label": "Recommendation List"
          }, p.a.createElement("table", {
            className: "table table-sm table-manually-striped"
          }, p.a.createElement("thead", null, p.a.createElement("tr", null, o ? p.a.createElement("th", {
            className: "align-middle checkbox-header",
            "aria-label": "Select All",
            scope: "col"
          }, p.a.createElement(roe, {
            pageOptionsOnly: !0,
            isChecked: a,
            someChecked: this.someChecked,
            onUncheckAll: c,
            onUncheckPage: u,
            onSelectAll: l,
            onSelectPage: s
          })) : null, p.a.createElement("th", {
            scope: "col",
            "aria-label": "Expand Toggle Control"
          }), d ? p.a.createElement("th", {
            scope: "col",
            "aria-label": "Status Icon"
          }) : null, p.a.createElement("th", {
            scope: "col"
          }, b("title"), p.a.createElement("br", null), b("date_dates")), p.a.createElement("th", {
            scope: "col"
          }, b("author")), p.a.createElement("th", {
            scope: "col"
          }, b("account")), p.a.createElement("th", {
            scope: "col"
          }, b("crop")), p.a.createElement("th", {
            scope: "col"
          }, b("products")), p.a.createElement("th", {
            "aria-label": "Actions",
            scope: "col",
            className: "actions"
          }))), p.a.createElement("tbody", null, n.map(function (t, n) {
            return p.a.createElement(ZS, {
              key: t.id,
              recommendationsPath: r,
              recommendation: t,
              recommendationsStore: f,
              isLight: n % 2 == 0,
              includeCheckboxes: o,
              recommendationSelector: i,
              hasArchive: e.hasArchive(t),
              showApprovalStatus: d
            });
          }))));
        }
      }]);
    }()).prototype, "someChecked", [f.computed], Object.getOwnPropertyDescriptor(eoe.prototype, "someChecked"), eoe.prototype), Zne = eoe)) || Zne,
        loe = Object(g.a)()(uoe),
        soe = r(96),
        poe = r.n(soe);

    function foe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, doe(n.key), n);
      }
    }

    function doe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var boe,
        yoe,
        moe,
        voe,
        hoe,
        goe,
        woe,
        Ooe = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.apiRecommendationsPath = "/if2/api/recommendations", this.recommendationsCropsPath = "".concat(this.apiRecommendationsPath, "/crops"), this.recommendationsFieldsPath = "".concat(this.apiRecommendationsPath, "/fields"), this.recommendationsProductsPath = "".concat(this.apiRecommendationsPath, "/products"), this.recommendationsTargetsPath = "".concat(this.apiRecommendationsPath, "/targets"), this.recommendationsVarietiesPath = "".concat(this.apiRecommendationsPath, "/varieties"), this.recommendationsQueryPath = "".concat(this.apiRecommendationsPath, "/query"), this.recommendationsQueryAllSerialsPath = "".concat(this.apiRecommendationsPath, "/query_all_serials"), this.recommendationsBasePath = t || "/if2/recommendations";
      }, (t = [{
        key: "apiRecommendationPath",
        value: function (e) {
          return "".concat(this.apiRecommendationsPath, "/").concat(e);
        }
      }, {
        key: "accountRecommendationsPath",
        value: function (e) {
          return "/if2/api/accounts/".concat(e, "/recommendations");
        }
      }, {
        key: "recommendationsPath",
        value: function (e) {
          return "/if2/api/recommendations/".concat(e);
        }
      }, {
        key: "recommendationsProductApplicationPath",
        value: function (e, t) {
          return "".concat(this.apiRecommendationPath(e), "/product_applications/").concat(t);
        }
      }, {
        key: "recommendationAccountContactsPath",
        value: function (e) {
          return "".concat(this.apiRecommendationPath(e), "/account_contacts");
        }
      }, {
        key: "csrf",
        value: function () {
          return document.querySelector("[name='csrf-token']").content;
        }
      }, {
        key: "create",
        value: function (e, t) {
          var r = this.csrf();
          return fetch(this.accountRecommendationsPath(e), {
            method: "POST",
            headers: {
              "X-CSRF-Token": r,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              spray_record: t
            })
          });
        }
      }, {
        key: "jsonFetch",
        value: function (e, t, r) {
          var n = {
            method: t || "GET",
            headers: {
              "X-CSRF-Token": this.csrf(),
              "Content-Type": "application/json"
            }
          };
          return r && (n.body = JSON.stringify(r)), fetch(e, n).then(function (e) {
            if (e.ok) return e.json();
            if (404 === e.status) return {
              status: "not-found"
            };
            throw Error(e.statusText);
          }).then(function (e) {
            if ("success" !== e.status) {
              if ("not-found" === e.status) throw new Error("Recommendation not found");
              var t = new Error(e.message || "An unexpected error occurred while fetching");
              throw t.errors = e.errors || [], t;
            }

            return e;
          });
        }
      }, {
        key: "fetch",
        value: function (e) {
          return this.sendRequest("GET", this.recommendationsPath(e));
        }
      }, {
        key: "fetchAccountContacts",
        value: function (e) {
          return this.jsonFetch(this.recommendationAccountContactsPath(e));
        }
      }, {
        key: "fetchAllForAccounts",
        value: function (e) {
          var t = this.csrf();
          return fetch(this.recommendationsQueryPath, {
            method: "POST",
            headers: {
              "X-CSRF-Token": t,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              accounts: e
            })
          }).then(function (e) {
            return e.json();
          }).then(function (e) {
            if ("success" !== e.status) {
              var t = new Error(e.message || "An unexpected error occurred while fetching recommendations");
              throw t.errors = e.errors || [], t;
            }

            return e;
          });
        }
      }, {
        key: "fetchCrops",
        value: function (e) {
          var t = this.csrf();
          return fetch(this.recommendationsCropsPath, {
            method: "POST",
            headers: {
              "X-CSRF-Token": t,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
          }).then(function (e) {
            return e.json();
          }).then(function (e) {
            if ("success" !== e.status) {
              var t = new Error(e.message || "An unexpected error occurred while fetching");
              throw t.errors = e.errors || [], t;
            }

            return e;
          });
        }
      }, {
        key: "fetchFields",
        value: function (e) {
          return this.jsonFetch(this.recommendationsFieldsPath, "POST", e);
        }
      }, {
        key: "fetchProducts",
        value: function (e) {
          return this.jsonFetch(this.recommendationsProductsPath, "POST", e);
        }
      }, {
        key: "fetchTargets",
        value: function (e) {
          return this.jsonFetch(this.recommendationsTargetsPath, "POST", e);
        }
      }, {
        key: "fetchVarieties",
        value: function (e) {
          var t = this.csrf();
          return fetch(this.recommendationsVarietiesPath, {
            method: "POST",
            headers: {
              "X-CSRF-Token": t,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
          }).then(function (e) {
            return e.json();
          }).then(function (e) {
            if ("success" !== e.status) {
              var t = new Error(e.message || "An unexpected error occurred while fetching");
              throw t.errors = e.errors || [], t;
            }

            return e;
          });
        }
      }, {
        key: "query",
        value: function (e) {
          var t = this.csrf();
          return fetch(this.recommendationsQueryPath, {
            method: "POST",
            headers: {
              "X-CSRF-Token": t,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
          }).then(function (e) {
            return e.json();
          }).then(function (e) {
            if ("success" !== e.status) {
              var t = new Error(e.message || "An unexpected error occurred while fetching spray records");
              throw t.errors = e.errors || [], t;
            }

            return e;
          });
        }
      }, {
        key: "queryAllSerials",
        value: function (e) {
          var t = this.csrf();
          return fetch(this.recommendationsQueryAllSerialsPath, {
            method: "POST",
            headers: {
              "X-CSRF-Token": t,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
          }).then(function (e) {
            return e.json();
          }).then(function (e) {
            if ("success" !== e.status) {
              var t = new Error(e.message || "An unexpected error occurred while fetching spray records");
              throw t.errors = e.errors || [], t;
            }

            return e;
          });
        }
      }, {
        key: "update",
        value: function (e, t) {
          var r = this.csrf();
          return fetch(this.recommendationsPath(e), {
            method: "PATCH",
            headers: {
              "X-CSRF-Token": r,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              spray_record: t
            })
          });
        }
      }, {
        key: "deleteProductApplication",
        value: function (e, t) {
          var r = this.csrf();
          return fetch("".concat(this.recommendationsProductApplicationPath(e, t)), {
            method: "DELETE",
            headers: {
              "X-CSRF-Token": r,
              "Content-Type": "application/json"
            }
          });
        }
      }, {
        key: "moveProductApplication",
        value: function (e, t, r) {
          var n = this.csrf();
          return fetch("".concat(this.recommendationsProductApplicationPath(e, t), "/reposition"), {
            method: "POST",
            headers: {
              "X-CSRF-Token": n,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              to_position: r
            })
          });
        }
      }, {
        key: "sendRequest",
        value: function (e, t) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
              n = this.csrf(),
              o = {
            method: e,
            headers: {
              "X-CSRF-Token": n,
              "Content-Type": "application/json"
            }
          };
          return r && (o.body = JSON.stringify(r)), fetch(t, o).then(function (e) {
            return e.json();
          }).catch(function (e) {
            throw console.log(e), {
              status: "error",
              message: "An unexpected error occurred",
              error: e
            };
          });
        }
      }]) && foe(e.prototype, t), r && foe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function joe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Poe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? joe(Object(r), !0).forEach(function (t) {
          _oe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : joe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function _oe(e, t, r) {
      return (t = Coe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Eoe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Soe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Coe(n.key), n);
      }
    }

    function Coe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function koe(e, t, r) {
      return t = Roe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Roe(e).constructor) : t.apply(e, r));
    }

    function Roe(e) {
      return (Roe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Toe(e, t) {
      return (Toe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function zoe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Noe,
        Doe,
        xoe = (yoe = zoe((boe = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = koe(this, t)).api = void 0, Eoe(r, "recommendations", yoe, r), Eoe(r, "crops", moe, r), Eoe(r, "fields", voe, r), Eoe(r, "products", hoe, r), Eoe(r, "targets", goe, r), Eoe(r, "varieties", woe, r), r.api = e || new Ooe(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Toe(e, t);
      }(t, Object(w["Mix"])(w["checkableCollectionMixin"])), function (e, t, r) {
        return t && Soe(e.prototype, t), r && Soe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "items",
        get: function () {
          return this.recommendations;
        }
      }, {
        key: "recommendationsBasePath",
        get: function () {
          return this.api.recommendationsBasePath;
        }
      }, {
        key: "deleteProductApplication",
        value: function (e, t) {
          var r = this;
          return this.api.deleteProductApplication(e, t).then(function (n) {
            if (!n.ok) throw n;
            return r.fetch(e), r.removeProductApplication(e, t);
          });
        }
      }, {
        key: "fetch",
        value: function (e) {
          var t = this;
          return this.api.fetch(e).then(function (e) {
            return t.push(e.recommendation);
          });
        }
      }, {
        key: "fetchAllForAccounts",
        value: function (e) {
          var t = this;
          return this.api.fetchAllForAccounts(e).then(function (e) {
            return t.pushMany(e.recommendations);
          }).then(function (e) {
            return e;
          });
        }
      }, {
        key: "find",
        value: function (e) {
          return this.recommendations.find(function (t) {
            return t.id === e;
          });
        }
      }, {
        key: "fetchCrops",
        value: function (e) {
          var t = this;
          return this.api.fetchCrops(Poe({}, e || {})).then(function (e) {
            return e.crops ? (t.crops = e.crops, t.crops) : t.crops;
          });
        }
      }, {
        key: "fetchFields",
        value: function (e) {
          var t = this;
          return this.api.fetchFields(Poe({}, e || {})).then(function (e) {
            return e.fields ? (t.fields = e.fields, t.fields) : t.fields;
          });
        }
      }, {
        key: "fetchProducts",
        value: function (e) {
          var t = this;
          return this.api.fetchProducts(Poe({}, e || {})).then(function (e) {
            return e.products ? (t.products = e.products, t.products) : t.products;
          });
        }
      }, {
        key: "fetchTargets",
        value: function (e) {
          var t = this;
          return this.api.fetchTargets(Poe({}, e || {})).then(function (e) {
            return e.targets ? (t.targets = e.targets, t.targets) : t.targets;
          });
        }
      }, {
        key: "fetchVarieties",
        value: function (e) {
          var t = this;
          return this.api.fetchVarieties(Poe({}, e || {})).then(function (e) {
            return e.varieties ? (t.varieties = e.varieties, t.varieties) : t.varieties;
          });
        }
      }, {
        key: "fetchAccountContacts",
        value: function (e) {
          return this.api.fetchAccountContacts(e.id).then(function (e) {
            return e.contacts;
          });
        }
      }, {
        key: "fetchApplicatorContacts",
        value: function (e) {
          return this.api.fetchApplicatorContacts(e.id).then(function (e) {
            return e.applicators;
          });
        }
      }, {
        key: "update",
        value: function (e, t) {
          return this.api.update(e, t);
        }
      }, {
        key: "moveProductApplication",
        value: function (e, t, r, n) {
          var o = this,
              i = this.find(e);
          return i ? (i.moveProductApplication(t, r, n), this.api.moveProductApplication(e, t, n).then(function (e) {
            if (!e.ok) throw e;
            return e.json();
          }).then(function (e) {
            return o.push(e.recommendation);
          })) : Promise.reject(new Error("Spray record not found in store"));
        }
      }, {
        key: "new",
        value: function (e) {
          return new e_(e);
        }
      }, {
        key: "push",
        value: function (e, t) {
          var r = this.find(e.id);
          return r ? r.update(e) : (r = this.new(e), Object.keys(t || {}).forEach(function (e) {
            r[e] = t[e];
          }), this.recommendations.push(r)), r;
        }
      }, {
        key: "pushApplication",
        value: function (e, t) {
          var r = this.find(e);
          if (r) return r.pushApplication(t);
        }
      }, {
        key: "pushMany",
        value: function (e, t) {
          var r = this;
          return e.map(function (e) {
            return r.push(e, t);
          });
        }
      }, {
        key: "remove",
        value: function (e) {
          var t = this.recommendations.findIndex(function (t) {
            return t.id === e;
          });
          t < 0 || this.recommendations.splice(t, 1);
        }
      }, {
        key: "removeApplication",
        value: function (e, t) {
          var r = this.find(e);
          r && r.removeApplication(t);
        }
      }, {
        key: "removeProductApplication",
        value: function (e, t) {
          var r = this.find(e);
          r && r.removeProductApplication(t);
        }
      }, {
        key: "saveProductApplication",
        value: function (e, t) {
          var r = this;
          return this.api.update(e, {
            product_applications: [{
              id: t.serial,
              product_id: t.product.serial,
              rate: t.rate,
              target: t.target,
              position: t.position
            }]
          }).then(function (e) {
            if (!e.ok) throw e;
            return e.json();
          }).then(function (e) {
            return r.push(e.recommendation);
          });
        }
      }, {
        key: "handleApplicationResponse",
        value: function (e, t) {
          if ("success" !== e.status) throw e;
          return this.fetch(t);
        }
      }]);
    }()).prototype, "recommendations", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), moe = zoe(boe.prototype, "crops", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), voe = zoe(boe.prototype, "fields", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), hoe = zoe(boe.prototype, "products", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), goe = zoe(boe.prototype, "targets", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), woe = zoe(boe.prototype, "varieties", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), zoe(boe.prototype, "items", [f.computed], Object.getOwnPropertyDescriptor(boe.prototype, "items"), boe.prototype), zoe(boe.prototype, "recommendationsBasePath", [f.computed], Object.getOwnPropertyDescriptor(boe.prototype, "recommendationsBasePath"), boe.prototype), zoe(boe.prototype, "deleteProductApplication", [f.action], Object.getOwnPropertyDescriptor(boe.prototype, "deleteProductApplication"), boe.prototype), zoe(boe.prototype, "fetch", [f.action], Object.getOwnPropertyDescriptor(boe.prototype, "fetch"), boe.prototype), zoe(boe.prototype, "fetchAllForAccounts", [f.action], Object.getOwnPropertyDescriptor(boe.prototype, "fetchAllForAccounts"), boe.prototype), zoe(boe.prototype, "update", [f.action], Object.getOwnPropertyDescriptor(boe.prototype, "update"), boe.prototype), zoe(boe.prototype, "moveProductApplication", [f.action], Object.getOwnPropertyDescriptor(boe.prototype, "moveProductApplication"), boe.prototype), zoe(boe.prototype, "push", [f.action], Object.getOwnPropertyDescriptor(boe.prototype, "push"), boe.prototype), zoe(boe.prototype, "pushApplication", [f.action], Object.getOwnPropertyDescriptor(boe.prototype, "pushApplication"), boe.prototype), zoe(boe.prototype, "pushMany", [f.action], Object.getOwnPropertyDescriptor(boe.prototype, "pushMany"), boe.prototype), zoe(boe.prototype, "remove", [f.action], Object.getOwnPropertyDescriptor(boe.prototype, "remove"), boe.prototype), zoe(boe.prototype, "removeApplication", [f.action], Object.getOwnPropertyDescriptor(boe.prototype, "removeApplication"), boe.prototype), zoe(boe.prototype, "removeProductApplication", [f.action], Object.getOwnPropertyDescriptor(boe.prototype, "removeProductApplication"), boe.prototype), zoe(boe.prototype, "saveProductApplication", [f.action], Object.getOwnPropertyDescriptor(boe.prototype, "saveProductApplication"), boe.prototype), zoe(boe.prototype, "handleApplicationResponse", [f.action], Object.getOwnPropertyDescriptor(boe.prototype, "handleApplicationResponse"), boe.prototype), boe);

    function Aoe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Moe(n.key), n);
      }
    }

    function Moe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Ioe(e, t, r) {
      return t = Loe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Loe(e).constructor) : t.apply(e, r));
    }

    function Foe() {
      return (Foe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Boe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Boe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = Loe(e)););

      return e;
    }

    function Loe(e) {
      return (Loe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Voe(e, t) {
      return (Voe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Uoe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var qoe,
        Koe,
        Goe,
        Woe = (Doe = Uoe((Noe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = Ioe(this, t, [].concat(n)), "archiveIndex", Doe, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Voe(e, t);
      }(t, Wv), function (e, t, r) {
        return t && Aoe(e.prototype, t), r && Aoe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "checkedCount",
        get: function () {
          return this.store.numChecked;
        }
      }, {
        key: "recommendations",
        get: function () {
          var e = this;
          return this.store ? Lm()(this.store.recommendations.filter(function (t) {
            return e.resultIds.includes(t.id);
          }), ["searchScore"], ["desc"]) : [];
        }
      }, {
        key: "captureQueryResults",
        value: function (e) {
          var r, n, o, i, a, c, u;
          if ((o = t, i = "captureQueryResults", a = this, u = Foe(Loe(1 & (c = 3) ? o.prototype : o), i, a), 2 & c && "function" == typeof u ? function (e) {
            return u.apply(a, e);
          } : u)([e]), this.resultIds = (null == e || null === (r = e.recommendations) || void 0 === r || null === (n = r.map) || void 0 === n ? void 0 : n.call(r, function (e) {
            return e.id;
          })) || [], this.archiveIndex = (null == e ? void 0 : e.archiveIndex) || {}, this.resultIds.length) return this.allChecked && this.store.checkMany(this.resultIds), this.store.pushMany(e.recommendations);
        }
      }, {
        key: "checkAllOnPage",
        value: function () {
          var e = this;
          this.recommendations.forEach(function (t) {
            e.store.check(t.id);
          }), this.currentPage && this.currentPage.setChecked(!0);
        }
      }, {
        key: "unCheckAll",
        value: function () {
          this.allChecked = !1, this.pages.map(function (e) {
            return e.setChecked(!1);
          }), this.store.unCheckAll();
        }
      }, {
        key: "unCheckAllOnPage",
        value: function () {
          var e = this;
          this.currentPage && this.currentPage.setChecked(!1), this.recommendations.forEach(function (t) {
            return e.store.unCheck(t.id);
          });
        }
      }]);
    }()).prototype, "archiveIndex", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return {};
      }
    }), Uoe(Noe.prototype, "checkedCount", [f.computed], Object.getOwnPropertyDescriptor(Noe.prototype, "checkedCount"), Noe.prototype), Uoe(Noe.prototype, "recommendations", [f.computed], Object.getOwnPropertyDescriptor(Noe.prototype, "recommendations"), Noe.prototype), Uoe(Noe.prototype, "captureQueryResults", [f.action], Object.getOwnPropertyDescriptor(Noe.prototype, "captureQueryResults"), Noe.prototype), Uoe(Noe.prototype, "checkAllOnPage", [f.action], Object.getOwnPropertyDescriptor(Noe.prototype, "checkAllOnPage"), Noe.prototype), Uoe(Noe.prototype, "unCheckAll", [f.action], Object.getOwnPropertyDescriptor(Noe.prototype, "unCheckAll"), Noe.prototype), Uoe(Noe.prototype, "unCheckAllOnPage", [f.action], Object.getOwnPropertyDescriptor(Noe.prototype, "unCheckAllOnPage"), Noe.prototype), Noe);

    function Hoe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Joe(n.key), n);
      }
    }

    function Joe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Yoe(e, t, r) {
      return t = Qoe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Qoe(e).constructor) : t.apply(e, r));
    }

    function Qoe(e) {
      return (Qoe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function $oe(e, t) {
      return ($oe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Xoe,
        Zoe,
        eie = Object(d.observer)((Goe = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((Koe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = Yoe(this, t, [].concat(n)), "onClick", Goe, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && $oe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props.page;
          return e.isActive || e.isDisabled ? p.a.createElement("span", {
            className: "page-link"
          }, e.number) : p.a.createElement("a", {
            className: "page-link",
            href: "#",
            onClick: this.onClick
          }, e.number);
        }
      }]) && Hoe(r.prototype, n), o && Hoe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "onClick", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.page,
              o = r.onClick;
          t.preventDefault(), o(n);
        };
      }
    }), qoe = Koe)) || qoe;

    function tie(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, rie(n.key), n);
      }
    }

    function rie(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function nie(e, t, r) {
      return t = oie(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], oie(e).constructor) : t.apply(e, r));
    }

    function oie(e) {
      return (oie = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function iie(e, t) {
      return (iie = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var aie,
        cie,
        uie,
        lie,
        sie,
        pie,
        fie,
        die = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((Zoe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), nie(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && iie(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "className",
        get: function () {
          var e = this.props,
              t = e.page,
              r = e.className;
          return ["page-item"].concat(t.isActive ? "active" : []).concat(t.isDisabled ? "disabled" : []).concat(r || []).join(" ");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.page,
              r = e.onClickPage;
          return p.a.createElement("li", {
            "aria-label": "PaginationNav Page Item",
            className: this.className,
            "aria-current": t.isActive ? "page" : void 0
          }, p.a.createElement(eie, {
            page: t,
            onClick: r
          }));
        }
      }]) && tie(r.prototype, n), o && tie(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "className", [f.computed], Object.getOwnPropertyDescriptor(Zoe.prototype, "className"), Zoe.prototype), Xoe = Zoe)) || Xoe;

    function bie(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function yie(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, mie(n.key), n);
      }
    }

    function mie(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function vie(e, t, r) {
      return t = hie(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], hie(e).constructor) : t.apply(e, r));
    }

    function hie(e) {
      return (hie = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function gie(e, t) {
      return (gie = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function wie(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Oie,
        jie,
        Pie,
        _ie,
        Eie,
        Sie,
        Cie,
        kie,
        Rie,
        Tie,
        zie,
        Nie,
        Die,
        xie,
        Aie,
        Mie,
        Iie,
        Fie = Object(d.observer)(((fie = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), bie(r = vie(this, t, [e]), "pages", uie, r), bie(r, "onClickPage", lie, r), bie(r, "onClickPrevious", sie, r), bie(r, "onClickNext", pie, r), r.pagesDisposer = Object(f.autorun)(function () {
          var e = r.props,
              t = e.pages,
              n = e.currentPageNumber,
              o = e.outerWindow,
              i = e.innerWindow,
              a = t.length;
          t.forEach(function (e) {
            var t = e.number;
            e.isActive = t === n, e.isHidden = t > 1 + o && t < n - i || t < a - o && t > n + i;
          }), r.pages = t;
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && gie(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && yie(e.prototype, t), r && yie(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "showLowerEllipsis",
        get: function () {
          var e = this.props.currentPageNumber;
          return this.pages.filter(function (t) {
            return t.number < e && t.isHidden;
          }).length > 0;
        }
      }, {
        key: "showUpperEllipsis",
        get: function () {
          var e = this.props.currentPageNumber;
          return this.pages.filter(function (t) {
            return t.number > e && t.isHidden;
          }).length > 0;
        }
      }, {
        key: "pagePrevious",
        get: function () {
          var e = this.props.t;
          return {
            number: "← ".concat(e("previous")),
            isDisabled: 0 === this.pages.length || this.pages[0].isActive
          };
        }
      }, {
        key: "pageNext",
        get: function () {
          var e = this.props.t;
          return {
            number: "".concat(e("next"), " →"),
            isDisabled: 0 === this.pages.length || this.pages[this.pages.length - 1].isActive
          };
        }
      }, {
        key: "pageEllipsis",
        get: function () {
          return {
            number: "…",
            isDisabled: !0
          };
        }
      }, {
        key: "lowerVisiblePages",
        get: function () {
          var e = this.props,
              t = e.innerWindow,
              r = e.currentPageNumber;
          return this.pages.filter(function (e) {
            return e.number < r - t && !e.isHidden;
          });
        }
      }, {
        key: "middleVisiblePages",
        get: function () {
          var e = this.props,
              t = e.innerWindow,
              r = e.currentPageNumber;
          return this.pages.filter(function (e) {
            return e.number >= r - t && e.number <= r + t && !e.isHidden;
          });
        }
      }, {
        key: "upperVisiblePages",
        get: function () {
          var e = this.props,
              t = e.innerWindow,
              r = e.currentPageNumber;
          return this.pages.filter(function (e) {
            return e.number > r + t && !e.isHidden;
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.pagesDisposer();
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props.className;
          return p.a.createElement("nav", {
            "aria-label": "Pagination Navigator"
          }, p.a.createElement("ul", {
            className: "pagination".concat(t ? " ".concat(t) : "")
          }, p.a.createElement(die, {
            key: this.pagePrevious.number,
            page: this.pagePrevious,
            onClickPage: this.onClickPrevious,
            className: "previous_page"
          }), this.lowerVisiblePages.map(function (t) {
            return p.a.createElement(die, {
              key: t.number,
              page: t,
              onClickPage: e.onClickPage
            });
          }), this.showLowerEllipsis ? p.a.createElement(die, {
            key: "".concat(this.pageEllipsis.number, "-lower"),
            page: this.pageEllipsis,
            onClickPage: this.doNothing,
            className: "ellipsis_page"
          }) : null, this.middleVisiblePages.map(function (t) {
            return p.a.createElement(die, {
              key: t.number,
              page: t,
              onClickPage: e.onClickPage
            });
          }), this.showUpperEllipsis ? p.a.createElement(die, {
            key: "".concat(this.pageEllipsis.number, "-upper"),
            page: this.pageEllipsis,
            onClickPage: this.doNothing,
            className: "ellipsis_page"
          }) : null, this.upperVisiblePages.map(function (t) {
            return p.a.createElement(die, {
              key: t.number,
              page: t,
              onClickPage: e.onClickPage
            });
          }), p.a.createElement(die, {
            key: this.pageNext.number,
            page: this.pageNext,
            onClickPage: this.onClickNext,
            className: "next_page"
          })));
        }
      }]);
    }()).defaultProps = {
      innerWindow: 3,
      outerWindow: 1,
      pages: [],
      currentPageNumber: 1
    }, uie = wie((cie = fie).prototype, "pages", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), wie(cie.prototype, "showLowerEllipsis", [f.computed], Object.getOwnPropertyDescriptor(cie.prototype, "showLowerEllipsis"), cie.prototype), wie(cie.prototype, "showUpperEllipsis", [f.computed], Object.getOwnPropertyDescriptor(cie.prototype, "showUpperEllipsis"), cie.prototype), wie(cie.prototype, "pagePrevious", [f.computed], Object.getOwnPropertyDescriptor(cie.prototype, "pagePrevious"), cie.prototype), wie(cie.prototype, "pageNext", [f.computed], Object.getOwnPropertyDescriptor(cie.prototype, "pageNext"), cie.prototype), wie(cie.prototype, "pageEllipsis", [f.computed], Object.getOwnPropertyDescriptor(cie.prototype, "pageEllipsis"), cie.prototype), wie(cie.prototype, "lowerVisiblePages", [f.computed], Object.getOwnPropertyDescriptor(cie.prototype, "lowerVisiblePages"), cie.prototype), wie(cie.prototype, "middleVisiblePages", [f.computed], Object.getOwnPropertyDescriptor(cie.prototype, "middleVisiblePages"), cie.prototype), wie(cie.prototype, "upperVisiblePages", [f.computed], Object.getOwnPropertyDescriptor(cie.prototype, "upperVisiblePages"), cie.prototype), lie = wie(cie.prototype, "onClickPage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          (0, e.props.onGoToPage)(t.number);
        };
      }
    }), sie = wie(cie.prototype, "onClickPrevious", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props;
          (0, t.onGoToPage)(t.currentPageNumber - 1);
        };
      }
    }), pie = wie(cie.prototype, "onClickNext", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props;
          (0, t.onGoToPage)(t.currentPageNumber + 1);
        };
      }
    }), aie = cie)) || aie,
        Bie = Object(g.a)()(Fie);

    function Lie(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Vie(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Lie(Object(r), !0).forEach(function (t) {
          Uie(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Lie(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Uie(e, t, r) {
      return (t = Gie(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function qie(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Kie(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Gie(n.key), n);
      }
    }

    function Gie(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Wie(e, t, r) {
      return t = Hie(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Hie(e).constructor) : t.apply(e, r));
    }

    function Hie(e) {
      return (Hie = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Jie(e, t) {
      return (Jie = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Yie(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Qie,
        $ie,
        Xie,
        Zie,
        eae,
        tae,
        rae,
        nae,
        oae = Object(d.inject)("configuration")(Oie = Object(d.observer)(((Iie = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = Wie(this, t, [e])).clearFiltersCallback = void 0, qie(r, "filterModalId", Pie, r), qie(r, "defaultTotalRecords", _ie, r), qie(r, "allRecommendationSerials", Eie, r), qie(r, "isDoingBulkAction", Sie, r), qie(r, "onChangeSearch", Cie, r), qie(r, "onClearSearch", kie, r), qie(r, "onClickFilterFlag", Rie, r), qie(r, "onDoBulkAction", Tie, r), qie(r, "unCheckAll", zie, r), qie(r, "unCheckAllOnPage", Nie, r), qie(r, "checkAll", Die, r), qie(r, "checkAllOnPage", xie, r), qie(r, "goToPage", Aie, r), qie(r, "registerClearFiltersCallback", Mie, r);
        var n = r.props,
            o = n.recommendationsBasePath,
            i = n.recommendationsApi,
            a = n.recommendationsStore,
            c = n.filterModalModel,
            u = n.queryService,
            l = n.t,
            s = n.configuration;
        return r.recommendationsApi = i || new Ooe(o), r.recommendationsStore = a || new xoe(r.recommendationsApi), r.queryService = u || new Woe(r.recommendationsStore, e.accountIds || []), r.filterModalModel = c || new Ng({
          id: r.filterModalId,
          title: l("recommendation_filters"),
          store: r.recommendationsStore,
          queryService: r.queryService,
          storageName: "recommendation-dashboard-filters",
          t: l,
          configuration: s
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Jie(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Kie(e.prototype, t), r && Kie(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "allChecked",
        get: function () {
          return this.queryService.allChecked;
        }
      }, {
        key: "isChecked",
        get: function () {
          return this.queryService.currentPageChecked;
        }
      }, {
        key: "badgeContent",
        get: function () {
          return this.queryService.filtersAppliedCount || "+";
        }
      }, {
        key: "recommendations",
        get: function () {
          return this.queryService.recommendations;
        }
      }, {
        key: "checkedCount",
        get: function () {
          return this.queryService.checkedCount;
        }
      }, {
        key: "checkedIds",
        get: function () {
          var e;
          return (null === (e = this.queryService.store) || void 0 === e ? void 0 : e.checked) || [];
        }
      }, {
        key: "componentDidMount",
        value: function () {
          this.filterModalModel.queryWhenReady();
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t,
              r = this,
              n = this.props,
              o = n.t,
              i = n.bulkActionButtons,
              a = n.bulkActionComponents,
              c = n.includeCheckboxes,
              u = n.recommendationSelector,
              l = n.includePagination,
              s = n.includeFilterModal,
              f = n.showApprovalStatus,
              d = n.icon,
              b = n.hideTitle;
          return p.a.createElement("div", {
            "aria-label": "Recommendations Dashboard",
            className: "recommendations-dashboard"
          }, s ? p.a.createElement(Kg, {
            model: this.filterModalModel
          }) : null, p.a.createElement("div", {
            className: "row no-gutters align-items-stretch mb-2"
          }, p.a.createElement("div", {
            className: "col-md-7"
          }, b ? p.a.createElement("div", {
            className: "button-list"
          }, null === (t = i.actions) || void 0 === t ? void 0 : t.map(function (e) {
            return p.a.createElement("button", {
              type: "button",
              key: e.key,
              className: "btn btn-recommendations mx-1",
              onClick: r.onDoBulkAction(e.key, e.target.url, e.target.method)
            }, r.isDoingBulkAction[e.key] ? p.a.createElement(h.Spinner, null) : null, o(e.key));
          }), a.map(function (e) {
            var t,
                n = e.name;

            try {
              t = poe.a.getConstructor(n);
            } catch (e) {
              throw new Error("Unable to load component ".concat(n, " from ReactRailsUJS: ").concat(e));
            }

            var o = Vie(Vie({}, e.props), {}, {
              key: n,
              selectedIds: r.checkedIds
            });
            return p.a.createElement(t, o);
          })) : p.a.createElement(UO, {
            icon: d,
            colorClass: "recommendation-color",
            type: o("recommendations")
          }, p.a.createElement("div", {
            className: "button-list"
          }, null === (e = i.actions) || void 0 === e ? void 0 : e.map(function (e) {
            return p.a.createElement("button", {
              type: "button",
              key: e.key,
              className: "btn btn-recommendations mr-1",
              onClick: r.onDoBulkAction(e.key, e.target.url, e.target.method)
            }, r.isDoingBulkAction[e.key] ? p.a.createElement(h.Spinner, null) : null, o(e.key));
          }), a.map(function (e) {
            var t,
                n = e.name;

            try {
              t = poe.a.getConstructor(n);
            } catch (e) {
              throw new Error("Unable to load component ".concat(n, " from ReactRailsUJS: ").concat(e));
            }

            var o = Vie(Vie({}, e.props), {}, {
              key: n,
              selectedIds: r.checkedIds
            });
            return p.a.createElement(t, o);
          })))), p.a.createElement("div", {
            className: "col-md-1 d-flex justify-content-end pr-2 ".concat(b ? "" : "align-with-page-title")
          }, p.a.createElement("div", {
            className: "filters-button"
          }, p.a.createElement(h.FiltersButton, {
            onClick: this.onClickFilterFlag,
            badgeContent: this.filterModalModel.badgeContent
          }))), p.a.createElement("div", {
            className: "col-md-4 ".concat(b ? "" : "align-with-page-title")
          }, p.a.createElement(h.SearchBox, {
            className: "search-filter drop-shadow mr-1 ",
            showIcon: !0,
            placeholder: o("search_recommendations"),
            searchText: this.queryService.search,
            onClearSearch: this.onClearSearch,
            onChange: this.onChangeSearch
          }))), p.a.createElement("div", {
            className: "status-feedback justify-content-between ml-1 mb-2"
          }, p.a.createElement("div", {
            className: "checked-status"
          }, p.a.createElement("span", null, this.checkedCount), " ", p.a.createElement("span", null, 1 === this.checkedCount ? o("record_selected") : o("records_selected"))), this.queryService.filtersAppliedCount ? p.a.createElement("div", {
            className: "filter-status"
          }, p.a.createElement("span", null, this.queryService.filtersAppliedCount), " ", p.a.createElement("span", null, 1 === this.queryService.filtersAppliedCount ? o("filter_applied_not_all_records_are_shown") : o("filters_applied_not_all_records_are_shown")), " ", p.a.createElement("a", {
            href: "#",
            onClick: this.filterModalModel.onClear
          }, o("clear_filters"))) : null), p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col"
          }, this.queryService.isPending ? p.a.createElement("div", {
            className: "query-spinner"
          }, p.a.createElement(h.Spinner, null)) : null, p.a.createElement(loe, {
            recommendations: this.recommendations,
            recommendationsStore: this.recommendationsStore,
            archiveIndex: this.queryService.archiveIndex,
            recommendationsPath: this.recommendationsStore.recommendationsBasePath,
            includeCheckboxes: c,
            isChecked: this.isChecked,
            checkedCount: this.checkedCount,
            onUncheckAll: this.unCheckAll,
            onUncheckPage: this.unCheckAllOnPage,
            onSelectAll: this.checkAll,
            onSelectPage: this.checkAllOnPage,
            recommendationSelector: u,
            showApprovalStatus: f
          }))), l ? p.a.createElement("div", {
            className: "text-center"
          }, p.a.createElement(Bie, {
            className: "justify-content-center",
            currentPageNumber: this.queryService.currentPageNumber,
            pages: this.queryService.pages,
            onGoToPage: this.goToPage
          })) : null);
        }
      }]);
    }()).defaultProps = {
      bulkActionButtons: {},
      bulkActionComponents: [],
      includeCheckboxes: !0,
      includePagination: !0,
      includeFilterModal: !0
    }, Pie = Yie((jie = Iie).prototype, "filterModalId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "recommendation-filter-modal";
      }
    }), _ie = Yie(jie.prototype, "defaultTotalRecords", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), Eie = Yie(jie.prototype, "allRecommendationSerials", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return null;
      }
    }), Sie = Yie(jie.prototype, "isDoingBulkAction", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return {};
      }
    }), Yie(jie.prototype, "allChecked", [f.computed], Object.getOwnPropertyDescriptor(jie.prototype, "allChecked"), jie.prototype), Yie(jie.prototype, "isChecked", [f.computed], Object.getOwnPropertyDescriptor(jie.prototype, "isChecked"), jie.prototype), Yie(jie.prototype, "badgeContent", [f.computed], Object.getOwnPropertyDescriptor(jie.prototype, "badgeContent"), jie.prototype), Yie(jie.prototype, "recommendations", [f.computed], Object.getOwnPropertyDescriptor(jie.prototype, "recommendations"), jie.prototype), Yie(jie.prototype, "checkedCount", [f.computed], Object.getOwnPropertyDescriptor(jie.prototype, "checkedCount"), jie.prototype), Yie(jie.prototype, "checkedIds", [f.computed], Object.getOwnPropertyDescriptor(jie.prototype, "checkedIds"), jie.prototype), Cie = Yie(jie.prototype, "onChangeSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.queryService.changeSearch(t.target.value), e.queryService.runQuery();
        };
      }
    }), kie = Yie(jie.prototype, "onClearSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.queryService.clearSearch(), e.queryService.runQuery();
        };
      }
    }), Rie = Yie(jie.prototype, "onClickFilterFlag", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.filterModalModel.show();
        };
      }
    }), Tie = Yie(jie.prototype, "onDoBulkAction", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r, n) {
          return function () {
            var o = e.props.authenticityToken;
            return e.isDoingBulkAction[t] = !0, fetch(r, {
              method: (n || "").toUpperCase() || "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                ids: e.checkedIds,
                authenticity_token: o
              })
            }).then(function (e) {
              if (e.ok) return alert("Success!");
              throw alert(e.statusText), Error(e.statusText);
            }).catch(console.error).finally(function () {
              return Object(f.runInAction)(function () {
                e.isDoingBulkAction[t] = !1;
              });
            });
          };
        };
      }
    }), zie = Yie(jie.prototype, "unCheckAll", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.queryService.unCheckAll();
        };
      }
    }), Nie = Yie(jie.prototype, "unCheckAllOnPage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.queryService.unCheckAllOnPage();
        };
      }
    }), Die = Yie(jie.prototype, "checkAll", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.queryService.checkAll();
        };
      }
    }), xie = Yie(jie.prototype, "checkAllOnPage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.queryService.checkAllOnPage();
        };
      }
    }), Aie = Yie(jie.prototype, "goToPage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.queryService.queryPage(t).catch(function (e) {
            console.error(e);
          });
        };
      }
    }), Mie = Yie(jie.prototype, "registerClearFiltersCallback", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.clearFiltersCallback = t;
        };
      }
    }), Oie = jie)) || Oie) || Oie,
        iae = jO(Object(g.a)()(oae));

    function aae(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function cae(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, uae(n.key), n);
      }
    }

    function uae(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function lae(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var sae,
        pae = ($ie = lae((Qie = function () {
      return e = function e(t) {
        var r = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.id = "recommendation-selector-".concat(Object(td.v4)()), this.headerId = "recommendation-selector-header-".concat(Object(td.v4)()), aae(this, "selectedId", $ie, this), aae(this, "documentNumber", Xie, this), aae(this, "writtenBy", Zie, this), aae(this, "date", eae, this), aae(this, "onChange", tae, this), aae(this, "select", rae, this), aae(this, "update", nae, this), this.show = function () {
          return $("#".concat(r.id)).modal("show");
        }, this.close = function () {
          $("#".concat(r.id)).modal("hide");
        }, this.update((null == t ? void 0 : t.recommendation) || {}), this.disableSelection = null == t ? void 0 : t.disableSelection, this.paramName = null == t ? void 0 : t.paramName;
      }, (t = [{
        key: "shouldDisable",
        get: function () {
          return !!this.selectedId || !!this.recommendationId;
        }
      }, {
        key: "linkedId",
        get: function () {
          return this.selectedId || this.recommendationId;
        }
      }, {
        key: "displayTitle",
        get: function () {
          var e;
          return (null === (e = this.recommendation) || void 0 === e ? void 0 : e.title) || "";
        }
      }]) && cae(e.prototype, t), r && cae(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "selectedId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Xie = lae(Qie.prototype, "documentNumber", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Zie = lae(Qie.prototype, "writtenBy", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), eae = lae(Qie.prototype, "date", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), lae(Qie.prototype, "shouldDisable", [f.computed], Object.getOwnPropertyDescriptor(Qie.prototype, "shouldDisable"), Qie.prototype), lae(Qie.prototype, "linkedId", [f.computed], Object.getOwnPropertyDescriptor(Qie.prototype, "linkedId"), Qie.prototype), lae(Qie.prototype, "displayTitle", [f.computed], Object.getOwnPropertyDescriptor(Qie.prototype, "displayTitle"), Qie.prototype), tae = lae(Qie.prototype, "onChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function (r) {
            e[t] = r.target.value;
          };
        };
      }
    }), rae = lae(Qie.prototype, "select", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.selectedId = null == t ? void 0 : t.id, e.update(t), e.close();
        };
      }
    }), nae = lae(Qie.prototype, "update", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r, n;
          e.recommendation = t, e.recommendationId = null == t ? void 0 : t.id, e.documentNumber = (null == t ? void 0 : t.documentNumber) || (null == t ? void 0 : t.document_number) || "", e.writtenBy = (null == t || null === (r = t.writtenBy) || void 0 === r ? void 0 : r.name) || (null == t || null === (n = t.written_by) || void 0 === n ? void 0 : n.name) || "", e.date = (null == t ? void 0 : t.date) || "";
        };
      }
    }), Qie);

    function fae(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, dae(n.key), n);
      }
    }

    function dae(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function bae(e, t, r) {
      return t = yae(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], yae(e).constructor) : t.apply(e, r));
    }

    function yae(e) {
      return (yae = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function mae(e, t) {
      return (mae = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var vae,
        hae,
        gae,
        wae = Object(d.observer)(sae = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), bae(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && mae(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && fae(e.prototype, t), r && fae(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.t,
              r = e.recommendationSelector;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("div", {
            className: "form-group"
          }, p.a.createElement("div", {
            className: "recommendation-selector-container"
          }, p.a.createElement("label", {
            className: "text-secondary text-uppercase text-nowrap font-weight-bold"
          }, t("recommendation_reference")), r.disableSelection ? p.a.createElement("span", {
            title: r.recommendation.title,
            className: "recommendation-reference-title"
          }, r.displayTitle) : p.a.createElement("a", {
            href: "#",
            className: "recommendation-selector-button",
            onClick: r.show
          }, t("choose_recommendation"))), r.shouldDisable ? p.a.createElement("input", {
            type: "hidden",
            name: "".concat(r.paramName, "[recommendation][id]"),
            value: r.linkedId
          }) : null, p.a.createElement("input", {
            type: "text",
            "aria-label": t("recommendation_reference"),
            name: "".concat(r.paramName, "[recommendation_snapshot][document_number]"),
            placeholder: t("recommendation_reference_optional"),
            className: "form-control",
            onChange: r.onChange("documentNumber"),
            value: r.documentNumber,
            disabled: r.shouldDisable
          })), p.a.createElement("div", {
            className: "form-group text-secondary text-uppercase font-weight-bold"
          }, p.a.createElement("label", null, t("recommended_by")), p.a.createElement("input", {
            type: "text",
            "aria-label": t("recommended_by"),
            name: "".concat(r.paramName, "[recommendation_snapshot][written_by][name]"),
            placeholder: t("recommended_by_optional"),
            className: "form-control",
            onChange: r.onChange("writtenBy"),
            value: r.writtenBy,
            disabled: r.shouldDisable
          })), p.a.createElement("div", {
            className: "form-group text-secondary text-uppercase font-weight-bold"
          }, p.a.createElement("label", null, t("if2.date")), p.a.createElement("input", {
            type: "date",
            "aria-label": t("if2.date"),
            name: "".concat(r.paramName, "[recommendation_snapshot][date]"),
            placeholder: "MM/DD/YYYY",
            className: "form-control",
            onChange: r.onChange("date"),
            value: r.date,
            disabled: r.shouldDisable
          })));
        }
      }]);
    }()) || sae,
        Oae = Object(g.a)()(wae);

    function jae(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Pae(n.key), n);
      }
    }

    function Pae(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function _ae(e, t, r) {
      return t = Eae(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Eae(e).constructor) : t.apply(e, r));
    }

    function Eae(e) {
      return (Eae = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Sae(e, t) {
      return (Sae = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Cae(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var kae,
        Rae = Object(d.observer)((Cae((hae = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = _ae(this, t, [].concat(n)), "goToPage", gae, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Sae(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && jae(e.prototype, t), r && jae(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "options",
        get: function () {
          var e = this.props,
              t = e.model,
              r = e.queryService;
          return {
            includeCheckboxes: !1,
            recommendationSelector: t,
            recommendationsApi: this.recommendationsApi,
            recommendationsStore: this.recommendationsStore,
            queryService: r,
            includePagination: !1,
            includeFilterModal: !1
          };
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.t,
              r = e.disableAnimation,
              n = e.title,
              o = e.model,
              i = e.queryService;
          return p.a.createElement(h.ModalDialog, {
            id: o.id,
            dismissOnClose: !1,
            className: "if2-modal recommendation-selector",
            disableAnimation: r,
            ariaLabelledBy: o.headerId
          }, p.a.createElement(h.ModalHeader, {
            id: o.headerId,
            title: n || t("choose_recommendation"),
            dismissOnClose: !1,
            onClose: o.close
          }), p.a.createElement(h.ModalBody, null, p.a.createElement(iae, Object.assign({}, this.props, this.options))), p.a.createElement(h.ModalFooter, null, p.a.createElement(Bie, {
            className: "justify-content-center",
            currentPageNumber: i.currentPageNumber,
            pages: i.pages,
            onGoToPage: this.goToPage
          }), p.a.createElement("button", {
            type: "button",
            className: "btn btn-secondary",
            onClick: o.close
          }, "Cancel")));
        }
      }]);
    }()).prototype, "options", [f.computed], Object.getOwnPropertyDescriptor(hae.prototype, "options"), hae.prototype), gae = Cae(hae.prototype, "goToPage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.queryService.queryPage(t).catch(function (e) {
            console.error(e);
          });
        };
      }
    }), vae = hae)) || vae,
        Tae = Object(g.a)()(Rae);

    function zae(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Nae(n.key), n);
      }
    }

    function Nae(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Dae(e, t, r) {
      return t = xae(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], xae(e).constructor) : t.apply(e, r));
    }

    function xae(e) {
      return (xae = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Aae(e, t) {
      return (Aae = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Mae = Object(d.inject)("configuration")(kae = Object(d.observer)(kae = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);
        var n = (r = Dae(this, t, [e])).props,
            o = n.paramName,
            i = n.recommendationsBasePath,
            a = n.recommendationSelectorViewModel,
            c = n.recommendationsStore,
            u = n.recommendation,
            l = n.disableSelection,
            s = n.t,
            p = n.configuration;
        r.recommendationsApi = new Ooe(i), r.recommendationsStore = c || new xoe(r.recommendationsApi);
        var f = {};
        f = null != u && u.id ? r.recommendationsStore.new(u) : u, r.recommendationSelector = a || new pae({
          recommendation: f,
          disableSelection: l,
          paramName: o || "spray_record"
        }), l || (r.queryService = new Woe(r.recommendationsStore, e.accountIds || []));
        var d = "recommendation-filter-modal-".concat(Object(td.v4)());
        return r.filterModalModel = new Ng({
          id: d,
          title: s("recommendation_filters"),
          store: r.recommendationsStore,
          queryService: r.queryService,
          storageName: "recommendation-selector-filters",
          t: s,
          configuration: p
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Aae(e, t);
      }(t, s["Component"]), r = t, o = [{
        key: "isEmpty",
        value: function (e) {
          return !(null != e && e.id);
        }
      }], (n = [{
        key: "render",
        value: function () {
          var e = this.props.hideTitle;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement(Oae, {
            recommendationSelector: this.recommendationSelector
          }), this.recommendationSelector.disableSelection ? null : p.a.createElement(p.a.Fragment, null, p.a.createElement(Tae, {
            model: this.recommendationSelector,
            filterModalModel: this.filterModalModel,
            recommendationsStore: this.recommendationsStore,
            queryService: this.queryService,
            hideTitle: e
          }), p.a.createElement(Kg, {
            model: this.filterModalModel
          })));
        }
      }]) && zae(r.prototype, n), o && zae(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || kae) || kae,
        Iae = jO(Object(g.a)()(Mae)),
        Fae = ["label", "onClick", "className"],
        Bae = {
      label: go.a.string.isRequired,
      onClick: go.a.func
    },
        Lae = p.a.forwardRef(function (e, t) {
      var r = e.label,
          n = e.onClick,
          o = e.className,
          i = er(e, Fae);
      return p.a.createElement("button", Zt({
        ref: t,
        type: "button",
        className: rr()("close", o),
        onClick: n
      }, i), p.a.createElement("span", {
        "aria-hidden": "true"
      }, "×"), p.a.createElement("span", {
        className: "sr-only"
      }, r));
    });
    Lae.displayName = "CloseButton", Lae.propTypes = Bae, Lae.defaultProps = {
      label: "Close"
    };
    var Vae,
        Uae = Lae,
        qae = ["bsPrefix", "show", "closeLabel", "className", "children", "variant", "onClose", "dismissible", "transition"],
        Kae = (Vae = "h4", p.a.forwardRef(function (e, t) {
      return p.a.createElement("div", Zt({}, e, {
        ref: t,
        className: rr()(e.className, Vae)
      }));
    }));
    Kae.displayName = "DivStyledAsH4";
    var Gae = bc("alert-heading", {
      Component: Kae
    }),
        Wae = bc("alert-link", {
      Component: Va
    }),
        Hae = {
      show: !0,
      transition: SB,
      closeLabel: "Close alert"
    },
        Jae = p.a.forwardRef(function (e, t) {
      var r = Po(e, {
        show: "onClose"
      }),
          n = r.bsPrefix,
          o = r.show,
          i = r.closeLabel,
          a = r.className,
          c = r.children,
          u = r.variant,
          l = r.onClose,
          s = r.dismissible,
          f = r.transition,
          d = er(r, qae),
          b = or(n, "alert"),
          y = To(function (e) {
        l && l(!1, e);
      }),
          m = !0 === f ? SB : f,
          v = p.a.createElement("div", Zt({
        role: "alert"
      }, m ? void 0 : d, {
        ref: t,
        className: rr()(a, b, u && b + "-" + u, s && b + "-dismissible")
      }), s && p.a.createElement(Uae, {
        onClick: y,
        label: i
      }), c);
      return m ? p.a.createElement(m, Zt({
        unmountOnExit: !0
      }, d, {
        ref: void 0,
        in: o
      }), v) : o ? v : null;
    });
    Jae.displayName = "Alert", Jae.defaultProps = Hae, Jae.Link = Wae, Jae.Heading = Gae;
    var Yae = Jae;

    function Qae(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $ae(n.key), n);
      }
    }

    function $ae(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var Xae = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.apiPath = t || this.defaultApiPath;
      }, (t = [{
        key: "apiReportsPath",
        value: function () {
          return "/if2/api/reports";
        }
      }, {
        key: "reportsPath",
        value: function () {
          return "/if2/legacy/reports";
        }
      }, {
        key: "reportPath",
        value: function (e) {
          return "/if2/legacy/reports/".concat(e);
        }
      }, {
        key: "apiReportPath",
        value: function (e) {
          return "/if2/api/reports/".concat(e);
        }
      }, {
        key: "csrf",
        value: function () {
          return document.querySelector("[name='csrf-token']").content;
        }
      }, {
        key: "create",
        value: function (e) {
          var t = this.csrf();
          return fetch(this.apiReportsPath(), {
            method: "POST",
            headers: {
              "X-CSRF-Token": t,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              report: e
            })
          }).then(function (e) {
            return e.json();
          });
        }
      }, {
        key: "update",
        value: function (e, t) {
          var r = this.csrf();
          return fetch(this.apiReportPath(e), {
            method: "PATCH",
            headers: {
              "X-CSRF-Token": r,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              report: t
            })
          }).then(function (e) {
            return e.json();
          });
        }
      }, {
        key: "delete",
        value: function (e) {
          var t = this.csrf();
          return fetch(this.apiReportPath(e), {
            method: "DELETE",
            headers: {
              "X-CSRF-Token": t,
              "Content-Type": "application/json"
            }
          }).then(function (e) {
            return e.json();
          });
        }
      }]) && Qae(e.prototype, t), r && Qae(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function Zae(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ece(n.key), n);
      }
    }

    function ece(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function tce(e, t, r) {
      return t = rce(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], rce(e).constructor) : t.apply(e, r));
    }

    function rce(e) {
      return (rce = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function nce(e, t) {
      return (nce = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function oce(e) {
      return "".concat("/if2/legacy/report_templates", "/").concat(e);
    }

    var ice,
        ace,
        cce = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), tce(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && nce(e, t);
      }(t, My), r = t, (n = [{
        key: "create",
        value: function (e) {
          return this.jsonFetch("/if2/legacy/report_templates", "POST", {
            template: e
          });
        }
      }, {
        key: "update",
        value: function (e, t) {
          return this.jsonFetch(oce(e), "PATCH", {
            template: t
          });
        }
      }, {
        key: "delete",
        value: function (e) {
          return this.jsonFetch(oce(e), "DELETE");
        }
      }]) && Zae(r.prototype, n), o && Zae(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function uce(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, lce(n.key), n);
      }
    }

    function lce(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function sce(e, t, r) {
      return t = pce(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], pce(e).constructor) : t.apply(e, r));
    }

    function pce(e) {
      return (pce = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function fce(e, t) {
      return (fce = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function dce(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var bce,
        yce,
        mce = Object(d.observer)((dce((ace = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), sce(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && fce(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && uce(e.prototype, t), r && uce(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "classNames",
        get: function () {
          var e = this.props.reportsManager;
          return e.showInvalidFeedback && !e.reportIsValid ? "is-invalid" : "";
        }
      }, {
        key: "title",
        get: function () {
          var e = this.props,
              t = e.reportsManager,
              r = e.t;
          return t.showInvalidFeedback && !t.reportIsValid ? r("cannot_be_blank") : "";
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.reportsManager,
              r = e.t;
          return p.a.createElement("div", {
            className: "col-md-6"
          }, p.a.createElement(LC, {
            inputClassName: this.classNames,
            title: this.title,
            placeholder: r("title_placeholder"),
            value: t.reportTitle,
            onChange: t.changeTitle
          }));
        }
      }]);
    }()).prototype, "classNames", [f.computed], Object.getOwnPropertyDescriptor(ace.prototype, "classNames"), ace.prototype), dce(ace.prototype, "title", [f.computed], Object.getOwnPropertyDescriptor(ace.prototype, "title"), ace.prototype), ice = ace)) || ice,
        vce = Object(g.a)()(mce);

    function hce(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, gce(n.key), n);
      }
    }

    function gce(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function wce(e, t, r) {
      return t = Oce(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Oce(e).constructor) : t.apply(e, r));
    }

    function Oce(e) {
      return (Oce = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function jce(e, t) {
      return (jce = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Pce,
        _ce,
        Ece,
        Sce = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((yce = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), wce(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && jce(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && hce(e.prototype, t), r && hce(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "_reportsManager",
        get: function () {
          return this.props.reportsManager;
        }
      }, {
        key: "_renderCancelButton",
        value: function (e) {
          return p.a.createElement("button", {
            type: "button",
            className: "btn btn-secondary btn-text",
            style: {
              margin: "0 0.1em"
            },
            onClick: this._reportsManager.cancel
          }, e("cancel").toUpperCase());
        }
      }, {
        key: "_renderDeleteButton",
        value: function (e) {
          if (this._reportsManager.isNew || this._reportsManager.isTemplate && !this._reportsManager.canEditTemplates) return null;
          var t = this._reportsManager.isTemplate ? this._reportsManager.deleteTemplate : this._reportsManager.deleteReport;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("button", {
            type: "button",
            className: "btn btn-danger btn-text",
            style: {
              margin: "0 0.1em"
            },
            onClick: t
          }, e("delete").toUpperCase()));
        }
      }, {
        key: "_renderDownloadButton",
        value: function (e) {
          return this._reportsManager.isTemplate ? null : p.a.createElement(p.a.Fragment, null, p.a.createElement("button", {
            type: "button",
            className: "btn btn-warning btn-text",
            style: {
              margin: "0 0.1em"
            },
            onClick: this._reportsManager.downloadReport
          }, e("download").toUpperCase()));
        }
      }, {
        key: "_renderSaveButton",
        value: function (e) {
          var t = this._reportsManager.isTemplate && this._reportsManager.canEditTemplates ? this._reportsManager.saveTemplate : this._reportsManager.saveReport;
          return p.a.createElement("button", {
            type: "button",
            className: "btn btn-success btn-text",
            onClick: t
          }, e("save").toUpperCase());
        }
      }, {
        key: "_renderSaveAsNewReportButton",
        value: function (e) {
          return p.a.createElement("button", {
            className: "dropdown-item",
            type: "button",
            onClick: this._reportsManager.saveAsNewReport
          }, e("if2.reports.save_as_new_report"));
        }
      }, {
        key: "_renderSaveAsNewTemplateButton",
        value: function (e) {
          return this._reportsManager.canEditTemplates ? p.a.createElement("button", {
            className: "dropdown-item",
            type: "button",
            onClick: this._reportsManager.saveAsNewTemplate
          }, e("if2.reports.save_as_new_template")) : null;
        }
      }, {
        key: "_renderSaveDropdown",
        value: function (e) {
          return p.a.createElement("div", {
            className: "btn-group",
            role: "group",
            "aria-label": "Save/Save as button group",
            style: {
              margin_left: "0.1em"
            }
          }, this._renderSaveButton(e), p.a.createElement("button", {
            type: "button",
            className: "btn btn-success btn-text dropdown-toggle dropdown-toggle-split",
            "data-toggle": "dropdown",
            "aria-expanded": "false"
          }, p.a.createElement("span", {
            className: "sr-only"
          }, e("toggle_dropdown"))), p.a.createElement("div", {
            className: "dropdown-menu dropdown-menu-right"
          }, this._renderSaveAsNewReportButton(e), this._renderSaveAsNewTemplateButton(e)));
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return p.a.createElement("div", {
            className: "d-flex col-md-auto"
          }, p.a.createElement("div", {
            className: "d-flex align-content-center pr-2",
            style: {
              width: "2rem"
            }
          }, p.a.createElement(h.FiltersButton, {
            onClick: this._reportsManager.openFilterSummaryModal,
            badgeContent: this._reportsManager.columnFiltersModel.numReportFilters
          })), p.a.createElement("div", null, this._renderCancelButton(e), this._renderDeleteButton(e), this._renderDownloadButton(e), this._renderSaveDropdown(e)));
        }
      }]);
    }()).prototype, "_reportsManager", [f.computed], Object.getOwnPropertyDescriptor(yce.prototype, "_reportsManager"), yce.prototype), bce = yce)) || bce,
        Cce = Object(g.a)()(Sce);

    function kce(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Rce(n.key), n);
      }
    }

    function Rce(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Tce(e, t, r) {
      return t = zce(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], zce(e).constructor) : t.apply(e, r));
    }

    function zce(e) {
      return (zce = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Nce(e, t) {
      return (Nce = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Dce,
        xce,
        Ace,
        Mce,
        Ice = Object(d.observer)((Ece = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((_ce = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = Tce(this, t, [e]), "value", Ece, r), r.onChange = function (e) {
          r.value = e.target.value;
        }, r.onKeyUp = function (e) {
          "Escape" === e.key && r.onCancel(), "Enter" === e.key && r.onSave();
        }, r.onCancel = function () {
          (0, r.props.onDone)();
        }, r.onSave = function () {
          var e = r.props,
              t = e.onChange,
              n = e.onDone;
          t(r.value), n();
        }, r.valueDisposer = Object(f.autorun)(function () {
          var e = r.props.value;
          r.value = e;
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Nce(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "componentWillUnmount",
        value: function () {
          this.valueDisposer();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.placeholder;
          return p.a.createElement("input", {
            onKeyUp: this.onKeyUp,
            onChange: this.onChange,
            onBlur: this.onSave,
            value: this.value || "",
            placeholder: e
          });
        }
      }]) && kce(r.prototype, n), o && kce(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "value", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Pce = _ce)) || Pce;

    function Fce(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Bce(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Lce(n.key), n);
      }
    }

    function Lce(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Vce(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Uce = (xce = Vce((Dce = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Fce(this, "isShowing", xce, this), Fce(this, "position", Ace, this), Fce(this, "nameOverride", Mce, this), this.constructor.validateProps(t), this.position = t.position, this.isShowing = t.isShowing || !1, this.nameOverride = t.nameOverride || "", this.ref = Object(s.createRef)(), this.id = t.id || Object(td.v4)();
      }, r = [{
        key: "requiredProps",
        value: function () {
          return ["position"];
        }
      }, {
        key: "type",
        value: function () {
          return "ColumnSpecBase";
        }
      }, {
        key: "validateMissing",
        value: function (e) {
          if (!e) throw new Error("Missing props");
          var t = [];
          if (this.requiredProps().forEach(function (r) {
            null == e[r] && t.push(r);
          }), t.length) throw new Error("Missing props: ".concat(t.join(", ")));
        }
      }, {
        key: "validateProps",
        value: function (e) {
          this.validateMissing(e);
        }
      }], (t = [{
        key: "changeName",
        value: function (e) {
          this.nameOverride = e;
        }
      }, {
        key: "defaultName",
        value: function () {
          return "";
        }
      }, {
        key: "display",
        value: function (e) {}
      }, {
        key: "errors",
        value: function () {
          return [];
        }
      }, {
        key: "getName",
        value: function () {
          return this.nameOverride || this.defaultName();
        }
      }, {
        key: "updatePosition",
        value: function (e) {
          return this.position = e, this;
        }
      }, {
        key: "toJS",
        value: function () {
          return {
            position: this.position,
            is_showing: this.isShowing,
            name_override: this.nameOverride,
            id: this.id,
            type: this.constructor.type()
          };
        }
      }]) && Bce(e.prototype, t), r && Bce(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "isShowing", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Ace = Vce(Dce.prototype, "position", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Mce = Vce(Dce.prototype, "nameOverride", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Vce(Dce.prototype, "changeName", [f.action], Object.getOwnPropertyDescriptor(Dce.prototype, "changeName"), Dce.prototype), Vce(Dce.prototype, "updatePosition", [f.action], Object.getOwnPropertyDescriptor(Dce.prototype, "updatePosition"), Dce.prototype), Dce);

    function qce(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Kce(n.key), n);
      }
    }

    function Kce(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var Gce = function () {
      return e = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
      }, r = [{
        key: "type",
        value: function () {
          return "CalculationOperandSpecBase";
        }
      }], (t = [{
        key: "getName",
        value: function () {
          return "";
        }
      }, {
        key: "getValue",
        value: function (e) {}
      }, {
        key: "toJS",
        value: function () {
          return {
            type: this.constructor.type()
          };
        }
      }]) && qce(e.prototype, t), r && qce(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function Wce(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Hce(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Wce(Object(r), !0).forEach(function (t) {
          Jce(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Wce(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Jce(e, t, r) {
      return (t = Qce(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Yce(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Qce(n.key), n);
      }
    }

    function Qce(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function $ce(e, t, r) {
      return t = eue(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], eue(e).constructor) : t.apply(e, r));
    }

    function Xce() {
      return (Xce = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Zce(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Zce(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = eue(e)););

      return e;
    }

    function eue(e) {
      return (eue = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function tue(e, t) {
      return (tue = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var rue,
        nue,
        oue,
        iue,
        aue = function (e) {
      function t(e) {
        var r;
        if (function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = $ce(this, t, [e])).referenceColumnSpec = e.referenceColumnSpec, !r.referenceColumnSpec) throw new Error("Missing referenceColumnSpec!");
        return r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && tue(e, t);
      }(t, Gce), function (e, t, r) {
        return t && Yce(e.prototype, t), r && Yce(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "getName",
        value: function () {
          return this.referenceColumnSpec.getName();
        }
      }, {
        key: "getValue",
        value: function (e) {
          return this.referenceColumnSpec.display(e);
        }
      }, {
        key: "toJS",
        value: function () {
          return Hce(Hce({}, (e = t, r = "toJS", n = this, i = Xce(eue(1 & (o = 3) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([])), {}, {
            reference_spec: this.referenceColumnSpec.id
          });
          var e, r, n, o, i;
        }
      }], [{
        key: "isColumnCalculationOperandSpec",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(t.prototype, e);
        }
      }, {
        key: "type",
        value: function () {
          return "ColumnCalculationOperandSpec";
        }
      }]);
    }();

    function cue(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function uue(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? cue(Object(r), !0).forEach(function (t) {
          lue(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : cue(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function lue(e, t, r) {
      return (t = fue(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function sue(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function pue(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, fue(n.key), n);
      }
    }

    function fue(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function due(e, t, r) {
      return t = hue(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], hue(e).constructor) : t.apply(e, r));
    }

    function bue(e, t) {
      return (bue = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function yue(e, t, r, n) {
      var o = mue(hue(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function mue() {
      return (mue = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = vue(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function vue(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = hue(e)););

      return e;
    }

    function hue(e) {
      return (hue = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function gue(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var wue,
        Oue,
        jue,
        Pue,
        _ue,
        Eue,
        Sue,
        Cue,
        kue,
        Rue,
        Tue,
        zue,
        Nue,
        Due = (nue = gue((rue = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), sue(r = due(this, t, [e]), "calculation", nue, r), sue(r, "operand1", oue, r), sue(r, "operand2", iue, r), r.calculation = e.calculation, r.operand1 = e.operand1, r.operand2 = e.operand2, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && bue(e, t);
      }(t, Uce), r = t, o = [{
        key: "getOperandName",
        value: function (e) {
          return aue.isColumnCalculationOperandSpec(e) && this.isCalculationColumnSpec(e.referenceColumnSpec) ? "(".concat(e.getName(), ")") : e.getName();
        }
      }, {
        key: "isCalculationColumnSpec",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(t.prototype, e);
        }
      }, {
        key: "requiredProps",
        value: function () {
          return yue(t, "requiredProps", this, 2)([]).concat(["calculation", "operand1", "operand2"]);
        }
      }, {
        key: "type",
        value: function () {
          return "CalculationColumnSpec";
        }
      }], (n = [{
        key: "defaultName",
        value: function () {
          return this.calculation.display([this.constructor.getOperandName(this.operand1), this.constructor.getOperandName(this.operand2)]);
        }
      }, {
        key: "display",
        value: function (e) {
          var t;
          return (null === (t = this.calculate(e)) || void 0 === t || null === (t = t.result) || void 0 === t ? void 0 : t.displayValue) || "";
        }
      }, {
        key: "errors",
        value: function (e) {
          var t;
          return (null === (t = this.calculate(e)) || void 0 === t ? void 0 : t.errors) || [];
        }
      }, {
        key: "calculate",
        value: function (e) {
          return this.calculation.calculate([this.operand1.getValue(e), this.operand2.getValue(e)]);
        }
      }, {
        key: "toJS",
        value: function () {
          return uue(uue({}, yue(t, "toJS", this, 3)([])), {}, {
            calculation: this.calculation.constructor.operatorId(),
            operand1: this.operand1.toJS(),
            operand2: this.operand2.toJS()
          });
        }
      }]) && pue(r.prototype, n), o && pue(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "calculation", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), oue = gue(rue.prototype, "operand1", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), iue = gue(rue.prototype, "operand2", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), rue);

    function xue(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Aue(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Mue(n.key), n);
      }
    }

    function Mue(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Iue(e, t, r) {
      return t = Fue(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Fue(e).constructor) : t.apply(e, r));
    }

    function Fue(e) {
      return (Fue = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Bue(e, t) {
      return (Bue = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Lue(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Vue,
        Uue = Object(d.observer)((jue = Lue((Oue = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return xue(e = Iue(this, t, [].concat(n)), "isAdding", jue, e), xue(e, "isRemoving", Pue, e), xue(e, "addColumn", _ue, e), e.hasMenuItems = function (e) {
          return e.length > 0;
        }, e.onAddColumnForAttribute = function (t) {
          return Object(f.action)(function (r) {
            r.preventDefault(), e.isAdding = !0, setTimeout(e.addColumn(t), 20);
          });
        }, xue(e, "onCalculate", Eue, e), xue(e, "onEditCalculation", Sue, e), xue(e, "onRemoveColumn", Cue, e), e.onRenameColumn = function (t) {
          var r = e.props,
              n = r.reportsManager,
              o = r.columnSpec;
          t.preventDefault(), n.renameColumn(o);
        }, xue(e, "onFilter", kue, e), xue(e, "onSortAscending", Rue, e), xue(e, "onSortDescending", Tue, e), xue(e, "onToggleGroup", zue, e), xue(e, "removeColumn", Nue, e), e.renderAddColumnMenuItem = function (t) {
          var r = e.findColumn(t);
          return p.a.createElement(_c.Item, {
            role: "menuitem",
            className: "".concat(r.isShowing ? "disabled" : ""),
            key: t.key,
            onClick: e.onAddColumnForAttribute(t)
          }, r.getName() || t.name);
        }, e.renderAddColumnMenuItems = function (t) {
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("div", {
            className: "dropdown-divider"
          }), p.a.createElement("h6", {
            className: "dropdown-header"
          }, "Add Column"), Object(x.map)(e.renderAddColumnMenuItem, t));
        }, e.renderNull = function () {
          return null;
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Bue(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Aue(e.prototype, t), r && Aue(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "isBeingFiltered",
        get: function () {
          var e = this.props,
              t = e.reportsManager,
              r = e.columnSpec;
          return !!t.columnFiltersModel.columnFilters[r.id];
        }
      }, {
        key: "findColumn",
        value: function (e) {
          var t = this.props,
              r = t.reportsManager,
              n = t.columnSpec;
          return r.findColumn([n.pathString].concat(e.key).join("/"));
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.reportsManager,
              r = e.columnSpec,
              n = e.t;
          return p.a.createElement(_c, null, p.a.createElement(_c.Toggle, {
            as: KB,
            bsPrefix: "link-dropdown-toggle",
            className: this.isAdding || this.isRemoving ? "icon icon-adding" : ""
          }, r.getName(), this.isBeingFiltered ? p.a.createElement("i", {
            className: "fas fa-filter ml-1"
          }) : null, t.isGrouped(r) ? p.a.createElement("i", {
            className: "fas fa-layer-group ml-1"
          }) : null, t.isSortingUp(r) ? p.a.createElement("i", {
            className: "fas fa-sort-up ml-1"
          }) : t.isSortingDown(r) ? p.a.createElement("i", {
            className: "fas fa-sort-down ml-1"
          }) : null), p.a.createElement(_c.Menu, null, p.a.createElement("h6", {
            className: "dropdown-header"
          }, n("column_actions")), p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "remove",
            onClick: this.onRemoveColumn
          }, p.a.createElement("i", {
            className: "fas fa-trash-alt pr-2"
          }), n("remove")), p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "rename",
            onClick: this.onRenameColumn
          }, p.a.createElement("i", {
            className: "fas fa-i-cursor pr-2"
          }), n("rename")), p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "filter",
            onClick: this.onFilter
          }, p.a.createElement("i", {
            className: "fas fa-filter pr-2"
          }), n("filter_verb")), Due.isCalculationColumnSpec(r) ? p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "edit_calculation",
            onClick: this.onEditCalculation
          }, p.a.createElement("i", {
            className: "fas fa-edit pr-2"
          }), n("edit_calculation"), "…") : null, p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "calculate",
            onClick: this.onCalculate
          }, p.a.createElement("i", {
            className: "fas fa-calculator pr-2"
          }), n("calculate"), "…"), p.a.createElement("h6", {
            className: "dropdown-header"
          }, n("group_sort")), p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "group",
            onClick: this.onToggleGroup
          }, p.a.createElement("i", {
            className: "fas fa-layer-group pr-2"
          }), t.isGrouped(r) ? n("ungroup") : n("group_verb")), p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "sort_ascending",
            onClick: this.onSortAscending
          }, p.a.createElement("i", {
            className: "fas fa-sort-up pr-2"
          }), n("sort_ascending")), p.a.createElement(_c.Item, {
            role: "menuitem",
            key: "sort_descending",
            onClick: this.onSortDescending
          }, p.a.createElement("i", {
            className: "fas fa-sort-down pr-2"
          }), n("sort_descending")), Object(x.ifElse)(this.hasMenuItems, this.renderAddColumnMenuItems, this.renderNull)(t.menuItemsFor(r))));
        }
      }]);
    }()).prototype, "isAdding", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Pue = Lue(Oue.prototype, "isRemoving", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Lue(Oue.prototype, "isBeingFiltered", [f.computed], Object.getOwnPropertyDescriptor(Oue.prototype, "isBeingFiltered"), Oue.prototype), _ue = Lue(Oue.prototype, "addColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function () {
            var r = e.props,
                n = r.reportsManager,
                o = r.columnSpec,
                i = n.isGrouped(o) ? n.groupSpecs.length : o.position + 1;
            n.addColumnAtPosition(e.findColumn(t), i), e.isAdding = !1;
          };
        };
      }
    }), Eue = Lue(Oue.prototype, "onCalculate", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.reportsManager,
              o = r.columnSpec;
          t.preventDefault(), n.openColumnCalculationModal(o, {
            isNew: !0
          });
        };
      }
    }), Sue = Lue(Oue.prototype, "onEditCalculation", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.reportsManager,
              o = r.columnSpec;
          t.preventDefault(), n.openColumnCalculationModal(o);
        };
      }
    }), Cue = Lue(Oue.prototype, "onRemoveColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.preventDefault(), e.isRemoving = !0, setTimeout(e.removeColumn, 20);
        };
      }
    }), kue = Lue(Oue.prototype, "onFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.reportsManager,
              n = t.columnSpec;
          r.openFilterModal(n);
        };
      }
    }), Rue = Lue(Oue.prototype, "onSortAscending", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.reportsManager,
              n = t.columnSpec;
          r.sortAscending(n);
        };
      }
    }), Tue = Lue(Oue.prototype, "onSortDescending", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.reportsManager,
              n = t.columnSpec;
          r.sortDescending(n);
        };
      }
    }), zue = Lue(Oue.prototype, "onToggleGroup", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.reportsManager,
              n = t.columnSpec;
          if (r.isGrouped(n)) return r.unGroup(n);
          r.group(n);
        };
      }
    }), Nue = Lue(Oue.prototype, "removeColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.reportsManager,
              n = t.columnSpec;
          r.removeColumn(n), e.isRemoving = !1;
        };
      }
    }), wue = Oue)) || wue,
        que = Object(g.a)()(Uue);

    function Kue(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Gue(n.key), n);
      }
    }

    function Gue(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Wue(e, t, r) {
      return t = Hue(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Hue(e).constructor) : t.apply(e, r));
    }

    function Hue(e) {
      return (Hue = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Jue(e, t) {
      return (Jue = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Yue,
        Que = Object(d.observer)(Vue = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = Wue(this, t, [].concat(n))).onDragColumnEnd = function (t) {
          var r = e.props,
              n = r.reportsManager,
              o = r.columnSpec;
          n.onDragColumnEnd(t, o);
        }, e.onDragColumnStart = function (t) {
          var r = e.props,
              n = r.reportsManager,
              o = r.columnSpec;
          n.onDragColumnStart(t, o);
        }, e.onDragOverColumn = function (t) {
          var r = e.props,
              n = r.reportsManager,
              o = r.columnSpec;
          n.onDragOverColumn(t, o);
        }, e.onDropColumn = function (t) {
          var r = e.props,
              n = r.reportsManager,
              o = r.columnSpec;
          n.onDropColumn(t, o);
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Jue(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.reportsManager,
              r = e.columnSpec;
          return p.a.createElement("th", {
            scope: "col",
            className: t.tableCellClass(r),
            ref: r.ref,
            draggable: t.columnToRename !== r,
            onDragStart: this.onDragColumnStart,
            onDragOver: this.onDragOverColumn,
            onDrop: this.onDropColumn,
            onDragEnd: this.onDragColumnEnd
          }, t.columnToRename === r ? p.a.createElement(Ice, {
            placeholder: r.defaultName(),
            value: r.nameOverride,
            onChange: t.onChangeColumnName,
            onDone: t.onDoneRenamingColumn
          }) : p.a.createElement(que, {
            reportsManager: t,
            columnSpec: r
          }));
        }
      }]) && Kue(r.prototype, n), o && Kue(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || Vue;

    function $ue(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Xue(n.key), n);
      }
    }

    function Xue(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Zue(e, t, r) {
      return t = ele(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ele(e).constructor) : t.apply(e, r));
    }

    function ele(e) {
      return (ele = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function tle(e, t) {
      return (tle = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var rle,
        nle,
        ole = Object(d.observer)(Yue = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Zue(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && tle(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props.reportsManager;
          return p.a.createElement("thead", {
            className: "thead-light"
          }, p.a.createElement("tr", null, e.visibleColumns.map(function (t) {
            return p.a.createElement(Que, {
              key: t.id,
              reportsManager: e,
              columnSpec: t
            });
          })));
        }
      }]) && $ue(r.prototype, n), o && $ue(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || Yue;

    function ile(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ale(n.key), n);
      }
    }

    function ale(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function cle(e, t, r) {
      return t = ule(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ule(e).constructor) : t.apply(e, r));
    }

    function ule(e) {
      return (ule = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function lle(e, t) {
      return (lle = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function sle(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var ple,
        fle,
        dle = Object(d.observer)((sle((nle = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), cle(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && lle(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "isDragging",
        get: function () {
          return this.props.reportsManager.isDragging;
        }
      }, {
        key: "draggedColumnSpec",
        get: function () {
          return this.props.reportsManager.draggedColumnSpec;
        }
      }, {
        key: "dropTargetColumnSpec",
        get: function () {
          return this.props.reportsManager.dropTargetColumnSpec;
        }
      }, {
        key: "tableCellClass",
        get: function () {
          var e = this.props.cell;
          return this.isDragging ? e.columnSpec === this.draggedColumnSpec ? "drag-origin" : e.columnSpec !== this.dropTargetColumnSpec ? "" : this.draggedColumnSpec.position < e.columnSpec.position ? "drop-after" : "drop-before" : "";
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.cell;
          return p.a.createElement("td", {
            className: this.tableCellClass
          }, e.displayValue, e.errors.length ? p.a.createElement("span", {
            className: "cell-error pl-1",
            title: e.errors.map(function (e) {
              return e.message;
            }).join("\n")
          }, p.a.createElement("i", {
            className: "fas fa-exclamation-triangle"
          })) : null);
        }
      }]) && ile(r.prototype, n), o && ile(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "isDragging", [f.computed], Object.getOwnPropertyDescriptor(nle.prototype, "isDragging"), nle.prototype), sle(nle.prototype, "draggedColumnSpec", [f.computed], Object.getOwnPropertyDescriptor(nle.prototype, "draggedColumnSpec"), nle.prototype), sle(nle.prototype, "dropTargetColumnSpec", [f.computed], Object.getOwnPropertyDescriptor(nle.prototype, "dropTargetColumnSpec"), nle.prototype), sle(nle.prototype, "tableCellClass", [f.computed], Object.getOwnPropertyDescriptor(nle.prototype, "tableCellClass"), nle.prototype), rle = nle)) || rle;

    function ble(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, yle(n.key), n);
      }
    }

    function yle(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function mle(e, t, r) {
      return t = vle(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], vle(e).constructor) : t.apply(e, r));
    }

    function vle(e) {
      return (vle = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function hle(e, t) {
      return (hle = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function gle(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var wle,
        Ole,
        jle = Object(d.observer)((gle((fle = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), mle(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && hle(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "numColumns",
        get: function () {
          return this.props.reportsManager.visibleColumns.length;
        }
      }, {
        key: "prefixCell",
        get: function () {
          var e = this.props.row;
          return e.level && e.level > 0 ? p.a.createElement("td", {
            colSpan: e.level
          }) : null;
        }
      }, {
        key: "bodyRow",
        get: function () {
          var e = this.props,
              t = e.row,
              r = e.reportsManager;
          return t.isGroup ? null : p.a.createElement("tr", null, this.prefixCell, t.cells.map(function (e) {
            return p.a.createElement(dle, {
              key: e.key,
              reportsManager: r,
              cell: e
            });
          }));
        }
      }, {
        key: "groupedRow",
        get: function () {
          var e = this.props,
              r = e.row,
              n = e.reportsManager;
          return r.isGroup ? p.a.createElement(p.a.Fragment, null, p.a.createElement("tr", null, this.prefixCell, p.a.createElement("td", {
            colSpan: this.numColumns - r.level
          }, r.displayValue)), r.children.map(function (e) {
            return p.a.createElement(t, {
              key: e.key,
              reportsManager: n,
              row: e
            });
          })) : null;
        }
      }, {
        key: "render",
        value: function () {
          return p.a.createElement(p.a.Fragment, null, this.groupedRow, this.bodyRow);
        }
      }]) && ble(r.prototype, n), o && ble(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "numColumns", [f.computed], Object.getOwnPropertyDescriptor(fle.prototype, "numColumns"), fle.prototype), gle(fle.prototype, "prefixCell", [f.computed], Object.getOwnPropertyDescriptor(fle.prototype, "prefixCell"), fle.prototype), gle(fle.prototype, "bodyRow", [f.computed], Object.getOwnPropertyDescriptor(fle.prototype, "bodyRow"), fle.prototype), gle(fle.prototype, "groupedRow", [f.computed], Object.getOwnPropertyDescriptor(fle.prototype, "groupedRow"), fle.prototype), ple = fle)) || ple;

    function Ple(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _le(n.key), n);
      }
    }

    function _le(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Ele(e, t, r) {
      return t = Sle(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Sle(e).constructor) : t.apply(e, r));
    }

    function Sle(e) {
      return (Sle = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Cle(e, t) {
      return (Cle = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function kle(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Rle,
        Tle,
        zle = Object(d.observer)((kle((Ole = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Ele(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Cle(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Ple(e.prototype, t), r && Ple(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "totalRecords",
        get: function () {
          var e = this.props.reportsManager;
          return e.reportItemsStore && e.reportItemsStore.rawRecords && e.reportItemsStore.rawRecords.length;
        }
      }, {
        key: "rows",
        get: function () {
          var e = this.props.reportsManager;
          return e.groupedRows || e.visibleRows;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.reportsManager,
              r = e.t;
          return p.a.createElement("tbody", null, p.a.createElement(p.a.Fragment, null, this.rows.map(function (e) {
            return p.a.createElement(jle, {
              key: e.key,
              reportsManager: t,
              row: e
            });
          }), this.totalRecords > t.maxRows && t.filteredRecordRows.length === t.maxRows || t.filteredRecordRows.length > t.maxRows ? p.a.createElement("tr", null, p.a.createElement("td", {
            colSpan: t.visibleColumns.length,
            className: "text-center text-danger"
          }, r("only_showing_max_rows", {
            rowCount: t.maxRows
          }))) : null));
        }
      }]);
    }()).prototype, "totalRecords", [f.computed], Object.getOwnPropertyDescriptor(Ole.prototype, "totalRecords"), Ole.prototype), kle(Ole.prototype, "rows", [f.computed], Object.getOwnPropertyDescriptor(Ole.prototype, "rows"), Ole.prototype), wle = Ole)) || wle,
        Nle = Object(g.a)()(zle);

    function Dle(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, xle(n.key), n);
      }
    }

    function xle(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Ale(e, t, r) {
      return t = Mle(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Mle(e).constructor) : t.apply(e, r));
    }

    function Mle(e) {
      return (Mle = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Ile(e, t) {
      return (Ile = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Fle(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Ble,
        Lle = Object(d.observer)((Fle((Tle = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Ale(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ile(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "numGroups",
        get: function () {
          var e;
          return (null === (e = this.props.reportsManager.groupSpecs) || void 0 === e ? void 0 : e.length) || 0;
        }
      }, {
        key: "numColumns",
        get: function () {
          return this.props.reportsManager.visibleColumns.length - this.numGroups;
        }
      }, {
        key: "render",
        value: function () {
          return p.a.createElement("colgroup", null, this.numGroups > 0 ? p.a.createElement("col", {
            span: this.numGroups,
            className: "reports-table-groups"
          }) : null, p.a.createElement("col", {
            span: this.numColumns,
            className: "reports-table-columns"
          }));
        }
      }]) && Dle(r.prototype, n), o && Dle(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "numGroups", [f.computed], Object.getOwnPropertyDescriptor(Tle.prototype, "numGroups"), Tle.prototype), Fle(Tle.prototype, "numColumns", [f.computed], Object.getOwnPropertyDescriptor(Tle.prototype, "numColumns"), Tle.prototype), Rle = Tle)) || Rle;

    function Vle(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ule(n.key), n);
      }
    }

    function Ule(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function qle(e, t, r) {
      return t = Kle(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Kle(e).constructor) : t.apply(e, r));
    }

    function Kle(e) {
      return (Kle = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Gle(e, t) {
      return (Gle = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Wle,
        Hle,
        Jle,
        Yle = Object(d.observer)(Ble = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), qle(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Gle(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props.reportsManager;
          return p.a.createElement("div", {
            className: "reports-table"
          }, p.a.createElement("table", {
            className: "table table-striped table-sm"
          }, p.a.createElement(Lle, {
            reportsManager: e
          }), p.a.createElement(ole, {
            reportsManager: e
          }), p.a.createElement(Nle, {
            reportsManager: e
          })));
        }
      }]) && Vle(r.prototype, n), o && Vle(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || Ble;

    function Qle(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $le(n.key), n);
      }
    }

    function $le(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Xle(e, t, r) {
      return t = Zle(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Zle(e).constructor) : t.apply(e, r));
    }

    function Zle(e) {
      return (Zle = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ese(e, t) {
      return (ese = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function tse(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var rse,
        nse,
        ose = Object(d.observer)((tse((Hle = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = Xle(this, t, [].concat(n)), "onChangeRadio", Jle, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ese(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Qle(e.prototype, t), r && Qle(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "hasReportItems",
        get: function () {
          var e = this.props.reportsManager;
          return Boolean(e.recordItems.length);
        }
      }, {
        key: "radioLabelClassName",
        get: function () {
          return ["field-filter-type-radio-label"].concat(this.hasReportItems ? [] : "disabled").join(" ");
        }
      }, {
        key: "matchNameId",
        get: function () {
          var e = this.props.baseId;
          return "".concat(e, "-field-filter-radio-match-name");
        }
      }, {
        key: "matchIdId",
        get: function () {
          var e = this.props.baseId;
          return "".concat(e, "-field-filter-radio-match-id");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.reportsManager,
              r = e.t;
          return p.a.createElement("ul", {
            className: "field-filter-type-radiogroup",
            role: "radiogroup"
          }, p.a.createElement("li", {
            className: "mr-3"
          }, p.a.createElement("input", {
            className: "field-filter-type-radio mr-2",
            type: "radio",
            disabled: !this.hasReportItems,
            name: "filterSpecificFields",
            id: this.matchNameId,
            checked: !t.columnFiltersModel.filterSpecificFields,
            value: !t.columnFiltersModel.filterSpecificFields,
            onChange: this.onChangeRadio(!1)
          }), p.a.createElement("label", {
            className: this.radioLabelClassName,
            htmlFor: this.matchNameId
          }, r("match_on_field_name"))), p.a.createElement("li", null, p.a.createElement("input", {
            className: "field-filter-type-radio mr-2",
            type: "radio",
            disabled: !this.hasReportItems,
            name: "filterSpecificFields",
            id: this.matchIdId,
            checked: t.columnFiltersModel.filterSpecificFields,
            value: t.columnFiltersModel.filterSpecificFields,
            onChange: this.onChangeRadio(!0)
          }), p.a.createElement("label", {
            className: this.radioLabelClassName,
            htmlFor: this.matchIdId
          }, r("match_on_field_id"))));
        }
      }]);
    }()).prototype, "hasReportItems", [f.computed], Object.getOwnPropertyDescriptor(Hle.prototype, "hasReportItems"), Hle.prototype), tse(Hle.prototype, "radioLabelClassName", [f.computed], Object.getOwnPropertyDescriptor(Hle.prototype, "radioLabelClassName"), Hle.prototype), tse(Hle.prototype, "matchNameId", [f.computed], Object.getOwnPropertyDescriptor(Hle.prototype, "matchNameId"), Hle.prototype), tse(Hle.prototype, "matchIdId", [f.computed], Object.getOwnPropertyDescriptor(Hle.prototype, "matchIdId"), Hle.prototype), Jle = tse(Hle.prototype, "onChangeRadio", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function () {
            e.props.reportsManager.columnFiltersModel.toggleSpecificFields(t);
          };
        };
      }
    }), Wle = Hle)) || Wle,
        ise = Object(g.a)()(ose);

    function ase(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, cse(n.key), n);
      }
    }

    function cse(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function use(e, t, r) {
      return t = lse(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], lse(e).constructor) : t.apply(e, r));
    }

    function lse(e) {
      return (lse = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function sse(e, t) {
      return (sse = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var pse,
        fse,
        dse = Object(d.observer)(((nse = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), use(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && sse(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props.reportsManager;
          return p.a.createElement("div", {
            className: "report-filter-search-container"
          }, p.a.createElement(h.SelectDropdown, {
            options: t.matchOptions,
            onRegisterModel: e.onRegisterMatchModel,
            placeholder: "Contains"
          }), p.a.createElement(h.FormInput, {
            onChange: e.onChangeSearchText,
            value: e.filterSearchText
          }));
        }
      }]) && ase(r.prototype, n), o && ase(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).matchOptions = ["Begins with", "Contains", "Is Exactly"].map(function (e) {
      return {
        key: e,
        text: e,
        value: e
      };
    }), rse = nse)) || rse;

    function bse(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, yse(n.key), n);
      }
    }

    function yse(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function mse(e, t, r) {
      return t = vse(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], vse(e).constructor) : t.apply(e, r));
    }

    function vse(e) {
      return (vse = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function hse(e, t) {
      return (hse = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function gse(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var wse,
        Ose,
        jse,
        Pse,
        _se,
        Ese,
        Sse = Object(d.observer)((gse((fse = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), mse(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && hse(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "hasReportItems",
        get: function () {
          var e = this.props.reportsManager;
          return Boolean(e.recordItems.length);
        }
      }, {
        key: "shouldFilterSpecificFields",
        get: function () {
          return this.props.reportsManager.columnFiltersModel.filterSpecificFields && this.hasReportItems;
        }
      }, {
        key: "fieldOptions",
        get: function () {
          var e = this.props.reportsManager;
          return e.columnFiltersModel.fieldOptions.slice().sort(function (t, r) {
            return Object(h.naturalSort)(e.fieldNameWithClientPath(t), e.fieldNameWithClientPath(r));
          }).map(function (t) {
            return {
              key: t.field.id,
              text: e.fieldNameWithClientPath(t),
              value: t
            };
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.baseId,
              r = e.reportsManager;
          return p.a.createElement("div", {
            className: "report-column-field-filter"
          }, p.a.createElement(ise, {
            baseId: t,
            reportsManager: r
          }), this.shouldFilterSpecificFields ? p.a.createElement(h.MultiSelectDropdown, {
            options: this.fieldOptions,
            placeholder: "Fields",
            model: r.columnFiltersModel.fieldSelector,
            onRegisterModel: r.columnFiltersModel.registerFieldSelector
          }) : p.a.createElement(dse, {
            reportsManager: r
          }));
        }
      }]) && bse(r.prototype, n), o && bse(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "hasReportItems", [f.computed], Object.getOwnPropertyDescriptor(fse.prototype, "hasReportItems"), fse.prototype), gse(fse.prototype, "shouldFilterSpecificFields", [f.computed], Object.getOwnPropertyDescriptor(fse.prototype, "shouldFilterSpecificFields"), fse.prototype), gse(fse.prototype, "fieldOptions", [f.computed], Object.getOwnPropertyDescriptor(fse.prototype, "fieldOptions"), fse.prototype), pse = fse)) || pse;

    function Cse(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function kse(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Rse(n.key), n);
      }
    }

    function Rse(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Tse(e, t, r) {
      return t = zse(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], zse(e).constructor) : t.apply(e, r));
    }

    function zse(e) {
      return (zse = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Nse(e, t) {
      return (Nse = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Dse(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var xse,
        Ase,
        Mse,
        Ise,
        Fse = Object(d.observer)((Dse((Ose = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return Cse(e = Tse(this, t, [].concat(n)), "addFilter", jse, e), Cse(e, "removeFilter", Pse, e), Cse(e, "onChange", _se, e), Cse(e, "onCheckboxChange", Ese, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Nse(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "isChecked",
        get: function () {
          var e = this.props,
              t = e.reportsManager,
              r = e.option;
          return !!t.columnFiltersModel.currentMultiSelections && -1 !== t.columnFiltersModel.currentMultiSelections.findIndex(function (e) {
            return e === r;
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.option;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("a", {
            href: "#",
            onClick: this.onChange
          }, p.a.createElement(oj.a, {
            className: "report-filter-multi-select-checkbox",
            isChecked: this.isChecked,
            onChange: this.onCheckboxChange,
            readOnly: !0
          }), p.a.createElement("label", null, null == e ? "(blank)" : !1 === e ? "false" : !0 === e ? "true" : e)));
        }
      }]) && kse(r.prototype, n), o && kse(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "isChecked", [f.computed], Object.getOwnPropertyDescriptor(Ose.prototype, "isChecked"), Ose.prototype), jse = Dse(Ose.prototype, "addFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.actions,
              n = t.option;
          r.addFilter(n);
        };
      }
    }), Pse = Dse(Ose.prototype, "removeFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.actions,
              n = t.option;
          r.removeFilter(n);
        };
      }
    }), _se = Dse(Ose.prototype, "onChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          if (t.preventDefault(), !e.isChecked) return e.addFilter();
          e.removeFilter();
        };
      }
    }), Ese = Dse(Ose.prototype, "onCheckboxChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          if (t) return e.addFilter();
          e.removeFilter();
        };
      }
    }), wse = Ose)) || wse;

    function Bse(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Lse(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Vse(n.key), n);
      }
    }

    function Vse(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Use(e, t, r) {
      return t = qse(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], qse(e).constructor) : t.apply(e, r));
    }

    function qse(e) {
      return (qse = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Kse(e, t) {
      return (Kse = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Gse(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Wse,
        Hse = Object(d.observer)((Gse((Ase = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return Bse(e = Use(this, t, [].concat(n)), "addFilter", Mse, e), Bse(e, "removeFilter", Ise, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Kse(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "columnSpec",
        get: function () {
          return this.props.reportsManager.columnFiltersModel.currentColumnSpec;
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props.reportsManager;
          return p.a.createElement("ul", null, t.columnFiltersModel.currentFilterChoices.map(function (r) {
            return p.a.createElement("li", {
              key: r || "blank"
            }, p.a.createElement(Fse, {
              reportsManager: t,
              columnSpec: e.columnSpec,
              option: r,
              actions: {
                addFilter: e.addFilter,
                removeFilter: e.removeFilter
              }
            }));
          }));
        }
      }]) && Lse(r.prototype, n), o && Lse(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "columnSpec", [f.computed], Object.getOwnPropertyDescriptor(Ase.prototype, "columnSpec"), Ase.prototype), Mse = Gse(Ase.prototype, "addFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.reportsManager.columnFiltersModel.currentMultiSelections.push(t);
        };
      }
    }), Ise = Gse(Ase.prototype, "removeFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.reportsManager,
              n = r.columnFiltersModel.currentMultiSelections.findIndex(function (e) {
            return e === t;
          });
          -1 !== n && r.columnFiltersModel.currentMultiSelections.splice(n, 1);
        };
      }
    }), xse = Ase)) || xse;

    function Jse(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Yse(n.key), n);
      }
    }

    function Yse(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Qse(e, t, r) {
      return t = $se(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], $se(e).constructor) : t.apply(e, r));
    }

    function $se(e) {
      return ($se = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Xse(e, t) {
      return (Xse = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Zse,
        epe = Object(d.observer)(Wse = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Qse(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Xse(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.reportsManager,
              r = e.treeModel;
          return p.a.createElement(fl, {
            items: t.columnFiltersModel.currentFilterAccountChoices,
            model: r,
            ControlsComponent: nj,
            ContentComponent: Cl(r)
          });
        }
      }]) && Jse(r.prototype, n), o && Jse(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || Wse;

    function tpe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, rpe(n.key), n);
      }
    }

    function rpe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function npe(e, t, r) {
      return t = ope(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ope(e).constructor) : t.apply(e, r));
    }

    function ope(e) {
      return (ope = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ipe(e, t) {
      return (ipe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var ape = Object(d.observer)(Zse = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), npe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ipe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props.reportsManager;
          return p.a.createElement(h.DateRangeSelector, {
            model: e.columnFiltersModel.currentDateRangeSelector
          });
        }
      }]) && tpe(r.prototype, n), o && tpe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || Zse;

    function cpe() {
      return (cpe = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];

          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }

        return e;
      }).apply(this, arguments);
    }

    function upe(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function lpe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function spe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? lpe(Object(r), !0).forEach(function (t) {
          upe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : lpe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function ppe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    function fpe(e, t) {
      return (fpe = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function dpe(e) {
      return (dpe = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function bpe(e) {
      return (bpe = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function ype(e, t) {
      return !t || "object" !== bpe(t) && "function" != typeof t ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function mpe(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function () {
        var r,
            n = dpe(e);

        if (t) {
          var o = dpe(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);

        return ype(this, r);
      };
    }

    function vpe(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function hpe(e, t) {
      if (e) {
        if ("string" == typeof e) return vpe(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? vpe(e, t) : void 0;
      }
    }

    function gpe(e) {
      return function (e) {
        if (Array.isArray(e)) return vpe(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || hpe(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    var wpe = function () {
      function e(e) {
        var t = this;
        this._insertTag = function (e) {
          var r;
          r = 0 === t.tags.length ? t.insertionPoint ? t.insertionPoint.nextSibling : t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling, t.container.insertBefore(e, r), t.tags.push(e);
        }, this.isSpeedy = void 0 === e.speedy || e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.insertionPoint = e.insertionPoint, this.before = null;
      }

      var t = e.prototype;
      return t.hydrate = function (e) {
        e.forEach(this._insertTag);
      }, t.insert = function (e) {
        this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(function (e) {
          var t = document.createElement("style");
          return t.setAttribute("data-emotion", e.key), void 0 !== e.nonce && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
        }(this));
        var t = this.tags[this.tags.length - 1];

        if (this.isSpeedy) {
          var r = function (e) {
            if (e.sheet) return e.sheet;

            for (var t = 0; t < document.styleSheets.length; t++) if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
          }(t);

          try {
            r.insertRule(e, r.cssRules.length);
          } catch (e) {
            0;
          }
        } else t.appendChild(document.createTextNode(e));

        this.ctr++;
      }, t.flush = function () {
        this.tags.forEach(function (e) {
          return e.parentNode && e.parentNode.removeChild(e);
        }), this.tags = [], this.ctr = 0;
      }, e;
    }(),
        Ope = "-ms-",
        jpe = "-moz-",
        Ppe = "-webkit-",
        _pe = "comm",
        Epe = "rule",
        Spe = "decl",
        Cpe = "@import",
        kpe = "@keyframes",
        Rpe = "@layer",
        Tpe = Math.abs,
        zpe = String.fromCharCode,
        Npe = Object.assign;

    function Dpe(e, t) {
      return 45 ^ Fpe(e, 0) ? (((t << 2 ^ Fpe(e, 0)) << 2 ^ Fpe(e, 1)) << 2 ^ Fpe(e, 2)) << 2 ^ Fpe(e, 3) : 0;
    }

    function xpe(e) {
      return e.trim();
    }

    function Ape(e, t) {
      return (e = t.exec(e)) ? e[0] : e;
    }

    function Mpe(e, t, r) {
      return e.replace(t, r);
    }

    function Ipe(e, t) {
      return e.indexOf(t);
    }

    function Fpe(e, t) {
      return 0 | e.charCodeAt(t);
    }

    function Bpe(e, t, r) {
      return e.slice(t, r);
    }

    function Lpe(e) {
      return e.length;
    }

    function Vpe(e) {
      return e.length;
    }

    function Upe(e, t) {
      return t.push(e), e;
    }

    function qpe(e, t) {
      return e.map(t).join("");
    }

    var Kpe = 1,
        Gpe = 1,
        Wpe = 0,
        Hpe = 0,
        Jpe = 0,
        Ype = "";

    function Qpe(e, t, r, n, o, i, a) {
      return {
        value: e,
        root: t,
        parent: r,
        type: n,
        props: o,
        children: i,
        line: Kpe,
        column: Gpe,
        length: a,
        return: ""
      };
    }

    function $pe(e, t) {
      return Npe(Qpe("", null, null, "", null, null, 0), e, {
        length: -e.length
      }, t);
    }

    function Xpe() {
      return Jpe = Hpe < Wpe ? Fpe(Ype, Hpe++) : 0, Gpe++, 10 === Jpe && (Gpe = 1, Kpe++), Jpe;
    }

    function Zpe() {
      return Fpe(Ype, Hpe);
    }

    function efe() {
      return Hpe;
    }

    function tfe(e, t) {
      return Bpe(Ype, e, t);
    }

    function rfe(e) {
      switch (e) {
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
          return 5;

        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
          return 4;

        case 58:
          return 3;

        case 34:
        case 39:
        case 40:
        case 91:
          return 2;

        case 41:
        case 93:
          return 1;
      }

      return 0;
    }

    function nfe(e) {
      return Kpe = Gpe = 1, Wpe = Lpe(Ype = e), Hpe = 0, [];
    }

    function ofe(e) {
      return Ype = "", e;
    }

    function ife(e) {
      return xpe(tfe(Hpe - 1, function e(t) {
        for (; Xpe();) switch (Jpe) {
          case t:
            return Hpe;

          case 34:
          case 39:
            34 !== t && 39 !== t && e(Jpe);
            break;

          case 40:
            41 === t && e(t);
            break;

          case 92:
            Xpe();
        }

        return Hpe;
      }(91 === e ? e + 2 : 40 === e ? e + 1 : e)));
    }

    function afe(e) {
      for (; (Jpe = Zpe()) && Jpe < 33;) Xpe();

      return rfe(e) > 2 || rfe(Jpe) > 3 ? "" : " ";
    }

    function cfe(e, t) {
      for (; --t && Xpe() && !(Jpe < 48 || Jpe > 102 || Jpe > 57 && Jpe < 65 || Jpe > 70 && Jpe < 97););

      return tfe(e, efe() + (t < 6 && 32 == Zpe() && 32 == Xpe()));
    }

    function ufe(e, t) {
      for (; Xpe() && e + Jpe !== 57 && (e + Jpe !== 84 || 47 !== Zpe()););

      return "/*" + tfe(t, Hpe - 1) + "*" + zpe(47 === e ? e : Xpe());
    }

    function lfe(e) {
      for (; !rfe(Zpe());) Xpe();

      return tfe(e, Hpe);
    }

    function sfe(e) {
      return ofe(function e(t, r, n, o, i, a, c, u, l) {
        var s = 0;
        var p = 0;
        var f = c;
        var d = 0;
        var b = 0;
        var y = 0;
        var m = 1;
        var v = 1;
        var h = 1;
        var g = 0;
        var w = "";
        var O = i;
        var j = a;
        var P = o;
        var _ = w;

        for (; v;) switch (y = g, g = Xpe()) {
          case 40:
            if (108 != y && 58 == Fpe(_, f - 1)) {
              -1 != Ipe(_ += Mpe(ife(g), "&", "&\f"), "&\f") && (h = -1);
              break;
            }

          case 34:
          case 39:
          case 91:
            _ += ife(g);
            break;

          case 9:
          case 10:
          case 13:
          case 32:
            _ += afe(y);
            break;

          case 92:
            _ += cfe(efe() - 1, 7);
            continue;

          case 47:
            switch (Zpe()) {
              case 42:
              case 47:
                Upe(ffe(ufe(Xpe(), efe()), r, n), l);
                break;

              default:
                _ += "/";
            }

            break;

          case 123 * m:
            u[s++] = Lpe(_) * h;

          case 125 * m:
          case 59:
          case 0:
            switch (g) {
              case 0:
              case 125:
                v = 0;

              case 59 + p:
                -1 == h && (_ = Mpe(_, /\f/g, "")), b > 0 && Lpe(_) - f && Upe(b > 32 ? dfe(_ + ";", o, n, f - 1) : dfe(Mpe(_, " ", "") + ";", o, n, f - 2), l);
                break;

              case 59:
                _ += ";";

              default:
                if (Upe(P = pfe(_, r, n, s, p, i, u, w, O = [], j = [], f), a), 123 === g) if (0 === p) e(_, r, P, P, O, a, f, u, j);else switch (99 === d && 110 === Fpe(_, 3) ? 100 : d) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    e(t, P, P, o && Upe(pfe(t, P, P, 0, 0, i, u, w, i, O = [], f), j), i, j, f, u, o ? O : j);
                    break;

                  default:
                    e(_, P, P, P, [""], j, 0, u, j);
                }
            }

            s = p = b = 0, m = h = 1, w = _ = "", f = c;
            break;

          case 58:
            f = 1 + Lpe(_), b = y;

          default:
            if (m < 1) if (123 == g) --m;else if (125 == g && 0 == m++ && 125 == (Jpe = Hpe > 0 ? Fpe(Ype, --Hpe) : 0, Gpe--, 10 === Jpe && (Gpe = 1, Kpe--), Jpe)) continue;

            switch (_ += zpe(g), g * m) {
              case 38:
                h = p > 0 ? 1 : (_ += "\f", -1);
                break;

              case 44:
                u[s++] = (Lpe(_) - 1) * h, h = 1;
                break;

              case 64:
                45 === Zpe() && (_ += ife(Xpe())), d = Zpe(), p = f = Lpe(w = _ += lfe(efe())), g++;
                break;

              case 45:
                45 === y && 2 == Lpe(_) && (m = 0);
            }

        }

        return a;
      }("", null, null, null, [""], e = nfe(e), 0, [0], e));
    }

    function pfe(e, t, r, n, o, i, a, c, u, l, s) {
      for (var p = o - 1, f = 0 === o ? i : [""], d = Vpe(f), b = 0, y = 0, m = 0; b < n; ++b) for (var v = 0, h = Bpe(e, p + 1, p = Tpe(y = a[b])), g = e; v < d; ++v) (g = xpe(y > 0 ? f[v] + " " + h : Mpe(h, /&\f/g, f[v]))) && (u[m++] = g);

      return Qpe(e, t, r, 0 === o ? Epe : c, u, l, s);
    }

    function ffe(e, t, r) {
      return Qpe(e, t, r, _pe, zpe(Jpe), Bpe(e, 2, -2), 0);
    }

    function dfe(e, t, r, n) {
      return Qpe(e, t, r, Spe, Bpe(e, 0, n), Bpe(e, n + 1, -1), n);
    }

    function bfe(e, t) {
      for (var r = "", n = Vpe(e), o = 0; o < n; o++) r += t(e[o], o, e, t) || "";

      return r;
    }

    function yfe(e, t, r, n) {
      switch (e.type) {
        case Rpe:
          if (e.children.length) break;

        case Cpe:
        case Spe:
          return e.return = e.return || e.value;

        case _pe:
          return "";

        case kpe:
          return e.return = e.value + "{" + bfe(e.children, n) + "}";

        case Epe:
          e.value = e.props.join(",");
      }

      return Lpe(r = bfe(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
    }

    function mfe(e) {
      var t = Object.create(null);
      return function (r) {
        return void 0 === t[r] && (t[r] = e(r)), t[r];
      };
    }

    var vfe = function (e, t, r) {
      for (var n = 0, o = 0; n = o, o = Zpe(), 38 === n && 12 === o && (t[r] = 1), !rfe(o);) Xpe();

      return tfe(e, Hpe);
    },
        hfe = function (e, t) {
      return ofe(function (e, t) {
        var r = -1,
            n = 44;

        do {
          switch (rfe(n)) {
            case 0:
              38 === n && 12 === Zpe() && (t[r] = 1), e[r] += vfe(Hpe - 1, t, r);
              break;

            case 2:
              e[r] += ife(n);
              break;

            case 4:
              if (44 === n) {
                e[++r] = 58 === Zpe() ? "&\f" : "", t[r] = e[r].length;
                break;
              }

            default:
              e[r] += zpe(n);
          }
        } while (n = Xpe());

        return e;
      }(nfe(e), t));
    },
        gfe = new WeakMap(),
        wfe = function (e) {
      if ("rule" === e.type && e.parent && !(e.length < 1)) {
        for (var t = e.value, r = e.parent, n = e.column === r.column && e.line === r.line; "rule" !== r.type;) if (!(r = r.parent)) return;

        if ((1 !== e.props.length || 58 === t.charCodeAt(0) || gfe.get(r)) && !n) {
          gfe.set(e, !0);

          for (var o = [], i = hfe(t, o), a = r.props, c = 0, u = 0; c < i.length; c++) for (var l = 0; l < a.length; l++, u++) e.props[u] = o[c] ? i[c].replace(/&\f/g, a[l]) : a[l] + " " + i[c];
        }
      }
    },
        Ofe = function (e) {
      if ("decl" === e.type) {
        var t = e.value;
        108 === t.charCodeAt(0) && 98 === t.charCodeAt(2) && (e.return = "", e.value = "");
      }
    };

    var jfe = [function (e, t, r, n) {
      if (e.length > -1 && !e.return) switch (e.type) {
        case Spe:
          e.return = function e(t, r) {
            switch (Dpe(t, r)) {
              case 5103:
                return Ppe + "print-" + t + t;

              case 5737:
              case 4201:
              case 3177:
              case 3433:
              case 1641:
              case 4457:
              case 2921:
              case 5572:
              case 6356:
              case 5844:
              case 3191:
              case 6645:
              case 3005:
              case 6391:
              case 5879:
              case 5623:
              case 6135:
              case 4599:
              case 4855:
              case 4215:
              case 6389:
              case 5109:
              case 5365:
              case 5621:
              case 3829:
                return Ppe + t + t;

              case 5349:
              case 4246:
              case 4810:
              case 6968:
              case 2756:
                return Ppe + t + jpe + t + Ope + t + t;

              case 6828:
              case 4268:
                return Ppe + t + Ope + t + t;

              case 6165:
                return Ppe + t + Ope + "flex-" + t + t;

              case 5187:
                return Ppe + t + Mpe(t, /(\w+).+(:[^]+)/, Ppe + "box-$1$2" + Ope + "flex-$1$2") + t;

              case 5443:
                return Ppe + t + Ope + "flex-item-" + Mpe(t, /flex-|-self/, "") + t;

              case 4675:
                return Ppe + t + Ope + "flex-line-pack" + Mpe(t, /align-content|flex-|-self/, "") + t;

              case 5548:
                return Ppe + t + Ope + Mpe(t, "shrink", "negative") + t;

              case 5292:
                return Ppe + t + Ope + Mpe(t, "basis", "preferred-size") + t;

              case 6060:
                return Ppe + "box-" + Mpe(t, "-grow", "") + Ppe + t + Ope + Mpe(t, "grow", "positive") + t;

              case 4554:
                return Ppe + Mpe(t, /([^-])(transform)/g, "$1" + Ppe + "$2") + t;

              case 6187:
                return Mpe(Mpe(Mpe(t, /(zoom-|grab)/, Ppe + "$1"), /(image-set)/, Ppe + "$1"), t, "") + t;

              case 5495:
              case 3959:
                return Mpe(t, /(image-set\([^]*)/, Ppe + "$1$`$1");

              case 4968:
                return Mpe(Mpe(t, /(.+:)(flex-)?(.*)/, Ppe + "box-pack:$3" + Ope + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Ppe + t + t;

              case 4095:
              case 3583:
              case 4068:
              case 2532:
                return Mpe(t, /(.+)-inline(.+)/, Ppe + "$1$2") + t;

              case 8116:
              case 7059:
              case 5753:
              case 5535:
              case 5445:
              case 5701:
              case 4933:
              case 4677:
              case 5533:
              case 5789:
              case 5021:
              case 4765:
                if (Lpe(t) - 1 - r > 6) switch (Fpe(t, r + 1)) {
                  case 109:
                    if (45 !== Fpe(t, r + 4)) break;

                  case 102:
                    return Mpe(t, /(.+:)(.+)-([^]+)/, "$1" + Ppe + "$2-$3$1" + jpe + (108 == Fpe(t, r + 3) ? "$3" : "$2-$3")) + t;

                  case 115:
                    return ~Ipe(t, "stretch") ? e(Mpe(t, "stretch", "fill-available"), r) + t : t;
                }
                break;

              case 4949:
                if (115 !== Fpe(t, r + 1)) break;

              case 6444:
                switch (Fpe(t, Lpe(t) - 3 - (~Ipe(t, "!important") && 10))) {
                  case 107:
                    return Mpe(t, ":", ":" + Ppe) + t;

                  case 101:
                    return Mpe(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Ppe + (45 === Fpe(t, 14) ? "inline-" : "") + "box$3$1" + Ppe + "$2$3$1" + Ope + "$2box$3") + t;
                }

                break;

              case 5936:
                switch (Fpe(t, r + 11)) {
                  case 114:
                    return Ppe + t + Ope + Mpe(t, /[svh]\w+-[tblr]{2}/, "tb") + t;

                  case 108:
                    return Ppe + t + Ope + Mpe(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;

                  case 45:
                    return Ppe + t + Ope + Mpe(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
                }

                return Ppe + t + Ope + t + t;
            }

            return t;
          }(e.value, e.length);

          break;

        case kpe:
          return bfe([$pe(e, {
            value: Mpe(e.value, "@", "@" + Ppe)
          })], n);

        case Epe:
          if (e.length) return qpe(e.props, function (t) {
            switch (Ape(t, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return bfe([$pe(e, {
                  props: [Mpe(t, /:(read-\w+)/, ":" + jpe + "$1")]
                })], n);

              case "::placeholder":
                return bfe([$pe(e, {
                  props: [Mpe(t, /:(plac\w+)/, ":" + Ppe + "input-$1")]
                }), $pe(e, {
                  props: [Mpe(t, /:(plac\w+)/, ":" + jpe + "$1")]
                }), $pe(e, {
                  props: [Mpe(t, /:(plac\w+)/, Ope + "input-$1")]
                })], n);
            }

            return "";
          });
      }
    }],
        Pfe = function (e) {
      var t = e.key;

      if ("css" === t) {
        var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
        Array.prototype.forEach.call(r, function (e) {
          -1 !== e.getAttribute("data-emotion").indexOf(" ") && (document.head.appendChild(e), e.setAttribute("data-s", ""));
        });
      }

      var n = e.stylisPlugins || jfe;
      var o,
          i,
          a = {},
          c = [];
      o = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + t + ' "]'), function (e) {
        for (var t = e.getAttribute("data-emotion").split(" "), r = 1; r < t.length; r++) a[t[r]] = !0;

        c.push(e);
      });

      var u,
          l,
          s = [yfe, (l = function (e) {
        u.insert(e);
      }, function (e) {
        e.root || (e = e.return) && l(e);
      })],
          p = function (e) {
        var t = Vpe(e);
        return function (r, n, o, i) {
          for (var a = "", c = 0; c < t; c++) a += e[c](r, n, o, i) || "";

          return a;
        };
      }([wfe, Ofe].concat(n, s));

      i = function (e, t, r, n) {
        u = r, bfe(sfe(e ? e + "{" + t.styles + "}" : t.styles), p), n && (f.inserted[t.name] = !0);
      };

      var f = {
        key: t,
        sheet: new wpe({
          key: t,
          container: o,
          nonce: e.nonce,
          speedy: e.speedy,
          prepend: e.prepend,
          insertionPoint: e.insertionPoint
        }),
        nonce: e.nonce,
        inserted: a,
        registered: {},
        insert: i
      };
      return f.sheet.hydrate(c), f;
    };

    r(94);

    function _fe(e, t, r) {
      var n = "";
      return r.split(" ").forEach(function (r) {
        void 0 !== e[r] ? t.push(e[r] + ";") : n += r + " ";
      }), n;
    }

    var Efe = function (e, t, r) {
      var n = e.key + "-" + t.name;
      !1 === r && void 0 === e.registered[n] && (e.registered[n] = t.styles);
    },
        Sfe = function (e, t, r) {
      Efe(e, t, r);
      var n = e.key + "-" + t.name;

      if (void 0 === e.inserted[t.name]) {
        var o = t;

        do {
          e.insert(t === o ? "." + n : "", o, e.sheet, !0), o = o.next;
        } while (void 0 !== o);
      }
    };

    var Cfe = {
      animationIterationCount: 1,
      aspectRatio: 1,
      borderImageOutset: 1,
      borderImageSlice: 1,
      borderImageWidth: 1,
      boxFlex: 1,
      boxFlexGroup: 1,
      boxOrdinalGroup: 1,
      columnCount: 1,
      columns: 1,
      flex: 1,
      flexGrow: 1,
      flexPositive: 1,
      flexShrink: 1,
      flexNegative: 1,
      flexOrder: 1,
      gridRow: 1,
      gridRowEnd: 1,
      gridRowSpan: 1,
      gridRowStart: 1,
      gridColumn: 1,
      gridColumnEnd: 1,
      gridColumnSpan: 1,
      gridColumnStart: 1,
      msGridRow: 1,
      msGridRowSpan: 1,
      msGridColumn: 1,
      msGridColumnSpan: 1,
      fontWeight: 1,
      lineHeight: 1,
      opacity: 1,
      order: 1,
      orphans: 1,
      tabSize: 1,
      widows: 1,
      zIndex: 1,
      zoom: 1,
      WebkitLineClamp: 1,
      fillOpacity: 1,
      floodOpacity: 1,
      stopOpacity: 1,
      strokeDasharray: 1,
      strokeDashoffset: 1,
      strokeMiterlimit: 1,
      strokeOpacity: 1,
      strokeWidth: 1
    },
        kfe = /[A-Z]|^ms/g,
        Rfe = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
        Tfe = function (e) {
      return 45 === e.charCodeAt(1);
    },
        zfe = function (e) {
      return null != e && "boolean" != typeof e;
    },
        Nfe = mfe(function (e) {
      return Tfe(e) ? e : e.replace(kfe, "-$&").toLowerCase();
    }),
        Dfe = function (e, t) {
      switch (e) {
        case "animation":
        case "animationName":
          if ("string" == typeof t) return t.replace(Rfe, function (e, t, r) {
            return Afe = {
              name: t,
              styles: r,
              next: Afe
            }, t;
          });
      }

      return 1 === Cfe[e] || Tfe(e) || "number" != typeof t || 0 === t ? t : t + "px";
    };

    function xfe(e, t, r) {
      if (null == r) return "";
      if (void 0 !== r.__emotion_styles) return r;

      switch (typeof r) {
        case "boolean":
          return "";

        case "object":
          if (1 === r.anim) return Afe = {
            name: r.name,
            styles: r.styles,
            next: Afe
          }, r.name;

          if (void 0 !== r.styles) {
            var n = r.next;
            if (void 0 !== n) for (; void 0 !== n;) Afe = {
              name: n.name,
              styles: n.styles,
              next: Afe
            }, n = n.next;
            return r.styles + ";";
          }

          return function (e, t, r) {
            var n = "";
            if (Array.isArray(r)) for (var o = 0; o < r.length; o++) n += xfe(e, t, r[o]) + ";";else for (var i in r) {
              var a = r[i];
              if ("object" != typeof a) null != t && void 0 !== t[a] ? n += i + "{" + t[a] + "}" : zfe(a) && (n += Nfe(i) + ":" + Dfe(i, a) + ";");else if (!Array.isArray(a) || "string" != typeof a[0] || null != t && void 0 !== t[a[0]]) {
                var c = xfe(e, t, a);

                switch (i) {
                  case "animation":
                  case "animationName":
                    n += Nfe(i) + ":" + c + ";";
                    break;

                  default:
                    n += i + "{" + c + "}";
                }
              } else for (var u = 0; u < a.length; u++) zfe(a[u]) && (n += Nfe(i) + ":" + Dfe(i, a[u]) + ";");
            }
            return n;
          }(e, t, r);

        case "function":
          if (void 0 !== e) {
            var o = Afe,
                i = r(e);
            return Afe = o, xfe(e, t, i);
          }

          break;

        case "string":
      }

      if (null == t) return r;
      var a = t[r];
      return void 0 !== a ? a : r;
    }

    var Afe,
        Mfe = /label:\s*([^\s;\n{]+)\s*(;|$)/g;

    var Ife = function (e, t, r) {
      if (1 === e.length && "object" == typeof e[0] && null !== e[0] && void 0 !== e[0].styles) return e[0];
      var n = !0,
          o = "";
      Afe = void 0;
      var i = e[0];
      null == i || void 0 === i.raw ? (n = !1, o += xfe(r, t, i)) : o += i[0];

      for (var a = 1; a < e.length; a++) o += xfe(r, t, e[a]), n && (o += i[a]);

      Mfe.lastIndex = 0;

      for (var c, u = ""; null !== (c = Mfe.exec(o));) u += "-" + c[1];

      return {
        name: function (e) {
          for (var t, r = 0, n = 0, o = e.length; o >= 4; ++n, o -= 4) t = 1540483477 * (65535 & (t = 255 & e.charCodeAt(n) | (255 & e.charCodeAt(++n)) << 8 | (255 & e.charCodeAt(++n)) << 16 | (255 & e.charCodeAt(++n)) << 24)) + (59797 * (t >>> 16) << 16), r = 1540483477 * (65535 & (t ^= t >>> 24)) + (59797 * (t >>> 16) << 16) ^ 1540483477 * (65535 & r) + (59797 * (r >>> 16) << 16);

          switch (o) {
            case 3:
              r ^= (255 & e.charCodeAt(n + 2)) << 16;

            case 2:
              r ^= (255 & e.charCodeAt(n + 1)) << 8;

            case 1:
              r = 1540483477 * (65535 & (r ^= 255 & e.charCodeAt(n))) + (59797 * (r >>> 16) << 16);
          }

          return (((r = 1540483477 * (65535 & (r ^= r >>> 13)) + (59797 * (r >>> 16) << 16)) ^ r >>> 15) >>> 0).toString(36);
        }(o) + u,
        styles: o,
        next: Afe
      };
    },
        Ffe = !!s.useInsertionEffect && s.useInsertionEffect,
        Bfe = Ffe || function (e) {
      return e();
    },
        Lfe = (Ffe || s.useLayoutEffect, {}.hasOwnProperty),
        Vfe = s.createContext("undefined" != typeof HTMLElement ? Pfe({
      key: "css"
    }) : null);

    Vfe.Provider;

    var Ufe = function (e) {
      return Object(s.forwardRef)(function (t, r) {
        var n = Object(s.useContext)(Vfe);
        return e(t, n, r);
      });
    };

    var qfe = s.createContext({});

    var Kfe = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__",
        Gfe = function (e, t) {
      var r = {};

      for (var n in t) Lfe.call(t, n) && (r[n] = t[n]);

      return r[Kfe] = e, r;
    },
        Wfe = function (e) {
      var t = e.cache,
          r = e.serialized,
          n = e.isStringTag;
      return Efe(t, r, n), Bfe(function () {
        return Sfe(t, r, n);
      }), null;
    };

    var Hfe = Ufe(function (e, t, r) {
      var n = e.css;
      "string" == typeof n && void 0 !== t.registered[n] && (n = t.registered[n]);
      var o = e[Kfe],
          i = [n],
          a = "";
      "string" == typeof e.className ? a = _fe(t.registered, i, e.className) : null != e.className && (a = e.className + " ");
      var c = Ife(i, void 0, s.useContext(qfe));
      a += t.key + "-" + c.name;
      var u = {};

      for (var l in e) Lfe.call(e, l) && "css" !== l && l !== Kfe && (u[l] = e[l]);

      return u.ref = r, u.className = a, s.createElement(s.Fragment, null, s.createElement(Wfe, {
        cache: t,
        serialized: c,
        isStringTag: "string" == typeof o
      }), s.createElement(o, u));
    }),
        Jfe = (r(365), function (e, t) {
      var r = arguments;
      if (null == t || !Lfe.call(t, "css")) return s.createElement.apply(void 0, r);
      var n = r.length,
          o = new Array(n);
      o[0] = Hfe, o[1] = Gfe(e, t);

      for (var i = 2; i < n; i++) o[i] = r[i];

      return s.createElement.apply(null, o);
    });

    function Yfe() {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];

      return Ife(t);
    }

    function Qfe(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
          var r = [],
              n = !0,
              o = !1,
              i = void 0;

          try {
            for (var a, c = e[Symbol.iterator](); !(n = (a = c.next()).done) && (r.push(a.value), !t || r.length !== t); n = !0);
          } catch (e) {
            o = !0, i = e;
          } finally {
            try {
              n || null == c.return || c.return();
            } finally {
              if (o) throw i;
            }
          }

          return r;
        }
      }(e, t) || hpe(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function $fe(e, t) {
      if (null == e) return {};

      var r,
          n,
          o = function (e, t) {
        if (null == e) return {};
        var r,
            n,
            o = {},
            i = Object.keys(e);

        for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);

        return o;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }

      return o;
    }

    const Xfe = Math.min,
          Zfe = Math.max,
          ede = Math.round,
          tde = Math.floor,
          rde = e => ({
      x: e,
      y: e
    });

    function nde(e) {
      return _objectSpread(_objectSpread({}, e), {}, {
        top: e.y,
        left: e.x,
        right: e.x + e.width,
        bottom: e.y + e.height
      });
    }

    function ode(e) {
      return cde(e) ? (e.nodeName || "").toLowerCase() : "#document";
    }

    function ide(e) {
      var t;
      return (null == e ? void 0 : null == (t = e.ownerDocument) ? void 0 : t.defaultView) || window;
    }

    function ade(e) {
      var t;
      return null == (t = (cde(e) ? e.ownerDocument : e.document) || window.document) ? void 0 : t.documentElement;
    }

    function cde(e) {
      return e instanceof Node || e instanceof ide(e).Node;
    }

    function ude(e) {
      return e instanceof Element || e instanceof ide(e).Element;
    }

    function lde(e) {
      return e instanceof HTMLElement || e instanceof ide(e).HTMLElement;
    }

    function sde(e) {
      return "undefined" != typeof ShadowRoot && (e instanceof ShadowRoot || e instanceof ide(e).ShadowRoot);
    }

    function pde(e) {
      const _bde = bde(e),
            t = _bde.overflow,
            r = _bde.overflowX,
            n = _bde.overflowY,
            o = _bde.display;

      return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(o);
    }

    function fde() {
      return !("undefined" == typeof CSS || !CSS.supports) && CSS.supports("-webkit-backdrop-filter", "none");
    }

    function dde(e) {
      return ["html", "body", "#document"].includes(ode(e));
    }

    function bde(e) {
      return ide(e).getComputedStyle(e);
    }

    function yde(e) {
      if ("html" === ode(e)) return e;
      const t = e.assignedSlot || e.parentNode || sde(e) && e.host || ade(e);
      return sde(t) ? t.host : t;
    }

    function mde(e, t, r) {
      var n;
      void 0 === t && (t = []), void 0 === r && (r = !0);

      const o = function e(t) {
        const r = yde(t);
        return dde(r) ? t.ownerDocument ? t.ownerDocument.body : t.body : lde(r) && pde(r) ? r : e(r);
      }(e),
            i = o === (null == (n = e.ownerDocument) ? void 0 : n.body),
            a = ide(o);

      return i ? t.concat(a, a.visualViewport || [], pde(o) ? o : [], a.frameElement && r ? mde(a.frameElement) : []) : t.concat(o, mde(o, [], r));
    }

    function vde(e) {
      const t = bde(e);
      let r = parseFloat(t.width) || 0,
          n = parseFloat(t.height) || 0;
      const o = lde(e),
            i = o ? e.offsetWidth : r,
            a = o ? e.offsetHeight : n,
            c = ede(r) !== i || ede(n) !== a;
      return c && (r = i, n = a), {
        width: r,
        height: n,
        $: c
      };
    }

    function hde(e) {
      return ude(e) ? e : e.contextElement;
    }

    function gde(e) {
      const t = hde(e);
      if (!lde(t)) return rde(1);

      const r = t.getBoundingClientRect(),
            _vde = vde(t),
            n = _vde.width,
            o = _vde.height,
            i = _vde.$;

      let a = (i ? ede(r.width) : r.width) / n,
          c = (i ? ede(r.height) : r.height) / o;
      return a && Number.isFinite(a) || (a = 1), c && Number.isFinite(c) || (c = 1), {
        x: a,
        y: c
      };
    }

    const wde = rde(0);

    function Ode(e) {
      const t = ide(e);
      return fde() && t.visualViewport ? {
        x: t.visualViewport.offsetLeft,
        y: t.visualViewport.offsetTop
      } : wde;
    }

    function jde(e, t, r, n) {
      void 0 === t && (t = !1), void 0 === r && (r = !1);
      const o = e.getBoundingClientRect(),
            i = hde(e);
      let a = rde(1);
      t && (n ? ude(n) && (a = gde(n)) : a = gde(e));
      const c = function (e, t, r) {
        return void 0 === t && (t = !1), !(!r || t && r !== ide(e)) && t;
      }(i, r, n) ? Ode(i) : rde(0);
      let u = (o.left + c.x) / a.x,
          l = (o.top + c.y) / a.y,
          s = o.width / a.x,
          p = o.height / a.y;

      if (i) {
        const e = ide(i),
              t = n && ude(n) ? ide(n) : n;
        let r = e.frameElement;

        for (; r && n && t !== e;) {
          const e = gde(r),
                t = r.getBoundingClientRect(),
                n = bde(r),
                o = t.left + (r.clientLeft + parseFloat(n.paddingLeft)) * e.x,
                i = t.top + (r.clientTop + parseFloat(n.paddingTop)) * e.y;
          u *= e.x, l *= e.y, s *= e.x, p *= e.y, u += o, l += i, r = ide(r).frameElement;
        }
      }

      return nde({
        width: s,
        height: p,
        x: u,
        y: l
      });
    }

    function Pde(e, t, r, n) {
      void 0 === n && (n = {});
      const _n2 = n,
            _n2$ancestorScroll = _n2.ancestorScroll,
            o = _n2$ancestorScroll === void 0 ? !0 : _n2$ancestorScroll,
            _n2$ancestorResize = _n2.ancestorResize,
            i = _n2$ancestorResize === void 0 ? !0 : _n2$ancestorResize,
            _n2$elementResize = _n2.elementResize,
            a = _n2$elementResize === void 0 ? "function" == typeof ResizeObserver : _n2$elementResize,
            _n2$layoutShift = _n2.layoutShift,
            c = _n2$layoutShift === void 0 ? "function" == typeof IntersectionObserver : _n2$layoutShift,
            _n2$animationFrame = _n2.animationFrame,
            u = _n2$animationFrame === void 0 ? !1 : _n2$animationFrame,
            l = hde(e),
            s = o || i ? [...(l ? mde(l) : []), ...mde(t)] : [];
      s.forEach(e => {
        o && e.addEventListener("scroll", r, {
          passive: !0
        }), i && e.addEventListener("resize", r);
      });
      const p = l && c ? function (e, t) {
        let r,
            n = null;
        const o = ade(e);

        function i() {
          clearTimeout(r), n && n.disconnect(), n = null;
        }

        return function a(c, u) {
          void 0 === c && (c = !1), void 0 === u && (u = 1), i();

          const _e$getBoundingClientR = e.getBoundingClientRect(),
                l = _e$getBoundingClientR.left,
                s = _e$getBoundingClientR.top,
                p = _e$getBoundingClientR.width,
                f = _e$getBoundingClientR.height;

          if (c || t(), !p || !f) return;
          const d = {
            rootMargin: -tde(s) + "px " + -tde(o.clientWidth - (l + p)) + "px " + -tde(o.clientHeight - (s + f)) + "px " + -tde(l) + "px",
            threshold: Zfe(0, Xfe(1, u)) || 1
          };
          let b = !0;

          function y(e) {
            const t = e[0].intersectionRatio;

            if (t !== u) {
              if (!b) return a();
              t ? a(!1, t) : r = setTimeout(() => {
                a(!1, 1e-7);
              }, 100);
            }

            b = !1;
          }

          try {
            n = new IntersectionObserver(y, _objectSpread(_objectSpread({}, d), {}, {
              root: o.ownerDocument
            }));
          } catch (e) {
            n = new IntersectionObserver(y, d);
          }

          n.observe(e);
        }(!0), i;
      }(l, r) : null;
      let f,
          d = -1,
          b = null;
      a && (b = new ResizeObserver(e => {
        let _e2 = _slicedToArray(e, 1),
            n = _e2[0];

        n && n.target === l && b && (b.unobserve(t), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
          b && b.observe(t);
        })), r();
      }), l && !u && b.observe(l), b.observe(t));
      let y = u ? jde(e) : null;
      return u && function t() {
        const n = jde(e);
        !y || n.x === y.x && n.y === y.y && n.width === y.width && n.height === y.height || r();
        y = n;
        f = requestAnimationFrame(t);
      }(), r(), () => {
        s.forEach(e => {
          o && e.removeEventListener("scroll", r), i && e.removeEventListener("resize", r);
        }), p && p(), b && b.disconnect(), b = null, u && cancelAnimationFrame(f);
      };
    }

    var _de = s.useLayoutEffect,
        Ede = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"],
        Sde = function () {};

    function Cde(e, t) {
      return t ? "-" === t[0] ? e + t : e + "__" + t : e;
    }

    function kde(e, t) {
      for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++) n[o - 2] = arguments[o];

      var i = [].concat(n);
      if (t && e) for (var a in t) t.hasOwnProperty(a) && t[a] && i.push("".concat(Cde(e, a)));
      return i.filter(function (e) {
        return e;
      }).map(function (e) {
        return String(e).trim();
      }).join(" ");
    }

    var Rde = function (e) {
      return t = e, Array.isArray(t) ? e.filter(Boolean) : "object" === bpe(e) && null !== e ? [e] : [];
      var t;
    },
        Tde = function (e) {
      return e.className, e.clearValue, e.cx, e.getStyles, e.getClassNames, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme, spe({}, $fe(e, Ede));
    },
        zde = function (e, t, r) {
      var n = e.cx,
          o = e.getStyles,
          i = e.getClassNames,
          a = e.className;
      return {
        css: o(t, e),
        className: n(null != r ? r : {}, i(t, e), a)
      };
    };

    function Nde(e) {
      return [document.documentElement, document.body, window].indexOf(e) > -1;
    }

    function Dde(e) {
      return Nde(e) ? window.pageYOffset : e.scrollTop;
    }

    function xde(e, t) {
      Nde(e) ? window.scrollTo(0, t) : e.scrollTop = t;
    }

    function Ade(e, t) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 200,
          n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : Sde,
          o = Dde(e),
          i = t - o,
          a = 10,
          c = 0;
      !function t() {
        var u,
            l = i * ((u = (u = c += a) / r - 1) * u * u + 1) + o;
        xde(e, l), c < r ? window.requestAnimationFrame(t) : n(e);
      }();
    }

    function Mde(e, t) {
      var r = e.getBoundingClientRect(),
          n = t.getBoundingClientRect(),
          o = t.offsetHeight / 3;
      n.bottom + o > r.bottom ? xde(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + o, e.scrollHeight)) : n.top - o < r.top && xde(e, Math.max(t.offsetTop - o, 0));
    }

    function Ide() {
      try {
        return document.createEvent("TouchEvent"), !0;
      } catch (e) {
        return !1;
      }
    }

    var Fde = !1,
        Bde = {
      get passive() {
        return Fde = !0;
      }

    },
        Lde = "undefined" != typeof window ? window : {};
    Lde.addEventListener && Lde.removeEventListener && (Lde.addEventListener("p", Sde, Bde), Lde.removeEventListener("p", Sde, !1));
    var Vde = Fde;

    function Ude(e) {
      return null != e;
    }

    function qde(e, t, r) {
      return e ? t : r;
    }

    function Kde(e) {
      return e;
    }

    function Gde(e) {
      return e;
    }

    var Wde = function (e) {
      for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];

      var o = Object.entries(e).filter(function (e) {
        var t = Qfe(e, 1)[0];
        return !r.includes(t);
      });
      return o.reduce(function (e, t) {
        var r = Qfe(t, 2),
            n = r[0],
            o = r[1];
        return e[n] = o, e;
      }, {});
    },
        Hde = ["children", "innerProps"],
        Jde = ["children", "innerProps"];

    function Yde(e) {
      var t = e.maxHeight,
          r = e.menuEl,
          n = e.minHeight,
          o = e.placement,
          i = e.shouldScroll,
          a = e.isFixedPosition,
          c = e.controlHeight,
          u = function (e) {
        var t = getComputedStyle(e),
            r = "absolute" === t.position,
            n = /(auto|scroll)/;
        if ("fixed" === t.position) return document.documentElement;

        for (var o = e; o = o.parentElement;) if (t = getComputedStyle(o), (!r || "static" !== t.position) && n.test(t.overflow + t.overflowY + t.overflowX)) return o;

        return document.documentElement;
      }(r),
          l = {
        placement: "bottom",
        maxHeight: t
      };

      if (!r || !r.offsetParent) return l;

      var s,
          p = u.getBoundingClientRect().height,
          f = r.getBoundingClientRect(),
          d = f.bottom,
          b = f.height,
          y = f.top,
          m = r.offsetParent.getBoundingClientRect().top,
          v = a ? window.innerHeight : Nde(s = u) ? window.innerHeight : s.clientHeight,
          h = Dde(u),
          g = parseInt(getComputedStyle(r).marginBottom, 10),
          w = parseInt(getComputedStyle(r).marginTop, 10),
          O = m - w,
          j = v - y,
          P = O + h,
          _ = p - h - y,
          E = d - v + h + g,
          S = h + y - w;

      switch (o) {
        case "auto":
        case "bottom":
          if (j >= b) return {
            placement: "bottom",
            maxHeight: t
          };
          if (_ >= b && !a) return i && Ade(u, E, 160), {
            placement: "bottom",
            maxHeight: t
          };
          if (!a && _ >= n || a && j >= n) return i && Ade(u, E, 160), {
            placement: "bottom",
            maxHeight: a ? j - g : _ - g
          };

          if ("auto" === o || a) {
            var C = t,
                k = a ? O : P;
            return k >= n && (C = Math.min(k - g - c, t)), {
              placement: "top",
              maxHeight: C
            };
          }

          if ("bottom" === o) return i && xde(u, E), {
            placement: "bottom",
            maxHeight: t
          };
          break;

        case "top":
          if (O >= b) return {
            placement: "top",
            maxHeight: t
          };
          if (P >= b && !a) return i && Ade(u, S, 160), {
            placement: "top",
            maxHeight: t
          };

          if (!a && P >= n || a && O >= n) {
            var R = t;
            return (!a && P >= n || a && O >= n) && (R = a ? O - w : P - w), i && Ade(u, S, 160), {
              placement: "top",
              maxHeight: R
            };
          }

          return {
            placement: "bottom",
            maxHeight: t
          };

        default:
          throw new Error('Invalid placement provided "'.concat(o, '".'));
      }

      return l;
    }

    var Qde,
        $de = function (e) {
      return "auto" === e ? "bottom" : e;
    },
        Xde = Object(s.createContext)(null),
        Zde = function (e) {
      var t = e.children,
          r = e.minMenuHeight,
          n = e.maxMenuHeight,
          o = e.menuPlacement,
          i = e.menuPosition,
          a = e.menuShouldScrollIntoView,
          c = e.theme,
          u = (Object(s.useContext)(Xde) || {}).setPortalPlacement,
          l = Object(s.useRef)(null),
          p = Qfe(Object(s.useState)(n), 2),
          f = p[0],
          d = p[1],
          b = Qfe(Object(s.useState)(null), 2),
          y = b[0],
          m = b[1],
          v = c.spacing.controlHeight;
      return _de(function () {
        var e = l.current;

        if (e) {
          var t = "fixed" === i,
              c = Yde({
            maxHeight: n,
            menuEl: e,
            minHeight: r,
            placement: o,
            shouldScroll: a && !t,
            isFixedPosition: t,
            controlHeight: v
          });
          d(c.maxHeight), m(c.placement), null == u || u(c.placement);
        }
      }, [n, o, i, a, r, u, v]), t({
        ref: l,
        placerProps: spe(spe({}, e), {}, {
          placement: y || $de(o),
          maxHeight: f
        })
      });
    },
        ebe = function (e) {
      var t = e.children,
          r = e.innerRef,
          n = e.innerProps;
      return Jfe("div", cpe({}, zde(e, "menu", {
        menu: !0
      }), {
        ref: r
      }, n), t);
    },
        tbe = function (e, t) {
      var r = e.theme,
          n = r.spacing.baseUnit,
          o = r.colors;
      return spe({
        textAlign: "center"
      }, t ? {} : {
        color: o.neutral40,
        padding: "".concat(2 * n, "px ").concat(3 * n, "px")
      });
    },
        rbe = tbe,
        nbe = tbe,
        obe = ["size"],
        ibe = ["innerProps", "isRtl", "size"];

    var abe,
        cbe,
        ube = {
      name: "8mmkcg",
      styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    },
        lbe = function (e) {
      var t = e.size,
          r = $fe(e, obe);
      return Jfe("svg", cpe({
        height: t,
        width: t,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: ube
      }, r));
    },
        sbe = function (e) {
      return Jfe(lbe, cpe({
        size: 20
      }, e), Jfe("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
      }));
    },
        pbe = function (e) {
      return Jfe(lbe, cpe({
        size: 20
      }, e), Jfe("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
      }));
    },
        fbe = function (e, t) {
      var r = e.isFocused,
          n = e.theme,
          o = n.spacing.baseUnit,
          i = n.colors;
      return spe({
        label: "indicatorContainer",
        display: "flex",
        transition: "color 150ms"
      }, t ? {} : {
        color: r ? i.neutral60 : i.neutral20,
        padding: 2 * o,
        ":hover": {
          color: r ? i.neutral80 : i.neutral40
        }
      });
    },
        dbe = fbe,
        bbe = fbe,
        ybe = function () {
      var e = Yfe.apply(void 0, arguments),
          t = "animation-" + e.name;
      return {
        name: t,
        styles: "@keyframes " + t + "{" + e.styles + "}",
        anim: 1,
        toString: function () {
          return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
      };
    }(Qde || (abe = ["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"], cbe || (cbe = abe.slice(0)), Qde = Object.freeze(Object.defineProperties(abe, {
      raw: {
        value: Object.freeze(cbe)
      }
    })))),
        mbe = function (e) {
      var t = e.delay,
          r = e.offset;
      return Jfe("span", {
        css: Yfe({
          animation: "".concat(ybe, " 1s ease-in-out ").concat(t, "ms infinite;"),
          backgroundColor: "currentColor",
          borderRadius: "1em",
          display: "inline-block",
          marginLeft: r ? "1em" : void 0,
          height: "1em",
          verticalAlign: "top",
          width: "1em"
        }, "", "")
      });
    },
        vbe = function (e) {
      var t = e.children,
          r = e.isDisabled,
          n = e.isFocused,
          o = e.innerRef,
          i = e.innerProps,
          a = e.menuIsOpen;
      return Jfe("div", cpe({
        ref: o
      }, zde(e, "control", {
        control: !0,
        "control--is-disabled": r,
        "control--is-focused": n,
        "control--menu-is-open": a
      }), i, {
        "aria-disabled": r || void 0
      }), t);
    },
        hbe = ["data"],
        gbe = function (e) {
      var t = e.children,
          r = e.cx,
          n = e.getStyles,
          o = e.getClassNames,
          i = e.Heading,
          a = e.headingProps,
          c = e.innerProps,
          u = e.label,
          l = e.theme,
          s = e.selectProps;
      return Jfe("div", cpe({}, zde(e, "group", {
        group: !0
      }), c), Jfe(i, cpe({}, a, {
        selectProps: s,
        theme: l,
        getStyles: n,
        getClassNames: o,
        cx: r
      }), u), Jfe("div", null, t));
    },
        wbe = ["innerRef", "isDisabled", "isHidden", "inputClassName"],
        Obe = {
      gridArea: "1 / 2",
      font: "inherit",
      minWidth: "2px",
      border: 0,
      margin: 0,
      outline: 0,
      padding: 0
    },
        jbe = {
      flex: "1 1 auto",
      display: "inline-grid",
      gridArea: "1 / 1 / 2 / 3",
      gridTemplateColumns: "0 min-content",
      "&:after": spe({
        content: 'attr(data-value) " "',
        visibility: "hidden",
        whiteSpace: "pre"
      }, Obe)
    },
        Pbe = function (e) {
      return spe({
        label: "input",
        color: "inherit",
        background: 0,
        opacity: e ? 0 : 1,
        width: "100%"
      }, Obe);
    },
        _be = function (e) {
      var t = e.children,
          r = e.innerProps;
      return Jfe("div", r, t);
    };

    var Ebe = {
      ClearIndicator: function (e) {
        var t = e.children,
            r = e.innerProps;
        return Jfe("div", cpe({}, zde(e, "clearIndicator", {
          indicator: !0,
          "clear-indicator": !0
        }), r), t || Jfe(sbe, null));
      },
      Control: vbe,
      DropdownIndicator: function (e) {
        var t = e.children,
            r = e.innerProps;
        return Jfe("div", cpe({}, zde(e, "dropdownIndicator", {
          indicator: !0,
          "dropdown-indicator": !0
        }), r), t || Jfe(pbe, null));
      },
      DownChevron: pbe,
      CrossIcon: sbe,
      Group: gbe,
      GroupHeading: function (e) {
        var t = Tde(e);
        t.data;
        var r = $fe(t, hbe);
        return Jfe("div", cpe({}, zde(e, "groupHeading", {
          "group-heading": !0
        }), r));
      },
      IndicatorsContainer: function (e) {
        var t = e.children,
            r = e.innerProps;
        return Jfe("div", cpe({}, zde(e, "indicatorsContainer", {
          indicators: !0
        }), r), t);
      },
      IndicatorSeparator: function (e) {
        var t = e.innerProps;
        return Jfe("span", cpe({}, t, zde(e, "indicatorSeparator", {
          "indicator-separator": !0
        })));
      },
      Input: function (e) {
        var t = e.cx,
            r = e.value,
            n = Tde(e),
            o = n.innerRef,
            i = n.isDisabled,
            a = n.isHidden,
            c = n.inputClassName,
            u = $fe(n, wbe);
        return Jfe("div", cpe({}, zde(e, "input", {
          "input-container": !0
        }), {
          "data-value": r || ""
        }), Jfe("input", cpe({
          className: t({
            input: !0
          }, c),
          ref: o,
          style: Pbe(a),
          disabled: i
        }, u)));
      },
      LoadingIndicator: function (e) {
        var t = e.innerProps,
            r = e.isRtl,
            n = e.size,
            o = void 0 === n ? 4 : n,
            i = $fe(e, ibe);
        return Jfe("div", cpe({}, zde(spe(spe({}, i), {}, {
          innerProps: t,
          isRtl: r,
          size: o
        }), "loadingIndicator", {
          indicator: !0,
          "loading-indicator": !0
        }), t), Jfe(mbe, {
          delay: 0,
          offset: r
        }), Jfe(mbe, {
          delay: 160,
          offset: !0
        }), Jfe(mbe, {
          delay: 320,
          offset: !r
        }));
      },
      Menu: ebe,
      MenuList: function (e) {
        var t = e.children,
            r = e.innerProps,
            n = e.innerRef,
            o = e.isMulti;
        return Jfe("div", cpe({}, zde(e, "menuList", {
          "menu-list": !0,
          "menu-list--is-multi": o
        }), {
          ref: n
        }, r), t);
      },
      MenuPortal: function (e) {
        var t = e.appendTo,
            r = e.children,
            n = e.controlElement,
            o = e.innerProps,
            i = e.menuPlacement,
            a = e.menuPosition,
            c = Object(s.useRef)(null),
            u = Object(s.useRef)(null),
            l = Qfe(Object(s.useState)($de(i)), 2),
            p = l[0],
            f = l[1],
            d = Object(s.useMemo)(function () {
          return {
            setPortalPlacement: f
          };
        }, []),
            b = Qfe(Object(s.useState)(null), 2),
            y = b[0],
            m = b[1],
            v = Object(s.useCallback)(function () {
          if (n) {
            var e = function (e) {
              var t = e.getBoundingClientRect();
              return {
                bottom: t.bottom,
                height: t.height,
                left: t.left,
                right: t.right,
                top: t.top,
                width: t.width
              };
            }(n),
                t = "fixed" === a ? 0 : window.pageYOffset,
                r = e[p] + t;

            r === (null == y ? void 0 : y.offset) && e.left === (null == y ? void 0 : y.rect.left) && e.width === (null == y ? void 0 : y.rect.width) || m({
              offset: r,
              rect: e
            });
          }
        }, [n, a, p, null == y ? void 0 : y.offset, null == y ? void 0 : y.rect.left, null == y ? void 0 : y.rect.width]);

        _de(function () {
          v();
        }, [v]);

        var h = Object(s.useCallback)(function () {
          "function" == typeof u.current && (u.current(), u.current = null), n && c.current && (u.current = Pde(n, c.current, v, {
            elementResize: "ResizeObserver" in window
          }));
        }, [n, v]);

        _de(function () {
          h();
        }, [h]);

        var g = Object(s.useCallback)(function (e) {
          c.current = e, h();
        }, [h]);
        if (!t && "fixed" !== a || !y) return null;
        var w = Jfe("div", cpe({
          ref: g
        }, zde(spe(spe({}, e), {}, {
          offset: y.offset,
          position: a,
          rect: y.rect
        }), "menuPortal", {
          "menu-portal": !0
        }), o), r);
        return Jfe(Xde.Provider, {
          value: d
        }, t ? Object(sa.createPortal)(w, t) : w);
      },
      LoadingMessage: function (e) {
        var t = e.children,
            r = void 0 === t ? "Loading..." : t,
            n = e.innerProps,
            o = $fe(e, Jde);
        return Jfe("div", cpe({}, zde(spe(spe({}, o), {}, {
          children: r,
          innerProps: n
        }), "loadingMessage", {
          "menu-notice": !0,
          "menu-notice--loading": !0
        }), n), r);
      },
      NoOptionsMessage: function (e) {
        var t = e.children,
            r = void 0 === t ? "No options" : t,
            n = e.innerProps,
            o = $fe(e, Hde);
        return Jfe("div", cpe({}, zde(spe(spe({}, o), {}, {
          children: r,
          innerProps: n
        }), "noOptionsMessage", {
          "menu-notice": !0,
          "menu-notice--no-options": !0
        }), n), r);
      },
      MultiValue: function (e) {
        var t = e.children,
            r = e.components,
            n = e.data,
            o = e.innerProps,
            i = e.isDisabled,
            a = e.removeProps,
            c = e.selectProps,
            u = r.Container,
            l = r.Label,
            s = r.Remove;
        return Jfe(u, {
          data: n,
          innerProps: spe(spe({}, zde(e, "multiValue", {
            "multi-value": !0,
            "multi-value--is-disabled": i
          })), o),
          selectProps: c
        }, Jfe(l, {
          data: n,
          innerProps: spe({}, zde(e, "multiValueLabel", {
            "multi-value__label": !0
          })),
          selectProps: c
        }, t), Jfe(s, {
          data: n,
          innerProps: spe(spe({}, zde(e, "multiValueRemove", {
            "multi-value__remove": !0
          })), {}, {
            "aria-label": "Remove ".concat(t || "option")
          }, a),
          selectProps: c
        }));
      },
      MultiValueContainer: _be,
      MultiValueLabel: _be,
      MultiValueRemove: function (e) {
        var t = e.children,
            r = e.innerProps;
        return Jfe("div", cpe({
          role: "button"
        }, r), t || Jfe(sbe, {
          size: 14
        }));
      },
      Option: function (e) {
        var t = e.children,
            r = e.isDisabled,
            n = e.isFocused,
            o = e.isSelected,
            i = e.innerRef,
            a = e.innerProps;
        return Jfe("div", cpe({}, zde(e, "option", {
          option: !0,
          "option--is-disabled": r,
          "option--is-focused": n,
          "option--is-selected": o
        }), {
          ref: i,
          "aria-disabled": r
        }, a), t);
      },
      Placeholder: function (e) {
        var t = e.children,
            r = e.innerProps;
        return Jfe("div", cpe({}, zde(e, "placeholder", {
          placeholder: !0
        }), r), t);
      },
      SelectContainer: function (e) {
        var t = e.children,
            r = e.innerProps,
            n = e.isDisabled,
            o = e.isRtl;
        return Jfe("div", cpe({}, zde(e, "container", {
          "--is-disabled": n,
          "--is-rtl": o
        }), r), t);
      },
      SingleValue: function (e) {
        var t = e.children,
            r = e.isDisabled,
            n = e.innerProps;
        return Jfe("div", cpe({}, zde(e, "singleValue", {
          "single-value": !0,
          "single-value--is-disabled": r
        }), n), t);
      },
      ValueContainer: function (e) {
        var t = e.children,
            r = e.innerProps,
            n = e.isMulti,
            o = e.hasValue;
        return Jfe("div", cpe({}, zde(e, "valueContainer", {
          "value-container": !0,
          "value-container--is-multi": n,
          "value-container--has-value": o
        }), r), t);
      }
    },
        Sbe = function (e) {
      return spe(spe({}, Ebe), e.components);
    },
        Cbe = Number.isNaN || function (e) {
      return "number" == typeof e && e != e;
    };

    function kbe(e, t) {
      if (e.length !== t.length) return !1;

      for (var r = 0; r < e.length; r++) if (n = e[r], o = t[r], !(n === o || Cbe(n) && Cbe(o))) return !1;

      var n, o;
      return !0;
    }

    for (var Rbe = {
      name: "7pg0cj-a11yText",
      styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
    }, Tbe = function (e) {
      return Jfe("span", cpe({
        css: Rbe
      }, e));
    }, zbe = {
      guidance: function (e) {
        var t = e.isSearchable,
            r = e.isMulti,
            n = e.isDisabled,
            o = e.tabSelectsValue;

        switch (e.context) {
          case "menu":
            return "Use Up and Down to choose options".concat(n ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(o ? ", press Tab to select the option and exit the menu" : "", ".");

          case "input":
            return "".concat(e["aria-label"] || "Select", " is focused ").concat(t ? ",type to refine list" : "", ", press Down to open the menu, ").concat(r ? " press left to focus selected values" : "");

          case "value":
            return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";

          default:
            return "";
        }
      },
      onChange: function (e) {
        var t = e.action,
            r = e.label,
            n = void 0 === r ? "" : r,
            o = e.labels,
            i = e.isDisabled;

        switch (t) {
          case "deselect-option":
          case "pop-value":
          case "remove-value":
            return "option ".concat(n, ", deselected.");

          case "clear":
            return "All selected options have been cleared.";

          case "initial-input-focus":
            return "option".concat(o.length > 1 ? "s" : "", " ").concat(o.join(","), ", selected.");

          case "select-option":
            return "option ".concat(n, i ? " is disabled. Select another option." : ", selected.");

          default:
            return "";
        }
      },
      onFocus: function (e) {
        var t = e.context,
            r = e.focused,
            n = e.options,
            o = e.label,
            i = void 0 === o ? "" : o,
            a = e.selectValue,
            c = e.isDisabled,
            u = e.isSelected,
            l = function (e, t) {
          return e && e.length ? "".concat(e.indexOf(t) + 1, " of ").concat(e.length) : "";
        };

        if ("value" === t && a) return "value ".concat(i, " focused, ").concat(l(a, r), ".");

        if ("menu" === t) {
          var s = c ? " disabled" : "",
              p = "".concat(u ? "selected" : "focused").concat(s);
          return "option ".concat(i, " ").concat(p, ", ").concat(l(n, r), ".");
        }

        return "";
      },
      onFilter: function (e) {
        var t = e.inputValue,
            r = e.resultsMessage;
        return "".concat(r).concat(t ? " for search term " + t : "", ".");
      }
    }, Nbe = function (e) {
      var t = e.ariaSelection,
          r = e.focusedOption,
          n = e.focusedValue,
          o = e.focusableOptions,
          i = e.isFocused,
          a = e.selectValue,
          c = e.selectProps,
          u = e.id,
          l = c.ariaLiveMessages,
          p = c.getOptionLabel,
          f = c.inputValue,
          d = c.isMulti,
          b = c.isOptionDisabled,
          y = c.isSearchable,
          m = c.menuIsOpen,
          v = c.options,
          h = c.screenReaderStatus,
          g = c.tabSelectsValue,
          w = c["aria-label"],
          O = c["aria-live"],
          j = Object(s.useMemo)(function () {
        return spe(spe({}, zbe), l || {});
      }, [l]),
          P = Object(s.useMemo)(function () {
        var e,
            r = "";

        if (t && j.onChange) {
          var n = t.option,
              o = t.options,
              i = t.removedValue,
              c = t.removedValues,
              u = t.value,
              l = i || n || (e = u, Array.isArray(e) ? null : e),
              s = l ? p(l) : "",
              f = o || c || void 0,
              d = f ? f.map(p) : [],
              y = spe({
            isDisabled: l && b(l, a),
            label: s,
            labels: d
          }, t);
          r = j.onChange(y);
        }

        return r;
      }, [t, j, b, a, p]),
          _ = Object(s.useMemo)(function () {
        var e = "",
            t = r || n,
            i = !!(r && a && a.includes(r));

        if (t && j.onFocus) {
          var c = {
            focused: t,
            label: p(t),
            isDisabled: b(t, a),
            isSelected: i,
            options: o,
            context: t === r ? "menu" : "value",
            selectValue: a
          };
          e = j.onFocus(c);
        }

        return e;
      }, [r, n, p, b, j, o, a]),
          E = Object(s.useMemo)(function () {
        var e = "";

        if (m && v.length && j.onFilter) {
          var t = h({
            count: o.length
          });
          e = j.onFilter({
            inputValue: f,
            resultsMessage: t
          });
        }

        return e;
      }, [o, f, m, j, v, h]),
          S = Object(s.useMemo)(function () {
        var e = "";

        if (j.guidance) {
          var t = n ? "value" : m ? "menu" : "input";
          e = j.guidance({
            "aria-label": w,
            context: t,
            isDisabled: r && b(r, a),
            isMulti: d,
            isSearchable: y,
            tabSelectsValue: g
          });
        }

        return e;
      }, [w, r, n, d, b, y, m, j, a, g]),
          C = "".concat(_, " ").concat(E, " ").concat(S),
          k = Jfe(s.Fragment, null, Jfe("span", {
        id: "aria-selection"
      }, P), Jfe("span", {
        id: "aria-context"
      }, C)),
          R = "initial-input-focus" === (null == t ? void 0 : t.action);

      return Jfe(s.Fragment, null, Jfe(Tbe, {
        id: u
      }, R && k), Jfe(Tbe, {
        "aria-live": O,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
      }, i && !R && k));
    }, Dbe = [{
      base: "A",
      letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
    }, {
      base: "AA",
      letters: "Ꜳ"
    }, {
      base: "AE",
      letters: "ÆǼǢ"
    }, {
      base: "AO",
      letters: "Ꜵ"
    }, {
      base: "AU",
      letters: "Ꜷ"
    }, {
      base: "AV",
      letters: "ꜸꜺ"
    }, {
      base: "AY",
      letters: "Ꜽ"
    }, {
      base: "B",
      letters: "BⒷＢḂḄḆɃƂƁ"
    }, {
      base: "C",
      letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
    }, {
      base: "D",
      letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
    }, {
      base: "DZ",
      letters: "ǱǄ"
    }, {
      base: "Dz",
      letters: "ǲǅ"
    }, {
      base: "E",
      letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
    }, {
      base: "F",
      letters: "FⒻＦḞƑꝻ"
    }, {
      base: "G",
      letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
    }, {
      base: "H",
      letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
    }, {
      base: "I",
      letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
    }, {
      base: "J",
      letters: "JⒿＪĴɈ"
    }, {
      base: "K",
      letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
    }, {
      base: "L",
      letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
    }, {
      base: "LJ",
      letters: "Ǉ"
    }, {
      base: "Lj",
      letters: "ǈ"
    }, {
      base: "M",
      letters: "MⓂＭḾṀṂⱮƜ"
    }, {
      base: "N",
      letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
    }, {
      base: "NJ",
      letters: "Ǌ"
    }, {
      base: "Nj",
      letters: "ǋ"
    }, {
      base: "O",
      letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
    }, {
      base: "OI",
      letters: "Ƣ"
    }, {
      base: "OO",
      letters: "Ꝏ"
    }, {
      base: "OU",
      letters: "Ȣ"
    }, {
      base: "P",
      letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
    }, {
      base: "Q",
      letters: "QⓆＱꝖꝘɊ"
    }, {
      base: "R",
      letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
    }, {
      base: "S",
      letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
    }, {
      base: "T",
      letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
    }, {
      base: "TZ",
      letters: "Ꜩ"
    }, {
      base: "U",
      letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
    }, {
      base: "V",
      letters: "VⓋＶṼṾƲꝞɅ"
    }, {
      base: "VY",
      letters: "Ꝡ"
    }, {
      base: "W",
      letters: "WⓌＷẀẂŴẆẄẈⱲ"
    }, {
      base: "X",
      letters: "XⓍＸẊẌ"
    }, {
      base: "Y",
      letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
    }, {
      base: "Z",
      letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
    }, {
      base: "a",
      letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
    }, {
      base: "aa",
      letters: "ꜳ"
    }, {
      base: "ae",
      letters: "æǽǣ"
    }, {
      base: "ao",
      letters: "ꜵ"
    }, {
      base: "au",
      letters: "ꜷ"
    }, {
      base: "av",
      letters: "ꜹꜻ"
    }, {
      base: "ay",
      letters: "ꜽ"
    }, {
      base: "b",
      letters: "bⓑｂḃḅḇƀƃɓ"
    }, {
      base: "c",
      letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
    }, {
      base: "d",
      letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
    }, {
      base: "dz",
      letters: "ǳǆ"
    }, {
      base: "e",
      letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
    }, {
      base: "f",
      letters: "fⓕｆḟƒꝼ"
    }, {
      base: "g",
      letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
    }, {
      base: "h",
      letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
    }, {
      base: "hv",
      letters: "ƕ"
    }, {
      base: "i",
      letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
    }, {
      base: "j",
      letters: "jⓙｊĵǰɉ"
    }, {
      base: "k",
      letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
    }, {
      base: "l",
      letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
    }, {
      base: "lj",
      letters: "ǉ"
    }, {
      base: "m",
      letters: "mⓜｍḿṁṃɱɯ"
    }, {
      base: "n",
      letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
    }, {
      base: "nj",
      letters: "ǌ"
    }, {
      base: "o",
      letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
    }, {
      base: "oi",
      letters: "ƣ"
    }, {
      base: "ou",
      letters: "ȣ"
    }, {
      base: "oo",
      letters: "ꝏ"
    }, {
      base: "p",
      letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
    }, {
      base: "q",
      letters: "qⓠｑɋꝗꝙ"
    }, {
      base: "r",
      letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
    }, {
      base: "s",
      letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
    }, {
      base: "t",
      letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
    }, {
      base: "tz",
      letters: "ꜩ"
    }, {
      base: "u",
      letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
    }, {
      base: "v",
      letters: "vⓥｖṽṿʋꝟʌ"
    }, {
      base: "vy",
      letters: "ꝡ"
    }, {
      base: "w",
      letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
    }, {
      base: "x",
      letters: "xⓧｘẋẍ"
    }, {
      base: "y",
      letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
    }, {
      base: "z",
      letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
    }], xbe = new RegExp("[" + Dbe.map(function (e) {
      return e.letters;
    }).join("") + "]", "g"), Abe = {}, Mbe = 0; Mbe < Dbe.length; Mbe++) for (var Ibe = Dbe[Mbe], Fbe = 0; Fbe < Ibe.letters.length; Fbe++) Abe[Ibe.letters[Fbe]] = Ibe.base;

    var Bbe = function (e) {
      return e.replace(xbe, function (e) {
        return Abe[e];
      });
    },
        Lbe = function (e, t) {
      void 0 === t && (t = kbe);
      var r = null;

      function n() {
        for (var n = [], o = 0; o < arguments.length; o++) n[o] = arguments[o];

        if (r && r.lastThis === this && t(n, r.lastArgs)) return r.lastResult;
        var i = e.apply(this, n);
        return r = {
          lastResult: i,
          lastArgs: n,
          lastThis: this
        }, i;
      }

      return n.clear = function () {
        r = null;
      }, n;
    }(Bbe),
        Vbe = function (e) {
      return e.replace(/^\s+|\s+$/g, "");
    },
        Ube = function (e) {
      return "".concat(e.label, " ").concat(e.value);
    },
        qbe = ["innerRef"];

    function Kbe(e) {
      var t = e.innerRef,
          r = $fe(e, qbe),
          n = Wde(r, "onExited", "in", "enter", "exit", "appear");
      return Jfe("input", cpe({
        ref: t
      }, n, {
        css: Yfe({
          label: "dummyInput",
          background: 0,
          border: 0,
          caretColor: "transparent",
          fontSize: "inherit",
          gridArea: "1 / 1 / 2 / 3",
          outline: 0,
          padding: 0,
          width: 1,
          color: "transparent",
          left: -100,
          opacity: 0,
          position: "relative",
          transform: "scale(.01)"
        }, "", "")
      }));
    }

    var Gbe = function (e) {
      e.cancelable && e.preventDefault(), e.stopPropagation();
    };

    var Wbe = ["boxSizing", "height", "overflow", "paddingRight", "position"],
        Hbe = {
      boxSizing: "border-box",
      overflow: "hidden",
      position: "relative",
      height: "100%"
    };

    function Jbe(e) {
      e.preventDefault();
    }

    function Ybe(e) {
      e.stopPropagation();
    }

    function Qbe() {
      var e = this.scrollTop,
          t = this.scrollHeight,
          r = e + this.offsetHeight;
      0 === e ? this.scrollTop = 1 : r === t && (this.scrollTop = e - 1);
    }

    function $be() {
      return "ontouchstart" in window || navigator.maxTouchPoints;
    }

    var Xbe = !("undefined" == typeof window || !window.document || !window.document.createElement),
        Zbe = 0,
        eye = {
      capture: !1,
      passive: !1
    };

    var tye = function (e) {
      var t = e.target;
      return t.ownerDocument.activeElement && t.ownerDocument.activeElement.blur();
    },
        rye = {
      name: "1kfdb0e",
      styles: "position:fixed;left:0;bottom:0;right:0;top:0"
    };

    function nye(e) {
      var t = e.children,
          r = e.lockEnabled,
          n = e.captureEnabled,
          o = function (e) {
        var t = e.isEnabled,
            r = e.onBottomArrive,
            n = e.onBottomLeave,
            o = e.onTopArrive,
            i = e.onTopLeave,
            a = Object(s.useRef)(!1),
            c = Object(s.useRef)(!1),
            u = Object(s.useRef)(0),
            l = Object(s.useRef)(null),
            p = Object(s.useCallback)(function (e, t) {
          if (null !== l.current) {
            var u = l.current,
                s = u.scrollTop,
                p = u.scrollHeight,
                f = u.clientHeight,
                d = l.current,
                b = t > 0,
                y = p - f - s,
                m = !1;
            y > t && a.current && (n && n(e), a.current = !1), b && c.current && (i && i(e), c.current = !1), b && t > y ? (r && !a.current && r(e), d.scrollTop = p, m = !0, a.current = !0) : !b && -t > s && (o && !c.current && o(e), d.scrollTop = 0, m = !0, c.current = !0), m && Gbe(e);
          }
        }, [r, n, o, i]),
            f = Object(s.useCallback)(function (e) {
          p(e, e.deltaY);
        }, [p]),
            d = Object(s.useCallback)(function (e) {
          u.current = e.changedTouches[0].clientY;
        }, []),
            b = Object(s.useCallback)(function (e) {
          var t = u.current - e.changedTouches[0].clientY;
          p(e, t);
        }, [p]),
            y = Object(s.useCallback)(function (e) {
          if (e) {
            var t = !!Vde && {
              passive: !1
            };
            e.addEventListener("wheel", f, t), e.addEventListener("touchstart", d, t), e.addEventListener("touchmove", b, t);
          }
        }, [b, d, f]),
            m = Object(s.useCallback)(function (e) {
          e && (e.removeEventListener("wheel", f, !1), e.removeEventListener("touchstart", d, !1), e.removeEventListener("touchmove", b, !1));
        }, [b, d, f]);
        return Object(s.useEffect)(function () {
          if (t) {
            var e = l.current;
            return y(e), function () {
              m(e);
            };
          }
        }, [t, y, m]), function (e) {
          l.current = e;
        };
      }({
        isEnabled: void 0 === n || n,
        onBottomArrive: e.onBottomArrive,
        onBottomLeave: e.onBottomLeave,
        onTopArrive: e.onTopArrive,
        onTopLeave: e.onTopLeave
      }),
          i = function (e) {
        var t = e.isEnabled,
            r = e.accountForScrollbars,
            n = void 0 === r || r,
            o = Object(s.useRef)({}),
            i = Object(s.useRef)(null),
            a = Object(s.useCallback)(function (e) {
          if (Xbe) {
            var t = document.body,
                r = t && t.style;

            if (n && Wbe.forEach(function (e) {
              var t = r && r[e];
              o.current[e] = t;
            }), n && Zbe < 1) {
              var i = parseInt(o.current.paddingRight, 10) || 0,
                  a = document.body ? document.body.clientWidth : 0,
                  c = window.innerWidth - a + i || 0;
              Object.keys(Hbe).forEach(function (e) {
                var t = Hbe[e];
                r && (r[e] = t);
              }), r && (r.paddingRight = "".concat(c, "px"));
            }

            t && $be() && (t.addEventListener("touchmove", Jbe, eye), e && (e.addEventListener("touchstart", Qbe, eye), e.addEventListener("touchmove", Ybe, eye))), Zbe += 1;
          }
        }, [n]),
            c = Object(s.useCallback)(function (e) {
          if (Xbe) {
            var t = document.body,
                r = t && t.style;
            Zbe = Math.max(Zbe - 1, 0), n && Zbe < 1 && Wbe.forEach(function (e) {
              var t = o.current[e];
              r && (r[e] = t);
            }), t && $be() && (t.removeEventListener("touchmove", Jbe, eye), e && (e.removeEventListener("touchstart", Qbe, eye), e.removeEventListener("touchmove", Ybe, eye)));
          }
        }, [n]);
        return Object(s.useEffect)(function () {
          if (t) {
            var e = i.current;
            return a(e), function () {
              c(e);
            };
          }
        }, [t, a, c]), function (e) {
          i.current = e;
        };
      }({
        isEnabled: r
      });

      return Jfe(s.Fragment, null, r && Jfe("div", {
        onClick: tye,
        css: rye
      }), t(function (e) {
        o(e), i(e);
      }));
    }

    var oye = {
      name: "1a0ro4n-requiredInput",
      styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
    },
        iye = function (e) {
      var t = e.name,
          r = e.onFocus;
      return Jfe("input", {
        required: !0,
        name: t,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: r,
        css: oye,
        value: "",
        onChange: function () {}
      });
    },
        aye = {
      clearIndicator: bbe,
      container: function (e) {
        var t = e.isDisabled;
        return {
          label: "container",
          direction: e.isRtl ? "rtl" : void 0,
          pointerEvents: t ? "none" : void 0,
          position: "relative"
        };
      },
      control: function (e, t) {
        var r = e.isDisabled,
            n = e.isFocused,
            o = e.theme,
            i = o.colors,
            a = o.borderRadius;
        return spe({
          label: "control",
          alignItems: "center",
          cursor: "default",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          minHeight: o.spacing.controlHeight,
          outline: "0 !important",
          position: "relative",
          transition: "all 100ms"
        }, t ? {} : {
          backgroundColor: r ? i.neutral5 : i.neutral0,
          borderColor: r ? i.neutral10 : n ? i.primary : i.neutral20,
          borderRadius: a,
          borderStyle: "solid",
          borderWidth: 1,
          boxShadow: n ? "0 0 0 1px ".concat(i.primary) : void 0,
          "&:hover": {
            borderColor: n ? i.primary : i.neutral30
          }
        });
      },
      dropdownIndicator: dbe,
      group: function (e, t) {
        var r = e.theme.spacing;
        return t ? {} : {
          paddingBottom: 2 * r.baseUnit,
          paddingTop: 2 * r.baseUnit
        };
      },
      groupHeading: function (e, t) {
        var r = e.theme,
            n = r.colors,
            o = r.spacing;
        return spe({
          label: "group",
          cursor: "default",
          display: "block"
        }, t ? {} : {
          color: n.neutral40,
          fontSize: "75%",
          fontWeight: 500,
          marginBottom: "0.25em",
          paddingLeft: 3 * o.baseUnit,
          paddingRight: 3 * o.baseUnit,
          textTransform: "uppercase"
        });
      },
      indicatorsContainer: function () {
        return {
          alignItems: "center",
          alignSelf: "stretch",
          display: "flex",
          flexShrink: 0
        };
      },
      indicatorSeparator: function (e, t) {
        var r = e.isDisabled,
            n = e.theme,
            o = n.spacing.baseUnit,
            i = n.colors;
        return spe({
          label: "indicatorSeparator",
          alignSelf: "stretch",
          width: 1
        }, t ? {} : {
          backgroundColor: r ? i.neutral10 : i.neutral20,
          marginBottom: 2 * o,
          marginTop: 2 * o
        });
      },
      input: function (e, t) {
        var r = e.isDisabled,
            n = e.value,
            o = e.theme,
            i = o.spacing,
            a = o.colors;
        return spe(spe({
          visibility: r ? "hidden" : "visible",
          transform: n ? "translateZ(0)" : ""
        }, jbe), t ? {} : {
          margin: i.baseUnit / 2,
          paddingBottom: i.baseUnit / 2,
          paddingTop: i.baseUnit / 2,
          color: a.neutral80
        });
      },
      loadingIndicator: function (e, t) {
        var r = e.isFocused,
            n = e.size,
            o = e.theme,
            i = o.colors,
            a = o.spacing.baseUnit;
        return spe({
          label: "loadingIndicator",
          display: "flex",
          transition: "color 150ms",
          alignSelf: "center",
          fontSize: n,
          lineHeight: 1,
          marginRight: n,
          textAlign: "center",
          verticalAlign: "middle"
        }, t ? {} : {
          color: r ? i.neutral60 : i.neutral20,
          padding: 2 * a
        });
      },
      loadingMessage: nbe,
      menu: function (e, t) {
        var r,
            n = e.placement,
            o = e.theme,
            i = o.borderRadius,
            a = o.spacing,
            c = o.colors;
        return spe((upe(r = {
          label: "menu"
        }, function (e) {
          return e ? {
            bottom: "top",
            top: "bottom"
          }[e] : "bottom";
        }(n), "100%"), upe(r, "position", "absolute"), upe(r, "width", "100%"), upe(r, "zIndex", 1), r), t ? {} : {
          backgroundColor: c.neutral0,
          borderRadius: i,
          boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
          marginBottom: a.menuGutter,
          marginTop: a.menuGutter
        });
      },
      menuList: function (e, t) {
        var r = e.maxHeight,
            n = e.theme.spacing.baseUnit;
        return spe({
          maxHeight: r,
          overflowY: "auto",
          position: "relative",
          WebkitOverflowScrolling: "touch"
        }, t ? {} : {
          paddingBottom: n,
          paddingTop: n
        });
      },
      menuPortal: function (e) {
        var t = e.rect,
            r = e.offset,
            n = e.position;
        return {
          left: t.left,
          position: n,
          top: r,
          width: t.width,
          zIndex: 1
        };
      },
      multiValue: function (e, t) {
        var r = e.theme,
            n = r.spacing,
            o = r.borderRadius,
            i = r.colors;
        return spe({
          label: "multiValue",
          display: "flex",
          minWidth: 0
        }, t ? {} : {
          backgroundColor: i.neutral10,
          borderRadius: o / 2,
          margin: n.baseUnit / 2
        });
      },
      multiValueLabel: function (e, t) {
        var r = e.theme,
            n = r.borderRadius,
            o = r.colors,
            i = e.cropWithEllipsis;
        return spe({
          overflow: "hidden",
          textOverflow: i || void 0 === i ? "ellipsis" : void 0,
          whiteSpace: "nowrap"
        }, t ? {} : {
          borderRadius: n / 2,
          color: o.neutral80,
          fontSize: "85%",
          padding: 3,
          paddingLeft: 6
        });
      },
      multiValueRemove: function (e, t) {
        var r = e.theme,
            n = r.spacing,
            o = r.borderRadius,
            i = r.colors,
            a = e.isFocused;
        return spe({
          alignItems: "center",
          display: "flex"
        }, t ? {} : {
          borderRadius: o / 2,
          backgroundColor: a ? i.dangerLight : void 0,
          paddingLeft: n.baseUnit,
          paddingRight: n.baseUnit,
          ":hover": {
            backgroundColor: i.dangerLight,
            color: i.danger
          }
        });
      },
      noOptionsMessage: rbe,
      option: function (e, t) {
        var r = e.isDisabled,
            n = e.isFocused,
            o = e.isSelected,
            i = e.theme,
            a = i.spacing,
            c = i.colors;
        return spe({
          label: "option",
          cursor: "default",
          display: "block",
          fontSize: "inherit",
          width: "100%",
          userSelect: "none",
          WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
        }, t ? {} : {
          backgroundColor: o ? c.primary : n ? c.primary25 : "transparent",
          color: r ? c.neutral20 : o ? c.neutral0 : "inherit",
          padding: "".concat(2 * a.baseUnit, "px ").concat(3 * a.baseUnit, "px"),
          ":active": {
            backgroundColor: r ? void 0 : o ? c.primary : c.primary50
          }
        });
      },
      placeholder: function (e, t) {
        var r = e.theme,
            n = r.spacing,
            o = r.colors;
        return spe({
          label: "placeholder",
          gridArea: "1 / 1 / 2 / 3"
        }, t ? {} : {
          color: o.neutral50,
          marginLeft: n.baseUnit / 2,
          marginRight: n.baseUnit / 2
        });
      },
      singleValue: function (e, t) {
        var r = e.isDisabled,
            n = e.theme,
            o = n.spacing,
            i = n.colors;
        return spe({
          label: "singleValue",
          gridArea: "1 / 1 / 2 / 3",
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }, t ? {} : {
          color: r ? i.neutral40 : i.neutral80,
          marginLeft: o.baseUnit / 2,
          marginRight: o.baseUnit / 2
        });
      },
      valueContainer: function (e, t) {
        var r = e.theme.spacing,
            n = e.isMulti,
            o = e.hasValue,
            i = e.selectProps.controlShouldRenderValue;
        return spe({
          alignItems: "center",
          display: n && o && i ? "flex" : "grid",
          flex: 1,
          flexWrap: "wrap",
          WebkitOverflowScrolling: "touch",
          position: "relative",
          overflow: "hidden"
        }, t ? {} : {
          padding: "".concat(r.baseUnit / 2, "px ").concat(2 * r.baseUnit, "px")
        });
      }
    };

    var cye,
        uye = {
      borderRadius: 4,
      colors: {
        primary: "#2684FF",
        primary75: "#4C9AFF",
        primary50: "#B2D4FF",
        primary25: "#DEEBFF",
        danger: "#DE350B",
        dangerLight: "#FFBDAD",
        neutral0: "hsl(0, 0%, 100%)",
        neutral5: "hsl(0, 0%, 95%)",
        neutral10: "hsl(0, 0%, 90%)",
        neutral20: "hsl(0, 0%, 80%)",
        neutral30: "hsl(0, 0%, 70%)",
        neutral40: "hsl(0, 0%, 60%)",
        neutral50: "hsl(0, 0%, 50%)",
        neutral60: "hsl(0, 0%, 40%)",
        neutral70: "hsl(0, 0%, 30%)",
        neutral80: "hsl(0, 0%, 20%)",
        neutral90: "hsl(0, 0%, 10%)"
      },
      spacing: {
        baseUnit: 4,
        controlHeight: 38,
        menuGutter: 8
      }
    },
        lye = {
      "aria-live": "polite",
      backspaceRemovesValue: !0,
      blurInputOnSelect: Ide(),
      captureMenuScroll: !Ide(),
      classNames: {},
      closeMenuOnSelect: !0,
      closeMenuOnScroll: !1,
      components: {},
      controlShouldRenderValue: !0,
      escapeClearsValue: !1,
      filterOption: function (e, t) {
        if (e.data.__isNew__) return !0;
        var r = spe({
          ignoreCase: !0,
          ignoreAccents: !0,
          stringify: Ube,
          trim: !0,
          matchFrom: "any"
        }, cye),
            n = r.ignoreCase,
            o = r.ignoreAccents,
            i = r.stringify,
            a = r.trim,
            c = r.matchFrom,
            u = a ? Vbe(t) : t,
            l = a ? Vbe(i(e)) : i(e);
        return n && (u = u.toLowerCase(), l = l.toLowerCase()), o && (u = Lbe(u), l = Bbe(l)), "start" === c ? l.substr(0, u.length) === u : l.indexOf(u) > -1;
      },
      formatGroupLabel: function (e) {
        return e.label;
      },
      getOptionLabel: function (e) {
        return e.label;
      },
      getOptionValue: function (e) {
        return e.value;
      },
      isDisabled: !1,
      isLoading: !1,
      isMulti: !1,
      isRtl: !1,
      isSearchable: !0,
      isOptionDisabled: function (e) {
        return !!e.isDisabled;
      },
      loadingMessage: function () {
        return "Loading...";
      },
      maxMenuHeight: 300,
      minMenuHeight: 140,
      menuIsOpen: !1,
      menuPlacement: "bottom",
      menuPosition: "absolute",
      menuShouldBlockScroll: !1,
      menuShouldScrollIntoView: !function () {
        try {
          return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
          return !1;
        }
      }(),
      noOptionsMessage: function () {
        return "No options";
      },
      openMenuOnFocus: !1,
      openMenuOnClick: !0,
      options: [],
      pageSize: 5,
      placeholder: "Select...",
      screenReaderStatus: function (e) {
        var t = e.count;
        return "".concat(t, " result").concat(1 !== t ? "s" : "", " available");
      },
      styles: {},
      tabIndex: 0,
      tabSelectsValue: !0,
      unstyled: !1
    };

    function sye(e, t, r, n) {
      return {
        type: "option",
        data: t,
        isDisabled: mye(e, t, r),
        isSelected: vye(e, t, r),
        label: bye(e, t),
        value: yye(e, t),
        index: n
      };
    }

    function pye(e, t) {
      return e.options.map(function (r, n) {
        if ("options" in r) {
          var o = r.options.map(function (r, n) {
            return sye(e, r, t, n);
          }).filter(function (t) {
            return dye(e, t);
          });
          return o.length > 0 ? {
            type: "group",
            data: r,
            options: o,
            index: n
          } : void 0;
        }

        var i = sye(e, r, t, n);
        return dye(e, i) ? i : void 0;
      }).filter(Ude);
    }

    function fye(e) {
      return e.reduce(function (e, t) {
        return "group" === t.type ? e.push.apply(e, gpe(t.options.map(function (e) {
          return e.data;
        }))) : e.push(t.data), e;
      }, []);
    }

    function dye(e, t) {
      var r = e.inputValue,
          n = void 0 === r ? "" : r,
          o = t.data,
          i = t.isSelected,
          a = t.label,
          c = t.value;
      return (!gye(e) || !i) && hye(e, {
        label: a,
        value: c,
        data: o
      }, n);
    }

    var bye = function (e, t) {
      return e.getOptionLabel(t);
    },
        yye = function (e, t) {
      return e.getOptionValue(t);
    };

    function mye(e, t, r) {
      return "function" == typeof e.isOptionDisabled && e.isOptionDisabled(t, r);
    }

    function vye(e, t, r) {
      if (r.indexOf(t) > -1) return !0;
      if ("function" == typeof e.isOptionSelected) return e.isOptionSelected(t, r);
      var n = yye(e, t);
      return r.some(function (t) {
        return yye(e, t) === n;
      });
    }

    function hye(e, t, r) {
      return !e.filterOption || e.filterOption(t, r);
    }

    var gye = function (e) {
      var t = e.hideSelectedOptions,
          r = e.isMulti;
      return void 0 === t ? r : t;
    },
        wye = 1,
        Oye = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && fpe(e, t);
      }(i, s["Component"]);
      var t,
          r,
          n,
          o = mpe(i);

      function i(e) {
        var t;

        if (function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, i), (t = o.call(this, e)).state = {
          ariaSelection: null,
          focusedOption: null,
          focusedValue: null,
          inputIsHidden: !1,
          isFocused: !1,
          selectValue: [],
          clearFocusValueOnUpdate: !1,
          prevWasFocused: !1,
          inputIsHiddenAfterUpdate: void 0,
          prevProps: void 0
        }, t.blockOptionHover = !1, t.isComposing = !1, t.commonProps = void 0, t.initialTouchX = 0, t.initialTouchY = 0, t.instancePrefix = "", t.openAfterFocus = !1, t.scrollToFocusedOptionOnUpdate = !1, t.userIsDragging = void 0, t.controlRef = null, t.getControlRef = function (e) {
          t.controlRef = e;
        }, t.focusedOptionRef = null, t.getFocusedOptionRef = function (e) {
          t.focusedOptionRef = e;
        }, t.menuListRef = null, t.getMenuListRef = function (e) {
          t.menuListRef = e;
        }, t.inputRef = null, t.getInputRef = function (e) {
          t.inputRef = e;
        }, t.focus = t.focusInput, t.blur = t.blurInput, t.onChange = function (e, r) {
          var n = t.props,
              o = n.onChange,
              i = n.name;
          r.name = i, t.ariaOnChange(e, r), o(e, r);
        }, t.setValue = function (e, r, n) {
          var o = t.props,
              i = o.closeMenuOnSelect,
              a = o.isMulti,
              c = o.inputValue;
          t.onInputChange("", {
            action: "set-value",
            prevInputValue: c
          }), i && (t.setState({
            inputIsHiddenAfterUpdate: !a
          }), t.onMenuClose()), t.setState({
            clearFocusValueOnUpdate: !0
          }), t.onChange(e, {
            action: r,
            option: n
          });
        }, t.selectOption = function (e) {
          var r = t.props,
              n = r.blurInputOnSelect,
              o = r.isMulti,
              i = r.name,
              a = t.state.selectValue,
              c = o && t.isOptionSelected(e, a),
              u = t.isOptionDisabled(e, a);

          if (c) {
            var l = t.getOptionValue(e);
            t.setValue(Gde(a.filter(function (e) {
              return t.getOptionValue(e) !== l;
            })), "deselect-option", e);
          } else {
            if (u) return void t.ariaOnChange(Kde(e), {
              action: "select-option",
              option: e,
              name: i
            });
            o ? t.setValue(Gde([].concat(gpe(a), [e])), "select-option", e) : t.setValue(Kde(e), "select-option");
          }

          n && t.blurInput();
        }, t.removeValue = function (e) {
          var r = t.props.isMulti,
              n = t.state.selectValue,
              o = t.getOptionValue(e),
              i = n.filter(function (e) {
            return t.getOptionValue(e) !== o;
          }),
              a = qde(r, i, i[0] || null);
          t.onChange(a, {
            action: "remove-value",
            removedValue: e
          }), t.focusInput();
        }, t.clearValue = function () {
          var e = t.state.selectValue;
          t.onChange(qde(t.props.isMulti, [], null), {
            action: "clear",
            removedValues: e
          });
        }, t.popValue = function () {
          var e = t.props.isMulti,
              r = t.state.selectValue,
              n = r[r.length - 1],
              o = r.slice(0, r.length - 1),
              i = qde(e, o, o[0] || null);
          t.onChange(i, {
            action: "pop-value",
            removedValue: n
          });
        }, t.getValue = function () {
          return t.state.selectValue;
        }, t.cx = function () {
          for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++) r[n] = arguments[n];

          return kde.apply(void 0, [t.props.classNamePrefix].concat(r));
        }, t.getOptionLabel = function (e) {
          return bye(t.props, e);
        }, t.getOptionValue = function (e) {
          return yye(t.props, e);
        }, t.getStyles = function (e, r) {
          var n = t.props.unstyled,
              o = aye[e](r, n);
          o.boxSizing = "border-box";
          var i = t.props.styles[e];
          return i ? i(o, r) : o;
        }, t.getClassNames = function (e, r) {
          var n, o;
          return null === (n = (o = t.props.classNames)[e]) || void 0 === n ? void 0 : n.call(o, r);
        }, t.getElementId = function (e) {
          return "".concat(t.instancePrefix, "-").concat(e);
        }, t.getComponents = function () {
          return Sbe(t.props);
        }, t.buildCategorizedOptions = function () {
          return pye(t.props, t.state.selectValue);
        }, t.getCategorizedOptions = function () {
          return t.props.menuIsOpen ? t.buildCategorizedOptions() : [];
        }, t.buildFocusableOptions = function () {
          return fye(t.buildCategorizedOptions());
        }, t.getFocusableOptions = function () {
          return t.props.menuIsOpen ? t.buildFocusableOptions() : [];
        }, t.ariaOnChange = function (e, r) {
          t.setState({
            ariaSelection: spe({
              value: e
            }, r)
          });
        }, t.onMenuMouseDown = function (e) {
          0 === e.button && (e.stopPropagation(), e.preventDefault(), t.focusInput());
        }, t.onMenuMouseMove = function (e) {
          t.blockOptionHover = !1;
        }, t.onControlMouseDown = function (e) {
          if (!e.defaultPrevented) {
            var r = t.props.openMenuOnClick;
            t.state.isFocused ? t.props.menuIsOpen ? "INPUT" !== e.target.tagName && "TEXTAREA" !== e.target.tagName && t.onMenuClose() : r && t.openMenu("first") : (r && (t.openAfterFocus = !0), t.focusInput()), "INPUT" !== e.target.tagName && "TEXTAREA" !== e.target.tagName && e.preventDefault();
          }
        }, t.onDropdownIndicatorMouseDown = function (e) {
          if (!(e && "mousedown" === e.type && 0 !== e.button || t.props.isDisabled)) {
            var r = t.props,
                n = r.isMulti,
                o = r.menuIsOpen;
            t.focusInput(), o ? (t.setState({
              inputIsHiddenAfterUpdate: !n
            }), t.onMenuClose()) : t.openMenu("first"), e.preventDefault();
          }
        }, t.onClearIndicatorMouseDown = function (e) {
          e && "mousedown" === e.type && 0 !== e.button || (t.clearValue(), e.preventDefault(), t.openAfterFocus = !1, "touchend" === e.type ? t.focusInput() : setTimeout(function () {
            return t.focusInput();
          }));
        }, t.onScroll = function (e) {
          "boolean" == typeof t.props.closeMenuOnScroll ? e.target instanceof HTMLElement && Nde(e.target) && t.props.onMenuClose() : "function" == typeof t.props.closeMenuOnScroll && t.props.closeMenuOnScroll(e) && t.props.onMenuClose();
        }, t.onCompositionStart = function () {
          t.isComposing = !0;
        }, t.onCompositionEnd = function () {
          t.isComposing = !1;
        }, t.onTouchStart = function (e) {
          var r = e.touches,
              n = r && r.item(0);
          n && (t.initialTouchX = n.clientX, t.initialTouchY = n.clientY, t.userIsDragging = !1);
        }, t.onTouchMove = function (e) {
          var r = e.touches,
              n = r && r.item(0);

          if (n) {
            var o = Math.abs(n.clientX - t.initialTouchX),
                i = Math.abs(n.clientY - t.initialTouchY);
            t.userIsDragging = o > 5 || i > 5;
          }
        }, t.onTouchEnd = function (e) {
          t.userIsDragging || (t.controlRef && !t.controlRef.contains(e.target) && t.menuListRef && !t.menuListRef.contains(e.target) && t.blurInput(), t.initialTouchX = 0, t.initialTouchY = 0);
        }, t.onControlTouchEnd = function (e) {
          t.userIsDragging || t.onControlMouseDown(e);
        }, t.onClearIndicatorTouchEnd = function (e) {
          t.userIsDragging || t.onClearIndicatorMouseDown(e);
        }, t.onDropdownIndicatorTouchEnd = function (e) {
          t.userIsDragging || t.onDropdownIndicatorMouseDown(e);
        }, t.handleInputChange = function (e) {
          var r = t.props.inputValue,
              n = e.currentTarget.value;
          t.setState({
            inputIsHiddenAfterUpdate: !1
          }), t.onInputChange(n, {
            action: "input-change",
            prevInputValue: r
          }), t.props.menuIsOpen || t.onMenuOpen();
        }, t.onInputFocus = function (e) {
          t.props.onFocus && t.props.onFocus(e), t.setState({
            inputIsHiddenAfterUpdate: !1,
            isFocused: !0
          }), (t.openAfterFocus || t.props.openMenuOnFocus) && t.openMenu("first"), t.openAfterFocus = !1;
        }, t.onInputBlur = function (e) {
          var r = t.props.inputValue;
          t.menuListRef && t.menuListRef.contains(document.activeElement) ? t.inputRef.focus() : (t.props.onBlur && t.props.onBlur(e), t.onInputChange("", {
            action: "input-blur",
            prevInputValue: r
          }), t.onMenuClose(), t.setState({
            focusedValue: null,
            isFocused: !1
          }));
        }, t.onOptionHover = function (e) {
          t.blockOptionHover || t.state.focusedOption === e || t.setState({
            focusedOption: e
          });
        }, t.shouldHideSelectedOptions = function () {
          return gye(t.props);
        }, t.onValueInputFocus = function (e) {
          e.preventDefault(), e.stopPropagation(), t.focus();
        }, t.onKeyDown = function (e) {
          var r = t.props,
              n = r.isMulti,
              o = r.backspaceRemovesValue,
              i = r.escapeClearsValue,
              a = r.inputValue,
              c = r.isClearable,
              u = r.isDisabled,
              l = r.menuIsOpen,
              s = r.onKeyDown,
              p = r.tabSelectsValue,
              f = r.openMenuOnFocus,
              d = t.state,
              b = d.focusedOption,
              y = d.focusedValue,
              m = d.selectValue;

          if (!(u || "function" == typeof s && (s(e), e.defaultPrevented))) {
            switch (t.blockOptionHover = !0, e.key) {
              case "ArrowLeft":
                if (!n || a) return;
                t.focusValue("previous");
                break;

              case "ArrowRight":
                if (!n || a) return;
                t.focusValue("next");
                break;

              case "Delete":
              case "Backspace":
                if (a) return;
                if (y) t.removeValue(y);else {
                  if (!o) return;
                  n ? t.popValue() : c && t.clearValue();
                }
                break;

              case "Tab":
                if (t.isComposing) return;
                if (e.shiftKey || !l || !p || !b || f && t.isOptionSelected(b, m)) return;
                t.selectOption(b);
                break;

              case "Enter":
                if (229 === e.keyCode) break;

                if (l) {
                  if (!b) return;
                  if (t.isComposing) return;
                  t.selectOption(b);
                  break;
                }

                return;

              case "Escape":
                l ? (t.setState({
                  inputIsHiddenAfterUpdate: !1
                }), t.onInputChange("", {
                  action: "menu-close",
                  prevInputValue: a
                }), t.onMenuClose()) : c && i && t.clearValue();
                break;

              case " ":
                if (a) return;

                if (!l) {
                  t.openMenu("first");
                  break;
                }

                if (!b) return;
                t.selectOption(b);
                break;

              case "ArrowUp":
                l ? t.focusOption("up") : t.openMenu("last");
                break;

              case "ArrowDown":
                l ? t.focusOption("down") : t.openMenu("first");
                break;

              case "PageUp":
                if (!l) return;
                t.focusOption("pageup");
                break;

              case "PageDown":
                if (!l) return;
                t.focusOption("pagedown");
                break;

              case "Home":
                if (!l) return;
                t.focusOption("first");
                break;

              case "End":
                if (!l) return;
                t.focusOption("last");
                break;

              default:
                return;
            }

            e.preventDefault();
          }
        }, t.instancePrefix = "react-select-" + (t.props.instanceId || ++wye), t.state.selectValue = Rde(e.value), e.menuIsOpen && t.state.selectValue.length) {
          var r = t.buildFocusableOptions(),
              n = r.indexOf(t.state.selectValue[0]);
          t.state.focusedOption = r[n];
        }

        return t;
      }

      return t = i, n = [{
        key: "getDerivedStateFromProps",
        value: function (e, t) {
          var r = t.prevProps,
              n = t.clearFocusValueOnUpdate,
              o = t.inputIsHiddenAfterUpdate,
              i = t.ariaSelection,
              a = t.isFocused,
              c = t.prevWasFocused,
              u = e.options,
              l = e.value,
              s = e.menuIsOpen,
              p = e.inputValue,
              f = e.isMulti,
              d = Rde(l),
              b = {};

          if (r && (l !== r.value || u !== r.options || s !== r.menuIsOpen || p !== r.inputValue)) {
            var y = s ? function (e, t) {
              return fye(pye(e, t));
            }(e, d) : [],
                m = n ? function (e, t) {
              var r = e.focusedValue,
                  n = e.selectValue.indexOf(r);

              if (n > -1) {
                if (t.indexOf(r) > -1) return r;
                if (n < t.length) return t[n];
              }

              return null;
            }(t, d) : null;
            b = {
              selectValue: d,
              focusedOption: function (e, t) {
                var r = e.focusedOption;
                return r && t.indexOf(r) > -1 ? r : t[0];
              }(t, y),
              focusedValue: m,
              clearFocusValueOnUpdate: !1
            };
          }

          var v = null != o && e !== r ? {
            inputIsHidden: o,
            inputIsHiddenAfterUpdate: void 0
          } : {},
              h = i,
              g = a && c;
          return a && !g && (h = {
            value: qde(f, d, d[0] || null),
            options: d,
            action: "initial-input-focus"
          }, g = !c), "initial-input-focus" === (null == i ? void 0 : i.action) && (h = null), spe(spe(spe({}, b), v), {}, {
            prevProps: e,
            ariaSelection: h,
            prevWasFocused: g
          });
        }
      }], (r = [{
        key: "componentDidMount",
        value: function () {
          this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && Mde(this.menuListRef, this.focusedOptionRef);
        }
      }, {
        key: "componentDidUpdate",
        value: function (e) {
          var t = this.props,
              r = t.isDisabled,
              n = t.menuIsOpen,
              o = this.state.isFocused;
          (o && !r && e.isDisabled || o && n && !e.menuIsOpen) && this.focusInput(), o && r && !e.isDisabled ? this.setState({
            isFocused: !1
          }, this.onMenuClose) : o || r || !e.isDisabled || this.inputRef !== document.activeElement || this.setState({
            isFocused: !0
          }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (Mde(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
        }
      }, {
        key: "onMenuOpen",
        value: function () {
          this.props.onMenuOpen();
        }
      }, {
        key: "onMenuClose",
        value: function () {
          this.onInputChange("", {
            action: "menu-close",
            prevInputValue: this.props.inputValue
          }), this.props.onMenuClose();
        }
      }, {
        key: "onInputChange",
        value: function (e, t) {
          this.props.onInputChange(e, t);
        }
      }, {
        key: "focusInput",
        value: function () {
          this.inputRef && this.inputRef.focus();
        }
      }, {
        key: "blurInput",
        value: function () {
          this.inputRef && this.inputRef.blur();
        }
      }, {
        key: "openMenu",
        value: function (e) {
          var t = this,
              r = this.state,
              n = r.selectValue,
              o = r.isFocused,
              i = this.buildFocusableOptions(),
              a = "first" === e ? 0 : i.length - 1;

          if (!this.props.isMulti) {
            var c = i.indexOf(n[0]);
            c > -1 && (a = c);
          }

          this.scrollToFocusedOptionOnUpdate = !(o && this.menuListRef), this.setState({
            inputIsHiddenAfterUpdate: !1,
            focusedValue: null,
            focusedOption: i[a]
          }, function () {
            return t.onMenuOpen();
          });
        }
      }, {
        key: "focusValue",
        value: function (e) {
          var t = this.state,
              r = t.selectValue,
              n = t.focusedValue;

          if (this.props.isMulti) {
            this.setState({
              focusedOption: null
            });
            var o = r.indexOf(n);
            n || (o = -1);
            var i = r.length - 1,
                a = -1;

            if (r.length) {
              switch (e) {
                case "previous":
                  a = 0 === o ? 0 : -1 === o ? i : o - 1;
                  break;

                case "next":
                  o > -1 && o < i && (a = o + 1);
              }

              this.setState({
                inputIsHidden: -1 !== a,
                focusedValue: r[a]
              });
            }
          }
        }
      }, {
        key: "focusOption",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "first",
              t = this.props.pageSize,
              r = this.state.focusedOption,
              n = this.getFocusableOptions();

          if (n.length) {
            var o = 0,
                i = n.indexOf(r);
            r || (i = -1), "up" === e ? o = i > 0 ? i - 1 : n.length - 1 : "down" === e ? o = (i + 1) % n.length : "pageup" === e ? (o = i - t) < 0 && (o = 0) : "pagedown" === e ? (o = i + t) > n.length - 1 && (o = n.length - 1) : "last" === e && (o = n.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
              focusedOption: n[o],
              focusedValue: null
            });
          }
        }
      }, {
        key: "getTheme",
        value: function () {
          return this.props.theme ? "function" == typeof this.props.theme ? this.props.theme(uye) : spe(spe({}, uye), this.props.theme) : uye;
        }
      }, {
        key: "getCommonProps",
        value: function () {
          var e = this.clearValue,
              t = this.cx,
              r = this.getStyles,
              n = this.getClassNames,
              o = this.getValue,
              i = this.selectOption,
              a = this.setValue,
              c = this.props,
              u = c.isMulti,
              l = c.isRtl,
              s = c.options;
          return {
            clearValue: e,
            cx: t,
            getStyles: r,
            getClassNames: n,
            getValue: o,
            hasValue: this.hasValue(),
            isMulti: u,
            isRtl: l,
            options: s,
            selectOption: i,
            selectProps: c,
            setValue: a,
            theme: this.getTheme()
          };
        }
      }, {
        key: "hasValue",
        value: function () {
          return this.state.selectValue.length > 0;
        }
      }, {
        key: "hasOptions",
        value: function () {
          return !!this.getFocusableOptions().length;
        }
      }, {
        key: "isClearable",
        value: function () {
          var e = this.props,
              t = e.isClearable,
              r = e.isMulti;
          return void 0 === t ? r : t;
        }
      }, {
        key: "isOptionDisabled",
        value: function (e, t) {
          return mye(this.props, e, t);
        }
      }, {
        key: "isOptionSelected",
        value: function (e, t) {
          return vye(this.props, e, t);
        }
      }, {
        key: "filterOption",
        value: function (e, t) {
          return hye(this.props, e, t);
        }
      }, {
        key: "formatOptionLabel",
        value: function (e, t) {
          if ("function" == typeof this.props.formatOptionLabel) {
            var r = this.props.inputValue,
                n = this.state.selectValue;
            return this.props.formatOptionLabel(e, {
              context: t,
              inputValue: r,
              selectValue: n
            });
          }

          return this.getOptionLabel(e);
        }
      }, {
        key: "formatGroupLabel",
        value: function (e) {
          return this.props.formatGroupLabel(e);
        }
      }, {
        key: "startListeningComposition",
        value: function () {
          document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
        }
      }, {
        key: "stopListeningComposition",
        value: function () {
          document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
        }
      }, {
        key: "startListeningToTouch",
        value: function () {
          document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
        }
      }, {
        key: "stopListeningToTouch",
        value: function () {
          document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
        }
      }, {
        key: "renderInput",
        value: function () {
          var e = this.props,
              t = e.isDisabled,
              r = e.isSearchable,
              n = e.inputId,
              o = e.inputValue,
              i = e.tabIndex,
              a = e.form,
              c = e.menuIsOpen,
              u = e.required,
              l = this.getComponents().Input,
              p = this.state,
              f = p.inputIsHidden,
              d = p.ariaSelection,
              b = this.commonProps,
              y = n || this.getElementId("input"),
              m = spe(spe(spe({
            "aria-autocomplete": "list",
            "aria-expanded": c,
            "aria-haspopup": !0,
            "aria-errormessage": this.props["aria-errormessage"],
            "aria-invalid": this.props["aria-invalid"],
            "aria-label": this.props["aria-label"],
            "aria-labelledby": this.props["aria-labelledby"],
            "aria-required": u,
            role: "combobox"
          }, c && {
            "aria-controls": this.getElementId("listbox"),
            "aria-owns": this.getElementId("listbox")
          }), !r && {
            "aria-readonly": !0
          }), this.hasValue() ? "initial-input-focus" === (null == d ? void 0 : d.action) && {
            "aria-describedby": this.getElementId("live-region")
          } : {
            "aria-describedby": this.getElementId("placeholder")
          });
          return r ? s.createElement(l, cpe({}, b, {
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: y,
            innerRef: this.getInputRef,
            isDisabled: t,
            isHidden: f,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: i,
            form: a,
            type: "text",
            value: o
          }, m)) : s.createElement(Kbe, cpe({
            id: y,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: Sde,
            onFocus: this.onInputFocus,
            disabled: t,
            tabIndex: i,
            inputMode: "none",
            form: a,
            value: ""
          }, m));
        }
      }, {
        key: "renderPlaceholderOrValue",
        value: function () {
          var e = this,
              t = this.getComponents(),
              r = t.MultiValue,
              n = t.MultiValueContainer,
              o = t.MultiValueLabel,
              i = t.MultiValueRemove,
              a = t.SingleValue,
              c = t.Placeholder,
              u = this.commonProps,
              l = this.props,
              p = l.controlShouldRenderValue,
              f = l.isDisabled,
              d = l.isMulti,
              b = l.inputValue,
              y = l.placeholder,
              m = this.state,
              v = m.selectValue,
              h = m.focusedValue,
              g = m.isFocused;
          if (!this.hasValue() || !p) return b ? null : s.createElement(c, cpe({}, u, {
            key: "placeholder",
            isDisabled: f,
            isFocused: g,
            innerProps: {
              id: this.getElementId("placeholder")
            }
          }), y);
          if (d) return v.map(function (t, a) {
            var c = t === h,
                l = "".concat(e.getOptionLabel(t), "-").concat(e.getOptionValue(t));
            return s.createElement(r, cpe({}, u, {
              components: {
                Container: n,
                Label: o,
                Remove: i
              },
              isFocused: c,
              isDisabled: f,
              key: l,
              index: a,
              removeProps: {
                onClick: function () {
                  return e.removeValue(t);
                },
                onTouchEnd: function () {
                  return e.removeValue(t);
                },
                onMouseDown: function (e) {
                  e.preventDefault();
                }
              },
              data: t
            }), e.formatOptionLabel(t, "value"));
          });
          if (b) return null;
          var w = v[0];
          return s.createElement(a, cpe({}, u, {
            data: w,
            isDisabled: f
          }), this.formatOptionLabel(w, "value"));
        }
      }, {
        key: "renderClearIndicator",
        value: function () {
          var e = this.getComponents().ClearIndicator,
              t = this.commonProps,
              r = this.props,
              n = r.isDisabled,
              o = r.isLoading,
              i = this.state.isFocused;
          if (!this.isClearable() || !e || n || !this.hasValue() || o) return null;
          var a = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            "aria-hidden": "true"
          };
          return s.createElement(e, cpe({}, t, {
            innerProps: a,
            isFocused: i
          }));
        }
      }, {
        key: "renderLoadingIndicator",
        value: function () {
          var e = this.getComponents().LoadingIndicator,
              t = this.commonProps,
              r = this.props,
              n = r.isDisabled,
              o = r.isLoading,
              i = this.state.isFocused;
          if (!e || !o) return null;
          return s.createElement(e, cpe({}, t, {
            innerProps: {
              "aria-hidden": "true"
            },
            isDisabled: n,
            isFocused: i
          }));
        }
      }, {
        key: "renderIndicatorSeparator",
        value: function () {
          var e = this.getComponents(),
              t = e.DropdownIndicator,
              r = e.IndicatorSeparator;
          if (!t || !r) return null;
          var n = this.commonProps,
              o = this.props.isDisabled,
              i = this.state.isFocused;
          return s.createElement(r, cpe({}, n, {
            isDisabled: o,
            isFocused: i
          }));
        }
      }, {
        key: "renderDropdownIndicator",
        value: function () {
          var e = this.getComponents().DropdownIndicator;
          if (!e) return null;
          var t = this.commonProps,
              r = this.props.isDisabled,
              n = this.state.isFocused,
              o = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            "aria-hidden": "true"
          };
          return s.createElement(e, cpe({}, t, {
            innerProps: o,
            isDisabled: r,
            isFocused: n
          }));
        }
      }, {
        key: "renderMenu",
        value: function () {
          var e = this,
              t = this.getComponents(),
              r = t.Group,
              n = t.GroupHeading,
              o = t.Menu,
              i = t.MenuList,
              a = t.MenuPortal,
              c = t.LoadingMessage,
              u = t.NoOptionsMessage,
              l = t.Option,
              p = this.commonProps,
              f = this.state.focusedOption,
              d = this.props,
              b = d.captureMenuScroll,
              y = d.inputValue,
              m = d.isLoading,
              v = d.loadingMessage,
              h = d.minMenuHeight,
              g = d.maxMenuHeight,
              w = d.menuIsOpen,
              O = d.menuPlacement,
              j = d.menuPosition,
              P = d.menuPortalTarget,
              _ = d.menuShouldBlockScroll,
              E = d.menuShouldScrollIntoView,
              S = d.noOptionsMessage,
              C = d.onMenuScrollToTop,
              k = d.onMenuScrollToBottom;
          if (!w) return null;

          var R,
              T = function (t, r) {
            var n = t.type,
                o = t.data,
                i = t.isDisabled,
                a = t.isSelected,
                c = t.label,
                u = t.value,
                d = f === o,
                b = i ? void 0 : function () {
              return e.onOptionHover(o);
            },
                y = i ? void 0 : function () {
              return e.selectOption(o);
            },
                m = "".concat(e.getElementId("option"), "-").concat(r),
                v = {
              id: m,
              onClick: y,
              onMouseMove: b,
              onMouseOver: b,
              tabIndex: -1
            };
            return s.createElement(l, cpe({}, p, {
              innerProps: v,
              data: o,
              isDisabled: i,
              isSelected: a,
              key: m,
              label: c,
              type: n,
              value: u,
              isFocused: d,
              innerRef: d ? e.getFocusedOptionRef : void 0
            }), e.formatOptionLabel(t.data, "menu"));
          };

          if (this.hasOptions()) R = this.getCategorizedOptions().map(function (t) {
            if ("group" === t.type) {
              var o = t.data,
                  i = t.options,
                  a = t.index,
                  c = "".concat(e.getElementId("group"), "-").concat(a),
                  u = "".concat(c, "-heading");
              return s.createElement(r, cpe({}, p, {
                key: c,
                data: o,
                options: i,
                Heading: n,
                headingProps: {
                  id: u,
                  data: t.data
                },
                label: e.formatGroupLabel(t.data)
              }), t.options.map(function (e) {
                return T(e, "".concat(a, "-").concat(e.index));
              }));
            }

            if ("option" === t.type) return T(t, "".concat(t.index));
          });else if (m) {
            var z = v({
              inputValue: y
            });
            if (null === z) return null;
            R = s.createElement(c, p, z);
          } else {
            var N = S({
              inputValue: y
            });
            if (null === N) return null;
            R = s.createElement(u, p, N);
          }
          var D = {
            minMenuHeight: h,
            maxMenuHeight: g,
            menuPlacement: O,
            menuPosition: j,
            menuShouldScrollIntoView: E
          },
              x = s.createElement(Zde, cpe({}, p, D), function (t) {
            var r = t.ref,
                n = t.placerProps,
                a = n.placement,
                c = n.maxHeight;
            return s.createElement(o, cpe({}, p, D, {
              innerRef: r,
              innerProps: {
                onMouseDown: e.onMenuMouseDown,
                onMouseMove: e.onMenuMouseMove,
                id: e.getElementId("listbox")
              },
              isLoading: m,
              placement: a
            }), s.createElement(nye, {
              captureEnabled: b,
              onTopArrive: C,
              onBottomArrive: k,
              lockEnabled: _
            }, function (t) {
              return s.createElement(i, cpe({}, p, {
                innerRef: function (r) {
                  e.getMenuListRef(r), t(r);
                },
                isLoading: m,
                maxHeight: c,
                focusedOption: f
              }), R);
            }));
          });
          return P || "fixed" === j ? s.createElement(a, cpe({}, p, {
            appendTo: P,
            controlElement: this.controlRef,
            menuPlacement: O,
            menuPosition: j
          }), x) : x;
        }
      }, {
        key: "renderFormField",
        value: function () {
          var e = this,
              t = this.props,
              r = t.delimiter,
              n = t.isDisabled,
              o = t.isMulti,
              i = t.name,
              a = t.required,
              c = this.state.selectValue;
          if (a && !this.hasValue() && !n) return s.createElement(iye, {
            name: i,
            onFocus: this.onValueInputFocus
          });

          if (i && !n) {
            if (o) {
              if (r) {
                var u = c.map(function (t) {
                  return e.getOptionValue(t);
                }).join(r);
                return s.createElement("input", {
                  name: i,
                  type: "hidden",
                  value: u
                });
              }

              var l = c.length > 0 ? c.map(function (t, r) {
                return s.createElement("input", {
                  key: "i-".concat(r),
                  name: i,
                  type: "hidden",
                  value: e.getOptionValue(t)
                });
              }) : s.createElement("input", {
                name: i,
                type: "hidden",
                value: ""
              });
              return s.createElement("div", null, l);
            }

            var p = c[0] ? this.getOptionValue(c[0]) : "";
            return s.createElement("input", {
              name: i,
              type: "hidden",
              value: p
            });
          }
        }
      }, {
        key: "renderLiveRegion",
        value: function () {
          var e = this.commonProps,
              t = this.state,
              r = t.ariaSelection,
              n = t.focusedOption,
              o = t.focusedValue,
              i = t.isFocused,
              a = t.selectValue,
              c = this.getFocusableOptions();
          return s.createElement(Nbe, cpe({}, e, {
            id: this.getElementId("live-region"),
            ariaSelection: r,
            focusedOption: n,
            focusedValue: o,
            isFocused: i,
            selectValue: a,
            focusableOptions: c
          }));
        }
      }, {
        key: "render",
        value: function () {
          var e = this.getComponents(),
              t = e.Control,
              r = e.IndicatorsContainer,
              n = e.SelectContainer,
              o = e.ValueContainer,
              i = this.props,
              a = i.className,
              c = i.id,
              u = i.isDisabled,
              l = i.menuIsOpen,
              p = this.state.isFocused,
              f = this.commonProps = this.getCommonProps();
          return s.createElement(n, cpe({}, f, {
            className: a,
            innerProps: {
              id: c,
              onKeyDown: this.onKeyDown
            },
            isDisabled: u,
            isFocused: p
          }), this.renderLiveRegion(), s.createElement(t, cpe({}, f, {
            innerRef: this.getControlRef,
            innerProps: {
              onMouseDown: this.onControlMouseDown,
              onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: u,
            isFocused: p,
            menuIsOpen: l
          }), s.createElement(o, cpe({}, f, {
            isDisabled: u
          }), this.renderPlaceholderOrValue(), this.renderInput()), s.createElement(r, cpe({}, f, {
            isDisabled: u
          }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
      }]) && ppe(t.prototype, r), n && ppe(t, n), i;
    }();

    Oye.defaultProps = lye;
    var jye = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
    var Pye = ["defaultOptions", "cacheOptions", "loadOptions", "options", "isLoading", "onInputChange", "filterOption"];
    r(344), r(345), r(346), r(347), r(349), r(354), r(358), r(362), r(131), r(364), r(130);

    var _ye,
        Eye,
        Sye = Object(s.forwardRef)(function (e, t) {
      var r,
          n,
          o,
          i,
          a,
          c,
          u,
          l,
          p,
          f,
          d,
          b,
          y,
          m,
          v,
          h,
          g,
          w,
          O,
          j,
          P,
          _,
          E,
          S,
          C,
          k,
          R,
          T,
          z,
          N,
          D,
          x = function (e) {
        var t = e.defaultOptions,
            r = void 0 !== t && t,
            n = e.cacheOptions,
            o = void 0 !== n && n,
            i = e.loadOptions;
        e.options;
        var a = e.isLoading,
            c = void 0 !== a && a,
            u = e.onInputChange,
            l = e.filterOption,
            p = void 0 === l ? null : l,
            f = $fe(e, Pye),
            d = f.inputValue,
            b = Object(s.useRef)(void 0),
            y = Object(s.useRef)(!1),
            m = Qfe(Object(s.useState)(Array.isArray(r) ? r : void 0), 2),
            v = m[0],
            h = m[1],
            g = Qfe(Object(s.useState)(void 0 !== d ? d : ""), 2),
            w = g[0],
            O = g[1],
            j = Qfe(Object(s.useState)(!0 === r), 2),
            P = j[0],
            _ = j[1],
            E = Qfe(Object(s.useState)(void 0), 2),
            S = E[0],
            C = E[1],
            k = Qfe(Object(s.useState)([]), 2),
            R = k[0],
            T = k[1],
            z = Qfe(Object(s.useState)(!1), 2),
            N = z[0],
            D = z[1],
            x = Qfe(Object(s.useState)({}), 2),
            A = x[0],
            M = x[1],
            I = Qfe(Object(s.useState)(void 0), 2),
            F = I[0],
            B = I[1],
            L = Qfe(Object(s.useState)(void 0), 2),
            V = L[0],
            U = L[1];
        o !== V && (M({}), U(o)), r !== F && (h(Array.isArray(r) ? r : void 0), B(r)), Object(s.useEffect)(function () {
          return y.current = !0, function () {
            y.current = !1;
          };
        }, []);
        var q = Object(s.useCallback)(function (e, t) {
          if (!i) return t();
          var r = i(e, t);
          r && "function" == typeof r.then && r.then(t, function () {
            return t();
          });
        }, [i]);
        Object(s.useEffect)(function () {
          !0 === r && q(w, function (e) {
            y.current && (h(e || []), _(!!b.current));
          });
        }, []);
        var K = Object(s.useCallback)(function (e, t) {
          var r = function (e, t, r) {
            if (r) {
              var n = r(e, t);
              if ("string" == typeof n) return n;
            }

            return e;
          }(e, t, u);

          if (!r) return b.current = void 0, O(""), C(""), T([]), _(!1), void D(!1);
          if (o && A[r]) O(r), C(r), T(A[r]), _(!1), D(!1);else {
            var n = b.current = {};
            O(r), _(!0), D(!S), q(r, function (e) {
              y && n === b.current && (b.current = void 0, _(!1), C(r), T(e || []), D(!1), M(e ? spe(spe({}, A), {}, upe({}, r, e)) : A));
            });
          }
        }, [o, q, S, A, u]),
            G = N ? [] : w && S ? R : v || [];
        return spe(spe({}, f), {}, {
          options: G,
          isLoading: P || c,
          onInputChange: K,
          filterOption: p
        });
      }(e),
          A = (n = (r = x).defaultInputValue, o = void 0 === n ? "" : n, i = r.defaultMenuIsOpen, a = void 0 !== i && i, c = r.defaultValue, u = void 0 === c ? null : c, l = r.inputValue, p = r.menuIsOpen, f = r.onChange, d = r.onInputChange, b = r.onMenuClose, y = r.onMenuOpen, m = r.value, v = $fe(r, jye), h = Qfe(Object(s.useState)(void 0 !== l ? l : o), 2), g = h[0], w = h[1], O = Qfe(Object(s.useState)(void 0 !== p ? p : a), 2), j = O[0], P = O[1], _ = Qfe(Object(s.useState)(void 0 !== m ? m : u), 2), E = _[0], S = _[1], C = Object(s.useCallback)(function (e, t) {
        "function" == typeof f && f(e, t), S(e);
      }, [f]), k = Object(s.useCallback)(function (e, t) {
        var r;
        "function" == typeof d && (r = d(e, t)), w(void 0 !== r ? r : e);
      }, [d]), R = Object(s.useCallback)(function () {
        "function" == typeof y && y(), P(!0);
      }, [y]), T = Object(s.useCallback)(function () {
        "function" == typeof b && b(), P(!1);
      }, [b]), z = void 0 !== l ? l : g, N = void 0 !== p ? p : j, D = void 0 !== m ? m : E, spe(spe({}, v), {}, {
        inputValue: z,
        menuIsOpen: N,
        onChange: C,
        onInputChange: k,
        onMenuClose: T,
        onMenuOpen: R,
        value: D
      }));

      return s.createElement(Oye, cpe({
        ref: t
      }, A));
    });

    function Cye(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, kye(n.key), n);
      }
    }

    function kye(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Rye(e, t, r) {
      return t = Tye(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Tye(e).constructor) : t.apply(e, r));
    }

    function Tye(e) {
      return (Tye = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function zye(e, t) {
      return (zye = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Nye,
        Dye,
        xye = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((Eye = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Rye(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && zye(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "model",
        get: function () {
          var e = this.props.model;
          if (!e) throw new Error("SearchableMultiSelectFilter: Missing view model!");
          return e;
        }
      }, {
        key: "render",
        value: function () {
          return p.a.createElement(Sye, {
            isMulti: !0,
            cacheOptions: !0,
            defaultOptions: !0,
            value: this.model.value,
            onChange: this.model.onChange,
            loadOptions: this.model.loadOptions
          });
        }
      }]) && Cye(r.prototype, n), o && Cye(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "model", [f.computed], Object.getOwnPropertyDescriptor(Eye.prototype, "model"), Eye.prototype), _ye = Eye)) || _ye;

    function Aye(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Mye(n.key), n);
      }
    }

    function Mye(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Iye(e, t, r) {
      return t = Fye(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Fye(e).constructor) : t.apply(e, r));
    }

    function Fye(e) {
      return (Fye = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Bye(e, t) {
      return (Bye = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Lye(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Vye,
        Uye,
        qye,
        Kye = Object(d.observer)((Lye((Dye = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Iye(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Bye(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "columnFiltersModel",
        get: function () {
          return this.props.reportsManager.columnFiltersModel;
        }
      }, {
        key: "shouldDateSelect",
        get: function () {
          return this.columnFiltersModel.shouldDateSelect;
        }
      }, {
        key: "shouldMultiSelect",
        get: function () {
          return this.columnFiltersModel.shouldMultiSelect;
        }
      }, {
        key: "shouldMultiSelectWithSearch",
        get: function () {
          return this.columnFiltersModel.shouldMultiSelectWithSearch;
        }
      }, {
        key: "shouldAccountSelect",
        get: function () {
          return this.columnFiltersModel.shouldAccountSelect;
        }
      }, {
        key: "shouldFieldSelect",
        get: function () {
          return this.columnFiltersModel.shouldFieldSelect;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.id,
              r = e.reportsManager,
              n = e.treeModel;
          return p.a.createElement(h.ModalBody, null, this.shouldFieldSelect ? p.a.createElement(Sse, {
            reportsManager: r,
            baseId: t
          }) : this.shouldMultiSelectWithSearch && this.columnFiltersModel.isShowing ? p.a.createElement(xye, {
            model: this.columnFiltersModel.searchableMultiselectModel
          }) : this.shouldMultiSelect ? p.a.createElement(Hse, {
            reportsManager: r
          }) : this.shouldAccountSelect ? p.a.createElement(epe, {
            reportsManager: r,
            treeModel: n
          }) : this.shouldDateSelect ? p.a.createElement(ape, {
            reportsManager: r
          }) : p.a.createElement(dse, {
            reportsManager: r
          }));
        }
      }]) && Aye(r.prototype, n), o && Aye(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "columnFiltersModel", [f.computed], Object.getOwnPropertyDescriptor(Dye.prototype, "columnFiltersModel"), Dye.prototype), Lye(Dye.prototype, "shouldDateSelect", [f.computed], Object.getOwnPropertyDescriptor(Dye.prototype, "shouldDateSelect"), Dye.prototype), Lye(Dye.prototype, "shouldMultiSelect", [f.computed], Object.getOwnPropertyDescriptor(Dye.prototype, "shouldMultiSelect"), Dye.prototype), Lye(Dye.prototype, "shouldMultiSelectWithSearch", [f.computed], Object.getOwnPropertyDescriptor(Dye.prototype, "shouldMultiSelectWithSearch"), Dye.prototype), Lye(Dye.prototype, "shouldAccountSelect", [f.computed], Object.getOwnPropertyDescriptor(Dye.prototype, "shouldAccountSelect"), Dye.prototype), Lye(Dye.prototype, "shouldFieldSelect", [f.computed], Object.getOwnPropertyDescriptor(Dye.prototype, "shouldFieldSelect"), Dye.prototype), Nye = Dye)) || Nye;

    function Gye(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Wye(n.key), n);
      }
    }

    function Wye(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Hye(e, t, r) {
      return t = Jye(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Jye(e).constructor) : t.apply(e, r));
    }

    function Jye(e) {
      return (Jye = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Yye(e, t) {
      return (Yye = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Qye(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var $ye,
        Xye,
        Zye,
        eme = Object(d.observer)((Qye((Uye = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = Hye(this, t, [].concat(n)), "onApply", qye, e), e.onCancel = function () {
          (0, e.props.onClose)();
        }, e.onClear = function () {
          var t = e.props,
              r = t.onClose,
              n = t.reportsManager;
          n.columnFiltersModel.removeFilter(e.columnSpec.id), n.requery(), r();
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Yye(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Gye(e.prototype, t), r && Gye(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "columnFiltersModel",
        get: function () {
          return this.props.reportsManager.columnFiltersModel;
        }
      }, {
        key: "columnSpec",
        get: function () {
          return this.columnFiltersModel.currentColumnSpec;
        }
      }, {
        key: "shouldDateSelect",
        get: function () {
          return this.columnFiltersModel.shouldDateSelect;
        }
      }, {
        key: "shouldMultiSelect",
        get: function () {
          return this.columnFiltersModel.shouldMultiSelect;
        }
      }, {
        key: "shouldAccountSelect",
        get: function () {
          return this.columnFiltersModel.shouldAccountSelect;
        }
      }, {
        key: "isFilteringFields",
        get: function () {
          return this.columnFiltersModel.shouldFieldSelect;
        }
      }, {
        key: "shouldFieldSelect",
        get: function () {
          return this.columnFiltersModel.filterSpecificFields && this.isFilteringFields && this.hasReportItems;
        }
      }, {
        key: "hasReportItems",
        get: function () {
          var e = this.props.reportsManager;
          return Boolean(e.recordItems.length);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return p.a.createElement(h.ModalFooter, null, p.a.createElement("button", {
            type: "button",
            className: "report-filter-modal-apply",
            onClick: this.onApply
          }, e("apply_filter")), p.a.createElement("button", {
            type: "button",
            className: "report-filter-modal-cancel",
            onClick: this.onCancel
          }, e("cancel")), p.a.createElement("button", {
            type: "button",
            className: "report-filter-modal-clear",
            onClick: this.onClear
          }, e("clear_filters")));
        }
      }]);
    }()).prototype, "columnFiltersModel", [f.computed], Object.getOwnPropertyDescriptor(Uye.prototype, "columnFiltersModel"), Uye.prototype), Qye(Uye.prototype, "columnSpec", [f.computed], Object.getOwnPropertyDescriptor(Uye.prototype, "columnSpec"), Uye.prototype), Qye(Uye.prototype, "shouldDateSelect", [f.computed], Object.getOwnPropertyDescriptor(Uye.prototype, "shouldDateSelect"), Uye.prototype), Qye(Uye.prototype, "shouldMultiSelect", [f.computed], Object.getOwnPropertyDescriptor(Uye.prototype, "shouldMultiSelect"), Uye.prototype), Qye(Uye.prototype, "shouldAccountSelect", [f.computed], Object.getOwnPropertyDescriptor(Uye.prototype, "shouldAccountSelect"), Uye.prototype), Qye(Uye.prototype, "isFilteringFields", [f.computed], Object.getOwnPropertyDescriptor(Uye.prototype, "isFilteringFields"), Uye.prototype), Qye(Uye.prototype, "shouldFieldSelect", [f.computed], Object.getOwnPropertyDescriptor(Uye.prototype, "shouldFieldSelect"), Uye.prototype), Qye(Uye.prototype, "hasReportItems", [f.computed], Object.getOwnPropertyDescriptor(Uye.prototype, "hasReportItems"), Uye.prototype), qye = Qye(Uye.prototype, "onApply", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.onClose,
              n = t.reportsManager;
          n.columnFiltersModel.applyFilter(e.columnSpec, {
            selectedAccountIds: n.treeModel.checked,
            matchMethod: n.matchModel.selectedOption.value,
            searchText: n.filterSearchText
          }), n.requery(), r();
        };
      }
    }), Vye = Uye)) || Vye,
        tme = Object(g.a)()(eme);

    function rme(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, nme(n.key), n);
      }
    }

    function nme(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ome(e, t, r) {
      return t = ime(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ime(e).constructor) : t.apply(e, r));
    }

    function ime(e) {
      return (ime = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ame(e, t) {
      return (ame = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var cme,
        ume,
        lme,
        sme,
        pme,
        fme,
        dme = Object(d.observer)((Zye = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((Xye = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = ome(this, t, [e]), "close", Zye, r);
        var n = r.props,
            o = n.reportsManager,
            i = n.readOnlyAncestors;
        return r.treeModel = new as(o.accountsStore), r.treeModel.setRoots(o.columnFiltersModel.currentFilterAccountChoices, (i || []).map(function (e) {
          return o.accountsStore.push(e);
        })), r.treeModel.sortRoots(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ame(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.id,
              r = e.title,
              n = e.reportsManager;
          return p.a.createElement(h.ModalDialog, {
            id: t,
            dismissOnClose: !1,
            className: "if2-modal report-column-filter-modal",
            dialogClassNames: "modal-md",
            ariaLabelledBy: "".concat(t, "-header"),
            resizable: !0
          }, p.a.createElement(h.ModalHeader, {
            id: "".concat(t, "-header"),
            title: r
          }), p.a.createElement(Kye, {
            id: t,
            reportsManager: n,
            treeModel: this.treeModel
          }), p.a.createElement(tme, {
            reportsManager: n,
            onClose: this.close
          }));
        }
      }]) && rme(r.prototype, n), o && rme(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "close", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.id,
              n = t.reportsManager;
          v()("#".concat(r)).modal("hide"), n.columnFiltersModel.setCurrentFilters([]);
        };
      }
    }), $ye = Xye)) || $ye;

    function bme(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function yme(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, mme(n.key), n);
      }
    }

    function mme(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function vme(e, t, r) {
      return t = hme(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], hme(e).constructor) : t.apply(e, r));
    }

    function hme(e) {
      return (hme = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function gme(e, t) {
      return (gme = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function wme(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Ome,
        jme,
        Pme,
        _me = Object(d.observer)((lme = wme((ume = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return bme(e = vme(this, t, [].concat(n)), "removeFilter", lme, e), bme(e, "editFilter", sme, e), bme(e, "hideColumn", pme, e), bme(e, "showColumn", fme, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && gme(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "componentWillUnmount",
        value: function () {
          this.props.model.dispose();
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props.model;
          return p.a.createElement("tr", null, p.a.createElement("td", null, p.a.createElement("a", {
            href: "#",
            "data-toggle": "tooltip",
            title: t.namePath
          }, t.name)), p.a.createElement("td", null, t.filterOnValue), p.a.createElement("td", null, p.a.createElement("div", {
            className: "filter-buttons"
          }, p.a.createElement("a", {
            href: "#",
            onClick: function () {
              e.editFilter();
            },
            "aria-label": "Edit"
          }, p.a.createElement("i", {
            className: "fas fa-edit"
          })), t.isVisible ? p.a.createElement("a", {
            href: "#",
            "data-toggle": "tooltip",
            title: "visible",
            onClick: function () {
              e.hideColumn();
            },
            "aria-label": "Visible"
          }, p.a.createElement("i", {
            className: "fas fa-eye"
          })) : p.a.createElement("a", {
            href: "#",
            "data-toggle": "tooltip",
            title: "hidden",
            onClick: function () {
              e.showColumn();
            },
            "aria-label": "Hidden"
          }, p.a.createElement("i", {
            className: "fas fa-eye-slash"
          })), p.a.createElement("a", {
            href: "#",
            onClick: function () {
              e.removeFilter(t.filter);
            },
            "aria-label": "Remove"
          }, p.a.createElement("i", {
            className: "fas fa-times"
          })))));
        }
      }]) && yme(r.prototype, n), o && yme(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "removeFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          (0, e.props.onRemoveFilter)(t.key);
        };
      }
    }), sme = wme(ume.prototype, "editFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.reportsManager,
              n = t.onClose,
              o = t.model;
          r.openFilterModal(o.columnSpec), n(), setTimeout(function () {
            v()("#".concat(r.filterModalId)).modal("show");
          }, 500);
        };
      }
    }), pme = wme(ume.prototype, "hideColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.props.model.setVisibility(!1);
        };
      }
    }), fme = wme(ume.prototype, "showColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.props.model.setVisibility(!0);
        };
      }
    }), cme = ume)) || cme;

    function Eme(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Sme(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Eme(Object(r), !0).forEach(function (t) {
          Cme(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Eme(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Cme(e, t, r) {
      return (t = Tme(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function kme(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Rme(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Tme(n.key), n);
      }
    }

    function Tme(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function zme(e, t, r) {
      return t = Mme(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Mme(e).constructor) : t.apply(e, r));
    }

    function Nme(e, t) {
      return (Nme = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Dme(e, t, r, n) {
      var o = xme(Mme(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function xme() {
      return (xme = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Ame(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Ame(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = Mme(e)););

      return e;
    }

    function Mme(e) {
      return (Mme = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Ime(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Fme,
        Bme,
        Lme,
        Vme,
        Ume = (jme = Ime((Ome = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), kme(r = zme(this, t, [e]), "path", jme, r), kme(r, "attribute", Pme, r), r.path = e.path || [], r.attribute = e.attribute || {}, r.pathString = r.path.join("/"), r.id = r.pathString, r.defaultAccessorPath = r.attribute.modelClass ? r.path.concat(r.attribute.modelClass.spec.defaultAccessor.path) : r.path, r.t = e.t, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Nme(e, t);
      }(t, Uce), r = t, o = [{
        key: "isReportColumnSpec",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(t.prototype, e);
        }
      }, {
        key: "requiredProps",
        value: function () {
          return Dme(t, "requiredProps", this, 2)([]).concat(["attribute", "path"]);
        }
      }, {
        key: "type",
        value: function () {
          return "ReportColumnSpec";
        }
      }], (n = [{
        key: "defaultName",
        value: function () {
          return this.t("report_attributes.".concat(this.attribute.jsKey || w.UpdatableBase.toSnakeCase(this.attribute.key)));
        }
      }, {
        key: "display",
        value: function (e) {
          var t = Object(x.path)(this.defaultAccessorPath, e);
          return null == t ? "" : "".concat(t);
        }
      }, {
        key: "toJS",
        value: function () {
          return Sme(Sme({}, Dme(t, "toJS", this, 3)([])), {}, {
            path: this.pathString
          });
        }
      }]) && Rme(r.prototype, n), o && Rme(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "path", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), Pme = Ime(Ome.prototype, "attribute", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return {};
      }
    }), Ome);

    function qme(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (null != r) {
          var n,
              o,
              i,
              a,
              c = [],
              u = !0,
              l = !1;

          try {
            if (i = (r = r.call(e)).next, 0 === t) {
              if (Object(r) !== r) return;
              u = !1;
            } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== t); u = !0);
          } catch (e) {
            l = !0, o = e;
          } finally {
            try {
              if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
            } finally {
              if (l) throw o;
            }
          }

          return c;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return Kme(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Kme(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function Kme(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function Gme(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Wme(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Hme(n.key), n);
      }
    }

    function Hme(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Jme(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Yme,
        Qme,
        $me,
        Xme,
        Zme,
        eve,
        tve,
        rve,
        nve,
        ove,
        ive,
        ave = (Bme = Jme((Fme = function () {
      return e = function e(t, r) {
        var n = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Gme(this, "isVisible", Bme, this), this.dispose = function () {
          n.visibilityDisposer();
        }, Gme(this, "setVisibility", Lme, this), Gme(this, "resetColumnVisibility", Vme, this), this.updateColumnVisibility = function () {
          n.isVisible ? n.reportsManager.addColumnAtPosition(n.columnSpec, n.columnSpec.position) : n.reportsManager.removeColumn(n.columnSpec);
        }, this.filter = t, this.reportsManager = r, this.visibilityDisposer = Object(f.autorun)(function () {
          n.isVisible = n.columnSpec.isShowing;
        });
      }, (t = [{
        key: "key",
        get: function () {
          return this.filter.key;
        }
      }, {
        key: "columnSpec",
        get: function () {
          return this.filter.columnSpec;
        }
      }, {
        key: "namePath",
        get: function () {
          var e = this;
          if (!Ume.isReportColumnSpec(this.columnSpec)) return this.columnSpec.getName();
          var t = [],
              r = "";
          return this.key.split("").forEach(function (e) {
            "/" === e && t.push(r), r += e;
          }), t.push(this.key), t.map(function (t) {
            var r = e.reportsManager.findColumn(t);
            if (r && r.attribute) return r.attribute.name;
          }).filter(Boolean).join(" > ");
        }
      }, {
        key: "name",
        get: function () {
          return this.columnSpec.getName() || "";
        }
      }, {
        key: "filterOnValue",
        get: function () {
          var e = this;
          return this.filter.isArray ? p.a.createElement("ul", null, this.filter.value.map(function (t) {
            return [e.handleDisplayValue(t), t];
          }).filter(function (e) {
            var t = qme(e, 1)[0];
            return Boolean(t);
          }).map(function (e) {
            var t = qme(e, 2),
                r = t[0],
                n = t[1];
            return p.a.createElement("li", {
              key: (null == n ? void 0 : n.value) || n
            }, r);
          })) : this.handleDisplayValue(this.filter.value);
        }
      }, {
        key: "handleDisplayValue",
        value: function (e) {
          var t,
              r = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
          if (!1 === e) return "false";
          if (!0 === e) return "true";
          if (!e && 0 !== e) return "(blank)";
          if (Due.isCalculationColumnSpec(this.columnSpec)) return e;
          if ("date" === this.columnSpec.attribute.filterType) return e.customSelected ? [].concat(M()(e.startDate).format("MM/DD/YYYY") || []).concat(M()(e.endDate).format("MM/DD/YYYY") || []).join(" - ") : (null === (t = e.selector) || void 0 === t || null === (t = t.selectedOption) || void 0 === t ? void 0 : t.text) || "";

          if ("account" === this.columnSpec.attribute.key && "string" == typeof e && e.match(r)) {
            var n = this.reportsManager.accountsStore.find(e);
            if (!n) return;
            return n.clientPathString;
          }

          if ("fieldSelect" === this.columnSpec.attribute.filterType && "string" == typeof e && e.match(r)) {
            var o = this.reportsManager.columnFiltersModel.fieldOptions.find(function (t) {
              return t.field.id === e;
            });
            if (!o) return;
            return this.reportsManager.fieldNameWithClientPath(o);
          }

          return "searchableMultiSelect" === this.columnSpec.attribute.filterType ? e.label : e;
        }
      }]) && Wme(e.prototype, t), r && Wme(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "isVisible", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Jme(Fme.prototype, "key", [f.computed], Object.getOwnPropertyDescriptor(Fme.prototype, "key"), Fme.prototype), Jme(Fme.prototype, "columnSpec", [f.computed], Object.getOwnPropertyDescriptor(Fme.prototype, "columnSpec"), Fme.prototype), Jme(Fme.prototype, "namePath", [f.computed], Object.getOwnPropertyDescriptor(Fme.prototype, "namePath"), Fme.prototype), Jme(Fme.prototype, "name", [f.computed], Object.getOwnPropertyDescriptor(Fme.prototype, "name"), Fme.prototype), Jme(Fme.prototype, "filterOnValue", [f.computed], Object.getOwnPropertyDescriptor(Fme.prototype, "filterOnValue"), Fme.prototype), Lme = Jme(Fme.prototype, "setVisibility", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.isVisible = t;
        };
      }
    }), Vme = Jme(Fme.prototype, "resetColumnVisibility", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isVisible = e.columnSpec.isShowing;
        };
      }
    }), Fme);

    function cve(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function uve(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? cve(Object(r), !0).forEach(function (t) {
          lve(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : cve(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function lve(e, t, r) {
      return (t = fve(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function sve(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function pve(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, fve(n.key), n);
      }
    }

    function fve(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function dve(e, t, r) {
      return t = bve(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], bve(e).constructor) : t.apply(e, r));
    }

    function bve(e) {
      return (bve = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function yve(e, t) {
      return (yve = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function mve(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var vve,
        hve = Object(d.observer)(($me = mve((Qme = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return sve(e = dve(this, t, [].concat(n)), "filters", $me, e), sve(e, "shouldRequery", Xme, e), sve(e, "close", Zme, e), sve(e, "updateColumnVisibility", eve, e), sve(e, "resetColumnVisibility", tve, e), sve(e, "onApply", rve, e), sve(e, "onClearAll", nve, e), sve(e, "onCancel", ove, e), sve(e, "onRemoveFilter", ive, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && yve(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && pve(e.prototype, t), r && pve(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "sortedFilters",
        get: function () {
          var e = this,
              t = this.props.reportsManager;
          return Object.keys(this.filters).slice().sort(h.naturalSort).map(function (r) {
            return new ave(e.filters[r], t);
          });
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = this;
          this.filtersDisposer = Object(f.autorun)(function () {
            var t = e.props.reportsManager;
            e.filters = uve({}, t.columnFiltersModel.columnFilters);
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.filtersDisposer();
        }
      }, {
        key: "requery",
        value: function () {
          this.props.reportsManager.requery(), this.shouldRequery = !1;
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.title,
              n = t.id,
              o = t.reportsManager,
              i = t.t;
          return p.a.createElement(h.ModalDialog, {
            id: n,
            dismissOnClose: !1,
            className: "if2-modal report-column-filter-summary-modal",
            dialogClassNames: "modal-md",
            ariaLabelledBy: "".concat(n, "-header")
          }, p.a.createElement(h.ModalHeader, {
            id: "".concat(n, "-header"),
            title: r,
            onClose: this.onCancel
          }), p.a.createElement(h.ModalBody, null, p.a.createElement("div", {
            className: "filters-table"
          }, p.a.createElement("table", {
            className: "table"
          }, p.a.createElement("thead", null), p.a.createElement("tbody", null, this.sortedFilters.map(function (t) {
            return p.a.createElement(_me, {
              key: t.key,
              model: t,
              reportsManager: o,
              onClose: e.close,
              onRemoveFilter: e.onRemoveFilter
            });
          }))))), p.a.createElement(h.ModalFooter, null, p.a.createElement("button", {
            type: "button",
            className: "report-filter-modal-apply",
            onClick: this.onApply
          }, i("apply")), p.a.createElement("button", {
            type: "button",
            className: "report-filter-modal-cancel",
            onClick: this.onCancel
          }, i("cancel")), p.a.createElement("button", {
            type: "button",
            className: "report-filter-modal-clear",
            onClick: this.onClearAll
          }, i("clear_filters"))));
        }
      }]);
    }()).prototype, "filters", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return {};
      }
    }), Xme = mve(Qme.prototype, "shouldRequery", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), mve(Qme.prototype, "sortedFilters", [f.computed], Object.getOwnPropertyDescriptor(Qme.prototype, "sortedFilters"), Qme.prototype), Zme = mve(Qme.prototype, "close", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.reportsManager;
          v()("#".concat(t.filterSummaryModalId)).modal("hide"), e.resetColumnVisibility(), e.shouldRequery = !1;
        };
      }
    }), eve = mve(Qme.prototype, "updateColumnVisibility", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.sortedFilters.forEach(function (e) {
            return e.updateColumnVisibility();
          });
        };
      }
    }), tve = mve(Qme.prototype, "resetColumnVisibility", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.sortedFilters.forEach(function (e) {
            return e.resetColumnVisibility();
          });
        };
      }
    }), mve(Qme.prototype, "requery", [f.action], Object.getOwnPropertyDescriptor(Qme.prototype, "requery"), Qme.prototype), rve = mve(Qme.prototype, "onApply", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.props.reportsManager.columnFiltersModel.applyColumnFilters(e.filters), e.updateColumnVisibility(), e.shouldRequery && e.requery(), e.close();
        };
      }
    }), nve = mve(Qme.prototype, "onClearAll", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.props.reportsManager.columnFiltersModel.removeAllFilters(), e.requery(), e.close();
        };
      }
    }), ove = mve(Qme.prototype, "onCancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.reportsManager;
          e.filters = uve({}, t.columnFiltersModel.columnFilters), e.close();
        };
      }
    }), ive = mve(Qme.prototype, "onRemoveFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          delete e.filters[t], e.shouldRequery = !0;
        };
      }
    }), Yme = Qme)) || Yme,
        gve = Object(g.a)()(hve);

    function wve(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ove(n.key), n);
      }
    }

    function Ove(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function jve(e, t, r) {
      return t = Pve(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Pve(e).constructor) : t.apply(e, r));
    }

    function Pve(e) {
      return (Pve = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function _ve(e, t) {
      return (_ve = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Eve = Object(d.observer)(vve = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), jve(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && _ve(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.reportsManager,
              r = e.reportItemsStore;
          return p.a.createElement("div", {
            className: "progress-bar-container"
          }, r.isPending ? p.a.createElement(Gne, {
            valueNow: r.progress
          }) : null, t.isDownloading ? p.a.createElement(Gne, {
            valueNow: t.downloadProgress
          }) : null);
        }
      }]) && wve(r.prototype, n), o && wve(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || vve;

    function Sve(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Cve(n.key), n);
      }
    }

    function Cve(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var kve = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.key = t.key, this.columnSpec = t.columnSpec, this.displayValue = this.constructor.displayValue(this.columnSpec, t.rowData), this.errors = this.constructor.errors(this.columnSpec, t.rowData);
      }, r = [{
        key: "displayValue",
        value: function (e, t) {
          return e.display(t);
        }
      }, {
        key: "errors",
        value: function (e, t) {
          return e.errors(t);
        }
      }], (t = null) && Sve(e.prototype, t), r && Sve(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function Rve(e, t, r) {
      return t = Dve(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, zve() ? Reflect.construct(t, r || [], Dve(e).constructor) : t.apply(e, r));
    }

    function Tve(e) {
      var t = "function" == typeof Map ? new Map() : void 0;
      return (Tve = function (e) {
        if (null === e || !function (e) {
          try {
            return -1 !== Function.toString.call(e).indexOf("[native code]");
          } catch (t) {
            return "function" == typeof e;
          }
        }(e)) return e;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, r);
        }

        function r() {
          return function (e, t, r) {
            if (zve()) return Reflect.construct.apply(null, arguments);
            var n = [null];
            n.push.apply(n, t);
            var o = new (e.bind.apply(e, n))();
            return r && Nve(o, r.prototype), o;
          }(e, arguments, Dve(this).constructor);
        }

        return r.prototype = Object.create(e.prototype, {
          constructor: {
            value: r,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), Nve(r, e);
      })(e);
    }

    function zve() {
      try {
        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch (e) {}

      return (zve = function () {
        return !!e;
      })();
    }

    function Nve(e, t) {
      return (Nve = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Dve(e) {
      return (Dve = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function xve(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Ave(e, t, r) {
      return (t = Bve(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Mve(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Ive(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Bve(n.key), n);
      }
    }

    function Fve(e, t, r) {
      return t && Ive(e.prototype, t), r && Ive(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function Bve(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var Lve = function () {
      function e(t) {
        Mve(this, e);
        var r = this.constructor.validateProps(t),
            n = r.columnSpecs,
            o = r.rowData,
            i = r.level;
        this.key = o._rowId, this.rowData = o, this.cells = n.map(function (e) {
          return new kve({
            key: "".concat(o._rowId, "-").concat(e.id),
            columnSpec: e,
            rowData: o
          });
        }), this.level = i || 0, this.reportItem = t.reportItem;
      }

      return Fve(e, [{
        key: "getSubrecord",
        value: function (e) {
          return this.constructor.getSubrecord(e, this);
        }
      }], [{
        key: "getSubrecord",
        value: function (e, t) {
          return Object(x.path)(this.getSubrecordPath(e, t))(t.reportItem);
        }
      }, {
        key: "getSubrecordPath",
        value: function (e, t) {
          return e.path.reduce(function (r, n, o) {
            var i = e.path.slice(0, o + 1),
                a = r.concat(n),
                c = Object(x.path)(a)(t.reportItem);
            return Array.isArray(c) && (a = a.concat(c.findIndex(function (e) {
              return e.id === Object(x.path)(i)(t.rowData).id;
            }))), a;
          }, []);
        }
      }, {
        key: "renderPrefixCellsToCsvString",
        value: function (e) {
          return [].concat(e.level && e.level > 0 ? Object(x.repeat)(JSON.stringify(""), e.level) : []).join(",");
        }
      }, {
        key: "renderToCsvString",
        value: function (e) {
          return [].concat(this.renderPrefixCellsToCsvString(e) || []).concat(e.cells.map(function (e) {
            var t;
            return '"'.concat(null === (t = e.displayValue) || void 0 === t ? void 0 : t.replace(/"/g, '""'), '"');
          })).join(",");
        }
      }, {
        key: "sort",
        value: function (e, t) {
          var r = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {};
              t % 2 ? xve(Object(r), !0).forEach(function (t) {
                Ave(e, t, r[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xve(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
            }

            return e;
          }({}, t || {}),
              n = r.sortDescending,
              o = r.accessor,
              i = r.customSort;

          if (!o) return e;
          var a = i || (n ? ie : h.naturalSort),
              c = Object(x.useWith)(a, [o, o]);
          return Object(x.sort)(c, e);
        }
      }, {
        key: "validateProps",
        value: function (t) {
          if (!t) throw new e.MissingPropsError();
          var r = t.columnSpecs,
              n = t.rowData,
              o = [];
          if (r || o.push("columnSpecs"), n || o.push("rowData"), o.length > 0) throw new e.MissingPropsError(o);
          return t;
        }
      }]);
    }();

    function Vve(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Uve(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Vve(Object(r), !0).forEach(function (t) {
          qve(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Vve(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function qve(e, t, r) {
      return (t = Gve(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Kve(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Gve(n.key), n);
      }
    }

    function Gve(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    Lve.MissingPropsError = function (e) {
      function t(e) {
        var r;
        Mve(this, t);

        for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) o[i - 1] = arguments[i];

        return (r = Rve(this, t, [["Missing prop".concat(e && 1 === e.length ? "" : "s")].concat(e && e.map(function (e) {
          return '"'.concat(e, '"');
        }).join(", ") || []).join(": ")].concat(o))).name = r.constructor.name, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Nve(e, t);
      }(t, Tve(Error)), Fve(t);
    }();

    var Wve,
        Hve,
        Jve = function () {
      function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e);
        var r = t.key,
            n = t.columnSpec,
            o = t.displayValue,
            i = t.level,
            a = t.children;
        this.isGroup = !0, this.key = r, this.columnSpec = n, this.displayValue = o, this.children = a, this.level = i || 0;
      }

      return t = e, n = [{
        key: "computeGroups",
        value: function (t, r, n) {
          var o = this;

          if (!(r.length < 1)) {
            var i = Uve({
              level: 0
            }, n || {}),
                a = i.level,
                c = i.sortConfig,
                u = r.slice(),
                l = u.shift(),
                s = this.groupBySpec(l, t),
                p = Object.keys(s).map(function (t) {
              var r = s[t],
                  i = o.displayValueForGroup(t, l, r),
                  c = r.map(function (e) {
                return new Lve({
                  columnSpecs: e.cells.map(function (e) {
                    return e.columnSpec;
                  }).filter(function (e) {
                    return e.id !== l.id;
                  }),
                  rowData: e.rowData,
                  level: a + 1,
                  reportItem: e.reportItem
                });
              }),
                  p = u.length > 0 ? o.computeGroups(c, u, Uve(Uve({}, n || {}), {}, {
                level: a + 1
              })) : c;
              return new e({
                key: t,
                columnSpec: l,
                displayValue: i,
                level: a,
                children: p
              });
            });
            return c ? this.sort(p, {
              sortDescending: c.isSortingDown(l.id)
            }) : p;
          }
        }
      }, {
        key: "displayValueAccessor",
        value: function (e) {
          return Object(x.compose)(function (t) {
            return kve.displayValue(e, t);
          }, Object(x.prop)("rowData"));
        }
      }, {
        key: "customDisplayValue",
        value: function (e, t) {
          var r, n;
          return Ume.isReportColumnSpec(e) && (null == e || null === (r = e.attribute) || void 0 === r || null === (r = r.modelClass) || void 0 === r || null === (n = r.displayValueForGroup) || void 0 === n ? void 0 : n.call(r, t.map(function (t) {
            return t.getSubrecord(e);
          })));
        }
      }, {
        key: "displayValueForGroup",
        value: function (e, t, r) {
          var n = this;
          return this.customDisplayValue(t, r) || Object(x.compose)(this.displayValueAccessor(t), Object(x.find)(function (r) {
            return e === n.groupKeyAccessor(t)(r);
          }))(r);
        }
      }, {
        key: "groupBySpec",
        value: function (e, t) {
          return Object(x.groupBy)(this.groupKeyAccessor(e))(t);
        }
      }, {
        key: "reportColumnKeyAccessor",
        value: function (e) {
          var t;
          return Object(x.compose)(Object(x.path)("model" === (null == e || null === (t = e.attribute) || void 0 === t ? void 0 : t.type) || "modelCollection" === (null == e ? void 0 : e.attribute.type) ? e.path.concat("id") : e.path), Object(x.prop)("rowData"));
        }
      }, {
        key: "calculationColumnKeyAccessor",
        value: function (e) {
          return Object(x.compose)(e.display.bind(e), Object(x.prop)("rowData"));
        }
      }, {
        key: "groupKeyAccessor",
        value: function (e) {
          return Ume.isReportColumnSpec(e) ? this.reportColumnKeyAccessor(e) : this.calculationColumnKeyAccessor(e);
        }
      }, {
        key: "renderChildToCsvString",
        value: function (e) {
          return e.isGroup ? this.renderToCsvString(e) : Lve.renderToCsvString(e);
        }
      }, {
        key: "renderToCsvString",
        value: function (e) {
          var t = this;
          return [[].concat(Lve.renderPrefixCellsToCsvString(e) || []).concat(JSON.stringify(e.displayValue)).join(",")].concat(e.children.map(function (e) {
            return t.renderChildToCsvString(e);
          })).join("\r\n");
        }
      }, {
        key: "sort",
        value: function (e, t) {
          var r = Uve({}, t || {}).sortDescending,
              n = Object(x.useWith)(h.naturalSort, [Object(x.prop)("displayValue"), Object(x.prop)("displayValue")]),
              o = r ? Object(x.flip)(n) : n;
          return Object(x.sort)(o, e);
        }
      }], (r = null) && Kve(t.prototype, r), n && Kve(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), t;
      var t, r, n;
    }();

    function Yve(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Qve(n.key), n);
      }
    }

    function Qve(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function $ve(e, t, r) {
      return t = Xve(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Xve(e).constructor) : t.apply(e, r));
    }

    function Xve(e) {
      return (Xve = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Zve(e, t) {
      return (Zve = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var ehe,
        the,
        rhe,
        nhe,
        ohe = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((Hve = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), $ve(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Zve(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Yve(e.prototype, t), r && Yve(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "filterStatusText",
        get: function () {
          var e = this.props,
              t = e.t,
              r = e.columnFiltersModel;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("span", {
            className: "report-filters-number"
          }, r.numReportFilters || 0, " "), p.a.createElement("span", {
            className: "report-filters-applied-text"
          }, 1 === r.numReportFilters ? t("filter_applied_not_all_records_are_shown") : t("filters_applied_not_all_records_are_shown")));
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.onClearFilters,
              r = e.columnFiltersModel,
              n = e.t;
          return p.a.createElement("div", {
            className: "clear-report-filters"
          }, r.numReportFilters ? p.a.createElement(p.a.Fragment, null, this.filterStatusText, " ", p.a.createElement("a", {
            role: "button",
            href: "#",
            onClick: t
          }, n("clear_filters"))) : null);
        }
      }]);
    }()).prototype, "filterStatusText", [f.computed], Object.getOwnPropertyDescriptor(Hve.prototype, "filterStatusText"), Hve.prototype), Wve = Hve)) || Wve;

    function ihe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function ahe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, che(n.key), n);
      }
    }

    function che(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function uhe(e, t, r) {
      return t = lhe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], lhe(e).constructor) : t.apply(e, r));
    }

    function lhe(e) {
      return (lhe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function she(e, t) {
      return (she = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function phe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var fhe,
        dhe,
        bhe,
        yhe = Object(d.observer)((phe((the = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), ihe(r = uhe(this, t, [e]), "onCancel", rhe, r), ihe(r, "onSubmit", nhe, r);
        var n = e.id,
            o = e.accountsStore,
            i = e.readOnlyAncestors;
        return r.id = n, r.defaultTreeModel = new as(o), r.treeModel.setRoots(o.roots, (i || []).map(function (e) {
          return o.push(e);
        })), r.treeModel.sortRoots(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && she(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && ahe(e.prototype, t), r && ahe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "treeModel",
        get: function () {
          return this.props.treeModel || this.defaultTreeModel;
        }
      }, {
        key: "resetCheckedAccounts",
        value: function (e) {
          this.treeModel.unCheckAll(), this.treeModel.checkMany(e);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.id,
              r = e.t;
          return p.a.createElement(h.ModalDialog, {
            id: t,
            dialogClassNames: "account-selector-modal"
          }, p.a.createElement(h.ModalHeader, {
            title: r("select_accounts"),
            onClose: this.onCancel
          }), p.a.createElement("form", {
            onSubmit: this.onSubmit
          }, p.a.createElement(h.ModalBody, null, p.a.createElement(fl, {
            items: this.treeModel.roots,
            model: this.treeModel,
            ControlsComponent: nj,
            ContentComponent: Cl(this.treeModel)
          })), p.a.createElement(h.ModalFooter, null, p.a.createElement("div", {
            className: "w-100 d-flex justify-content-end"
          }, p.a.createElement("div", {
            className: ""
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-outline-secondary mr-2",
            "data-dismiss": "modal",
            onClick: this.onCancel
          }, r("cancel").toUpperCase()), p.a.createElement("button", {
            type: "submit",
            className: "btn btn-primary",
            "data-dismiss": "modal",
            onClick: this.onSubmit
          }, r("ok").toUpperCase()))))));
        }
      }]);
    }()).prototype, "treeModel", [f.computed], Object.getOwnPropertyDescriptor(the.prototype, "treeModel"), the.prototype), rhe = phe(the.prototype, "onCancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.id,
              n = t.selectedAccountIds;
          v()("#".concat(r)).modal("hide"), e.resetCheckedAccounts(n);
        };
      }
    }), nhe = phe(the.prototype, "onSubmit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onSubmit;
          t.preventDefault(), r(e.treeModel.checked);
        };
      }
    }), ehe = the)) || ehe,
        mhe = Object(g.a)()(yhe);

    function vhe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, hhe(n.key), n);
      }
    }

    function hhe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ghe(e, t, r) {
      return t = whe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], whe(e).constructor) : t.apply(e, r));
    }

    function whe(e) {
      return (whe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Ohe(e, t) {
      return (Ohe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var jhe,
        Phe,
        _he,
        Ehe,
        She,
        Che = Object(d.observer)((bhe = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((dhe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = ghe(this, t, [].concat(n))).modalId = "account-selector-modal", function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e, "showModal", bhe, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ohe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && vhe(e.prototype, t), r && vhe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.accountsStore,
              r = e.onSelectAccounts,
              n = e.readOnlyAncestors,
              o = e.treeModel,
              i = e.t,
              a = e.selectedAccountIds;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement(mhe, {
            id: this.modalId,
            treeModel: o,
            accountsStore: t,
            onSubmit: r,
            readOnlyAncestors: n,
            selectedAccountIds: a
          }), p.a.createElement("div", {
            className: "select-accounts-control d-inline-block"
          }, p.a.createElement("a", {
            className: "icon icon-select",
            href: "#",
            onClick: this.showModal
          }, i("select_accounts"))));
        }
      }]);
    }()).prototype, "showModal", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.preventDefault(), v()("#".concat(e.modalId)).modal("show");
        };
      }
    }), fhe = dhe)) || fhe,
        khe = Object(g.a)()(Che);

    function Rhe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function The(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zhe(n.key), n);
      }
    }

    function zhe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Nhe(e, t, r) {
      return t = Dhe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Dhe(e).constructor) : t.apply(e, r));
    }

    function Dhe(e) {
      return (Dhe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function xhe(e, t) {
      return (xhe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Ahe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Mhe,
        Ihe = Object(d.observer)((_he = Ahe((Phe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return Rhe(e = Nhe(this, t, [].concat(n)), "adding", _he, e), Rhe(e, "addColumn", Ehe, e), Rhe(e, "onAddColumn", She, e), e.preventDefault = function (e) {
          return e.preventDefault();
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && xhe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && The(e.prototype, t), r && The(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "topLevelColumns",
        get: function () {
          var e = this.props.reportsManager;
          return e.reportItemSpec.attributes.map(function (t) {
            return e.findColumn(t.key);
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props.t;
          return p.a.createElement("div", {
            "aria-label": "Add Column Dropdown",
            className: "add-column-control col text-right"
          }, p.a.createElement(_c, null, p.a.createElement(_c.Toggle, {
            as: KB,
            className: "icon".concat(this.adding ? " icon-adding" : " icon-add")
          }, this.adding ? "".concat(t("adding"), ' "').concat(this.adding, '"') : t("add_column")), p.a.createElement(_c.Menu, {
            align: "right"
          }, this.topLevelColumns.map(function (t) {
            var r;
            return p.a.createElement(_c.Item, {
              role: "menuitem",
              className: t.isShowing ? "disabled" : null,
              key: t.attribute.key,
              onClick: e.onAddColumn(t)
            }, t.getName() || (null === (r = t.attribute) || void 0 === r ? void 0 : r.name));
          }))));
        }
      }]);
    }()).prototype, "adding", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Ahe(Phe.prototype, "topLevelColumns", [f.computed], Object.getOwnPropertyDescriptor(Phe.prototype, "topLevelColumns"), Phe.prototype), Ehe = Ahe(Phe.prototype, "addColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function () {
            e.props.reportsManager.addColumnAtEnd(t), e.adding = "";
          };
        };
      }
    }), She = Ahe(Phe.prototype, "onAddColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function (r) {
            var n;
            r.preventDefault(), e.adding = (null === (n = t.attribute) || void 0 === n ? void 0 : n.name) || t.getName(), setTimeout(e.addColumn(t), 20);
          };
        };
      }
    }), jhe = Phe)) || jhe,
        Fhe = Object(g.a)()(Ihe);

    function Bhe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Lhe(n.key), n);
      }
    }

    function Lhe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Vhe(e, t, r) {
      return t = Uhe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Uhe(e).constructor) : t.apply(e, r));
    }

    function Uhe(e) {
      return (Uhe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function qhe(e, t) {
      return (qhe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Khe = Object(d.observer)(Mhe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Vhe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && qhe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Bhe(e.prototype, t), r && Bhe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.reportsManager,
              r = e.readOnlyAncestors,
              n = e.t;
          return p.a.createElement("div", {
            className: "row report-controls justify-content-between mb-2"
          }, p.a.createElement("div", {
            className: "col"
          }, t.shouldIncludeAccountSelector ? p.a.createElement(p.a.Fragment, null, p.a.createElement(khe, {
            readOnlyAncestors: r,
            treeModel: t.treeModel,
            accountsStore: t.accountsStore,
            onSelectAccounts: t.getReportItemsForAccounts,
            selectedAccountIds: t.selectedAccountIds
          }), p.a.createElement("button", {
            type: "button",
            className: "btn btn-link".concat(t.didQuery ? "" : " disabled"),
            "data-testid": "test-refresh-query-button",
            title: n("refresh_query"),
            "data-toggle": "tooltip",
            disabled: !t.didQuery,
            onClick: t.onRefreshQuery
          }, p.a.createElement("i", {
            className: "fas fa-redo"
          }))) : null), p.a.createElement(Fhe, {
            reportsManager: t
          }));
        }
      }]);
    }()) || Mhe;

    function Ghe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Whe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ghe(Object(r), !0).forEach(function (t) {
          Hhe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ghe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Hhe(e, t, r) {
      return (t = Yhe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Jhe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Yhe(n.key), n);
      }
    }

    function Yhe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Qhe(e, t, r) {
      return t = Zhe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Zhe(e).constructor) : t.apply(e, r));
    }

    function $he() {
      return ($he = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Xhe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Xhe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = Zhe(e)););

      return e;
    }

    function Zhe(e) {
      return (Zhe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ege(e, t) {
      return (ege = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var tge,
        rge,
        nge,
        oge,
        ige,
        age,
        cge,
        uge,
        lge,
        sge,
        pge,
        fge,
        dge,
        bge = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = Qhe(this, t, [e])).value = e.value, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ege(e, t);
      }(t, Gce), function (e, t, r) {
        return t && Jhe(e.prototype, t), r && Jhe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "getName",
        value: function () {
          return this.value;
        }
      }, {
        key: "getValue",
        value: function (e) {
          return this.value;
        }
      }, {
        key: "toJS",
        value: function () {
          return Whe(Whe({}, (e = t, r = "toJS", n = this, i = $he(Zhe(1 & (o = 3) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([])), {}, {
            value: this.value
          });
          var e, r, n, o, i;
        }
      }], [{
        key: "isConstantCalculationOperandSpec",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(t.prototype, e);
        }
      }, {
        key: "type",
        value: function () {
          return "ConstantCalculationOperandSpec";
        }
      }]);
    }();

    function yge(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function mge(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, vge(n.key), n);
      }
    }

    function vge(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function hge(e, t, r) {
      return t = gge(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], gge(e).constructor) : t.apply(e, r));
    }

    function gge(e) {
      return (gge = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function wge(e, t) {
      return (wge = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Oge(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var jge,
        Pge,
        _ge = ((dge = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return yge(e = hge(this, t, [].concat(n)), "additionalColumnChoices", rge, e), yge(e, "selectedColumn", nge, e), yge(e, "columnError", oge, e), yge(e, "selectedUnit", ige, e), yge(e, "scalar", age, e), yge(e, "scalarError", cge, e), e.id = Object(td.v4)(), yge(e, "isConstant", uge, e), yge(e, "selectColumn", lge, e), yge(e, "selectUnit", sge, e), yge(e, "setScalar", pge, e), yge(e, "toggleConstant", fge, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && wge(e, t);
      }(t, h["ViewModel"]), function (e, t, r) {
        return t && mge(e.prototype, t), r && mge(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "isValid",
        get: function () {
          return this.isConstant && !this.scalarError || !this.isConstant && !this.columnError;
        }
      }, {
        key: "columnChoices",
        get: function () {
          var e = this.props.columnChoices;
          return Object(x.uniqBy)(Object(x.prop)("id"))((e || []).concat(this.additionalColumnChoices));
        }
      }, {
        key: "clearErrors",
        value: function () {
          this.columnError = "", this.scalarError = "";
        }
      }, {
        key: "getSelectedColumnSpec",
        value: function () {
          var e = this;
          return this.columnChoices.find(function (t) {
            return t.id === e.selectedColumn;
          });
        }
      }, {
        key: "reset",
        value: function () {
          this.scalar = "", this.selectedUnit = "", this.selectedColumn = "", this.isConstant = !1, this.clearErrors();
        }
      }, {
        key: "validate",
        value: function () {
          if (this.clearErrors(), this.isConstant) return this.validateConstant();

          if (!this.selectedColumn) {
            var e = this.props.t;
            this.columnError = e("column_blank_error");
          }
        }
      }, {
        key: "validateConstant",
        value: function () {
          if (!this.scalar && 0 !== this.scalar) {
            var e = this.props.t;
            this.scalarError = e("scalar_blank_error");
          }
        }
      }, {
        key: "initializeFromSpec",
        value: function (e) {
          if (aue.isColumnCalculationOperandSpec(e)) this.isConstant = !1, this.selectedColumn = e.referenceColumnSpec.id, this.additionalColumnChoices = [e.referenceColumnSpec];else if (bge.isConstantCalculationOperandSpec(e)) {
            this.isConstant = !0;
            var t = new w.Quantity(e.value);
            this.scalar = t.scalar, this.selectedUnit = t.units;
          }
        }
      }]);
    }()).unitChoices = ["acre", "hectare"].map(function (e) {
      return {
        group: "Area",
        value: e
      };
    }).concat(["oz", "lbs", "tn", "grams", "kg"].map(function (e) {
      return {
        group: "Mass",
        value: e
      };
    })).concat(["floz", "pt", "qt", "gal", "hgal", "mL", "L"].map(function (e) {
      return {
        group: "Volume",
        value: e,
        displayName: e.replace("hgal", "100 gal")
      };
    })), rge = Oge((tge = dge).prototype, "additionalColumnChoices", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), nge = Oge(tge.prototype, "selectedColumn", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), oge = Oge(tge.prototype, "columnError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), ige = Oge(tge.prototype, "selectedUnit", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), age = Oge(tge.prototype, "scalar", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), cge = Oge(tge.prototype, "scalarError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), uge = Oge(tge.prototype, "isConstant", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Oge(tge.prototype, "isValid", [f.computed], Object.getOwnPropertyDescriptor(tge.prototype, "isValid"), tge.prototype), Oge(tge.prototype, "columnChoices", [f.computed], Object.getOwnPropertyDescriptor(tge.prototype, "columnChoices"), tge.prototype), Oge(tge.prototype, "clearErrors", [f.action], Object.getOwnPropertyDescriptor(tge.prototype, "clearErrors"), tge.prototype), Oge(tge.prototype, "reset", [f.action], Object.getOwnPropertyDescriptor(tge.prototype, "reset"), tge.prototype), lge = Oge(tge.prototype, "selectColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.selectedColumn = t;
        };
      }
    }), sge = Oge(tge.prototype, "selectUnit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.selectedUnit = t;
        };
      }
    }), pge = Oge(tge.prototype, "setScalar", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.scalar = t;
        };
      }
    }), fge = Oge(tge.prototype, "toggleConstant", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isConstant = !e.isConstant;
        };
      }
    }), Oge(tge.prototype, "validate", [f.action], Object.getOwnPropertyDescriptor(tge.prototype, "validate"), tge.prototype), Oge(tge.prototype, "validateConstant", [f.action], Object.getOwnPropertyDescriptor(tge.prototype, "validateConstant"), tge.prototype), Oge(tge.prototype, "initializeFromSpec", [f.action], Object.getOwnPropertyDescriptor(tge.prototype, "initializeFromSpec"), tge.prototype), tge);

    function Ege(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Sge(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ege(Object(r), !0).forEach(function (t) {
          Cge(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ege(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Cge(e, t, r) {
      return (t = Rge(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function kge(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Rge(n.key), n);
      }
    }

    function Rge(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Tge(e, t, r) {
      return t = zge(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], zge(e).constructor) : t.apply(e, r));
    }

    function zge(e) {
      return (zge = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Nge(e, t) {
      return (Nge = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Dge = ((Pge = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Tge(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Nge(e, t);
      }(t, Object(w["MixInto"])(w["Quantity"])(w["reportableMixin"])), r = t, o = [{
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition || {};
          return {
            scalar: e.scalar,
            units: Sge(Sge({}, e.units), {}, {
              key: "displayUnits"
            }),
            displayValue: {
              name: "Display Value",
              key: "displayValue",
              type: "string"
            }
          };
        }
      }], (n = [{
        key: "displayUnits",
        get: function () {
          return w.Quantity.formatUnits(this.units);
        }
      }]) && kge(r.prototype, n), o && kge(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).defaultKey = "displayValue", function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((jge = Pge).prototype, "displayUnits", [f.computed], Object.getOwnPropertyDescriptor(jge.prototype, "displayUnits"), jge.prototype), jge);

    function xge(e, t, r) {
      return t = Bge(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, Ige() ? Reflect.construct(t, r || [], Bge(e).constructor) : t.apply(e, r));
    }

    function Age(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && Fge(e, t);
    }

    function Mge(e) {
      var t = "function" == typeof Map ? new Map() : void 0;
      return (Mge = function (e) {
        if (null === e || !function (e) {
          try {
            return -1 !== Function.toString.call(e).indexOf("[native code]");
          } catch (t) {
            return "function" == typeof e;
          }
        }(e)) return e;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, r);
        }

        function r() {
          return function (e, t, r) {
            if (Ige()) return Reflect.construct.apply(null, arguments);
            var n = [null];
            n.push.apply(n, t);
            var o = new (e.bind.apply(e, n))();
            return r && Fge(o, r.prototype), o;
          }(e, arguments, Bge(this).constructor);
        }

        return r.prototype = Object.create(e.prototype, {
          constructor: {
            value: r,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), Fge(r, e);
      })(e);
    }

    function Ige() {
      try {
        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch (e) {}

      return (Ige = function () {
        return !!e;
      })();
    }

    function Fge(e, t) {
      return (Fge = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Bge(e) {
      return (Bge = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Lge(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function Vge(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qge(n.key), n);
      }
    }

    function Uge(e, t, r) {
      return t && Vge(e.prototype, t), r && Vge(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function qge(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var Kge = function () {
      return Uge(function e(t) {
        if (Lge(this, e), null == t || !t.t) throw new Error("Must provide translation function");
        this.t = t.t;
      }, [{
        key: "validateOperands",
        value: function (e) {
          var t = this;
          if (!Array.isArray(e) || !e.length || e.every(function (e) {
            return null == e;
          })) return [new this.constructor.OperandsMissingError(this.t)];
          var r = new w.Quantity(e[0]),
              n = new w.Quantity(e[1]),
              o = [];
          return [r, n].forEach(function (r, n) {
            null != e[n] && "" !== e[n] ? r.isBlank && o.push(new t.constructor.InvalidOperandError(e[n], n, t.t)) : o.push(new t.constructor.BlankOperandError(e[n], n, t.t));
          }), o.length ? o : [];
        }
      }, {
        key: "calculate",
        value: function (e) {
          return {
            result: null,
            errors: this.validateOperands(e)
          };
        }
      }, {
        key: "display",
        value: function (e) {
          return "".concat(e[0], " ").concat(this.constructor.operatorSymbol(), " ").concat(e[1]);
        }
      }], [{
        key: "isOperandsMissingError",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(this.OperandsMissingError.prototype, e);
        }
      }, {
        key: "isInvalidOperandError",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(this.InvalidOperandError.prototype, e);
        }
      }, {
        key: "isBlankOperandError",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(this.BlankOperandError.prototype, e);
        }
      }, {
        key: "isIncompatibleUnitsError",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(this.IncompatibleUnitsError.prototype, e);
        }
      }, {
        key: "operatorSymbol",
        value: function () {
          return "<binary_operator>";
        }
      }, {
        key: "operatorId",
        value: function () {
          return "binary_operator_id";
        }
      }]);
    }();

    function Gge(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Wge(n.key), n);
      }
    }

    function Wge(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Hge(e, t, r) {
      return t = $ge(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], $ge(e).constructor) : t.apply(e, r));
    }

    function Jge(e, t, r, n) {
      var o = Yge($ge(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function Yge() {
      return (Yge = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Qge(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Qge(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = $ge(e)););

      return e;
    }

    function $ge(e) {
      return ($ge = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Xge(e, t) {
      return (Xge = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    Kge.OperandsMissingError = function (e) {
      function t(e) {
        var r;
        return Lge(this, t), (r = xge(this, t, [e("operands_missing_error")])).name = "OperandsMissingError", r;
      }

      return Age(t, Mge(Error)), Uge(t);
    }(), Kge.InvalidOperandError = function (e) {
      function t(e, r, n) {
        var o;
        return Lge(this, t), (o = xge(this, t, [n("invalid_operand_error", {
          leftOrRightOperand: n(0 === r ? "left_operand" : "right_operand"),
          operandValue: w.Quantity.isQuantity(e) && e.displayValue || e
        })])).operand = e, o.index = r, o.name = "InvalidOperandError", o;
      }

      return Age(t, Mge(Error)), Uge(t);
    }(), Kge.BlankOperandError = function (e) {
      function t(e, r, n) {
        var o;
        return Lge(this, t), (o = xge(this, t, [n("blank_operand_error", {
          leftOrRightOperand: n(0 === r ? "left_operand" : "right_operand"),
          typeOfBlank: e
        })])).operand = e, o.index = r, o.name = "BlankOperandError", o;
      }

      return Age(t, Mge(Error)), Uge(t);
    }(), Kge.IncompatibleUnitsError = function (e) {
      function t(e, r, n) {
        var o;
        return Lge(this, t), (o = xge(this, t, [n("incompatible_units_error", {
          firstUnit: e,
          secondUnit: r
        })])).op1Units = e, o.op2Units = r, o.name = "IncompatibleUnitsError", o;
      }

      return Age(t, Mge(Error)), Uge(t);
    }();

    var Zge = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Hge(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Xge(e, t);
      }(t, Kge), r = t, o = [{
        key: "operatorSymbol",
        value: function () {
          return "+";
        }
      }, {
        key: "operatorId",
        value: function () {
          return "add";
        }
      }], (n = [{
        key: "validateOperands",
        value: function (e) {
          var r = Jge(t, "validateOperands", this, 3)([e]);
          if (r.length) return r;
          var n = new w.Quantity(e[0]),
              o = new w.Quantity(e[1]);
          return n.units === o.units || w.Quantity.isCompatible(n, o) || r.push(new this.constructor.IncompatibleUnitsError(n.units, o.units, this.t)), r;
        }
      }, {
        key: "calculate",
        value: function (e) {
          var r,
              n = Jge(t, "calculate", this, 3)([e]);

          if (null !== (r = n.errors) && void 0 !== r && r.length) {
            if (n.errors.find(function (e) {
              return t.isOperandsMissingError(e);
            })) return n;
            if (n.errors.find(function (e) {
              return t.isInvalidOperandError(e);
            })) return n;
            var o = !1,
                i = e.slice();

            if (n.errors.forEach(function (e) {
              t.isBlankOperandError(e) && (i[e.index] = 0, o = !0);
            }), o) {
              var a = i.find(function (e) {
                return 0 !== e;
              });
              n.result = a && new w.Quantity(a) || null;
            }

            return n;
          }

          return n.result = new w.Quantity(e[0]).add(new w.Quantity(e[1])), n;
        }
      }]) && Gge(r.prototype, n), o && Gge(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function ewe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, twe(n.key), n);
      }
    }

    function twe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function rwe(e, t, r) {
      return t = awe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], awe(e).constructor) : t.apply(e, r));
    }

    function nwe(e, t, r, n) {
      var o = owe(awe(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function owe() {
      return (owe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = iwe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function iwe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = awe(e)););

      return e;
    }

    function awe(e) {
      return (awe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function cwe(e, t) {
      return (cwe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var uwe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), rwe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && cwe(e, t);
      }(t, Kge), r = t, o = [{
        key: "operatorSymbol",
        value: function () {
          return "−";
        }
      }, {
        key: "operatorId",
        value: function () {
          return "subtract";
        }
      }], (n = [{
        key: "validateOperands",
        value: function (e) {
          var r = nwe(t, "validateOperands", this, 3)([e]);
          if (r.length) return r;
          var n = new w.Quantity(e[0]),
              o = new w.Quantity(e[1]);
          return n.units === o.units || w.Quantity.isCompatible(n, o) || r.push(new this.constructor.IncompatibleUnitsError(n.units, o.units, this.t)), r;
        }
      }, {
        key: "calculate",
        value: function (e) {
          var r,
              n = nwe(t, "calculate", this, 3)([e]);

          if (null !== (r = n.errors) && void 0 !== r && r.length) {
            if (n.errors.find(function (e) {
              return t.isOperandsMissingError(e);
            })) return n;
            if (n.errors.find(function (e) {
              return t.isInvalidOperandError(e);
            })) return n;
            var o = n.errors.filter(function (e) {
              return t.isBlankOperandError(e);
            });

            if (1 === o.length) {
              var i = 0 === o[0].index ? new w.Quantity(e[1]) : new w.Quantity(e[0]),
                  a = new w.Quantity(i.toJS());
              a.updateScalar(0), n.result = 0 === o[0].index ? a.sub(i) : i;
            }

            return n;
          }

          return n.result = new w.Quantity(e[0]).sub(new w.Quantity(e[1])), n;
        }
      }]) && ewe(r.prototype, n), o && ewe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function lwe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, swe(n.key), n);
      }
    }

    function swe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function pwe(e, t, r) {
      return t = bwe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], bwe(e).constructor) : t.apply(e, r));
    }

    function fwe() {
      return (fwe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = dwe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function dwe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = bwe(e)););

      return e;
    }

    function bwe(e) {
      return (bwe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ywe(e, t) {
      return (ywe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var mwe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), pwe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ywe(e, t);
      }(t, Kge), function (e, t, r) {
        return t && lwe(e.prototype, t), r && lwe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "calculate",
        value: function (e) {
          var r,
              n,
              o,
              i,
              a,
              c,
              u = (n = t, o = "calculate", i = this, c = fwe(bwe(1 & (a = 3) ? n.prototype : n), o, i), 2 & a && "function" == typeof c ? function (e) {
            return c.apply(i, e);
          } : c)([e]);
          return null !== (r = u.errors) && void 0 !== r && r.length ? u : (u.result = new w.Quantity(e[0]).mul(new w.Quantity(e[1])), u);
        }
      }], [{
        key: "operatorSymbol",
        value: function () {
          return "×";
        }
      }, {
        key: "operatorId",
        value: function () {
          return "multiply";
        }
      }]);
    }();

    function vwe(e) {
      var t = "function" == typeof Map ? new Map() : void 0;
      return (vwe = function (e) {
        if (null === e || !function (e) {
          try {
            return -1 !== Function.toString.call(e).indexOf("[native code]");
          } catch (t) {
            return "function" == typeof e;
          }
        }(e)) return e;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, r);
        }

        function r() {
          return function (e, t, r) {
            if (Pwe()) return Reflect.construct.apply(null, arguments);
            var n = [null];
            n.push.apply(n, t);
            var o = new (e.bind.apply(e, n))();
            return r && Rwe(o, r.prototype), o;
          }(e, arguments, Cwe(this).constructor);
        }

        return r.prototype = Object.create(e.prototype, {
          constructor: {
            value: r,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), Rwe(r, e);
      })(e);
    }

    function hwe(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function gwe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Owe(n.key), n);
      }
    }

    function wwe(e, t, r) {
      return t && gwe(e.prototype, t), r && gwe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function Owe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function jwe(e, t, r) {
      return t = Cwe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, Pwe() ? Reflect.construct(t, r || [], Cwe(e).constructor) : t.apply(e, r));
    }

    function Pwe() {
      try {
        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch (e) {}

      return (Pwe = function () {
        return !!e;
      })();
    }

    function _we(e, t, r, n) {
      var o = Ewe(Cwe(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function Ewe() {
      return (Ewe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Swe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Swe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = Cwe(e)););

      return e;
    }

    function Cwe(e) {
      return (Cwe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function kwe(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && Rwe(e, t);
    }

    function Rwe(e, t) {
      return (Rwe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Twe,
        zwe,
        Nwe,
        Dwe,
        xwe,
        Awe,
        Mwe,
        Iwe,
        Fwe,
        Bwe,
        Lwe,
        Vwe,
        Uwe,
        qwe,
        Kwe,
        Gwe = function (e) {
      function t() {
        return hwe(this, t), jwe(this, t, arguments);
      }

      return kwe(t, Kge), wwe(t, [{
        key: "validateOperands",
        value: function (e) {
          var r = _we(t, "validateOperands", this, 3)([e]);

          return r.length ? r : (new w.Quantity(e[1]).isZero() && r.push(new this.constructor.DivideByZeroError()), r);
        }
      }, {
        key: "calculate",
        value: function (e) {
          var r,
              n = _we(t, "calculate", this, 3)([e]);

          return null !== (r = n.errors) && void 0 !== r && r.length ? n : (n.result = new w.Quantity(e[0]).div(new w.Quantity(e[1])), n);
        }
      }], [{
        key: "isDivideByZeroError",
        value: function (e) {
          return Object.prototype.isPrototypeOf.call(this.DivideByZeroError.prototype, e);
        }
      }, {
        key: "operatorSymbol",
        value: function () {
          return "÷";
        }
      }, {
        key: "operatorId",
        value: function () {
          return "divide";
        }
      }]);
    }();

    function Wwe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Hwe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Jwe(n.key), n);
      }
    }

    function Jwe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Ywe(e, t, r) {
      return t = Qwe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Qwe(e).constructor) : t.apply(e, r));
    }

    function Qwe(e) {
      return (Qwe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function $we(e, t) {
      return ($we = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Xwe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    Gwe.DivideByZeroError = function (e) {
      function t() {
        var e;
        return hwe(this, t), (e = jwe(this, t, ["Divide by zero"])).name = "DivideByZeroError", e;
      }

      return kwe(t, vwe(Error)), wwe(t);
    }();

    var Zwe,
        eOe,
        tOe,
        rOe,
        nOe,
        oOe,
        iOe,
        aOe = ((Kwe = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Wwe(r = Ywe(this, t, [e]), "calculationColumnSpec", zwe, r), Wwe(r, "modal", Nwe, r), Wwe(r, "newColumnPosition", Dwe, r), Wwe(r, "operand1", xwe, r), Wwe(r, "operand2", Awe, r), Wwe(r, "saveButtonText", Mwe, r), Wwe(r, "selectedOperation", Iwe, r), Wwe(r, "operationError", Fwe, r), Wwe(r, "isEditing", Bwe, r), Wwe(r, "edit", Lwe, r), Wwe(r, "new", Vwe, r), Wwe(r, "reverseOperands", Uwe, r), Wwe(r, "selectOperation", qwe, r), r.modal = new h.ModalModel(), r.operand1 = new _ge({
          t: r.props.t
        }), r.operand2 = new _ge({
          t: r.props.t
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && $we(e, t);
      }(t, h["ViewModel"]), function (e, t, r) {
        return t && Hwe(e.prototype, t), r && Hwe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "id",
        get: function () {
          return this.modal.id;
        }
      }, {
        key: "isValid",
        get: function () {
          return !this.operationError && this.operand1.isValid && this.operand2.isValid;
        }
      }, {
        key: "title",
        get: function () {
          return this.modal.title;
        }
      }, {
        key: "clearErrors",
        value: function () {
          this.operationError = "";
        }
      }, {
        key: "hide",
        value: function () {
          this.modal.hide();
        }
      }, {
        key: "getCalculationSpec",
        value: function () {
          var e = {
            add: Zge,
            subtract: uwe,
            multiply: mwe,
            divide: Gwe
          }[this.selectedOperation],
              t = e && new e({
            t: this.props.t
          });
          if (!t) throw new Error('Could not create calculation for "'.concat(this.selectedOperation, '"'));
          var r = this.newColumnPosition,
              n = this.getCalculationOperandSpec(this.operand1),
              o = this.getCalculationOperandSpec(this.operand2);
          return this.isEditing ? (this.calculationColumnSpec.position = r, this.calculationColumnSpec.calculation = t, this.calculationColumnSpec.operand1 = n, this.calculationColumnSpec.operand2 = o, this.calculationColumnSpec) : new Due({
            position: r,
            calculation: t,
            operand1: n,
            operand2: o
          });
        }
      }, {
        key: "getCalculationOperandSpec",
        value: function (e) {
          return e.isConstant ? new bge({
            value: [].concat(e.scalar).concat(e.selectedUnit).join(" ")
          }) : new aue({
            referenceColumnSpec: e.getSelectedColumnSpec()
          });
        }
      }, {
        key: "reset",
        value: function () {
          this.operand1.reset(), this.operand2.reset(), this.selectedOperation = "multiply", this.calculationColumnSpec = void 0, this.isEditing = !1, this.clearErrors();
        }
      }, {
        key: "setColumnChoices",
        value: function (e) {
          var t = e.filter(function (e) {
            return Due.isCalculationColumnSpec(e) || Ume.isReportColumnSpec(e) && ("number" === e.attribute.type || "model" === e.attribute.type && e.attribute.modelClass === Dge || e.attribute.calculable);
          });
          this.operand1.update({
            columnChoices: t
          }), this.operand2.update({
            columnChoices: t
          });
        }
      }, {
        key: "show",
        value: function () {
          this.modal.show();
        }
      }, {
        key: "validate",
        value: function () {
          if (this.clearErrors(), this.operand1.validate(), this.operand2.validate(), !this.selectedOperation) {
            var e = this.props.t;
            this.operationError = e("operation_blank_error");
          }
        }
      }]);
    }()).operationChoices = [{
      id: "add",
      value: Zge.operatorSymbol()
    }, {
      id: "subtract",
      value: uwe.operatorSymbol()
    }, {
      id: "multiply",
      value: mwe.operatorSymbol()
    }, {
      id: "divide",
      value: Gwe.operatorSymbol()
    }], zwe = Xwe((Twe = Kwe).prototype, "calculationColumnSpec", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Nwe = Xwe(Twe.prototype, "modal", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Dwe = Xwe(Twe.prototype, "newColumnPosition", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), xwe = Xwe(Twe.prototype, "operand1", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Awe = Xwe(Twe.prototype, "operand2", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Mwe = Xwe(Twe.prototype, "saveButtonText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Iwe = Xwe(Twe.prototype, "selectedOperation", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "multiply";
      }
    }), Fwe = Xwe(Twe.prototype, "operationError", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Bwe = Xwe(Twe.prototype, "isEditing", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), Xwe(Twe.prototype, "id", [f.computed], Object.getOwnPropertyDescriptor(Twe.prototype, "id"), Twe.prototype), Xwe(Twe.prototype, "isValid", [f.computed], Object.getOwnPropertyDescriptor(Twe.prototype, "isValid"), Twe.prototype), Xwe(Twe.prototype, "title", [f.computed], Object.getOwnPropertyDescriptor(Twe.prototype, "title"), Twe.prototype), Xwe(Twe.prototype, "clearErrors", [f.action], Object.getOwnPropertyDescriptor(Twe.prototype, "clearErrors"), Twe.prototype), Lwe = Xwe(Twe.prototype, "edit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.t;
          e.modal.props.title = r("edit_calculation"), e.saveButtonText = r("save"), e.newColumnPosition = t.position, e.operand1.initializeFromSpec(t.operand1), e.operand2.initializeFromSpec(t.operand2), e.selectedOperation = t.calculation.constructor.operatorId(), e.calculationColumnSpec = t, e.isEditing = !0;
        };
      }
    }), Vwe = Xwe(Twe.prototype, "new", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.t;
          e.newColumnPosition = t.position, e.modal.props.title = r("add_calculation"), e.saveButtonText = r("add_calculated_column");
        };
      }
    }), Xwe(Twe.prototype, "reset", [f.action], Object.getOwnPropertyDescriptor(Twe.prototype, "reset"), Twe.prototype), Uwe = Xwe(Twe.prototype, "reverseOperands", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.operand1;
          e.operand1 = e.operand2, e.operand2 = t;
        };
      }
    }), Xwe(Twe.prototype, "setColumnChoices", [f.action], Object.getOwnPropertyDescriptor(Twe.prototype, "setColumnChoices"), Twe.prototype), qwe = Xwe(Twe.prototype, "selectOperation", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.selectedOperation = t;
        };
      }
    }), Twe);

    function cOe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function uOe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, lOe(n.key), n);
      }
    }

    function lOe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function sOe(e, t, r) {
      return t = pOe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], pOe(e).constructor) : t.apply(e, r));
    }

    function pOe(e) {
      return (pOe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function fOe(e, t) {
      return (fOe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function dOe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var bOe,
        yOe,
        mOe,
        vOe,
        hOe,
        gOe = Object(d.observer)((dOe((eOe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return cOe(e = sOe(this, t, [].concat(n)), "onChangeColumn", tOe, e), cOe(e, "onRadioClick", rOe, e), cOe(e, "onRadioKeyDown", nOe, e), cOe(e, "onUpdateUnit", oOe, e), cOe(e, "onUpdateValue", iOe, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && fOe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && uOe(e.prototype, t), r && uOe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "columnId",
        get: function () {
          var e = this.props.operand;
          return "".concat(e.id, "-column");
        }
      }, {
        key: "columnSelectorClassNames",
        get: function () {
          var e = this.props.operand;
          return ["form-control calculation-selector"].concat(e.isValid ? [] : "is-invalid").join(" ");
        }
      }, {
        key: "constantId",
        get: function () {
          var e = this.props.operand;
          return "".concat(e.id, "-constant");
        }
      }, {
        key: "defaultId",
        get: function () {
          var e = this.props.operand;
          return "".concat(e.id, "-default");
        }
      }, {
        key: "radioRowClasses",
        get: function () {
          var e = this.props.alignRight;
          return "row radio-row".concat(e ? " justify-content-end" : "", " align-items-end");
        }
      }, {
        key: "groupName",
        get: function () {
          var e = this.props.operand;
          return "operand-radio-".concat(e.id);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.operand,
              r = e.t;
          return p.a.createElement("div", {
            className: "operand-tool"
          }, p.a.createElement("div", {
            className: this.radioRowClasses
          }, p.a.createElement("div", {
            className: "col-auto mb-1"
          }, p.a.createElement("div", {
            role: "button",
            className: "form-check form-check-inline",
            onClick: this.onRadioClick(!t.isConstant),
            onKeyDown: this.onRadioKeyDown(!t.isConstant),
            tabIndex: "0"
          }, p.a.createElement("input", {
            className: "form-check-input",
            style: {
              pointerEvents: "none"
            },
            name: this.groupName,
            type: "radio",
            readOnly: !0,
            checked: !t.isConstant,
            tabIndex: "-1",
            id: this.columnId
          }), p.a.createElement("label", {
            className: "form-check-label",
            htmlFor: this.columnId
          }, r("column"))), p.a.createElement("div", {
            role: "button",
            className: "form-check form-check-inline",
            onClick: this.onRadioClick(t.isConstant),
            onKeyDown: this.onRadioKeyDown(t.isConstant),
            tabIndex: "0"
          }, p.a.createElement("input", {
            className: "form-check-input",
            style: {
              pointerEvents: "none"
            },
            name: this.groupName,
            type: "radio",
            readOnly: !0,
            checked: t.isConstant,
            tabIndex: "-1",
            id: this.constantId
          }), p.a.createElement("label", {
            className: "form-check-label",
            htmlFor: this.constantId
          }, r("constant"))))), p.a.createElement("div", {
            className: "row mx-n1 justify-content-end"
          }, t.isConstant ? p.a.createElement(h.UnitSelector, {
            unitChoices: t.constructor.unitChoices,
            currentUnit: t.selectedUnit,
            currentValue: t.scalar,
            valueColumnClassName: "col-sm-6 px-1",
            valueError: t.scalarError,
            unitColumnClassName: "col-sm-6 px-1",
            unitSelectorClassName: "form-control calculation-selector",
            onUpdateUnit: this.onUpdateUnit,
            onUpdateValue: this.onUpdateValue
          }) : p.a.createElement("div", {
            className: "col px-1"
          }, p.a.createElement("select", {
            value: t.selectedColumn,
            onChange: this.onChangeColumn,
            className: this.columnSelectorClassNames
          }, p.a.createElement("option", {
            key: this.defaultId,
            value: ""
          }, r("select_column")), t.columnChoices.map(function (e) {
            return p.a.createElement("option", {
              key: e.id,
              value: e.id
            }, e.getName());
          })), p.a.createElement("div", {
            className: "invalid-feedback"
          }, t.columnError))));
        }
      }]);
    }()).prototype, "columnId", [f.computed], Object.getOwnPropertyDescriptor(eOe.prototype, "columnId"), eOe.prototype), dOe(eOe.prototype, "columnSelectorClassNames", [f.computed], Object.getOwnPropertyDescriptor(eOe.prototype, "columnSelectorClassNames"), eOe.prototype), dOe(eOe.prototype, "constantId", [f.computed], Object.getOwnPropertyDescriptor(eOe.prototype, "constantId"), eOe.prototype), dOe(eOe.prototype, "defaultId", [f.computed], Object.getOwnPropertyDescriptor(eOe.prototype, "defaultId"), eOe.prototype), dOe(eOe.prototype, "radioRowClasses", [f.computed], Object.getOwnPropertyDescriptor(eOe.prototype, "radioRowClasses"), eOe.prototype), dOe(eOe.prototype, "groupName", [f.computed], Object.getOwnPropertyDescriptor(eOe.prototype, "groupName"), eOe.prototype), tOe = dOe(eOe.prototype, "onChangeColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.operand.selectColumn(t.target.value);
        };
      }
    }), rOe = dOe(eOe.prototype, "onRadioClick", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function () {
            var r = e.props.operand;
            t || r.toggleConstant();
          };
        };
      }
    }), nOe = dOe(eOe.prototype, "onRadioKeyDown", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function (r) {
            ["Enter", " "].includes(r.key) && e.onRadioClick(t)();
          };
        };
      }
    }), oOe = dOe(eOe.prototype, "onUpdateUnit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.operand.selectUnit(t);
        };
      }
    }), iOe = dOe(eOe.prototype, "onUpdateValue", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.operand.setScalar(t);
        };
      }
    }), Zwe = eOe)) || Zwe;

    function wOe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function OOe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, jOe(n.key), n);
      }
    }

    function jOe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function POe(e, t, r) {
      return t = _Oe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], _Oe(e).constructor) : t.apply(e, r));
    }

    function _Oe(e) {
      return (_Oe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function EOe(e, t) {
      return (EOe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function SOe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var COe = Object(d.observer)((SOe((yOe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return wOe(e = POe(this, t, [].concat(n)), "onChangeOperation", mOe, e), wOe(e, "onCancel", vOe, e), wOe(e, "onSave", hOe, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && EOe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && OOe(e.prototype, t), r && OOe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "headerId",
        get: function () {
          var e = this.props.modal;
          return "".concat(e.id, "-header");
        }
      }, {
        key: "defaultOperationId",
        get: function () {
          var e = this.props.modal;
          return "".concat(e.id, "-defaultOperation");
        }
      }, {
        key: "operationClassNames",
        get: function () {
          var e = this.props.modal;
          return ["form-control calculation-selector operation-selector"].concat(e.isValid ? [] : "is-invalid").join(" ");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.modal,
              r = e.t;
          return p.a.createElement(h.ModalDialog, {
            id: t.id,
            dismissOnClose: !1,
            className: "if2-modal column-calculation-modal",
            dialogClassNames: "modal-lg",
            ariaLabelledBy: this.headerId,
            resizable: !0
          }, p.a.createElement(h.ModalHeader, {
            id: this.headerId,
            title: t.title,
            onClose: this.onCancel
          }), p.a.createElement(h.ModalBody, null, p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col-md-5"
          }, p.a.createElement(gOe, {
            operand: t.operand1,
            t: r,
            key: t.operand1.id
          })), p.a.createElement("div", {
            className: "col-md-2"
          }, p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col text-center mb-2"
          }, p.a.createElement("button", {
            type: "button",
            "aria-label": "Reverse operands",
            className: "btn btn-secondary",
            onClick: t.reverseOperands
          }, p.a.createElement("i", {
            className: "fas fa-exchange-alt"
          })))), p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col mb-2"
          }, p.a.createElement("select", {
            value: t.selectedOperation,
            onChange: this.onChangeOperation,
            className: this.operationClassNames
          }, t.constructor.operationChoices.map(function (e) {
            return p.a.createElement("option", {
              key: e.id,
              value: e.id
            }, e.value);
          })), p.a.createElement("div", {
            className: "invalid-feedback"
          }, t.operationError)))), p.a.createElement("div", {
            className: "col-md-5"
          }, p.a.createElement(gOe, {
            operand: t.operand2,
            t: r,
            alignRight: !0,
            key: t.operand2.id
          }))), p.a.createElement("div", {
            className: "row justify-content-end mt-5"
          }, p.a.createElement("div", {
            className: "col-md-auto"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-secondary",
            onClick: this.onCancel
          }, r("cancel")), " ", p.a.createElement("button", {
            type: "button",
            className: "btn btn-primary",
            onClick: this.onSave
          }, r(t.saveButtonText))))));
        }
      }]);
    }()).prototype, "headerId", [f.computed], Object.getOwnPropertyDescriptor(yOe.prototype, "headerId"), yOe.prototype), SOe(yOe.prototype, "defaultOperationId", [f.computed], Object.getOwnPropertyDescriptor(yOe.prototype, "defaultOperationId"), yOe.prototype), SOe(yOe.prototype, "operationClassNames", [f.computed], Object.getOwnPropertyDescriptor(yOe.prototype, "operationClassNames"), yOe.prototype), mOe = SOe(yOe.prototype, "onChangeOperation", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.modal.selectOperation(t.target.value);
        };
      }
    }), vOe = SOe(yOe.prototype, "onCancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.modal;
          t.hide(), t.reset();
        };
      }
    }), hOe = SOe(yOe.prototype, "onSave", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.reportsManager,
              n = t.modal;

          if (n.validate(), n.isValid) {
            var o = n.getCalculationSpec();
            n.isEditing || r.addColumnAtPosition(o, o.position), n.hide(), n.reset();
          }
        };
      }
    }), bOe = yOe)) || bOe;

    function kOe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function ROe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? kOe(Object(r), !0).forEach(function (t) {
          TOe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : kOe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function TOe(e, t, r) {
      return (t = DOe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function zOe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function NOe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, DOe(n.key), n);
      }
    }

    function DOe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function xOe(e, t, r) {
      return t = AOe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], AOe(e).constructor) : t.apply(e, r));
    }

    function AOe(e) {
      return (AOe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function MOe(e, t) {
      return (MOe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function IOe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var FOe = function (e) {
      var t, r, n;
      return r = IOe((t = function (t) {
        function o() {
          var e;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, o);

          for (var t = arguments.length, i = new Array(t), a = 0; a < t; a++) i[a] = arguments[a];

          return zOe(e = xOe(this, o, [].concat(i)), "columnSpecs", r, e), zOe(e, "columnSpecCache", n, e), e.createCalculationSpec = function (t, r, n) {
            var o = e.props.t,
                i = [Zge, uwe, mwe, Gwe].find(function (e) {
              return e.operatorId() === t.calculation;
            }),
                a = i && new i({
              t: o
            }),
                c = t.operand1.type === bge.type() ? new bge({
              value: t.operand1.value
            }) : new aue({
              referenceColumnSpec: e.getOrCreateSpec(r[t.operand1.reference_spec], r, n)
            }),
                u = t.operand2.type === bge.type() ? new bge({
              value: t.operand2.value
            }) : new aue({
              referenceColumnSpec: e.getOrCreateSpec(r[t.operand2.reference_spec], r, n)
            }),
                l = new Due({
              id: t.id,
              position: t.position,
              calculation: a,
              operand1: c,
              operand2: u
            });
            return n[l.id] = l, l;
          }, e.getOrCreateSpec = function (t, r, n) {
            var o = e.props.t,
                i = n[t.id || t.path];
            if (i) return i;

            if (t.type !== Ume.type()) {
              if (t.type === Due.type()) return e.createCalculationSpec(t, r, n);
              console.error("Unexpected columnSpec type. Ignoring...", t);
            } else window.alert(o("unable_to_load_column_error", {
              columnName: t.name_override || t.path
            }));
          }, e;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && MOe(e, t);
        }(o, e), i = o, (a = [{
          key: "visibleColumns",
          get: function () {
            return this.columnSpecs.filter(function (e) {
              return e.isShowing;
            });
          }
        }, {
          key: "visibleColumnsToReport",
          get: function () {
            var e = this.visibleColumns.filter(function (e) {
              return Due.isCalculationColumnSpec(e);
            }).map(function (e) {
              return function e(t) {
                var r = [];

                if (aue.isColumnCalculationOperandSpec(t.operand1)) {
                  var n = t.operand1.referenceColumnSpec;
                  Due.isCalculationColumnSpec(n) ? r.push(e(n)) : r.push(n);
                }

                if (aue.isColumnCalculationOperandSpec(t.operand2)) {
                  var o = t.operand2.referenceColumnSpec;
                  Due.isCalculationColumnSpec(o) ? r.push(e(o)) : r.push(o);
                }

                return Object(x.flatten)(r);
              }(e);
            }),
                t = this.visibleColumns.filter(function (e) {
              return Ume.isReportColumnSpec(e);
            });
            return Object(x.uniqBy)(Object(x.prop)("id"))(t.concat(Object(x.flatten)(e)));
          }
        }, {
          key: "addColumn",
          value: function (e) {
            e && (e.isShowing = !0);
          }
        }, {
          key: "addColumnAtPosition",
          value: function (e, t) {
            this.addColumn(e);
            var r = e.position < t ? t - 1 : t;
            this.moveColumnToPosition(e, r);
          }
        }, {
          key: "addColumnAtEnd",
          value: function (e) {
            this.addColumnAtPosition(e, this.columnSpecs.length);
          }
        }, {
          key: "findColumn",
          value: function (e) {
            return this.columnSpecs.find(function (t) {
              return t.id && t.id === e;
            });
          }
        }, {
          key: "initColumnSpecs",
          value: function (e) {
            var t = this;
            this.columnSpecs = e.accessors.map(function (e, r) {
              return new Ume(ROe(ROe({}, e), {}, {
                position: r,
                t: t.props.t
              }));
            }), this.columnSpecs.forEach(function (e) {
              t.columnSpecCache[e.id] = e;
            });
          }
        }, {
          key: "loadColumnSpecs",
          value: function (e, t) {
            var r = this;

            if (Array.isArray(t)) {
              var n = {};
              t.forEach(function (e) {
                n[e.id || e.path] = e;
              }), t.forEach(function (e) {
                var t = r.getOrCreateSpec(e, n, r.columnSpecCache);
                t && (t.changeName(e.name_override), t.isShowing = e.is_showing, t.position = e.position, Due.isCalculationColumnSpec(t) && r.columnSpecs.push(t));
              }), this.reorderColumns();
            } else {
              var o = this.columnSpecs.find(function (t) {
                return Object(x.equals)(e.defaultAccessor.path, t.path);
              });
              o && (o.isShowing = !0);
            }
          }
        }, {
          key: "moveColumnToPosition",
          value: function (e, t) {
            if (e) {
              var r = this.findColumn(e.id);
              r && this.columnSpecs.splice(r.position, 1), this.columnSpecs.splice(t, 0, e), this.columnSpecs.forEach(function (e, t) {
                e.position = t;
              }), this.reorderColumns();
            }
          }
        }, {
          key: "removeColumn",
          value: function (e) {
            e && (e.isShowing = !1);
          }
        }, {
          key: "reorderColumns",
          value: function () {
            this.columnSpecs = this.columnSpecs.slice().sort(function (e, t) {
              return Object(h.naturalSort)(e.position, t.position);
            }).map(function (e, t) {
              return e.updatePosition(t);
            });
          }
        }]) && NOe(i.prototype, a), c && NOe(i, c), Object.defineProperty(i, "prototype", {
          writable: !1
        }), i;
        var i, a, c;
      }()).prototype, "columnSpecs", [f.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return [];
        }
      }), n = IOe(t.prototype, "columnSpecCache", [f.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return {};
        }
      }), IOe(t.prototype, "visibleColumns", [f.computed], Object.getOwnPropertyDescriptor(t.prototype, "visibleColumns"), t.prototype), IOe(t.prototype, "visibleColumnsToReport", [f.computed], Object.getOwnPropertyDescriptor(t.prototype, "visibleColumnsToReport"), t.prototype), IOe(t.prototype, "addColumn", [f.action], Object.getOwnPropertyDescriptor(t.prototype, "addColumn"), t.prototype), IOe(t.prototype, "addColumnAtPosition", [f.action], Object.getOwnPropertyDescriptor(t.prototype, "addColumnAtPosition"), t.prototype), IOe(t.prototype, "addColumnAtEnd", [f.action], Object.getOwnPropertyDescriptor(t.prototype, "addColumnAtEnd"), t.prototype), IOe(t.prototype, "moveColumnToPosition", [f.action], Object.getOwnPropertyDescriptor(t.prototype, "moveColumnToPosition"), t.prototype), IOe(t.prototype, "removeColumn", [f.action], Object.getOwnPropertyDescriptor(t.prototype, "removeColumn"), t.prototype), IOe(t.prototype, "reorderColumns", [f.action], Object.getOwnPropertyDescriptor(t.prototype, "reorderColumns"), t.prototype), t;
    },
        BOe = r(211);

    function LOe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, VOe(n.key), n);
      }
    }

    function VOe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function UOe(e, t, r) {
      return t = qOe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], qOe(e).constructor) : t.apply(e, r));
    }

    function qOe(e) {
      return (qOe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function KOe(e, t) {
      return (KOe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var GOe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), UOe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && KOe(e, t);
      }(t, Object(w["MixInto"])(w["AccountReference"])(w["reportableMixin"])), r = t, o = [{
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition || {};
          return {
            id: e.id,
            serial: e.serial,
            name: e.name,
            type: e.type
          };
        }
      }], (n = null) && LOe(r.prototype, n), o && LOe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function WOe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function HOe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? WOe(Object(r), !0).forEach(function (t) {
          JOe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : WOe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function JOe(e, t, r) {
      return (t = QOe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function YOe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, QOe(n.key), n);
      }
    }

    function QOe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function $Oe(e, t, r) {
      return t = eje(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], eje(e).constructor) : t.apply(e, r));
    }

    function XOe() {
      return (XOe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = ZOe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function ZOe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = eje(e)););

      return e;
    }

    function eje(e) {
      return (eje = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function tje(e, t) {
      return (tje = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var rje = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), $Oe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && tje(e, t);
      }(t, Object(w["MixInto"])(w["AccountWithPath"])(w["reportableMixin"])), function (e, t, r) {
        return t && YOe(e.prototype, t), r && YOe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = XOe(eje(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return HOe(HOe({}, a), {}, {
            clientPath: HOe(HOe({}, a.clientPath), {}, {
              modelClass: GOe
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition || {},
              t = e.id,
              r = e.serial,
              n = e.name,
              o = e.type,
              i = {
            id: t,
            serial: r,
            name: n
          },
              a = HOe(HOe({}, i), {}, {
            type: o,
            clientPathString: {
              name: "Client Path String",
              key: "clientPathString",
              type: "string"
            }
          });
          return $H.getConfig("useNewReports") ? i : a;
        }
      }]);
    }();

    rje.defaultKey = "clientPathString";
    var nje = rje;

    function oje(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function ije(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? oje(Object(r), !0).forEach(function (t) {
          aje(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : oje(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function aje(e, t, r) {
      return (t = uje(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function cje(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, uje(n.key), n);
      }
    }

    function uje(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function lje(e, t, r) {
      return t = sje(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], sje(e).constructor) : t.apply(e, r));
    }

    function sje(e) {
      return (sje = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function pje(e, t) {
      return (pje = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var fje = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), lje(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && pje(e, t);
      }(t, Object(w["MixInto"])(w["Formulation"])(w["reportableMixin"])), r = t, o = [{
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.type,
              r = {
            description: e.description,
            baseUnit: e.baseUnit
          },
              n = ije(ije({}, r), {}, {
            baseUnit: ije(ije({}, r.baseUnit), {}, {
              backendKey: "base_unit"
            })
          }),
              o = ije(ije({}, r), {}, {
            type: t
          });
          return $H.getConfig("useNewReports") ? n : o;
        }
      }], (n = null) && cje(r.prototype, n), o && cje(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    fje.defaultKey = "description";
    var dje = fje;

    function bje(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function yje(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? bje(Object(r), !0).forEach(function (t) {
          mje(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bje(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function mje(e, t, r) {
      return (t = hje(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function vje(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, hje(n.key), n);
      }
    }

    function hje(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function gje(e, t, r) {
      return t = wje(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], wje(e).constructor) : t.apply(e, r));
    }

    function wje(e) {
      return (wje = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Oje(e, t) {
      return (Oje = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var jje = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), gje(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Oje(e, t);
      }(t, Object(w["MixInto"])(w["ModeOfAction"])(w["reportableMixin"])), r = t, o = [{
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.id,
              r = e.type,
              n = {
            id: t,
            action: e.action,
            groupNumber: e.groupNumber,
            description: e.description
          },
              o = yje(yje({}, n), {}, {
            type: r
          });
          return $H.getConfig("useNewReports") ? n : o;
        }
      }], (n = null) && vje(r.prototype, n), o && vje(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    jje.defaultKey = "action";
    var Pje = jje;

    function _je(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Eje(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? _je(Object(r), !0).forEach(function (t) {
          Sje(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _je(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Sje(e, t, r) {
      return (t = kje(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Cje(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, kje(n.key), n);
      }
    }

    function kje(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Rje(e, t, r) {
      return t = Nje(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Nje(e).constructor) : t.apply(e, r));
    }

    function Tje() {
      return (Tje = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = zje(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function zje(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = Nje(e)););

      return e;
    }

    function Nje(e) {
      return (Nje = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Dje(e, t) {
      return (Dje = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var xje = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Rje(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Dje(e, t);
      }(t, Object(w["MixInto"])(w["ActiveIngredient"])(w["reportableMixin"])), function (e, t, r) {
        return t && Cje(e.prototype, t), r && Cje(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = Tje(Nje(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return Eje(Eje({}, a), {}, {
            liquidConcentration: Eje(Eje({}, a.liquidConcentration), {}, {
              modelClass: Dge
            }),
            modesOfAction: Eje(Eje({}, a.modesOfAction), {}, {
              modelClass: Pje
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.id,
              r = e.name,
              n = e.type,
              o = {
            id: t,
            name: r,
            shortName: e.shortName,
            cas: e.cas,
            pcCode: e.pcCode,
            percent: e.percent,
            liquidConcentration: e.liquidConcentration,
            modesOfAction: e.modesOfAction,
            toxicityClass: e.toxicityClass,
            toxicityCategory: e.toxicityCategory,
            alternateNames: e.alternateNames
          },
              i = Eje(Eje({}, o), {}, {
            shortName: Eje(Eje({}, o.shortName), {}, {
              backendKey: "short_name"
            }),
            pcCode: Eje(Eje({}, o.pcCode), {}, {
              backendKey: "pc_code"
            }),
            liquidConcentration: Eje(Eje({}, o.liquidConcentration), {}, {
              type: "string",
              modelClass: null,
              backendKey: "liquid_concentration",
              calculable: !0
            }),
            modesOfAction: Eje(Eje({}, o.modesOfAction), {}, {
              backendKey: "modes_of_action"
            }),
            toxicityCategory: Eje(Eje({}, o.toxicityCategory), {}, {
              backendKey: "toxicity_category"
            }),
            toxicityClass: Eje(Eje({}, o.toxicityClass), {}, {
              backendKey: "toxicity_class"
            }),
            alternateNames: Eje(Eje({}, o.alternateNames), {}, {
              backendKey: "alternate_names"
            })
          }),
              a = Eje(Eje({}, o), {}, {
            type: n
          });
          return $H.getConfig("useNewReports") ? i : a;
        }
      }]);
    }();

    function Aje(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Mje(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Aje(Object(r), !0).forEach(function (t) {
          Ije(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Aje(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Ije(e, t, r) {
      return (t = Bje(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Fje(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Bje(n.key), n);
      }
    }

    function Bje(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Lje(e, t, r) {
      return t = Vje(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Vje(e).constructor) : t.apply(e, r));
    }

    function Vje(e) {
      return (Vje = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Uje(e, t) {
      return (Uje = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var qje = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Lje(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Uje(e, t);
      }(t, Object(w["MixInto"])(w["NutrientAnalysis"])(w["reportableMixin"])), r = t, o = [{
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.n,
              r = e.p,
              n = e.k,
              o = e.s,
              i = e.ca,
              a = e.mg,
              c = e.al,
              u = e.b,
              l = e.cu,
              s = e.fe,
              p = e.mn,
              f = e.mo,
              d = e.si,
              b = e.zn,
              y = e.humicAcid,
              m = {
            n: Mje(Mje({}, t), {}, {
              calculable: !0
            }),
            p: Mje(Mje({}, r), {}, {
              calculable: !0
            }),
            k: Mje(Mje({}, n), {}, {
              calculable: !0
            }),
            s: Mje(Mje({}, o), {}, {
              calculable: !0
            }),
            ca: Mje(Mje({}, i), {}, {
              calculable: !0
            }),
            mg: Mje(Mje({}, a), {}, {
              calculable: !0
            }),
            al: Mje(Mje({}, c), {}, {
              calculable: !0
            }),
            b: Mje(Mje({}, u), {}, {
              calculable: !0
            }),
            cu: Mje(Mje({}, l), {}, {
              calculable: !0
            }),
            fe: Mje(Mje({}, s), {}, {
              calculable: !0
            }),
            mn: Mje(Mje({}, p), {}, {
              calculable: !0
            }),
            mo: Mje(Mje({}, f), {}, {
              calculable: !0
            }),
            si: Mje(Mje({}, d), {}, {
              calculable: !0
            }),
            zn: Mje(Mje({}, b), {}, {
              calculable: !0
            }),
            humicAcid: Mje(Mje({}, y), {}, {
              calculable: !0
            })
          },
              v = Mje(Mje({}, m), {}, {
            label: {
              name: "Label",
              key: "label",
              type: "string"
            }
          });
          return $H.getConfig("useNewReports") ? m : v;
        }
      }], (n = null) && Fje(r.prototype, n), o && Fje(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    qje.defaultKey = "label";
    var Kje = qje;

    function Gje(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Wje(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Gje(Object(r), !0).forEach(function (t) {
          Hje(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Gje(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Hje(e, t, r) {
      return (t = Yje(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Jje(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Yje(n.key), n);
      }
    }

    function Yje(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Qje(e, t, r) {
      return t = $je(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], $je(e).constructor) : t.apply(e, r));
    }

    function $je(e) {
      return ($je = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Xje(e, t) {
      return (Xje = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Zje = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Qje(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Xje(e, t);
      }(t, Object(w["MixInto"])(w["OrganicListing"])(w["reportableMixin"])), r = t, o = [{
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.serial,
              r = e.createdAt,
              n = e.updatedAt,
              o = e.type,
              i = {
            serial: t,
            createdAt: r,
            updatedAt: n,
            reference: e.reference,
            agency: e.agency,
            number: e.number,
            expires: e.expires
          },
              a = Wje({}, i),
              c = Wje(Wje({}, i), {}, {
            type: o
          });
          return $H.getConfig("useNewReports") ? a : c;
        }
      }], (n = null) && Jje(r.prototype, n), o && Jje(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    Zje.defaultKey = "reference";
    var ePe = Zje;

    function tPe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function rPe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? tPe(Object(r), !0).forEach(function (t) {
          nPe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : tPe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function nPe(e, t, r) {
      return (t = iPe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function oPe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, iPe(n.key), n);
      }
    }

    function iPe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function aPe(e, t, r) {
      return t = lPe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], lPe(e).constructor) : t.apply(e, r));
    }

    function cPe() {
      return (cPe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = uPe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function uPe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = lPe(e)););

      return e;
    }

    function lPe(e) {
      return (lPe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function sPe(e, t) {
      return (sPe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var pPe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), aPe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && sPe(e, t);
      }(t, Object(w["MixInto"])(w["ProductCropLabel"])(w["reportableMixin"])), function (e, t, r) {
        return t && oPe(e.prototype, t), r && oPe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = cPe(lPe(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return rPe(rPe({}, a), {}, {
            phi: rPe(rPe({}, a.phi), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            rei: rPe(rPe({}, a.rei), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            minSprayRate: rPe(rPe({}, a.minSprayRate), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            minTreatmentInterval: rPe(rPe({}, a.minTreatmentInterval), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            maxPerApplication: rPe(rPe({}, a.maxPerApplication), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            maxPerYear: rPe(rPe({}, a.maxPerYear), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.id,
              r = e.type,
              n = {
            id: t,
            serial: e.serial,
            createdAt: e.createdAt,
            updatedAt: e.updatedAt,
            crop: e.crop,
            applicationMethods: e.applicationMethods,
            phi: e.phi,
            rei: e.rei,
            minSprayRate: e.minSprayRate,
            minTreatmentInterval: e.minTreatmentInterval,
            maxApplicationsPerYear: e.maxApplicationsPerYear,
            maxPerApplication: e.maxPerApplication,
            maxPerYear: e.maxPerYear,
            productId: e.productId,
            specialConditions: e.specialConditions
          },
              o = rPe(rPe({}, n), {}, {
            applicationMethods: rPe(rPe({}, n.applicationMethods), {}, {
              backendKey: "application_methods"
            }),
            phi: rPe(rPe({}, n.phi), {}, {
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            }),
            rei: rPe(rPe({}, n.rei), {}, {
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            }),
            minSprayRate: rPe(rPe({}, n.minSprayRate), {}, {
              backendKey: "min_spray_rate",
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            }),
            minTreatmentInterval: rPe(rPe({}, n.minTreatmentInterval), {}, {
              backendKey: "min_treatment_interval",
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            }),
            maxApplicationsPerYear: rPe(rPe({}, n.maxApplicationsPerYear), {}, {
              backendKey: "max_applications_per_year"
            }),
            maxPerApplication: rPe(rPe({}, n.maxPerApplication), {}, {
              backendKey: "max_per_application",
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            }),
            maxPerYear: rPe(rPe({}, n.maxPerYear), {}, {
              backendKey: "max_per_year",
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            }),
            productId: rPe(rPe({}, n.productId), {}, {
              backendKey: "product_id"
            }),
            specialConditions: rPe(rPe({}, n.specialConditions), {}, {
              backendKey: "special_conditions"
            })
          }),
              i = rPe(rPe({}, n), {}, {
            type: r
          });
          return $H.getConfig("useNewReports") ? o : i;
        }
      }]);
    }();

    pPe.defaultKey = "crop";
    var fPe,
        dPe = pPe;

    function bPe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function yPe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? bPe(Object(r), !0).forEach(function (t) {
          mPe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bPe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function mPe(e, t, r) {
      return (t = hPe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function vPe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, hPe(n.key), n);
      }
    }

    function hPe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function gPe(e, t, r) {
      return t = jPe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], jPe(e).constructor) : t.apply(e, r));
    }

    function wPe() {
      return (wPe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = OPe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function OPe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = jPe(e)););

      return e;
    }

    function jPe(e) {
      return (jPe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function PPe(e, t) {
      return (PPe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var _Pe,
        EPe,
        SPe,
        CPe,
        kPe,
        RPe,
        TPe,
        zPe = (function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((fPe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), gPe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && PPe(e, t);
      }(t, Object(w["MixInto"])(w["Product"])(w["reportableMixin"])), function (e, t, r) {
        return t && vPe(e.prototype, t), r && vPe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "activeIngredientList",
        get: function () {
          return this.activeIngredients.map(function (e) {
            return e.name;
          }).filter(Boolean).join(", ");
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = wPe(jPe(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return yPe(yPe({}, a), {}, {
            account: yPe(yPe({}, a.account), {}, {
              modelClass: nje,
              defaultValue: new nje()
            }),
            formulation: yPe(yPe({}, a.formulation), {}, {
              modelClass: dje,
              defaultValue: new dje()
            }),
            activeIngredients: yPe(yPe({}, a.activeIngredients), {}, {
              modelClass: xje
            }),
            nutrientAnalysis: yPe(yPe({}, a.nutrientAnalysis), {}, {
              modelClass: Kje
            }),
            organicListings: yPe(yPe({}, a.organicListings), {}, {
              modelClass: ePe
            }),
            cropLabels: yPe(yPe({}, a.cropLabels), {}, {
              modelClass: dPe
            }),
            massPerVolume: yPe(yPe({}, a.massPerVolume), {}, {
              modelClass: Dge
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.id,
              r = e.serial,
              n = e.name,
              o = e.type,
              i = e.createdAt,
              a = e.updatedAt,
              c = e.account,
              u = e.manufacturer,
              l = e.epaNumber,
              s = e.signalWord,
              p = e.productType,
              f = e.use,
              d = e.formulation,
              b = e.alternateNames,
              y = e.activeIngredients,
              m = e.nutrientAnalysis,
              v = e.labelUrl,
              h = e.sdsUrl,
              g = e.beeHazard,
              w = e.organic,
              O = e.organicListings,
              j = e.notes,
              P = e.reviewedAt,
              _ = e.inactive,
              E = e.cropLabels,
              S = e.acheInhibitor,
              C = e.targetRatesRequired,
              k = e.registrationNumber,
              R = {
            id: t,
            serial: r,
            name: n,
            createdAt: i,
            updatedAt: a,
            account: c,
            manufacturer: u,
            epaNumber: l,
            signalWord: s,
            productType: p,
            use: f,
            formulation: d,
            alternateNames: b,
            activeIngredients: y,
            nutrientAnalysis: m,
            labelUrl: v,
            sdsUrl: h,
            beeHazard: g,
            organic: w,
            organicListings: O,
            notes: j,
            reviewedAt: P,
            inactive: _,
            cropLabels: E,
            acheInhibitor: S,
            targetRatesRequired: C,
            massPerVolume: e.massPerVolume
          },
              T = yPe(yPe({}, R), {}, {
            acheInhibitor: yPe(yPe({}, R.acheInhibitor), {}, {
              backendKey: "ache_inhibitor"
            }),
            cropLabels: yPe(yPe({}, R.cropLabels), {}, {
              backendKey: "crop_labels"
            }),
            labelUrl: yPe(yPe({}, R.labelUrl), {}, {
              backendKey: "label_url"
            }),
            beeHazard: yPe(yPe({}, R.beeHazard), {}, {
              backendKey: "bee_hazard"
            }),
            targetRatesRequired: yPe(yPe({}, R.targetRatesRequired), {}, {
              backendKey: "target_rates_required"
            }),
            massPerVolume: yPe(yPe({}, R.massPerVolume), {}, {
              type: "string",
              modelClass: null,
              backendKey: "mass_per_volume",
              calculable: !0
            }),
            organicListings: yPe(yPe({}, R.organicListings), {}, {
              backendKey: "organic_listings"
            }),
            sdsUrl: yPe(yPe({}, R.sdsUrl), {}, {
              backendKey: "sds_url"
            })
          }),
              z = yPe(yPe({}, R), {}, {
            type: o,
            activeIngredientList: {
              name: "Active Ingredient List",
              key: "activeIngredientList",
              type: "string"
            },
            nutrient: {
              key: "hasNutrientAnalysis",
              type: "boolean"
            },
            registrationNumber: k,
            displayStateRegistration: {
              name: "State Registration",
              key: "displayStateRegistration",
              type: "string"
            }
          });
          return $H.getConfig("useNewReports") ? T : z;
        }
      }]);
    }()).prototype, "activeIngredientList", [f.computed], Object.getOwnPropertyDescriptor(fPe.prototype, "activeIngredientList"), fPe.prototype), fPe);

    function NPe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function DPe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, xPe(n.key), n);
      }
    }

    function xPe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function APe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var MPe,
        IPe,
        FPe,
        BPe,
        LPe = (EPe = APe((_Pe = function () {
      return e = function e() {
        var t = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.reader = void 0, NPe(this, "isDownloading", EPe, this), NPe(this, "contentLength", SPe, this), NPe(this, "receivedLength", CPe, this), NPe(this, "done", kPe, this), NPe(this, "receive", RPe, this), NPe(this, "reset", TPe, this), this.pump = function (e) {
          return t.reader.read().then(function (r) {
            var n = r.done,
                o = r.value;
            return n ? (e.close(), void t.done()) : (t.receive(o), e.enqueue(o), t.pump(e));
          });
        };
      }, (t = [{
        key: "progress",
        get: function () {
          return this.contentLength && Math.round(this.receivedLength / this.contentLength * 100) || 0;
        }
      }, {
        key: "download",
        value: function (e) {
          var t = this;
          return this.reader = e.body.getReader(), Object(f.runInAction)(function () {
            t.contentLength = +e.headers.get("Content-Length"), t.receivedLength = 0, t.isDownloading = !0;
          }), new Response(new ReadableStream({
            start: this.pump
          }));
        }
      }]) && DPe(e.prototype, t), r && DPe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "isDownloading", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), SPe = APe(_Pe.prototype, "contentLength", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), CPe = APe(_Pe.prototype, "receivedLength", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), APe(_Pe.prototype, "progress", [f.computed], Object.getOwnPropertyDescriptor(_Pe.prototype, "progress"), _Pe.prototype), kPe = APe(_Pe.prototype, "done", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isDownloading = !1;
        };
      }
    }), RPe = APe(_Pe.prototype, "receive", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.receivedLength += t.length;
        };
      }
    }), TPe = APe(_Pe.prototype, "reset", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isDownloading = !1, e.receivedLength = 0;
        };
      }
    }), _Pe);

    function VPe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function UPe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qPe(n.key), n);
      }
    }

    function qPe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function KPe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var GPe,
        WPe,
        HPe,
        JPe,
        YPe,
        QPe,
        $Pe,
        XPe,
        ZPe,
        e_e,
        t_e,
        r_e,
        n_e = (IPe = KPe((MPe = function () {
      return e = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), VPe(this, "duration", IPe, this), VPe(this, "progress", FPe, this), VPe(this, "id", BPe, this);
      }, (t = [{
        key: "baseline",
        get: function () {
          return this.duration / 100;
        }
      }, {
        key: "cancel",
        value: function () {
          var e = this;
          cancelAnimationFrame(this.id), Object(f.runInAction)(function () {
            e.progress = 100;
          });
        }
      }, {
        key: "nextInterval",
        value: function () {
          return this.progress < 25 ? Math.ceil(Math.random() * Math.ceil(.25 * this.baseline)) : this.progress < 50 ? Math.ceil(.25 * this.baseline + Math.random() * Math.ceil(this.baseline)) : this.progress < 75 ? Math.ceil(this.baseline + Math.random() * Math.ceil(2 * this.baseline)) : this.progress < 80 ? Math.ceil(2 * this.baseline + Math.random() * Math.ceil(4 * this.baseline)) : this.progress < 90 ? Math.ceil(3 * this.baseline + Math.random() * Math.ceil(4 * this.baseline)) : Math.ceil(4 * this.baseline + Math.random() * Math.ceil(8 * this.baseline));
        }
      }, {
        key: "start",
        value: function (e) {
          var t,
              r,
              n = this;
          Object(f.runInAction)(function () {
            n.progress = 0, n.duration = e;
          });
          var o = this.nextInterval(0);
          requestAnimationFrame(function e(i) {
            null == t && (t = i, r = t);
            var a = i - t;
            i - r >= o && (Object(f.runInAction)(function () {
              n.progress += 1;
            }), r = i, o = n.nextInterval(a)), n.progress < 100 && requestAnimationFrame(e);
          });
        }
      }]) && UPe(e.prototype, t), r && UPe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "duration", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), FPe = KPe(MPe.prototype, "progress", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), BPe = KPe(MPe.prototype, "id", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), KPe(MPe.prototype, "baseline", [f.computed], Object.getOwnPropertyDescriptor(MPe.prototype, "baseline"), MPe.prototype), MPe);

    function o_e(e, t, r) {
      return t = u_e(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, a_e() ? Reflect.construct(t, r || [], u_e(e).constructor) : t.apply(e, r));
    }

    function i_e(e) {
      var t = "function" == typeof Map ? new Map() : void 0;
      return (i_e = function (e) {
        if (null === e || !function (e) {
          try {
            return -1 !== Function.toString.call(e).indexOf("[native code]");
          } catch (t) {
            return "function" == typeof e;
          }
        }(e)) return e;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== t) {
          if (t.has(e)) return t.get(e);
          t.set(e, r);
        }

        function r() {
          return function (e, t, r) {
            if (a_e()) return Reflect.construct.apply(null, arguments);
            var n = [null];
            n.push.apply(n, t);
            var o = new (e.bind.apply(e, n))();
            return r && c_e(o, r.prototype), o;
          }(e, arguments, u_e(this).constructor);
        }

        return r.prototype = Object.create(e.prototype, {
          constructor: {
            value: r,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), c_e(r, e);
      })(e);
    }

    function a_e() {
      try {
        var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      } catch (e) {}

      return (a_e = function () {
        return !!e;
      })();
    }

    function c_e(e, t) {
      return (c_e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function u_e(e) {
      return (u_e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function l_e(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function s_e(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? l_e(Object(r), !0).forEach(function (t) {
          p_e(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l_e(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function p_e(e, t, r) {
      return (t = h_e(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function f_e() {
      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      f_e = function () {
        return t;
      };

      var e,
          t = {},
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = Object.defineProperty || function (e, t, r) {
        e[t] = r.value;
      },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          u = i.toStringTag || "@@toStringTag";

      function l(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        l({}, "");
      } catch (e) {
        l = function (e, t, r) {
          return e[t] = r;
        };
      }

      function s(e, t, r, n) {
        var i = t && t.prototype instanceof v ? t : v,
            a = Object.create(i.prototype),
            c = new T(n || []);
        return o(a, "_invoke", {
          value: S(e, r, c)
        }), a;
      }

      function p(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      t.wrap = s;
      var f = "suspendedStart",
          d = "suspendedYield",
          b = "executing",
          y = "completed",
          m = {};

      function v() {}

      function h() {}

      function g() {}

      var w = {};
      l(w, a, function () {
        return this;
      });
      var O = Object.getPrototypeOf,
          j = O && O(O(z([])));
      j && j !== r && n.call(j, a) && (w = j);
      var P = g.prototype = v.prototype = Object.create(w);

      function _(e) {
        ["next", "throw", "return"].forEach(function (t) {
          l(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function E(e, t) {
        function r(o, i, a, c) {
          var u = p(e[o], e, i);

          if ("throw" !== u.type) {
            var l = u.arg,
                s = l.value;
            return s && "object" == typeof s && n.call(s, "__await") ? t.resolve(s.__await).then(function (e) {
              r("next", e, a, c);
            }, function (e) {
              r("throw", e, a, c);
            }) : t.resolve(s).then(function (e) {
              l.value = e, a(l);
            }, function (e) {
              return r("throw", e, a, c);
            });
          }

          c(u.arg);
        }

        var i;
        o(this, "_invoke", {
          value: function (e, n) {
            function o() {
              return new t(function (t, o) {
                r(e, n, t, o);
              });
            }

            return i = i ? i.then(o, o) : o();
          }
        });
      }

      function S(t, r, n) {
        var o = f;
        return function (i, a) {
          if (o === b) throw Error("Generator is already running");

          if (o === y) {
            if ("throw" === i) throw a;
            return {
              value: e,
              done: !0
            };
          }

          for (n.method = i, n.arg = a;;) {
            var c = n.delegate;

            if (c) {
              var u = C(c, n);

              if (u) {
                if (u === m) continue;
                return u;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (o === f) throw o = y, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            o = b;
            var l = p(t, r, n);

            if ("normal" === l.type) {
              if (o = n.done ? y : d, l.arg === m) continue;
              return {
                value: l.arg,
                done: n.done
              };
            }

            "throw" === l.type && (o = y, n.method = "throw", n.arg = l.arg);
          }
        };
      }

      function C(t, r) {
        var n = r.method,
            o = t.iterator[n];
        if (o === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, C(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), m;
        var i = p(o, t.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, m;
        var a = i.arg;
        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, m) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m);
      }

      function k(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function R(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function T(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(k, this), this.reset(!0);
      }

      function z(t) {
        if (t || "" === t) {
          var r = t[a];
          if (r) return r.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var o = -1,
                i = function r() {
              for (; ++o < t.length;) if (n.call(t, o)) return r.value = t[o], r.done = !1, r;

              return r.value = e, r.done = !0, r;
            };

            return i.next = i;
          }
        }

        throw new TypeError(typeof t + " is not iterable");
      }

      return h.prototype = g, o(P, "constructor", {
        value: g,
        configurable: !0
      }), o(g, "constructor", {
        value: h,
        configurable: !0
      }), h.displayName = l(g, u, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === h || "GeneratorFunction" === (t.displayName || t.name));
      }, t.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, l(e, u, "GeneratorFunction")), e.prototype = Object.create(P), e;
      }, t.awrap = function (e) {
        return {
          __await: e
        };
      }, _(E.prototype), l(E.prototype, c, function () {
        return this;
      }), t.AsyncIterator = E, t.async = function (e, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new E(s(e, r, n, o), i);
        return t.isGeneratorFunction(r) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, _(P), l(P, u, "Generator"), l(P, a, function () {
        return this;
      }), l(P, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (e) {
        var t = Object(e),
            r = [];

        for (var n in t) r.push(n);

        return r.reverse(), function e() {
          for (; r.length;) {
            var n = r.pop();
            if (n in t) return e.value = n, e.done = !1, e;
          }

          return e.done = !0, e;
        };
      }, t.values = z, T.prototype = {
        constructor: T,
        reset: function (t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(R), !t) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
        },
        stop: function () {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function (t) {
          if (this.done) throw t;
          var r = this;

          function o(n, o) {
            return c.type = "throw", c.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
                c = a.completion;
            if ("root" === a.tryLoc) return o("end");

            if (a.tryLoc <= this.prev) {
              var u = n.call(a, "catchLoc"),
                  l = n.call(a, "finallyLoc");

              if (u && l) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!l) throw Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function (e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(a);
        },
        complete: function (e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
        },
        finish: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), R(r), m;
          }
        },
        catch: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                R(r);
              }

              return o;
            }
          }

          throw Error("illegal catch attempt");
        },
        delegateYield: function (t, r, n) {
          return this.delegate = {
            iterator: z(t),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = e), m;
        }
      }, t;
    }

    function d_e(e, t, r, n, o, i, a) {
      try {
        var c = e[i](a),
            u = c.value;
      } catch (e) {
        return void r(e);
      }

      c.done ? t(u) : Promise.resolve(u).then(n, o);
    }

    function b_e(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function y_e(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function m_e(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, h_e(n.key), n);
      }
    }

    function v_e(e, t, r) {
      return t && m_e(e.prototype, t), r && m_e(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function h_e(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function g_e(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var w_e = ((r_e = function () {
      function e(t, r) {
        var n = this;
        y_e(this, e), this.api = void 0, this.rawRecords = [], this.progressFaker = new n_e(), this._newResults = void 0, b_e(this, "batchSize", WPe, this), b_e(this, "batchInfo", HPe, this), b_e(this, "pushProgress", JPe, this), b_e(this, "recordLimit", YPe, this), b_e(this, "storeItemsLimit", QPe, this), b_e(this, "maxServerTimeEstimate", $Pe, this), b_e(this, "items", XPe, this), b_e(this, "status", ZPe, this), b_e(this, "filtersForLastQuery", e_e, this), b_e(this, "totalResults", t_e, this), this.fetchEachBatch = function () {
          var e,
              t = (e = f_e().mark(function e(t, r) {
            var o, i, a;
            return f_e().wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  o = [], n._newResults = new Array(n.batchInfo.length), i = 0, a = n.batchInfo.length;

                case 3:
                  if (!(i < a)) {
                    e.next = 14;
                    break;
                  }

                  return e.t0 = o, e.t1 = n.batchInfo[i], e.next = 8, n.fetchBatch(n.batchInfo[i], t, r);

                case 8:
                  e.t2 = e.sent, e.t3 = {
                    batch: e.t1,
                    response: e.t2
                  }, e.t0.push.call(e.t0, e.t3);

                case 11:
                  i += 1, e.next = 3;
                  break;

                case 14:
                  return e.next = 16, Promise.all(o.map(function (e) {
                    return n.processBatch(e.batch, e.response);
                  }));

                case 16:
                  return e.abrupt("return", n.reduceResults());

                case 17:
                case "end":
                  return e.stop();
              }
            }, e);
          }), function () {
            var t = this,
                r = arguments;
            return new Promise(function (n, o) {
              var i = e.apply(t, r);

              function a(e) {
                d_e(i, n, o, a, c, "next", e);
              }

              function c(e) {
                d_e(i, n, o, a, c, "throw", e);
              }

              a(void 0);
            });
          });
          return function (e, r) {
            return t.apply(this, arguments);
          };
        }(), this.api = t, r && (this.recordLimit = r);
      }

      return v_e(e, [{
        key: "progress",
        get: function () {
          var e;
          return null !== (e = this.batchInfo) && void 0 !== e && e.length ? Math.round(.2 * this.progressFaker.progress + this.batchInfo.reduce(function (e, t) {
            return e + t.downloader.progress + t.pushProgress;
          }, 0) / this.batchInfo.length * .4) : 0;
        }
      }, {
        key: "totalBatches",
        get: function () {
          return Math.floor(this.totalResults / this.batchSize) + (this.totalResults % this.batchSize ? 1 : 0);
        }
      }, {
        key: "isPending",
        get: function () {
          return "ready" !== this.status;
        }
      }, {
        key: "isFetching",
        get: function () {
          return "fetching" === this.status;
        }
      }, {
        key: "isDownloading",
        get: function () {
          return "downloading" === this.status;
        }
      }, {
        key: "isPushing",
        get: function () {
          return "pushing" === this.status;
        }
      }, {
        key: "clear",
        value: function () {
          this.items = [];
        }
      }, {
        key: "fetchAll",
        value: function () {
          var e = this;
          return this.status = "fetching", this.pushProgress = 0, this.progressFaker.start(this.maxServerTimeEstimate), this.rawRecords = [], this.items = [], this._newResults = new Array(1), this.batchInfo = [{
            batchNum: 0,
            downloader: new LPe(),
            pushProgress: 0
          }], this.api.fetchAll().then(function (t) {
            return e.processBatch(e.batchInfo[0], t);
          }).then(function () {
            return e.reduceResults();
          }).then(function () {
            return e.items;
          }).catch(function (e) {
            console.error(e);
          }).finally(function () {
            e.progressFaker.cancel(), Object(f.runInAction)(function () {
              e.status = "ready", e.batchInfo = null;
            });
          });
        }
      }, {
        key: "extractCollection",
        value: function (e) {
          return e[this.collectionKey];
        }
      }, {
        key: "reduceResults",
        value: function () {
          this.items = this._newResults.reduce(function (e, t) {
            return e.concat(t.storeItems || []);
          }, []), this.rawRecords = this._newResults.reduce(function (e, t) {
            return e.concat(t.rawRecords);
          }, []), this._newResults = null;
        }
      }, {
        key: "processBatch",
        value: function (e, t) {
          var r = this;
          return this.status = "downloading", this.progressFaker.cancel(), e.downloader.download(t).json().then(function (t) {
            return r.pushBatch(e, r.extractCollection(t));
          });
        }
      }, {
        key: "fetchBatch",
        value: function (e, t, r) {
          return this.api.fetchAllForAccounts(t, s_e({
            limit: this.batchSize,
            offset: this.batchSize * e.batchNum
          }, r));
        }
      }, {
        key: "fetchAllForAccounts",
        value: function (t) {
          var r = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              o = n.filters;
          return o && (this.filtersForLastQuery = o), this.status = "fetching", this.pushProgress = 0, this.progressFaker.start(this.maxServerTimeEstimate), this.rawRecords = [], this.items = [], this.api.fetchAllForAccounts(t, s_e({
            limit: 1,
            offset: 0
          }, n)).then(function (e) {
            return e.json();
          }).then(function (o) {
            if ("error" === o.status) throw new Error(o.message);
            return Object(f.runInAction)(function () {
              if (r.totalResults = (null == o ? void 0 : o.totalResults) || 0, r.totalResults > r.recordLimit) throw new e.RecordLimitExceededError();
              r.batchInfo = Object(x.range)(0, r.totalBatches).map(function (e) {
                return {
                  batchNum: e,
                  downloader: new LPe(),
                  pushProgress: 0
                };
              });
            }), r.fetchEachBatch(t, n);
          }).then(function () {
            return r.items;
          }).catch(function (t) {
            if (t instanceof e.RecordLimitExceededError) throw t;
            console.error(t);
          }).finally(function () {
            r.progressFaker.cancel(), Object(f.runInAction)(function () {
              r.status = "ready", r.batchInfo = null;
            });
          });
        }
      }, {
        key: "find",
        value: function (e) {
          return this.items.find(function (t) {
            return t.id === e;
          });
        }
      }, {
        key: "getQueryFilters",
        value: function (e) {
          return {};
        }
      }, {
        key: "isFilterRefinement",
        value: function (e) {
          return !0;
        }
      }, {
        key: "new",
        value: function () {
          throw new Error("Not implemented in base class.  Must override in derived class");
        }
      }, {
        key: "push",
        value: function (e) {
          var t = this.find(e.id);
          return t ? t.update(e) : (t = this.new(e), this.items.push(t)), t;
        }
      }, {
        key: "pushBatch",
        value: function (e, t) {
          var r = this;
          this.status = "pushing";
          var n = {
            rawRecords: t,
            storeItems: []
          };
          this._newResults[e.batchNum] = n;
          var o = this.batchSize * e.batchNum;
          if (o >= this.storeItemsLimit) return Promise.resolve(n);
          var i = this.storeItemsLimit - o,
              a = t.slice(0, i);
          return new Promise(function (t) {
            var o = 0;
            requestAnimationFrame(function i() {
              n.storeItems.push(r.new(a[o])), o += 1, Object(f.runInAction)(function () {
                e.pushProgress = Math.round(o / a.length * 100);
              }), o < a.length ? requestAnimationFrame(i) : (t(n), n = null);
            });
          });
        }
      }]);
    }()).RecordLimitExceededError = function (e) {
      function t() {
        var e;
        y_e(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = o_e(this, t, [].concat(n))).name = e.constructor.name, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && c_e(e, t);
      }(t, i_e(Error)), v_e(t);
    }(), WPe = g_e((GPe = r_e).prototype, "batchSize", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 50;
      }
    }), HPe = g_e(GPe.prototype, "batchInfo", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), JPe = g_e(GPe.prototype, "pushProgress", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), YPe = g_e(GPe.prototype, "recordLimit", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 1e4;
      }
    }), QPe = g_e(GPe.prototype, "storeItemsLimit", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 1e3;
      }
    }), $Pe = g_e(GPe.prototype, "maxServerTimeEstimate", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 3e4;
      }
    }), XPe = g_e(GPe.prototype, "items", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), ZPe = g_e(GPe.prototype, "status", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "ready";
      }
    }), e_e = g_e(GPe.prototype, "filtersForLastQuery", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), t_e = g_e(GPe.prototype, "totalResults", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), g_e(GPe.prototype, "progress", [f.computed], Object.getOwnPropertyDescriptor(GPe.prototype, "progress"), GPe.prototype), g_e(GPe.prototype, "totalBatches", [f.computed], Object.getOwnPropertyDescriptor(GPe.prototype, "totalBatches"), GPe.prototype), g_e(GPe.prototype, "isPending", [f.computed], Object.getOwnPropertyDescriptor(GPe.prototype, "isPending"), GPe.prototype), g_e(GPe.prototype, "isFetching", [f.computed], Object.getOwnPropertyDescriptor(GPe.prototype, "isFetching"), GPe.prototype), g_e(GPe.prototype, "isDownloading", [f.computed], Object.getOwnPropertyDescriptor(GPe.prototype, "isDownloading"), GPe.prototype), g_e(GPe.prototype, "isPushing", [f.computed], Object.getOwnPropertyDescriptor(GPe.prototype, "isPushing"), GPe.prototype), g_e(GPe.prototype, "clear", [f.action], Object.getOwnPropertyDescriptor(GPe.prototype, "clear"), GPe.prototype), g_e(GPe.prototype, "fetchAll", [f.action], Object.getOwnPropertyDescriptor(GPe.prototype, "fetchAll"), GPe.prototype), g_e(GPe.prototype, "reduceResults", [f.action], Object.getOwnPropertyDescriptor(GPe.prototype, "reduceResults"), GPe.prototype), g_e(GPe.prototype, "processBatch", [f.action], Object.getOwnPropertyDescriptor(GPe.prototype, "processBatch"), GPe.prototype), g_e(GPe.prototype, "fetchBatch", [f.action], Object.getOwnPropertyDescriptor(GPe.prototype, "fetchBatch"), GPe.prototype), g_e(GPe.prototype, "fetchAllForAccounts", [f.action], Object.getOwnPropertyDescriptor(GPe.prototype, "fetchAllForAccounts"), GPe.prototype), g_e(GPe.prototype, "push", [f.action], Object.getOwnPropertyDescriptor(GPe.prototype, "push"), GPe.prototype), g_e(GPe.prototype, "pushBatch", [f.action], Object.getOwnPropertyDescriptor(GPe.prototype, "pushBatch"), GPe.prototype), GPe);

    function O_e(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, j_e(n.key), n);
      }
    }

    function j_e(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function P_e(e, t, r) {
      return t = __e(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], __e(e).constructor) : t.apply(e, r));
    }

    function __e(e) {
      return (__e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function E_e(e, t) {
      return (E_e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var S_e = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), P_e(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && E_e(e, t);
      }(t, w_e), r = t, (n = [{
        key: "extractCollection",
        value: function (e) {
          return e;
        }
      }, {
        key: "new",
        value: function (e) {
          return new zPe(e);
        }
      }]) && O_e(r.prototype, n), o && O_e(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function C_e(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, k_e(n.key), n);
      }
    }

    function k_e(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function R_e(e, t, r) {
      return t = T_e(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], T_e(e).constructor) : t.apply(e, r));
    }

    function T_e(e) {
      return (T_e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function z_e(e, t) {
      return (z_e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var N_e = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), R_e(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && z_e(e, t);
      }(t, Object(w["MixInto"])(w["FieldCropVariety"])(w["reportableMixin"])), r = t, o = [{
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition || {};
          return {
            name: e.name,
            percent: e.percent
          };
        }
      }], (n = null) && C_e(r.prototype, n), o && C_e(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function D_e(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, x_e(n.key), n);
      }
    }

    function x_e(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function A_e(e, t, r) {
      return t = M_e(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], M_e(e).constructor) : t.apply(e, r));
    }

    function M_e(e) {
      return (M_e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function I_e(e, t) {
      return (I_e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var F_e = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), A_e(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && I_e(e, t);
      }(t, Object(w["MixInto"])(w["FieldCropCultivar"])(w["reportableMixin"])), r = t, o = [{
        key: "reportableAttributes",
        get: function () {
          return {
            name: (this.attributeDefinition || {}).name
          };
        }
      }], (n = null) && D_e(r.prototype, n), o && D_e(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function B_e(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, L_e(n.key), n);
      }
    }

    function L_e(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function V_e(e, t, r) {
      return t = U_e(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], U_e(e).constructor) : t.apply(e, r));
    }

    function U_e(e) {
      return (U_e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function q_e(e, t) {
      return (q_e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var K_e = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), V_e(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && q_e(e, t);
      }(t, Object(w["MixInto"])(w["FieldCropRootStock"])(w["reportableMixin"])), r = t, o = [{
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition || {};
          return {
            name: e.name,
            percent: e.percent
          };
        }
      }], (n = null) && B_e(r.prototype, n), o && B_e(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function G_e(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function W_e(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? G_e(Object(r), !0).forEach(function (t) {
          H_e(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : G_e(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function H_e(e, t, r) {
      return (t = Y_e(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function J_e(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Y_e(n.key), n);
      }
    }

    function Y_e(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Q_e(e, t, r) {
      return t = Z_e(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Z_e(e).constructor) : t.apply(e, r));
    }

    function $_e() {
      return ($_e = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = X_e(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function X_e(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = Z_e(e)););

      return e;
    }

    function Z_e(e) {
      return (Z_e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function eEe(e, t) {
      return (eEe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var tEe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Q_e(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && eEe(e, t);
      }(t, Object(w["MixInto"])(w["FieldCropReference"])(w["reportableMixin"])), function (e, t, r) {
        return t && J_e(e.prototype, t), r && J_e(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = $_e(Z_e(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return W_e(W_e({}, a), {}, {
            varieties: W_e(W_e({}, a.varieties), {}, {
              modelClass: N_e
            }),
            cultivars: W_e(W_e({}, a.cultivars), {}, {
              modelClass: F_e
            }),
            rootStocks: W_e(W_e({}, a.rootStocks), {}, {
              modelClass: K_e
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition || {};
          return {
            id: e.id,
            name: e.name,
            varieties: e.varieties,
            cultivars: e.cultivars,
            rootStocks: e.rootStocks,
            useTypes: e.useTypes
          };
        }
      }]);
    }();

    function rEe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, nEe(n.key), n);
      }
    }

    function nEe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function oEe(e, t, r) {
      return t = iEe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], iEe(e).constructor) : t.apply(e, r));
    }

    function iEe(e) {
      return (iEe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function aEe(e, t) {
      return (aEe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var cEe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), oEe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && aEe(e, t);
      }(t, Object(w["MixInto"])(w["PointGeometry"])(w["reportableMixin"])), r = t, n && rEe(r.prototype, n), o && rEe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function uEe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, lEe(n.key), n);
      }
    }

    function lEe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function sEe(e, t, r) {
      return t = pEe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], pEe(e).constructor) : t.apply(e, r));
    }

    function pEe(e) {
      return (pEe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function fEe(e, t) {
      return (fEe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var dEe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), sEe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && fEe(e, t);
      }(t, Object(w["MixInto"])(w["PolygonGeometry"])(w["reportableMixin"])), r = t, n && uEe(r.prototype, n), o && uEe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function bEe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, yEe(n.key), n);
      }
    }

    function yEe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function mEe(e, t, r) {
      return t = vEe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], vEe(e).constructor) : t.apply(e, r));
    }

    function vEe(e) {
      return (vEe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function hEe(e, t) {
      return (hEe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var gEe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), mEe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && hEe(e, t);
      }(t, Object(w["MixInto"])(w["MultiPolygonGeometry"])(w["reportableMixin"])), r = t, n && bEe(r.prototype, n), o && bEe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function wEe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, OEe(n.key), n);
      }
    }

    function OEe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function jEe(e, t, r) {
      return t = PEe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], PEe(e).constructor) : t.apply(e, r));
    }

    function PEe(e) {
      return (PEe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function _Ee(e, t) {
      return (_Ee = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var EEe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), jEe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && _Ee(e, t);
      }(t, Object(w["MixInto"])(w["FeatureGeometry"])(w["reportableMixin"])), r = t, n && wEe(r.prototype, n), o && wEe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    EEe.PointGeometryClass = cEe, EEe.PolygonGeometryClass = dEe, EEe.MultiPolygonGeometryClass = gEe;
    var SEe = EEe;

    function CEe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function kEe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? CEe(Object(r), !0).forEach(function (t) {
          REe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : CEe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function REe(e, t, r) {
      return (t = zEe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function TEe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zEe(n.key), n);
      }
    }

    function zEe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function NEe(e, t, r) {
      return t = AEe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], AEe(e).constructor) : t.apply(e, r));
    }

    function DEe() {
      return (DEe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = xEe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function xEe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = AEe(e)););

      return e;
    }

    function AEe(e) {
      return (AEe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function MEe(e, t) {
      return (MEe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var IEe,
        FEe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), NEe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && MEe(e, t);
      }(t, Object(w["MixInto"])(w["Feature"])(w["reportableMixin"])), function (e, t, r) {
        return t && TEe(e.prototype, t), r && TEe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = DEe(AEe(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return kEe(kEe({}, a), {}, {
            geometry: kEe(kEe({}, a.geometry), {}, {
              modelClass: SEe
            })
          });
        }
      }]);
    }();

    function BEe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, LEe(n.key), n);
      }
    }

    function LEe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function VEe(e, t, r) {
      return t = UEe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], UEe(e).constructor) : t.apply(e, r));
    }

    function UEe(e) {
      return (UEe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function qEe(e, t) {
      return (qEe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var KEe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), VEe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && qEe(e, t);
      }(t, Object(w["MixInto"])(w["FeatureCollection"])(w["reportableMixin"])), r = t, n && BEe(r.prototype, n), o && BEe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    IEe = KEe, KEe.FeatureCollectionClass = IEe, KEe.FeatureClass = FEe;
    var GEe = KEe;

    function WEe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, HEe(n.key), n);
      }
    }

    function HEe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function JEe(e, t, r) {
      return t = YEe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], YEe(e).constructor) : t.apply(e, r));
    }

    function YEe(e) {
      return (YEe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function QEe(e, t) {
      return (QEe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var $Ee = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), JEe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && QEe(e, t);
      }(t, Object(w["MixInto"])(w["FeatureBuilder"])(w["reportableMixin"])), r = t, n && WEe(r.prototype, n), o && WEe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    $Ee.FeatureCollectionClass = GEe, $Ee.FeatureClass = FEe;
    var XEe = $Ee;

    function ZEe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, eSe(n.key), n);
      }
    }

    function eSe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function tSe(e, t, r) {
      return t = rSe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], rSe(e).constructor) : t.apply(e, r));
    }

    function rSe(e) {
      return (rSe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function nSe(e, t) {
      return (nSe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var oSe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), tSe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && nSe(e, t);
      }(t, Object(w["MixInto"])(w["GeoJSON"])(w["reportableMixin"])), r = t, o = [{
        key: "reportableAttributes",
        get: function () {
          return {
            type: (this.attributeDefinition || {}).type,
            jsonString: {
              name: "JSON String",
              key: "jsonString",
              type: "string"
            }
          };
        }
      }], (n = null) && ZEe(r.prototype, n), o && ZEe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    oSe.defaultKey = "jsonString", oSe.FeatureBuilderClass = XEe, oSe.FeatureGeometryClass = SEe;
    var iSe = oSe;

    function aSe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function cSe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? aSe(Object(r), !0).forEach(function (t) {
          uSe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : aSe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function uSe(e, t, r) {
      return (t = sSe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function lSe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, sSe(n.key), n);
      }
    }

    function sSe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function pSe(e, t, r) {
      return t = bSe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], bSe(e).constructor) : t.apply(e, r));
    }

    function fSe() {
      return (fSe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = dSe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function dSe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = bSe(e)););

      return e;
    }

    function bSe(e) {
      return (bSe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ySe(e, t) {
      return (ySe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var mSe,
        vSe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), pSe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ySe(e, t);
      }(t, Object(w["MixInto"])(w["Field"])(w["reportableMixin"])), function (e, t, r) {
        return t && lSe(e.prototype, t), r && lSe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = fSe(bSe(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return cSe(cSe({}, a), {}, {
            account: cSe(cSe({}, a.account), {}, {
              modelClass: nje,
              defaultValue: new nje(),
              filterType: "accountSelect"
            }),
            crop: cSe(cSe({}, a.crop), {}, {
              modelClass: tEe,
              defaultValue: new tEe()
            }),
            area: cSe(cSe({}, a.area), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            rowSpacing: cSe(cSe({}, a.rowSpacing), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            geoJson: cSe(cSe({}, a.geoJson), {}, {
              modelClass: iSe
            }),
            fieldVarieties: cSe(cSe({}, a.fieldVarieties), {}, {
              modelClass: N_e
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.id,
              r = e.name,
              n = e.serial,
              o = e.createdAt,
              i = e.updatedAt,
              a = e.type,
              c = {
            id: t,
            name: r,
            serial: n,
            createdAt: o,
            updatedAt: i,
            account: e.account,
            crop: e.crop,
            county: e.county,
            yearPlanted: e.yearPlanted,
            area: e.area,
            rowSpacing: e.rowSpacing,
            notes: e.notes,
            longitude: e.longitude,
            latitude: e.latitude,
            nonBearing: e.nonBearing,
            geoJson: e.geoJson,
            organic: e.organic,
            organicDate: e.organicDate,
            accountingReference: e.accountingReference,
            inactive: e.inactive,
            fieldVarieties: e.fieldVarieties
          },
              u = cSe(cSe({}, c), {}, {
            area: cSe(cSe({}, c.area), {}, {
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            }),
            geoJson: cSe(cSe({}, c.geoJson), {}, {
              type: "string",
              modelClass: null
            }),
            rowSpacing: cSe(cSe({}, c.rowSpacing), {}, {
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            })
          }),
              l = cSe(cSe({}, c), {}, {
            type: a
          });
          return $H.getConfig("useNewReports") ? u : l;
        }
      }, {
        key: "displayValueForGroup",
        value: function (e) {
          var t;
          return null === (t = Object(x.sortBy)(Object(x.prop)("updatedAt"))(e.filter(Boolean)).pop()) || void 0 === t ? void 0 : t.name;
        }
      }]);
    }();

    function hSe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, gSe(n.key), n);
      }
    }

    function gSe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function wSe(e, t, r) {
      return t = OSe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], OSe(e).constructor) : t.apply(e, r));
    }

    function OSe(e) {
      return (OSe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function jSe(e, t) {
      return (jSe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var PSe,
        _Se,
        ESe,
        SSe = (function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((mSe = function (e) {
      function t(e, r) {
        var n;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (n = wSe(this, t, [e, r])).collectionKey = "fields", n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && jSe(e, t);
      }(t, w_e), r = t, (n = [{
        key: "fetchAllForAccounts",
        value: function (e) {
          var t = this;
          return this.status = "fetching", this.pushProgress = 0, this.progressFaker.start(this.maxServerTimeEstimate), this.rawRecords = [], this.items = [], this._newResults = new Array(1), this.batchInfo = [{
            batchNum: 0,
            downloader: new LPe(),
            pushProgress: 0
          }], this.api.fetchAllForAccounts(e).then(function (e) {
            return t.processBatch(t.batchInfo[0], e);
          }).then(function () {
            return t.reduceResults();
          }).then(function () {
            return t.items;
          }).catch(function (e) {
            console.error(e);
          }).finally(function () {
            t.progressFaker.cancel(), Object(f.runInAction)(function () {
              t.status = "ready", t.batchInfo = null;
            });
          });
        }
      }, {
        key: "new",
        value: function (e) {
          return new vSe(e);
        }
      }]) && hSe(r.prototype, n), o && hSe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "fetchAllForAccounts", [f.action], Object.getOwnPropertyDescriptor(mSe.prototype, "fetchAllForAccounts"), mSe.prototype), mSe);

    function CSe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function kSe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? CSe(Object(r), !0).forEach(function (t) {
          RSe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : CSe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function RSe(e, t, r) {
      return (t = zSe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function TSe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zSe(n.key), n);
      }
    }

    function zSe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function NSe(e, t, r) {
      return t = MSe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], MSe(e).constructor) : t.apply(e, r));
    }

    function DSe(e, t, r, n) {
      var o = xSe(MSe(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function xSe() {
      return (xSe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = ASe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function ASe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = MSe(e)););

      return e;
    }

    function MSe(e) {
      return (MSe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ISe(e, t) {
      return (ISe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function FSe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var BSe = ((ESe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = NSe(this, t, [].concat(n)), "targetRate", _Se, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ISe(e, t);
      }(t, Object(w["MixInto"])(w["RecommendationProductApplication"])(w["reportableMixin"])), r = t, o = [{
        key: "getAttributeDefinition",
        value: function () {
          var e = DSe(t, "getAttributeDefinition", this, 2)([]);
          return kSe(kSe({}, e), {}, {
            product: kSe(kSe({}, e.product), {}, {
              modelClass: zPe,
              defaultValue: new zPe()
            }),
            rate: kSe(kSe({}, e.rate), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition;
          return {
            id: e.id,
            serial: e.serial,
            type: e.type,
            product: e.product,
            rate: e.rate,
            target: e.target,
            position: e.position,
            applicationMethod: e.applicationMethod,
            cropNames: e.cropNames,
            notes: e.notes,
            ratePerAcre: {
              name: "Rate/Acre",
              key: "ratePerAcre",
              type: "model",
              modelClass: Dge
            },
            ratePerVolume: {
              name: "Rate/Volume",
              key: "ratePerVolume",
              type: "model",
              modelClass: Dge
            },
            poundsPerAcre: {
              name: "Lbs/Acre",
              key: "poundsPerAcre",
              type: "model",
              modelClass: Dge
            }
          };
        }
      }], (n = [{
        key: "ratePerAcre",
        get: function () {
          if (this.ratePerArea) return this.ratePerArea.isCompatible("lbs/acre") || this.ratePerArea.isCompatible("gal/acre") || this.ratePerArea.isCompatible("/acre") ? this.ratePerArea.to("".concat(this.ratePerArea.numeratorUnits, "/acre")) : void 0;
        }
      }, {
        key: "ratePerArea",
        get: function () {
          return this.rate.isCompatible("lbs/acre") || this.rate.isCompatible("gal/acre") || this.rate.isCompatible("/acre") ? this.rate : this.targetRate && Dge.isQuantityTruthy(this.targetRate) && Dge.isCompatible(this.targetRate, "gal/acre") && (this.rate.isCompatible("floz/gal") || this.rate.isCompatible("lbs/gal") || this.rate.isCompatible("/gal")) ? this.rate.mul(this.targetRate) : void 0;
        }
      }, {
        key: "ratePerVolume",
        get: function () {
          return this.rate.isCompatible("floz/gal") || this.rate.isCompatible("lbs/gal") || this.rate.isCompatible("/gal") ? this.rate : this.targetRate && Dge.isQuantityTruthy(this.targetRate) && Dge.isCompatible(this.targetRate, "gal/acre") && (this.rate.isCompatible("lbs/acre") || this.rate.isCompatible("gal/acre") || this.rate.isCompatible("/acre")) ? this.rate.div(this.targetRate).to("".concat(this.rate.numeratorUnits, "/hgal")) : void 0;
        }
      }, {
        key: "poundsPerAcre",
        get: function () {
          try {
            return DSe(t, "poundsPerAcre", this, 3)([this.targetRate]);
          } catch (e) {
            return console.error(e), new Dge();
          }
        }
      }]) && TSe(r.prototype, n), o && TSe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).defaultKey = "product", _Se = FSe((PSe = ESe).prototype, "targetRate", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), FSe(PSe.prototype, "ratePerAcre", [f.computed], Object.getOwnPropertyDescriptor(PSe.prototype, "ratePerAcre"), PSe.prototype), FSe(PSe.prototype, "ratePerArea", [f.computed], Object.getOwnPropertyDescriptor(PSe.prototype, "ratePerArea"), PSe.prototype), FSe(PSe.prototype, "ratePerVolume", [f.computed], Object.getOwnPropertyDescriptor(PSe.prototype, "ratePerVolume"), PSe.prototype), FSe(PSe.prototype, "poundsPerAcre", [f.computed], Object.getOwnPropertyDescriptor(PSe.prototype, "poundsPerAcre"), PSe.prototype), PSe);

    function LSe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function VSe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? LSe(Object(r), !0).forEach(function (t) {
          USe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : LSe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function USe(e, t, r) {
      return (t = KSe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function qSe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, KSe(n.key), n);
      }
    }

    function KSe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function GSe(e, t, r) {
      return t = WSe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], WSe(e).constructor) : t.apply(e, r));
    }

    function WSe(e) {
      return (WSe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function HSe(e, t) {
      return (HSe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var JSe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), GSe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && HSe(e, t);
      }(t, Object(w["MixInto"])(w["UserReferenceWithLicenses"])(w["reportableMixin"])), r = t, o = [{
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.id,
              r = e.serial,
              n = e.type,
              o = {
            id: t,
            serial: r,
            name: e.name,
            licenses: e.licenses
          },
              i = VSe(VSe({}, o), {}, {
            type: n
          });
          return $H.getConfig("useNewReports") ? o : i;
        }
      }], (n = null) && qSe(r.prototype, n), o && qSe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function YSe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function QSe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? YSe(Object(r), !0).forEach(function (t) {
          $Se(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : YSe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function $Se(e, t, r) {
      return (t = ZSe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function XSe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ZSe(n.key), n);
      }
    }

    function ZSe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function eCe(e, t, r) {
      return t = nCe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], nCe(e).constructor) : t.apply(e, r));
    }

    function tCe() {
      return (tCe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = rCe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function rCe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = nCe(e)););

      return e;
    }

    function nCe(e) {
      return (nCe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function oCe(e, t) {
      return (oCe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var iCe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), eCe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && oCe(e, t);
      }(t, Object(w["MixInto"])(w["RecommendationReference"])(w["reportableMixin"])), function (e, t, r) {
        return t && XSe(e.prototype, t), r && XSe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = tCe(nCe(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return QSe(QSe({}, a), {}, {
            accounts: QSe(QSe({}, a.accounts), {}, {
              modelClass: GOe
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition;
          return {
            id: e.id,
            name: e.name,
            type: e.type,
            date: e.date,
            accountId: e.accountId,
            accounts: e.accounts,
            writtenById: e.writtenById,
            status: e.status
          };
        }
      }]);
    }();

    function aCe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function cCe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? aCe(Object(r), !0).forEach(function (t) {
          uCe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : aCe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function uCe(e, t, r) {
      return (t = sCe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function lCe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, sCe(n.key), n);
      }
    }

    function sCe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function pCe(e, t, r) {
      return t = bCe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], bCe(e).constructor) : t.apply(e, r));
    }

    function fCe() {
      return (fCe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = dCe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function dCe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = bCe(e)););

      return e;
    }

    function bCe(e) {
      return (bCe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function yCe(e, t) {
      return (yCe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    iCe.defaultKey = "documentNumber";

    var mCe,
        vCe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), pCe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && yCe(e, t);
      }(t, Object(w["MixInto"])(w["Reject"])(w["reportableMixin"])), function (e, t, r) {
        return t && lCe(e.prototype, t), r && lCe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = fCe(bCe(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return cCe(cCe({}, a), {}, {
            by: cCe(cCe({}, a.by), {}, {
              modelClass: JSe,
              defaultValue: new JSe()
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition;
          return {
            by: e.by,
            reason: e.reason,
            at: e.at
          };
        }
      }]);
    }();

    function hCe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function gCe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? hCe(Object(r), !0).forEach(function (t) {
          wCe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : hCe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function wCe(e, t, r) {
      return (t = jCe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function OCe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, jCe(n.key), n);
      }
    }

    function jCe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function PCe(e, t, r) {
      return t = CCe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], CCe(e).constructor) : t.apply(e, r));
    }

    function _Ce(e, t) {
      return (_Ce = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ECe() {
      return (ECe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = SCe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function SCe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = CCe(e)););

      return e;
    }

    function CCe(e) {
      return (CCe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function kCe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    vCe.defaultKey = "by";
    var RCe = (kCe((mCe = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = PCe(this, t, [e])).productApplications.forEach(function (e) {
          e.targetRate = new Dge(r.targetRate);
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && _Ce(e, t);
      }(t, Object(w["MixInto"])(w["Recommendation"])(w["reportableMixin"])), function (e, t, r) {
        return t && OCe(e.prototype, t), r && OCe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "createdAtDate",
        get: function () {
          return M()(this.createdAt).format("YYYY-MM-DD");
        }
      }, {
        key: "updatedAtDate",
        get: function () {
          return M()(this.updatedAt).format("YYYY-MM-DD");
        }
      }, {
        key: "totalFields",
        get: function () {
          return this.fields.length;
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = ECe(CCe(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return gCe(gCe({}, a), {}, {
            createdAt: gCe(gCe({}, a.createdAt), {}, {
              filterType: "date"
            }),
            updatedAt: gCe(gCe({}, a.updatedAt), {}, {
              filterType: "date"
            }),
            writtenBy: gCe(gCe({}, a.writtenBy), {}, {
              modelClass: JSe,
              defaultValue: new JSe()
            }),
            account: gCe(gCe({}, a.account), {}, {
              modelClass: nje,
              defaultValue: new nje(),
              filterType: "accountSelect"
            }),
            accounts: gCe(gCe({}, a.accounts), {}, {
              modelClass: nje
            }),
            replaces: gCe(gCe({}, a.replaces), {}, {
              modelClass: iCe
            }),
            targetRate: gCe(gCe({}, a.targetRate), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            productApplications: gCe(gCe({}, a.productApplications), {}, {
              modelClass: BSe
            }),
            fields: gCe(gCe({}, a.fields), {}, {
              modelClass: vSe,
              filterType: "fieldSelect"
            }),
            tankSize: gCe(gCe({}, a.tankSize), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            rejected: gCe(gCe({}, a.rejected), {}, {
              modelClass: vCe
            }),
            date: gCe(gCe({}, a.date), {}, {
              filterType: "date",
              dateFormat: "YYYY-MM-DD"
            }),
            applicationMethod: gCe(gCe({}, a.applicationMethod), {}, {
              filterType: "multiSelect"
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition;
          return {
            id: e.id,
            name: e.name,
            date: e.date,
            createdAt: e.createdAt,
            createdAtDate: {
              name: "Created At Date",
              key: "createdAtDate",
              type: "string",
              filterType: "date",
              dateFormat: "YYYY-MM-DD"
            },
            updatedAt: e.updatedAt,
            updatedAtDate: {
              name: "Updated At Date",
              key: "updatedAtDate",
              type: "string",
              filterType: "date",
              dateFormat: "YYYY-MM-DD"
            },
            type: e.type,
            documentNumber: e.documentNumber,
            timing: e.timing,
            account: e.account,
            accounts: e.accounts,
            cropNames: e.cropNames,
            notes: e.notes,
            organic: e.organic,
            applicationMethod: e.applicationMethod,
            targetRate: e.targetRate,
            tankSize: e.tankSize,
            totalAcres: {
              name: "Total Acres",
              key: "totalAcres",
              type: "number"
            },
            totalFields: {
              name: "Total Fields",
              key: "totalFields",
              type: "number"
            },
            optimumTemperature: e.optimumTemperature,
            areasToTreat: e.areasToTreat,
            coverage: e.coverage,
            fields: e.fields,
            status: e.status,
            productApplications: e.productApplications,
            writtenBy: e.writtenBy,
            rejected: e.rejected
          };
        }
      }]);
    }()).prototype, "createdAtDate", [f.computed], Object.getOwnPropertyDescriptor(mCe.prototype, "createdAtDate"), mCe.prototype), kCe(mCe.prototype, "updatedAtDate", [f.computed], Object.getOwnPropertyDescriptor(mCe.prototype, "updatedAtDate"), mCe.prototype), kCe(mCe.prototype, "totalFields", [f.computed], Object.getOwnPropertyDescriptor(mCe.prototype, "totalFields"), mCe.prototype), mCe);

    function TCe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zCe(n.key), n);
      }
    }

    function zCe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function NCe(e, t, r) {
      return t = DCe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], DCe(e).constructor) : t.apply(e, r));
    }

    function DCe(e) {
      return (DCe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function xCe(e, t) {
      return (xCe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var ACe = function (e) {
      function t(e, r) {
        var n;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (n = NCe(this, t, [e, r])).collectionKey = "recommendations", n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && xCe(e, t);
      }(t, w_e), r = t, (n = [{
        key: "new",
        value: function (e) {
          return new RCe(e);
        }
      }, {
        key: "isDateFilterRefinement",
        value: function (e, t) {
          var r = M()(e.values.start),
              n = M()(e.values.end),
              o = M()(t.values.start),
              i = M()(t.values.end);
          return r.isBetween(o, i, void 0, "[]") && n.isBetween(o, i, void 0, "[]");
        }
      }, {
        key: "isTextFilterRefinement",
        value: function (e, t) {
          return Object(x.equals)(e.values, t.values);
        }
      }, {
        key: "isFilterRefinement",
        value: function (e) {
          var t = {
            crop: this.isTextFilterRefinement,
            updated_at: this.isDateFilterRefinement,
            date: this.isDateFilterRefinement,
            "field.name": this.isTextFilterRefinement,
            "product.name": this.isTextFilterRefinement,
            target: this.isTextFilterRefinement,
            variety: this.isTextFilterRefinement
          };
          return !this.filtersForLastQuery || !this.filtersForLastQuery.length || !!e && this.filtersForLastQuery.every(function (r) {
            var n = e.find(function (e) {
              return e.filter === r.filter;
            });
            return n && t[r.filter](n, r);
          });
        }
      }, {
        key: "getQueryFilters",
        value: function (e) {
          var t,
              r = Object.values(e || {}),
              n = r.find(function (e) {
            return "date" === e.key;
          }),
              o = r.find(function (e) {
            return "updatedAt" === e.key;
          }),
              i = r.find(function (e) {
            return "fields/crop" === e.key && "Contains" === e.matchMethod;
          }),
              a = r.find(function (e) {
            return "fields" === e.key && "Contains" === e.matchMethod;
          }),
              c = r.find(function (e) {
            return ("productApplications" === e.key || "productApplications/product" === e.key) && "Contains" === e.matchMethod;
          }),
              u = r.find(function (e) {
            return "productApplications/target" === e.key && "Contains" === e.matchMethod;
          }),
              l = r.find(function (e) {
            return "fields/crop/varieties" === e.key && "Contains" === e.matchMethod;
          });
          return null != i && i.value && (t = [].concat(t || []).concat({
            filter: "crop",
            values: [i.value]
          })), null != n && n.value && (t = [].concat(t || []).concat({
            filter: "date",
            values: n.value.dateRange
          })), null != o && o.value && (t = [].concat(t || []).concat({
            filter: "updated_at",
            values: o.value.dateRange
          })), null != a && a.value && (t = [].concat(t || []).concat({
            filter: "field.name",
            values: [a.value]
          })), null != c && c.value && (t = [].concat(t || []).concat({
            filter: "product.name",
            values: [c.value]
          })), null != u && u.value && (t = [].concat(t || []).concat({
            filter: "target",
            values: [u.value]
          })), null != l && l.value && (t = [].concat(t || []).concat({
            filter: "variety",
            values: [l.value]
          })), t;
        }
      }]) && TCe(r.prototype, n), o && TCe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function MCe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function ICe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? MCe(Object(r), !0).forEach(function (t) {
          FCe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : MCe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function FCe(e, t, r) {
      return (t = LCe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function BCe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, LCe(n.key), n);
      }
    }

    function LCe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var VCe = function () {
      return e = function e() {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.recommendationsPath = "/if2/api/recommendations", this.recommendationsQueryPath = "".concat(this.recommendationsPath, "/query");
      }, (t = [{
        key: "csrf",
        value: function () {
          return document.querySelector("[name='csrf-token']").content;
        }
      }, {
        key: "fetchAll",
        value: function () {
          var e = this.csrf();
          return fetch(this.recommendationsPath, {
            method: "GET",
            headers: {
              "X-CSRF-Token": e,
              "Content-Type": "application/json"
            }
          });
        }
      }, {
        key: "fetchAllForAccounts",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = this.csrf();
          return fetch(this.recommendationsQueryPath, {
            method: "POST",
            headers: {
              "X-CSRF-Token": r,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(ICe({
              accounts: e
            }, t))
          });
        }
      }]) && BCe(e.prototype, t), r && BCe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function UCe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qCe(n.key), n);
      }
    }

    function qCe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function KCe(e, t, r) {
      return t = GCe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], GCe(e).constructor) : t.apply(e, r));
    }

    function GCe(e) {
      return (GCe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function WCe(e, t) {
      return (WCe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var HCe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), KCe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && WCe(e, t);
      }(t, Object(w["MixInto"])(w["ContactAddress"])(w["reportableMixin"])), r = t, o = [{
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition;
          return {
            label: e.label,
            primary: e.primary,
            value: e.value
          };
        }
      }], (n = null) && UCe(r.prototype, n), o && UCe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    HCe.defaultKey = "value";
    var JCe = HCe;

    function YCe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, QCe(n.key), n);
      }
    }

    function QCe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function $Ce(e, t, r) {
      return t = XCe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], XCe(e).constructor) : t.apply(e, r));
    }

    function XCe(e) {
      return (XCe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ZCe(e, t) {
      return (ZCe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var eke = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), $Ce(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ZCe(e, t);
      }(t, Object(w["MixInto"])(w["ContactEmail"])(w["reportableMixin"])), r = t, o = [{
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition;
          return {
            label: e.label,
            primary: e.primary,
            address: e.address
          };
        }
      }], (n = null) && YCe(r.prototype, n), o && YCe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    eke.defaultKey = "address";
    var tke = eke;

    function rke(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, nke(n.key), n);
      }
    }

    function nke(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function oke(e, t, r) {
      return t = ike(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ike(e).constructor) : t.apply(e, r));
    }

    function ike(e) {
      return (ike = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ake(e, t) {
      return (ake = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var cke = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), oke(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ake(e, t);
      }(t, Object(w["MixInto"])(w["ContactPhone"])(w["reportableMixin"])), r = t, o = [{
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition;
          return {
            label: e.label,
            primary: e.primary,
            number: e.number
          };
        }
      }], (n = null) && rke(r.prototype, n), o && rke(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    cke.defaultKey = "number";
    var uke = cke;

    function lke(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function ske(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? lke(Object(r), !0).forEach(function (t) {
          pke(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : lke(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function pke(e, t, r) {
      return (t = dke(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function fke(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, dke(n.key), n);
      }
    }

    function dke(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function bke(e, t, r) {
      return t = vke(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], vke(e).constructor) : t.apply(e, r));
    }

    function yke() {
      return (yke = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = mke(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function mke(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = vke(e)););

      return e;
    }

    function vke(e) {
      return (vke = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function hke(e, t) {
      return (hke = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var gke = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), bke(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && hke(e, t);
      }(t, Object(w["MixInto"])(w["Sprayer"])(w["reportableMixin"])), function (e, t, r) {
        return t && fke(e.prototype, t), r && fke(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = yke(vke(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return ske(ske({}, a), {}, {
            account: ske(ske({}, a.account), {}, {
              modelClass: nje,
              defaultValue: new nje()
            }),
            tankSize: ske(ske({}, a.tankSize), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.id,
              r = e.serial,
              n = e.name,
              o = e.type,
              i = {
            id: t,
            serial: r,
            name: n,
            account: e.account,
            licensePlateNumber: e.licensePlateNumber,
            notes: e.notes,
            tankSize: e.tankSize
          },
              a = ske(ske({}, i), {}, {
            licensePlateNumber: ske(ske({}, i.licensePlateNumber), {}, {
              backendKey: "license_plate_number"
            }),
            tankSize: ske(ske({}, i.tankSize), {}, {
              modelClass: null,
              type: "string",
              backendKey: "tank_size",
              calculable: !0
            })
          }),
              c = ske(ske({}, i), {}, {
            type: o
          });
          return $H.getConfig("useNewReports") ? a : c;
        }
      }]);
    }();

    function wke(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Oke(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? wke(Object(r), !0).forEach(function (t) {
          jke(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : wke(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function jke(e, t, r) {
      return (t = _ke(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Pke(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _ke(n.key), n);
      }
    }

    function _ke(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Eke(e, t, r) {
      return t = kke(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], kke(e).constructor) : t.apply(e, r));
    }

    function Ske() {
      return (Ske = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Cke(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Cke(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = kke(e)););

      return e;
    }

    function kke(e) {
      return (kke = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Rke(e, t) {
      return (Rke = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Tke = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Eke(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Rke(e, t);
      }(t, Object(w["MixInto"])(w["Tractor"])(w["reportableMixin"])), function (e, t, r) {
        return t && Pke(e.prototype, t), r && Pke(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = Ske(kke(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return Oke(Oke({}, a), {}, {
            account: Oke(Oke({}, a.account), {}, {
              modelClass: nje,
              defaultValue: new nje()
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.id,
              r = e.serial,
              n = e.name,
              o = e.type,
              i = {
            id: t,
            serial: r,
            name: n,
            account: e.account,
            licensePlateNumber: e.licensePlateNumber,
            notes: e.notes
          },
              a = Oke(Oke({}, i), {}, {
            type: o
          });
          return $H.getConfig("useNewReports") ? i : a;
        }
      }]);
    }();

    function zke(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function Nke(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? zke(Object(r), !0).forEach(function (t) {
          Dke(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zke(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Dke(e, t, r) {
      return (t = Ake(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function xke(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ake(n.key), n);
      }
    }

    function Ake(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Mke(e, t, r) {
      return t = Bke(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Bke(e).constructor) : t.apply(e, r));
    }

    function Ike() {
      return (Ike = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Fke(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Fke(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = Bke(e)););

      return e;
    }

    function Bke(e) {
      return (Bke = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Lke(e, t) {
      return (Lke = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Vke = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Mke(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Lke(e, t);
      }(t, Object(w["MixInto"])(w["Contact"])(w["reportableMixin"])), function (e, t, r) {
        return t && xke(e.prototype, t), r && xke(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = Ike(Bke(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return Nke(Nke({}, a), {}, {
            addresses: Nke(Nke({}, a.addresses), {}, {
              modelClass: JCe
            }),
            emails: Nke(Nke({}, a.emails), {}, {
              modelClass: tke
            }),
            phones: Nke(Nke({}, a.phones), {}, {
              modelClass: uke
            }),
            defaultSprayer: Nke(Nke({}, a.defaultSprayer), {}, {
              modelClass: gke,
              defaultValue: new gke()
            }),
            defaultTractor: Nke(Nke({}, a.defaultTractor), {}, {
              modelClass: Tke,
              defaultValue: new Tke()
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.id,
              r = e.type,
              n = {
            id: t,
            firstName: e.firstName,
            lastName: e.lastName,
            licenseNumber: e.licenseNumber,
            addresses: e.addresses,
            emails: e.emails,
            phones: e.phones,
            categories: e.categories,
            defaultSprayer: e.defaultSprayer,
            defaultTractor: e.defaultTractor
          },
              o = Nke(Nke({}, n), {}, {
            type: r,
            name: {
              name: "Name",
              key: "name",
              type: "string"
            }
          });
          return $H.getConfig("useNewReports") ? n : o;
        }
      }]);
    }();

    function Uke(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function qke(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Uke(Object(r), !0).forEach(function (t) {
          Kke(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Uke(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function Kke(e, t, r) {
      return (t = Wke(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function Gke(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Wke(n.key), n);
      }
    }

    function Wke(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Hke(e, t, r) {
      return t = Qke(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Qke(e).constructor) : t.apply(e, r));
    }

    function Jke() {
      return (Jke = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Yke(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function Yke(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = Qke(e)););

      return e;
    }

    function Qke(e) {
      return (Qke = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function $ke(e, t) {
      return ($ke = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Xke = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Hke(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && $ke(e, t);
      }(t, tEe), function (e, t, r) {
        return t && Gke(e.prototype, t), r && Gke(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = Jke(Qke(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return qke(qke({}, a), {}, {
            varieties: qke(qke({}, a.varieties), {}, {
              filterType: "searchableMultiSelect"
            })
          });
        }
      }]);
    }();

    function Zke(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function eRe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Zke(Object(r), !0).forEach(function (t) {
          tRe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Zke(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function tRe(e, t, r) {
      return (t = nRe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function rRe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, nRe(n.key), n);
      }
    }

    function nRe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function oRe(e, t, r) {
      return t = cRe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], cRe(e).constructor) : t.apply(e, r));
    }

    function iRe() {
      return (iRe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = aRe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function aRe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = cRe(e)););

      return e;
    }

    function cRe(e) {
      return (cRe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function uRe(e, t) {
      return (uRe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var lRe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), oRe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && uRe(e, t);
      }(t, vSe), function (e, t, r) {
        return t && rRe(e.prototype, t), r && rRe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = iRe(cRe(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return eRe(eRe({}, a), {}, {
            crop: eRe(eRe({}, a.crop), {}, {
              modelClass: Xke,
              defaultValue: new Xke(),
              filterType: "searchableMultiSelect"
            }),
            fieldVarieties: eRe(eRe({}, a.fieldVarieties), {}, {
              filterType: "searchableMultiSelect"
            })
          });
        }
      }]);
    }();

    function sRe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function pRe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? sRe(Object(r), !0).forEach(function (t) {
          fRe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : sRe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function fRe(e, t, r) {
      return (t = bRe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function dRe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bRe(n.key), n);
      }
    }

    function bRe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function yRe(e, t, r) {
      return t = hRe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], hRe(e).constructor) : t.apply(e, r));
    }

    function mRe() {
      return (mRe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = vRe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function vRe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = hRe(e)););

      return e;
    }

    function hRe(e) {
      return (hRe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function gRe(e, t) {
      return (gRe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var wRe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), yRe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && gRe(e, t);
      }(t, Object(w["MixInto"])(w["SprayRecordRecommendationReference"])(w["reportableMixin"])), function (e, t, r) {
        return t && dRe(e.prototype, t), r && dRe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = mRe(hRe(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return pRe(pRe({}, a), {}, {
            date: pRe(pRe({}, a.date), {}, {
              filterType: "date",
              dateFormat: "YYYY-MM-DD"
            }),
            writtenBy: pRe(pRe({}, a.writtenBy), {}, {
              modelClass: JSe,
              defaultValue: new JSe()
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = {
            id: e.id,
            name: e.name,
            documentNumber: e.documentNumber,
            date: e.date,
            writtenBy: e.writtenBy
          },
              r = pRe(pRe({}, t), {}, {
            documentNumber: pRe(pRe({}, t.documentNumber), {}, {
              backendKey: "document_number"
            }),
            writtenBy: pRe(pRe({}, t.writtenBy), {}, {
              backendKey: "written_by"
            })
          });
          return $H.getConfig("useNewReports") ? r : t;
        }
      }]);
    }();

    wRe.defaultKey = "documentNumber";
    var ORe = wRe;

    function jRe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function PRe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? jRe(Object(r), !0).forEach(function (t) {
          _Re(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : jRe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function _Re(e, t, r) {
      return (t = SRe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function ERe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, SRe(n.key), n);
      }
    }

    function SRe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function CRe(e, t, r) {
      return t = TRe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], TRe(e).constructor) : t.apply(e, r));
    }

    function kRe() {
      return (kRe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = RRe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function RRe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = TRe(e)););

      return e;
    }

    function TRe(e) {
      return (TRe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function zRe(e, t) {
      return (zRe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var NRe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), CRe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && zRe(e, t);
      }(t, Object(w["MixInto"])(w["Spreader"])(w["reportableMixin"])), function (e, t, r) {
        return t && ERe(e.prototype, t), r && ERe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = kRe(TRe(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return PRe(PRe({}, a), {}, {
            account: PRe(PRe({}, a.account), {}, {
              modelClass: nje,
              defaultValue: new nje()
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.id,
              r = e.serial,
              n = e.name,
              o = e.type,
              i = {
            id: t,
            serial: r,
            name: n,
            account: e.account,
            licensePlateNumber: e.licensePlateNumber,
            notes: e.notes
          },
              a = PRe(PRe({}, i), {}, {
            type: o
          });
          return $H.getConfig("useNewReports") ? i : a;
        }
      }]);
    }();

    function DRe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function xRe(e, t, r) {
      return (t = MRe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function ARe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, MRe(n.key), n);
      }
    }

    function MRe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function IRe(e, t, r) {
      return t = FRe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], FRe(e).constructor) : t.apply(e, r));
    }

    function FRe(e) {
      return (FRe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function BRe(e, t) {
      return (BRe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var LRe,
        VRe,
        URe,
        qRe = function (e) {
      return function (t) {
        function r() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r), IRe(this, r, arguments);
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && BRe(e, t);
        }(r, e), n = r, i = [{
          key: "formatNumber",
          value: function (e, t) {
            var r = function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? DRe(Object(r), !0).forEach(function (t) {
                  xRe(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : DRe(Object(r)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
              }

              return e;
            }({
              precision: 2
            }, t || {}).precision;

            return Number.isFinite(e) ? F1()(e, r) : "";
          }
        }], (o = null) && ARe(n.prototype, o), i && ARe(n, i), Object.defineProperty(n, "prototype", {
          writable: !1
        }), n;
        var n, o, i;
      }();
    };

    function KRe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function GRe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? KRe(Object(r), !0).forEach(function (t) {
          WRe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : KRe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function WRe(e, t, r) {
      return (t = JRe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function HRe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, JRe(n.key), n);
      }
    }

    function JRe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function YRe(e, t, r) {
      return t = XRe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], XRe(e).constructor) : t.apply(e, r));
    }

    function QRe() {
      return (QRe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = $Re(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function $Re(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = XRe(e)););

      return e;
    }

    function XRe(e) {
      return (XRe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ZRe(e, t) {
      return (ZRe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function eTe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var tTe = ((URe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = YRe(this, t, [].concat(n)), "_targetGpa", VRe, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ZRe(e, t);
      }(t, Object(w["MixInto"])(w["SprayRecordApplicator"])(w["reportableMixin"], qRe)), function (e, t, r) {
        return t && HRe(e.prototype, t), r && HRe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "predictedAcresTreated",
        get: function () {
          return this.constructor.formatNumber(this.constructor.predictedAcresTreated(this, this._targetGpa));
        }
      }, {
        key: "updateTargetGpa",
        value: function (e) {
          this._targetGpa = e;
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = QRe(XRe(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return GRe(GRe({}, a), {}, {
            contact: GRe(GRe({}, a.contact), {}, {
              modelClass: Vke,
              defaultValue: new Vke()
            }),
            tractor: GRe(GRe({}, a.tractor), {}, {
              modelClass: Tke,
              defaultValue: new Tke()
            }),
            sprayer: GRe(GRe({}, a.sprayer), {}, {
              modelClass: gke,
              defaultValue: new gke()
            }),
            sprayRate: GRe(GRe({}, a.sprayRate), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            spreader: GRe(GRe({}, a.spreader), {}, {
              modelClass: NRe,
              defaultValue: new NRe()
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.id,
              r = e.serial,
              n = e.type,
              o = {
            id: t,
            serial: r,
            applicationId: e.applicationId,
            contact: e.contact,
            gallonsApplied: e.gallonsApplied,
            tractor: e.tractor,
            sprayer: e.sprayer,
            sprayRate: e.sprayRate,
            spreader: e.spreader,
            tankCleaned: e.tankCleaned,
            tanksCompleted: e.tanksCompleted
          },
              i = GRe(GRe({}, o), {}, {
            id: GRe(GRe({}, o.id), {}, {
              backendKey: "uuid"
            }),
            serial: GRe(GRe({}, o.serial), {}, {
              backendKey: "id"
            }),
            gallonsApplied: GRe(GRe({}, o.gallonsApplied), {}, {
              backendKey: "gallons_applied"
            }),
            sprayRate: GRe(GRe({}, o.sprayRate), {}, {
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            }),
            tanksCompleted: GRe(GRe({}, o.tanksCompleted), {}, {
              backendKey: "tanks_completed"
            })
          }),
              a = GRe(GRe({}, o), {}, {
            type: n,
            computedGallonsApplied: {
              name: "Computed Gallons Applied",
              key: "computedGallonsApplied",
              type: "string"
            },
            predictedAcresTreated: {
              name: "Predicted Acres Treated",
              key: "predictedAcresTreated",
              type: "number"
            }
          });
          return $H.getConfig("useNewReports") ? i : a;
        }
      }]);
    }()).defaultKey = "contact", VRe = eTe((LRe = URe).prototype, "_targetGpa", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), eTe(LRe.prototype, "predictedAcresTreated", [f.computed], Object.getOwnPropertyDescriptor(LRe.prototype, "predictedAcresTreated"), LRe.prototype), eTe(LRe.prototype, "updateTargetGpa", [f.action], Object.getOwnPropertyDescriptor(LRe.prototype, "updateTargetGpa"), LRe.prototype), LRe);

    function rTe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function nTe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? rTe(Object(r), !0).forEach(function (t) {
          oTe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : rTe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function oTe(e, t, r) {
      return (t = aTe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function iTe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, aTe(n.key), n);
      }
    }

    function aTe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function cTe(e, t, r) {
      return t = sTe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], sTe(e).constructor) : t.apply(e, r));
    }

    function uTe() {
      return (uTe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = lTe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function lTe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = sTe(e)););

      return e;
    }

    function sTe(e) {
      return (sTe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function pTe(e, t) {
      return (pTe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var fTe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), cTe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && pTe(e, t);
      }(t, Object(w["MixInto"])(w["FieldCompletion"])(w["reportableMixin"])), function (e, t, r) {
        return t && iTe(e.prototype, t), r && iTe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, null, [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = uTe(sTe(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return nTe(nTe({}, a), {}, {
            field: nTe(nTe({}, a.field), {}, {
              modelClass: vSe,
              defaultValue: new vSe(),
              filterType: "fieldSelect"
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.id,
              r = e.serial,
              n = e.type,
              o = {
            id: t,
            serial: r,
            applicationId: e.applicationId,
            field: e.field,
            acres: e.acres,
            percentage: e.percentage,
            coveragePercentage: e.coveragePercentage
          },
              i = nTe(nTe({}, o), {}, {
            id: nTe(nTe({}, o.id), {}, {
              backendKey: "uuid"
            }),
            serial: nTe(nTe({}, o.serial), {}, {
              backendKey: "id"
            })
          }),
              a = nTe(nTe({}, o), {}, {
            type: n
          });
          return $H.getConfig("useNewReports") ? i : a;
        }
      }]);
    }();

    fTe.defaultKey = "field";
    var dTe,
        bTe,
        yTe,
        mTe = fTe;

    function vTe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function hTe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? vTe(Object(r), !0).forEach(function (t) {
          gTe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vTe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function gTe(e, t, r) {
      return (t = OTe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function wTe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, OTe(n.key), n);
      }
    }

    function OTe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function jTe(e, t, r) {
      return t = ETe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ETe(e).constructor) : t.apply(e, r));
    }

    function PTe() {
      return (PTe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = _Te(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function _Te(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = ETe(e)););

      return e;
    }

    function ETe(e) {
      return (ETe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function STe(e, t) {
      return (STe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function CTe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var kTe,
        RTe,
        TTe,
        zTe = ((yTe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = jTe(this, t, [].concat(n)), "_targetGpa", bTe, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && STe(e, t);
      }(t, Object(w["MixInto"])(w["SprayRecordApplication"])(w["reportableMixin"], qRe)), function (e, t, r) {
        return t && wTe(e.prototype, t), r && wTe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "percentVarianceAcresTreated",
        get: function () {
          return this.constructor.formatNumber(this.constructor.percentVarianceAcresTreated(this, this._targetGpa));
        }
      }, {
        key: "predictedAcresTreated",
        get: function () {
          return this.constructor.formatNumber(this.constructor.predictedAcresTreated(this, this._targetGpa));
        }
      }, {
        key: "displayTotalTreatedAcres",
        get: function () {
          return this.constructor.formatNumber(this.totalTreatedAcres);
        }
      }, {
        key: "displayTotalAcresCompleted",
        get: function () {
          return this.constructor.formatNumber(this.totalAcresCompleted);
        }
      }, {
        key: "displayTotalGallonsApplied",
        get: function () {
          return this.constructor.formatNumber(this.totalGallonsApplied);
        }
      }, {
        key: "dateTime",
        get: function () {
          var e = M()(this.date).format("MM/DD/YYYY");
          return e += ", ".concat(oe(this.startTime)), e += " - ".concat(oe(this.stopTime));
        }
      }, {
        key: "updateTargetGpa",
        value: function (e) {
          this._targetGpa = e, (this.applicators || []).forEach(function (t) {
            return t.updateTargetGpa(e);
          });
        }
      }], [{
        key: "getAttributeDefinition",
        value: function () {
          var e,
              r,
              n,
              o,
              i,
              a = (e = t, r = "getAttributeDefinition", n = this, i = PTe(ETe(1 & (o = 2) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]);
          return hTe(hTe({}, a), {}, {
            lowWindSpeed: hTe(hTe({}, a.lowWindSpeed), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            highWindSpeed: hTe(hTe({}, a.highWindSpeed), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            applicators: hTe(hTe({}, a.applicators), {}, {
              modelClass: tTe
            }),
            fieldCompletions: hTe(hTe({}, a.fieldCompletions), {}, {
              modelClass: mTe
            }),
            date: hTe(hTe({}, a.date), {}, {
              filterType: "date"
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.id,
              r = e.serial,
              n = e.type,
              o = {
            id: t,
            serial: r,
            date: e.date,
            sprayRecordId: e.sprayRecordId,
            startTime: e.startTime,
            stopTime: e.stopTime,
            windDirection: e.windDirection,
            temperatureUnits: e.temperatureUnits,
            temperatureLow: e.temperatureLow,
            temperatureHigh: e.temperatureHigh,
            lowWindSpeed: e.lowWindSpeed,
            highWindSpeed: e.highWindSpeed,
            applicators: e.applicators,
            fieldCompletions: e.fieldCompletions
          },
              i = hTe(hTe({}, o), {}, {
            id: hTe(hTe({}, o.id), {}, {
              backendKey: "uuid"
            }),
            serial: hTe(hTe({}, o.serial), {}, {
              backendKey: "id"
            }),
            lowWindSpeed: hTe(hTe({}, o.lowWindSpeed), {}, {
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            }),
            highWindSpeed: hTe(hTe({}, o.highWindSpeed), {}, {
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            })
          }),
              a = hTe(hTe({}, o), {}, {
            type: n,
            percentVarianceAcresTreated: {
              name: "% Variance",
              key: "percentVarianceAcresTreated",
              type: "number"
            },
            predictedAcresTreated: {
              name: "Predicted Acres Treated",
              key: "predictedAcresTreated",
              type: "number"
            },
            displayTotalTreatedAcres: {
              name: "Treated Acres Selected",
              key: "displayTotalTreatedAcres",
              type: "number"
            },
            displayTotalAcresCompleted: {
              name: "Total Acres Completed",
              key: "displayTotalAcresCompleted",
              type: "number"
            },
            displayTotalGallonsApplied: {
              name: "Total Gallons Applied",
              key: "displayTotalGallonsApplied",
              type: "number"
            },
            dateTime: {
              name: "Date Time",
              key: "dateTime",
              type: "string",
              filterType: "date"
            }
          });
          return $H.getConfig("useNewReports") ? i : a;
        }
      }]);
    }()).defaultKey = "dateTime", bTe = CTe((dTe = yTe).prototype, "_targetGpa", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), CTe(dTe.prototype, "percentVarianceAcresTreated", [f.computed], Object.getOwnPropertyDescriptor(dTe.prototype, "percentVarianceAcresTreated"), dTe.prototype), CTe(dTe.prototype, "predictedAcresTreated", [f.computed], Object.getOwnPropertyDescriptor(dTe.prototype, "predictedAcresTreated"), dTe.prototype), CTe(dTe.prototype, "displayTotalTreatedAcres", [f.computed], Object.getOwnPropertyDescriptor(dTe.prototype, "displayTotalTreatedAcres"), dTe.prototype), CTe(dTe.prototype, "displayTotalAcresCompleted", [f.computed], Object.getOwnPropertyDescriptor(dTe.prototype, "displayTotalAcresCompleted"), dTe.prototype), CTe(dTe.prototype, "displayTotalGallonsApplied", [f.computed], Object.getOwnPropertyDescriptor(dTe.prototype, "displayTotalGallonsApplied"), dTe.prototype), CTe(dTe.prototype, "dateTime", [f.computed], Object.getOwnPropertyDescriptor(dTe.prototype, "dateTime"), dTe.prototype), CTe(dTe.prototype, "updateTargetGpa", [f.action], Object.getOwnPropertyDescriptor(dTe.prototype, "updateTargetGpa"), dTe.prototype), dTe);

    function NTe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function DTe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? NTe(Object(r), !0).forEach(function (t) {
          xTe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : NTe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function xTe(e, t, r) {
      return (t = MTe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function ATe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, MTe(n.key), n);
      }
    }

    function MTe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ITe(e, t, r) {
      return t = VTe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], VTe(e).constructor) : t.apply(e, r));
    }

    function FTe(e, t, r, n) {
      var o = BTe(VTe(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function BTe() {
      return (BTe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = LTe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function LTe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = VTe(e)););

      return e;
    }

    function VTe(e) {
      return (VTe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function UTe(e, t) {
      return (UTe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function qTe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var KTe,
        GTe,
        WTe = ((TTe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = ITe(this, t, [].concat(n)), "targetRate", RTe, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && UTe(e, t);
      }(t, Object(w["MixInto"])(w["SprayRecordProductApplication"])(w["reportableMixin"])), r = t, o = [{
        key: "getAttributeDefinition",
        value: function () {
          var e = FTe(t, "getAttributeDefinition", this, 2)([]);
          return DTe(DTe({}, e), {}, {
            product: DTe(DTe({}, e.product), {}, {
              modelClass: zPe,
              defaultValue: new zPe(),
              filterType: "searchableMultiSelect"
            }),
            rate: DTe(DTe({}, e.rate), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            phi: DTe(DTe({}, e.phi), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            rei: DTe(DTe({}, e.rei), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            phiOverride: DTe(DTe({}, e.phiOverride), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            reiOverride: DTe(DTe({}, e.reiOverride), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            target: DTe(DTe({}, e.target), {}, {
              filterType: "searchableMultiSelect"
            }),
            total: DTe(DTe({}, e.total), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.id,
              r = e.serial,
              n = e.type,
              o = {
            id: t,
            serial: r,
            sprayRecordId: e.sprayRecordId,
            product: e.product,
            rate: e.rate,
            phi: e.phi,
            rei: e.rei,
            target: e.target,
            position: e.position,
            phiOverride: e.phiOverride,
            phiOverrideBy: e.phiOverrideBy,
            phiOverrideReason: e.phiOverrideReason,
            reiOverride: e.reiOverride,
            reiOverrideBy: e.reiOverrideBy,
            reiOverrideReason: e.reiOverrideReason,
            total: e.total
          },
              i = DTe(DTe({}, o), {}, {
            id: DTe(DTe({}, o.id), {}, {
              backendKey: "uuid"
            }),
            serial: DTe(DTe({}, o.serial), {}, {
              backendKey: "id"
            }),
            rate: DTe(DTe({}, o.rate), {}, {
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            }),
            phi: DTe(DTe({}, o.phi), {}, {
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            }),
            rei: DTe(DTe({}, o.rei), {}, {
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            }),
            phiOverride: DTe(DTe({}, o.phiOverride), {}, {
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            }),
            reiOverride: DTe(DTe({}, o.reiOverride), {}, {
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            }),
            total: DTe(DTe({}, o.total), {}, {
              type: "string",
              modelClass: null,
              defaultValue: null,
              calculable: !0
            })
          }),
              a = DTe(DTe({}, o), {}, {
            type: n,
            ratePerAcre: {
              name: "Rate/Acre",
              key: "ratePerAcre",
              type: "model",
              modelClass: Dge
            },
            ratePerVolume: {
              name: "Rate/Volume",
              key: "ratePerVolume",
              type: "model",
              modelClass: Dge
            },
            poundsPerAcre: {
              name: "Lbs/Acre",
              key: "poundsPerAcre",
              type: "model",
              modelClass: Dge
            }
          });
          return $H.getConfig("useNewReports") ? i : a;
        }
      }], (n = [{
        key: "ratePerAcre",
        get: function () {
          if (this.ratePerArea) return this.ratePerArea.isCompatible("lbs/acre") || this.ratePerArea.isCompatible("gal/acre") || this.ratePerArea.isCompatible("/acre") ? this.ratePerArea.to("".concat(this.ratePerArea.numeratorUnits, "/acre")) : void 0;
        }
      }, {
        key: "ratePerArea",
        get: function () {
          return this.rate.isCompatible("lbs/acre") || this.rate.isCompatible("gal/acre") || this.rate.isCompatible("/acre") ? this.rate : this.targetRate && Dge.isQuantityTruthy(this.targetRate) && Dge.isCompatible(this.targetRate, "gal/acre") && (this.rate.isCompatible("floz/gal") || this.rate.isCompatible("lbs/gal") || this.rate.isCompatible("/gal")) ? this.rate.mul(this.targetRate) : void 0;
        }
      }, {
        key: "ratePerVolume",
        get: function () {
          return this.rate.isCompatible("floz/gal") || this.rate.isCompatible("lbs/gal") || this.rate.isCompatible("/gal") ? this.rate : this.targetRate && Dge.isQuantityTruthy(this.targetRate) && Dge.isCompatible(this.targetRate, "gal/acre") && (this.rate.isCompatible("lbs/acre") || this.rate.isCompatible("gal/acre") || this.rate.isCompatible("/acre")) ? this.rate.div(this.targetRate).to("".concat(this.rate.numeratorUnits, "/hgal")) : void 0;
        }
      }, {
        key: "poundsPerAcre",
        get: function () {
          try {
            return FTe(t, "poundsPerAcre", this, 3)([this.targetRate]);
          } catch (e) {
            return console.error(e), new Dge();
          }
        }
      }]) && ATe(r.prototype, n), o && ATe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).defaultKey = "product", RTe = qTe((kTe = TTe).prototype, "targetRate", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), qTe(kTe.prototype, "ratePerAcre", [f.computed], Object.getOwnPropertyDescriptor(kTe.prototype, "ratePerAcre"), kTe.prototype), qTe(kTe.prototype, "ratePerArea", [f.computed], Object.getOwnPropertyDescriptor(kTe.prototype, "ratePerArea"), kTe.prototype), qTe(kTe.prototype, "ratePerVolume", [f.computed], Object.getOwnPropertyDescriptor(kTe.prototype, "ratePerVolume"), kTe.prototype), qTe(kTe.prototype, "poundsPerAcre", [f.computed], Object.getOwnPropertyDescriptor(kTe.prototype, "poundsPerAcre"), kTe.prototype), kTe);

    function HTe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function JTe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? HTe(Object(r), !0).forEach(function (t) {
          YTe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : HTe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function YTe(e, t, r) {
      return (t = $Te(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function QTe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $Te(n.key), n);
      }
    }

    function $Te(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function XTe(e, t, r) {
      return t = nze(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], nze(e).constructor) : t.apply(e, r));
    }

    function ZTe(e, t) {
      return (ZTe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function eze(e, t, r, n) {
      var o = tze(nze(1 & n ? e.prototype : e), t, r);
      return 2 & n && "function" == typeof o ? function (e) {
        return o.apply(r, e);
      } : o;
    }

    function tze() {
      return (tze = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = rze(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function rze(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = nze(e)););

      return e;
    }

    function nze(e) {
      return (nze = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var oze = ((GTe = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = XTe(this, t, [e])).productApplications.forEach(function (e) {
          e.targetRate = r.targetGallonsPerAcre && new Dge(r.targetGallonsPerAcre).mul("1 gal/acre");
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ZTe(e, t);
      }(t, Object(w["MixInto"])(w["SprayRecord"])(w["reportableMixin"])), r = t, o = [{
        key: "getAttributeDefinition",
        value: function () {
          var e = eze(t, "getAttributeDefinition", this, 2)([]);
          return JTe(JTe({}, e), {}, {
            account: JTe(JTe({}, e.account), {}, {
              modelClass: nje,
              defaultValue: new nje(),
              filterType: "accountSelect"
            }),
            createdAt: JTe(JTe({}, e.createdAt), {}, {
              filterType: "date"
            }),
            updatedAt: JTe(JTe({}, e.updatedAt), {}, {
              filterType: "date"
            }),
            date: JTe(JTe({}, e.date), {}, {
              filterType: "date",
              dateFormat: "YYYY-MM-DD"
            }),
            cropNames: JTe(JTe({}, e.cropNames), {}, {
              filterType: "searchableMultiSelect",
              filterMethod: this.cropNamesFilterMethod
            }),
            licensedApplicator: JTe(JTe({}, e.licensedApplicator), {}, {
              modelClass: Vke,
              defaultValue: new Vke()
            }),
            maxPhi: JTe(JTe({}, e.maxPhi), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            maxRei: JTe(JTe({}, e.maxRei), {}, {
              modelClass: Dge,
              defaultValue: new Dge("")
            }),
            fields: JTe(JTe({}, e.fields), {}, {
              modelClass: lRe,
              filterType: "searchableMultiSelect",
              filterMethod: this.fieldsFilterMethod
            }),
            recommendation: JTe(JTe({}, e.recommendation), {}, {
              modelClass: ORe,
              defaultValue: new ORe()
            }),
            applications: JTe(JTe({}, e.applications), {}, {
              modelClass: zTe,
              filterType: "date",
              filterMethod: this.dateTimeFilterMethod
            }),
            productApplications: JTe(JTe({}, e.productApplications), {}, {
              modelClass: WTe,
              filterType: "searchableMultiSelect"
            }),
            applicationMethod: JTe(JTe({}, e.applicationMethod), {}, {
              filterType: "multiSelect"
            })
          });
        }
      }, {
        key: "reportableAttributes",
        get: function () {
          var e = this.attributeDefinition,
              t = e.id,
              r = e.name,
              n = e.serial,
              o = e.date,
              i = e.createdAt,
              a = e.updatedAt,
              c = e.type,
              u = e.account,
              l = e.cropNames,
              s = e.notes,
              p = e.organic,
              f = e.applicationMethod,
              d = e.targetGallonsPerAcre,
              b = e.licensedApplicator,
              y = e.fields,
              m = e.recommendation,
              v = e.complete,
              h = e.applications,
              g = e.maxPhi,
              w = e.maxRei,
              O = {
            id: t,
            name: r,
            serial: n,
            createdAt: i,
            updatedAt: a,
            account: u,
            cropNames: l,
            notes: s,
            organic: p,
            applicationMethod: f,
            targetGallonsPerAcre: d,
            licensedApplicator: b,
            fields: y,
            recommendation: m,
            complete: v,
            applications: h,
            productApplications: e.productApplications,
            targetCoveragePercentage: e.targetCoveragePercentage
          },
              j = JTe(JTe({}, O), {}, {
            id: JTe(JTe({}, O.id), {}, {
              backendKey: "uuid"
            }),
            serial: JTe(JTe({}, O.serial), {}, {
              backendKey: "id"
            })
          }),
              P = JTe(JTe({}, O), {}, {
            date: o,
            type: c,
            maxPhi: g,
            maxRei: w
          });
          return $H.getConfig("useNewReports") ? j : P;
        }
      }, {
        key: "isInDateRange",
        value: function (e, t, r, n) {
          var o = n && r.add(1, "d"),
              i = e.isSameOrBefore(r) || o && e.isSameOrBefore(o),
              a = t.isSameOrAfter(r) || o && t.isSameOrAfter(o);
          return i && a;
        }
      }], (n = [{
        key: "update",
        value: function (e) {
          var r = this,
              n = e || {};
          return eze(t, "update", this, 3)([e]), Object(w.includesAny)(["targetGallonsPerAcre", "target_gallons_per_acre"], Object.keys(n)) && (this.applications || []).forEach(function (e) {
            e.updateTargetGpa(r.targetGallonsPerAcre);
          }), this;
        }
      }]) && QTe(r.prototype, n), o && QTe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).dateTimeFilterMethod = function (e) {
      var t,
          r,
          n,
          o = e.row,
          i = e.filter,
          a = e.defaultAnswer,
          c = i.columnSpec,
          u = null === (t = Object(x.path)(i.accessor, o)) || void 0 === t ? void 0 : t.model;
      u || (u = null === (n = Object(x.path)(i.accessor.slice(0, -1), o)) || void 0 === n ? void 0 : n.model);
      var l = M()(i.value.startDate, [].concat(c.attribute.dateFormat || []).concat(M.a.ISO_8601)),
          s = M()(i.value.endDate, [].concat(c.attribute.dateFormat || []).concat(M.a.ISO_8601));
      return (null === (r = u) || void 0 === r ? void 0 : r.date) && GTe.isInDateRange(l, s, M()(u.date), u.isOvernight) && a;
    }, GTe.fieldsFilterMethod = function (e) {
      var t = e.row,
          r = e.filter,
          n = e.defaultAnswer;
      return r.value.some(function (e) {
        return Object(x.path)(["fields", "id"], t) === e.value;
      }) && n;
    }, GTe.cropNamesFilterMethod = function (e) {
      var t = e.row,
          r = e.filter,
          n = e.defaultAnswer;
      return r.value.some(function (e) {
        return Object(w.includesAny)(Object(x.path)(r.accessor, t), e.value);
      }) && n;
    }, function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((KTe = GTe).prototype, "update", [f.action], Object.getOwnPropertyDescriptor(KTe.prototype, "update"), KTe.prototype), KTe);

    function ize(e) {
      return function (e) {
        if (Array.isArray(e)) return aze(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return aze(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? aze(e, t) : void 0;
        }
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function aze(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function cze(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, uze(n.key), n);
      }
    }

    function uze(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function lze(e, t, r) {
      return t = sze(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], sze(e).constructor) : t.apply(e, r));
    }

    function sze(e) {
      return (sze = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function pze(e, t) {
      return (pze = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var fze = function (e) {
      function t(e, r) {
        var n;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (n = lze(this, t, [e, r])).collectionKey = "sprayRecords", n;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && pze(e, t);
      }(t, w_e), r = t, (n = [{
        key: "new",
        value: function (e) {
          return new oze(e);
        }
      }, {
        key: "isDateFilterRefinement",
        value: function (e, t) {
          var r = M()(e.values.start),
              n = M()(e.values.end),
              o = M()(t.values.start),
              i = M()(t.values.end);
          return r.isBetween(o, i, void 0, "[]") && n.isBetween(o, i, void 0, "[]");
        }
      }, {
        key: "isNutrientFilterRefinement",
        value: function (e, t) {
          return Object(x.equals)(e.values, t.values);
        }
      }, {
        key: "isTextFilterRefinement",
        value: function (e, t) {
          return Object(x.equals)(e.values, t.values);
        }
      }, {
        key: "isFilterRefinement",
        value: function (e) {
          var t = {
            date: this.isDateFilterRefinement,
            nutrient: this.isNutrientFilterRefinement,
            "product.name": this.isTextFilterRefinement,
            field: this.isTextFilterRefinement,
            crop: this.isTextFilterRefinement,
            variety: this.isTextFilterRefinement,
            target: this.isTextFilterRefinement,
            status: this.isTextFilterRefinement
          };
          return !this.filtersForLastQuery || !this.filtersForLastQuery.length || !!e && this.filtersForLastQuery.every(function (r) {
            var n = e.find(function (e) {
              return e.filter === r.filter;
            });
            return n && t[r.filter](n, r);
          });
        }
      }, {
        key: "getDateFilterRange",
        value: function (e) {
          var t = Math.max.apply(Math, ize(e.map(function (e) {
            var t;
            return null == e || null === (t = e.value) || void 0 === t ? void 0 : t.startDate;
          }))),
              r = Math.min.apply(Math, ize(e.map(function (e) {
            var t;
            return null == e || null === (t = e.value) || void 0 === t ? void 0 : t.endDate;
          }))),
              n = {};
          return t > -1 / 0 && (n.start = new Date(t).toISOString()), r < 1 / 0 && (n.end = new Date(r).toISOString()), n;
        }
      }, {
        key: "_getProductNameFilterValues",
        value: function (e) {
          var t,
              r,
              n = ((null === (t = e.find(function (e) {
            return "productApplications" === e.key;
          })) || void 0 === t ? void 0 : t.value) || []).map(function (e) {
            return e.value;
          }),
              o = ((null === (r = e.find(function (e) {
            return "productApplications/product" === e.key;
          })) || void 0 === r ? void 0 : r.value) || []).map(function (e) {
            return e.value;
          });
          return n.length && o.length ? Object(x.intersection)(n, o) : n.length ? n : o;
        }
      }, {
        key: "_getFieldFilterValues",
        value: function (e) {
          var t;
          return ((null === (t = e.find(function (e) {
            return "fields" === e.key;
          })) || void 0 === t ? void 0 : t.value) || []).map(function (e) {
            return e.value;
          });
        }
      }, {
        key: "_getCropFilterValues",
        value: function (e) {
          var t,
              r,
              n = ((null === (t = e.find(function (e) {
            return "cropNames" === e.key;
          })) || void 0 === t ? void 0 : t.value) || []).map(function (e) {
            return e.value;
          }),
              o = ((null === (r = e.find(function (e) {
            return "fields/crop" === e.key;
          })) || void 0 === r ? void 0 : r.value) || []).map(function (e) {
            return e.value;
          });
          return n.length && o.length ? Object(x.intersection)(n, o) : n.length ? n : o;
        }
      }, {
        key: "_getVarietyFilterValues",
        value: function (e) {
          var t,
              r,
              n = ((null === (t = e.find(function (e) {
            return "fields/fieldVarieties" === e.key;
          })) || void 0 === t ? void 0 : t.value) || []).map(function (e) {
            return e.value;
          }),
              o = ((null === (r = e.find(function (e) {
            return "fields/crop/varieties" === e.key;
          })) || void 0 === r ? void 0 : r.value) || []).map(function (e) {
            return e.value;
          });
          return n.length && o.length ? Object(x.intersection)(n, o) : n.length ? n : o;
        }
      }, {
        key: "getQueryFilters",
        value: function (e) {
          var t,
              r,
              n,
              o = Object.values(e || {}),
              i = o.find(function (e) {
            return "productApplications/product/hasNutrientAnalysis" === e.key;
          }),
              a = o.filter(function (e) {
            var t;
            return "date" === (null == e || null === (t = e.columnSpec) || void 0 === t || null === (t = t.attribute) || void 0 === t ? void 0 : t.filterType);
          }),
              c = this._getProductNameFilterValues(o),
              u = this._getFieldFilterValues(o),
              l = this._getCropFilterValues(o),
              s = this._getVarietyFilterValues(o),
              p = ((null === (t = o.find(function (e) {
            return "productApplications/target" === e.key;
          })) || void 0 === t ? void 0 : t.value) || []).map(function (e) {
            return e.value;
          }),
              f = ((null === (r = o.find(function (e) {
            return "complete" === e.key;
          })) || void 0 === r ? void 0 : r.value) || []).map(function (e) {
            return e ? "complete" : "incomplete";
          });

          if (a.length && (n = [].concat(n || []).concat({
            filter: "date",
            values: this.getDateFilterRange(a)
          })), null != i && i.value) {
            var d = i.value.includes(!0),
                b = i.value.includes(!1);
            (d && !b || b && !d) && (n = [].concat(n || []).concat({
              filter: "nutrient",
              values: [d]
            }));
          }

          return null != c && c.length && (n = [].concat(n || []).concat({
            filter: "product.name",
            values: c
          })), null != u && u.length && (n = [].concat(n || []).concat({
            filter: "field",
            values: u
          })), null != l && l.length && (n = [].concat(n || []).concat({
            filter: "crop",
            values: l
          })), null != s && s.length && (n = [].concat(n || []).concat({
            filter: "variety",
            values: s
          })), null != p && p.length && (n = [].concat(n || []).concat({
            filter: "target",
            values: p
          })), null != f && f.length && (n = [].concat(n || []).concat({
            filter: "status",
            values: f
          })), n;
        }
      }, {
        key: "loadOptionsFor",
        value: function (e) {
          var t = this,
              r = e.columnSpec,
              n = e.accounts,
              o = e.inputValue,
              i = e.currentFilters;
          return "productApplications" === r.id || "productApplications/product" === r.id ? this.api.fetchProducts({
            accounts: n,
            filters: this.getQueryFilters(i),
            search: o
          }).then(function (e) {
            return (e.products || []).map(function (e) {
              return {
                value: e.name,
                label: e.name
              };
            }).sort(t.constructor.sortByLabel);
          }) : "fields" === r.id ? this.api.fetchFields({
            accounts: n,
            filters: this.getQueryFilters(i),
            search: o
          }).then(function (e) {
            return (e.fields || []).map(function (e) {
              return {
                value: e.id,
                label: "".concat(e.accountName, ": ").concat(e.fieldName)
              };
            }).sort(t.constructor.sortByLabel);
          }) : "productApplications/target" === r.id ? this.api.fetchTargets({
            accounts: n,
            filters: this.getQueryFilters(i),
            search: o
          }).then(function (e) {
            return (e.targets || []).map(function (e) {
              return {
                value: e,
                label: e
              };
            }).sort(t.constructor.sortByLabel);
          }) : "cropNames" === r.id || "fields/crop" === r.id ? this.api.fetchCrops({
            accounts: n,
            filters: this.getQueryFilters(i),
            search: o
          }).then(function (e) {
            return (e.crops || []).map(function (e) {
              return {
                value: e,
                label: e
              };
            }).sort(t.constructor.sortByLabel);
          }) : "fields/fieldVarieties" === r.id || "fields/crop/varieties" === r.id ? this.api.fetchVarieties({
            accounts: n,
            filters: this.getQueryFilters(i),
            search: o
          }).then(function (e) {
            return (e.varieties || []).map(function (e) {
              return {
                value: e,
                label: e
              };
            }).sort(t.constructor.sortByLabel);
          }) : void 0;
        }
      }]) && cze(r.prototype, n), o && cze(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    fze.sortByLabel = function (e, t) {
      return e.label && t.label ? Object(w.naturalSort)(String(e.label).toLowerCase(), String(t.label).toLowerCase()) : 0;
    };

    var dze = fze;

    function bze(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function yze(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? bze(Object(r), !0).forEach(function (t) {
          mze(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bze(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function mze(e, t, r) {
      return (t = hze(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function vze(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, hze(n.key), n);
      }
    }

    function hze(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function gze(e, t, r) {
      return t = wze(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], wze(e).constructor) : t.apply(e, r));
    }

    function wze(e) {
      return (wze = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Oze(e, t) {
      return (Oze = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var jze = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = gze(this, t, [].concat(n))).sprayRecordsPath = "/if2/api/spray_records", e.sprayRecordsQueryPath = "".concat(e.sprayRecordsPath, "/query"), e.sprayRecordsProductsPath = "".concat(e.sprayRecordsPath, "/products"), e.sprayRecordsFieldsPath = "".concat(e.sprayRecordsPath, "/fields"), e.sprayRecordsCropsPath = "".concat(e.sprayRecordsPath, "/crops"), e.sprayRecordsTargetsPath = "".concat(e.sprayRecordsPath, "/targets"), e.sprayRecordsVarietiesPath = "".concat(e.sprayRecordsPath, "/varieties"), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Oze(e, t);
      }(t, My), r = t, (n = [{
        key: "fetchAll",
        value: function () {
          var e = this.csrf();
          return fetch(this.sprayRecordsPath, {
            method: "GET",
            headers: {
              "X-CSRF-Token": e,
              "Content-Type": "application/json"
            }
          });
        }
      }, {
        key: "fetchAllForAccounts",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = this.csrf();
          return fetch(this.sprayRecordsQueryPath, {
            method: "POST",
            headers: {
              "X-CSRF-Token": r,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(yze({
              accounts: e
            }, t))
          });
        }
      }, {
        key: "fetchProducts",
        value: function (e) {
          return this.jsonFetch(this.sprayRecordsProductsPath, "POST", e);
        }
      }, {
        key: "fetchFields",
        value: function (e) {
          return this.jsonFetch(this.sprayRecordsFieldsPath, "POST", e);
        }
      }, {
        key: "fetchCrops",
        value: function (e) {
          return this.jsonFetch(this.sprayRecordsCropsPath, "POST", e);
        }
      }, {
        key: "fetchTargets",
        value: function (e) {
          return this.jsonFetch(this.sprayRecordsTargetsPath, "POST", e);
        }
      }, {
        key: "fetchVarieties",
        value: function (e) {
          return this.jsonFetch(this.sprayRecordsVarietiesPath, "POST", e);
        }
      }]) && vze(r.prototype, n), o && vze(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function Pze(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _ze(n.key), n);
      }
    }

    function _ze(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Eze(e, t, r) {
      return t = Sze(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Sze(e).constructor) : t.apply(e, r));
    }

    function Sze(e) {
      return (Sze = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Cze(e, t) {
      return (Cze = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var kze,
        Rze,
        Tze,
        zze,
        Nze = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        e = Eze(this, t, [].concat(n));
        var i = new h.SelectorModel(e.translatedDateOptions);
        return e.registerSelectorModel(i), e.onMount(), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Cze(e, t);
      }(t, h["DateRangeSelectorModel"]), r = t, o = [{
        key: "fromJS",
        value: function (e) {
          var t,
              r,
              n = new this();
          n.updateDateRanges();
          var o = new h.SelectorModel(n.translatedDateOptions);
          return n.registerSelectorModel(o), n.selectOption(null === (t = e.selectedOption) || void 0 === t ? void 0 : t.key), "custom" === (null === (r = o.selectedOption) || void 0 === r ? void 0 : r.key) && (n.onChangeStartDate(e.startDate && M()(e.startDate).toDate() || ""), n.onChangeEndDate(e.endDate && M()(e.endDate).toDate() || "")), n;
        }
      }], (n = [{
        key: "toJS",
        value: function () {
          var e, t, r, n, o;
          return {
            selectedOption: Object(f.toJS)(null === (e = this.selector) || void 0 === e ? void 0 : e.selectedOption),
            startDate: (null === (t = (r = this.startDate).toISOString) || void 0 === t ? void 0 : t.call(r)) || this.startDate,
            endDate: (null === (n = (o = this.endDate).toISOString) || void 0 === n ? void 0 : n.call(o)) || this.endDate
          };
        }
      }]) && Pze(r.prototype, n), o && Pze(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function Dze(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function xze(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Aze(n.key), n);
      }
    }

    function Aze(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Mze(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Ize,
        Fze = (Rze = Mze((kze = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Dze(this, "value", Rze, this), Dze(this, "columnSpec", Tze, this), Dze(this, "matchMethod", zze, this), this.update(t);
      }, (t = [{
        key: "id",
        get: function () {
          var e;
          return null === (e = this.columnSpec) || void 0 === e ? void 0 : e.id;
        }
      }, {
        key: "key",
        get: function () {
          return this.id;
        }
      }, {
        key: "isArray",
        get: function () {
          return Array.isArray(this.value);
        }
      }, {
        key: "toJS",
        value: function () {
          var e, t;
          return {
            key: this.key,
            value: (null === (e = (t = this.value).toJS) || void 0 === e ? void 0 : e.call(t)) || this.value,
            match_method: this.matchMethod
          };
        }
      }, {
        key: "update",
        value: function (e) {
          return this.value = e.value || this.value, this.columnSpec = e.columnSpec || this.columnSpec, this.matchMethod = e.matchMethod || e.match_method || this.matchMethod, this;
        }
      }]) && xze(e.prototype, t), r && xze(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "value", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Tze = Mze(kze.prototype, "columnSpec", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), zze = Mze(kze.prototype, "matchMethod", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), Mze(kze.prototype, "id", [f.computed], Object.getOwnPropertyDescriptor(kze.prototype, "id"), kze.prototype), Mze(kze.prototype, "key", [f.computed], Object.getOwnPropertyDescriptor(kze.prototype, "key"), kze.prototype), Mze(kze.prototype, "isArray", [f.computed], Object.getOwnPropertyDescriptor(kze.prototype, "isArray"), kze.prototype), Mze(kze.prototype, "update", [f.action], Object.getOwnPropertyDescriptor(kze.prototype, "update"), kze.prototype), kze);

    function Bze(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Lze(n.key), n);
      }
    }

    function Lze(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Vze(e, t, r) {
      return t = Uze(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Uze(e).constructor) : t.apply(e, r));
    }

    function Uze(e) {
      return (Uze = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function qze(e, t) {
      return (qze = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Kze = (function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((Ize = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Vze(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && qze(e, t);
      }(t, Fze), r = t, (n = [{
        key: "accessor",
        get: function () {
          return this.columnSpec.defaultAccessorPath;
        }
      }]) && Bze(r.prototype, n), o && Bze(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "accessor", [f.computed], Object.getOwnPropertyDescriptor(Ize.prototype, "accessor"), Ize.prototype), Ize);

    function Gze(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Wze(n.key), n);
      }
    }

    function Wze(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Hze(e, t, r) {
      return t = Jze(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Jze(e).constructor) : t.apply(e, r));
    }

    function Jze(e) {
      return (Jze = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Yze(e, t) {
      return (Yze = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Qze,
        $ze,
        Xze = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = Hze(this, t, [e])).update({
          value: e.value instanceof Nze ? e.value : Nze.fromJS(e.value)
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Yze(e, t);
      }(t, Kze), r = t, (n = [{
        key: "toJS",
        value: function () {
          return {
            key: this.key,
            value: this.value.toJS(),
            accessor: this.accessor,
            match_method: this.matchMethod
          };
        }
      }]) && Gze(r.prototype, n), o && Gze(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function Zze(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, eNe(n.key), n);
      }
    }

    function eNe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function tNe(e, t, r) {
      return t = rNe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], rNe(e).constructor) : t.apply(e, r));
    }

    function rNe(e) {
      return (rNe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function nNe(e, t) {
      return (nNe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function oNe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var iNe = ($ze = oNe((Qze = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = tNe(this, t, [e]), "filterSpecificFields", $ze, r), r.filterSpecificFields = e.filterSpecificFields, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && nNe(e, t);
      }(t, Kze), r = t, (n = [{
        key: "accessor",
        get: function () {
          return this.filterSpecificFields ? this.columnSpec.path : this.columnSpec.defaultAccessorPath;
        }
      }]) && Zze(r.prototype, n), o && Zze(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "filterSpecificFields", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), oNe(Qze.prototype, "accessor", [f.computed], Object.getOwnPropertyDescriptor(Qze.prototype, "accessor"), Qze.prototype), Qze);

    function aNe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, cNe(n.key), n);
      }
    }

    function cNe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function uNe(e, t, r) {
      return t = lNe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], lNe(e).constructor) : t.apply(e, r));
    }

    function lNe(e) {
      return (lNe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function sNe(e, t) {
      return (sNe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var pNe,
        fNe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), uNe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && sNe(e, t);
      }(t, Fze), r = t, n && aNe(r.prototype, n), o && aNe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function dNe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bNe(n.key), n);
      }
    }

    function bNe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function yNe(e, t, r) {
      return t = mNe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], mNe(e).constructor) : t.apply(e, r));
    }

    function mNe(e) {
      return (mNe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function vNe(e, t) {
      return (vNe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var hNe,
        gNe,
        wNe,
        ONe,
        jNe = (function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((pNe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), yNe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && vNe(e, t);
      }(t, Kze), r = t, (n = [{
        key: "accessor",
        get: function () {
          return this.columnSpec.path;
        }
      }]) && dNe(r.prototype, n), o && dNe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "accessor", [f.computed], Object.getOwnPropertyDescriptor(pNe.prototype, "accessor"), pNe.prototype), pNe),
        PNe = r(212),
        _Ne = r.n(PNe);

    function ENe() {
      /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
      ENe = function () {
        return t;
      };

      var e,
          t = {},
          r = Object.prototype,
          n = r.hasOwnProperty,
          o = Object.defineProperty || function (e, t, r) {
        e[t] = r.value;
      },
          i = "function" == typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          c = i.asyncIterator || "@@asyncIterator",
          u = i.toStringTag || "@@toStringTag";

      function l(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        l({}, "");
      } catch (e) {
        l = function (e, t, r) {
          return e[t] = r;
        };
      }

      function s(e, t, r, n) {
        var i = t && t.prototype instanceof v ? t : v,
            a = Object.create(i.prototype),
            c = new T(n || []);
        return o(a, "_invoke", {
          value: S(e, r, c)
        }), a;
      }

      function p(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      t.wrap = s;
      var f = "suspendedStart",
          d = "suspendedYield",
          b = "executing",
          y = "completed",
          m = {};

      function v() {}

      function h() {}

      function g() {}

      var w = {};
      l(w, a, function () {
        return this;
      });
      var O = Object.getPrototypeOf,
          j = O && O(O(z([])));
      j && j !== r && n.call(j, a) && (w = j);
      var P = g.prototype = v.prototype = Object.create(w);

      function _(e) {
        ["next", "throw", "return"].forEach(function (t) {
          l(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function E(e, t) {
        function r(o, i, a, c) {
          var u = p(e[o], e, i);

          if ("throw" !== u.type) {
            var l = u.arg,
                s = l.value;
            return s && "object" == typeof s && n.call(s, "__await") ? t.resolve(s.__await).then(function (e) {
              r("next", e, a, c);
            }, function (e) {
              r("throw", e, a, c);
            }) : t.resolve(s).then(function (e) {
              l.value = e, a(l);
            }, function (e) {
              return r("throw", e, a, c);
            });
          }

          c(u.arg);
        }

        var i;
        o(this, "_invoke", {
          value: function (e, n) {
            function o() {
              return new t(function (t, o) {
                r(e, n, t, o);
              });
            }

            return i = i ? i.then(o, o) : o();
          }
        });
      }

      function S(t, r, n) {
        var o = f;
        return function (i, a) {
          if (o === b) throw Error("Generator is already running");

          if (o === y) {
            if ("throw" === i) throw a;
            return {
              value: e,
              done: !0
            };
          }

          for (n.method = i, n.arg = a;;) {
            var c = n.delegate;

            if (c) {
              var u = C(c, n);

              if (u) {
                if (u === m) continue;
                return u;
              }
            }

            if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
              if (o === f) throw o = y, n.arg;
              n.dispatchException(n.arg);
            } else "return" === n.method && n.abrupt("return", n.arg);
            o = b;
            var l = p(t, r, n);

            if ("normal" === l.type) {
              if (o = n.done ? y : d, l.arg === m) continue;
              return {
                value: l.arg,
                done: n.done
              };
            }

            "throw" === l.type && (o = y, n.method = "throw", n.arg = l.arg);
          }
        };
      }

      function C(t, r) {
        var n = r.method,
            o = t.iterator[n];
        if (o === e) return r.delegate = null, "throw" === n && t.iterator.return && (r.method = "return", r.arg = e, C(t, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), m;
        var i = p(o, t.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, m;
        var a = i.arg;
        return a ? a.done ? (r[t.resultName] = a.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, m) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, m);
      }

      function k(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function R(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function T(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(k, this), this.reset(!0);
      }

      function z(t) {
        if (t || "" === t) {
          var r = t[a];
          if (r) return r.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var o = -1,
                i = function r() {
              for (; ++o < t.length;) if (n.call(t, o)) return r.value = t[o], r.done = !1, r;

              return r.value = e, r.done = !0, r;
            };

            return i.next = i;
          }
        }

        throw new TypeError(typeof t + " is not iterable");
      }

      return h.prototype = g, o(P, "constructor", {
        value: g,
        configurable: !0
      }), o(g, "constructor", {
        value: h,
        configurable: !0
      }), h.displayName = l(g, u, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === h || "GeneratorFunction" === (t.displayName || t.name));
      }, t.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, g) : (e.__proto__ = g, l(e, u, "GeneratorFunction")), e.prototype = Object.create(P), e;
      }, t.awrap = function (e) {
        return {
          __await: e
        };
      }, _(E.prototype), l(E.prototype, c, function () {
        return this;
      }), t.AsyncIterator = E, t.async = function (e, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new E(s(e, r, n, o), i);
        return t.isGeneratorFunction(r) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, _(P), l(P, u, "Generator"), l(P, a, function () {
        return this;
      }), l(P, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (e) {
        var t = Object(e),
            r = [];

        for (var n in t) r.push(n);

        return r.reverse(), function e() {
          for (; r.length;) {
            var n = r.pop();
            if (n in t) return e.value = n, e.done = !1, e;
          }

          return e.done = !0, e;
        };
      }, t.values = z, T.prototype = {
        constructor: T,
        reset: function (t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(R), !t) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
        },
        stop: function () {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function (t) {
          if (this.done) throw t;
          var r = this;

          function o(n, o) {
            return c.type = "throw", c.arg = t, r.next = n, o && (r.method = "next", r.arg = e), !!o;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
                c = a.completion;
            if ("root" === a.tryLoc) return o("end");

            if (a.tryLoc <= this.prev) {
              var u = n.call(a, "catchLoc"),
                  l = n.call(a, "finallyLoc");

              if (u && l) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
              } else {
                if (!l) throw Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return o(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function (e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];

            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }

          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, m) : this.complete(a);
        },
        complete: function (e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
        },
        finish: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), R(r), m;
          }
        },
        catch: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var o = n.arg;
                R(r);
              }

              return o;
            }
          }

          throw Error("illegal catch attempt");
        },
        delegateYield: function (t, r, n) {
          return this.delegate = {
            iterator: z(t),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = e), m;
        }
      }, t;
    }

    function SNe(e, t, r, n, o, i, a) {
      try {
        var c = e[i](a),
            u = c.value;
      } catch (e) {
        return void r(e);
      }

      c.done ? t(u) : Promise.resolve(u).then(n, o);
    }

    function CNe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function kNe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, TNe(n.key), n);
      }
    }

    function RNe(e, t, r) {
      return t && kNe(e.prototype, t), r && kNe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function TNe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function zNe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var NNe,
        DNe,
        xNe,
        ANe,
        MNe,
        INe,
        FNe,
        BNe,
        LNe,
        VNe,
        UNe,
        qNe,
        KNe,
        GNe,
        WNe,
        HNe,
        JNe,
        YNe,
        QNe,
        $Ne,
        XNe,
        ZNe,
        eDe,
        tDe,
        rDe,
        nDe,
        oDe,
        iDe,
        aDe = (gNe = zNe((hNe = RNe(function e(t) {
      var r = t.store,
          n = t.columnSpec,
          o = t.currentFilters,
          i = t.accountIds,
          a = t.value;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), CNe(this, "value", gNe, this), CNe(this, "_loadOptions", wNe, this), CNe(this, "onChange", ONe, this), this.store = r, this.columnSpec = n, this.currentFilters = o, this.accountIds = i, this.loadOptions = _Ne()(this._loadOptions, 500), this.value = a;
    })).prototype, "value", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), wNe = zNe(hNe.prototype, "_loadOptions", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t,
              r = (t = ENe().mark(function t(r) {
            return ENe().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return t.abrupt("return", e.store.loadOptionsFor({
                    columnSpec: e.columnSpec,
                    accounts: e.accountIds,
                    currentFilters: e.currentFilters,
                    inputValue: r
                  }));

                case 1:
                case "end":
                  return t.stop();
              }
            }, t);
          }), function () {
            var e = this,
                r = arguments;
            return new Promise(function (n, o) {
              var i = t.apply(e, r);

              function a(e) {
                SNe(i, n, o, a, c, "next", e);
              }

              function c(e) {
                SNe(i, n, o, a, c, "throw", e);
              }

              a(void 0);
            });
          });
          return function (e) {
            return r.apply(this, arguments);
          };
        }();
      }
    }), ONe = zNe(hNe.prototype, "onChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.value = t;
        };
      }
    }), hNe);

    function cDe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function uDe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? cDe(Object(r), !0).forEach(function (t) {
          lDe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : cDe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function lDe(e, t, r) {
      return (t = fDe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function sDe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function pDe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, fDe(n.key), n);
      }
    }

    function fDe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function dDe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var bDe = (DNe = dDe((NNe = function () {
      function e() {
        var t = this,
            r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), sDe(this, "isShowing", DNe, this), sDe(this, "columnFilters", xNe, this), sDe(this, "currentFilterChoices", ANe, this), sDe(this, "currentFilterAttribute", MNe, this), sDe(this, "currentFilterAccessor", INe, this), sDe(this, "currentColumnSpec", FNe, this), sDe(this, "currentDateRangeSelector", BNe, this), sDe(this, "currentMultiSelections", LNe, this), sDe(this, "currentFilter", VNe, this), sDe(this, "currentFilterAccountChoices", UNe, this), sDe(this, "fieldOptions", qNe, this), sDe(this, "fieldSelector", KNe, this), sDe(this, "filterSpecificFields", GNe, this), sDe(this, "searchableMultiselectModel", WNe, this), sDe(this, "applyFilter", HNe, this), sDe(this, "filterBy", JNe, this), sDe(this, "onHide", YNe, this), sDe(this, "onShow", QNe, this), sDe(this, "removeFilter", $Ne, this), sDe(this, "removeAllFilters", XNe, this), this.findAllFiltersByKey = function (e) {
          return t.columnFilters[e] && t.columnFilters[e].value || [];
        }, sDe(this, "setCurrentMultiSelectionsById", ZNe, this), sDe(this, "setCurrentFilters", eDe, this), sDe(this, "setCurrentFilterChoices", tDe, this), sDe(this, "setCurrentColumn", rDe, this), sDe(this, "registerFieldSelector", nDe, this), sDe(this, "setDataForModal", oDe, this), sDe(this, "toggleSpecificFields", iDe, this), this.applyColumnFilters(r);
      }

      return t = e, n = [{
        key: "getRootsFromCollection",
        value: function (e, t) {
          return t.reduce(function (r, n) {
            var o = e.accountsStore.find(n);
            return o ? t.includes(o.parent_id) ? r : r.concat(o) : r;
          }, []);
        }
      }, {
        key: "filterType",
        value: function (e) {
          var t;
          return null == e || null === (t = e.attribute) || void 0 === t ? void 0 : t.filterType;
        }
      }, {
        key: "shouldDateSelect",
        value: function (e) {
          return "date" === this.filterType(e);
        }
      }, {
        key: "shouldMultiSelect",
        value: function (e) {
          var t;
          return "multiSelect" === this.filterType(e) || "boolean" === (null == e || null === (t = e.attribute) || void 0 === t ? void 0 : t.type);
        }
      }, {
        key: "shouldMultiSelectWithSearch",
        value: function (e) {
          return "searchableMultiSelect" === this.filterType(e);
        }
      }, {
        key: "shouldAccountSelect",
        value: function (e) {
          return "accountSelect" === this.filterType(e);
        }
      }, {
        key: "shouldFieldSelect",
        value: function (e) {
          return "fieldSelect" === this.filterType(e);
        }
      }], (r = [{
        key: "shouldDateSelect",
        get: function () {
          return e.shouldDateSelect(this.currentColumnSpec);
        }
      }, {
        key: "shouldMultiSelect",
        get: function () {
          return e.shouldMultiSelect(this.currentColumnSpec);
        }
      }, {
        key: "shouldMultiSelectWithSearch",
        get: function () {
          return e.shouldMultiSelectWithSearch(this.currentColumnSpec);
        }
      }, {
        key: "shouldAccountSelect",
        get: function () {
          return e.shouldAccountSelect(this.currentColumnSpec);
        }
      }, {
        key: "shouldFieldSelect",
        get: function () {
          return e.shouldFieldSelect(this.currentColumnSpec);
        }
      }, {
        key: "numReportFilters",
        get: function () {
          return Object.values(this.columnFilters).length;
        }
      }, {
        key: "filterTitle",
        get: function () {
          return this.currentColumnSpec && this.currentColumnSpec.getName() || "";
        }
      }, {
        key: "createFilter",
        value: function (t) {
          return Due.isCalculationColumnSpec(t.columnSpec) ? new fNe(t) : e.shouldDateSelect(t.columnSpec) ? new Xze(t) : e.shouldFieldSelect(t.columnSpec) ? new iNe(uDe(uDe({}, t), {}, {
            filterSpecificFields: Array.isArray(t.value)
          })) : e.shouldAccountSelect(t.columnSpec) ? new jNe(t) : new Kze(t);
        }
      }, {
        key: "setCurrentDateModel",
        value: function () {
          var e;
          this.currentDateRangeSelector = (null === (e = this.currentFilter) || void 0 === e ? void 0 : e.value) && Nze.fromJS(this.currentFilter.value.toJS()) || new Nze();
        }
      }, {
        key: "setCurrentFieldSelector",
        value: function () {
          this.fieldSelector = this.fieldSelector || new h.FilteringMultiSelectModel(this.fieldOptions);
        }
      }, {
        key: "setFieldOptions",
        value: function (e) {
          this.fieldOptions = e;
        }
      }, {
        key: "filterRow",
        value: function (t, r, n) {
          var o,
              i = r.columnSpec;
          if ("function" == typeof (null === (o = i.attribute) || void 0 === o ? void 0 : o.filterMethod)) return i.attribute.filterMethod({
            row: t,
            filter: r,
            defaultAnswer: n
          });

          if (e.shouldDateSelect(i)) {
            var a,
                c,
                u = M()(Object(x.path)(r.accessor, t));
            return M()(r.value.startDate, [].concat((null == i || null === (a = i.attribute) || void 0 === a ? void 0 : a.dateFormat) || []).concat(M.a.ISO_8601)) <= u && M()(r.value.endDate, [].concat((null == i || null === (c = i.attribute) || void 0 === c ? void 0 : c.dateFormat) || []).concat(M.a.ISO_8601)) >= u && n;
          }

          if (e.shouldMultiSelectWithSearch(i)) return r.value.some(function (e) {
            return Object(x.path)(r.accessor, t) === e.value;
          }) && n;
          if (e.shouldMultiSelect(i)) return r.value.some(function (e) {
            return Object(x.path)(r.accessor, t) === e;
          }) && n;
          if (r.isArray) return r.value.some(function (e) {
            var n = Object(x.path)(r.accessor, t);
            return (n && n.id) === e;
          }) && n;
          var l = "".concat(i.display(t)).toLowerCase();
          return "Begins with" === r.matchMethod ? l.startsWith(r.value.toLowerCase()) && n : "Is Exactly" === r.matchMethod ? Object(x.path)(r.accessor, t) === r.value && n : l.includes(r.value.toLowerCase()) && n;
        }
      }, {
        key: "shouldIncludeRow",
        value: function (e, t) {
          var r = this;
          return !!e.id && Object.values(this.columnFilters).reduce(function (n, o) {
            return Ume.isReportColumnSpec(o.columnSpec) && !Object(x.hasPath)(o.accessor, e) ? !!t[e.id] && t[e.id].some(function (e) {
              return r.filterRow(e, o, n);
            }) && n : r.filterRow(e, o, n);
          }, !0);
        }
      }, {
        key: "toJS",
        value: function () {
          var e = this;
          return Object.keys(this.columnFilters).reduce(function (t, r) {
            return t[r] = e.columnFilters[r].toJS(), t;
          }, {});
        }
      }, {
        key: "applyColumnFilters",
        value: function (e) {
          var t = this;
          Object.keys(e).forEach(function (r) {
            var n;
            (null === (n = e[r]) || void 0 === n ? void 0 : n.columnSpec) && t.filterBy(t.createFilter(e[r]));
          }), Object.keys(this.columnFilters).forEach(function (r) {
            e[r] || t.removeFilter(r);
          });
        }
      }]) && pDe(t.prototype, r), n && pDe(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), t;
      var t, r, n;
    }()).prototype, "isShowing", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), xNe = dDe(NNe.prototype, "columnFilters", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return {};
      }
    }), ANe = dDe(NNe.prototype, "currentFilterChoices", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), MNe = dDe(NNe.prototype, "currentFilterAttribute", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), INe = dDe(NNe.prototype, "currentFilterAccessor", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), FNe = dDe(NNe.prototype, "currentColumnSpec", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), BNe = dDe(NNe.prototype, "currentDateRangeSelector", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), LNe = dDe(NNe.prototype, "currentMultiSelections", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), VNe = dDe(NNe.prototype, "currentFilter", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), UNe = dDe(NNe.prototype, "currentFilterAccountChoices", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), qNe = dDe(NNe.prototype, "fieldOptions", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), KNe = dDe(NNe.prototype, "fieldSelector", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), GNe = dDe(NNe.prototype, "filterSpecificFields", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), WNe = dDe(NNe.prototype, "searchableMultiselectModel", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), dDe(NNe.prototype, "shouldDateSelect", [f.computed], Object.getOwnPropertyDescriptor(NNe.prototype, "shouldDateSelect"), NNe.prototype), dDe(NNe.prototype, "shouldMultiSelect", [f.computed], Object.getOwnPropertyDescriptor(NNe.prototype, "shouldMultiSelect"), NNe.prototype), dDe(NNe.prototype, "shouldMultiSelectWithSearch", [f.computed], Object.getOwnPropertyDescriptor(NNe.prototype, "shouldMultiSelectWithSearch"), NNe.prototype), dDe(NNe.prototype, "shouldAccountSelect", [f.computed], Object.getOwnPropertyDescriptor(NNe.prototype, "shouldAccountSelect"), NNe.prototype), dDe(NNe.prototype, "shouldFieldSelect", [f.computed], Object.getOwnPropertyDescriptor(NNe.prototype, "shouldFieldSelect"), NNe.prototype), dDe(NNe.prototype, "numReportFilters", [f.computed], Object.getOwnPropertyDescriptor(NNe.prototype, "numReportFilters"), NNe.prototype), dDe(NNe.prototype, "filterTitle", [f.computed], Object.getOwnPropertyDescriptor(NNe.prototype, "filterTitle"), NNe.prototype), HNe = dDe(NNe.prototype, "applyFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r) {
          var n = {
            key: t.id,
            columnSpec: t,
            matchMethod: null
          };
          if (bDe.shouldDateSelect(t)) n.value = e.currentDateRangeSelector;else if (bDe.shouldMultiSelectWithSearch(t)) n.value = e.searchableMultiselectModel.value;else if (bDe.shouldMultiSelect(t)) n.value = e.currentMultiSelections;else if (bDe.shouldAccountSelect(t)) n.value = r.selectedAccountIds;else if (bDe.shouldFieldSelect(t) && e.filterSpecificFields) {
            var o;
            n.value = null === (o = e.fieldSelector) || void 0 === o ? void 0 : o.selectedKeys.slice();
          } else n.matchMethod = r.matchMethod, n.value = r.searchText;
          e.filterBy(e.createFilter(n));
        };
      }
    }), dDe(NNe.prototype, "createFilter", [f.action], Object.getOwnPropertyDescriptor(NNe.prototype, "createFilter"), NNe.prototype), JNe = dDe(NNe.prototype, "filterBy", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          if (t.isArray && !t.value.length) return e.removeFilter(t.key);
          e.columnFilters[t.key] = t;
        };
      }
    }), YNe = dDe(NNe.prototype, "onHide", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isShowing = !1;
        };
      }
    }), QNe = dDe(NNe.prototype, "onShow", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isShowing = !0;
        };
      }
    }), $Ne = dDe(NNe.prototype, "removeFilter", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return delete e.columnFilters[t];
        };
      }
    }), XNe = dDe(NNe.prototype, "removeAllFilters", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.columnFilters = {};
        };
      }
    }), ZNe = dDe(NNe.prototype, "setCurrentMultiSelectionsById", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.currentMultiSelections = e.findAllFiltersByKey(t).slice();
        };
      }
    }), eDe = dDe(NNe.prototype, "setCurrentFilters", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.currentMultiSelections = t;
        };
      }
    }), tDe = dDe(NNe.prototype, "setCurrentFilterChoices", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r) {
          var n;
          e.currentFilterChoices = ee([].concat("boolean" === (null === (n = e.currentColumnSpec) || void 0 === n || null === (n = n.attribute) || void 0 === n ? void 0 : n.type) ? [!0, !1] : []).concat(r.map(function (e) {
            return Object(x.path)(t, e);
          }))).sort(h.naturalSort);
        };
      }
    }), rDe = dDe(NNe.prototype, "setCurrentColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.currentColumnSpec = t;
        };
      }
    }), nDe = dDe(NNe.prototype, "registerFieldSelector", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.fieldSelector = t;
        };
      }
    }), dDe(NNe.prototype, "setCurrentDateModel", [f.action], Object.getOwnPropertyDescriptor(NNe.prototype, "setCurrentDateModel"), NNe.prototype), dDe(NNe.prototype, "setCurrentFieldSelector", [f.action], Object.getOwnPropertyDescriptor(NNe.prototype, "setCurrentFieldSelector"), NNe.prototype), oDe = dDe(NNe.prototype, "setDataForModal", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r, n) {
          var o, i;
          (e.currentFilterChoices = [], e.currentMultiSelections = [], e.currentFilterAccountChoices = [], e.currentFilter = e.columnFilters[t.id], e.setCurrentColumn(t), e.shouldMultiSelectWithSearch) && (e.searchableMultiselectModel = new aDe({
            columnSpec: t,
            store: null == n ? void 0 : n.reportItemsStore,
            currentFilters: e.columnFilters,
            accountIds: null == n || null === (o = n.treeModel) || void 0 === o ? void 0 : o.checked,
            value: e.findAllFiltersByKey(t.id)
          }));
          (e.shouldMultiSelect && e.setCurrentFilterChoices(t.defaultAccessorPath, r), (e.shouldMultiSelect || e.shouldAccountSelect) && e.setCurrentMultiSelectionsById(t.id), e.shouldFieldSelect) && (e.currentFilter && (e.filterSpecificFields = e.currentFilter.filterSpecificFields), e.filterSpecificFields && (e.setCurrentFieldSelector(), e.fieldSelector.selectMany((null === (i = e.currentFilter) || void 0 === i ? void 0 : i.value) || [])));
          e.shouldDateSelect && e.setCurrentDateModel(), e.shouldAccountSelect && (e.currentFilterAccountChoices = bDe.getRootsFromCollection(null == n ? void 0 : n.treeModel, (null == n ? void 0 : n.treeModel.checked) || []).sort(function (e, t) {
            return Object(h.naturalSort)(e.name, t.name);
          }));
        };
      }
    }), dDe(NNe.prototype, "setFieldOptions", [f.action], Object.getOwnPropertyDescriptor(NNe.prototype, "setFieldOptions"), NNe.prototype), iDe = dDe(NNe.prototype, "toggleSpecificFields", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.filterSpecificFields = t;
        };
      }
    }), dDe(NNe.prototype, "applyColumnFilters", [f.action], Object.getOwnPropertyDescriptor(NNe.prototype, "applyColumnFilters"), NNe.prototype), NNe);

    function yDe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function mDe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? yDe(Object(r), !0).forEach(function (t) {
          vDe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yDe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function vDe(e, t, r) {
      return (t = wDe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function hDe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function gDe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, wDe(n.key), n);
      }
    }

    function wDe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ODe(e, t, r) {
      return t = jDe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], jDe(e).constructor) : t.apply(e, r));
    }

    function jDe(e) {
      return (jDe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function PDe(e, t) {
      return (PDe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function _De(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var EDe,
        SDe,
        CDe,
        kDe,
        RDe,
        TDe,
        zDe,
        NDe,
        DDe,
        xDe,
        ADe,
        MDe,
        IDe,
        FDe,
        BDe,
        LDe,
        VDe,
        UDe,
        qDe,
        KDe,
        GDe,
        WDe,
        HDe,
        JDe,
        YDe,
        QDe,
        $De,
        XDe,
        ZDe,
        exe,
        txe,
        rxe,
        nxe,
        oxe,
        ixe,
        axe,
        cxe,
        uxe,
        lxe,
        sxe,
        pxe,
        fxe,
        dxe,
        bxe = function (e) {
      var t, r, n, o;
      return r = _De((t = function (t) {
        function i(e) {
          var t;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, i), hDe(t = ODe(this, i, [e]), "maxRows", r, t), hDe(t, "reportItemSpec", n, t), hDe(t, "reportType", o, t);
          var a = t.props,
              c = a.report,
              u = a.reportItemsStore,
              s = a.productsApi,
              p = a.fieldsApi,
              f = a.recommendationReportItemsApi,
              d = a.sprayRecordReportItemsApi;
          return t.reportType = c.report_type || "IF2::SprayRecord", t.reportItemsStore = u || ("IF2::Product" === t.reportType ? new S_e(s || new $r()) : "IF2::Field" === t.reportType ? new SSe(p || new l.FieldsApi()) : "IF2::Recommendation" === t.reportType ? new ACe(f || new VCe()) : new dze(d || new jze())), t.reportItemSpec = "IF2::Product" === t.reportType ? zPe.spec : "IF2::Field" === t.reportType ? vSe.spec : "IF2::Recommendation" === t.reportType ? RCe.spec : oze.spec, t.initColumnSpecs(t.reportItemSpec), t.loadColumnSpecs(t.reportItemSpec, c.column_specs), t.initColumnFilters(c.filters), t;
        }

        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && PDe(e, t);
        }(i, e), a = i, u = [{
          key: "sortRows",
          value: function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                r = t.sortConfig,
                n = t.sortingColumn;
            return r && n ? Lve.sort(e, {
              sortDescending: r.isSortingDown(n.id),
              accessor: Due.isCalculationColumnSpec(n) ? function (e) {
                return n.display(e.rowData);
              } : Object(x.path)(["rowData"].concat(n.defaultAccessorPath))
            }) : e;
          }
        }], (c = [{
          key: "filterColumnsHash",
          get: function () {
            return this.computeFilterHash(this.recordItems, this.filteredSpecsToReport);
          }
        }, {
          key: "filteredColumnSpecs",
          get: function () {
            var e = this;
            return Object.keys(this.columnFiltersModel.columnFilters).map(function (t) {
              return e.findColumn(t);
            });
          }
        }, {
          key: "filteredRecordRows",
          get: function () {
            var e = this;
            return this.columnFiltersModel.numReportFilters ? this.recordRows.filter(function (t) {
              return e.columnFiltersModel.shouldIncludeRow(t, e.filterColumnsHash);
            }) : this.recordRows;
          }
        }, {
          key: "filteredSpecsToReport",
          get: function () {
            return this.filteredColumnSpecs.filter(function (e) {
              return Ume.isReportColumnSpec(e);
            });
          }
        }, {
          key: "groupedRows",
          get: function () {
            return Jve.computeGroups(this.visibleRows, this.groupSpecs, {
              sortConfig: this.sortConfig
            });
          }
        }, {
          key: "recordItems",
          get: function () {
            return this.reportItemsStore.items;
          }
        }, {
          key: "recordRows",
          get: function () {
            return this.computeRecordRows(this.recordItems, this.visibleColumnsToReport);
          }
        }, {
          key: "reportableRows",
          get: function () {
            var e = this;
            return this.filteredRecordRows.map(function (t) {
              return new Lve({
                columnSpecs: e.visibleColumns,
                rowData: t,
                reportItem: e.reportItemsStore.find(t.id)
              });
            });
          }
        }, {
          key: "visibleRows",
          get: function () {
            var e = this.reportableRows.slice(0, this.maxRows);
            return this.constructor.sortRows(e, {
              sortConfig: this.sortConfig,
              sortingColumn: this.sortingColumn
            });
          }
        }, {
          key: "computeFilterHash",
          value: function (e, t) {
            return e.reduce(function (e, r) {
              return e[r.id] = r.report(t), e;
            }, {});
          }
        }, {
          key: "computeRecordRows",
          value: function (e, t) {
            return Object(x.flatten)(Object(x.map)(function (e) {
              return e.report(t);
            }, e));
          }
        }, {
          key: "initColumnFilters",
          value: function (e) {
            var t = this;

            if (e && Object.keys(e).length) {
              var r = Object.keys(e).reduce(function (r, n) {
                return r[n] = mDe(mDe({}, e[n] || {}), {}, {
                  columnSpec: t.findColumn(n)
                }), r;
              }, {});
              this.columnFiltersModel = new bDe(r);
            } else this.columnFiltersModel = new bDe();
          }
        }]) && gDe(a.prototype, c), u && gDe(a, u), Object.defineProperty(a, "prototype", {
          writable: !1
        }), a;
        var a, c, u;
      }()).prototype, "maxRows", [f.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return 200;
        }
      }), n = _De(t.prototype, "reportItemSpec", [f.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), o = _De(t.prototype, "reportType", [f.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "IF2::SprayRecord";
        }
      }), _De(t.prototype, "filterColumnsHash", [f.computed], Object.getOwnPropertyDescriptor(t.prototype, "filterColumnsHash"), t.prototype), _De(t.prototype, "filteredColumnSpecs", [f.computed], Object.getOwnPropertyDescriptor(t.prototype, "filteredColumnSpecs"), t.prototype), _De(t.prototype, "filteredRecordRows", [f.computed], Object.getOwnPropertyDescriptor(t.prototype, "filteredRecordRows"), t.prototype), _De(t.prototype, "filteredSpecsToReport", [f.computed], Object.getOwnPropertyDescriptor(t.prototype, "filteredSpecsToReport"), t.prototype), _De(t.prototype, "groupedRows", [f.computed], Object.getOwnPropertyDescriptor(t.prototype, "groupedRows"), t.prototype), _De(t.prototype, "recordItems", [f.computed], Object.getOwnPropertyDescriptor(t.prototype, "recordItems"), t.prototype), _De(t.prototype, "recordRows", [f.computed], Object.getOwnPropertyDescriptor(t.prototype, "recordRows"), t.prototype), _De(t.prototype, "reportableRows", [f.computed], Object.getOwnPropertyDescriptor(t.prototype, "reportableRows"), t.prototype), _De(t.prototype, "visibleRows", [f.computed], Object.getOwnPropertyDescriptor(t.prototype, "visibleRows"), t.prototype), t;
    };

    function yxe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function mxe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, vxe(n.key), n);
      }
    }

    function vxe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function hxe(e, t, r) {
      return t = Oxe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Oxe(e).constructor) : t.apply(e, r));
    }

    function gxe() {
      return (gxe = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = wxe(e, t);

        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(null, arguments);
    }

    function wxe(e, t) {
      for (; !{}.hasOwnProperty.call(e, t) && null !== (e = Oxe(e)););

      return e;
    }

    function Oxe(e) {
      return (Oxe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function jxe(e, t) {
      return (jxe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Pxe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    v()(document).off(".data-api");

    var _xe,
        Exe,
        Sxe,
        Cxe,
        kxe,
        Rxe,
        Txe = Object(d.observer)((CDe = Pxe((SDe = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = hxe(this, t, [e])).blankImg = document.createElement("img"), yxe(r, "rowLimit", CDe, r), yxe(r, "columnCalculationModal", kDe, r), yxe(r, "columnToRename", RDe, r), yxe(r, "didQuery", TDe, r), yxe(r, "downloadProgress", zDe, r), yxe(r, "dragElementInfo", NDe, r), yxe(r, "draggedColumnSpec", DDe, r), yxe(r, "dropTargetColumnSpec", xDe, r), yxe(r, "isDownloading", ADe, r), yxe(r, "isDragging", MDe, r), yxe(r, "lastSavedTitle", IDe, r), yxe(r, "reportId", FDe, r), yxe(r, "templateId", BDe, r), yxe(r, "isTemplate", LDe, r), yxe(r, "reportTitle", VDe, r), yxe(r, "showInvalidFeedback", UDe, r), yxe(r, "showSuccessAlert", qDe, r), yxe(r, "filterSearchText", KDe, r), yxe(r, "selectedAccountIds", GDe, r), yxe(r, "_successAlertText", WDe, r), r.filterModalId = "report-column-filter-modal", r.filterSummaryModalId = "report-column-filter-summary-modal", r.openFilterSummaryModal = function () {
          v()("#".concat(r.filterSummaryModalId)).modal("show");
        }, yxe(r, "_setupTemplateMode", HDe, r), yxe(r, "_setupReportMode", JDe, r), yxe(r, "onRefreshQuery", YDe, r), yxe(r, "onRegisterMatchModel", QDe, r), yxe(r, "onChangeSearchText", $De, r), yxe(r, "openColumnCalculationModal", XDe, r), r.openFilterModal = function (e) {
          r.columnFiltersModel.setDataForModal(e, r.recordRows, {
            treeModel: r.treeModel,
            reportItemsStore: r.reportItemsStore
          }), r.populateDefaultFilterSearch(), v()("#".concat(r.filterModalId)).modal("show");
        }, yxe(r, "populateDefaultFilterSearch", ZDe, r), yxe(r, "cancel", exe, r), yxe(r, "changeTitle", txe, r), yxe(r, "deleteReport", rxe, r), yxe(r, "deleteTemplate", nxe, r), yxe(r, "downloadReport", oxe, r), yxe(r, "onChangeColumnName", ixe, r), yxe(r, "onCloseAlert", axe, r), yxe(r, "onDoneRenamingColumn", cxe, r), yxe(r, "onDragColumnEnd", uxe, r), yxe(r, "onDragColumnStart", lxe, r), yxe(r, "onShowSuccessAlert", sxe, r), yxe(r, "onDragOverColumn", pxe, r), yxe(r, "onDropColumn", fxe, r), r.saveAsNewReport = function (e) {
          r.saveReport(e, !0);
        }, r.saveAsNewTemplate = function (e) {
          r.saveTemplate(e, !0);
        }, yxe(r, "removeAllFilters", dxe, r);
        var n = e.report,
            o = e.accounts,
            i = e.reportsPath,
            a = e.reportTemplatesPath,
            c = e.testConfig,
            u = e.t,
            l = c || {},
            s = l.reportsApi,
            p = l.reportTemplatesApi;
        return r.saveReport = r.saveReport.bind(r), r.saveTemplate = r.saveTemplate.bind(r), r.getReportItemsForAccounts = r.getReportItemsForAccounts.bind(r), null != n.serial && (r.reportId = n.serial), r._providedIsTemplate ? r._setupTemplateMode(r._providedTemplateId) : r._setupReportMode(r.reportId), r.reportsApi = s || new Xae(i), r.reportTemplatesApi = p || new cce(a), r.accountsApi = new N(), r.accountsStore = new Tt(r.accountsApi, new qt()), o.forEach(function (e) {
          r.accountsStore.push(e);
        }), r.treeModel = new as(r.accountsStore), (n.account_uuids || []).forEach(function (e) {
          return r.treeModel.check(e);
        }), r.loadGroups(n.group_specs), r.loadSortConfig(n.sort_config), r.reportTitle = n.title || r.reportTitle, r.lastSavedTitle = r.reportTitle, r.blankImg.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", Array.isArray(n.account_uuids) && n.account_uuids.length && r.getReportItemsForAccounts(r.treeModel.checked), r.columnCalculationModal = new aOe({
          t: u
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && jxe(e, t);
      }(t, Object(w["MixInto"])(s["Component"])(FOe, BOe["a"], bxe)), function (e, t, r) {
        return t && mxe(e.prototype, t), r && mxe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "isNew",
        get: function () {
          return !this.reportId && !this.templateId;
        }
      }, {
        key: "canEditTemplates",
        get: function () {
          return this.props.canEditTemplates;
        }
      }, {
        key: "reportIsValid",
        get: function () {
          return !!this.reportTitle;
        }
      }, {
        key: "shouldIncludeAccountSelector",
        get: function () {
          return ["IF2::SprayRecord", "IF2::Field", "IF2::Recommendation"].includes(this.reportType);
        }
      }, {
        key: "_providedTemplateId",
        get: function () {
          var e = this.props.templateId;
          return e || new URL(document.location).searchParams.get("template_id");
        }
      }, {
        key: "_providedIsTemplate",
        get: function () {
          var e,
              t = this.props.isTemplate;
          return null !== t ? t : "true" === (null === (e = new URL(document.location).searchParams.get("template")) || void 0 === e ? void 0 : e.toLowerCase());
        }
      }, {
        key: "componentDidMount",
        value: function () {
          this.shouldIncludeAccountSelector || this.reportItemsStore.fetchAll(), v()('[data-toggle="tooltip"]').tooltip({
            trigger: "hover",
            delay: {
              show: 500,
              hide: 0
            }
          }), v()("#".concat(this.filterModalId)).on("hidden.bs.modal", this.columnFiltersModel.onHide), v()("#".concat(this.filterModalId)).on("show.bs.modal", this.columnFiltersModel.onShow);
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          var e, r, n, o, i;
          (e = t, r = "componentWillUnmount", n = this, i = gxe(Oxe(1 & (o = 3) ? e.prototype : e), r, n), 2 & o && "function" == typeof i ? function (e) {
            return i.apply(n, e);
          } : i)([]), v()("#".concat(this.filterModalId)).off("hidden.bs.modal", this.columnFiltersModel.onHide), v()("#".concat(this.filterModalId)).off("show.bs.modal", this.columnFiltersModel.onShow);
        }
      }, {
        key: "fieldNameWithClientPath",
        value: function (e) {
          return "".concat(e.account.clientPathString, ":").concat(e.field.name);
        }
      }, {
        key: "browseToIndex",
        value: function () {
          window.location.assign(this.reportsApi.apiPath);
        }
      }, {
        key: "reportHeaderRow",
        value: function () {
          return this.visibleColumns.map(function (e) {
            return JSON.stringify(e.getName());
          }).join(",");
        }
      }, {
        key: "menuItemsFor",
        value: function (e) {
          if (!Ume.isReportColumnSpec(e)) return [];
          var t = Object(x.reject)(function (t) {
            return e.attribute.defaultAccessor.attribute === t;
          });
          return e.attribute instanceof he ? t(e.attribute.elementSpec.attributes) : e.attribute instanceof Ce ? t(e.attribute.modelSpec.attributes) : e.attribute.modelClass ? e.attribute.modelClass.spec.attributes.filter(function (t) {
            return !Object(x.equals)(t, e.attribute.modelClass.spec.defaultAccessor.attribute);
          }) : [];
        }
      }, {
        key: "isValidDropTarget",
        value: function (e) {
          var t,
              r = this.isGrouped(e),
              n = this.isGrouped(this.draggedColumnSpec);
          return (null == e ? void 0 : e.id) && (null == e ? void 0 : e.id) !== (null === (t = this.draggedColumnSpec) || void 0 === t ? void 0 : t.id) && (!r && !n || r && n);
        }
      }, {
        key: "renameColumn",
        value: function (e) {
          var t = this;
          this.columnToRename = e, setTimeout(function () {
            return Object(xE.select)(t.columnToRename.ref.current).select("input").node().focus();
          }, 20);
        }
      }, {
        key: "requery",
        value: function () {
          var e,
              t = this.reportItemsStore.getQueryFilters(null === (e = this.columnFiltersModel) || void 0 === e ? void 0 : e.columnFilters);
          return this.reportItemsStore.filtersForLastQuery && !this.reportItemsStore.isFilterRefinement(t) ? this.onRefreshQuery() : Promise.resolve();
        }
      }, {
        key: "columnsToSave",
        value: function () {
          var e = this.visibleColumns.map(function (e) {
            return Ume.isReportColumnSpec(e) ? e : function e(t) {
              var r = [];

              if (aue.isColumnCalculationOperandSpec(t.operand1)) {
                var n = t.operand1.referenceColumnSpec;
                r.push(n), Due.isCalculationColumnSpec(n) && r.push(e(n));
              }

              if (aue.isColumnCalculationOperandSpec(t.operand2)) {
                var o = t.operand2.referenceColumnSpec;
                r.push(o), Due.isCalculationColumnSpec(o) && r.push(e(o));
              }

              return Object(x.flatten)(r);
            }(e).concat(e);
          });
          return Object(x.uniqBy)(Object(x.prop)("id"))(Object(x.flatten)(e)).map(function (e) {
            return e.toJS();
          });
        }
      }, {
        key: "groupsToSave",
        value: function () {
          return this.groupSpecs.map(function (e) {
            return e.id;
          });
        }
      }, {
        key: "reportParams",
        value: function () {
          return {
            title: this.reportTitle,
            report_type: this.reportType,
            column_specs: this.columnsToSave(),
            account_uuids: this.selectedAccountIds,
            filters: this.columnFiltersModel.toJS(),
            group_specs: this.groupsToSave(),
            sort_config: this.sortConfig.dump()
          };
        }
      }, {
        key: "saveReport",
        value: function (e, t) {
          var r = this,
              n = this.props.t;
          if (e.preventDefault(), !this.reportIsValid) return this.showInvalidFeedback = !0, Promise.resolve();
          var o = t || this.isNew;
          if (this.isTemplate && !o) throw new Error("Cannot update a template as a report!");
          return o || this.lastSavedTitle === this.reportTitle || window.confirm(n("if2.reports.ok_to_overwrite_report")) ? (o ? this.reportsApi.create(this.reportParams()) : this.reportsApi.update(this.reportId, this.reportParams())).then(function (e) {
            return Object(f.runInAction)(function () {
              r.lastSavedTitle = r.reportTitle;
            }), o && r._setupReportMode(e.id), r.onShowSuccessAlert(n("report_saved_successfully"));
          }).catch(function (e) {
            alert("Unexpected error.  Unable to ".concat(o ? "create" : "update", " report")), console.error(e);
          }) : Promise.resolve();
        }
      }, {
        key: "saveTemplate",
        value: function (e, t) {
          var r = this,
              n = this.props.t;
          if (e.preventDefault(), !this.reportIsValid) return this.showInvalidFeedback = !0, Promise.resolve();
          var o = t || this.isNew;
          if (!this.isTemplate && !o) throw new Error("Cannot update a report as a template!");
          return o || this.lastSavedTitle === this.reportTitle || window.confirm(n("if2.reports.ok_to_overwrite_template")) ? (o ? this.reportTemplatesApi.create(this.reportParams()) : this.reportTemplatesApi.update(this.templateId, this.reportParams())).then(function (e) {
            return Object(f.runInAction)(function () {
              r.lastSavedTitle = r.reportTitle;
            }), o && r._setupTemplateMode(e.id), r.onShowSuccessAlert(n("if2.reports.template_saved_successfully"));
          }).catch(function (e) {
            alert("Unexpected error.  Unable to ".concat(o ? "create" : "update", " template")), console.error(e);
          }) : Promise.resolve();
        }
      }, {
        key: "setFieldOptions",
        value: function () {
          var e;
          this.columnFiltersModel.setFieldOptions((null === (e = this.treeModel) || void 0 === e || null === (e = e.accountsStore) || void 0 === e ? void 0 : e.getFields(this.treeModel.checked || [])) || []);
        }
      }, {
        key: "getReportItemsForAccounts",
        value: function (e) {
          var t,
              r = this,
              n = this.props.t;
          return this.selectedAccountIds = e || [], this.reportItemsStore.clear(), this.reportItemsStore.fetchAllForAccounts(e, {
            filters: this.reportItemsStore.getQueryFilters(null === (t = this.columnFiltersModel) || void 0 === t ? void 0 : t.columnFilters)
          }).then(function (t) {
            r.setFieldOptions();
            var n = r.findColumn("applications/fieldCompletions/field/account");
            return n && r.columnFiltersModel.filterBy(r.columnFiltersModel.createFilter({
              key: "applications/fieldCompletions/field/account",
              value: e,
              columnSpec: n
            })), t;
          }).catch(function (e) {
            e instanceof r.reportItemsStore.constructor.RecordLimitExceededError ? window.alert(n("data_set_too_large", {
              totalResults: r.reportItemsStore.totalResults,
              recordLimit: r.reportItemsStore.recordLimit
            })) : window.alert("".concat(n("unexpected_error"), ": ").concat(e.message || e));
          }).finally(function () {
            return Object(f.runInAction)(function () {
              r.didQuery = !0;
            });
          });
        }
      }, {
        key: "tableCellClass",
        value: function (e) {
          return this.isDragging ? e === this.draggedColumnSpec ? "drag-origin" : e !== this.dropTargetColumnSpec ? "" : this.draggedColumnSpec.position < e.position ? "drop-after" : "drop-before" : "";
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t = this.props,
              r = t.t,
              n = t.readOnlyAncestors;
          return p.a.createElement("div", {
            className: "reports-manager d-flex flex-column"
          }, p.a.createElement("div", {
            className: "reports-manager-alert-container"
          }, p.a.createElement(Yae, {
            "data-testid": "test-success-alert",
            variant: "success",
            show: this.showSuccessAlert,
            onClose: this.onCloseAlert,
            dismissible: !0
          }, p.a.createElement(Yae.Heading, {
            "data-testid": "test-success-alert-heading"
          }, this._successAlertText))), p.a.createElement("div", {
            className: "row align-items-center justify-content-between"
          }, p.a.createElement(vce, {
            reportsManager: this
          }), p.a.createElement(Cce, {
            reportsManager: this
          })), p.a.createElement(ohe, {
            columnFiltersModel: this.columnFiltersModel,
            onClearFilters: this.removeAllFilters,
            t: r
          }), p.a.createElement("div", {
            className: "row table-container"
          }, p.a.createElement("div", {
            className: "col"
          }, p.a.createElement(h.Card, {
            className: "p-3"
          }, p.a.createElement(Khe, {
            reportsManager: this,
            readOnlyAncestors: n,
            t: r
          }), p.a.createElement(Eve, {
            reportItemsStore: this.reportItemsStore,
            reportsManager: this
          }), p.a.createElement(Yle, {
            reportsManager: this
          })))), p.a.createElement(COe, {
            reportsManager: this,
            modal: this.columnCalculationModal,
            t: r
          }), p.a.createElement(dme, {
            id: this.filterModalId,
            title: (null === (e = this.columnFiltersModel) || void 0 === e ? void 0 : e.filterTitle) || "",
            readOnlyAncestors: n,
            reportsManager: this
          }), p.a.createElement(gve, {
            id: this.filterSummaryModalId,
            title: r("filter_summary"),
            reportsManager: this,
            columnSpec: this.columnFiltersModel.currentColumnSpec
          }));
        }
      }], [{
        key: "renderToCsvString",
        value: function (e, t, r) {
          var n = Jve.computeGroups(e, t, r);
          return n ? n.map(function (e) {
            return Jve.renderToCsvString(e);
          }).join("\r\n") : this.sortRows(e, r).map(function (e) {
            return Lve.renderToCsvString(e);
          }).join("\r\n");
        }
      }]);
    }()).prototype, "rowLimit", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 200;
      }
    }), kDe = Pxe(SDe.prototype, "columnCalculationModal", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), RDe = Pxe(SDe.prototype, "columnToRename", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), TDe = Pxe(SDe.prototype, "didQuery", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), zDe = Pxe(SDe.prototype, "downloadProgress", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), NDe = Pxe(SDe.prototype, "dragElementInfo", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), DDe = Pxe(SDe.prototype, "draggedColumnSpec", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), xDe = Pxe(SDe.prototype, "dropTargetColumnSpec", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), ADe = Pxe(SDe.prototype, "isDownloading", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), MDe = Pxe(SDe.prototype, "isDragging", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), IDe = Pxe(SDe.prototype, "lastSavedTitle", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), FDe = Pxe(SDe.prototype, "reportId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), BDe = Pxe(SDe.prototype, "templateId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), LDe = Pxe(SDe.prototype, "isTemplate", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), VDe = Pxe(SDe.prototype, "reportTitle", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), UDe = Pxe(SDe.prototype, "showInvalidFeedback", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), qDe = Pxe(SDe.prototype, "showSuccessAlert", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), KDe = Pxe(SDe.prototype, "filterSearchText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), GDe = Pxe(SDe.prototype, "selectedAccountIds", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), WDe = Pxe(SDe.prototype, "_successAlertText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Pxe(SDe.prototype, "isNew", [f.computed], Object.getOwnPropertyDescriptor(SDe.prototype, "isNew"), SDe.prototype), Pxe(SDe.prototype, "canEditTemplates", [f.computed], Object.getOwnPropertyDescriptor(SDe.prototype, "canEditTemplates"), SDe.prototype), Pxe(SDe.prototype, "reportIsValid", [f.computed], Object.getOwnPropertyDescriptor(SDe.prototype, "reportIsValid"), SDe.prototype), Pxe(SDe.prototype, "shouldIncludeAccountSelector", [f.computed], Object.getOwnPropertyDescriptor(SDe.prototype, "shouldIncludeAccountSelector"), SDe.prototype), Pxe(SDe.prototype, "_providedTemplateId", [f.computed], Object.getOwnPropertyDescriptor(SDe.prototype, "_providedTemplateId"), SDe.prototype), Pxe(SDe.prototype, "_providedIsTemplate", [f.computed], Object.getOwnPropertyDescriptor(SDe.prototype, "_providedIsTemplate"), SDe.prototype), HDe = Pxe(SDe.prototype, "_setupTemplateMode", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          if (!t) throw new Error("ReportsManager cannot run in template mode without a template id");
          e.isTemplate = !0, e.templateId = t;
        };
      }
    }), JDe = Pxe(SDe.prototype, "_setupReportMode", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.isTemplate = !1, e.templateId = "", e.reportId = t;
        };
      }
    }), YDe = Pxe(SDe.prototype, "onRefreshQuery", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          return e.getReportItemsForAccounts(e.selectedAccountIds);
        };
      }
    }), QDe = Pxe(SDe.prototype, "onRegisterMatchModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.matchModel = t, e.matchModel.search("Contains");
        };
      }
    }), $De = Pxe(SDe.prototype, "onChangeSearchText", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.filterSearchText = t.target.value;
        };
      }
    }), XDe = Pxe(SDe.prototype, "openColumnCalculationModal", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = r.isNew,
              o = n ? e.visibleColumns : e.visibleColumns.filter(function (e) {
            return e.id !== t.id;
          });
          e.columnCalculationModal.setColumnChoices(o), t && n && (e.columnCalculationModal.operand1.selectColumn(t.id), e.columnCalculationModal.new({
            position: t.position && t.position + 1 || e.columnSpecs.length
          })), t && !n && e.columnCalculationModal.edit(t), e.columnCalculationModal.show();
        };
      }
    }), ZDe = Pxe(SDe.prototype, "populateDefaultFilterSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          if (!e.columnFiltersModel.currentFilter) return e.filterSearchText = "", void e.matchModel.search("");
          var t = e.columnFiltersModel.currentFilter.matchMethod,
              r = e.columnFiltersModel.currentFilter.value;
          if (e.columnFiltersModel.currentFilter.isArray) return e.filterSearchText = "", void e.matchModel.search("");
          e.filterSearchText = r || "", e.matchModel.search(t || "");
        };
      }
    }), exe = Pxe(SDe.prototype, "cancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.preventDefault(), e.browseToIndex();
        };
      }
    }), txe = Pxe(SDe.prototype, "changeTitle", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.reportTitle = t;
        };
      }
    }), rxe = Pxe(SDe.prototype, "deleteReport", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.t;
          window.confirm(t("are_you_sure")) && e.reportsApi.delete(e.reportId).then(function () {
            return e.browseToIndex();
          }).catch(function (e) {
            alert("Unexpected error.  Unable to delete report"), console.error(e);
          });
        };
      }
    }), nxe = Pxe(SDe.prototype, "deleteTemplate", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.t;
          window.confirm(t("are_you_sure")) && e.reportTemplatesApi.delete(e.templateId).then(function () {
            return e.browseToIndex();
          }).catch(function (e) {
            alert("Unexpected error.  Unable to delete template"), console.error(e);
          });
        };
      }
    }), oxe = Pxe(SDe.prototype, "downloadReport", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.preventDefault();
          var r = [e.reportHeaderRow()],
              n = [],
              o = (e.reportItemsStore.rawRecords || []).slice();
          e.isDownloading = !0, e.downloadProgress = 0;
          var i = {},
              a = 0;
          setTimeout(function t() {
            var c = o.length && o[a] && e.reportItemsStore.new(o[a]);
            c && (i[c.id] = c.report(e.filteredSpecsToReport)), (c && e.computeRecordRows([c], e.visibleColumnsToReport) || []).forEach(function (t) {
              e.columnFiltersModel.shouldIncludeRow(t, i) && n.push(new Lve({
                columnSpecs: e.visibleColumns,
                rowData: t,
                reportItem: e.reportItemsStore.find(t.id)
              }));
            }), a += 1, Object(f.runInAction)(function () {
              e.downloadProgress = Math.round(a / o.length * 100);
            }), a < o.length ? setTimeout(t, 1) : (r.push(e.constructor.renderToCsvString(n, e.groupSpecs, {
              sortConfig: e.sortConfig,
              sortingColumn: e.sortingColumn
            })), Object(f.runInAction)(function () {
              e.downloadProgress = 100;
            }), Z(r.join("\r\n"), "".concat(e.reportTitle || "report", ".csv"), "text/csv"), Object(f.runInAction)(function () {
              e.isDownloading = !1, e.downloadProgress = 0;
            }), o = null, n = null, r = null);
          }, 1);
        };
      }
    }), ixe = Pxe(SDe.prototype, "onChangeColumnName", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.columnToRename && (e.columnToRename.nameOverride = t);
        };
      }
    }), axe = Pxe(SDe.prototype, "onCloseAlert", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.showSuccessAlert = !1;
        };
      }
    }), cxe = Pxe(SDe.prototype, "onDoneRenamingColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.columnToRename = null;
        };
      }
    }), uxe = Pxe(SDe.prototype, "onDragColumnEnd", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isDragging = !1;
        };
      }
    }), lxe = Pxe(SDe.prototype, "onDragColumnStart", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r) {
          t.dataTransfer.dropEffect = "move", e.draggedColumnSpec = r, e.isDragging = !0;
        };
      }
    }), sxe = Pxe(SDe.prototype, "onShowSuccessAlert", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e._successAlertText = t, e.showSuccessAlert = !0, new Promise(function (t) {
            setTimeout(function () {
              return Object(f.runInAction)(function () {
                e.showSuccessAlert = !1, t();
              });
            }, 3e3);
          });
        };
      }
    }), pxe = Pxe(SDe.prototype, "onDragOverColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r) {
          if (t.preventDefault(), !e.isValidDropTarget(r)) return e.dropTargetColumnSpec = null, void (t.dataTransfer.dropEffect = "none");
          t.dataTransfer.dropEffect = "move", e.dropTargetColumnSpec = r;
        };
      }
    }), fxe = Pxe(SDe.prototype, "onDropColumn", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r) {
          t.preventDefault(), e.isDragging = !1, e.isValidDropTarget(r) && e.moveColumnToPosition(e.draggedColumnSpec, r.position);
        };
      }
    }), Pxe(SDe.prototype, "renameColumn", [f.action], Object.getOwnPropertyDescriptor(SDe.prototype, "renameColumn"), SDe.prototype), Pxe(SDe.prototype, "saveReport", [f.action], Object.getOwnPropertyDescriptor(SDe.prototype, "saveReport"), SDe.prototype), Pxe(SDe.prototype, "saveTemplate", [f.action], Object.getOwnPropertyDescriptor(SDe.prototype, "saveTemplate"), SDe.prototype), Pxe(SDe.prototype, "setFieldOptions", [f.action], Object.getOwnPropertyDescriptor(SDe.prototype, "setFieldOptions"), SDe.prototype), Pxe(SDe.prototype, "getReportItemsForAccounts", [f.action], Object.getOwnPropertyDescriptor(SDe.prototype, "getReportItemsForAccounts"), SDe.prototype), dxe = Pxe(SDe.prototype, "removeAllFilters", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.columnFiltersModel.removeAllFilters(), e.requery();
        };
      }
    }), EDe = SDe)) || EDe,
        zxe = Object(g.a)()(Txe);

    function Nxe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function Dxe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, xxe(n.key), n);
      }
    }

    function xxe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Axe(e, t, r) {
      return t = Mxe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Mxe(e).constructor) : t.apply(e, r));
    }

    function Mxe(e) {
      return (Mxe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Ixe(e, t) {
      return (Ixe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function Fxe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var Bxe,
        Lxe = Object(d.observer)((Sxe = Fxe((Exe = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = Axe(this, t, [e])).productsStore = void 0, r.aiStore = void 0, Nxe(r, "searchText", Sxe, r), r.fetchAll = function (e) {
          var t = (e || {}).offset;
          return r.productsStore.fetchAll({
            only: ["account", "activeIngredients", "alternateNames", "epaNumber", "formulation", "id", "inactive", "manufacturer", "name", "organic", "organic_listings", "productType", "registration_number", "reviewedAt", "serial", "type", "nutrientAnalysis"],
            limit: r.productsStore.pageSize,
            offset: t,
            search: r.searchText,
            meta: !0
          });
        }, r.getActiveIngredientPath = function (e) {
          return "".concat(r.aiStore.aiPath).concat(e);
        }, r.getProductReviewPath = function (e) {
          return "".concat(r.props.productsPath, "/").concat(e, "/review");
        }, Nxe(r, "updateSearchText", Cxe, r), Nxe(r, "onPageSizeChange", kxe, r), Nxe(r, "onSearch", Rxe, r), r.productsStore = new pn(new $r(e.apiPath), {
          useNewModels: !0
        }), r._debouncedFetchAll = Km()(r.fetchAll, 500), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Ixe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && Dxe(e.prototype, t), r && Dxe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "componentDidMount",
        value: function () {
          this.fetchAll({
            offset: this.productsStore.currentIndex
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props.t;
          return s.createElement(s.Fragment, null, s.createElement("div", {
            className: "form-row align-items-center"
          }, s.createElement("div", {
            className: "col"
          }, s.createElement(h.SearchBar, {
            placeholder: t("search_products"),
            onSearch: this.onSearch
          })), s.createElement("div", {
            className: "col-auto ml-auto"
          }, s.createElement(SZ, {
            currentIndex: this.productsStore.productIndex,
            lastIndex: this.productsStore.endIndex,
            numResults: this.productsStore.totalResults,
            pageSize: this.productsStore.pageSize,
            onChangePageSize: this.onPageSizeChange,
            onPageBack: this.productsStore.pageBack,
            onPageForward: this.productsStore.pageForward
          }))), "pending" === this.productsStore.status ? s.createElement("div", {
            className: "large-spinner py-4"
          }, s.createElement(h.Spinner, null)) : s.createElement("div", {
            className: "products-table"
          }, s.createElement("table", null, s.createElement("tbody", null, s.createElement("tr", null, s.createElement("th", null, t("product_name")), s.createElement("th", null, t("active_ingredients")), s.createElement("th", null, t("reviewed_at")), s.createElement("th", {
            "aria-label": "Actions"
          })), this.productsStore.filteredSortedProducts.map(function (r) {
            return s.createElement("tr", {
              key: r.id
            }, s.createElement("td", {
              className: "product-name"
            }, s.createElement("a", {
              href: "".concat(e.getProductReviewPath(r.serial))
            }, r.name)), s.createElement("td", null, r.activeIngredients.map(function (e) {
              return s.createElement(s.Fragment, {
                key: e.id
              }, "".concat(e.name, " (").concat(e.percent, " %)"), s.createElement("br", null));
            })), s.createElement("td", null, r.reviewedAt ? s.createElement(s.Fragment, null, M()(r.reviewedAt).format("M/D/YYYY"), s.createElement("div", {
              className: "reviewed-from-now"
            }, M()(r.reviewedAt).fromNow())) : s.createElement("em", null, t("never"))), s.createElement("td", null, s.createElement("a", {
              className: "btn btn-outline-primary btn-sm mr-1",
              href: "".concat(e.getProductReviewPath(r.serial))
            }, t("review"))));
          })))));
        }
      }]);
    }()).prototype, "searchText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), Cxe = Fxe(Exe.prototype, "updateSearchText", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.searchText = t;
        };
      }
    }), kxe = Fxe(Exe.prototype, "onPageSizeChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.productsStore.changePageSize(t), e._debouncedFetchAll();
        };
      }
    }), Rxe = Fxe(Exe.prototype, "onSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.updateSearchText(t.target.value), e._debouncedFetchAll(), e.productsStore.filterProducts(t.target.value);
        };
      }
    }), _xe = Exe)) || _xe,
        Vxe = Object(g.a)()(Lxe),
        Uxe = function (e) {
      return Object(d.useObserver)(function () {
        return p.a.createElement(p.a.Fragment, null, p.a.createElement(h.TreeNodeContent, e));
      });
    };

    function qxe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Kxe(n.key), n);
      }
    }

    function Kxe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Gxe(e, t, r) {
      return t = Wxe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Wxe(e).constructor) : t.apply(e, r));
    }

    function Wxe(e) {
      return (Wxe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Hxe(e, t) {
      return (Hxe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Jxe,
        Yxe = Object(d.observer)(Bxe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Gxe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Hxe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.title,
              r = e.onClose;
          return p.a.createElement("div", {
            className: "modal-header"
          }, p.a.createElement("h5", {
            className: "modal-title",
            id: "accessLevelModalLabel"
          }, t), p.a.createElement("button", {
            type: "button",
            className: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: r
          }, p.a.createElement("span", {
            "aria-hidden": "true"
          }, "×")));
        }
      }]) && qxe(r.prototype, n), o && qxe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || Bxe;

    function Qxe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $xe(n.key), n);
      }
    }

    function $xe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Xxe(e, t, r) {
      return t = Zxe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Zxe(e).constructor) : t.apply(e, r));
    }

    function Zxe(e) {
      return (Zxe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function eAe(e, t) {
      return (eAe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var tAe,
        rAe,
        nAe = Object(d.observer)(Jxe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Xxe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && eAe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.children,
              r = e.isSaving;
          return p.a.createElement("div", {
            className: "modal-body ".concat(r ? "saving" : "")
          }, t, p.a.createElement("div", {
            className: r ? "overlay large-spinner" : "d-none"
          }, p.a.createElement(h.Spinner, null)));
        }
      }]) && Qxe(r.prototype, n), o && Qxe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || Jxe;

    function oAe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, iAe(n.key), n);
      }
    }

    function iAe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function aAe(e, t, r) {
      return t = cAe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], cAe(e).constructor) : t.apply(e, r));
    }

    function cAe(e) {
      return (cAe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function uAe(e, t) {
      return (uAe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function lAe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var sAe,
        pAe,
        fAe,
        dAe,
        bAe = Object(d.observer)((lAe((rAe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), aAe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && uAe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && oAe(e.prototype, t), r && oAe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "hasCheckedAccounts",
        get: function () {
          var e,
              t = this.props.treeModel;
          return !(null == t || null === (e = t.checked) || void 0 === e || !e.length);
        }
      }, {
        key: "shouldDisableSaveButton",
        get: function () {
          var e = this.props.chooseAccountPhase;
          return !this.hasCheckedAccounts && e;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.okText,
              r = e.cancelText,
              n = e.onClickCancel,
              o = e.onClickOk,
              i = e.initValue,
              a = e.isSaving,
              c = e.t;
          return p.a.createElement("div", {
            className: "modal-footer"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-secondary",
            onClick: a ? null : n
          }, c(r)), p.a.createElement("button", {
            type: "button",
            className: "".concat(i ? "d-none" : "", " btn btn-primary"),
            onClick: a ? null : o,
            disabled: this.shouldDisableSaveButton
          }, c(a ? "saving" : t)));
        }
      }]);
    }()).prototype, "hasCheckedAccounts", [f.computed], Object.getOwnPropertyDescriptor(rAe.prototype, "hasCheckedAccounts"), rAe.prototype), lAe(rAe.prototype, "shouldDisableSaveButton", [f.computed], Object.getOwnPropertyDescriptor(rAe.prototype, "shouldDisableSaveButton"), rAe.prototype), tAe = rAe)) || tAe,
        yAe = Object(g.a)()(bAe);

    function mAe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function vAe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, gAe(n.key), n);
      }
    }

    function hAe(e, t, r) {
      return t && vAe(e.prototype, t), r && vAe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function gAe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function wAe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var OAe,
        jAe,
        PAe,
        _Ae,
        EAe,
        SAe,
        CAe,
        kAe,
        RAe,
        TAe,
        zAe = (pAe = wAe((sAe = hAe(function e(t, r, n) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), mAe(this, "title", pAe, this), mAe(this, "cancelText", fAe, this), mAe(this, "confirmText", dAe, this), this.title = t, this.cancelText = r, this.confirmText = n;
    })).prototype, "title", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), fAe = wAe(sAe.prototype, "cancelText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), dAe = wAe(sAe.prototype, "confirmText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), sAe);

    function NAe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function DAe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, AAe(n.key), n);
      }
    }

    function xAe(e, t, r) {
      return t && DAe(e.prototype, t), r && DAe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function AAe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function MAe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var IAe,
        FAe,
        BAe,
        LAe,
        VAe,
        UAe,
        qAe,
        KAe,
        GAe,
        WAe,
        HAe,
        JAe = (jAe = MAe((OAe = xAe(function e(t) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), NAe(this, "displaySet", jAe, this), NAe(this, "phases", PAe, this), NAe(this, "curPhaseIndex", _Ae, this), NAe(this, "init", EAe, this), NAe(this, "next", SAe, this), NAe(this, "previous", CAe, this), NAe(this, "setDisplay", kAe, this), NAe(this, "onePhase", RAe, this), NAe(this, "twoPhase", TAe, this), this.confirmText = t, this.init();
    })).prototype, "displaySet", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), PAe = MAe(OAe.prototype, "phases", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [new zAe("select_a_role", "cancel", "next"), new zAe("select_an_account", "previous", this.confirmText)];
      }
    }), _Ae = MAe(OAe.prototype, "curPhaseIndex", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), EAe = MAe(OAe.prototype, "init", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.setDisplay(new zAe("select_a_role", "cancel", e.confirmText));
        };
      }
    }), SAe = MAe(OAe.prototype, "next", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.curPhaseIndex += 1, e.setDisplay(e.phases[e.curPhaseIndex]);
        };
      }
    }), CAe = MAe(OAe.prototype, "previous", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.curPhaseIndex -= 1, e.setDisplay(e.phases[e.curPhaseIndex]);
        };
      }
    }), kAe = MAe(OAe.prototype, "setDisplay", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.displaySet = t;
        };
      }
    }), RAe = MAe(OAe.prototype, "onePhase", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.setDisplay(new zAe("select_a_role", "cancel", e.confirmText));
        };
      }
    }), TAe = MAe(OAe.prototype, "twoPhase", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.setDisplay(e.phases[e.curPhaseIndex]);
        };
      }
    }), OAe);

    function YAe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function QAe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $Ae(n.key), n);
      }
    }

    function $Ae(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function XAe(e, t, r) {
      return t = ZAe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ZAe(e).constructor) : t.apply(e, r));
    }

    function ZAe(e) {
      return (ZAe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function eMe(e, t) {
      return (eMe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function tMe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var rMe = Object(d.observer)((BAe = tMe((FAe = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), YAe(r = XAe(this, t, [e]), "roleOptions", BAe, r), YAe(r, "currentRole", LAe, r), YAe(r, "selectedRole", VAe, r), YAe(r, "wizard", UAe, r), YAe(r, "roleSelector", qAe, r), r.componentWillUnmount = function () {
          document.removeEventListener("click", r.handleClickOutside, !0);
        }, YAe(r, "onClickOk", KAe, r), YAe(r, "onClickCancel", GAe, r), YAe(r, "closeModal", WAe, r), YAe(r, "onChangeRole", HAe, r), r.handleClickOutside = function (e) {
          r.modalRef.current.contains(e.target) || r.closeModal();
        }, r.registerRoleSelector = function (e) {
          r.roleSelector = e;
        };
        var n = r.props,
            o = n.newUser,
            i = n.t;
        return r.newUser = o, r.wizard = new JAe(r.newUser ? i("ok") : i("save")), r.currentRole = r.dropdownPlaceHolder, r.modalRef = Object(s.createRef)(), document.addEventListener("click", r.handleClickOutside, !0), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && eMe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && QAe(e.prototype, t), r && QAe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "dropdownPlaceHolder",
        get: function () {
          var e = this.props.t;
          return {
            name: e("select_a_role"),
            description: e("select_and_follow_prompts"),
            init: !0
          };
        }
      }, {
        key: "roleOptionsFormatted",
        get: function () {
          return this.props.roles.slice().sort(function (e, t) {
            return Object(h.naturalSort)(e.preferredName, t.preferredName);
          }).map(function (e) {
            return {
              key: e.serial,
              text: e.preferredName,
              value: e
            };
          });
        }
      }, {
        key: "chooseAccountPhase",
        get: function () {
          return this.wizard.curPhaseIndex >= 1;
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t = this.props,
              r = t.roots,
              n = t.actions,
              o = t.isSaving,
              i = t.treeModel,
              a = t.t;
          return p.a.createElement("div", {
            className: "modal fade role-assignment",
            id: "accessLevelModal",
            ref: this.modalRef,
            tabIndex: "-1",
            role: "dialog",
            "aria-labelledby": "accessLevelModalLabel",
            "aria-hidden": "true"
          }, p.a.createElement("div", {
            className: "modal-dialog",
            role: "document"
          }, p.a.createElement("div", {
            className: "modal-content"
          }, p.a.createElement(Yxe, {
            title: a(this.wizard.displaySet.title),
            onClose: this.closeModal
          }), p.a.createElement(nAe, {
            isSaving: o
          }, 0 === this.wizard.curPhaseIndex ? p.a.createElement("div", {
            className: "choose-role-content"
          }, p.a.createElement(h.SelectDropdown, {
            className: "role-selector",
            inputText: a((null === (e = this.roleSelector) || void 0 === e ? void 0 : e.searchText) || ""),
            placeholder: a("select_role"),
            onChange: this.onChangeRole,
            onRegisterModel: this.registerRoleSelector,
            options: this.roleOptionsFormatted
          }), p.a.createElement("div", {
            className: "px-1 pt-2"
          }, p.a.createElement("p", {
            className: "mb-1"
          }, this.currentRole.description))) : p.a.createElement("div", {
            className: "choose-account-content"
          }, p.a.createElement("p", null, a("role_selected"), " ", this.currentRole.name), p.a.createElement(h.Tree, {
            items: r,
            model: i,
            ControlsComponent: nj,
            ContentComponent: Uxe,
            actions: {
              handleClickNodeContent: n.handleClickNodeContent,
              handleToggleChecked: n.handleToggleChecked,
              handleToggleExpand: n.handleToggleExpand
            }
          }))), p.a.createElement(yAe, {
            cancelText: a(this.wizard.displaySet.cancelText),
            okText: a(this.wizard.displaySet.confirmText),
            onClickCancel: this.onClickCancel,
            onClickOk: this.onClickOk,
            initValue: this.currentRole.init,
            isSaving: o,
            shouldDisableSaveButton: this.shouldDisableSaveButton,
            chooseAccountPhase: this.chooseAccountPhase,
            treeModel: i
          }))));
        }
      }]);
    }()).prototype, "roleOptions", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [{
          key: "init",
          text: "role_assignment.select_role",
          value: "None"
        }];
      }
    }), LAe = tMe(FAe.prototype, "currentRole", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), VAe = tMe(FAe.prototype, "selectedRole", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), UAe = tMe(FAe.prototype, "wizard", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), qAe = tMe(FAe.prototype, "roleSelector", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), tMe(FAe.prototype, "dropdownPlaceHolder", [f.computed], Object.getOwnPropertyDescriptor(FAe.prototype, "dropdownPlaceHolder"), FAe.prototype), tMe(FAe.prototype, "roleOptionsFormatted", [f.computed], Object.getOwnPropertyDescriptor(FAe.prototype, "roleOptionsFormatted"), FAe.prototype), tMe(FAe.prototype, "chooseAccountPhase", [f.computed], Object.getOwnPropertyDescriptor(FAe.prototype, "chooseAccountPhase"), FAe.prototype), KAe = tMe(FAe.prototype, "onClickOk", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.actions;
          if (e.selectedRole = e.currentRole, e.wizard.curPhaseIndex >= 1 || !e.selectedRole.accountSpecific) return t.handleSave(e.selectedRole), e.newUser ? e.closeModal() : null;
          e.wizard.next();
        };
      }
    }), GAe = tMe(FAe.prototype, "onClickCancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.actions;
          e.wizard.curPhaseIndex <= 0 ? (t.handleClose(), e.wizard.curPhaseIndex = 0, e.closeModal(), e.currentRole = e.dropdownPlaceHolder) : e.wizard.previous();
        };
      }
    }), WAe = tMe(FAe.prototype, "closeModal", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props.actions;
          v()("#accessLevelModal").modal("hide"), e.wizard.curPhaseIndex = 0, e.onChangeRole(), e.selectedRole = null, t.handleClose();
        };
      }
    }), HAe = tMe(FAe.prototype, "onChangeRole", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t ? (e.currentRole = t.value, e.currentRole.accountSpecific ? e.wizard.twoPhase() : e.wizard.onePhase()) : (e.currentRole = e.dropdownPlaceHolder, e.wizard.init());
        };
      }
    }), IAe = FAe)) || IAe,
        nMe = Object(g.a)()(rMe);

    function oMe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, iMe(n.key), n);
      }
    }

    function iMe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var aMe,
        cMe,
        uMe,
        lMe,
        sMe,
        pMe,
        fMe,
        dMe,
        bMe,
        yMe = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.defaultApiPath = "/if2/api/roles", this.apiPath = t || this.defaultApiPath;
      }, (t = [{
        key: "fetchAll",
        value: function () {
          return fetch(this.apiPath).then(function (e) {
            return e.json();
          });
        }
      }]) && oMe(e.prototype, t), r && oMe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    function mMe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function vMe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, hMe(n.key), n);
      }
    }

    function hMe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function gMe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var wMe,
        OMe,
        jMe,
        PMe = ((bMe = function () {
      return e = function e() {
        var t = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), mMe(this, "name", cMe, this), mMe(this, "displayName", uMe, this), mMe(this, "description", lMe, this), mMe(this, "privileges", sMe, this), mMe(this, "accountSpecific", pMe, this), mMe(this, "assignableRoles", fMe, this), this.toJS = function () {
          return {
            type: t.type,
            serial: t.serial,
            name: t.name,
            display_name: t.displayName,
            description: t.description,
            privileges: t.privileges,
            account_specific: t.accountSpecific,
            assignable_roles: t.assignableRoles
          };
        }, mMe(this, "updateFromJS", dMe, this);
      }, (t = [{
        key: "preferredName",
        get: function () {
          return this.displayName || this.name;
        }
      }, {
        key: "isAdmin",
        get: function () {
          return 0 === this.serial;
        }
      }]) && vMe(e.prototype, t), r && vMe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).fromJS = function (e) {
      var t = new bMe();
      return t.updateFromJS(e), t;
    }, cMe = gMe((aMe = bMe).prototype, "name", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), uMe = gMe(aMe.prototype, "displayName", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), lMe = gMe(aMe.prototype, "description", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), sMe = gMe(aMe.prototype, "privileges", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), pMe = gMe(aMe.prototype, "accountSpecific", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), fMe = gMe(aMe.prototype, "assignableRoles", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), gMe(aMe.prototype, "preferredName", [f.computed], Object.getOwnPropertyDescriptor(aMe.prototype, "preferredName"), aMe.prototype), gMe(aMe.prototype, "isAdmin", [f.computed], Object.getOwnPropertyDescriptor(aMe.prototype, "isAdmin"), aMe.prototype), dMe = gMe(aMe.prototype, "updateFromJS", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = t || {};
          e.type = r.type, e.serial = r.serial, e.name = r.name, e.displayName = r.display_name, e.description = r.description, e.privileges = r.privileges, e.accountSpecific = r.account_specific, e.assignableRoles = r.assignable_roles;
        };
      }
    }), aMe);

    function _Me(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function EMe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, SMe(n.key), n);
      }
    }

    function SMe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function CMe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var kMe,
        RMe = (OMe = CMe((wMe = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.api = void 0, _Me(this, "status", OMe, this), _Me(this, "roles", jMe, this), this.api = t;
      }, (t = [{
        key: "isPending",
        get: function () {
          return "pending" === this.status;
        }
      }, {
        key: "fetchAll",
        value: function () {
          var e = this;
          return this.status = "pending", this.api.fetchAll().then(function (t) {
            return e.pushMany(t), !1;
          }).catch(function (e) {
            return console.log(e), [];
          }).finally(function () {
            return Object(f.runInAction)(function () {
              e.status = "ready";
            });
          });
        }
      }, {
        key: "findSerial",
        value: function (e) {
          return this.roles.find(function (t) {
            return t.serial === e;
          });
        }
      }, {
        key: "pushMany",
        value: function (e) {
          var t = this;
          e.forEach(function (e) {
            t.roles.push(PMe.fromJS(e));
          });
        }
      }]) && EMe(e.prototype, t), r && EMe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "status", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "ready";
      }
    }), jMe = CMe(wMe.prototype, "roles", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), CMe(wMe.prototype, "isPending", [f.computed], Object.getOwnPropertyDescriptor(wMe.prototype, "isPending"), wMe.prototype), CMe(wMe.prototype, "fetchAll", [f.action], Object.getOwnPropertyDescriptor(wMe.prototype, "fetchAll"), wMe.prototype), CMe(wMe.prototype, "findSerial", [f.action], Object.getOwnPropertyDescriptor(wMe.prototype, "findSerial"), wMe.prototype), CMe(wMe.prototype, "pushMany", [f.action], Object.getOwnPropertyDescriptor(wMe.prototype, "pushMany"), wMe.prototype), wMe);

    function TMe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zMe(n.key), n);
      }
    }

    function zMe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var NMe = function () {
      return e = function e() {
        var t = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.accountIds = [], this.accountNames = [], this.name = void 0, this.toJS = function () {
          return {
            user_id: t.userId,
            account_ids: t.accountIds,
            role_id: t.roleId
          };
        }, this.updateFromJS = function (e) {
          t.userId = e.user_id || null, t.accountIds = e.account_ids || [], t.accountNames = e.account_names || [], t.roleId = e.role_id, t.name = e.role_name || "";
        }, this.save = function (e) {
          var r = "/if2/users/".concat(t.userId, "/role_assignments");
          return fetch(r, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              role_assignment: t.toJS(),
              authenticity_token: e
            })
          }).then(function (e) {
            window.location = e.url;
          }).catch(function (e) {
            alert("Save Failed:", e), console.error("Save Failed:", e);
          });
        }, this.id = kj()();
      }, (t = [{
        key: "combine",
        value: function (e) {
          this.accountIds = this.accountIds.concat(e.accountIds), this.accountNames = this.accountNames.concat(e.accountNames);
        }
      }]) && TMe(e.prototype, t), r && TMe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }();

    kMe = NMe, NMe.fromJS = function (e) {
      var t = new kMe();
      return t.updateFromJS(e), t;
    };
    var DMe,
        xMe = NMe;

    function AMe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, MMe(n.key), n);
      }
    }

    function MMe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function IMe(e, t, r) {
      return t = FMe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], FMe(e).constructor) : t.apply(e, r));
    }

    function FMe(e) {
      return (FMe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function BMe(e, t) {
      return (BMe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var LMe,
        VMe,
        UMe,
        qMe,
        KMe,
        GMe,
        WMe,
        HMe,
        JMe,
        YMe,
        QMe,
        $Me,
        XMe = Object(d.observer)(DMe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), IMe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && BMe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.roleAssignment,
              r = e.onClose;
          return p.a.createElement(s.Fragment, {
            key: t.serial
          }, p.a.createElement("input", {
            type: "hidden",
            name: "role_assignments[][role_id]",
            value: t.roleId
          }), t.accountIds.map(function (e) {
            return p.a.createElement("input", {
              key: e,
              type: "hidden",
              name: "role_assignments[][account_ids][]",
              value: e
            });
          }), p.a.createElement("div", {
            className: "col-lg-4 px-3 py-2 mr-3 card"
          }, p.a.createElement("div", null, p.a.createElement("button", {
            type: "button",
            className: "close",
            onClick: function () {
              r(t.id);
            }
          }, p.a.createElement("span", {
            "aria-hidden": "true"
          }, "×"))), p.a.createElement("div", {
            className: "d-flex flex-row"
          }, p.a.createElement("div", null, t.name), p.a.createElement("div", {
            className: "ml-2 pl-2 border-left"
          }, p.a.createElement("div", null, t.accountNames.map(function (e) {
            return p.a.createElement("div", {
              key: e
            }, e);
          }))))));
        }
      }]) && AMe(r.prototype, n), o && AMe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || DMe;

    function ZMe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function eIe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, tIe(n.key), n);
      }
    }

    function tIe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function rIe(e, t, r) {
      return t = nIe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], nIe(e).constructor) : t.apply(e, r));
    }

    function nIe(e) {
      return (nIe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function oIe(e, t) {
      return (oIe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function iIe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var aIe,
        cIe,
        uIe,
        lIe = Object(d.observer)((UMe = iIe((VMe = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), ZMe(r = rIe(this, t, [e]), "currentNode", UMe, r), ZMe(r, "isSaving", qMe, r), ZMe(r, "newUserRoleAssignments", KMe, r), r.persistRoleAssignments = function () {
          var e = r.props.roleAssignments,
              t = {};
          e && (e.forEach(function (e) {
            var n = xMe.fromJS({
              user_id: r.user.serial,
              account_ids: e.account ? [e.account.serial] : null,
              account_names: e.account ? [e.account.name] : null,
              role_id: e.role.serial,
              role_name: e.role.name
            });
            t[e.role.name] ? t[e.role.name].combine(n) : t[e.role.name] = n;
          }), r.newUserRoleAssignments = Object.values(t));
        }, r.handleToggleExpand = function (e) {
          var t = r.accountsStore.find(e);
          t && (t.child_ids.some(function (e) {
            return !r.accountsStore.isLoaded(e);
          }) && r.accountsStore.updateChildrenOf(e), r.treeModel.toggleExpanded(e));
        }, r.handleClickName = function (e) {
          r.handleToggleChecked(e);
        }, ZMe(r, "handleToggleChecked", GMe, r), ZMe(r, "handleSaveRole", WMe, r), ZMe(r, "handleSaveExisting", HMe, r), ZMe(r, "handleSaveNew", JMe, r), ZMe(r, "handleClose", YMe, r), ZMe(r, "onCloseRoleAssignment", QMe, r), ZMe(r, "onOpenWizard", $Me, r);
        var n = r.props,
            o = n.visibleAccounts,
            i = n.user;
        return r.user = i, r.accountsApi = new N(), r.accountsStore = new Tt(r.accountsApi, new qt(), r.user.id), o.forEach(function (e) {
          r.accountsStore.push(e);
        }), r.treeModel = new h.AccountsTreeModel(r.accountsStore), r.rolesApi = new yMe(), r.rolesStore = new RMe(r.rolesApi), r.persistRoleAssignments(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && oIe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && eIe(e.prototype, t), r && eIe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "newUser",
        get: function () {
          return !this.user.serial;
        }
      }, {
        key: "componentDidMount",
        value: function () {
          this.rolesStore.fetchAll();
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.accountsStore.roots,
              r = this.rolesStore.roles,
              n = this.props.t;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement(nMe, {
            roots: t,
            currentLevel: this.currentLevel,
            roles: r,
            treeModel: this.treeModel,
            isSaving: this.isSaving,
            newUser: this.newUser,
            actions: {
              handleToggleExpand: this.handleToggleExpand,
              handleClickNodeContent: this.handleClickName,
              handleToggleChecked: this.handleToggleChecked,
              handleSave: this.newUser ? this.handleSaveNew : this.handleSaveExisting,
              handleClose: this.handleClose
            }
          }), p.a.createElement("div", {
            className: "ml-1 row"
          }, this.newUserRoleAssignments.map(function (t) {
            return p.a.createElement(XMe, {
              key: t.id,
              roleAssignment: t,
              onClose: e.onCloseRoleAssignment
            });
          })), p.a.createElement("a", {
            href: "#",
            onClick: this.onOpenWizard
          }, n("assign_new_role"), " ", p.a.createElement("i", {
            className: "fas fa-plus-circle"
          })));
        }
      }]);
    }()).prototype, "currentNode", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), qMe = iIe(VMe.prototype, "isSaving", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), KMe = iIe(VMe.prototype, "newUserRoleAssignments", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), iIe(VMe.prototype, "newUser", [f.computed], Object.getOwnPropertyDescriptor(VMe.prototype, "newUser"), VMe.prototype), GMe = iIe(VMe.prototype, "handleToggleChecked", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.accountsStore.find(t);
          if (e.currentNode = r, r) return e.accountsStore.descendantsAreLoadedOf(t) ? e.treeModel.toggleChecked(t) : e.accountsStore.updateDescendantsOf(t).then(function () {
            return e.treeModel.toggleChecked(t);
          });
        };
      }
    }), WMe = iIe(VMe.prototype, "handleSaveRole", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.accountsStore.find(t);
          e.currentNode = r;
        };
      }
    }), HMe = iIe(VMe.prototype, "handleSaveExisting", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.authenticityToken,
              n = xMe.fromJS({
            user_id: e.user.serial,
            role_id: t.serial
          });
          e.isSaving = !0, e.treeModel.checked.forEach(function (t) {
            var r = e.accountsStore.find(t);
            e.treeModel.isParentChecked(t) || n.accountIds.push(r.serial);
          }), n.save(r);
        };
      }
    }), JMe = iIe(VMe.prototype, "handleSaveNew", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = xMe.fromJS({
            user_id: e.user.serial,
            role_id: t.serial
          });
          r.name = t.name, e.treeModel.checked.forEach(function (t) {
            var n = e.accountsStore.find(t);
            e.treeModel.isParentChecked(t) || (r.accountIds.push(n.serial), r.accountNames.push(n.name));
          }), e.newUserRoleAssignments.push(r);
        };
      }
    }), YMe = iIe(VMe.prototype, "handleClose", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isSaving = !1;
        };
      }
    }), QMe = iIe(VMe.prototype, "onCloseRoleAssignment", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.newUserRoleAssignments.splice(e.newUserRoleAssignments.findIndex(function (e) {
            return e.id === t;
          }), 1);
        };
      }
    }), $Me = iIe(VMe.prototype, "onOpenWizard", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.treeModel.unCheckAll(), v()("#accessLevelModal").modal();
        };
      }
    }), LMe = VMe)) || LMe,
        sIe = Object(g.a)()(lIe);

    function pIe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function fIe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bIe(n.key), n);
      }
    }

    function dIe(e, t, r) {
      return t && fIe(e.prototype, t), r && fIe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function bIe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function yIe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var mIe,
        vIe,
        hIe,
        gIe,
        wIe,
        OIe,
        jIe,
        PIe,
        _Ie,
        EIe,
        SIe = (cIe = yIe((aIe = dIe(function e(t, r, n, o) {
      var i = this;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), pIe(this, "account", cIe, this), pIe(this, "role", uIe, this), this.accountSpecific = void 0, this.toJS = function () {
        var e = {};
        return i.account && (e.account_id = i.account.serial), i.role && (e.role_id = i.role.serial), e;
      }, this.update = function (e) {
        var t = "/if2/role_assignments/".concat(i.serial);
        return fetch(t, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            role_assignment: i.toJS(),
            authenticity_token: e
          })
        }).then(function (e) {
          console.log("update", e), window.location.reload();
        }).catch(function (e) {
          alert("Save Failed:", e), console.error("Save Failed:", e);
        });
      }, this.trash = function (e) {
        var t = "Are you sure you want to delete ".concat(i.role.name, " role");

        if (i.account ? window.confirm("".concat(t, " for ").concat(i.account.name, "?")) : window.confirm("".concat(t, "?"))) {
          var r = "/if2/role_assignments/".concat(i.serial);
          return fetch(r, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              authenticity_token: e
            })
          }).then(function (e) {
            switch (e.status) {
              case 200:
                window.location.reload();
                break;

              case 401:
                alert("In order to delete last role, delete the user");
                break;

              default:
                console.log(e);
            }
          }).catch(function (e) {
            alert("Delete Failed:", e), console.error("Delete Failed:", e);
          });
        }
      }, this.serial = t, this.account = r, this.role = n, this.accountSpecific = o;
    })).prototype, "account", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), uIe = yIe(aIe.prototype, "role", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), aIe);

    function CIe(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

        if (null != r) {
          var n,
              o,
              i,
              a,
              c = [],
              u = !0,
              l = !1;

          try {
            if (i = (r = r.call(e)).next, 0 === t) {
              if (Object(r) !== r) return;
              u = !1;
            } else for (; !(u = (n = i.call(r)).done) && (c.push(n.value), c.length !== t); u = !0);
          } catch (e) {
            l = !0, o = e;
          } finally {
            try {
              if (!u && null != r.return && (a = r.return(), Object(a) !== a)) return;
            } finally {
              if (l) throw o;
            }
          }

          return c;
        }
      }(e, t) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return kIe(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? kIe(e, t) : void 0;
        }
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function kIe(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function RIe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function TIe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zIe(n.key), n);
      }
    }

    function zIe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function NIe(e, t, r) {
      return t = DIe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], DIe(e).constructor) : t.apply(e, r));
    }

    function DIe(e) {
      return (DIe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function xIe(e, t) {
      return (xIe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function AIe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var MIe,
        IIe,
        FIe = Object(d.observer)((hIe = AIe((vIe = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), RIe(r = NIe(this, t, [e]), "roleSelector", hIe, r), RIe(r, "currentRole", gIe, r), RIe(r, "roleOptions", wIe, r), RIe(r, "onRegisterSelectModel", OIe, r), RIe(r, "onClickOk", jIe, r), RIe(r, "onClickCancel", PIe, r), RIe(r, "closeModal", _Ie, r), RIe(r, "onChangeRole", EIe, r);
        var n = r.props.id;
        return r.id = n, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && xIe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && TIe(e.prototype, t), r && TIe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "dropdownPlaceHolder",
        get: function () {
          var e = this.props.t;
          return {
            name: e("select_a_role"),
            description: e("select_and_follow_prompts"),
            init: !0
          };
        }
      }, {
        key: "roles",
        get: function () {
          return this.props.rolesStore.roles;
        }
      }, {
        key: "roleOptionsFormat",
        get: function () {
          return this.roles.filter(function (e) {
            return !0 === e.accountSpecific;
          }).map(function (e) {
            return {
              key: e.serial,
              text: e.preferredName,
              value: e
            };
          });
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = this;
          this.roleEditorDisposer = Object(f.reaction)(function () {
            return [e.props.currentRoleAssignment, e.roleOptionsFormat];
          }, function (t) {
            var r,
                n,
                o = CIe(t, 2),
                i = o[0],
                a = o[1];
            null != i && null !== (r = i.role) && void 0 !== r && r.name && a.length ? (e.roleSelector.search(null == i || null === (n = i.role) || void 0 === n ? void 0 : n.name), e.currentRole = e.roleSelector.selectedValue) : e.currentRole = e.dropdownPlaceHolder;
          }, {
            fireImmediately: !0
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.roleEditorDisposer();
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t,
              r = this.props,
              n = r.t,
              o = r.currentRoleAssignment,
              i = r.rolesStore;
          return p.a.createElement("div", {
            className: "modal fade role-assignment",
            id: this.id,
            tabIndex: "-1",
            role: "dialog",
            "aria-labelledby": "".concat(this.id, "Label"),
            "aria-hidden": "true"
          }, p.a.createElement("div", {
            className: "modal-dialog",
            role: "document"
          }, p.a.createElement("div", {
            className: "modal-content"
          }, p.a.createElement(Yxe, {
            title: null == o || null === (e = o.account) || void 0 === e ? void 0 : e.clientPathString,
            onClose: this.closeModal
          }), p.a.createElement(nAe, null, p.a.createElement(h.SelectDropdown, {
            className: "role-selector",
            placeholder: "Select Role",
            onRegisterModel: this.onRegisterSelectModel,
            options: this.roleOptionsFormat,
            onChange: this.onChangeRole
          }), p.a.createElement("div", {
            className: "px-1 pt-2"
          }, i.isPending ? p.a.createElement(h.Spinner, null) : p.a.createElement("p", {
            className: "mb-1"
          }, null === (t = this.currentRole) || void 0 === t ? void 0 : t.description))), p.a.createElement(yAe, {
            cancelText: n("cancel"),
            okText: n("save"),
            onClickCancel: this.onClickCancel,
            onClickOk: this.onClickOk
          }))));
        }
      }]);
    }()).prototype, "roleSelector", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new h.SelectorModel();
      }
    }), gIe = AIe(vIe.prototype, "currentRole", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), wIe = AIe(vIe.prototype, "roleOptions", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [{
          key: "init",
          text: "Select Role",
          value: "None"
        }];
      }
    }), AIe(vIe.prototype, "dropdownPlaceHolder", [f.computed], Object.getOwnPropertyDescriptor(vIe.prototype, "dropdownPlaceHolder"), vIe.prototype), AIe(vIe.prototype, "roles", [f.computed], Object.getOwnPropertyDescriptor(vIe.prototype, "roles"), vIe.prototype), AIe(vIe.prototype, "roleOptionsFormat", [f.computed], Object.getOwnPropertyDescriptor(vIe.prototype, "roleOptionsFormat"), vIe.prototype), OIe = AIe(vIe.prototype, "onRegisterSelectModel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.roleSelector = t;
        };
      }
    }), jIe = AIe(vIe.prototype, "onClickOk", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.props.actions.handleOk(e.currentRole), e.closeModal();
        };
      }
    }), PIe = AIe(vIe.prototype, "onClickCancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.closeModal();
        };
      }
    }), _Ie = AIe(vIe.prototype, "closeModal", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          v()("#".concat(e.id)).modal("hide");
        };
      }
    }), EIe = AIe(vIe.prototype, "onChangeRole", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.currentRole = null == t ? void 0 : t.value;
        };
      }
    }), mIe = vIe)) || mIe,
        BIe = Object(g.a)()(FIe);

    function LIe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, UIe(n.key), n);
      }
    }

    function VIe(e, t, r) {
      return t && LIe(e.prototype, t), r && LIe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }

    function UIe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    var qIe,
        KIe,
        GIe = (IIe = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((MIe = VIe(function e(t, r) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), function (e, t, r, n) {
        r && Object.defineProperty(e, t, {
          enumerable: r.enumerable,
          configurable: r.configurable,
          writable: r.writable,
          value: r.initializer ? r.initializer.call(n) : void 0
        });
      }(this, "visible", IIe, this), this.visible = t, this.id = r.id, this.name = r.name;
    })).prototype, "visible", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !0;
      }
    }), MIe);

    function WIe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, HIe(n.key), n);
      }
    }

    function HIe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function JIe(e, t, r) {
      return t = YIe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], YIe(e).constructor) : t.apply(e, r));
    }

    function YIe(e) {
      return (YIe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function QIe(e, t) {
      return (QIe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function $Ie(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var XIe,
        ZIe,
        eFe,
        tFe,
        rFe = Object(d.observer)(($Ie((KIe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = JIe(this, t, [].concat(n))).numVisibleIndex = 2, e.handleExpandCollapse = function (t) {
          return t.preventDefault(), e.areAllVisible ? e.setCollapsed() : e.setExpanded();
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && QIe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && WIe(e.prototype, t), r && WIe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "childModels",
        get: function () {
          var e = this;
          return this.props.childAccounts.map(function (t, r) {
            return r > e.numVisibleIndex ? new GIe(!1, t) : new GIe(!0, t);
          });
        }
      }, {
        key: "areAllVisible",
        get: function () {
          return this.childModels[this.childModels.length - 1].visible;
        }
      }, {
        key: "setExpanded",
        value: function () {
          this.childModels.forEach(function (e) {
            e.visible = !0;
          });
        }
      }, {
        key: "setCollapsed",
        value: function () {
          var e = this;
          this.childModels.forEach(function (t, r) {
            r > e.numVisibleIndex && (t.visible = !1);
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return p.a.createElement("ul", {
            className: "child-accounts"
          }, this.childModels.map(function (e) {
            return e.visible ? p.a.createElement("li", {
              className: "text-secondary understated",
              key: e.id
            }, e.name) : null;
          }), this.childModels.length - 1 > this.numVisibleIndex ? p.a.createElement("li", null, p.a.createElement("a", {
            href: "#",
            className: "understated",
            onClick: this.handleExpandCollapse
          }, this.areAllVisible ? e("hide") : e("see_more"))) : null);
        }
      }]);
    }()).prototype, "childModels", [f.computed], Object.getOwnPropertyDescriptor(KIe.prototype, "childModels"), KIe.prototype), $Ie(KIe.prototype, "areAllVisible", [f.computed], Object.getOwnPropertyDescriptor(KIe.prototype, "areAllVisible"), KIe.prototype), $Ie(KIe.prototype, "setExpanded", [f.action], Object.getOwnPropertyDescriptor(KIe.prototype, "setExpanded"), KIe.prototype), $Ie(KIe.prototype, "setCollapsed", [f.action], Object.getOwnPropertyDescriptor(KIe.prototype, "setCollapsed"), KIe.prototype), qIe = KIe)) || qIe,
        nFe = Object(g.a)()(rFe);

    function oFe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function iFe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, aFe(n.key), n);
      }
    }

    function aFe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function cFe(e, t, r) {
      return t = uFe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], uFe(e).constructor) : t.apply(e, r));
    }

    function uFe(e) {
      return (uFe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function lFe(e, t) {
      return (lFe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function sFe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var pFe,
        fFe,
        dFe,
        bFe,
        yFe,
        mFe,
        vFe,
        hFe,
        gFe = Object(d.observer)((eFe = sFe((ZIe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return oFe(e = cFe(this, t, [].concat(n)), "onClickRoleEdit", eFe, e), oFe(e, "onClickTrash", tFe, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && lFe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          var e,
              t,
              r = this.props.roleAssignment;
          return p.a.createElement("tr", {
            key: r.serial
          }, p.a.createElement("td", null, r.role ? r.role.name : null), p.a.createElement("td", null, p.a.createElement("div", {
            className: "d-inline-block"
          }, r.accountSpecific && !r.account ? p.a.createElement(h.Spinner, null) : null), p.a.createElement("div", {
            className: "d-inline-block"
          }, null === (e = r.account) || void 0 === e ? void 0 : e.clientPathString, (null == r || null === (t = r.account) || void 0 === t || null === (t = t.children) || void 0 === t ? void 0 : t.length) > 0 ? p.a.createElement(nFe, {
            childAccounts: r.account.children
          }) : null)), p.a.createElement("td", {
            className: "text-right"
          }, r.account ? p.a.createElement("a", {
            href: "#",
            onClick: this.onClickRoleEdit
          }, p.a.createElement("i", {
            className: "fas fa-edit text-primary clickable"
          })) : null, p.a.createElement("a", {
            href: "#",
            onClick: this.onClickTrash
          }, p.a.createElement("i", {
            className: "fas fa-trash-alt ml-3 text-danger clickable"
          }))));
        }
      }]) && iFe(r.prototype, n), o && iFe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "onClickRoleEdit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.onClickRoleEdit,
              o = r.roleAssignment;
          t.preventDefault(), n(o);
        };
      }
    }), tFe = sFe(ZIe.prototype, "onClickTrash", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.onClickTrash,
              o = r.roleAssignment;
          t.preventDefault(), n(o);
        };
      }
    }), XIe = ZIe)) || XIe;

    function wFe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function OFe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, jFe(n.key), n);
      }
    }

    function jFe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function PFe(e, t, r) {
      return t = _Fe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], _Fe(e).constructor) : t.apply(e, r));
    }

    function _Fe(e) {
      return (_Fe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function EFe(e, t) {
      return (EFe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function SFe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var CFe,
        kFe,
        RFe = Object(d.observer)((dFe = SFe((fFe = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), wFe(r = PFe(this, t, [e]), "currentNode", dFe, r), wFe(r, "currentRoleAssignment", bFe, r), wFe(r, "isSaving", yFe, r), wFe(r, "handleOkRole", mFe, r), wFe(r, "onClickRoleEdit", vFe, r), wFe(r, "onClickTrash", hFe, r);
        var n = r.props,
            o = n.user,
            i = n.roleAssignments;
        return r.user = o, r.accountsApi = new N(), r.accountsStore = new Tt(r.accountsApi, new qt(), r.user.id), i.map(function (e) {
          var t;
          return null == e || null === (t = e.account) || void 0 === t ? void 0 : t.id;
        }).filter(Boolean).forEach(function (e) {
          r.accountsStore.load(e);
        }), r.rolesApi = new yMe(), r.rolesStore = new RMe(r.rolesApi), r.rolesStore.fetchAll(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && EFe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && OFe(e.prototype, t), r && OFe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "roleAssignments",
        get: function () {
          var e = this;
          return this.props.roleAssignments.map(function (t) {
            var r = t.account && e.accountsStore.find(t.account.id),
                n = !1;
            return t.account && (n = !0), new SIe(t.serial, r, t.role, n);
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props.t;
          return p.a.createElement("div", null, p.a.createElement(BIe, {
            id: "roleEditor",
            rolesStore: this.rolesStore,
            currentRoleAssignment: this.currentRoleAssignment,
            actions: {
              handleOk: this.handleOkRole
            }
          }), p.a.createElement("table", {
            className: "table table-striped role-assignment-table"
          }, p.a.createElement("thead", null, p.a.createElement("tr", null, p.a.createElement("th", null, t("roles")), p.a.createElement("th", null, t("accounts")), p.a.createElement("th", {
            "aria-label": "action-button-column"
          }))), p.a.createElement("tbody", null, this.roleAssignments.map(function (t) {
            return p.a.createElement(gFe, {
              key: t.serial,
              roleAssignment: t,
              onClickRoleEdit: e.onClickRoleEdit,
              onClickTrash: e.onClickTrash
            });
          }))));
        }
      }]);
    }()).prototype, "currentNode", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), bFe = SFe(fFe.prototype, "currentRoleAssignment", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return {};
      }
    }), yFe = SFe(fFe.prototype, "isSaving", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), SFe(fFe.prototype, "roleAssignments", [f.computed], Object.getOwnPropertyDescriptor(fFe.prototype, "roleAssignments"), fFe.prototype), mFe = SFe(fFe.prototype, "handleOkRole", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.authenticityToken;
          e.currentRoleAssignment.role = t, e.currentRoleAssignment.update(r);
        };
      }
    }), vFe = SFe(fFe.prototype, "onClickRoleEdit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          v()("#roleEditor").modal("show"), e.currentRoleAssignment = t;
        };
      }
    }), hFe = SFe(fFe.prototype, "onClickTrash", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.authenticityToken;
          t.trash(r);
        };
      }
    }), pFe = fFe)) || pFe,
        TFe = Object(g.a)()(RFe);

    function zFe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, NFe(n.key), n);
      }
    }

    function NFe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function DFe(e, t, r) {
      return t = xFe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], xFe(e).constructor) : t.apply(e, r));
    }

    function xFe(e) {
      return (xFe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function AFe(e, t) {
      return (AFe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function MFe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var IFe,
        FFe,
        BFe = Object(d.observer)((MFe((kFe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = DFe(this, t, [].concat(n)))._handleSelected = function (t) {
          var r = e.props.onSelect;
          r && e._applyRecursively(t, r);
        }, e._handleDeselected = function (t) {
          var r = e.props.onDeselect;
          r && e._applyRecursively(t, r);
        }, e._applyRecursively = function (t, r) {
          r(t), t.privileges.forEach(function (t) {
            return e._applyRecursively(t, r);
          });
        }, e._handleOnChange = function (t, r) {
          t.target.checked ? e._handleSelected(r) : e._handleDeselected(r);
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && AFe(e, t);
      }(t, p.a.Component), r = t, (n = [{
        key: "_privilege",
        get: function () {
          var e = this.props.privilege;
          if (!e) throw new Error("Privilege needs a 'privilege' property");
          return e;
        }
      }, {
        key: "_childPrivileges",
        get: function () {
          return ep()(this._privilege.privileges, function (e) {
            return e.description;
          });
        }
      }, {
        key: "_currentPrivilegeKeys",
        get: function () {
          var e = this.props.currentPrivilegeKeys;
          if (!e) throw new Error("Privilege needs a 'currentPrivilegeKeys' property");
          return e;
        }
      }, {
        key: "_implied",
        get: function () {
          return !0 === this.props.implied;
        }
      }, {
        key: "_selected",
        get: function () {
          return this._implied || this._currentPrivilegeKeys.includes(this._privilege.key);
        }
      }, {
        key: "_renderChildPrivileges",
        value: function () {
          var e = this;
          return 0 === this._childPrivileges.length ? null : this._childPrivileges.map(function (r) {
            return p.a.createElement(t, {
              privilege: r,
              currentPrivilegeKeys: e._currentPrivilegeKeys,
              onSelect: e._handleSelected,
              onDeselect: e._handleDeselected,
              implied: e._selected,
              key: r.key
            });
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this;
          return p.a.createElement("div", {
            className: "ml-3"
          }, p.a.createElement("div", {
            className: "form-check"
          }, p.a.createElement("input", {
            id: this._privilege.key,
            type: "checkbox",
            checked: this._selected,
            value: this._privilege.key,
            className: "form-check-input",
            onChange: function (t) {
              return e._handleOnChange(t, e._privilege);
            },
            disabled: this._implied
          }), this._selected ? p.a.createElement("input", {
            type: "hidden",
            name: "role[privileges][]",
            value: this._privilege.key
          }) : null, p.a.createElement("label", {
            className: "form-check-label",
            htmlFor: this._privilege.key
          }, this._privilege.description)), this._renderChildPrivileges());
        }
      }]) && zFe(r.prototype, n), o && zFe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "_privilege", [f.computed], Object.getOwnPropertyDescriptor(kFe.prototype, "_privilege"), kFe.prototype), MFe(kFe.prototype, "_childPrivileges", [f.computed], Object.getOwnPropertyDescriptor(kFe.prototype, "_childPrivileges"), kFe.prototype), MFe(kFe.prototype, "_currentPrivilegeKeys", [f.computed], Object.getOwnPropertyDescriptor(kFe.prototype, "_currentPrivilegeKeys"), kFe.prototype), MFe(kFe.prototype, "_implied", [f.computed], Object.getOwnPropertyDescriptor(kFe.prototype, "_implied"), kFe.prototype), CFe = kFe)) || CFe;

    function LFe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, VFe(n.key), n);
      }
    }

    function VFe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function UFe(e, t, r) {
      return t = qFe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], qFe(e).constructor) : t.apply(e, r));
    }

    function qFe(e) {
      return (qFe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function KFe(e, t) {
      return (KFe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function GFe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var WFe,
        HFe,
        JFe,
        YFe,
        QFe,
        $Fe,
        XFe,
        ZFe = Object(d.observer)((GFe((FFe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = UFe(this, t, [].concat(n)))._handleSelected = function (t) {
          var r = e.props.onSelect;
          r && r(t.key);
        }, e._handleDeselected = function (t) {
          var r = e.props.onDeselect;
          r && r(t.key);
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && KFe(e, t);
      }(t, p.a.Component), r = t, (n = [{
        key: "_privileges",
        get: function () {
          var e = this.props.privileges;
          if (!e) throw new Error("PrivilegeGroup needs a 'privileges' property");
          return ep()(e, function (e) {
            return e.description;
          });
        }
      }, {
        key: "_currentPrivilegeKeys",
        get: function () {
          var e = this.props.currentPrivilegeKeys;
          if (!e) throw new Error("PrivilegeGroup needs a 'currentPrivilegeKeys' property");
          return e;
        }
      }, {
        key: "_title",
        get: function () {
          var e = this.props.title;
          if (!e) throw new Error("PrivilegeGroup needs a 'title' property");
          return e;
        }
      }, {
        key: "render",
        value: function () {
          var e = this;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("strong", null, this._title), this._privileges.map(function (t) {
            return p.a.createElement(BFe, {
              privilege: t,
              currentPrivilegeKeys: e._currentPrivilegeKeys,
              onSelect: e._handleSelected,
              onDeselect: e._handleDeselected,
              key: t.key
            });
          }));
        }
      }]) && LFe(r.prototype, n), o && LFe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "_privileges", [f.computed], Object.getOwnPropertyDescriptor(FFe.prototype, "_privileges"), FFe.prototype), GFe(FFe.prototype, "_currentPrivilegeKeys", [f.computed], Object.getOwnPropertyDescriptor(FFe.prototype, "_currentPrivilegeKeys"), FFe.prototype), GFe(FFe.prototype, "_title", [f.computed], Object.getOwnPropertyDescriptor(FFe.prototype, "_title"), FFe.prototype), IFe = FFe)) || IFe;

    function eBe(e) {
      return function (e) {
        if (Array.isArray(e)) return tBe(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (e) {
          if ("string" == typeof e) return tBe(e, t);
          var r = {}.toString.call(e).slice(8, -1);
          return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? tBe(e, t) : void 0;
        }
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function tBe(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];

      return n;
    }

    function rBe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function nBe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, oBe(n.key), n);
      }
    }

    function oBe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function iBe(e, t, r) {
      return t = aBe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], aBe(e).constructor) : t.apply(e, r));
    }

    function aBe(e) {
      return (aBe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function cBe(e, t) {
      return (cBe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function uBe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var lBe,
        sBe,
        pBe = Object(d.observer)((JFe = uBe((HFe = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), rBe(r = iBe(this, t, [e]), "role", JFe, r), rBe(r, "assignableRoleSerials", YFe, r), rBe(r, "handlePrivilegeSelected", QFe, r), rBe(r, "handlePrivilegeDeselected", $Fe, r), rBe(r, "toggleAssignableRole", XFe, r);
        var n = r.props.role;
        return r.role = PMe.fromJS(n), r.assignableRoleSerials = r.role.assignableRoles.map(function (e) {
          return e.serial;
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && cBe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && nBe(e.prototype, t), r && nBe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "showRoleChoices",
        get: function () {
          var e = this.props.assignableRoleChoices;
          return this.role.privileges.includes("edit_users") && e.length > 0;
        }
      }, {
        key: "privileges",
        get: function () {
          var e = this.props.privileges;
          if (!e) throw new Error("RoleForm needs a 'privileges' property");
          return ep()(e, function (e) {
            return e.description;
          });
        }
      }, {
        key: "privColumns",
        get: function () {
          var e = this,
              t = this.privileges,
              r = Math.round(t.length / 2),
              n = t.slice(0, r),
              o = t.slice(r);
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("div", {
            className: "col-sm-5"
          }, n.map(function (t) {
            return p.a.createElement(ZFe, {
              key: t.key,
              title: t.description,
              currentPrivilegeKeys: e.role.privileges,
              privileges: t.privileges,
              onSelect: e.handlePrivilegeSelected,
              onDeselect: e.handlePrivilegeDeselected
            });
          })), p.a.createElement("div", {
            className: "col-sm-5"
          }, o.map(function (t) {
            return p.a.createElement(ZFe, {
              key: t.description,
              title: t.description,
              currentPrivilegeKeys: e.role.privileges,
              privileges: t.privileges,
              onSelect: e.handlePrivilegeSelected,
              onDeselect: e.handlePrivilegeDeselected
            });
          })));
        }
      }, {
        key: "privilegeDisplayName",
        value: function (e) {
          return e.split("_").map(function (e) {
            return e.charAt(0).toUpperCase() + e.slice(1);
          }).join(" ");
        }
      }, {
        key: "renderRoleChoices",
        value: function () {
          var e = this,
              t = this.props.assignableRoleChoices;
          return p.a.createElement("div", {
            className: "form-group row"
          }, p.a.createElement("label", {
            className: "col-sm-2 control-label"
          }, "Assignable Roles"), p.a.createElement("div", {
            className: "col-sm-10"
          }, t.filter(function (e) {
            return !e.isAdmin;
          }).map(function (t) {
            return p.a.createElement("div", {
              className: "form-check",
              key: t.serial
            }, p.a.createElement("input", {
              type: "checkbox",
              name: "role[assignable_role_ids][]",
              checked: e.assignableRoleSerials.includes(t.serial),
              value: t.serial,
              className: "form-check-input",
              onChange: function (r) {
                return e.toggleAssignableRole(r, t);
              }
            }), p.a.createElement("label", {
              className: "form-check-label"
            }, t.name));
          })));
        }
      }, {
        key: "getChildPrivs",
        value: function (e, t) {
          return this.allPrivileges[e] && this.allPrivileges[e].filter(function (e) {
            return e.parent === t;
          }) || [];
        }
      }, {
        key: "renderPrivilegeGroup",
        value: function (e) {
          var t = this;
          return p.a.createElement(ZFe, {
            key: e.description,
            title: e.description,
            privileges: e.privileges
          }, function (e) {
            return e.map(function (e) {
              if (!e.parent) return p.a.createElement(s.Fragment, {
                key: e.key
              }, t.renderPrivilegeCheck(e.key, null == e ? void 0 : e.label), t.getChildPrivs(title, e.key).map(function (e) {
                return p.a.createElement("div", {
                  className: "ml-3",
                  key: e.key
                }, t.renderSubordinatePrivilegeCheck(e.parent, e.key, null == e ? void 0 : e.label));
              }));
            });
          });
        }
      }, {
        key: "renderPrivilegeCheck",
        value: function (e, t) {
          var r = this;
          return p.a.createElement("div", {
            className: "form-check",
            key: e
          }, p.a.createElement("input", {
            id: e,
            type: "checkbox",
            name: "role[privileges][]",
            checked: this.role.privileges.includes(e),
            value: e,
            className: "form-check-input",
            onChange: function (t) {
              return r.togglePrivilege(t, e);
            }
          }), p.a.createElement("label", {
            className: "form-check-label",
            htmlFor: e
          }, t || this.privilegeDisplayName(e)));
        }
      }, {
        key: "renderSubordinatePrivilegeCheck",
        value: function (e, t, r) {
          var n = this;
          return p.a.createElement("div", {
            className: "form-check",
            key: t
          }, p.a.createElement("input", {
            id: t,
            type: "checkbox",
            name: "role[privileges][]",
            checked: this.role.privileges.includes(t) || this.role.privileges.includes(e),
            disabled: this.role.privileges.includes(e),
            value: t,
            className: "form-check-input",
            onChange: function (e) {
              return n.togglePrivilege(e, t);
            }
          }), p.a.createElement("label", {
            className: "form-check-label",
            htmlFor: t
          }, r || this.privilegeDisplayName(t)));
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.cancelPath,
              n = t.t;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("div", {
            className: "form-group row"
          }, p.a.createElement("label", {
            className: "col-sm-2 control-label"
          }, n("name")), " ", p.a.createElement("div", {
            className: "col-sm-10"
          }, p.a.createElement("input", {
            type: "text",
            className: "form-control",
            placeholder: n("name"),
            name: "role[name]",
            value: this.role.name || "",
            onChange: function (t) {
              return e.role.name = t.target.value;
            }
          }))), p.a.createElement("div", {
            className: "form-group row"
          }, p.a.createElement("label", {
            className: "col-sm-2 control-label"
          }, n("display_name")), p.a.createElement("div", {
            className: "col-sm-10"
          }, p.a.createElement("input", {
            type: "text",
            className: "form-control",
            placeholder: n("display_name"),
            name: "role[display_name]",
            value: this.role.display_name || "",
            onChange: function (t) {
              return e.role.display_name = t.target.value;
            }
          }))), p.a.createElement("div", {
            className: "form-group row"
          }, p.a.createElement("label", {
            className: "col-sm-2 control-label"
          }, n("description")), p.a.createElement("div", {
            className: "col-sm-10"
          }, p.a.createElement("textarea", {
            className: "form-control",
            placeholder: n("description"),
            name: "role[description]",
            onChange: function (t) {
              return e.role.description = t.target.value;
            },
            value: this.role.description || ""
          }))), p.a.createElement("div", {
            className: "form-group row"
          }, p.a.createElement("label", {
            className: "col-sm-2 control-label"
          }, n("privileges")), this.privColumns), this.showRoleChoices ? this.renderRoleChoices() : null, p.a.createElement("div", {
            className: "form-group row"
          }, p.a.createElement("div", {
            className: "col-sm-10 offset-sm-2 text-right"
          }, p.a.createElement("a", {
            href: r,
            className: "btn btn-secondary mr-1"
          }, n("cancel")), p.a.createElement("input", {
            type: "submit",
            value: "Save",
            className: "btn btn-primary"
          }))));
        }
      }]);
    }()).prototype, "role", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), YFe = uBe(HFe.prototype, "assignableRoleSerials", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), uBe(HFe.prototype, "showRoleChoices", [f.computed], Object.getOwnPropertyDescriptor(HFe.prototype, "showRoleChoices"), HFe.prototype), uBe(HFe.prototype, "privileges", [f.computed], Object.getOwnPropertyDescriptor(HFe.prototype, "privileges"), HFe.prototype), uBe(HFe.prototype, "privColumns", [f.computed], Object.getOwnPropertyDescriptor(HFe.prototype, "privColumns"), HFe.prototype), QFe = uBe(HFe.prototype, "handlePrivilegeSelected", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = new Set(e.role.privileges);
          r.add(t), e.role.privileges = eBe(r);
        };
      }
    }), $Fe = uBe(HFe.prototype, "handlePrivilegeDeselected", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.role.privileges = e.role.privileges.filter(function (e) {
            return e !== t;
          });
        };
      }
    }), XFe = uBe(HFe.prototype, "toggleAssignableRole", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r) {
          t.target.checked ? e.assignableRoleSerials.push(r.serial) : e.assignableRoleSerials = e.assignableRoleSerials.filter(function (e) {
            return e !== r.serial;
          });
        };
      }
    }), WFe = HFe)) || WFe,
        fBe = Object(g.a)()(pBe);

    function dBe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bBe(n.key), n);
      }
    }

    function bBe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function yBe(e, t, r) {
      return t = mBe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], mBe(e).constructor) : t.apply(e, r));
    }

    function mBe(e) {
      return (mBe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function vBe(e, t) {
      return (vBe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var hBe,
        gBe,
        wBe,
        OBe,
        jBe,
        PBe,
        _Be,
        EBe,
        SBe,
        CBe,
        kBe,
        RBe,
        TBe = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((sBe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), yBe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && vBe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "classNames",
        get: function () {
          var e = this.props,
              t = e.className,
              r = e.showIcon;
          return ["search-box-input"].concat(r ? "with-icon" : []).concat(t || []).join(" ");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.value,
              r = e.onChange,
              n = e.showIcon,
              o = e.placeholder;
          return p.a.createElement("div", {
            "aria-label": "Search Box",
            className: "search-box"
          }, n ? p.a.createElement("i", {
            "aria-label": "Search Icon",
            className: "fas fa-search icon-search"
          }) : null, p.a.createElement("input", {
            type: "search",
            role: "searchbox",
            className: this.classNames,
            placeholder: o,
            value: t,
            onChange: r
          }));
        }
      }]) && dBe(r.prototype, n), o && dBe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "classNames", [f.computed], Object.getOwnPropertyDescriptor(sBe.prototype, "classNames"), sBe.prototype), lBe = sBe)) || lBe;

    function zBe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function NBe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, DBe(n.key), n);
      }
    }

    function DBe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function xBe(e, t, r) {
      return t = ABe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ABe(e).constructor) : t.apply(e, r));
    }

    function ABe(e) {
      return (ABe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function MBe(e, t) {
      return (MBe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function IBe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var FBe,
        BBe,
        LBe,
        VBe = Object(d.observer)(((RBe = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = xBe(this, t, [e])).id = kj()(), zBe(r, "showDropdown", wBe, r), zBe(r, "onClickDocument", OBe, r), zBe(r, "chooseItem", jBe, r), zBe(r, "clearSearch", PBe, r), zBe(r, "onBlur", _Be, r), zBe(r, "onChange", EBe, r), zBe(r, "onFocus", SBe, r), zBe(r, "onKeyDown", CBe, r), zBe(r, "preventDefault", kBe, r), r.ref = Object(s.createRef)(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && MBe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "lowerCaseOptions",
        get: function () {
          return this.props.options.map(function (e) {
            return e.text.toLowerCase();
          });
        }
      }, {
        key: "inputClassNames",
        get: function () {
          var e = this.props,
              t = e.hasError,
              r = e.inputText;
          return ["form-control", "select-dropdown-input"].concat(t ? "is-invalid" : []).concat(r ? [] : " unspecified").join(" ");
        }
      }, {
        key: "componentDidMount",
        value: function () {
          document.addEventListener("click", this.onClickDocument);
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          document.removeEventListener("click", this.onClickDocument);
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.tabIndex,
              n = t.inputText,
              o = t.options,
              i = t.placeholder,
              a = t.selectedIndex,
              c = t.className,
              u = t.disableClearSearch;
          return p.a.createElement("div", {
            ref: this.ref,
            id: "select-dropdown-".concat(this.id),
            className: "select-dropdown mb-2".concat(c ? " ".concat(c) : ""),
            role: "combobox",
            "aria-expanded": this.showDropdown,
            "aria-controls": "listbox-".concat(this.id)
          }, u ? null : p.a.createElement("button", {
            className: "clear-search".concat(n ? "" : " empty"),
            type: "button",
            onClick: this.clearSearch
          }, p.a.createElement("span", {
            "aria-hidden": "true"
          }, "×")), p.a.createElement("input", {
            tabIndex: r || 0,
            type: "text",
            className: this.inputClassNames,
            "aria-label": "SelectDropdown Input",
            autoComplete: "disable",
            autoCorrect: "off",
            autoCapitalize: "on",
            spellCheck: "false",
            onKeyDown: this.onKeyDown,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            onChange: this.onChange,
            placeholder: i,
            value: n
          }), p.a.createElement("div", {
            className: "dropdown-menu".concat(this.showDropdown ? " show" : "", " w-100"),
            role: "listbox",
            id: "listbox-".concat(this.id)
          }, o.map(function (t, r) {
            return p.a.createElement("a", {
              href: "#",
              key: t.key,
              className: "dropdown-item text-truncate".concat(a === r ? " selected" : ""),
              "aria-selected": a === r,
              role: "option",
              title: t.text,
              onMouseDown: e.chooseItem(t),
              onClick: e.preventDefault
            }, t.text);
          })));
        }
      }]) && NBe(r.prototype, n), o && NBe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).defaultProps = {
      options: [],
      onCancel: function () {},
      onBlur: function () {},
      onFocus: function () {}
    }, wBe = IBe((gBe = RBe).prototype, "showDropdown", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), IBe(gBe.prototype, "lowerCaseOptions", [f.computed], Object.getOwnPropertyDescriptor(gBe.prototype, "lowerCaseOptions"), gBe.prototype), IBe(gBe.prototype, "inputClassNames", [f.computed], Object.getOwnPropertyDescriptor(gBe.prototype, "inputClassNames"), gBe.prototype), OBe = IBe(gBe.prototype, "onClickDocument", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.ref.current.contains(t.target) || (e.showDropdown = !1);
        };
      }
    }), jBe = IBe(gBe.prototype, "chooseItem", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return function () {
            var r = e.props.onChange;
            return e.showDropdown = !1, r(t);
          };
        };
      }
    }), PBe = IBe(gBe.prototype, "clearSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          (0, e.props.onChange)();
        };
      }
    }), _Be = IBe(gBe.prototype, "onBlur", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.selectedIndex,
              o = r.onChange,
              i = r.onBlur,
              a = r.options;
          "" !== n && a[n] && o(a[n]), i(t);
        };
      }
    }), EBe = IBe(gBe.prototype, "onChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.onSelect,
              o = r.onSearch,
              i = r.onChange,
              a = r.options;
          if (o(t.target.value), "" === t.target.value) return i();
          var c = e.lowerCaseOptions.findIndex(function (e) {
            return e.startsWith(t.target.value.toLowerCase());
          });
          c >= 0 && a[c] && n(c);
        };
      }
    }), SBe = IBe(gBe.prototype, "onFocus", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onFocus;
          e.showDropdown = !0, r(t);
        };
      }
    }), CBe = IBe(gBe.prototype, "onKeyDown", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.onCancel,
              o = r.onChange,
              i = r.onSelect,
              a = r.selectedIndex,
              c = r.inputText,
              u = r.options;

          if ([38, 40].includes(t.keyCode)) {
            t.preventDefault(), e.showDropdown = !0;
            var l = 0 === a || a ? a : u.findIndex(function (e) {
              return e.text === c;
            });
            return 40 === t.keyCode ? null == l || l < 0 || l === u.length - 1 ? l = 0 : l += 1 : 38 === t.keyCode && (0 === l ? l = u.length - 1 : l -= 1), void i(l);
          }

          if ("Enter" === t.key || "Tab" === t.key) return e.showDropdown = !1, void ("" !== a && u[a] && o(u[a]));
          "Escape" !== t.key ? e.showDropdown = !0 : n();
        };
      }
    }), kBe = IBe(gBe.prototype, "preventDefault", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return function (e) {
          e.preventDefault();
        };
      }
    }), hBe = gBe)) || hBe,
        UBe = ["treeModel", "nodeClasses", "node"];

    function qBe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, KBe(n.key), n);
      }
    }

    function KBe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function GBe(e, t, r) {
      return t = WBe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], WBe(e).constructor) : t.apply(e, r));
    }

    function WBe(e) {
      return (WBe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function HBe(e, t) {
      return (HBe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var JBe,
        YBe,
        QBe = Object(d.observer)((LBe = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((BBe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = GBe(this, t, [].concat(n)), "highlighted", LBe, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && HBe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "componentDidMount",
        value: function () {
          var e = this.props.treeModel;
          this.highlighted = e.checked.slice();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.treeModel,
              r = e.nodeClasses,
              n = e.node,
              o = function (e, t) {
            if (null == e) return {};

            var r,
                n,
                o = function (e, t) {
              if (null == e) return {};
              var r = {};

              for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
                if (t.includes(n)) continue;
                r[n] = e[n];
              }

              return r;
            }(e, t);

            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);

              for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
            }

            return o;
          }(e, UBe);

          return t.isReadOnly(n.id) ? p.a.createElement(hl, Object.assign({
            node: n,
            nodeClasses: r,
            treeModel: t
          }, o)) : p.a.createElement(h.TreeNodeContent, Object.assign({}, o, {
            treeModel: t,
            node: n,
            nodeClasses: (r || []).concat(this.highlighted.includes(n.id) ? "recommended-account" : [])
          }));
        }
      }]) && qBe(r.prototype, n), o && qBe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "highlighted", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), FBe = BBe)) || FBe,
        $Be = ["treeModel", "node"];

    function XBe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, ZBe(n.key), n);
      }
    }

    function ZBe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function eLe(e, t, r) {
      return t = tLe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], tLe(e).constructor) : t.apply(e, r));
    }

    function tLe(e) {
      return (tLe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function rLe(e, t) {
      return (rLe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var nLe,
        oLe,
        iLe,
        aLe = Object(d.observer)((function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && Object.defineProperty(e, t, i);
    }((YBe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), eLe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && rLe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "controls",
        get: function () {
          var e = this.props,
              t = e.treeModel,
              r = e.node;
          return t.accountsStore.isPending(r.id) ? [{
            id: "1",
            component: h.Spinner
          }] : [{
            id: "1",
            component: h.TreeNodeToggle
          }];
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.treeModel,
              r = e.node,
              n = function (e, t) {
            if (null == e) return {};

            var r,
                n,
                o = function (e, t) {
              if (null == e) return {};
              var r = {};

              for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
                if (t.includes(n)) continue;
                r[n] = e[n];
              }

              return r;
            }(e, t);

            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);

              for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
            }

            return o;
          }(e, $Be);

          return t.isReadOnly(r.id) ? p.a.createElement(h.TreeNodeControls, Object.assign({}, n, {
            node: r,
            controls: this.controls,
            treeModel: t
          })) : p.a.createElement(nj, Object.assign({
            treeModel: t,
            node: r
          }, n));
        }
      }]) && XBe(r.prototype, n), o && XBe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "controls", [f.computed], Object.getOwnPropertyDescriptor(YBe.prototype, "controls"), YBe.prototype), JBe = YBe)) || JBe;

    function cLe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, uLe(n.key), n);
      }
    }

    function uLe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function lLe(e, t, r) {
      return t = sLe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], sLe(e).constructor) : t.apply(e, r));
    }

    function sLe(e) {
      return (sLe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function pLe(e, t) {
      return (pLe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function fLe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var dLe,
        bLe = Object(d.observer)((fLe((oLe = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r = lLe(this, t, [e]), "handleToggleChecked", iLe, r), r.handleToggleExpand = function (e) {
          r.treeModel.toggleExpanded(e), r.treeModel.isExpanded(e) && r.accountsStore.updateChildrenOf(e);
        };
        var n = e.accountsPath,
            o = e.rootAccounts,
            i = e.readOnlyAncestors,
            a = e.fieldAccounts,
            c = e.recommendationAccounts;
        r.accountsApi = new N(n), r.accountsStore = new Tt(new N(), new qt());
        var u = [];
        return r.treeModel = new as(r.accountsStore), Promise.all(o.map(function (e) {
          return u.push(r.accountsStore.push(e)), r.accountsStore.loadChildrenOf(e.id);
        })).then(function () {
          return a.forEach(function (e) {
            r.treeModel.expandAncestorsOf(e.id);
          }), c.forEach(function (e) {
            r.treeModel.expandAncestorsOf(e.id), r.treeModel.check(e.id);
          });
        }).catch(console.error), r.treeModel.setRoots(u, (i || []).map(function (e) {
          return r.accountsStore.push(e);
        })), r.treeModel.sortRoots(), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && pLe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && cLe(e.prototype, t), r && cLe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "checkedAccounts",
        get: function () {
          return this.accountsStore.findMany(this.treeModel.checked);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.saveUrl,
              r = e.cancelUrl,
              n = e.authenticityToken,
              o = e.t;
          return p.a.createElement("form", {
            action: t,
            method: "POST"
          }, p.a.createElement("input", {
            type: "hidden",
            name: "authenticity_token",
            value: n
          }), p.a.createElement("h1", null, o("choose_accounts")), p.a.createElement("p", null, o("choose_which_accounts_this_application_record_applies_to"), ":"), p.a.createElement(fl, {
            items: this.treeModel.roots,
            model: this.treeModel,
            ControlsComponent: aLe,
            ContentComponent: QBe,
            actions: {
              handleToggleChecked: this.handleToggleChecked,
              handleToggleExpand: this.handleToggleExpand,
              handleClickNodeContent: this.handleToggleChecked
            }
          }), this.checkedAccounts.map(function (e) {
            return p.a.createElement("input", {
              key: e.id,
              type: "hidden",
              name: "account_ids[]",
              value: e.serial
            });
          }), p.a.createElement("div", {
            className: "text-right"
          }, p.a.createElement("a", {
            className: "btn btn-secondary mr-1",
            href: r
          }, o("cancel")), p.a.createElement("input", {
            type: "submit",
            name: "commit",
            value: o("choose"),
            className: "btn btn-primary",
            "data-disable-with": "Choose"
          })));
        }
      }]);
    }()).prototype, "checkedAccounts", [f.computed], Object.getOwnPropertyDescriptor(oLe.prototype, "checkedAccounts"), oLe.prototype), iLe = fLe(oLe.prototype, "handleToggleChecked", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.treeModel.toggleChecked(t);
        };
      }
    }), nLe = oLe)) || nLe,
        yLe = Object(g.a)()(bLe);

    function mLe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, vLe(n.key), n);
      }
    }

    function vLe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function hLe(e, t, r) {
      return t = gLe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], gLe(e).constructor) : t.apply(e, r));
    }

    function gLe(e) {
      return (gLe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function wLe(e, t) {
      return (wLe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var OLe,
        jLe = Object(d.observer)(dLe = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = hLe(this, t, [e])).registerMapRerenderer = function (e, t) {
          var n = r.getRenderers(),
              o = n.find(function (t) {
            return t.id === e;
          });
          o ? o.render = t : n.push({
            id: e,
            render: t
          });
        }, r.unregisterMapRerenderer = function (e) {
          var t = r.getRenderers(),
              n = t.findIndex(function (t) {
            return t.id === e;
          });
          n < 0 || t.splice(n, 1);
        };
        var n = r.props.fields;
        if (!n) throw new Error("WithMap requires fields");
        return r.fields = n.map(function (e) {
          return new l.Field(e);
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && wLe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "getRenderers",
        value: function () {
          return Array.isArray(window.mapRenderers) || (window.mapRenderers = []), window.mapRenderers;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.children,
              r = e.address,
              n = e.id;
          return p.a.createElement("div", {
            className: "row with-map if2-fields"
          }, p.a.createElement("div", {
            className: "col-children"
          }, t), p.a.createElement("div", {
            className: "col-map"
          }, p.a.createElement("div", {
            className: "map screen-map"
          }, p.a.createElement(l.FieldMapViewer, {
            id: "spray-record-map-".concat(n),
            fields: this.fields,
            address: r,
            showLabels: !0
          }))), p.a.createElement("div", {
            className: "col-map print"
          }, p.a.createElement("div", {
            className: "map screen-map print"
          }, p.a.createElement(l.FieldMapViewer, {
            id: "spray-record-map-".concat(n, "-print"),
            fields: this.fields,
            address: r,
            showLabels: !0,
            onRegisterMapRerenderer: this.registerMapRerenderer,
            onUnregisterMapRerenderer: this.unregisterMapRerenderer
          }))));
        }
      }]) && mLe(r.prototype, n), o && mLe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || dLe;

    function PLe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _Le(n.key), n);
      }
    }

    function _Le(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ELe(e, t, r) {
      return t = SLe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], SLe(e).constructor) : t.apply(e, r));
    }

    function SLe(e) {
      return (SLe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function CLe(e, t) {
      return (CLe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var kLe,
        RLe = Object(d.observer)(OLe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), ELe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && CLe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && PLe(e.prototype, t), r && PLe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "countyName",
        value: function (e) {
          return e ? e.match(/county/i) ? e : "".concat(e, " County") : null;
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.fields,
              n = t.fieldCompletionPercents,
              o = t.showEditControls,
              i = t.sprayRecordFieldPath,
              a = t.addFieldPath,
              c = t.t;
          return p.a.createElement("tbody", null, r.slice().sort(h.sortByName).map(function (t) {
            var r;
            return p.a.createElement("tr", {
              key: t.id
            }, p.a.createElement("td", null, t.clientPathFieldName, p.a.createElement("div", {
              className: "d-flex flex-row"
            }, p.a.createElement("div", {
              className: "gps px-1"
            }, t.gps), p.a.createElement("div", {
              className: "county px-1"
            }, e.countyName(t.county)))), p.a.createElement("td", null, p.a.createElement($E, {
              percent: n[t.id] || 0,
              useIconWhenComplete: !0
            })), p.a.createElement("td", null, t.cropName), p.a.createElement("td", null, t.organic ? p.a.createElement("div", {
              className: "organic"
            }) : null), p.a.createElement("td", null, t.varietyNames), p.a.createElement("td", null, (null === (r = t.area) || void 0 === r ? void 0 : r.displayValue) || ""), o ? p.a.createElement("td", {
              className: "actions"
            }, p.a.createElement("a", {
              href: i(t.id),
              className: "text-danger",
              "data-method": "delete",
              "data-confirm": c("confirm_remove_field"),
              rel: "nofollow"
            }, p.a.createElement("i", {
              className: "fas fa-trash-alt"
            }))) : null);
          }), o ? p.a.createElement("tr", null, p.a.createElement("td", {
            colSpan: "7",
            className: "actions"
          }, p.a.createElement("a", {
            href: a,
            "data-testid": "add-fields",
            className: "add-new"
          }, p.a.createElement("span", {
            className: "add-new-text"
          }, c("add_new")), p.a.createElement("i", {
            className: "fas fa-plus-circle"
          })))) : null);
        }
      }]);
    }()) || OLe,
        TLe = Object(g.a)()(RLe);

    function zLe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, NLe(n.key), n);
      }
    }

    function NLe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function DLe(e, t, r) {
      return t = xLe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], xLe(e).constructor) : t.apply(e, r));
    }

    function xLe(e) {
      return (xLe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ALe(e, t) {
      return (ALe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var MLe,
        ILe,
        FLe = Object(d.observer)(kLe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), DLe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ALe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && zLe(e.prototype, t), r && zLe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.showEditControls,
              r = e.addFieldPath,
              n = e.fields,
              o = e.t;
          return 0 === n.length ? p.a.createElement(p.a.Fragment, null, p.a.createElement("p", {
            className: "unspecified"
          }, o("no_fields_have_been_added")), t ? p.a.createElement("p", null, p.a.createElement("a", {
            href: r,
            className: "icon icon-add"
          }, o("add_fields"))) : "") : p.a.createElement("table", {
            className: "table table-striped table-sm"
          }, p.a.createElement("thead", {
            className: "thead-light"
          }, p.a.createElement("tr", null, p.a.createElement("th", {
            scope: "col",
            colSpan: "2"
          }, o("field")), p.a.createElement("th", {
            scope: "col"
          }, o("crop")), p.a.createElement("th", {
            scope: "col",
            "aria-label": "Organic Indicator"
          }), p.a.createElement("th", {
            scope: "col"
          }, o("variety")), p.a.createElement("th", {
            scope: "col"
          }, o("acres")), p.a.createElement("th", {
            scope: "col",
            "aria-label": "Actions"
          }))), p.a.createElement(TLe, this.props));
        }
      }]);
    }()) || kLe,
        BLe = Object(g.a)()(FLe);

    function LLe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, VLe(n.key), n);
      }
    }

    function VLe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function ULe(e, t, r) {
      return t = qLe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], qLe(e).constructor) : t.apply(e, r));
    }

    function qLe(e) {
      return (qLe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function KLe(e, t) {
      return (KLe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function GLe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var WLe,
        HLe,
        JLe,
        YLe,
        QLe,
        $Le,
        XLe = Object(d.observer)((GLe((ILe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = ULe(this, t, [].concat(n))).sprayRecordFieldPath = function (t) {
          return "/if2/spray_records/".concat(e.sprayRecord.serial, "/field/").concat(t);
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && KLe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "sprayRecord",
        get: function () {
          return this.props.sprayRecord;
        }
      }, {
        key: "fieldCompletionPercents",
        get: function () {
          return this.sprayRecord.fieldCompletionPercents;
        }
      }, {
        key: "fields",
        get: function () {
          return this.sprayRecord.fields;
        }
      }, {
        key: "addFieldPath",
        get: function () {
          return this.props.addFieldPath || "/if2/spray_records/".concat(this.sprayRecord.serial, "/fields");
        }
      }, {
        key: "componentDidMount",
        value: function () {
          if (this.props.testThrowError) throw new Error("Test fallback UI");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.accountAddress,
              r = e.showEditControls;
          return this.sprayRecord.showFieldMap ? p.a.createElement(jLe, {
            fields: this.fields,
            address: t,
            id: this.sprayRecord.serial
          }, p.a.createElement(BLe, {
            fields: this.fields,
            fieldCompletionPercents: this.fieldCompletionPercents,
            showEditControls: r,
            sprayRecordFieldPath: this.sprayRecordFieldPath,
            addFieldPath: this.addFieldPath
          })) : p.a.createElement(BLe, {
            fields: this.fields,
            fieldCompletionPercents: this.fieldCompletionPercents,
            showEditControls: r,
            sprayRecordFieldPath: this.sprayRecordFieldPath,
            addFieldPath: this.addFieldPath
          });
        }
      }]) && LLe(r.prototype, n), o && LLe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "sprayRecord", [f.computed], Object.getOwnPropertyDescriptor(ILe.prototype, "sprayRecord"), ILe.prototype), GLe(ILe.prototype, "fieldCompletionPercents", [f.computed], Object.getOwnPropertyDescriptor(ILe.prototype, "fieldCompletionPercents"), ILe.prototype), GLe(ILe.prototype, "fields", [f.computed], Object.getOwnPropertyDescriptor(ILe.prototype, "fields"), ILe.prototype), GLe(ILe.prototype, "addFieldPath", [f.computed], Object.getOwnPropertyDescriptor(ILe.prototype, "addFieldPath"), ILe.prototype), MLe = ILe)) || MLe;

    function ZLe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function eVe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, tVe(n.key), n);
      }
    }

    function tVe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function rVe(e, t, r) {
      return t = nVe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], nVe(e).constructor) : t.apply(e, r));
    }

    function nVe(e) {
      return (nVe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function oVe(e, t) {
      return (oVe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function iVe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var aVe = Object(d.observer)((JLe = iVe((HLe = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = rVe(this, t, [e])).sprayRecordsStore = void 0, ZLe(r, "isOpen", JLe, r), ZLe(r, "updateShowFieldMap", YLe, r), ZLe(r, "close", QLe, r), ZLe(r, "open", $Le, r), r.sprayRecordsStore = window.sprayRecordsStore, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && oVe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && eVe(e.prototype, t), r && eVe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "sprayRecordId",
        get: function () {
          return this.props.sprayRecordId;
        }
      }, {
        key: "sprayRecord",
        get: function () {
          return this.sprayRecordsStore.find(this.sprayRecordId);
        }
      }, {
        key: "fields",
        get: function () {
          return this.sprayRecord && this.sprayRecord.fields || [];
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return p.a.createElement(h.Card, {
            shouldNotPrint: this.fields.length <= 0
          }, p.a.createElement(h.CardHeader, {
            isOpen: this.isOpen,
            title: e("fields").toUpperCase(),
            onOpen: this.open,
            onClose: this.close,
            hasToggle: !0
          }, p.a.createElement("div", {
            className: "float-right"
          }, p.a.createElement("div", {
            className: "form-check"
          }, p.a.createElement(oj.a, {
            className: "form-check-input",
            isChecked: this.sprayRecord.showFieldMap,
            onChange: this.updateShowFieldMap
          }), p.a.createElement("label", {
            className: "form-check-label"
          }, e("show_field_map"))))), p.a.createElement(h.CardBody, {
            isOpen: this.isOpen
          }, p.a.createElement(mf, {
            componentProps: this.props,
            renderError: function () {
              return p.a.createElement(Lp, {
                errorMessage: e("error_displaying_fields")
              });
            }
          }, p.a.createElement(XLe, Object.assign({
            sprayRecord: this.sprayRecord
          }, this.props)))));
        }
      }]);
    }()).prototype, "isOpen", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !0;
      }
    }), iVe(HLe.prototype, "sprayRecordId", [f.computed], Object.getOwnPropertyDescriptor(HLe.prototype, "sprayRecordId"), HLe.prototype), iVe(HLe.prototype, "sprayRecord", [f.computed], Object.getOwnPropertyDescriptor(HLe.prototype, "sprayRecord"), HLe.prototype), iVe(HLe.prototype, "fields", [f.computed], Object.getOwnPropertyDescriptor(HLe.prototype, "fields"), HLe.prototype), YLe = iVe(HLe.prototype, "updateShowFieldMap", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.sprayRecord.showFieldMap = t, e.sprayRecordsStore.update(e.sprayRecordId, {
            show_field_map: t
          });
        };
      }
    }), QLe = iVe(HLe.prototype, "close", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isOpen = !1;
        };
      }
    }), $Le = iVe(HLe.prototype, "open", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isOpen = !0;
        };
      }
    }), WLe = HLe)) || WLe,
        cVe = Object(g.a)()(aVe);

    function uVe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, lVe(n.key), n);
      }
    }

    function lVe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function sVe(e, t, r) {
      return t = pVe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], pVe(e).constructor) : t.apply(e, r));
    }

    function pVe(e) {
      return (pVe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function fVe(e, t) {
      return (fVe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var dVe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), sVe(this, t, [{
          defaultKey: "clientPathString",
          attributes: [new le({
            name: "ID",
            key: "id"
          }), new le({
            name: "Serial",
            key: "serial"
          }), new le({
            name: "Name",
            key: "name"
          }), new he({
            name: "Client Path",
            key: "clientPath",
            elementSpec: new et()
          }), new le({
            name: "Client Path String",
            key: "clientPathString",
            isReadonly: !0,
            shouldNotSerialize: !0
          }), new le({
            name: "Full Name",
            key: "fullName"
          })]
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && fVe(e, t);
      }(t, Ne), r = t, n && uVe(r.prototype, n), o && uVe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function bVe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, yVe(n.key), n);
      }
    }

    function yVe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function mVe(e, t, r) {
      return t = vVe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], vVe(e).constructor) : t.apply(e, r));
    }

    function vVe(e) {
      return (vVe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function hVe(e, t) {
      return (hVe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var gVe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), mVe(this, t, [{
          defaultKey: "name",
          attributes: [new le({
            name: "Name",
            key: "name"
          }), new le({
            name: "Percent",
            key: "percent"
          })]
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && hVe(e, t);
      }(t, Ne), r = t, n && bVe(r.prototype, n), o && bVe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function wVe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, OVe(n.key), n);
      }
    }

    function OVe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function jVe(e, t, r) {
      return t = PVe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], PVe(e).constructor) : t.apply(e, r));
    }

    function PVe(e) {
      return (PVe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function _Ve(e, t) {
      return (_Ve = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var EVe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), jVe(this, t, [{
          defaultKey: "name",
          attributes: [new le({
            name: "Name",
            key: "name"
          }), new le({
            name: "Variety",
            key: "variety"
          })]
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && _Ve(e, t);
      }(t, Ne), r = t, n && wVe(r.prototype, n), o && wVe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function SVe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, CVe(n.key), n);
      }
    }

    function CVe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function kVe(e, t, r) {
      return t = RVe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], RVe(e).constructor) : t.apply(e, r));
    }

    function RVe(e) {
      return (RVe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function TVe(e, t) {
      return (TVe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var zVe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), kVe(this, t, [{
          defaultKey: "name",
          attributes: [new le({
            name: "Name",
            key: "name"
          }), new le({
            name: "Percent",
            key: "percent"
          })]
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && TVe(e, t);
      }(t, Ne), r = t, n && SVe(r.prototype, n), o && SVe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function NVe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, DVe(n.key), n);
      }
    }

    function DVe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function xVe(e, t, r) {
      return t = AVe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], AVe(e).constructor) : t.apply(e, r));
    }

    function AVe(e) {
      return (AVe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function MVe(e, t) {
      return (MVe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var IVe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), xVe(this, t, [{
          defaultKey: "value",
          attributes: [new le({
            name: "Value",
            key: "value"
          })]
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && MVe(e, t);
      }(t, Ne), r = t, n && NVe(r.prototype, n), o && NVe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function FVe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, BVe(n.key), n);
      }
    }

    function BVe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function LVe(e, t, r) {
      return t = VVe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], VVe(e).constructor) : t.apply(e, r));
    }

    function VVe(e) {
      return (VVe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function UVe(e, t) {
      return (UVe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var qVe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), LVe(this, t, [{
          defaultKey: "name",
          attributes: [new le({
            name: "ID",
            key: "id"
          }), new le({
            name: "Name",
            key: "name"
          }), new he({
            name: "Variety",
            key: "varieties",
            elementSpec: new gVe()
          }), new he({
            name: "Cultivar",
            key: "cultivars",
            elementSpec: new EVe()
          }), new he({
            name: "Rootstock",
            key: "rootStocks",
            elementSpec: new zVe()
          }), new he({
            name: "Use Type",
            key: "useTypes",
            elementSpec: new IVe()
          })]
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && UVe(e, t);
      }(t, Ne), r = t, n && FVe(r.prototype, n), o && FVe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }(),
        KVe = ["attributeSpecType", "ModelSpecClass", "ElementSpecClass"];

    function GVe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function WVe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? GVe(Object(r), !0).forEach(function (t) {
          HVe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : GVe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function HVe(e, t, r) {
      return (t = function (e) {
        var t = function (e, t) {
          if ("object" != typeof e || !e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(e, "string");

        return "symbol" == typeof t ? t : t + "";
      }(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    var JVe = function (e) {
      return Object.keys(e).map(function (t) {
        var r = e[t],
            n = r.attributeSpecType,
            o = r.ModelSpecClass,
            i = r.ElementSpecClass,
            a = function (e, t) {
          if (null == e) return {};

          var r,
              n,
              o = function (e, t) {
            if (null == e) return {};
            var r = {};

            for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
              if (t.includes(n)) continue;
              r[n] = e[n];
            }

            return r;
          }(e, t);

          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);

            for (n = 0; n < i.length; n++) r = i[n], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
          }

          return o;
        }(r, KVe);

        if ("CollectionAttributeSpec" === n) {
          var c = new i();
          return new he(WVe(WVe({}, a), {}, {
            key: t,
            elementSpec: c
          }));
        }

        if ("ModelAttributeSpec" === n) {
          var u = new o();
          return new Ce(WVe(WVe({}, a), {}, {
            key: t,
            modelSpec: u
          }));
        }

        return new le(WVe(WVe({}, a), {}, {
          key: t
        }));
      });
    };

    function YVe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, QVe(n.key), n);
      }
    }

    function QVe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function $Ve(e, t, r) {
      return t = XVe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], XVe(e).constructor) : t.apply(e, r));
    }

    function XVe(e) {
      return (XVe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function ZVe(e, t) {
      return (ZVe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var eUe,
        tUe,
        rUe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), $Ve(this, t, [{
          defaultKey: "name",
          attributes: JVe(t.attributeDefinition)
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && ZVe(e, t);
      }(t, Ne), r = t, n && YVe(r.prototype, n), o && YVe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function nUe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function oUe(e, t, r) {
      return (t = aUe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function iUe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, aUe(n.key), n);
      }
    }

    function aUe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function cUe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    rUe.attributeDefinition = {
      id: {
        name: "ID"
      },
      serial: {
        name: "Serial",
        type: "number"
      },
      name: {
        name: "Name"
      },
      createdAt: {
        name: "Created At"
      },
      updatedAt: {
        name: "Updated At"
      },
      type: {
        name: "Type",
        defaultValue: "IF2::Field"
      },
      account: {
        name: "Account",
        attributeSpecType: "ModelAttributeSpec",
        ModelSpecClass: dVe
      },
      accountingReference: {
        name: "Accounting Reference"
      },
      crop: {
        name: "Crop",
        attributeSpecType: "ModelAttributeSpec",
        ModelSpecClass: qVe
      },
      county: {
        name: "County"
      },
      yearPlanted: {
        name: "Year Planted"
      },
      area: {
        name: "Area"
      },
      rowSpacing: {
        name: "Row Spacing"
      },
      notes: {
        name: "Notes"
      },
      longitude: {
        name: "Longitude"
      },
      latitude: {
        name: "Latitude"
      },
      nonBearing: {
        name: "Non Bearing",
        type: "boolean"
      },
      geoJson: {
        name: "Geo JSON"
      },
      organic: {
        name: "Organic"
      },
      organicDate: {
        name: "Organic Date"
      },
      acres: {
        name: "Acres",
        type: "number",
        isReadonly: !0,
        shouldNotSerialize: !0
      }
    };

    var uUe,
        lUe,
        sUe,
        pUe,
        fUe,
        dUe,
        bUe,
        yUe,
        mUe,
        vUe,
        hUe,
        gUe = function (e) {
      return {
        get: function (t, r, n) {
          if (Object.getOwnPropertyNames(Array.prototype).concat(Object.getOwnPropertyNames(e)).includes(r)) {
            var o = Reflect.get(e, r, n);
            return "function" == typeof o ? o.bind(e) : o;
          }

          return Reflect.get(t, r, n);
        }
      };
    },
        wUe = (tUe = cUe((eUe = function () {
      return e = function e(t, r) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(this, "items", tUe, this);

        var n = function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? nUe(Object(r), !0).forEach(function (t) {
              oUe(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : nUe(Object(r)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
          }

          return e;
        }({
          items: [],
          key: "id"
        }, r),
            o = n.items,
            i = n.key;

        return this.ItemClass = t, this.key = i, this.items = o.map(function (e) {
          return new t(e);
        }), new Proxy(this, gUe(this.items));
      }, (t = [{
        key: "serialize",
        value: function () {
          return this.items.map(function (e) {
            return "function" == typeof e.serialize ? e.serialize() : e;
          });
        }
      }, {
        key: "update",
        value: function (e) {
          var t = this,
              r = this.items.findIndex(function (r) {
            return r[t.key] === e[t.key];
          });

          if (r < 0) {
            var n = new this.ItemClass(e);
            return this.items.push(n), n;
          }

          return this.items[r].update(e), this.items[r];
        }
      }, {
        key: "updateMany",
        value: function (e) {
          var t = this;
          return e.map(function (e) {
            return t.update(e);
          });
        }
      }, {
        key: "updateItems",
        value: function (e) {
          var t = this;
          return this.items = e.map(function (e) {
            return t.update(e);
          }), this.items;
        }
      }]) && iUe(e.prototype, t), r && iUe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "items", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), cUe(eUe.prototype, "update", [f.action], Object.getOwnPropertyDescriptor(eUe.prototype, "update"), eUe.prototype), cUe(eUe.prototype, "updateMany", [f.action], Object.getOwnPropertyDescriptor(eUe.prototype, "updateMany"), eUe.prototype), cUe(eUe.prototype, "updateItems", [f.action], Object.getOwnPropertyDescriptor(eUe.prototype, "updateItems"), eUe.prototype), eUe),
        OUe = X("StringPrimitive", {
      base: Be,
      mixins: [{
        spec: {
          value: new IVe(),
          isStatic: !0
        },
        update: {
          value: function (e) {
            return this[this.constructor.spec.defaultKey] = e, this;
          }
        },
        serialize: {
          value: function () {
            return this[this.constructor.spec.defaultKey];
          }
        }
      }],
      superArgs: function () {
        return [];
      }
    }, function (e) {
      e ? this.update(e) : this.update("");
    }),
        jUe = X("FieldCropVariety", {
      base: Be,
      mixins: [{
        spec: {
          value: new gVe(),
          isStatic: !0
        }
      }]
    }),
        PUe = X("FieldCropCultivar", {
      base: Be,
      mixins: [{
        spec: {
          value: new EVe(),
          isStatic: !0
        }
      }]
    }),
        _Ue = X("FieldCropRootStock", {
      base: Be,
      mixins: [{
        spec: {
          value: new zVe(),
          isStatic: !0
        }
      }]
    }),
        EUe = X("FieldCropReference", {
      base: Be,
      mixins: [tt, {
        spec: {
          value: new qVe(),
          isStatic: !0
        },
        updateAttribute: {
          value: function (e, t) {
            switch (e) {
              case "useTypes":
                return this.updateCollectionAttribute(wUe, OUe, e, t, "value");

              case "varieties":
                return this.updateCollectionAttribute(wUe, jUe, e, t, "name");

              case "cultivars":
                return this.updateCollectionAttribute(wUe, PUe, e, t, "name");

              case "rootStocks":
                return this.updateCollectionAttribute(wUe, _Ue, e, t, "name");

              default:
                return Be.prototype.updateAttribute.call(this, e, t);
            }
          }
        }
      }]
    }),
        SUe = {
      clientPathString: {
        get: function () {
          for (var e = this.clientPath.items.concat(this), t = [], r = e.length; r > 0; r -= 1) {
            var n = e.pop();

            if (n.fullName) {
              t.unshift(n.fullName);
              break;
            }

            t.unshift(n.name);
          }

          return t.join(": ");
        },
        configurable: !0,
        decorate: f.computed
      }
    },
        CUe = X("AccountWithPath", {
      base: Be,
      mixins: [tt, SUe, {
        spec: {
          value: new dVe(),
          isStatic: !0
        },
        updateAttribute: {
          value: function (e, t) {
            return "clientPath" === e ? this.updateCollectionAttribute(wUe, nt, e, t) : Be.prototype.updateAttribute.call(this, e, t);
          }
        }
      }]
    }),
        kUe = X("Field", {
      base: Be,
      mixins: [tt, {
        spec: {
          value: new rUe(),
          isStatic: !0
        },
        isChecked: {
          value: !1,
          configurable: !0,
          decorate: f.observable
        },
        isSelected: {
          value: !1,
          configurable: !0,
          decorate: f.observable
        },
        gps: {
          get: function () {
            if (!this.latitude && !this.longitude) return "";
            var e = parseFloat(this.latitude).toFixed(4),
                t = parseFloat(this.longitude).toFixed(4);
            return "".concat(e, ",").concat(t);
          },
          configurable: !0,
          decorate: f.computed
        },
        cropName: {
          get: function () {
            return this.crop.name || "";
          },
          configurable: !0,
          decorate: f.computed
        },
        varieties: {
          get: function () {
            return this.crop.varieties.items;
          },
          configurable: !0,
          decorate: f.computed
        },
        varietyNames: {
          get: function () {
            return this.varieties.slice().sort(function (e, t) {
              return e.percent === t.percent ? Object(h.sortByName)(e, t) : parseFloat(t.percent) - parseFloat(e.percent);
            }).map(function (e) {
              return e.name;
            }).join(", ");
          },
          configurable: !0,
          decorate: f.computed
        },
        acreage: {
          get: function () {
            return F()(this.area).to("acres").toString();
          },
          configurable: !0,
          decorate: f.computed
        },
        acres: {
          get: function () {
            var e = 0;
            if (!this.area) return e;

            try {
              e = F()(this.area);
            } catch (t) {
              if (t instanceof F.a.Error) return e;
              throw t;
            }

            return e.to("acre").scalar;
          },
          configurable: !0,
          decorate: f.computed
        },
        clientPathFieldName: {
          get: function () {
            return [].concat(this.account.clientPathString || []).concat(this.name).join(": ");
          },
          configurable: !0,
          decorate: f.computed
        },
        fullText: {
          get: function () {
            return [this.clientPathFieldName, this.cropName, this.organic ? "organic" : "", this.varieties.filter(function (e) {
              return !!e;
            }).map(function (e) {
              return e.name;
            }).join(" ")].filter(function (e) {
              return !!e;
            }).join(" ");
          },
          configurable: !0,
          decorate: f.computed
        },
        fullTextLowercase: {
          get: function () {
            return this.fullText.toLowerCase();
          },
          configurable: !0,
          decorate: f.computed
        },
        toggleSelected: {
          value: function () {
            this.isSelected = !this.isSelected;
          },
          configurable: !0,
          decorate: f.action
        },
        select: {
          value: function () {
            return this.isSelected = !0, this;
          },
          configurable: !0,
          decorate: f.action
        },
        deselect: {
          value: function () {
            return this.isSelected = !1, this;
          },
          configurable: !0,
          decorate: f.action
        },
        toggleChecked: {
          value: function () {
            this.isChecked = !this.isChecked;
          },
          configurable: !0,
          decorate: f.action
        },
        check: {
          value: function () {
            return this.isChecked = !0, this;
          },
          configurable: !0,
          decorate: f.action
        },
        uncheck: {
          value: function () {
            return this.isChecked = !1, this;
          },
          configurable: !0,
          decorate: f.action
        },
        updateAttribute: {
          value: function (e, t) {
            if ("acres" !== e) return "crop" === e ? this.updateModelAttribute(EUe, e, t) : "account" === e ? this.updateModelAttribute(CUe, e, t) : Be.prototype.updateAttribute.call(this, e, t);
          }
        }
      }]
    });

    function RUe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function TUe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zUe(n.key), n);
      }
    }

    function zUe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function NUe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var DUe,
        xUe,
        AUe,
        MUe,
        IUe = (lUe = NUe((uUe = function () {
      return e = function e(t) {
        var r = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.api = void 0, RUe(this, "status", lUe, this), RUe(this, "fields", sUe, this), RUe(this, "searchTerm", pUe, this), RUe(this, "cropFilter", fUe, this), RUe(this, "varietyFilter", dUe, this), RUe(this, "organicFilter", bUe, this), this.checkedFieldsUpdater = Object(f.autorun)(function () {
          r.fields.forEach(function (e) {
            return e.uncheck();
          }), r.filteredFields.forEach(function (e) {
            return e.check();
          });
        }), RUe(this, "filterFields", yUe, this), RUe(this, "filterCrop", mUe, this), RUe(this, "filterVariety", vUe, this), RUe(this, "filterOrganic", hUe, this), this.api = t;
      }, (t = [{
        key: "apiPath",
        get: function () {
          return this.api.apiPath;
        }
      }, {
        key: "filteredFields",
        get: function () {
          var e = this,
              t = this.fields.concat();
          return "organic" === this.organicFilter ? t = t.filter(function (e) {
            return e.organic;
          }) : "conventional" === this.organicFilter && (t = t.filter(function (e) {
            return !e.organic;
          })), this.cropFilter && this.cropFilter.length && (t = t.filter(function (t) {
            return e.cropFilter.includes(t.cropName);
          })), this.varietyFilter && (t = t.filter(function (t) {
            return t.varieties.find(function (t) {
              return t.name === e.varietyFilter;
            });
          })), this.searchTerm && (t = t.filter(function (t) {
            return t.fullTextLowercase.includes(e.searchTerm);
          })), t.sort(h.sortByName);
        }
      }, {
        key: "checkedOrSelectedFields",
        get: function () {
          return this.fields.filter(function (e) {
            return e.isSelected || e.isChecked;
          });
        }
      }, {
        key: "isPending",
        get: function () {
          return "pending" === this.status;
        }
      }, {
        key: "crops",
        get: function () {
          return ee(this.fields.map(function (e) {
            return e.cropName;
          }));
        }
      }, {
        key: "varieties",
        get: function () {
          return ee((e = this.fields.map(function (e) {
            return e.varieties.map(function (e) {
              return e.name;
            });
          }), (t = []).concat.apply(t, L(e))));
          var e, t;
        }
      }, {
        key: "find",
        value: function (e) {
          return this.fields.find(function (t) {
            return t.id === e;
          });
        }
      }, {
        key: "fetchAll",
        value: function () {
          var e = this;
          return this.status = "pending", this.api.findAll().then(function (t) {
            return Object(f.runInAction)(function () {
              return e.status = "ready", t.map(function (t) {
                return e.push(t);
              });
            });
          }).catch(function (t) {
            return Object(f.runInAction)(function () {
              return console.error(t), e.status = "ready", [];
            });
          });
        }
      }, {
        key: "push",
        value: function (e) {
          var t = this.find(e.id);
          return t ? t.update(e) : (t = new kUe(e), this.fields.push(t)), t;
        }
      }]) && TUe(e.prototype, t), r && TUe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "status", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "ready";
      }
    }), sUe = NUe(uUe.prototype, "fields", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), pUe = NUe(uUe.prototype, "searchTerm", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), fUe = NUe(uUe.prototype, "cropFilter", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), dUe = NUe(uUe.prototype, "varietyFilter", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), bUe = NUe(uUe.prototype, "organicFilter", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "both";
      }
    }), NUe(uUe.prototype, "apiPath", [f.computed], Object.getOwnPropertyDescriptor(uUe.prototype, "apiPath"), uUe.prototype), NUe(uUe.prototype, "filteredFields", [f.computed], Object.getOwnPropertyDescriptor(uUe.prototype, "filteredFields"), uUe.prototype), NUe(uUe.prototype, "checkedOrSelectedFields", [f.computed], Object.getOwnPropertyDescriptor(uUe.prototype, "checkedOrSelectedFields"), uUe.prototype), NUe(uUe.prototype, "isPending", [f.computed], Object.getOwnPropertyDescriptor(uUe.prototype, "isPending"), uUe.prototype), NUe(uUe.prototype, "crops", [f.computed], Object.getOwnPropertyDescriptor(uUe.prototype, "crops"), uUe.prototype), NUe(uUe.prototype, "varieties", [f.computed], Object.getOwnPropertyDescriptor(uUe.prototype, "varieties"), uUe.prototype), yUe = NUe(uUe.prototype, "filterFields", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.searchTerm = t.toLowerCase();
        };
      }
    }), mUe = NUe(uUe.prototype, "filterCrop", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.cropFilter = t;
        };
      }
    }), vUe = NUe(uUe.prototype, "filterVariety", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.varietyFilter = t;
        };
      }
    }), hUe = NUe(uUe.prototype, "filterOrganic", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.organicFilter = t;
        };
      }
    }), NUe(uUe.prototype, "fetchAll", [f.action], Object.getOwnPropertyDescriptor(uUe.prototype, "fetchAll"), uUe.prototype), NUe(uUe.prototype, "push", [f.action], Object.getOwnPropertyDescriptor(uUe.prototype, "push"), uUe.prototype), uUe);

    function FUe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function BUe(e, t, r) {
      return (t = UUe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function LUe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function VUe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, UUe(n.key), n);
      }
    }

    function UUe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function qUe(e, t, r) {
      return t = KUe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], KUe(e).constructor) : t.apply(e, r));
    }

    function KUe(e) {
      return (KUe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function GUe(e, t) {
      return (GUe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function WUe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var HUe,
        JUe = Object(d.observer)((AUe = WUe((xUe = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = qUe(this, t, [e])).fieldsStore = void 0, LUe(r, "isSubmitPending", AUe, r), LUe(r, "onSubmit", MUe, r), r.fieldsStore = e.fieldsStore || new IUe(new l.FieldsApi({
          accountId: e.accountSerial
        })), e.selectedCrops && e.selectedCrops.length && r.fieldsStore.filterCrop(e.selectedCrops.map(function (e) {
          return e.name;
        })), r.fieldsStore.filterOrganic(e.isOrganic ? "organic" : "both"), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && GUe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && VUe(e.prototype, t), r && VUe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "shouldConfirmOrganicStatus",
        get: function () {
          return this.props.isOrganic && this.fieldsStore.checkedOrSelectedFields.some(function (e) {
            return !e.organic;
          });
        }
      }, {
        key: "selectedCropNames",
        get: function () {
          return this.props.selectedCrops.map(function (e) {
            return e.name;
          });
        }
      }, {
        key: "unlistedCrops",
        get: function () {
          var e = this;
          return ee(this.fieldsStore.checkedOrSelectedFields.filter(function (t) {
            return !e.selectedCropNames.includes(t.cropName);
          }).map(function (e) {
            return e.cropName;
          }));
        }
      }, {
        key: "shouldConfirmCrops",
        get: function () {
          return !!this.unlistedCrops.length;
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e = this,
              t = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {};
              t % 2 ? FUe(Object(r), !0).forEach(function (t) {
                BUe(e, t, r[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : FUe(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
            }

            return e;
          }({
            fields: []
          }, this.props).fields;

          this.fieldsStore.fetchAll().then(function () {
            return e.fieldsStore.fields.filter(function (e) {
              return t.find(function (t) {
                return t.id === e.id;
              });
            }).forEach(function (e) {
              e.select(), e.check();
            });
          }).catch(console.log);
        }
      }, {
        key: "confirmCrops",
        value: function () {
          var e = this.props.t,
              t = this.unlistedCrops.length > 1 ? e("confirm_continue_will_add_crop_plural") : e("confirm_continue_will_add_crop_singular");
          return window.confirm("".concat(ne(this.unlistedCrops), " ").concat(t));
        }
      }, {
        key: "confirmOrganicStatus",
        value: function () {
          var e = this.props.t;
          return window.confirm(e("confirm_continue_conventional_added_to_organic"));
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.formFieldName,
              r = e.accountId,
              n = e.sprayRecordUrl,
              o = e.submitUrl,
              i = e.authenticityToken;
          return p.a.createElement("div", {
            "aria-label": "Spray Record Fields Editor",
            className: "spray-record-fields-editor"
          }, p.a.createElement("form", {
            action: o,
            acceptCharset: "UTF-8",
            method: "post",
            onSubmit: this.onSubmit
          }, p.a.createElement("input", {
            type: "hidden",
            name: "_method",
            value: "patch"
          }), p.a.createElement("input", {
            type: "hidden",
            name: "authenticity_token",
            value: i
          }), p.a.createElement(FR, {
            accountId: r,
            crops: this.fieldsStore.crops,
            varieties: this.fieldsStore.varieties,
            cropFilter: this.fieldsStore.cropFilter,
            organicFilter: this.fieldsStore.organicFilter,
            varietyFilter: this.fieldsStore.varietyFilter,
            filterFields: this.fieldsStore.filterFields,
            filteredFields: this.fieldsStore.filteredFields,
            isPending: this.fieldsStore.isPending,
            onFilterCrop: this.fieldsStore.filterCrop,
            onFilterVariety: this.fieldsStore.filterVariety,
            onFilterOrganic: this.fieldsStore.filterOrganic
          }), 0 === this.fieldsStore.checkedOrSelectedFields.length ? p.a.createElement("input", {
            type: "hidden",
            name: t,
            value: ""
          }) : "", this.fieldsStore.checkedOrSelectedFields.map(function (e) {
            return p.a.createElement("input", {
              key: e.id,
              type: "hidden",
              name: "".concat(t),
              value: e.id
            });
          }), p.a.createElement("div", {
            className: "text-right"
          }, p.a.createElement("a", {
            className: "btn btn-secondary",
            href: n
          }, "Cancel"), " ", p.a.createElement("input", {
            type: "submit",
            name: "commit",
            value: "Save",
            className: "btn btn-primary",
            disabled: this.isSubmitPending
          }))));
        }
      }]);
    }()).prototype, "isSubmitPending", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), WUe(xUe.prototype, "shouldConfirmOrganicStatus", [f.computed], Object.getOwnPropertyDescriptor(xUe.prototype, "shouldConfirmOrganicStatus"), xUe.prototype), WUe(xUe.prototype, "selectedCropNames", [f.computed], Object.getOwnPropertyDescriptor(xUe.prototype, "selectedCropNames"), xUe.prototype), WUe(xUe.prototype, "unlistedCrops", [f.computed], Object.getOwnPropertyDescriptor(xUe.prototype, "unlistedCrops"), xUe.prototype), WUe(xUe.prototype, "shouldConfirmCrops", [f.computed], Object.getOwnPropertyDescriptor(xUe.prototype, "shouldConfirmCrops"), xUe.prototype), MUe = WUe(xUe.prototype, "onSubmit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.isSubmitPending = !0;
          var r = !0,
              n = !0;
          e.shouldConfirmOrganicStatus && (r = e.confirmOrganicStatus()), e.shouldConfirmCrops && (n = e.confirmCrops()), r && n || (e.isSubmitPending = !1, t.preventDefault());
        };
      }
    }), DUe = xUe)) || DUe,
        YUe = Object(g.a)()(JUe);

    function QUe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $Ue(n.key), n);
      }
    }

    function $Ue(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function XUe(e, t, r) {
      return t = ZUe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ZUe(e).constructor) : t.apply(e, r));
    }

    function ZUe(e) {
      return (ZUe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function eqe(e, t) {
      return (eqe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var tqe,
        rqe,
        nqe,
        oqe,
        iqe,
        aqe = Object(d.observer)(HUe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), XUe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && eqe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && QUe(e.prototype, t), r && QUe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this.props,
              t = e.sprayRecordsPath,
              r = e.sprayRecords,
              n = e.includeCheckboxes,
              o = e.isChecked,
              i = e.onUncheckAll,
              a = e.onUncheckPage,
              c = e.onSelectAll,
              u = e.onSelectPage,
              l = e.t;
          return p.a.createElement("div", {
            className: "spray-record-list",
            "aria-label": "Spray Record List"
          }, p.a.createElement("table", {
            className: "table table-sm table-manually-striped"
          }, p.a.createElement("thead", null, p.a.createElement("tr", null, n ? p.a.createElement("th", {
            className: "align-middle checkbox-header",
            "aria-label": "Select All",
            scope: "col"
          }, p.a.createElement(roe, {
            isChecked: o,
            onUncheckAll: i,
            onUncheckPage: a,
            onSelectAll: c,
            onSelectPage: u
          })) : null, p.a.createElement("th", {
            scope: "col",
            className: "toggle-expand-header",
            "aria-label": "Expand Toggle Control"
          }), p.a.createElement("th", {
            scope: "col"
          }, l("title"), p.a.createElement("br", null), l("date_dates")), p.a.createElement("th", {
            scope: "col"
          }, l("recommendation")), p.a.createElement("th", {
            scope: "col"
          }, l("account")), p.a.createElement("th", {
            scope: "col"
          }, l("crop")), p.a.createElement("th", {
            scope: "col"
          }, l("products")), p.a.createElement("th", {
            scope: "col"
          }, l("complete"), "?"), p.a.createElement("th", {
            "aria-label": "Actions",
            scope: "col",
            className: "actions"
          }))), p.a.createElement("tbody", null, null == r ? void 0 : r.map(function (e, r) {
            return p.a.createElement(yS, {
              key: e.id,
              sprayRecordsPath: t,
              sprayRecord: e,
              isLight: r % 2 == 0,
              includeCheckboxes: n
            });
          }))));
        }
      }]);
    }()) || HUe,
        cqe = Object(g.a)()(aqe);

    function uqe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function lqe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, sqe(n.key), n);
      }
    }

    function sqe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function pqe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var fqe = (rqe = pqe((tqe = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), uqe(this, "errorText", rqe, this), uqe(this, "selectedApplicator", nqe, this), uqe(this, "applicatorContacts", oqe, this), uqe(this, "changeApplicator", iqe, this), this.applicatorContacts = (null == t ? void 0 : t.applicatorContacts) || [];
      }, (t = [{
        key: "clearErrorText",
        value: function () {
          this.errorText = "";
        }
      }]) && lqe(e.prototype, t), r && lqe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "errorText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), nqe = pqe(tqe.prototype, "selectedApplicator", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), oqe = pqe(tqe.prototype, "applicatorContacts", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), iqe = pqe(tqe.prototype, "changeApplicator", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.selectedApplicator = t;
        };
      }
    }), pqe(tqe.prototype, "clearErrorText", [f.action], Object.getOwnPropertyDescriptor(tqe.prototype, "clearErrorText"), tqe.prototype), tqe);

    function dqe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bqe(n.key), n);
      }
    }

    function bqe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function yqe(e, t, r) {
      return t = mqe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], mqe(e).constructor) : t.apply(e, r));
    }

    function mqe(e) {
      return (mqe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function vqe(e, t) {
      return (vqe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var hqe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), yqe(this, t, [{
          defaultKey: "value",
          attributes: [new le({
            name: "ID",
            key: "id",
            shouldNotSerialize: !0
          }), new le({
            name: "Label",
            key: "label"
          }), new le({
            name: "Value",
            key: "value"
          }), new le({
            name: "Primary",
            key: "primary",
            type: "boolean"
          })]
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && vqe(e, t);
      }(t, Ne), r = t, n && dqe(r.prototype, n), o && dqe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function gqe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, wqe(n.key), n);
      }
    }

    function wqe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Oqe(e, t, r) {
      return t = jqe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], jqe(e).constructor) : t.apply(e, r));
    }

    function jqe(e) {
      return (jqe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Pqe(e, t) {
      return (Pqe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var _qe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Oqe(this, t, [{
          defaultKey: "address",
          attributes: [new le({
            name: "ID",
            key: "id",
            shouldNotSerialize: !0
          }), new le({
            name: "Label",
            key: "label"
          }), new le({
            name: "Address",
            key: "address"
          }), new le({
            name: "Primary",
            key: "primary",
            type: "boolean"
          })]
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Pqe(e, t);
      }(t, Ne), r = t, n && gqe(r.prototype, n), o && gqe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function Eqe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Sqe(n.key), n);
      }
    }

    function Sqe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Cqe(e, t, r) {
      return t = kqe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], kqe(e).constructor) : t.apply(e, r));
    }

    function kqe(e) {
      return (kqe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Rqe(e, t) {
      return (Rqe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Tqe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Cqe(this, t, [{
          defaultKey: "number",
          attributes: [new le({
            name: "ID",
            key: "id",
            shouldNotSerialize: !0
          }), new le({
            name: "Number",
            key: "number"
          }), new le({
            name: "Label",
            key: "label"
          }), new le({
            name: "Primary",
            key: "primary",
            type: "boolean"
          })]
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Rqe(e, t);
      }(t, Ne), r = t, n && Eqe(r.prototype, n), o && Eqe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function zqe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Nqe(n.key), n);
      }
    }

    function Nqe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Dqe(e, t, r) {
      return t = xqe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], xqe(e).constructor) : t.apply(e, r));
    }

    function xqe(e) {
      return (xqe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Aqe(e, t) {
      return (Aqe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Mqe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Dqe(this, t, [{
          defaultKey: "name",
          attributes: [new le({
            name: "ID",
            key: "id"
          }), new le({
            name: "Serial",
            key: "serial",
            type: "number"
          }), new le({
            name: "Name",
            key: "name"
          }), new le({
            name: "Type",
            key: "type",
            defaultValue: "IF2::Tractor"
          }), new Ce({
            name: "Account",
            key: "account",
            modelSpec: new dVe()
          }), new le({
            name: "License Plate Number",
            key: "licensePlateNumber"
          }), new le({
            name: "Notes",
            key: "notes"
          })]
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Aqe(e, t);
      }(t, Ne), r = t, n && zqe(r.prototype, n), o && zqe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function Iqe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Fqe(n.key), n);
      }
    }

    function Fqe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Bqe(e, t, r) {
      return t = Lqe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Lqe(e).constructor) : t.apply(e, r));
    }

    function Lqe(e) {
      return (Lqe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Vqe(e, t) {
      return (Vqe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var Uqe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Bqe(this, t, [{
          defaultKey: "name",
          attributes: JVe(t.attributeDefinition)
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Vqe(e, t);
      }(t, Ne), r = t, n && Iqe(r.prototype, n), o && Iqe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function qqe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Kqe(n.key), n);
      }
    }

    function Kqe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function Gqe(e, t, r) {
      return t = Wqe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Wqe(e).constructor) : t.apply(e, r));
    }

    function Wqe(e) {
      return (Wqe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Hqe(e, t) {
      return (Hqe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    Uqe.attributeDefinition = {
      id: {
        name: "ID"
      },
      serial: {
        name: "Serial",
        type: "number"
      },
      name: {
        name: "Name"
      },
      type: {
        name: "Type",
        defaultValue: "IF2::Sprayer"
      },
      account: {
        name: "Account",
        attributeSpecType: "ModelAttributeSpec",
        ModelSpecClass: dVe
      },
      licensePlateNumber: {
        name: "License Plate Number"
      },
      tankSize: {
        name: "Tank Size"
      },
      notes: {
        name: "Notes"
      }
    };

    var Jqe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), Gqe(this, t, [{
          defaultKey: "name",
          attributes: JVe(t.attributeDefinition)
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Hqe(e, t);
      }(t, Ne), r = t, n && qqe(r.prototype, n), o && qqe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function Yqe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Qqe(n.key), n);
      }
    }

    function Qqe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function $qe(e, t, r) {
      return t = Xqe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], Xqe(e).constructor) : t.apply(e, r));
    }

    function Xqe(e) {
      return (Xqe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function Zqe(e, t) {
      return (Zqe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    Jqe.attributeDefinition = {
      id: {
        name: "ID"
      },
      serial: {
        name: "Serial",
        type: "number"
      },
      name: {
        name: "Name"
      },
      type: {
        name: "Type",
        defaultValue: "IF2::Spreader"
      },
      account: {
        name: "Account",
        attributeSpecType: "ModelAttributeSpec",
        ModelSpecClass: dVe
      },
      licensePlateNumber: {
        name: "License Plate Number"
      },
      notes: {
        name: "Notes"
      }
    };

    var eKe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), $qe(this, t, [{
          defaultKey: "name",
          attributes: JVe(t.attributeDefinition)
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Zqe(e, t);
      }(t, Ne), r = t, n && Yqe(r.prototype, n), o && Yqe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    eKe.attributeDefinition = {
      id: {
        name: "ID"
      },
      serial: {
        name: "Serial",
        type: "number"
      },
      name: {
        name: "Name",
        isReadonly: !0,
        shouldNotSerialize: !0
      },
      type: {
        name: "Type",
        defaultValue: "IF2::Contact"
      },
      firstName: {
        name: "First Name"
      },
      lastName: {
        name: "Last Name"
      },
      licenseNumber: {
        name: "License Number"
      },
      defaultTractor: {
        name: "Default Tractor",
        attributeSpecType: "ModelAttributeSpec",
        ModelSpecClass: Mqe
      },
      defaultSprayer: {
        name: "Default Sprayer",
        attributeSpecType: "ModelAttributeSpec",
        ModelSpecClass: Uqe
      },
      defaultSpreader: {
        name: "Default Spreader",
        attributeSpecType: "ModelAttributeSpec",
        ModelSpecClass: Jqe
      },
      categories: {
        name: "Category",
        attributeSpecType: "CollectionAttributeSpec",
        ElementSpecClass: IVe
      },
      phones: {
        name: "Phone",
        attributeSpecType: "CollectionAttributeSpec",
        ElementSpecClass: Tqe
      },
      emails: {
        name: "Email",
        attributeSpecType: "CollectionAttributeSpec",
        ElementSpecClass: _qe
      },
      addresses: {
        name: "Address",
        ElementSpecClass: hqe
      }
    };
    var tKe = X("Address", {
      base: Be,
      mixins: [{
        spec: {
          value: new hqe(),
          isStatic: !0
        }
      }]
    }),
        rKe = X("Email", {
      base: Be,
      mixins: [{
        spec: {
          value: new _qe(),
          isStatic: !0
        }
      }]
    }),
        nKe = X("Phone", {
      base: Be,
      mixins: [{
        spec: {
          value: new Tqe(),
          isStatic: !0
        }
      }]
    }),
        oKe = X("Tractor", {
      base: Be,
      mixins: [tt, {
        spec: {
          value: new Mqe(),
          isStatic: !0
        },
        updateAttribute: {
          value: function (e, t) {
            return "account" === e ? this.updateModelAttribute(CUe, e, t) : Be.prototype.updateAttribute.call(this, e, t);
          }
        }
      }]
    }),
        iKe = X("Sprayer", {
      base: Be,
      mixins: [tt, {
        spec: {
          value: new Uqe(),
          isStatic: !0
        },
        updateAttribute: {
          value: function (e, t) {
            return "account" === e ? this.updateModelAttribute(CUe, e, t) : Be.prototype.updateAttribute.call(this, e, t);
          }
        }
      }]
    }),
        aKe = X("Spreader", {
      base: Be,
      mixins: [tt, {
        spec: {
          value: new Jqe(),
          isStatic: !0
        },
        updateAttribute: {
          value: function (e, t) {
            return "account" === e ? this.updateModelAttribute(CUe, e, t) : Be.prototype.updateAttribute.call(this, e, t);
          }
        }
      }]
    });

    function cKe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function uKe(e, t, r) {
      return (t = function (e) {
        var t = function (e, t) {
          if ("object" != typeof e || !e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(e, "string");

        return "symbol" == typeof t ? t : t + "";
      }(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    var lKe,
        sKe,
        pKe,
        fKe = X("Contact", {
      base: Be,
      mixins: [tt, {
        spec: {
          value: new eKe(),
          isStatic: !0
        },
        name: {
          get: function () {
            return (this.firstName && [this.firstName] || []).concat(this.lastName && [this.lastName] || []).join(" ");
          },
          configurable: !0,
          decorate: f.computed
        },
        phone: {
          get: function () {
            return (this.primaryPhone || {
              number: ""
            }).number;
          },
          configurable: !0,
          decorate: f.computed
        },
        primaryPhone: {
          get: function () {
            return (this.phones.items || []).find(function (e) {
              return e.primary;
            }) || this.phones.items.length ? this.phones.items[0] : void 0;
          },
          configurable: !0,
          decorate: f.computed
        },
        address: {
          get: function () {
            return (this.primaryAddress || {
              value: ""
            }).value;
          },
          configurable: !0,
          decorate: f.computed
        },
        primaryAddress: {
          get: function () {
            return (this.addresses.items || []).find(function (e) {
              return e.primary;
            }) || this.addresses.items.length ? this.addresses.items[0] : void 0;
          },
          configurable: !0,
          decorate: f.computed
        },
        email: {
          get: function () {
            return (this.primaryEmail || {
              address: ""
            }).address;
          },
          configurable: !0,
          decorate: f.computed
        },
        primaryEmail: {
          get: function () {
            return (this.emails.items || []).find(function (e) {
              return e.primary;
            }) || this.emails.items.length ? this.emails.items[0] : void 0;
          },
          configurable: !0,
          decorate: f.computed
        },
        setPhone: {
          value: function (e) {
            var t = this.primaryPhone || new nKe({
              number: e,
              primary: !0
            });
            t.number = e, this.phones.update(t);
          }
        },
        setAddress: {
          value: function (e) {
            var t = this.primaryAddress || new tKe({
              value: e,
              primary: !0
            });
            t.value = e, this.addresses.update(t);
          }
        },
        setEmail: {
          value: function (e) {
            var t = this.primaryEmail || new rKe({
              address: e,
              primary: !0
            });
            t.address = e, this.emails.update(t);
          }
        },
        updateAttribute: {
          value: function (e, t) {
            var r = function (e) {
              return Array.isArray(e) ? e.map(function (e) {
                return function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var r = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? cKe(Object(r), !0).forEach(function (t) {
                      uKe(e, t, r[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : cKe(Object(r)).forEach(function (t) {
                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                    });
                  }

                  return e;
                }({
                  id: kj()()
                }, e);
              }) : [];
            };

            if ("name" !== e) {
              if ("addresses" === e) return this.updateCollectionAttribute(wUe, tKe, e, r(t));
              if ("categories" === e) return this.updateCollectionAttribute(wUe, OUe, e, t, "value");
              if ("emails" === e) return this.updateCollectionAttribute(wUe, rKe, e, r(t));
              if ("phones" === e) return this.updateCollectionAttribute(wUe, nKe, e, r(t));
              var n = {
                defaultTractor: oKe,
                defaultSprayer: iKe,
                defaultSpreader: aKe
              };
              return n[e] ? this.updateModelAttribute(n[e], e, t) : Be.prototype.updateAttribute.call(this, e, t);
            }
          }
        }
      }]
    });

    function dKe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bKe(n.key), n);
      }
    }

    function bKe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function yKe(e, t, r) {
      return t = mKe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], mKe(e).constructor) : t.apply(e, r));
    }

    function mKe(e) {
      return (mKe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function vKe(e, t) {
      return (vKe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function hKe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var gKe,
        wKe,
        OKe,
        jKe,
        PKe,
        _Ke,
        EKe,
        SKe,
        CKe,
        kKe,
        RKe = Object(d.observer)((hKe((sKe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = yKe(this, t, [].concat(n))).contactSelector = new h.SelectorModel(e.applicatorOptions.sort(function (e, t) {
          return Object(h.naturalSort)(e.text, t.text);
        })), function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e, "onChange", pKe, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && vKe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && dKe(e.prototype, t), r && dKe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "applicatorOptions",
        get: function () {
          return this.props.model.applicatorContacts.filter(function (e) {
            return e.license_number;
          }).map(function (e) {
            var t = new fKe(e);
            return {
              key: t.id,
              text: t.name,
              value: t
            };
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.t,
              r = e.model;
          return p.a.createElement("div", {
            className: "applicator-prompt"
          }, p.a.createElement("p", null, t("alert_licensed_applicator_missing")), this.applicatorOptions.length ? p.a.createElement(p.a.Fragment, null, p.a.createElement("p", null, t("select_licensed_applicator_from_options")), p.a.createElement(h.SelectDropdown, {
            placeholder: t("select_licensed_applicator"),
            options: this.contactSelector.options,
            onChange: this.onChange,
            hasError: !!r.errorText,
            model: this.contactSelector
          }), p.a.createElement("span", {
            className: r.errorText ? "visible error" : "invisible"
          }, r.errorText)) : null);
        }
      }]);
    }()).prototype, "applicatorOptions", [f.computed], Object.getOwnPropertyDescriptor(sKe.prototype, "applicatorOptions"), sKe.prototype), pKe = hKe(sKe.prototype, "onChange", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.model;
          r.clearErrorText(), e.contactSelector.change(t), r.changeApplicator(null == t ? void 0 : t.value);
        };
      }
    }), lKe = sKe)) || lKe,
        TKe = Object(g.a)()(RKe);

    function zKe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function NKe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, DKe(n.key), n);
      }
    }

    function DKe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function xKe(e, t, r) {
      return t = AKe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], AKe(e).constructor) : t.apply(e, r));
    }

    function AKe(e) {
      return (AKe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function MKe(e, t) {
      return (MKe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function IKe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var FKe,
        BKe,
        LKe,
        VKe,
        UKe = Object(d.observer)(((kKe = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = xKe(this, t, [e])).formRef = p.a.createRef(), zKe(r, "isSubmitting", OKe, r), zKe(r, "shouldSubmitForm", jKe, r), zKe(r, "useCondensedList", PKe, r), zKe(r, "applicatorErrorText", _Ke, r), zKe(r, "sortedFields", EKe, r), zKe(r, "setErrorText", SKe, r), zKe(r, "onSubmit", CKe, r);
        var n = r.props,
            o = n.t,
            i = n.applicatorContacts;
        return r.sprayRecordsStore = window.sprayRecordsStore, r.submitFormDisposer = Object(f.reaction)(function () {
          return r.shouldSubmitForm;
        }, function (e) {
          e && (r.shouldSubmitForm = !1, r.constructor.submitForm(r.formRef.current));
        }, {
          delay: 100
        }), r.applicatorPromptModel = new fqe({
          applicatorContacts: i
        }), r.confirmApplicatorPromptModel = h.SafePrompt.createViewModel({
          isConfirm: !0,
          headerText: o("licensed_applicator_missing"),
          okButtonText: o("ok"),
          cancelButtonText: o("cancel")
        }), r.confirmFieldsPromptModel = h.SafePrompt.createViewModel({
          isConfirm: !0,
          headerText: o("untreated_fields_warning"),
          okButtonText: o("ok"),
          cancelButtonText: o("cancel"),
          footerText: o("remove_these_fields")
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && MKe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && NKe(e.prototype, t), r && NKe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "sprayRecord",
        get: function () {
          var e = this.props.sprayRecordId;
          return this.sprayRecordsStore.find(e);
        }
      }, {
        key: "includedCropNames",
        get: function () {
          return ee(this.sprayRecord.fields.map(function (e) {
            return e.cropName;
          })).sort();
        }
      }, {
        key: "extraCropNames",
        get: function () {
          var e = this;
          return this.sprayRecord.cropNames.filter(function (t) {
            return !e.includedCropNames.includes(t);
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.submitFormDisposer();
        }
      }, {
        key: "confirmCrops",
        value: function () {
          var e = this.props.t,
              t = ne(this.extraCropNames),
              r = this.extraCropNames.length > 1 ? e("crops_not_present", {
            string: t
          }) : e("crop_not_present", {
            string: t
          });
          return window.confirm(r);
        }
      }, {
        key: "getFieldCompletionFields",
        value: function () {
          return Object(x.pipe)(Object(x.map)(function (e) {
            return e.fieldCompletions.map(function (e) {
              return e.field;
            });
          }), x.flatten)(this.sprayRecord.applications);
        }
      }, {
        key: "getFieldsWithCompletions",
        value: function () {
          var e = this;
          return Object(x.intersection)(this.sprayRecord.fields.map(function (e) {
            return e.id;
          }), this.getFieldCompletionFields().map(function (e) {
            return e.id;
          })).map(function (t) {
            return e.sprayRecord.fields.find(function (e) {
              return e.id === t;
            });
          });
        }
      }, {
        key: "getFieldsWithoutCompletions",
        value: function () {
          var e = this;
          return Object(x.difference)(this.sprayRecord.fields.map(function (e) {
            return e.id;
          }), this.getFieldCompletionFields().map(function (e) {
            return e.id;
          })).map(function (t) {
            return e.sprayRecord.fields.find(function (e) {
              return e.id === t;
            });
          });
        }
      }, {
        key: "validateFields",
        value: function () {
          var e = this,
              t = this.getFieldsWithoutCompletions();
          if (null != t && t.length) return this.sortedFields = t.slice().sort(w.sortByName), this.confirmFieldsPromptModel.onShow().then(function (t) {
            if (!t) throw e.constructor.cancelError();
            return e.sprayRecord.update({
              fields: e.getFieldsWithCompletions()
            }), e.sprayRecordsStore.update(e.sprayRecord.id, {
              field_ids: e.sprayRecord.fields.map(function (e) {
                return e.serial;
              })
            });
          });
        }
      }, {
        key: "validateLicensedApplicator",
        value: function () {
          var e = this,
              t = this.props.t;
          return this.sprayRecord.licensedApplicator ? Promise.resolve() : this.confirmApplicatorPromptModel.onShow({
            onConfirm: function (r) {
              var n = r.resolve,
                  o = r.hide;
              return e.applicatorPromptModel.selectedApplicator ? (o(), n(!0)) : (Object(f.runInAction)(function () {
                e.applicatorPromptModel.errorText = t("licensed_applicator_missing");
              }), console.error(t("licensed_applicator_missing")));
            }
          }).then(function (t) {
            if (e.applicatorPromptModel.clearErrorText(), !t) throw e.constructor.cancelError();
            return e.sprayRecordsStore.update(e.sprayRecord.id, {
              licensed_applicator_id: e.applicatorPromptModel.selectedApplicator.id
            });
          });
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.formAction,
              r = e.authenticityToken,
              n = e.t;
          return p.a.createElement("div", {
            className: "spray-record-mark-complete-form"
          }, p.a.createElement("form", {
            ref: this.formRef,
            className: "edit_spray_record",
            action: t,
            acceptCharset: "UTF-8",
            method: "post",
            onSubmit: this.onSubmit
          }, p.a.createElement("input", {
            type: "hidden",
            name: "_method",
            value: "patch"
          }), p.a.createElement("input", {
            type: "hidden",
            name: "authenticity_token",
            value: r
          }), p.a.createElement("input", {
            value: "1",
            type: "hidden",
            name: "spray_record[complete]"
          }), this.useCondensedList ? this.includedCropNames.map(function (e) {
            return p.a.createElement("input", {
              key: e,
              value: e,
              type: "hidden",
              name: "spray_record[crop_names][]"
            });
          }) : null, p.a.createElement("input", {
            type: "hidden",
            name: "commit",
            value: "Mark as Complete"
          }), p.a.createElement("button", {
            type: "submit",
            className: "btn btn-secondary",
            disabled: this.isSubmitting
          }, n("mark_as_complete"))), p.a.createElement(h.SafePrompt, {
            model: this.confirmApplicatorPromptModel
          }, p.a.createElement(TKe, {
            model: this.applicatorPromptModel
          })), p.a.createElement(h.SafePrompt, {
            model: this.confirmFieldsPromptModel
          }, p.a.createElement(p.a.Fragment, null, p.a.createElement("p", null, n("fields_listed_but_not_treated")), p.a.createElement("div", {
            className: "untreated-fields-list"
          }, p.a.createElement("ul", null, this.sortedFields.map(function (e) {
            return p.a.createElement("li", {
              key: e.id
            }, e.name);
          }))))));
        }
      }], [{
        key: "cancelError",
        value: function () {
          return new Error("cancelled mark complete");
        }
      }, {
        key: "submitForm",
        value: function (e) {
          e.submit();
        }
      }]);
    }()).defaultProps = {
      applicatorContacts: []
    }, OKe = IKe((wKe = kKe).prototype, "isSubmitting", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), jKe = IKe(wKe.prototype, "shouldSubmitForm", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), PKe = IKe(wKe.prototype, "useCondensedList", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), _Ke = IKe(wKe.prototype, "applicatorErrorText", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), EKe = IKe(wKe.prototype, "sortedFields", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), IKe(wKe.prototype, "sprayRecord", [f.computed], Object.getOwnPropertyDescriptor(wKe.prototype, "sprayRecord"), wKe.prototype), IKe(wKe.prototype, "includedCropNames", [f.computed], Object.getOwnPropertyDescriptor(wKe.prototype, "includedCropNames"), wKe.prototype), IKe(wKe.prototype, "extraCropNames", [f.computed], Object.getOwnPropertyDescriptor(wKe.prototype, "extraCropNames"), wKe.prototype), SKe = IKe(wKe.prototype, "setErrorText", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.applicatorErrorText = t;
        };
      }
    }), IKe(wKe.prototype, "confirmCrops", [f.action], Object.getOwnPropertyDescriptor(wKe.prototype, "confirmCrops"), wKe.prototype), CKe = IKe(wKe.prototype, "onSubmit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.preventDefault(), e.isSubmitting = !0, e.validateLicensedApplicator().then(function () {
            if (e.extraCropNames.length) return e.confirmCrops() ? e.useCondensedList = !0 : e.useCondensedList;
          }).then(function () {
            return e.validateFields();
          }).then(function () {
            return Object(f.runInAction)(function () {
              e.shouldSubmitForm = !0;
            });
          }).catch(function (t) {
            Object(f.runInAction)(function () {
              e.isSubmitting = !1;
            }), console.error(t);
          });
        };
      }
    }), IKe(wKe.prototype, "validateFields", [f.action], Object.getOwnPropertyDescriptor(wKe.prototype, "validateFields"), wKe.prototype), gKe = wKe)) || gKe,
        qKe = Object(g.a)()(UKe);

    function KKe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function GKe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, WKe(n.key), n);
      }
    }

    function WKe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function HKe(e, t, r) {
      return t = JKe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], JKe(e).constructor) : t.apply(e, r));
    }

    function JKe(e) {
      return (JKe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function YKe(e, t) {
      return (YKe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function QKe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var $Ke,
        XKe,
        ZKe,
        eGe,
        tGe,
        rGe = Object(d.observer)((LKe = QKe((BKe = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = HKe(this, t, [e])).sprayRecordsStore = void 0, KKe(r, "value", LKe, r), KKe(r, "changeText", VKe, r), r.sprayRecordsStore = window.sprayRecordsStore, r.value = r.sprayRecord.notes, r.saveReaction = Object(f.reaction)(function () {
          return r.value;
        }, function (e) {
          r.sprayRecordsStore.update(r.sprayRecordId, {
            notes: e
          }).catch(function (e) {
            return alert(e);
          });
        }, {
          delay: 750
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && YKe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "lines",
        get: function () {
          return this.value.split("\n").map(function (e, t) {
            return {
              id: t,
              text: e
            };
          });
        }
      }, {
        key: "sprayRecordId",
        get: function () {
          return this.props.sprayRecordId;
        }
      }, {
        key: "sprayRecord",
        get: function () {
          return this.sprayRecordsStore.find(this.sprayRecordId);
        }
      }, {
        key: "componentDidMount",
        value: function () {
          if (this.props.testThrowError) throw new Error("Test fallback UI");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.showEditControls;
          return p.a.createElement("div", {
            className: "notes"
          }, this.sprayRecord.complete || !e ? this.lines.map(function (e) {
            return p.a.createElement(s.Fragment, {
              key: e.id
            }, e.text, p.a.createElement("br", null));
          }) : p.a.createElement("textarea", {
            value: this.value,
            onChange: this.changeText,
            className: "form-control"
          }));
        }
      }]) && GKe(r.prototype, n), o && GKe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "value", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), QKe(BKe.prototype, "lines", [f.computed], Object.getOwnPropertyDescriptor(BKe.prototype, "lines"), BKe.prototype), QKe(BKe.prototype, "sprayRecordId", [f.computed], Object.getOwnPropertyDescriptor(BKe.prototype, "sprayRecordId"), BKe.prototype), QKe(BKe.prototype, "sprayRecord", [f.computed], Object.getOwnPropertyDescriptor(BKe.prototype, "sprayRecord"), BKe.prototype), VKe = QKe(BKe.prototype, "changeText", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.value = t.target.value;
        };
      }
    }), FKe = BKe)) || FKe;

    function nGe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function oGe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, iGe(n.key), n);
      }
    }

    function iGe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function aGe(e, t, r) {
      return t = cGe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], cGe(e).constructor) : t.apply(e, r));
    }

    function cGe(e) {
      return (cGe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function uGe(e, t) {
      return (uGe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function lGe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var sGe,
        pGe = Object(d.observer)((ZKe = lGe((XKe = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), nGe(r = aGe(this, t, [e]), "isOpen", ZKe, r), nGe(r, "close", eGe, r), nGe(r, "open", tGe, r), r.sprayRecordsStore = window.sprayRecordsStore, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && uGe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && oGe(e.prototype, t), r && oGe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "sprayRecord",
        get: function () {
          var e = this.props.sprayRecordId;
          return this.sprayRecordsStore.find(e);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return p.a.createElement(h.Card, {
            shouldNotPrint: !this.sprayRecord.notes
          }, p.a.createElement(h.CardHeader, {
            isOpen: this.isOpen,
            title: e("notes").toUpperCase(),
            onOpen: this.open,
            onClose: this.close,
            hasToggle: !0
          }), p.a.createElement(h.CardBody, {
            isOpen: this.isOpen
          }, p.a.createElement(mf, {
            componentProps: this.props,
            renderError: function () {
              return p.a.createElement(Lp, {
                errorMessage: e("error_displaying_notes")
              });
            }
          }, p.a.createElement(rGe, this.props))));
        }
      }]);
    }()).prototype, "isOpen", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !0;
      }
    }), lGe(XKe.prototype, "sprayRecord", [f.computed], Object.getOwnPropertyDescriptor(XKe.prototype, "sprayRecord"), XKe.prototype), eGe = lGe(XKe.prototype, "close", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isOpen = !1;
        };
      }
    }), tGe = lGe(XKe.prototype, "open", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isOpen = !0;
        };
      }
    }), $Ke = XKe)) || $Ke,
        fGe = Object(g.a)()(pGe);

    function dGe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, bGe(n.key), n);
      }
    }

    function bGe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function yGe(e, t, r) {
      return t = mGe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], mGe(e).constructor) : t.apply(e, r));
    }

    function mGe(e) {
      return (mGe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function vGe(e, t) {
      return (vGe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var hGe,
        gGe,
        wGe = Object(d.observer)(sGe = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = yGe(this, t, [e])).registerMapRerenderer = function (e, t) {
          var n = r.getRenderers(),
              o = n.find(function (t) {
            return t.id === e;
          });
          o ? o.render = t : n.push({
            id: e,
            render: t
          });
        }, r.unregisterMapRerenderer = function (e) {
          var t = r.getRenderers(),
              n = t.findIndex(function (t) {
            return t.id === e;
          });
          n < 0 || t.splice(n, 1);
        };
        var n = r.props.fields;
        if (!n) throw new Error("WithPrintedMap requires fields");
        return r.fields = n.map(function (e) {
          return new l.Field(e);
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && vGe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "getRenderers",
        value: function () {
          return Array.isArray(window.mapRenderers) || (window.mapRenderers = []), window.mapRenderers;
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.address,
              r = e.id;
          return p.a.createElement("div", {
            className: "map if2-fields print-map print"
          }, p.a.createElement(l.FieldMapViewer, {
            id: "spray-record-map-".concat(r, "-print-view"),
            fields: this.fields,
            address: t,
            showLabels: !0,
            onRegisterMapRerenderer: this.registerMapRerenderer,
            onUnregisterMapRerenderer: this.unregisterMapRenderer
          }));
        }
      }]) && dGe(r.prototype, n), o && dGe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || sGe;

    function OGe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, jGe(n.key), n);
      }
    }

    function jGe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function PGe(e, t, r) {
      return t = _Ge(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], _Ge(e).constructor) : t.apply(e, r));
    }

    function _Ge(e) {
      return (_Ge = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function EGe(e, t) {
      return (EGe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function SGe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var CGe,
        kGe,
        RGe,
        TGe = Object(d.observer)((SGe((gGe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = PGe(this, t, [].concat(n))).sprayRecordFieldPath = function (t) {
          return "/if2/spray_records/".concat(e.sprayRecord.serial, "/field/").concat(t);
        }, e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && EGe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "sprayRecord",
        get: function () {
          return this.props.sprayRecord;
        }
      }, {
        key: "fieldCompletionPercents",
        get: function () {
          return this.sprayRecord.fieldCompletionPercents;
        }
      }, {
        key: "fields",
        get: function () {
          return this.sprayRecord.fields;
        }
      }, {
        key: "addFieldPath",
        get: function () {
          return "/if2/spray_records/".concat(this.sprayRecord.serial, "/fields");
        }
      }, {
        key: "componentDidMount",
        value: function () {
          if (this.props.testThrowError) throw new Error("Test fallback UI");
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.accountAddress;
          return p.a.createElement(wGe, {
            fields: this.fields,
            address: e,
            id: this.sprayRecord.serial
          });
        }
      }]) && OGe(r.prototype, n), o && OGe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "sprayRecord", [f.computed], Object.getOwnPropertyDescriptor(gGe.prototype, "sprayRecord"), gGe.prototype), SGe(gGe.prototype, "fieldCompletionPercents", [f.computed], Object.getOwnPropertyDescriptor(gGe.prototype, "fieldCompletionPercents"), gGe.prototype), SGe(gGe.prototype, "fields", [f.computed], Object.getOwnPropertyDescriptor(gGe.prototype, "fields"), gGe.prototype), SGe(gGe.prototype, "addFieldPath", [f.computed], Object.getOwnPropertyDescriptor(gGe.prototype, "addFieldPath"), gGe.prototype), hGe = gGe)) || hGe;

    function zGe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, NGe(n.key), n);
      }
    }

    function NGe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function DGe(e, t, r) {
      return t = xGe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], xGe(e).constructor) : t.apply(e, r));
    }

    function xGe(e) {
      return (xGe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function AGe(e, t) {
      return (AGe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function MGe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var IGe,
        FGe,
        BGe,
        LGe,
        VGe,
        UGe,
        qGe,
        KGe,
        GGe,
        WGe,
        HGe,
        JGe = Object(d.observer)((RGe = MGe((kGe = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = DGe(this, t, [e])).sprayRecordsStore = void 0, function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(r, "isOpen", RGe, r), r.sprayRecordsStore = window.sprayRecordsStore, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && AGe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "sprayRecordId",
        get: function () {
          return this.props.sprayRecordId;
        }
      }, {
        key: "sprayRecord",
        get: function () {
          return this.sprayRecordsStore.find(this.sprayRecordId);
        }
      }, {
        key: "fields",
        get: function () {
          return this.sprayRecord && this.sprayRecord.fields || [];
        }
      }, {
        key: "render",
        value: function () {
          return p.a.createElement("div", {
            className: "col"
          }, p.a.createElement(TGe, Object.assign({
            sprayRecord: this.sprayRecord
          }, this.props)));
        }
      }]) && zGe(r.prototype, n), o && zGe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()).prototype, "isOpen", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !0;
      }
    }), MGe(kGe.prototype, "sprayRecordId", [f.computed], Object.getOwnPropertyDescriptor(kGe.prototype, "sprayRecordId"), kGe.prototype), MGe(kGe.prototype, "sprayRecord", [f.computed], Object.getOwnPropertyDescriptor(kGe.prototype, "sprayRecord"), kGe.prototype), MGe(kGe.prototype, "fields", [f.computed], Object.getOwnPropertyDescriptor(kGe.prototype, "fields"), kGe.prototype), CGe = kGe)) || CGe;

    function YGe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function QGe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $Ge(n.key), n);
      }
    }

    function $Ge(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function XGe(e, t, r) {
      return t = ZGe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], ZGe(e).constructor) : t.apply(e, r));
    }

    function ZGe(e) {
      return (ZGe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function eWe(e, t) {
      return (eWe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function tWe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var rWe,
        nWe,
        oWe,
        iWe,
        aWe,
        cWe,
        uWe,
        lWe,
        sWe,
        pWe,
        fWe,
        dWe,
        bWe,
        yWe = Object(d.observer)((BGe = tWe((FGe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return YGe(e = XGe(this, t, [].concat(n)), "saving", BGe, e), YGe(e, "handleSelectProduct", LGe, e), YGe(e, "onSave", VGe, e), YGe(e, "onCancel", UGe, e), YGe(e, "handleChangeTarget", qGe, e), YGe(e, "handleUpdateRateUnit", KGe, e), YGe(e, "handleUpdateRateValue", GGe, e), YGe(e, "onInputKeyDown", WGe, e), YGe(e, "onDragRowStart", HGe, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && eWe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && QGe(e.prototype, t), r && QGe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "rateUnitChoices",
        get: function () {
          var e = this.props.productApplication;
          return e && e.product && e.product.rateUnitChoices || [];
        }
      }, {
        key: "componentDidMount",
        value: function () {
          this.props.isEditing && this.focus();
        }
      }, {
        key: "focus",
        value: function () {
          v()(".product-application-row-editor .product-selector input").focus();
        }
      }, {
        key: "focusNext",
        value: function () {
          v()(".product-application-row-editor .unit-selector-value input").focus();
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t,
              r = this.props,
              n = r.isDraggable,
              o = r.isEditing,
              i = r.moveIsPending,
              a = r.productsStore,
              c = r.productApplication,
              u = r.onDragRowEnd,
              l = r.className,
              s = r.errorMessagesModel,
              f = r.t;
          return p.a.createElement("tr", {
            className: "".concat(l, " product-application-row-editor"),
            draggable: !!n,
            onDragEnd: u,
            onDragStart: this.onDragRowStart
          }, p.a.createElement("td", {
            colSpan: "2"
          }, p.a.createElement("div", {
            className: "d-flex align-items-center"
          }, n ? p.a.createElement("i", {
            className: "editor-row-grip fas fa-grip-vertical pl-2 pr-3 text-secondary"
          }) : i ? p.a.createElement(h.Spinner, null) : null, p.a.createElement(lo, {
            errorMessage: f(s.product) || f(s.productAlreadyApplied) || "",
            productsStore: a,
            currentProduct: c.product,
            onSelectProduct: this.handleSelectProduct
          }))), p.a.createElement("td", {
            colSpan: "2",
            "aria-label": "Rate"
          }, p.a.createElement("div", {
            className: ""
          }, p.a.createElement("div", {
            className: "form-row my-2"
          }, p.a.createElement(h.UnitSelector, {
            placeholder: f("rate"),
            currentUnit: (null === (e = c.rate) || void 0 === e ? void 0 : e.units) || "",
            currentValue: (null === (t = c.rate) || void 0 === t ? void 0 : t.scalar) || "",
            unitChoices: this.rateUnitChoices,
            valueColumnClassName: "col-md-5 unit-selector-value",
            unitColumnClassName: "col-md-7 unit-selector-unit",
            onValueKeyDown: this.onInputKeyDown,
            onUpdateUnit: this.handleUpdateRateUnit,
            onUpdateValue: this.handleUpdateRateValue,
            valueError: f(s.rateValue) || "",
            unitsError: f(s.rateUnit) || ""
          })))), p.a.createElement("td", {
            colSpan: "3",
            "aria-label": "Target Reason"
          }, p.a.createElement("div", {
            className: "my-2"
          }, p.a.createElement("input", {
            className: "form-control",
            placeholder: f("target_reason"),
            value: c.target,
            onChange: this.handleChangeTarget,
            onKeyDown: this.onInputKeyDown
          }))), p.a.createElement("td", {
            className: "actions",
            "aria-label": "Actions"
          }, p.a.createElement("a", {
            href: "#",
            className: "".concat(i || this.saving ? "disabled " : "").concat(o ? "text-success" : "icon-link"),
            onClick: this.onSave,
            "aria-label": "Save"
          }, p.a.createElement("i", {
            className: "fas ".concat(o ? "fa-save" : "fa-plus-circle")
          })), p.a.createElement("a", {
            href: "#",
            className: "".concat(i || this.saving ? "disabled " : "", "text-secondary"),
            onClick: this.onCancel,
            disabled: i || this.saving,
            "aria-label": "Cancel"
          }, p.a.createElement("i", {
            className: "fas fa-times-circle"
          }))));
        }
      }]);
    }()).prototype, "saving", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), tWe(FGe.prototype, "rateUnitChoices", [f.computed], Object.getOwnPropertyDescriptor(FGe.prototype, "rateUnitChoices"), FGe.prototype), LGe = tWe(FGe.prototype, "handleSelectProduct", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r) {
          var n,
              o = e.props,
              i = o.productApplication,
              a = o.errorMessagesModel;
          i.product = t, setTimeout(function () {
            a.resetProduct();
          }, 100), null !== (n = i.rate) && void 0 !== n && n.units && !e.rateUnitChoices.find(function (e) {
            return e.value === i.rate.units;
          }) && (i.rate.units = ""), r || e.focusNext();
        };
      }
    }), VGe = tWe(FGe.prototype, "onSave", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          if (t && t.preventDefault(), !e.props.moveIsPending && !e.saving) {
            e.saving = !0;
            var r = e.props,
                n = r.productApplication;
            return (0, r.onSave)(n).then(function (t) {
              return Object(f.runInAction)(function () {
                e.saving = !1, t && e.focus();
              });
            });
          }
        };
      }
    }), UGe = tWe(FGe.prototype, "onCancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t && t.preventDefault();
          var r = e.props,
              n = r.onCancel,
              o = r.productApplication,
              i = r.isEditing;
          n(), i || (o.product = null, e.focus());
        };
      }
    }), qGe = tWe(FGe.prototype, "handleChangeTarget", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.props.productApplication.update({
            target: t.target.value
          });
        };
      }
    }), KGe = tWe(FGe.prototype, "handleUpdateRateUnit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.productApplication,
              o = r.errorMessagesModel;
          n.rate || (n.rate = new w.Quantity()), n.rate.units = t, setTimeout(function () {
            o.resetRateUnit();
          }, 100);
        };
      }
    }), GGe = tWe(FGe.prototype, "handleUpdateRateValue", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.productApplication,
              o = r.errorMessagesModel;
          n.rate || (n.rate = new w.Quantity()), n.rate.scalar = t, setTimeout(function () {
            o.resetRateValue();
          }, 100);
        };
      }
    }), WGe = tWe(FGe.prototype, "onInputKeyDown", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          "Enter" === t.key && e.onSave(t);
        };
      }
    }), HGe = tWe(FGe.prototype, "onDragRowStart", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props.onDragRowStart;
          t.dataTransfer.effectAllowed = "move", r();
        };
      }
    }), IGe = FGe)) || IGe,
        mWe = Object(g.a)()(yWe);

    function vWe(e, t, r) {
      return (t = wWe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function hWe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function gWe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, wWe(n.key), n);
      }
    }

    function wWe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function OWe(e, t, r) {
      return t = jWe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], jWe(e).constructor) : t.apply(e, r));
    }

    function jWe(e) {
      return (jWe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function PWe(e, t) {
      return (PWe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function _We(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    v()(document).off(".data-api");
    var EWe,
        SWe,
        CWe,
        kWe = Object(d.observer)((oWe = _We((nWe = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), hWe(r = OWe(this, t, [e]), "currentUnit", oWe, r), hWe(r, "currentValue", iWe, r), hWe(r, "overrideReason", aWe, r), hWe(r, "showValidFeedback", cWe, r), hWe(r, "onCancel", uWe, r), hWe(r, "onUpdateUnit", lWe, r), hWe(r, "onUpdateValue", sWe, r), hWe(r, "onChangeReason", pWe, r), hWe(r, "onClear", fWe, r), hWe(r, "onKeyDown", dWe, r), hWe(r, "onSave", bWe, r), r.disposeModalFocuser = Object(f.autorun)(function () {
          var e = r.props,
              t = e.shouldFocusModal,
              n = e.onDidFocusModal;
          t && setTimeout(function () {
            r.focus(), n();
          }, 500);
        }), r.disposePaInitializer = Object(f.autorun)(function () {
          var e = r.props,
              t = e.productApplication,
              n = e.overrideKey,
              o = e.overrideReasonKey,
              i = t[n],
              a = "",
              c = "";
          i && (a = i.units, c = i.scalar), r.currentUnit = a, r.currentValue = c, r.overrideReason = t[o];
        }), r.disposeTooltipInitializer = Object(f.autorun)(function () {
          var e = r.props.id;
          r.showValidFeedback && v()("#".concat(e, ' [data-toggle="tooltip"]')).tooltip({
            trigger: "hover",
            delay: {
              show: 700,
              hide: 0
            }
          });
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && PWe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && gWe(e.prototype, t), r && gWe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "disableValueInput",
        get: function () {
          return "Dry" === this.currentUnit;
        }
      }, {
        key: "isCurrentValueInvalid",
        get: function () {
          return !(this.currentValue || "0" === this.currentValue) && (this.currentUnit || this.overrideReason);
        }
      }, {
        key: "isCurrentUnitInvalid",
        get: function () {
          return !(this.currentUnit || !this.currentValue && "0" !== this.currentValue && !this.overrideReason);
        }
      }, {
        key: "isOverrideValid",
        get: function () {
          return this.currentValue || "0" === this.currentValue ? !(!this.currentUnit || !this.overrideReason) : !this.currentUnit && !this.overrideReason;
        }
      }, {
        key: "isReasonValid",
        get: function () {
          return !(!this.overrideReason && (this.currentValue || "0" === this.currentValue || this.currentUnit));
        }
      }, {
        key: "isValid",
        get: function () {
          return this.isOverrideValid && this.isReasonValid;
        }
      }, {
        key: "override",
        get: function () {
          return this.currentValue || "0" === this.currentValue ? "".concat(this.currentValue, " ").concat(this.currentUnit) : "";
        }
      }, {
        key: "clearForm",
        value: function () {
          this.currentUnit = "", this.currentValue = "", this.overrideReason = "", this.showValidFeedback = !1;
        }
      }, {
        key: "focus",
        value: function () {
          var e = this.props.id;
          v()("#".concat(e, ' input[name="override"]')).focus();
        }
      }, {
        key: "isDryUnit",
        value: function (e) {
          return e.search(/Dry/) > -1;
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t = this.props,
              r = t.id,
              n = t.productApplication,
              o = t.displayName,
              i = t.originalKey,
              a = t.unitChoices,
              c = t.t;
          return p.a.createElement(h.ModalDialog, {
            id: r,
            dialogClassNames: "override-modal"
          }, p.a.createElement(h.ModalHeader, {
            title: "Override ".concat(o),
            onClose: this.onCancel
          }), p.a.createElement(h.ModalBody, null, p.a.createElement("div", {
            className: "form-row"
          }, p.a.createElement("div", {
            className: "col form-group"
          }, p.a.createElement("label", null, "Standard ", o), p.a.createElement("input", {
            className: "form-control",
            readOnly: !0,
            value: (null === (e = n[i]) || void 0 === e ? void 0 : e.displayValue) || ""
          }))), p.a.createElement("div", {
            className: "form-row"
          }, p.a.createElement("div", {
            className: "col form-group"
          }, p.a.createElement("label", null, c("new"), " ", o), p.a.createElement("div", {
            className: "form-row"
          }, p.a.createElement(h.UnitSelector, {
            disableValueInput: this.disableValueInput,
            placeholder: o,
            currentUnit: this.currentUnit,
            currentValue: this.currentValue,
            unitChoices: a,
            valueColumnClassName: "col-md-5 unit-selector-value",
            valueInputClassName: this.showValidFeedback && !this.isOverrideValid && this.isCurrentValueInvalid ? "form-control is-invalid" : "form-control",
            valueTooltipTitle: this.showValidFeedback && this.isCurrentValueInvalid ? c("must_not_be_blank") : "",
            unitColumnClassName: "col-md-7 unit-selector-unit",
            unitSelectorClassName: this.showValidFeedback && !this.isOverrideValid && this.isCurrentUnitInvalid ? "form-control is-invalid" : "form-control",
            unitTooltipTitle: this.showValidFeedback && this.isCurrentUnitInvalid ? c("must_not_be_blank") : "",
            onUpdateUnit: this.onUpdateUnit,
            onUpdateValue: this.onUpdateValue
          })))), p.a.createElement("div", {
            className: "form-row"
          }, p.a.createElement("div", {
            className: "col form-group"
          }, p.a.createElement("label", null, c("reason_for_override")), p.a.createElement("textarea", {
            className: "form-control".concat(this.showValidFeedback && !this.isReasonValid ? " is-invalid" : ""),
            placeholder: c("reason"),
            "data-original-title": this.showValidFeedback && !this.isReasonValid ? c("must_not_be_blank") : "",
            "data-toggle": "tooltip",
            onChange: this.onChangeReason,
            onKeyDown: this.onKeyDown,
            value: this.overrideReason
          })))), p.a.createElement(h.ModalFooter, null, p.a.createElement("div", {
            className: "w-100 d-flex justify-content-between"
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-outline-danger",
            "data-dismiss": "modal",
            onClick: this.onClear
          }, c("remove_override")), p.a.createElement("div", {
            className: ""
          }, p.a.createElement("button", {
            type: "button",
            className: "btn btn-outline-secondary mr-2",
            "data-dismiss": "modal",
            onClick: this.onCancel
          }, c("cancel")), p.a.createElement("button", {
            type: "submit",
            className: "btn btn-primary",
            onClick: this.onSave
          }, c("save"))))));
        }
      }]);
    }()).prototype, "currentUnit", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), iWe = _We(nWe.prototype, "currentValue", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), aWe = _We(nWe.prototype, "overrideReason", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), cWe = _We(nWe.prototype, "showValidFeedback", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), _We(nWe.prototype, "disableValueInput", [f.computed], Object.getOwnPropertyDescriptor(nWe.prototype, "disableValueInput"), nWe.prototype), _We(nWe.prototype, "isCurrentValueInvalid", [f.computed], Object.getOwnPropertyDescriptor(nWe.prototype, "isCurrentValueInvalid"), nWe.prototype), _We(nWe.prototype, "isCurrentUnitInvalid", [f.computed], Object.getOwnPropertyDescriptor(nWe.prototype, "isCurrentUnitInvalid"), nWe.prototype), _We(nWe.prototype, "isOverrideValid", [f.computed], Object.getOwnPropertyDescriptor(nWe.prototype, "isOverrideValid"), nWe.prototype), _We(nWe.prototype, "isReasonValid", [f.computed], Object.getOwnPropertyDescriptor(nWe.prototype, "isReasonValid"), nWe.prototype), _We(nWe.prototype, "isValid", [f.computed], Object.getOwnPropertyDescriptor(nWe.prototype, "isValid"), nWe.prototype), _We(nWe.prototype, "override", [f.computed], Object.getOwnPropertyDescriptor(nWe.prototype, "override"), nWe.prototype), uWe = _We(nWe.prototype, "onCancel", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.clearForm();
        };
      }
    }), lWe = _We(nWe.prototype, "onUpdateUnit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.currentUnit = t, "Dry" === e.currentUnit && (e.currentValue = 1);
        };
      }
    }), sWe = _We(nWe.prototype, "onUpdateValue", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.currentValue = t;
        };
      }
    }), pWe = _We(nWe.prototype, "onChangeReason", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.overrideReason = t.target.value;
        };
      }
    }), fWe = _We(nWe.prototype, "onClear", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.clearForm(), e.onSave(t);
        };
      }
    }), dWe = _We(nWe.prototype, "onKeyDown", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          "Enter" !== t.key || t.shiftKey || e.onSave(t), "Escape" === t.key && e.onCancel();
        };
      }
    }), bWe = _We(nWe.prototype, "onSave", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.id,
              o = r.onSave,
              i = r.productApplication,
              a = r.overrideKey,
              c = r.overrideReasonKey,
              u = e.override,
              l = e.overrideReason;
          if (!e.isValid) return e.showValidFeedback = !0, e.focus(), void t.preventDefault();
          o(vWe(vWe(vWe({}, a, u), c, l), "productApplication", i)), v()("#".concat(n)).modal("hide");
        };
      }
    }), _We(nWe.prototype, "clearForm", [f.action], Object.getOwnPropertyDescriptor(nWe.prototype, "clearForm"), nWe.prototype), rWe = nWe)) || rWe,
        RWe = Object(g.a)()(kWe);

    function TWe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, zWe(n.key), n);
      }
    }

    function zWe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function NWe(e, t, r) {
      return t = DWe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], DWe(e).constructor) : t.apply(e, r));
    }

    function DWe(e) {
      return (DWe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function xWe(e, t) {
      return (xWe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    v()(document).off(".data-api");
    var AWe,
        MWe,
        IWe,
        FWe,
        BWe,
        LWe,
        VWe,
        UWe,
        qWe = Object(d.observer)((CWe = function (e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }((SWe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return function (e, t, r, n) {
          r && Object.defineProperty(e, t, {
            enumerable: r.enumerable,
            configurable: r.configurable,
            writable: r.writable,
            value: r.initializer ? r.initializer.call(n) : void 0
          });
        }(e = NWe(this, t, [].concat(n)), "onOverride", CWe, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && xWe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && TWe(e.prototype, t), r && TWe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "renderProductionApplicationValue",
        value: function () {
          var e,
              t,
              r = this.props,
              n = r.productApplication,
              o = r.originalKey,
              i = r.overrideKey,
              a = r.valueMissingText,
              c = r.valueMissingClass,
              u = r.t;
          return n[i] ? p.a.createElement("span", {
            className: "text-danger"
          }, null === (e = n[i]) || void 0 === e ? void 0 : e.displayValue) : n[o] ? null === (t = n[o]) || void 0 === t ? void 0 : t.displayValue : p.a.createElement("span", {
            className: c || "unspecified"
          }, a || u("n_a"));
        }
      }, {
        key: "renderOverride",
        value: function () {
          var e = this.props,
              t = e.isComplete,
              r = e.productApplication,
              n = e.originalKey,
              o = e.overrideKey,
              i = e.overrideByKey,
              a = e.overrideReasonKey,
              c = e.valueMissingClass,
              u = e.showEditControls;
          return t ? this.renderProductionApplicationValue() : u ? p.a.createElement("a", {
            href: "#",
            className: r[o] ? "text-danger" : r[n] ? "" : c || "unspecified",
            onClick: this.onOverride,
            "data-original-title": r[o] ? "Overridden by ".concat(r[i], ", Reason: ").concat(r[a]) : null,
            "data-toggle": "tooltip"
          }, this.renderProductionApplicationValue()) : this.renderProductionApplicationValue();
        }
      }, {
        key: "render",
        value: function () {
          return p.a.createElement("div", {
            className: "override-editor"
          }, this.renderOverride());
        }
      }]);
    }()).prototype, "onOverride", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props,
              n = r.productApplication,
              o = r.onOverride;
          t.preventDefault(), o(n);
        };
      }
    }), EWe = SWe)) || EWe,
        KWe = Object(g.a)()(qWe);

    function GWe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function WWe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, HWe(n.key), n);
      }
    }

    function HWe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function JWe(e, t, r) {
      return t = YWe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], YWe(e).constructor) : t.apply(e, r));
    }

    function YWe(e) {
      return (YWe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function QWe(e, t) {
      return (QWe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function $We(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var XWe,
        ZWe,
        eHe,
        tHe,
        rHe,
        nHe,
        oHe,
        iHe,
        aHe = Object(d.observer)((IWe = $We((MWe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return GWe(e = JWe(this, t, [].concat(n)), "isDropTarget", IWe, e), GWe(e, "onDragOver", FWe, e), GWe(e, "onDragExit", BWe, e), GWe(e, "onDrop", LWe, e), GWe(e, "onEdit", VWe, e), GWe(e, "onRemove", UWe, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && QWe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && WWe(e.prototype, t), r && WWe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "product",
        get: function () {
          var e = this.props.productApplication;
          return e && e.product || new w.Product();
        }
      }, {
        key: "renderActiveIngredients",
        value: function () {
          if (this.product.activeIngredients) return this.product.activeIngredients.map(function (e) {
            return p.a.createElement("div", {
              className: "active-ingredient",
              key: e.id
            }, e.name);
          });
        }
      }, {
        key: "renderNutrientAnalysis",
        value: function () {
          return this.product.hasNutrientAnalysis ? p.a.createElement("div", {
            className: "nutrient-analysis"
          }, this.product.nutrientAnalysisLabel) : "";
        }
      }, {
        key: "renderOrganicReferences",
        value: function () {
          if (this.product.organicListings) return p.a.createElement("div", {
            className: "product-reference"
          }, this.product.organicListings.map(function (e) {
            return e.reference;
          }).join("\n"));
        }
      }, {
        key: "render",
        value: function () {
          var e,
              t,
              r = this.props,
              n = r.productApplication,
              o = r.onOverridePhi,
              i = r.onOverrideRei,
              a = r.isComplete,
              c = r.showEditControls,
              u = r.t;
          return p.a.createElement("tr", {
            className: this.isDropTarget ? "table-primary" : "",
            onDragOver: this.onDragOver,
            onDragLeave: this.onDragExit,
            onDrop: this.onDrop
          }, p.a.createElement("td", null, this.product.name, this.renderActiveIngredients(), this.renderNutrientAnalysis()), p.a.createElement("td", {
            className: "product-reg-num"
          }, this.product.registrationNumber, this.renderOrganicReferences()), p.a.createElement("td", null, null === (e = n.rate) || void 0 === e ? void 0 : e.displayValue), p.a.createElement("td", null, null === (t = n.total) || void 0 === t ? void 0 : t.displayValue), p.a.createElement("td", null, n.target), p.a.createElement("td", null, p.a.createElement(KWe, {
            isComplete: a,
            productApplication: n,
            onOverride: o,
            originalKey: "phi",
            overrideKey: "phiOverride",
            overrideReasonKey: "phiOverrideReason",
            overrideByKey: "phiOverrideBy",
            showEditControls: c
          })), p.a.createElement("td", null, p.a.createElement(KWe, {
            isComplete: a,
            productApplication: n,
            onOverride: i,
            originalKey: "rei",
            overrideKey: "reiOverride",
            overrideReasonKey: "reiOverrideReason",
            overrideByKey: "reiOverrideBy",
            valueMissingText: u("unspecified"),
            valueMissingClass: "text-danger font-italic",
            showEditControls: c
          })), p.a.createElement("td", {
            className: "actions"
          }, c ? p.a.createElement(p.a.Fragment, null, p.a.createElement("a", {
            href: "#",
            className: "icon-link",
            onClick: this.onEdit
          }, p.a.createElement("i", {
            className: "fas fa-edit"
          })), p.a.createElement("a", {
            href: "#",
            className: "text-danger",
            onClick: this.onRemove
          }, p.a.createElement("i", {
            className: "fas fa-trash-alt"
          }))) : null));
        }
      }]);
    }()).prototype, "isDropTarget", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), $We(MWe.prototype, "product", [f.computed], Object.getOwnPropertyDescriptor(MWe.prototype, "product"), MWe.prototype), FWe = $We(MWe.prototype, "onDragOver", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.preventDefault(), e.isDropTarget = !0;
        };
      }
    }), BWe = $We(MWe.prototype, "onDragExit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isDropTarget = !1;
        };
      }
    }), LWe = $We(MWe.prototype, "onDrop", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          var t = e.props,
              r = t.productApplication,
              n = t.onDropRow;
          e.isDropTarget = !1, n(r.position);
        };
      }
    }), VWe = $We(MWe.prototype, "onEdit", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.preventDefault();
          var r = e.props;
          (0, r.onEdit)(r.productApplication);
        };
      }
    }), UWe = $We(MWe.prototype, "onRemove", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          t.preventDefault();
          var r = e.props,
              n = r.onRemove,
              o = r.productApplication,
              i = r.t;
          window.confirm(i("confirm_remove_product")) && n(o);
        };
      }
    }), AWe = MWe)) || AWe,
        cHe = Object(g.a)()(aHe);

    function uHe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function lHe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, sHe(n.key), n);
      }
    }

    function sHe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function pHe(e, t, r) {
      return t = fHe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], fHe(e).constructor) : t.apply(e, r));
    }

    function fHe(e) {
      return (fHe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function dHe(e, t) {
      return (dHe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function bHe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var yHe,
        mHe,
        vHe,
        hHe,
        gHe,
        wHe = Object(d.observer)((eHe = bHe((ZWe = function (e) {
      function t() {
        var e;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];

        return (e = pHe(this, t, [].concat(n))).phiModalId = "phi-editor-modal", e.phiUnits = ["d"], e.reiModalId = "rei-editor-modal", e.reiUnits = ["Dry", "h", "d"], uHe(e, "shouldFocusModal", eHe, e), uHe(e, "paBeingOverriden", tHe, e), uHe(e, "onDropRow", rHe, e), uHe(e, "onOverridePhi", nHe, e), uHe(e, "onOverrideRei", oHe, e), uHe(e, "onDidFocusModal", iHe, e), e;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && dHe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && lHe(e.prototype, t), r && lHe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "render",
        value: function () {
          var e = this,
              t = this.props,
              r = t.errorMessagesModel,
              n = t.isEditing,
              o = t.isComplete,
              i = t.maxPhi,
              a = t.maxRei,
              c = t.moveIsPending,
              u = t.productsStore,
              l = t.productApplication,
              s = t.productApplications,
              f = t.onCancel,
              d = t.onDragRowEnd,
              b = t.onDragRowStart,
              y = t.onEdit,
              m = t.onRemove,
              v = t.onSave,
              h = t.onSavePhiOverride,
              g = t.onSaveReiOverride,
              w = t.showEditControls,
              O = t.t;
          return p.a.createElement("div", {
            className: "product-applications-table"
          }, p.a.createElement(RWe, {
            id: this.phiModalId,
            displayName: "PHI",
            productApplication: this.paBeingOverriden,
            shouldFocusModal: this.shouldFocusModal,
            unitChoices: this.phiUnits,
            originalKey: "phi",
            overrideKey: "phiOverride",
            overrideReasonKey: "phiOverrideReason",
            onDidFocusModal: this.onDidFocusModal,
            onSave: h
          }), p.a.createElement(RWe, {
            id: this.reiModalId,
            displayName: "REI",
            productApplication: this.paBeingOverriden,
            shouldFocusModal: this.shouldFocusModal,
            unitChoices: this.reiUnits,
            originalKey: "rei",
            overrideKey: "reiOverride",
            overrideReasonKey: "reiOverrideReason",
            onDidFocusModal: this.onDidFocusModal,
            onSave: g
          }), p.a.createElement("table", {
            className: "table table-striped table-sm"
          }, p.a.createElement("thead", null, p.a.createElement("tr", null, p.a.createElement("th", {
            scope: "col"
          }, O("product")), p.a.createElement("th", {
            scope: "col"
          }, O("reg_number_short")), p.a.createElement("th", {
            scope: "col"
          }, O("rate")), p.a.createElement("th", {
            scope: "col"
          }, O("total_applied")), p.a.createElement("th", {
            scope: "col"
          }, O("target_reason")), p.a.createElement("th", {
            scope: "col"
          }, "PHI"), p.a.createElement("th", {
            scope: "col"
          }, "REI"), p.a.createElement("th", {
            scope: "col",
            "aria-label": "Actions",
            className: "actions"
          }))), p.a.createElement("tbody", null, s.map(function (t) {
            return n && t.serial === l.serial ? p.a.createElement(mWe, {
              key: t.serial,
              isDraggable: !c,
              isEditing: n,
              moveIsPending: c,
              productsStore: u,
              productApplication: l,
              onCancel: f,
              onDragRowEnd: d,
              onDragRowStart: b,
              onSave: v,
              errorMessagesModel: r
            }) : p.a.createElement(cHe, {
              key: t.serial,
              isComplete: o,
              productApplication: t,
              onDropRow: e.onDropRow,
              onEdit: y,
              errorMessagesModel: r,
              onRemove: m,
              onOverridePhi: e.onOverridePhi,
              onOverrideRei: e.onOverrideRei,
              showEditControls: w
            });
          }), n || !w ? null : p.a.createElement(mWe, {
            className: "new-product-application-row",
            isEditing: n,
            productsStore: u,
            productApplication: l,
            onCancel: f,
            onDragRowEnd: d,
            onDragRowStart: b,
            onSave: v,
            errorMessagesModel: r
          }), p.a.createElement("tr", null, p.a.createElement("td", {
            colSpan: "5",
            className: "text-right font-weight-bold text-uppercase"
          }, O("max"), ":"), p.a.createElement("td", {
            className: "text-nowrap"
          }, null == i ? void 0 : i.displayValue), p.a.createElement("td", {
            className: "text-nowrap"
          }, null == a ? void 0 : a.displayValue), p.a.createElement("td", null)))));
        }
      }]);
    }()).prototype, "shouldFocusModal", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), tHe = bHe(ZWe.prototype, "paBeingOverriden", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return new om();
      }
    }), rHe = bHe(ZWe.prototype, "onDropRow", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = e.props;
          (0, r.onMoveRow)(r.productApplication.position, t);
        };
      }
    }), nHe = bHe(ZWe.prototype, "onOverridePhi", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.paBeingOverriden = t, v()("#".concat(e.phiModalId)).modal("show"), e.shouldFocusModal = !0;
        };
      }
    }), oHe = bHe(ZWe.prototype, "onOverrideRei", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.paBeingOverriden = t, v()("#".concat(e.reiModalId)).modal("show"), e.shouldFocusModal = !0;
        };
      }
    }), iHe = bHe(ZWe.prototype, "onDidFocusModal", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.shouldFocusModal = !1;
        };
      }
    }), XWe = ZWe)) || XWe,
        OHe = Object(g.a)()(wHe);

    function jHe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function PHe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _He(n.key), n);
      }
    }

    function _He(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function EHe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var SHe,
        CHe,
        kHe,
        RHe,
        THe,
        zHe,
        NHe,
        DHe,
        xHe,
        AHe,
        MHe,
        IHe,
        FHe,
        BHe,
        LHe,
        VHe,
        UHe,
        qHe = (mHe = EHe((yHe = function () {
      return e = function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), jHe(this, "product", mHe, this), jHe(this, "rateValue", vHe, this), jHe(this, "rateUnit", hHe, this), jHe(this, "productAlreadyApplied", gHe, this), null != t && t.id && this.validationErrors(t);
      }, (t = [{
        key: "errorMessages",
        get: function () {
          return [this.product, this.productAlreadyApplied, this.rateValue, this.rateUnit].every(function (e) {
            return !e;
          }) ? null : {
            product: this.product,
            productAlreadyApplied: this.productAlreadyApplied,
            rateValue: this.rateValue,
            rateUnit: this.rateUnit
          };
        }
      }, {
        key: "isValid",
        get: function () {
          var e = this;
          return !this.errorMessages || !Object.keys(this.errorMessages).find(function (t) {
            return e.errorMessages[t];
          });
        }
      }, {
        key: "validationErrors",
        value: function (e, t) {
          var r = this;
          this.reset(), [{
            key: "product",
            isInvalid: function (e) {
              return !e.product || !e.product.id;
            },
            message: "valid_product_required"
          }, {
            key: "rateValue",
            isInvalid: function (e) {
              var t;
              return !(null !== (t = e.rate) && void 0 !== t && t.scalar);
            },
            message: "valid_rate_required"
          }, {
            key: "rateUnit",
            isInvalid: function (e) {
              var t;
              return !(null !== (t = e.rate) && void 0 !== t && t.units);
            },
            message: "valid_units_required"
          }].forEach(function (t) {
            t.isInvalid(e) && (r[t.key] = t.message);
          }), this.checkRateIsPositive(e), this.checkForDuplicateProduct(e, t);
        }
      }, {
        key: "checkForDuplicateProduct",
        value: function (e, t) {
          var r = this;
          t && t.forEach(function (t) {
            var n, o;
            e.id !== t.id && (null === (n = e.product) || void 0 === n ? void 0 : n.id) === (null === (o = t.product) || void 0 === o ? void 0 : o.id) && (r.productAlreadyApplied = "product_already_applied");
          });
        }
      }, {
        key: "validateRateValueAndUnits",
        value: function (e) {
          this.checkRateIsPositive(e);
        }
      }, {
        key: "checkRateIsPositive",
        value: function (e) {
          var t;
          (null === (t = e.rate) || void 0 === t ? void 0 : t.scalar) > 0 || (this.rateValue = "valid_rate_required");
        }
      }, {
        key: "reset",
        value: function () {
          this.resetProduct(), this.resetRateValue(), this.resetRateUnit();
        }
      }, {
        key: "resetProduct",
        value: function () {
          this.product = "", this.productAlreadyApplied = "";
        }
      }, {
        key: "resetRateValue",
        value: function () {
          this.rateValue = "";
        }
      }, {
        key: "resetRateUnit",
        value: function () {
          this.rateUnit = "";
        }
      }]) && PHe(e.prototype, t), r && PHe(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
      var e, t, r;
    }()).prototype, "product", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), vHe = EHe(yHe.prototype, "rateValue", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), hHe = EHe(yHe.prototype, "rateUnit", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), gHe = EHe(yHe.prototype, "productAlreadyApplied", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), EHe(yHe.prototype, "errorMessages", [f.computed], Object.getOwnPropertyDescriptor(yHe.prototype, "errorMessages"), yHe.prototype), EHe(yHe.prototype, "isValid", [f.computed], Object.getOwnPropertyDescriptor(yHe.prototype, "isValid"), yHe.prototype), EHe(yHe.prototype, "validationErrors", [f.action], Object.getOwnPropertyDescriptor(yHe.prototype, "validationErrors"), yHe.prototype), EHe(yHe.prototype, "checkForDuplicateProduct", [f.action], Object.getOwnPropertyDescriptor(yHe.prototype, "checkForDuplicateProduct"), yHe.prototype), EHe(yHe.prototype, "validateRateValueAndUnits", [f.action], Object.getOwnPropertyDescriptor(yHe.prototype, "validateRateValueAndUnits"), yHe.prototype), EHe(yHe.prototype, "checkRateIsPositive", [f.action], Object.getOwnPropertyDescriptor(yHe.prototype, "checkRateIsPositive"), yHe.prototype), EHe(yHe.prototype, "reset", [f.action], Object.getOwnPropertyDescriptor(yHe.prototype, "reset"), yHe.prototype), EHe(yHe.prototype, "resetProduct", [f.action], Object.getOwnPropertyDescriptor(yHe.prototype, "resetProduct"), yHe.prototype), EHe(yHe.prototype, "resetRateValue", [f.action], Object.getOwnPropertyDescriptor(yHe.prototype, "resetRateValue"), yHe.prototype), EHe(yHe.prototype, "resetRateUnit", [f.action], Object.getOwnPropertyDescriptor(yHe.prototype, "resetRateUnit"), yHe.prototype), yHe);

    function KHe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function GHe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? KHe(Object(r), !0).forEach(function (t) {
          WHe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : KHe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function WHe(e, t, r) {
      return (t = YHe(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    function HHe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function JHe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, YHe(n.key), n);
      }
    }

    function YHe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function QHe(e, t, r) {
      return t = $He(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], $He(e).constructor) : t.apply(e, r));
    }

    function $He(e) {
      return ($He = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function XHe(e, t) {
      return (XHe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function ZHe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var eJe,
        tJe,
        rJe,
        nJe,
        oJe,
        iJe = Object(d.observer)((kHe = ZHe((CHe = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = QHe(this, t, [e])).productsStore = void 0, HHe(r, "id", kHe, r), HHe(r, "isDragging", RHe, r), HHe(r, "isEditing", THe, r), HHe(r, "moveIsPending", zHe, r), HHe(r, "currentProductApplication", NHe, r), HHe(r, "savedProductApplication", DHe, r), HHe(r, "handleSave", xHe, r), HHe(r, "clearForm", AHe, r), HHe(r, "handleDragRow", MHe, r), HHe(r, "handleDragRowEnd", IHe, r), HHe(r, "handleEditProductApplication", FHe, r), HHe(r, "handleMoveRow", BHe, r), HHe(r, "handleRemove", LHe, r), HHe(r, "handleSavePhiOverride", VHe, r), HHe(r, "handleSaveReiOverride", UHe, r), r.sprayRecordsStore = window.sprayRecordsStore;
        var n = r.props.useNewModels,
            o = GHe({
          id: "",
          nameOfUser: "",
          productsStore: new pn(new $r(), {
            useNewModels: n
          })
        }, r.props),
            i = o.id,
            a = o.nameOfUser,
            c = o.productsStore;
        return r.id = i, r.nameOfUser = a, r.productsStore = c, r.currentProductApplication = new om({
          id: null,
          position: r.productApplications.length
        }), r.errorMessagesModel = new qHe(r.currentProductApplication), r.organicFilterDisposer = Object(f.reaction)(function () {
          return r.sprayRecordIsOrganic;
        }, function (e) {
          if (r.productStore) {
            if (e) return void r.productsStore.filterOrganic();
            r.productsStore.stopFilteringOrganic();
          }
        }, {
          fireImmediately: !0
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && XHe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && JHe(e.prototype, t), r && JHe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "sprayRecord",
        get: function () {
          return this.sprayRecordsStore.find(this.id);
        }
      }, {
        key: "productApplications",
        get: function () {
          return this.sprayRecord.productApplications.slice().sort(function (e, t) {
            return Object(h.naturalSort)(e.position, t.position);
          });
        }
      }, {
        key: "sprayRecordIsOrganic",
        get: function () {
          return this.sprayRecord.organic;
        }
      }, {
        key: "componentDidMount",
        value: function () {
          var e;
          if (this.props.testThrowError) throw new Error("Test fallback UI");
          null !== (e = this.sprayRecord) && void 0 !== e && null !== (e = e.account) && void 0 !== e && e.serial && this.productsStore.fetchAllForAccount(this.sprayRecord.account.serial, {
            only: ["activeIngredients", "epaNumber", "formulation", "id", "inactive", "manufacturer", "name", "organic", "organic_listings", "registration_number", "serial", "type", "nutrientAnalysis"]
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.organicFilterDisposer();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.showEditControls,
              r = e.t;
          return p.a.createElement("div", {
            className: "spray-record-products-editor-body"
          }, this.productApplications.length < 1 ? p.a.createElement("p", {
            className: "unspecified"
          }, r("no_products_have_been_added_to_this_application_record")) : null, p.a.createElement(OHe, {
            errorMessagesModel: this.errorMessagesModel,
            isDragging: this.isDragging,
            isEditing: this.isEditing,
            isComplete: this.sprayRecord.complete,
            maxPhi: this.sprayRecord.maxPhi,
            maxRei: this.sprayRecord.maxRei,
            moveIsPending: this.moveIsPending,
            productsStore: this.productsStore,
            productApplication: this.currentProductApplication,
            productApplications: this.productApplications,
            onCancel: this.clearForm,
            onDragRowEnd: this.handleDragRowEnd,
            onDragRowStart: this.handleDragRow,
            onEdit: this.handleEditProductApplication,
            onMoveRow: this.handleMoveRow,
            onRemove: this.handleRemove,
            onSave: this.handleSave,
            onSavePhiOverride: this.handleSavePhiOverride,
            onSaveReiOverride: this.handleSaveReiOverride,
            showEditControls: t
          }));
        }
      }]);
    }()).prototype, "id", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), RHe = ZHe(CHe.prototype, "isDragging", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), THe = ZHe(CHe.prototype, "isEditing", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), zHe = ZHe(CHe.prototype, "moveIsPending", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), NHe = ZHe(CHe.prototype, "currentProductApplication", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), DHe = ZHe(CHe.prototype, "savedProductApplication", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), ZHe(CHe.prototype, "sprayRecord", [f.computed], Object.getOwnPropertyDescriptor(CHe.prototype, "sprayRecord"), CHe.prototype), ZHe(CHe.prototype, "productApplications", [f.computed], Object.getOwnPropertyDescriptor(CHe.prototype, "productApplications"), CHe.prototype), ZHe(CHe.prototype, "sprayRecordIsOrganic", [f.computed], Object.getOwnPropertyDescriptor(CHe.prototype, "sprayRecordIsOrganic"), CHe.prototype), xHe = ZHe(CHe.prototype, "handleSave", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          return e.errorMessagesModel.validationErrors(t, e.productApplications), e.errorMessagesModel.isValid ? e.sprayRecordsStore.saveProductApplication(e.id, t).then(function () {
            return e.clearForm({
              skipRestore: !0
            }), !0;
          }).catch(function (e) {
            return window.alert((null == e ? void 0 : e.message) || e), console.error(e), !1;
          }) : Promise.resolve(!1);
        };
      }
    }), AHe = ZHe(CHe.prototype, "clearForm", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = (t || {}).skipRestore;
          e.savedProductApplication && !r && Object.keys(e.currentProductApplication).forEach(function (t) {
            e.currentProductApplication[t] = "position" === t ? e.currentProductApplication[t] : e.savedProductApplication[t];
          }), e.currentProductApplication = new om({
            position: e.productApplications.length
          }), e.errorMessagesModel.reset(), e.savedProductApplication = null, e.productsStore.searchTerm = "", e.isEditing = !1;
        };
      }
    }), MHe = ZHe(CHe.prototype, "handleDragRow", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isDragging = !0;
        };
      }
    }), IHe = ZHe(CHe.prototype, "handleDragRowEnd", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isDragging = !1;
        };
      }
    }), FHe = ZHe(CHe.prototype, "handleEditProductApplication", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.isEditing && e.clearForm(), e.isEditing = !0, e.errorMessagesModel.reset(), e.currentProductApplication = t, e.savedProductApplication = new om(t.toJS());
        };
      }
    }), BHe = ZHe(CHe.prototype, "handleMoveRow", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t, r) {
          var n = e.currentProductApplication.serial;
          e.moveIsPending = !0, e.sprayRecordsStore.moveProductApplication(e.id, n, t, r).then(function () {
            return Object(f.runInAction)(function () {
              e.moveIsPending = !1, e.currentProductApplication = new om({
                position: e.productApplications.length
              });
              var t = e.sprayRecord.findProductApplication(n);
              t && (e.currentProductApplication = t);
            });
          }).catch(function (t) {
            console.error(t), Object(f.runInAction)(function () {
              e.moveIsPending = !1;
            });
          });
        };
      }
    }), LHe = ZHe(CHe.prototype, "handleRemove", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.sprayRecordsStore.deleteProductApplication(e.id, t.serial);
        };
      }
    }), VHe = ZHe(CHe.prototype, "handleSavePhiOverride", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = t.phiOverride,
              n = t.phiOverrideReason,
              o = t.productApplication;
          e.handleSave(new om(GHe(GHe({}, o.toJS()), {}, {
            phiOverride: r,
            phiOverrideBy: r && n ? e.nameOfUser : "",
            phiOverrideReason: n
          })));
        };
      }
    }), UHe = ZHe(CHe.prototype, "handleSaveReiOverride", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = t.reiOverride,
              n = t.reiOverrideReason,
              o = t.productApplication;
          e.handleSave(new om(GHe(GHe({}, o.toJS()), {}, {
            reiOverride: r,
            reiOverrideBy: r && n ? e.nameOfUser : "",
            reiOverrideReason: n
          })));
        };
      }
    }), SHe = CHe)) || SHe,
        aJe = Object(g.a)()(iJe);

    function cJe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function uJe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, lJe(n.key), n);
      }
    }

    function lJe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function sJe(e, t, r) {
      return t = pJe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], pJe(e).constructor) : t.apply(e, r));
    }

    function pJe(e) {
      return (pJe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function fJe(e, t) {
      return (fJe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function dJe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var bJe,
        yJe,
        mJe,
        vJe,
        hJe,
        gJe,
        wJe,
        OJe,
        jJe,
        PJe,
        _Je = Object(d.observer)((rJe = dJe((tJe = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), cJe(r = sJe(this, t, [e]), "isOpen", rJe, r), cJe(r, "open", nJe, r), cJe(r, "close", oJe, r), r.sprayRecordsStore = window.sprayRecordsStore, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && fJe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && uJe(e.prototype, t), r && uJe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "sprayRecord",
        get: function () {
          var e = this.props.id;
          return this.sprayRecordsStore.find(e);
        }
      }, {
        key: "productApplications",
        get: function () {
          return this.sprayRecord && this.sprayRecord.productApplications || [];
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.t;
          return p.a.createElement("div", {
            className: "spray-record-products-editor"
          }, p.a.createElement(h.Card, {
            shouldNotPrint: this.productApplications.length <= 0
          }, p.a.createElement(h.CardHeader, {
            isOpen: this.isOpen,
            title: e("products_applied").toUpperCase(),
            onOpen: this.open,
            onClose: this.close,
            hasToggle: !0
          }), p.a.createElement(h.CardBody, {
            isOpen: this.isOpen
          }, p.a.createElement(mf, {
            componentProps: this.props,
            renderError: function () {
              return p.a.createElement(Lp, {
                errorMessage: e("error_displaying_products_applied")
              });
            }
          }, p.a.createElement(aJe, this.props)))));
        }
      }]);
    }()).prototype, "isOpen", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !0;
      }
    }), dJe(tJe.prototype, "sprayRecord", [f.computed], Object.getOwnPropertyDescriptor(tJe.prototype, "sprayRecord"), tJe.prototype), dJe(tJe.prototype, "productApplications", [f.computed], Object.getOwnPropertyDescriptor(tJe.prototype, "productApplications"), tJe.prototype), nJe = dJe(tJe.prototype, "open", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isOpen = !0;
        };
      }
    }), oJe = dJe(tJe.prototype, "close", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.isOpen = !1;
        };
      }
    }), eJe = tJe)) || eJe,
        EJe = Object(g.a)()(_Je);

    function SJe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function CJe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, kJe(n.key), n);
      }
    }

    function kJe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function RJe(e, t, r) {
      return t = TJe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], TJe(e).constructor) : t.apply(e, r));
    }

    function TJe(e) {
      return (TJe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function zJe(e, t) {
      return (zJe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function NJe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var DJe = Object(d.inject)("configuration")(bJe = Object(d.observer)((mJe = NJe((yJe = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = RJe(this, t, [e])).clearFiltersCallback = void 0, SJe(r, "filterModalId", mJe, r), SJe(r, "onChangeSearch", vJe, r), SJe(r, "onClickFilterFlag", hJe, r), SJe(r, "unCheckAll", gJe, r), SJe(r, "unCheckAllOnPage", wJe, r), SJe(r, "checkAll", OJe, r), SJe(r, "checkAllOnPage", jJe, r), SJe(r, "goToPage", PJe, r);
        var n = r.props,
            o = n.sprayRecordsBasePath,
            i = n.accountsPath,
            a = n.t,
            c = n.configuration;
        return r.sprayRecordsApi = new Gy(o, i), r.sprayRecordsStore = e.sprayRecordsStore || new Fm(r.sprayRecordsApi), r.queryService = new Sh(r.sprayRecordsStore, e.accountIds || []), r.filterModalModel = new Ng({
          id: r.filterModalId,
          title: a("application_record_filters"),
          store: r.sprayRecordsStore,
          queryService: r.queryService,
          includeStatusFilter: !0,
          storageName: "spray-record-dashboard-filters",
          t: a,
          configuration: c
        }), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && zJe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && CJe(e.prototype, t), r && CJe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "newAccountSprayRecordPath",
        get: function () {
          var e = this.props.accountSerial;
          return this.sprayRecordsStore.newAccountSprayRecordPath(e);
        }
      }, {
        key: "sprayRecords",
        get: function () {
          return this.queryService.sprayRecords;
        }
      }, {
        key: "componentDidMount",
        value: function () {
          this.filterModalModel.queryWhenReady();
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.authenticityToken,
              r = e.t,
              n = e.icon;
          return p.a.createElement("div", {
            "aria-label": "Spray Records Dashboard",
            className: "spray-records-dashboard"
          }, p.a.createElement(Kg, {
            model: this.filterModalModel
          }), p.a.createElement("div", {
            className: "inline-heading"
          }, p.a.createElement("div", {
            className: "full-length"
          }, p.a.createElement("div", {
            className: "row no-gutters align-items-stretch mb-2"
          }, p.a.createElement("div", {
            className: "col-md-7"
          }, p.a.createElement(UO, {
            icon: n,
            colorClass: "spray-record-color",
            type: r("application_records_short")
          }, p.a.createElement("div", null, p.a.createElement("div", {
            className: "button-list"
          }, p.a.createElement("form", {
            className: "d-inline-block",
            action: "".concat(window.location.pathname, "/records.pdf"),
            method: "POST",
            target: "_blank"
          }, p.a.createElement("input", {
            type: "hidden",
            name: "authenticity_token",
            value: t
          }), this.queryService.serialsForBulkActions.map(function (e) {
            return p.a.createElement("input", {
              key: e,
              type: "hidden",
              name: "spray_record_ids[]",
              value: e
            });
          }), p.a.createElement("input", {
            type: "submit",
            className: "btn btn-outline-spray-records mr-1",
            disabled: this.queryService.fetchingAllSerials || 0 === this.queryService.serialsForBulkActions.length,
            value: "PDF"
          })), p.a.createElement("form", {
            className: "d-inline-block",
            action: "".concat(window.location.pathname, "/rei_posters.pdf"),
            method: "POST",
            target: "_blank"
          }, p.a.createElement("input", {
            type: "hidden",
            name: "authenticity_token",
            value: t
          }), this.queryService.serialsForBulkActions.map(function (e) {
            return p.a.createElement("input", {
              key: e,
              type: "hidden",
              name: "spray_record_ids[]",
              value: e
            });
          }), p.a.createElement("input", {
            type: "submit",
            className: "btn btn-outline-spray-records mx-1",
            disabled: this.queryService.fetchingAllSerials || 0 === this.queryService.serialsForBulkActions.length,
            value: r("rei_poster")
          })), p.a.createElement("a", {
            role: "button",
            className: "btn btn-spray-records mx-1",
            href: this.newAccountSprayRecordPath
          }, r("new_record")))))), p.a.createElement("div", {
            className: "col-md-1 d-flex justify-content-end pr-2 align-with-page-title"
          }, p.a.createElement("div", {
            className: "d-flex align-content-center",
            style: {
              width: "2rem"
            }
          }, p.a.createElement(h.FiltersButton, {
            onClick: this.onClickFilterFlag,
            badgeContent: this.filterModalModel.badgeContent
          }))), p.a.createElement("div", {
            className: "search-filter col-md-4 align-with-page-title"
          }, p.a.createElement(TBe, {
            className: "drop-shadow mr-1",
            showIcon: !0,
            placeholder: r("search_application_records"),
            value: this.queryService.search,
            onChange: this.onChangeSearch
          }))))), p.a.createElement("div", {
            className: "status-feedback justify-content-between ml-1 mb-2"
          }, p.a.createElement("div", {
            className: "checked-status"
          }, this.queryService.fetchingAllSerials ? p.a.createElement(h.Spinner, null) : null, p.a.createElement("span", null, this.queryService.checkedCount), " ", p.a.createElement("span", null, 1 === this.queryService.checkedCount ? "Record" : "Records"), " ", "Selected"), this.queryService.filtersAppliedCount ? p.a.createElement("div", {
            className: "filter-status"
          }, p.a.createElement("span", null, this.queryService.filtersAppliedCount), " ", p.a.createElement("span", null, 1 === this.queryService.filtersAppliedCount ? "".concat(r("filter"), " ").concat(r("applied_sing_masc"), ".") : "".concat(r("filters"), " ").concat(r("applied_pl_masc"), ".")), " ", r("not_all_records_shown"), p.a.createElement("a", {
            href: "#",
            onClick: this.filterModalModel.onClear
          }, r("clear_filters"))) : null), p.a.createElement("div", {
            className: "row"
          }, p.a.createElement("div", {
            className: "col"
          }, this.queryService.isPending ? p.a.createElement("div", {
            className: "query-spinner"
          }, p.a.createElement(h.Spinner, null)) : null, p.a.createElement(cqe, {
            sprayRecords: this.sprayRecords,
            sprayRecordsPath: this.sprayRecordsStore.sprayRecordsBasePath,
            includeCheckboxes: !0,
            isChecked: this.queryService.currentPageChecked,
            onUncheckAll: this.unCheckAll,
            onUncheckPage: this.unCheckAllOnPage,
            onSelectAll: this.checkAll,
            onSelectPage: this.checkAllOnPage
          }))), p.a.createElement("div", {
            className: "text-center"
          }, p.a.createElement(Bie, {
            className: "justify-content-center",
            currentPageNumber: this.queryService.currentPageNumber,
            pages: this.queryService.pages,
            onGoToPage: this.goToPage
          })));
        }
      }]);
    }()).prototype, "filterModalId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "spray-record-filter-modal";
      }
    }), NJe(yJe.prototype, "newAccountSprayRecordPath", [f.computed], Object.getOwnPropertyDescriptor(yJe.prototype, "newAccountSprayRecordPath"), yJe.prototype), NJe(yJe.prototype, "sprayRecords", [f.computed], Object.getOwnPropertyDescriptor(yJe.prototype, "sprayRecords"), yJe.prototype), vJe = NJe(yJe.prototype, "onChangeSearch", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.queryService.changeSearch(t.target.value), e.queryService.runQuery();
        };
      }
    }), hJe = NJe(yJe.prototype, "onClickFilterFlag", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.filterModalModel.show();
        };
      }
    }), gJe = NJe(yJe.prototype, "unCheckAll", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.queryService.unCheckAll();
        };
      }
    }), wJe = NJe(yJe.prototype, "unCheckAllOnPage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.queryService.unCheckAllOnPage();
        };
      }
    }), OJe = NJe(yJe.prototype, "checkAll", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.queryService.checkAll();
        };
      }
    }), jJe = NJe(yJe.prototype, "checkAllOnPage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function () {
          e.queryService.checkAllOnPage();
        };
      }
    }), PJe = NJe(yJe.prototype, "goToPage", [f.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          e.queryService.queryPage(t);
        };
      }
    }), bJe = yJe)) || bJe) || bJe,
        xJe = jO(Object(g.a)()(DJe));

    function AJe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, MJe(n.key), n);
      }
    }

    function MJe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function IJe(e, t, r) {
      return t = FJe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], FJe(e).constructor) : t.apply(e, r));
    }

    function FJe(e) {
      return (FJe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function BJe(e, t) {
      return (BJe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var LJe = function (e) {
      function t(e) {
        var r;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), (r = IJe(this, t, [e])).sprayRecordsStore = void 0;
        var n = e.sprayRecords,
            o = e.useNewModels;
        return r.sprayRecordsStore = new Fm(new Gy(), {
          useNewModels: o
        }), r.sprayRecordsStore.pushMany(n), window.sprayRecordsStore = r.sprayRecordsStore, r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && BJe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "render",
        value: function () {
          return p.a.createElement(p.a.Fragment, null);
        }
      }]) && AJe(r.prototype, n), o && AJe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }();

    function VJe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, UJe(n.key), n);
      }
    }

    function UJe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function qJe(e, t, r) {
      return t = KJe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], KJe(e).constructor) : t.apply(e, r));
    }

    function KJe(e) {
      return (KJe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function GJe(e, t) {
      return (GJe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var WJe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), qJe(this, t, [{
          defaultKey: "contact",
          attributes: [new le({
            name: "ID",
            key: "id"
          }), new le({
            name: "Serial",
            key: "serial",
            type: "number"
          }), new le({
            name: "Type",
            key: "type",
            defaultValue: "IF2::TeamApplicator"
          }), new Ce({
            name: "Contact",
            key: "contact",
            modelSpec: new eKe()
          }), new Ce({
            name: "Tractor",
            key: "tractor",
            modelSpec: new Mqe()
          }), new Ce({
            name: "Sprayer",
            key: "sprayer",
            modelSpec: new Uqe()
          }), new Ce({
            name: "Spreader",
            key: "spreader",
            modelSpec: new Jqe()
          })]
        }]);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && GJe(e, t);
      }(t, Ne), r = t, n && VJe(r.prototype, n), o && VJe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }(),
        HJe = X("TeamApplicator", {
      base: Be,
      mixins: [tt, {
        spec: {
          value: new WJe(),
          isStatic: !0
        },
        name: {
          get: function () {
            return this.contact.name;
          },
          configurable: !0,
          decorate: f.computed
        },
        phone: {
          get: function () {
            return this.contact.phone;
          },
          configurable: !0,
          decorate: f.computed
        },
        address: {
          get: function () {
            return this.contact.address;
          },
          configurable: !0,
          decorate: f.computed
        },
        licenseNumber: {
          get: function () {
            return this.contact.licenseNumber;
          },
          configurable: !0,
          decorate: f.computed
        },
        updateAttribute: {
          value: function (e, t) {
            return "contact" === e ? this.updateModelAttribute(fKe, e, t) : "tractor" === e ? this.updateModelAttribute(oKe, e, t) : "sprayer" === e ? this.updateModelAttribute(iKe, e, t) : Be.prototype.updateAttribute.call(this, e, t);
          }
        }
      }]
    });

    function JJe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, YJe(n.key), n);
      }
    }

    function YJe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function QJe(e, t, r) {
      return t = $Je(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], $Je(e).constructor) : t.apply(e, r));
    }

    function $Je(e) {
      return ($Je = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function XJe(e, t) {
      return (XJe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var ZJe,
        eYe = X("Team", {
      base: Be,
      mixins: [tt, {
        spec: {
          value: new (function (e) {
            function t() {
              return function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, t), QJe(this, t, [{
                defaultKey: "name",
                attributes: [new le({
                  name: "ID",
                  key: "id"
                }), new le({
                  name: "Serial",
                  key: "serial",
                  type: "number"
                }), new le({
                  name: "Name",
                  key: "name"
                }), new le({
                  name: "Type",
                  key: "type",
                  defaultValue: "IF2::Team"
                }), new Ce({
                  name: "Account",
                  key: "account",
                  modelSpec: new dVe()
                }), new he({
                  name: "Applicator",
                  key: "applicators",
                  elementSpec: new WJe()
                })]
              }]);
            }

            return function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  writable: !0,
                  configurable: !0
                }
              }), Object.defineProperty(e, "prototype", {
                writable: !1
              }), t && XJe(e, t);
            }(t, Ne), r = t, n && JJe(r.prototype, n), o && JJe(r, o), Object.defineProperty(r, "prototype", {
              writable: !1
            }), r;
            var r, n, o;
          }())(),
          isStatic: !0
        },
        updateAttribute: {
          value: function (e, t) {
            return "applicators" === e ? this.updateCollectionAttribute(wUe, HJe, e, t, "serial") : "account" === e ? this.updateModelAttribute(CUe, e, t) : Be.prototype.updateAttribute.call(this, e, t);
          }
        }
      }]
    });

    function tYe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, rYe(n.key), n);
      }
    }

    function rYe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function nYe(e, t, r) {
      return t = oYe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], oYe(e).constructor) : t.apply(e, r));
    }

    function oYe(e) {
      return (oYe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function iYe(e, t) {
      return (iYe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    var aYe,
        cYe,
        uYe,
        lYe,
        sYe,
        pYe,
        fYe,
        dYe,
        bYe,
        yYe = Object(d.observer)(ZJe = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), nYe(this, t, arguments);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && iYe(e, t);
      }(t, s["Component"]), r = t, (n = [{
        key: "renderHiddenFields",
        value: function () {
          var e = this.props.applicator;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("input", {
            type: "hidden",
            name: "team[applicators][][contact_id]",
            value: e.contact.serial
          }), p.a.createElement("input", {
            type: "hidden",
            name: "team[applicators][][tractor_id]",
            value: e.tractor.serial
          }), p.a.createElement("input", {
            type: "hidden",
            name: "team[applicators][][sprayer_id]",
            value: e.sprayer.serial
          }), p.a.createElement("input", {
            type: "hidden",
            name: "team[applicators][][spreader_id]",
            value: e.spreader.serial
          }));
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
              t = e.applicator,
              r = e.onDelete;
          return p.a.createElement("tr", null, p.a.createElement("td", null, t.contact ? t.contact.name : ""), p.a.createElement("td", null, t.tractor ? t.tractor.name : ""), p.a.createElement("td", null, t.sprayer ? t.sprayer.name : ""), p.a.createElement("td", null, t.sprayer ? t.spreader.name : ""), p.a.createElement("td", {
            className: "actions"
          }, p.a.createElement("a", {
            href: "#",
            onClick: r,
            className: "icon-button"
          }, p.a.createElement("i", {
            className: "fas fa-trash-alt text-danger"
          })), this.renderHiddenFields()));
        }
      }]) && tYe(r.prototype, n), o && tYe(r, o), Object.defineProperty(r, "prototype", {
        writable: !1
      }), r;
      var r, n, o;
    }()) || ZJe;

    function mYe(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }

    function vYe(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, hYe(n.key), n);
      }
    }

    function hYe(e) {
      var t = function (e, t) {
        if ("object" != typeof e || !e) return e;
        var r = e[Symbol.toPrimitive];

        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }

        return ("string" === t ? String : Number)(e);
      }(e, "string");

      return "symbol" == typeof t ? t : t + "";
    }

    function gYe(e, t, r) {
      return t = wYe(t), function (e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return function (e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }(e);
      }(e, function () {
        try {
          var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
        } catch (e) {}

        return function () {
          return !!e;
        }();
      }() ? Reflect.construct(t, r || [], wYe(e).constructor) : t.apply(e, r));
    }

    function wYe(e) {
      return (wYe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function OYe(e, t) {
      return (OYe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function jYe(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer ? (Object.defineProperty(e, t, i), null) : i;
    }

    var PYe = Object(d.observer)((uYe = jYe((cYe = function (e) {
      function t(e) {
        var r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), mYe(r = gYe(this, t, [e]), "team", uYe, r), mYe(r, "errors", lYe, r), mYe(r, "newContactId", sYe, r), mYe(r, "newTractorId", pYe, r), mYe(r, "newSprayerId", fYe, r), mYe(r, "newSpreaderId", dYe, r), mYe(r, "isSubmitted", bYe, r), r.team = new eYe(e.team), r;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && OYe(e, t);
      }(t, s["Component"]), function (e, t, r) {
        return t && vYe(e.prototype, t), r && vYe(e, r), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }(t, [{
        key: "contactOptions",
        get: function () {
          var e = this;
          return this.props.contacts.map(function (e) {
            return new fKe(e);
          }).filter(function (t) {
            return !e.team.applicators.items.find(function (e) {
              return e.contact.id === t.id;
            });
          });
        }
      }, {
        key: "tractorOptions",
        get: function () {
          var e = this;
          return this.props.tractors.map(function (e) {
            return new oKe(e);
          }).filter(function (t) {
            return !e.team.applicators.items.find(function (e) {
              return e.tractor.id === t.id;
            });
          }).sort(h.sortByName);
        }
      }, {
        key: "sprayerOptions",
        get: function () {
          var e = this;
          return this.props.sprayers.map(function (e) {
            return new iKe(e);
          }).filter(function (t) {
            return !e.team.applicators.items.find(function (e) {
              return e.sprayer.id === t.id;
            });
          }).sort(h.sortByName);
        }
      }, {
        key: "spreaderOptions",
        get: function () {
          var e = this;
          return this.props.spreaders.map(function (e) {
            return new aKe(e);
          }).filter(function (t) {
            return !e.team.applicators.items.find(function (e) {
              return e.spreader.id === t.id;
            });
          }).sort(h.sortByName);
        }
      }, {
        key: "selectedContact",
        get: function () {
          var e = this;
          return this.props.contacts.find(function (t) {
            return t.id === e.newContactId;
          });
        }
      }, {
        key: "selectedTractor",
        get: function () {
          var e = this;
          return this.props.tractors.find(function (t) {
            return t.id === e.newTractorId;
          });
        }
      }, {
        key: "selectedSprayer",
        get: function () {
          var e = this;
          return this.props.sprayers.find(function (t) {
            return t.id === e.newSprayerId;
          });
        }
      }, {
        key: "selectedSpreader",
        get: function () {
          var e = this;
          return this.props.spreaders.find(function (t) {
            return t.id === e.newSpreaderId;
          });
        }
      }, {
        key: "updateContact",
        value: function (e) {
          this.newContactId = e, this.validateIfSubmitted();
        }
      }, {
        key: "updateTractor",
        value: function (e) {
          this.newTractorId = e, this.validateIfSubmitted();
        }
      }, {
        key: "updateSprayer",
        value: function (e) {
          this.newSprayerId = e, this.validateIfSubmitted();
        }
      }, {
        key: "updateSpreader",
        value: function (e) {
          this.newSpreaderId = e, this.validateIfSubmitted();
        }
      }, {
        key: "validateIfSubmitted",
        value: function () {
          this.isSubmitted && this.validate();
        }
      }, {
        key: "validate",
        value: function () {
          this.errors = {}, this.selectedContact || (this.errors.contact = "must_choose_applicator");
        }
      }, {
        key: "addNewApplicator",
        value: function () {
          this.isSubmitted = !0, this.validate(), Object.keys(this.errors).length > 0 || (this.team.applicators.items.push(new HJe({
            contact: new fKe(this.selectedContact),
            tractor: new oKe(this.selectedTractor),
            sprayer: new iKe(this.selectedSprayer),
            spreader: new aKe(this.selectedSpreader)
          })), this.newContactId = "", this.newTractorId = "", this.newSprayerId = "", this.isSubmitted = !1);
        }
      }, {
        key: "removeApplicator",
        value: function (e) {
          var t = this.team.applicators.items.findIndex(function (t) {
            return t.id === e.id;
          });
          this.team.applicators.items.splice(t, 1);
        }
      }, {
        key: "renderContactName",
        value: function (e) {
          var t = e.name;
          return e.licenseNumber && e.licenseNumber.length > 0 && (t += " #".concat(e.licenseNumber)), t;
        }
      }, {
        key: "renderError",
        value: function (e) {
          if (this.errors[e]) return p.a.createElement("div", {
            className: "invalid-feedback"
          }, this.errors[e]);
        }
      }, {
        key: "render",
        value: function () {
          var e = this,
              t = this.props.t;
          return p.a.createElement(p.a.Fragment, null, p.a.createElement("div", {
            className: "editor-header mb-2"
          }, p.a.createElement("input", {
            type: "text",
            name: "team[name]",
            value: this.team.name,
            onChange: function (t) {
              return e.team.name = t.target.value;
            },
            className: "form-control form-control-lg",
            placeholder: t("team_name")
          })), p.a.createElement(h.Card, null, p.a.createElement(h.CardHeader, {
            title: t("applicators").toUpperCase()
          }), p.a.createElement(h.CardBody, null, p.a.createElement("table", {
            className: "table table-striped table-sm"
          }, p.a.createElement("thead", {
            className: "thead-light"
          }, p.a.createElement("tr", null, p.a.createElement("th", null, t("contact")), p.a.createElement("th", null, t("tractor")), p.a.createElement("th", null, t("sprayer")), p.a.createElement("th", null, t("spreader")), p.a.createElement("th", {
            "aria-label": "Actions"
          }))), p.a.createElement("tbody", null, this.team.applicators.items.map(function (t) {
            return p.a.createElement(yYe, {
              key: t.id,
              applicator: t,
              onDelete: function () {
                return e.removeApplicator(t);
              }
            });
          }), p.a.createElement("tr", {
            className: "add"
          }, p.a.createElement("td", null, p.a.createElement("select", {
            onChange: function (t) {
              return e.updateContact(t.target.value);
            },
            className: "form-control".concat(this.errors.contact ? " is-invalid" : "")
          }, p.a.createElement("option", {
            value: ""
          }, t("select_an_applicator")), this.contactOptions.map(function (t) {
            return p.a.createElement("option", {
              key: t.id,
              value: t.id
            }, e.renderContactName(t));
          })), this.errors.contact ? p.a.createElement("div", {
            className: "invalid-feedback"
          }, t(this.errors.contact)) : null), p.a.createElement("td", null, p.a.createElement("select", {
            onChange: function (t) {
              return e.updateTractor(t.target.value);
            },
            className: "form-control"
          }, p.a.createElement("option", {
            value: ""
          }, t("select_a_tractor")), this.tractorOptions.map(function (e) {
            return p.a.createElement("option", {
              key: e.id,
              value: e.id
            }, e.name);
          }))), p.a.createElement("td", null, p.a.createElement("select", {
            onChange: function (t) {
              return e.updateSprayer(t.target.value);
            },
            className: "form-control".concat(this.errors.sprayer ? " is-invalid" : "")
          }, p.a.createElement("option", {
            value: ""
          }, t("select_a_sprayer")), this.sprayerOptions.map(function (e) {
            return p.a.createElement("option", {
              key: e.id,
              value: e.id
            }, e.name);
          })), this.errors.sprayer ? p.a.createElement("div", {
            className: "invalid-feedback"
          }, t(this.errors.sprayer)) : null), p.a.createElement("td", null, p.a.createElement("select", {
            onChange: function (t) {
              return e.updateSpreader(t.target.value);
            },
            className: "form-control".concat(this.errors.spreader ? " is-invalid" : "")
          }, p.a.createElement("option", {
            value: ""
          }, t("select_a_spreader")), this.spreaderOptions.map(function (e) {
            return p.a.createElement("option", {
              key: e.id,
              value: e.id
            }, e.name);
          })), this.errors.spreader ? p.a.createElement("div", {
            className: "invalid-feedback"
          }, t(this.errors.spreader)) : null), p.a.createElement("td", {
            className: "actions"
          }, p.a.createElement("a", {
            href: "#",
            onClick: function () {
              return e.addNewApplicator();
            },
            className: "text-primary"
          }, p.a.createElement("i", {
            className: "fas fa-plus-circle"
          }), " ", t("add_new")))))))));
        }
      }]);
    }()).prototype, "team", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), lYe = jYe(cYe.prototype, "errors", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return {};
      }
    }), sYe = jYe(cYe.prototype, "newContactId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), pYe = jYe(cYe.prototype, "newTractorId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), fYe = jYe(cYe.prototype, "newSprayerId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), dYe = jYe(cYe.prototype, "newSpreaderId", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "";
      }
    }), bYe = jYe(cYe.prototype, "isSubmitted", [f.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), jYe(cYe.prototype, "contactOptions", [f.computed], Object.getOwnPropertyDescriptor(cYe.prototype, "contactOptions"), cYe.prototype), jYe(cYe.prototype, "tractorOptions", [f.computed], Object.getOwnPropertyDescriptor(cYe.prototype, "tractorOptions"), cYe.prototype), jYe(cYe.prototype, "sprayerOptions", [f.computed], Object.getOwnPropertyDescriptor(cYe.prototype, "sprayerOptions"), cYe.prototype), jYe(cYe.prototype, "spreaderOptions", [f.computed], Object.getOwnPropertyDescriptor(cYe.prototype, "spreaderOptions"), cYe.prototype), jYe(cYe.prototype, "selectedContact", [f.computed], Object.getOwnPropertyDescriptor(cYe.prototype, "selectedContact"), cYe.prototype), jYe(cYe.prototype, "selectedTractor", [f.computed], Object.getOwnPropertyDescriptor(cYe.prototype, "selectedTractor"), cYe.prototype), jYe(cYe.prototype, "selectedSprayer", [f.computed], Object.getOwnPropertyDescriptor(cYe.prototype, "selectedSprayer"), cYe.prototype), jYe(cYe.prototype, "selectedSpreader", [f.computed], Object.getOwnPropertyDescriptor(cYe.prototype, "selectedSpreader"), cYe.prototype), jYe(cYe.prototype, "updateContact", [f.action], Object.getOwnPropertyDescriptor(cYe.prototype, "updateContact"), cYe.prototype), jYe(cYe.prototype, "updateTractor", [f.action], Object.getOwnPropertyDescriptor(cYe.prototype, "updateTractor"), cYe.prototype), jYe(cYe.prototype, "updateSprayer", [f.action], Object.getOwnPropertyDescriptor(cYe.prototype, "updateSprayer"), cYe.prototype), jYe(cYe.prototype, "updateSpreader", [f.action], Object.getOwnPropertyDescriptor(cYe.prototype, "updateSpreader"), cYe.prototype), jYe(cYe.prototype, "validate", [f.action], Object.getOwnPropertyDescriptor(cYe.prototype, "validate"), cYe.prototype), jYe(cYe.prototype, "addNewApplicator", [f.action], Object.getOwnPropertyDescriptor(cYe.prototype, "addNewApplicator"), cYe.prototype), jYe(cYe.prototype, "removeApplicator", [f.action], Object.getOwnPropertyDescriptor(cYe.prototype, "removeApplicator"), cYe.prototype), aYe = cYe)) || aYe,
        _Ye = Object(g.a)()(PYe);

    function EYe(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function SYe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? EYe(Object(r), !0).forEach(function (t) {
          CYe(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : EYe(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function CYe(e, t, r) {
      return (t = function (e) {
        var t = function (e, t) {
          if ("object" != typeof e || !e) return e;
          var r = e[Symbol.toPrimitive];

          if (void 0 !== r) {
            var n = r.call(e, t || "default");
            if ("object" != typeof n) return n;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }

          return ("string" === t ? String : Number)(e);
        }(e, "string");

        return "symbol" == typeof t ? t : t + "";
      }(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }

    var kYe = SYe(SYe({}, n), o);
    "undefined" != typeof window ? window.IF2 = kYe : console.warn("Unable to register React components for IF2"), document.addEventListener("wheel", function (e) {
      "number" === document.activeElement.type && "number" === e.target.type && e.preventDefault();
    }, {
      passive: !1
    });
  }]);
});